
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire50df"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire50df"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5omY3", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $3ed1028483214486$export$ffb0004e005737fa; }, function (v) { return $3ed1028483214486$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $3ed1028483214486$export$34b9dba7ce09269b; }, function (v) { return $3ed1028483214486$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $3ed1028483214486$export$25062201e9e25d76; }, function (v) { return $3ed1028483214486$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3ed1028483214486$export$ffb0004e005737fa;
var $3ed1028483214486$export$34b9dba7ce09269b;
var $3ed1028483214486$export$25062201e9e25d76;
'use strict';

var $lVd4O = parcelRequire("lVd4O");
var $3ed1028483214486$var$k = Symbol.for("react.element"), $3ed1028483214486$var$l = Symbol.for("react.fragment"), $3ed1028483214486$var$m = Object.prototype.hasOwnProperty, $3ed1028483214486$var$n = $lVd4O.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3ed1028483214486$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3ed1028483214486$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$3ed1028483214486$var$m.call(a, b) && !$3ed1028483214486$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3ed1028483214486$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $3ed1028483214486$var$n.current
    };
}
$3ed1028483214486$export$ffb0004e005737fa = $3ed1028483214486$var$l;
$3ed1028483214486$export$34b9dba7ce09269b = $3ed1028483214486$var$q;
$3ed1028483214486$export$25062201e9e25d76 = $3ed1028483214486$var$q;

});
parcelRegister("lVd4O", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9poi6"));

});
parcelRegister("9poi6", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $6d994a8dd3fb2d1c$export$dca3b0875bd9a954; }, function (v) { return $6d994a8dd3fb2d1c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $6d994a8dd3fb2d1c$export$16fa2f45be04daa8; }, function (v) { return $6d994a8dd3fb2d1c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6d994a8dd3fb2d1c$export$ffb0004e005737fa; }, function (v) { return $6d994a8dd3fb2d1c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $6d994a8dd3fb2d1c$export$e2c29f18771995cb; }, function (v) { return $6d994a8dd3fb2d1c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $6d994a8dd3fb2d1c$export$221d75b3f55bb0bd; }, function (v) { return $6d994a8dd3fb2d1c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6d994a8dd3fb2d1c$export$5f8d39834fd61797; }, function (v) { return $6d994a8dd3fb2d1c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6d994a8dd3fb2d1c$export$74bf444e3cd11ea5; }, function (v) { return $6d994a8dd3fb2d1c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $6d994a8dd3fb2d1c$export$ae55be85d98224ed; }, function (v) { return $6d994a8dd3fb2d1c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $6d994a8dd3fb2d1c$export$3ba232387fd5d6dd; }, function (v) { return $6d994a8dd3fb2d1c$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $6d994a8dd3fb2d1c$export$e530037191fcd5d7; }, function (v) { return $6d994a8dd3fb2d1c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $6d994a8dd3fb2d1c$export$fd42f52fd3ae1109; }, function (v) { return $6d994a8dd3fb2d1c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $6d994a8dd3fb2d1c$export$c8a8987d4410bf2d; }, function (v) { return $6d994a8dd3fb2d1c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $6d994a8dd3fb2d1c$export$d38cd72104c1f0e9; }, function (v) { return $6d994a8dd3fb2d1c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $6d994a8dd3fb2d1c$export$7d1e3a5e95ceca43; }, function (v) { return $6d994a8dd3fb2d1c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $6d994a8dd3fb2d1c$export$257a8862b851cb5b; }, function (v) { return $6d994a8dd3fb2d1c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $6d994a8dd3fb2d1c$export$a8257692ac88316c; }, function (v) { return $6d994a8dd3fb2d1c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $6d994a8dd3fb2d1c$export$488013bae63b21da; }, function (v) { return $6d994a8dd3fb2d1c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $6d994a8dd3fb2d1c$export$7c73462e0d25e514; }, function (v) { return $6d994a8dd3fb2d1c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $6d994a8dd3fb2d1c$export$7568632d0d33d16d; }, function (v) { return $6d994a8dd3fb2d1c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $6d994a8dd3fb2d1c$export$88948ce120ea2619; }, function (v) { return $6d994a8dd3fb2d1c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $6d994a8dd3fb2d1c$export$35808ee640e87ca7; }, function (v) { return $6d994a8dd3fb2d1c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $6d994a8dd3fb2d1c$export$fae74005e78b1a27; }, function (v) { return $6d994a8dd3fb2d1c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $6d994a8dd3fb2d1c$export$dc8fbce3eb94dc1e; }, function (v) { return $6d994a8dd3fb2d1c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $6d994a8dd3fb2d1c$export$6a7bc4e911dc01cf; }, function (v) { return $6d994a8dd3fb2d1c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $6d994a8dd3fb2d1c$export$6d9c69b0de29b591; }, function (v) { return $6d994a8dd3fb2d1c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $6d994a8dd3fb2d1c$export$f680877a34711e37; }, function (v) { return $6d994a8dd3fb2d1c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $6d994a8dd3fb2d1c$export$d5a552a76deda3c2; }, function (v) { return $6d994a8dd3fb2d1c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $6d994a8dd3fb2d1c$export$aaabe4eda9ed9969; }, function (v) { return $6d994a8dd3fb2d1c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $6d994a8dd3fb2d1c$export$e5c5a5f917a5871c; }, function (v) { return $6d994a8dd3fb2d1c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $6d994a8dd3fb2d1c$export$1538c33de8887b59; }, function (v) { return $6d994a8dd3fb2d1c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $6d994a8dd3fb2d1c$export$13e3392192263954; }, function (v) { return $6d994a8dd3fb2d1c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $6d994a8dd3fb2d1c$export$b8f5890fc79d6aca; }, function (v) { return $6d994a8dd3fb2d1c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $6d994a8dd3fb2d1c$export$60241385465d0a34; }, function (v) { return $6d994a8dd3fb2d1c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $6d994a8dd3fb2d1c$export$306c0aa65ff9ec16; }, function (v) { return $6d994a8dd3fb2d1c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $6d994a8dd3fb2d1c$export$7b286972b8d8ccbf; }, function (v) { return $6d994a8dd3fb2d1c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $6d994a8dd3fb2d1c$export$83d89fbfd8236492; }, function (v) { return $6d994a8dd3fb2d1c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d994a8dd3fb2d1c$export$dca3b0875bd9a954;
var $6d994a8dd3fb2d1c$export$16fa2f45be04daa8;
var $6d994a8dd3fb2d1c$export$ffb0004e005737fa;
var $6d994a8dd3fb2d1c$export$e2c29f18771995cb;
var $6d994a8dd3fb2d1c$export$221d75b3f55bb0bd;
var $6d994a8dd3fb2d1c$export$5f8d39834fd61797;
var $6d994a8dd3fb2d1c$export$74bf444e3cd11ea5;
var $6d994a8dd3fb2d1c$export$ae55be85d98224ed;
var $6d994a8dd3fb2d1c$export$3ba232387fd5d6dd;
var $6d994a8dd3fb2d1c$export$e530037191fcd5d7;
var $6d994a8dd3fb2d1c$export$fd42f52fd3ae1109;
var $6d994a8dd3fb2d1c$export$c8a8987d4410bf2d;
var $6d994a8dd3fb2d1c$export$d38cd72104c1f0e9;
var $6d994a8dd3fb2d1c$export$7d1e3a5e95ceca43;
var $6d994a8dd3fb2d1c$export$257a8862b851cb5b;
var $6d994a8dd3fb2d1c$export$a8257692ac88316c;
var $6d994a8dd3fb2d1c$export$488013bae63b21da;
var $6d994a8dd3fb2d1c$export$7c73462e0d25e514;
var $6d994a8dd3fb2d1c$export$7568632d0d33d16d;
var $6d994a8dd3fb2d1c$export$88948ce120ea2619;
var $6d994a8dd3fb2d1c$export$35808ee640e87ca7;
var $6d994a8dd3fb2d1c$export$fae74005e78b1a27;
var $6d994a8dd3fb2d1c$export$dc8fbce3eb94dc1e;
var $6d994a8dd3fb2d1c$export$6a7bc4e911dc01cf;
var $6d994a8dd3fb2d1c$export$6d9c69b0de29b591;
var $6d994a8dd3fb2d1c$export$f680877a34711e37;
var $6d994a8dd3fb2d1c$export$d5a552a76deda3c2;
var $6d994a8dd3fb2d1c$export$aaabe4eda9ed9969;
var $6d994a8dd3fb2d1c$export$e5c5a5f917a5871c;
var $6d994a8dd3fb2d1c$export$1538c33de8887b59;
var $6d994a8dd3fb2d1c$export$13e3392192263954;
var $6d994a8dd3fb2d1c$export$b8f5890fc79d6aca;
var $6d994a8dd3fb2d1c$export$60241385465d0a34;
var $6d994a8dd3fb2d1c$export$306c0aa65ff9ec16;
var $6d994a8dd3fb2d1c$export$7b286972b8d8ccbf;
var $6d994a8dd3fb2d1c$export$83d89fbfd8236492;
'use strict';
var $6d994a8dd3fb2d1c$var$l = Symbol.for("react.element"), $6d994a8dd3fb2d1c$var$n = Symbol.for("react.portal"), $6d994a8dd3fb2d1c$var$p = Symbol.for("react.fragment"), $6d994a8dd3fb2d1c$var$q = Symbol.for("react.strict_mode"), $6d994a8dd3fb2d1c$var$r = Symbol.for("react.profiler"), $6d994a8dd3fb2d1c$var$t = Symbol.for("react.provider"), $6d994a8dd3fb2d1c$var$u = Symbol.for("react.context"), $6d994a8dd3fb2d1c$var$v = Symbol.for("react.forward_ref"), $6d994a8dd3fb2d1c$var$w = Symbol.for("react.suspense"), $6d994a8dd3fb2d1c$var$x = Symbol.for("react.memo"), $6d994a8dd3fb2d1c$var$y = Symbol.for("react.lazy"), $6d994a8dd3fb2d1c$var$z = Symbol.iterator;
function $6d994a8dd3fb2d1c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $6d994a8dd3fb2d1c$var$z && a[$6d994a8dd3fb2d1c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $6d994a8dd3fb2d1c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6d994a8dd3fb2d1c$var$C = Object.assign, $6d994a8dd3fb2d1c$var$D = {};
function $6d994a8dd3fb2d1c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $6d994a8dd3fb2d1c$var$D;
    this.updater = e || $6d994a8dd3fb2d1c$var$B;
}
$6d994a8dd3fb2d1c$var$E.prototype.isReactComponent = {};
$6d994a8dd3fb2d1c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$6d994a8dd3fb2d1c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $6d994a8dd3fb2d1c$var$F() {}
$6d994a8dd3fb2d1c$var$F.prototype = $6d994a8dd3fb2d1c$var$E.prototype;
function $6d994a8dd3fb2d1c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $6d994a8dd3fb2d1c$var$D;
    this.updater = e || $6d994a8dd3fb2d1c$var$B;
}
var $6d994a8dd3fb2d1c$var$H = $6d994a8dd3fb2d1c$var$G.prototype = new $6d994a8dd3fb2d1c$var$F;
$6d994a8dd3fb2d1c$var$H.constructor = $6d994a8dd3fb2d1c$var$G;
$6d994a8dd3fb2d1c$var$C($6d994a8dd3fb2d1c$var$H, $6d994a8dd3fb2d1c$var$E.prototype);
$6d994a8dd3fb2d1c$var$H.isPureReactComponent = !0;
var $6d994a8dd3fb2d1c$var$I = Array.isArray, $6d994a8dd3fb2d1c$var$J = Object.prototype.hasOwnProperty, $6d994a8dd3fb2d1c$var$K = {
    current: null
}, $6d994a8dd3fb2d1c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6d994a8dd3fb2d1c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$6d994a8dd3fb2d1c$var$J.call(b, d) && !$6d994a8dd3fb2d1c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $6d994a8dd3fb2d1c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $6d994a8dd3fb2d1c$var$K.current
    };
}
function $6d994a8dd3fb2d1c$var$N(a, b) {
    return {
        $$typeof: $6d994a8dd3fb2d1c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $6d994a8dd3fb2d1c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6d994a8dd3fb2d1c$var$l;
}
function $6d994a8dd3fb2d1c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $6d994a8dd3fb2d1c$var$P = /\/+/g;
function $6d994a8dd3fb2d1c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $6d994a8dd3fb2d1c$var$escape("" + a.key) : b.toString(36);
}
function $6d994a8dd3fb2d1c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $6d994a8dd3fb2d1c$var$l:
                case $6d994a8dd3fb2d1c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $6d994a8dd3fb2d1c$var$Q(h, 0) : d, $6d994a8dd3fb2d1c$var$I(c) ? (e = "", null != a && (e = a.replace($6d994a8dd3fb2d1c$var$P, "$&/") + "/"), $6d994a8dd3fb2d1c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($6d994a8dd3fb2d1c$var$O(c) && (c = $6d994a8dd3fb2d1c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($6d994a8dd3fb2d1c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($6d994a8dd3fb2d1c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $6d994a8dd3fb2d1c$var$Q(k, g);
        h += $6d994a8dd3fb2d1c$var$R(k, b, e, f, c);
    }
    else if (f = $6d994a8dd3fb2d1c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $6d994a8dd3fb2d1c$var$Q(k, g++), h += $6d994a8dd3fb2d1c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $6d994a8dd3fb2d1c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $6d994a8dd3fb2d1c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $6d994a8dd3fb2d1c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $6d994a8dd3fb2d1c$var$U = {
    current: null
}, $6d994a8dd3fb2d1c$var$V = {
    transition: null
}, $6d994a8dd3fb2d1c$var$W = {
    ReactCurrentDispatcher: $6d994a8dd3fb2d1c$var$U,
    ReactCurrentBatchConfig: $6d994a8dd3fb2d1c$var$V,
    ReactCurrentOwner: $6d994a8dd3fb2d1c$var$K
};
function $6d994a8dd3fb2d1c$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$6d994a8dd3fb2d1c$export$dca3b0875bd9a954 = {
    map: $6d994a8dd3fb2d1c$var$S,
    forEach: function(a, b, e) {
        $6d994a8dd3fb2d1c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $6d994a8dd3fb2d1c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $6d994a8dd3fb2d1c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$6d994a8dd3fb2d1c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$6d994a8dd3fb2d1c$export$16fa2f45be04daa8 = $6d994a8dd3fb2d1c$var$E;
$6d994a8dd3fb2d1c$export$ffb0004e005737fa = $6d994a8dd3fb2d1c$var$p;
$6d994a8dd3fb2d1c$export$e2c29f18771995cb = $6d994a8dd3fb2d1c$var$r;
$6d994a8dd3fb2d1c$export$221d75b3f55bb0bd = $6d994a8dd3fb2d1c$var$G;
$6d994a8dd3fb2d1c$export$5f8d39834fd61797 = $6d994a8dd3fb2d1c$var$q;
$6d994a8dd3fb2d1c$export$74bf444e3cd11ea5 = $6d994a8dd3fb2d1c$var$w;
$6d994a8dd3fb2d1c$export$ae55be85d98224ed = $6d994a8dd3fb2d1c$var$W;
$6d994a8dd3fb2d1c$export$3ba232387fd5d6dd = $6d994a8dd3fb2d1c$var$X;
$6d994a8dd3fb2d1c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $6d994a8dd3fb2d1c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $6d994a8dd3fb2d1c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$6d994a8dd3fb2d1c$var$J.call(b, f) && !$6d994a8dd3fb2d1c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $6d994a8dd3fb2d1c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$6d994a8dd3fb2d1c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $6d994a8dd3fb2d1c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $6d994a8dd3fb2d1c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$6d994a8dd3fb2d1c$export$c8a8987d4410bf2d = $6d994a8dd3fb2d1c$var$M;
$6d994a8dd3fb2d1c$export$d38cd72104c1f0e9 = function(a) {
    var b = $6d994a8dd3fb2d1c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$6d994a8dd3fb2d1c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6d994a8dd3fb2d1c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $6d994a8dd3fb2d1c$var$v,
        render: a
    };
};
$6d994a8dd3fb2d1c$export$a8257692ac88316c = $6d994a8dd3fb2d1c$var$O;
$6d994a8dd3fb2d1c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $6d994a8dd3fb2d1c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $6d994a8dd3fb2d1c$var$T
    };
};
$6d994a8dd3fb2d1c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $6d994a8dd3fb2d1c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$6d994a8dd3fb2d1c$export$7568632d0d33d16d = function(a) {
    var b = $6d994a8dd3fb2d1c$var$V.transition;
    $6d994a8dd3fb2d1c$var$V.transition = {};
    try {
        a();
    } finally{
        $6d994a8dd3fb2d1c$var$V.transition = b;
    }
};
$6d994a8dd3fb2d1c$export$88948ce120ea2619 = $6d994a8dd3fb2d1c$var$X;
$6d994a8dd3fb2d1c$export$35808ee640e87ca7 = function(a, b) {
    return $6d994a8dd3fb2d1c$var$U.current.useCallback(a, b);
};
$6d994a8dd3fb2d1c$export$fae74005e78b1a27 = function(a) {
    return $6d994a8dd3fb2d1c$var$U.current.useContext(a);
};
$6d994a8dd3fb2d1c$export$dc8fbce3eb94dc1e = function() {};
$6d994a8dd3fb2d1c$export$6a7bc4e911dc01cf = function(a) {
    return $6d994a8dd3fb2d1c$var$U.current.useDeferredValue(a);
};
$6d994a8dd3fb2d1c$export$6d9c69b0de29b591 = function(a, b) {
    return $6d994a8dd3fb2d1c$var$U.current.useEffect(a, b);
};
$6d994a8dd3fb2d1c$export$f680877a34711e37 = function() {
    return $6d994a8dd3fb2d1c$var$U.current.useId();
};
$6d994a8dd3fb2d1c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $6d994a8dd3fb2d1c$var$U.current.useImperativeHandle(a, b, e);
};
$6d994a8dd3fb2d1c$export$aaabe4eda9ed9969 = function(a, b) {
    return $6d994a8dd3fb2d1c$var$U.current.useInsertionEffect(a, b);
};
$6d994a8dd3fb2d1c$export$e5c5a5f917a5871c = function(a, b) {
    return $6d994a8dd3fb2d1c$var$U.current.useLayoutEffect(a, b);
};
$6d994a8dd3fb2d1c$export$1538c33de8887b59 = function(a, b) {
    return $6d994a8dd3fb2d1c$var$U.current.useMemo(a, b);
};
$6d994a8dd3fb2d1c$export$13e3392192263954 = function(a, b, e) {
    return $6d994a8dd3fb2d1c$var$U.current.useReducer(a, b, e);
};
$6d994a8dd3fb2d1c$export$b8f5890fc79d6aca = function(a) {
    return $6d994a8dd3fb2d1c$var$U.current.useRef(a);
};
$6d994a8dd3fb2d1c$export$60241385465d0a34 = function(a) {
    return $6d994a8dd3fb2d1c$var$U.current.useState(a);
};
$6d994a8dd3fb2d1c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $6d994a8dd3fb2d1c$var$U.current.useSyncExternalStore(a, b, e);
};
$6d994a8dd3fb2d1c$export$7b286972b8d8ccbf = function() {
    return $6d994a8dd3fb2d1c$var$U.current.useTransition();
};
$6d994a8dd3fb2d1c$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6nd29", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4a3f0044ce2ef491$export$ae55be85d98224ed; }, function (v) { return $4a3f0044ce2ef491$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4a3f0044ce2ef491$export$d39a5bbd09211389; }, function (v) { return $4a3f0044ce2ef491$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4a3f0044ce2ef491$export$882461b6382ed46c; }, function (v) { return $4a3f0044ce2ef491$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4a3f0044ce2ef491$export$466bfc07425424d5; }, function (v) { return $4a3f0044ce2ef491$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4a3f0044ce2ef491$export$cd75ccfd720a3cd4; }, function (v) { return $4a3f0044ce2ef491$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4a3f0044ce2ef491$export$fa8d919ba61d84db; }, function (v) { return $4a3f0044ce2ef491$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4a3f0044ce2ef491$export$757ceba2d55c277e; }, function (v) { return $4a3f0044ce2ef491$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4a3f0044ce2ef491$export$b3890eb0ae9dca99; }, function (v) { return $4a3f0044ce2ef491$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4a3f0044ce2ef491$export$502457920280e6be; }, function (v) { return $4a3f0044ce2ef491$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4a3f0044ce2ef491$export$c78a37762a8d58e1; }, function (v) { return $4a3f0044ce2ef491$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4a3f0044ce2ef491$export$dc54d992c10e8a18; }, function (v) { return $4a3f0044ce2ef491$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4a3f0044ce2ef491$export$83d89fbfd8236492; }, function (v) { return $4a3f0044ce2ef491$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4a3f0044ce2ef491$export$ae55be85d98224ed;
var $4a3f0044ce2ef491$export$d39a5bbd09211389;
var $4a3f0044ce2ef491$export$882461b6382ed46c;
var $4a3f0044ce2ef491$export$466bfc07425424d5;
var $4a3f0044ce2ef491$export$cd75ccfd720a3cd4;
var $4a3f0044ce2ef491$export$fa8d919ba61d84db;
var $4a3f0044ce2ef491$export$757ceba2d55c277e;
var $4a3f0044ce2ef491$export$b3890eb0ae9dca99;
var $4a3f0044ce2ef491$export$502457920280e6be;
var $4a3f0044ce2ef491$export$c78a37762a8d58e1;
var $4a3f0044ce2ef491$export$dc54d992c10e8a18;
var $4a3f0044ce2ef491$export$83d89fbfd8236492;
'use strict';

var $lVd4O = parcelRequire("lVd4O");

var $bG2CK = parcelRequire("bG2CK");
function $4a3f0044ce2ef491$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4a3f0044ce2ef491$var$da = new Set, $4a3f0044ce2ef491$var$ea = {};
function $4a3f0044ce2ef491$var$fa(a, b) {
    $4a3f0044ce2ef491$var$ha(a, b);
    $4a3f0044ce2ef491$var$ha(a + "Capture", b);
}
function $4a3f0044ce2ef491$var$ha(a, b) {
    $4a3f0044ce2ef491$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4a3f0044ce2ef491$var$da.add(b[a]);
}
var $4a3f0044ce2ef491$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4a3f0044ce2ef491$var$ja = Object.prototype.hasOwnProperty, $4a3f0044ce2ef491$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4a3f0044ce2ef491$var$la = {}, $4a3f0044ce2ef491$var$ma = {};
function $4a3f0044ce2ef491$var$oa(a) {
    if ($4a3f0044ce2ef491$var$ja.call($4a3f0044ce2ef491$var$ma, a)) return !0;
    if ($4a3f0044ce2ef491$var$ja.call($4a3f0044ce2ef491$var$la, a)) return !1;
    if ($4a3f0044ce2ef491$var$ka.test(a)) return $4a3f0044ce2ef491$var$ma[a] = !0;
    $4a3f0044ce2ef491$var$la[a] = !0;
    return !1;
}
function $4a3f0044ce2ef491$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4a3f0044ce2ef491$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4a3f0044ce2ef491$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4a3f0044ce2ef491$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4a3f0044ce2ef491$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4a3f0044ce2ef491$var$z[b] = new $4a3f0044ce2ef491$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4a3f0044ce2ef491$var$ra = /[\-:]([a-z])/g;
function $4a3f0044ce2ef491$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4a3f0044ce2ef491$var$ra, $4a3f0044ce2ef491$var$sa);
    $4a3f0044ce2ef491$var$z[b] = new $4a3f0044ce2ef491$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4a3f0044ce2ef491$var$ra, $4a3f0044ce2ef491$var$sa);
    $4a3f0044ce2ef491$var$z[b] = new $4a3f0044ce2ef491$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4a3f0044ce2ef491$var$ra, $4a3f0044ce2ef491$var$sa);
    $4a3f0044ce2ef491$var$z[b] = new $4a3f0044ce2ef491$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4a3f0044ce2ef491$var$z.xlinkHref = new $4a3f0044ce2ef491$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4a3f0044ce2ef491$var$z[a] = new $4a3f0044ce2ef491$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4a3f0044ce2ef491$var$ta(a, b, c, d) {
    var e = $4a3f0044ce2ef491$var$z.hasOwnProperty(b) ? $4a3f0044ce2ef491$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4a3f0044ce2ef491$var$qa(b, c, e, d) && (c = null), d || null === e ? $4a3f0044ce2ef491$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4a3f0044ce2ef491$var$ua = $lVd4O.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4a3f0044ce2ef491$var$va = Symbol.for("react.element"), $4a3f0044ce2ef491$var$wa = Symbol.for("react.portal"), $4a3f0044ce2ef491$var$ya = Symbol.for("react.fragment"), $4a3f0044ce2ef491$var$za = Symbol.for("react.strict_mode"), $4a3f0044ce2ef491$var$Aa = Symbol.for("react.profiler"), $4a3f0044ce2ef491$var$Ba = Symbol.for("react.provider"), $4a3f0044ce2ef491$var$Ca = Symbol.for("react.context"), $4a3f0044ce2ef491$var$Da = Symbol.for("react.forward_ref"), $4a3f0044ce2ef491$var$Ea = Symbol.for("react.suspense"), $4a3f0044ce2ef491$var$Fa = Symbol.for("react.suspense_list"), $4a3f0044ce2ef491$var$Ga = Symbol.for("react.memo"), $4a3f0044ce2ef491$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4a3f0044ce2ef491$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4a3f0044ce2ef491$var$Ja = Symbol.iterator;
function $4a3f0044ce2ef491$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4a3f0044ce2ef491$var$Ja && a[$4a3f0044ce2ef491$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4a3f0044ce2ef491$var$A = Object.assign, $4a3f0044ce2ef491$var$La;
function $4a3f0044ce2ef491$var$Ma(a) {
    if (void 0 === $4a3f0044ce2ef491$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4a3f0044ce2ef491$var$La = b && b[1] || "";
    }
    return "\n" + $4a3f0044ce2ef491$var$La + a;
}
var $4a3f0044ce2ef491$var$Na = !1;
function $4a3f0044ce2ef491$var$Oa(a, b) {
    if (!a || $4a3f0044ce2ef491$var$Na) return "";
    $4a3f0044ce2ef491$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4a3f0044ce2ef491$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4a3f0044ce2ef491$var$Ma(a) : "";
}
function $4a3f0044ce2ef491$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4a3f0044ce2ef491$var$Ma(a.type);
        case 16:
            return $4a3f0044ce2ef491$var$Ma("Lazy");
        case 13:
            return $4a3f0044ce2ef491$var$Ma("Suspense");
        case 19:
            return $4a3f0044ce2ef491$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4a3f0044ce2ef491$var$Oa(a.type, !1), a;
        case 11:
            return a = $4a3f0044ce2ef491$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4a3f0044ce2ef491$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4a3f0044ce2ef491$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4a3f0044ce2ef491$var$ya:
            return "Fragment";
        case $4a3f0044ce2ef491$var$wa:
            return "Portal";
        case $4a3f0044ce2ef491$var$Aa:
            return "Profiler";
        case $4a3f0044ce2ef491$var$za:
            return "StrictMode";
        case $4a3f0044ce2ef491$var$Ea:
            return "Suspense";
        case $4a3f0044ce2ef491$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4a3f0044ce2ef491$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4a3f0044ce2ef491$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4a3f0044ce2ef491$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4a3f0044ce2ef491$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4a3f0044ce2ef491$var$Qa(a.type) || "Memo";
        case $4a3f0044ce2ef491$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4a3f0044ce2ef491$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4a3f0044ce2ef491$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4a3f0044ce2ef491$var$Qa(b);
        case 8:
            return b === $4a3f0044ce2ef491$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4a3f0044ce2ef491$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4a3f0044ce2ef491$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4a3f0044ce2ef491$var$Ua(a) {
    var b = $4a3f0044ce2ef491$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4a3f0044ce2ef491$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4a3f0044ce2ef491$var$Ua(a));
}
function $4a3f0044ce2ef491$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4a3f0044ce2ef491$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4a3f0044ce2ef491$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4a3f0044ce2ef491$var$Ya(a, b) {
    var c = b.checked;
    return $4a3f0044ce2ef491$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4a3f0044ce2ef491$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4a3f0044ce2ef491$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4a3f0044ce2ef491$var$ab(a, b) {
    b = b.checked;
    null != b && $4a3f0044ce2ef491$var$ta(a, "checked", b, !1);
}
function $4a3f0044ce2ef491$var$bb(a, b) {
    $4a3f0044ce2ef491$var$ab(a, b);
    var c = $4a3f0044ce2ef491$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4a3f0044ce2ef491$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4a3f0044ce2ef491$var$cb(a, b.type, $4a3f0044ce2ef491$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4a3f0044ce2ef491$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4a3f0044ce2ef491$var$cb(a, b, c) {
    if ("number" !== b || $4a3f0044ce2ef491$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4a3f0044ce2ef491$var$eb = Array.isArray;
function $4a3f0044ce2ef491$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4a3f0044ce2ef491$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4a3f0044ce2ef491$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4a3f0044ce2ef491$var$p(91));
    return $4a3f0044ce2ef491$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4a3f0044ce2ef491$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4a3f0044ce2ef491$var$p(92));
            if ($4a3f0044ce2ef491$var$eb(c)) {
                if (1 < c.length) throw Error($4a3f0044ce2ef491$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4a3f0044ce2ef491$var$Sa(c)
    };
}
function $4a3f0044ce2ef491$var$ib(a, b) {
    var c = $4a3f0044ce2ef491$var$Sa(b.value), d = $4a3f0044ce2ef491$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4a3f0044ce2ef491$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4a3f0044ce2ef491$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4a3f0044ce2ef491$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4a3f0044ce2ef491$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4a3f0044ce2ef491$var$mb, $4a3f0044ce2ef491$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4a3f0044ce2ef491$var$mb = $4a3f0044ce2ef491$var$mb || document.createElement("div");
        $4a3f0044ce2ef491$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4a3f0044ce2ef491$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4a3f0044ce2ef491$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4a3f0044ce2ef491$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4a3f0044ce2ef491$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4a3f0044ce2ef491$var$pb).forEach(function(a) {
    $4a3f0044ce2ef491$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4a3f0044ce2ef491$var$pb[b] = $4a3f0044ce2ef491$var$pb[a];
    });
});
function $4a3f0044ce2ef491$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4a3f0044ce2ef491$var$pb.hasOwnProperty(a) && $4a3f0044ce2ef491$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4a3f0044ce2ef491$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4a3f0044ce2ef491$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4a3f0044ce2ef491$var$tb = $4a3f0044ce2ef491$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4a3f0044ce2ef491$var$ub(a, b) {
    if (b) {
        if ($4a3f0044ce2ef491$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4a3f0044ce2ef491$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4a3f0044ce2ef491$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4a3f0044ce2ef491$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4a3f0044ce2ef491$var$p(62));
    }
}
function $4a3f0044ce2ef491$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4a3f0044ce2ef491$var$wb = null;
function $4a3f0044ce2ef491$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4a3f0044ce2ef491$var$yb = null, $4a3f0044ce2ef491$var$zb = null, $4a3f0044ce2ef491$var$Ab = null;
function $4a3f0044ce2ef491$var$Bb(a) {
    if (a = $4a3f0044ce2ef491$var$Cb(a)) {
        if ("function" !== typeof $4a3f0044ce2ef491$var$yb) throw Error($4a3f0044ce2ef491$var$p(280));
        var b = a.stateNode;
        b && (b = $4a3f0044ce2ef491$var$Db(b), $4a3f0044ce2ef491$var$yb(a.stateNode, a.type, b));
    }
}
function $4a3f0044ce2ef491$var$Eb(a) {
    $4a3f0044ce2ef491$var$zb ? $4a3f0044ce2ef491$var$Ab ? $4a3f0044ce2ef491$var$Ab.push(a) : $4a3f0044ce2ef491$var$Ab = [
        a
    ] : $4a3f0044ce2ef491$var$zb = a;
}
function $4a3f0044ce2ef491$var$Fb() {
    if ($4a3f0044ce2ef491$var$zb) {
        var a = $4a3f0044ce2ef491$var$zb, b = $4a3f0044ce2ef491$var$Ab;
        $4a3f0044ce2ef491$var$Ab = $4a3f0044ce2ef491$var$zb = null;
        $4a3f0044ce2ef491$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4a3f0044ce2ef491$var$Bb(b[a]);
    }
}
function $4a3f0044ce2ef491$var$Gb(a, b) {
    return a(b);
}
function $4a3f0044ce2ef491$var$Hb() {}
var $4a3f0044ce2ef491$var$Ib = !1;
function $4a3f0044ce2ef491$var$Jb(a, b, c) {
    if ($4a3f0044ce2ef491$var$Ib) return a(b, c);
    $4a3f0044ce2ef491$var$Ib = !0;
    try {
        return $4a3f0044ce2ef491$var$Gb(a, b, c);
    } finally{
        if ($4a3f0044ce2ef491$var$Ib = !1, null !== $4a3f0044ce2ef491$var$zb || null !== $4a3f0044ce2ef491$var$Ab) $4a3f0044ce2ef491$var$Hb(), $4a3f0044ce2ef491$var$Fb();
    }
}
function $4a3f0044ce2ef491$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4a3f0044ce2ef491$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4a3f0044ce2ef491$var$p(231, b, typeof c));
    return c;
}
var $4a3f0044ce2ef491$var$Lb = !1;
if ($4a3f0044ce2ef491$var$ia) try {
    var $4a3f0044ce2ef491$var$Mb = {};
    Object.defineProperty($4a3f0044ce2ef491$var$Mb, "passive", {
        get: function() {
            $4a3f0044ce2ef491$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4a3f0044ce2ef491$var$Mb, $4a3f0044ce2ef491$var$Mb);
    window.removeEventListener("test", $4a3f0044ce2ef491$var$Mb, $4a3f0044ce2ef491$var$Mb);
} catch (a) {
    $4a3f0044ce2ef491$var$Lb = !1;
}
function $4a3f0044ce2ef491$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4a3f0044ce2ef491$var$Ob = !1, $4a3f0044ce2ef491$var$Pb = null, $4a3f0044ce2ef491$var$Qb = !1, $4a3f0044ce2ef491$var$Rb = null, $4a3f0044ce2ef491$var$Sb = {
    onError: function(a) {
        $4a3f0044ce2ef491$var$Ob = !0;
        $4a3f0044ce2ef491$var$Pb = a;
    }
};
function $4a3f0044ce2ef491$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4a3f0044ce2ef491$var$Ob = !1;
    $4a3f0044ce2ef491$var$Pb = null;
    $4a3f0044ce2ef491$var$Nb.apply($4a3f0044ce2ef491$var$Sb, arguments);
}
function $4a3f0044ce2ef491$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4a3f0044ce2ef491$var$Tb.apply(this, arguments);
    if ($4a3f0044ce2ef491$var$Ob) {
        if ($4a3f0044ce2ef491$var$Ob) {
            var l = $4a3f0044ce2ef491$var$Pb;
            $4a3f0044ce2ef491$var$Ob = !1;
            $4a3f0044ce2ef491$var$Pb = null;
        } else throw Error($4a3f0044ce2ef491$var$p(198));
        $4a3f0044ce2ef491$var$Qb || ($4a3f0044ce2ef491$var$Qb = !0, $4a3f0044ce2ef491$var$Rb = l);
    }
}
function $4a3f0044ce2ef491$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4a3f0044ce2ef491$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4a3f0044ce2ef491$var$Xb(a) {
    if ($4a3f0044ce2ef491$var$Vb(a) !== a) throw Error($4a3f0044ce2ef491$var$p(188));
}
function $4a3f0044ce2ef491$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4a3f0044ce2ef491$var$Vb(a);
        if (null === b) throw Error($4a3f0044ce2ef491$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4a3f0044ce2ef491$var$Xb(e), a;
                if (f === d) return $4a3f0044ce2ef491$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4a3f0044ce2ef491$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4a3f0044ce2ef491$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4a3f0044ce2ef491$var$p(190));
    }
    if (3 !== c.tag) throw Error($4a3f0044ce2ef491$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4a3f0044ce2ef491$var$Zb(a) {
    a = $4a3f0044ce2ef491$var$Yb(a);
    return null !== a ? $4a3f0044ce2ef491$var$$b(a) : null;
}
function $4a3f0044ce2ef491$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4a3f0044ce2ef491$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4a3f0044ce2ef491$var$ac = $bG2CK.unstable_scheduleCallback, $4a3f0044ce2ef491$var$bc = $bG2CK.unstable_cancelCallback, $4a3f0044ce2ef491$var$cc = $bG2CK.unstable_shouldYield, $4a3f0044ce2ef491$var$dc = $bG2CK.unstable_requestPaint, $4a3f0044ce2ef491$var$B = $bG2CK.unstable_now, $4a3f0044ce2ef491$var$ec = $bG2CK.unstable_getCurrentPriorityLevel, $4a3f0044ce2ef491$var$fc = $bG2CK.unstable_ImmediatePriority, $4a3f0044ce2ef491$var$gc = $bG2CK.unstable_UserBlockingPriority, $4a3f0044ce2ef491$var$hc = $bG2CK.unstable_NormalPriority, $4a3f0044ce2ef491$var$ic = $bG2CK.unstable_LowPriority, $4a3f0044ce2ef491$var$jc = $bG2CK.unstable_IdlePriority, $4a3f0044ce2ef491$var$kc = null, $4a3f0044ce2ef491$var$lc = null;
function $4a3f0044ce2ef491$var$mc(a) {
    if ($4a3f0044ce2ef491$var$lc && "function" === typeof $4a3f0044ce2ef491$var$lc.onCommitFiberRoot) try {
        $4a3f0044ce2ef491$var$lc.onCommitFiberRoot($4a3f0044ce2ef491$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4a3f0044ce2ef491$var$oc = Math.clz32 ? Math.clz32 : $4a3f0044ce2ef491$var$nc, $4a3f0044ce2ef491$var$pc = Math.log, $4a3f0044ce2ef491$var$qc = Math.LN2;
function $4a3f0044ce2ef491$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4a3f0044ce2ef491$var$pc(a) / $4a3f0044ce2ef491$var$qc | 0) | 0;
}
var $4a3f0044ce2ef491$var$rc = 64, $4a3f0044ce2ef491$var$sc = 4194304;
function $4a3f0044ce2ef491$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4a3f0044ce2ef491$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4a3f0044ce2ef491$var$tc(h) : (f &= g, 0 !== f && (d = $4a3f0044ce2ef491$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4a3f0044ce2ef491$var$tc(g) : 0 !== f && (d = $4a3f0044ce2ef491$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4a3f0044ce2ef491$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4a3f0044ce2ef491$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4a3f0044ce2ef491$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4a3f0044ce2ef491$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4a3f0044ce2ef491$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4a3f0044ce2ef491$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4a3f0044ce2ef491$var$yc() {
    var a = $4a3f0044ce2ef491$var$rc;
    $4a3f0044ce2ef491$var$rc <<= 1;
    0 === ($4a3f0044ce2ef491$var$rc & 4194240) && ($4a3f0044ce2ef491$var$rc = 64);
    return a;
}
function $4a3f0044ce2ef491$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4a3f0044ce2ef491$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4a3f0044ce2ef491$var$oc(b);
    a[b] = c;
}
function $4a3f0044ce2ef491$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4a3f0044ce2ef491$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4a3f0044ce2ef491$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4a3f0044ce2ef491$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4a3f0044ce2ef491$var$C = 0;
function $4a3f0044ce2ef491$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4a3f0044ce2ef491$var$Ec, $4a3f0044ce2ef491$var$Fc, $4a3f0044ce2ef491$var$Gc, $4a3f0044ce2ef491$var$Hc, $4a3f0044ce2ef491$var$Ic, $4a3f0044ce2ef491$var$Jc = !1, $4a3f0044ce2ef491$var$Kc = [], $4a3f0044ce2ef491$var$Lc = null, $4a3f0044ce2ef491$var$Mc = null, $4a3f0044ce2ef491$var$Nc = null, $4a3f0044ce2ef491$var$Oc = new Map, $4a3f0044ce2ef491$var$Pc = new Map, $4a3f0044ce2ef491$var$Qc = [], $4a3f0044ce2ef491$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4a3f0044ce2ef491$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4a3f0044ce2ef491$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4a3f0044ce2ef491$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4a3f0044ce2ef491$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4a3f0044ce2ef491$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4a3f0044ce2ef491$var$Pc.delete(b.pointerId);
    }
}
function $4a3f0044ce2ef491$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4a3f0044ce2ef491$var$Cb(b), null !== b && $4a3f0044ce2ef491$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4a3f0044ce2ef491$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4a3f0044ce2ef491$var$Lc = $4a3f0044ce2ef491$var$Tc($4a3f0044ce2ef491$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4a3f0044ce2ef491$var$Mc = $4a3f0044ce2ef491$var$Tc($4a3f0044ce2ef491$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4a3f0044ce2ef491$var$Nc = $4a3f0044ce2ef491$var$Tc($4a3f0044ce2ef491$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4a3f0044ce2ef491$var$Oc.set(f, $4a3f0044ce2ef491$var$Tc($4a3f0044ce2ef491$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4a3f0044ce2ef491$var$Pc.set(f, $4a3f0044ce2ef491$var$Tc($4a3f0044ce2ef491$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4a3f0044ce2ef491$var$Vc(a) {
    var b = $4a3f0044ce2ef491$var$Wc(a.target);
    if (null !== b) {
        var c = $4a3f0044ce2ef491$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4a3f0044ce2ef491$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4a3f0044ce2ef491$var$Ic(a.priority, function() {
                        $4a3f0044ce2ef491$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4a3f0044ce2ef491$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4a3f0044ce2ef491$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4a3f0044ce2ef491$var$wb = d;
            c.target.dispatchEvent(d);
            $4a3f0044ce2ef491$var$wb = null;
        } else return b = $4a3f0044ce2ef491$var$Cb(c), null !== b && $4a3f0044ce2ef491$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4a3f0044ce2ef491$var$Zc(a, b, c) {
    $4a3f0044ce2ef491$var$Xc(a) && c.delete(b);
}
function $4a3f0044ce2ef491$var$$c() {
    $4a3f0044ce2ef491$var$Jc = !1;
    null !== $4a3f0044ce2ef491$var$Lc && $4a3f0044ce2ef491$var$Xc($4a3f0044ce2ef491$var$Lc) && ($4a3f0044ce2ef491$var$Lc = null);
    null !== $4a3f0044ce2ef491$var$Mc && $4a3f0044ce2ef491$var$Xc($4a3f0044ce2ef491$var$Mc) && ($4a3f0044ce2ef491$var$Mc = null);
    null !== $4a3f0044ce2ef491$var$Nc && $4a3f0044ce2ef491$var$Xc($4a3f0044ce2ef491$var$Nc) && ($4a3f0044ce2ef491$var$Nc = null);
    $4a3f0044ce2ef491$var$Oc.forEach($4a3f0044ce2ef491$var$Zc);
    $4a3f0044ce2ef491$var$Pc.forEach($4a3f0044ce2ef491$var$Zc);
}
function $4a3f0044ce2ef491$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4a3f0044ce2ef491$var$Jc || ($4a3f0044ce2ef491$var$Jc = !0, $bG2CK.unstable_scheduleCallback($bG2CK.unstable_NormalPriority, $4a3f0044ce2ef491$var$$c)));
}
function $4a3f0044ce2ef491$var$bd(a) {
    function b(b) {
        return $4a3f0044ce2ef491$var$ad(b, a);
    }
    if (0 < $4a3f0044ce2ef491$var$Kc.length) {
        $4a3f0044ce2ef491$var$ad($4a3f0044ce2ef491$var$Kc[0], a);
        for(var c = 1; c < $4a3f0044ce2ef491$var$Kc.length; c++){
            var d = $4a3f0044ce2ef491$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4a3f0044ce2ef491$var$Lc && $4a3f0044ce2ef491$var$ad($4a3f0044ce2ef491$var$Lc, a);
    null !== $4a3f0044ce2ef491$var$Mc && $4a3f0044ce2ef491$var$ad($4a3f0044ce2ef491$var$Mc, a);
    null !== $4a3f0044ce2ef491$var$Nc && $4a3f0044ce2ef491$var$ad($4a3f0044ce2ef491$var$Nc, a);
    $4a3f0044ce2ef491$var$Oc.forEach(b);
    $4a3f0044ce2ef491$var$Pc.forEach(b);
    for(c = 0; c < $4a3f0044ce2ef491$var$Qc.length; c++)d = $4a3f0044ce2ef491$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4a3f0044ce2ef491$var$Qc.length && (c = $4a3f0044ce2ef491$var$Qc[0], null === c.blockedOn);)$4a3f0044ce2ef491$var$Vc(c), null === c.blockedOn && $4a3f0044ce2ef491$var$Qc.shift();
}
var $4a3f0044ce2ef491$var$cd = $4a3f0044ce2ef491$var$ua.ReactCurrentBatchConfig, $4a3f0044ce2ef491$var$dd = !0;
function $4a3f0044ce2ef491$var$ed(a, b, c, d) {
    var e = $4a3f0044ce2ef491$var$C, f = $4a3f0044ce2ef491$var$cd.transition;
    $4a3f0044ce2ef491$var$cd.transition = null;
    try {
        $4a3f0044ce2ef491$var$C = 1, $4a3f0044ce2ef491$var$fd(a, b, c, d);
    } finally{
        $4a3f0044ce2ef491$var$C = e, $4a3f0044ce2ef491$var$cd.transition = f;
    }
}
function $4a3f0044ce2ef491$var$gd(a, b, c, d) {
    var e = $4a3f0044ce2ef491$var$C, f = $4a3f0044ce2ef491$var$cd.transition;
    $4a3f0044ce2ef491$var$cd.transition = null;
    try {
        $4a3f0044ce2ef491$var$C = 4, $4a3f0044ce2ef491$var$fd(a, b, c, d);
    } finally{
        $4a3f0044ce2ef491$var$C = e, $4a3f0044ce2ef491$var$cd.transition = f;
    }
}
function $4a3f0044ce2ef491$var$fd(a, b, c, d) {
    if ($4a3f0044ce2ef491$var$dd) {
        var e = $4a3f0044ce2ef491$var$Yc(a, b, c, d);
        if (null === e) $4a3f0044ce2ef491$var$hd(a, b, d, $4a3f0044ce2ef491$var$id, c), $4a3f0044ce2ef491$var$Sc(a, d);
        else if ($4a3f0044ce2ef491$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4a3f0044ce2ef491$var$Sc(a, d), b & 4 && -1 < $4a3f0044ce2ef491$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4a3f0044ce2ef491$var$Cb(e);
                null !== f && $4a3f0044ce2ef491$var$Ec(f);
                f = $4a3f0044ce2ef491$var$Yc(a, b, c, d);
                null === f && $4a3f0044ce2ef491$var$hd(a, b, d, $4a3f0044ce2ef491$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4a3f0044ce2ef491$var$hd(a, b, d, null, c);
    }
}
var $4a3f0044ce2ef491$var$id = null;
function $4a3f0044ce2ef491$var$Yc(a, b, c, d) {
    $4a3f0044ce2ef491$var$id = null;
    a = $4a3f0044ce2ef491$var$xb(d);
    a = $4a3f0044ce2ef491$var$Wc(a);
    if (null !== a) {
        if (b = $4a3f0044ce2ef491$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4a3f0044ce2ef491$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4a3f0044ce2ef491$var$id = a;
    return null;
}
function $4a3f0044ce2ef491$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4a3f0044ce2ef491$var$ec()){
                case $4a3f0044ce2ef491$var$fc:
                    return 1;
                case $4a3f0044ce2ef491$var$gc:
                    return 4;
                case $4a3f0044ce2ef491$var$hc:
                case $4a3f0044ce2ef491$var$ic:
                    return 16;
                case $4a3f0044ce2ef491$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4a3f0044ce2ef491$var$kd = null, $4a3f0044ce2ef491$var$ld = null, $4a3f0044ce2ef491$var$md = null;
function $4a3f0044ce2ef491$var$nd() {
    if ($4a3f0044ce2ef491$var$md) return $4a3f0044ce2ef491$var$md;
    var a, b = $4a3f0044ce2ef491$var$ld, c = b.length, d, e = "value" in $4a3f0044ce2ef491$var$kd ? $4a3f0044ce2ef491$var$kd.value : $4a3f0044ce2ef491$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4a3f0044ce2ef491$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4a3f0044ce2ef491$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4a3f0044ce2ef491$var$pd() {
    return !0;
}
function $4a3f0044ce2ef491$var$qd() {
    return !1;
}
function $4a3f0044ce2ef491$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4a3f0044ce2ef491$var$pd : $4a3f0044ce2ef491$var$qd;
        this.isPropagationStopped = $4a3f0044ce2ef491$var$qd;
        return this;
    }
    $4a3f0044ce2ef491$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4a3f0044ce2ef491$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4a3f0044ce2ef491$var$pd);
        },
        persist: function() {},
        isPersistent: $4a3f0044ce2ef491$var$pd
    });
    return b;
}
var $4a3f0044ce2ef491$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4a3f0044ce2ef491$var$td = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$sd), $4a3f0044ce2ef491$var$ud = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$sd, {
    view: 0,
    detail: 0
}), $4a3f0044ce2ef491$var$vd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$ud), $4a3f0044ce2ef491$var$wd, $4a3f0044ce2ef491$var$xd, $4a3f0044ce2ef491$var$yd, $4a3f0044ce2ef491$var$Ad = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4a3f0044ce2ef491$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4a3f0044ce2ef491$var$yd && ($4a3f0044ce2ef491$var$yd && "mousemove" === a.type ? ($4a3f0044ce2ef491$var$wd = a.screenX - $4a3f0044ce2ef491$var$yd.screenX, $4a3f0044ce2ef491$var$xd = a.screenY - $4a3f0044ce2ef491$var$yd.screenY) : $4a3f0044ce2ef491$var$xd = $4a3f0044ce2ef491$var$wd = 0, $4a3f0044ce2ef491$var$yd = a);
        return $4a3f0044ce2ef491$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4a3f0044ce2ef491$var$xd;
    }
}), $4a3f0044ce2ef491$var$Bd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Ad), $4a3f0044ce2ef491$var$Cd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$Ad, {
    dataTransfer: 0
}), $4a3f0044ce2ef491$var$Dd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Cd), $4a3f0044ce2ef491$var$Ed = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$ud, {
    relatedTarget: 0
}), $4a3f0044ce2ef491$var$Fd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Ed), $4a3f0044ce2ef491$var$Gd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4a3f0044ce2ef491$var$Hd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Gd), $4a3f0044ce2ef491$var$Id = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4a3f0044ce2ef491$var$Jd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Id), $4a3f0044ce2ef491$var$Kd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$sd, {
    data: 0
}), $4a3f0044ce2ef491$var$Ld = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Kd), $4a3f0044ce2ef491$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4a3f0044ce2ef491$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4a3f0044ce2ef491$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4a3f0044ce2ef491$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4a3f0044ce2ef491$var$Od[a]) ? !!b[a] : !1;
}
function $4a3f0044ce2ef491$var$zd() {
    return $4a3f0044ce2ef491$var$Pd;
}
var $4a3f0044ce2ef491$var$Qd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4a3f0044ce2ef491$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4a3f0044ce2ef491$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4a3f0044ce2ef491$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4a3f0044ce2ef491$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4a3f0044ce2ef491$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4a3f0044ce2ef491$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4a3f0044ce2ef491$var$Rd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Qd), $4a3f0044ce2ef491$var$Sd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4a3f0044ce2ef491$var$Td = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Sd), $4a3f0044ce2ef491$var$Ud = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4a3f0044ce2ef491$var$zd
}), $4a3f0044ce2ef491$var$Vd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Ud), $4a3f0044ce2ef491$var$Wd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4a3f0044ce2ef491$var$Xd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Wd), $4a3f0044ce2ef491$var$Yd = $4a3f0044ce2ef491$var$A({}, $4a3f0044ce2ef491$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4a3f0044ce2ef491$var$Zd = $4a3f0044ce2ef491$var$rd($4a3f0044ce2ef491$var$Yd), $4a3f0044ce2ef491$var$$d = [
    9,
    13,
    27,
    32
], $4a3f0044ce2ef491$var$ae = $4a3f0044ce2ef491$var$ia && "CompositionEvent" in window, $4a3f0044ce2ef491$var$be = null;
$4a3f0044ce2ef491$var$ia && "documentMode" in document && ($4a3f0044ce2ef491$var$be = document.documentMode);
var $4a3f0044ce2ef491$var$ce = $4a3f0044ce2ef491$var$ia && "TextEvent" in window && !$4a3f0044ce2ef491$var$be, $4a3f0044ce2ef491$var$de = $4a3f0044ce2ef491$var$ia && (!$4a3f0044ce2ef491$var$ae || $4a3f0044ce2ef491$var$be && 8 < $4a3f0044ce2ef491$var$be && 11 >= $4a3f0044ce2ef491$var$be), $4a3f0044ce2ef491$var$ee = String.fromCharCode(32), $4a3f0044ce2ef491$var$fe = !1;
function $4a3f0044ce2ef491$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4a3f0044ce2ef491$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4a3f0044ce2ef491$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4a3f0044ce2ef491$var$ie = !1;
function $4a3f0044ce2ef491$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4a3f0044ce2ef491$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4a3f0044ce2ef491$var$fe = !0;
            return $4a3f0044ce2ef491$var$ee;
        case "textInput":
            return a = b.data, a === $4a3f0044ce2ef491$var$ee && $4a3f0044ce2ef491$var$fe ? null : a;
        default:
            return null;
    }
}
function $4a3f0044ce2ef491$var$ke(a, b) {
    if ($4a3f0044ce2ef491$var$ie) return "compositionend" === a || !$4a3f0044ce2ef491$var$ae && $4a3f0044ce2ef491$var$ge(a, b) ? (a = $4a3f0044ce2ef491$var$nd(), $4a3f0044ce2ef491$var$md = $4a3f0044ce2ef491$var$ld = $4a3f0044ce2ef491$var$kd = null, $4a3f0044ce2ef491$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4a3f0044ce2ef491$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4a3f0044ce2ef491$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4a3f0044ce2ef491$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4a3f0044ce2ef491$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4a3f0044ce2ef491$var$ne(a, b, c, d) {
    $4a3f0044ce2ef491$var$Eb(d);
    b = $4a3f0044ce2ef491$var$oe(b, "onChange");
    0 < b.length && (c = new $4a3f0044ce2ef491$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4a3f0044ce2ef491$var$pe = null, $4a3f0044ce2ef491$var$qe = null;
function $4a3f0044ce2ef491$var$re(a) {
    $4a3f0044ce2ef491$var$se(a, 0);
}
function $4a3f0044ce2ef491$var$te(a) {
    var b = $4a3f0044ce2ef491$var$ue(a);
    if ($4a3f0044ce2ef491$var$Wa(b)) return a;
}
function $4a3f0044ce2ef491$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4a3f0044ce2ef491$var$we = !1;
if ($4a3f0044ce2ef491$var$ia) {
    var $4a3f0044ce2ef491$var$xe;
    if ($4a3f0044ce2ef491$var$ia) {
        var $4a3f0044ce2ef491$var$ye = "oninput" in document;
        if (!$4a3f0044ce2ef491$var$ye) {
            var $4a3f0044ce2ef491$var$ze = document.createElement("div");
            $4a3f0044ce2ef491$var$ze.setAttribute("oninput", "return;");
            $4a3f0044ce2ef491$var$ye = "function" === typeof $4a3f0044ce2ef491$var$ze.oninput;
        }
        $4a3f0044ce2ef491$var$xe = $4a3f0044ce2ef491$var$ye;
    } else $4a3f0044ce2ef491$var$xe = !1;
    $4a3f0044ce2ef491$var$we = $4a3f0044ce2ef491$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4a3f0044ce2ef491$var$Ae() {
    $4a3f0044ce2ef491$var$pe && ($4a3f0044ce2ef491$var$pe.detachEvent("onpropertychange", $4a3f0044ce2ef491$var$Be), $4a3f0044ce2ef491$var$qe = $4a3f0044ce2ef491$var$pe = null);
}
function $4a3f0044ce2ef491$var$Be(a) {
    if ("value" === a.propertyName && $4a3f0044ce2ef491$var$te($4a3f0044ce2ef491$var$qe)) {
        var b = [];
        $4a3f0044ce2ef491$var$ne(b, $4a3f0044ce2ef491$var$qe, a, $4a3f0044ce2ef491$var$xb(a));
        $4a3f0044ce2ef491$var$Jb($4a3f0044ce2ef491$var$re, b);
    }
}
function $4a3f0044ce2ef491$var$Ce(a, b, c) {
    "focusin" === a ? ($4a3f0044ce2ef491$var$Ae(), $4a3f0044ce2ef491$var$pe = b, $4a3f0044ce2ef491$var$qe = c, $4a3f0044ce2ef491$var$pe.attachEvent("onpropertychange", $4a3f0044ce2ef491$var$Be)) : "focusout" === a && $4a3f0044ce2ef491$var$Ae();
}
function $4a3f0044ce2ef491$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4a3f0044ce2ef491$var$te($4a3f0044ce2ef491$var$qe);
}
function $4a3f0044ce2ef491$var$Ee(a, b) {
    if ("click" === a) return $4a3f0044ce2ef491$var$te(b);
}
function $4a3f0044ce2ef491$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4a3f0044ce2ef491$var$te(b);
}
function $4a3f0044ce2ef491$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4a3f0044ce2ef491$var$He = "function" === typeof Object.is ? Object.is : $4a3f0044ce2ef491$var$Ge;
function $4a3f0044ce2ef491$var$Ie(a, b) {
    if ($4a3f0044ce2ef491$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4a3f0044ce2ef491$var$ja.call(b, e) || !$4a3f0044ce2ef491$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4a3f0044ce2ef491$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4a3f0044ce2ef491$var$Ke(a, b) {
    var c = $4a3f0044ce2ef491$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4a3f0044ce2ef491$var$Je(c);
    }
}
function $4a3f0044ce2ef491$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4a3f0044ce2ef491$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4a3f0044ce2ef491$var$Me() {
    for(var a = window, b = $4a3f0044ce2ef491$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4a3f0044ce2ef491$var$Xa(a.document);
    }
    return b;
}
function $4a3f0044ce2ef491$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4a3f0044ce2ef491$var$Oe(a) {
    var b = $4a3f0044ce2ef491$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4a3f0044ce2ef491$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4a3f0044ce2ef491$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4a3f0044ce2ef491$var$Ke(c, f);
                var g = $4a3f0044ce2ef491$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4a3f0044ce2ef491$var$Pe = $4a3f0044ce2ef491$var$ia && "documentMode" in document && 11 >= document.documentMode, $4a3f0044ce2ef491$var$Qe = null, $4a3f0044ce2ef491$var$Re = null, $4a3f0044ce2ef491$var$Se = null, $4a3f0044ce2ef491$var$Te = !1;
function $4a3f0044ce2ef491$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4a3f0044ce2ef491$var$Te || null == $4a3f0044ce2ef491$var$Qe || $4a3f0044ce2ef491$var$Qe !== $4a3f0044ce2ef491$var$Xa(d) || (d = $4a3f0044ce2ef491$var$Qe, "selectionStart" in d && $4a3f0044ce2ef491$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4a3f0044ce2ef491$var$Se && $4a3f0044ce2ef491$var$Ie($4a3f0044ce2ef491$var$Se, d) || ($4a3f0044ce2ef491$var$Se = d, d = $4a3f0044ce2ef491$var$oe($4a3f0044ce2ef491$var$Re, "onSelect"), 0 < d.length && (b = new $4a3f0044ce2ef491$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4a3f0044ce2ef491$var$Qe)));
}
function $4a3f0044ce2ef491$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4a3f0044ce2ef491$var$We = {
    animationend: $4a3f0044ce2ef491$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4a3f0044ce2ef491$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4a3f0044ce2ef491$var$Ve("Animation", "AnimationStart"),
    transitionend: $4a3f0044ce2ef491$var$Ve("Transition", "TransitionEnd")
}, $4a3f0044ce2ef491$var$Xe = {}, $4a3f0044ce2ef491$var$Ye = {};
$4a3f0044ce2ef491$var$ia && ($4a3f0044ce2ef491$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4a3f0044ce2ef491$var$We.animationend.animation, delete $4a3f0044ce2ef491$var$We.animationiteration.animation, delete $4a3f0044ce2ef491$var$We.animationstart.animation), "TransitionEvent" in window || delete $4a3f0044ce2ef491$var$We.transitionend.transition);
function $4a3f0044ce2ef491$var$Ze(a) {
    if ($4a3f0044ce2ef491$var$Xe[a]) return $4a3f0044ce2ef491$var$Xe[a];
    if (!$4a3f0044ce2ef491$var$We[a]) return a;
    var b = $4a3f0044ce2ef491$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4a3f0044ce2ef491$var$Ye) return $4a3f0044ce2ef491$var$Xe[a] = b[c];
    return a;
}
var $4a3f0044ce2ef491$var$$e = $4a3f0044ce2ef491$var$Ze("animationend"), $4a3f0044ce2ef491$var$af = $4a3f0044ce2ef491$var$Ze("animationiteration"), $4a3f0044ce2ef491$var$bf = $4a3f0044ce2ef491$var$Ze("animationstart"), $4a3f0044ce2ef491$var$cf = $4a3f0044ce2ef491$var$Ze("transitionend"), $4a3f0044ce2ef491$var$df = new Map, $4a3f0044ce2ef491$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4a3f0044ce2ef491$var$ff(a, b) {
    $4a3f0044ce2ef491$var$df.set(a, b);
    $4a3f0044ce2ef491$var$fa(b, [
        a
    ]);
}
for(var $4a3f0044ce2ef491$var$gf = 0; $4a3f0044ce2ef491$var$gf < $4a3f0044ce2ef491$var$ef.length; $4a3f0044ce2ef491$var$gf++){
    var $4a3f0044ce2ef491$var$hf = $4a3f0044ce2ef491$var$ef[$4a3f0044ce2ef491$var$gf], $4a3f0044ce2ef491$var$jf = $4a3f0044ce2ef491$var$hf.toLowerCase(), $4a3f0044ce2ef491$var$kf = $4a3f0044ce2ef491$var$hf[0].toUpperCase() + $4a3f0044ce2ef491$var$hf.slice(1);
    $4a3f0044ce2ef491$var$ff($4a3f0044ce2ef491$var$jf, "on" + $4a3f0044ce2ef491$var$kf);
}
$4a3f0044ce2ef491$var$ff($4a3f0044ce2ef491$var$$e, "onAnimationEnd");
$4a3f0044ce2ef491$var$ff($4a3f0044ce2ef491$var$af, "onAnimationIteration");
$4a3f0044ce2ef491$var$ff($4a3f0044ce2ef491$var$bf, "onAnimationStart");
$4a3f0044ce2ef491$var$ff("dblclick", "onDoubleClick");
$4a3f0044ce2ef491$var$ff("focusin", "onFocus");
$4a3f0044ce2ef491$var$ff("focusout", "onBlur");
$4a3f0044ce2ef491$var$ff($4a3f0044ce2ef491$var$cf, "onTransitionEnd");
$4a3f0044ce2ef491$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4a3f0044ce2ef491$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4a3f0044ce2ef491$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4a3f0044ce2ef491$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4a3f0044ce2ef491$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4a3f0044ce2ef491$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4a3f0044ce2ef491$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4a3f0044ce2ef491$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4a3f0044ce2ef491$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4a3f0044ce2ef491$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4a3f0044ce2ef491$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4a3f0044ce2ef491$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4a3f0044ce2ef491$var$lf));
function $4a3f0044ce2ef491$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4a3f0044ce2ef491$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4a3f0044ce2ef491$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4a3f0044ce2ef491$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4a3f0044ce2ef491$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4a3f0044ce2ef491$var$Qb) throw a = $4a3f0044ce2ef491$var$Rb, $4a3f0044ce2ef491$var$Qb = !1, $4a3f0044ce2ef491$var$Rb = null, a;
}
function $4a3f0044ce2ef491$var$D(a, b) {
    var c = b[$4a3f0044ce2ef491$var$of];
    void 0 === c && (c = b[$4a3f0044ce2ef491$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4a3f0044ce2ef491$var$pf(b, a, 2, !1), c.add(d));
}
function $4a3f0044ce2ef491$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4a3f0044ce2ef491$var$pf(c, a, d, b);
}
var $4a3f0044ce2ef491$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4a3f0044ce2ef491$var$sf(a) {
    if (!a[$4a3f0044ce2ef491$var$rf]) {
        a[$4a3f0044ce2ef491$var$rf] = !0;
        $4a3f0044ce2ef491$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4a3f0044ce2ef491$var$mf.has(b) || $4a3f0044ce2ef491$var$qf(b, !1, a), $4a3f0044ce2ef491$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4a3f0044ce2ef491$var$rf] || (b[$4a3f0044ce2ef491$var$rf] = !0, $4a3f0044ce2ef491$var$qf("selectionchange", !1, b));
    }
}
function $4a3f0044ce2ef491$var$pf(a, b, c, d) {
    switch($4a3f0044ce2ef491$var$jd(b)){
        case 1:
            var e = $4a3f0044ce2ef491$var$ed;
            break;
        case 4:
            e = $4a3f0044ce2ef491$var$gd;
            break;
        default:
            e = $4a3f0044ce2ef491$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4a3f0044ce2ef491$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4a3f0044ce2ef491$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4a3f0044ce2ef491$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4a3f0044ce2ef491$var$Jb(function() {
        var d = f, e = $4a3f0044ce2ef491$var$xb(c), g = [];
        a: {
            var h = $4a3f0044ce2ef491$var$df.get(a);
            if (void 0 !== h) {
                var k = $4a3f0044ce2ef491$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4a3f0044ce2ef491$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4a3f0044ce2ef491$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4a3f0044ce2ef491$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4a3f0044ce2ef491$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4a3f0044ce2ef491$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4a3f0044ce2ef491$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4a3f0044ce2ef491$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4a3f0044ce2ef491$var$Vd;
                        break;
                    case $4a3f0044ce2ef491$var$$e:
                    case $4a3f0044ce2ef491$var$af:
                    case $4a3f0044ce2ef491$var$bf:
                        k = $4a3f0044ce2ef491$var$Hd;
                        break;
                    case $4a3f0044ce2ef491$var$cf:
                        k = $4a3f0044ce2ef491$var$Xd;
                        break;
                    case "scroll":
                        k = $4a3f0044ce2ef491$var$vd;
                        break;
                    case "wheel":
                        k = $4a3f0044ce2ef491$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4a3f0044ce2ef491$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4a3f0044ce2ef491$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4a3f0044ce2ef491$var$Kb(w, x), null != F && t.push($4a3f0044ce2ef491$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4a3f0044ce2ef491$var$wb && (n = c.relatedTarget || c.fromElement) && ($4a3f0044ce2ef491$var$Wc(n) || n[$4a3f0044ce2ef491$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4a3f0044ce2ef491$var$Wc(n) : null, null !== n && (J = $4a3f0044ce2ef491$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4a3f0044ce2ef491$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4a3f0044ce2ef491$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4a3f0044ce2ef491$var$ue(k);
                        u = null == n ? h : $4a3f0044ce2ef491$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4a3f0044ce2ef491$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4a3f0044ce2ef491$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4a3f0044ce2ef491$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4a3f0044ce2ef491$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4a3f0044ce2ef491$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4a3f0044ce2ef491$var$vf(t);
                                x = $4a3f0044ce2ef491$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4a3f0044ce2ef491$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4a3f0044ce2ef491$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4a3f0044ce2ef491$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4a3f0044ce2ef491$var$ve;
                else if ($4a3f0044ce2ef491$var$me(h)) {
                    if ($4a3f0044ce2ef491$var$we) na = $4a3f0044ce2ef491$var$Fe;
                    else {
                        na = $4a3f0044ce2ef491$var$De;
                        var xa = $4a3f0044ce2ef491$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4a3f0044ce2ef491$var$Ee);
                if (na && (na = na(a, d))) {
                    $4a3f0044ce2ef491$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4a3f0044ce2ef491$var$cb(h, "number", h.value);
            }
            xa = d ? $4a3f0044ce2ef491$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4a3f0044ce2ef491$var$me(xa) || "true" === xa.contentEditable) $4a3f0044ce2ef491$var$Qe = xa, $4a3f0044ce2ef491$var$Re = d, $4a3f0044ce2ef491$var$Se = null;
                    break;
                case "focusout":
                    $4a3f0044ce2ef491$var$Se = $4a3f0044ce2ef491$var$Re = $4a3f0044ce2ef491$var$Qe = null;
                    break;
                case "mousedown":
                    $4a3f0044ce2ef491$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4a3f0044ce2ef491$var$Te = !1;
                    $4a3f0044ce2ef491$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4a3f0044ce2ef491$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4a3f0044ce2ef491$var$Ue(g, c, e);
            }
            var $a;
            if ($4a3f0044ce2ef491$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4a3f0044ce2ef491$var$ie ? $4a3f0044ce2ef491$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4a3f0044ce2ef491$var$de && "ko" !== c.locale && ($4a3f0044ce2ef491$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4a3f0044ce2ef491$var$ie && ($a = $4a3f0044ce2ef491$var$nd()) : ($4a3f0044ce2ef491$var$kd = e, $4a3f0044ce2ef491$var$ld = "value" in $4a3f0044ce2ef491$var$kd ? $4a3f0044ce2ef491$var$kd.value : $4a3f0044ce2ef491$var$kd.textContent, $4a3f0044ce2ef491$var$ie = !0)), xa = $4a3f0044ce2ef491$var$oe(d, ba), 0 < xa.length && (ba = new $4a3f0044ce2ef491$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4a3f0044ce2ef491$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4a3f0044ce2ef491$var$ce ? $4a3f0044ce2ef491$var$je(a, c) : $4a3f0044ce2ef491$var$ke(a, c)) d = $4a3f0044ce2ef491$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4a3f0044ce2ef491$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4a3f0044ce2ef491$var$se(g, b);
    });
}
function $4a3f0044ce2ef491$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4a3f0044ce2ef491$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4a3f0044ce2ef491$var$Kb(a, c), null != f && d.unshift($4a3f0044ce2ef491$var$tf(a, f, e)), f = $4a3f0044ce2ef491$var$Kb(a, b), null != f && d.push($4a3f0044ce2ef491$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4a3f0044ce2ef491$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4a3f0044ce2ef491$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4a3f0044ce2ef491$var$Kb(c, f), null != k && g.unshift($4a3f0044ce2ef491$var$tf(c, k, h))) : e || (k = $4a3f0044ce2ef491$var$Kb(c, f), null != k && g.push($4a3f0044ce2ef491$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4a3f0044ce2ef491$var$xf = /\r\n?/g, $4a3f0044ce2ef491$var$yf = /\u0000|\uFFFD/g;
function $4a3f0044ce2ef491$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4a3f0044ce2ef491$var$xf, "\n").replace($4a3f0044ce2ef491$var$yf, "");
}
function $4a3f0044ce2ef491$var$Af(a, b, c) {
    b = $4a3f0044ce2ef491$var$zf(b);
    if ($4a3f0044ce2ef491$var$zf(a) !== b && c) throw Error($4a3f0044ce2ef491$var$p(425));
}
function $4a3f0044ce2ef491$var$Bf() {}
var $4a3f0044ce2ef491$var$Cf = null, $4a3f0044ce2ef491$var$Df = null;
function $4a3f0044ce2ef491$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4a3f0044ce2ef491$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4a3f0044ce2ef491$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4a3f0044ce2ef491$var$Hf = "function" === typeof Promise ? Promise : void 0, $4a3f0044ce2ef491$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4a3f0044ce2ef491$var$Hf ? function(a) {
    return $4a3f0044ce2ef491$var$Hf.resolve(null).then(a).catch($4a3f0044ce2ef491$var$If);
} : $4a3f0044ce2ef491$var$Ff;
function $4a3f0044ce2ef491$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4a3f0044ce2ef491$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4a3f0044ce2ef491$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4a3f0044ce2ef491$var$bd(b);
}
function $4a3f0044ce2ef491$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4a3f0044ce2ef491$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4a3f0044ce2ef491$var$Nf = Math.random().toString(36).slice(2), $4a3f0044ce2ef491$var$Of = "__reactFiber$" + $4a3f0044ce2ef491$var$Nf, $4a3f0044ce2ef491$var$Pf = "__reactProps$" + $4a3f0044ce2ef491$var$Nf, $4a3f0044ce2ef491$var$uf = "__reactContainer$" + $4a3f0044ce2ef491$var$Nf, $4a3f0044ce2ef491$var$of = "__reactEvents$" + $4a3f0044ce2ef491$var$Nf, $4a3f0044ce2ef491$var$Qf = "__reactListeners$" + $4a3f0044ce2ef491$var$Nf, $4a3f0044ce2ef491$var$Rf = "__reactHandles$" + $4a3f0044ce2ef491$var$Nf;
function $4a3f0044ce2ef491$var$Wc(a) {
    var b = a[$4a3f0044ce2ef491$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4a3f0044ce2ef491$var$uf] || c[$4a3f0044ce2ef491$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4a3f0044ce2ef491$var$Mf(a); null !== a;){
                if (c = a[$4a3f0044ce2ef491$var$Of]) return c;
                a = $4a3f0044ce2ef491$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4a3f0044ce2ef491$var$Cb(a) {
    a = a[$4a3f0044ce2ef491$var$Of] || a[$4a3f0044ce2ef491$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4a3f0044ce2ef491$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4a3f0044ce2ef491$var$p(33));
}
function $4a3f0044ce2ef491$var$Db(a) {
    return a[$4a3f0044ce2ef491$var$Pf] || null;
}
var $4a3f0044ce2ef491$var$Sf = [], $4a3f0044ce2ef491$var$Tf = -1;
function $4a3f0044ce2ef491$var$Uf(a) {
    return {
        current: a
    };
}
function $4a3f0044ce2ef491$var$E(a) {
    0 > $4a3f0044ce2ef491$var$Tf || (a.current = $4a3f0044ce2ef491$var$Sf[$4a3f0044ce2ef491$var$Tf], $4a3f0044ce2ef491$var$Sf[$4a3f0044ce2ef491$var$Tf] = null, $4a3f0044ce2ef491$var$Tf--);
}
function $4a3f0044ce2ef491$var$G(a, b) {
    $4a3f0044ce2ef491$var$Tf++;
    $4a3f0044ce2ef491$var$Sf[$4a3f0044ce2ef491$var$Tf] = a.current;
    a.current = b;
}
var $4a3f0044ce2ef491$var$Vf = {}, $4a3f0044ce2ef491$var$H = $4a3f0044ce2ef491$var$Uf($4a3f0044ce2ef491$var$Vf), $4a3f0044ce2ef491$var$Wf = $4a3f0044ce2ef491$var$Uf(!1), $4a3f0044ce2ef491$var$Xf = $4a3f0044ce2ef491$var$Vf;
function $4a3f0044ce2ef491$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4a3f0044ce2ef491$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4a3f0044ce2ef491$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4a3f0044ce2ef491$var$$f() {
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wf);
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$H);
}
function $4a3f0044ce2ef491$var$ag(a, b, c) {
    if ($4a3f0044ce2ef491$var$H.current !== $4a3f0044ce2ef491$var$Vf) throw Error($4a3f0044ce2ef491$var$p(168));
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$H, b);
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$Wf, c);
}
function $4a3f0044ce2ef491$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4a3f0044ce2ef491$var$p(108, $4a3f0044ce2ef491$var$Ra(a) || "Unknown", e));
    return $4a3f0044ce2ef491$var$A({}, c, d);
}
function $4a3f0044ce2ef491$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4a3f0044ce2ef491$var$Vf;
    $4a3f0044ce2ef491$var$Xf = $4a3f0044ce2ef491$var$H.current;
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$H, a);
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$Wf, $4a3f0044ce2ef491$var$Wf.current);
    return !0;
}
function $4a3f0044ce2ef491$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4a3f0044ce2ef491$var$p(169));
    c ? (a = $4a3f0044ce2ef491$var$bg(a, b, $4a3f0044ce2ef491$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wf), $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$H), $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$H, a)) : $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wf);
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$Wf, c);
}
var $4a3f0044ce2ef491$var$eg = null, $4a3f0044ce2ef491$var$fg = !1, $4a3f0044ce2ef491$var$gg = !1;
function $4a3f0044ce2ef491$var$hg(a) {
    null === $4a3f0044ce2ef491$var$eg ? $4a3f0044ce2ef491$var$eg = [
        a
    ] : $4a3f0044ce2ef491$var$eg.push(a);
}
function $4a3f0044ce2ef491$var$ig(a) {
    $4a3f0044ce2ef491$var$fg = !0;
    $4a3f0044ce2ef491$var$hg(a);
}
function $4a3f0044ce2ef491$var$jg() {
    if (!$4a3f0044ce2ef491$var$gg && null !== $4a3f0044ce2ef491$var$eg) {
        $4a3f0044ce2ef491$var$gg = !0;
        var a = 0, b = $4a3f0044ce2ef491$var$C;
        try {
            var c = $4a3f0044ce2ef491$var$eg;
            for($4a3f0044ce2ef491$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4a3f0044ce2ef491$var$eg = null;
            $4a3f0044ce2ef491$var$fg = !1;
        } catch (e) {
            throw null !== $4a3f0044ce2ef491$var$eg && ($4a3f0044ce2ef491$var$eg = $4a3f0044ce2ef491$var$eg.slice(a + 1)), $4a3f0044ce2ef491$var$ac($4a3f0044ce2ef491$var$fc, $4a3f0044ce2ef491$var$jg), e;
        } finally{
            $4a3f0044ce2ef491$var$C = b, $4a3f0044ce2ef491$var$gg = !1;
        }
    }
    return null;
}
var $4a3f0044ce2ef491$var$kg = [], $4a3f0044ce2ef491$var$lg = 0, $4a3f0044ce2ef491$var$mg = null, $4a3f0044ce2ef491$var$ng = 0, $4a3f0044ce2ef491$var$og = [], $4a3f0044ce2ef491$var$pg = 0, $4a3f0044ce2ef491$var$qg = null, $4a3f0044ce2ef491$var$rg = 1, $4a3f0044ce2ef491$var$sg = "";
function $4a3f0044ce2ef491$var$tg(a, b) {
    $4a3f0044ce2ef491$var$kg[$4a3f0044ce2ef491$var$lg++] = $4a3f0044ce2ef491$var$ng;
    $4a3f0044ce2ef491$var$kg[$4a3f0044ce2ef491$var$lg++] = $4a3f0044ce2ef491$var$mg;
    $4a3f0044ce2ef491$var$mg = a;
    $4a3f0044ce2ef491$var$ng = b;
}
function $4a3f0044ce2ef491$var$ug(a, b, c) {
    $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg++] = $4a3f0044ce2ef491$var$rg;
    $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg++] = $4a3f0044ce2ef491$var$sg;
    $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg++] = $4a3f0044ce2ef491$var$qg;
    $4a3f0044ce2ef491$var$qg = a;
    var d = $4a3f0044ce2ef491$var$rg;
    a = $4a3f0044ce2ef491$var$sg;
    var e = 32 - $4a3f0044ce2ef491$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4a3f0044ce2ef491$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4a3f0044ce2ef491$var$rg = 1 << 32 - $4a3f0044ce2ef491$var$oc(b) + e | c << e | d;
        $4a3f0044ce2ef491$var$sg = f + a;
    } else $4a3f0044ce2ef491$var$rg = 1 << f | c << e | d, $4a3f0044ce2ef491$var$sg = a;
}
function $4a3f0044ce2ef491$var$vg(a) {
    null !== a.return && ($4a3f0044ce2ef491$var$tg(a, 1), $4a3f0044ce2ef491$var$ug(a, 1, 0));
}
function $4a3f0044ce2ef491$var$wg(a) {
    for(; a === $4a3f0044ce2ef491$var$mg;)$4a3f0044ce2ef491$var$mg = $4a3f0044ce2ef491$var$kg[--$4a3f0044ce2ef491$var$lg], $4a3f0044ce2ef491$var$kg[$4a3f0044ce2ef491$var$lg] = null, $4a3f0044ce2ef491$var$ng = $4a3f0044ce2ef491$var$kg[--$4a3f0044ce2ef491$var$lg], $4a3f0044ce2ef491$var$kg[$4a3f0044ce2ef491$var$lg] = null;
    for(; a === $4a3f0044ce2ef491$var$qg;)$4a3f0044ce2ef491$var$qg = $4a3f0044ce2ef491$var$og[--$4a3f0044ce2ef491$var$pg], $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg] = null, $4a3f0044ce2ef491$var$sg = $4a3f0044ce2ef491$var$og[--$4a3f0044ce2ef491$var$pg], $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg] = null, $4a3f0044ce2ef491$var$rg = $4a3f0044ce2ef491$var$og[--$4a3f0044ce2ef491$var$pg], $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg] = null;
}
var $4a3f0044ce2ef491$var$xg = null, $4a3f0044ce2ef491$var$yg = null, $4a3f0044ce2ef491$var$I = !1, $4a3f0044ce2ef491$var$zg = null;
function $4a3f0044ce2ef491$var$Ag(a, b) {
    var c = $4a3f0044ce2ef491$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4a3f0044ce2ef491$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4a3f0044ce2ef491$var$xg = a, $4a3f0044ce2ef491$var$yg = $4a3f0044ce2ef491$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4a3f0044ce2ef491$var$xg = a, $4a3f0044ce2ef491$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4a3f0044ce2ef491$var$qg ? {
                id: $4a3f0044ce2ef491$var$rg,
                overflow: $4a3f0044ce2ef491$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4a3f0044ce2ef491$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4a3f0044ce2ef491$var$xg = a, $4a3f0044ce2ef491$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4a3f0044ce2ef491$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4a3f0044ce2ef491$var$Eg(a) {
    if ($4a3f0044ce2ef491$var$I) {
        var b = $4a3f0044ce2ef491$var$yg;
        if (b) {
            var c = b;
            if (!$4a3f0044ce2ef491$var$Cg(a, b)) {
                if ($4a3f0044ce2ef491$var$Dg(a)) throw Error($4a3f0044ce2ef491$var$p(418));
                b = $4a3f0044ce2ef491$var$Lf(c.nextSibling);
                var d = $4a3f0044ce2ef491$var$xg;
                b && $4a3f0044ce2ef491$var$Cg(a, b) ? $4a3f0044ce2ef491$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4a3f0044ce2ef491$var$I = !1, $4a3f0044ce2ef491$var$xg = a);
            }
        } else {
            if ($4a3f0044ce2ef491$var$Dg(a)) throw Error($4a3f0044ce2ef491$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4a3f0044ce2ef491$var$I = !1;
            $4a3f0044ce2ef491$var$xg = a;
        }
    }
}
function $4a3f0044ce2ef491$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4a3f0044ce2ef491$var$xg = a;
}
function $4a3f0044ce2ef491$var$Gg(a) {
    if (a !== $4a3f0044ce2ef491$var$xg) return !1;
    if (!$4a3f0044ce2ef491$var$I) return $4a3f0044ce2ef491$var$Fg(a), $4a3f0044ce2ef491$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4a3f0044ce2ef491$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4a3f0044ce2ef491$var$yg)) {
        if ($4a3f0044ce2ef491$var$Dg(a)) throw $4a3f0044ce2ef491$var$Hg(), Error($4a3f0044ce2ef491$var$p(418));
        for(; b;)$4a3f0044ce2ef491$var$Ag(a, b), b = $4a3f0044ce2ef491$var$Lf(b.nextSibling);
    }
    $4a3f0044ce2ef491$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4a3f0044ce2ef491$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4a3f0044ce2ef491$var$yg = $4a3f0044ce2ef491$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4a3f0044ce2ef491$var$yg = null;
        }
    } else $4a3f0044ce2ef491$var$yg = $4a3f0044ce2ef491$var$xg ? $4a3f0044ce2ef491$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4a3f0044ce2ef491$var$Hg() {
    for(var a = $4a3f0044ce2ef491$var$yg; a;)a = $4a3f0044ce2ef491$var$Lf(a.nextSibling);
}
function $4a3f0044ce2ef491$var$Ig() {
    $4a3f0044ce2ef491$var$yg = $4a3f0044ce2ef491$var$xg = null;
    $4a3f0044ce2ef491$var$I = !1;
}
function $4a3f0044ce2ef491$var$Jg(a) {
    null === $4a3f0044ce2ef491$var$zg ? $4a3f0044ce2ef491$var$zg = [
        a
    ] : $4a3f0044ce2ef491$var$zg.push(a);
}
var $4a3f0044ce2ef491$var$Kg = $4a3f0044ce2ef491$var$ua.ReactCurrentBatchConfig;
function $4a3f0044ce2ef491$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4a3f0044ce2ef491$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4a3f0044ce2ef491$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4a3f0044ce2ef491$var$p(284));
        if (!c._owner) throw Error($4a3f0044ce2ef491$var$p(290, a));
    }
    return a;
}
function $4a3f0044ce2ef491$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4a3f0044ce2ef491$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4a3f0044ce2ef491$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4a3f0044ce2ef491$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4a3f0044ce2ef491$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4a3f0044ce2ef491$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4a3f0044ce2ef491$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4a3f0044ce2ef491$var$Ha && $4a3f0044ce2ef491$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4a3f0044ce2ef491$var$Lg(a, b, c), d.return = a, d;
        d = $4a3f0044ce2ef491$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4a3f0044ce2ef491$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4a3f0044ce2ef491$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4a3f0044ce2ef491$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4a3f0044ce2ef491$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4a3f0044ce2ef491$var$va:
                    return c = $4a3f0044ce2ef491$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4a3f0044ce2ef491$var$Lg(a, null, b), c.return = a, c;
                case $4a3f0044ce2ef491$var$wa:
                    return b = $4a3f0044ce2ef491$var$Sg(b, a.mode, c), b.return = a, b;
                case $4a3f0044ce2ef491$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4a3f0044ce2ef491$var$eb(b) || $4a3f0044ce2ef491$var$Ka(b)) return b = $4a3f0044ce2ef491$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4a3f0044ce2ef491$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4a3f0044ce2ef491$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4a3f0044ce2ef491$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4a3f0044ce2ef491$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4a3f0044ce2ef491$var$eb(c) || $4a3f0044ce2ef491$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4a3f0044ce2ef491$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4a3f0044ce2ef491$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4a3f0044ce2ef491$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4a3f0044ce2ef491$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4a3f0044ce2ef491$var$eb(d) || $4a3f0044ce2ef491$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4a3f0044ce2ef491$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4a3f0044ce2ef491$var$I && $4a3f0044ce2ef491$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4a3f0044ce2ef491$var$I && $4a3f0044ce2ef491$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4a3f0044ce2ef491$var$I && $4a3f0044ce2ef491$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4a3f0044ce2ef491$var$Ka(h);
        if ("function" !== typeof l) throw Error($4a3f0044ce2ef491$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4a3f0044ce2ef491$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4a3f0044ce2ef491$var$I && $4a3f0044ce2ef491$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4a3f0044ce2ef491$var$I && $4a3f0044ce2ef491$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4a3f0044ce2ef491$var$I && $4a3f0044ce2ef491$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4a3f0044ce2ef491$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4a3f0044ce2ef491$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4a3f0044ce2ef491$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4a3f0044ce2ef491$var$Ha && $4a3f0044ce2ef491$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4a3f0044ce2ef491$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4a3f0044ce2ef491$var$ya ? (d = $4a3f0044ce2ef491$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4a3f0044ce2ef491$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4a3f0044ce2ef491$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4a3f0044ce2ef491$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4a3f0044ce2ef491$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4a3f0044ce2ef491$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4a3f0044ce2ef491$var$eb(f)) return n(a, d, f, h);
            if ($4a3f0044ce2ef491$var$Ka(f)) return t(a, d, f, h);
            $4a3f0044ce2ef491$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4a3f0044ce2ef491$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4a3f0044ce2ef491$var$Ug = $4a3f0044ce2ef491$var$Og(!0), $4a3f0044ce2ef491$var$Vg = $4a3f0044ce2ef491$var$Og(!1), $4a3f0044ce2ef491$var$Wg = $4a3f0044ce2ef491$var$Uf(null), $4a3f0044ce2ef491$var$Xg = null, $4a3f0044ce2ef491$var$Yg = null, $4a3f0044ce2ef491$var$Zg = null;
function $4a3f0044ce2ef491$var$$g() {
    $4a3f0044ce2ef491$var$Zg = $4a3f0044ce2ef491$var$Yg = $4a3f0044ce2ef491$var$Xg = null;
}
function $4a3f0044ce2ef491$var$ah(a) {
    var b = $4a3f0044ce2ef491$var$Wg.current;
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wg);
    a._currentValue = b;
}
function $4a3f0044ce2ef491$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4a3f0044ce2ef491$var$ch(a, b) {
    $4a3f0044ce2ef491$var$Xg = a;
    $4a3f0044ce2ef491$var$Zg = $4a3f0044ce2ef491$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4a3f0044ce2ef491$var$dh = !0), a.firstContext = null);
}
function $4a3f0044ce2ef491$var$eh(a) {
    var b = a._currentValue;
    if ($4a3f0044ce2ef491$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4a3f0044ce2ef491$var$Yg) {
            if (null === $4a3f0044ce2ef491$var$Xg) throw Error($4a3f0044ce2ef491$var$p(308));
            $4a3f0044ce2ef491$var$Yg = a;
            $4a3f0044ce2ef491$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4a3f0044ce2ef491$var$Yg = $4a3f0044ce2ef491$var$Yg.next = a;
    }
    return b;
}
var $4a3f0044ce2ef491$var$fh = null;
function $4a3f0044ce2ef491$var$gh(a) {
    null === $4a3f0044ce2ef491$var$fh ? $4a3f0044ce2ef491$var$fh = [
        a
    ] : $4a3f0044ce2ef491$var$fh.push(a);
}
function $4a3f0044ce2ef491$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4a3f0044ce2ef491$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4a3f0044ce2ef491$var$ih(a, d);
}
function $4a3f0044ce2ef491$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4a3f0044ce2ef491$var$jh = !1;
function $4a3f0044ce2ef491$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4a3f0044ce2ef491$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4a3f0044ce2ef491$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4a3f0044ce2ef491$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4a3f0044ce2ef491$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4a3f0044ce2ef491$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4a3f0044ce2ef491$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4a3f0044ce2ef491$var$ih(a, c);
}
function $4a3f0044ce2ef491$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4a3f0044ce2ef491$var$Cc(a, c);
    }
}
function $4a3f0044ce2ef491$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4a3f0044ce2ef491$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4a3f0044ce2ef491$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4a3f0044ce2ef491$var$A({}, q, r);
                            break a;
                        case 2:
                            $4a3f0044ce2ef491$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4a3f0044ce2ef491$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4a3f0044ce2ef491$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4a3f0044ce2ef491$var$p(191, e));
            e.call(d);
        }
    }
}
var $4a3f0044ce2ef491$var$th = {}, $4a3f0044ce2ef491$var$uh = $4a3f0044ce2ef491$var$Uf($4a3f0044ce2ef491$var$th), $4a3f0044ce2ef491$var$vh = $4a3f0044ce2ef491$var$Uf($4a3f0044ce2ef491$var$th), $4a3f0044ce2ef491$var$wh = $4a3f0044ce2ef491$var$Uf($4a3f0044ce2ef491$var$th);
function $4a3f0044ce2ef491$var$xh(a) {
    if (a === $4a3f0044ce2ef491$var$th) throw Error($4a3f0044ce2ef491$var$p(174));
    return a;
}
function $4a3f0044ce2ef491$var$yh(a, b) {
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$wh, b);
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$vh, a);
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$uh, $4a3f0044ce2ef491$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4a3f0044ce2ef491$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4a3f0044ce2ef491$var$lb(b, a);
    }
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$uh);
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$uh, b);
}
function $4a3f0044ce2ef491$var$zh() {
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$uh);
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$vh);
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$wh);
}
function $4a3f0044ce2ef491$var$Ah(a) {
    $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$wh.current);
    var b = $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$uh.current);
    var c = $4a3f0044ce2ef491$var$lb(b, a.type);
    b !== c && ($4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$vh, a), $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$uh, c));
}
function $4a3f0044ce2ef491$var$Bh(a) {
    $4a3f0044ce2ef491$var$vh.current === a && ($4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$uh), $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$vh));
}
var $4a3f0044ce2ef491$var$L = $4a3f0044ce2ef491$var$Uf(0);
function $4a3f0044ce2ef491$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4a3f0044ce2ef491$var$Dh = [];
function $4a3f0044ce2ef491$var$Eh() {
    for(var a = 0; a < $4a3f0044ce2ef491$var$Dh.length; a++)$4a3f0044ce2ef491$var$Dh[a]._workInProgressVersionPrimary = null;
    $4a3f0044ce2ef491$var$Dh.length = 0;
}
var $4a3f0044ce2ef491$var$Fh = $4a3f0044ce2ef491$var$ua.ReactCurrentDispatcher, $4a3f0044ce2ef491$var$Gh = $4a3f0044ce2ef491$var$ua.ReactCurrentBatchConfig, $4a3f0044ce2ef491$var$Hh = 0, $4a3f0044ce2ef491$var$M = null, $4a3f0044ce2ef491$var$N = null, $4a3f0044ce2ef491$var$O = null, $4a3f0044ce2ef491$var$Ih = !1, $4a3f0044ce2ef491$var$Jh = !1, $4a3f0044ce2ef491$var$Kh = 0, $4a3f0044ce2ef491$var$Lh = 0;
function $4a3f0044ce2ef491$var$P() {
    throw Error($4a3f0044ce2ef491$var$p(321));
}
function $4a3f0044ce2ef491$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4a3f0044ce2ef491$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4a3f0044ce2ef491$var$Nh(a, b, c, d, e, f) {
    $4a3f0044ce2ef491$var$Hh = f;
    $4a3f0044ce2ef491$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4a3f0044ce2ef491$var$Fh.current = null === a || null === a.memoizedState ? $4a3f0044ce2ef491$var$Oh : $4a3f0044ce2ef491$var$Ph;
    a = c(d, e);
    if ($4a3f0044ce2ef491$var$Jh) {
        f = 0;
        do {
            $4a3f0044ce2ef491$var$Jh = !1;
            $4a3f0044ce2ef491$var$Kh = 0;
            if (25 <= f) throw Error($4a3f0044ce2ef491$var$p(301));
            f += 1;
            $4a3f0044ce2ef491$var$O = $4a3f0044ce2ef491$var$N = null;
            b.updateQueue = null;
            $4a3f0044ce2ef491$var$Fh.current = $4a3f0044ce2ef491$var$Qh;
            a = c(d, e);
        }while ($4a3f0044ce2ef491$var$Jh);
    }
    $4a3f0044ce2ef491$var$Fh.current = $4a3f0044ce2ef491$var$Rh;
    b = null !== $4a3f0044ce2ef491$var$N && null !== $4a3f0044ce2ef491$var$N.next;
    $4a3f0044ce2ef491$var$Hh = 0;
    $4a3f0044ce2ef491$var$O = $4a3f0044ce2ef491$var$N = $4a3f0044ce2ef491$var$M = null;
    $4a3f0044ce2ef491$var$Ih = !1;
    if (b) throw Error($4a3f0044ce2ef491$var$p(300));
    return a;
}
function $4a3f0044ce2ef491$var$Sh() {
    var a = 0 !== $4a3f0044ce2ef491$var$Kh;
    $4a3f0044ce2ef491$var$Kh = 0;
    return a;
}
function $4a3f0044ce2ef491$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4a3f0044ce2ef491$var$O ? $4a3f0044ce2ef491$var$M.memoizedState = $4a3f0044ce2ef491$var$O = a : $4a3f0044ce2ef491$var$O = $4a3f0044ce2ef491$var$O.next = a;
    return $4a3f0044ce2ef491$var$O;
}
function $4a3f0044ce2ef491$var$Uh() {
    if (null === $4a3f0044ce2ef491$var$N) {
        var a = $4a3f0044ce2ef491$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4a3f0044ce2ef491$var$N.next;
    var b = null === $4a3f0044ce2ef491$var$O ? $4a3f0044ce2ef491$var$M.memoizedState : $4a3f0044ce2ef491$var$O.next;
    if (null !== b) $4a3f0044ce2ef491$var$O = b, $4a3f0044ce2ef491$var$N = a;
    else {
        if (null === a) throw Error($4a3f0044ce2ef491$var$p(310));
        $4a3f0044ce2ef491$var$N = a;
        a = {
            memoizedState: $4a3f0044ce2ef491$var$N.memoizedState,
            baseState: $4a3f0044ce2ef491$var$N.baseState,
            baseQueue: $4a3f0044ce2ef491$var$N.baseQueue,
            queue: $4a3f0044ce2ef491$var$N.queue,
            next: null
        };
        null === $4a3f0044ce2ef491$var$O ? $4a3f0044ce2ef491$var$M.memoizedState = $4a3f0044ce2ef491$var$O = a : $4a3f0044ce2ef491$var$O = $4a3f0044ce2ef491$var$O.next = a;
    }
    return $4a3f0044ce2ef491$var$O;
}
function $4a3f0044ce2ef491$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4a3f0044ce2ef491$var$Wh(a) {
    var b = $4a3f0044ce2ef491$var$Uh(), c = b.queue;
    if (null === c) throw Error($4a3f0044ce2ef491$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4a3f0044ce2ef491$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4a3f0044ce2ef491$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4a3f0044ce2ef491$var$M.lanes |= m;
                $4a3f0044ce2ef491$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4a3f0044ce2ef491$var$He(d, b.memoizedState) || ($4a3f0044ce2ef491$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4a3f0044ce2ef491$var$M.lanes |= f, $4a3f0044ce2ef491$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4a3f0044ce2ef491$var$Xh(a) {
    var b = $4a3f0044ce2ef491$var$Uh(), c = b.queue;
    if (null === c) throw Error($4a3f0044ce2ef491$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4a3f0044ce2ef491$var$He(f, b.memoizedState) || ($4a3f0044ce2ef491$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4a3f0044ce2ef491$var$Yh() {}
function $4a3f0044ce2ef491$var$Zh(a, b) {
    var c = $4a3f0044ce2ef491$var$M, d = $4a3f0044ce2ef491$var$Uh(), e = b(), f = !$4a3f0044ce2ef491$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4a3f0044ce2ef491$var$dh = !0);
    d = d.queue;
    $4a3f0044ce2ef491$var$$h($4a3f0044ce2ef491$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4a3f0044ce2ef491$var$O && $4a3f0044ce2ef491$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4a3f0044ce2ef491$var$bi(9, $4a3f0044ce2ef491$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4a3f0044ce2ef491$var$Q) throw Error($4a3f0044ce2ef491$var$p(349));
        0 !== ($4a3f0044ce2ef491$var$Hh & 30) || $4a3f0044ce2ef491$var$di(c, b, e);
    }
    return e;
}
function $4a3f0044ce2ef491$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4a3f0044ce2ef491$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4a3f0044ce2ef491$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4a3f0044ce2ef491$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4a3f0044ce2ef491$var$ei(b) && $4a3f0044ce2ef491$var$fi(a);
}
function $4a3f0044ce2ef491$var$ai(a, b, c) {
    return c(function() {
        $4a3f0044ce2ef491$var$ei(b) && $4a3f0044ce2ef491$var$fi(a);
    });
}
function $4a3f0044ce2ef491$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4a3f0044ce2ef491$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4a3f0044ce2ef491$var$fi(a) {
    var b = $4a3f0044ce2ef491$var$ih(a, 1);
    null !== b && $4a3f0044ce2ef491$var$gi(b, a, 1, -1);
}
function $4a3f0044ce2ef491$var$hi(a) {
    var b = $4a3f0044ce2ef491$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4a3f0044ce2ef491$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4a3f0044ce2ef491$var$ii.bind(null, $4a3f0044ce2ef491$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4a3f0044ce2ef491$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4a3f0044ce2ef491$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4a3f0044ce2ef491$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4a3f0044ce2ef491$var$ji() {
    return $4a3f0044ce2ef491$var$Uh().memoizedState;
}
function $4a3f0044ce2ef491$var$ki(a, b, c, d) {
    var e = $4a3f0044ce2ef491$var$Th();
    $4a3f0044ce2ef491$var$M.flags |= a;
    e.memoizedState = $4a3f0044ce2ef491$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4a3f0044ce2ef491$var$li(a, b, c, d) {
    var e = $4a3f0044ce2ef491$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4a3f0044ce2ef491$var$N) {
        var g = $4a3f0044ce2ef491$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4a3f0044ce2ef491$var$Mh(d, g.deps)) {
            e.memoizedState = $4a3f0044ce2ef491$var$bi(b, c, f, d);
            return;
        }
    }
    $4a3f0044ce2ef491$var$M.flags |= a;
    e.memoizedState = $4a3f0044ce2ef491$var$bi(1 | b, c, f, d);
}
function $4a3f0044ce2ef491$var$mi(a, b) {
    return $4a3f0044ce2ef491$var$ki(8390656, 8, a, b);
}
function $4a3f0044ce2ef491$var$$h(a, b) {
    return $4a3f0044ce2ef491$var$li(2048, 8, a, b);
}
function $4a3f0044ce2ef491$var$ni(a, b) {
    return $4a3f0044ce2ef491$var$li(4, 2, a, b);
}
function $4a3f0044ce2ef491$var$oi(a, b) {
    return $4a3f0044ce2ef491$var$li(4, 4, a, b);
}
function $4a3f0044ce2ef491$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4a3f0044ce2ef491$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4a3f0044ce2ef491$var$li(4, 4, $4a3f0044ce2ef491$var$pi.bind(null, b, a), c);
}
function $4a3f0044ce2ef491$var$ri() {}
function $4a3f0044ce2ef491$var$si(a, b) {
    var c = $4a3f0044ce2ef491$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4a3f0044ce2ef491$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4a3f0044ce2ef491$var$ti(a, b) {
    var c = $4a3f0044ce2ef491$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4a3f0044ce2ef491$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4a3f0044ce2ef491$var$ui(a, b, c) {
    if (0 === ($4a3f0044ce2ef491$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4a3f0044ce2ef491$var$dh = !0), a.memoizedState = c;
    $4a3f0044ce2ef491$var$He(c, b) || (c = $4a3f0044ce2ef491$var$yc(), $4a3f0044ce2ef491$var$M.lanes |= c, $4a3f0044ce2ef491$var$rh |= c, a.baseState = !0);
    return b;
}
function $4a3f0044ce2ef491$var$vi(a, b) {
    var c = $4a3f0044ce2ef491$var$C;
    $4a3f0044ce2ef491$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4a3f0044ce2ef491$var$Gh.transition;
    $4a3f0044ce2ef491$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4a3f0044ce2ef491$var$C = c, $4a3f0044ce2ef491$var$Gh.transition = d;
    }
}
function $4a3f0044ce2ef491$var$wi() {
    return $4a3f0044ce2ef491$var$Uh().memoizedState;
}
function $4a3f0044ce2ef491$var$xi(a, b, c) {
    var d = $4a3f0044ce2ef491$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4a3f0044ce2ef491$var$zi(a)) $4a3f0044ce2ef491$var$Ai(b, c);
    else if (c = $4a3f0044ce2ef491$var$hh(a, b, c, d), null !== c) {
        var e = $4a3f0044ce2ef491$var$R();
        $4a3f0044ce2ef491$var$gi(c, a, d, e);
        $4a3f0044ce2ef491$var$Bi(c, b, d);
    }
}
function $4a3f0044ce2ef491$var$ii(a, b, c) {
    var d = $4a3f0044ce2ef491$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4a3f0044ce2ef491$var$zi(a)) $4a3f0044ce2ef491$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4a3f0044ce2ef491$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4a3f0044ce2ef491$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4a3f0044ce2ef491$var$hh(a, b, e, d);
        null !== c && (e = $4a3f0044ce2ef491$var$R(), $4a3f0044ce2ef491$var$gi(c, a, d, e), $4a3f0044ce2ef491$var$Bi(c, b, d));
    }
}
function $4a3f0044ce2ef491$var$zi(a) {
    var b = a.alternate;
    return a === $4a3f0044ce2ef491$var$M || null !== b && b === $4a3f0044ce2ef491$var$M;
}
function $4a3f0044ce2ef491$var$Ai(a, b) {
    $4a3f0044ce2ef491$var$Jh = $4a3f0044ce2ef491$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4a3f0044ce2ef491$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4a3f0044ce2ef491$var$Cc(a, c);
    }
}
var $4a3f0044ce2ef491$var$Rh = {
    readContext: $4a3f0044ce2ef491$var$eh,
    useCallback: $4a3f0044ce2ef491$var$P,
    useContext: $4a3f0044ce2ef491$var$P,
    useEffect: $4a3f0044ce2ef491$var$P,
    useImperativeHandle: $4a3f0044ce2ef491$var$P,
    useInsertionEffect: $4a3f0044ce2ef491$var$P,
    useLayoutEffect: $4a3f0044ce2ef491$var$P,
    useMemo: $4a3f0044ce2ef491$var$P,
    useReducer: $4a3f0044ce2ef491$var$P,
    useRef: $4a3f0044ce2ef491$var$P,
    useState: $4a3f0044ce2ef491$var$P,
    useDebugValue: $4a3f0044ce2ef491$var$P,
    useDeferredValue: $4a3f0044ce2ef491$var$P,
    useTransition: $4a3f0044ce2ef491$var$P,
    useMutableSource: $4a3f0044ce2ef491$var$P,
    useSyncExternalStore: $4a3f0044ce2ef491$var$P,
    useId: $4a3f0044ce2ef491$var$P,
    unstable_isNewReconciler: !1
}, $4a3f0044ce2ef491$var$Oh = {
    readContext: $4a3f0044ce2ef491$var$eh,
    useCallback: function(a, b) {
        $4a3f0044ce2ef491$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4a3f0044ce2ef491$var$eh,
    useEffect: $4a3f0044ce2ef491$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4a3f0044ce2ef491$var$ki(4194308, 4, $4a3f0044ce2ef491$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4a3f0044ce2ef491$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4a3f0044ce2ef491$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4a3f0044ce2ef491$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4a3f0044ce2ef491$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4a3f0044ce2ef491$var$xi.bind(null, $4a3f0044ce2ef491$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4a3f0044ce2ef491$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4a3f0044ce2ef491$var$hi,
    useDebugValue: $4a3f0044ce2ef491$var$ri,
    useDeferredValue: function(a) {
        return $4a3f0044ce2ef491$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4a3f0044ce2ef491$var$hi(!1), b = a[0];
        a = $4a3f0044ce2ef491$var$vi.bind(null, a[1]);
        $4a3f0044ce2ef491$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4a3f0044ce2ef491$var$M, e = $4a3f0044ce2ef491$var$Th();
        if ($4a3f0044ce2ef491$var$I) {
            if (void 0 === c) throw Error($4a3f0044ce2ef491$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4a3f0044ce2ef491$var$Q) throw Error($4a3f0044ce2ef491$var$p(349));
            0 !== ($4a3f0044ce2ef491$var$Hh & 30) || $4a3f0044ce2ef491$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4a3f0044ce2ef491$var$mi($4a3f0044ce2ef491$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4a3f0044ce2ef491$var$bi(9, $4a3f0044ce2ef491$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4a3f0044ce2ef491$var$Th(), b = $4a3f0044ce2ef491$var$Q.identifierPrefix;
        if ($4a3f0044ce2ef491$var$I) {
            var c = $4a3f0044ce2ef491$var$sg;
            var d = $4a3f0044ce2ef491$var$rg;
            c = (d & ~(1 << 32 - $4a3f0044ce2ef491$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4a3f0044ce2ef491$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4a3f0044ce2ef491$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4a3f0044ce2ef491$var$Ph = {
    readContext: $4a3f0044ce2ef491$var$eh,
    useCallback: $4a3f0044ce2ef491$var$si,
    useContext: $4a3f0044ce2ef491$var$eh,
    useEffect: $4a3f0044ce2ef491$var$$h,
    useImperativeHandle: $4a3f0044ce2ef491$var$qi,
    useInsertionEffect: $4a3f0044ce2ef491$var$ni,
    useLayoutEffect: $4a3f0044ce2ef491$var$oi,
    useMemo: $4a3f0044ce2ef491$var$ti,
    useReducer: $4a3f0044ce2ef491$var$Wh,
    useRef: $4a3f0044ce2ef491$var$ji,
    useState: function() {
        return $4a3f0044ce2ef491$var$Wh($4a3f0044ce2ef491$var$Vh);
    },
    useDebugValue: $4a3f0044ce2ef491$var$ri,
    useDeferredValue: function(a) {
        var b = $4a3f0044ce2ef491$var$Uh();
        return $4a3f0044ce2ef491$var$ui(b, $4a3f0044ce2ef491$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4a3f0044ce2ef491$var$Wh($4a3f0044ce2ef491$var$Vh)[0], b = $4a3f0044ce2ef491$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4a3f0044ce2ef491$var$Yh,
    useSyncExternalStore: $4a3f0044ce2ef491$var$Zh,
    useId: $4a3f0044ce2ef491$var$wi,
    unstable_isNewReconciler: !1
}, $4a3f0044ce2ef491$var$Qh = {
    readContext: $4a3f0044ce2ef491$var$eh,
    useCallback: $4a3f0044ce2ef491$var$si,
    useContext: $4a3f0044ce2ef491$var$eh,
    useEffect: $4a3f0044ce2ef491$var$$h,
    useImperativeHandle: $4a3f0044ce2ef491$var$qi,
    useInsertionEffect: $4a3f0044ce2ef491$var$ni,
    useLayoutEffect: $4a3f0044ce2ef491$var$oi,
    useMemo: $4a3f0044ce2ef491$var$ti,
    useReducer: $4a3f0044ce2ef491$var$Xh,
    useRef: $4a3f0044ce2ef491$var$ji,
    useState: function() {
        return $4a3f0044ce2ef491$var$Xh($4a3f0044ce2ef491$var$Vh);
    },
    useDebugValue: $4a3f0044ce2ef491$var$ri,
    useDeferredValue: function(a) {
        var b = $4a3f0044ce2ef491$var$Uh();
        return null === $4a3f0044ce2ef491$var$N ? b.memoizedState = a : $4a3f0044ce2ef491$var$ui(b, $4a3f0044ce2ef491$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4a3f0044ce2ef491$var$Xh($4a3f0044ce2ef491$var$Vh)[0], b = $4a3f0044ce2ef491$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4a3f0044ce2ef491$var$Yh,
    useSyncExternalStore: $4a3f0044ce2ef491$var$Zh,
    useId: $4a3f0044ce2ef491$var$wi,
    unstable_isNewReconciler: !1
};
function $4a3f0044ce2ef491$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4a3f0044ce2ef491$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4a3f0044ce2ef491$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4a3f0044ce2ef491$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4a3f0044ce2ef491$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4a3f0044ce2ef491$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4a3f0044ce2ef491$var$R(), e = $4a3f0044ce2ef491$var$yi(a), f = $4a3f0044ce2ef491$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4a3f0044ce2ef491$var$nh(a, f, e);
        null !== b && ($4a3f0044ce2ef491$var$gi(b, a, e, d), $4a3f0044ce2ef491$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4a3f0044ce2ef491$var$R(), e = $4a3f0044ce2ef491$var$yi(a), f = $4a3f0044ce2ef491$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4a3f0044ce2ef491$var$nh(a, f, e);
        null !== b && ($4a3f0044ce2ef491$var$gi(b, a, e, d), $4a3f0044ce2ef491$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4a3f0044ce2ef491$var$R(), d = $4a3f0044ce2ef491$var$yi(a), e = $4a3f0044ce2ef491$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4a3f0044ce2ef491$var$nh(a, e, d);
        null !== b && ($4a3f0044ce2ef491$var$gi(b, a, d, c), $4a3f0044ce2ef491$var$oh(b, a, d));
    }
};
function $4a3f0044ce2ef491$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4a3f0044ce2ef491$var$Ie(c, d) || !$4a3f0044ce2ef491$var$Ie(e, f) : !0;
}
function $4a3f0044ce2ef491$var$Gi(a, b, c) {
    var d = !1, e = $4a3f0044ce2ef491$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4a3f0044ce2ef491$var$eh(f) : (e = $4a3f0044ce2ef491$var$Zf(b) ? $4a3f0044ce2ef491$var$Xf : $4a3f0044ce2ef491$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4a3f0044ce2ef491$var$Yf(a, e) : $4a3f0044ce2ef491$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4a3f0044ce2ef491$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4a3f0044ce2ef491$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4a3f0044ce2ef491$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4a3f0044ce2ef491$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4a3f0044ce2ef491$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4a3f0044ce2ef491$var$eh(f) : (f = $4a3f0044ce2ef491$var$Zf(b) ? $4a3f0044ce2ef491$var$Xf : $4a3f0044ce2ef491$var$H.current, e.context = $4a3f0044ce2ef491$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4a3f0044ce2ef491$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4a3f0044ce2ef491$var$Ei.enqueueReplaceState(e, e.state, null), $4a3f0044ce2ef491$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4a3f0044ce2ef491$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4a3f0044ce2ef491$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4a3f0044ce2ef491$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4a3f0044ce2ef491$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4a3f0044ce2ef491$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4a3f0044ce2ef491$var$Ni(a, b, c) {
    c = $4a3f0044ce2ef491$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4a3f0044ce2ef491$var$Oi || ($4a3f0044ce2ef491$var$Oi = !0, $4a3f0044ce2ef491$var$Pi = d);
        $4a3f0044ce2ef491$var$Li(a, b);
    };
    return c;
}
function $4a3f0044ce2ef491$var$Qi(a, b, c) {
    c = $4a3f0044ce2ef491$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4a3f0044ce2ef491$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4a3f0044ce2ef491$var$Li(a, b);
        "function" !== typeof d && (null === $4a3f0044ce2ef491$var$Ri ? $4a3f0044ce2ef491$var$Ri = new Set([
            this
        ]) : $4a3f0044ce2ef491$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4a3f0044ce2ef491$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4a3f0044ce2ef491$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4a3f0044ce2ef491$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4a3f0044ce2ef491$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4a3f0044ce2ef491$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4a3f0044ce2ef491$var$mh(-1, 1), b.tag = 2, $4a3f0044ce2ef491$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4a3f0044ce2ef491$var$Wi = $4a3f0044ce2ef491$var$ua.ReactCurrentOwner, $4a3f0044ce2ef491$var$dh = !1;
function $4a3f0044ce2ef491$var$Xi(a, b, c, d) {
    b.child = null === a ? $4a3f0044ce2ef491$var$Vg(b, null, c, d) : $4a3f0044ce2ef491$var$Ug(b, a.child, c, d);
}
function $4a3f0044ce2ef491$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4a3f0044ce2ef491$var$ch(b, e);
    d = $4a3f0044ce2ef491$var$Nh(a, b, c, d, f, e);
    c = $4a3f0044ce2ef491$var$Sh();
    if (null !== a && !$4a3f0044ce2ef491$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4a3f0044ce2ef491$var$Zi(a, b, e);
    $4a3f0044ce2ef491$var$I && c && $4a3f0044ce2ef491$var$vg(b);
    b.flags |= 1;
    $4a3f0044ce2ef491$var$Xi(a, b, d, e);
    return b.child;
}
function $4a3f0044ce2ef491$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4a3f0044ce2ef491$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4a3f0044ce2ef491$var$bj(a, b, f, d, e);
        a = $4a3f0044ce2ef491$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4a3f0044ce2ef491$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4a3f0044ce2ef491$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4a3f0044ce2ef491$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4a3f0044ce2ef491$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4a3f0044ce2ef491$var$Ie(f, d) && a.ref === b.ref) {
            if ($4a3f0044ce2ef491$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4a3f0044ce2ef491$var$dh = !0);
            else return b.lanes = a.lanes, $4a3f0044ce2ef491$var$Zi(a, b, e);
        }
    }
    return $4a3f0044ce2ef491$var$cj(a, b, c, d, e);
}
function $4a3f0044ce2ef491$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$ej, $4a3f0044ce2ef491$var$fj), $4a3f0044ce2ef491$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$ej, $4a3f0044ce2ef491$var$fj), $4a3f0044ce2ef491$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$ej, $4a3f0044ce2ef491$var$fj);
            $4a3f0044ce2ef491$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$ej, $4a3f0044ce2ef491$var$fj), $4a3f0044ce2ef491$var$fj |= d;
    $4a3f0044ce2ef491$var$Xi(a, b, e, c);
    return b.child;
}
function $4a3f0044ce2ef491$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4a3f0044ce2ef491$var$cj(a, b, c, d, e) {
    var f = $4a3f0044ce2ef491$var$Zf(c) ? $4a3f0044ce2ef491$var$Xf : $4a3f0044ce2ef491$var$H.current;
    f = $4a3f0044ce2ef491$var$Yf(b, f);
    $4a3f0044ce2ef491$var$ch(b, e);
    c = $4a3f0044ce2ef491$var$Nh(a, b, c, d, f, e);
    d = $4a3f0044ce2ef491$var$Sh();
    if (null !== a && !$4a3f0044ce2ef491$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4a3f0044ce2ef491$var$Zi(a, b, e);
    $4a3f0044ce2ef491$var$I && d && $4a3f0044ce2ef491$var$vg(b);
    b.flags |= 1;
    $4a3f0044ce2ef491$var$Xi(a, b, c, e);
    return b.child;
}
function $4a3f0044ce2ef491$var$hj(a, b, c, d, e) {
    if ($4a3f0044ce2ef491$var$Zf(c)) {
        var f = !0;
        $4a3f0044ce2ef491$var$cg(b);
    } else f = !1;
    $4a3f0044ce2ef491$var$ch(b, e);
    if (null === b.stateNode) $4a3f0044ce2ef491$var$ij(a, b), $4a3f0044ce2ef491$var$Gi(b, c, d), $4a3f0044ce2ef491$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4a3f0044ce2ef491$var$eh(l) : (l = $4a3f0044ce2ef491$var$Zf(c) ? $4a3f0044ce2ef491$var$Xf : $4a3f0044ce2ef491$var$H.current, l = $4a3f0044ce2ef491$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4a3f0044ce2ef491$var$Hi(b, g, d, l);
        $4a3f0044ce2ef491$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4a3f0044ce2ef491$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4a3f0044ce2ef491$var$Wf.current || $4a3f0044ce2ef491$var$jh ? ("function" === typeof m && ($4a3f0044ce2ef491$var$Di(b, c, m, d), k = b.memoizedState), (h = $4a3f0044ce2ef491$var$jh || $4a3f0044ce2ef491$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4a3f0044ce2ef491$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4a3f0044ce2ef491$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4a3f0044ce2ef491$var$eh(k) : (k = $4a3f0044ce2ef491$var$Zf(c) ? $4a3f0044ce2ef491$var$Xf : $4a3f0044ce2ef491$var$H.current, k = $4a3f0044ce2ef491$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4a3f0044ce2ef491$var$Hi(b, g, d, k);
        $4a3f0044ce2ef491$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4a3f0044ce2ef491$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4a3f0044ce2ef491$var$Wf.current || $4a3f0044ce2ef491$var$jh ? ("function" === typeof y && ($4a3f0044ce2ef491$var$Di(b, c, y, d), n = b.memoizedState), (l = $4a3f0044ce2ef491$var$jh || $4a3f0044ce2ef491$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4a3f0044ce2ef491$var$jj(a, b, c, d, f, e);
}
function $4a3f0044ce2ef491$var$jj(a, b, c, d, e, f) {
    $4a3f0044ce2ef491$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4a3f0044ce2ef491$var$dg(b, c, !1), $4a3f0044ce2ef491$var$Zi(a, b, f);
    d = b.stateNode;
    $4a3f0044ce2ef491$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4a3f0044ce2ef491$var$Ug(b, a.child, null, f), b.child = $4a3f0044ce2ef491$var$Ug(b, null, h, f)) : $4a3f0044ce2ef491$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4a3f0044ce2ef491$var$dg(b, c, !0);
    return b.child;
}
function $4a3f0044ce2ef491$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4a3f0044ce2ef491$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4a3f0044ce2ef491$var$ag(a, b.context, !1);
    $4a3f0044ce2ef491$var$yh(a, b.containerInfo);
}
function $4a3f0044ce2ef491$var$lj(a, b, c, d, e) {
    $4a3f0044ce2ef491$var$Ig();
    $4a3f0044ce2ef491$var$Jg(e);
    b.flags |= 256;
    $4a3f0044ce2ef491$var$Xi(a, b, c, d);
    return b.child;
}
var $4a3f0044ce2ef491$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4a3f0044ce2ef491$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4a3f0044ce2ef491$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4a3f0044ce2ef491$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, e & 1);
    if (null === a) {
        $4a3f0044ce2ef491$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4a3f0044ce2ef491$var$pj(g, d, 0, null), a = $4a3f0044ce2ef491$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4a3f0044ce2ef491$var$nj(c), b.memoizedState = $4a3f0044ce2ef491$var$mj, a) : $4a3f0044ce2ef491$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4a3f0044ce2ef491$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4a3f0044ce2ef491$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4a3f0044ce2ef491$var$Pg(h, f) : (f = $4a3f0044ce2ef491$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4a3f0044ce2ef491$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4a3f0044ce2ef491$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4a3f0044ce2ef491$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4a3f0044ce2ef491$var$qj(a, b) {
    b = $4a3f0044ce2ef491$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4a3f0044ce2ef491$var$sj(a, b, c, d) {
    null !== d && $4a3f0044ce2ef491$var$Jg(d);
    $4a3f0044ce2ef491$var$Ug(b, a.child, null, c);
    a = $4a3f0044ce2ef491$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4a3f0044ce2ef491$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4a3f0044ce2ef491$var$Ki(Error($4a3f0044ce2ef491$var$p(422))), $4a3f0044ce2ef491$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4a3f0044ce2ef491$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4a3f0044ce2ef491$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4a3f0044ce2ef491$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4a3f0044ce2ef491$var$nj(g);
        b.memoizedState = $4a3f0044ce2ef491$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4a3f0044ce2ef491$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4a3f0044ce2ef491$var$p(419));
        d = $4a3f0044ce2ef491$var$Ki(f, d, void 0);
        return $4a3f0044ce2ef491$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4a3f0044ce2ef491$var$dh || h) {
        d = $4a3f0044ce2ef491$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4a3f0044ce2ef491$var$ih(a, e), $4a3f0044ce2ef491$var$gi(d, a, e, -1));
        }
        $4a3f0044ce2ef491$var$tj();
        d = $4a3f0044ce2ef491$var$Ki(Error($4a3f0044ce2ef491$var$p(421)));
        return $4a3f0044ce2ef491$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4a3f0044ce2ef491$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4a3f0044ce2ef491$var$yg = $4a3f0044ce2ef491$var$Lf(e.nextSibling);
    $4a3f0044ce2ef491$var$xg = b;
    $4a3f0044ce2ef491$var$I = !0;
    $4a3f0044ce2ef491$var$zg = null;
    null !== a && ($4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg++] = $4a3f0044ce2ef491$var$rg, $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg++] = $4a3f0044ce2ef491$var$sg, $4a3f0044ce2ef491$var$og[$4a3f0044ce2ef491$var$pg++] = $4a3f0044ce2ef491$var$qg, $4a3f0044ce2ef491$var$rg = a.id, $4a3f0044ce2ef491$var$sg = a.overflow, $4a3f0044ce2ef491$var$qg = b);
    b = $4a3f0044ce2ef491$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4a3f0044ce2ef491$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4a3f0044ce2ef491$var$bh(a.return, b, c);
}
function $4a3f0044ce2ef491$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4a3f0044ce2ef491$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4a3f0044ce2ef491$var$Xi(a, b, d.children, c);
    d = $4a3f0044ce2ef491$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4a3f0044ce2ef491$var$vj(a, c, b);
            else if (19 === a.tag) $4a3f0044ce2ef491$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4a3f0044ce2ef491$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4a3f0044ce2ef491$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4a3f0044ce2ef491$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4a3f0044ce2ef491$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4a3f0044ce2ef491$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4a3f0044ce2ef491$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4a3f0044ce2ef491$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4a3f0044ce2ef491$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4a3f0044ce2ef491$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4a3f0044ce2ef491$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4a3f0044ce2ef491$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4a3f0044ce2ef491$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4a3f0044ce2ef491$var$kj(b);
            $4a3f0044ce2ef491$var$Ig();
            break;
        case 5:
            $4a3f0044ce2ef491$var$Ah(b);
            break;
        case 1:
            $4a3f0044ce2ef491$var$Zf(b.type) && $4a3f0044ce2ef491$var$cg(b);
            break;
        case 4:
            $4a3f0044ce2ef491$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, $4a3f0044ce2ef491$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4a3f0044ce2ef491$var$oj(a, b, c);
                $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, $4a3f0044ce2ef491$var$L.current & 1);
                a = $4a3f0044ce2ef491$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, $4a3f0044ce2ef491$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4a3f0044ce2ef491$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, $4a3f0044ce2ef491$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4a3f0044ce2ef491$var$dj(a, b, c);
    }
    return $4a3f0044ce2ef491$var$Zi(a, b, c);
}
var $4a3f0044ce2ef491$var$zj, $4a3f0044ce2ef491$var$Aj, $4a3f0044ce2ef491$var$Bj, $4a3f0044ce2ef491$var$Cj;
$4a3f0044ce2ef491$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4a3f0044ce2ef491$var$Aj = function() {};
$4a3f0044ce2ef491$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4a3f0044ce2ef491$var$Ya(a, e);
                d = $4a3f0044ce2ef491$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4a3f0044ce2ef491$var$A({}, e, {
                    value: void 0
                });
                d = $4a3f0044ce2ef491$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4a3f0044ce2ef491$var$gb(a, e);
                d = $4a3f0044ce2ef491$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4a3f0044ce2ef491$var$Bf);
        }
        $4a3f0044ce2ef491$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4a3f0044ce2ef491$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4a3f0044ce2ef491$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4a3f0044ce2ef491$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4a3f0044ce2ef491$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4a3f0044ce2ef491$var$Dj(a, b) {
    if (!$4a3f0044ce2ef491$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4a3f0044ce2ef491$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4a3f0044ce2ef491$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4a3f0044ce2ef491$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4a3f0044ce2ef491$var$S(b), null;
        case 1:
            return $4a3f0044ce2ef491$var$Zf(b.type) && $4a3f0044ce2ef491$var$$f(), $4a3f0044ce2ef491$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4a3f0044ce2ef491$var$zh();
            $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wf);
            $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$H);
            $4a3f0044ce2ef491$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4a3f0044ce2ef491$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4a3f0044ce2ef491$var$zg && ($4a3f0044ce2ef491$var$Fj($4a3f0044ce2ef491$var$zg), $4a3f0044ce2ef491$var$zg = null));
            $4a3f0044ce2ef491$var$Aj(a, b);
            $4a3f0044ce2ef491$var$S(b);
            return null;
        case 5:
            $4a3f0044ce2ef491$var$Bh(b);
            var e = $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4a3f0044ce2ef491$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4a3f0044ce2ef491$var$p(166));
                    $4a3f0044ce2ef491$var$S(b);
                    return null;
                }
                a = $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$uh.current);
                if ($4a3f0044ce2ef491$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4a3f0044ce2ef491$var$Of] = b;
                    d[$4a3f0044ce2ef491$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4a3f0044ce2ef491$var$D("cancel", d);
                            $4a3f0044ce2ef491$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4a3f0044ce2ef491$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4a3f0044ce2ef491$var$lf.length; e++)$4a3f0044ce2ef491$var$D($4a3f0044ce2ef491$var$lf[e], d);
                            break;
                        case "source":
                            $4a3f0044ce2ef491$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4a3f0044ce2ef491$var$D("error", d);
                            $4a3f0044ce2ef491$var$D("load", d);
                            break;
                        case "details":
                            $4a3f0044ce2ef491$var$D("toggle", d);
                            break;
                        case "input":
                            $4a3f0044ce2ef491$var$Za(d, f);
                            $4a3f0044ce2ef491$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4a3f0044ce2ef491$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4a3f0044ce2ef491$var$hb(d, f), $4a3f0044ce2ef491$var$D("invalid", d);
                    }
                    $4a3f0044ce2ef491$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4a3f0044ce2ef491$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4a3f0044ce2ef491$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4a3f0044ce2ef491$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4a3f0044ce2ef491$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4a3f0044ce2ef491$var$Va(d);
                            $4a3f0044ce2ef491$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4a3f0044ce2ef491$var$Va(d);
                            $4a3f0044ce2ef491$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4a3f0044ce2ef491$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4a3f0044ce2ef491$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4a3f0044ce2ef491$var$Of] = b;
                    a[$4a3f0044ce2ef491$var$Pf] = d;
                    $4a3f0044ce2ef491$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4a3f0044ce2ef491$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4a3f0044ce2ef491$var$D("cancel", a);
                                $4a3f0044ce2ef491$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4a3f0044ce2ef491$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4a3f0044ce2ef491$var$lf.length; e++)$4a3f0044ce2ef491$var$D($4a3f0044ce2ef491$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4a3f0044ce2ef491$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4a3f0044ce2ef491$var$D("error", a);
                                $4a3f0044ce2ef491$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4a3f0044ce2ef491$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4a3f0044ce2ef491$var$Za(a, d);
                                e = $4a3f0044ce2ef491$var$Ya(a, d);
                                $4a3f0044ce2ef491$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4a3f0044ce2ef491$var$A({}, d, {
                                    value: void 0
                                });
                                $4a3f0044ce2ef491$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4a3f0044ce2ef491$var$hb(a, d);
                                e = $4a3f0044ce2ef491$var$gb(a, d);
                                $4a3f0044ce2ef491$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4a3f0044ce2ef491$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4a3f0044ce2ef491$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4a3f0044ce2ef491$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4a3f0044ce2ef491$var$ob(a, k) : "number" === typeof k && $4a3f0044ce2ef491$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4a3f0044ce2ef491$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4a3f0044ce2ef491$var$D("scroll", a) : null != k && $4a3f0044ce2ef491$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4a3f0044ce2ef491$var$Va(a);
                                $4a3f0044ce2ef491$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4a3f0044ce2ef491$var$Va(a);
                                $4a3f0044ce2ef491$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4a3f0044ce2ef491$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4a3f0044ce2ef491$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4a3f0044ce2ef491$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4a3f0044ce2ef491$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4a3f0044ce2ef491$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4a3f0044ce2ef491$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4a3f0044ce2ef491$var$p(166));
                c = $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$wh.current);
                $4a3f0044ce2ef491$var$xh($4a3f0044ce2ef491$var$uh.current);
                if ($4a3f0044ce2ef491$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4a3f0044ce2ef491$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4a3f0044ce2ef491$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4a3f0044ce2ef491$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4a3f0044ce2ef491$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4a3f0044ce2ef491$var$Of] = b, b.stateNode = d;
            }
            $4a3f0044ce2ef491$var$S(b);
            return null;
        case 13:
            $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4a3f0044ce2ef491$var$I && null !== $4a3f0044ce2ef491$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4a3f0044ce2ef491$var$Hg(), $4a3f0044ce2ef491$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4a3f0044ce2ef491$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4a3f0044ce2ef491$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4a3f0044ce2ef491$var$p(317));
                        f[$4a3f0044ce2ef491$var$Of] = b;
                    } else $4a3f0044ce2ef491$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4a3f0044ce2ef491$var$S(b);
                    f = !1;
                } else null !== $4a3f0044ce2ef491$var$zg && ($4a3f0044ce2ef491$var$Fj($4a3f0044ce2ef491$var$zg), $4a3f0044ce2ef491$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4a3f0044ce2ef491$var$L.current & 1) ? 0 === $4a3f0044ce2ef491$var$T && ($4a3f0044ce2ef491$var$T = 3) : $4a3f0044ce2ef491$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4a3f0044ce2ef491$var$S(b);
            return null;
        case 4:
            return $4a3f0044ce2ef491$var$zh(), $4a3f0044ce2ef491$var$Aj(a, b), null === a && $4a3f0044ce2ef491$var$sf(b.stateNode.containerInfo), $4a3f0044ce2ef491$var$S(b), null;
        case 10:
            return $4a3f0044ce2ef491$var$ah(b.type._context), $4a3f0044ce2ef491$var$S(b), null;
        case 17:
            return $4a3f0044ce2ef491$var$Zf(b.type) && $4a3f0044ce2ef491$var$$f(), $4a3f0044ce2ef491$var$S(b), null;
        case 19:
            $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$L);
            f = b.memoizedState;
            if (null === f) return $4a3f0044ce2ef491$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4a3f0044ce2ef491$var$Dj(f, !1);
                else {
                    if (0 !== $4a3f0044ce2ef491$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4a3f0044ce2ef491$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4a3f0044ce2ef491$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, $4a3f0044ce2ef491$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4a3f0044ce2ef491$var$B() > $4a3f0044ce2ef491$var$Gj && (b.flags |= 128, d = !0, $4a3f0044ce2ef491$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4a3f0044ce2ef491$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4a3f0044ce2ef491$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4a3f0044ce2ef491$var$I) return $4a3f0044ce2ef491$var$S(b), null;
                    } else 2 * $4a3f0044ce2ef491$var$B() - f.renderingStartTime > $4a3f0044ce2ef491$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4a3f0044ce2ef491$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4a3f0044ce2ef491$var$B(), b.sibling = null, c = $4a3f0044ce2ef491$var$L.current, $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$L, d ? c & 1 | 2 : c & 1), b;
            $4a3f0044ce2ef491$var$S(b);
            return null;
        case 22:
        case 23:
            return $4a3f0044ce2ef491$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4a3f0044ce2ef491$var$fj & 1073741824) && ($4a3f0044ce2ef491$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4a3f0044ce2ef491$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4a3f0044ce2ef491$var$p(156, b.tag));
}
function $4a3f0044ce2ef491$var$Ij(a, b) {
    $4a3f0044ce2ef491$var$wg(b);
    switch(b.tag){
        case 1:
            return $4a3f0044ce2ef491$var$Zf(b.type) && $4a3f0044ce2ef491$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4a3f0044ce2ef491$var$zh(), $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wf), $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$H), $4a3f0044ce2ef491$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4a3f0044ce2ef491$var$Bh(b), null;
        case 13:
            $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4a3f0044ce2ef491$var$p(340));
                $4a3f0044ce2ef491$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$L), null;
        case 4:
            return $4a3f0044ce2ef491$var$zh(), null;
        case 10:
            return $4a3f0044ce2ef491$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4a3f0044ce2ef491$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4a3f0044ce2ef491$var$Jj = !1, $4a3f0044ce2ef491$var$U = !1, $4a3f0044ce2ef491$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4a3f0044ce2ef491$var$V = null;
function $4a3f0044ce2ef491$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4a3f0044ce2ef491$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4a3f0044ce2ef491$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4a3f0044ce2ef491$var$W(a, b, d);
    }
}
var $4a3f0044ce2ef491$var$Nj = !1;
function $4a3f0044ce2ef491$var$Oj(a, b) {
    $4a3f0044ce2ef491$var$Cf = $4a3f0044ce2ef491$var$dd;
    a = $4a3f0044ce2ef491$var$Me();
    if ($4a3f0044ce2ef491$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4a3f0044ce2ef491$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4a3f0044ce2ef491$var$dd = !1;
    for($4a3f0044ce2ef491$var$V = b; null !== $4a3f0044ce2ef491$var$V;)if (b = $4a3f0044ce2ef491$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4a3f0044ce2ef491$var$V = a;
    else for(; null !== $4a3f0044ce2ef491$var$V;){
        b = $4a3f0044ce2ef491$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4a3f0044ce2ef491$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4a3f0044ce2ef491$var$p(163));
            }
        } catch (F) {
            $4a3f0044ce2ef491$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4a3f0044ce2ef491$var$V = a;
            break;
        }
        $4a3f0044ce2ef491$var$V = b.return;
    }
    n = $4a3f0044ce2ef491$var$Nj;
    $4a3f0044ce2ef491$var$Nj = !1;
    return n;
}
function $4a3f0044ce2ef491$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4a3f0044ce2ef491$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4a3f0044ce2ef491$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4a3f0044ce2ef491$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4a3f0044ce2ef491$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4a3f0044ce2ef491$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4a3f0044ce2ef491$var$Of], delete b[$4a3f0044ce2ef491$var$Pf], delete b[$4a3f0044ce2ef491$var$of], delete b[$4a3f0044ce2ef491$var$Qf], delete b[$4a3f0044ce2ef491$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4a3f0044ce2ef491$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4a3f0044ce2ef491$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4a3f0044ce2ef491$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4a3f0044ce2ef491$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4a3f0044ce2ef491$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4a3f0044ce2ef491$var$Vj(a, b, c), a = a.sibling; null !== a;)$4a3f0044ce2ef491$var$Vj(a, b, c), a = a.sibling;
}
function $4a3f0044ce2ef491$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4a3f0044ce2ef491$var$Wj(a, b, c), a = a.sibling; null !== a;)$4a3f0044ce2ef491$var$Wj(a, b, c), a = a.sibling;
}
var $4a3f0044ce2ef491$var$X = null, $4a3f0044ce2ef491$var$Xj = !1;
function $4a3f0044ce2ef491$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4a3f0044ce2ef491$var$Zj(a, b, c), c = c.sibling;
}
function $4a3f0044ce2ef491$var$Zj(a, b, c) {
    if ($4a3f0044ce2ef491$var$lc && "function" === typeof $4a3f0044ce2ef491$var$lc.onCommitFiberUnmount) try {
        $4a3f0044ce2ef491$var$lc.onCommitFiberUnmount($4a3f0044ce2ef491$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4a3f0044ce2ef491$var$U || $4a3f0044ce2ef491$var$Lj(c, b);
        case 6:
            var d = $4a3f0044ce2ef491$var$X, e = $4a3f0044ce2ef491$var$Xj;
            $4a3f0044ce2ef491$var$X = null;
            $4a3f0044ce2ef491$var$Yj(a, b, c);
            $4a3f0044ce2ef491$var$X = d;
            $4a3f0044ce2ef491$var$Xj = e;
            null !== $4a3f0044ce2ef491$var$X && ($4a3f0044ce2ef491$var$Xj ? (a = $4a3f0044ce2ef491$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4a3f0044ce2ef491$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4a3f0044ce2ef491$var$X && ($4a3f0044ce2ef491$var$Xj ? (a = $4a3f0044ce2ef491$var$X, c = c.stateNode, 8 === a.nodeType ? $4a3f0044ce2ef491$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4a3f0044ce2ef491$var$Kf(a, c), $4a3f0044ce2ef491$var$bd(a)) : $4a3f0044ce2ef491$var$Kf($4a3f0044ce2ef491$var$X, c.stateNode));
            break;
        case 4:
            d = $4a3f0044ce2ef491$var$X;
            e = $4a3f0044ce2ef491$var$Xj;
            $4a3f0044ce2ef491$var$X = c.stateNode.containerInfo;
            $4a3f0044ce2ef491$var$Xj = !0;
            $4a3f0044ce2ef491$var$Yj(a, b, c);
            $4a3f0044ce2ef491$var$X = d;
            $4a3f0044ce2ef491$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4a3f0044ce2ef491$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4a3f0044ce2ef491$var$Mj(c, b, g) : 0 !== (f & 4) && $4a3f0044ce2ef491$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4a3f0044ce2ef491$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4a3f0044ce2ef491$var$U && ($4a3f0044ce2ef491$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4a3f0044ce2ef491$var$W(c, b, h);
            }
            $4a3f0044ce2ef491$var$Yj(a, b, c);
            break;
        case 21:
            $4a3f0044ce2ef491$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4a3f0044ce2ef491$var$U = (d = $4a3f0044ce2ef491$var$U) || null !== c.memoizedState, $4a3f0044ce2ef491$var$Yj(a, b, c), $4a3f0044ce2ef491$var$U = d) : $4a3f0044ce2ef491$var$Yj(a, b, c);
            break;
        default:
            $4a3f0044ce2ef491$var$Yj(a, b, c);
    }
}
function $4a3f0044ce2ef491$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4a3f0044ce2ef491$var$Kj);
        b.forEach(function(b) {
            var d = $4a3f0044ce2ef491$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4a3f0044ce2ef491$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4a3f0044ce2ef491$var$X = h.stateNode;
                        $4a3f0044ce2ef491$var$Xj = !1;
                        break a;
                    case 3:
                        $4a3f0044ce2ef491$var$X = h.stateNode.containerInfo;
                        $4a3f0044ce2ef491$var$Xj = !0;
                        break a;
                    case 4:
                        $4a3f0044ce2ef491$var$X = h.stateNode.containerInfo;
                        $4a3f0044ce2ef491$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4a3f0044ce2ef491$var$X) throw Error($4a3f0044ce2ef491$var$p(160));
            $4a3f0044ce2ef491$var$Zj(f, g, e);
            $4a3f0044ce2ef491$var$X = null;
            $4a3f0044ce2ef491$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4a3f0044ce2ef491$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4a3f0044ce2ef491$var$dk(b, a), b = b.sibling;
}
function $4a3f0044ce2ef491$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            if (d & 4) {
                try {
                    $4a3f0044ce2ef491$var$Pj(3, a, a.return), $4a3f0044ce2ef491$var$Qj(3, a);
                } catch (t) {
                    $4a3f0044ce2ef491$var$W(a, a.return, t);
                }
                try {
                    $4a3f0044ce2ef491$var$Pj(5, a, a.return);
                } catch (t) {
                    $4a3f0044ce2ef491$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            d & 512 && null !== c && $4a3f0044ce2ef491$var$Lj(c, c.return);
            break;
        case 5:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            d & 512 && null !== c && $4a3f0044ce2ef491$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4a3f0044ce2ef491$var$ob(e, "");
                } catch (t) {
                    $4a3f0044ce2ef491$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4a3f0044ce2ef491$var$ab(e, f);
                    $4a3f0044ce2ef491$var$vb(h, g);
                    var l = $4a3f0044ce2ef491$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4a3f0044ce2ef491$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4a3f0044ce2ef491$var$nb(e, q) : "children" === m ? $4a3f0044ce2ef491$var$ob(e, q) : $4a3f0044ce2ef491$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4a3f0044ce2ef491$var$bb(e, f);
                            break;
                        case "textarea":
                            $4a3f0044ce2ef491$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4a3f0044ce2ef491$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4a3f0044ce2ef491$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4a3f0044ce2ef491$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4a3f0044ce2ef491$var$Pf] = f;
                } catch (t) {
                    $4a3f0044ce2ef491$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4a3f0044ce2ef491$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4a3f0044ce2ef491$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4a3f0044ce2ef491$var$bd(b.containerInfo);
            } catch (t) {
                $4a3f0044ce2ef491$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            break;
        case 13:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4a3f0044ce2ef491$var$fk = $4a3f0044ce2ef491$var$B()));
            d & 4 && $4a3f0044ce2ef491$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4a3f0044ce2ef491$var$U = (l = $4a3f0044ce2ef491$var$U) || m, $4a3f0044ce2ef491$var$ck(b, a), $4a3f0044ce2ef491$var$U = l) : $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4a3f0044ce2ef491$var$V = a, m = a.child; null !== m;){
                    for(q = $4a3f0044ce2ef491$var$V = m; null !== $4a3f0044ce2ef491$var$V;){
                        r = $4a3f0044ce2ef491$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4a3f0044ce2ef491$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4a3f0044ce2ef491$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4a3f0044ce2ef491$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4a3f0044ce2ef491$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4a3f0044ce2ef491$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4a3f0044ce2ef491$var$V = y) : $4a3f0044ce2ef491$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4a3f0044ce2ef491$var$rb("display", g));
                            } catch (t) {
                                $4a3f0044ce2ef491$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4a3f0044ce2ef491$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4a3f0044ce2ef491$var$ck(b, a);
            $4a3f0044ce2ef491$var$ek(a);
            d & 4 && $4a3f0044ce2ef491$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4a3f0044ce2ef491$var$ck(b, a), $4a3f0044ce2ef491$var$ek(a);
    }
}
function $4a3f0044ce2ef491$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4a3f0044ce2ef491$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4a3f0044ce2ef491$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4a3f0044ce2ef491$var$ob(e, ""), d.flags &= -33);
                    var f = $4a3f0044ce2ef491$var$Uj(a);
                    $4a3f0044ce2ef491$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4a3f0044ce2ef491$var$Uj(a);
                    $4a3f0044ce2ef491$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4a3f0044ce2ef491$var$p(161));
            }
        } catch (k) {
            $4a3f0044ce2ef491$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4a3f0044ce2ef491$var$hk(a, b, c) {
    $4a3f0044ce2ef491$var$V = a;
    $4a3f0044ce2ef491$var$ik(a, b, c);
}
function $4a3f0044ce2ef491$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4a3f0044ce2ef491$var$V;){
        var e = $4a3f0044ce2ef491$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4a3f0044ce2ef491$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4a3f0044ce2ef491$var$U;
                h = $4a3f0044ce2ef491$var$Jj;
                var l = $4a3f0044ce2ef491$var$U;
                $4a3f0044ce2ef491$var$Jj = g;
                if (($4a3f0044ce2ef491$var$U = k) && !l) for($4a3f0044ce2ef491$var$V = e; null !== $4a3f0044ce2ef491$var$V;)g = $4a3f0044ce2ef491$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4a3f0044ce2ef491$var$jk(e) : null !== k ? (k.return = g, $4a3f0044ce2ef491$var$V = k) : $4a3f0044ce2ef491$var$jk(e);
                for(; null !== f;)$4a3f0044ce2ef491$var$V = f, $4a3f0044ce2ef491$var$ik(f, b, c), f = f.sibling;
                $4a3f0044ce2ef491$var$V = e;
                $4a3f0044ce2ef491$var$Jj = h;
                $4a3f0044ce2ef491$var$U = l;
            }
            $4a3f0044ce2ef491$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4a3f0044ce2ef491$var$V = f) : $4a3f0044ce2ef491$var$kk(a, b, c);
    }
}
function $4a3f0044ce2ef491$var$kk(a) {
    for(; null !== $4a3f0044ce2ef491$var$V;){
        var b = $4a3f0044ce2ef491$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4a3f0044ce2ef491$var$U || $4a3f0044ce2ef491$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4a3f0044ce2ef491$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4a3f0044ce2ef491$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4a3f0044ce2ef491$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4a3f0044ce2ef491$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4a3f0044ce2ef491$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4a3f0044ce2ef491$var$p(163));
                }
                $4a3f0044ce2ef491$var$U || b.flags & 512 && $4a3f0044ce2ef491$var$Rj(b);
            } catch (r) {
                $4a3f0044ce2ef491$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4a3f0044ce2ef491$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4a3f0044ce2ef491$var$V = c;
            break;
        }
        $4a3f0044ce2ef491$var$V = b.return;
    }
}
function $4a3f0044ce2ef491$var$gk(a) {
    for(; null !== $4a3f0044ce2ef491$var$V;){
        var b = $4a3f0044ce2ef491$var$V;
        if (b === a) {
            $4a3f0044ce2ef491$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4a3f0044ce2ef491$var$V = c;
            break;
        }
        $4a3f0044ce2ef491$var$V = b.return;
    }
}
function $4a3f0044ce2ef491$var$jk(a) {
    for(; null !== $4a3f0044ce2ef491$var$V;){
        var b = $4a3f0044ce2ef491$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4a3f0044ce2ef491$var$Qj(4, b);
                    } catch (k) {
                        $4a3f0044ce2ef491$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4a3f0044ce2ef491$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4a3f0044ce2ef491$var$Rj(b);
                    } catch (k) {
                        $4a3f0044ce2ef491$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4a3f0044ce2ef491$var$Rj(b);
                    } catch (k) {
                        $4a3f0044ce2ef491$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4a3f0044ce2ef491$var$W(b, b.return, k);
        }
        if (b === a) {
            $4a3f0044ce2ef491$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4a3f0044ce2ef491$var$V = h;
            break;
        }
        $4a3f0044ce2ef491$var$V = b.return;
    }
}
var $4a3f0044ce2ef491$var$lk = Math.ceil, $4a3f0044ce2ef491$var$mk = $4a3f0044ce2ef491$var$ua.ReactCurrentDispatcher, $4a3f0044ce2ef491$var$nk = $4a3f0044ce2ef491$var$ua.ReactCurrentOwner, $4a3f0044ce2ef491$var$ok = $4a3f0044ce2ef491$var$ua.ReactCurrentBatchConfig, $4a3f0044ce2ef491$var$K = 0, $4a3f0044ce2ef491$var$Q = null, $4a3f0044ce2ef491$var$Y = null, $4a3f0044ce2ef491$var$Z = 0, $4a3f0044ce2ef491$var$fj = 0, $4a3f0044ce2ef491$var$ej = $4a3f0044ce2ef491$var$Uf(0), $4a3f0044ce2ef491$var$T = 0, $4a3f0044ce2ef491$var$pk = null, $4a3f0044ce2ef491$var$rh = 0, $4a3f0044ce2ef491$var$qk = 0, $4a3f0044ce2ef491$var$rk = 0, $4a3f0044ce2ef491$var$sk = null, $4a3f0044ce2ef491$var$tk = null, $4a3f0044ce2ef491$var$fk = 0, $4a3f0044ce2ef491$var$Gj = Infinity, $4a3f0044ce2ef491$var$uk = null, $4a3f0044ce2ef491$var$Oi = !1, $4a3f0044ce2ef491$var$Pi = null, $4a3f0044ce2ef491$var$Ri = null, $4a3f0044ce2ef491$var$vk = !1, $4a3f0044ce2ef491$var$wk = null, $4a3f0044ce2ef491$var$xk = 0, $4a3f0044ce2ef491$var$yk = 0, $4a3f0044ce2ef491$var$zk = null, $4a3f0044ce2ef491$var$Ak = -1, $4a3f0044ce2ef491$var$Bk = 0;
function $4a3f0044ce2ef491$var$R() {
    return 0 !== ($4a3f0044ce2ef491$var$K & 6) ? $4a3f0044ce2ef491$var$B() : -1 !== $4a3f0044ce2ef491$var$Ak ? $4a3f0044ce2ef491$var$Ak : $4a3f0044ce2ef491$var$Ak = $4a3f0044ce2ef491$var$B();
}
function $4a3f0044ce2ef491$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4a3f0044ce2ef491$var$K & 2) && 0 !== $4a3f0044ce2ef491$var$Z) return $4a3f0044ce2ef491$var$Z & -$4a3f0044ce2ef491$var$Z;
    if (null !== $4a3f0044ce2ef491$var$Kg.transition) return 0 === $4a3f0044ce2ef491$var$Bk && ($4a3f0044ce2ef491$var$Bk = $4a3f0044ce2ef491$var$yc()), $4a3f0044ce2ef491$var$Bk;
    a = $4a3f0044ce2ef491$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4a3f0044ce2ef491$var$jd(a.type);
    return a;
}
function $4a3f0044ce2ef491$var$gi(a, b, c, d) {
    if (50 < $4a3f0044ce2ef491$var$yk) throw $4a3f0044ce2ef491$var$yk = 0, $4a3f0044ce2ef491$var$zk = null, Error($4a3f0044ce2ef491$var$p(185));
    $4a3f0044ce2ef491$var$Ac(a, c, d);
    if (0 === ($4a3f0044ce2ef491$var$K & 2) || a !== $4a3f0044ce2ef491$var$Q) a === $4a3f0044ce2ef491$var$Q && (0 === ($4a3f0044ce2ef491$var$K & 2) && ($4a3f0044ce2ef491$var$qk |= c), 4 === $4a3f0044ce2ef491$var$T && $4a3f0044ce2ef491$var$Ck(a, $4a3f0044ce2ef491$var$Z)), $4a3f0044ce2ef491$var$Dk(a, d), 1 === c && 0 === $4a3f0044ce2ef491$var$K && 0 === (b.mode & 1) && ($4a3f0044ce2ef491$var$Gj = $4a3f0044ce2ef491$var$B() + 500, $4a3f0044ce2ef491$var$fg && $4a3f0044ce2ef491$var$jg());
}
function $4a3f0044ce2ef491$var$Dk(a, b) {
    var c = a.callbackNode;
    $4a3f0044ce2ef491$var$wc(a, b);
    var d = $4a3f0044ce2ef491$var$uc(a, a === $4a3f0044ce2ef491$var$Q ? $4a3f0044ce2ef491$var$Z : 0);
    if (0 === d) null !== c && $4a3f0044ce2ef491$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4a3f0044ce2ef491$var$bc(c);
        if (1 === b) 0 === a.tag ? $4a3f0044ce2ef491$var$ig($4a3f0044ce2ef491$var$Ek.bind(null, a)) : $4a3f0044ce2ef491$var$hg($4a3f0044ce2ef491$var$Ek.bind(null, a)), $4a3f0044ce2ef491$var$Jf(function() {
            0 === ($4a3f0044ce2ef491$var$K & 6) && $4a3f0044ce2ef491$var$jg();
        }), c = null;
        else {
            switch($4a3f0044ce2ef491$var$Dc(d)){
                case 1:
                    c = $4a3f0044ce2ef491$var$fc;
                    break;
                case 4:
                    c = $4a3f0044ce2ef491$var$gc;
                    break;
                case 16:
                    c = $4a3f0044ce2ef491$var$hc;
                    break;
                case 536870912:
                    c = $4a3f0044ce2ef491$var$jc;
                    break;
                default:
                    c = $4a3f0044ce2ef491$var$hc;
            }
            c = $4a3f0044ce2ef491$var$Fk(c, $4a3f0044ce2ef491$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4a3f0044ce2ef491$var$Gk(a, b) {
    $4a3f0044ce2ef491$var$Ak = -1;
    $4a3f0044ce2ef491$var$Bk = 0;
    if (0 !== ($4a3f0044ce2ef491$var$K & 6)) throw Error($4a3f0044ce2ef491$var$p(327));
    var c = a.callbackNode;
    if ($4a3f0044ce2ef491$var$Hk() && a.callbackNode !== c) return null;
    var d = $4a3f0044ce2ef491$var$uc(a, a === $4a3f0044ce2ef491$var$Q ? $4a3f0044ce2ef491$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4a3f0044ce2ef491$var$Ik(a, d);
    else {
        b = d;
        var e = $4a3f0044ce2ef491$var$K;
        $4a3f0044ce2ef491$var$K |= 2;
        var f = $4a3f0044ce2ef491$var$Jk();
        if ($4a3f0044ce2ef491$var$Q !== a || $4a3f0044ce2ef491$var$Z !== b) $4a3f0044ce2ef491$var$uk = null, $4a3f0044ce2ef491$var$Gj = $4a3f0044ce2ef491$var$B() + 500, $4a3f0044ce2ef491$var$Kk(a, b);
        for(;;)try {
            $4a3f0044ce2ef491$var$Lk();
            break;
        } catch (h) {
            $4a3f0044ce2ef491$var$Mk(a, h);
        }
        $4a3f0044ce2ef491$var$$g();
        $4a3f0044ce2ef491$var$mk.current = f;
        $4a3f0044ce2ef491$var$K = e;
        null !== $4a3f0044ce2ef491$var$Y ? b = 0 : ($4a3f0044ce2ef491$var$Q = null, $4a3f0044ce2ef491$var$Z = 0, b = $4a3f0044ce2ef491$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4a3f0044ce2ef491$var$xc(a), 0 !== e && (d = e, b = $4a3f0044ce2ef491$var$Nk(a, e)));
        if (1 === b) throw c = $4a3f0044ce2ef491$var$pk, $4a3f0044ce2ef491$var$Kk(a, 0), $4a3f0044ce2ef491$var$Ck(a, d), $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B()), c;
        if (6 === b) $4a3f0044ce2ef491$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4a3f0044ce2ef491$var$Ok(e) && (b = $4a3f0044ce2ef491$var$Ik(a, d), 2 === b && (f = $4a3f0044ce2ef491$var$xc(a), 0 !== f && (d = f, b = $4a3f0044ce2ef491$var$Nk(a, f))), 1 === b)) throw c = $4a3f0044ce2ef491$var$pk, $4a3f0044ce2ef491$var$Kk(a, 0), $4a3f0044ce2ef491$var$Ck(a, d), $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4a3f0044ce2ef491$var$p(345));
                case 2:
                    $4a3f0044ce2ef491$var$Pk(a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk);
                    break;
                case 3:
                    $4a3f0044ce2ef491$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4a3f0044ce2ef491$var$fk + 500 - $4a3f0044ce2ef491$var$B(), 10 < b)) {
                        if (0 !== $4a3f0044ce2ef491$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4a3f0044ce2ef491$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4a3f0044ce2ef491$var$Ff($4a3f0044ce2ef491$var$Pk.bind(null, a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk), b);
                        break;
                    }
                    $4a3f0044ce2ef491$var$Pk(a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk);
                    break;
                case 4:
                    $4a3f0044ce2ef491$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4a3f0044ce2ef491$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4a3f0044ce2ef491$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4a3f0044ce2ef491$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4a3f0044ce2ef491$var$Ff($4a3f0044ce2ef491$var$Pk.bind(null, a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk), d);
                        break;
                    }
                    $4a3f0044ce2ef491$var$Pk(a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk);
                    break;
                case 5:
                    $4a3f0044ce2ef491$var$Pk(a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk);
                    break;
                default:
                    throw Error($4a3f0044ce2ef491$var$p(329));
            }
        }
    }
    $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B());
    return a.callbackNode === c ? $4a3f0044ce2ef491$var$Gk.bind(null, a) : null;
}
function $4a3f0044ce2ef491$var$Nk(a, b) {
    var c = $4a3f0044ce2ef491$var$sk;
    a.current.memoizedState.isDehydrated && ($4a3f0044ce2ef491$var$Kk(a, b).flags |= 256);
    a = $4a3f0044ce2ef491$var$Ik(a, b);
    2 !== a && (b = $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$tk = c, null !== b && $4a3f0044ce2ef491$var$Fj(b));
    return a;
}
function $4a3f0044ce2ef491$var$Fj(a) {
    null === $4a3f0044ce2ef491$var$tk ? $4a3f0044ce2ef491$var$tk = a : $4a3f0044ce2ef491$var$tk.push.apply($4a3f0044ce2ef491$var$tk, a);
}
function $4a3f0044ce2ef491$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4a3f0044ce2ef491$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4a3f0044ce2ef491$var$Ck(a, b) {
    b &= ~$4a3f0044ce2ef491$var$rk;
    b &= ~$4a3f0044ce2ef491$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4a3f0044ce2ef491$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4a3f0044ce2ef491$var$Ek(a) {
    if (0 !== ($4a3f0044ce2ef491$var$K & 6)) throw Error($4a3f0044ce2ef491$var$p(327));
    $4a3f0044ce2ef491$var$Hk();
    var b = $4a3f0044ce2ef491$var$uc(a, 0);
    if (0 === (b & 1)) return $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B()), null;
    var c = $4a3f0044ce2ef491$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4a3f0044ce2ef491$var$xc(a);
        0 !== d && (b = d, c = $4a3f0044ce2ef491$var$Nk(a, d));
    }
    if (1 === c) throw c = $4a3f0044ce2ef491$var$pk, $4a3f0044ce2ef491$var$Kk(a, 0), $4a3f0044ce2ef491$var$Ck(a, b), $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B()), c;
    if (6 === c) throw Error($4a3f0044ce2ef491$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4a3f0044ce2ef491$var$Pk(a, $4a3f0044ce2ef491$var$tk, $4a3f0044ce2ef491$var$uk);
    $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B());
    return null;
}
function $4a3f0044ce2ef491$var$Qk(a, b) {
    var c = $4a3f0044ce2ef491$var$K;
    $4a3f0044ce2ef491$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4a3f0044ce2ef491$var$K = c, 0 === $4a3f0044ce2ef491$var$K && ($4a3f0044ce2ef491$var$Gj = $4a3f0044ce2ef491$var$B() + 500, $4a3f0044ce2ef491$var$fg && $4a3f0044ce2ef491$var$jg());
    }
}
function $4a3f0044ce2ef491$var$Rk(a) {
    null !== $4a3f0044ce2ef491$var$wk && 0 === $4a3f0044ce2ef491$var$wk.tag && 0 === ($4a3f0044ce2ef491$var$K & 6) && $4a3f0044ce2ef491$var$Hk();
    var b = $4a3f0044ce2ef491$var$K;
    $4a3f0044ce2ef491$var$K |= 1;
    var c = $4a3f0044ce2ef491$var$ok.transition, d = $4a3f0044ce2ef491$var$C;
    try {
        if ($4a3f0044ce2ef491$var$ok.transition = null, $4a3f0044ce2ef491$var$C = 1, a) return a();
    } finally{
        $4a3f0044ce2ef491$var$C = d, $4a3f0044ce2ef491$var$ok.transition = c, $4a3f0044ce2ef491$var$K = b, 0 === ($4a3f0044ce2ef491$var$K & 6) && $4a3f0044ce2ef491$var$jg();
    }
}
function $4a3f0044ce2ef491$var$Hj() {
    $4a3f0044ce2ef491$var$fj = $4a3f0044ce2ef491$var$ej.current;
    $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$ej);
}
function $4a3f0044ce2ef491$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4a3f0044ce2ef491$var$Gf(c));
    if (null !== $4a3f0044ce2ef491$var$Y) for(c = $4a3f0044ce2ef491$var$Y.return; null !== c;){
        var d = c;
        $4a3f0044ce2ef491$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4a3f0044ce2ef491$var$$f();
                break;
            case 3:
                $4a3f0044ce2ef491$var$zh();
                $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$Wf);
                $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$H);
                $4a3f0044ce2ef491$var$Eh();
                break;
            case 5:
                $4a3f0044ce2ef491$var$Bh(d);
                break;
            case 4:
                $4a3f0044ce2ef491$var$zh();
                break;
            case 13:
                $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$L);
                break;
            case 19:
                $4a3f0044ce2ef491$var$E($4a3f0044ce2ef491$var$L);
                break;
            case 10:
                $4a3f0044ce2ef491$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4a3f0044ce2ef491$var$Hj();
        }
        c = c.return;
    }
    $4a3f0044ce2ef491$var$Q = a;
    $4a3f0044ce2ef491$var$Y = a = $4a3f0044ce2ef491$var$Pg(a.current, null);
    $4a3f0044ce2ef491$var$Z = $4a3f0044ce2ef491$var$fj = b;
    $4a3f0044ce2ef491$var$T = 0;
    $4a3f0044ce2ef491$var$pk = null;
    $4a3f0044ce2ef491$var$rk = $4a3f0044ce2ef491$var$qk = $4a3f0044ce2ef491$var$rh = 0;
    $4a3f0044ce2ef491$var$tk = $4a3f0044ce2ef491$var$sk = null;
    if (null !== $4a3f0044ce2ef491$var$fh) {
        for(b = 0; b < $4a3f0044ce2ef491$var$fh.length; b++)if (c = $4a3f0044ce2ef491$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4a3f0044ce2ef491$var$fh = null;
    }
    return a;
}
function $4a3f0044ce2ef491$var$Mk(a, b) {
    do {
        var c = $4a3f0044ce2ef491$var$Y;
        try {
            $4a3f0044ce2ef491$var$$g();
            $4a3f0044ce2ef491$var$Fh.current = $4a3f0044ce2ef491$var$Rh;
            if ($4a3f0044ce2ef491$var$Ih) {
                for(var d = $4a3f0044ce2ef491$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4a3f0044ce2ef491$var$Ih = !1;
            }
            $4a3f0044ce2ef491$var$Hh = 0;
            $4a3f0044ce2ef491$var$O = $4a3f0044ce2ef491$var$N = $4a3f0044ce2ef491$var$M = null;
            $4a3f0044ce2ef491$var$Jh = !1;
            $4a3f0044ce2ef491$var$Kh = 0;
            $4a3f0044ce2ef491$var$nk.current = null;
            if (null === c || null === c.return) {
                $4a3f0044ce2ef491$var$T = 1;
                $4a3f0044ce2ef491$var$pk = b;
                $4a3f0044ce2ef491$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4a3f0044ce2ef491$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4a3f0044ce2ef491$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4a3f0044ce2ef491$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4a3f0044ce2ef491$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4a3f0044ce2ef491$var$Si(f, l, b);
                            $4a3f0044ce2ef491$var$tj();
                            break a;
                        }
                        k = Error($4a3f0044ce2ef491$var$p(426));
                    }
                } else if ($4a3f0044ce2ef491$var$I && h.mode & 1) {
                    var J = $4a3f0044ce2ef491$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4a3f0044ce2ef491$var$Vi(J, g, h, f, b);
                        $4a3f0044ce2ef491$var$Jg($4a3f0044ce2ef491$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4a3f0044ce2ef491$var$Ji(k, h);
                4 !== $4a3f0044ce2ef491$var$T && ($4a3f0044ce2ef491$var$T = 2);
                null === $4a3f0044ce2ef491$var$sk ? $4a3f0044ce2ef491$var$sk = [
                    f
                ] : $4a3f0044ce2ef491$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4a3f0044ce2ef491$var$Ni(f, k, b);
                            $4a3f0044ce2ef491$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4a3f0044ce2ef491$var$Ri || !$4a3f0044ce2ef491$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4a3f0044ce2ef491$var$Qi(f, h, b);
                                $4a3f0044ce2ef491$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4a3f0044ce2ef491$var$Sk(c);
        } catch (na) {
            b = na;
            $4a3f0044ce2ef491$var$Y === c && null !== c && ($4a3f0044ce2ef491$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4a3f0044ce2ef491$var$Jk() {
    var a = $4a3f0044ce2ef491$var$mk.current;
    $4a3f0044ce2ef491$var$mk.current = $4a3f0044ce2ef491$var$Rh;
    return null === a ? $4a3f0044ce2ef491$var$Rh : a;
}
function $4a3f0044ce2ef491$var$tj() {
    if (0 === $4a3f0044ce2ef491$var$T || 3 === $4a3f0044ce2ef491$var$T || 2 === $4a3f0044ce2ef491$var$T) $4a3f0044ce2ef491$var$T = 4;
    null === $4a3f0044ce2ef491$var$Q || 0 === ($4a3f0044ce2ef491$var$rh & 268435455) && 0 === ($4a3f0044ce2ef491$var$qk & 268435455) || $4a3f0044ce2ef491$var$Ck($4a3f0044ce2ef491$var$Q, $4a3f0044ce2ef491$var$Z);
}
function $4a3f0044ce2ef491$var$Ik(a, b) {
    var c = $4a3f0044ce2ef491$var$K;
    $4a3f0044ce2ef491$var$K |= 2;
    var d = $4a3f0044ce2ef491$var$Jk();
    if ($4a3f0044ce2ef491$var$Q !== a || $4a3f0044ce2ef491$var$Z !== b) $4a3f0044ce2ef491$var$uk = null, $4a3f0044ce2ef491$var$Kk(a, b);
    for(;;)try {
        $4a3f0044ce2ef491$var$Tk();
        break;
    } catch (e) {
        $4a3f0044ce2ef491$var$Mk(a, e);
    }
    $4a3f0044ce2ef491$var$$g();
    $4a3f0044ce2ef491$var$K = c;
    $4a3f0044ce2ef491$var$mk.current = d;
    if (null !== $4a3f0044ce2ef491$var$Y) throw Error($4a3f0044ce2ef491$var$p(261));
    $4a3f0044ce2ef491$var$Q = null;
    $4a3f0044ce2ef491$var$Z = 0;
    return $4a3f0044ce2ef491$var$T;
}
function $4a3f0044ce2ef491$var$Tk() {
    for(; null !== $4a3f0044ce2ef491$var$Y;)$4a3f0044ce2ef491$var$Uk($4a3f0044ce2ef491$var$Y);
}
function $4a3f0044ce2ef491$var$Lk() {
    for(; null !== $4a3f0044ce2ef491$var$Y && !$4a3f0044ce2ef491$var$cc();)$4a3f0044ce2ef491$var$Uk($4a3f0044ce2ef491$var$Y);
}
function $4a3f0044ce2ef491$var$Uk(a) {
    var b = $4a3f0044ce2ef491$var$Vk(a.alternate, a, $4a3f0044ce2ef491$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4a3f0044ce2ef491$var$Sk(a) : $4a3f0044ce2ef491$var$Y = b;
    $4a3f0044ce2ef491$var$nk.current = null;
}
function $4a3f0044ce2ef491$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4a3f0044ce2ef491$var$Ej(c, b, $4a3f0044ce2ef491$var$fj), null !== c) {
                $4a3f0044ce2ef491$var$Y = c;
                return;
            }
        } else {
            c = $4a3f0044ce2ef491$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4a3f0044ce2ef491$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4a3f0044ce2ef491$var$T = 6;
                $4a3f0044ce2ef491$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4a3f0044ce2ef491$var$Y = b;
            return;
        }
        $4a3f0044ce2ef491$var$Y = b = a;
    }while (null !== b);
    0 === $4a3f0044ce2ef491$var$T && ($4a3f0044ce2ef491$var$T = 5);
}
function $4a3f0044ce2ef491$var$Pk(a, b, c) {
    var d = $4a3f0044ce2ef491$var$C, e = $4a3f0044ce2ef491$var$ok.transition;
    try {
        $4a3f0044ce2ef491$var$ok.transition = null, $4a3f0044ce2ef491$var$C = 1, $4a3f0044ce2ef491$var$Wk(a, b, c, d);
    } finally{
        $4a3f0044ce2ef491$var$ok.transition = e, $4a3f0044ce2ef491$var$C = d;
    }
    return null;
}
function $4a3f0044ce2ef491$var$Wk(a, b, c, d) {
    do $4a3f0044ce2ef491$var$Hk();
    while (null !== $4a3f0044ce2ef491$var$wk);
    if (0 !== ($4a3f0044ce2ef491$var$K & 6)) throw Error($4a3f0044ce2ef491$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4a3f0044ce2ef491$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4a3f0044ce2ef491$var$Bc(a, f);
    a === $4a3f0044ce2ef491$var$Q && ($4a3f0044ce2ef491$var$Y = $4a3f0044ce2ef491$var$Q = null, $4a3f0044ce2ef491$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4a3f0044ce2ef491$var$vk || ($4a3f0044ce2ef491$var$vk = !0, $4a3f0044ce2ef491$var$Fk($4a3f0044ce2ef491$var$hc, function() {
        $4a3f0044ce2ef491$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4a3f0044ce2ef491$var$ok.transition;
        $4a3f0044ce2ef491$var$ok.transition = null;
        var g = $4a3f0044ce2ef491$var$C;
        $4a3f0044ce2ef491$var$C = 1;
        var h = $4a3f0044ce2ef491$var$K;
        $4a3f0044ce2ef491$var$K |= 4;
        $4a3f0044ce2ef491$var$nk.current = null;
        $4a3f0044ce2ef491$var$Oj(a, c);
        $4a3f0044ce2ef491$var$dk(c, a);
        $4a3f0044ce2ef491$var$Oe($4a3f0044ce2ef491$var$Df);
        $4a3f0044ce2ef491$var$dd = !!$4a3f0044ce2ef491$var$Cf;
        $4a3f0044ce2ef491$var$Df = $4a3f0044ce2ef491$var$Cf = null;
        a.current = c;
        $4a3f0044ce2ef491$var$hk(c, a, e);
        $4a3f0044ce2ef491$var$dc();
        $4a3f0044ce2ef491$var$K = h;
        $4a3f0044ce2ef491$var$C = g;
        $4a3f0044ce2ef491$var$ok.transition = f;
    } else a.current = c;
    $4a3f0044ce2ef491$var$vk && ($4a3f0044ce2ef491$var$vk = !1, $4a3f0044ce2ef491$var$wk = a, $4a3f0044ce2ef491$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4a3f0044ce2ef491$var$Ri = null);
    $4a3f0044ce2ef491$var$mc(c.stateNode, d);
    $4a3f0044ce2ef491$var$Dk(a, $4a3f0044ce2ef491$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4a3f0044ce2ef491$var$Oi) throw $4a3f0044ce2ef491$var$Oi = !1, a = $4a3f0044ce2ef491$var$Pi, $4a3f0044ce2ef491$var$Pi = null, a;
    0 !== ($4a3f0044ce2ef491$var$xk & 1) && 0 !== a.tag && $4a3f0044ce2ef491$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4a3f0044ce2ef491$var$zk ? $4a3f0044ce2ef491$var$yk++ : ($4a3f0044ce2ef491$var$yk = 0, $4a3f0044ce2ef491$var$zk = a) : $4a3f0044ce2ef491$var$yk = 0;
    $4a3f0044ce2ef491$var$jg();
    return null;
}
function $4a3f0044ce2ef491$var$Hk() {
    if (null !== $4a3f0044ce2ef491$var$wk) {
        var a = $4a3f0044ce2ef491$var$Dc($4a3f0044ce2ef491$var$xk), b = $4a3f0044ce2ef491$var$ok.transition, c = $4a3f0044ce2ef491$var$C;
        try {
            $4a3f0044ce2ef491$var$ok.transition = null;
            $4a3f0044ce2ef491$var$C = 16 > a ? 16 : a;
            if (null === $4a3f0044ce2ef491$var$wk) var d = !1;
            else {
                a = $4a3f0044ce2ef491$var$wk;
                $4a3f0044ce2ef491$var$wk = null;
                $4a3f0044ce2ef491$var$xk = 0;
                if (0 !== ($4a3f0044ce2ef491$var$K & 6)) throw Error($4a3f0044ce2ef491$var$p(331));
                var e = $4a3f0044ce2ef491$var$K;
                $4a3f0044ce2ef491$var$K |= 4;
                for($4a3f0044ce2ef491$var$V = a.current; null !== $4a3f0044ce2ef491$var$V;){
                    var f = $4a3f0044ce2ef491$var$V, g = f.child;
                    if (0 !== ($4a3f0044ce2ef491$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4a3f0044ce2ef491$var$V = l; null !== $4a3f0044ce2ef491$var$V;){
                                    var m = $4a3f0044ce2ef491$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4a3f0044ce2ef491$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4a3f0044ce2ef491$var$V = q;
                                    else for(; null !== $4a3f0044ce2ef491$var$V;){
                                        m = $4a3f0044ce2ef491$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4a3f0044ce2ef491$var$Sj(m);
                                        if (m === l) {
                                            $4a3f0044ce2ef491$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4a3f0044ce2ef491$var$V = r;
                                            break;
                                        }
                                        $4a3f0044ce2ef491$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4a3f0044ce2ef491$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4a3f0044ce2ef491$var$V = g;
                    else b: for(; null !== $4a3f0044ce2ef491$var$V;){
                        f = $4a3f0044ce2ef491$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4a3f0044ce2ef491$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4a3f0044ce2ef491$var$V = x;
                            break b;
                        }
                        $4a3f0044ce2ef491$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4a3f0044ce2ef491$var$V = w; null !== $4a3f0044ce2ef491$var$V;){
                    g = $4a3f0044ce2ef491$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4a3f0044ce2ef491$var$V = u;
                    else b: for(g = w; null !== $4a3f0044ce2ef491$var$V;){
                        h = $4a3f0044ce2ef491$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4a3f0044ce2ef491$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4a3f0044ce2ef491$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4a3f0044ce2ef491$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4a3f0044ce2ef491$var$V = F;
                            break b;
                        }
                        $4a3f0044ce2ef491$var$V = h.return;
                    }
                }
                $4a3f0044ce2ef491$var$K = e;
                $4a3f0044ce2ef491$var$jg();
                if ($4a3f0044ce2ef491$var$lc && "function" === typeof $4a3f0044ce2ef491$var$lc.onPostCommitFiberRoot) try {
                    $4a3f0044ce2ef491$var$lc.onPostCommitFiberRoot($4a3f0044ce2ef491$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4a3f0044ce2ef491$var$C = c, $4a3f0044ce2ef491$var$ok.transition = b;
        }
    }
    return !1;
}
function $4a3f0044ce2ef491$var$Xk(a, b, c) {
    b = $4a3f0044ce2ef491$var$Ji(c, b);
    b = $4a3f0044ce2ef491$var$Ni(a, b, 1);
    a = $4a3f0044ce2ef491$var$nh(a, b, 1);
    b = $4a3f0044ce2ef491$var$R();
    null !== a && ($4a3f0044ce2ef491$var$Ac(a, 1, b), $4a3f0044ce2ef491$var$Dk(a, b));
}
function $4a3f0044ce2ef491$var$W(a, b, c) {
    if (3 === a.tag) $4a3f0044ce2ef491$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4a3f0044ce2ef491$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4a3f0044ce2ef491$var$Ri || !$4a3f0044ce2ef491$var$Ri.has(d))) {
                a = $4a3f0044ce2ef491$var$Ji(c, a);
                a = $4a3f0044ce2ef491$var$Qi(b, a, 1);
                b = $4a3f0044ce2ef491$var$nh(b, a, 1);
                a = $4a3f0044ce2ef491$var$R();
                null !== b && ($4a3f0044ce2ef491$var$Ac(b, 1, a), $4a3f0044ce2ef491$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4a3f0044ce2ef491$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4a3f0044ce2ef491$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4a3f0044ce2ef491$var$Q === a && ($4a3f0044ce2ef491$var$Z & c) === c && (4 === $4a3f0044ce2ef491$var$T || 3 === $4a3f0044ce2ef491$var$T && ($4a3f0044ce2ef491$var$Z & 130023424) === $4a3f0044ce2ef491$var$Z && 500 > $4a3f0044ce2ef491$var$B() - $4a3f0044ce2ef491$var$fk ? $4a3f0044ce2ef491$var$Kk(a, 0) : $4a3f0044ce2ef491$var$rk |= c);
    $4a3f0044ce2ef491$var$Dk(a, b);
}
function $4a3f0044ce2ef491$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4a3f0044ce2ef491$var$sc, $4a3f0044ce2ef491$var$sc <<= 1, 0 === ($4a3f0044ce2ef491$var$sc & 130023424) && ($4a3f0044ce2ef491$var$sc = 4194304)));
    var c = $4a3f0044ce2ef491$var$R();
    a = $4a3f0044ce2ef491$var$ih(a, b);
    null !== a && ($4a3f0044ce2ef491$var$Ac(a, b, c), $4a3f0044ce2ef491$var$Dk(a, c));
}
function $4a3f0044ce2ef491$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4a3f0044ce2ef491$var$Yk(a, c);
}
function $4a3f0044ce2ef491$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4a3f0044ce2ef491$var$p(314));
    }
    null !== d && d.delete(b);
    $4a3f0044ce2ef491$var$Yk(a, c);
}
var $4a3f0044ce2ef491$var$Vk;
$4a3f0044ce2ef491$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4a3f0044ce2ef491$var$Wf.current) $4a3f0044ce2ef491$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4a3f0044ce2ef491$var$dh = !1, $4a3f0044ce2ef491$var$yj(a, b, c);
            $4a3f0044ce2ef491$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4a3f0044ce2ef491$var$dh = !1, $4a3f0044ce2ef491$var$I && 0 !== (b.flags & 1048576) && $4a3f0044ce2ef491$var$ug(b, $4a3f0044ce2ef491$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4a3f0044ce2ef491$var$ij(a, b);
            a = b.pendingProps;
            var e = $4a3f0044ce2ef491$var$Yf(b, $4a3f0044ce2ef491$var$H.current);
            $4a3f0044ce2ef491$var$ch(b, c);
            e = $4a3f0044ce2ef491$var$Nh(null, b, d, a, e, c);
            var f = $4a3f0044ce2ef491$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4a3f0044ce2ef491$var$Zf(d) ? (f = !0, $4a3f0044ce2ef491$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4a3f0044ce2ef491$var$kh(b), e.updater = $4a3f0044ce2ef491$var$Ei, b.stateNode = e, e._reactInternals = b, $4a3f0044ce2ef491$var$Ii(b, d, a, c), b = $4a3f0044ce2ef491$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4a3f0044ce2ef491$var$I && f && $4a3f0044ce2ef491$var$vg(b), $4a3f0044ce2ef491$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4a3f0044ce2ef491$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4a3f0044ce2ef491$var$Zk(d);
                a = $4a3f0044ce2ef491$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4a3f0044ce2ef491$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4a3f0044ce2ef491$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4a3f0044ce2ef491$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4a3f0044ce2ef491$var$$i(null, b, d, $4a3f0044ce2ef491$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4a3f0044ce2ef491$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4a3f0044ce2ef491$var$Ci(d, e), $4a3f0044ce2ef491$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4a3f0044ce2ef491$var$Ci(d, e), $4a3f0044ce2ef491$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4a3f0044ce2ef491$var$kj(b);
                if (null === a) throw Error($4a3f0044ce2ef491$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4a3f0044ce2ef491$var$lh(a, b);
                $4a3f0044ce2ef491$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4a3f0044ce2ef491$var$Ji(Error($4a3f0044ce2ef491$var$p(423)), b);
                        b = $4a3f0044ce2ef491$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4a3f0044ce2ef491$var$Ji(Error($4a3f0044ce2ef491$var$p(424)), b);
                        b = $4a3f0044ce2ef491$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4a3f0044ce2ef491$var$yg = $4a3f0044ce2ef491$var$Lf(b.stateNode.containerInfo.firstChild), $4a3f0044ce2ef491$var$xg = b, $4a3f0044ce2ef491$var$I = !0, $4a3f0044ce2ef491$var$zg = null, c = $4a3f0044ce2ef491$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4a3f0044ce2ef491$var$Ig();
                    if (d === e) {
                        b = $4a3f0044ce2ef491$var$Zi(a, b, c);
                        break a;
                    }
                    $4a3f0044ce2ef491$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4a3f0044ce2ef491$var$Ah(b), null === a && $4a3f0044ce2ef491$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4a3f0044ce2ef491$var$Ef(d, e) ? g = null : null !== f && $4a3f0044ce2ef491$var$Ef(d, f) && (b.flags |= 32), $4a3f0044ce2ef491$var$gj(a, b), $4a3f0044ce2ef491$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4a3f0044ce2ef491$var$Eg(b), null;
        case 13:
            return $4a3f0044ce2ef491$var$oj(a, b, c);
        case 4:
            return $4a3f0044ce2ef491$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4a3f0044ce2ef491$var$Ug(b, null, d, c) : $4a3f0044ce2ef491$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4a3f0044ce2ef491$var$Ci(d, e), $4a3f0044ce2ef491$var$Yi(a, b, d, e, c);
        case 7:
            return $4a3f0044ce2ef491$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4a3f0044ce2ef491$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4a3f0044ce2ef491$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4a3f0044ce2ef491$var$G($4a3f0044ce2ef491$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4a3f0044ce2ef491$var$He(f.value, g)) {
                        if (f.children === e.children && !$4a3f0044ce2ef491$var$Wf.current) {
                            b = $4a3f0044ce2ef491$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4a3f0044ce2ef491$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4a3f0044ce2ef491$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4a3f0044ce2ef491$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4a3f0044ce2ef491$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4a3f0044ce2ef491$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4a3f0044ce2ef491$var$ch(b, c), e = $4a3f0044ce2ef491$var$eh(e), d = d(e), b.flags |= 1, $4a3f0044ce2ef491$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4a3f0044ce2ef491$var$Ci(d, b.pendingProps), e = $4a3f0044ce2ef491$var$Ci(d.type, e), $4a3f0044ce2ef491$var$$i(a, b, d, e, c);
        case 15:
            return $4a3f0044ce2ef491$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4a3f0044ce2ef491$var$Ci(d, e), $4a3f0044ce2ef491$var$ij(a, b), b.tag = 1, $4a3f0044ce2ef491$var$Zf(d) ? (a = !0, $4a3f0044ce2ef491$var$cg(b)) : a = !1, $4a3f0044ce2ef491$var$ch(b, c), $4a3f0044ce2ef491$var$Gi(b, d, e), $4a3f0044ce2ef491$var$Ii(b, d, e, c), $4a3f0044ce2ef491$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4a3f0044ce2ef491$var$xj(a, b, c);
        case 22:
            return $4a3f0044ce2ef491$var$dj(a, b, c);
    }
    throw Error($4a3f0044ce2ef491$var$p(156, b.tag));
};
function $4a3f0044ce2ef491$var$Fk(a, b) {
    return $4a3f0044ce2ef491$var$ac(a, b);
}
function $4a3f0044ce2ef491$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4a3f0044ce2ef491$var$Bg(a, b, c, d) {
    return new $4a3f0044ce2ef491$var$$k(a, b, c, d);
}
function $4a3f0044ce2ef491$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4a3f0044ce2ef491$var$Zk(a) {
    if ("function" === typeof a) return $4a3f0044ce2ef491$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4a3f0044ce2ef491$var$Da) return 11;
        if (a === $4a3f0044ce2ef491$var$Ga) return 14;
    }
    return 2;
}
function $4a3f0044ce2ef491$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4a3f0044ce2ef491$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4a3f0044ce2ef491$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4a3f0044ce2ef491$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4a3f0044ce2ef491$var$ya:
            return $4a3f0044ce2ef491$var$Tg(c.children, e, f, b);
        case $4a3f0044ce2ef491$var$za:
            g = 8;
            e |= 8;
            break;
        case $4a3f0044ce2ef491$var$Aa:
            return a = $4a3f0044ce2ef491$var$Bg(12, c, b, e | 2), a.elementType = $4a3f0044ce2ef491$var$Aa, a.lanes = f, a;
        case $4a3f0044ce2ef491$var$Ea:
            return a = $4a3f0044ce2ef491$var$Bg(13, c, b, e), a.elementType = $4a3f0044ce2ef491$var$Ea, a.lanes = f, a;
        case $4a3f0044ce2ef491$var$Fa:
            return a = $4a3f0044ce2ef491$var$Bg(19, c, b, e), a.elementType = $4a3f0044ce2ef491$var$Fa, a.lanes = f, a;
        case $4a3f0044ce2ef491$var$Ia:
            return $4a3f0044ce2ef491$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4a3f0044ce2ef491$var$Ba:
                    g = 10;
                    break a;
                case $4a3f0044ce2ef491$var$Ca:
                    g = 9;
                    break a;
                case $4a3f0044ce2ef491$var$Da:
                    g = 11;
                    break a;
                case $4a3f0044ce2ef491$var$Ga:
                    g = 14;
                    break a;
                case $4a3f0044ce2ef491$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4a3f0044ce2ef491$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4a3f0044ce2ef491$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4a3f0044ce2ef491$var$Tg(a, b, c, d) {
    a = $4a3f0044ce2ef491$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4a3f0044ce2ef491$var$pj(a, b, c, d) {
    a = $4a3f0044ce2ef491$var$Bg(22, a, d, b);
    a.elementType = $4a3f0044ce2ef491$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4a3f0044ce2ef491$var$Qg(a, b, c) {
    a = $4a3f0044ce2ef491$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4a3f0044ce2ef491$var$Sg(a, b, c) {
    b = $4a3f0044ce2ef491$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4a3f0044ce2ef491$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4a3f0044ce2ef491$var$zc(0);
    this.expirationTimes = $4a3f0044ce2ef491$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4a3f0044ce2ef491$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4a3f0044ce2ef491$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4a3f0044ce2ef491$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4a3f0044ce2ef491$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4a3f0044ce2ef491$var$kh(f);
    return a;
}
function $4a3f0044ce2ef491$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4a3f0044ce2ef491$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4a3f0044ce2ef491$var$dl(a) {
    if (!a) return $4a3f0044ce2ef491$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4a3f0044ce2ef491$var$Vb(a) !== a || 1 !== a.tag) throw Error($4a3f0044ce2ef491$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4a3f0044ce2ef491$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4a3f0044ce2ef491$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4a3f0044ce2ef491$var$Zf(c)) return $4a3f0044ce2ef491$var$bg(a, c, b);
    }
    return b;
}
function $4a3f0044ce2ef491$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4a3f0044ce2ef491$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4a3f0044ce2ef491$var$dl(null);
    c = a.current;
    d = $4a3f0044ce2ef491$var$R();
    e = $4a3f0044ce2ef491$var$yi(c);
    f = $4a3f0044ce2ef491$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4a3f0044ce2ef491$var$nh(c, f, e);
    a.current.lanes = e;
    $4a3f0044ce2ef491$var$Ac(a, e, d);
    $4a3f0044ce2ef491$var$Dk(a, d);
    return a;
}
function $4a3f0044ce2ef491$var$fl(a, b, c, d) {
    var e = b.current, f = $4a3f0044ce2ef491$var$R(), g = $4a3f0044ce2ef491$var$yi(e);
    c = $4a3f0044ce2ef491$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4a3f0044ce2ef491$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4a3f0044ce2ef491$var$nh(e, b, g);
    null !== a && ($4a3f0044ce2ef491$var$gi(a, e, g, f), $4a3f0044ce2ef491$var$oh(a, e, g));
    return g;
}
function $4a3f0044ce2ef491$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4a3f0044ce2ef491$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4a3f0044ce2ef491$var$il(a, b) {
    $4a3f0044ce2ef491$var$hl(a, b);
    (a = a.alternate) && $4a3f0044ce2ef491$var$hl(a, b);
}
function $4a3f0044ce2ef491$var$jl() {
    return null;
}
var $4a3f0044ce2ef491$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4a3f0044ce2ef491$var$ll(a) {
    this._internalRoot = a;
}
$4a3f0044ce2ef491$var$ml.prototype.render = $4a3f0044ce2ef491$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4a3f0044ce2ef491$var$p(409));
    $4a3f0044ce2ef491$var$fl(a, b, null, null);
};
$4a3f0044ce2ef491$var$ml.prototype.unmount = $4a3f0044ce2ef491$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4a3f0044ce2ef491$var$Rk(function() {
            $4a3f0044ce2ef491$var$fl(null, a, null, null);
        });
        b[$4a3f0044ce2ef491$var$uf] = null;
    }
};
function $4a3f0044ce2ef491$var$ml(a) {
    this._internalRoot = a;
}
$4a3f0044ce2ef491$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4a3f0044ce2ef491$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4a3f0044ce2ef491$var$Qc.length && 0 !== b && b < $4a3f0044ce2ef491$var$Qc[c].priority; c++);
        $4a3f0044ce2ef491$var$Qc.splice(c, 0, a);
        0 === c && $4a3f0044ce2ef491$var$Vc(a);
    }
};
function $4a3f0044ce2ef491$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4a3f0044ce2ef491$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4a3f0044ce2ef491$var$pl() {}
function $4a3f0044ce2ef491$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4a3f0044ce2ef491$var$gl(g);
                f.call(a);
            };
        }
        var g = $4a3f0044ce2ef491$var$el(b, d, a, 0, null, !1, !1, "", $4a3f0044ce2ef491$var$pl);
        a._reactRootContainer = g;
        a[$4a3f0044ce2ef491$var$uf] = g.current;
        $4a3f0044ce2ef491$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4a3f0044ce2ef491$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4a3f0044ce2ef491$var$gl(k);
            h.call(a);
        };
    }
    var k = $4a3f0044ce2ef491$var$bl(a, 0, !1, null, null, !1, !1, "", $4a3f0044ce2ef491$var$pl);
    a._reactRootContainer = k;
    a[$4a3f0044ce2ef491$var$uf] = k.current;
    $4a3f0044ce2ef491$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4a3f0044ce2ef491$var$Rk(function() {
        $4a3f0044ce2ef491$var$fl(b, k, c, d);
    });
    return k;
}
function $4a3f0044ce2ef491$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4a3f0044ce2ef491$var$gl(g);
                h.call(a);
            };
        }
        $4a3f0044ce2ef491$var$fl(b, g, a, e);
    } else g = $4a3f0044ce2ef491$var$ql(c, b, a, e, d);
    return $4a3f0044ce2ef491$var$gl(g);
}
$4a3f0044ce2ef491$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4a3f0044ce2ef491$var$tc(b.pendingLanes);
                0 !== c && ($4a3f0044ce2ef491$var$Cc(b, c | 1), $4a3f0044ce2ef491$var$Dk(b, $4a3f0044ce2ef491$var$B()), 0 === ($4a3f0044ce2ef491$var$K & 6) && ($4a3f0044ce2ef491$var$Gj = $4a3f0044ce2ef491$var$B() + 500, $4a3f0044ce2ef491$var$jg()));
            }
            break;
        case 13:
            $4a3f0044ce2ef491$var$Rk(function() {
                var b = $4a3f0044ce2ef491$var$ih(a, 1);
                if (null !== b) {
                    var c = $4a3f0044ce2ef491$var$R();
                    $4a3f0044ce2ef491$var$gi(b, a, 1, c);
                }
            }), $4a3f0044ce2ef491$var$il(a, 1);
    }
};
$4a3f0044ce2ef491$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4a3f0044ce2ef491$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4a3f0044ce2ef491$var$R();
            $4a3f0044ce2ef491$var$gi(b, a, 134217728, c);
        }
        $4a3f0044ce2ef491$var$il(a, 134217728);
    }
};
$4a3f0044ce2ef491$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4a3f0044ce2ef491$var$yi(a), c = $4a3f0044ce2ef491$var$ih(a, b);
        if (null !== c) {
            var d = $4a3f0044ce2ef491$var$R();
            $4a3f0044ce2ef491$var$gi(c, a, b, d);
        }
        $4a3f0044ce2ef491$var$il(a, b);
    }
};
$4a3f0044ce2ef491$var$Hc = function() {
    return $4a3f0044ce2ef491$var$C;
};
$4a3f0044ce2ef491$var$Ic = function(a, b) {
    var c = $4a3f0044ce2ef491$var$C;
    try {
        return $4a3f0044ce2ef491$var$C = a, b();
    } finally{
        $4a3f0044ce2ef491$var$C = c;
    }
};
$4a3f0044ce2ef491$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4a3f0044ce2ef491$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4a3f0044ce2ef491$var$Db(d);
                        if (!e) throw Error($4a3f0044ce2ef491$var$p(90));
                        $4a3f0044ce2ef491$var$Wa(d);
                        $4a3f0044ce2ef491$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4a3f0044ce2ef491$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4a3f0044ce2ef491$var$fb(a, !!c.multiple, b, !1);
    }
};
$4a3f0044ce2ef491$var$Gb = $4a3f0044ce2ef491$var$Qk;
$4a3f0044ce2ef491$var$Hb = $4a3f0044ce2ef491$var$Rk;
var $4a3f0044ce2ef491$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4a3f0044ce2ef491$var$Cb,
        $4a3f0044ce2ef491$var$ue,
        $4a3f0044ce2ef491$var$Db,
        $4a3f0044ce2ef491$var$Eb,
        $4a3f0044ce2ef491$var$Fb,
        $4a3f0044ce2ef491$var$Qk
    ]
}, $4a3f0044ce2ef491$var$tl = {
    findFiberByHostInstance: $4a3f0044ce2ef491$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4a3f0044ce2ef491$var$ul = {
    bundleType: $4a3f0044ce2ef491$var$tl.bundleType,
    version: $4a3f0044ce2ef491$var$tl.version,
    rendererPackageName: $4a3f0044ce2ef491$var$tl.rendererPackageName,
    rendererConfig: $4a3f0044ce2ef491$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4a3f0044ce2ef491$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4a3f0044ce2ef491$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4a3f0044ce2ef491$var$tl.findFiberByHostInstance || $4a3f0044ce2ef491$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4a3f0044ce2ef491$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4a3f0044ce2ef491$var$vl.isDisabled && $4a3f0044ce2ef491$var$vl.supportsFiber) try {
        $4a3f0044ce2ef491$var$kc = $4a3f0044ce2ef491$var$vl.inject($4a3f0044ce2ef491$var$ul), $4a3f0044ce2ef491$var$lc = $4a3f0044ce2ef491$var$vl;
    } catch (a) {}
}
$4a3f0044ce2ef491$export$ae55be85d98224ed = $4a3f0044ce2ef491$var$sl;
$4a3f0044ce2ef491$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4a3f0044ce2ef491$var$nl(b)) throw Error($4a3f0044ce2ef491$var$p(200));
    return $4a3f0044ce2ef491$var$cl(a, b, null, c);
};
$4a3f0044ce2ef491$export$882461b6382ed46c = function(a, b) {
    if (!$4a3f0044ce2ef491$var$nl(a)) throw Error($4a3f0044ce2ef491$var$p(299));
    var c = !1, d = "", e = $4a3f0044ce2ef491$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4a3f0044ce2ef491$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4a3f0044ce2ef491$var$uf] = b.current;
    $4a3f0044ce2ef491$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4a3f0044ce2ef491$var$ll(b);
};
$4a3f0044ce2ef491$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4a3f0044ce2ef491$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4a3f0044ce2ef491$var$p(268, a));
    }
    a = $4a3f0044ce2ef491$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4a3f0044ce2ef491$export$cd75ccfd720a3cd4 = function(a) {
    return $4a3f0044ce2ef491$var$Rk(a);
};
$4a3f0044ce2ef491$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4a3f0044ce2ef491$var$ol(b)) throw Error($4a3f0044ce2ef491$var$p(200));
    return $4a3f0044ce2ef491$var$rl(null, a, b, !0, c);
};
$4a3f0044ce2ef491$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4a3f0044ce2ef491$var$nl(a)) throw Error($4a3f0044ce2ef491$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4a3f0044ce2ef491$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4a3f0044ce2ef491$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4a3f0044ce2ef491$var$uf] = b.current;
    $4a3f0044ce2ef491$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4a3f0044ce2ef491$var$ml(b);
};
$4a3f0044ce2ef491$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4a3f0044ce2ef491$var$ol(b)) throw Error($4a3f0044ce2ef491$var$p(200));
    return $4a3f0044ce2ef491$var$rl(null, a, b, !1, c);
};
$4a3f0044ce2ef491$export$502457920280e6be = function(a) {
    if (!$4a3f0044ce2ef491$var$ol(a)) throw Error($4a3f0044ce2ef491$var$p(40));
    return a._reactRootContainer ? ($4a3f0044ce2ef491$var$Rk(function() {
        $4a3f0044ce2ef491$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4a3f0044ce2ef491$var$uf] = null;
        });
    }), !0) : !1;
};
$4a3f0044ce2ef491$export$c78a37762a8d58e1 = $4a3f0044ce2ef491$var$Qk;
$4a3f0044ce2ef491$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4a3f0044ce2ef491$var$ol(c)) throw Error($4a3f0044ce2ef491$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4a3f0044ce2ef491$var$p(38));
    return $4a3f0044ce2ef491$var$rl(a, b, c, !1, d);
};
$4a3f0044ce2ef491$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bG2CK", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1EEty"));

});
parcelRegister("1EEty", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1348ec7b8599ad86$export$c4744153514ff05d; }, function (v) { return $1348ec7b8599ad86$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1348ec7b8599ad86$export$3e506c1ccc9cc1a7; }, function (v) { return $1348ec7b8599ad86$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1348ec7b8599ad86$export$e26fe2ed2fa76875; }, function (v) { return $1348ec7b8599ad86$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1348ec7b8599ad86$export$502329bbf4b505b1; }, function (v) { return $1348ec7b8599ad86$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1348ec7b8599ad86$export$6e3807111c4874c4; }, function (v) { return $1348ec7b8599ad86$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1348ec7b8599ad86$export$c27134553091fb3a; }, function (v) { return $1348ec7b8599ad86$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1348ec7b8599ad86$export$33ee1acdc04fd2a2; }, function (v) { return $1348ec7b8599ad86$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1348ec7b8599ad86$export$b00a404bbd5edef2; }, function (v) { return $1348ec7b8599ad86$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1348ec7b8599ad86$export$8352ce38b91d0c62; }, function (v) { return $1348ec7b8599ad86$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1348ec7b8599ad86$export$d66a1c1c77bd778b; }, function (v) { return $1348ec7b8599ad86$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1348ec7b8599ad86$export$d3dfb8e4810cb555; }, function (v) { return $1348ec7b8599ad86$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1348ec7b8599ad86$export$839f9183b0465a69; }, function (v) { return $1348ec7b8599ad86$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1348ec7b8599ad86$export$72fdf0e06517287b; }, function (v) { return $1348ec7b8599ad86$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1348ec7b8599ad86$export$4b844e58a3e414b4; }, function (v) { return $1348ec7b8599ad86$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1348ec7b8599ad86$export$816d2913ae6b83b1; }, function (v) { return $1348ec7b8599ad86$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1348ec7b8599ad86$export$61bcfe829111a1d0; }, function (v) { return $1348ec7b8599ad86$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1348ec7b8599ad86$export$7ee8c9beb337bc3f; }, function (v) { return $1348ec7b8599ad86$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1348ec7b8599ad86$export$b5836b71941fa3ed; }, function (v) { return $1348ec7b8599ad86$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1348ec7b8599ad86$export$cf845f2c119da08a; }, function (v) { return $1348ec7b8599ad86$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1348ec7b8599ad86$export$c4744153514ff05d;
var $1348ec7b8599ad86$export$3e506c1ccc9cc1a7;
var $1348ec7b8599ad86$export$e26fe2ed2fa76875;
var $1348ec7b8599ad86$export$502329bbf4b505b1;
var $1348ec7b8599ad86$export$6e3807111c4874c4;
var $1348ec7b8599ad86$export$c27134553091fb3a;
var $1348ec7b8599ad86$export$33ee1acdc04fd2a2;
var $1348ec7b8599ad86$export$b00a404bbd5edef2;
var $1348ec7b8599ad86$export$8352ce38b91d0c62;
var $1348ec7b8599ad86$export$d66a1c1c77bd778b;
var $1348ec7b8599ad86$export$d3dfb8e4810cb555;
var $1348ec7b8599ad86$export$839f9183b0465a69;
var $1348ec7b8599ad86$export$72fdf0e06517287b;
var $1348ec7b8599ad86$export$4b844e58a3e414b4;
var $1348ec7b8599ad86$export$816d2913ae6b83b1;
var $1348ec7b8599ad86$export$61bcfe829111a1d0;
var $1348ec7b8599ad86$export$7ee8c9beb337bc3f;
var $1348ec7b8599ad86$export$b5836b71941fa3ed;
var $1348ec7b8599ad86$export$cf845f2c119da08a;
'use strict';
function $1348ec7b8599ad86$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1348ec7b8599ad86$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1348ec7b8599ad86$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1348ec7b8599ad86$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1348ec7b8599ad86$var$g(C, c)) n < e && 0 > $1348ec7b8599ad86$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1348ec7b8599ad86$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1348ec7b8599ad86$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1348ec7b8599ad86$var$l = performance;
    $1348ec7b8599ad86$export$c4744153514ff05d = function() {
        return $1348ec7b8599ad86$var$l.now();
    };
} else {
    var $1348ec7b8599ad86$var$p = Date, $1348ec7b8599ad86$var$q = $1348ec7b8599ad86$var$p.now();
    $1348ec7b8599ad86$export$c4744153514ff05d = function() {
        return $1348ec7b8599ad86$var$p.now() - $1348ec7b8599ad86$var$q;
    };
}
var $1348ec7b8599ad86$var$r = [], $1348ec7b8599ad86$var$t = [], $1348ec7b8599ad86$var$u = 1, $1348ec7b8599ad86$var$v = null, $1348ec7b8599ad86$var$y = 3, $1348ec7b8599ad86$var$z = !1, $1348ec7b8599ad86$var$A = !1, $1348ec7b8599ad86$var$B = !1, $1348ec7b8599ad86$var$D = "function" === typeof setTimeout ? setTimeout : null, $1348ec7b8599ad86$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1348ec7b8599ad86$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1348ec7b8599ad86$var$G(a) {
    for(var b = $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$t); null !== b;){
        if (null === b.callback) $1348ec7b8599ad86$var$k($1348ec7b8599ad86$var$t);
        else if (b.startTime <= a) $1348ec7b8599ad86$var$k($1348ec7b8599ad86$var$t), b.sortIndex = b.expirationTime, $1348ec7b8599ad86$var$f($1348ec7b8599ad86$var$r, b);
        else break;
        b = $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$t);
    }
}
function $1348ec7b8599ad86$var$H(a) {
    $1348ec7b8599ad86$var$B = !1;
    $1348ec7b8599ad86$var$G(a);
    if (!$1348ec7b8599ad86$var$A) {
        if (null !== $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$r)) $1348ec7b8599ad86$var$A = !0, $1348ec7b8599ad86$var$I($1348ec7b8599ad86$var$J);
        else {
            var b = $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$t);
            null !== b && $1348ec7b8599ad86$var$K($1348ec7b8599ad86$var$H, b.startTime - a);
        }
    }
}
function $1348ec7b8599ad86$var$J(a, b) {
    $1348ec7b8599ad86$var$A = !1;
    $1348ec7b8599ad86$var$B && ($1348ec7b8599ad86$var$B = !1, $1348ec7b8599ad86$var$E($1348ec7b8599ad86$var$L), $1348ec7b8599ad86$var$L = -1);
    $1348ec7b8599ad86$var$z = !0;
    var c = $1348ec7b8599ad86$var$y;
    try {
        $1348ec7b8599ad86$var$G(b);
        for($1348ec7b8599ad86$var$v = $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$r); null !== $1348ec7b8599ad86$var$v && (!($1348ec7b8599ad86$var$v.expirationTime > b) || a && !$1348ec7b8599ad86$var$M());){
            var d = $1348ec7b8599ad86$var$v.callback;
            if ("function" === typeof d) {
                $1348ec7b8599ad86$var$v.callback = null;
                $1348ec7b8599ad86$var$y = $1348ec7b8599ad86$var$v.priorityLevel;
                var e = d($1348ec7b8599ad86$var$v.expirationTime <= b);
                b = $1348ec7b8599ad86$export$c4744153514ff05d();
                "function" === typeof e ? $1348ec7b8599ad86$var$v.callback = e : $1348ec7b8599ad86$var$v === $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$r) && $1348ec7b8599ad86$var$k($1348ec7b8599ad86$var$r);
                $1348ec7b8599ad86$var$G(b);
            } else $1348ec7b8599ad86$var$k($1348ec7b8599ad86$var$r);
            $1348ec7b8599ad86$var$v = $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$r);
        }
        if (null !== $1348ec7b8599ad86$var$v) var w = !0;
        else {
            var m = $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$t);
            null !== m && $1348ec7b8599ad86$var$K($1348ec7b8599ad86$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1348ec7b8599ad86$var$v = null, $1348ec7b8599ad86$var$y = c, $1348ec7b8599ad86$var$z = !1;
    }
}
var $1348ec7b8599ad86$var$N = !1, $1348ec7b8599ad86$var$O = null, $1348ec7b8599ad86$var$L = -1, $1348ec7b8599ad86$var$P = 5, $1348ec7b8599ad86$var$Q = -1;
function $1348ec7b8599ad86$var$M() {
    return $1348ec7b8599ad86$export$c4744153514ff05d() - $1348ec7b8599ad86$var$Q < $1348ec7b8599ad86$var$P ? !1 : !0;
}
function $1348ec7b8599ad86$var$R() {
    if (null !== $1348ec7b8599ad86$var$O) {
        var a = $1348ec7b8599ad86$export$c4744153514ff05d();
        $1348ec7b8599ad86$var$Q = a;
        var b = !0;
        try {
            b = $1348ec7b8599ad86$var$O(!0, a);
        } finally{
            b ? $1348ec7b8599ad86$var$S() : ($1348ec7b8599ad86$var$N = !1, $1348ec7b8599ad86$var$O = null);
        }
    } else $1348ec7b8599ad86$var$N = !1;
}
var $1348ec7b8599ad86$var$S;
if ("function" === typeof $1348ec7b8599ad86$var$F) $1348ec7b8599ad86$var$S = function() {
    $1348ec7b8599ad86$var$F($1348ec7b8599ad86$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1348ec7b8599ad86$var$T = new MessageChannel, $1348ec7b8599ad86$var$U = $1348ec7b8599ad86$var$T.port2;
    $1348ec7b8599ad86$var$T.port1.onmessage = $1348ec7b8599ad86$var$R;
    $1348ec7b8599ad86$var$S = function() {
        $1348ec7b8599ad86$var$U.postMessage(null);
    };
} else $1348ec7b8599ad86$var$S = function() {
    $1348ec7b8599ad86$var$D($1348ec7b8599ad86$var$R, 0);
};
function $1348ec7b8599ad86$var$I(a) {
    $1348ec7b8599ad86$var$O = a;
    $1348ec7b8599ad86$var$N || ($1348ec7b8599ad86$var$N = !0, $1348ec7b8599ad86$var$S());
}
function $1348ec7b8599ad86$var$K(a, b) {
    $1348ec7b8599ad86$var$L = $1348ec7b8599ad86$var$D(function() {
        a($1348ec7b8599ad86$export$c4744153514ff05d());
    }, b);
}
$1348ec7b8599ad86$export$3e506c1ccc9cc1a7 = 5;
$1348ec7b8599ad86$export$e26fe2ed2fa76875 = 1;
$1348ec7b8599ad86$export$502329bbf4b505b1 = 4;
$1348ec7b8599ad86$export$6e3807111c4874c4 = 3;
$1348ec7b8599ad86$export$c27134553091fb3a = null;
$1348ec7b8599ad86$export$33ee1acdc04fd2a2 = 2;
$1348ec7b8599ad86$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1348ec7b8599ad86$export$8352ce38b91d0c62 = function() {
    $1348ec7b8599ad86$var$A || $1348ec7b8599ad86$var$z || ($1348ec7b8599ad86$var$A = !0, $1348ec7b8599ad86$var$I($1348ec7b8599ad86$var$J));
};
$1348ec7b8599ad86$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1348ec7b8599ad86$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1348ec7b8599ad86$export$d3dfb8e4810cb555 = function() {
    return $1348ec7b8599ad86$var$y;
};
$1348ec7b8599ad86$export$839f9183b0465a69 = function() {
    return $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$r);
};
$1348ec7b8599ad86$export$72fdf0e06517287b = function(a) {
    switch($1348ec7b8599ad86$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1348ec7b8599ad86$var$y;
    }
    var c = $1348ec7b8599ad86$var$y;
    $1348ec7b8599ad86$var$y = b;
    try {
        return a();
    } finally{
        $1348ec7b8599ad86$var$y = c;
    }
};
$1348ec7b8599ad86$export$4b844e58a3e414b4 = function() {};
$1348ec7b8599ad86$export$816d2913ae6b83b1 = function() {};
$1348ec7b8599ad86$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1348ec7b8599ad86$var$y;
    $1348ec7b8599ad86$var$y = a;
    try {
        return b();
    } finally{
        $1348ec7b8599ad86$var$y = c;
    }
};
$1348ec7b8599ad86$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1348ec7b8599ad86$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1348ec7b8599ad86$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1348ec7b8599ad86$var$f($1348ec7b8599ad86$var$t, a), null === $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$r) && a === $1348ec7b8599ad86$var$h($1348ec7b8599ad86$var$t) && ($1348ec7b8599ad86$var$B ? ($1348ec7b8599ad86$var$E($1348ec7b8599ad86$var$L), $1348ec7b8599ad86$var$L = -1) : $1348ec7b8599ad86$var$B = !0, $1348ec7b8599ad86$var$K($1348ec7b8599ad86$var$H, c - d))) : (a.sortIndex = e, $1348ec7b8599ad86$var$f($1348ec7b8599ad86$var$r, a), $1348ec7b8599ad86$var$A || $1348ec7b8599ad86$var$z || ($1348ec7b8599ad86$var$A = !0, $1348ec7b8599ad86$var$I($1348ec7b8599ad86$var$J)));
    return a;
};
$1348ec7b8599ad86$export$b5836b71941fa3ed = $1348ec7b8599ad86$var$M;
$1348ec7b8599ad86$export$cf845f2c119da08a = function(a) {
    var b = $1348ec7b8599ad86$var$y;
    return function() {
        var c = $1348ec7b8599ad86$var$y;
        $1348ec7b8599ad86$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1348ec7b8599ad86$var$y = c;
        }
    };
};

});



parcelRegister("eO48b", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $ac78f0871e51f4a0$export$2b8d127b894957b9; }, function (v) { return $ac78f0871e51f4a0$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $ac78f0871e51f4a0$export$cea3a54a6425200c; }, function (v) { return $ac78f0871e51f4a0$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $ac78f0871e51f4a0$export$a7c73072b1a182ae; }, function (v) { return $ac78f0871e51f4a0$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ac78f0871e51f4a0$export$9f27bc3417b4524d; }, function (v) { return $ac78f0871e51f4a0$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ac78f0871e51f4a0$export$db77ccec0bb4ccac; }, function (v) { return $ac78f0871e51f4a0$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ac78f0871e51f4a0$export$8392c0c9d3dcbd35; }, function (v) { return $ac78f0871e51f4a0$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ac78f0871e51f4a0$export$ffb0004e005737fa; }, function (v) { return $ac78f0871e51f4a0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ac78f0871e51f4a0$export$b624eff549462981; }, function (v) { return $ac78f0871e51f4a0$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ac78f0871e51f4a0$export$7897aa7841a5380c; }, function (v) { return $ac78f0871e51f4a0$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ac78f0871e51f4a0$export$602eac185826482c; }, function (v) { return $ac78f0871e51f4a0$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ac78f0871e51f4a0$export$e2c29f18771995cb; }, function (v) { return $ac78f0871e51f4a0$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ac78f0871e51f4a0$export$5f8d39834fd61797; }, function (v) { return $ac78f0871e51f4a0$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ac78f0871e51f4a0$export$74bf444e3cd11ea5; }, function (v) { return $ac78f0871e51f4a0$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ac78f0871e51f4a0$export$92387174baf9b227; }, function (v) { return $ac78f0871e51f4a0$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ac78f0871e51f4a0$export$ec112efeb987d9c6; }, function (v) { return $ac78f0871e51f4a0$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ac78f0871e51f4a0$export$b706b080d889d2c9; }, function (v) { return $ac78f0871e51f4a0$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ac78f0871e51f4a0$export$5be5a87408f70ddc; }, function (v) { return $ac78f0871e51f4a0$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ac78f0871e51f4a0$export$45a5e7f76e0caa8d; }, function (v) { return $ac78f0871e51f4a0$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ac78f0871e51f4a0$export$455c2e768291efa6; }, function (v) { return $ac78f0871e51f4a0$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ac78f0871e51f4a0$export$9522e17588c12572; }, function (v) { return $ac78f0871e51f4a0$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ac78f0871e51f4a0$export$2110ac352bb060b9; }, function (v) { return $ac78f0871e51f4a0$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ac78f0871e51f4a0$export$56885ab8b9c456ab; }, function (v) { return $ac78f0871e51f4a0$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ac78f0871e51f4a0$export$d927fcb6adf8f9de; }, function (v) { return $ac78f0871e51f4a0$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ac78f0871e51f4a0$export$b82d16f27459e05a; }, function (v) { return $ac78f0871e51f4a0$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ac78f0871e51f4a0$export$522c17b4f5e123e8; }, function (v) { return $ac78f0871e51f4a0$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ac78f0871e51f4a0$export$1aabd8a0274ecfd6; }, function (v) { return $ac78f0871e51f4a0$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ac78f0871e51f4a0$export$9b621391a187a31a; }, function (v) { return $ac78f0871e51f4a0$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ac78f0871e51f4a0$export$f5bbd400c2f4426f; }, function (v) { return $ac78f0871e51f4a0$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac78f0871e51f4a0$export$2b8d127b894957b9;
var $ac78f0871e51f4a0$export$cea3a54a6425200c;
var $ac78f0871e51f4a0$export$a7c73072b1a182ae;
var $ac78f0871e51f4a0$export$9f27bc3417b4524d;
var $ac78f0871e51f4a0$export$db77ccec0bb4ccac;
var $ac78f0871e51f4a0$export$8392c0c9d3dcbd35;
var $ac78f0871e51f4a0$export$ffb0004e005737fa;
var $ac78f0871e51f4a0$export$b624eff549462981;
var $ac78f0871e51f4a0$export$7897aa7841a5380c;
var $ac78f0871e51f4a0$export$602eac185826482c;
var $ac78f0871e51f4a0$export$e2c29f18771995cb;
var $ac78f0871e51f4a0$export$5f8d39834fd61797;
var $ac78f0871e51f4a0$export$74bf444e3cd11ea5;
var $ac78f0871e51f4a0$export$92387174baf9b227;
var $ac78f0871e51f4a0$export$ec112efeb987d9c6;
var $ac78f0871e51f4a0$export$b706b080d889d2c9;
var $ac78f0871e51f4a0$export$5be5a87408f70ddc;
var $ac78f0871e51f4a0$export$45a5e7f76e0caa8d;
var $ac78f0871e51f4a0$export$455c2e768291efa6;
var $ac78f0871e51f4a0$export$9522e17588c12572;
var $ac78f0871e51f4a0$export$2110ac352bb060b9;
var $ac78f0871e51f4a0$export$56885ab8b9c456ab;
var $ac78f0871e51f4a0$export$d927fcb6adf8f9de;
var $ac78f0871e51f4a0$export$b82d16f27459e05a;
var $ac78f0871e51f4a0$export$522c17b4f5e123e8;
var $ac78f0871e51f4a0$export$1aabd8a0274ecfd6;
var $ac78f0871e51f4a0$export$9b621391a187a31a;
var $ac78f0871e51f4a0$export$f5bbd400c2f4426f;
'use strict';
var $ac78f0871e51f4a0$var$b = "function" === typeof Symbol && Symbol.for, $ac78f0871e51f4a0$var$c = $ac78f0871e51f4a0$var$b ? Symbol.for("react.element") : 60103, $ac78f0871e51f4a0$var$d = $ac78f0871e51f4a0$var$b ? Symbol.for("react.portal") : 60106, $ac78f0871e51f4a0$var$e = $ac78f0871e51f4a0$var$b ? Symbol.for("react.fragment") : 60107, $ac78f0871e51f4a0$var$f = $ac78f0871e51f4a0$var$b ? Symbol.for("react.strict_mode") : 60108, $ac78f0871e51f4a0$var$g = $ac78f0871e51f4a0$var$b ? Symbol.for("react.profiler") : 60114, $ac78f0871e51f4a0$var$h = $ac78f0871e51f4a0$var$b ? Symbol.for("react.provider") : 60109, $ac78f0871e51f4a0$var$k = $ac78f0871e51f4a0$var$b ? Symbol.for("react.context") : 60110, $ac78f0871e51f4a0$var$l = $ac78f0871e51f4a0$var$b ? Symbol.for("react.async_mode") : 60111, $ac78f0871e51f4a0$var$m = $ac78f0871e51f4a0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $ac78f0871e51f4a0$var$n = $ac78f0871e51f4a0$var$b ? Symbol.for("react.forward_ref") : 60112, $ac78f0871e51f4a0$var$p = $ac78f0871e51f4a0$var$b ? Symbol.for("react.suspense") : 60113, $ac78f0871e51f4a0$var$q = $ac78f0871e51f4a0$var$b ? Symbol.for("react.suspense_list") : 60120, $ac78f0871e51f4a0$var$r = $ac78f0871e51f4a0$var$b ? Symbol.for("react.memo") : 60115, $ac78f0871e51f4a0$var$t = $ac78f0871e51f4a0$var$b ? Symbol.for("react.lazy") : 60116, $ac78f0871e51f4a0$var$v = $ac78f0871e51f4a0$var$b ? Symbol.for("react.block") : 60121, $ac78f0871e51f4a0$var$w = $ac78f0871e51f4a0$var$b ? Symbol.for("react.fundamental") : 60117, $ac78f0871e51f4a0$var$x = $ac78f0871e51f4a0$var$b ? Symbol.for("react.responder") : 60118, $ac78f0871e51f4a0$var$y = $ac78f0871e51f4a0$var$b ? Symbol.for("react.scope") : 60119;
function $ac78f0871e51f4a0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $ac78f0871e51f4a0$var$c:
                switch(a = a.type, a){
                    case $ac78f0871e51f4a0$var$l:
                    case $ac78f0871e51f4a0$var$m:
                    case $ac78f0871e51f4a0$var$e:
                    case $ac78f0871e51f4a0$var$g:
                    case $ac78f0871e51f4a0$var$f:
                    case $ac78f0871e51f4a0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ac78f0871e51f4a0$var$k:
                            case $ac78f0871e51f4a0$var$n:
                            case $ac78f0871e51f4a0$var$t:
                            case $ac78f0871e51f4a0$var$r:
                            case $ac78f0871e51f4a0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $ac78f0871e51f4a0$var$d:
                return u;
        }
    }
}
function $ac78f0871e51f4a0$var$A(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$m;
}
$ac78f0871e51f4a0$export$2b8d127b894957b9 = $ac78f0871e51f4a0$var$l;
$ac78f0871e51f4a0$export$cea3a54a6425200c = $ac78f0871e51f4a0$var$m;
$ac78f0871e51f4a0$export$a7c73072b1a182ae = $ac78f0871e51f4a0$var$k;
$ac78f0871e51f4a0$export$9f27bc3417b4524d = $ac78f0871e51f4a0$var$h;
$ac78f0871e51f4a0$export$db77ccec0bb4ccac = $ac78f0871e51f4a0$var$c;
$ac78f0871e51f4a0$export$8392c0c9d3dcbd35 = $ac78f0871e51f4a0$var$n;
$ac78f0871e51f4a0$export$ffb0004e005737fa = $ac78f0871e51f4a0$var$e;
$ac78f0871e51f4a0$export$b624eff549462981 = $ac78f0871e51f4a0$var$t;
$ac78f0871e51f4a0$export$7897aa7841a5380c = $ac78f0871e51f4a0$var$r;
$ac78f0871e51f4a0$export$602eac185826482c = $ac78f0871e51f4a0$var$d;
$ac78f0871e51f4a0$export$e2c29f18771995cb = $ac78f0871e51f4a0$var$g;
$ac78f0871e51f4a0$export$5f8d39834fd61797 = $ac78f0871e51f4a0$var$f;
$ac78f0871e51f4a0$export$74bf444e3cd11ea5 = $ac78f0871e51f4a0$var$p;
$ac78f0871e51f4a0$export$92387174baf9b227 = function(a) {
    return $ac78f0871e51f4a0$var$A(a) || $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$l;
};
$ac78f0871e51f4a0$export$ec112efeb987d9c6 = $ac78f0871e51f4a0$var$A;
$ac78f0871e51f4a0$export$b706b080d889d2c9 = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$k;
};
$ac78f0871e51f4a0$export$5be5a87408f70ddc = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$h;
};
$ac78f0871e51f4a0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ac78f0871e51f4a0$var$c;
};
$ac78f0871e51f4a0$export$455c2e768291efa6 = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$n;
};
$ac78f0871e51f4a0$export$9522e17588c12572 = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$e;
};
$ac78f0871e51f4a0$export$2110ac352bb060b9 = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$t;
};
$ac78f0871e51f4a0$export$56885ab8b9c456ab = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$r;
};
$ac78f0871e51f4a0$export$d927fcb6adf8f9de = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$d;
};
$ac78f0871e51f4a0$export$b82d16f27459e05a = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$g;
};
$ac78f0871e51f4a0$export$522c17b4f5e123e8 = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$f;
};
$ac78f0871e51f4a0$export$1aabd8a0274ecfd6 = function(a) {
    return $ac78f0871e51f4a0$var$z(a) === $ac78f0871e51f4a0$var$p;
};
$ac78f0871e51f4a0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ac78f0871e51f4a0$var$e || a === $ac78f0871e51f4a0$var$m || a === $ac78f0871e51f4a0$var$g || a === $ac78f0871e51f4a0$var$f || a === $ac78f0871e51f4a0$var$p || a === $ac78f0871e51f4a0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $ac78f0871e51f4a0$var$t || a.$$typeof === $ac78f0871e51f4a0$var$r || a.$$typeof === $ac78f0871e51f4a0$var$h || a.$$typeof === $ac78f0871e51f4a0$var$k || a.$$typeof === $ac78f0871e51f4a0$var$n || a.$$typeof === $ac78f0871e51f4a0$var$w || a.$$typeof === $ac78f0871e51f4a0$var$x || a.$$typeof === $ac78f0871e51f4a0$var$y || a.$$typeof === $ac78f0871e51f4a0$var$v);
};
$ac78f0871e51f4a0$export$f5bbd400c2f4426f = $ac78f0871e51f4a0$var$z;

});

parcelRegister("kCiZZ", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $f02618061279c4f2$export$a7c73072b1a182ae; }, function (v) { return $f02618061279c4f2$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f02618061279c4f2$export$9f27bc3417b4524d; }, function (v) { return $f02618061279c4f2$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f02618061279c4f2$export$db77ccec0bb4ccac; }, function (v) { return $f02618061279c4f2$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f02618061279c4f2$export$8392c0c9d3dcbd35; }, function (v) { return $f02618061279c4f2$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f02618061279c4f2$export$ffb0004e005737fa; }, function (v) { return $f02618061279c4f2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f02618061279c4f2$export$b624eff549462981; }, function (v) { return $f02618061279c4f2$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f02618061279c4f2$export$7897aa7841a5380c; }, function (v) { return $f02618061279c4f2$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f02618061279c4f2$export$602eac185826482c; }, function (v) { return $f02618061279c4f2$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f02618061279c4f2$export$e2c29f18771995cb; }, function (v) { return $f02618061279c4f2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f02618061279c4f2$export$5f8d39834fd61797; }, function (v) { return $f02618061279c4f2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f02618061279c4f2$export$74bf444e3cd11ea5; }, function (v) { return $f02618061279c4f2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $f02618061279c4f2$export$998bcd577473dd93; }, function (v) { return $f02618061279c4f2$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f02618061279c4f2$export$b706b080d889d2c9; }, function (v) { return $f02618061279c4f2$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f02618061279c4f2$export$5be5a87408f70ddc; }, function (v) { return $f02618061279c4f2$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f02618061279c4f2$export$45a5e7f76e0caa8d; }, function (v) { return $f02618061279c4f2$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f02618061279c4f2$export$455c2e768291efa6; }, function (v) { return $f02618061279c4f2$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f02618061279c4f2$export$9522e17588c12572; }, function (v) { return $f02618061279c4f2$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f02618061279c4f2$export$2110ac352bb060b9; }, function (v) { return $f02618061279c4f2$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f02618061279c4f2$export$56885ab8b9c456ab; }, function (v) { return $f02618061279c4f2$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f02618061279c4f2$export$d927fcb6adf8f9de; }, function (v) { return $f02618061279c4f2$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f02618061279c4f2$export$b82d16f27459e05a; }, function (v) { return $f02618061279c4f2$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f02618061279c4f2$export$522c17b4f5e123e8; }, function (v) { return $f02618061279c4f2$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f02618061279c4f2$export$1aabd8a0274ecfd6; }, function (v) { return $f02618061279c4f2$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $f02618061279c4f2$export$3d6c20d97e46b957; }, function (v) { return $f02618061279c4f2$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f02618061279c4f2$export$9b621391a187a31a; }, function (v) { return $f02618061279c4f2$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f02618061279c4f2$export$f5bbd400c2f4426f; }, function (v) { return $f02618061279c4f2$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f02618061279c4f2$export$a7c73072b1a182ae;
var $f02618061279c4f2$export$9f27bc3417b4524d;
var $f02618061279c4f2$export$db77ccec0bb4ccac;
var $f02618061279c4f2$export$8392c0c9d3dcbd35;
var $f02618061279c4f2$export$ffb0004e005737fa;
var $f02618061279c4f2$export$b624eff549462981;
var $f02618061279c4f2$export$7897aa7841a5380c;
var $f02618061279c4f2$export$602eac185826482c;
var $f02618061279c4f2$export$e2c29f18771995cb;
var $f02618061279c4f2$export$5f8d39834fd61797;
var $f02618061279c4f2$export$74bf444e3cd11ea5;
var $f02618061279c4f2$export$998bcd577473dd93;
var $f02618061279c4f2$export$b706b080d889d2c9;
var $f02618061279c4f2$export$5be5a87408f70ddc;
var $f02618061279c4f2$export$45a5e7f76e0caa8d;
var $f02618061279c4f2$export$455c2e768291efa6;
var $f02618061279c4f2$export$9522e17588c12572;
var $f02618061279c4f2$export$2110ac352bb060b9;
var $f02618061279c4f2$export$56885ab8b9c456ab;
var $f02618061279c4f2$export$d927fcb6adf8f9de;
var $f02618061279c4f2$export$b82d16f27459e05a;
var $f02618061279c4f2$export$522c17b4f5e123e8;
var $f02618061279c4f2$export$1aabd8a0274ecfd6;
var $f02618061279c4f2$export$3d6c20d97e46b957;
var $f02618061279c4f2$export$9b621391a187a31a;
var $f02618061279c4f2$export$f5bbd400c2f4426f;
"use strict";
var $f02618061279c4f2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f02618061279c4f2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f02618061279c4f2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f02618061279c4f2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f02618061279c4f2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $f02618061279c4f2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f02618061279c4f2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f02618061279c4f2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f02618061279c4f2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f02618061279c4f2$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f02618061279c4f2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f02618061279c4f2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $f02618061279c4f2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $f02618061279c4f2$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f02618061279c4f2$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $f02618061279c4f2$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f02618061279c4f2$var$REACT_FRAGMENT_TYPE:
                    case $f02618061279c4f2$var$REACT_PROFILER_TYPE:
                    case $f02618061279c4f2$var$REACT_STRICT_MODE_TYPE:
                    case $f02618061279c4f2$var$REACT_SUSPENSE_TYPE:
                    case $f02618061279c4f2$var$REACT_SUSPENSE_LIST_TYPE:
                    case $f02618061279c4f2$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f02618061279c4f2$var$REACT_CONTEXT_TYPE:
                            case $f02618061279c4f2$var$REACT_FORWARD_REF_TYPE:
                            case $f02618061279c4f2$var$REACT_LAZY_TYPE:
                            case $f02618061279c4f2$var$REACT_MEMO_TYPE:
                                return object;
                            case $f02618061279c4f2$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f02618061279c4f2$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$f02618061279c4f2$export$a7c73072b1a182ae = $f02618061279c4f2$var$REACT_CONSUMER_TYPE;
$f02618061279c4f2$export$9f27bc3417b4524d = $f02618061279c4f2$var$REACT_CONTEXT_TYPE;
$f02618061279c4f2$export$db77ccec0bb4ccac = $f02618061279c4f2$var$REACT_ELEMENT_TYPE;
$f02618061279c4f2$export$8392c0c9d3dcbd35 = $f02618061279c4f2$var$REACT_FORWARD_REF_TYPE;
$f02618061279c4f2$export$ffb0004e005737fa = $f02618061279c4f2$var$REACT_FRAGMENT_TYPE;
$f02618061279c4f2$export$b624eff549462981 = $f02618061279c4f2$var$REACT_LAZY_TYPE;
$f02618061279c4f2$export$7897aa7841a5380c = $f02618061279c4f2$var$REACT_MEMO_TYPE;
$f02618061279c4f2$export$602eac185826482c = $f02618061279c4f2$var$REACT_PORTAL_TYPE;
$f02618061279c4f2$export$e2c29f18771995cb = $f02618061279c4f2$var$REACT_PROFILER_TYPE;
$f02618061279c4f2$export$5f8d39834fd61797 = $f02618061279c4f2$var$REACT_STRICT_MODE_TYPE;
$f02618061279c4f2$export$74bf444e3cd11ea5 = $f02618061279c4f2$var$REACT_SUSPENSE_TYPE;
$f02618061279c4f2$export$998bcd577473dd93 = $f02618061279c4f2$var$REACT_SUSPENSE_LIST_TYPE;
$f02618061279c4f2$export$b706b080d889d2c9 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_CONSUMER_TYPE;
};
$f02618061279c4f2$export$5be5a87408f70ddc = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_CONTEXT_TYPE;
};
$f02618061279c4f2$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $f02618061279c4f2$var$REACT_ELEMENT_TYPE;
};
$f02618061279c4f2$export$455c2e768291efa6 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_FORWARD_REF_TYPE;
};
$f02618061279c4f2$export$9522e17588c12572 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_FRAGMENT_TYPE;
};
$f02618061279c4f2$export$2110ac352bb060b9 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_LAZY_TYPE;
};
$f02618061279c4f2$export$56885ab8b9c456ab = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_MEMO_TYPE;
};
$f02618061279c4f2$export$d927fcb6adf8f9de = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_PORTAL_TYPE;
};
$f02618061279c4f2$export$b82d16f27459e05a = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_PROFILER_TYPE;
};
$f02618061279c4f2$export$522c17b4f5e123e8 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_STRICT_MODE_TYPE;
};
$f02618061279c4f2$export$1aabd8a0274ecfd6 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_SUSPENSE_TYPE;
};
$f02618061279c4f2$export$3d6c20d97e46b957 = function(object) {
    return $f02618061279c4f2$var$typeOf(object) === $f02618061279c4f2$var$REACT_SUSPENSE_LIST_TYPE;
};
$f02618061279c4f2$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $f02618061279c4f2$var$REACT_FRAGMENT_TYPE || type === $f02618061279c4f2$var$REACT_PROFILER_TYPE || type === $f02618061279c4f2$var$REACT_STRICT_MODE_TYPE || type === $f02618061279c4f2$var$REACT_SUSPENSE_TYPE || type === $f02618061279c4f2$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $f02618061279c4f2$var$REACT_LAZY_TYPE || type.$$typeof === $f02618061279c4f2$var$REACT_MEMO_TYPE || type.$$typeof === $f02618061279c4f2$var$REACT_CONTEXT_TYPE || type.$$typeof === $f02618061279c4f2$var$REACT_CONSUMER_TYPE || type.$$typeof === $f02618061279c4f2$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f02618061279c4f2$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$f02618061279c4f2$export$f5bbd400c2f4426f = $f02618061279c4f2$var$typeOf;

});

parcelRegister("jzre3", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("39bR5", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $kDNpt = parcelRequire("kDNpt");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $kDNpt.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $kDNpt.default)(Rgb, rgb, (0, $kDNpt.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $kDNpt.default)(Hsl, hsl, (0, $kDNpt.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("kDNpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f06dc6f13873086a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $f06dc6f13873086a$export$8b58be045bf06082; });
function $f06dc6f13873086a$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f06dc6f13873086a$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("5bL8r", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });

var $dKYzS = parcelRequire("dKYzS");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex3 = /^#([0-9a-f]{3})$/, reHex6 = /^#([0-9a-f]{6})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $dKYzS.default)(Color, color, {
    displayable: function() {
        return this.rgb().displayable();
    },
    toString: function() {
        return this.rgb() + "";
    }
});
function color(format) {
    var m;
    format = (format + "").trim().toLowerCase();
    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb(m >> 8 & 0xf | m >> 4 & 0x0f0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
    ) : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
     : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $dKYzS.default)(Rgb, rgb, (0, $dKYzS.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
    },
    toString: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
    }
}));
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $dKYzS.default)(Hsl, hsl, (0, $dKYzS.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("dKYzS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a03e8fb8c471df9e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $a03e8fb8c471df9e$export$8b58be045bf06082; });
function $a03e8fb8c471df9e$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $a03e8fb8c471df9e$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("76qHb", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $l64PU = parcelRequire("l64PU");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $l64PU.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $l64PU.default)(Rgb, rgb, (0, $l64PU.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $l64PU.default)(Hsl, hsl, (0, $l64PU.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("l64PU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5bde8e0253e5801$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $f5bde8e0253e5801$export$8b58be045bf06082; });
function $f5bde8e0253e5801$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f5bde8e0253e5801$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("iBwc3", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });

var $1Iwhd = parcelRequire("1Iwhd");

var $gGVAG = parcelRequire("gGVAG");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $1Iwhd.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $1Iwhd.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d8b4a7a609b0e913$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $gGVAG.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("1Iwhd", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $1402eff988df7cc7$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "atan2", function () { return $1402eff988df7cc7$export$b8b770ee6a0d9760; });
$parcel$export(module.exports, "cos", function () { return $1402eff988df7cc7$export$50d414a77b60d802; });
$parcel$export(module.exports, "max", function () { return $1402eff988df7cc7$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $1402eff988df7cc7$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $1402eff988df7cc7$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $1402eff988df7cc7$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $1402eff988df7cc7$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $1402eff988df7cc7$export$18c7bea995a110f; });
$parcel$export(module.exports, "halfPi", function () { return $1402eff988df7cc7$export$e51408a300e8929a; });
$parcel$export(module.exports, "tau", function () { return $1402eff988df7cc7$export$a4b4b4d4d776fe92; });
$parcel$export(module.exports, "acos", function () { return $1402eff988df7cc7$export$fd6306be3fde5b04; });
$parcel$export(module.exports, "asin", function () { return $1402eff988df7cc7$export$41726bdb1fc63f; });
var $1402eff988df7cc7$export$2335f513bbd82c6d = Math.abs;
var $1402eff988df7cc7$export$b8b770ee6a0d9760 = Math.atan2;
var $1402eff988df7cc7$export$50d414a77b60d802 = Math.cos;
var $1402eff988df7cc7$export$8960430cfd85939f = Math.max;
var $1402eff988df7cc7$export$96ec731ed4dcb222 = Math.min;
var $1402eff988df7cc7$export$5de3937cb4b592ed = Math.sin;
var $1402eff988df7cc7$export$eba8049fb5020b81 = Math.sqrt;
var $1402eff988df7cc7$export$6c421550c66a327d = 1e-12;
var $1402eff988df7cc7$export$18c7bea995a110f = Math.PI;
var $1402eff988df7cc7$export$e51408a300e8929a = $1402eff988df7cc7$export$18c7bea995a110f / 2;
var $1402eff988df7cc7$export$a4b4b4d4d776fe92 = 2 * $1402eff988df7cc7$export$18c7bea995a110f;
function $1402eff988df7cc7$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $1402eff988df7cc7$export$18c7bea995a110f : Math.acos(x);
}
function $1402eff988df7cc7$export$41726bdb1fc63f(x) {
    return x >= 1 ? $1402eff988df7cc7$export$e51408a300e8929a : x <= -1 ? -$1402eff988df7cc7$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("gGVAG", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $c26d3de22b25ae0b$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $c26d3de22b25ae0b$export$ee51ff373511cbeb; });
function $c26d3de22b25ae0b$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $c26d3de22b25ae0b$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$c26d3de22b25ae0b$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $c26d3de22b25ae0b$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                $c26d3de22b25ae0b$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c26d3de22b25ae0b$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $c26d3de22b25ae0b$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("hp6is", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $kdgmU = parcelRequire("kdgmU");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $kdgmU.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $kdgmU.default)(Rgb, rgb, (0, $kdgmU.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $kdgmU.default)(Hsl, hsl, (0, $kdgmU.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("kdgmU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb71b7fe378b383a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $eb71b7fe378b383a$export$8b58be045bf06082; });
function $eb71b7fe378b383a$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $eb71b7fe378b383a$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("7tI6w", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return epsilon; });
$parcel$export(module.exports, "epsilon2", function () { return epsilon2; });
$parcel$export(module.exports, "beaches", function () { return beaches; });
$parcel$export(module.exports, "cells", function () { return cells; });
$parcel$export(module.exports, "circles", function () { return circles; });
$parcel$export(module.exports, "edges", function () { return edges; });
$parcel$export(module.exports, "default", function () { return Diagram; });

var $5WaPE = parcelRequire("5WaPE");

var $4QDtm = parcelRequire("4QDtm");

var $6u4Wi = parcelRequire("6u4Wi");

var $2wxnj = parcelRequire("2wxnj");

var $3y8BX = parcelRequire("3y8BX");
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, $3y8BX.default);
    circles = new (0, $3y8BX.default);
    while(true){
        circle = (0, $6u4Wi.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, $5WaPE.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, $5WaPE.removeBeach)(circle.arc);
        else break;
    }
    (0, $4QDtm.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, $2wxnj.clipEdges)(x0, y0, x1, y1);
        (0, $4QDtm.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, $4QDtm.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

});
parcelRegister("5WaPE", function(module, exports) {

$parcel$export(module.exports, "removeBeach", function () { return $452ac58d26c0c327$export$25be321a9b2d3c3c; });
$parcel$export(module.exports, "addBeach", function () { return $452ac58d26c0c327$export$fec167a219592370; });

var $3y8BX = parcelRequire("3y8BX");

var $4QDtm = parcelRequire("4QDtm");

var $6u4Wi = parcelRequire("6u4Wi");

var $2wxnj = parcelRequire("2wxnj");

var $7tI6w = parcelRequire("7tI6w");
var $452ac58d26c0c327$var$beachPool = [];
function $452ac58d26c0c327$var$Beach() {
    (0, $3y8BX.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function $452ac58d26c0c327$var$createBeach(site) {
    var beach = $452ac58d26c0c327$var$beachPool.pop() || new $452ac58d26c0c327$var$Beach;
    beach.site = site;
    return beach;
}
function $452ac58d26c0c327$var$detachBeach(beach) {
    (0, $6u4Wi.detachCircle)(beach);
    (0, $7tI6w.beaches).remove(beach);
    $452ac58d26c0c327$var$beachPool.push(beach);
    (0, $3y8BX.RedBlackNode)(beach);
}
function $452ac58d26c0c327$export$25be321a9b2d3c3c(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    $452ac58d26c0c327$var$detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, $7tI6w.epsilon) && Math.abs(y - lArc.circle.cy) < (0, $7tI6w.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        $452ac58d26c0c327$var$detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, $6u4Wi.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, $7tI6w.epsilon) && Math.abs(y - rArc.circle.cy) < (0, $7tI6w.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        $452ac58d26c0c327$var$detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, $6u4Wi.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, $2wxnj.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, $2wxnj.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, $6u4Wi.attachCircle)(lArc);
    (0, $6u4Wi.attachCircle)(rArc);
}
function $452ac58d26c0c327$export$fec167a219592370(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, $7tI6w.beaches)._;
    while(node){
        dxl = $452ac58d26c0c327$var$leftBreakPoint(node, directrix) - x;
        if (dxl > (0, $7tI6w.epsilon)) node = node.L;
        else {
            dxr = x - $452ac58d26c0c327$var$rightBreakPoint(node, directrix);
            if (dxr > (0, $7tI6w.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, $7tI6w.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, $7tI6w.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, $4QDtm.createCell)(site);
    var newArc = $452ac58d26c0c327$var$createBeach(site);
    (0, $7tI6w.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, $6u4Wi.detachCircle)(lArc);
        rArc = $452ac58d26c0c327$var$createBeach(lArc.site);
        (0, $7tI6w.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, $2wxnj.createEdge)(lArc.site, newArc.site);
        (0, $6u4Wi.attachCircle)(lArc);
        (0, $6u4Wi.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, $2wxnj.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, $6u4Wi.detachCircle)(lArc);
    (0, $6u4Wi.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, $2wxnj.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, $2wxnj.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, $2wxnj.createEdge)(site, rSite, null, vertex);
    (0, $6u4Wi.attachCircle)(lArc);
    (0, $6u4Wi.attachCircle)(rArc);
}
function $452ac58d26c0c327$var$leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function $452ac58d26c0c327$var$rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return $452ac58d26c0c327$var$leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

});
parcelRegister("3y8BX", function(module, exports) {

$parcel$export(module.exports, "RedBlackNode", function () { return $295b3a1335aa7cd1$export$5072552a5e64b90a; });
$parcel$export(module.exports, "default", function () { return $295b3a1335aa7cd1$export$2e2bcd8739ae039; });
function $295b3a1335aa7cd1$var$RedBlackTree() {
    this._ = null; // root node
}
function $295b3a1335aa7cd1$export$5072552a5e64b90a(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
$295b3a1335aa7cd1$var$RedBlackTree.prototype = {
    constructor: $295b3a1335aa7cd1$var$RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = $295b3a1335aa7cd1$var$RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        $295b3a1335aa7cd1$var$RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $295b3a1335aa7cd1$var$RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        $295b3a1335aa7cd1$var$RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    $295b3a1335aa7cd1$var$RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = $295b3a1335aa7cd1$var$RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $295b3a1335aa7cd1$var$RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        $295b3a1335aa7cd1$var$RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    $295b3a1335aa7cd1$var$RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    $295b3a1335aa7cd1$var$RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        $295b3a1335aa7cd1$var$RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    $295b3a1335aa7cd1$var$RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function $295b3a1335aa7cd1$var$RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function $295b3a1335aa7cd1$var$RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function $295b3a1335aa7cd1$var$RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
var $295b3a1335aa7cd1$export$2e2bcd8739ae039 = $295b3a1335aa7cd1$var$RedBlackTree;

});

parcelRegister("4QDtm", function(module, exports) {

$parcel$export(module.exports, "createCell", function () { return $387aa32e6eb5f5b2$export$3cb21b6b1233300e; });
$parcel$export(module.exports, "cellHalfedgeStart", function () { return $387aa32e6eb5f5b2$export$67c16aa967774be; });
$parcel$export(module.exports, "sortCellHalfedges", function () { return $387aa32e6eb5f5b2$export$41888d88cbc31210; });
$parcel$export(module.exports, "clipCells", function () { return $387aa32e6eb5f5b2$export$cdcebd68073bc3f; });

var $2wxnj = parcelRequire("2wxnj");

var $7tI6w = parcelRequire("7tI6w");
function $387aa32e6eb5f5b2$export$3cb21b6b1233300e(site) {
    return (0, $7tI6w.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function $387aa32e6eb5f5b2$var$cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function $387aa32e6eb5f5b2$export$67c16aa967774be(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function $387aa32e6eb5f5b2$export$bf8e581ba65a00a5(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function $387aa32e6eb5f5b2$export$41888d88cbc31210() {
    for(var i = 0, n = (0, $7tI6w.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, $7tI6w.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = $387aa32e6eb5f5b2$var$cellHalfedgeAngle(cell, (0, $7tI6w.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function $387aa32e6eb5f5b2$export$cdcebd68073bc3f(x0, y0, x1, y1) {
    var nCells = (0, $7tI6w.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, $7tI6w.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, $7tI6w.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = $387aa32e6eb5f5b2$export$bf8e581ba65a00a5(cell, (0, $7tI6w.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = $387aa32e6eb5f5b2$export$67c16aa967774be(cell, (0, $7tI6w.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, $7tI6w.epsilon) || Math.abs(endY - startY) > (0, $7tI6w.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, $7tI6w.edges).push((0, $2wxnj.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, $7tI6w.epsilon) && y1 - endY > (0, $7tI6w.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, $7tI6w.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, $7tI6w.epsilon) && x1 - endX > (0, $7tI6w.epsilon) ? [
                    Math.abs(startY - y1) < (0, $7tI6w.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, $7tI6w.epsilon) && endY - y0 > (0, $7tI6w.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, $7tI6w.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, $7tI6w.epsilon) && endX - x0 > (0, $7tI6w.epsilon) ? [
                    Math.abs(startY - y0) < (0, $7tI6w.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, $7tI6w.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, $7tI6w.edges).push((0, $2wxnj.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, $7tI6w.edges).push((0, $2wxnj.createBorderEdge)(site, v01, v11)) - 1, (0, $7tI6w.edges).push((0, $2wxnj.createBorderEdge)(site, v11, v10)) - 1, (0, $7tI6w.edges).push((0, $2wxnj.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, $7tI6w.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, $7tI6w.cells)[iCell];
        }
    }
}

});
parcelRegister("2wxnj", function(module, exports) {

$parcel$export(module.exports, "createEdge", function () { return $1d687585c733b8f6$export$bdd941b9b8806569; });
$parcel$export(module.exports, "setEdgeEnd", function () { return $1d687585c733b8f6$export$9e883caea829cb44; });
$parcel$export(module.exports, "createBorderEdge", function () { return $1d687585c733b8f6$export$681cc0bbec712be1; });
$parcel$export(module.exports, "clipEdges", function () { return $1d687585c733b8f6$export$db4502aa9c1617af; });

var $7tI6w = parcelRequire("7tI6w");
function $1d687585c733b8f6$export$bdd941b9b8806569(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, $7tI6w.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) $1d687585c733b8f6$export$9e883caea829cb44(edge, left, right, v0);
    if (v1) $1d687585c733b8f6$export$9e883caea829cb44(edge, right, left, v1);
    (0, $7tI6w.cells)[left.index].halfedges.push(index);
    (0, $7tI6w.cells)[right.index].halfedges.push(index);
    return edge;
}
function $1d687585c733b8f6$export$681cc0bbec712be1(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function $1d687585c733b8f6$export$9e883caea829cb44(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function $1d687585c733b8f6$var$clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function $1d687585c733b8f6$var$connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function $1d687585c733b8f6$export$db4502aa9c1617af(x0, y0, x1, y1) {
    var i = (0, $7tI6w.edges).length, edge;
    while(i--)if (!$1d687585c733b8f6$var$connectEdge(edge = (0, $7tI6w.edges)[i], x0, y0, x1, y1) || !$1d687585c733b8f6$var$clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, $7tI6w.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, $7tI6w.epsilon))) delete (0, $7tI6w.edges)[i];
}

});


parcelRegister("6u4Wi", function(module, exports) {

$parcel$export(module.exports, "firstCircle", function () { return $4b89604315ba1dbe$export$2ca650a30b282a37; });
$parcel$export(module.exports, "attachCircle", function () { return $4b89604315ba1dbe$export$2a19333f6373b7a2; });
$parcel$export(module.exports, "detachCircle", function () { return $4b89604315ba1dbe$export$f0bd50ff687673c1; });

var $3y8BX = parcelRequire("3y8BX");

var $7tI6w = parcelRequire("7tI6w");
var $4b89604315ba1dbe$var$circlePool = [];
var $4b89604315ba1dbe$export$2ca650a30b282a37;
function $4b89604315ba1dbe$var$Circle() {
    (0, $3y8BX.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function $4b89604315ba1dbe$export$2a19333f6373b7a2(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, $7tI6w.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = $4b89604315ba1dbe$var$circlePool.pop() || new $4b89604315ba1dbe$var$Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, $7tI6w.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, $7tI6w.circles).insert(before, circle);
    if (!before) $4b89604315ba1dbe$export$2ca650a30b282a37 = circle;
}
function $4b89604315ba1dbe$export$f0bd50ff687673c1(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) $4b89604315ba1dbe$export$2ca650a30b282a37 = circle.N;
        (0, $7tI6w.circles).remove(circle);
        $4b89604315ba1dbe$var$circlePool.push(circle);
        (0, $3y8BX.RedBlackNode)(circle);
        arc.circle = null;
    }
}

});



parcelRegister("PKVGF", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("japms", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3qrVB.default;
    }
});

var $3qrVB = parcelRequire("3qrVB");

});
parcelRegister("3qrVB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27e976bbc2730a9b$export$2e2bcd8739ae039; });

var $lVd4O = parcelRequire("lVd4O");

var $7q9VC = parcelRequire("7q9VC");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $27e976bbc2730a9b$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7q9VC.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $7q9VC.default).muiName;
    return /*#__PURE__*/ $lVd4O.memo(/*#__PURE__*/ $lVd4O.forwardRef(Component));
}

});
parcelRegister("7q9VC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5672a9aabb2e1357$export$2e2bcd8739ae039; });

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $4HqRp = parcelRequire("4HqRp");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $eJnIG = parcelRequire("eJnIG");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $5672a9aabb2e1357$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $4HqRp.default)(color)}`,
            `fontSize${(0, $4HqRp.default)(fontSize)}`
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $eJnIG.getSvgIconUtilityClass), classes);
};
const $5672a9aabb2e1357$var$SvgIconRoot = (0, $gvIKB.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $4HqRp.default)(ownerState.color)}`],
            styles[`fontSize${(0, $4HqRp.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $5672a9aabb2e1357$var$SvgIcon = /*#__PURE__*/ $lVd4O.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $lVd4O.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $5672a9aabb2e1357$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($5672a9aabb2e1357$var$SvgIconRoot, {
        as: component,
        className: (0, $anaDR.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $iO5o7.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$5672a9aabb2e1357$var$SvgIcon.muiName = 'SvgIcon';
var $5672a9aabb2e1357$export$2e2bcd8739ae039 = $5672a9aabb2e1357$var$SvgIcon;

});
parcelRegister("anaDR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ad552e8c7e9c50$export$2e2bcd8739ae039; });
function $f9ad552e8c7e9c50$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f9ad552e8c7e9c50$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f9ad552e8c7e9c50$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f9ad552e8c7e9c50$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f9ad552e8c7e9c50$export$2e2bcd8739ae039 = $f9ad552e8c7e9c50$export$4f5d2d50c9deca37;

});

parcelRegister("jkA0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e12bd03dd172ba09$export$2e2bcd8739ae039; });
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $e12bd03dd172ba09$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("4HqRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36c0037e46a29116$export$2e2bcd8739ae039; });

var $6PGAD = parcelRequire("6PGAD");
var $36c0037e46a29116$export$2e2bcd8739ae039 = (0, $6PGAD.default);

});
parcelRegister("6PGAD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f988af2859558fe$export$2e2bcd8739ae039; });

var $biW9R = parcelRequire("biW9R");
function $4f988af2859558fe$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $biW9R.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("biW9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021fb7b1f65a87d4$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $021fb7b1f65a87d4$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("gvIKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0524128498e55af$export$2e2bcd8739ae039; });

var $5EDGA = parcelRequire("5EDGA");

var $4ZbsN = parcelRequire("4ZbsN");

var $lRoul = parcelRequire("lRoul");

var $8Yw6Z = parcelRequire("8Yw6Z");

'use client';
const $c0524128498e55af$var$styled = (0, $5EDGA.default)({
    themeId: (0, $lRoul.default),
    defaultTheme: $4ZbsN.default,
    rootShouldForwardProp: $8Yw6Z.default
});
var $c0524128498e55af$export$2e2bcd8739ae039 = $c0524128498e55af$var$styled;

});
parcelRegister("5EDGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41df78f479051008$export$2e2bcd8739ae039; });

var $6TPZZ = parcelRequire("6TPZZ");

var $7qwc9 = parcelRequire("7qwc9");

var $6PGAD = parcelRequire("6PGAD");

var $dzyak = parcelRequire("dzyak");

var $lyfWf = parcelRequire("lyfWf");

var $gOseu = parcelRequire("gOseu");

var $6qvYg = parcelRequire("6qvYg");
const $41df78f479051008$export$35e57303dbd8a66 = (0, $lyfWf.default)();
function $41df78f479051008$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $41df78f479051008$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $41df78f479051008$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $41df78f479051008$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $41df78f479051008$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$41df78f479051008$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $41df78f479051008$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $41df78f479051008$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $41df78f479051008$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $41df78f479051008$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $41df78f479051008$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $41df78f479051008$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $41df78f479051008$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $6TPZZ.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $gOseu.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $41df78f479051008$var$defaultOverridesResolver($41df78f479051008$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $41df78f479051008$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($41df78f479051008$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $6TPZZ.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $41df78f479051008$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $41df78f479051008$var$processStyle(props, style);
            };
            if ((0, $7qwc9.isPlainObject)(style)) {
                const serialized = (0, $6qvYg.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $41df78f479051008$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $41df78f479051008$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $41df78f479051008$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $gOseu.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $41df78f479051008$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $6PGAD.default)(componentSlot || '')}`;
    return `Styled(${(0, $dzyak.default)(tag)})`;
}
function $41df78f479051008$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $41df78f479051008$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $41df78f479051008$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $41df78f479051008$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("6TPZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50603708aca8d756$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $50603708aca8d756$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $50603708aca8d756$export$13a2d3ef13012b32; });
/**
 * @mui/styled-engine v6.4.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $91uEb = parcelRequire("91uEb");

var $eVgkC = parcelRequire("eVgkC");

var $cfEcJ = parcelRequire("cfEcJ");
var $7iw0c = parcelRequire("7iw0c");


var $hVfFZ = parcelRequire("hVfFZ");
function $50603708aca8d756$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $91uEb.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $50603708aca8d756$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $50603708aca8d756$var$wrapper = [];
function $50603708aca8d756$export$13a2d3ef13012b32(styles) {
    $50603708aca8d756$var$wrapper[0] = styles;
    return (0, $eVgkC.serializeStyles)($50603708aca8d756$var$wrapper);
}

});
parcelRegister("91uEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $691bfaeef9d8f80f$export$2e2bcd8739ae039; });

var $gFM92 = parcelRequire("gFM92");
parcelRequire("2baGr");

parcelRequire("eVgkC");
parcelRequire("aKeTF");
parcelRequire("k9fGq");
parcelRequire("lVd4O");
parcelRequire("9SGBx");
var $691bfaeef9d8f80f$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $691bfaeef9d8f80f$export$2e2bcd8739ae039 = (0, $gFM92.default).bind(null);
$691bfaeef9d8f80f$var$tags.forEach(function(tagName) {
    $691bfaeef9d8f80f$export$2e2bcd8739ae039[tagName] = $691bfaeef9d8f80f$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("gFM92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c235d237aa3a679e$export$2e2bcd8739ae039; });

var $42AQp = parcelRequire("42AQp");
parcelRequire("cfEcJ");
var $7iw0c = parcelRequire("7iw0c");

var $eVgkC = parcelRequire("eVgkC");

var $aKeTF = parcelRequire("aKeTF");

var $k9fGq = parcelRequire("k9fGq");

var $lVd4O = parcelRequire("lVd4O");

var $9SGBx = parcelRequire("9SGBx");
var $c235d237aa3a679e$var$isBrowser = typeof document !== 'undefined';
var $c235d237aa3a679e$var$isDevelopment = false;
var $c235d237aa3a679e$var$testOmitPropsOnStringTag = (0, $9SGBx.default);
var $c235d237aa3a679e$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $c235d237aa3a679e$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $c235d237aa3a679e$var$testOmitPropsOnStringTag : $c235d237aa3a679e$var$testOmitPropsOnComponent;
};
var $c235d237aa3a679e$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $c235d237aa3a679e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $k9fGq.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aKeTF.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $k9fGq.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$c235d237aa3a679e$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $lVd4O.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $c235d237aa3a679e$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $c235d237aa3a679e$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $c235d237aa3a679e$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $7iw0c.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $lVd4O.useContext((0, $7iw0c.T));
            }
            if (typeof props.className === 'string') className = (0, $k9fGq.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $eVgkC.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $c235d237aa3a679e$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, /*#__PURE__*/ $lVd4O.createElement($c235d237aa3a679e$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $lVd4O.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $c235d237aa3a679e$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $42AQp.default)({}, options, nextOptions, {
                shouldForwardProp: $c235d237aa3a679e$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("42AQp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f13edd153507553$export$2e2bcd8739ae039; });
function $2f13edd153507553$export$2e2bcd8739ae039() {
    return $2f13edd153507553$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2f13edd153507553$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cfEcJ", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $8eb612791f32a6f5$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $8eb612791f32a6f5$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $8eb612791f32a6f5$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("7iw0c")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("7iw0c")).w; });

var $7iw0c = parcelRequire("7iw0c");

var $lVd4O = parcelRequire("lVd4O");

var $k9fGq = parcelRequire("k9fGq");

var $aKeTF = parcelRequire("aKeTF");

var $eVgkC = parcelRequire("eVgkC");
parcelRequire("8WCzc");
parcelRequire("2baGr");
parcelRequire("23Y8j");

parcelRequire("13oN0");
var $8eb612791f32a6f5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $7iw0c.h).call(props, 'css')) return $lVd4O.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $7iw0c.E);
    createElementArgArray[1] = (0, $7iw0c.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $lVd4O.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($8eb612791f32a6f5$export$c8a8987d4410bf2d || ($8eb612791f32a6f5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $8eb612791f32a6f5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $7iw0c.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $eVgkC.serializeStyles)([
        styles
    ], undefined, $lVd4O.useContext((0, $7iw0c.T)));
    if (!(0, $7iw0c.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $lVd4O.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $lVd4O.useRef();
    (0, $aKeTF.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $aKeTF.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $k9fGq.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $8eb612791f32a6f5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $eVgkC.serializeStyles)(args);
}
function $8eb612791f32a6f5$export$d25ddfdf17c3ad3e() {
    var insertable = $8eb612791f32a6f5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $8eb612791f32a6f5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $8eb612791f32a6f5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $k9fGq.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $8eb612791f32a6f5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $aKeTF.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $k9fGq.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $7iw0c.i) && res !== undefined) rules += res;
        }
        if (!(0, $7iw0c.i)) return rules;
    });
    if (!(0, $7iw0c.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $lVd4O.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $8eb612791f32a6f5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $7iw0c.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $7iw0c.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $eVgkC.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $k9fGq.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $7iw0c.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $8eb612791f32a6f5$var$merge(cache.registered, css, $8eb612791f32a6f5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $lVd4O.useContext((0, $7iw0c.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, /*#__PURE__*/ $lVd4O.createElement($8eb612791f32a6f5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("7iw0c", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $550309d0960f9984$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $550309d0960f9984$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $550309d0960f9984$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $550309d0960f9984$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $550309d0960f9984$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $550309d0960f9984$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $550309d0960f9984$export$a9c23c6ac3fc3eca; });

var $lVd4O = parcelRequire("lVd4O");

var $8WCzc = parcelRequire("8WCzc");

var $42AQp = parcelRequire("42AQp");

var $23Y8j = parcelRequire("23Y8j");

var $125v8 = parcelRequire("125v8");

var $k9fGq = parcelRequire("k9fGq");

var $eVgkC = parcelRequire("eVgkC");

var $aKeTF = parcelRequire("aKeTF");
var $550309d0960f9984$export$407448d2b89b1813 = false;
var $550309d0960f9984$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $550309d0960f9984$var$EmotionCacheContext = /* #__PURE__ */ $lVd4O.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $8WCzc.default)({
    key: 'css'
}) : null);
var $550309d0960f9984$export$e7094788287c5e9b = $550309d0960f9984$var$EmotionCacheContext.Provider;
var $550309d0960f9984$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $lVd4O.useContext)($550309d0960f9984$var$EmotionCacheContext);
};
var $550309d0960f9984$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $lVd4O.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $lVd4O.useContext)($550309d0960f9984$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$550309d0960f9984$export$23f2a1d2818174ef) $550309d0960f9984$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $lVd4O.useContext)($550309d0960f9984$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $8WCzc.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $lVd4O.createElement($550309d0960f9984$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $550309d0960f9984$export$971d5caa766a69d7 = /* #__PURE__ */ $lVd4O.createContext({});
var $550309d0960f9984$export$3b14a55fb2447963 = function useTheme() {
    return $lVd4O.useContext($550309d0960f9984$export$971d5caa766a69d7);
};
var $550309d0960f9984$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $42AQp.default)({}, outerTheme, theme);
};
var $550309d0960f9984$var$createCacheWithTheme = /* #__PURE__ */ (0, $23Y8j.default)(function(outerTheme) {
    return (0, $23Y8j.default)(function(theme) {
        return $550309d0960f9984$var$getTheme(outerTheme, theme);
    });
});
var $550309d0960f9984$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $lVd4O.useContext($550309d0960f9984$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $550309d0960f9984$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $lVd4O.createElement($550309d0960f9984$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $550309d0960f9984$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $lVd4O.forwardRef(function render(props, ref) {
        var theme = $lVd4O.useContext($550309d0960f9984$export$971d5caa766a69d7);
        return /*#__PURE__*/ $lVd4O.createElement(Component, (0, $42AQp.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $125v8.default)(WithTheme, Component);
}
var $550309d0960f9984$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $550309d0960f9984$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $550309d0960f9984$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($550309d0960f9984$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$550309d0960f9984$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $550309d0960f9984$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $k9fGq.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aKeTF.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $k9fGq.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$550309d0960f9984$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $lVd4O.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $550309d0960f9984$var$Emotion = /* #__PURE__ */ $550309d0960f9984$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$550309d0960f9984$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $k9fGq.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $eVgkC.serializeStyles)(registeredStyles, undefined, $lVd4O.useContext($550309d0960f9984$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($550309d0960f9984$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $550309d0960f9984$var$typePropName && !$550309d0960f9984$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, /*#__PURE__*/ $lVd4O.createElement($550309d0960f9984$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $lVd4O.createElement(WrappedComponent, newProps));
});
var $550309d0960f9984$export$a9c23c6ac3fc3eca = $550309d0960f9984$var$Emotion;

});
parcelRegister("8WCzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6831a80ea913b8c8$export$2e2bcd8739ae039; });

var $bogwF = parcelRequire("bogwF");

var $5b5Fu = parcelRequire("5b5Fu");

var $23Y8j = parcelRequire("23Y8j");

var $iudSj = parcelRequire("iudSj");
var $6831a80ea913b8c8$var$isBrowser = typeof document !== 'undefined';
var $6831a80ea913b8c8$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $5b5Fu.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $5b5Fu.token)(character)) break;
        (0, $5b5Fu.next)();
    }
    return (0, $5b5Fu.slice)(begin, (0, $5b5Fu.position));
};
var $6831a80ea913b8c8$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $5b5Fu.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $5b5Fu.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6831a80ea913b8c8$var$identifierWithPointTracking((0, $5b5Fu.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $5b5Fu.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $5b5Fu.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5b5Fu.from)(character);
    }
    while (character = (0, $5b5Fu.next)());
    return parsed;
};
var $6831a80ea913b8c8$var$getRules = function getRules(value, points) {
    return (0, $5b5Fu.dealloc)($6831a80ea913b8c8$var$toRules((0, $5b5Fu.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6831a80ea913b8c8$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6831a80ea913b8c8$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6831a80ea913b8c8$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6831a80ea913b8c8$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6831a80ea913b8c8$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6831a80ea913b8c8$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $6831a80ea913b8c8$var$prefix(value, length) {
    switch((0, $5b5Fu.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $5b5Fu.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $5b5Fu.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MOZ) + value + (0, $5b5Fu.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + value + value;
        // order
        case 6165:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.replace)(value, /(\w+).+(:[^]+)/, (0, $5b5Fu.WEBKIT) + 'box-$1$2' + (0, $5b5Fu.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + 'flex-item-' + (0, $5b5Fu.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + 'flex-line-pack' + (0, $5b5Fu.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + (0, $5b5Fu.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + (0, $5b5Fu.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $5b5Fu.WEBKIT) + 'box-' + (0, $5b5Fu.replace)(value, '-grow', '') + (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + (0, $5b5Fu.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $5b5Fu.WEBKIT) + (0, $5b5Fu.replace)(value, /([^-])(transform)/g, '$1' + (0, $5b5Fu.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5b5Fu.replace)((0, $5b5Fu.replace)((0, $5b5Fu.replace)(value, /(zoom-|grab)/, (0, $5b5Fu.WEBKIT) + '$1'), /(image-set)/, (0, $5b5Fu.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5b5Fu.replace)(value, /(image-set\([^]*)/, (0, $5b5Fu.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5b5Fu.replace)((0, $5b5Fu.replace)(value, /(.+:)(flex-)?(.*)/, (0, $5b5Fu.WEBKIT) + 'box-pack:$3' + (0, $5b5Fu.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $5b5Fu.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5b5Fu.replace)(value, /(.+)-inline(.+)/, (0, $5b5Fu.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5b5Fu.strlen)(value) - 1 - length > 6) switch((0, $5b5Fu.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5b5Fu.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5b5Fu.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $5b5Fu.WEBKIT) + '$2-$3' + '$1' + (0, $5b5Fu.MOZ) + ((0, $5b5Fu.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5b5Fu.indexof)(value, 'stretch') ? $6831a80ea913b8c8$var$prefix((0, $5b5Fu.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5b5Fu.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5b5Fu.charat)(value, (0, $5b5Fu.strlen)(value) - 3 - (~(0, $5b5Fu.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5b5Fu.replace)(value, ':', ':' + (0, $5b5Fu.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5b5Fu.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $5b5Fu.WEBKIT) + ((0, $5b5Fu.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $5b5Fu.WEBKIT) + '$2$3' + '$1' + (0, $5b5Fu.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5b5Fu.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + (0, $5b5Fu.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + (0, $5b5Fu.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + (0, $5b5Fu.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $5b5Fu.WEBKIT) + value + (0, $5b5Fu.MS) + value + value;
    }
    return value;
}
var $6831a80ea913b8c8$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $5b5Fu.DECLARATION:
                element["return"] = $6831a80ea913b8c8$var$prefix(element.value, element.length);
                break;
            case 0, $5b5Fu.KEYFRAMES:
                return (0, $5b5Fu.serialize)([
                    (0, $5b5Fu.copy)(element, {
                        value: (0, $5b5Fu.replace)(element.value, '@', '@' + (0, $5b5Fu.WEBKIT))
                    })
                ], callback);
            case 0, $5b5Fu.RULESET:
                if (element.length) return (0, $5b5Fu.combine)(element.props, function(value) {
                    switch((0, $5b5Fu.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $5b5Fu.serialize)([
                                (0, $5b5Fu.copy)(element, {
                                    props: [
                                        (0, $5b5Fu.replace)(value, /:(read-\w+)/, ':' + (0, $5b5Fu.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $5b5Fu.serialize)([
                                (0, $5b5Fu.copy)(element, {
                                    props: [
                                        (0, $5b5Fu.replace)(value, /:(plac\w+)/, ':' + (0, $5b5Fu.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $5b5Fu.copy)(element, {
                                    props: [
                                        (0, $5b5Fu.replace)(value, /:(plac\w+)/, ':' + (0, $5b5Fu.MOZ) + '$1')
                                    ]
                                }),
                                (0, $5b5Fu.copy)(element, {
                                    props: [
                                        (0, $5b5Fu.replace)(value, /:(plac\w+)/, (0, $5b5Fu.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $6831a80ea913b8c8$var$getServerStylisCache = $6831a80ea913b8c8$var$isBrowser ? undefined : (0, $23Y8j.default)(function() {
    return (0, $iudSj.default)(function() {
        return {};
    });
});
var $6831a80ea913b8c8$var$defaultStylisPlugins = [
    $6831a80ea913b8c8$var$prefixer
];
var $6831a80ea913b8c8$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($6831a80ea913b8c8$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $6831a80ea913b8c8$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($6831a80ea913b8c8$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $6831a80ea913b8c8$var$compat,
        $6831a80ea913b8c8$var$removeLabel
    ];
    if (!$6831a80ea913b8c8$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $5b5Fu.stringify),
            (0, $5b5Fu.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $5b5Fu.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $5b5Fu.serialize)((0, $5b5Fu.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $5b5Fu.stringify)
        ];
        var _serializer = (0, $5b5Fu.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $5b5Fu.serialize)((0, $5b5Fu.compile)(styles), _serializer);
        };
        var serverStylisCache = $6831a80ea913b8c8$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bogwF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bogwF", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $84aec14b3a607f4b$export$9d753cd7ae895cce; });
var $84aec14b3a607f4b$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $84aec14b3a607f4b$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $84aec14b3a607f4b$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $84aec14b3a607f4b$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$84aec14b3a607f4b$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($84aec14b3a607f4b$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $84aec14b3a607f4b$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("5b5Fu", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $a4af60e7c8d47cd8$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $a4af60e7c8d47cd8$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $a4af60e7c8d47cd8$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $a4af60e7c8d47cd8$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $a4af60e7c8d47cd8$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $a4af60e7c8d47cd8$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $a4af60e7c8d47cd8$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $a4af60e7c8d47cd8$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $a4af60e7c8d47cd8$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $a4af60e7c8d47cd8$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $a4af60e7c8d47cd8$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $a4af60e7c8d47cd8$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $a4af60e7c8d47cd8$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $a4af60e7c8d47cd8$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $a4af60e7c8d47cd8$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $a4af60e7c8d47cd8$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $a4af60e7c8d47cd8$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $a4af60e7c8d47cd8$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $a4af60e7c8d47cd8$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $a4af60e7c8d47cd8$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $a4af60e7c8d47cd8$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $a4af60e7c8d47cd8$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $a4af60e7c8d47cd8$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $a4af60e7c8d47cd8$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $a4af60e7c8d47cd8$export$38bcb760f1d4871c; });
var $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 = "-ms-";
var $a4af60e7c8d47cd8$export$2c0f367103c8d01c = "-moz-";
var $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 = "-webkit-";
var $a4af60e7c8d47cd8$export$a29989082612d0d9 = "comm";
var $a4af60e7c8d47cd8$export$aa3a2e812ca8570d = "rule";
var $a4af60e7c8d47cd8$export$527d108ccf083c2b = "decl";
var $a4af60e7c8d47cd8$export$d3d35020fa5b54f0 = "@page";
var $a4af60e7c8d47cd8$export$500415a86c544f73 = "@media";
var $a4af60e7c8d47cd8$export$a763edbf796b780a = "@import";
var $a4af60e7c8d47cd8$export$2790aeb8b4e5c826 = "@charset";
var $a4af60e7c8d47cd8$export$1cc683e23b84b133 = "@viewport";
var $a4af60e7c8d47cd8$export$9447a5efea57e862 = "@supports";
var $a4af60e7c8d47cd8$export$ef011b4e114b1fba = "@document";
var $a4af60e7c8d47cd8$export$6aad947bda0f3f46 = "@namespace";
var $a4af60e7c8d47cd8$export$b44a8529a35fcb60 = "@keyframes";
var $a4af60e7c8d47cd8$export$2c16de31893252e6 = "@font-face";
var $a4af60e7c8d47cd8$export$3d846dd52e150c6f = "@counter-style";
var $a4af60e7c8d47cd8$export$22314bfbb57653fe = "@font-feature-values";
var $a4af60e7c8d47cd8$export$d773506282b3cfe6 = "@layer";
var $a4af60e7c8d47cd8$export$2335f513bbd82c6d = Math.abs;
var $a4af60e7c8d47cd8$export$6788812c4e6611e6 = String.fromCharCode;
var $a4af60e7c8d47cd8$export$e6e34fd1f2686227 = Object.assign;
function $a4af60e7c8d47cd8$export$d6af199866bfb566(e, r) {
    return $a4af60e7c8d47cd8$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $a4af60e7c8d47cd8$export$a9db5e087081082d(e, 0)) << 2 ^ $a4af60e7c8d47cd8$export$a9db5e087081082d(e, 1)) << 2 ^ $a4af60e7c8d47cd8$export$a9db5e087081082d(e, 2)) << 2 ^ $a4af60e7c8d47cd8$export$a9db5e087081082d(e, 3) : 0;
}
function $a4af60e7c8d47cd8$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $a4af60e7c8d47cd8$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $a4af60e7c8d47cd8$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $a4af60e7c8d47cd8$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $a4af60e7c8d47cd8$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $a4af60e7c8d47cd8$export$36776f635604f274(e) {
    return e.length;
}
function $a4af60e7c8d47cd8$export$f9084667e487ed46(e) {
    return e.length;
}
function $a4af60e7c8d47cd8$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $a4af60e7c8d47cd8$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $a4af60e7c8d47cd8$export$53f1d5ea8de3d7c = 1;
var $a4af60e7c8d47cd8$export$4e0c71f277ca26b3 = 1;
var $a4af60e7c8d47cd8$export$f24224f1c91d8156 = 0;
var $a4af60e7c8d47cd8$export$5880b8b5730aff45 = 0;
var $a4af60e7c8d47cd8$export$c0306caf338ac095 = 0;
var $a4af60e7c8d47cd8$export$30a86d91af8ff6e6 = "";
function $a4af60e7c8d47cd8$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $a4af60e7c8d47cd8$export$53f1d5ea8de3d7c,
        column: $a4af60e7c8d47cd8$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $a4af60e7c8d47cd8$export$784d13d8ee351f07(e, r) {
    return $a4af60e7c8d47cd8$export$e6e34fd1f2686227($a4af60e7c8d47cd8$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $a4af60e7c8d47cd8$export$eba6f6f03b0a92e7() {
    return $a4af60e7c8d47cd8$export$c0306caf338ac095;
}
function $a4af60e7c8d47cd8$export$232faf9add678146() {
    $a4af60e7c8d47cd8$export$c0306caf338ac095 = $a4af60e7c8d47cd8$export$5880b8b5730aff45 > 0 ? $a4af60e7c8d47cd8$export$a9db5e087081082d($a4af60e7c8d47cd8$export$30a86d91af8ff6e6, --$a4af60e7c8d47cd8$export$5880b8b5730aff45) : 0;
    if ($a4af60e7c8d47cd8$export$4e0c71f277ca26b3--, $a4af60e7c8d47cd8$export$c0306caf338ac095 === 10) $a4af60e7c8d47cd8$export$4e0c71f277ca26b3 = 1, $a4af60e7c8d47cd8$export$53f1d5ea8de3d7c--;
    return $a4af60e7c8d47cd8$export$c0306caf338ac095;
}
function $a4af60e7c8d47cd8$export$48cfd1e771a65c4f() {
    $a4af60e7c8d47cd8$export$c0306caf338ac095 = $a4af60e7c8d47cd8$export$5880b8b5730aff45 < $a4af60e7c8d47cd8$export$f24224f1c91d8156 ? $a4af60e7c8d47cd8$export$a9db5e087081082d($a4af60e7c8d47cd8$export$30a86d91af8ff6e6, $a4af60e7c8d47cd8$export$5880b8b5730aff45++) : 0;
    if ($a4af60e7c8d47cd8$export$4e0c71f277ca26b3++, $a4af60e7c8d47cd8$export$c0306caf338ac095 === 10) $a4af60e7c8d47cd8$export$4e0c71f277ca26b3 = 1, $a4af60e7c8d47cd8$export$53f1d5ea8de3d7c++;
    return $a4af60e7c8d47cd8$export$c0306caf338ac095;
}
function $a4af60e7c8d47cd8$export$4d3fb11e950abb9e() {
    return $a4af60e7c8d47cd8$export$a9db5e087081082d($a4af60e7c8d47cd8$export$30a86d91af8ff6e6, $a4af60e7c8d47cd8$export$5880b8b5730aff45);
}
function $a4af60e7c8d47cd8$export$e88cb2efb12ae807() {
    return $a4af60e7c8d47cd8$export$5880b8b5730aff45;
}
function $a4af60e7c8d47cd8$export$58adb3bec8346d0f(e, r) {
    return $a4af60e7c8d47cd8$export$2f35ab04d2335697($a4af60e7c8d47cd8$export$30a86d91af8ff6e6, e, r);
}
function $a4af60e7c8d47cd8$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $a4af60e7c8d47cd8$export$2de70f21292aac9e(e) {
    return $a4af60e7c8d47cd8$export$53f1d5ea8de3d7c = $a4af60e7c8d47cd8$export$4e0c71f277ca26b3 = 1, $a4af60e7c8d47cd8$export$f24224f1c91d8156 = $a4af60e7c8d47cd8$export$36776f635604f274($a4af60e7c8d47cd8$export$30a86d91af8ff6e6 = e), $a4af60e7c8d47cd8$export$5880b8b5730aff45 = 0, [];
}
function $a4af60e7c8d47cd8$export$45918ac1574455b1(e) {
    return $a4af60e7c8d47cd8$export$30a86d91af8ff6e6 = "", e;
}
function $a4af60e7c8d47cd8$export$410ac95b9ec204b8(e) {
    return $a4af60e7c8d47cd8$export$87c2784dc9fc4ab($a4af60e7c8d47cd8$export$58adb3bec8346d0f($a4af60e7c8d47cd8$export$5880b8b5730aff45 - 1, $a4af60e7c8d47cd8$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $a4af60e7c8d47cd8$export$660b2ee2d4fb4eff(e) {
    return $a4af60e7c8d47cd8$export$45918ac1574455b1($a4af60e7c8d47cd8$export$5f8c09e3ae6f64e1($a4af60e7c8d47cd8$export$2de70f21292aac9e(e)));
}
function $a4af60e7c8d47cd8$export$7af1228ff777d175(e) {
    while($a4af60e7c8d47cd8$export$c0306caf338ac095 = $a4af60e7c8d47cd8$export$4d3fb11e950abb9e())if ($a4af60e7c8d47cd8$export$c0306caf338ac095 < 33) $a4af60e7c8d47cd8$export$48cfd1e771a65c4f();
    else break;
    return $a4af60e7c8d47cd8$export$9e1725a4cfeada27(e) > 2 || $a4af60e7c8d47cd8$export$9e1725a4cfeada27($a4af60e7c8d47cd8$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $a4af60e7c8d47cd8$export$5f8c09e3ae6f64e1(e) {
    while($a4af60e7c8d47cd8$export$48cfd1e771a65c4f())switch($a4af60e7c8d47cd8$export$9e1725a4cfeada27($a4af60e7c8d47cd8$export$c0306caf338ac095)){
        case 0:
            $a4af60e7c8d47cd8$export$10d8903dec122b9d($a4af60e7c8d47cd8$export$c2ab62c7bf24634($a4af60e7c8d47cd8$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $a4af60e7c8d47cd8$export$10d8903dec122b9d($a4af60e7c8d47cd8$export$410ac95b9ec204b8($a4af60e7c8d47cd8$export$c0306caf338ac095), e);
            break;
        default:
            $a4af60e7c8d47cd8$export$10d8903dec122b9d($a4af60e7c8d47cd8$export$6788812c4e6611e6($a4af60e7c8d47cd8$export$c0306caf338ac095), e);
    }
    return e;
}
function $a4af60e7c8d47cd8$export$955ba06d119e085e(e, r) {
    while(--r && $a4af60e7c8d47cd8$export$48cfd1e771a65c4f())if ($a4af60e7c8d47cd8$export$c0306caf338ac095 < 48 || $a4af60e7c8d47cd8$export$c0306caf338ac095 > 102 || $a4af60e7c8d47cd8$export$c0306caf338ac095 > 57 && $a4af60e7c8d47cd8$export$c0306caf338ac095 < 65 || $a4af60e7c8d47cd8$export$c0306caf338ac095 > 70 && $a4af60e7c8d47cd8$export$c0306caf338ac095 < 97) break;
    return $a4af60e7c8d47cd8$export$58adb3bec8346d0f(e, $a4af60e7c8d47cd8$export$e88cb2efb12ae807() + (r < 6 && $a4af60e7c8d47cd8$export$4d3fb11e950abb9e() == 32 && $a4af60e7c8d47cd8$export$48cfd1e771a65c4f() == 32));
}
function $a4af60e7c8d47cd8$export$c889f2fcc19dbf12(e) {
    while($a4af60e7c8d47cd8$export$48cfd1e771a65c4f())switch($a4af60e7c8d47cd8$export$c0306caf338ac095){
        case e:
            return $a4af60e7c8d47cd8$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $a4af60e7c8d47cd8$export$c889f2fcc19dbf12($a4af60e7c8d47cd8$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $a4af60e7c8d47cd8$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $a4af60e7c8d47cd8$export$48cfd1e771a65c4f();
            break;
    }
    return $a4af60e7c8d47cd8$export$5880b8b5730aff45;
}
function $a4af60e7c8d47cd8$export$4254d4e2b3745c4c(e, r) {
    while($a4af60e7c8d47cd8$export$48cfd1e771a65c4f())if (e + $a4af60e7c8d47cd8$export$c0306caf338ac095 === 57) break;
    else if (e + $a4af60e7c8d47cd8$export$c0306caf338ac095 === 84 && $a4af60e7c8d47cd8$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $a4af60e7c8d47cd8$export$58adb3bec8346d0f(r, $a4af60e7c8d47cd8$export$5880b8b5730aff45 - 1) + "*" + $a4af60e7c8d47cd8$export$6788812c4e6611e6(e === 47 ? e : $a4af60e7c8d47cd8$export$48cfd1e771a65c4f());
}
function $a4af60e7c8d47cd8$export$c2ab62c7bf24634(e) {
    while(!$a4af60e7c8d47cd8$export$9e1725a4cfeada27($a4af60e7c8d47cd8$export$4d3fb11e950abb9e()))$a4af60e7c8d47cd8$export$48cfd1e771a65c4f();
    return $a4af60e7c8d47cd8$export$58adb3bec8346d0f(e, $a4af60e7c8d47cd8$export$5880b8b5730aff45);
}
function $a4af60e7c8d47cd8$export$ef7acd7185315e22(e) {
    return $a4af60e7c8d47cd8$export$45918ac1574455b1($a4af60e7c8d47cd8$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $a4af60e7c8d47cd8$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $a4af60e7c8d47cd8$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $a4af60e7c8d47cd8$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $a4af60e7c8d47cd8$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($a4af60e7c8d47cd8$export$f8e21b1e77979a08(j += $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed($a4af60e7c8d47cd8$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $a4af60e7c8d47cd8$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $a4af60e7c8d47cd8$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $a4af60e7c8d47cd8$export$955ba06d119e085e($a4af60e7c8d47cd8$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($a4af60e7c8d47cd8$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $a4af60e7c8d47cd8$export$10d8903dec122b9d($a4af60e7c8d47cd8$export$4a34f930e789283c($a4af60e7c8d47cd8$export$4254d4e2b3745c4c($a4af60e7c8d47cd8$export$48cfd1e771a65c4f(), $a4af60e7c8d47cd8$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $a4af60e7c8d47cd8$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $a4af60e7c8d47cd8$export$36776f635604f274(j) - l) $a4af60e7c8d47cd8$export$10d8903dec122b9d(p > 32 ? $a4af60e7c8d47cd8$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $a4af60e7c8d47cd8$export$f8483753829ec8f3($a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $a4af60e7c8d47cd8$export$10d8903dec122b9d(y = $a4af60e7c8d47cd8$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $a4af60e7c8d47cd8$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $a4af60e7c8d47cd8$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $a4af60e7c8d47cd8$export$98e6a39c04603d36(e, y, y, n && $a4af60e7c8d47cd8$export$10d8903dec122b9d($a4af60e7c8d47cd8$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $a4af60e7c8d47cd8$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $a4af60e7c8d47cd8$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $a4af60e7c8d47cd8$export$232faf9add678146() == 125) continue;
            }
            switch(j += $a4af60e7c8d47cd8$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($a4af60e7c8d47cd8$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($a4af60e7c8d47cd8$export$4d3fb11e950abb9e() === 45) j += $a4af60e7c8d47cd8$export$410ac95b9ec204b8($a4af60e7c8d47cd8$export$48cfd1e771a65c4f());
                    v = $a4af60e7c8d47cd8$export$4d3fb11e950abb9e(), o = l = $a4af60e7c8d47cd8$export$36776f635604f274(g = j += $a4af60e7c8d47cd8$export$c2ab62c7bf24634($a4af60e7c8d47cd8$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $a4af60e7c8d47cd8$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $a4af60e7c8d47cd8$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $a4af60e7c8d47cd8$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $a4af60e7c8d47cd8$export$2f35ab04d2335697(e, v + 1, v = $a4af60e7c8d47cd8$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $a4af60e7c8d47cd8$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $a4af60e7c8d47cd8$export$35059013cd4a06db(e, r, a, s === 0 ? $a4af60e7c8d47cd8$export$aa3a2e812ca8570d : i, f, o, l);
}
function $a4af60e7c8d47cd8$export$4a34f930e789283c(e, r, a) {
    return $a4af60e7c8d47cd8$export$35059013cd4a06db(e, r, a, $a4af60e7c8d47cd8$export$a29989082612d0d9, $a4af60e7c8d47cd8$export$6788812c4e6611e6($a4af60e7c8d47cd8$export$eba6f6f03b0a92e7()), $a4af60e7c8d47cd8$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $a4af60e7c8d47cd8$export$f8483753829ec8f3(e, r, a, n) {
    return $a4af60e7c8d47cd8$export$35059013cd4a06db(e, r, a, $a4af60e7c8d47cd8$export$527d108ccf083c2b, $a4af60e7c8d47cd8$export$2f35ab04d2335697(e, 0, n), $a4af60e7c8d47cd8$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $a4af60e7c8d47cd8$export$82e9f45cca5ba907(n, c, s) {
    switch($a4af60e7c8d47cd8$export$d6af199866bfb566(n, c)){
        case 5103:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $a4af60e7c8d47cd8$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$2c0f367103c8d01c + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($a4af60e7c8d47cd8$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "box-$1$2" + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "flex-item-" + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$a4af60e7c8d47cd8$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "grid-row-" + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "flex-line-pack" + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "box-" + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "-grow", "") + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed($a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed($a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed($a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "box-pack:$3" + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$a4af60e7c8d47cd8$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "grid-column-align" + $a4af60e7c8d47cd8$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $a4af60e7c8d47cd8$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$a4af60e7c8d47cd8$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$a4af60e7c8d47cd8$export$f8e21b1e77979a08(s, "span") ? $a4af60e7c8d47cd8$export$4659b591c19bdf3d(s, /\d+/) : +$a4af60e7c8d47cd8$export$4659b591c19bdf3d(s, /\d+/) - +$a4af60e7c8d47cd8$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $a4af60e7c8d47cd8$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed($a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($a4af60e7c8d47cd8$export$36776f635604f274(n) - 1 - c > 6) switch($a4af60e7c8d47cd8$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($a4af60e7c8d47cd8$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $a4af60e7c8d47cd8$export$2c0f367103c8d01c + ($a4af60e7c8d47cd8$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$a4af60e7c8d47cd8$export$f8e21b1e77979a08(n, "stretch") ? $a4af60e7c8d47cd8$export$82e9f45cca5ba907($a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($a4af60e7c8d47cd8$export$a9db5e087081082d(n, c + 6) === 121) return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, ":", ":" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($a4af60e7c8d47cd8$export$a9db5e087081082d(n, $a4af60e7c8d47cd8$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + ($a4af60e7c8d47cd8$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, ":", ":" + $a4af60e7c8d47cd8$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $a4af60e7c8d47cd8$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $a4af60e7c8d47cd8$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $a4af60e7c8d47cd8$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $a4af60e7c8d47cd8$export$a763edbf796b780a:
        case $a4af60e7c8d47cd8$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $a4af60e7c8d47cd8$export$a29989082612d0d9:
            return "";
        case $a4af60e7c8d47cd8$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $a4af60e7c8d47cd8$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $a4af60e7c8d47cd8$export$36776f635604f274(a = $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $a4af60e7c8d47cd8$export$5a7767152ae0305f(e) {
    var r = $a4af60e7c8d47cd8$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $a4af60e7c8d47cd8$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $a4af60e7c8d47cd8$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $a4af60e7c8d47cd8$export$527d108ccf083c2b:
                n.return = $a4af60e7c8d47cd8$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $a4af60e7c8d47cd8$export$b44a8529a35fcb60:
                return $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb([
                    $a4af60e7c8d47cd8$export$784d13d8ee351f07(n, {
                        value: $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $a4af60e7c8d47cd8$export$aa3a2e812ca8570d:
                if (n.length) return $a4af60e7c8d47cd8$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($a4af60e7c8d47cd8$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb([
                                $a4af60e7c8d47cd8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $a4af60e7c8d47cd8$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $a4af60e7c8d47cd8$export$dfdc1655ccc5b9cb([
                                $a4af60e7c8d47cd8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $a4af60e7c8d47cd8$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $a4af60e7c8d47cd8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $a4af60e7c8d47cd8$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $a4af60e7c8d47cd8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $a4af60e7c8d47cd8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $a4af60e7c8d47cd8$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $a4af60e7c8d47cd8$export$76a88f7de6507443(e) {
    switch(e.type){
        case $a4af60e7c8d47cd8$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $a4af60e7c8d47cd8$export$1be1fc439b849fdf($a4af60e7c8d47cd8$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($a4af60e7c8d47cd8$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $a4af60e7c8d47cd8$export$2f35ab04d2335697(r, 1, $a4af60e7c8d47cd8$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $a4af60e7c8d47cd8$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $a4af60e7c8d47cd8$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $a4af60e7c8d47cd8$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("23Y8j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $180a81c6949286e6$export$2e2bcd8739ae039; });
var $180a81c6949286e6$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("iudSj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d755ca9a2612550a$export$2e2bcd8739ae039; });
function $d755ca9a2612550a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("125v8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c0a3ec1cb2860c7$export$2e2bcd8739ae039; });

var $13oN0 = parcelRequire("13oN0");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0c0a3ec1cb2860c7$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($13oN0)))(targetComponent, sourceComponent);
};

});
parcelRegister("13oN0", function(module, exports) {
'use strict';

var $9bcpa = parcelRequire("9bcpa");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $0c494ce4fe3556a0$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $0c494ce4fe3556a0$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $0c494ce4fe3556a0$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $0c494ce4fe3556a0$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $0c494ce4fe3556a0$var$TYPE_STATICS = {};
$0c494ce4fe3556a0$var$TYPE_STATICS[$9bcpa.ForwardRef] = $0c494ce4fe3556a0$var$FORWARD_REF_STATICS;
$0c494ce4fe3556a0$var$TYPE_STATICS[$9bcpa.Memo] = $0c494ce4fe3556a0$var$MEMO_STATICS;
function $0c494ce4fe3556a0$var$getStatics(component) {
    // React v16.11 and below
    if ($9bcpa.isMemo(component)) return $0c494ce4fe3556a0$var$MEMO_STATICS;
     // React v16.12 and above
    return $0c494ce4fe3556a0$var$TYPE_STATICS[component['$$typeof']] || $0c494ce4fe3556a0$var$REACT_STATICS;
}
var $0c494ce4fe3556a0$var$defineProperty = Object.defineProperty;
var $0c494ce4fe3556a0$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $0c494ce4fe3556a0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0c494ce4fe3556a0$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0c494ce4fe3556a0$var$getPrototypeOf = Object.getPrototypeOf;
var $0c494ce4fe3556a0$var$objectPrototype = Object.prototype;
function $0c494ce4fe3556a0$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($0c494ce4fe3556a0$var$objectPrototype) {
            var inheritedComponent = $0c494ce4fe3556a0$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $0c494ce4fe3556a0$var$objectPrototype) $0c494ce4fe3556a0$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $0c494ce4fe3556a0$var$getOwnPropertyNames(sourceComponent);
        if ($0c494ce4fe3556a0$var$getOwnPropertySymbols) keys = keys.concat($0c494ce4fe3556a0$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $0c494ce4fe3556a0$var$getStatics(targetComponent);
        var sourceStatics = $0c494ce4fe3556a0$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$0c494ce4fe3556a0$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $0c494ce4fe3556a0$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $0c494ce4fe3556a0$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $0c494ce4fe3556a0$var$hoistNonReactStatics;

});
parcelRegister("9bcpa", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eO48b"));

});



parcelRegister("k9fGq", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $eab0d0473787f541$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $eab0d0473787f541$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $eab0d0473787f541$export$6f077d94b33a01aa; });
var $eab0d0473787f541$var$isBrowser = typeof document !== 'undefined';
function $eab0d0473787f541$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $eab0d0473787f541$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $eab0d0473787f541$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $eab0d0473787f541$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $eab0d0473787f541$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$eab0d0473787f541$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$eab0d0473787f541$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("eVgkC", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $add30ea8ae81a8b9$export$6321afa313b251b5; });

var $3awqP = parcelRequire("3awqP");

var $hgrEE = parcelRequire("hgrEE");

var $iudSj = parcelRequire("iudSj");
var $add30ea8ae81a8b9$var$isDevelopment = false;
var $add30ea8ae81a8b9$var$hyphenateRegex = /[A-Z]|^ms/g;
var $add30ea8ae81a8b9$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $add30ea8ae81a8b9$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $add30ea8ae81a8b9$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $add30ea8ae81a8b9$var$processStyleName = /* #__PURE__ */ (0, $iudSj.default)(function(styleName) {
    return $add30ea8ae81a8b9$var$isCustomProperty(styleName) ? styleName : styleName.replace($add30ea8ae81a8b9$var$hyphenateRegex, '-$&').toLowerCase();
});
var $add30ea8ae81a8b9$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($add30ea8ae81a8b9$var$animationRegex, function(match, p1, p2) {
                $add30ea8ae81a8b9$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $add30ea8ae81a8b9$var$cursor
                };
                return p1;
            });
    }
    if ((0, $hgrEE.default)[key] !== 1 && !$add30ea8ae81a8b9$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $add30ea8ae81a8b9$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $add30ea8ae81a8b9$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $add30ea8ae81a8b9$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $add30ea8ae81a8b9$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $add30ea8ae81a8b9$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $add30ea8ae81a8b9$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $add30ea8ae81a8b9$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $add30ea8ae81a8b9$var$cursor;
                var result = interpolation(mergedProps);
                $add30ea8ae81a8b9$var$cursor = previousCursor;
                return $add30ea8ae81a8b9$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $add30ea8ae81a8b9$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $add30ea8ae81a8b9$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($add30ea8ae81a8b9$var$isProcessableValue(asString)) string += $add30ea8ae81a8b9$var$processStyleName(key) + ":" + $add30ea8ae81a8b9$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $add30ea8ae81a8b9$var$isDevelopment) throw new Error($add30ea8ae81a8b9$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($add30ea8ae81a8b9$var$isProcessableValue(value[_i])) string += $add30ea8ae81a8b9$var$processStyleName(key) + ":" + $add30ea8ae81a8b9$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $add30ea8ae81a8b9$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $add30ea8ae81a8b9$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $add30ea8ae81a8b9$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $add30ea8ae81a8b9$var$cursor;
function $add30ea8ae81a8b9$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $add30ea8ae81a8b9$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $add30ea8ae81a8b9$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $add30ea8ae81a8b9$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $add30ea8ae81a8b9$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $add30ea8ae81a8b9$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3awqP.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $add30ea8ae81a8b9$var$cursor
    };
}

});
parcelRegister("3awqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24eb768a33a2538e$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $24eb768a33a2538e$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("hgrEE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c91961ea8f094d5d$export$2e2bcd8739ae039; });
var $c91961ea8f094d5d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("aKeTF", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $7d29c1737b3aea8b$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $7d29c1737b3aea8b$export$811a713a7276cb9d; });

var $lVd4O = parcelRequire("lVd4O");
var $7d29c1737b3aea8b$var$isBrowser = typeof document !== 'undefined';
var $7d29c1737b3aea8b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $7d29c1737b3aea8b$var$useInsertionEffect = $lVd4O.useInsertionEffect ? $lVd4O.useInsertionEffect : false;
var $7d29c1737b3aea8b$export$db21c7ffa21794e7 = !$7d29c1737b3aea8b$var$isBrowser ? $7d29c1737b3aea8b$var$syncFallback : $7d29c1737b3aea8b$var$useInsertionEffect || $7d29c1737b3aea8b$var$syncFallback;
var $7d29c1737b3aea8b$export$811a713a7276cb9d = $7d29c1737b3aea8b$var$useInsertionEffect || $lVd4O.useLayoutEffect;

});


parcelRegister("2baGr", function(module, exports) {
function $1964e55d21bc17e2$var$_extends() {
    return module.exports = $1964e55d21bc17e2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1964e55d21bc17e2$var$_extends.apply(null, arguments);
}
module.exports = $1964e55d21bc17e2$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9SGBx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $731a348d702aa87c$export$2e2bcd8739ae039; });

var $iudSj = parcelRequire("iudSj");
// eslint-disable-next-line no-undef
var $731a348d702aa87c$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $731a348d702aa87c$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $iudSj.default)(function(prop) {
    return $731a348d702aa87c$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("hVfFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0c3eb8273b73713$export$2e2bcd8739ae039; });
parcelRequire("lVd4O");


var $cfEcJ = parcelRequire("cfEcJ");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $d0c3eb8273b73713$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $d0c3eb8273b73713$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($d0c3eb8273b73713$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cfEcJ.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("iO5o7", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5omY3"));

});



parcelRegister("7qwc9", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $5683ef5d951bf2b9$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $5683ef5d951bf2b9$export$2e2bcd8739ae039; });

var $lVd4O = parcelRequire("lVd4O");

var $7ntL2 = parcelRequire("7ntL2");
function $5683ef5d951bf2b9$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $5683ef5d951bf2b9$var$deepClone(source) {
    if (/*#__PURE__*/ $lVd4O.isValidElement(source) || (0, $7ntL2.isValidElementType)(source) || !$5683ef5d951bf2b9$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $5683ef5d951bf2b9$var$deepClone(source[key]);
    });
    return output;
}
function $5683ef5d951bf2b9$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($5683ef5d951bf2b9$export$53b83ca8eaab0383(target) && $5683ef5d951bf2b9$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $lVd4O.isValidElement(source[key]) || (0, $7ntL2.isValidElementType)(source[key])) output[key] = source[key];
        else if ($5683ef5d951bf2b9$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $5683ef5d951bf2b9$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $5683ef5d951bf2b9$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $5683ef5d951bf2b9$export$53b83ca8eaab0383(source[key]) ? $5683ef5d951bf2b9$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("7ntL2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kCiZZ"));

});


parcelRegister("dzyak", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e190bd7c2d58d9c$export$2e2bcd8739ae039; });

var $7ntL2 = parcelRequire("7ntL2");
function $9e190bd7c2d58d9c$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $9e190bd7c2d58d9c$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $9e190bd7c2d58d9c$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $9e190bd7c2d58d9c$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $9e190bd7c2d58d9c$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $7ntL2.ForwardRef:
            return $9e190bd7c2d58d9c$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $7ntL2.Memo:
            return $9e190bd7c2d58d9c$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("lyfWf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0922ffe3debd77$export$2e2bcd8739ae039; });

var $7qwc9 = parcelRequire("7qwc9");

var $dAYaj = parcelRequire("dAYaj");

var $3HOx1 = parcelRequire("3HOx1");

var $f7kDA = parcelRequire("f7kDA");

var $dF8K7 = parcelRequire("dF8K7");

var $gOseu = parcelRequire("gOseu");

var $fOrBY = parcelRequire("fOrBY");

var $hvE8q = parcelRequire("hvE8q");
function $fb0922ffe3debd77$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $dAYaj.default)(breakpointsInput);
    const spacing = (0, $dF8K7.default)(spacingInput);
    let muiTheme = (0, $7qwc9.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $f7kDA.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $3HOx1.default)(muiTheme);
    muiTheme.applyStyles = (0, $hvE8q.default);
    muiTheme = args.reduce((acc, argument)=>(0, $7qwc9.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $fOrBY.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $gOseu.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $fb0922ffe3debd77$export$2e2bcd8739ae039 = $fb0922ffe3debd77$var$createTheme;

});
parcelRegister("dAYaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e5d4eb89879a71b$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $9e5d4eb89879a71b$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $9e5d4eb89879a71b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $9e5d4eb89879a71b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $9e5d4eb89879a71b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("3HOx1", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $2b2c95c2ea343822$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $2b2c95c2ea343822$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $2b2c95c2ea343822$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $2b2c95c2ea343822$export$2e2bcd8739ae039; });

function $2b2c95c2ea343822$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2b2c95c2ea343822$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2b2c95c2ea343822$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2b2c95c2ea343822$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("f7kDA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b01784a2b62be1c5$export$2e2bcd8739ae039; });
const $b01784a2b62be1c5$var$shape = {
    borderRadius: 4
};
var $b01784a2b62be1c5$export$2e2bcd8739ae039 = $b01784a2b62be1c5$var$shape;

});

parcelRegister("dF8K7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f25e2d563388f4e$export$2e2bcd8739ae039; });

var $8qjYP = parcelRequire("8qjYP");
function $9f25e2d563388f4e$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $8qjYP.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8qjYP", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $622040121c71d41f$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $622040121c71d41f$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $622040121c71d41f$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $622040121c71d41f$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $622040121c71d41f$export$6f98e8eaf0be1996; });


var $iYYAo = parcelRequire("iYYAo");

var $4T0ON = parcelRequire("4T0ON");

var $lj5cg = parcelRequire("lj5cg");

var $kWThH = parcelRequire("kWThH");
const $622040121c71d41f$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $622040121c71d41f$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $622040121c71d41f$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $622040121c71d41f$var$getCssProperties = (0, $kWThH.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($622040121c71d41f$var$aliases[prop]) prop = $622040121c71d41f$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $622040121c71d41f$var$properties[a];
    const direction = $622040121c71d41f$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $622040121c71d41f$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $622040121c71d41f$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $622040121c71d41f$var$spacingKeys = [
    ...$622040121c71d41f$export$aab52a0dde05ad8a,
    ...$622040121c71d41f$export$f8397d44f03ab6ad
];
function $622040121c71d41f$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $4T0ON.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $622040121c71d41f$export$1def6f833384e3d1(theme) {
    return $622040121c71d41f$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $622040121c71d41f$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $622040121c71d41f$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $622040121c71d41f$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $622040121c71d41f$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $622040121c71d41f$var$getCssProperties(prop);
    const styleFromPropValue = $622040121c71d41f$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $iYYAo.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $622040121c71d41f$var$style(props, keys) {
    const transformer = $622040121c71d41f$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$622040121c71d41f$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $lj5cg.default), {});
}
function $622040121c71d41f$export$7ede87f9b603dd3c(props) {
    return $622040121c71d41f$var$style(props, $622040121c71d41f$export$aab52a0dde05ad8a);
}
$622040121c71d41f$export$7ede87f9b603dd3c.propTypes = {};
$622040121c71d41f$export$7ede87f9b603dd3c.filterProps = $622040121c71d41f$export$aab52a0dde05ad8a;
function $622040121c71d41f$export$6f98e8eaf0be1996(props) {
    return $622040121c71d41f$var$style(props, $622040121c71d41f$export$f8397d44f03ab6ad);
}
$622040121c71d41f$export$6f98e8eaf0be1996.propTypes = {};
$622040121c71d41f$export$6f98e8eaf0be1996.filterProps = $622040121c71d41f$export$f8397d44f03ab6ad;
function $622040121c71d41f$var$spacing(props) {
    return $622040121c71d41f$var$style(props, $622040121c71d41f$var$spacingKeys);
}
$622040121c71d41f$var$spacing.propTypes = {};
$622040121c71d41f$var$spacing.filterProps = $622040121c71d41f$var$spacingKeys;
var $622040121c71d41f$export$2e2bcd8739ae039 = $622040121c71d41f$var$spacing;

});
parcelRegister("iYYAo", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $dd1cd3b60615013e$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $dd1cd3b60615013e$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $dd1cd3b60615013e$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $dd1cd3b60615013e$export$8922c90b6e020726; });


var $7qwc9 = parcelRequire("7qwc9");

var $lj5cg = parcelRequire("lj5cg");

var $3HOx1 = parcelRequire("3HOx1");
const $dd1cd3b60615013e$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $dd1cd3b60615013e$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$dd1cd3b60615013e$export$68c286be0e7e55b7[key]}px)`
};
const $dd1cd3b60615013e$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $dd1cd3b60615013e$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $dd1cd3b60615013e$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $dd1cd3b60615013e$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $dd1cd3b60615013e$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $3HOx1.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $3HOx1.getContainerQuery)(theme.containerQueries ? theme : $dd1cd3b60615013e$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $dd1cd3b60615013e$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $dd1cd3b60615013e$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $dd1cd3b60615013e$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $lj5cg.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $dd1cd3b60615013e$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $dd1cd3b60615013e$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $dd1cd3b60615013e$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $dd1cd3b60615013e$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $7qwc9.default)(prev, next), {});
    return $dd1cd3b60615013e$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $dd1cd3b60615013e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $dd1cd3b60615013e$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $dd1cd3b60615013e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $dd1cd3b60615013e$export$2e2bcd8739ae039 = $dd1cd3b60615013e$var$breakpoints;

});
parcelRegister("lj5cg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f82f674c1df92037$export$2e2bcd8739ae039; });

var $7qwc9 = parcelRequire("7qwc9");
function $f82f674c1df92037$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $7qwc9.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $f82f674c1df92037$export$2e2bcd8739ae039 = $f82f674c1df92037$var$merge;

});


parcelRegister("4T0ON", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $38eceefc5e16a3cb$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $38eceefc5e16a3cb$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $38eceefc5e16a3cb$export$2e2bcd8739ae039; });

var $6PGAD = parcelRequire("6PGAD");


var $iYYAo = parcelRequire("iYYAo");
function $38eceefc5e16a3cb$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $38eceefc5e16a3cb$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $38eceefc5e16a3cb$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $38eceefc5e16a3cb$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $38eceefc5e16a3cb$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $38eceefc5e16a3cb$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $38eceefc5e16a3cb$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $6PGAD.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $iYYAo.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $38eceefc5e16a3cb$export$2e2bcd8739ae039 = $38eceefc5e16a3cb$var$style;

});

parcelRegister("kWThH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4041bc7a72e59fc$export$2e2bcd8739ae039; });
function $f4041bc7a72e59fc$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("gOseu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3d7374c749364c5$export$2e2bcd8739ae039; });

var $6PGAD = parcelRequire("6PGAD");

var $lj5cg = parcelRequire("lj5cg");

var $4T0ON = parcelRequire("4T0ON");

var $iYYAo = parcelRequire("iYYAo");

var $3HOx1 = parcelRequire("3HOx1");

var $fOrBY = parcelRequire("fOrBY");
function $c3d7374c749364c5$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $c3d7374c749364c5$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $c3d7374c749364c5$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $4T0ON.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $4T0ON.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $4T0ON.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $6PGAD.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $iYYAo.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $fOrBY.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $iYYAo.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $c3d7374c749364c5$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $lj5cg.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $iYYAo.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($c3d7374c749364c5$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $lj5cg.default)(css, breakpointsValues);
                        }
                    } else css = (0, $lj5cg.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $3HOx1.sortContainerQueries)(theme, (0, $iYYAo.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $c3d7374c749364c5$var$styleFunctionSx = $c3d7374c749364c5$export$7d53d8bf2911e013();
$c3d7374c749364c5$var$styleFunctionSx.filterProps = [
    'sx'
];
var $c3d7374c749364c5$export$2e2bcd8739ae039 = $c3d7374c749364c5$var$styleFunctionSx;

});
parcelRegister("fOrBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b830f1942ad0025b$export$2e2bcd8739ae039; });

var $8qjYP = parcelRequire("8qjYP");

var $gCCt7 = parcelRequire("gCCt7");

var $5NOGZ = parcelRequire("5NOGZ");

var $bI1cf = parcelRequire("bI1cf");

var $ksvpw = parcelRequire("ksvpw");
const $b830f1942ad0025b$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $gCCt7.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $gCCt7.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $gCCt7.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $gCCt7.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $gCCt7.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $gCCt7.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $gCCt7.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $bI1cf.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $bI1cf.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $bI1cf.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $8qjYP.padding)
    },
    pt: {
        style: (0, $8qjYP.padding)
    },
    pr: {
        style: (0, $8qjYP.padding)
    },
    pb: {
        style: (0, $8qjYP.padding)
    },
    pl: {
        style: (0, $8qjYP.padding)
    },
    px: {
        style: (0, $8qjYP.padding)
    },
    py: {
        style: (0, $8qjYP.padding)
    },
    padding: {
        style: (0, $8qjYP.padding)
    },
    paddingTop: {
        style: (0, $8qjYP.padding)
    },
    paddingRight: {
        style: (0, $8qjYP.padding)
    },
    paddingBottom: {
        style: (0, $8qjYP.padding)
    },
    paddingLeft: {
        style: (0, $8qjYP.padding)
    },
    paddingX: {
        style: (0, $8qjYP.padding)
    },
    paddingY: {
        style: (0, $8qjYP.padding)
    },
    paddingInline: {
        style: (0, $8qjYP.padding)
    },
    paddingInlineStart: {
        style: (0, $8qjYP.padding)
    },
    paddingInlineEnd: {
        style: (0, $8qjYP.padding)
    },
    paddingBlock: {
        style: (0, $8qjYP.padding)
    },
    paddingBlockStart: {
        style: (0, $8qjYP.padding)
    },
    paddingBlockEnd: {
        style: (0, $8qjYP.padding)
    },
    m: {
        style: (0, $8qjYP.margin)
    },
    mt: {
        style: (0, $8qjYP.margin)
    },
    mr: {
        style: (0, $8qjYP.margin)
    },
    mb: {
        style: (0, $8qjYP.margin)
    },
    ml: {
        style: (0, $8qjYP.margin)
    },
    mx: {
        style: (0, $8qjYP.margin)
    },
    my: {
        style: (0, $8qjYP.margin)
    },
    margin: {
        style: (0, $8qjYP.margin)
    },
    marginTop: {
        style: (0, $8qjYP.margin)
    },
    marginRight: {
        style: (0, $8qjYP.margin)
    },
    marginBottom: {
        style: (0, $8qjYP.margin)
    },
    marginLeft: {
        style: (0, $8qjYP.margin)
    },
    marginX: {
        style: (0, $8qjYP.margin)
    },
    marginY: {
        style: (0, $8qjYP.margin)
    },
    marginInline: {
        style: (0, $8qjYP.margin)
    },
    marginInlineStart: {
        style: (0, $8qjYP.margin)
    },
    marginInlineEnd: {
        style: (0, $8qjYP.margin)
    },
    marginBlock: {
        style: (0, $8qjYP.margin)
    },
    marginBlockStart: {
        style: (0, $8qjYP.margin)
    },
    marginBlockEnd: {
        style: (0, $8qjYP.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $5NOGZ.gap)
    },
    rowGap: {
        style: (0, $5NOGZ.rowGap)
    },
    columnGap: {
        style: (0, $5NOGZ.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $ksvpw.sizingTransform)
    },
    maxWidth: {
        style: (0, $ksvpw.maxWidth)
    },
    minWidth: {
        transform: (0, $ksvpw.sizingTransform)
    },
    height: {
        transform: (0, $ksvpw.sizingTransform)
    },
    maxHeight: {
        transform: (0, $ksvpw.sizingTransform)
    },
    minHeight: {
        transform: (0, $ksvpw.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $b830f1942ad0025b$export$2e2bcd8739ae039 = $b830f1942ad0025b$var$defaultSxConfig;

});
parcelRegister("gCCt7", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $c19e0906c556dbed$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $c19e0906c556dbed$export$7a57f79000377ca2; });


var $4T0ON = parcelRequire("4T0ON");

var $9BkEZ = parcelRequire("9BkEZ");

var $8qjYP = parcelRequire("8qjYP");

var $iYYAo = parcelRequire("iYYAo");
function $c19e0906c556dbed$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c19e0906c556dbed$var$createBorderStyle(prop, transform) {
    return (0, $4T0ON.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c19e0906c556dbed$export$1edee58a52776cd9 = $c19e0906c556dbed$var$createBorderStyle('border', $c19e0906c556dbed$export$34e2febe53ae29cc);
const $c19e0906c556dbed$export$f9a7b6bd24892946 = $c19e0906c556dbed$var$createBorderStyle('borderTop', $c19e0906c556dbed$export$34e2febe53ae29cc);
const $c19e0906c556dbed$export$5abca33e6be905d2 = $c19e0906c556dbed$var$createBorderStyle('borderRight', $c19e0906c556dbed$export$34e2febe53ae29cc);
const $c19e0906c556dbed$export$e2ce9f12a980a822 = $c19e0906c556dbed$var$createBorderStyle('borderBottom', $c19e0906c556dbed$export$34e2febe53ae29cc);
const $c19e0906c556dbed$export$47658cca1a909427 = $c19e0906c556dbed$var$createBorderStyle('borderLeft', $c19e0906c556dbed$export$34e2febe53ae29cc);
const $c19e0906c556dbed$export$e7fb0694ba2404fc = $c19e0906c556dbed$var$createBorderStyle('borderColor');
const $c19e0906c556dbed$export$126a92c968acdb85 = $c19e0906c556dbed$var$createBorderStyle('borderTopColor');
const $c19e0906c556dbed$export$85cc51cb8fbb8c0e = $c19e0906c556dbed$var$createBorderStyle('borderRightColor');
const $c19e0906c556dbed$export$340b0327727f6d1a = $c19e0906c556dbed$var$createBorderStyle('borderBottomColor');
const $c19e0906c556dbed$export$60beef91a985b4bf = $c19e0906c556dbed$var$createBorderStyle('borderLeftColor');
const $c19e0906c556dbed$export$f9258c55612cbed7 = $c19e0906c556dbed$var$createBorderStyle('outline', $c19e0906c556dbed$export$34e2febe53ae29cc);
const $c19e0906c556dbed$export$621fe586efeb64b9 = $c19e0906c556dbed$var$createBorderStyle('outlineColor');
const $c19e0906c556dbed$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8qjYP.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8qjYP.getValue)(transformer, propValue)
            });
        return (0, $iYYAo.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c19e0906c556dbed$export$7a57f79000377ca2.propTypes = {};
$c19e0906c556dbed$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c19e0906c556dbed$var$borders = (0, $9BkEZ.default)($c19e0906c556dbed$export$1edee58a52776cd9, $c19e0906c556dbed$export$f9a7b6bd24892946, $c19e0906c556dbed$export$5abca33e6be905d2, $c19e0906c556dbed$export$e2ce9f12a980a822, $c19e0906c556dbed$export$47658cca1a909427, $c19e0906c556dbed$export$e7fb0694ba2404fc, $c19e0906c556dbed$export$126a92c968acdb85, $c19e0906c556dbed$export$85cc51cb8fbb8c0e, $c19e0906c556dbed$export$340b0327727f6d1a, $c19e0906c556dbed$export$60beef91a985b4bf, $c19e0906c556dbed$export$7a57f79000377ca2, $c19e0906c556dbed$export$f9258c55612cbed7, $c19e0906c556dbed$export$621fe586efeb64b9);
var $c19e0906c556dbed$export$2e2bcd8739ae039 = $c19e0906c556dbed$var$borders;

});
parcelRegister("9BkEZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fd798733c804f06$export$2e2bcd8739ae039; });

var $lj5cg = parcelRequire("lj5cg");
function $6fd798733c804f06$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $lj5cg.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $6fd798733c804f06$export$2e2bcd8739ae039 = $6fd798733c804f06$var$compose;

});


parcelRegister("5NOGZ", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $4398d9cb9fc687e5$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $4398d9cb9fc687e5$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $4398d9cb9fc687e5$export$8a833ffa5f5dbeda; });

var $4T0ON = parcelRequire("4T0ON");

var $9BkEZ = parcelRequire("9BkEZ");

var $8qjYP = parcelRequire("8qjYP");

var $iYYAo = parcelRequire("iYYAo");

const $4398d9cb9fc687e5$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8qjYP.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8qjYP.getValue)(transformer, propValue)
            });
        return (0, $iYYAo.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$4398d9cb9fc687e5$export$5df9adcb0db95e1e.propTypes = {};
$4398d9cb9fc687e5$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $4398d9cb9fc687e5$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8qjYP.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8qjYP.getValue)(transformer, propValue)
            });
        return (0, $iYYAo.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$4398d9cb9fc687e5$export$ec60d70ff941a580.propTypes = {};
$4398d9cb9fc687e5$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $4398d9cb9fc687e5$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8qjYP.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8qjYP.getValue)(transformer, propValue)
            });
        return (0, $iYYAo.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$4398d9cb9fc687e5$export$8a833ffa5f5dbeda.propTypes = {};
$4398d9cb9fc687e5$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $4398d9cb9fc687e5$export$baf44164ca3a34e8 = (0, $4T0ON.default)({
    prop: 'gridColumn'
});
const $4398d9cb9fc687e5$export$8f7213a1cd01e832 = (0, $4T0ON.default)({
    prop: 'gridRow'
});
const $4398d9cb9fc687e5$export$b0e0abbc49ba668 = (0, $4T0ON.default)({
    prop: 'gridAutoFlow'
});
const $4398d9cb9fc687e5$export$bcd8b929d4b4142 = (0, $4T0ON.default)({
    prop: 'gridAutoColumns'
});
const $4398d9cb9fc687e5$export$e5039a674e14c828 = (0, $4T0ON.default)({
    prop: 'gridAutoRows'
});
const $4398d9cb9fc687e5$export$42bd9088661ffb03 = (0, $4T0ON.default)({
    prop: 'gridTemplateColumns'
});
const $4398d9cb9fc687e5$export$920682ae05b999bc = (0, $4T0ON.default)({
    prop: 'gridTemplateRows'
});
const $4398d9cb9fc687e5$export$1b88fbdd482fd33a = (0, $4T0ON.default)({
    prop: 'gridTemplateAreas'
});
const $4398d9cb9fc687e5$export$bdb486e40d52d26f = (0, $4T0ON.default)({
    prop: 'gridArea'
});
const $4398d9cb9fc687e5$var$grid = (0, $9BkEZ.default)($4398d9cb9fc687e5$export$5df9adcb0db95e1e, $4398d9cb9fc687e5$export$ec60d70ff941a580, $4398d9cb9fc687e5$export$8a833ffa5f5dbeda, $4398d9cb9fc687e5$export$baf44164ca3a34e8, $4398d9cb9fc687e5$export$8f7213a1cd01e832, $4398d9cb9fc687e5$export$b0e0abbc49ba668, $4398d9cb9fc687e5$export$bcd8b929d4b4142, $4398d9cb9fc687e5$export$e5039a674e14c828, $4398d9cb9fc687e5$export$42bd9088661ffb03, $4398d9cb9fc687e5$export$920682ae05b999bc, $4398d9cb9fc687e5$export$1b88fbdd482fd33a, $4398d9cb9fc687e5$export$bdb486e40d52d26f);
var $4398d9cb9fc687e5$export$2e2bcd8739ae039 = $4398d9cb9fc687e5$var$grid;

});

parcelRegister("bI1cf", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $8864bb5d61142c6d$export$dbaffd4420ea0ac6; });

var $4T0ON = parcelRequire("4T0ON");

var $9BkEZ = parcelRequire("9BkEZ");
function $8864bb5d61142c6d$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $8864bb5d61142c6d$export$35e9368ef982300f = (0, $4T0ON.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $8864bb5d61142c6d$export$dbaffd4420ea0ac6
});
const $8864bb5d61142c6d$export$2506f56c10355b33 = (0, $4T0ON.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $8864bb5d61142c6d$export$dbaffd4420ea0ac6
});
const $8864bb5d61142c6d$export$8c5a050822fd698c = (0, $4T0ON.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $8864bb5d61142c6d$export$dbaffd4420ea0ac6
});
const $8864bb5d61142c6d$var$palette = (0, $9BkEZ.default)($8864bb5d61142c6d$export$35e9368ef982300f, $8864bb5d61142c6d$export$2506f56c10355b33, $8864bb5d61142c6d$export$8c5a050822fd698c);
var $8864bb5d61142c6d$export$2e2bcd8739ae039 = $8864bb5d61142c6d$var$palette;

});

parcelRegister("ksvpw", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $ee4ec9aeccaf79cf$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $ee4ec9aeccaf79cf$export$488fda99655ff65a; });

var $4T0ON = parcelRequire("4T0ON");

var $9BkEZ = parcelRequire("9BkEZ");

var $iYYAo = parcelRequire("iYYAo");
function $ee4ec9aeccaf79cf$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $ee4ec9aeccaf79cf$export$7e3df82ee760448c = (0, $4T0ON.default)({
    prop: 'width',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $iYYAo.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $ee4ec9aeccaf79cf$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $iYYAo.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$ee4ec9aeccaf79cf$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $ee4ec9aeccaf79cf$export$ee148fbbe8357dd2 = (0, $4T0ON.default)({
    prop: 'minWidth',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$ac607276a8fe9f0a = (0, $4T0ON.default)({
    prop: 'height',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$dc0d8bd0b94f8570 = (0, $4T0ON.default)({
    prop: 'maxHeight',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$a43cf604e12f3b17 = (0, $4T0ON.default)({
    prop: 'minHeight',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$ffed9f14fb65e276 = (0, $4T0ON.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$905076ed6620e671 = (0, $4T0ON.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $ee4ec9aeccaf79cf$export$8afece71750ec241
});
const $ee4ec9aeccaf79cf$export$6ccc93f785106a58 = (0, $4T0ON.default)({
    prop: 'boxSizing'
});
const $ee4ec9aeccaf79cf$var$sizing = (0, $9BkEZ.default)($ee4ec9aeccaf79cf$export$7e3df82ee760448c, $ee4ec9aeccaf79cf$export$488fda99655ff65a, $ee4ec9aeccaf79cf$export$ee148fbbe8357dd2, $ee4ec9aeccaf79cf$export$ac607276a8fe9f0a, $ee4ec9aeccaf79cf$export$dc0d8bd0b94f8570, $ee4ec9aeccaf79cf$export$a43cf604e12f3b17, $ee4ec9aeccaf79cf$export$6ccc93f785106a58);
var $ee4ec9aeccaf79cf$export$2e2bcd8739ae039 = $ee4ec9aeccaf79cf$var$sizing;

});



parcelRegister("hvE8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf476dd7153b75b$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $cbf476dd7153b75b$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("6qvYg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4addf888eba63d0a$export$2e2bcd8739ae039; });

var $6TPZZ = parcelRequire("6TPZZ");
function $4addf888eba63d0a$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $6TPZZ.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $6TPZZ.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("4ZbsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a15c05764091003$export$2e2bcd8739ae039; });

var $92iwa = parcelRequire("92iwa");
'use client';
const $3a15c05764091003$var$defaultTheme = (0, $92iwa.default)();
var $3a15c05764091003$export$2e2bcd8739ae039 = $3a15c05764091003$var$defaultTheme;

});
parcelRegister("92iwa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6942aa33dfcea1b6$export$2e2bcd8739ae039; });

var $bWsTg = parcelRequire("bWsTg");

var $hPmpk = parcelRequire("hPmpk");

var $9tRah = parcelRequire("9tRah");
// eslint-disable-next-line consistent-return
function $6942aa33dfcea1b6$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $bWsTg.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $6942aa33dfcea1b6$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $9tRah.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $9tRah.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $6942aa33dfcea1b6$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $6942aa33dfcea1b6$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $hPmpk.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("bWsTg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b1b857e53d951ee$export$2e2bcd8739ae039; });

var $biW9R = parcelRequire("biW9R");

var $7qwc9 = parcelRequire("7qwc9");

var $dRIMW = parcelRequire("dRIMW");

var $bNwqO = parcelRequire("bNwqO");

var $1sVOg = parcelRequire("1sVOg");

var $19X7M = parcelRequire("19X7M");

var $5UBAX = parcelRequire("5UBAX");

var $dhrUx = parcelRequire("dhrUx");

var $6JVge = parcelRequire("6JVge");

var $f5nUc = parcelRequire("f5nUc");

var $bFuy8 = parcelRequire("bFuy8");
function $8b1b857e53d951ee$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $bNwqO.default).white,
            default: (0, $bNwqO.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $8b1b857e53d951ee$export$a43af521ac8c3202 = $8b1b857e53d951ee$var$getLight();
function $8b1b857e53d951ee$var$getDark() {
    return {
        text: {
            primary: (0, $bNwqO.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $bNwqO.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $8b1b857e53d951ee$export$55ce6f3a06c59543 = $8b1b857e53d951ee$var$getDark();
function $8b1b857e53d951ee$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $dRIMW.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $dRIMW.darken)(intent.main, tonalOffsetDark);
    }
}
function $8b1b857e53d951ee$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $6JVge.default)[200],
        light: (0, $6JVge.default)[50],
        dark: (0, $6JVge.default)[400]
    };
    return {
        main: (0, $6JVge.default)[700],
        light: (0, $6JVge.default)[400],
        dark: (0, $6JVge.default)[800]
    };
}
function $8b1b857e53d951ee$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $19X7M.default)[200],
        light: (0, $19X7M.default)[50],
        dark: (0, $19X7M.default)[400]
    };
    return {
        main: (0, $19X7M.default)[500],
        light: (0, $19X7M.default)[300],
        dark: (0, $19X7M.default)[700]
    };
}
function $8b1b857e53d951ee$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5UBAX.default)[500],
        light: (0, $5UBAX.default)[300],
        dark: (0, $5UBAX.default)[700]
    };
    return {
        main: (0, $5UBAX.default)[700],
        light: (0, $5UBAX.default)[400],
        dark: (0, $5UBAX.default)[800]
    };
}
function $8b1b857e53d951ee$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $f5nUc.default)[400],
        light: (0, $f5nUc.default)[300],
        dark: (0, $f5nUc.default)[700]
    };
    return {
        main: (0, $f5nUc.default)[700],
        light: (0, $f5nUc.default)[500],
        dark: (0, $f5nUc.default)[900]
    };
}
function $8b1b857e53d951ee$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bFuy8.default)[400],
        light: (0, $bFuy8.default)[300],
        dark: (0, $bFuy8.default)[700]
    };
    return {
        main: (0, $bFuy8.default)[800],
        light: (0, $bFuy8.default)[500],
        dark: (0, $bFuy8.default)[900]
    };
}
function $8b1b857e53d951ee$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dhrUx.default)[400],
        light: (0, $dhrUx.default)[300],
        dark: (0, $dhrUx.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dhrUx.default)[500],
        dark: (0, $dhrUx.default)[900]
    };
}
function $8b1b857e53d951ee$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $8b1b857e53d951ee$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $8b1b857e53d951ee$var$getDefaultSecondary(mode);
    const error = palette.error || $8b1b857e53d951ee$var$getDefaultError(mode);
    const info = palette.info || $8b1b857e53d951ee$var$getDefaultInfo(mode);
    const success = palette.success || $8b1b857e53d951ee$var$getDefaultSuccess(mode);
    const warning = palette.warning || $8b1b857e53d951ee$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $dRIMW.getContrastRatio)(background, $8b1b857e53d951ee$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $8b1b857e53d951ee$export$55ce6f3a06c59543.text.primary : $8b1b857e53d951ee$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $biW9R.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $biW9R.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $8b1b857e53d951ee$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $8b1b857e53d951ee$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $8b1b857e53d951ee$var$getLight();
    else if (mode === 'dark') modeHydrated = $8b1b857e53d951ee$var$getDark();
    const paletteOutput = (0, $7qwc9.default)({
        // A collection of common colors.
        common: {
            ...(0, $bNwqO.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $1sVOg.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("dRIMW", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", function () { return $a182f7a726228d2c$export$427365fc3db6fc5e; });
$parcel$export(module.exports, "hslToRgb", function () { return $a182f7a726228d2c$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getContrastRatio", function () { return $a182f7a726228d2c$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $a182f7a726228d2c$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "private_safeAlpha", function () { return $a182f7a726228d2c$export$34109543fc7f43f8; });
$parcel$export(module.exports, "darken", function () { return $a182f7a726228d2c$export$4b073707ff63303; });
$parcel$export(module.exports, "private_safeDarken", function () { return $a182f7a726228d2c$export$eaaef2dca3e9e512; });
$parcel$export(module.exports, "lighten", function () { return $a182f7a726228d2c$export$c0816ed86df316af; });
$parcel$export(module.exports, "private_safeLighten", function () { return $a182f7a726228d2c$export$aeeda94ef1d01275; });
$parcel$export(module.exports, "emphasize", function () { return $a182f7a726228d2c$export$e665714f76e581fd; });
$parcel$export(module.exports, "private_safeEmphasize", function () { return $a182f7a726228d2c$export$11bb74ba10c85505; });

var $biW9R = parcelRequire("biW9R");

var $h9hwn = parcelRequire("h9hwn");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $a182f7a726228d2c$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $h9hwn.default)(value, min, max);
}
function $a182f7a726228d2c$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $a182f7a726228d2c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $a182f7a726228d2c$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $a182f7a726228d2c$export$677b39864803984e($a182f7a726228d2c$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $biW9R.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $biW9R.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $a182f7a726228d2c$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $a182f7a726228d2c$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $a182f7a726228d2c$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $a182f7a726228d2c$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $a182f7a726228d2c$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $a182f7a726228d2c$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $a182f7a726228d2c$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$a182f7a726228d2c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $a182f7a726228d2c$export$29fb7152bd3f781a(color) {
    color = $a182f7a726228d2c$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $a182f7a726228d2c$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $a182f7a726228d2c$export$c852d90bf7403b62(color) {
    color = $a182f7a726228d2c$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $a182f7a726228d2c$export$677b39864803984e($a182f7a726228d2c$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $a182f7a726228d2c$export$d061e26956a60b0a(foreground, background) {
    const lumA = $a182f7a726228d2c$export$c852d90bf7403b62(foreground);
    const lumB = $a182f7a726228d2c$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $a182f7a726228d2c$export$58f0f39f63f3cf42(color, value) {
    color = $a182f7a726228d2c$export$677b39864803984e(color);
    value = $a182f7a726228d2c$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $a182f7a726228d2c$export$211a73f2b8c10ce4(color);
}
function $a182f7a726228d2c$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $a182f7a726228d2c$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $a182f7a726228d2c$export$4b073707ff63303(color, coefficient) {
    color = $a182f7a726228d2c$export$677b39864803984e(color);
    coefficient = $a182f7a726228d2c$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $a182f7a726228d2c$export$211a73f2b8c10ce4(color);
}
function $a182f7a726228d2c$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $a182f7a726228d2c$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $a182f7a726228d2c$export$c0816ed86df316af(color, coefficient) {
    color = $a182f7a726228d2c$export$677b39864803984e(color);
    coefficient = $a182f7a726228d2c$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $a182f7a726228d2c$export$211a73f2b8c10ce4(color);
}
function $a182f7a726228d2c$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $a182f7a726228d2c$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $a182f7a726228d2c$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $a182f7a726228d2c$export$c852d90bf7403b62(color) > 0.5 ? $a182f7a726228d2c$export$4b073707ff63303(color, coefficient) : $a182f7a726228d2c$export$c0816ed86df316af(color, coefficient);
}
function $a182f7a726228d2c$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $a182f7a726228d2c$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $a182f7a726228d2c$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $a182f7a726228d2c$export$677b39864803984e(background);
    const overlayColor = $a182f7a726228d2c$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $a182f7a726228d2c$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("h9hwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7c0de4bada53692$export$2e2bcd8739ae039; });
function $c7c0de4bada53692$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $c7c0de4bada53692$export$2e2bcd8739ae039 = $c7c0de4bada53692$var$clamp;

});


parcelRegister("bNwqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $896d6d8bfdf2a2d5$export$2e2bcd8739ae039; });
const $896d6d8bfdf2a2d5$var$common = {
    black: '#000',
    white: '#fff'
};
var $896d6d8bfdf2a2d5$export$2e2bcd8739ae039 = $896d6d8bfdf2a2d5$var$common;

});

parcelRegister("1sVOg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11153fcb08598ab1$export$2e2bcd8739ae039; });
const $11153fcb08598ab1$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $11153fcb08598ab1$export$2e2bcd8739ae039 = $11153fcb08598ab1$var$grey;

});

parcelRegister("19X7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d847e977e07192c$export$2e2bcd8739ae039; });
const $0d847e977e07192c$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $0d847e977e07192c$export$2e2bcd8739ae039 = $0d847e977e07192c$var$purple;

});

parcelRegister("5UBAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44df584b77bb578e$export$2e2bcd8739ae039; });
const $44df584b77bb578e$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $44df584b77bb578e$export$2e2bcd8739ae039 = $44df584b77bb578e$var$red;

});

parcelRegister("dhrUx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ab28367775e21bb$export$2e2bcd8739ae039; });
const $9ab28367775e21bb$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $9ab28367775e21bb$export$2e2bcd8739ae039 = $9ab28367775e21bb$var$orange;

});

parcelRegister("6JVge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e835cd4a1e05d96$export$2e2bcd8739ae039; });
const $4e835cd4a1e05d96$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $4e835cd4a1e05d96$export$2e2bcd8739ae039 = $4e835cd4a1e05d96$var$blue;

});

parcelRegister("f5nUc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afb9ddc9757b6f50$export$2e2bcd8739ae039; });
const $afb9ddc9757b6f50$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $afb9ddc9757b6f50$export$2e2bcd8739ae039 = $afb9ddc9757b6f50$var$lightBlue;

});

parcelRegister("bFuy8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87eb388b502bb59d$export$2e2bcd8739ae039; });
const $87eb388b502bb59d$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $87eb388b502bb59d$export$2e2bcd8739ae039 = $87eb388b502bb59d$var$green;

});


parcelRegister("hPmpk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfa894c619fa5906$export$2e2bcd8739ae039; });

var $biW9R = parcelRequire("biW9R");

var $7qwc9 = parcelRequire("7qwc9");

var $dF8K7 = parcelRequire("dF8K7");
var $fVug4 = parcelRequire("fVug4");

var $8qjYP = parcelRequire("8qjYP");

var $ic8lx = parcelRequire("ic8lx");
var $59gaQ = parcelRequire("59gaQ");
var $hFAWP = parcelRequire("hFAWP");

var $gOseu = parcelRequire("gOseu");
var $fOrBY = parcelRequire("fOrBY");

var $dRIMW = parcelRequire("dRIMW");

var $9tRah = parcelRequire("9tRah");

var $lDnsW = parcelRequire("lDnsW");

var $hqTgR = parcelRequire("hqTgR");

var $eLDld = parcelRequire("eLDld");

var $fl2My = parcelRequire("fl2My");
function $cfa894c619fa5906$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $cfa894c619fa5906$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $cfa894c619fa5906$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $dRIMW.hslToRgb)(color);
}
function $cfa894c619fa5906$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $dRIMW.private_safeColorChannel)($cfa894c619fa5906$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $cfa894c619fa5906$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $cfa894c619fa5906$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $cfa894c619fa5906$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $fVug4.default)(cssVarPrefix);
function $cfa894c619fa5906$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $lDnsW.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $9tRah.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $lDnsW.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $lDnsW.getOverlays)(mode)
    };
    return muiTheme;
}
function $cfa894c619fa5906$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $hqTgR.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $cfa894c619fa5906$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $biW9R.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $cfa894c619fa5906$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $cfa894c619fa5906$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $cfa894c619fa5906$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $hFAWP.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $cfa894c619fa5906$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $cfa894c619fa5906$var$setColor(palette.common, 'background', '#fff');
            $cfa894c619fa5906$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $cfa894c619fa5906$var$setColor(palette.common, 'background', '#000');
            $cfa894c619fa5906$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $cfa894c619fa5906$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorColor', (0, $dRIMW.private_safeDarken)(palette.error.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoColor', (0, $dRIMW.private_safeDarken)(palette.info.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successColor', (0, $dRIMW.private_safeDarken)(palette.success.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningColor', (0, $dRIMW.private_safeDarken)(palette.warning.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.error.main)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.info.main)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.success.main)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorStandardBg', (0, $dRIMW.private_safeLighten)(palette.error.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoStandardBg', (0, $dRIMW.private_safeLighten)(palette.info.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successStandardBg', (0, $dRIMW.private_safeLighten)(palette.success.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningStandardBg', (0, $dRIMW.private_safeLighten)(palette.warning.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $cfa894c619fa5906$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $cfa894c619fa5906$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $cfa894c619fa5906$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $cfa894c619fa5906$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $cfa894c619fa5906$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $cfa894c619fa5906$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $cfa894c619fa5906$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $cfa894c619fa5906$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $cfa894c619fa5906$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $cfa894c619fa5906$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'primaryBg', (0, $dRIMW.private_safeLighten)(palette.primary.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $dRIMW.private_safeLighten)(palette.secondary.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'errorBg', (0, $dRIMW.private_safeLighten)(palette.error.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'infoBg', (0, $dRIMW.private_safeLighten)(palette.info.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'successBg', (0, $dRIMW.private_safeLighten)(palette.success.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'warningBg', (0, $dRIMW.private_safeLighten)(palette.warning.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $cfa894c619fa5906$var$setColor(palette.Slider, 'primaryTrack', (0, $dRIMW.private_safeLighten)(palette.primary.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'secondaryTrack', (0, $dRIMW.private_safeLighten)(palette.secondary.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'errorTrack', (0, $dRIMW.private_safeLighten)(palette.error.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'infoTrack', (0, $dRIMW.private_safeLighten)(palette.info.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'successTrack', (0, $dRIMW.private_safeLighten)(palette.success.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'warningTrack', (0, $dRIMW.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $dRIMW.private_safeEmphasize)(palette.background.default, 0.8);
            $cfa894c619fa5906$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $cfa894c619fa5906$var$setColor(palette.SnackbarContent, 'color', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $cfa894c619fa5906$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $dRIMW.private_safeEmphasize)(palette.background.paper, 0.15));
            $cfa894c619fa5906$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $cfa894c619fa5906$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $dRIMW.private_safeLighten)(palette.primary.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $dRIMW.private_safeLighten)(palette.secondary.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'errorDisabledColor', (0, $dRIMW.private_safeLighten)(palette.error.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'infoDisabledColor', (0, $dRIMW.private_safeLighten)(palette.info.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'successDisabledColor', (0, $dRIMW.private_safeLighten)(palette.success.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'warningDisabledColor', (0, $dRIMW.private_safeLighten)(palette.warning.main, 0.62));
            $cfa894c619fa5906$var$setColor(palette.TableCell, 'border', (0, $dRIMW.private_safeLighten)((0, $dRIMW.private_safeAlpha)(palette.divider, 1), 0.88));
            $cfa894c619fa5906$var$setColor(palette.Tooltip, 'bg', (0, $dRIMW.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorColor', (0, $dRIMW.private_safeLighten)(palette.error.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoColor', (0, $dRIMW.private_safeLighten)(palette.info.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successColor', (0, $dRIMW.private_safeLighten)(palette.success.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningColor', (0, $dRIMW.private_safeLighten)(palette.warning.light, 0.6));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningFilledColor', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorStandardBg', (0, $dRIMW.private_safeDarken)(palette.error.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoStandardBg', (0, $dRIMW.private_safeDarken)(palette.info.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successStandardBg', (0, $dRIMW.private_safeDarken)(palette.success.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningStandardBg', (0, $dRIMW.private_safeDarken)(palette.warning.light, 0.9));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $cfa894c619fa5906$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $cfa894c619fa5906$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $cfa894c619fa5906$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $cfa894c619fa5906$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $cfa894c619fa5906$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $cfa894c619fa5906$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $cfa894c619fa5906$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $cfa894c619fa5906$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $cfa894c619fa5906$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $cfa894c619fa5906$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $cfa894c619fa5906$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $cfa894c619fa5906$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $cfa894c619fa5906$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'primaryBg', (0, $dRIMW.private_safeDarken)(palette.primary.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $dRIMW.private_safeDarken)(palette.secondary.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'errorBg', (0, $dRIMW.private_safeDarken)(palette.error.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'infoBg', (0, $dRIMW.private_safeDarken)(palette.info.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'successBg', (0, $dRIMW.private_safeDarken)(palette.success.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.LinearProgress, 'warningBg', (0, $dRIMW.private_safeDarken)(palette.warning.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $cfa894c619fa5906$var$setColor(palette.Slider, 'primaryTrack', (0, $dRIMW.private_safeDarken)(palette.primary.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'secondaryTrack', (0, $dRIMW.private_safeDarken)(palette.secondary.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'errorTrack', (0, $dRIMW.private_safeDarken)(palette.error.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'infoTrack', (0, $dRIMW.private_safeDarken)(palette.info.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'successTrack', (0, $dRIMW.private_safeDarken)(palette.success.main, 0.5));
            $cfa894c619fa5906$var$setColor(palette.Slider, 'warningTrack', (0, $dRIMW.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $dRIMW.private_safeEmphasize)(palette.background.default, 0.98);
            $cfa894c619fa5906$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $cfa894c619fa5906$var$setColor(palette.SnackbarContent, 'color', $cfa894c619fa5906$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $cfa894c619fa5906$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $dRIMW.private_safeEmphasize)(palette.background.paper, 0.15));
            $cfa894c619fa5906$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $cfa894c619fa5906$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $dRIMW.private_safeDarken)(palette.primary.main, 0.55));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $dRIMW.private_safeDarken)(palette.secondary.main, 0.55));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'errorDisabledColor', (0, $dRIMW.private_safeDarken)(palette.error.main, 0.55));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'infoDisabledColor', (0, $dRIMW.private_safeDarken)(palette.info.main, 0.55));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'successDisabledColor', (0, $dRIMW.private_safeDarken)(palette.success.main, 0.55));
            $cfa894c619fa5906$var$setColor(palette.Switch, 'warningDisabledColor', (0, $dRIMW.private_safeDarken)(palette.warning.main, 0.55));
            $cfa894c619fa5906$var$setColor(palette.TableCell, 'border', (0, $dRIMW.private_safeDarken)((0, $dRIMW.private_safeAlpha)(palette.divider, 1), 0.68));
            $cfa894c619fa5906$var$setColor(palette.Tooltip, 'bg', (0, $dRIMW.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $cfa894c619fa5906$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $cfa894c619fa5906$var$setColorChannel(palette.background, 'paper');
        $cfa894c619fa5906$var$setColorChannel(palette.common, 'background');
        $cfa894c619fa5906$var$setColorChannel(palette.common, 'onBackground');
        $cfa894c619fa5906$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $cfa894c619fa5906$var$setColor(palette[color], 'mainChannel', (0, $dRIMW.private_safeColorChannel)($cfa894c619fa5906$var$toRgb(colors.main)));
                if (colors.light) $cfa894c619fa5906$var$setColor(palette[color], 'lightChannel', (0, $dRIMW.private_safeColorChannel)($cfa894c619fa5906$var$toRgb(colors.light)));
                if (colors.dark) $cfa894c619fa5906$var$setColor(palette[color], 'darkChannel', (0, $dRIMW.private_safeColorChannel)($cfa894c619fa5906$var$toRgb(colors.dark)));
                if (colors.contrastText) $cfa894c619fa5906$var$setColor(palette[color], 'contrastTextChannel', (0, $dRIMW.private_safeColorChannel)($cfa894c619fa5906$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $cfa894c619fa5906$var$setColorChannel(palette[color], 'primary');
                    $cfa894c619fa5906$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $cfa894c619fa5906$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $cfa894c619fa5906$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $7qwc9.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $eLDld.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $59gaQ.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $dF8K7.default)(input.spacing, (0, $8qjYP.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $ic8lx.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $fOrBY.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $gOseu.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $fl2My.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fVug4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b983a68cdb89112a$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $b983a68cdb89112a$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("ic8lx", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", function () { return $d3efd263f7b25569$export$858538ff6c0d421d; });
/* eslint-disable import/prefer-default-export */ function $d3efd263f7b25569$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("59gaQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bfa56d26dd2ee2a$export$2e2bcd8739ae039; });

var $7qwc9 = parcelRequire("7qwc9");

var $iFuiy = parcelRequire("iFuiy");
function $3bfa56d26dd2ee2a$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $iFuiy.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $iFuiy.default)(scheme, parserConfig);
        themeVars = (0, $7qwc9.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $iFuiy.default)(defaultScheme, parserConfig);
        themeVars = (0, $7qwc9.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $7qwc9.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $3bfa56d26dd2ee2a$export$2e2bcd8739ae039 = $3bfa56d26dd2ee2a$var$prepareCssVars;

});
parcelRegister("iFuiy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9738eec31168b61$export$2e2bcd8739ae039; });
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $d9738eec31168b61$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $d9738eec31168b61$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $d9738eec31168b61$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $d9738eec31168b61$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $d9738eec31168b61$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $d9738eec31168b61$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $d9738eec31168b61$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $d9738eec31168b61$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("hFAWP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdd2ed153a2c2816$export$2e2bcd8739ae039; });
function $cdd2ed153a2c2816$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("9tRah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e700fe40e045b61$export$2e2bcd8739ae039; });

var $biW9R = parcelRequire("biW9R");

var $7qwc9 = parcelRequire("7qwc9");

var $gOseu = parcelRequire("gOseu");
var $fOrBY = parcelRequire("fOrBY");

var $lyfWf = parcelRequire("lyfWf");


var $5BJbH = parcelRequire("5BJbH");

var $bWsTg = parcelRequire("bWsTg");

var $gYayb = parcelRequire("gYayb");

var $dKJjb = parcelRequire("dKJjb");

var $3gKZ0 = parcelRequire("3gKZ0");

var $jUxNl = parcelRequire("jUxNl");

var $fl2My = parcelRequire("fl2My");
function $6e700fe40e045b61$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $biW9R.default)(20));
    const palette = (0, $bWsTg.default)(paletteInput);
    const systemTheme = (0, $lyfWf.default)(options);
    let muiTheme = (0, $7qwc9.default)(systemTheme, {
        mixins: (0, $5BJbH.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $dKJjb.default).slice(),
        typography: (0, $gYayb.default)(palette, typographyInput),
        transitions: (0, $3gKZ0.default)(transitionsInput),
        zIndex: {
            ...(0, $jUxNl.default)
        }
    });
    muiTheme = (0, $7qwc9.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $7qwc9.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $fOrBY.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $gOseu.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $fl2My.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $6e700fe40e045b61$var$warnedOnce = false;
function $6e700fe40e045b61$export$c469355549431d9b(...args) {
    return $6e700fe40e045b61$var$createThemeNoVars(...args);
}
var $6e700fe40e045b61$export$2e2bcd8739ae039 = $6e700fe40e045b61$var$createThemeNoVars;

});
parcelRegister("5BJbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $415375c59be0e249$export$2e2bcd8739ae039; });
function $415375c59be0e249$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("gYayb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5aa6f04ff7980a5$export$2e2bcd8739ae039; });

var $7qwc9 = parcelRequire("7qwc9");
function $c5aa6f04ff7980a5$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $c5aa6f04ff7980a5$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $c5aa6f04ff7980a5$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $c5aa6f04ff7980a5$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $c5aa6f04ff7980a5$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $c5aa6f04ff7980a5$var$defaultFontFamily ? {
                letterSpacing: `${$c5aa6f04ff7980a5$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $c5aa6f04ff7980a5$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $c5aa6f04ff7980a5$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $7qwc9.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("dKJjb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a032b78fa315a3e6$export$2e2bcd8739ae039; });
const $a032b78fa315a3e6$var$shadowKeyUmbraOpacity = 0.2;
const $a032b78fa315a3e6$var$shadowKeyPenumbraOpacity = 0.14;
const $a032b78fa315a3e6$var$shadowAmbientShadowOpacity = 0.12;
function $a032b78fa315a3e6$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$a032b78fa315a3e6$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$a032b78fa315a3e6$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$a032b78fa315a3e6$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $a032b78fa315a3e6$var$shadows = [
    'none',
    $a032b78fa315a3e6$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $a032b78fa315a3e6$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $a032b78fa315a3e6$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $a032b78fa315a3e6$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $a032b78fa315a3e6$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $a032b78fa315a3e6$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $a032b78fa315a3e6$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $a032b78fa315a3e6$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $a032b78fa315a3e6$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $a032b78fa315a3e6$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $a032b78fa315a3e6$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $a032b78fa315a3e6$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $a032b78fa315a3e6$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $a032b78fa315a3e6$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $a032b78fa315a3e6$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $a032b78fa315a3e6$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $a032b78fa315a3e6$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $a032b78fa315a3e6$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $a032b78fa315a3e6$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $a032b78fa315a3e6$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $a032b78fa315a3e6$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $a032b78fa315a3e6$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $a032b78fa315a3e6$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $a032b78fa315a3e6$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $a032b78fa315a3e6$export$2e2bcd8739ae039 = $a032b78fa315a3e6$var$shadows;

});

parcelRegister("3gKZ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26174f8dca0883ed$export$2e2bcd8739ae039; });
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $26174f8dca0883ed$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $26174f8dca0883ed$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $26174f8dca0883ed$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $26174f8dca0883ed$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $26174f8dca0883ed$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$26174f8dca0883ed$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$26174f8dca0883ed$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $26174f8dca0883ed$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $26174f8dca0883ed$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $26174f8dca0883ed$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("jUxNl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7ed76424ba941f9$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $e7ed76424ba941f9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $e7ed76424ba941f9$export$2e2bcd8739ae039 = $e7ed76424ba941f9$var$zIndex;

});

parcelRegister("fl2My", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", function () { return $b2aaf9aa74b7cbfc$export$32c2afa5f91892aa; });
/* eslint-disable import/prefer-default-export */ 
var $7qwc9 = parcelRequire("7qwc9");
function $b2aaf9aa74b7cbfc$var$isSerializable(val) {
    return (0, $7qwc9.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $b2aaf9aa74b7cbfc$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$b2aaf9aa74b7cbfc$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $7qwc9.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("lDnsW", function(module, exports) {

$parcel$export(module.exports, "getOpacity", function () { return $fbff714efb45fbad$export$c85e0347fceb69ba; });
$parcel$export(module.exports, "getOverlays", function () { return $fbff714efb45fbad$export$dd191566510330d3; });
$parcel$export(module.exports, "default", function () { return $fbff714efb45fbad$export$2e2bcd8739ae039; });

var $bWsTg = parcelRequire("bWsTg");

var $18Oap = parcelRequire("18Oap");
const $fbff714efb45fbad$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $18Oap.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $fbff714efb45fbad$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $fbff714efb45fbad$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $fbff714efb45fbad$var$defaultDarkOverlays : [];
}
function $fbff714efb45fbad$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $bWsTg.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$fbff714efb45fbad$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $fbff714efb45fbad$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("18Oap", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d4d73ebbfd480ad$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $0d4d73ebbfd480ad$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("hqTgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0fbd055a990dbd$export$2e2bcd8739ae039; });
function $cb0fbd055a990dbd$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("eLDld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac03f8d0ec496e3d$export$2e2bcd8739ae039; });

var $fbkiv = parcelRequire("fbkiv");
var $ac03f8d0ec496e3d$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $fbkiv.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("fbkiv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d7a0bdb6d24aa6$export$2e2bcd8739ae039; });
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $b0d7a0bdb6d24aa6$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $b0d7a0bdb6d24aa6$export$2e2bcd8739ae039 = $b0d7a0bdb6d24aa6$var$excludeVariablesFromRoot;

});





parcelRegister("lRoul", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fea18b1759d6a1d9$export$2e2bcd8739ae039; });
var $fea18b1759d6a1d9$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Yw6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688cd60be7ef69fb$export$2e2bcd8739ae039; });

var $9o0F5 = parcelRequire("9o0F5");
const $688cd60be7ef69fb$var$rootShouldForwardProp = (prop)=>(0, $9o0F5.default)(prop) && prop !== 'classes';
var $688cd60be7ef69fb$export$2e2bcd8739ae039 = $688cd60be7ef69fb$var$rootShouldForwardProp;

});
parcelRegister("9o0F5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d56de538bad3180$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $6d56de538bad3180$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $6d56de538bad3180$export$2e2bcd8739ae039 = $6d56de538bad3180$var$slotShouldForwardProp;

});



parcelRegister("7KgDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a39bc50f53ac7c4$export$2e2bcd8739ae039; });

var $cXEHk = parcelRequire("cXEHk");
const $5a39bc50f53ac7c4$var$memoTheme = (0, $cXEHk.default);
var $5a39bc50f53ac7c4$export$2e2bcd8739ae039 = $5a39bc50f53ac7c4$var$memoTheme;

});
parcelRegister("cXEHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96fa9073588a5fd6$export$2e2bcd8739ae039; });

var $6qvYg = parcelRequire("6qvYg");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $96fa9073588a5fd6$var$arg = {
    theme: undefined
};
function $96fa9073588a5fd6$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $96fa9073588a5fd6$var$arg.theme = props.theme;
            value = (0, $6qvYg.default)(styleFn($96fa9073588a5fd6$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("6r1xF", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $4af675ee6a6e6ae1$export$2440da353cedad43; });
parcelRequire("lVd4O");


var $cFHFa = parcelRequire("cFHFa");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $4af675ee6a6e6ae1$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cFHFa.default), {
        ...props
    });
}
var $4af675ee6a6e6ae1$export$2e2bcd8739ae039 = $4af675ee6a6e6ae1$var$DefaultPropsProvider;
function $4af675ee6a6e6ae1$export$2440da353cedad43(params) {
    return (0, $cFHFa.useDefaultProps)(params);
}

});
parcelRegister("cFHFa", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $939b2eebf4160936$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $939b2eebf4160936$export$2e2bcd8739ae039; });

var $lVd4O = parcelRequire("lVd4O");


var $cbgVL = parcelRequire("cbgVL");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $939b2eebf4160936$var$PropsContext = /*#__PURE__*/ $lVd4O.createContext(undefined);
function $939b2eebf4160936$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $iO5o7.jsx)($939b2eebf4160936$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $939b2eebf4160936$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $cbgVL.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $cbgVL.default)(config, props);
    return props;
}
function $939b2eebf4160936$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $lVd4O.useContext($939b2eebf4160936$var$PropsContext);
    return $939b2eebf4160936$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $939b2eebf4160936$export$2e2bcd8739ae039 = $939b2eebf4160936$var$DefaultPropsProvider;

});
parcelRegister("cbgVL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de3a5370342bd21$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $8de3a5370342bd21$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $8de3a5370342bd21$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("eJnIG", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $ab97aaea692a1f50$export$c7c50641356bdfa5; });

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $ab97aaea692a1f50$export$c7c50641356bdfa5(slot) {
    return (0, $bYZd6.default)('MuiSvgIcon', slot);
}
const $ab97aaea692a1f50$var$svgIconClasses = (0, $eaNcJ.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $ab97aaea692a1f50$export$2e2bcd8739ae039 = $ab97aaea692a1f50$var$svgIconClasses;

});
parcelRegister("eaNcJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5182ad6214032b3$export$2e2bcd8739ae039; });

var $bYZd6 = parcelRequire("bYZd6");
function $a5182ad6214032b3$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $bYZd6.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("bYZd6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b94c76112aa548c$export$2e2bcd8739ae039; });

var $gUVSy = parcelRequire("gUVSy");
const $8b94c76112aa548c$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $8b94c76112aa548c$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $8b94c76112aa548c$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $gUVSy.default).generate(componentName)}-${slot}`;
}
function $8b94c76112aa548c$export$34c0130b1f3e8ae3(slot) {
    return $8b94c76112aa548c$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("gUVSy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50ec5da48c2bf64$export$2e2bcd8739ae039; });
const $c50ec5da48c2bf64$var$defaultGenerator = (componentName)=>componentName;
const $c50ec5da48c2bf64$var$createClassNameGenerator = ()=>{
    let generate = $c50ec5da48c2bf64$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c50ec5da48c2bf64$var$defaultGenerator;
        }
    };
};
const $c50ec5da48c2bf64$var$ClassNameGenerator = $c50ec5da48c2bf64$var$createClassNameGenerator();
var $c50ec5da48c2bf64$export$2e2bcd8739ae039 = $c50ec5da48c2bf64$var$ClassNameGenerator;

});







var $087b485a4eb79be9$exports = {};
$parcel$extendImportMap({
    "3aVcS": "fuse-icon.e0b5cef2.png",
    "cD1uO": "logo-white.2af6379c.png",
    "7Ktu7": "fuse-logo-2.bba6a192.png",
    "c9OGt": "loan_white.4c1efefc.png",
    "cXfVm": "loan.0ac211f1.png"
});


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");
var $37cfaa3aa237e105$exports = {};

$parcel$export($37cfaa3aa237e105$exports, "createRoot", function () { return $37cfaa3aa237e105$export$882461b6382ed46c; }, function (v) { return $37cfaa3aa237e105$export$882461b6382ed46c = v; });
$parcel$export($37cfaa3aa237e105$exports, "hydrateRoot", function () { return $37cfaa3aa237e105$export$757ceba2d55c277e; }, function (v) { return $37cfaa3aa237e105$export$757ceba2d55c277e = v; });
var $37cfaa3aa237e105$export$882461b6382ed46c;
var $37cfaa3aa237e105$export$757ceba2d55c277e;
'use strict';
var $096c782a4047fe48$exports = {};
'use strict';
function $096c782a4047fe48$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($096c782a4047fe48$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$096c782a4047fe48$var$checkDCE();

$096c782a4047fe48$exports = (parcelRequire("6nd29"));


var $37cfaa3aa237e105$var$i;
$37cfaa3aa237e105$export$882461b6382ed46c = $096c782a4047fe48$exports.createRoot;
$37cfaa3aa237e105$export$757ceba2d55c277e = $096c782a4047fe48$exports.hydrateRoot;


/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lVd4O = parcelRequire("lVd4O");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b25d08d99320e805$var$_extends() {
    $b25d08d99320e805$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b25d08d99320e805$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b25d08d99320e805$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b25d08d99320e805$export$e19cd5f9376f8cee || ($b25d08d99320e805$export$e19cd5f9376f8cee = {}));
const $b25d08d99320e805$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b25d08d99320e805$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b25d08d99320e805$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b25d08d99320e805$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b25d08d99320e805$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b25d08d99320e805$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b25d08d99320e805$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b25d08d99320e805$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b25d08d99320e805$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b25d08d99320e805$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b25d08d99320e805$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b25d08d99320e805$export$fe53371bee54353d(to);
    }
    return $b25d08d99320e805$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b25d08d99320e805$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b25d08d99320e805$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b25d08d99320e805$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b25d08d99320e805$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b25d08d99320e805$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b25d08d99320e805$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b25d08d99320e805$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b25d08d99320e805$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b25d08d99320e805$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b25d08d99320e805$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b25d08d99320e805$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b25d08d99320e805$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b25d08d99320e805$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b25d08d99320e805$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b25d08d99320e805$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b25d08d99320e805$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b25d08d99320e805$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b25d08d99320e805$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b25d08d99320e805$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b25d08d99320e805$export$e19cd5f9376f8cee.Push;
        let location = $b25d08d99320e805$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b25d08d99320e805$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b25d08d99320e805$export$e19cd5f9376f8cee.Replace;
        let location = $b25d08d99320e805$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b25d08d99320e805$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b25d08d99320e805$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $b25d08d99320e805$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b25d08d99320e805$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b25d08d99320e805$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b25d08d99320e805$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b25d08d99320e805$var$ResultType || ($b25d08d99320e805$var$ResultType = {}));
const $b25d08d99320e805$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b25d08d99320e805$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b25d08d99320e805$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b25d08d99320e805$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b25d08d99320e805$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($b25d08d99320e805$var$isIndexRoute(route)) {
            let indexRoute = $b25d08d99320e805$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b25d08d99320e805$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b25d08d99320e805$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $b25d08d99320e805$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $b25d08d99320e805$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $b25d08d99320e805$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b25d08d99320e805$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b25d08d99320e805$var$flattenRoutes(routes);
    $b25d08d99320e805$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $b25d08d99320e805$export$30d21fd6d7295f52(pathname);
        matches = $b25d08d99320e805$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $b25d08d99320e805$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b25d08d99320e805$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b25d08d99320e805$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b25d08d99320e805$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b25d08d99320e805$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $b25d08d99320e805$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b25d08d99320e805$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b25d08d99320e805$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b25d08d99320e805$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b25d08d99320e805$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b25d08d99320e805$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b25d08d99320e805$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b25d08d99320e805$var$paramRe = /^:[\w-]+$/;
const $b25d08d99320e805$var$dynamicSegmentValue = 3;
const $b25d08d99320e805$var$indexRouteValue = 2;
const $b25d08d99320e805$var$emptySegmentValue = 1;
const $b25d08d99320e805$var$staticSegmentValue = 10;
const $b25d08d99320e805$var$splatPenalty = -2;
const $b25d08d99320e805$var$isSplat = (s)=>s === "*";
function $b25d08d99320e805$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b25d08d99320e805$var$isSplat)) initialScore += $b25d08d99320e805$var$splatPenalty;
    if (index) initialScore += $b25d08d99320e805$var$indexRouteValue;
    return segments.filter((s)=>!$b25d08d99320e805$var$isSplat(s)).reduce((score, segment)=>score + ($b25d08d99320e805$var$paramRe.test(segment) ? $b25d08d99320e805$var$dynamicSegmentValue : segment === "" ? $b25d08d99320e805$var$emptySegmentValue : $b25d08d99320e805$var$staticSegmentValue), initialScore);
}
function $b25d08d99320e805$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b25d08d99320e805$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b25d08d99320e805$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b25d08d99320e805$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b25d08d99320e805$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b25d08d99320e805$export$a5c6d149b50c1d86($b25d08d99320e805$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b25d08d99320e805$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $b25d08d99320e805$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b25d08d99320e805$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b25d08d99320e805$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $b25d08d99320e805$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b25d08d99320e805$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b25d08d99320e805$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b25d08d99320e805$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b25d08d99320e805$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b25d08d99320e805$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b25d08d99320e805$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $b25d08d99320e805$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b25d08d99320e805$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b25d08d99320e805$var$normalizeSearch(search),
        hash: $b25d08d99320e805$var$normalizeHash(hash)
    };
}
function $b25d08d99320e805$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b25d08d99320e805$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b25d08d99320e805$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b25d08d99320e805$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b25d08d99320e805$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b25d08d99320e805$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b25d08d99320e805$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b25d08d99320e805$var$_extends({}, toArg);
        $b25d08d99320e805$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b25d08d99320e805$var$getInvalidPathError("?", "pathname", "search", to));
        $b25d08d99320e805$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b25d08d99320e805$var$getInvalidPathError("#", "pathname", "hash", to));
        $b25d08d99320e805$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b25d08d99320e805$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b25d08d99320e805$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b25d08d99320e805$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b25d08d99320e805$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b25d08d99320e805$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b25d08d99320e805$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b25d08d99320e805$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $b25d08d99320e805$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b25d08d99320e805$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b25d08d99320e805$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $b25d08d99320e805$export$4051a07651545597(data, init) {
    return new $b25d08d99320e805$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $b25d08d99320e805$export$42a99a7a4bc0e76a extends Error {
}
class $b25d08d99320e805$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b25d08d99320e805$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b25d08d99320e805$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b25d08d99320e805$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b25d08d99320e805$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b25d08d99320e805$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b25d08d99320e805$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b25d08d99320e805$var$unwrapTrackedPromise(value) {
    if (!$b25d08d99320e805$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $b25d08d99320e805$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b25d08d99320e805$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b25d08d99320e805$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b25d08d99320e805$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b25d08d99320e805$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b25d08d99320e805$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b25d08d99320e805$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b25d08d99320e805$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b25d08d99320e805$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b25d08d99320e805$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b25d08d99320e805$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b25d08d99320e805$var$validMutationMethods = new Set($b25d08d99320e805$var$validMutationMethodsArr);
const $b25d08d99320e805$var$validRequestMethodsArr = [
    "get",
    ...$b25d08d99320e805$var$validMutationMethodsArr
];
const $b25d08d99320e805$var$validRequestMethods = new Set($b25d08d99320e805$var$validRequestMethodsArr);
const $b25d08d99320e805$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b25d08d99320e805$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b25d08d99320e805$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b25d08d99320e805$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b25d08d99320e805$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b25d08d99320e805$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b25d08d99320e805$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b25d08d99320e805$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b25d08d99320e805$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b25d08d99320e805$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b25d08d99320e805$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b25d08d99320e805$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $b25d08d99320e805$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $b25d08d99320e805$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b25d08d99320e805$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b25d08d99320e805$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b25d08d99320e805$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$b25d08d99320e805$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$b25d08d99320e805$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b25d08d99320e805$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b25d08d99320e805$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $b25d08d99320e805$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b25d08d99320e805$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b25d08d99320e805$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b25d08d99320e805$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b25d08d99320e805$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b25d08d99320e805$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b25d08d99320e805$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b25d08d99320e805$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b25d08d99320e805$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b25d08d99320e805$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b25d08d99320e805$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b25d08d99320e805$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b25d08d99320e805$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b25d08d99320e805$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b25d08d99320e805$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b25d08d99320e805$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b25d08d99320e805$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b25d08d99320e805$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b25d08d99320e805$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b25d08d99320e805$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b25d08d99320e805$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b25d08d99320e805$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b25d08d99320e805$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b25d08d99320e805$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b25d08d99320e805$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b25d08d99320e805$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $b25d08d99320e805$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $b25d08d99320e805$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b25d08d99320e805$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b25d08d99320e805$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $b25d08d99320e805$var$findNearestBoundary(matches).route.id,
            {
                type: $b25d08d99320e805$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b25d08d99320e805$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b25d08d99320e805$var$isErrorResult(result) && $b25d08d99320e805$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b25d08d99320e805$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $b25d08d99320e805$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b25d08d99320e805$var$_extends({
            matches: updatedMatches || matches
        }, $b25d08d99320e805$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b25d08d99320e805$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b25d08d99320e805$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $b25d08d99320e805$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $b25d08d99320e805$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $b25d08d99320e805$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b25d08d99320e805$var$ResultType.error,
            error: $b25d08d99320e805$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b25d08d99320e805$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $b25d08d99320e805$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b25d08d99320e805$var$isDeferredResult(result)) throw $b25d08d99320e805$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($b25d08d99320e805$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b25d08d99320e805$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $b25d08d99320e805$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b25d08d99320e805$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b25d08d99320e805$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($b25d08d99320e805$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $b25d08d99320e805$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b25d08d99320e805$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b25d08d99320e805$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b25d08d99320e805$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $b25d08d99320e805$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b25d08d99320e805$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $b25d08d99320e805$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b25d08d99320e805$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $b25d08d99320e805$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b25d08d99320e805$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b25d08d99320e805$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $b25d08d99320e805$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b25d08d99320e805$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b25d08d99320e805$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b25d08d99320e805$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b25d08d99320e805$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b25d08d99320e805$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b25d08d99320e805$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $b25d08d99320e805$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b25d08d99320e805$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b25d08d99320e805$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b25d08d99320e805$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $b25d08d99320e805$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b25d08d99320e805$var$isRedirectResult(actionResult) || $b25d08d99320e805$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b25d08d99320e805$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b25d08d99320e805$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b25d08d99320e805$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b25d08d99320e805$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b25d08d99320e805$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b25d08d99320e805$var$isDeferredResult(actionResult)) throw $b25d08d99320e805$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b25d08d99320e805$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b25d08d99320e805$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b25d08d99320e805$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b25d08d99320e805$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b25d08d99320e805$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b25d08d99320e805$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b25d08d99320e805$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $b25d08d99320e805$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b25d08d99320e805$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b25d08d99320e805$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b25d08d99320e805$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b25d08d99320e805$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b25d08d99320e805$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b25d08d99320e805$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b25d08d99320e805$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $b25d08d99320e805$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b25d08d99320e805$var$isDeferredResult(result)) result = await $b25d08d99320e805$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b25d08d99320e805$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b25d08d99320e805$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b25d08d99320e805$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b25d08d99320e805$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b25d08d99320e805$export$3e9cee6b33872309(!$b25d08d99320e805$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b25d08d99320e805$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $b25d08d99320e805$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $b25d08d99320e805$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $b25d08d99320e805$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b25d08d99320e805$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b25d08d99320e805$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $b25d08d99320e805$export$e19cd5f9376f8cee.Replace : $b25d08d99320e805$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b25d08d99320e805$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b25d08d99320e805$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $b25d08d99320e805$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b25d08d99320e805$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b25d08d99320e805$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $b25d08d99320e805$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $b25d08d99320e805$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($b25d08d99320e805$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $b25d08d99320e805$var$ResultType.redirect,
                response: $b25d08d99320e805$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $b25d08d99320e805$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $b25d08d99320e805$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $b25d08d99320e805$var$ResultType.error,
                    error: $b25d08d99320e805$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $b25d08d99320e805$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $b25d08d99320e805$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b25d08d99320e805$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $b25d08d99320e805$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b25d08d99320e805$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b25d08d99320e805$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b25d08d99320e805$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b25d08d99320e805$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b25d08d99320e805$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b25d08d99320e805$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b25d08d99320e805$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b25d08d99320e805$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $b25d08d99320e805$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b25d08d99320e805$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b25d08d99320e805$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $b25d08d99320e805$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $b25d08d99320e805$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $b25d08d99320e805$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $b25d08d99320e805$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $b25d08d99320e805$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b25d08d99320e805$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $b25d08d99320e805$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b25d08d99320e805$export$4d0306f8f6a4585b = Symbol("deferred");
function $b25d08d99320e805$export$3336b097a6fbc59a(routes, opts) {
    $b25d08d99320e805$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b25d08d99320e805$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b25d08d99320e805$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $b25d08d99320e805$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b25d08d99320e805$var$createLocation("", $b25d08d99320e805$export$fe53371bee54353d(url), null, "default");
        let matches = $b25d08d99320e805$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b25d08d99320e805$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b25d08d99320e805$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b25d08d99320e805$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b25d08d99320e805$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b25d08d99320e805$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($b25d08d99320e805$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b25d08d99320e805$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b25d08d99320e805$var$createLocation("", $b25d08d99320e805$export$fe53371bee54353d(url), null, "default");
        let matches = $b25d08d99320e805$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b25d08d99320e805$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b25d08d99320e805$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b25d08d99320e805$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b25d08d99320e805$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b25d08d99320e805$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b25d08d99320e805$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($b25d08d99320e805$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b25d08d99320e805$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $b25d08d99320e805$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b25d08d99320e805$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b25d08d99320e805$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $b25d08d99320e805$var$isResponse(result) ? result : $b25d08d99320e805$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($b25d08d99320e805$var$isDataStrategyResult(e) && $b25d08d99320e805$var$isResponse(e.result)) {
                if (e.type === $b25d08d99320e805$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b25d08d99320e805$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b25d08d99320e805$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b25d08d99320e805$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $b25d08d99320e805$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($b25d08d99320e805$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($b25d08d99320e805$var$isDeferredResult(result)) {
            let error = $b25d08d99320e805$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b25d08d99320e805$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b25d08d99320e805$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b25d08d99320e805$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b25d08d99320e805$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $b25d08d99320e805$var$_extends({}, context, {
                statusCode: $b25d08d99320e805$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $b25d08d99320e805$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $b25d08d99320e805$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b25d08d99320e805$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $b25d08d99320e805$var$isErrorResult(pendingActionResult[1]) ? $b25d08d99320e805$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $b25d08d99320e805$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $b25d08d99320e805$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b25d08d99320e805$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b25d08d99320e805$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $b25d08d99320e805$var$callDataStrategyImpl(dataStrategy || $b25d08d99320e805$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($b25d08d99320e805$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $b25d08d99320e805$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($b25d08d99320e805$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $b25d08d99320e805$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b25d08d99320e805$export$fec11da027c70692(routes, context, error) {
    let newContext = $b25d08d99320e805$var$_extends({}, context, {
        statusCode: $b25d08d99320e805$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b25d08d99320e805$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $b25d08d99320e805$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b25d08d99320e805$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b25d08d99320e805$export$cae722b0cc860f13(to ? to : ".", $b25d08d99320e805$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b25d08d99320e805$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $b25d08d99320e805$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b25d08d99320e805$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b25d08d99320e805$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b25d08d99320e805$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b25d08d99320e805$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b25d08d99320e805$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b25d08d99320e805$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b25d08d99320e805$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b25d08d99320e805$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b25d08d99320e805$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b25d08d99320e805$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b25d08d99320e805$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b25d08d99320e805$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b25d08d99320e805$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b25d08d99320e805$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b25d08d99320e805$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b25d08d99320e805$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b25d08d99320e805$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b25d08d99320e805$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b25d08d99320e805$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $b25d08d99320e805$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $b25d08d99320e805$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $b25d08d99320e805$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $b25d08d99320e805$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $b25d08d99320e805$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $b25d08d99320e805$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $b25d08d99320e805$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($b25d08d99320e805$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b25d08d99320e805$var$shouldRevalidateLoader(match, $b25d08d99320e805$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b25d08d99320e805$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b25d08d99320e805$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b25d08d99320e805$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b25d08d99320e805$var$shouldRevalidateLoader(fetcherMatch, $b25d08d99320e805$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b25d08d99320e805$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $b25d08d99320e805$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b25d08d99320e805$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b25d08d99320e805$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $b25d08d99320e805$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $b25d08d99320e805$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$b25d08d99320e805$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $b25d08d99320e805$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $b25d08d99320e805$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$b25d08d99320e805$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b25d08d99320e805$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b25d08d99320e805$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b25d08d99320e805$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$b25d08d99320e805$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b25d08d99320e805$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $b25d08d99320e805$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $b25d08d99320e805$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $b25d08d99320e805$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $b25d08d99320e805$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $b25d08d99320e805$var$ResultType.data,
                result: undefined
            });
        };
        return $b25d08d99320e805$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $b25d08d99320e805$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b25d08d99320e805$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b25d08d99320e805$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b25d08d99320e805$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b25d08d99320e805$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $b25d08d99320e805$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b25d08d99320e805$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($b25d08d99320e805$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b25d08d99320e805$var$ResultType.error,
                error: e
            };
        }
        if (type === $b25d08d99320e805$var$ResultType.error) return {
            type: $b25d08d99320e805$var$ResultType.error,
            error: new $b25d08d99320e805$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $b25d08d99320e805$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $b25d08d99320e805$var$ResultType.error) {
        if ($b25d08d99320e805$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $b25d08d99320e805$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $b25d08d99320e805$var$ResultType.error,
                error: new $b25d08d99320e805$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $b25d08d99320e805$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $b25d08d99320e805$var$ResultType.error,
            error: result,
            statusCode: $b25d08d99320e805$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($b25d08d99320e805$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $b25d08d99320e805$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($b25d08d99320e805$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $b25d08d99320e805$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $b25d08d99320e805$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $b25d08d99320e805$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $b25d08d99320e805$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b25d08d99320e805$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b25d08d99320e805$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $b25d08d99320e805$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($b25d08d99320e805$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $b25d08d99320e805$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b25d08d99320e805$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b25d08d99320e805$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b25d08d99320e805$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b25d08d99320e805$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b25d08d99320e805$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b25d08d99320e805$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b25d08d99320e805$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b25d08d99320e805$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $b25d08d99320e805$export$3e9cee6b33872309(!$b25d08d99320e805$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b25d08d99320e805$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $b25d08d99320e805$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b25d08d99320e805$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($b25d08d99320e805$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b25d08d99320e805$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b25d08d99320e805$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $b25d08d99320e805$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($b25d08d99320e805$var$isErrorResult(result)) {
            let boundaryMatch = $b25d08d99320e805$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b25d08d99320e805$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b25d08d99320e805$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b25d08d99320e805$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b25d08d99320e805$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b25d08d99320e805$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b25d08d99320e805$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b25d08d99320e805$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b25d08d99320e805$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b25d08d99320e805$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b25d08d99320e805$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b25d08d99320e805$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b25d08d99320e805$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b25d08d99320e805$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $b25d08d99320e805$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b25d08d99320e805$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($b25d08d99320e805$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $b25d08d99320e805$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(path) : path;
    return $b25d08d99320e805$export$fe53371bee54353d($b25d08d99320e805$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b25d08d99320e805$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b25d08d99320e805$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $b25d08d99320e805$var$ResultType.data || result.type === $b25d08d99320e805$var$ResultType.error);
}
function $b25d08d99320e805$var$isRedirectDataStrategyResultResult(result) {
    return $b25d08d99320e805$var$isResponse(result.result) && $b25d08d99320e805$var$redirectStatusCodes.has(result.result.status);
}
function $b25d08d99320e805$var$isDeferredResult(result) {
    return result.type === $b25d08d99320e805$var$ResultType.deferred;
}
function $b25d08d99320e805$var$isErrorResult(result) {
    return result.type === $b25d08d99320e805$var$ResultType.error;
}
function $b25d08d99320e805$var$isRedirectResult(result) {
    return (result && result.type) === $b25d08d99320e805$var$ResultType.redirect;
}
function $b25d08d99320e805$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b25d08d99320e805$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b25d08d99320e805$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b25d08d99320e805$var$isRedirectResponse(result) {
    if (!$b25d08d99320e805$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b25d08d99320e805$var$isValidMethod(method) {
    return $b25d08d99320e805$var$validRequestMethods.has(method.toLowerCase());
}
function $b25d08d99320e805$var$isMutationMethod(method) {
    return $b25d08d99320e805$var$validMutationMethods.has(method.toLowerCase());
}
async function $b25d08d99320e805$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b25d08d99320e805$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b25d08d99320e805$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $b25d08d99320e805$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $b25d08d99320e805$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($b25d08d99320e805$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $b25d08d99320e805$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $b25d08d99320e805$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $b25d08d99320e805$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b25d08d99320e805$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b25d08d99320e805$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b25d08d99320e805$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b25d08d99320e805$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b25d08d99320e805$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b25d08d99320e805$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b25d08d99320e805$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b25d08d99320e805$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b25d08d99320e805$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b25d08d99320e805$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b25d08d99320e805$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b25d08d99320e805$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b25d08d99320e805$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b25d08d99320e805$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b25d08d99320e805$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b25d08d99320e805$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b25d08d99320e805$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b25d08d99320e805$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b25d08d99320e805$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lVd4O = parcelRequire("lVd4O");

function $a648eab72417989b$var$_extends() {
    $a648eab72417989b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a648eab72417989b$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $a648eab72417989b$export$3add0d5dce533e2e = /*#__PURE__*/ $lVd4O.createContext(null);
const $a648eab72417989b$export$145dfa71566a64dc = /*#__PURE__*/ $lVd4O.createContext(null);
const $a648eab72417989b$var$AwaitContext = /*#__PURE__*/ $lVd4O.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $a648eab72417989b$export$26749e8557646306 = /*#__PURE__*/ $lVd4O.createContext(null);
const $a648eab72417989b$export$c7914228fb69b0f5 = /*#__PURE__*/ $lVd4O.createContext(null);
const $a648eab72417989b$export$9072aa6dd1f93057 = /*#__PURE__*/ $lVd4O.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $a648eab72417989b$var$RouteErrorContext = /*#__PURE__*/ $lVd4O.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $a648eab72417989b$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $lVd4O.useContext($a648eab72417989b$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $a648eab72417989b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $b25d08d99320e805$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $a648eab72417989b$export$9c954a9d03d32f4a() {
    return $lVd4O.useContext($a648eab72417989b$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $a648eab72417989b$export$45d76561a5302f2b() {
    !$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return $lVd4O.useContext($a648eab72417989b$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $a648eab72417989b$export$1b3f31771c5d07c() {
    return $lVd4O.useContext($a648eab72417989b$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $a648eab72417989b$export$6c330e8992e8a295(pattern) {
    !$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $a648eab72417989b$export$45d76561a5302f2b();
    return $lVd4O.useMemo(()=>(0, $b25d08d99320e805$export$81336c211d5ff295)(pattern, (0, $b25d08d99320e805$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $a648eab72417989b$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $a648eab72417989b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lVd4O.useContext($a648eab72417989b$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lVd4O.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $a648eab72417989b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $a648eab72417989b$var$useNavigateStable() : $a648eab72417989b$var$useNavigateUnstable();
}
function $a648eab72417989b$var$useNavigateUnstable() {
    !$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let dataRouterContext = $lVd4O.useContext($a648eab72417989b$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $lVd4O.useContext($a648eab72417989b$export$26749e8557646306);
    let { matches: matches } = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a648eab72417989b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b25d08d99320e805$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $lVd4O.useRef(false);
    $a648eab72417989b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lVd4O.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $b25d08d99320e805$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b25d08d99320e805$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $a648eab72417989b$var$OutletContext = /*#__PURE__*/ $lVd4O.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $a648eab72417989b$export$4138103a3ae699cc() {
    return $lVd4O.useContext($a648eab72417989b$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $a648eab72417989b$export$a3be3530d8e40d0b(context) {
    let outlet = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $a648eab72417989b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $a648eab72417989b$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $lVd4O.useContext($a648eab72417989b$export$26749e8557646306);
    let { matches: matches } = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a648eab72417989b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b25d08d99320e805$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $lVd4O.useMemo(()=>(0, $b25d08d99320e805$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $a648eab72417989b$export$5d3fca4a98652595(routes, locationArg) {
    return $a648eab72417989b$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $a648eab72417989b$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $lVd4O.useContext($a648eab72417989b$export$26749e8557646306);
    let { matches: parentMatches } = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $a648eab72417989b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $b25d08d99320e805$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $b25d08d99320e805$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $a648eab72417989b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $b25d08d99320e805$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $b25d08d99320e805$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $a648eab72417989b$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $b25d08d99320e805$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $a648eab72417989b$var$DefaultErrorComponent() {
    let error = $a648eab72417989b$export$ed527bf60f6e05f2();
    let message = (0, $b25d08d99320e805$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, /*#__PURE__*/ $lVd4O.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lVd4O.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lVd4O.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $a648eab72417989b$var$defaultErrorElement = /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$DefaultErrorComponent, null);
class $a648eab72417989b$var$RenderErrorBoundary extends $lVd4O.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $a648eab72417989b$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $lVd4O.useContext($a648eab72417989b$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $a648eab72417989b$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $a648eab72417989b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $a648eab72417989b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lVd4O.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $a648eab72417989b$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($a648eab72417989b$var$DataRouterHook || {});
var $a648eab72417989b$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($a648eab72417989b$var$DataRouterStateHook || {});
function $a648eab72417989b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a648eab72417989b$var$useDataRouterContext(hookName) {
    let ctx = $lVd4O.useContext($a648eab72417989b$export$3add0d5dce533e2e);
    !ctx && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a648eab72417989b$var$useDataRouterState(hookName) {
    let state = $lVd4O.useContext($a648eab72417989b$export$145dfa71566a64dc);
    !state && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return state;
}
function $a648eab72417989b$var$useRouteContext(hookName) {
    let route = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    !route && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $a648eab72417989b$var$useCurrentRouteId(hookName) {
    let route = $a648eab72417989b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $a648eab72417989b$export$5fc8298006ad9e58() {
    return $a648eab72417989b$var$useCurrentRouteId($a648eab72417989b$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $a648eab72417989b$export$d0fd4b7106de2769() {
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $a648eab72417989b$export$600dc272ed516c15() {
    let dataRouterContext = $a648eab72417989b$var$useDataRouterContext($a648eab72417989b$var$DataRouterHook.UseRevalidator);
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseRevalidator);
    return $lVd4O.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $a648eab72417989b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseMatches);
    return $lVd4O.useMemo(()=>matches.map((m)=>(0, $b25d08d99320e805$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $a648eab72417989b$export$1448a5050d252c4d() {
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseLoaderData);
    let routeId = $a648eab72417989b$var$useCurrentRouteId($a648eab72417989b$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $a648eab72417989b$export$fd5d37484eab868d(routeId) {
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $a648eab72417989b$export$fdc00f3f26066d5e() {
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseActionData);
    let routeId = $a648eab72417989b$var$useCurrentRouteId($a648eab72417989b$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $a648eab72417989b$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $lVd4O.useContext($a648eab72417989b$var$RouteErrorContext);
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseRouteError);
    let routeId = $a648eab72417989b$var$useCurrentRouteId($a648eab72417989b$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $a648eab72417989b$export$78a72ddb39bdd145() {
    let value = $lVd4O.useContext($a648eab72417989b$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $a648eab72417989b$export$17f53340677d5831() {
    let value = $lVd4O.useContext($a648eab72417989b$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $a648eab72417989b$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $a648eab72417989b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $a648eab72417989b$var$useDataRouterContext($a648eab72417989b$var$DataRouterHook.UseBlocker);
    let state = $a648eab72417989b$var$useDataRouterState($a648eab72417989b$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $lVd4O.useState("");
    let blockerFunction = $lVd4O.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $a648eab72417989b$var$_extends({}, currentLocation, {
                pathname: (0, $b25d08d99320e805$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $a648eab72417989b$var$_extends({}, nextLocation, {
                pathname: (0, $b25d08d99320e805$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lVd4O.useEffect(()=>{
        let key = String(++$a648eab72417989b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lVd4O.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $b25d08d99320e805$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $a648eab72417989b$var$useNavigateStable() {
    let { router: router } = $a648eab72417989b$var$useDataRouterContext($a648eab72417989b$var$DataRouterHook.UseNavigateStable);
    let id = $a648eab72417989b$var$useCurrentRouteId($a648eab72417989b$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $lVd4O.useRef(false);
    $a648eab72417989b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lVd4O.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $a648eab72417989b$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $a648eab72417989b$var$alreadyWarned$1 = {};
function $a648eab72417989b$var$warningOnce(key, cond, message) {
    if (!cond && !$a648eab72417989b$var$alreadyWarned$1[key]) $a648eab72417989b$var$alreadyWarned$1[key] = true;
}
const $a648eab72417989b$var$alreadyWarned = {};
function $a648eab72417989b$var$warnOnce(key, message) {}
const $a648eab72417989b$var$logDeprecation = (flag, msg, link)=>$a648eab72417989b$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $a648eab72417989b$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $a648eab72417989b$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $a648eab72417989b$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $a648eab72417989b$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $a648eab72417989b$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $a648eab72417989b$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $a648eab72417989b$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a648eab72417989b$var$START_TRANSITION = "startTransition";
const $a648eab72417989b$var$startTransitionImpl = $lVd4O[$a648eab72417989b$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a648eab72417989b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lVd4O.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lVd4O.useCallback((newState)=>{
        if (v7_startTransition && $a648eab72417989b$var$startTransitionImpl) $a648eab72417989b$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lVd4O.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $lVd4O.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lVd4O.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lVd4O.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $lVd4O.useEffect(()=>$a648eab72417989b$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $a648eab72417989b$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $a648eab72417989b$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $a648eab72417989b$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $lVd4O.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b25d08d99320e805$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lVd4O.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lVd4O.useCallback((newState)=>{
        v7_startTransition && $a648eab72417989b$var$startTransitionImpl ? $a648eab72417989b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lVd4O.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lVd4O.useEffect(()=>$a648eab72417989b$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $a648eab72417989b$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $lVd4O.useContext($a648eab72417989b$export$26749e8557646306);
    let { matches: matches } = $lVd4O.useContext($a648eab72417989b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a648eab72417989b$export$45d76561a5302f2b();
    let navigate = $a648eab72417989b$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $b25d08d99320e805$export$cae722b0cc860f13)(to, (0, $b25d08d99320e805$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lVd4O.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $a648eab72417989b$export$910ae8079b2c2852(props) {
    return $a648eab72417989b$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $a648eab72417989b$export$e7b0ac011bb776c6(_props) {
    (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $a648eab72417989b$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $b25d08d99320e805$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$a648eab72417989b$export$9c954a9d03d32f4a() && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lVd4O.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $a648eab72417989b$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $b25d08d99320e805$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $lVd4O.useMemo(()=>{
        let trailingPathname = (0, $b25d08d99320e805$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $a648eab72417989b$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $a648eab72417989b$export$5d3fca4a98652595($a648eab72417989b$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $a648eab72417989b$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$ResolveAwait, null, children));
}
var $a648eab72417989b$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($a648eab72417989b$var$AwaitRenderStatus || {});
const $a648eab72417989b$var$neverSettledPromise = new Promise(()=>{});
class $a648eab72417989b$var$AwaitErrorBoundary extends $lVd4O.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $a648eab72417989b$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $a648eab72417989b$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $a648eab72417989b$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $a648eab72417989b$var$AwaitRenderStatus.error : "_data" in promise ? $a648eab72417989b$var$AwaitRenderStatus.success : $a648eab72417989b$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $a648eab72417989b$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $a648eab72417989b$var$AwaitRenderStatus.error && promise._error instanceof (0, $b25d08d99320e805$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $a648eab72417989b$var$neverSettledPromise;
        if (status === $a648eab72417989b$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $a648eab72417989b$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $a648eab72417989b$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $lVd4O.createElement($a648eab72417989b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $a648eab72417989b$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $a648eab72417989b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $a648eab72417989b$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $lVd4O.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $lVd4O.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lVd4O.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $a648eab72417989b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $a648eab72417989b$export$e7b0ac011bb776c6) && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $a648eab72417989b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $a648eab72417989b$export$daf73786167a7f72(matches) {
    return $a648eab72417989b$var$_renderMatches(matches);
}
function $a648eab72417989b$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lVd4O.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $lVd4O.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lVd4O.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $a648eab72417989b$export$f30f7e456d254e83(routes, opts) {
    return (0, $b25d08d99320e805$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a648eab72417989b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b25d08d99320e805$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $a648eab72417989b$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $3114e5f14228fb75$var$_extends() {
    $3114e5f14228fb75$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3114e5f14228fb75$var$_extends.apply(this, arguments);
}
function $3114e5f14228fb75$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $3114e5f14228fb75$var$defaultMethod = "get";
const $3114e5f14228fb75$var$defaultEncType = "application/x-www-form-urlencoded";
function $3114e5f14228fb75$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $3114e5f14228fb75$var$isButtonElement(object) {
    return $3114e5f14228fb75$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $3114e5f14228fb75$var$isFormElement(object) {
    return $3114e5f14228fb75$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $3114e5f14228fb75$var$isInputElement(object) {
    return $3114e5f14228fb75$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $3114e5f14228fb75$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $3114e5f14228fb75$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$3114e5f14228fb75$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $3114e5f14228fb75$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $3114e5f14228fb75$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $3114e5f14228fb75$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $3114e5f14228fb75$var$_formDataSupportsSubmitter = null;
function $3114e5f14228fb75$var$isFormDataSubmitterSupported() {
    if ($3114e5f14228fb75$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $3114e5f14228fb75$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $3114e5f14228fb75$var$_formDataSupportsSubmitter = true;
    }
    return $3114e5f14228fb75$var$_formDataSupportsSubmitter;
}
const $3114e5f14228fb75$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $3114e5f14228fb75$var$getFormEncType(encType) {
    if (encType != null && !$3114e5f14228fb75$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $3114e5f14228fb75$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($3114e5f14228fb75$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $b25d08d99320e805$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $3114e5f14228fb75$var$defaultMethod;
        encType = $3114e5f14228fb75$var$getFormEncType(target.getAttribute("enctype")) || $3114e5f14228fb75$var$defaultEncType;
        formData = new FormData(target);
    } else if ($3114e5f14228fb75$var$isButtonElement(target) || $3114e5f14228fb75$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $b25d08d99320e805$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $3114e5f14228fb75$var$defaultMethod;
        encType = $3114e5f14228fb75$var$getFormEncType(target.getAttribute("formenctype")) || $3114e5f14228fb75$var$getFormEncType(form.getAttribute("enctype")) || $3114e5f14228fb75$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$3114e5f14228fb75$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($3114e5f14228fb75$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $3114e5f14228fb75$var$defaultMethod;
        action = null;
        encType = $3114e5f14228fb75$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $3114e5f14228fb75$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $3114e5f14228fb75$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $3114e5f14228fb75$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $3114e5f14228fb75$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $3114e5f14228fb75$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $3114e5f14228fb75$export$1f3f55432a00e06d(routes, opts) {
    return (0, $b25d08d99320e805$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3114e5f14228fb75$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b25d08d99320e805$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $3114e5f14228fb75$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $a648eab72417989b$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $3114e5f14228fb75$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $b25d08d99320e805$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $3114e5f14228fb75$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b25d08d99320e805$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $3114e5f14228fb75$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $a648eab72417989b$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $3114e5f14228fb75$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $3114e5f14228fb75$var$_extends({}, state, {
        errors: $3114e5f14228fb75$var$deserializeErrors(state.errors)
    });
    return state;
}
function $3114e5f14228fb75$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $b25d08d99320e805$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $3114e5f14228fb75$export$7ad602f0e94e62d1 = /*#__PURE__*/ $lVd4O.createContext({
    isTransitioning: false
});
const $3114e5f14228fb75$export$148fd98d095596d4 = /*#__PURE__*/ $lVd4O.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $3114e5f14228fb75$var$START_TRANSITION = "startTransition";
const $3114e5f14228fb75$var$startTransitionImpl = $lVd4O[$3114e5f14228fb75$var$START_TRANSITION];
const $3114e5f14228fb75$var$FLUSH_SYNC = "flushSync";
const $3114e5f14228fb75$var$flushSyncImpl = $096c782a4047fe48$exports[$3114e5f14228fb75$var$FLUSH_SYNC];
const $3114e5f14228fb75$var$USE_ID = "useId";
const $3114e5f14228fb75$var$useIdImpl = $lVd4O[$3114e5f14228fb75$var$USE_ID];
function $3114e5f14228fb75$var$startTransitionSafe(cb) {
    if ($3114e5f14228fb75$var$startTransitionImpl) $3114e5f14228fb75$var$startTransitionImpl(cb);
    else cb();
}
function $3114e5f14228fb75$var$flushSyncSafe(cb) {
    if ($3114e5f14228fb75$var$flushSyncImpl) $3114e5f14228fb75$var$flushSyncImpl(cb);
    else cb();
}
class $3114e5f14228fb75$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $3114e5f14228fb75$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lVd4O.useState(router.state);
    let [pendingState, setPendingState] = $lVd4O.useState();
    let [vtContext, setVtContext] = $lVd4O.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $lVd4O.useState();
    let [transition, setTransition] = $lVd4O.useState();
    let [interruption, setInterruption] = $lVd4O.useState();
    let fetcherData = $lVd4O.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $lVd4O.useCallback((cb)=>{
        if (v7_startTransition) $3114e5f14228fb75$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $lVd4O.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $3114e5f14228fb75$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $3114e5f14228fb75$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $3114e5f14228fb75$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $3114e5f14228fb75$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $3114e5f14228fb75$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lVd4O.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $lVd4O.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $3114e5f14228fb75$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $lVd4O.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $lVd4O.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $lVd4O.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $lVd4O.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lVd4O.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lVd4O.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $lVd4O.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $lVd4O.useEffect(()=>(0, $a648eab72417989b$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lVd4O.createElement($lVd4O.Fragment, null, /*#__PURE__*/ $lVd4O.createElement((0, $a648eab72417989b$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lVd4O.createElement((0, $a648eab72417989b$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $lVd4O.createElement($3114e5f14228fb75$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $lVd4O.createElement($3114e5f14228fb75$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $lVd4O.createElement((0, $a648eab72417989b$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lVd4O.createElement($3114e5f14228fb75$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $3114e5f14228fb75$var$MemoizedDataRoutes = /*#__PURE__*/ $lVd4O.memo($3114e5f14228fb75$var$DataRoutes);
function $3114e5f14228fb75$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $a648eab72417989b$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $3114e5f14228fb75$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $lVd4O.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b25d08d99320e805$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lVd4O.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lVd4O.useCallback((newState)=>{
        v7_startTransition && $3114e5f14228fb75$var$startTransitionImpl ? $3114e5f14228fb75$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lVd4O.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lVd4O.useEffect(()=>(0, $a648eab72417989b$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lVd4O.createElement((0, $a648eab72417989b$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $3114e5f14228fb75$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $lVd4O.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b25d08d99320e805$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lVd4O.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lVd4O.useCallback((newState)=>{
        v7_startTransition && $3114e5f14228fb75$var$startTransitionImpl ? $3114e5f14228fb75$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lVd4O.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lVd4O.useEffect(()=>(0, $a648eab72417989b$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lVd4O.createElement((0, $a648eab72417989b$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $3114e5f14228fb75$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $lVd4O.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lVd4O.useCallback((newState)=>{
        v7_startTransition && $3114e5f14228fb75$var$startTransitionImpl ? $3114e5f14228fb75$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lVd4O.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $lVd4O.useEffect(()=>(0, $a648eab72417989b$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $lVd4O.createElement((0, $a648eab72417989b$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $3114e5f14228fb75$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $3114e5f14228fb75$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $3114e5f14228fb75$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lVd4O.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $3114e5f14228fb75$var$_objectWithoutPropertiesLoose(_ref7, $3114e5f14228fb75$var$_excluded);
    let { basename: basename } = $lVd4O.useContext((0, $a648eab72417989b$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $3114e5f14228fb75$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($3114e5f14228fb75$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $b25d08d99320e805$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $a648eab72417989b$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $3114e5f14228fb75$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lVd4O.createElement("a", $3114e5f14228fb75$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $3114e5f14228fb75$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lVd4O.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $3114e5f14228fb75$var$_objectWithoutPropertiesLoose(_ref8, $3114e5f14228fb75$var$_excluded2);
    let path = (0, $a648eab72417989b$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    let routerState = $lVd4O.useContext((0, $a648eab72417989b$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $lVd4O.useContext((0, $a648eab72417989b$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3114e5f14228fb75$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $b25d08d99320e805$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $lVd4O.createElement($3114e5f14228fb75$export$a6c7ac8248d6e38a, $3114e5f14228fb75$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $3114e5f14228fb75$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lVd4O.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $3114e5f14228fb75$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $3114e5f14228fb75$var$_objectWithoutPropertiesLoose(_ref9, $3114e5f14228fb75$var$_excluded3);
    let submit = $3114e5f14228fb75$export$47c85c6e3a081d3();
    let formAction = $3114e5f14228fb75$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $lVd4O.createElement("form", $3114e5f14228fb75$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $3114e5f14228fb75$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $3114e5f14228fb75$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $3114e5f14228fb75$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($3114e5f14228fb75$var$DataRouterHook || ($3114e5f14228fb75$var$DataRouterHook = {}));
var $3114e5f14228fb75$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($3114e5f14228fb75$var$DataRouterStateHook || ($3114e5f14228fb75$var$DataRouterStateHook = {}));
// Internal hooks
function $3114e5f14228fb75$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $3114e5f14228fb75$var$useDataRouterContext(hookName) {
    let ctx = $lVd4O.useContext((0, $a648eab72417989b$export$3add0d5dce533e2e));
    !ctx && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return ctx;
}
function $3114e5f14228fb75$var$useDataRouterState(hookName) {
    let state = $lVd4O.useContext((0, $a648eab72417989b$export$145dfa71566a64dc));
    !state && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $3114e5f14228fb75$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    let location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    let path = (0, $a648eab72417989b$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lVd4O.useCallback((event)=>{
        if ($3114e5f14228fb75$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $b25d08d99320e805$export$fe53371bee54353d)(location) === (0, $b25d08d99320e805$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $3114e5f14228fb75$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $lVd4O.useRef($3114e5f14228fb75$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lVd4O.useRef(false);
    let location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    let searchParams = $lVd4O.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $3114e5f14228fb75$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    let setSearchParams = $lVd4O.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $3114e5f14228fb75$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $3114e5f14228fb75$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $3114e5f14228fb75$var$fetcherId = 0;
let $3114e5f14228fb75$var$getUniqueFetcherId = ()=>"__" + String(++$3114e5f14228fb75$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $3114e5f14228fb75$export$47c85c6e3a081d3() {
    let { router: router } = $3114e5f14228fb75$var$useDataRouterContext($3114e5f14228fb75$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $lVd4O.useContext((0, $a648eab72417989b$export$26749e8557646306));
    let currentRouteId = (0, $a648eab72417989b$export$5fc8298006ad9e58)();
    return $lVd4O.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $3114e5f14228fb75$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3114e5f14228fb75$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $3114e5f14228fb75$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $3114e5f14228fb75$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $lVd4O.useContext((0, $a648eab72417989b$export$26749e8557646306));
    let routeContext = $lVd4O.useContext((0, $a648eab72417989b$export$9072aa6dd1f93057));
    !routeContext && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $3114e5f14228fb75$var$_extends({}, (0, $a648eab72417989b$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b25d08d99320e805$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $b25d08d99320e805$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $3114e5f14228fb75$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $3114e5f14228fb75$var$useDataRouterContext($3114e5f14228fb75$var$DataRouterHook.UseFetcher);
    let state = $3114e5f14228fb75$var$useDataRouterState($3114e5f14228fb75$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $lVd4O.useContext($3114e5f14228fb75$export$148fd98d095596d4);
    let route = $lVd4O.useContext((0, $a648eab72417989b$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    !route && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $3114e5f14228fb75$var$useIdImpl ? $3114e5f14228fb75$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $lVd4O.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($3114e5f14228fb75$var$getUniqueFetcherId());
    // Registration/cleanup
    $lVd4O.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $lVd4O.useCallback((href, opts)=>{
        !routeId && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $3114e5f14228fb75$export$47c85c6e3a081d3();
    let submit = $lVd4O.useCallback((target, opts)=>{
        submitImpl(target, $3114e5f14228fb75$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $lVd4O.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $lVd4O.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $lVd4O.createElement($3114e5f14228fb75$export$a7fed597f4b8afd8, $3114e5f14228fb75$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $b25d08d99320e805$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $lVd4O.useMemo(()=>$3114e5f14228fb75$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $3114e5f14228fb75$export$fa996778a3a31087() {
    let state = $3114e5f14228fb75$var$useDataRouterState($3114e5f14228fb75$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $3114e5f14228fb75$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $3114e5f14228fb75$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $3114e5f14228fb75$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $3114e5f14228fb75$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $3114e5f14228fb75$var$useDataRouterContext($3114e5f14228fb75$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $3114e5f14228fb75$var$useDataRouterState($3114e5f14228fb75$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $lVd4O.useContext((0, $a648eab72417989b$export$26749e8557646306));
    let location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    let matches = (0, $a648eab72417989b$export$2378eb7f5ff86053)();
    let navigation = (0, $a648eab72417989b$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lVd4O.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $3114e5f14228fb75$var$usePageHide($lVd4O.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $3114e5f14228fb75$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $3114e5f14228fb75$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($3114e5f14228fb75$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lVd4O.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $3114e5f14228fb75$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $3114e5f14228fb75$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lVd4O.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($3114e5f14228fb75$var$_extends({}, location, {
                    pathname: (0, $b25d08d99320e805$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($3114e5f14228fb75$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lVd4O.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $3114e5f14228fb75$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lVd4O.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $3114e5f14228fb75$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lVd4O.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $3114e5f14228fb75$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $a648eab72417989b$export$b273b3273281a049)(when);
    $lVd4O.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lVd4O.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $3114e5f14228fb75$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $lVd4O.useContext($3114e5f14228fb75$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $b25d08d99320e805$export$3e9cee6b33872309)(false);
    let { basename: basename } = $3114e5f14228fb75$var$useDataRouterContext($3114e5f14228fb75$var$DataRouterHook.useViewTransitionState);
    let path = (0, $a648eab72417989b$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $b25d08d99320e805$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $b25d08d99320e805$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $b25d08d99320e805$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $b25d08d99320e805$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $lVd4O = parcelRequire("lVd4O");
function $47c33be2491a5ba5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $47c33be2491a5ba5$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $47c33be2491a5ba5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $47c33be2491a5ba5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $47c33be2491a5ba5$export$2e2bcd8739ae039 = $47c33be2491a5ba5$export$4f5d2d50c9deca37;


'use client';
const $ad74cb9159ed3c41$var$u = (t)=>"number" == typeof t && !isNaN(t), $ad74cb9159ed3c41$var$d = (t)=>"string" == typeof t, $ad74cb9159ed3c41$var$p = (t)=>"function" == typeof t, $ad74cb9159ed3c41$var$m = (t)=>$ad74cb9159ed3c41$var$d(t) || $ad74cb9159ed3c41$var$p(t) ? t : null, $ad74cb9159ed3c41$var$f = (t)=>(0, $lVd4O.isValidElement)(t) || $ad74cb9159ed3c41$var$d(t) || $ad74cb9159ed3c41$var$p(t) || $ad74cb9159ed3c41$var$u(t);
function $ad74cb9159ed3c41$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $ad74cb9159ed3c41$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $lVd4O.useRef)(0);
        return (0, $lVd4O.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $lVd4O.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $ad74cb9159ed3c41$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).Fragment, null, u);
    };
}
function $ad74cb9159ed3c41$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $ad74cb9159ed3c41$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $ad74cb9159ed3c41$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $ad74cb9159ed3c41$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($ad74cb9159ed3c41$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($ad74cb9159ed3c41$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($ad74cb9159ed3c41$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($ad74cb9159ed3c41$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $ad74cb9159ed3c41$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $lVd4O.useReducer)((t)=>t + 1, 0), [l, c] = (0, $lVd4O.useState)([]), g = (0, $lVd4O.useRef)(null), h = (0, $lVd4O.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $lVd4O.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$ad74cb9159ed3c41$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $ad74cb9159ed3c41$var$m(i.className || b.toastClassName),
            bodyClassName: $ad74cb9159ed3c41$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $ad74cb9159ed3c41$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $ad74cb9159ed3c41$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $ad74cb9159ed3c41$var$y(h.get(l), "removed");
                h.delete(l), $ad74cb9159ed3c41$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($ad74cb9159ed3c41$var$p(r) ? i = r(l) : (0, $lVd4O.isValidElement)(r) ? i = (0, $lVd4O.cloneElement)(r, l) : $ad74cb9159ed3c41$var$d(r) || $ad74cb9159ed3c41$var$u(r) ? i = r : s ? i = $ad74cb9159ed3c41$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $ad74cb9159ed3c41$export$4f13f83fd8bb1dac)(o) && (i = $ad74cb9159ed3c41$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $ad74cb9159ed3c41$var$p(i.onOpen) && (M.onOpen = i.onOpen), $ad74cb9159ed3c41$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $ad74cb9159ed3c41$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$ad74cb9159ed3c41$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $lVd4O.isValidElement)(t) && !$ad74cb9159ed3c41$var$d(t.type) ? x = (0, $lVd4O.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $ad74cb9159ed3c41$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $ad74cb9159ed3c41$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $ad74cb9159ed3c41$var$v.emit(4, $ad74cb9159ed3c41$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $lVd4O.useEffect)(()=>(C.containerId = t.containerId, $ad74cb9159ed3c41$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $ad74cb9159ed3c41$var$v.emit(3, C);
        }), []), (0, $lVd4O.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $ad74cb9159ed3c41$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $ad74cb9159ed3c41$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $ad74cb9159ed3c41$export$a407b657d3044108(t) {
    const [o, a] = (0, $lVd4O.useState)(!1), [r, l] = (0, $lVd4O.useState)(!1), c = (0, $lVd4O.useRef)(null), u = (0, $lVd4O.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $lVd4O.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $ad74cb9159ed3c41$var$b(e.nativeEvent), u.y = $ad74cb9159ed3c41$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $ad74cb9159ed3c41$var$b(e), u.y = $ad74cb9159ed3c41$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $lVd4O.useEffect)(()=>{
        d.current = t;
    }), (0, $lVd4O.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $ad74cb9159ed3c41$var$p(t.onOpen) && t.onOpen((0, $lVd4O.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $ad74cb9159ed3c41$var$p(t.onClose) && t.onClose((0, $lVd4O.isValidElement)(t.children) && t.children.props);
        }), []), (0, $lVd4O.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $ad74cb9159ed3c41$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $ad74cb9159ed3c41$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $ad74cb9159ed3c41$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $ad74cb9159ed3c41$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $ad74cb9159ed3c41$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $ad74cb9159ed3c41$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $ad74cb9159ed3c41$var$p(l) ? l(q) : (0, $lVd4O.isValidElement)(l) ? (0, $lVd4O.cloneElement)(l, q) : $ad74cb9159ed3c41$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
        ...P && {
            role: R
        },
        className: $ad74cb9159ed3c41$var$p(C) ? C({
            type: f
        }) : (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
        className: (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($ad74cb9159ed3c41$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $ad74cb9159ed3c41$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $ad74cb9159ed3c41$export$d20e79fdc3899e95 = $ad74cb9159ed3c41$export$3ff7dc44d332d222($ad74cb9159ed3c41$var$M("bounce", !0)), $ad74cb9159ed3c41$export$d8dc01b5c85a37b9 = $ad74cb9159ed3c41$export$3ff7dc44d332d222($ad74cb9159ed3c41$var$M("slide", !0)), $ad74cb9159ed3c41$export$65cfd44a2050f99 = $ad74cb9159ed3c41$export$3ff7dc44d332d222($ad74cb9159ed3c41$var$M("zoom")), $ad74cb9159ed3c41$export$4d2fae537bd90431 = $ad74cb9159ed3c41$export$3ff7dc44d332d222($ad74cb9159ed3c41$var$M("flip")), $ad74cb9159ed3c41$export$f2815235e76a62b9 = (0, $lVd4O.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $ad74cb9159ed3c41$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $ad74cb9159ed3c41$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $47c33be2491a5ba5$export$2e2bcd8739ae039)(e, $ad74cb9159ed3c41$var$m(i));
    }
    return (0, $lVd4O.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($ad74cb9159ed3c41$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$ad74cb9159ed3c41$export$f2815235e76a62b9.displayName = "ToastContainer", $ad74cb9159ed3c41$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $ad74cb9159ed3c41$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $ad74cb9159ed3c41$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $ad74cb9159ed3c41$var$P, $ad74cb9159ed3c41$var$B = new Map, $ad74cb9159ed3c41$var$D = [], $ad74cb9159ed3c41$var$A = 1;
function $ad74cb9159ed3c41$var$z() {
    return "" + $ad74cb9159ed3c41$var$A++;
}
function $ad74cb9159ed3c41$var$F(t) {
    return t && ($ad74cb9159ed3c41$var$d(t.toastId) || $ad74cb9159ed3c41$var$u(t.toastId)) ? t.toastId : $ad74cb9159ed3c41$var$z();
}
function $ad74cb9159ed3c41$var$H(t, e) {
    return $ad74cb9159ed3c41$var$B.size > 0 ? $ad74cb9159ed3c41$var$v.emit(0, t, e) : $ad74cb9159ed3c41$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $ad74cb9159ed3c41$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $ad74cb9159ed3c41$var$F(e)
    };
}
function $ad74cb9159ed3c41$var$q(t) {
    return (e, n)=>$ad74cb9159ed3c41$var$H(e, $ad74cb9159ed3c41$var$S(t, n));
}
function $ad74cb9159ed3c41$export$b410431fab84fa58(t, e) {
    return $ad74cb9159ed3c41$var$H(t, $ad74cb9159ed3c41$var$S("default", e));
}
$ad74cb9159ed3c41$export$b410431fab84fa58.loading = (t, e)=>$ad74cb9159ed3c41$var$H(t, $ad74cb9159ed3c41$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $ad74cb9159ed3c41$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $ad74cb9159ed3c41$var$d(s) ? $ad74cb9159ed3c41$export$b410431fab84fa58.loading(s, n) : $ad74cb9159ed3c41$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $ad74cb9159ed3c41$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $ad74cb9159ed3c41$var$d(e) ? {
            render: e
        } : e;
        return o ? $ad74cb9159ed3c41$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $ad74cb9159ed3c41$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $ad74cb9159ed3c41$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $ad74cb9159ed3c41$export$b410431fab84fa58.success = $ad74cb9159ed3c41$var$q("success"), $ad74cb9159ed3c41$export$b410431fab84fa58.info = $ad74cb9159ed3c41$var$q("info"), $ad74cb9159ed3c41$export$b410431fab84fa58.error = $ad74cb9159ed3c41$var$q("error"), $ad74cb9159ed3c41$export$b410431fab84fa58.warning = $ad74cb9159ed3c41$var$q("warning"), $ad74cb9159ed3c41$export$b410431fab84fa58.warn = $ad74cb9159ed3c41$export$b410431fab84fa58.warning, $ad74cb9159ed3c41$export$b410431fab84fa58.dark = (t, e)=>$ad74cb9159ed3c41$var$H(t, $ad74cb9159ed3c41$var$S("default", {
        theme: "dark",
        ...e
    })), $ad74cb9159ed3c41$export$b410431fab84fa58.dismiss = (t)=>{
    $ad74cb9159ed3c41$var$B.size > 0 ? $ad74cb9159ed3c41$var$v.emit(1, t) : $ad74cb9159ed3c41$var$D = $ad74cb9159ed3c41$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $ad74cb9159ed3c41$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $ad74cb9159ed3c41$var$v.emit(5, t);
}, $ad74cb9159ed3c41$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $ad74cb9159ed3c41$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $ad74cb9159ed3c41$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $ad74cb9159ed3c41$var$B.get(n || $ad74cb9159ed3c41$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $ad74cb9159ed3c41$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $ad74cb9159ed3c41$var$H(r, a);
        }
    }, 0);
}, $ad74cb9159ed3c41$export$b410431fab84fa58.done = (t)=>{
    $ad74cb9159ed3c41$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $ad74cb9159ed3c41$export$b410431fab84fa58.onChange = (t)=>($ad74cb9159ed3c41$var$v.on(4, t), ()=>{
        $ad74cb9159ed3c41$var$v.off(4, t);
    }), $ad74cb9159ed3c41$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $ad74cb9159ed3c41$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $ad74cb9159ed3c41$var$v.on(2, (t)=>{
    $ad74cb9159ed3c41$var$P = t.containerId || t, $ad74cb9159ed3c41$var$B.set($ad74cb9159ed3c41$var$P, t), $ad74cb9159ed3c41$var$D.forEach((t)=>{
        $ad74cb9159ed3c41$var$v.emit(0, t.content, t.options);
    }), $ad74cb9159ed3c41$var$D = [];
}).on(3, (t)=>{
    $ad74cb9159ed3c41$var$B.delete(t.containerId || t), 0 === $ad74cb9159ed3c41$var$B.size && $ad74cb9159ed3c41$var$v.off(0).off(1).off(5);
});



parcelRequire("lVd4O");
parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");


var $lVd4O = parcelRequire("lVd4O");



var $lVd4O = parcelRequire("lVd4O");
'use client';
const $9654c3899998e505$var$ThemeContext = /*#__PURE__*/ $lVd4O.createContext(null);
var $9654c3899998e505$export$2e2bcd8739ae039 = $9654c3899998e505$var$ThemeContext;



var $lVd4O = parcelRequire("lVd4O");

function $42ae421ba4996b63$export$2e2bcd8739ae039() {
    const theme = $lVd4O.useContext((0, $9654c3899998e505$export$2e2bcd8739ae039));
    return theme;
}


const $09080556891f84e7$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $09080556891f84e7$export$2e2bcd8739ae039 = $09080556891f84e7$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $iO5o7 = parcelRequire("iO5o7");
function $2448d5d4bb30147f$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $2448d5d4bb30147f$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $42ae421ba4996b63$export$2e2bcd8739ae039)();
    const theme = $lVd4O.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $2448d5d4bb30147f$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $09080556891f84e7$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $9654c3899998e505$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $2448d5d4bb30147f$export$2e2bcd8739ae039 = $2448d5d4bb30147f$var$ThemeProvider;



parcelRequire("cfEcJ");
var $7iw0c = parcelRequire("7iw0c");

var $lVd4O = parcelRequire("lVd4O");
parcelRequire("cfEcJ");
var $7iw0c = parcelRequire("7iw0c");
'use client';
function $9ef7510407a00805$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $9ef7510407a00805$var$useTheme(defaultTheme = null) {
    const contextTheme = $lVd4O.useContext((0, $7iw0c.T));
    return !contextTheme || $9ef7510407a00805$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $9ef7510407a00805$export$2e2bcd8739ae039 = $9ef7510407a00805$var$useTheme;



var $lVd4O = parcelRequire("lVd4O");


var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $b74605da85fbbf8b$var$RtlContext = /*#__PURE__*/ $lVd4O.createContext();
function $b74605da85fbbf8b$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $iO5o7.jsx)($b74605da85fbbf8b$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $b74605da85fbbf8b$export$b2dd014b6c321cb = ()=>{
    const value = $lVd4O.useContext($b74605da85fbbf8b$var$RtlContext);
    return value ?? false;
};
var $b74605da85fbbf8b$export$2e2bcd8739ae039 = $b74605da85fbbf8b$var$RtlProvider;



var $cFHFa = parcelRequire("cFHFa");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $2bfcffc8ca3df437$var$EMPTY_THEME = {};
function $2bfcffc8ca3df437$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $lVd4O.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2bfcffc8ca3df437$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $9ef7510407a00805$export$2e2bcd8739ae039)($2bfcffc8ca3df437$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $42ae421ba4996b63$export$2e2bcd8739ae039)() || $2bfcffc8ca3df437$var$EMPTY_THEME;
    const engineTheme = $2bfcffc8ca3df437$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2bfcffc8ca3df437$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2448d5d4bb30147f$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7iw0c.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b74605da85fbbf8b$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cFHFa.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $2bfcffc8ca3df437$export$2e2bcd8739ae039 = $2bfcffc8ca3df437$var$ThemeProvider;



var $lRoul = parcelRequire("lRoul");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $7d83d27e62bcddcf$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $lRoul.default) in themeInput ? themeInput[0, $lRoul.default] : undefined;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2bfcffc8ca3df437$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $lRoul.default) : undefined,
        theme: scopedTheme || themeInput
    });
}


parcelRequire("lVd4O");

var $gOseu = parcelRequire("gOseu");

var $lVd4O = parcelRequire("lVd4O");


var $hVfFZ = parcelRequire("hVfFZ");


var $lVd4O = parcelRequire("lVd4O");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $936b0567590735ec$var$useEnhancedEffect = typeof window !== 'undefined' ? $lVd4O.useLayoutEffect : $lVd4O.useEffect;
var $936b0567590735ec$export$2e2bcd8739ae039 = $936b0567590735ec$var$useEnhancedEffect;



/**
 * Split this component for RSC import
 */ parcelRequire("lVd4O");

var $iO5o7 = parcelRequire("iO5o7");
const $3814e7198354a2ec$export$ff0fa3047d11164c = 'mode';
const $3814e7198354a2ec$export$665054ea9d94dab9 = 'color-scheme';
const $3814e7198354a2ec$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $3814e7198354a2ec$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $3814e7198354a2ec$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $3814e7198354a2ec$export$665054ea9d94dab9, attribute: initialAttribute = $3814e7198354a2ec$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $iO5o7.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $lVd4O = parcelRequire("lVd4O");

function $59c03c3fd237a717$var$noop() {}
const $59c03c3fd237a717$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $59c03c3fd237a717$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $59c03c3fd237a717$export$2e2bcd8739ae039 = $59c03c3fd237a717$var$localStorageManager;


'use client';
function $d7bd7c4aec23e342$var$noop() {}
function $d7bd7c4aec23e342$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d7bd7c4aec23e342$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d7bd7c4aec23e342$export$3caa7590cc1987bd(state) {
    return $d7bd7c4aec23e342$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d7bd7c4aec23e342$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $3814e7198354a2ec$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $3814e7198354a2ec$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $59c03c3fd237a717$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $lVd4O.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $lVd4O.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $lVd4O.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $lVd4O.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $d7bd7c4aec23e342$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $lVd4O.useState(noSsr || !isMultiSchemes);
    $lVd4O.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $d7bd7c4aec23e342$export$3caa7590cc1987bd(state);
    const setMode = $lVd4O.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $d7bd7c4aec23e342$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $lVd4O.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $d7bd7c4aec23e342$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $lVd4O.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $lVd4O.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $lVd4O.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $lVd4O.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $d7bd7c4aec23e342$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $d7bd7c4aec23e342$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $d7bd7c4aec23e342$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $35360e99596f601c$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $35360e99596f601c$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $3814e7198354a2ec$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $3814e7198354a2ec$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $lVd4O.createContext(undefined);
    const useColorScheme = ()=>$lVd4O.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', noSsr: noSsr } = props;
        const hasMounted = $lVd4O.useRef(false);
        const upperTheme = (0, $42ae421ba4996b63$export$2e2bcd8739ae039)();
        const ctx = $lVd4O.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $lVd4O.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $lVd4O.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $d7bd7c4aec23e342$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $lVd4O.useMemo(()=>{
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $lVd4O.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($35360e99596f601c$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $lVd4O.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $lVd4O.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2bfcffc8ca3df437$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $hVfFZ.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $iO5o7.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $3814e7198354a2ec$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $92iwa = parcelRequire("92iwa");

var $gYayb = parcelRequire("gYayb");

var $lRoul = parcelRequire("lRoul");
parcelRequire("lVd4O");


var $iO5o7 = parcelRequire("iO5o7");
const $3a4e9e590e789bd9$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $3a4e9e590e789bd9$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3814e7198354a2ec$export$2e2bcd8739ae039), {
        ...$3a4e9e590e789bd9$export$f84bd70098573c5c,
        ...props
    });
};



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const { CssVarsProvider: $7e1aaf7b56c9e493$var$InternalCssVarsProvider, useColorScheme: $7e1aaf7b56c9e493$export$6343629ee1b29116, getInitColorSchemeScript: $7e1aaf7b56c9e493$var$deprecatedGetInitColorSchemeScript } = (0, $35360e99596f601c$export$2e2bcd8739ae039)({
    themeId: (0, $lRoul.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $92iwa.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $3a4e9e590e789bd9$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $3a4e9e590e789bd9$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $3a4e9e590e789bd9$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $3a4e9e590e789bd9$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $gYayb.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $gOseu.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $7e1aaf7b56c9e493$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $7e1aaf7b56c9e493$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $iO5o7.jsx)($7e1aaf7b56c9e493$var$InternalCssVarsProvider, {
        ...props
    });
}
let $7e1aaf7b56c9e493$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $7e1aaf7b56c9e493$export$f9a57b4a2abf8ed = (params)=>{
    if (!$7e1aaf7b56c9e493$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $7e1aaf7b56c9e493$var$warnedInitScriptOnce = true;
    }
    return $7e1aaf7b56c9e493$var$deprecatedGetInitColorSchemeScript(params);
};
const $7e1aaf7b56c9e493$export$50ec01b133c61652 = $7e1aaf7b56c9e493$var$InternalCssVarsProvider;



var $lRoul = parcelRequire("lRoul");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $ea93627b116aa5a9$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    if (typeof theme === 'function') return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7d83d27e62bcddcf$export$2e2bcd8739ae039), {
        theme: theme,
        ...props
    });
    const muiTheme = (0, $lRoul.default) in theme ? theme[0, $lRoul.default] : theme;
    if (!('colorSchemes' in muiTheme)) {
        if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
        // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
        return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7d83d27e62bcddcf$export$2e2bcd8739ae039), {
            theme: {
                ...theme,
                vars: null
            },
            ...props
        });
        return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7d83d27e62bcddcf$export$2e2bcd8739ae039), {
            theme: theme,
            ...props
        });
    }
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7e1aaf7b56c9e493$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}




















var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");

var $anaDR = parcelRequire("anaDR");

var $6TPZZ = parcelRequire("6TPZZ");

var $gOseu = parcelRequire("gOseu");
var $7qwc9 = parcelRequire("7qwc9");

var $fOrBY = parcelRequire("fOrBY");
const $75e909056141c6de$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $fOrBY.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $75e909056141c6de$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $75e909056141c6de$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $7qwc9.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}



var $lyfWf = parcelRequire("lyfWf");

'use client';
const $6a00530d38c0e8b0$export$35e57303dbd8a66 = (0, $lyfWf.default)();
function $6a00530d38c0e8b0$var$useTheme(defaultTheme = $6a00530d38c0e8b0$export$35e57303dbd8a66) {
    return (0, $9ef7510407a00805$export$2e2bcd8739ae039)(defaultTheme);
}
var $6a00530d38c0e8b0$export$2e2bcd8739ae039 = $6a00530d38c0e8b0$var$useTheme;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $b76746888cd02f38$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $6TPZZ.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $gOseu.default));
    const Box = /*#__PURE__*/ $lVd4O.forwardRef(function Box(inProps, ref) {
        const theme = (0, $6a00530d38c0e8b0$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $75e909056141c6de$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $iO5o7.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $anaDR.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}




var $gUVSy = parcelRequire("gUVSy");

var $92iwa = parcelRequire("92iwa");

var $lRoul = parcelRequire("lRoul");

var $eaNcJ = parcelRequire("eaNcJ");
const $ef5be0d1c9066c45$var$boxClasses = (0, $eaNcJ.default)('MuiBox', [
    'root'
]);
var $ef5be0d1c9066c45$export$2e2bcd8739ae039 = $ef5be0d1c9066c45$var$boxClasses;


'use client';
const $fbb05a6af45ba6c1$var$defaultTheme = (0, $92iwa.default)();
const $fbb05a6af45ba6c1$var$Box = (0, $b76746888cd02f38$export$2e2bcd8739ae039)({
    themeId: (0, $lRoul.default),
    defaultTheme: $fbb05a6af45ba6c1$var$defaultTheme,
    defaultClassName: (0, $ef5be0d1c9066c45$export$2e2bcd8739ae039).root,
    generateClassName: (0, $gUVSy.default).generate
});
var $fbb05a6af45ba6c1$export$2e2bcd8739ae039 = $fbb05a6af45ba6c1$var$Box;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");

var $cfEcJ = parcelRequire("cfEcJ");
var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $4HqRp = parcelRequire("4HqRp");
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $92f3facad9078ce8$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $92f3facad9078ce8$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$92f3facad9078ce8$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $92f3facad9078ce8$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $92f3facad9078ce8$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $9c861574c295530e$export$29cad1383b3f235d(slot) {
    return (0, $bYZd6.default)('MuiCircularProgress', slot);
}
const $9c861574c295530e$var$circularProgressClasses = (0, $eaNcJ.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $9c861574c295530e$export$2e2bcd8739ae039 = $9c861574c295530e$var$circularProgressClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a137f263533bb854$var$SIZE = 44;
const $a137f263533bb854$var$circularRotateKeyframe = (0, $cfEcJ.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $a137f263533bb854$var$circularDashKeyframe = (0, $cfEcJ.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $a137f263533bb854$var$rotateAnimation = typeof $a137f263533bb854$var$circularRotateKeyframe !== 'string' ? (0, $cfEcJ.css)`
        animation: ${$a137f263533bb854$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $a137f263533bb854$var$dashAnimation = typeof $a137f263533bb854$var$circularDashKeyframe !== 'string' ? (0, $cfEcJ.css)`
        animation: ${$a137f263533bb854$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $a137f263533bb854$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $4HqRp.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $4HqRp.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $9c861574c295530e$export$29cad1383b3f235d), classes);
};
const $a137f263533bb854$var$CircularProgressRoot = (0, $gvIKB.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $4HqRp.default)(ownerState.color)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $a137f263533bb854$var$rotateAnimation || {
                    animation: `${$a137f263533bb854$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $a137f263533bb854$var$CircularProgressSVG = (0, $gvIKB.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $a137f263533bb854$var$CircularProgressCircle = (0, $gvIKB.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $4HqRp.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $a137f263533bb854$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$a137f263533bb854$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $a137f263533bb854$var$CircularProgress = /*#__PURE__*/ $lVd4O.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $a137f263533bb854$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($a137f263533bb854$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $iO5o7.jsx)($a137f263533bb854$var$CircularProgressRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)($a137f263533bb854$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$a137f263533bb854$var$SIZE / 2} ${$a137f263533bb854$var$SIZE / 2} ${$a137f263533bb854$var$SIZE} ${$a137f263533bb854$var$SIZE}`,
            children: /*#__PURE__*/ (0, $iO5o7.jsx)($a137f263533bb854$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $a137f263533bb854$var$SIZE,
                cy: $a137f263533bb854$var$SIZE,
                r: ($a137f263533bb854$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $a137f263533bb854$export$2e2bcd8739ae039 = $a137f263533bb854$var$CircularProgress;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $7adef3073a7f326d$export$46f01d01378ec5a2(slot) {
    return (0, $bYZd6.default)('MuiDivider', slot);
}
const $7adef3073a7f326d$var$dividerClasses = (0, $eaNcJ.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $7adef3073a7f326d$export$2e2bcd8739ae039 = $7adef3073a7f326d$var$dividerClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $7640c64fed7cb5ef$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $7adef3073a7f326d$export$46f01d01378ec5a2), classes);
};
const $7640c64fed7cb5ef$var$DividerRoot = (0, $gvIKB.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $dRIMW.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $7640c64fed7cb5ef$var$DividerWrapper = (0, $gvIKB.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $7640c64fed7cb5ef$var$Divider = /*#__PURE__*/ $lVd4O.forwardRef(function Divider(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $7640c64fed7cb5ef$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($7640c64fed7cb5ef$var$DividerRoot, {
        as: component,
        className: (0, $anaDR.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $iO5o7.jsx)($7640c64fed7cb5ef$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($7640c64fed7cb5ef$var$Divider) $7640c64fed7cb5ef$var$Divider.muiSkipListHighlight = true;
var $7640c64fed7cb5ef$export$2e2bcd8739ae039 = $7640c64fed7cb5ef$var$Divider;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $314e9ef39ea63309$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $314e9ef39ea63309$export$2e2bcd8739ae039 = $314e9ef39ea63309$var$isHostComponent;



var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $lVd4O = parcelRequire("lVd4O");
function $47c130483729695b$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $lVd4O.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}


var $0ae62b7a43146e9e$export$2e2bcd8739ae039 = (0, $47c130483729695b$export$2e2bcd8739ae039);



var $lVd4O = parcelRequire("lVd4O");
'use client';
function $56d901343d819caa$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $lVd4O.useRef(undefined);
    const refEffect = $lVd4O.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $lVd4O.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $378090240d6c80ab$export$2e2bcd8739ae039 = (0, $56d901343d819caa$export$2e2bcd8739ae039);



var $lVd4O = parcelRequire("lVd4O");
'use client';
/**
 * @ignore - internal component.
 */ const $71f802e7b868aa8f$var$ListContext = /*#__PURE__*/ $lVd4O.createContext({});
var $71f802e7b868aa8f$export$2e2bcd8739ae039 = $71f802e7b868aa8f$var$ListContext;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $a9fa421821c8107d$export$5682c366c0c669d9(slot) {
    return (0, $bYZd6.default)('MuiListItem', slot);
}
const $a9fa421821c8107d$var$listItemClasses = (0, $eaNcJ.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $a9fa421821c8107d$export$2e2bcd8739ae039 = $a9fa421821c8107d$var$listItemClasses;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $3d53be13576839e6$export$c09531d8563c67a5(slot) {
    return (0, $bYZd6.default)('MuiListItemButton', slot);
}
const $3d53be13576839e6$var$listItemButtonClasses = (0, $eaNcJ.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $3d53be13576839e6$export$2e2bcd8739ae039 = $3d53be13576839e6$var$listItemButtonClasses;



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");


var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $1e7604dc166d1551$export$ccdb26aeba48a86e(slot) {
    return (0, $bYZd6.default)('MuiListItemSecondaryAction', slot);
}
const $1e7604dc166d1551$var$listItemSecondaryActionClasses = (0, $eaNcJ.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $1e7604dc166d1551$export$2e2bcd8739ae039 = $1e7604dc166d1551$var$listItemSecondaryActionClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $605a0052853ceb14$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $1e7604dc166d1551$export$ccdb26aeba48a86e), classes);
};
const $605a0052853ceb14$var$ListItemSecondaryActionRoot = (0, $gvIKB.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $605a0052853ceb14$var$ListItemSecondaryAction = /*#__PURE__*/ $lVd4O.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $lVd4O.useContext((0, $71f802e7b868aa8f$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $605a0052853ceb14$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($605a0052853ceb14$var$ListItemSecondaryActionRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$605a0052853ceb14$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $605a0052853ceb14$export$2e2bcd8739ae039 = $605a0052853ceb14$var$ListItemSecondaryAction;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a2032c97e5ab093a$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $a2032c97e5ab093a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $a9fa421821c8107d$export$5682c366c0c669d9), classes);
};
const $a2032c97e5ab093a$export$aed538f7519abe89 = (0, $gvIKB.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $a2032c97e5ab093a$export$4334bb34c76fef24
})((0, $7KgDD.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $3d53be13576839e6$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $a2032c97e5ab093a$var$ListItemContainer = (0, $gvIKB.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $a2032c97e5ab093a$var$ListItem = /*#__PURE__*/ $lVd4O.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $lVd4O.useContext((0, $71f802e7b868aa8f$export$2e2bcd8739ae039));
    const childContext = $lVd4O.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $lVd4O.useRef(null);
    const children = $lVd4O.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $0ae62b7a43146e9e$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $a2032c97e5ab093a$var$useUtilityClasses(ownerState);
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $a2032c97e5ab093a$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $anaDR.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $71f802e7b868aa8f$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)($a2032c97e5ab093a$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $anaDR.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $71f802e7b868aa8f$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $605a0052853ceb14$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $a2032c97e5ab093a$export$2e2bcd8739ae039 = $a2032c97e5ab093a$var$ListItem;


var $dd0f682fb0da8fa4$exports = {};
!function(t, e) {
    $dd0f682fb0da8fa4$exports = e();
}($dd0f682fb0da8fa4$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});



var $jzre3 = parcelRequire("jzre3");

var $lVd4O = parcelRequire("lVd4O");
if (!(0, $lVd4O.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $jzre3.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






var $jzre3 = parcelRequire("jzre3");
function $de362d66ee0f53c4$export$fb2daceae6f5097a(callback) {
    callback();
}
function $de362d66ee0f53c4$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $de362d66ee0f53c4$export$fb2daceae6f5097a;
    (0, $jzre3.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $de362d66ee0f53c4$export$13ce1459b9a04b51 = function() {
    return true;
};


var $04b332d7ef88c39c$var$deprecatedMessages = [];
function $04b332d7ef88c39c$export$be38475be17599d(msg) {
    if (!$04b332d7ef88c39c$var$deprecatedMessages.includes(msg)) {
        $04b332d7ef88c39c$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $jzre3 = parcelRequire("jzre3");

var $lVd4O = parcelRequire("lVd4O");

var $jzre3 = parcelRequire("jzre3");
function $525bd8518c34bdb2$export$ef795f1f307682c7(v) {
    return (0, $jzre3.getDependencyTree)(v);
}


var $7e1e1efc5fc085c4$export$e901ba0ffe10ba41 = 10000;
var $7e1e1efc5fc085c4$export$1ae22ce5a82f26b6 = 10000;
var $7e1e1efc5fc085c4$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $7e1e1efc5fc085c4$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $7e1e1efc5fc085c4$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $7e1e1efc5fc085c4$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $7e1e1efc5fc085c4$export$b7a00d372cedeedd;


var $1411037912d5e502$export$10e8a12fbfd8583c = new (0, $7e1e1efc5fc085c4$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $c70e490b30f866a5$var$globalIsUsingStaticRendering = false;
function $c70e490b30f866a5$export$5d52eaa7c0f24c9e(enable) {
    $c70e490b30f866a5$var$globalIsUsingStaticRendering = enable;
}
function $c70e490b30f866a5$export$55979271896d643e() {
    return $c70e490b30f866a5$var$globalIsUsingStaticRendering;
}


var $14c6a45fc8698c7f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $14c6a45fc8698c7f$var$observerComponentNameFor(baseComponentName) {
    return "observer".concat(baseComponentName);
}
/**
 * We use class to make it easier to detect in heap snapshots by name
 */ var $14c6a45fc8698c7f$var$ObjectToBeRetainedByReact = /** @class */ function() {
    function ObjectToBeRetainedByReact() {}
    return ObjectToBeRetainedByReact;
}();
function $14c6a45fc8698c7f$var$objectToBeRetainedByReactFactory() {
    return new $14c6a45fc8698c7f$var$ObjectToBeRetainedByReact();
}
function $14c6a45fc8698c7f$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $c70e490b30f866a5$export$55979271896d643e)()) return fn();
    var _a = $14c6a45fc8698c7f$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).useState($14c6a45fc8698c7f$var$objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
    // Force update, see #2982
    var _b = $14c6a45fc8698c7f$var$__read((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).useState(), 2), setState = _b[1];
    var forceUpdate = function() {
        return setState([]);
    };
    // StrictMode/ConcurrentMode/Suspense may mean that our component is
    // rendered and abandoned multiple times, so we need to track leaked
    // Reactions.
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).useRef(null);
    if (!admRef.current) // First render
    admRef.current = {
        reaction: null,
        mounted: false,
        changedBeforeMount: false
    };
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or component was not committed and reaction was disposed by registry
        adm.reaction = new (0, $jzre3.Reaction)($14c6a45fc8698c7f$var$observerComponentNameFor(baseComponentName), function() {
            // Observable has changed, meaning we want to re-render
            // BUT if we're a component that hasn't yet got to the useEffect()
            // stage, we might be a component that _started_ to render, but
            // got dropped, and we don't want to make state changes then.
            // (It triggers warnings in StrictMode, for a start.)
            if (adm.mounted) // We have reached useEffect(), so we're mounted, and can trigger an update
            forceUpdate();
            else // We haven't yet reached useEffect(), so we'll need to trigger a re-render
            // when (and if) useEffect() arrives.
            adm.changedBeforeMount = true;
        });
        (0, $1411037912d5e502$export$10e8a12fbfd8583c).register(objectRetainedByReact, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).useDebugValue(adm.reaction, (0, $525bd8518c34bdb2$export$ef795f1f307682c7));
    (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).useEffect(function() {
        (0, $1411037912d5e502$export$10e8a12fbfd8583c).unregister(adm);
        adm.mounted = true;
        if (adm.reaction) {
            if (adm.changedBeforeMount) {
                // Got a change before mount, force an update
                adm.changedBeforeMount = false;
                forceUpdate();
            }
        } else {
            // The reaction we set up in our render has been disposed.
            // This can be due to bad timings of renderings, e.g. our
            // component was paused for a _very_ long time, and our
            // reaction got cleaned up
            // Re-create the reaction
            adm.reaction = new (0, $jzre3.Reaction)($14c6a45fc8698c7f$var$observerComponentNameFor(baseComponentName), function() {
                // We've definitely already been mounted at this point
                forceUpdate();
            });
            forceUpdate();
        }
        return function() {
            adm.reaction.dispose();
            adm.reaction = null;
            adm.mounted = false;
            adm.changedBeforeMount = false;
        };
    }, []);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var rendering;
    var exception;
    adm.reaction.track(function() {
        try {
            rendering = fn();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return rendering;
}





var $lVd4O = parcelRequire("lVd4O");


var $0f7629d23d6d6537$var$warnObserverOptionsDeprecated = true;
var $0f7629d23d6d6537$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $0f7629d23d6d6537$var$ReactForwardRefSymbol = $0f7629d23d6d6537$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $lVd4O.forwardRef) === "function" && (0, $lVd4O.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $0f7629d23d6d6537$var$ReactMemoSymbol = $0f7629d23d6d6537$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $lVd4O.memo) === "function" && (0, $lVd4O.memo)(function(props) {
    return null;
})["$$typeof"];
function $0f7629d23d6d6537$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($0f7629d23d6d6537$var$ReactMemoSymbol && baseComponent["$$typeof"] === $0f7629d23d6d6537$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $c70e490b30f866a5$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($0f7629d23d6d6537$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $0f7629d23d6d6537$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $14c6a45fc8698c7f$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    // Don't set `displayName` for anonymous components,
    // so the `displayName` can be customized by user, see #3192.
    if (baseComponentName !== "") observerComponent.displayName = baseComponentName;
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $lVd4O.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $lVd4O.memo)(observerComponent);
    $0f7629d23d6d6537$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $0f7629d23d6d6537$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $0f7629d23d6d6537$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$0f7629d23d6d6537$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $3804002e506ba289$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $14c6a45fc8698c7f$export$b9c7ecd090a87b14)(component);
}
$3804002e506ba289$export$c1cbdee04e18ea8b.displayName = "Observer";
function $3804002e506ba289$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $jzre3 = parcelRequire("jzre3");

var $lVd4O = parcelRequire("lVd4O");
function $e2c2aa24ab9f3335$export$aa207039f277c5f(initializer, annotations) {
    return (0, $lVd4O.useState)(function() {
        return (0, $jzre3.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $jzre3 = parcelRequire("jzre3");

var $lVd4O = parcelRequire("lVd4O");



var $jzre3 = parcelRequire("jzre3");

var $lVd4O = parcelRequire("lVd4O");
var $c10539e03645ba20$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $c10539e03645ba20$export$e0ded3646391939c(current) {
    var _a = $c10539e03645ba20$var$__read((0, $lVd4O.useState)(function() {
        return (0, $jzre3.observable)(current, {}, {
            deep: false
        });
    }), 1), res = _a[0];
    (0, $jzre3.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $7701fccdbb697646$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $c10539e03645ba20$export$e0ded3646391939c)(current);
    return (0, $lVd4O.useState)(function() {
        return (0, $jzre3.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $c377bf5a79239025$var$_a;
(0, $de362d66ee0f53c4$export$294943bbc3c74f4f)((0, $096c782a4047fe48$exports.unstable_batchedUpdates));
var $c377bf5a79239025$export$469d51fb8d268227 = ($c377bf5a79239025$var$_a = (0, $1411037912d5e502$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $c377bf5a79239025$var$_a !== void 0 ? $c377bf5a79239025$var$_a : function() {};
function $c377bf5a79239025$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $14c6a45fc8698c7f$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $c377bf5a79239025$export$7613124ee4202834(enable) {
    (0, $c70e490b30f866a5$export$5d52eaa7c0f24c9e)(enable);
}




var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $jzre3 = parcelRequire("jzre3");
class $9329bf06553946c4$export$f6772e87ca157ef {
    rootStore;
    constructor(rootStore){
        this.rootStore = rootStore;
    }
}


class $a11fedce377bfa25$export$f2e832acab1bdd79 extends Error {
    url;
    status;
    statusText;
    body;
    request;
    constructor(request, response, message){
        super(message);
        this.name = 'ApiError';
        this.url = response.url;
        this.status = response.status;
        this.statusText = response.statusText;
        this.body = response.body;
        this.request = request;
    }
}






/* istanbul ignore file */ /* tslint:disable */ /* eslint-disable */ class $d10444b79161e7f1$export$d7f5e52d091a66db extends Error {
    constructor(message){
        super(message);
        this.name = 'CancelError';
    }
    get isCancelled() {
        return true;
    }
}
class $d10444b79161e7f1$export$551a058e9626aa5a {
    #isResolved;
    #isRejected;
    #isCancelled;
    #cancelHandlers;
    #promise;
    #resolve;
    #reject;
    constructor(executor){
        this.#isResolved = false;
        this.#isRejected = false;
        this.#isCancelled = false;
        this.#cancelHandlers = [];
        this.#promise = new Promise((resolve, reject)=>{
            this.#resolve = resolve;
            this.#reject = reject;
            const onResolve = (value)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isResolved = true;
                this.#resolve?.(value);
            };
            const onReject = (reason)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#isRejected = true;
                this.#reject?.(reason);
            };
            const onCancel = (cancelHandler)=>{
                if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
                this.#cancelHandlers.push(cancelHandler);
            };
            Object.defineProperty(onCancel, 'isResolved', {
                get: ()=>this.#isResolved
            });
            Object.defineProperty(onCancel, 'isRejected', {
                get: ()=>this.#isRejected
            });
            Object.defineProperty(onCancel, 'isCancelled', {
                get: ()=>this.#isCancelled
            });
            return executor(onResolve, onReject, onCancel);
        });
    }
    get [Symbol.toStringTag]() {
        return 'Cancellable Promise';
    }
    then(onFulfilled, onRejected) {
        return this.#promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this.#promise.catch(onRejected);
    }
    finally(onFinally) {
        return this.#promise.finally(onFinally);
    }
    cancel() {
        if (this.#isResolved || this.#isRejected || this.#isCancelled) return;
        this.#isCancelled = true;
        if (this.#cancelHandlers.length) try {
            for (const cancelHandler of this.#cancelHandlers)cancelHandler();
        } catch (error) {
            console.warn('Cancellation threw an error', error);
            return;
        }
        this.#cancelHandlers.length = 0;
        this.#reject?.(new $d10444b79161e7f1$export$d7f5e52d091a66db('Request aborted'));
    }
    get isCancelled() {
        return this.#isCancelled;
    }
}


var $5a3f4c65fc5261f3$exports = {};
$5a3f4c65fc5261f3$exports = JSON.parse("{\"name\":\"fuse-financial-frontend\",\"description\":\"Frontend for the FuSE Financial platform\",\"version\":\"1.0.0\",\"private\":true,\"author\":\"FuSE\",\"engines\":{\"node\":\"^18.16.0\"},\"scripts\":{\"build\":\"parcel build public/index.html\",\"dev\":\"DEBUG=fuse* parcel public/index.html\",\"dev:clean\":\"yarn clean && yarn dev\",\"start\":\"parcel public/index.html\",\"lint\":\"eslint src --ext .ts,.tsx --max-warnings 0\",\"lint:fix\":\"eslint src --ext .ts,.tsx --fix\",\"format\":\"prettier --write \\\"src/**/*.{ts,tsx,js,jsx,json,md}\\\"\",\"check-format\":\"prettier --check \\\"src/**/*.{ts,tsx,js,jsx,json,md}\\\"\",\"clean\":\"rm -rf .parcel-cache dist\"},\"browserslist\":\"> 0.5%, last 2 versions, not dead\",\"dependencies\":{\"@emotion/react\":\"^11.14.0\",\"@emotion/styled\":\"^11.14.0\",\"@mui/icons-material\":\"^6.4.6\",\"@mui/material\":\"^6.4.6\",\"animate.css\":\"^3.4.0\",\"d3\":\"4\",\"d3-tip\":\"^0.9.1\",\"dayjs\":\"^1.11.10\",\"debug\":\"^4.3.4\",\"lodash\":\"^4.17.21\",\"materialize-css\":\"0.97.8\",\"mobx\":\"^6.9.0\",\"mobx-react-lite\":\"^3.4.3\",\"react\":\"^18.0.0\",\"react-dom\":\"^18.0.0\",\"react-error-boundary\":\"^6.0.0\",\"react-number-format\":\"^5.4.4\",\"react-router-dom\":\"^6.11.2\",\"react-toastify\":\"^9.1.2\"},\"devDependencies\":{\"@parcel/css\":\"^1.14.0\",\"@parcel/transformer-svg-react\":\"^2.8.3\",\"@trivago/prettier-plugin-sort-imports\":\"^4.1.1\",\"@types/debug\":\"^4.1.12\",\"@types/lodash\":\"^4.17.18\",\"@types/node\":\"20.1.2\",\"@types/react\":\"^18.0.0\",\"@types/react-dom\":\"^18.2.4\",\"@typescript-eslint/eslint-plugin\":\"^5.59.6\",\"@typescript-eslint/parser\":\"^5.59.6\",\"assert\":\"^2.0.0\",\"buffer\":\"^5.5.0||^6.0.0\",\"console-browserify\":\"^1.2.0\",\"eslint\":\"8.40.0\",\"eslint-config-prettier\":\"^10.0.1\",\"eslint-plugin-jsx-a11y\":\"^6.7.1\",\"eslint-plugin-prettier\":\"^5.5.4\",\"eslint-plugin-react\":\"^7.37.4\",\"eslint-plugin-react-hooks\":\"^4.6.0\",\"parcel\":\"^2.10.2\",\"prettier\":\"^2.8.8\",\"process\":\"^0.11.10\",\"timers-browserify\":\"^2.0.11\",\"typescript\":\"5.0.4\"}}");


const $05ae455d2b766b2e$var$getEnvironmentVariable = (unvalidatedEnvironmentVariable, defaultValue)=>{
    if (!unvalidatedEnvironmentVariable) {
        if (typeof defaultValue === 'string') return defaultValue;
        throw new Error(`Couldn't find environment variable: ${unvalidatedEnvironmentVariable}`);
    } else return unvalidatedEnvironmentVariable;
};
const $05ae455d2b766b2e$export$e506a1d27d1eaa20 = {
    nodeEnv: $05ae455d2b766b2e$var$getEnvironmentVariable("production"),
    client: {
        url: $05ae455d2b766b2e$var$getEnvironmentVariable("https://fuse-financial.app", 'http://localhost:1234'),
        basePageTitle: $05ae455d2b766b2e$var$getEnvironmentVariable(undefined, 'FuSE Financial')
    },
    api: {
        url: $05ae455d2b766b2e$var$getEnvironmentVariable("https://fuse-financial.app"),
        prefix: $05ae455d2b766b2e$var$getEnvironmentVariable("api", 'api'),
        useCredentials: $05ae455d2b766b2e$var$getEnvironmentVariable("true", 'false') === 'true',
        credentialsType: $05ae455d2b766b2e$var$getEnvironmentVariable("include", 'include')
    },
    logs: {
        rootNamespace: $05ae455d2b766b2e$var$getEnvironmentVariable("fuse-financial", 'fuse-frontend')
    }
};


const $a387df8f417cb087$export$3bbbb17165d6e0ef = {
    BASE: `/${(0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.prefix}`,
    VERSION: (0, (/*@__PURE__*/$parcel$interopDefault($5a3f4c65fc5261f3$exports))).version,
    USE_CREDENTIALS: (0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.useCredentials,
    CREDENTIALS: (0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.credentialsType,
    TOKEN: undefined,
    USERNAME: undefined,
    PASSWORD: undefined,
    HEADERS: undefined,
    ENCODE_PATH: undefined
};





/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $72caa8f32d3329c9$export$a143d493d941bafc;
var $72caa8f32d3329c9$export$e4cf37d7f6fb9e0a;
var $72caa8f32d3329c9$export$f99ded8fe4b79145;
var $72caa8f32d3329c9$export$599f31c3813fae4d;
'use strict';
var $b1b61c70b629423c$export$a48f0734ac7c2329;
var $b1b61c70b629423c$export$d622b2ad8d90c771;
var $b1b61c70b629423c$export$6100ba28696e12de;
'use strict';
$b1b61c70b629423c$export$a48f0734ac7c2329 = $b1b61c70b629423c$var$byteLength;
$b1b61c70b629423c$export$d622b2ad8d90c771 = $b1b61c70b629423c$var$toByteArray;
$b1b61c70b629423c$export$6100ba28696e12de = $b1b61c70b629423c$var$fromByteArray;
var $b1b61c70b629423c$var$lookup = [];
var $b1b61c70b629423c$var$revLookup = [];
var $b1b61c70b629423c$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $b1b61c70b629423c$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $b1b61c70b629423c$var$i = 0, $b1b61c70b629423c$var$len = $b1b61c70b629423c$var$code.length; $b1b61c70b629423c$var$i < $b1b61c70b629423c$var$len; ++$b1b61c70b629423c$var$i){
    $b1b61c70b629423c$var$lookup[$b1b61c70b629423c$var$i] = $b1b61c70b629423c$var$code[$b1b61c70b629423c$var$i];
    $b1b61c70b629423c$var$revLookup[$b1b61c70b629423c$var$code.charCodeAt($b1b61c70b629423c$var$i)] = $b1b61c70b629423c$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$b1b61c70b629423c$var$revLookup['-'.charCodeAt(0)] = 62;
$b1b61c70b629423c$var$revLookup['_'.charCodeAt(0)] = 63;
function $b1b61c70b629423c$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $b1b61c70b629423c$var$byteLength(b64) {
    var lens = $b1b61c70b629423c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b1b61c70b629423c$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b1b61c70b629423c$var$toByteArray(b64) {
    var tmp;
    var lens = $b1b61c70b629423c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $b1b61c70b629423c$var$Arr($b1b61c70b629423c$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i)] << 18 | $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i)] << 2 | $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i)] << 10 | $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $b1b61c70b629423c$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $b1b61c70b629423c$var$tripletToBase64(num) {
    return $b1b61c70b629423c$var$lookup[num >> 18 & 0x3F] + $b1b61c70b629423c$var$lookup[num >> 12 & 0x3F] + $b1b61c70b629423c$var$lookup[num >> 6 & 0x3F] + $b1b61c70b629423c$var$lookup[num & 0x3F];
}
function $b1b61c70b629423c$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($b1b61c70b629423c$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $b1b61c70b629423c$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($b1b61c70b629423c$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($b1b61c70b629423c$var$lookup[tmp >> 2] + $b1b61c70b629423c$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($b1b61c70b629423c$var$lookup[tmp >> 10] + $b1b61c70b629423c$var$lookup[tmp >> 4 & 0x3F] + $b1b61c70b629423c$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $b3684d424de2ad56$export$aafa59e2e03f2942;
var $b3684d424de2ad56$export$68d8715fc104d294;
$b3684d424de2ad56$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$b3684d424de2ad56$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $72caa8f32d3329c9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$72caa8f32d3329c9$export$a143d493d941bafc = $72caa8f32d3329c9$var$Buffer;
$72caa8f32d3329c9$export$e4cf37d7f6fb9e0a = $72caa8f32d3329c9$var$SlowBuffer;
$72caa8f32d3329c9$export$f99ded8fe4b79145 = 50;
const $72caa8f32d3329c9$var$K_MAX_LENGTH = 0x7fffffff;
$72caa8f32d3329c9$export$599f31c3813fae4d = $72caa8f32d3329c9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $72caa8f32d3329c9$var$Buffer.TYPED_ARRAY_SUPPORT = $72caa8f32d3329c9$var$typedArraySupport();
if (!$72caa8f32d3329c9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $72caa8f32d3329c9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($72caa8f32d3329c9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$72caa8f32d3329c9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($72caa8f32d3329c9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$72caa8f32d3329c9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $72caa8f32d3329c9$var$createBuffer(length) {
    if (length > $72caa8f32d3329c9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $72caa8f32d3329c9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $72caa8f32d3329c9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $72caa8f32d3329c9$var$allocUnsafe(arg);
    }
    return $72caa8f32d3329c9$var$from(arg, encodingOrOffset, length);
}
$72caa8f32d3329c9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $72caa8f32d3329c9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $72caa8f32d3329c9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $72caa8f32d3329c9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($72caa8f32d3329c9$var$isInstance(value, ArrayBuffer) || value && $72caa8f32d3329c9$var$isInstance(value.buffer, ArrayBuffer)) return $72caa8f32d3329c9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($72caa8f32d3329c9$var$isInstance(value, SharedArrayBuffer) || value && $72caa8f32d3329c9$var$isInstance(value.buffer, SharedArrayBuffer))) return $72caa8f32d3329c9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $72caa8f32d3329c9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $72caa8f32d3329c9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $72caa8f32d3329c9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $72caa8f32d3329c9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $72caa8f32d3329c9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($72caa8f32d3329c9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($72caa8f32d3329c9$var$Buffer, Uint8Array);
function $72caa8f32d3329c9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $72caa8f32d3329c9$var$alloc(size, fill, encoding) {
    $72caa8f32d3329c9$var$assertSize(size);
    if (size <= 0) return $72caa8f32d3329c9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $72caa8f32d3329c9$var$createBuffer(size).fill(fill, encoding) : $72caa8f32d3329c9$var$createBuffer(size).fill(fill);
    return $72caa8f32d3329c9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $72caa8f32d3329c9$var$Buffer.alloc = function(size, fill, encoding) {
    return $72caa8f32d3329c9$var$alloc(size, fill, encoding);
};
function $72caa8f32d3329c9$var$allocUnsafe(size) {
    $72caa8f32d3329c9$var$assertSize(size);
    return $72caa8f32d3329c9$var$createBuffer(size < 0 ? 0 : $72caa8f32d3329c9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $72caa8f32d3329c9$var$Buffer.allocUnsafe = function(size) {
    return $72caa8f32d3329c9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $72caa8f32d3329c9$var$Buffer.allocUnsafeSlow = function(size) {
    return $72caa8f32d3329c9$var$allocUnsafe(size);
};
function $72caa8f32d3329c9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$72caa8f32d3329c9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $72caa8f32d3329c9$var$byteLength(string, encoding) | 0;
    let buf = $72caa8f32d3329c9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $72caa8f32d3329c9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $72caa8f32d3329c9$var$checked(array.length) | 0;
    const buf = $72caa8f32d3329c9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $72caa8f32d3329c9$var$fromArrayView(arrayView) {
    if ($72caa8f32d3329c9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $72caa8f32d3329c9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $72caa8f32d3329c9$var$fromArrayLike(arrayView);
}
function $72caa8f32d3329c9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $72caa8f32d3329c9$var$Buffer.prototype);
    return buf;
}
function $72caa8f32d3329c9$var$fromObject(obj) {
    if ($72caa8f32d3329c9$var$Buffer.isBuffer(obj)) {
        const len = $72caa8f32d3329c9$var$checked(obj.length) | 0;
        const buf = $72caa8f32d3329c9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $72caa8f32d3329c9$var$numberIsNaN(obj.length)) return $72caa8f32d3329c9$var$createBuffer(0);
        return $72caa8f32d3329c9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $72caa8f32d3329c9$var$fromArrayLike(obj.data);
}
function $72caa8f32d3329c9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $72caa8f32d3329c9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $72caa8f32d3329c9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $72caa8f32d3329c9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $72caa8f32d3329c9$var$Buffer.alloc(+length);
}
$72caa8f32d3329c9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $72caa8f32d3329c9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$72caa8f32d3329c9$var$Buffer.compare = function compare(a, b) {
    if ($72caa8f32d3329c9$var$isInstance(a, Uint8Array)) a = $72caa8f32d3329c9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($72caa8f32d3329c9$var$isInstance(b, Uint8Array)) b = $72caa8f32d3329c9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$72caa8f32d3329c9$var$Buffer.isBuffer(a) || !$72caa8f32d3329c9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$72caa8f32d3329c9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$72caa8f32d3329c9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $72caa8f32d3329c9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $72caa8f32d3329c9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($72caa8f32d3329c9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$72caa8f32d3329c9$var$Buffer.isBuffer(buf)) buf = $72caa8f32d3329c9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$72caa8f32d3329c9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $72caa8f32d3329c9$var$byteLength(string, encoding) {
    if ($72caa8f32d3329c9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $72caa8f32d3329c9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $72caa8f32d3329c9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $72caa8f32d3329c9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $72caa8f32d3329c9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$72caa8f32d3329c9$var$Buffer.byteLength = $72caa8f32d3329c9$var$byteLength;
function $72caa8f32d3329c9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $72caa8f32d3329c9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $72caa8f32d3329c9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $72caa8f32d3329c9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $72caa8f32d3329c9$var$latin1Slice(this, start, end);
        case 'base64':
            return $72caa8f32d3329c9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $72caa8f32d3329c9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$72caa8f32d3329c9$var$Buffer.prototype._isBuffer = true;
function $72caa8f32d3329c9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$72caa8f32d3329c9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$72caa8f32d3329c9$var$swap(this, i, i + 1);
    return this;
};
$72caa8f32d3329c9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $72caa8f32d3329c9$var$swap(this, i, i + 3);
        $72caa8f32d3329c9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$72caa8f32d3329c9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $72caa8f32d3329c9$var$swap(this, i, i + 7);
        $72caa8f32d3329c9$var$swap(this, i + 1, i + 6);
        $72caa8f32d3329c9$var$swap(this, i + 2, i + 5);
        $72caa8f32d3329c9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$72caa8f32d3329c9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $72caa8f32d3329c9$var$utf8Slice(this, 0, length);
    return $72caa8f32d3329c9$var$slowToString.apply(this, arguments);
};
$72caa8f32d3329c9$var$Buffer.prototype.toLocaleString = $72caa8f32d3329c9$var$Buffer.prototype.toString;
$72caa8f32d3329c9$var$Buffer.prototype.equals = function equals(b) {
    if (!$72caa8f32d3329c9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $72caa8f32d3329c9$var$Buffer.compare(this, b) === 0;
};
$72caa8f32d3329c9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $72caa8f32d3329c9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($72caa8f32d3329c9$var$customInspectSymbol) $72caa8f32d3329c9$var$Buffer.prototype[$72caa8f32d3329c9$var$customInspectSymbol] = $72caa8f32d3329c9$var$Buffer.prototype.inspect;
$72caa8f32d3329c9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($72caa8f32d3329c9$var$isInstance(target, Uint8Array)) target = $72caa8f32d3329c9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$72caa8f32d3329c9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $72caa8f32d3329c9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($72caa8f32d3329c9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $72caa8f32d3329c9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($72caa8f32d3329c9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $72caa8f32d3329c9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $72caa8f32d3329c9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $72caa8f32d3329c9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$72caa8f32d3329c9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$72caa8f32d3329c9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $72caa8f32d3329c9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$72caa8f32d3329c9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $72caa8f32d3329c9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $72caa8f32d3329c9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($72caa8f32d3329c9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $72caa8f32d3329c9$var$utf8Write(buf, string, offset, length) {
    return $72caa8f32d3329c9$var$blitBuffer($72caa8f32d3329c9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $72caa8f32d3329c9$var$asciiWrite(buf, string, offset, length) {
    return $72caa8f32d3329c9$var$blitBuffer($72caa8f32d3329c9$var$asciiToBytes(string), buf, offset, length);
}
function $72caa8f32d3329c9$var$base64Write(buf, string, offset, length) {
    return $72caa8f32d3329c9$var$blitBuffer($72caa8f32d3329c9$var$base64ToBytes(string), buf, offset, length);
}
function $72caa8f32d3329c9$var$ucs2Write(buf, string, offset, length) {
    return $72caa8f32d3329c9$var$blitBuffer($72caa8f32d3329c9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$72caa8f32d3329c9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $72caa8f32d3329c9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $72caa8f32d3329c9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $72caa8f32d3329c9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $72caa8f32d3329c9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $72caa8f32d3329c9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$72caa8f32d3329c9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $72caa8f32d3329c9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $b1b61c70b629423c$export$6100ba28696e12de(buf);
    else return $b1b61c70b629423c$export$6100ba28696e12de(buf.slice(start, end));
}
function $72caa8f32d3329c9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $72caa8f32d3329c9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $72caa8f32d3329c9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $72caa8f32d3329c9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $72caa8f32d3329c9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $72caa8f32d3329c9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $72caa8f32d3329c9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $72caa8f32d3329c9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $72caa8f32d3329c9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $72caa8f32d3329c9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $72caa8f32d3329c9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$72caa8f32d3329c9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $72caa8f32d3329c9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $72caa8f32d3329c9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$72caa8f32d3329c9$var$Buffer.prototype.readUintLE = $72caa8f32d3329c9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$72caa8f32d3329c9$var$Buffer.prototype.readUintBE = $72caa8f32d3329c9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$72caa8f32d3329c9$var$Buffer.prototype.readUint8 = $72caa8f32d3329c9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$72caa8f32d3329c9$var$Buffer.prototype.readUint16LE = $72caa8f32d3329c9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$72caa8f32d3329c9$var$Buffer.prototype.readUint16BE = $72caa8f32d3329c9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$72caa8f32d3329c9$var$Buffer.prototype.readUint32LE = $72caa8f32d3329c9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$72caa8f32d3329c9$var$Buffer.prototype.readUint32BE = $72caa8f32d3329c9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$72caa8f32d3329c9$var$Buffer.prototype.readBigUInt64LE = $72caa8f32d3329c9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $72caa8f32d3329c9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72caa8f32d3329c9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$72caa8f32d3329c9$var$Buffer.prototype.readBigUInt64BE = $72caa8f32d3329c9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $72caa8f32d3329c9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72caa8f32d3329c9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$72caa8f32d3329c9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$72caa8f32d3329c9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$72caa8f32d3329c9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$72caa8f32d3329c9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$72caa8f32d3329c9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$72caa8f32d3329c9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$72caa8f32d3329c9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$72caa8f32d3329c9$var$Buffer.prototype.readBigInt64LE = $72caa8f32d3329c9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $72caa8f32d3329c9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72caa8f32d3329c9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$72caa8f32d3329c9$var$Buffer.prototype.readBigInt64BE = $72caa8f32d3329c9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $72caa8f32d3329c9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72caa8f32d3329c9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$72caa8f32d3329c9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 4, this.length);
    return $b3684d424de2ad56$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$72caa8f32d3329c9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 4, this.length);
    return $b3684d424de2ad56$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$72caa8f32d3329c9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 8, this.length);
    return $b3684d424de2ad56$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$72caa8f32d3329c9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkOffset(offset, 8, this.length);
    return $b3684d424de2ad56$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $72caa8f32d3329c9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$72caa8f32d3329c9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$72caa8f32d3329c9$var$Buffer.prototype.writeUintLE = $72caa8f32d3329c9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $72caa8f32d3329c9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeUintBE = $72caa8f32d3329c9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $72caa8f32d3329c9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeUint8 = $72caa8f32d3329c9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeUint16LE = $72caa8f32d3329c9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeUint16BE = $72caa8f32d3329c9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeUint32LE = $72caa8f32d3329c9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeUint32BE = $72caa8f32d3329c9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $72caa8f32d3329c9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $72caa8f32d3329c9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $72caa8f32d3329c9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $72caa8f32d3329c9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$72caa8f32d3329c9$var$Buffer.prototype.writeBigUInt64LE = $72caa8f32d3329c9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $72caa8f32d3329c9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$72caa8f32d3329c9$var$Buffer.prototype.writeBigUInt64BE = $72caa8f32d3329c9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $72caa8f32d3329c9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$72caa8f32d3329c9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $72caa8f32d3329c9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $72caa8f32d3329c9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$72caa8f32d3329c9$var$Buffer.prototype.writeBigInt64LE = $72caa8f32d3329c9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $72caa8f32d3329c9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$72caa8f32d3329c9$var$Buffer.prototype.writeBigInt64BE = $72caa8f32d3329c9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $72caa8f32d3329c9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $72caa8f32d3329c9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $72caa8f32d3329c9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $b3684d424de2ad56$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$72caa8f32d3329c9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $72caa8f32d3329c9$var$writeFloat(this, value, offset, true, noAssert);
};
$72caa8f32d3329c9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $72caa8f32d3329c9$var$writeFloat(this, value, offset, false, noAssert);
};
function $72caa8f32d3329c9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72caa8f32d3329c9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $b3684d424de2ad56$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$72caa8f32d3329c9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $72caa8f32d3329c9$var$writeDouble(this, value, offset, true, noAssert);
};
$72caa8f32d3329c9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $72caa8f32d3329c9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$72caa8f32d3329c9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$72caa8f32d3329c9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$72caa8f32d3329c9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$72caa8f32d3329c9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $72caa8f32d3329c9$var$Buffer.isBuffer(val) ? val : $72caa8f32d3329c9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $72caa8f32d3329c9$var$errors = {};
function $72caa8f32d3329c9$var$E(sym, getMessage, Base) {
    $72caa8f32d3329c9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$72caa8f32d3329c9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$72caa8f32d3329c9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$72caa8f32d3329c9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $72caa8f32d3329c9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $72caa8f32d3329c9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $72caa8f32d3329c9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $72caa8f32d3329c9$var$checkBounds(buf, offset, byteLength) {
    $72caa8f32d3329c9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $72caa8f32d3329c9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $72caa8f32d3329c9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $72caa8f32d3329c9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $72caa8f32d3329c9$var$checkBounds(buf, offset, byteLength);
}
function $72caa8f32d3329c9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $72caa8f32d3329c9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $72caa8f32d3329c9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $72caa8f32d3329c9$var$validateNumber(value, type);
        throw new $72caa8f32d3329c9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $72caa8f32d3329c9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $72caa8f32d3329c9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $72caa8f32d3329c9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $72caa8f32d3329c9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($72caa8f32d3329c9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $72caa8f32d3329c9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $72caa8f32d3329c9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $72caa8f32d3329c9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $72caa8f32d3329c9$var$base64ToBytes(str) {
    return $b1b61c70b629423c$export$d622b2ad8d90c771($72caa8f32d3329c9$var$base64clean(str));
}
function $72caa8f32d3329c9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $72caa8f32d3329c9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $72caa8f32d3329c9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $72caa8f32d3329c9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $72caa8f32d3329c9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $72caa8f32d3329c9$var$BufferBigIntNotDefined : fn;
}
function $72caa8f32d3329c9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $6c9b670123ce891e$require$Buffer = $72caa8f32d3329c9$export$a143d493d941bafc;
const $6c9b670123ce891e$var$isDefined = (value)=>{
    return value !== undefined && value !== null;
};
const $6c9b670123ce891e$var$isString = (value)=>{
    return typeof value === 'string';
};
const $6c9b670123ce891e$var$isStringWithValue = (value)=>{
    return $6c9b670123ce891e$var$isString(value) && value !== '';
};
const $6c9b670123ce891e$var$isBlob = (value)=>{
    return typeof value === 'object' && value !== null && typeof value.type === 'string' && typeof value.stream === 'function' && typeof value.arrayBuffer === 'function' && typeof value.constructor === 'function' && typeof value.constructor.name === 'string' && /^(Blob|File)$/.test(value.constructor.name) && /^(Blob|File)$/.test(value[Symbol.toStringTag]);
};
const $6c9b670123ce891e$var$isFormData = (value)=>{
    return value instanceof FormData;
};
const $6c9b670123ce891e$var$base64 = (str)=>{
    try {
        return btoa(str);
    } catch (err) {
        return $6c9b670123ce891e$require$Buffer.from(str).toString('base64');
    }
};
const $6c9b670123ce891e$var$getQueryString = (params)=>{
    const qs = [];
    const append = (key, value)=>{
        qs.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    };
    const process = (key, value)=>{
        if ($6c9b670123ce891e$var$isDefined(value)) {
            if (Array.isArray(value)) value.forEach((v)=>{
                process(key, v);
            });
            else if (typeof value === 'object') Object.entries(value).forEach(([k, v])=>{
                process(`${key}[${k}]`, v);
            });
            else append(key, value);
        }
    };
    Object.entries(params).forEach(([key, value])=>{
        process(key, value);
    });
    if (qs.length > 0) return `?${qs.join('&')}`;
    return '';
};
const $6c9b670123ce891e$export$1b98eaf73d37f034 = ()=>(0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.url[(0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.url.length - 1] === '/' ? (0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.url.slice(0, -1) : (0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).api.url;
const $6c9b670123ce891e$var$getUrl = (config, options)=>{
    const encoder = config.ENCODE_PATH || encodeURI;
    const base = config.BASE[0] !== '/' ? `/${config.BASE}` : config.BASE;
    const path = options.url.replace(/{(.*?)}/g, (substring, group)=>{
        if (options.path && Object.prototype.hasOwnProperty.call(options.path, group)) return encoder(String(options.path[group]));
        return substring;
    });
    const apiUrl = $6c9b670123ce891e$export$1b98eaf73d37f034();
    const url = `${apiUrl}${base}${path}`;
    if (options.query) return `${url}${$6c9b670123ce891e$var$getQueryString(options.query)}`;
    return url;
};
const $6c9b670123ce891e$var$getFormData = (options)=>{
    if (options.formData) {
        const formData = new FormData();
        const process = (key, value)=>{
            if ($6c9b670123ce891e$var$isString(value) || $6c9b670123ce891e$var$isBlob(value)) formData.append(key, value);
            else formData.append(key, JSON.stringify(value));
        };
        Object.entries(options.formData).filter(([, value])=>$6c9b670123ce891e$var$isDefined(value)).forEach(([key, value])=>{
            if (Array.isArray(value)) value.forEach((v)=>process(key, v));
            else process(key, value);
        });
        return formData;
    }
    return undefined;
};
const $6c9b670123ce891e$var$resolve = async (options, resolver)=>{
    if (typeof resolver === 'function') return resolver(options);
    return resolver;
};
const $6c9b670123ce891e$var$getHeaders = async (config, options)=>{
    const token = await $6c9b670123ce891e$var$resolve(options, config.TOKEN);
    const username = await $6c9b670123ce891e$var$resolve(options, config.USERNAME);
    const password = await $6c9b670123ce891e$var$resolve(options, config.PASSWORD);
    const additionalHeaders = await $6c9b670123ce891e$var$resolve(options, config.HEADERS);
    const headers = Object.entries({
        Accept: 'application/json',
        ...additionalHeaders,
        ...options.headers
    }).filter(([, value])=>$6c9b670123ce891e$var$isDefined(value)).reduce((headers, [key, value])=>({
            ...headers,
            [key]: String(value)
        }), {});
    if ($6c9b670123ce891e$var$isStringWithValue(token)) headers['Authorization'] = `Bearer ${token}`;
    if ($6c9b670123ce891e$var$isStringWithValue(username) && $6c9b670123ce891e$var$isStringWithValue(password)) {
        const credentials = $6c9b670123ce891e$var$base64(`${username}:${password}`);
        headers['Authorization'] = `Basic ${credentials}`;
    }
    if (options.body) {
        if (options.mediaType) headers['Content-Type'] = options.mediaType;
        else if ($6c9b670123ce891e$var$isBlob(options.body)) headers['Content-Type'] = options.body.type || 'application/octet-stream';
        else if ($6c9b670123ce891e$var$isString(options.body)) headers['Content-Type'] = 'text/plain';
        else if (!$6c9b670123ce891e$var$isFormData(options.body)) headers['Content-Type'] = 'application/json';
    }
    return new Headers(headers);
};
const $6c9b670123ce891e$var$getRequestBody = (options)=>{
    if (options.body !== undefined) {
        if (options.mediaType?.includes('/json')) return JSON.stringify(options.body);
        else if ($6c9b670123ce891e$var$isString(options.body) || $6c9b670123ce891e$var$isBlob(options.body) || $6c9b670123ce891e$var$isFormData(options.body)) return options.body;
        else return JSON.stringify(options.body);
    }
    return undefined;
};
const $6c9b670123ce891e$export$d5a1e65f8aa21b51 = async (config, options, url, body, formData, headers, onCancel)=>{
    const controller = new AbortController();
    const request = {
        headers: headers,
        body: body ?? formData,
        method: options.method,
        signal: controller.signal
    };
    if (config.USE_CREDENTIALS) request.credentials = config.CREDENTIALS;
    onCancel(()=>controller.abort());
    return await fetch(url, request);
};
const $6c9b670123ce891e$var$getResponseHeader = (response, responseHeader)=>{
    if (responseHeader) {
        const content = response.headers.get(responseHeader);
        if ($6c9b670123ce891e$var$isString(content)) return content;
    }
    return undefined;
};
const $6c9b670123ce891e$var$getResponseBody = async (response)=>{
    if (response.status !== 204) try {
        const contentType = response.headers.get('Content-Type');
        if (contentType) {
            const jsonTypes = [
                'application/json',
                'application/problem+json'
            ];
            const isJSON = jsonTypes.some((type)=>contentType.toLowerCase().startsWith(type));
            if (isJSON) return await response.json();
            else return await response.text();
        }
    } catch (err) {
        console.error(err);
    }
    return undefined;
};
const $6c9b670123ce891e$var$catchErrorCodes = (options, result)=>{
    const errors = {
        400: 'Bad Request',
        401: 'Unauthorized',
        403: 'Forbidden',
        404: 'Not Found',
        422: 'Unprocessable Content',
        500: 'Internal Server Error',
        502: 'Bad Gateway',
        503: 'Service Unavailable',
        ...options.errors
    };
    const error = errors[result.status];
    if (error) throw new (0, $a11fedce377bfa25$export$f2e832acab1bdd79)(options, result, error);
    if (!result.ok) throw new (0, $a11fedce377bfa25$export$f2e832acab1bdd79)(options, result, 'Generic Error');
};
const $6c9b670123ce891e$export$b5fe3f66a567bec0 = (config, options)=>{
    return new (0, $d10444b79161e7f1$export$551a058e9626aa5a)(async (resolve, reject, onCancel)=>{
        try {
            const url = $6c9b670123ce891e$var$getUrl(config, options);
            const formData = $6c9b670123ce891e$var$getFormData(options);
            const body = $6c9b670123ce891e$var$getRequestBody(options);
            const headers = await $6c9b670123ce891e$var$getHeaders(config, options);
            if (!onCancel.isCancelled) {
                const response = await $6c9b670123ce891e$export$d5a1e65f8aa21b51(config, options, url, body, formData, headers, onCancel);
                const responseBody = await $6c9b670123ce891e$var$getResponseBody(response);
                const responseHeader = $6c9b670123ce891e$var$getResponseHeader(response, options.responseHeader);
                const result = {
                    url: url,
                    ok: response.ok,
                    status: response.status,
                    statusText: response.statusText,
                    body: responseHeader ?? responseBody
                };
                $6c9b670123ce891e$var$catchErrorCodes(options, result);
                resolve(result.body);
            }
        } catch (err) {
            console.error(err);
            reject(err);
        }
    });
};





class $df00e24747d28c11$export$37b37a9dc875f921 {
    /**
   * List Adjustments
   * @returns Adjustment[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/adjustments',
            query: req
        });
        return res;
    }
    /**
   * Get Adjustment
   * @param id TAdjustmentId
   * @returns Adjustment
   * @throws ApiError
   */ static async get(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/adjustments/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Create Adjustment
   * @param adjustment Adjustment
   * @returns Adjustment
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/adjustments',
            body: req
        });
        return res;
    }
    /**
   * Update Adjustment
   * @param adjustment Adjustment
   * @returns Adjustment
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/adjustments/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Delete Adjustment
   * @param id TAdjustmentId
   * @returns Adjustment
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/adjustments/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
}



class $92ab41bdff63d770$export$5d45644869e3cfc {
    /**
   * List Advances
   * @returns Advance[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/advances',
            query: req
        });
        return res;
    }
    /**
   * Get Advance
   * @param id TAdvanceId
   * @returns Advance
   * @throws ApiError
   */ static async get(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/advances/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Create Advance
   * @param advance Advance
   * @returns Advance
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/advances',
            body: req
        });
        return res;
    }
    /**
   * Update Advance
   * @param advance Advance
   * @returns Advance
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/advances/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Delete Advance
   * @param id TAdvanceId
   * @returns Advance
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/advances/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
}



class $995d980118c41d8f$export$29ef22b941ad5ba0 {
    /**
   * List Assets
   * @returns Asset[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/assets',
            query: req
        });
        return res;
    }
    /**
   * Get Asset Name
   * @param id TAssetId
   * @returns Asset
   * @throws ApiError
   */ static async getName(id) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/assets/{id}',
            path: {
                id: id
            },
            query: {
                include: '{_id,name}'
            }
        });
    }
    /**
   * Get Asset
   * @param id TAssetId
   * @returns Asset
   * @throws ApiError
   */ static async get(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/assets/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Create Asset
   * @param asset Asset
   * @returns Asset
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/assets',
            body: req
        });
        return res;
    }
    /**
   * Update Asset
   * @param asset Asset
   * @returns Asset
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/assets/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Delete Asset
   * @param id TAssetId
   * @returns Asset
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/assets/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
}



class $415208479c772fab$export$a15b8b4ccae62017 {
    /**
   * Signin
   */ static async signin(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/auth/signin',
            body: req
        });
        return res;
    }
    /**
   * Signout
   */ static async signout(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/auth/signout',
            body: req
        });
        return res;
    }
}



class $9ee2733bf62593c7$export$81a665b0338610f5 {
    /**
   * List Companies
   * @returns Company[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/companies',
            query: req
        });
        return res;
    }
    /**
   * Get Company
   * @param id TCompanyId
   * @returns Company
   * @throws ApiError
   */ static async get(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/companies/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Create Company
   * @param company Company
   * @returns Company
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/companies',
            body: req
        });
        return res;
    }
    /**
   * Update Company
   * @param company Company
   * @returns Company
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/companies/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Deactivate Company
   * @param id TCompanyId
   * @returns Company
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/companies/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
}



class $1fd8a92edc8c1db5$export$8bcf2a1e145214ea {
    /**
   * Formats/calculates Headlines response data
   */ static _interceptor = (headlines)=>{
        if (!headlines.assetCredit) headlines.assetCredit = 0;
        if (!headlines.assetValue) headlines.assetValue = 0;
        if (!headlines.availableCredit) headlines.availableCredit = 0;
        if (!headlines.feesDue) headlines.feesDue = 0;
        if (!headlines.feesPaid) headlines.feesPaid = 0;
        if (!headlines.interestDue) headlines.interestDue = 0;
        if (!headlines.interestPaid) headlines.interestPaid = 0;
        if (!headlines.principalBalance) headlines.principalBalance = 0;
        if (!headlines.totalRevenue) headlines.totalRevenue = 0;
        // Return
        return headlines;
    };
    /**
   * Get Headlines
   * @param id TReportId
   * @returns Report
   * @throws ApiError
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/headlines',
            query: req
        }));
    }
}



class $ead355dc3e4dafd9$export$6f059e92a7272a52 {
    /**
   * List Lenders
   * @returns Lender[]
   * @throws ApiError
   */ static async query(req) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/lenders',
            query: req
        });
    }
    /**
   * Get Lender
   * @param id TLenderId
   * @returns Lender
   * @throws ApiError
   */ static async get(id) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/lenders/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Deactivate Lender
   * @param id TLenderId
   * @returns Lender
   * @throws ApiError
   */ static async deactivate(id) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/companies/{id}',
            path: {
                id: id
            }
        });
    }
}



class $2674880b4f6f34a4$export$ebbafa41a7dafb5c {
    /**
   * Get Lender Statement Headlines
   * @returns Headline
   * @throws ApiError
   */ static async get(req) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/lender-statement-headlines',
            query: req
        });
    }
}



class $036b2e0dfab38af7$export$bc9e7cacb37e13e9 {
    /**
   * List Loans
   * @returns Loan[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/loans',
            query: req
        });
        return res;
    }
    /**
   * Get Loan Name
   * @param id TLoanId
   * @returns Loan
   * @throws ApiError
   */ static async getName(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/loans/{id}',
            path: {
                id: id
            },
            query: {
                include: '{_id,name}'
            }
        });
        return res;
    }
    /**
   * Get Loan
   * @param id TLoanId
   * @returns Loan
   * @throws ApiError
   */ static async get(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/loans/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Create Loan
   * @param loan Loan
   * @returns Loan
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/loans',
            body: req
        });
        return res;
    }
    /**
   * Update Loan
   * @param loan Loan
   * @returns Loan
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/loans/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Delete Loan
   * @param id TLoanId
   * @returns Loan
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/loans/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
}



class $4346f0317e5d5849$export$8790c55037488520 {
    /**
   * List Participations
   * @returns Participation[]
   * @throws ApiError
   */ static async query(req) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/participations',
            query: req
        });
    }
}



class $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8 {
    // TODO: re-implement the request/backoff timer from `payments.client.service.js`
    /**
   * List Payments
   * @returns Payment[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/payments',
            query: req
        });
        return res;
    }
    /**
   * Get Payment
   * @param id TPaymentId
   * @returns Payment
   * @throws ApiError
   */ static async get(id) {
        const paymentResponse = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/payments/{id}',
            path: {
                id: id
            }
        });
        const assetResponse = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/assets/{id}',
            path: {
                id: paymentResponse.assetId
            }
        });
        paymentResponse.asset = assetResponse;
        return paymentResponse;
    }
    /**
   * Create Payment
   * @param payment Payment
   * @returns Payment
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/payments',
            body: req
        });
        return res;
    }
    /**
   * Update Payment
   * @param payment Payment
   * @returns Payment
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/payments/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Delete Payment
   * @param id TPaymentId
   * @returns Payment
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/payments/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Get Payoff Estimate Report
   * @param id TLoanId
   * @returns Report
   * @throws ApiError
   */ static async getPayoffReport(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/payments/payoff-estimate-report/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Get Payoff Estimate Statement
   * @param loanId TLoanId
   * @param asOfDate Date
   * @returns Payment
   * @throws ApiError
   */ static async estimatePayoff({ loanId: loanId, asOfDate: asOfDate }) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/payments/payoff-estimate-statement/{loanId}/{asOfDate}',
            path: {
                loanId: loanId,
                asOfDate: asOfDate.toISOString()
            }
        });
        return res;
    }
}



class $78de0e464a7e5887$export$732ba14786ab16c9 {
    /**
   * Formats/calculates Assets & Payments response data
   */ static _interceptor = (balances)=>{
        const newBalances = [];
        for (const chartItem of balances.sunburstChart.children)if (chartItem.amount !== 0) newBalances.push({
            amount: chartItem.amount,
            company: chartItem.name ? chartItem.name : '',
            chartTitle: 'balances'
        });
        return newBalances;
    };
    /**
   * Get Loan Balances report
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/balances',
            query: req
        }));
    }
}



class $64b06aa07d3fa40d$export$953265e3a561b3f2 {
    /**
   * Formats/calculates CashFlow response data
   */ static _interceptor = (cashflow)=>{
        for(let i = 0, il = cashflow.byDate.length; i < il; i += 1){
            cashflow.byDate[i] = {
                month: cashflow.byDate[i].date
            };
            cashflow.byDate[i].advances = {
                payments: cashflow.byDate[i].payments,
                advances: cashflow.byDate[i].advances
            };
        }
        return cashflow.advances;
    };
    /**
   * Get Cash Flow report
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/cashflow',
            query: req
        }));
    }
}



class $78334dc192bf113d$export$4ae0a19c5571ff34 {
    /**
   * Formats/calculates LoanBalances response data
   */ static _interceptor = (balances)=>{
        const newBalances = [];
        for (const chartItem of balances.sunburstChart.children)if (chartItem.amount !== 0) newBalances.push({
            amount: chartItem.amount,
            company: chartItem.name ? chartItem.name : '',
            chartTitle: 'balances'
        });
        return newBalances;
    };
    /**
   * Get Loan Balances report
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/balances',
            query: req
        }));
    }
}




class $a06e9f24104da8b2$export$b892c6de60948fe9 {
    /**
   * Formats/calculates MonthlyActivity response data
   */ static _interceptor = (response)=>{
        // Pre-process the data
        if (response.length) for(const item in response){
            const d = response[item];
            let newData = [];
            const newItems = {
                advances: [],
                revenue: [],
                principalPayments: []
            };
            // Convert the dates into date objects
            d.month = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(d.month, 'YYYY-MM');
            for(const category in d.items){
                newData = [];
                if (d.items[category].length) for(const categoryItem in d.items[category]){
                    const dataItem = d.items[category][categoryItem];
                    // Remove items without value
                    if (dataItem.value) newData.push(dataItem);
                }
                newItems[category] = newData;
            }
            d.items = newItems;
            response[item] = d;
        }
        // Return the data
        return response;
    };
    /**
   * Get Monthly Activity report
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/monthly-activity',
            query: req
        }));
    }
}



class $95921c948e1c414c$export$6afbdc6ae408984b {
    /**
   * Formats/calculates Revenue response data
   */ static _interceptor = (revenue)=>{
        const costs = [];
        for (const company of revenue.byCompany)costs.push({
            amount: company.total,
            company: company.name,
            chartTitle: 'costs'
        });
        return costs;
    };
    /**
   * Get Revenue report
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/revenue',
            query: req
        }));
    }
}





class $fe5c98af9b155e38$export$dc1f3aaa2c25ddbc {
    static _interceptor = (headlines)=>{
        let balances = [];
        // End-of-month calcs
        if (headlines.month) {
            headlines.month.totalRevenue = headlines.month.appliedToFees + headlines.month.appliedToInterest;
            headlines.month.netRevenue = headlines.month.totalRevenue - headlines.month.managementFees;
            headlines.month.totalUnpaidRevenue = headlines.month.feeBalance + headlines.month.interestBalance;
            balances = [
                headlines.month.account.amountInvested,
                -Math.abs(headlines.month.principalBalance),
                headlines.month.appliedToFees,
                headlines.month.appliedToInterest,
                -Math.abs(headlines.month.managementFees),
                -Math.abs(headlines.month.account.amountReturned)
            ];
            headlines.month.balances = balances.reduce((prev, curr)=>prev + curr);
        }
        // YTD calcs
        if (headlines.ytd) {
            headlines.ytd.totalRevenue = headlines.ytd.appliedToFees + headlines.ytd.appliedToInterest;
            headlines.ytd.netRevenue = headlines.ytd.totalRevenue - headlines.ytd.managementFees;
            headlines.ytd.totalUnpaidRevenue = headlines.ytd.feeBalance + headlines.ytd.interestBalance;
            balances = [
                headlines.ytd.account.amountInvested,
                -Math.abs(headlines.ytd.principalBalance),
                headlines.ytd.appliedToFees,
                headlines.ytd.appliedToInterest,
                -Math.abs(headlines.ytd.managementFees),
                -Math.abs(headlines.ytd.account.amountReturned)
            ];
            headlines.ytd.balances = balances.reduce((prev, curr)=>prev + curr);
        }
        // All-time calcs
        if (headlines.alltime) {
            headlines.alltime.totalRevenue = headlines.alltime.appliedToFees + headlines.alltime.appliedToInterest;
            headlines.alltime.netRevenue = headlines.alltime.totalRevenue - headlines.alltime.managementFees;
            headlines.alltime.totalUnpaidRevenue = headlines.alltime.feeBalance + headlines.alltime.interestBalance;
            balances = [
                headlines.alltime.account.amountInvested,
                -Math.abs(headlines.alltime.principalBalance),
                headlines.alltime.appliedToFees,
                headlines.alltime.appliedToInterest,
                -Math.abs(headlines.alltime.managementFees),
                -Math.abs(headlines.alltime.account.amountReturned)
            ];
            headlines.alltime.balances = balances.reduce((prev, curr)=>prev + curr);
        }
        // Return the data
        return headlines;
    };
    /**
   * Get Statement Headlines
   * @returns Headline
   * @throws ApiError
   */ static async get(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/reports/statement-headlines',
            query: req
        }));
    }
}



class $76ba802ebedc9513$export$5311a4c759a4a703 {
    /**
   * List Loan Statements
   * @returns Statement[]
   * @throws ApiError
   */ static async queryStatements(query) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/transactions/:loanId/:statementId',
            query: query
        });
    }
}









var $c6a113d11e099562$export$d4654b2858949cbe = /*#__PURE__*/ function(AlertStatus) {
    AlertStatus["Unread"] = "unread";
    AlertStatus["Read"] = "read";
    return AlertStatus;
}({});


var $16167722a89c0415$export$ea3addc32bc92d57 = /*#__PURE__*/ function(AssetStatus) {
    AssetStatus["Open"] = "open";
    AssetStatus["Closed"] = "closed";
    AssetStatus["Pending"] = "pending";
    AssetStatus["ShortPay"] = "short-pay";
    AssetStatus["OverPaid"] = "over-paid";
    AssetStatus["PaidInFull"] = "paid-in-full";
    return AssetStatus;
}({});
var $16167722a89c0415$export$e57062a38354425e = /*#__PURE__*/ function(AssetType) {
    AssetType["CA LCFS"] = "CA LCFS";
    AssetType["CA FCI"] = "CA FCI";
    AssetType["OR CFP"] = "OR CFP";
    AssetType["WA CFS"] = "WA CFS";
    AssetType["BC LCFS"] = "BC LCFS";
    AssetType["CAN CFR"] = "CAN CFR";
    AssetType["Other"] = "Other";
    return AssetType;
}({});






var $5c4a9f32b679a002$export$cec65c3c11b5d5c1 = /*#__PURE__*/ function(CompanyStatus) {
    CompanyStatus["Active"] = "active";
    CompanyStatus["Inactive"] = "inactive";
    CompanyStatus["Closed"] = "closed";
    CompanyStatus["WorkOut"] = "work-out";
    CompanyStatus["Suspended"] = "suspended";
    return CompanyStatus;
}({});
var $5c4a9f32b679a002$export$65e03f16ca8e7cd5 = /*#__PURE__*/ function(SocketLineOfBusiness) {
    SocketLineOfBusiness["Tech"] = "Tech";
    SocketLineOfBusiness["Medical"] = "Medical";
    SocketLineOfBusiness["HardGoods"] = "HardGoods";
    SocketLineOfBusiness["Food"] = "Food";
    SocketLineOfBusiness["Media"] = "Media";
    SocketLineOfBusiness["Service"] = "Service";
    SocketLineOfBusiness["Energy"] = "Energy";
    SocketLineOfBusiness["Lender"] = "Lender";
    SocketLineOfBusiness["Investor"] = "Investor";
    SocketLineOfBusiness["Other"] = "Other";
    return SocketLineOfBusiness;
}({});


var $50e9e5a88f291ca6$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    return FileType;
}({});
var $50e9e5a88f291ca6$export$f7cdc72f22de79df = /*#__PURE__*/ function(UploadStatus) {
    UploadStatus["Ready"] = "ready";
    UploadStatus["Queued"] = "queued";
    UploadStatus["Uploading"] = "uploading";
    UploadStatus["Done"] = "done";
    return UploadStatus;
}({});






var $2dfb8a4751b2faae$export$34b52ce9cfcb0a39 = /*#__PURE__*/ function(PaymentMethod) {
    PaymentMethod["None"] = "None";
    PaymentMethod["SetAmount"] = "Set Amount";
    PaymentMethod["FeesAndInterest"] = "Fees + Interest";
    PaymentMethod["PayDown"] = "Pay Down";
    return PaymentMethod;
}({});
var $2dfb8a4751b2faae$export$bbc9c51434c18c55 = /*#__PURE__*/ function(LoanStatus) {
    LoanStatus["Active"] = "active";
    LoanStatus["Inactive"] = "inactive";
    LoanStatus["PaidOff"] = "paid-off";
    return LoanStatus;
}({});
var $2dfb8a4751b2faae$export$bb78da1c05bb8d09 = /*#__PURE__*/ function(LoanType) {
    LoanType["Loan"] = "Loan Deal";
    LoanType["Owned"] = "Owned Deal";
    return LoanType;
}({});






/**
 * Forgot Password Request
 */ 

var $6094cb98919e34c7$export$35df6b9ddec9b15d = /*#__PURE__*/ function(PayoffType) {
    PayoffType["Check"] = "Check";
    PayoffType["Cash"] = "Cash";
    PayoffType["Credit"] = "Credit";
    return PayoffType;
}({});


var $164c4db93398e7b4$export$b741539d6da07114 = /*#__PURE__*/ function(MonthlyActivityCategory) {
    MonthlyActivityCategory["Advances"] = "advances";
    MonthlyActivityCategory["Revenue"] = "revenue";
    MonthlyActivityCategory["PrincipalPayments"] = "principalPayments";
    return MonthlyActivityCategory;
}({});




var $989a2d26b0fc80b4$export$eb3485a690c2f0b8 = /*#__PURE__*/ function(UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Company"] = "user";
    UserRole["Investor"] = "lender";
    return UserRole;
}({});
var $989a2d26b0fc80b4$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Active"] = "active";
    UserStatus["Inactive"] = "inactive";
    return UserStatus;
}({});


var $dff1c8c0bf270f18$export$d0d7df129860d081 = /*#__PURE__*/ function(DateRangeType) {
    DateRangeType["Yearly"] = "yearly";
    DateRangeType["Monthly"] = "monthly";
    DateRangeType["Weekly"] = "weekly";
    return DateRangeType;
}({});
var $dff1c8c0bf270f18$export$4a453a419d731b2d = /*#__PURE__*/ function(DateRangeAction) {
    DateRangeAction["Next"] = "next";
    DateRangeAction["Previous"] = "previous";
    return DateRangeAction;
}({});
var $dff1c8c0bf270f18$export$c79d5012e88c1e24 = /*#__PURE__*/ function(MenuItemType) {
    MenuItemType["Dropdown"] = "dropdown";
    MenuItemType["Item"] = "item";
    return MenuItemType;
}({});
var $dff1c8c0bf270f18$export$25c0d5b425a20ec = /*#__PURE__*/ function(StorageKeys) {
    StorageKeys["SessionToken"] = "fuse-financial:sessionToken";
    StorageKeys["SessionUser"] = "fuse-financial:sessionUser";
    StorageKeys["SessionExpiration"] = "fuse-financial:sessionExpiration";
    StorageKeys["Session"] = "fuse-financial:session";
    return StorageKeys;
}({});
var $dff1c8c0bf270f18$export$4c61f29f9791c495 = /*#__PURE__*/ function(DataModelType) {
    DataModelType["Account"] = "Account";
    DataModelType["Adjustment"] = "Adjustment";
    DataModelType["Advance"] = "Advance";
    DataModelType["Alert"] = "Alert";
    DataModelType["Asset"] = "Asset";
    DataModelType["Company"] = "Company";
    DataModelType["Lender"] = "Investor";
    DataModelType["Loan"] = "Deal";
    DataModelType["Note"] = "Note";
    DataModelType["Participation"] = "Participation";
    DataModelType["Payment"] = "Payment";
    DataModelType["Report"] = "Report";
    DataModelType["Statement"] = "Statement";
    DataModelType["Transaction"] = "Transaction";
    DataModelType["User"] = "User";
    return DataModelType;
}({});
var $dff1c8c0bf270f18$export$b99e2dfdc8527d3c = /*#__PURE__*/ function(DataModelPluralType) {
    DataModelPluralType["Account"] = "accounts";
    DataModelPluralType["Adjustment"] = "adjustments";
    DataModelPluralType["Advance"] = "advances";
    DataModelPluralType["Alert"] = "alerts";
    DataModelPluralType["Asset"] = "assets";
    DataModelPluralType["Company"] = "companies";
    DataModelPluralType["Lender"] = "investors";
    DataModelPluralType["Loan"] = "deals";
    DataModelPluralType["Note"] = "notes";
    DataModelPluralType["Participation"] = "participations";
    DataModelPluralType["Payment"] = "payments";
    DataModelPluralType["Report"] = "reports";
    DataModelPluralType["Statement"] = "statements";
    DataModelPluralType["Transaction"] = "transactions";
    DataModelPluralType["User"] = "users";
    return DataModelPluralType;
}({});
const $dff1c8c0bf270f18$export$5f1ddd061a43f32d = {
    ["Account"]: "accounts",
    ["Adjustment"]: "adjustments",
    ["Advance"]: "advances",
    ["Alert"]: "alerts",
    ["Asset"]: "assets",
    ["Company"]: "companies",
    ["Investor"]: "investors",
    ["Deal"]: "deals",
    ["Note"]: "notes",
    ["Participation"]: "participations",
    ["Payment"]: "payments",
    ["Report"]: "reports",
    ["Statement"]: "statements",
    ["Transaction"]: "transactions",
    ["User"]: "users"
};
var $dff1c8c0bf270f18$export$e4d8b68a62928ba3 = /*#__PURE__*/ function(CRUDMode) {
    CRUDMode["Create"] = "create";
    CRUDMode["Edit"] = "edit";
    CRUDMode["Remove"] = "remove";
    CRUDMode["Read"] = "read";
    CRUDMode["View"] = "view";
    return CRUDMode;
}({});
var $dff1c8c0bf270f18$export$b1f97c3099fc6872 = /*#__PURE__*/ function(Region) {
    Region[Region["AL"] = 0] = "AL";
    Region[Region["AK"] = 1] = "AK";
    Region[Region["AZ"] = 2] = "AZ";
    Region[Region["AR"] = 3] = "AR";
    Region[Region["CA"] = 4] = "CA";
    Region[Region["CO"] = 5] = "CO";
    Region[Region["CT"] = 6] = "CT";
    Region[Region["DC"] = 7] = "DC";
    Region[Region["DE"] = 8] = "DE";
    Region[Region["FL"] = 9] = "FL";
    Region[Region["GA"] = 10] = "GA";
    Region[Region["HI"] = 11] = "HI";
    Region[Region["ID"] = 12] = "ID";
    Region[Region["IL"] = 13] = "IL";
    Region[Region["IN"] = 14] = "IN";
    Region[Region["IA"] = 15] = "IA";
    Region[Region["KS"] = 16] = "KS";
    Region[Region["KY"] = 17] = "KY";
    Region[Region["LA"] = 18] = "LA";
    Region[Region["ME"] = 19] = "ME";
    Region[Region["MD"] = 20] = "MD";
    Region[Region["MA"] = 21] = "MA";
    Region[Region["MI"] = 22] = "MI";
    Region[Region["MN"] = 23] = "MN";
    Region[Region["MS"] = 24] = "MS";
    Region[Region["MO"] = 25] = "MO";
    Region[Region["MT"] = 26] = "MT";
    Region[Region["NE"] = 27] = "NE";
    Region[Region["NV"] = 28] = "NV";
    Region[Region["NH"] = 29] = "NH";
    Region[Region["NJ"] = 30] = "NJ";
    Region[Region["NM"] = 31] = "NM";
    Region[Region["NY"] = 32] = "NY";
    Region[Region["NC"] = 33] = "NC";
    Region[Region["ND"] = 34] = "ND";
    Region[Region["OH"] = 35] = "OH";
    Region[Region["OK"] = 36] = "OK";
    Region[Region["OR"] = 37] = "OR";
    Region[Region["PA"] = 38] = "PA";
    Region[Region["RI"] = 39] = "RI";
    Region[Region["SC"] = 40] = "SC";
    Region[Region["SD"] = 41] = "SD";
    Region[Region["TN"] = 42] = "TN";
    Region[Region["TX"] = 43] = "TX";
    Region[Region["UT"] = 44] = "UT";
    Region[Region["VT"] = 45] = "VT";
    Region[Region["VA"] = 46] = "VA";
    Region[Region["WA"] = 47] = "WA";
    Region[Region["WV"] = 48] = "WV";
    Region[Region["WI"] = 49] = "WI";
    Region[Region["WY"] = 50] = "WY";
    return Region;
}({});


class $6ab62f0bff533817$export$31e7a36e1317b801 {
    static _interceptor = (transactions)=>{
        const statements = [];
        // Prepare totals (for entire transaction history)
        const totals = {
            feesCharged: 0,
            feeTotal: 0,
            feesPaid: 0,
            interestCharged: 0,
            interestPaid: 0,
            principalPaid: 0,
            currentPrincipal: 0,
            advanceAmount: 0,
            adjustmentAmount: 0,
            paymentAmount: 0
        };
        let allAdjustments = true;
        // Pre-process the data
        if (transactions.length) {
            let transaction;
            for(const txn in transactions){
                transaction = transactions[txn];
                // Push all statement transactions to the Statements array
                if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement) statements.push(transaction);
                // Skip the transaction if it's an adjustment
                if (transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment) {
                    // Set the 'list is all adjustments' flag to false
                    allAdjustments = false;
                    // Define some item-specific totals
                    if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance) {
                        transaction.advanceAmount = transaction.amount;
                        totals.advanceAmount += transaction.amount;
                    } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment) {
                        transaction.paymentAmount = transaction.amount;
                        totals.paymentAmount += transaction.amount;
                    }
                    // Total fees
                    transaction.feeTotal = transaction.fees + transaction.lateFee;
                    totals.feeTotal += transaction.feeTotal;
                    // Fees charged
                    totals.feesCharged += transaction.feeTotal;
                    // Fees due
                    transaction.feesDue = transaction.feeBalance + transaction.feeTotal;
                    // Fees paid
                    if (transaction.appliedToFees) {
                        transaction.feesDue -= transaction.appliedToFees;
                        totals.feesPaid += transaction.appliedToFees;
                    }
                    // Interest due
                    transaction.interestDue = transaction.interestBalance + transaction.interestCharge;
                    totals.interestCharged += transaction.interestCharge;
                    // Interest paid
                    if (transaction.appliedToInterest) {
                        transaction.interestDue -= transaction.appliedToInterest;
                        totals.interestPaid += transaction.appliedToInterest;
                    }
                    // Principal balance
                    if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance) {
                        transaction.newPrincipalBalance = transaction.principalBalance + transaction.amount;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                    } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment) {
                        transaction.newPrincipalBalance = transaction.principalBalance - transaction.appliedToPrincipal;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                        totals.principalPaid += transaction.appliedToPrincipal;
                    } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment) {
                        transaction.newPrincipalBalance = transaction.principalBalance;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                    }
                }
            }
            if (transactions && transactions[0]) {
                if (transactions[0].newPrincipalBalance) totals.currentPrincipal = transactions[0].newPrincipalBalance;
                if (transactions[0].assetValue) totals.currentAssets = transactions[0].assetValue;
                if (transactions[0].currentAvailableCredit) totals.currentAvailableCredit = transactions[0].currentAvailableCredit;
            }
        }
        // Return the data
        return {
            transactions: transactions,
            totals: totals,
            allAdjustments: allAdjustments
        };
    };
    /**
   * Get Loan Transactions
   */ static async query(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/transactions',
            query: req
        }));
    }
}



var $2c379471d5bc2795$exports = {};
var $4bb6caff349888e9$exports = {};

$parcel$export($4bb6caff349888e9$exports, "currency", function () { return $4bb6caff349888e9$export$f4f21ed02b0ddb8f; });
$parcel$export($4bb6caff349888e9$exports, "decimal", function () { return $4bb6caff349888e9$export$78a48a3d1e5dbe89; });
$parcel$export($4bb6caff349888e9$exports, "percent", function () { return $4bb6caff349888e9$export$626336c2cd4b14de; });
$parcel$export($4bb6caff349888e9$exports, "toJSON", function () { return $4bb6caff349888e9$export$54fd2c36b5cc6731; });
$parcel$export($4bb6caff349888e9$exports, "getSpeedDialActionProps", function () { return $4bb6caff349888e9$export$5ddecab480f41f9a; });


var $92iwa = parcelRequire("92iwa");
const $f54d11072eae9148$var$amber = {
    50: '#fff8e1',
    100: '#ffecb3',
    200: '#ffe082',
    300: '#ffd54f',
    400: '#ffca28',
    500: '#ffc107',
    600: '#ffb300',
    700: '#ffa000',
    800: '#ff8f00',
    900: '#ff6f00',
    A100: '#ffe57f',
    A200: '#ffd740',
    A400: '#ffc400',
    A700: '#ffab00'
};
var $f54d11072eae9148$export$2e2bcd8739ae039 = $f54d11072eae9148$var$amber;

const $f66a31a22c309759$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $f66a31a22c309759$export$2e2bcd8739ae039 = $f66a31a22c309759$var$indigo;


var $5UBAX = parcelRequire("5UBAX");
const $5b108f16e2d84dda$export$bca14c5b3b88a9c9 = (0, $92iwa.default)({
    palette: {
        primary: {
            main: (0, $f66a31a22c309759$export$2e2bcd8739ae039)[500]
        },
        secondary: {
            main: (0, $f54d11072eae9148$export$2e2bcd8739ae039)[500]
        },
        warning: {
            main: (0, $5UBAX.default)[500]
        }
    }
});
const $5b108f16e2d84dda$export$4aa0a1b480cdb1b6 = {
    accent: '#EAAD47',
    gray: '#EAECEF',
    placeholderText: 'rgb(102, 102, 102)'
};
const $5b108f16e2d84dda$export$569885e57444f84a = [
    // Indigos
    '#E8EAF6',
    '#C5CAE9',
    '#9FA8DA',
    '#7986CB',
    '#5C6BC0',
    '#316399',
    '#3949AB',
    '#303F9F',
    '#283593',
    '#EAAD47',
    '#FFB300',
    '#FFA000',
    '#FF8F00',
    '#FF6F00'
];


const $4bb6caff349888e9$export$f4f21ed02b0ddb8f = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});
const $4bb6caff349888e9$export$78a48a3d1e5dbe89 = new Intl.NumberFormat('en-US', {
    style: 'decimal'
});
const $4bb6caff349888e9$export$626336c2cd4b14de = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const $4bb6caff349888e9$export$54fd2c36b5cc6731 = (input)=>{
    if (!input) return;
    try {
        return JSON.parse(input);
    } catch (_) {
        return;
    }
};
const $4bb6caff349888e9$export$5ddecab480f41f9a = (actionType, label, tooltip)=>{
    switch(actionType){
        case (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit:
            return {
                fab: {
                    'aria-label': label,
                    className: 'md-fab md-mini md-accent md-button md-default-theme'
                },
                tooltip: {
                    title: tooltip || label
                }
            };
        case (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Remove:
            return {
                fab: {
                    'aria-label': label,
                    className: 'md-fab md-mini md-warn md-button md-default-theme',
                    style: {
                        background: (0, $5b108f16e2d84dda$export$bca14c5b3b88a9c9).palette.warning.main,
                        color: 'white'
                    }
                },
                tooltip: {
                    title: tooltip || label
                }
            };
        default:
            return {};
    }
};


var $f90d087769f90e7b$exports = {};

$parcel$export($f90d087769f90e7b$exports, "isNumber", function () { return $f90d087769f90e7b$export$7e4aa119212bc614; });
const $f90d087769f90e7b$export$7e4aa119212bc614 = (value)=>typeof value === 'number' || !Number.isNaN(parseFloat(value));


var $ca0b580bae42961b$exports = {};

$parcel$export($ca0b580bae42961b$exports, "getSessionToken", function () { return $ca0b580bae42961b$export$70d175fe2fbaa383; });
$parcel$export($ca0b580bae42961b$exports, "setSessionToken", function () { return $ca0b580bae42961b$export$46b0b91198def893; });
$parcel$export($ca0b580bae42961b$exports, "removeSessionToken", function () { return $ca0b580bae42961b$export$cd1eacef65db9ebc; });
$parcel$export($ca0b580bae42961b$exports, "getSessionUser", function () { return $ca0b580bae42961b$export$a79e7ef8c396bb0e; });
$parcel$export($ca0b580bae42961b$exports, "setSessionUser", function () { return $ca0b580bae42961b$export$97851c88c0bf33aa; });
$parcel$export($ca0b580bae42961b$exports, "removeSessionUser", function () { return $ca0b580bae42961b$export$b0ef8831976e9d68; });
$parcel$export($ca0b580bae42961b$exports, "getSessionExpiration", function () { return $ca0b580bae42961b$export$599cd8c85ed06f71; });
$parcel$export($ca0b580bae42961b$exports, "setSessionExpiration", function () { return $ca0b580bae42961b$export$d7dfbce2d184dd6; });
$parcel$export($ca0b580bae42961b$exports, "removeSessionExpiration", function () { return $ca0b580bae42961b$export$6d845b163d151800; });


const $ca0b580bae42961b$export$70d175fe2fbaa383 = (key)=>{
    return (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).get(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionToken);
};
const $ca0b580bae42961b$export$46b0b91198def893 = (token, key)=>{
    (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).set(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionToken, token);
};
const $ca0b580bae42961b$export$cd1eacef65db9ebc = (key)=>{
    (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).remove(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionToken);
};
const $ca0b580bae42961b$export$a79e7ef8c396bb0e = (key)=>{
    return (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).get(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionUser);
};
const $ca0b580bae42961b$export$97851c88c0bf33aa = (user, key)=>{
    (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).set(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionUser, user);
};
const $ca0b580bae42961b$export$b0ef8831976e9d68 = (key)=>{
    (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).remove(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionUser);
};
const $ca0b580bae42961b$export$599cd8c85ed06f71 = (key)=>{
    return (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).get(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionExpiration);
};
const $ca0b580bae42961b$export$d7dfbce2d184dd6 = (expiration, key)=>{
    (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).set(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionExpiration, expiration);
};
const $ca0b580bae42961b$export$6d845b163d151800 = (key)=>{
    (0, $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c).remove(key ?? (0, $dff1c8c0bf270f18$export$25c0d5b425a20ec).SessionExpiration);
};


var $95a9e3a3afe1e6c3$exports = {};

$parcel$export($95a9e3a3afe1e6c3$exports, "Storage", function () { return $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c; });
class $95a9e3a3afe1e6c3$export$bf2a15d34f3c441c {
    static get(key, defaultValue = '') {
        if (typeof window !== 'undefined') {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
            return defaultValue;
        }
        return false;
    }
    static set(key, value) {
        if (typeof window !== 'undefined') {
            const valueToStr = JSON.stringify(value || '');
            localStorage.setItem(key, valueToStr);
        }
    }
    static remove(key) {
        if (typeof window !== 'undefined') localStorage.removeItem(key);
    }
    static removeAll() {
        if (typeof window !== 'undefined') localStorage.clear();
    }
}


var $8597a53da626d345$exports = {};

$parcel$export($8597a53da626d345$exports, "getMonths", function () { return $8597a53da626d345$export$ab152e6ff2cc840e; });
$parcel$export($8597a53da626d345$exports, "dataSorter", function () { return $8597a53da626d345$export$50499dcf398ab867; });
$parcel$export($8597a53da626d345$exports, "getWidth", function () { return $8597a53da626d345$export$3c49c185de0c2bfc; });
$parcel$export($8597a53da626d345$exports, "getBarWidth", function () { return $8597a53da626d345$export$55382f732810ce34; });
$parcel$export($8597a53da626d345$exports, "stripPunctuation", function () { return $8597a53da626d345$export$871ad45925ecebef; });
$parcel$export($8597a53da626d345$exports, "toCamelCase", function () { return $8597a53da626d345$export$86f54f62aa7a7514; });
$parcel$export($8597a53da626d345$exports, "convertCamelCase", function () { return $8597a53da626d345$export$c8d7cffe57163567; });
// Localization
const $50c68e19ba8e5079$export$8eebe5cdb07c3b08 = '$';
const $50c68e19ba8e5079$export$398db890a5d5c686 = ',';
const $50c68e19ba8e5079$export$93cc62f3860b8d09 = '.';
const $50c68e19ba8e5079$export$26e685d98fdeb12f = 'M/D/YY';
const $50c68e19ba8e5079$export$237cfe6dcad1a246 = 'MMM D, YYYY';
const $50c68e19ba8e5079$export$73df931598513ca3 = 'MMMM D, YYYY';
const $50c68e19ba8e5079$export$808a00d1bbeaf439 = 'MMMM YYYY';
const $50c68e19ba8e5079$export$bfc92d8962c59fa1 = 'YYYY-MM-DD';
const $50c68e19ba8e5079$export$2e59fa295abca125 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];


var $2a584e384e0c1f6d$exports = {};

$parcel$export($2a584e384e0c1f6d$exports, "AxisLabel", function () { return $2a584e384e0c1f6d$export$921c750a0983d74c; });
class $2a584e384e0c1f6d$export$921c750a0983d74c {
    axis;
    text = '';
    position;
    classes;
    styles;
    element;
    constructor(axis, text = '', position, classes, styles){
        if (!axis || !text) return;
        this.axis = axis;
        this.text = text;
        this.position = position ? position : undefined;
        this.classes = classes ? classes : undefined;
        this.styles = styles ? styles : undefined;
        this.element = this.axis.append('text');
        if (this.position) for(const item in this.position)this.element.attr(item, this.position[item]);
        if (this.classes) this.element.attr('class', classes);
        if (this.styles) {
            if (this.styles.length) for(const style in this.styles)this.element.style(style, this.styles[style]);
        }
        this.element.text(text);
    }
}


var $f114d6e387da3e11$exports = {};

$parcel$export($f114d6e387da3e11$exports, "Chart", function () { return $f114d6e387da3e11$export$acaa6426d77a227e; });
var $ae834e1b2abe4e5d$export$a8ff84c12d48cfa6 = "d3";
var $ae834e1b2abe4e5d$export$83d89fbfd8236492 = "4.13.0";
var $ae834e1b2abe4e5d$export$6d59db4903f20f7d = "Data-Driven Documents";
var $ae834e1b2abe4e5d$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $ae834e1b2abe4e5d$export$4cec2234a9c7ce6d = "https://d3js.org";
var $ae834e1b2abe4e5d$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $ae834e1b2abe4e5d$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $ae834e1b2abe4e5d$export$f22da7240b7add18 = "build/d3.node.js";
var $ae834e1b2abe4e5d$export$101358e655b23e68 = "build/d3.min.js";
var $ae834e1b2abe4e5d$export$a2877c4988dda7ec = "build/d3.min.js";
var $ae834e1b2abe4e5d$export$130be424786e852f = "index";
var $ae834e1b2abe4e5d$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $ae834e1b2abe4e5d$export$e0fef70db1fd3806 = {
    "pretest": "rimraf build && mkdir build && json2module package.json > build/package.js && node rollup.node",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "npm run test && rollup -c --banner \"$(preamble)\" && uglifyjs -b beautify=false,preamble=\"'$(preamble)'\" build/d3.js -c negate_iife=false -m -o build/d3.min.js",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/build/d3.js d3.v4.js && cp ../d3/build/d3.min.js d3.v4.min.js && git add d3.v4.js d3.v4.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/build/d3.js ../d3/build/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j build/d3.zip -- LICENSE README.md API.md CHANGES.md build/d3.js build/d3.min.js"
};
var $ae834e1b2abe4e5d$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "package-preamble": "0.1",
    "rimraf": "2",
    "rollup": "0.53",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "3",
    "tape": "4",
    "uglify-js": "3.2"
};
var $ae834e1b2abe4e5d$export$b74ff737e0e298b5 = {
    "d3-array": "1.2.1",
    "d3-axis": "1.0.8",
    "d3-brush": "1.0.4",
    "d3-chord": "1.0.4",
    "d3-collection": "1.0.4",
    "d3-color": "1.0.3",
    "d3-dispatch": "1.0.3",
    "d3-drag": "1.2.1",
    "d3-dsv": "1.0.8",
    "d3-ease": "1.0.3",
    "d3-force": "1.1.0",
    "d3-format": "1.2.2",
    "d3-geo": "1.9.1",
    "d3-hierarchy": "1.1.5",
    "d3-interpolate": "1.1.6",
    "d3-path": "1.0.5",
    "d3-polygon": "1.0.3",
    "d3-quadtree": "1.0.3",
    "d3-queue": "3.0.7",
    "d3-random": "1.1.0",
    "d3-request": "1.0.6",
    "d3-scale": "1.0.7",
    "d3-selection": "1.3.0",
    "d3-shape": "1.2.0",
    "d3-time": "1.0.8",
    "d3-time-format": "2.1.1",
    "d3-timer": "1.0.7",
    "d3-transition": "1.1.1",
    "d3-voronoi": "1.1.2",
    "d3-zoom": "1.7.1"
};


function $d5ec0898dbf13e3e$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $8316d101034f510b$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $8316d101034f510b$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $8316d101034f510b$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $d5ec0898dbf13e3e$export$2e2bcd8739ae039)(f(d), x);
    };
}


var $19968a669a9ddbe8$var$ascendingBisect = (0, $8316d101034f510b$export$2e2bcd8739ae039)((0, $d5ec0898dbf13e3e$export$2e2bcd8739ae039));
var $19968a669a9ddbe8$export$4d945ad3ad5751b0 = $19968a669a9ddbe8$var$ascendingBisect.right;
var $19968a669a9ddbe8$export$df7d25c84ebd12a5 = $19968a669a9ddbe8$var$ascendingBisect.left;
var $19968a669a9ddbe8$export$2e2bcd8739ae039 = $19968a669a9ddbe8$export$4d945ad3ad5751b0;




function $83d0f22db043f641$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $83d0f22db043f641$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $83d0f22db043f641$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}


function $0a6e4e3b71d7d6c9$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $83d0f22db043f641$export$a04cb3fe8b81dd);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}


function $7f21c0282ca04526$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $12cce058748b2ae8$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}


function $035a62630b9fe3a6$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $12cce058748b2ae8$export$2e2bcd8739ae039)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $12cce058748b2ae8$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}


function $c2036d84075801db$export$2e2bcd8739ae039(array, f) {
    var v = (0, $035a62630b9fe3a6$export$2e2bcd8739ae039)(array, f);
    return v ? Math.sqrt(v) : v;
}


function $db07a8fa4cd8bec1$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


var $a3c1e09d9376a4e5$var$array = Array.prototype;
var $a3c1e09d9376a4e5$export$58adb3bec8346d0f = $a3c1e09d9376a4e5$var$array.slice;
var $a3c1e09d9376a4e5$export$871de8747c9eaa88 = $a3c1e09d9376a4e5$var$array.map;



function $4826da4390747a02$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $57fd0a9b5adc28e7$export$2e2bcd8739ae039(x) {
    return x;
}


function $180d1bb1ece88c1c$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


var $b0044322d3fdda08$var$e10 = Math.sqrt(50), $b0044322d3fdda08$var$e5 = Math.sqrt(10), $b0044322d3fdda08$var$e2 = Math.sqrt(2);
function $b0044322d3fdda08$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $b0044322d3fdda08$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $b0044322d3fdda08$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $b0044322d3fdda08$var$e10 ? 10 : error >= $b0044322d3fdda08$var$e5 ? 5 : error >= $b0044322d3fdda08$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $b0044322d3fdda08$var$e10 ? 10 : error >= $b0044322d3fdda08$var$e5 ? 5 : error >= $b0044322d3fdda08$var$e2 ? 2 : 1);
}
function $b0044322d3fdda08$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $b0044322d3fdda08$var$e10) step1 *= 10;
    else if (error >= $b0044322d3fdda08$var$e5) step1 *= 5;
    else if (error >= $b0044322d3fdda08$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $aa4b6420449570cb$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}


function $b55cd3db08b5c667$export$2e2bcd8739ae039() {
    var value = (0, $57fd0a9b5adc28e7$export$2e2bcd8739ae039), domain = (0, $db07a8fa4cd8bec1$export$2e2bcd8739ae039), threshold = (0, $aa4b6420449570cb$export$2e2bcd8739ae039);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $b0044322d3fdda08$export$81087d9b915d4ede)(x0, x1, tz);
            tz = (0, $180d1bb1ece88c1c$export$2e2bcd8739ae039)(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $19968a669a9ddbe8$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $4826da4390747a02$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $4826da4390747a02$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $4826da4390747a02$export$2e2bcd8739ae039)((0, $a3c1e09d9376a4e5$export$58adb3bec8346d0f).call(_)) : (0, $4826da4390747a02$export$2e2bcd8739ae039)(_), histogram) : threshold;
    };
    return histogram;
}






function $c159625f4cbf8475$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $12cce058748b2ae8$export$2e2bcd8739ae039);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}


function $ea6407fdab6f6238$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $a3c1e09d9376a4e5$export$871de8747c9eaa88).call(values, (0, $12cce058748b2ae8$export$2e2bcd8739ae039)).sort((0, $d5ec0898dbf13e3e$export$2e2bcd8739ae039));
    return Math.ceil((max - min) / (2 * ((0, $c159625f4cbf8475$export$2e2bcd8739ae039)(values, 0.75) - (0, $c159625f4cbf8475$export$2e2bcd8739ae039)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}



function $c73dcb0b43114948$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $c2036d84075801db$export$2e2bcd8739ae039)(values) * Math.pow(values.length, -1 / 3)));
}



function $d70b2001361cd73e$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}



function $08a7b344b81f8e08$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $12cce058748b2ae8$export$2e2bcd8739ae039)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $12cce058748b2ae8$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}





function $2661844933b7cc33$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $12cce058748b2ae8$export$2e2bcd8739ae039)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $12cce058748b2ae8$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $c159625f4cbf8475$export$2e2bcd8739ae039)(numbers.sort((0, $d5ec0898dbf13e3e$export$2e2bcd8739ae039)), 0.5);
}


function $22b887e7a9a54d15$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}


function $f4dfa84d0b23db3f$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}



function $c93d4d015f891f81$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}





function $8acf382df9327eb6$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $d5ec0898dbf13e3e$export$2e2bcd8739ae039);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}


function $08e8a16238d9e3f1$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}


function $d36343614d41302d$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}




function $d4d5f5584e01c647$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $f4dfa84d0b23db3f$export$2e2bcd8739ae039)(matrix, $d4d5f5584e01c647$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $d4d5f5584e01c647$var$length(d) {
    return d.length;
}




function $1d047c467b140e7e$export$2e2bcd8739ae039() {
    return (0, $d4d5f5584e01c647$export$2e2bcd8739ae039)(arguments);
}




var $c0d5cd0ca871c13a$export$58adb3bec8346d0f = Array.prototype.slice;


function $4a2c5a6c0d0225a3$export$2e2bcd8739ae039(x) {
    return x;
}


var $275db4cb014cc241$var$top = 1, $275db4cb014cc241$var$right = 2, $275db4cb014cc241$var$bottom = 3, $275db4cb014cc241$var$left = 4, $275db4cb014cc241$var$epsilon = 1e-6;
function $275db4cb014cc241$var$translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function $275db4cb014cc241$var$translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function $275db4cb014cc241$var$number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function $275db4cb014cc241$var$center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function $275db4cb014cc241$var$entering() {
    return !this.__axis;
}
function $275db4cb014cc241$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === $275db4cb014cc241$var$top || orient === $275db4cb014cc241$var$left ? -1 : 1, x = orient === $275db4cb014cc241$var$left || orient === $275db4cb014cc241$var$right ? "x" : "y", transform = orient === $275db4cb014cc241$var$top || orient === $275db4cb014cc241$var$bottom ? $275db4cb014cc241$var$translateX : $275db4cb014cc241$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $4a2c5a6c0d0225a3$export$2e2bcd8739ae039) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? $275db4cb014cc241$var$center : $275db4cb014cc241$var$number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "#000").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "#000").attr(x, k * spacing).attr("dy", orient === $275db4cb014cc241$var$top ? "0em" : orient === $275db4cb014cc241$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $275db4cb014cc241$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $275db4cb014cc241$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === $275db4cb014cc241$var$left || orient == $275db4cb014cc241$var$right ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($275db4cb014cc241$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $275db4cb014cc241$var$right ? "start" : orient === $275db4cb014cc241$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, $c0d5cd0ca871c13a$export$58adb3bec8346d0f).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, $c0d5cd0ca871c13a$export$58adb3bec8346d0f).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, $c0d5cd0ca871c13a$export$58adb3bec8346d0f).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function $275db4cb014cc241$export$59b8cfab074bdeb1(scale) {
    return $275db4cb014cc241$var$axis($275db4cb014cc241$var$top, scale);
}
function $275db4cb014cc241$export$b0d2e24dc4f898f0(scale) {
    return $275db4cb014cc241$var$axis($275db4cb014cc241$var$right, scale);
}
function $275db4cb014cc241$export$e5cb22533a15e72e(scale) {
    return $275db4cb014cc241$var$axis($275db4cb014cc241$var$bottom, scale);
}
function $275db4cb014cc241$export$2749afb169a520d2(scale) {
    return $275db4cb014cc241$var$axis($275db4cb014cc241$var$left, scale);
}




var $f1a1df54262d4945$var$noop = {
    value: function() {}
};
function $f1a1df54262d4945$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $f1a1df54262d4945$var$Dispatch(_);
}
function $f1a1df54262d4945$var$Dispatch(_) {
    this._ = _;
}
function $f1a1df54262d4945$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$f1a1df54262d4945$var$Dispatch.prototype = $f1a1df54262d4945$var$dispatch.prototype = {
    constructor: $f1a1df54262d4945$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $f1a1df54262d4945$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $f1a1df54262d4945$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $f1a1df54262d4945$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $f1a1df54262d4945$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $f1a1df54262d4945$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $f1a1df54262d4945$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $f1a1df54262d4945$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $f1a1df54262d4945$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $f1a1df54262d4945$export$2e2bcd8739ae039 = $f1a1df54262d4945$var$dispatch;



function $be2e2fac88587051$var$none() {}
function $be2e2fac88587051$export$2e2bcd8739ae039(selector) {
    return selector == null ? $be2e2fac88587051$var$none : function() {
        return this.querySelector(selector);
    };
}


function $bf0a697bf4a859ac$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $be2e2fac88587051$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(subgroups, this._parents);
}



function $3a1dac8b380914ce$var$empty() {
    return [];
}
function $3a1dac8b380914ce$export$2e2bcd8739ae039(selector) {
    return selector == null ? $3a1dac8b380914ce$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $e3832533f1b45d07$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $3a1dac8b380914ce$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(subgroups, parents);
}



function $ccfdb86e45d4adde$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}


function $0d36679a94712e54$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $ccfdb86e45d4adde$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(subgroups, this._parents);
}



function $085ac7165dfe6987$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $dab60d86c43e41d5$export$2e2bcd8739ae039() {
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(this._enter || this._groups.map((0, $085ac7165dfe6987$export$2e2bcd8739ae039)), this._parents);
}
function $dab60d86c43e41d5$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$dab60d86c43e41d5$export$67b01759a14cf6a4.prototype = {
    constructor: $dab60d86c43e41d5$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $28914b6a25527f7b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


var $3db8a534b9ec89a4$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $3db8a534b9ec89a4$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $dab60d86c43e41d5$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $3db8a534b9ec89a4$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $3db8a534b9ec89a4$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $3db8a534b9ec89a4$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $dab60d86c43e41d5$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $3db8a534b9ec89a4$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $3db8a534b9ec89a4$var$bindKey : $3db8a534b9ec89a4$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $28914b6a25527f7b$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $b57289059d371d85$export$2e2bcd8739ae039() {
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(this._exit || this._groups.map((0, $085ac7165dfe6987$export$2e2bcd8739ae039)), this._parents);
}


function $c9737c277bdd415e$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $69446d0b5ddc2e34$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(merges, this._parents);
}


function $f8e6c027ba269a26$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $1d96cc6034d72be8$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $1d96cc6034d72be8$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $1d96cc6034d72be8$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $9ac1d6fd08ea99a4$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $2c5921e933082769$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}


function $39b032bd37bfa03a$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $bd2a1b07eb2856a4$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}


function $5fe89734a0d4fc09$export$2e2bcd8739ae039() {
    return !this.node();
}


function $c12c5d9e76f74c92$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $542e854fdda42179$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $542e854fdda42179$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $542e854fdda42179$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $02f72b7ceb2c1487$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $542e854fdda42179$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $542e854fdda42179$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name;
}


function $af86241803058538$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $af86241803058538$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $af86241803058538$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $af86241803058538$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $af86241803058538$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $af86241803058538$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $af86241803058538$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $02f72b7ceb2c1487$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $af86241803058538$var$attrRemoveNS : $af86241803058538$var$attrRemove : typeof value === "function" ? fullname.local ? $af86241803058538$var$attrFunctionNS : $af86241803058538$var$attrFunction : fullname.local ? $af86241803058538$var$attrConstantNS : $af86241803058538$var$attrConstant)(fullname, value));
}


function $6cc4751f766dc9bc$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $1c6290e260db4178$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $1c6290e260db4178$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $1c6290e260db4178$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $1c6290e260db4178$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $1c6290e260db4178$var$styleRemove : typeof value === "function" ? $1c6290e260db4178$var$styleFunction : $1c6290e260db4178$var$styleConstant)(name, value, priority == null ? "" : priority)) : $1c6290e260db4178$export$5e3cec964f0b5efd(this.node(), name);
}
function $1c6290e260db4178$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $6cc4751f766dc9bc$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $ecffd6e004703528$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $ecffd6e004703528$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $ecffd6e004703528$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $ecffd6e004703528$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $ecffd6e004703528$var$propertyRemove : typeof value === "function" ? $ecffd6e004703528$var$propertyFunction : $ecffd6e004703528$var$propertyConstant)(name, value)) : this.node()[name];
}


function $a7ad5ce44ee8452d$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $a7ad5ce44ee8452d$var$classList(node) {
    return node.classList || new $a7ad5ce44ee8452d$var$ClassList(node);
}
function $a7ad5ce44ee8452d$var$ClassList(node) {
    this._node = node;
    this._names = $a7ad5ce44ee8452d$var$classArray(node.getAttribute("class") || "");
}
$a7ad5ce44ee8452d$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $a7ad5ce44ee8452d$var$classedAdd(node, names) {
    var list = $a7ad5ce44ee8452d$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $a7ad5ce44ee8452d$var$classedRemove(node, names) {
    var list = $a7ad5ce44ee8452d$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $a7ad5ce44ee8452d$var$classedTrue(names) {
    return function() {
        $a7ad5ce44ee8452d$var$classedAdd(this, names);
    };
}
function $a7ad5ce44ee8452d$var$classedFalse(names) {
    return function() {
        $a7ad5ce44ee8452d$var$classedRemove(this, names);
    };
}
function $a7ad5ce44ee8452d$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $a7ad5ce44ee8452d$var$classedAdd : $a7ad5ce44ee8452d$var$classedRemove)(this, names);
    };
}
function $a7ad5ce44ee8452d$export$2e2bcd8739ae039(name, value) {
    var names = $a7ad5ce44ee8452d$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $a7ad5ce44ee8452d$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $a7ad5ce44ee8452d$var$classedFunction : value ? $a7ad5ce44ee8452d$var$classedTrue : $a7ad5ce44ee8452d$var$classedFalse)(names, value));
}


function $fa93fbd1a5bb3155$var$textRemove() {
    this.textContent = "";
}
function $fa93fbd1a5bb3155$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $fa93fbd1a5bb3155$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $fa93fbd1a5bb3155$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $fa93fbd1a5bb3155$var$textRemove : (typeof value === "function" ? $fa93fbd1a5bb3155$var$textFunction : $fa93fbd1a5bb3155$var$textConstant)(value)) : this.node().textContent;
}


function $fedc59a77e1ac2e8$var$htmlRemove() {
    this.innerHTML = "";
}
function $fedc59a77e1ac2e8$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $fedc59a77e1ac2e8$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $fedc59a77e1ac2e8$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $fedc59a77e1ac2e8$var$htmlRemove : (typeof value === "function" ? $fedc59a77e1ac2e8$var$htmlFunction : $fedc59a77e1ac2e8$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $320677afea2b7756$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $320677afea2b7756$export$2e2bcd8739ae039() {
    return this.each($320677afea2b7756$var$raise);
}


function $02c48853b6d3f9ba$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $02c48853b6d3f9ba$export$2e2bcd8739ae039() {
    return this.each($02c48853b6d3f9ba$var$lower);
}




function $47db7840a6181cac$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $542e854fdda42179$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $542e854fdda42179$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $47db7840a6181cac$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $47db7840a6181cac$export$2e2bcd8739ae039(name) {
    var fullname = (0, $02f72b7ceb2c1487$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $47db7840a6181cac$var$creatorFixed : $47db7840a6181cac$var$creatorInherit)(fullname);
}


function $189c4690fd6b58ed$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $47db7840a6181cac$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $4240c1db2b5a09d6$var$constantNull() {
    return null;
}
function $4240c1db2b5a09d6$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $47db7840a6181cac$export$2e2bcd8739ae039)(name), select = before == null ? $4240c1db2b5a09d6$var$constantNull : typeof before === "function" ? before : (0, $be2e2fac88587051$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $54582190c7825593$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $54582190c7825593$export$2e2bcd8739ae039() {
    return this.each($54582190c7825593$var$remove);
}


function $e04c82ba4f96df8f$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $e04c82ba4f96df8f$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $e04c82ba4f96df8f$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $e04c82ba4f96df8f$var$selection_cloneDeep : $e04c82ba4f96df8f$var$selection_cloneShallow);
}


function $4e7688a1818ef78a$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


var $75679d3f7c3bc482$var$filterEvents = {};
var $75679d3f7c3bc482$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $75679d3f7c3bc482$var$element = document.documentElement;
    if (!("onmouseenter" in $75679d3f7c3bc482$var$element)) $75679d3f7c3bc482$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $75679d3f7c3bc482$var$filterContextListener(listener, index, group) {
    listener = $75679d3f7c3bc482$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $75679d3f7c3bc482$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $75679d3f7c3bc482$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $75679d3f7c3bc482$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $75679d3f7c3bc482$export$6cd530ed55e06764 = event0;
        }
    };
}
function $75679d3f7c3bc482$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $75679d3f7c3bc482$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $75679d3f7c3bc482$var$onAdd(typename, value, capture) {
    var wrap = $75679d3f7c3bc482$var$filterEvents.hasOwnProperty(typename.type) ? $75679d3f7c3bc482$var$filterContextListener : $75679d3f7c3bc482$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $75679d3f7c3bc482$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $75679d3f7c3bc482$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $75679d3f7c3bc482$var$onAdd : $75679d3f7c3bc482$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $75679d3f7c3bc482$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $75679d3f7c3bc482$export$6cd530ed55e06764;
    event1.sourceEvent = $75679d3f7c3bc482$export$6cd530ed55e06764;
    $75679d3f7c3bc482$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $75679d3f7c3bc482$export$6cd530ed55e06764 = event0;
    }
}



function $63a1bc9866c85157$var$dispatchEvent(node, type, params) {
    var window = (0, $6cc4751f766dc9bc$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $63a1bc9866c85157$var$dispatchConstant(type, params) {
    return function() {
        return $63a1bc9866c85157$var$dispatchEvent(this, type, params);
    };
}
function $63a1bc9866c85157$var$dispatchFunction(type, params) {
    return function() {
        return $63a1bc9866c85157$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $63a1bc9866c85157$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $63a1bc9866c85157$var$dispatchFunction : $63a1bc9866c85157$var$dispatchConstant)(type, params));
}


var $aeaebb8c1a00ba54$export$e8e78c978b129247 = [
    null
];
function $aeaebb8c1a00ba54$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $aeaebb8c1a00ba54$var$selection() {
    return new $aeaebb8c1a00ba54$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $aeaebb8c1a00ba54$export$e8e78c978b129247);
}
$aeaebb8c1a00ba54$export$52baac22726c72bf.prototype = $aeaebb8c1a00ba54$var$selection.prototype = {
    constructor: $aeaebb8c1a00ba54$export$52baac22726c72bf,
    select: (0, $bf0a697bf4a859ac$export$2e2bcd8739ae039),
    selectAll: (0, $e3832533f1b45d07$export$2e2bcd8739ae039),
    filter: (0, $0d36679a94712e54$export$2e2bcd8739ae039),
    data: (0, $3db8a534b9ec89a4$export$2e2bcd8739ae039),
    enter: (0, $dab60d86c43e41d5$export$2e2bcd8739ae039),
    exit: (0, $b57289059d371d85$export$2e2bcd8739ae039),
    join: (0, $c9737c277bdd415e$export$2e2bcd8739ae039),
    merge: (0, $69446d0b5ddc2e34$export$2e2bcd8739ae039),
    order: (0, $f8e6c027ba269a26$export$2e2bcd8739ae039),
    sort: (0, $1d96cc6034d72be8$export$2e2bcd8739ae039),
    call: (0, $9ac1d6fd08ea99a4$export$2e2bcd8739ae039),
    nodes: (0, $2c5921e933082769$export$2e2bcd8739ae039),
    node: (0, $39b032bd37bfa03a$export$2e2bcd8739ae039),
    size: (0, $bd2a1b07eb2856a4$export$2e2bcd8739ae039),
    empty: (0, $5fe89734a0d4fc09$export$2e2bcd8739ae039),
    each: (0, $c12c5d9e76f74c92$export$2e2bcd8739ae039),
    attr: (0, $af86241803058538$export$2e2bcd8739ae039),
    style: (0, $1c6290e260db4178$export$2e2bcd8739ae039),
    property: (0, $ecffd6e004703528$export$2e2bcd8739ae039),
    classed: (0, $a7ad5ce44ee8452d$export$2e2bcd8739ae039),
    text: (0, $fa93fbd1a5bb3155$export$2e2bcd8739ae039),
    html: (0, $fedc59a77e1ac2e8$export$2e2bcd8739ae039),
    raise: (0, $320677afea2b7756$export$2e2bcd8739ae039),
    lower: (0, $02c48853b6d3f9ba$export$2e2bcd8739ae039),
    append: (0, $189c4690fd6b58ed$export$2e2bcd8739ae039),
    insert: (0, $4240c1db2b5a09d6$export$2e2bcd8739ae039),
    remove: (0, $54582190c7825593$export$2e2bcd8739ae039),
    clone: (0, $e04c82ba4f96df8f$export$2e2bcd8739ae039),
    datum: (0, $4e7688a1818ef78a$export$2e2bcd8739ae039),
    on: (0, $75679d3f7c3bc482$export$2e2bcd8739ae039),
    dispatch: (0, $63a1bc9866c85157$export$2e2bcd8739ae039)
};
var $aeaebb8c1a00ba54$export$2e2bcd8739ae039 = $aeaebb8c1a00ba54$var$selection;


function $47d5dea6a143564e$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $aeaebb8c1a00ba54$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $aeaebb8c1a00ba54$export$e8e78c978b129247));
}



function $4dea0f1aa0d9e1e0$export$2e2561858db9bf47() {
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $4dea0f1aa0d9e1e0$export$2e2bcd8739ae039() {
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).preventDefault();
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).stopImmediatePropagation();
}


function $1ad953c62f5557ec$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $4dea0f1aa0d9e1e0$export$2e2bcd8739ae039), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $4dea0f1aa0d9e1e0$export$2e2bcd8739ae039), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $1ad953c62f5557ec$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $4dea0f1aa0d9e1e0$export$2e2bcd8739ae039), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $39bR5 = parcelRequire("39bR5");

var $39bR5 = parcelRequire("39bR5");
function $ba64a636a82cd71f$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $ba64a636a82cd71f$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $ba64a636a82cd71f$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $8fee2dc35e0e489e$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $ba64a636a82cd71f$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


function $bd75a4a014ff609c$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $8ccd72a948bd24c2$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $8ccd72a948bd24c2$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $8ccd72a948bd24c2$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $8ccd72a948bd24c2$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $bd75a4a014ff609c$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $8ccd72a948bd24c2$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $8ccd72a948bd24c2$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $8ccd72a948bd24c2$var$exponential(a, b, y) : (0, $bd75a4a014ff609c$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $8ccd72a948bd24c2$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $8ccd72a948bd24c2$var$linear(a, d) : (0, $bd75a4a014ff609c$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $f9e46e9cba142458$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $8ccd72a948bd24c2$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $39bR5.rgb)(start)).r, (end = (0, $39bR5.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8ccd72a948bd24c2$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $f9e46e9cba142458$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $39bR5.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f9e46e9cba142458$export$2c0e28f2e2852d3f = $f9e46e9cba142458$var$rgbSpline((0, $ba64a636a82cd71f$export$2e2bcd8739ae039));
var $f9e46e9cba142458$export$53d5214f625ccd4c = $f9e46e9cba142458$var$rgbSpline((0, $8fee2dc35e0e489e$export$2e2bcd8739ae039));



function $99e97fff7d348d30$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $99e97fff7d348d30$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $5ce52220a56b54dd$export$2e2bcd8739ae039(a, b) {
    return ((0, $99e97fff7d348d30$export$5cd576d1827d40c8)(b) ? (0, $99e97fff7d348d30$export$2e2bcd8739ae039) : $5ce52220a56b54dd$export$15d09067c6a5ee49)(a, b);
}
function $5ce52220a56b54dd$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $c1f23c99e29b9b5a$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $5c7d85facff975df$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $4bd58df1c6298bf3$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $1ebc51bd96714c0a$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $c1f23c99e29b9b5a$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $5f42cbc37aae07c8$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $5f42cbc37aae07c8$var$reB = new RegExp($5f42cbc37aae07c8$var$reA.source, "g");
function $5f42cbc37aae07c8$var$zero(b) {
    return function() {
        return b;
    };
}
function $5f42cbc37aae07c8$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $5f42cbc37aae07c8$export$2e2bcd8739ae039(a, b) {
    var bi = $5f42cbc37aae07c8$var$reA.lastIndex = $5f42cbc37aae07c8$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $5f42cbc37aae07c8$var$reA.exec(a)) && (bm = $5f42cbc37aae07c8$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $5f42cbc37aae07c8$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $5f42cbc37aae07c8$var$one(q[0].x) : $5f42cbc37aae07c8$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $c1f23c99e29b9b5a$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $bd75a4a014ff609c$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $39bR5.default)(b)) ? (b = c, $f9e46e9cba142458$export$2e2bcd8739ae039) : (0, $5f42cbc37aae07c8$export$2e2bcd8739ae039) : b instanceof (0, $39bR5.default) ? (0, $f9e46e9cba142458$export$2e2bcd8739ae039) : b instanceof Date ? (0, $5c7d85facff975df$export$2e2bcd8739ae039) : (0, $99e97fff7d348d30$export$5cd576d1827d40c8)(b) ? (0, $99e97fff7d348d30$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $5ce52220a56b54dd$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $1ebc51bd96714c0a$export$2e2bcd8739ae039) : (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039))(a, b);
}



function $8ca07fdf38c63b63$export$2e2bcd8739ae039() {
    var current = (0, $75679d3f7c3bc482$export$6cd530ed55e06764), source;
    while(source = current.sourceEvent)current = source;
    return current;
}


function $d292e63c082fa724$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}


function $a9daf6b6ba2679b5$export$2e2bcd8739ae039(node) {
    var event = (0, $8ca07fdf38c63b63$export$2e2bcd8739ae039)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $d292e63c082fa724$export$2e2bcd8739ae039)(node, event);
}




var $87dbce956a1d037c$var$frame = 0, $87dbce956a1d037c$var$timeout = 0, $87dbce956a1d037c$var$interval = 0, $87dbce956a1d037c$var$pokeDelay = 1000, $87dbce956a1d037c$var$taskHead, $87dbce956a1d037c$var$taskTail, $87dbce956a1d037c$var$clockLast = 0, $87dbce956a1d037c$var$clockNow = 0, $87dbce956a1d037c$var$clockSkew = 0, $87dbce956a1d037c$var$clock = typeof performance === "object" && performance.now ? performance : Date, $87dbce956a1d037c$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $87dbce956a1d037c$export$461939dd4422153() {
    return $87dbce956a1d037c$var$clockNow || ($87dbce956a1d037c$var$setFrame($87dbce956a1d037c$var$clearNow), $87dbce956a1d037c$var$clockNow = $87dbce956a1d037c$var$clock.now() + $87dbce956a1d037c$var$clockSkew);
}
function $87dbce956a1d037c$var$clearNow() {
    $87dbce956a1d037c$var$clockNow = 0;
}
function $87dbce956a1d037c$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$87dbce956a1d037c$export$c57e9b2d8b9e4de.prototype = $87dbce956a1d037c$export$9dc4ecf953986f04.prototype = {
    constructor: $87dbce956a1d037c$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $87dbce956a1d037c$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $87dbce956a1d037c$var$taskTail !== this) {
            if ($87dbce956a1d037c$var$taskTail) $87dbce956a1d037c$var$taskTail._next = this;
            else $87dbce956a1d037c$var$taskHead = this;
            $87dbce956a1d037c$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $87dbce956a1d037c$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $87dbce956a1d037c$var$sleep();
        }
    }
};
function $87dbce956a1d037c$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $87dbce956a1d037c$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $87dbce956a1d037c$export$d60154c1d7f3990e() {
    $87dbce956a1d037c$export$461939dd4422153(); // Get the current time, if not already set.
    ++$87dbce956a1d037c$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $87dbce956a1d037c$var$taskHead, e;
    while(t){
        if ((e = $87dbce956a1d037c$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$87dbce956a1d037c$var$frame;
}
function $87dbce956a1d037c$var$wake() {
    $87dbce956a1d037c$var$clockNow = ($87dbce956a1d037c$var$clockLast = $87dbce956a1d037c$var$clock.now()) + $87dbce956a1d037c$var$clockSkew;
    $87dbce956a1d037c$var$frame = $87dbce956a1d037c$var$timeout = 0;
    try {
        $87dbce956a1d037c$export$d60154c1d7f3990e();
    } finally{
        $87dbce956a1d037c$var$frame = 0;
        $87dbce956a1d037c$var$nap();
        $87dbce956a1d037c$var$clockNow = 0;
    }
}
function $87dbce956a1d037c$var$poke() {
    var now = $87dbce956a1d037c$var$clock.now(), delay = now - $87dbce956a1d037c$var$clockLast;
    if (delay > $87dbce956a1d037c$var$pokeDelay) $87dbce956a1d037c$var$clockSkew -= delay, $87dbce956a1d037c$var$clockLast = now;
}
function $87dbce956a1d037c$var$nap() {
    var t0, t1 = $87dbce956a1d037c$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $87dbce956a1d037c$var$taskHead = t2;
    }
    $87dbce956a1d037c$var$taskTail = t0;
    $87dbce956a1d037c$var$sleep(time);
}
function $87dbce956a1d037c$var$sleep(time) {
    if ($87dbce956a1d037c$var$frame) return; // Soonest alarm already set, or will be.
    if ($87dbce956a1d037c$var$timeout) $87dbce956a1d037c$var$timeout = clearTimeout($87dbce956a1d037c$var$timeout);
    var delay = time - $87dbce956a1d037c$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $87dbce956a1d037c$var$timeout = setTimeout($87dbce956a1d037c$var$wake, time - $87dbce956a1d037c$var$clock.now() - $87dbce956a1d037c$var$clockSkew);
        if ($87dbce956a1d037c$var$interval) $87dbce956a1d037c$var$interval = clearInterval($87dbce956a1d037c$var$interval);
    } else {
        if (!$87dbce956a1d037c$var$interval) $87dbce956a1d037c$var$clockLast = $87dbce956a1d037c$var$clock.now(), $87dbce956a1d037c$var$interval = setInterval($87dbce956a1d037c$var$poke, $87dbce956a1d037c$var$pokeDelay);
        $87dbce956a1d037c$var$frame = 1, $87dbce956a1d037c$var$setFrame($87dbce956a1d037c$var$wake);
    }
}


function $078fd03d78f5c268$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $87dbce956a1d037c$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $46f2175a8a2d2955$var$emptyOn = (0, $f1a1df54262d4945$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $46f2175a8a2d2955$var$emptyTween = [];
var $46f2175a8a2d2955$export$ff39ebd4bb12b718 = 0;
var $46f2175a8a2d2955$export$584530fe98d14a84 = 1;
var $46f2175a8a2d2955$export$a5d151aee16efd42 = 2;
var $46f2175a8a2d2955$export$fb935ab5849a0db9 = 3;
var $46f2175a8a2d2955$export$1573e22b087389af = 4;
var $46f2175a8a2d2955$export$a2e792214ded83b2 = 5;
var $46f2175a8a2d2955$export$9d38167254403955 = 6;
function $46f2175a8a2d2955$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $46f2175a8a2d2955$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $46f2175a8a2d2955$var$emptyOn,
        tween: $46f2175a8a2d2955$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $46f2175a8a2d2955$export$ff39ebd4bb12b718
    });
}
function $46f2175a8a2d2955$export$2cd8252107eb640b(node, id) {
    var schedule = $46f2175a8a2d2955$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $46f2175a8a2d2955$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $46f2175a8a2d2955$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $46f2175a8a2d2955$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $46f2175a8a2d2955$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $46f2175a8a2d2955$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $46f2175a8a2d2955$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $87dbce956a1d037c$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $46f2175a8a2d2955$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $46f2175a8a2d2955$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $46f2175a8a2d2955$export$fb935ab5849a0db9) return (0, $078fd03d78f5c268$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $46f2175a8a2d2955$export$1573e22b087389af) {
                o.state = $46f2175a8a2d2955$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $46f2175a8a2d2955$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $078fd03d78f5c268$export$2e2bcd8739ae039)(function() {
            if (self.state === $46f2175a8a2d2955$export$fb935ab5849a0db9) {
                self.state = $46f2175a8a2d2955$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $46f2175a8a2d2955$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $46f2175a8a2d2955$export$a5d151aee16efd42) return; // interrupted
        self.state = $46f2175a8a2d2955$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $46f2175a8a2d2955$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $46f2175a8a2d2955$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $46f2175a8a2d2955$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $ef45489bd346b26a$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $46f2175a8a2d2955$export$a5d151aee16efd42) && schedule.state < (0, $46f2175a8a2d2955$export$a2e792214ded83b2);
        schedule.state = (0, $46f2175a8a2d2955$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $35b0a6191027db65$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $ef45489bd346b26a$export$2e2bcd8739ae039)(this, name);
    });
}




var $acd0f5157ecc0b1f$var$degrees = 180 / Math.PI;
var $acd0f5157ecc0b1f$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $acd0f5157ecc0b1f$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $acd0f5157ecc0b1f$var$degrees,
        skewX: Math.atan(skewX) * $acd0f5157ecc0b1f$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $261e403d6e2ee252$var$cssNode, $261e403d6e2ee252$var$cssRoot, $261e403d6e2ee252$var$cssView, $261e403d6e2ee252$var$svgNode;
function $261e403d6e2ee252$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $acd0f5157ecc0b1f$export$f0954fd7d5368655;
    if (!$261e403d6e2ee252$var$cssNode) $261e403d6e2ee252$var$cssNode = document.createElement("DIV"), $261e403d6e2ee252$var$cssRoot = document.documentElement, $261e403d6e2ee252$var$cssView = document.defaultView;
    $261e403d6e2ee252$var$cssNode.style.transform = value;
    value = $261e403d6e2ee252$var$cssView.getComputedStyle($261e403d6e2ee252$var$cssRoot.appendChild($261e403d6e2ee252$var$cssNode), null).getPropertyValue("transform");
    $261e403d6e2ee252$var$cssRoot.removeChild($261e403d6e2ee252$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $acd0f5157ecc0b1f$export$2e2bcd8739ae039)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $261e403d6e2ee252$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $acd0f5157ecc0b1f$export$f0954fd7d5368655;
    if (!$261e403d6e2ee252$var$svgNode) $261e403d6e2ee252$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $261e403d6e2ee252$var$svgNode.setAttribute("transform", value);
    if (!(value = $261e403d6e2ee252$var$svgNode.transform.baseVal.consolidate())) return 0, $acd0f5157ecc0b1f$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $acd0f5157ecc0b1f$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $85c43fd100ef0565$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $85c43fd100ef0565$export$56bec7123bb3589a = $85c43fd100ef0565$var$interpolateTransform((0, $261e403d6e2ee252$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $85c43fd100ef0565$export$da8cba906d64c082 = $85c43fd100ef0565$var$interpolateTransform((0, $261e403d6e2ee252$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $35147ed1adcccfce$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $35147ed1adcccfce$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $35147ed1adcccfce$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $35147ed1adcccfce$var$tweenRemove : $35147ed1adcccfce$var$tweenFunction)(id, name, value));
}
function $35147ed1adcccfce$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $39bR5 = parcelRequire("39bR5");

function $1563f42dcf87a7a9$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039) : b instanceof (0, $39bR5.default) ? (0, $f9e46e9cba142458$export$2e2bcd8739ae039) : (c = (0, $39bR5.default)(b)) ? (b = c, $f9e46e9cba142458$export$2e2bcd8739ae039) : (0, $5f42cbc37aae07c8$export$2e2bcd8739ae039))(a, b);
}


function $e4f3a438b0d0ba20$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $e4f3a438b0d0ba20$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $e4f3a438b0d0ba20$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $e4f3a438b0d0ba20$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $e4f3a438b0d0ba20$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $e4f3a438b0d0ba20$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $e4f3a438b0d0ba20$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $02f72b7ceb2c1487$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $85c43fd100ef0565$export$da8cba906d64c082) : (0, $1563f42dcf87a7a9$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $e4f3a438b0d0ba20$var$attrFunctionNS : $e4f3a438b0d0ba20$var$attrFunction)(fullname, i, (0, $35147ed1adcccfce$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $e4f3a438b0d0ba20$var$attrRemoveNS : $e4f3a438b0d0ba20$var$attrRemove)(fullname) : (fullname.local ? $e4f3a438b0d0ba20$var$attrConstantNS : $e4f3a438b0d0ba20$var$attrConstant)(fullname, i, value));
}



function $398037008b4f517e$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $398037008b4f517e$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $398037008b4f517e$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $398037008b4f517e$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $398037008b4f517e$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $398037008b4f517e$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $398037008b4f517e$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $02f72b7ceb2c1487$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $398037008b4f517e$var$attrTweenNS : $398037008b4f517e$var$attrTween)(fullname, value));
}



function $0fced8424a968fdb$var$delayFunction(id, value) {
    return function() {
        (0, $46f2175a8a2d2955$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $0fced8424a968fdb$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $46f2175a8a2d2955$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $0fced8424a968fdb$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $0fced8424a968fdb$var$delayFunction : $0fced8424a968fdb$var$delayConstant)(id, value)) : (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $7531ec83a888fda5$var$durationFunction(id, value) {
    return function() {
        (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $7531ec83a888fda5$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $7531ec83a888fda5$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $7531ec83a888fda5$var$durationFunction : $7531ec83a888fda5$var$durationConstant)(id, value)) : (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $9b3e81648fa66adf$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $9b3e81648fa66adf$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($9b3e81648fa66adf$var$easeConstant(id, value)) : (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(this.node(), id).ease;
}




function $075d6c464b624fc0$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $ccfdb86e45d4adde$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $1f802ac6485480d3$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $04916a6d5a70e1c1$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $1f802ac6485480d3$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $4ebab1c3dbab53a2$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $4ebab1c3dbab53a2$var$onFunction(id, name, listener) {
    var on0, on1, sit = $4ebab1c3dbab53a2$var$start(name) ? (0, $46f2175a8a2d2955$export$2cd8252107eb640b) : (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $4ebab1c3dbab53a2$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($4ebab1c3dbab53a2$var$onFunction(id, name, listener));
}


function $db2c093ee835f7e9$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $db2c093ee835f7e9$export$2e2bcd8739ae039() {
    return this.on("end.remove", $db2c093ee835f7e9$var$removeFunction(this._id));
}





function $8d97c7d963541e26$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $be2e2fac88587051$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $46f2175a8a2d2955$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $1f802ac6485480d3$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $7d6a6d4bdde4c60d$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $3a1dac8b380914ce$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $46f2175a8a2d2955$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $1f802ac6485480d3$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $2d297c0d2ec43c6e$var$Selection = (0, $aeaebb8c1a00ba54$export$2e2bcd8739ae039).prototype.constructor;
function $2d297c0d2ec43c6e$export$2e2bcd8739ae039() {
    return new $2d297c0d2ec43c6e$var$Selection(this._groups, this._parents);
}







function $d9a0206c6e144203$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $1c6290e260db4178$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $1c6290e260db4178$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d9a0206c6e144203$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d9a0206c6e144203$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $1c6290e260db4178$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d9a0206c6e144203$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $1c6290e260db4178$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $1c6290e260db4178$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d9a0206c6e144203$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d9a0206c6e144203$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d9a0206c6e144203$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $85c43fd100ef0565$export$56bec7123bb3589a) : (0, $1563f42dcf87a7a9$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d9a0206c6e144203$var$styleNull(name, i)).on("end.style." + name, $d9a0206c6e144203$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d9a0206c6e144203$var$styleFunction(name, i, (0, $35147ed1adcccfce$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d9a0206c6e144203$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d9a0206c6e144203$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $85487f71ed980825$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $85487f71ed980825$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $85487f71ed980825$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $85487f71ed980825$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $85487f71ed980825$var$styleTween(name, value, priority == null ? "" : priority));
}



function $9a56124b2d8787a2$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $9a56124b2d8787a2$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $9a56124b2d8787a2$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $9a56124b2d8787a2$var$textFunction((0, $35147ed1adcccfce$export$f78ce6ab10405d82)(this, "text", value)) : $9a56124b2d8787a2$var$textConstant(value == null ? "" : value + ""));
}


function $f5664d79e17059e9$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $f5664d79e17059e9$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $f5664d79e17059e9$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $f5664d79e17059e9$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $f5664d79e17059e9$var$textTween(value));
}




function $9b9f3c82b993e401$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $1f802ac6485480d3$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $46f2175a8a2d2955$export$3988ae62b71be9a3)(node, id0);
            (0, $46f2175a8a2d2955$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $1f802ac6485480d3$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $21757ba429b62d20$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $46f2175a8a2d2955$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
    });
}


var $1f802ac6485480d3$var$id = 0;
function $1f802ac6485480d3$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $1f802ac6485480d3$export$2e2bcd8739ae039(name) {
    return (0, $aeaebb8c1a00ba54$export$2e2bcd8739ae039)().transition(name);
}
function $1f802ac6485480d3$export$9ffd10a3fbdc175b() {
    return ++$1f802ac6485480d3$var$id;
}
var $1f802ac6485480d3$var$selection_prototype = (0, $aeaebb8c1a00ba54$export$2e2bcd8739ae039).prototype;
$1f802ac6485480d3$export$be58926105124dd4.prototype = $1f802ac6485480d3$export$2e2bcd8739ae039.prototype = {
    constructor: $1f802ac6485480d3$export$be58926105124dd4,
    select: (0, $8d97c7d963541e26$export$2e2bcd8739ae039),
    selectAll: (0, $7d6a6d4bdde4c60d$export$2e2bcd8739ae039),
    filter: (0, $075d6c464b624fc0$export$2e2bcd8739ae039),
    merge: (0, $04916a6d5a70e1c1$export$2e2bcd8739ae039),
    selection: (0, $2d297c0d2ec43c6e$export$2e2bcd8739ae039),
    transition: (0, $9b9f3c82b993e401$export$2e2bcd8739ae039),
    call: $1f802ac6485480d3$var$selection_prototype.call,
    nodes: $1f802ac6485480d3$var$selection_prototype.nodes,
    node: $1f802ac6485480d3$var$selection_prototype.node,
    size: $1f802ac6485480d3$var$selection_prototype.size,
    empty: $1f802ac6485480d3$var$selection_prototype.empty,
    each: $1f802ac6485480d3$var$selection_prototype.each,
    on: (0, $4ebab1c3dbab53a2$export$2e2bcd8739ae039),
    attr: (0, $e4f3a438b0d0ba20$export$2e2bcd8739ae039),
    attrTween: (0, $398037008b4f517e$export$2e2bcd8739ae039),
    style: (0, $d9a0206c6e144203$export$2e2bcd8739ae039),
    styleTween: (0, $85487f71ed980825$export$2e2bcd8739ae039),
    text: (0, $9a56124b2d8787a2$export$2e2bcd8739ae039),
    textTween: (0, $f5664d79e17059e9$export$2e2bcd8739ae039),
    remove: (0, $db2c093ee835f7e9$export$2e2bcd8739ae039),
    tween: (0, $35147ed1adcccfce$export$2e2bcd8739ae039),
    delay: (0, $0fced8424a968fdb$export$2e2bcd8739ae039),
    duration: (0, $7531ec83a888fda5$export$2e2bcd8739ae039),
    ease: (0, $9b3e81648fa66adf$export$2e2bcd8739ae039),
    end: (0, $21757ba429b62d20$export$2e2bcd8739ae039)
};



function $1eaed4302d861ef3$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $1eaed4302d861ef3$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $1eaed4302d861ef3$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $14d128d500322811$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $1eaed4302d861ef3$export$89238d3bc79d3ada)
};
function $14d128d500322811$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $14d128d500322811$var$defaultTiming.time = (0, $87dbce956a1d037c$export$461939dd4422153)(), $14d128d500322811$var$defaultTiming;
    }
    return timing;
}
function $14d128d500322811$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $1f802ac6485480d3$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $1f802ac6485480d3$export$9ffd10a3fbdc175b)(), (timing = $14d128d500322811$var$defaultTiming).time = (0, $87dbce956a1d037c$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $46f2175a8a2d2955$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $14d128d500322811$var$inherit(node, id));
    }
    return new (0, $1f802ac6485480d3$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $aeaebb8c1a00ba54$export$2e2bcd8739ae039).prototype.interrupt = (0, $35b0a6191027db65$export$2e2bcd8739ae039);
(0, $aeaebb8c1a00ba54$export$2e2bcd8739ae039).prototype.transition = (0, $14d128d500322811$export$2e2bcd8739ae039);





var $5a8dca21af8240ab$var$root = [
    null
];
function $5a8dca21af8240ab$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $46f2175a8a2d2955$export$584530fe98d14a84) && schedule.name === name) return new (0, $1f802ac6485480d3$export$be58926105124dd4)([
                [
                    node
                ]
            ], $5a8dca21af8240ab$var$root, name, +i);
        }
    }
    return null;
}





function $652a972c5f449632$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $5758558c53d9a031$export$2e2bcd8739ae039(target, type, selection) {
    this.target = target;
    this.type = type;
    this.selection = selection;
}



function $f9900216ec0f0b9e$export$2e2561858db9bf47() {
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $f9900216ec0f0b9e$export$2e2bcd8739ae039() {
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).preventDefault();
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).stopImmediatePropagation();
}


var $3a735f31bcb1c7a8$var$MODE_DRAG = {
    name: "drag"
}, $3a735f31bcb1c7a8$var$MODE_SPACE = {
    name: "space"
}, $3a735f31bcb1c7a8$var$MODE_HANDLE = {
    name: "handle"
}, $3a735f31bcb1c7a8$var$MODE_CENTER = {
    name: "center"
};
var $3a735f31bcb1c7a8$var$X = {
    name: "x",
    handles: [
        "e",
        "w"
    ].map($3a735f31bcb1c7a8$var$type),
    input: function(x, e) {
        return x && [
            [
                x[0],
                e[0][1]
            ],
            [
                x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $3a735f31bcb1c7a8$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($3a735f31bcb1c7a8$var$type),
    input: function(y, e) {
        return y && [
            [
                e[0][0],
                y[0]
            ],
            [
                e[1][0],
                y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $3a735f31bcb1c7a8$var$XY = {
    name: "xy",
    handles: [
        "n",
        "e",
        "s",
        "w",
        "nw",
        "ne",
        "se",
        "sw"
    ].map($3a735f31bcb1c7a8$var$type),
    input: function(xy) {
        return xy;
    },
    output: function(xy) {
        return xy;
    }
};
var $3a735f31bcb1c7a8$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $3a735f31bcb1c7a8$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $3a735f31bcb1c7a8$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $3a735f31bcb1c7a8$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $3a735f31bcb1c7a8$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $3a735f31bcb1c7a8$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $3a735f31bcb1c7a8$var$defaultFilter() {
    return !(0, $75679d3f7c3bc482$export$6cd530ed55e06764).button;
}
function $3a735f31bcb1c7a8$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $3a735f31bcb1c7a8$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $3a735f31bcb1c7a8$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $3a735f31bcb1c7a8$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $3a735f31bcb1c7a8$export$979ace6c88860aa8() {
    return $3a735f31bcb1c7a8$var$brush($3a735f31bcb1c7a8$var$X);
}
function $3a735f31bcb1c7a8$export$468748b530991c54() {
    return $3a735f31bcb1c7a8$var$brush($3a735f31bcb1c7a8$var$Y);
}
function $3a735f31bcb1c7a8$export$2e2bcd8739ae039() {
    return $3a735f31bcb1c7a8$var$brush($3a735f31bcb1c7a8$var$XY);
}
function $3a735f31bcb1c7a8$var$brush(dim) {
    var extent = $3a735f31bcb1c7a8$var$defaultExtent, filter = $3a735f31bcb1c7a8$var$defaultFilter, listeners = (0, $f1a1df54262d4945$export$2e2bcd8739ae039)(brush, "start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $3a735f31bcb1c7a8$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $3a735f31bcb1c7a8$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $3a735f31bcb1c7a8$var$local(this).extent;
            (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $3a735f31bcb1c7a8$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $3a735f31bcb1c7a8$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $3a735f31bcb1c7a8$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", started);
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $c1f23c99e29b9b5a$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && $3a735f31bcb1c7a8$var$empty(selection1) ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 && selection1 ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $ef45489bd346b26a$export$2e2bcd8739ae039)(that);
            state.selection = selection1 == null || $3a735f31bcb1c7a8$var$empty(selection1) ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    function redraw() {
        var group = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(this), selection = $3a735f31bcb1c7a8$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args) {
        return that.__brush.emitter || new Emitter(that, args);
    }
    function Emitter(that, args) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, $75679d3f7c3bc482$export$4c724631b4750aef)(new (0, $5758558c53d9a031$export$2e2bcd8739ae039)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).touches) {
            if ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).changedTouches.length < (0, $75679d3f7c3bc482$export$6cd530ed55e06764).touches.length) return (0, $f9900216ec0f0b9e$export$2e2bcd8739ae039)();
        } else if (touchending) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).target.__data__.type, mode = ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).metaKey ? type = "overlay" : type) === "selection" ? $3a735f31bcb1c7a8$var$MODE_DRAG : (0, $75679d3f7c3bc482$export$6cd530ed55e06764).altKey ? $3a735f31bcb1c7a8$var$MODE_CENTER : $3a735f31bcb1c7a8$var$MODE_HANDLE, signX = dim === $3a735f31bcb1c7a8$var$Y ? null : $3a735f31bcb1c7a8$var$signsX[type], signY = dim === $3a735f31bcb1c7a8$var$X ? null : $3a735f31bcb1c7a8$var$signsY[type], state = $3a735f31bcb1c7a8$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx, dy, moving, shifting = signX && signY && (0, $75679d3f7c3bc482$export$6cd530ed55e06764).shiftKey, lockX, lockY, point0 = (0, $a9daf6b6ba2679b5$export$2e2bcd8739ae039)(that), point = point0, emit = emitter(that, arguments).beforestart();
        if (type === "overlay") state.selection = selection = [
            [
                w0 = dim === $3a735f31bcb1c7a8$var$Y ? W : point0[0],
                n0 = dim === $3a735f31bcb1c7a8$var$X ? N : point0[1]
            ],
            [
                e0 = dim === $3a735f31bcb1c7a8$var$Y ? E : w0,
                s0 = dim === $3a735f31bcb1c7a8$var$X ? S : n0
            ]
        ];
        else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $3a735f31bcb1c7a8$var$cursors[type]);
        if ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).touches) group.on("touchmove.brush", moved, true).on("touchend.brush touchcancel.brush", ended, true);
        else {
            var view = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)((0, $75679d3f7c3bc482$export$6cd530ed55e06764).view).on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            (0, $1ad953c62f5557ec$export$2e2bcd8739ae039)((0, $75679d3f7c3bc482$export$6cd530ed55e06764).view);
        }
        (0, $f9900216ec0f0b9e$export$2e2561858db9bf47)();
        (0, $ef45489bd346b26a$export$2e2bcd8739ae039)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = (0, $a9daf6b6ba2679b5$export$2e2bcd8739ae039)(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, $f9900216ec0f0b9e$export$2e2bcd8739ae039)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $3a735f31bcb1c7a8$var$MODE_SPACE:
                case $3a735f31bcb1c7a8$var$MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $3a735f31bcb1c7a8$var$MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case $3a735f31bcb1c7a8$var$MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $3a735f31bcb1c7a8$var$flipX) overlay.attr("cursor", $3a735f31bcb1c7a8$var$cursors[type = $3a735f31bcb1c7a8$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $3a735f31bcb1c7a8$var$flipY) overlay.attr("cursor", $3a735f31bcb1c7a8$var$cursors[type = $3a735f31bcb1c7a8$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, $f9900216ec0f0b9e$export$2e2561858db9bf47)();
            if ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).touches) {
                if ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
                group.on("touchmove.brush touchend.brush touchcancel.brush", null);
            } else {
                (0, $1ad953c62f5557ec$export$833237748009e1e1)((0, $75679d3f7c3bc482$export$6cd530ed55e06764).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $3a735f31bcb1c7a8$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($3a735f31bcb1c7a8$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, $75679d3f7c3bc482$export$6cd530ed55e06764).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $3a735f31bcb1c7a8$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $3a735f31bcb1c7a8$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $3a735f31bcb1c7a8$var$MODE_HANDLE || mode === $3a735f31bcb1c7a8$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $3a735f31bcb1c7a8$var$MODE_SPACE;
                        overlay.attr("cursor", $3a735f31bcb1c7a8$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $f9900216ec0f0b9e$export$2e2bcd8739ae039)();
        }
        function keyupped() {
            switch((0, $75679d3f7c3bc482$export$6cd530ed55e06764).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $3a735f31bcb1c7a8$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $3a735f31bcb1c7a8$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $3a735f31bcb1c7a8$var$MODE_SPACE) {
                        if ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $3a735f31bcb1c7a8$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $3a735f31bcb1c7a8$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $3a735f31bcb1c7a8$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $f9900216ec0f0b9e$export$2e2bcd8739ae039)();
        }
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = extent.apply(this, arguments);
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $652a972c5f449632$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $652a972c5f449632$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}




function $ac07eaf4741610f5$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $48ef30fb98306994$export$2e2bcd8739ae039(compare) {
    if (compare.length === 1) compare = $48ef30fb98306994$var$ascendingComparator(compare);
    return {
        left: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }
            return lo;
        },
        right: function(a, x, lo, hi) {
            if (lo == null) lo = 0;
            if (hi == null) hi = a.length;
            while(lo < hi){
                var mid = lo + hi >>> 1;
                if (compare(a[mid], x) > 0) hi = mid;
                else lo = mid + 1;
            }
            return lo;
        }
    };
}
function $48ef30fb98306994$var$ascendingComparator(f) {
    return function(d, x) {
        return (0, $ac07eaf4741610f5$export$2e2bcd8739ae039)(f(d), x);
    };
}


var $ebc8358e83b40f6b$var$ascendingBisect = (0, $48ef30fb98306994$export$2e2bcd8739ae039)((0, $ac07eaf4741610f5$export$2e2bcd8739ae039));
var $ebc8358e83b40f6b$export$4d945ad3ad5751b0 = $ebc8358e83b40f6b$var$ascendingBisect.right;
var $ebc8358e83b40f6b$export$df7d25c84ebd12a5 = $ebc8358e83b40f6b$var$ascendingBisect.left;
var $ebc8358e83b40f6b$export$2e2bcd8739ae039 = $ebc8358e83b40f6b$export$4d945ad3ad5751b0;




function $d7e8972d4aae520a$export$2e2bcd8739ae039(array, f) {
    if (f == null) f = $d7e8972d4aae520a$export$a04cb3fe8b81dd;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while(i < n)pairs[i] = f(p, p = array[++i]);
    return pairs;
}
function $d7e8972d4aae520a$export$a04cb3fe8b81dd(a, b) {
    return [
        a,
        b
    ];
}


function $f30331f4c18ed1ad$export$2e2bcd8739ae039(values0, values1, reduce) {
    var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
    if (reduce == null) reduce = (0, $d7e8972d4aae520a$export$a04cb3fe8b81dd);
    for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
    return values;
}


function $fc7edb1318a52ca5$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $07c377c535c03f01$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}


function $9762117f7292b651$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $07c377c535c03f01$export$2e2bcd8739ae039)(values[i]))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    } else {
        while(++i < n)if (!isNaN(value = (0, $07c377c535c03f01$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) {
            delta = value - mean;
            mean += delta / ++m;
            sum += delta * (value - mean);
        }
    }
    if (m > 1) return sum / (m - 1);
}


function $85eeec3a83d15642$export$2e2bcd8739ae039(array, f) {
    var v = (0, $9762117f7292b651$export$2e2bcd8739ae039)(array, f);
    return v ? Math.sqrt(v) : v;
}


function $8be2f922f3d44306$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = values[i]) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}


var $9974eb0dba1d25a9$var$array = Array.prototype;
var $9974eb0dba1d25a9$export$58adb3bec8346d0f = $9974eb0dba1d25a9$var$array.slice;
var $9974eb0dba1d25a9$export$871de8747c9eaa88 = $9974eb0dba1d25a9$var$array.map;



function $586e279ccd9ef5eb$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $cead48ebd21e1959$export$2e2bcd8739ae039(x) {
    return x;
}


function $6bd36ecffc9a8fb7$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


var $fd752f66568b8bf9$var$e10 = Math.sqrt(50), $fd752f66568b8bf9$var$e5 = Math.sqrt(10), $fd752f66568b8bf9$var$e2 = Math.sqrt(2);
function $fd752f66568b8bf9$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $fd752f66568b8bf9$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        while(++i < n)ticks[i] = (start + i) * step;
    } else {
        start = Math.floor(start * step);
        stop = Math.ceil(stop * step);
        ticks = new Array(n = Math.ceil(start - stop + 1));
        while(++i < n)ticks[i] = (start - i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $fd752f66568b8bf9$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $fd752f66568b8bf9$var$e10 ? 10 : error >= $fd752f66568b8bf9$var$e5 ? 5 : error >= $fd752f66568b8bf9$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $fd752f66568b8bf9$var$e10 ? 10 : error >= $fd752f66568b8bf9$var$e5 ? 5 : error >= $fd752f66568b8bf9$var$e2 ? 2 : 1);
}
function $fd752f66568b8bf9$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $fd752f66568b8bf9$var$e10) step1 *= 10;
    else if (error >= $fd752f66568b8bf9$var$e5) step1 *= 5;
    else if (error >= $fd752f66568b8bf9$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $33482493d5ca98ac$export$2e2bcd8739ae039(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}


function $846aadcff4730c3e$export$2e2bcd8739ae039() {
    var value = (0, $cead48ebd21e1959$export$2e2bcd8739ae039), domain = (0, $8be2f922f3d44306$export$2e2bcd8739ae039), threshold = (0, $33482493d5ca98ac$export$2e2bcd8739ae039);
    function histogram(data) {
        var i, n = data.length, x, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds.
        if (!Array.isArray(tz)) {
            tz = (0, $fd752f66568b8bf9$export$81087d9b915d4ede)(x0, x1, tz);
            tz = (0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        for(i = 0; i < n; ++i){
            x = values[i];
            if (x0 <= x && x <= x1) bins[(0, $ebc8358e83b40f6b$export$2e2bcd8739ae039)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $586e279ccd9ef5eb$export$2e2bcd8739ae039)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $586e279ccd9ef5eb$export$2e2bcd8739ae039)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $586e279ccd9ef5eb$export$2e2bcd8739ae039)((0, $9974eb0dba1d25a9$export$58adb3bec8346d0f).call(_)) : (0, $586e279ccd9ef5eb$export$2e2bcd8739ae039)(_), histogram) : threshold;
    };
    return histogram;
}






function $f418b2432d94f799$export$2e2bcd8739ae039(values, p, valueof) {
    if (valueof == null) valueof = (0, $07c377c535c03f01$export$2e2bcd8739ae039);
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}


function $b67f373b02cd7e4b$export$2e2bcd8739ae039(values, min, max) {
    values = (0, $9974eb0dba1d25a9$export$871de8747c9eaa88).call(values, (0, $07c377c535c03f01$export$2e2bcd8739ae039)).sort((0, $ac07eaf4741610f5$export$2e2bcd8739ae039));
    return Math.ceil((max - min) / (2 * ((0, $f418b2432d94f799$export$2e2bcd8739ae039)(values, 0.75) - (0, $f418b2432d94f799$export$2e2bcd8739ae039)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
}



function $dee7572d22b36efa$export$2e2bcd8739ae039(values, min, max) {
    return Math.ceil((max - min) / (3.5 * (0, $85eeec3a83d15642$export$2e2bcd8739ae039)(values) * Math.pow(values.length, -1 / 3)));
}



function $61a238ccfddb9bc1$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, max;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = values[i]) != null && value > max) max = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            max = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
        }
    }
    return max;
}



function $60e8b76e58f27a4f$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, m = n, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $07c377c535c03f01$export$2e2bcd8739ae039)(values[i]))) sum += value;
        else --m;
    } else {
        while(++i < n)if (!isNaN(value = (0, $07c377c535c03f01$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) sum += value;
        else --m;
    }
    if (m) return sum / m;
}





function $66c31c71f670a874$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, numbers = [];
    if (valueof == null) {
        while(++i < n)if (!isNaN(value = (0, $07c377c535c03f01$export$2e2bcd8739ae039)(values[i]))) numbers.push(value);
    } else {
        while(++i < n)if (!isNaN(value = (0, $07c377c535c03f01$export$2e2bcd8739ae039)(valueof(values[i], i, values)))) numbers.push(value);
    }
    return (0, $f418b2432d94f799$export$2e2bcd8739ae039)(numbers.sort((0, $ac07eaf4741610f5$export$2e2bcd8739ae039)), 0.5);
}


function $809b374c1c35a6b2$export$2e2bcd8739ae039(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while(++i < n)j += arrays[i].length;
    merged = new Array(j);
    while(--n >= 0){
        array = arrays[n];
        m = array.length;
        while(--m >= 0)merged[--j] = array[m];
    }
    return merged;
}


function $e123331673497592$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, min;
    if (valueof == null) {
        while(++i < n)if ((value = values[i]) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = values[i]) != null && min > value) min = value;
        }
    } else {
        while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
            min = value;
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
        }
    }
    return min;
}



function $0e0ce02817cdc9da$export$2e2bcd8739ae039(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while(i--)permutes[i] = array[indexes[i]];
    return permutes;
}





function $2f2912db9e3f822c$export$2e2bcd8739ae039(values, compare) {
    if (!(n = values.length)) return;
    var n, i = 0, j = 0, xi, xj = values[j];
    if (compare == null) compare = (0, $ac07eaf4741610f5$export$2e2bcd8739ae039);
    while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
    if (compare(xj, xj) === 0) return j;
}


function $acc5ee437767b549$export$2e2bcd8739ae039(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m + i0];
        array[m + i0] = array[i + i0];
        array[i + i0] = t;
    }
    return array;
}


function $e4491376e083738a$export$2e2bcd8739ae039(values, valueof) {
    var n = values.length, i = -1, value, sum = 0;
    if (valueof == null) {
        while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    } else {
        while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
    }
    return sum;
}




function $ef29b5fc92d1da58$export$2e2bcd8739ae039(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $e123331673497592$export$2e2bcd8739ae039)(matrix, $ef29b5fc92d1da58$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $ef29b5fc92d1da58$var$length(d) {
    return d.length;
}




function $514340aa7d75b685$export$2e2bcd8739ae039() {
    return (0, $ef29b5fc92d1da58$export$2e2bcd8739ae039)(arguments);
}




var $5202b6e48212307b$export$50d414a77b60d802 = Math.cos;
var $5202b6e48212307b$export$5de3937cb4b592ed = Math.sin;
var $5202b6e48212307b$export$18c7bea995a110f = Math.PI;
var $5202b6e48212307b$export$e51408a300e8929a = $5202b6e48212307b$export$18c7bea995a110f / 2;
var $5202b6e48212307b$export$a4b4b4d4d776fe92 = $5202b6e48212307b$export$18c7bea995a110f * 2;
var $5202b6e48212307b$export$8960430cfd85939f = Math.max;


function $f06b096cbc9eaee0$var$compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
function $f06b096cbc9eaee0$export$2e2bcd8739ae039() {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = [], groupIndex = (0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)(n), subgroupIndex = [], chords = [], groups = chords.groups = new Array(n), subgroups = new Array(n * n), k, x, x0, dx, i, j;
        // Compute the sum.
        k = 0, i = -1;
        while(++i < n){
            x = 0, j = -1;
            while(++j < n)x += matrix[i][j];
            groupSums.push(x);
            subgroupIndex.push((0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)(n));
            k += x;
        }
        // Sort groups…
        if (sortGroups) groupIndex.sort(function(a, b) {
            return sortGroups(groupSums[a], groupSums[b]);
        });
        // Sort subgroups…
        if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
            d.sort(function(a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
            });
        });
        // Convert the sum to scaling factor for [0, 2pi].
        // TODO Allow start and end angle to be specified?
        // TODO Allow padding to be specified as percentage?
        k = (0, $5202b6e48212307b$export$8960430cfd85939f)(0, (0, $5202b6e48212307b$export$a4b4b4d4d776fe92) - padAngle * n) / k;
        dx = k ? padAngle : (0, $5202b6e48212307b$export$a4b4b4d4d776fe92) / n;
        // Compute the start and end angle for each group and subgroup.
        // Note: Opera has a bug reordering object literal properties!
        x = 0, i = -1;
        while(++i < n){
            x0 = x, j = -1;
            while(++j < n){
                var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                subgroups[dj * n + di] = {
                    index: di,
                    subindex: dj,
                    startAngle: a0,
                    endAngle: a1,
                    value: v
                };
            }
            groups[di] = {
                index: di,
                startAngle: x0,
                endAngle: x,
                value: groupSums[di]
            };
            x += dx;
        }
        // Generate chords for each (non-empty) subgroup-subgroup link.
        i = -1;
        while(++i < n){
            j = i - 1;
            while(++j < n){
                var source = subgroups[j * n + i], target = subgroups[i * n + j];
                if (source.value || target.value) chords.push(source.value < target.value ? {
                    source: target,
                    target: source
                } : {
                    source: source,
                    target: target
                });
            }
        }
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function(_) {
        return arguments.length ? (padAngle = (0, $5202b6e48212307b$export$8960430cfd85939f)(0, _), chord) : padAngle;
    };
    chord.sortGroups = function(_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function(_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function(_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = $f06b096cbc9eaee0$var$compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}


var $b04d2b586a06757d$export$58adb3bec8346d0f = Array.prototype.slice;


function $6b660893fffa3c46$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



var $d29cec310fd417a9$var$pi = Math.PI, $d29cec310fd417a9$var$tau = 2 * $d29cec310fd417a9$var$pi, $d29cec310fd417a9$var$epsilon = 1e-6, $d29cec310fd417a9$var$tauEpsilon = $d29cec310fd417a9$var$tau - $d29cec310fd417a9$var$epsilon;
function $d29cec310fd417a9$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $d29cec310fd417a9$var$path() {
    return new $d29cec310fd417a9$var$Path;
}
$d29cec310fd417a9$var$Path.prototype = $d29cec310fd417a9$var$path.prototype = {
    constructor: $d29cec310fd417a9$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $d29cec310fd417a9$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $d29cec310fd417a9$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($d29cec310fd417a9$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $d29cec310fd417a9$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $d29cec310fd417a9$var$epsilon || Math.abs(this._y1 - y0) > $d29cec310fd417a9$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $d29cec310fd417a9$var$tau + $d29cec310fd417a9$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $d29cec310fd417a9$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $d29cec310fd417a9$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $d29cec310fd417a9$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $d29cec310fd417a9$export$2e2bcd8739ae039 = $d29cec310fd417a9$var$path;


function $2c4736dceb0d17e5$var$defaultSource(d) {
    return d.source;
}
function $2c4736dceb0d17e5$var$defaultTarget(d) {
    return d.target;
}
function $2c4736dceb0d17e5$var$defaultRadius(d) {
    return d.radius;
}
function $2c4736dceb0d17e5$var$defaultStartAngle(d) {
    return d.startAngle;
}
function $2c4736dceb0d17e5$var$defaultEndAngle(d) {
    return d.endAngle;
}
function $2c4736dceb0d17e5$export$2e2bcd8739ae039() {
    var source = $2c4736dceb0d17e5$var$defaultSource, target = $2c4736dceb0d17e5$var$defaultTarget, radius = $2c4736dceb0d17e5$var$defaultRadius, startAngle = $2c4736dceb0d17e5$var$defaultStartAngle, endAngle = $2c4736dceb0d17e5$var$defaultEndAngle, context = null;
    function ribbon() {
        var buffer, argv = (0, $b04d2b586a06757d$export$58adb3bec8346d0f).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv), sr = +radius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, $5202b6e48212307b$export$e51408a300e8929a), sa1 = endAngle.apply(this, argv) - (0, $5202b6e48212307b$export$e51408a300e8929a), sx0 = sr * (0, $5202b6e48212307b$export$50d414a77b60d802)(sa0), sy0 = sr * (0, $5202b6e48212307b$export$5de3937cb4b592ed)(sa0), tr = +radius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, $5202b6e48212307b$export$e51408a300e8929a), ta1 = endAngle.apply(this, argv) - (0, $5202b6e48212307b$export$e51408a300e8929a);
        if (!context) context = buffer = (0, $d29cec310fd417a9$export$2e2bcd8739ae039)();
        context.moveTo(sx0, sy0);
        context.arc(0, 0, sr, sa0, sa1);
        if (sa0 !== ta0 || sa1 !== ta1) {
            context.quadraticCurveTo(0, 0, tr * (0, $5202b6e48212307b$export$50d414a77b60d802)(ta0), tr * (0, $5202b6e48212307b$export$5de3937cb4b592ed)(ta0));
            context.arc(0, 0, tr, ta0, ta1);
        }
        context.quadraticCurveTo(0, 0, sx0, sy0);
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    ribbon.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $6b660893fffa3c46$export$2e2bcd8739ae039)(+_), ribbon) : radius;
    };
    ribbon.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $6b660893fffa3c46$export$2e2bcd8739ae039)(+_), ribbon) : startAngle;
    };
    ribbon.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $6b660893fffa3c46$export$2e2bcd8739ae039)(+_), ribbon) : endAngle;
    };
    ribbon.source = function(_) {
        return arguments.length ? (source = _, ribbon) : source;
    };
    ribbon.target = function(_) {
        return arguments.length ? (target = _, ribbon) : target;
    };
    ribbon.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
    };
    return ribbon;
}




var $f9d259c96143256b$export$82e9f45cca5ba907 = "$";
function $f9d259c96143256b$var$Map() {}
$f9d259c96143256b$var$Map.prototype = $f9d259c96143256b$var$map.prototype = {
    constructor: $f9d259c96143256b$var$Map,
    has: function(key) {
        return $f9d259c96143256b$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$f9d259c96143256b$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$f9d259c96143256b$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $f9d259c96143256b$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $f9d259c96143256b$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $f9d259c96143256b$var$map(object, f) {
    var map = new $f9d259c96143256b$var$Map;
    // Copy constructor.
    if (object instanceof $f9d259c96143256b$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $f9d259c96143256b$export$2e2bcd8739ae039 = $f9d259c96143256b$var$map;


function $4e3c8afbf7e573f4$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $f9d259c96143256b$export$2e2bcd8739ae039)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $4e3c8afbf7e573f4$var$createObject, $4e3c8afbf7e573f4$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $4e3c8afbf7e573f4$var$createMap, $4e3c8afbf7e573f4$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $4e3c8afbf7e573f4$var$createMap, $4e3c8afbf7e573f4$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $4e3c8afbf7e573f4$var$createObject() {
    return {};
}
function $4e3c8afbf7e573f4$var$setObject(object, key, value) {
    object[key] = value;
}
function $4e3c8afbf7e573f4$var$createMap() {
    return (0, $f9d259c96143256b$export$2e2bcd8739ae039)();
}
function $4e3c8afbf7e573f4$var$setMap(map, key, value) {
    map.set(key, value);
}



function $87f77f05795c14f4$var$Set() {}
var $87f77f05795c14f4$var$proto = (0, $f9d259c96143256b$export$2e2bcd8739ae039).prototype;
$87f77f05795c14f4$var$Set.prototype = $87f77f05795c14f4$var$set.prototype = {
    constructor: $87f77f05795c14f4$var$Set,
    has: $87f77f05795c14f4$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $f9d259c96143256b$export$82e9f45cca5ba907) + value] = value;
        return this;
    },
    remove: $87f77f05795c14f4$var$proto.remove,
    clear: $87f77f05795c14f4$var$proto.clear,
    values: $87f77f05795c14f4$var$proto.keys,
    size: $87f77f05795c14f4$var$proto.size,
    empty: $87f77f05795c14f4$var$proto.empty,
    each: $87f77f05795c14f4$var$proto.each
};
function $87f77f05795c14f4$var$set(object, f) {
    var set = new $87f77f05795c14f4$var$Set;
    // Copy constructor.
    if (object instanceof $87f77f05795c14f4$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $87f77f05795c14f4$export$2e2bcd8739ae039 = $87f77f05795c14f4$var$set;



function $e86bf5b7d6cc91f1$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}


function $94b5c9e25170bf7b$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}


function $aa793b1a45b4e485$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}





var $5bL8r = parcelRequire("5bL8r");

var $dKYzS = parcelRequire("dKYzS");

var $5bL8r = parcelRequire("5bL8r");
var $03668111efb25e43$export$b1b275608b2b1b8 = Math.PI / 180;
var $03668111efb25e43$export$b2ba2578f2c43d74 = 180 / Math.PI;


var $ab8b2b92bf5915d9$var$Kn = 18, $ab8b2b92bf5915d9$var$Xn = 0.950470, $ab8b2b92bf5915d9$var$Yn = 1, $ab8b2b92bf5915d9$var$Zn = 1.088830, $ab8b2b92bf5915d9$var$t0 = 4 / 29, $ab8b2b92bf5915d9$var$t1 = 6 / 29, $ab8b2b92bf5915d9$var$t2 = 3 * $ab8b2b92bf5915d9$var$t1 * $ab8b2b92bf5915d9$var$t1, $ab8b2b92bf5915d9$var$t3 = $ab8b2b92bf5915d9$var$t1 * $ab8b2b92bf5915d9$var$t1 * $ab8b2b92bf5915d9$var$t1;
function $ab8b2b92bf5915d9$var$labConvert(o) {
    if (o instanceof $ab8b2b92bf5915d9$export$f2722c70a60257f7) return new $ab8b2b92bf5915d9$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $ab8b2b92bf5915d9$export$d9397e094a5fbb9a) {
        var h = o.h * (0, $03668111efb25e43$export$b1b275608b2b1b8);
        return new $ab8b2b92bf5915d9$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    if (!(o instanceof (0, $5bL8r.Rgb))) o = (0, $5bL8r.rgbConvert)(o);
    var b = $ab8b2b92bf5915d9$var$rgb2xyz(o.r), a = $ab8b2b92bf5915d9$var$rgb2xyz(o.g), l = $ab8b2b92bf5915d9$var$rgb2xyz(o.b), x = $ab8b2b92bf5915d9$var$xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / $ab8b2b92bf5915d9$var$Xn), y = $ab8b2b92bf5915d9$var$xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / $ab8b2b92bf5915d9$var$Yn), z = $ab8b2b92bf5915d9$var$xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / $ab8b2b92bf5915d9$var$Zn);
    return new $ab8b2b92bf5915d9$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $ab8b2b92bf5915d9$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $ab8b2b92bf5915d9$var$labConvert(l) : new $ab8b2b92bf5915d9$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $ab8b2b92bf5915d9$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $dKYzS.default)($ab8b2b92bf5915d9$export$f2722c70a60257f7, $ab8b2b92bf5915d9$export$2e2bcd8739ae039, (0, $dKYzS.extend)((0, $5bL8r.Color), {
    brighter: function(k) {
        return new $ab8b2b92bf5915d9$export$f2722c70a60257f7(this.l + $ab8b2b92bf5915d9$var$Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $ab8b2b92bf5915d9$export$f2722c70a60257f7(this.l - $ab8b2b92bf5915d9$var$Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        y = $ab8b2b92bf5915d9$var$Yn * $ab8b2b92bf5915d9$var$lab2xyz(y);
        x = $ab8b2b92bf5915d9$var$Xn * $ab8b2b92bf5915d9$var$lab2xyz(x);
        z = $ab8b2b92bf5915d9$var$Zn * $ab8b2b92bf5915d9$var$lab2xyz(z);
        return new (0, $5bL8r.Rgb)($ab8b2b92bf5915d9$var$xyz2rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), $ab8b2b92bf5915d9$var$xyz2rgb(-0.969266 * x + 1.8760108 * y + 0.0415560 * z), $ab8b2b92bf5915d9$var$xyz2rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), this.opacity);
    }
}));
function $ab8b2b92bf5915d9$var$xyz2lab(t) {
    return t > $ab8b2b92bf5915d9$var$t3 ? Math.pow(t, 1 / 3) : t / $ab8b2b92bf5915d9$var$t2 + $ab8b2b92bf5915d9$var$t0;
}
function $ab8b2b92bf5915d9$var$lab2xyz(t) {
    return t > $ab8b2b92bf5915d9$var$t1 ? t * t * t : $ab8b2b92bf5915d9$var$t2 * (t - $ab8b2b92bf5915d9$var$t0);
}
function $ab8b2b92bf5915d9$var$xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $ab8b2b92bf5915d9$var$rgb2xyz(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $ab8b2b92bf5915d9$var$hclConvert(o) {
    if (o instanceof $ab8b2b92bf5915d9$export$d9397e094a5fbb9a) return new $ab8b2b92bf5915d9$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $ab8b2b92bf5915d9$export$f2722c70a60257f7)) o = $ab8b2b92bf5915d9$var$labConvert(o);
    var h = Math.atan2(o.b, o.a) * (0, $03668111efb25e43$export$b2ba2578f2c43d74);
    return new $ab8b2b92bf5915d9$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $ab8b2b92bf5915d9$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $ab8b2b92bf5915d9$var$hclConvert(h) : new $ab8b2b92bf5915d9$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $ab8b2b92bf5915d9$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $dKYzS.default)($ab8b2b92bf5915d9$export$d9397e094a5fbb9a, $ab8b2b92bf5915d9$export$d0e870ba50062ff1, (0, $dKYzS.extend)((0, $5bL8r.Color), {
    brighter: function(k) {
        return new $ab8b2b92bf5915d9$export$d9397e094a5fbb9a(this.h, this.c, this.l + $ab8b2b92bf5915d9$var$Kn * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $ab8b2b92bf5915d9$export$d9397e094a5fbb9a(this.h, this.c, this.l - $ab8b2b92bf5915d9$var$Kn * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $ab8b2b92bf5915d9$var$labConvert(this).rgb();
    }
}));



var $dKYzS = parcelRequire("dKYzS");

var $5bL8r = parcelRequire("5bL8r");

var $a1d976a639517d89$var$A = -0.14861, $a1d976a639517d89$var$B = 1.78277, $a1d976a639517d89$var$C = -0.29227, $a1d976a639517d89$var$D = -0.90649, $a1d976a639517d89$var$E = 1.97294, $a1d976a639517d89$var$ED = $a1d976a639517d89$var$E * $a1d976a639517d89$var$D, $a1d976a639517d89$var$EB = $a1d976a639517d89$var$E * $a1d976a639517d89$var$B, $a1d976a639517d89$var$BC_DA = $a1d976a639517d89$var$B * $a1d976a639517d89$var$C - $a1d976a639517d89$var$D * $a1d976a639517d89$var$A;
function $a1d976a639517d89$var$cubehelixConvert(o) {
    if (o instanceof $a1d976a639517d89$export$57ed4bde61a1e2f2) return new $a1d976a639517d89$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $5bL8r.Rgb))) o = (0, $5bL8r.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($a1d976a639517d89$var$BC_DA * b + $a1d976a639517d89$var$ED * r - $a1d976a639517d89$var$EB * g) / ($a1d976a639517d89$var$BC_DA + $a1d976a639517d89$var$ED - $a1d976a639517d89$var$EB), bl = b - l, k = ($a1d976a639517d89$var$E * (g - l) - $a1d976a639517d89$var$C * bl) / $a1d976a639517d89$var$D, s = Math.sqrt(k * k + bl * bl) / ($a1d976a639517d89$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $03668111efb25e43$export$b2ba2578f2c43d74) - 120 : NaN;
    return new $a1d976a639517d89$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $a1d976a639517d89$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $a1d976a639517d89$var$cubehelixConvert(h) : new $a1d976a639517d89$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $a1d976a639517d89$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $dKYzS.default)($a1d976a639517d89$export$57ed4bde61a1e2f2, $a1d976a639517d89$export$2e2bcd8739ae039, (0, $dKYzS.extend)((0, $5bL8r.Color), {
    brighter: function(k) {
        k = k == null ? (0, $5bL8r.brighter) : Math.pow((0, $5bL8r.brighter), k);
        return new $a1d976a639517d89$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $5bL8r.darker) : Math.pow((0, $5bL8r.darker), k);
        return new $a1d976a639517d89$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $03668111efb25e43$export$b1b275608b2b1b8), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $5bL8r.Rgb)(255 * (l + a * ($a1d976a639517d89$var$A * cosh + $a1d976a639517d89$var$B * sinh)), 255 * (l + a * ($a1d976a639517d89$var$C * cosh + $a1d976a639517d89$var$D * sinh)), 255 * (l + a * ($a1d976a639517d89$var$E * cosh)), this.opacity);
    }
}));




var $c9515d5398667545$var$noop = {
    value: function() {}
};
function $c9515d5398667545$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $c9515d5398667545$var$Dispatch(_);
}
function $c9515d5398667545$var$Dispatch(_) {
    this._ = _;
}
function $c9515d5398667545$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$c9515d5398667545$var$Dispatch.prototype = $c9515d5398667545$var$dispatch.prototype = {
    constructor: $c9515d5398667545$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $c9515d5398667545$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $c9515d5398667545$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $c9515d5398667545$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $c9515d5398667545$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $c9515d5398667545$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $c9515d5398667545$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $c9515d5398667545$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $c9515d5398667545$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $c9515d5398667545$export$2e2bcd8739ae039 = $c9515d5398667545$var$dispatch;




var $ecf1033b15c76961$var$noop = {
    value: function() {}
};
function $ecf1033b15c76961$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $ecf1033b15c76961$var$Dispatch(_);
}
function $ecf1033b15c76961$var$Dispatch(_) {
    this._ = _;
}
function $ecf1033b15c76961$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$ecf1033b15c76961$var$Dispatch.prototype = $ecf1033b15c76961$var$dispatch.prototype = {
    constructor: $ecf1033b15c76961$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $ecf1033b15c76961$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $ecf1033b15c76961$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $ecf1033b15c76961$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $ecf1033b15c76961$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $ecf1033b15c76961$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $ecf1033b15c76961$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $ecf1033b15c76961$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $ecf1033b15c76961$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $ecf1033b15c76961$export$2e2bcd8739ae039 = $ecf1033b15c76961$var$dispatch;


var $0383e60967e24fea$var$filterEvents = {};
var $0383e60967e24fea$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $0383e60967e24fea$var$element = document.documentElement;
    if (!("onmouseenter" in $0383e60967e24fea$var$element)) $0383e60967e24fea$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $0383e60967e24fea$var$filterContextListener(listener, index, group) {
    listener = $0383e60967e24fea$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $0383e60967e24fea$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $0383e60967e24fea$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $0383e60967e24fea$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $0383e60967e24fea$export$6cd530ed55e06764 = event0;
        }
    };
}
function $0383e60967e24fea$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $0383e60967e24fea$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $0383e60967e24fea$var$onAdd(typename, value, capture) {
    var wrap = $0383e60967e24fea$var$filterEvents.hasOwnProperty(typename.type) ? $0383e60967e24fea$var$filterContextListener : $0383e60967e24fea$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $0383e60967e24fea$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $0383e60967e24fea$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $0383e60967e24fea$var$onAdd : $0383e60967e24fea$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $0383e60967e24fea$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $0383e60967e24fea$export$6cd530ed55e06764;
    event1.sourceEvent = $0383e60967e24fea$export$6cd530ed55e06764;
    $0383e60967e24fea$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $0383e60967e24fea$export$6cd530ed55e06764 = event0;
    }
}


function $c5042787164d6ee7$export$2e2bcd8739ae039() {
    var current = (0, $0383e60967e24fea$export$6cd530ed55e06764), source;
    while(source = current.sourceEvent)current = source;
    return current;
}


function $6a93369071a64fb4$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}


function $21ae33b2cc2362da$export$2e2bcd8739ae039(node) {
    var event = (0, $c5042787164d6ee7$export$2e2bcd8739ae039)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $6a93369071a64fb4$export$2e2bcd8739ae039)(node, event);
}


function $76bf7f1b19dd4689$var$none() {}
function $76bf7f1b19dd4689$export$2e2bcd8739ae039(selector) {
    return selector == null ? $76bf7f1b19dd4689$var$none : function() {
        return this.querySelector(selector);
    };
}


function $7df527edab03d9c2$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $76bf7f1b19dd4689$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(subgroups, this._parents);
}



function $8c29b0deb78a3047$var$empty() {
    return [];
}
function $8c29b0deb78a3047$export$2e2bcd8739ae039(selector) {
    return selector == null ? $8c29b0deb78a3047$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $14dd2711e09565e7$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $8c29b0deb78a3047$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(subgroups, parents);
}



function $1f4e0038925c9a74$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}


function $cc4b94b5f30d65dc$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $1f4e0038925c9a74$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(subgroups, this._parents);
}



function $72256ae052bf81a5$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $57662c24217a2be4$export$2e2bcd8739ae039() {
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(this._enter || this._groups.map((0, $72256ae052bf81a5$export$2e2bcd8739ae039)), this._parents);
}
function $57662c24217a2be4$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$57662c24217a2be4$export$67b01759a14cf6a4.prototype = {
    constructor: $57662c24217a2be4$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $11963db61566e602$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


var $4da5a7b2a1ce7e7b$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $4da5a7b2a1ce7e7b$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $57662c24217a2be4$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $4da5a7b2a1ce7e7b$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $4da5a7b2a1ce7e7b$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $4da5a7b2a1ce7e7b$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $57662c24217a2be4$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $4da5a7b2a1ce7e7b$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $4da5a7b2a1ce7e7b$var$bindKey : $4da5a7b2a1ce7e7b$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $11963db61566e602$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $e8b555d3058f741c$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $bc500b14bf396a67$export$2e2bcd8739ae039() {
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(this._exit || this._groups.map((0, $72256ae052bf81a5$export$2e2bcd8739ae039)), this._parents);
}


function $7ec932c66fb44110$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $55121c0ac6c62382$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(merges, this._parents);
}


function $4f72244fd4b888dd$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $f670bdca68ce7d50$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $f670bdca68ce7d50$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $e8b555d3058f741c$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $f670bdca68ce7d50$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $bb31b3a127589fa9$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $b20e711dcde24cc3$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}


function $603facc5970ac568$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $34271ca46f96d0e2$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}


function $3d1f140dc534d11f$export$2e2bcd8739ae039() {
    return !this.node();
}


function $70e790250f79dc26$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $d1d0673f2cec5ba3$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $d1d0673f2cec5ba3$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $d1d0673f2cec5ba3$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $ffd18f5199bac038$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $d1d0673f2cec5ba3$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $d1d0673f2cec5ba3$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name;
}


function $4adfba69a13b2a91$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $4adfba69a13b2a91$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $4adfba69a13b2a91$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $4adfba69a13b2a91$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $4adfba69a13b2a91$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $4adfba69a13b2a91$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $4adfba69a13b2a91$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $ffd18f5199bac038$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $4adfba69a13b2a91$var$attrRemoveNS : $4adfba69a13b2a91$var$attrRemove : typeof value === "function" ? fullname.local ? $4adfba69a13b2a91$var$attrFunctionNS : $4adfba69a13b2a91$var$attrFunction : fullname.local ? $4adfba69a13b2a91$var$attrConstantNS : $4adfba69a13b2a91$var$attrConstant)(fullname, value));
}


function $4869baefd29346b0$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $e3c350fc9a588a86$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $e3c350fc9a588a86$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $e3c350fc9a588a86$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $e3c350fc9a588a86$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $e3c350fc9a588a86$var$styleRemove : typeof value === "function" ? $e3c350fc9a588a86$var$styleFunction : $e3c350fc9a588a86$var$styleConstant)(name, value, priority == null ? "" : priority)) : $e3c350fc9a588a86$export$5e3cec964f0b5efd(this.node(), name);
}
function $e3c350fc9a588a86$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $4869baefd29346b0$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $c7c1cbada1bb9834$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $c7c1cbada1bb9834$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $c7c1cbada1bb9834$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $c7c1cbada1bb9834$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $c7c1cbada1bb9834$var$propertyRemove : typeof value === "function" ? $c7c1cbada1bb9834$var$propertyFunction : $c7c1cbada1bb9834$var$propertyConstant)(name, value)) : this.node()[name];
}


function $edf8947a3e716fc7$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $edf8947a3e716fc7$var$classList(node) {
    return node.classList || new $edf8947a3e716fc7$var$ClassList(node);
}
function $edf8947a3e716fc7$var$ClassList(node) {
    this._node = node;
    this._names = $edf8947a3e716fc7$var$classArray(node.getAttribute("class") || "");
}
$edf8947a3e716fc7$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $edf8947a3e716fc7$var$classedAdd(node, names) {
    var list = $edf8947a3e716fc7$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $edf8947a3e716fc7$var$classedRemove(node, names) {
    var list = $edf8947a3e716fc7$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $edf8947a3e716fc7$var$classedTrue(names) {
    return function() {
        $edf8947a3e716fc7$var$classedAdd(this, names);
    };
}
function $edf8947a3e716fc7$var$classedFalse(names) {
    return function() {
        $edf8947a3e716fc7$var$classedRemove(this, names);
    };
}
function $edf8947a3e716fc7$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $edf8947a3e716fc7$var$classedAdd : $edf8947a3e716fc7$var$classedRemove)(this, names);
    };
}
function $edf8947a3e716fc7$export$2e2bcd8739ae039(name, value) {
    var names = $edf8947a3e716fc7$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $edf8947a3e716fc7$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $edf8947a3e716fc7$var$classedFunction : value ? $edf8947a3e716fc7$var$classedTrue : $edf8947a3e716fc7$var$classedFalse)(names, value));
}


function $e564f444aa5f2259$var$textRemove() {
    this.textContent = "";
}
function $e564f444aa5f2259$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e564f444aa5f2259$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $e564f444aa5f2259$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $e564f444aa5f2259$var$textRemove : (typeof value === "function" ? $e564f444aa5f2259$var$textFunction : $e564f444aa5f2259$var$textConstant)(value)) : this.node().textContent;
}


function $7e83f8a36a6504ca$var$htmlRemove() {
    this.innerHTML = "";
}
function $7e83f8a36a6504ca$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $7e83f8a36a6504ca$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $7e83f8a36a6504ca$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $7e83f8a36a6504ca$var$htmlRemove : (typeof value === "function" ? $7e83f8a36a6504ca$var$htmlFunction : $7e83f8a36a6504ca$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $6c78dd76a23a2efb$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $6c78dd76a23a2efb$export$2e2bcd8739ae039() {
    return this.each($6c78dd76a23a2efb$var$raise);
}


function $9ab3048bbdeb3024$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $9ab3048bbdeb3024$export$2e2bcd8739ae039() {
    return this.each($9ab3048bbdeb3024$var$lower);
}




function $239851271f8eb958$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $d1d0673f2cec5ba3$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $d1d0673f2cec5ba3$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $239851271f8eb958$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $239851271f8eb958$export$2e2bcd8739ae039(name) {
    var fullname = (0, $ffd18f5199bac038$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $239851271f8eb958$var$creatorFixed : $239851271f8eb958$var$creatorInherit)(fullname);
}


function $e2d7677da9b0198c$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $239851271f8eb958$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $3cfd2d834e663cde$var$constantNull() {
    return null;
}
function $3cfd2d834e663cde$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $239851271f8eb958$export$2e2bcd8739ae039)(name), select = before == null ? $3cfd2d834e663cde$var$constantNull : typeof before === "function" ? before : (0, $76bf7f1b19dd4689$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $5cafd7bcdce3c6ec$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $5cafd7bcdce3c6ec$export$2e2bcd8739ae039() {
    return this.each($5cafd7bcdce3c6ec$var$remove);
}


function $a7f8577cc34ff9dd$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $a7f8577cc34ff9dd$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $a7f8577cc34ff9dd$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $a7f8577cc34ff9dd$var$selection_cloneDeep : $a7f8577cc34ff9dd$var$selection_cloneShallow);
}


function $352857aa3abb94a0$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}




function $62f1dc9dc76c3ef9$var$dispatchEvent(node, type, params) {
    var window = (0, $4869baefd29346b0$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $62f1dc9dc76c3ef9$var$dispatchConstant(type, params) {
    return function() {
        return $62f1dc9dc76c3ef9$var$dispatchEvent(this, type, params);
    };
}
function $62f1dc9dc76c3ef9$var$dispatchFunction(type, params) {
    return function() {
        return $62f1dc9dc76c3ef9$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $62f1dc9dc76c3ef9$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $62f1dc9dc76c3ef9$var$dispatchFunction : $62f1dc9dc76c3ef9$var$dispatchConstant)(type, params));
}


var $e8b555d3058f741c$export$e8e78c978b129247 = [
    null
];
function $e8b555d3058f741c$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $e8b555d3058f741c$var$selection() {
    return new $e8b555d3058f741c$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $e8b555d3058f741c$export$e8e78c978b129247);
}
$e8b555d3058f741c$export$52baac22726c72bf.prototype = $e8b555d3058f741c$var$selection.prototype = {
    constructor: $e8b555d3058f741c$export$52baac22726c72bf,
    select: (0, $7df527edab03d9c2$export$2e2bcd8739ae039),
    selectAll: (0, $14dd2711e09565e7$export$2e2bcd8739ae039),
    filter: (0, $cc4b94b5f30d65dc$export$2e2bcd8739ae039),
    data: (0, $4da5a7b2a1ce7e7b$export$2e2bcd8739ae039),
    enter: (0, $57662c24217a2be4$export$2e2bcd8739ae039),
    exit: (0, $bc500b14bf396a67$export$2e2bcd8739ae039),
    join: (0, $7ec932c66fb44110$export$2e2bcd8739ae039),
    merge: (0, $55121c0ac6c62382$export$2e2bcd8739ae039),
    order: (0, $4f72244fd4b888dd$export$2e2bcd8739ae039),
    sort: (0, $f670bdca68ce7d50$export$2e2bcd8739ae039),
    call: (0, $bb31b3a127589fa9$export$2e2bcd8739ae039),
    nodes: (0, $b20e711dcde24cc3$export$2e2bcd8739ae039),
    node: (0, $603facc5970ac568$export$2e2bcd8739ae039),
    size: (0, $34271ca46f96d0e2$export$2e2bcd8739ae039),
    empty: (0, $3d1f140dc534d11f$export$2e2bcd8739ae039),
    each: (0, $70e790250f79dc26$export$2e2bcd8739ae039),
    attr: (0, $4adfba69a13b2a91$export$2e2bcd8739ae039),
    style: (0, $e3c350fc9a588a86$export$2e2bcd8739ae039),
    property: (0, $c7c1cbada1bb9834$export$2e2bcd8739ae039),
    classed: (0, $edf8947a3e716fc7$export$2e2bcd8739ae039),
    text: (0, $e564f444aa5f2259$export$2e2bcd8739ae039),
    html: (0, $7e83f8a36a6504ca$export$2e2bcd8739ae039),
    raise: (0, $6c78dd76a23a2efb$export$2e2bcd8739ae039),
    lower: (0, $9ab3048bbdeb3024$export$2e2bcd8739ae039),
    append: (0, $e2d7677da9b0198c$export$2e2bcd8739ae039),
    insert: (0, $3cfd2d834e663cde$export$2e2bcd8739ae039),
    remove: (0, $5cafd7bcdce3c6ec$export$2e2bcd8739ae039),
    clone: (0, $a7f8577cc34ff9dd$export$2e2bcd8739ae039),
    datum: (0, $352857aa3abb94a0$export$2e2bcd8739ae039),
    on: (0, $0383e60967e24fea$export$2e2bcd8739ae039),
    dispatch: (0, $62f1dc9dc76c3ef9$export$2e2bcd8739ae039)
};
var $e8b555d3058f741c$export$2e2bcd8739ae039 = $e8b555d3058f741c$var$selection;


function $81d2060de99d6983$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $e8b555d3058f741c$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $e8b555d3058f741c$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $e8b555d3058f741c$export$e8e78c978b129247));
}



function $f42aef48a13b0100$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $c5042787164d6ee7$export$2e2bcd8739ae039)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $6a93369071a64fb4$export$2e2bcd8739ae039)(node, touch);
    }
    return null;
}




function $7ec0d1044c416f7b$export$2e2561858db9bf47() {
    (0, $0383e60967e24fea$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $7ec0d1044c416f7b$export$2e2bcd8739ae039() {
    (0, $0383e60967e24fea$export$6cd530ed55e06764).preventDefault();
    (0, $0383e60967e24fea$export$6cd530ed55e06764).stopImmediatePropagation();
}


function $8c97706f05fd2db4$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $81d2060de99d6983$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $7ec0d1044c416f7b$export$2e2bcd8739ae039), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $7ec0d1044c416f7b$export$2e2bcd8739ae039), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $8c97706f05fd2db4$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $81d2060de99d6983$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $7ec0d1044c416f7b$export$2e2bcd8739ae039), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



function $953dd55fe4bf003e$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $f24e747b08aeef4e$export$2e2bcd8739ae039(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
$f24e747b08aeef4e$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $fbd8ab131c40da80$var$defaultFilter() {
    return !(0, $0383e60967e24fea$export$6cd530ed55e06764).button;
}
function $fbd8ab131c40da80$var$defaultContainer() {
    return this.parentNode;
}
function $fbd8ab131c40da80$var$defaultSubject(d) {
    return d == null ? {
        x: (0, $0383e60967e24fea$export$6cd530ed55e06764).x,
        y: (0, $0383e60967e24fea$export$6cd530ed55e06764).y
    } : d;
}
function $fbd8ab131c40da80$var$defaultTouchable() {
    return "ontouchstart" in this;
}
function $fbd8ab131c40da80$export$2e2bcd8739ae039() {
    var filter = $fbd8ab131c40da80$var$defaultFilter, container = $fbd8ab131c40da80$var$defaultContainer, subject = $fbd8ab131c40da80$var$defaultSubject, touchable = $fbd8ab131c40da80$var$defaultTouchable, gestures = {}, listeners = (0, $ecf1033b15c76961$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var gesture = beforestart("mouse", container.apply(this, arguments), (0, $21ae33b2cc2362da$export$2e2bcd8739ae039), this, arguments);
        if (!gesture) return;
        (0, $81d2060de99d6983$export$2e2bcd8739ae039)((0, $0383e60967e24fea$export$6cd530ed55e06764).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
        (0, $8c97706f05fd2db4$export$2e2bcd8739ae039)((0, $0383e60967e24fea$export$6cd530ed55e06764).view);
        (0, $7ec0d1044c416f7b$export$2e2561858db9bf47)();
        mousemoving = false;
        mousedownx = (0, $0383e60967e24fea$export$6cd530ed55e06764).clientX;
        mousedowny = (0, $0383e60967e24fea$export$6cd530ed55e06764).clientY;
        gesture("start");
    }
    function mousemoved() {
        (0, $7ec0d1044c416f7b$export$2e2bcd8739ae039)();
        if (!mousemoving) {
            var dx = (0, $0383e60967e24fea$export$6cd530ed55e06764).clientX - mousedownx, dy = (0, $0383e60967e24fea$export$6cd530ed55e06764).clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag");
    }
    function mouseupped() {
        (0, $81d2060de99d6983$export$2e2bcd8739ae039)((0, $0383e60967e24fea$export$6cd530ed55e06764).view).on("mousemove.drag mouseup.drag", null);
        (0, $8c97706f05fd2db4$export$833237748009e1e1)((0, $0383e60967e24fea$export$6cd530ed55e06764).view, mousemoving);
        (0, $7ec0d1044c416f7b$export$2e2bcd8739ae039)();
        gestures.mouse("end");
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var touches = (0, $0383e60967e24fea$export$6cd530ed55e06764).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, $f42aef48a13b0100$export$2e2bcd8739ae039), this, arguments)) {
            (0, $7ec0d1044c416f7b$export$2e2561858db9bf47)();
            gesture("start");
        }
    }
    function touchmoved() {
        var touches = (0, $0383e60967e24fea$export$6cd530ed55e06764).changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $7ec0d1044c416f7b$export$2e2bcd8739ae039)();
            gesture("drag");
        }
    }
    function touchended() {
        var touches = (0, $0383e60967e24fea$export$6cd530ed55e06764).changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $7ec0d1044c416f7b$export$2e2561858db9bf47)();
            gesture("end");
        }
    }
    function beforestart(id, container, point, that, args) {
        var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
        if (!(0, $0383e60967e24fea$export$4c724631b4750aef)(new (0, $f24e747b08aeef4e$export$2e2bcd8739ae039)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
            if (((0, $0383e60967e24fea$export$6cd530ed55e06764).subject = s = subject.apply(that, args)) == null) return false;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return true;
        })) return;
        return function gesture(type) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[id] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[id], --active; // nobreak
                case "drag":
                    p = point(container, id), n = active;
                    break;
            }
            (0, $0383e60967e24fea$export$4c724631b4750aef)(new (0, $f24e747b08aeef4e$export$2e2bcd8739ae039)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                type,
                that,
                args
            ]);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $953dd55fe4bf003e$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $953dd55fe4bf003e$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $953dd55fe4bf003e$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $953dd55fe4bf003e$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}





var $25c503558e0d243a$var$EOL = {}, $25c503558e0d243a$var$EOF = {}, $25c503558e0d243a$var$QUOTE = 34, $25c503558e0d243a$var$NEWLINE = 10, $25c503558e0d243a$var$RETURN = 13;
function $25c503558e0d243a$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "]";
    }).join(",") + "}");
}
function $25c503558e0d243a$var$customConverter(columns, f) {
    var object = $25c503558e0d243a$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $25c503558e0d243a$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $25c503558e0d243a$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $25c503558e0d243a$var$customConverter(row, f) : $25c503558e0d243a$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $25c503558e0d243a$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $25c503558e0d243a$var$RETURN) --N;
        function token() {
            if (eof) return $25c503558e0d243a$var$EOF;
            if (eol) return eol = false, $25c503558e0d243a$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $25c503558e0d243a$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $25c503558e0d243a$var$QUOTE || text.charCodeAt(++I) === $25c503558e0d243a$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $25c503558e0d243a$var$NEWLINE) eol = true;
                else if (c === $25c503558e0d243a$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $25c503558e0d243a$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $25c503558e0d243a$var$NEWLINE) eol = true;
                else if (c === $25c503558e0d243a$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $25c503558e0d243a$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $25c503558e0d243a$var$EOF){
            var row = [];
            while(t !== $25c503558e0d243a$var$EOL && t !== $25c503558e0d243a$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function format(rows, columns) {
        if (columns == null) columns = $25c503558e0d243a$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        })).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
        return text == null ? "" : reFormat.test(text += "") ? "\"" + text.replace(/"/g, "\"\"") + "\"" : text;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatRows: formatRows
    };
}



var $05038a8137f3ac98$var$csv = (0, $25c503558e0d243a$export$2e2bcd8739ae039)(",");
var $05038a8137f3ac98$export$289d25497b0f4c16 = $05038a8137f3ac98$var$csv.parse;
var $05038a8137f3ac98$export$c82550ca942d869 = $05038a8137f3ac98$var$csv.parseRows;
var $05038a8137f3ac98$export$afe767551074aa08 = $05038a8137f3ac98$var$csv.format;
var $05038a8137f3ac98$export$3f42a65843fbd1d9 = $05038a8137f3ac98$var$csv.formatRows;



var $0871617b497d4e9d$var$tsv = (0, $25c503558e0d243a$export$2e2bcd8739ae039)("\t");
var $0871617b497d4e9d$export$f913251db2f734ee = $0871617b497d4e9d$var$tsv.parse;
var $0871617b497d4e9d$export$8de3b5abc40a067f = $0871617b497d4e9d$var$tsv.parseRows;
var $0871617b497d4e9d$export$77e754c4f8504293 = $0871617b497d4e9d$var$tsv.format;
var $0871617b497d4e9d$export$ae461973f6adc981 = $0871617b497d4e9d$var$tsv.formatRows;




function $1fc66d7e78a5fd75$export$45db2fc2f15997e7(t) {
    return +t;
}


function $4e601c7c887f248f$export$5118fc7a1e64441b(t) {
    return t * t;
}
function $4e601c7c887f248f$export$5be5f5e804d0b60c(t) {
    return t * (2 - t);
}
function $4e601c7c887f248f$export$d6ded66933892ed3(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


function $dc79710e1d9f0cdf$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $dc79710e1d9f0cdf$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $dc79710e1d9f0cdf$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


var $506a6287b6c73b7d$var$exponent = 3;
var $506a6287b6c73b7d$export$aa0b5c3ce2df9d7d = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}($506a6287b6c73b7d$var$exponent);
var $506a6287b6c73b7d$export$e3d987a417dc6640 = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}($506a6287b6c73b7d$var$exponent);
var $506a6287b6c73b7d$export$ae94c6a40058b429 = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}($506a6287b6c73b7d$var$exponent);


var $514ee9022bf7648c$var$pi = Math.PI, $514ee9022bf7648c$var$halfPi = $514ee9022bf7648c$var$pi / 2;
function $514ee9022bf7648c$export$a83a280f8d31ba8d(t) {
    return 1 - Math.cos(t * $514ee9022bf7648c$var$halfPi);
}
function $514ee9022bf7648c$export$62ec6410ca53f2a7(t) {
    return Math.sin(t * $514ee9022bf7648c$var$halfPi);
}
function $514ee9022bf7648c$export$ff58b604d3ba15ba(t) {
    return (1 - Math.cos($514ee9022bf7648c$var$pi * t)) / 2;
}


function $14b8efd68d1abaa7$export$fc3e95f15e1ef38e(t) {
    return Math.pow(2, 10 * t - 10);
}
function $14b8efd68d1abaa7$export$f3c9b2f85fbcf0ab(t) {
    return 1 - Math.pow(2, -10 * t);
}
function $14b8efd68d1abaa7$export$ae4d4e77fab188ff(t) {
    return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


function $efb6d5a21657c571$export$9f82a71b0377c018(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function $efb6d5a21657c571$export$27989e665abef2c8(t) {
    return Math.sqrt(1 - --t * t);
}
function $efb6d5a21657c571$export$2d757ff9ad09038f(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


var $ab8564a0e6a324d6$var$b1 = 4 / 11, $ab8564a0e6a324d6$var$b2 = 6 / 11, $ab8564a0e6a324d6$var$b3 = 8 / 11, $ab8564a0e6a324d6$var$b4 = 3 / 4, $ab8564a0e6a324d6$var$b5 = 9 / 11, $ab8564a0e6a324d6$var$b6 = 10 / 11, $ab8564a0e6a324d6$var$b7 = 15 / 16, $ab8564a0e6a324d6$var$b8 = 21 / 22, $ab8564a0e6a324d6$var$b9 = 63 / 64, $ab8564a0e6a324d6$var$b0 = 1 / $ab8564a0e6a324d6$var$b1 / $ab8564a0e6a324d6$var$b1;
function $ab8564a0e6a324d6$export$fccebd7948554554(t) {
    return 1 - $ab8564a0e6a324d6$export$cccc9e04465dce11(1 - t);
}
function $ab8564a0e6a324d6$export$cccc9e04465dce11(t) {
    return (t = +t) < $ab8564a0e6a324d6$var$b1 ? $ab8564a0e6a324d6$var$b0 * t * t : t < $ab8564a0e6a324d6$var$b3 ? $ab8564a0e6a324d6$var$b0 * (t -= $ab8564a0e6a324d6$var$b2) * t + $ab8564a0e6a324d6$var$b4 : t < $ab8564a0e6a324d6$var$b6 ? $ab8564a0e6a324d6$var$b0 * (t -= $ab8564a0e6a324d6$var$b5) * t + $ab8564a0e6a324d6$var$b7 : $ab8564a0e6a324d6$var$b0 * (t -= $ab8564a0e6a324d6$var$b8) * t + $ab8564a0e6a324d6$var$b9;
}
function $ab8564a0e6a324d6$export$41ad9e9849a703ce(t) {
    return ((t *= 2) <= 1 ? 1 - $ab8564a0e6a324d6$export$cccc9e04465dce11(1 - t) : $ab8564a0e6a324d6$export$cccc9e04465dce11(t - 1) + 1) / 2;
}


var $1026fa12c946d0df$var$overshoot = 1.70158;
var $1026fa12c946d0df$export$b01116c84cdfe1a2 = function custom(s) {
    s = +s;
    function backIn(t) {
        return t * t * ((s + 1) * t - s);
    }
    backIn.overshoot = custom;
    return backIn;
}($1026fa12c946d0df$var$overshoot);
var $1026fa12c946d0df$export$77edfce482316a60 = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((s + 1) * t + s) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}($1026fa12c946d0df$var$overshoot);
var $1026fa12c946d0df$export$ddc5fd596f6c71b2 = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}($1026fa12c946d0df$var$overshoot);


var $4ccaa5bb479503e1$var$tau = 2 * Math.PI, $4ccaa5bb479503e1$var$amplitude = 1, $4ccaa5bb479503e1$var$period = 0.3;
var $4ccaa5bb479503e1$export$41f42134872a5fa0 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $4ccaa5bb479503e1$var$tau);
    function elasticIn(t) {
        return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * $4ccaa5bb479503e1$var$tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}($4ccaa5bb479503e1$var$amplitude, $4ccaa5bb479503e1$var$period);
var $4ccaa5bb479503e1$export$ed1782b99e69bbc8 = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $4ccaa5bb479503e1$var$tau);
    function elasticOut(t) {
        return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * $4ccaa5bb479503e1$var$tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}($4ccaa5bb479503e1$var$amplitude, $4ccaa5bb479503e1$var$period);
var $4ccaa5bb479503e1$export$309de4f35f218bfd = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= $4ccaa5bb479503e1$var$tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p) : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * $4ccaa5bb479503e1$var$tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}($4ccaa5bb479503e1$var$amplitude, $4ccaa5bb479503e1$var$period);




function $72592693f8b9eeef$export$2e2bcd8739ae039(x, y) {
    var nodes;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}


function $3f4157e71d7f6fb5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $7ba65eecbbb2e105$export$2e2bcd8739ae039() {
    return (Math.random() - 0.5) * 1e-6;
}


function $5bbbb108d760cf33$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $5bbbb108d760cf33$var$add(this.cover(x, y), x, y, d);
}
function $5bbbb108d760cf33$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $5bbbb108d760cf33$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$5bbbb108d760cf33$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $5ea26b1f5cb06fd5$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $8da7f37bc31840c1$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $b92adc5d757b4c6b$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $4039b82eacd823ce$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $1278061f79f686b0$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $abd819b87128443c$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $abd819b87128443c$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $3fe6ea355a2da722$export$2e2bcd8739ae039() {
    return this._root;
}


function $754841cd54ab03a8$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $470f293c956e86de$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $2d65aa4b2922c64c$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $4039b82eacd823ce$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $8417e431907c2f86$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $8417e431907c2f86$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $1367d19d7c0eee37$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $1367d19d7c0eee37$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $a9286f4c05033d58$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $a9286f4c05033d58$var$Quadtree(x == null ? (0, $8417e431907c2f86$export$e6fafc98131d2a44) : x, y == null ? (0, $1367d19d7c0eee37$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $a9286f4c05033d58$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $a9286f4c05033d58$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $a9286f4c05033d58$var$treeProto = $a9286f4c05033d58$export$2e2bcd8739ae039.prototype = $a9286f4c05033d58$var$Quadtree.prototype;
$a9286f4c05033d58$var$treeProto.copy = function() {
    var copy = new $a9286f4c05033d58$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $a9286f4c05033d58$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $a9286f4c05033d58$var$leaf_copy(child);
        }
    }
    return copy;
};
$a9286f4c05033d58$var$treeProto.add = (0, $5bbbb108d760cf33$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.addAll = (0, $5bbbb108d760cf33$export$32ed0561867ec8a1);
$a9286f4c05033d58$var$treeProto.cover = (0, $5ea26b1f5cb06fd5$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.data = (0, $8da7f37bc31840c1$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.extent = (0, $b92adc5d757b4c6b$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.find = (0, $1278061f79f686b0$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.remove = (0, $abd819b87128443c$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.removeAll = (0, $abd819b87128443c$export$1cfc7aad5cb1833b);
$a9286f4c05033d58$var$treeProto.root = (0, $3fe6ea355a2da722$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.size = (0, $754841cd54ab03a8$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.visit = (0, $470f293c956e86de$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.visitAfter = (0, $2d65aa4b2922c64c$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.x = (0, $8417e431907c2f86$export$2e2bcd8739ae039);
$a9286f4c05033d58$var$treeProto.y = (0, $1367d19d7c0eee37$export$2e2bcd8739ae039);


function $a00b5d89a57b1ce3$var$x(d) {
    return d.x + d.vx;
}
function $a00b5d89a57b1ce3$var$y(d) {
    return d.y + d.vy;
}
function $a00b5d89a57b1ce3$export$2e2bcd8739ae039(radius) {
    var nodes, radii, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $a9286f4c05033d58$export$2e2bcd8739ae039)(nodes, $a00b5d89a57b1ce3$var$x, $a00b5d89a57b1ce3$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)(), l += x * x;
                        if (y === 0) y = (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)(), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}




var $26d518efaa36ea37$export$82e9f45cca5ba907 = "$";
function $26d518efaa36ea37$var$Map() {}
$26d518efaa36ea37$var$Map.prototype = $26d518efaa36ea37$var$map.prototype = {
    constructor: $26d518efaa36ea37$var$Map,
    has: function(key) {
        return $26d518efaa36ea37$export$82e9f45cca5ba907 + key in this;
    },
    get: function(key) {
        return this[$26d518efaa36ea37$export$82e9f45cca5ba907 + key];
    },
    set: function(key, value) {
        this[$26d518efaa36ea37$export$82e9f45cca5ba907 + key] = value;
        return this;
    },
    remove: function(key) {
        var property = $26d518efaa36ea37$export$82e9f45cca5ba907 + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === $26d518efaa36ea37$export$82e9f45cca5ba907) f(this[property], property.slice(1), this);
    }
};
function $26d518efaa36ea37$var$map(object, f) {
    var map = new $26d518efaa36ea37$var$Map;
    // Copy constructor.
    if (object instanceof $26d518efaa36ea37$var$Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
var $26d518efaa36ea37$export$2e2bcd8739ae039 = $26d518efaa36ea37$var$map;


function $b1204be9d29fb18e$export$2e2bcd8739ae039() {
    var keys = [], sortKeys = [], sortValues, rollup, nest;
    function apply(array, depth, createResult, setResult) {
        if (depth >= keys.length) {
            if (sortValues != null) array.sort(sortValues);
            return rollup != null ? rollup(array) : array;
        }
        var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, $26d518efaa36ea37$export$2e2bcd8739ae039)(), values, result = createResult();
        while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
        else valuesByKey.set(keyValue, [
            value
        ]);
        valuesByKey.each(function(values, key) {
            setResult(result, key, apply(values, depth, createResult, setResult));
        });
        return result;
    }
    function entries(map, depth) {
        if (++depth > keys.length) return map;
        var array, sortKey = sortKeys[depth - 1];
        if (rollup != null && depth >= keys.length) array = map.entries();
        else array = [], map.each(function(v, k) {
            array.push({
                key: k,
                values: entries(v, depth)
            });
        });
        return sortKey != null ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
        }) : array;
    }
    return nest = {
        object: function(array) {
            return apply(array, 0, $b1204be9d29fb18e$var$createObject, $b1204be9d29fb18e$var$setObject);
        },
        map: function(array) {
            return apply(array, 0, $b1204be9d29fb18e$var$createMap, $b1204be9d29fb18e$var$setMap);
        },
        entries: function(array) {
            return entries(apply(array, 0, $b1204be9d29fb18e$var$createMap, $b1204be9d29fb18e$var$setMap), 0);
        },
        key: function(d) {
            keys.push(d);
            return nest;
        },
        sortKeys: function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        },
        sortValues: function(order) {
            sortValues = order;
            return nest;
        },
        rollup: function(f) {
            rollup = f;
            return nest;
        }
    };
}
function $b1204be9d29fb18e$var$createObject() {
    return {};
}
function $b1204be9d29fb18e$var$setObject(object, key, value) {
    object[key] = value;
}
function $b1204be9d29fb18e$var$createMap() {
    return (0, $26d518efaa36ea37$export$2e2bcd8739ae039)();
}
function $b1204be9d29fb18e$var$setMap(map, key, value) {
    map.set(key, value);
}



function $48e8b4346e82b1b1$var$Set() {}
var $48e8b4346e82b1b1$var$proto = (0, $26d518efaa36ea37$export$2e2bcd8739ae039).prototype;
$48e8b4346e82b1b1$var$Set.prototype = $48e8b4346e82b1b1$var$set.prototype = {
    constructor: $48e8b4346e82b1b1$var$Set,
    has: $48e8b4346e82b1b1$var$proto.has,
    add: function(value) {
        value += "";
        this[(0, $26d518efaa36ea37$export$82e9f45cca5ba907) + value] = value;
        return this;
    },
    remove: $48e8b4346e82b1b1$var$proto.remove,
    clear: $48e8b4346e82b1b1$var$proto.clear,
    values: $48e8b4346e82b1b1$var$proto.keys,
    size: $48e8b4346e82b1b1$var$proto.size,
    empty: $48e8b4346e82b1b1$var$proto.empty,
    each: $48e8b4346e82b1b1$var$proto.each
};
function $48e8b4346e82b1b1$var$set(object, f) {
    var set = new $48e8b4346e82b1b1$var$Set;
    // Copy constructor.
    if (object instanceof $48e8b4346e82b1b1$var$Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
var $48e8b4346e82b1b1$export$2e2bcd8739ae039 = $48e8b4346e82b1b1$var$set;



function $ac3bc485793088d4$export$2e2bcd8739ae039(map) {
    var keys = [];
    for(var key in map)keys.push(key);
    return keys;
}


function $1770d290a593374a$export$2e2bcd8739ae039(map) {
    var values = [];
    for(var key in map)values.push(map[key]);
    return values;
}


function $6f45086338852fe7$export$2e2bcd8739ae039(map) {
    var entries = [];
    for(var key in map)entries.push({
        key: key,
        value: map[key]
    });
    return entries;
}




function $c114a2fef12ff363$var$index(d) {
    return d.index;
}
function $c114a2fef12ff363$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
}
function $c114a2fef12ff363$export$2e2bcd8739ae039(links) {
    var id = $c114a2fef12ff363$var$index, strength = defaultStrength, strengths, distance = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(30), distances, nodes, count, bias, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)();
            y = target.y + target.vy - source.y - source.vy || (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)();
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = (0, $26d518efaa36ea37$export$2e2bcd8739ae039)(nodes, id), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $c114a2fef12ff363$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $c114a2fef12ff363$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}








function $5d3029066360b104$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $5d3029066360b104$export$4a5767248b18ef41(d) {
    return d.y;
}
var $5d3029066360b104$var$initialRadius = 10, $5d3029066360b104$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $5d3029066360b104$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, $26d518efaa36ea37$export$2e2bcd8739ae039)(), stepper = (0, $87dbce956a1d037c$export$9dc4ecf953986f04)(step), event = (0, $f1a1df54262d4945$export$2e2bcd8739ae039)("tick", "end");
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick() {
        var i, n = nodes.length, node;
        alpha += (alphaTarget - alpha) * alphaDecay;
        forces.each(function(force) {
            force(alpha);
        });
        for(i = 0; i < n; ++i){
            node = nodes[i];
            if (node.fx == null) node.x += node.vx *= velocityDecay;
            else node.x = node.fx, node.vx = 0;
            if (node.fy == null) node.y += node.vy *= velocityDecay;
            else node.y = node.fy, node.vy = 0;
        }
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $5d3029066360b104$var$initialRadius * Math.sqrt(i), angle = i * $5d3029066360b104$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $43c1ba767391d064$export$2e2bcd8739ae039() {
    var nodes, node, alpha, strength = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $a9286f4c05033d58$export$2e2bcd8739ae039)(nodes, (0, $5d3029066360b104$export$d141bba7fdc215a3), (0, $5d3029066360b104$export$4a5767248b18ef41)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)(), l += x * x;
                if (y === 0) y = (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)(), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)(), l += x * x;
            if (y === 0) y = (0, $7ba65eecbbb2e105$export$2e2bcd8739ae039)(), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}



function $30467bed3b62344e$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}




function $b1a34331a7f8cf9d$export$2e2bcd8739ae039(x) {
    var strength = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : x;
    };
    return force;
}



function $a71361fda0f3a96e$export$2e2bcd8739ae039(y) {
    var strength = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $3f4157e71d7f6fb5$export$2e2bcd8739ae039)(+_), initialize(), force) : y;
    };
    return force;
}




// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
function $cbb9f25887355499$export$2e2bcd8739ae039(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $0aa5c3863365947d$export$2e2bcd8739ae039(x) {
    return x = (0, $cbb9f25887355499$export$2e2bcd8739ae039)(Math.abs(x)), x ? x[1] : NaN;
}


function $eee971c18a69ef26$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $a393da87aae122ee$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


function $6940e2c1241ad5e4$export$2e2bcd8739ae039(x, p) {
    x = x.toPrecision(p);
    out: for(var n = x.length, i = 1, i0 = -1, i1; i < n; ++i)switch(x[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        case "e":
            break out;
        default:
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
}



var $2c81721795921763$export$6863724d9a42263;
function $2c81721795921763$export$2e2bcd8739ae039(x, p) {
    var d = (0, $cbb9f25887355499$export$2e2bcd8739ae039)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($2c81721795921763$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $cbb9f25887355499$export$2e2bcd8739ae039)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $989e0d002aafc802$export$2e2bcd8739ae039(x, p) {
    var d = (0, $cbb9f25887355499$export$2e2bcd8739ae039)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $1c308ce698ff2ff2$export$2e2bcd8739ae039 = {
    "": (0, $6940e2c1241ad5e4$export$2e2bcd8739ae039),
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": function(x) {
        return Math.round(x).toString(10);
    },
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $989e0d002aafc802$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $989e0d002aafc802$export$2e2bcd8739ae039),
    "s": (0, $2c81721795921763$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var $f1abee0b799a2570$var$re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
function $f1abee0b799a2570$export$2e2bcd8739ae039(specifier) {
    return new $f1abee0b799a2570$var$FormatSpecifier(specifier);
}
$f1abee0b799a2570$export$2e2bcd8739ae039.prototype = $f1abee0b799a2570$var$FormatSpecifier.prototype; // instanceof
function $f1abee0b799a2570$var$FormatSpecifier(specifier) {
    if (!(match = $f1abee0b799a2570$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match, fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zero = !!match[5], width = match[6] && +match[6], comma = !!match[7], precision = match[8] && +match[8].slice(1), type = match[9] || "";
    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";
    else if (!(0, $1c308ce698ff2ff2$export$2e2bcd8739ae039)[type]) type = "";
    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
    this.fill = fill;
    this.align = align;
    this.sign = sign;
    this.symbol = symbol;
    this.zero = zero;
    this.width = width;
    this.comma = comma;
    this.precision = precision;
    this.type = type;
}
$f1abee0b799a2570$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + this.type;
};




function $37180e8604af4152$export$2e2bcd8739ae039(x) {
    return x;
}


var $4ac8c0d930ecca32$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $4ac8c0d930ecca32$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping && locale.thousands ? (0, $eee971c18a69ef26$export$2e2bcd8739ae039)(locale.grouping, locale.thousands) : (0, $37180e8604af4152$export$2e2bcd8739ae039), currency = locale.currency, decimal = locale.decimal, numerals = locale.numerals ? (0, $a393da87aae122ee$export$2e2bcd8739ae039)(locale.numerals) : (0, $37180e8604af4152$export$2e2bcd8739ae039), percent = locale.percent || "%";
    function newFormat(specifier) {
        specifier = (0, $f1abee0b799a2570$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, type = specifier.type;
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $1c308ce698ff2ff2$export$2e2bcd8739ae039)[type], maybeSuffix = !type || /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision == null ? type ? 6 : 12 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Perform the initial formatting.
                var valueNegative = value < 0;
                value = formatType(Math.abs(value), precision);
                // If a negative value rounds to zero during formatting, treat as positive.
                if (valueNegative && +value === 0) valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : "-" : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $4ac8c0d930ecca32$var$prefixes[8 + (0, $2c81721795921763$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $f1abee0b799a2570$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $0aa5c3863365947d$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $4ac8c0d930ecca32$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $1b1bb56af5b47b07$var$locale;
var $1b1bb56af5b47b07$export$d9468344d3651243;
var $1b1bb56af5b47b07$export$8d85692a469dde6f;
$1b1bb56af5b47b07$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $1b1bb56af5b47b07$export$2e2bcd8739ae039(definition) {
    $1b1bb56af5b47b07$var$locale = (0, $4ac8c0d930ecca32$export$2e2bcd8739ae039)(definition);
    $1b1bb56af5b47b07$export$d9468344d3651243 = $1b1bb56af5b47b07$var$locale.format;
    $1b1bb56af5b47b07$export$8d85692a469dde6f = $1b1bb56af5b47b07$var$locale.formatPrefix;
    return $1b1bb56af5b47b07$var$locale;
}





function $4f1ec0bca71712ae$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $0aa5c3863365947d$export$2e2bcd8739ae039)(Math.abs(step)));
}



function $a6eadc454f39cf8c$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $0aa5c3863365947d$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $0aa5c3863365947d$export$2e2bcd8739ae039)(Math.abs(step)));
}



function $987798405d6a5eac$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $0aa5c3863365947d$export$2e2bcd8739ae039)(max) - (0, $0aa5c3863365947d$export$2e2bcd8739ae039)(step)) + 1;
}




// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
function $3fdaf69483da55a8$export$2e2bcd8739ae039() {
    return new $3fdaf69483da55a8$var$Adder;
}
function $3fdaf69483da55a8$var$Adder() {
    this.reset();
}
$3fdaf69483da55a8$var$Adder.prototype = {
    constructor: $3fdaf69483da55a8$var$Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        $3fdaf69483da55a8$var$add($3fdaf69483da55a8$var$temp, y, this.t);
        $3fdaf69483da55a8$var$add(this, $3fdaf69483da55a8$var$temp.s, this.s);
        if (this.s) this.t += $3fdaf69483da55a8$var$temp.t;
        else this.s = $3fdaf69483da55a8$var$temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var $3fdaf69483da55a8$var$temp = new $3fdaf69483da55a8$var$Adder;
function $3fdaf69483da55a8$var$add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}


var $70840aecc36cf34e$export$6c421550c66a327d = 1e-6;
var $70840aecc36cf34e$export$92c06fba281fe81b = 1e-12;
var $70840aecc36cf34e$export$18c7bea995a110f = Math.PI;
var $70840aecc36cf34e$export$e51408a300e8929a = $70840aecc36cf34e$export$18c7bea995a110f / 2;
var $70840aecc36cf34e$export$c39a5cba78ea0fc2 = $70840aecc36cf34e$export$18c7bea995a110f / 4;
var $70840aecc36cf34e$export$a4b4b4d4d776fe92 = $70840aecc36cf34e$export$18c7bea995a110f * 2;
var $70840aecc36cf34e$export$41fc368e1a942b97 = 180 / $70840aecc36cf34e$export$18c7bea995a110f;
var $70840aecc36cf34e$export$8449e153fbd325fc = $70840aecc36cf34e$export$18c7bea995a110f / 180;
var $70840aecc36cf34e$export$2335f513bbd82c6d = Math.abs;
var $70840aecc36cf34e$export$628dc4eed22b0fbd = Math.atan;
var $70840aecc36cf34e$export$b8b770ee6a0d9760 = Math.atan2;
var $70840aecc36cf34e$export$50d414a77b60d802 = Math.cos;
var $70840aecc36cf34e$export$803ce6b71a0a94b2 = Math.ceil;
var $70840aecc36cf34e$export$b310ec824aaee37f = Math.exp;
var $70840aecc36cf34e$export$a3fe094919f356fd = Math.floor;
var $70840aecc36cf34e$export$bef1f36f5486a6a3 = Math.log;
var $70840aecc36cf34e$export$9c297f60e22e3389 = Math.pow;
var $70840aecc36cf34e$export$5de3937cb4b592ed = Math.sin;
var $70840aecc36cf34e$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $70840aecc36cf34e$export$eba8049fb5020b81 = Math.sqrt;
var $70840aecc36cf34e$export$fcdd3b0b3246a325 = Math.tan;
function $70840aecc36cf34e$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $70840aecc36cf34e$export$18c7bea995a110f : Math.acos(x);
}
function $70840aecc36cf34e$export$41726bdb1fc63f(x) {
    return x > 1 ? $70840aecc36cf34e$export$e51408a300e8929a : x < -1 ? -$70840aecc36cf34e$export$e51408a300e8929a : Math.asin(x);
}
function $70840aecc36cf34e$export$e808712c2966e662(x) {
    return (x = $70840aecc36cf34e$export$5de3937cb4b592ed(x / 2)) * x;
}


function $6015f26a2955b66b$export$2e2bcd8739ae039() {}


function $632b0d86f5bfaeaf$var$streamGeometry(geometry, stream) {
    if (geometry && $632b0d86f5bfaeaf$var$streamGeometryType.hasOwnProperty(geometry.type)) $632b0d86f5bfaeaf$var$streamGeometryType[geometry.type](geometry, stream);
}
var $632b0d86f5bfaeaf$var$streamObjectType = {
    Feature: function(object, stream) {
        $632b0d86f5bfaeaf$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$632b0d86f5bfaeaf$var$streamGeometry(features[i].geometry, stream);
    }
};
var $632b0d86f5bfaeaf$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $632b0d86f5bfaeaf$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$632b0d86f5bfaeaf$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $632b0d86f5bfaeaf$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$632b0d86f5bfaeaf$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$632b0d86f5bfaeaf$var$streamGeometry(geometries[i], stream);
    }
};
function $632b0d86f5bfaeaf$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $632b0d86f5bfaeaf$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$632b0d86f5bfaeaf$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $632b0d86f5bfaeaf$export$2e2bcd8739ae039(object, stream) {
    if (object && $632b0d86f5bfaeaf$var$streamObjectType.hasOwnProperty(object.type)) $632b0d86f5bfaeaf$var$streamObjectType[object.type](object, stream);
    else $632b0d86f5bfaeaf$var$streamGeometry(object, stream);
}


var $1d42c5d7b24edc40$export$bf8f994332070c7f = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)();
var $1d42c5d7b24edc40$var$areaSum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)(), $1d42c5d7b24edc40$var$lambda00, $1d42c5d7b24edc40$var$phi00, $1d42c5d7b24edc40$var$lambda0, $1d42c5d7b24edc40$var$cosPhi0, $1d42c5d7b24edc40$var$sinPhi0;
var $1d42c5d7b24edc40$export$cb67cfa750ae69dc = {
    point: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineStart: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    polygonStart: function() {
        $1d42c5d7b24edc40$export$bf8f994332070c7f.reset();
        $1d42c5d7b24edc40$export$cb67cfa750ae69dc.lineStart = $1d42c5d7b24edc40$var$areaRingStart;
        $1d42c5d7b24edc40$export$cb67cfa750ae69dc.lineEnd = $1d42c5d7b24edc40$var$areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +$1d42c5d7b24edc40$export$bf8f994332070c7f;
        $1d42c5d7b24edc40$var$areaSum.add(areaRing < 0 ? (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, $6015f26a2955b66b$export$2e2bcd8739ae039);
    },
    sphere: function() {
        $1d42c5d7b24edc40$var$areaSum.add((0, $70840aecc36cf34e$export$a4b4b4d4d776fe92));
    }
};
function $1d42c5d7b24edc40$var$areaRingStart() {
    $1d42c5d7b24edc40$export$cb67cfa750ae69dc.point = $1d42c5d7b24edc40$var$areaPointFirst;
}
function $1d42c5d7b24edc40$var$areaRingEnd() {
    $1d42c5d7b24edc40$var$areaPoint($1d42c5d7b24edc40$var$lambda00, $1d42c5d7b24edc40$var$phi00);
}
function $1d42c5d7b24edc40$var$areaPointFirst(lambda, phi) {
    $1d42c5d7b24edc40$export$cb67cfa750ae69dc.point = $1d42c5d7b24edc40$var$areaPoint;
    $1d42c5d7b24edc40$var$lambda00 = lambda, $1d42c5d7b24edc40$var$phi00 = phi;
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    $1d42c5d7b24edc40$var$lambda0 = lambda, $1d42c5d7b24edc40$var$cosPhi0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi = phi / 2 + (0, $70840aecc36cf34e$export$c39a5cba78ea0fc2)), $1d42c5d7b24edc40$var$sinPhi0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi);
}
function $1d42c5d7b24edc40$var$areaPoint(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    phi = phi / 2 + (0, $70840aecc36cf34e$export$c39a5cba78ea0fc2); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - $1d42c5d7b24edc40$var$lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi), sinPhi = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), k = $1d42c5d7b24edc40$var$sinPhi0 * sinPhi, u = $1d42c5d7b24edc40$var$cosPhi0 * cosPhi + k * (0, $70840aecc36cf34e$export$50d414a77b60d802)(adLambda), v = k * sdLambda * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(adLambda);
    $1d42c5d7b24edc40$export$bf8f994332070c7f.add((0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(v, u));
    // Advance the previous points.
    $1d42c5d7b24edc40$var$lambda0 = lambda, $1d42c5d7b24edc40$var$cosPhi0 = cosPhi, $1d42c5d7b24edc40$var$sinPhi0 = sinPhi;
}
function $1d42c5d7b24edc40$export$2e2bcd8739ae039(object) {
    $1d42c5d7b24edc40$var$areaSum.reset();
    (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, $1d42c5d7b24edc40$export$cb67cfa750ae69dc);
    return $1d42c5d7b24edc40$var$areaSum * 2;
}





function $49177a3f7b861183$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $70840aecc36cf34e$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $49177a3f7b861183$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda),
        (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi)
    ];
}
function $49177a3f7b861183$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $49177a3f7b861183$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $49177a3f7b861183$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $49177a3f7b861183$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $49177a3f7b861183$export$6789498aec2cb34b(d) {
    var l = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}




var $30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$phi0, $30870850ff092f3f$var$lambda1, $30870850ff092f3f$var$phi1, $30870850ff092f3f$var$lambda2, $30870850ff092f3f$var$lambda00, $30870850ff092f3f$var$phi00, $30870850ff092f3f$var$p0, $30870850ff092f3f$var$deltaSum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)(), $30870850ff092f3f$var$ranges, $30870850ff092f3f$var$range;
var $30870850ff092f3f$var$boundsStream = {
    point: $30870850ff092f3f$var$boundsPoint,
    lineStart: $30870850ff092f3f$var$boundsLineStart,
    lineEnd: $30870850ff092f3f$var$boundsLineEnd,
    polygonStart: function() {
        $30870850ff092f3f$var$boundsStream.point = $30870850ff092f3f$var$boundsRingPoint;
        $30870850ff092f3f$var$boundsStream.lineStart = $30870850ff092f3f$var$boundsRingStart;
        $30870850ff092f3f$var$boundsStream.lineEnd = $30870850ff092f3f$var$boundsRingEnd;
        $30870850ff092f3f$var$deltaSum.reset();
        (0, $1d42c5d7b24edc40$export$cb67cfa750ae69dc).polygonStart();
    },
    polygonEnd: function() {
        (0, $1d42c5d7b24edc40$export$cb67cfa750ae69dc).polygonEnd();
        $30870850ff092f3f$var$boundsStream.point = $30870850ff092f3f$var$boundsPoint;
        $30870850ff092f3f$var$boundsStream.lineStart = $30870850ff092f3f$var$boundsLineStart;
        $30870850ff092f3f$var$boundsStream.lineEnd = $30870850ff092f3f$var$boundsLineEnd;
        if ((0, $1d42c5d7b24edc40$export$bf8f994332070c7f) < 0) $30870850ff092f3f$var$lambda0 = -($30870850ff092f3f$var$lambda1 = 180), $30870850ff092f3f$var$phi0 = -($30870850ff092f3f$var$phi1 = 90);
        else if ($30870850ff092f3f$var$deltaSum > (0, $70840aecc36cf34e$export$6c421550c66a327d)) $30870850ff092f3f$var$phi1 = 90;
        else if ($30870850ff092f3f$var$deltaSum < -(0, $70840aecc36cf34e$export$6c421550c66a327d)) $30870850ff092f3f$var$phi0 = -90;
        $30870850ff092f3f$var$range[0] = $30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$range[1] = $30870850ff092f3f$var$lambda1;
    }
};
function $30870850ff092f3f$var$boundsPoint(lambda, phi) {
    $30870850ff092f3f$var$ranges.push($30870850ff092f3f$var$range = [
        $30870850ff092f3f$var$lambda0 = lambda,
        $30870850ff092f3f$var$lambda1 = lambda
    ]);
    if (phi < $30870850ff092f3f$var$phi0) $30870850ff092f3f$var$phi0 = phi;
    if (phi > $30870850ff092f3f$var$phi1) $30870850ff092f3f$var$phi1 = phi;
}
function $30870850ff092f3f$var$linePoint(lambda, phi) {
    var p = (0, $49177a3f7b861183$export$6e6697ef026a96)([
        lambda * (0, $70840aecc36cf34e$export$8449e153fbd325fc),
        phi * (0, $70840aecc36cf34e$export$8449e153fbd325fc)
    ]);
    if ($30870850ff092f3f$var$p0) {
        var normal = (0, $49177a3f7b861183$export$4763f5351b14293f)($30870850ff092f3f$var$p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, $49177a3f7b861183$export$4763f5351b14293f)(equatorial, normal);
        (0, $49177a3f7b861183$export$6789498aec2cb34b)(inflection);
        inflection = (0, $49177a3f7b861183$export$12f9ad44fe773943)(inflection);
        var delta = lambda - $30870850ff092f3f$var$lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, $70840aecc36cf34e$export$41fc368e1a942b97) * sign, phii, antimeridian = (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(delta) > 180;
        if (antimeridian ^ (sign * $30870850ff092f3f$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, $70840aecc36cf34e$export$41fc368e1a942b97);
            if (phii > $30870850ff092f3f$var$phi1) $30870850ff092f3f$var$phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * $30870850ff092f3f$var$lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, $70840aecc36cf34e$export$41fc368e1a942b97);
            if (phii < $30870850ff092f3f$var$phi0) $30870850ff092f3f$var$phi0 = phii;
        } else {
            if (phi < $30870850ff092f3f$var$phi0) $30870850ff092f3f$var$phi0 = phi;
            if (phi > $30870850ff092f3f$var$phi1) $30870850ff092f3f$var$phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < $30870850ff092f3f$var$lambda2) {
                if ($30870850ff092f3f$var$angle($30870850ff092f3f$var$lambda0, lambda) > $30870850ff092f3f$var$angle($30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$lambda1)) $30870850ff092f3f$var$lambda1 = lambda;
            } else if ($30870850ff092f3f$var$angle(lambda, $30870850ff092f3f$var$lambda1) > $30870850ff092f3f$var$angle($30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$lambda1)) $30870850ff092f3f$var$lambda0 = lambda;
        } else if ($30870850ff092f3f$var$lambda1 >= $30870850ff092f3f$var$lambda0) {
            if (lambda < $30870850ff092f3f$var$lambda0) $30870850ff092f3f$var$lambda0 = lambda;
            if (lambda > $30870850ff092f3f$var$lambda1) $30870850ff092f3f$var$lambda1 = lambda;
        } else {
            if (lambda > $30870850ff092f3f$var$lambda2) {
                if ($30870850ff092f3f$var$angle($30870850ff092f3f$var$lambda0, lambda) > $30870850ff092f3f$var$angle($30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$lambda1)) $30870850ff092f3f$var$lambda1 = lambda;
            } else if ($30870850ff092f3f$var$angle(lambda, $30870850ff092f3f$var$lambda1) > $30870850ff092f3f$var$angle($30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$lambda1)) $30870850ff092f3f$var$lambda0 = lambda;
        }
    } else $30870850ff092f3f$var$ranges.push($30870850ff092f3f$var$range = [
        $30870850ff092f3f$var$lambda0 = lambda,
        $30870850ff092f3f$var$lambda1 = lambda
    ]);
    if (phi < $30870850ff092f3f$var$phi0) $30870850ff092f3f$var$phi0 = phi;
    if (phi > $30870850ff092f3f$var$phi1) $30870850ff092f3f$var$phi1 = phi;
    $30870850ff092f3f$var$p0 = p, $30870850ff092f3f$var$lambda2 = lambda;
}
function $30870850ff092f3f$var$boundsLineStart() {
    $30870850ff092f3f$var$boundsStream.point = $30870850ff092f3f$var$linePoint;
}
function $30870850ff092f3f$var$boundsLineEnd() {
    $30870850ff092f3f$var$range[0] = $30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$range[1] = $30870850ff092f3f$var$lambda1;
    $30870850ff092f3f$var$boundsStream.point = $30870850ff092f3f$var$boundsPoint;
    $30870850ff092f3f$var$p0 = null;
}
function $30870850ff092f3f$var$boundsRingPoint(lambda, phi) {
    if ($30870850ff092f3f$var$p0) {
        var delta = lambda - $30870850ff092f3f$var$lambda2;
        $30870850ff092f3f$var$deltaSum.add((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else $30870850ff092f3f$var$lambda00 = lambda, $30870850ff092f3f$var$phi00 = phi;
    (0, $1d42c5d7b24edc40$export$cb67cfa750ae69dc).point(lambda, phi);
    $30870850ff092f3f$var$linePoint(lambda, phi);
}
function $30870850ff092f3f$var$boundsRingStart() {
    (0, $1d42c5d7b24edc40$export$cb67cfa750ae69dc).lineStart();
}
function $30870850ff092f3f$var$boundsRingEnd() {
    $30870850ff092f3f$var$boundsRingPoint($30870850ff092f3f$var$lambda00, $30870850ff092f3f$var$phi00);
    (0, $1d42c5d7b24edc40$export$cb67cfa750ae69dc).lineEnd();
    if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)($30870850ff092f3f$var$deltaSum) > (0, $70840aecc36cf34e$export$6c421550c66a327d)) $30870850ff092f3f$var$lambda0 = -($30870850ff092f3f$var$lambda1 = 180);
    $30870850ff092f3f$var$range[0] = $30870850ff092f3f$var$lambda0, $30870850ff092f3f$var$range[1] = $30870850ff092f3f$var$lambda1;
    $30870850ff092f3f$var$p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function $30870850ff092f3f$var$angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function $30870850ff092f3f$var$rangeCompare(a, b) {
    return a[0] - b[0];
}
function $30870850ff092f3f$var$rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}
function $30870850ff092f3f$export$2e2bcd8739ae039(feature) {
    var i, n, a, b, merged, deltaMax, delta;
    $30870850ff092f3f$var$phi1 = $30870850ff092f3f$var$lambda1 = -($30870850ff092f3f$var$lambda0 = $30870850ff092f3f$var$phi0 = Infinity);
    $30870850ff092f3f$var$ranges = [];
    (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(feature, $30870850ff092f3f$var$boundsStream);
    // First, sort ranges by their minimum longitudes.
    if (n = $30870850ff092f3f$var$ranges.length) {
        $30870850ff092f3f$var$ranges.sort($30870850ff092f3f$var$rangeCompare);
        // Then, merge any ranges that overlap.
        for(i = 1, a = $30870850ff092f3f$var$ranges[0], merged = [
            a
        ]; i < n; ++i){
            b = $30870850ff092f3f$var$ranges[i];
            if ($30870850ff092f3f$var$rangeContains(a, b[0]) || $30870850ff092f3f$var$rangeContains(a, b[1])) {
                if ($30870850ff092f3f$var$angle(a[0], b[1]) > $30870850ff092f3f$var$angle(a[0], a[1])) a[1] = b[1];
                if ($30870850ff092f3f$var$angle(b[0], a[1]) > $30870850ff092f3f$var$angle(a[0], a[1])) a[0] = b[0];
            } else merged.push(a = b);
        }
        // Finally, find the largest gap between the merged ranges.
        // The final bounding box will be the inverse of this gap.
        for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
            b = merged[i];
            if ((delta = $30870850ff092f3f$var$angle(a[1], b[0])) > deltaMax) deltaMax = delta, $30870850ff092f3f$var$lambda0 = b[0], $30870850ff092f3f$var$lambda1 = a[1];
        }
    }
    $30870850ff092f3f$var$ranges = $30870850ff092f3f$var$range = null;
    return $30870850ff092f3f$var$lambda0 === Infinity || $30870850ff092f3f$var$phi0 === Infinity ? [
        [
            NaN,
            NaN
        ],
        [
            NaN,
            NaN
        ]
    ] : [
        [
            $30870850ff092f3f$var$lambda0,
            $30870850ff092f3f$var$phi0
        ],
        [
            $30870850ff092f3f$var$lambda1,
            $30870850ff092f3f$var$phi1
        ]
    ];
}





var $2953d6306df9720b$var$W0, $2953d6306df9720b$var$W1, $2953d6306df9720b$var$X0, $2953d6306df9720b$var$Y0, $2953d6306df9720b$var$Z0, $2953d6306df9720b$var$X1, $2953d6306df9720b$var$Y1, $2953d6306df9720b$var$Z1, $2953d6306df9720b$var$X2, $2953d6306df9720b$var$Y2, $2953d6306df9720b$var$Z2, $2953d6306df9720b$var$lambda00, $2953d6306df9720b$var$phi00, $2953d6306df9720b$var$x0, $2953d6306df9720b$var$y0, $2953d6306df9720b$var$z0; // previous point
var $2953d6306df9720b$var$centroidStream = {
    sphere: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    point: $2953d6306df9720b$var$centroidPoint,
    lineStart: $2953d6306df9720b$var$centroidLineStart,
    lineEnd: $2953d6306df9720b$var$centroidLineEnd,
    polygonStart: function() {
        $2953d6306df9720b$var$centroidStream.lineStart = $2953d6306df9720b$var$centroidRingStart;
        $2953d6306df9720b$var$centroidStream.lineEnd = $2953d6306df9720b$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $2953d6306df9720b$var$centroidStream.lineStart = $2953d6306df9720b$var$centroidLineStart;
        $2953d6306df9720b$var$centroidStream.lineEnd = $2953d6306df9720b$var$centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function $2953d6306df9720b$var$centroidPoint(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi);
    $2953d6306df9720b$var$centroidPointCartesian(cosPhi * (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda), cosPhi * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda), (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi));
}
function $2953d6306df9720b$var$centroidPointCartesian(x, y, z) {
    ++$2953d6306df9720b$var$W0;
    $2953d6306df9720b$var$X0 += (x - $2953d6306df9720b$var$X0) / $2953d6306df9720b$var$W0;
    $2953d6306df9720b$var$Y0 += (y - $2953d6306df9720b$var$Y0) / $2953d6306df9720b$var$W0;
    $2953d6306df9720b$var$Z0 += (z - $2953d6306df9720b$var$Z0) / $2953d6306df9720b$var$W0;
}
function $2953d6306df9720b$var$centroidLineStart() {
    $2953d6306df9720b$var$centroidStream.point = $2953d6306df9720b$var$centroidLinePointFirst;
}
function $2953d6306df9720b$var$centroidLinePointFirst(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi);
    $2953d6306df9720b$var$x0 = cosPhi * (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda);
    $2953d6306df9720b$var$y0 = cosPhi * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda);
    $2953d6306df9720b$var$z0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi);
    $2953d6306df9720b$var$centroidStream.point = $2953d6306df9720b$var$centroidLinePoint;
    $2953d6306df9720b$var$centroidPointCartesian($2953d6306df9720b$var$x0, $2953d6306df9720b$var$y0, $2953d6306df9720b$var$z0);
}
function $2953d6306df9720b$var$centroidLinePoint(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi), x = cosPhi * (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda), z = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), w = (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)((0, $70840aecc36cf34e$export$eba8049fb5020b81)((w = $2953d6306df9720b$var$y0 * z - $2953d6306df9720b$var$z0 * y) * w + (w = $2953d6306df9720b$var$z0 * x - $2953d6306df9720b$var$x0 * z) * w + (w = $2953d6306df9720b$var$x0 * y - $2953d6306df9720b$var$y0 * x) * w), $2953d6306df9720b$var$x0 * x + $2953d6306df9720b$var$y0 * y + $2953d6306df9720b$var$z0 * z);
    $2953d6306df9720b$var$W1 += w;
    $2953d6306df9720b$var$X1 += w * ($2953d6306df9720b$var$x0 + ($2953d6306df9720b$var$x0 = x));
    $2953d6306df9720b$var$Y1 += w * ($2953d6306df9720b$var$y0 + ($2953d6306df9720b$var$y0 = y));
    $2953d6306df9720b$var$Z1 += w * ($2953d6306df9720b$var$z0 + ($2953d6306df9720b$var$z0 = z));
    $2953d6306df9720b$var$centroidPointCartesian($2953d6306df9720b$var$x0, $2953d6306df9720b$var$y0, $2953d6306df9720b$var$z0);
}
function $2953d6306df9720b$var$centroidLineEnd() {
    $2953d6306df9720b$var$centroidStream.point = $2953d6306df9720b$var$centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function $2953d6306df9720b$var$centroidRingStart() {
    $2953d6306df9720b$var$centroidStream.point = $2953d6306df9720b$var$centroidRingPointFirst;
}
function $2953d6306df9720b$var$centroidRingEnd() {
    $2953d6306df9720b$var$centroidRingPoint($2953d6306df9720b$var$lambda00, $2953d6306df9720b$var$phi00);
    $2953d6306df9720b$var$centroidStream.point = $2953d6306df9720b$var$centroidPoint;
}
function $2953d6306df9720b$var$centroidRingPointFirst(lambda, phi) {
    $2953d6306df9720b$var$lambda00 = lambda, $2953d6306df9720b$var$phi00 = phi;
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    $2953d6306df9720b$var$centroidStream.point = $2953d6306df9720b$var$centroidRingPoint;
    var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi);
    $2953d6306df9720b$var$x0 = cosPhi * (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda);
    $2953d6306df9720b$var$y0 = cosPhi * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda);
    $2953d6306df9720b$var$z0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi);
    $2953d6306df9720b$var$centroidPointCartesian($2953d6306df9720b$var$x0, $2953d6306df9720b$var$y0, $2953d6306df9720b$var$z0);
}
function $2953d6306df9720b$var$centroidRingPoint(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi), x = cosPhi * (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda), y = cosPhi * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda), z = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), cx = $2953d6306df9720b$var$y0 * z - $2953d6306df9720b$var$z0 * y, cy = $2953d6306df9720b$var$z0 * x - $2953d6306df9720b$var$x0 * z, cz = $2953d6306df9720b$var$x0 * y - $2953d6306df9720b$var$y0 * x, m = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(cx * cx + cy * cy + cz * cz), w = (0, $70840aecc36cf34e$export$41726bdb1fc63f)(m), v = m && -w / m; // area weight multiplier
    $2953d6306df9720b$var$X2 += v * cx;
    $2953d6306df9720b$var$Y2 += v * cy;
    $2953d6306df9720b$var$Z2 += v * cz;
    $2953d6306df9720b$var$W1 += w;
    $2953d6306df9720b$var$X1 += w * ($2953d6306df9720b$var$x0 + ($2953d6306df9720b$var$x0 = x));
    $2953d6306df9720b$var$Y1 += w * ($2953d6306df9720b$var$y0 + ($2953d6306df9720b$var$y0 = y));
    $2953d6306df9720b$var$Z1 += w * ($2953d6306df9720b$var$z0 + ($2953d6306df9720b$var$z0 = z));
    $2953d6306df9720b$var$centroidPointCartesian($2953d6306df9720b$var$x0, $2953d6306df9720b$var$y0, $2953d6306df9720b$var$z0);
}
function $2953d6306df9720b$export$2e2bcd8739ae039(object) {
    $2953d6306df9720b$var$W0 = $2953d6306df9720b$var$W1 = $2953d6306df9720b$var$X0 = $2953d6306df9720b$var$Y0 = $2953d6306df9720b$var$Z0 = $2953d6306df9720b$var$X1 = $2953d6306df9720b$var$Y1 = $2953d6306df9720b$var$Z1 = $2953d6306df9720b$var$X2 = $2953d6306df9720b$var$Y2 = $2953d6306df9720b$var$Z2 = 0;
    (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, $2953d6306df9720b$var$centroidStream);
    var x = $2953d6306df9720b$var$X2, y = $2953d6306df9720b$var$Y2, z = $2953d6306df9720b$var$Z2, m = x * x + y * y + z * z;
    // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
    if (m < (0, $70840aecc36cf34e$export$92c06fba281fe81b)) {
        x = $2953d6306df9720b$var$X1, y = $2953d6306df9720b$var$Y1, z = $2953d6306df9720b$var$Z1;
        // If the feature has zero length, fall back to arithmetic mean of point vectors.
        if ($2953d6306df9720b$var$W1 < (0, $70840aecc36cf34e$export$6c421550c66a327d)) x = $2953d6306df9720b$var$X0, y = $2953d6306df9720b$var$Y0, z = $2953d6306df9720b$var$Z0;
        m = x * x + y * y + z * z;
        // If the feature still has an undefined ccentroid, then return.
        if (m < (0, $70840aecc36cf34e$export$92c06fba281fe81b)) return [
            NaN,
            NaN
        ];
    }
    return [
        (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(y, x) * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
        (0, $70840aecc36cf34e$export$41726bdb1fc63f)(z / (0, $70840aecc36cf34e$export$eba8049fb5020b81)(m)) * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
    ];
}



function $6786d98f8fc00cd2$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $46633a69482867a7$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $78f32e27e549aaef$var$rotationIdentity(lambda, phi) {
    return [
        lambda > (0, $70840aecc36cf34e$export$18c7bea995a110f) ? lambda - (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) : lambda < -(0, $70840aecc36cf34e$export$18c7bea995a110f) ? lambda + (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) : lambda,
        phi
    ];
}
$78f32e27e549aaef$var$rotationIdentity.invert = $78f32e27e549aaef$var$rotationIdentity;
function $78f32e27e549aaef$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $46633a69482867a7$export$2e2bcd8739ae039)($78f32e27e549aaef$var$rotationLambda(deltaLambda), $78f32e27e549aaef$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $78f32e27e549aaef$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $78f32e27e549aaef$var$rotationPhiGamma(deltaPhi, deltaGamma) : $78f32e27e549aaef$var$rotationIdentity;
}
function $78f32e27e549aaef$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, $70840aecc36cf34e$export$18c7bea995a110f) ? lambda - (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) : lambda < -(0, $70840aecc36cf34e$export$18c7bea995a110f) ? lambda + (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) : lambda,
            phi
        ];
    };
}
function $78f32e27e549aaef$var$rotationLambda(deltaLambda) {
    var rotation = $78f32e27e549aaef$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $78f32e27e549aaef$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $78f32e27e549aaef$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $70840aecc36cf34e$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi), x = (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $70840aecc36cf34e$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi), x = (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $70840aecc36cf34e$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $78f32e27e549aaef$export$2e2bcd8739ae039(rotate) {
    rotate = $78f32e27e549aaef$export$a2ba89726971a90f(rotate[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), rotate[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $70840aecc36cf34e$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), coordinates[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $70840aecc36cf34e$export$41fc368e1a942b97), coordinates[1] *= (0, $70840aecc36cf34e$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), coordinates[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $70840aecc36cf34e$export$41fc368e1a942b97), coordinates[1] *= (0, $70840aecc36cf34e$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $80a6d64eaafa7bc2$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $70840aecc36cf34e$export$50d414a77b60d802)(radius), sinRadius = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $80a6d64eaafa7bc2$var$circleRadius(cosRadius, t0);
        t1 = $80a6d64eaafa7bc2$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $49177a3f7b861183$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $70840aecc36cf34e$export$50d414a77b60d802)(t),
            -sinRadius * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $80a6d64eaafa7bc2$var$circleRadius(cosRadius, point) {
    point = (0, $49177a3f7b861183$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $49177a3f7b861183$export$6789498aec2cb34b)(point);
    var radius = (0, $70840aecc36cf34e$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) - (0, $70840aecc36cf34e$export$6c421550c66a327d)) % (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92);
}
function $80a6d64eaafa7bc2$export$2e2bcd8739ae039() {
    var center = (0, $6786d98f8fc00cd2$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $6786d98f8fc00cd2$export$2e2bcd8739ae039)(90), precision = (0, $6786d98f8fc00cd2$export$2e2bcd8739ae039)(6), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $70840aecc36cf34e$export$41fc368e1a942b97), x[1] *= (0, $70840aecc36cf34e$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $70840aecc36cf34e$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $70840aecc36cf34e$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $78f32e27e549aaef$export$a2ba89726971a90f)(-c[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), -c[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), 0).invert;
        $80a6d64eaafa7bc2$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $6786d98f8fc00cd2$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $6786d98f8fc00cd2$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $6786d98f8fc00cd2$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}



function $be746d937a6b2ed1$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y) {
            line.push([
                x,
                y
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}



function $e58b56fa1327dc25$export$2e2bcd8739ae039(a, b) {
    return (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $70840aecc36cf34e$export$6c421550c66a327d) && (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $70840aecc36cf34e$export$6c421550c66a327d);
}


function $3425b0251ab64a1f$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $3425b0251ab64a1f$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        // If the first and last points of a segment are coincident, then treat as a
        // closed ring. TODO if all rings are closed, then the winding order of the
        // exterior ring should be checked.
        if ((0, $e58b56fa1327dc25$export$2e2bcd8739ae039)(p0, p1)) {
            stream.lineStart();
            for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
            stream.lineEnd();
            return;
        }
        subject.push(x = new $3425b0251ab64a1f$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $3425b0251ab64a1f$var$Intersection(p0, null, x, false));
        subject.push(x = new $3425b0251ab64a1f$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $3425b0251ab64a1f$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $3425b0251ab64a1f$var$link(subject);
    $3425b0251ab64a1f$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $3425b0251ab64a1f$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}






var $feafe4a2afae0067$var$sum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)();
function $feafe4a2afae0067$export$2e2bcd8739ae039(polygon, point) {
    var lambda = point[0], phi = point[1], normal = [
        (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda),
        -(0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    $feafe4a2afae0067$var$sum.reset();
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = point0[0], phi0 = point0[1] / 2 + (0, $70840aecc36cf34e$export$c39a5cba78ea0fc2), sinPhi0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = point1[0], phi1 = point1[1] / 2 + (0, $70840aecc36cf34e$export$c39a5cba78ea0fc2), sinPhi1 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $70840aecc36cf34e$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            $feafe4a2afae0067$var$sum.add((0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(k * sign * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $70840aecc36cf34e$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $49177a3f7b861183$export$4763f5351b14293f)((0, $49177a3f7b861183$export$6e6697ef026a96)(point0), (0, $49177a3f7b861183$export$6e6697ef026a96)(point1));
                (0, $49177a3f7b861183$export$6789498aec2cb34b)(arc);
                var intersection = (0, $49177a3f7b861183$export$4763f5351b14293f)(normal, arc);
                (0, $49177a3f7b861183$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $70840aecc36cf34e$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $70840aecc36cf34e$export$6c421550c66a327d) || angle < (0, $70840aecc36cf34e$export$6c421550c66a327d) && $feafe4a2afae0067$var$sum < -(0, $70840aecc36cf34e$export$6c421550c66a327d)) ^ winding & 1;
}



function $4465b2a071da6643$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $be746d937a6b2ed1$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $809b374c1c35a6b2$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $feafe4a2afae0067$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $3425b0251ab64a1f$export$2e2bcd8739ae039)(segments, $4465b2a071da6643$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($4465b2a071da6643$var$validSegment));
        }
        return clip;
    };
}
function $4465b2a071da6643$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $4465b2a071da6643$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $70840aecc36cf34e$export$e51408a300e8929a) - (0, $70840aecc36cf34e$export$6c421550c66a327d) : (0, $70840aecc36cf34e$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $70840aecc36cf34e$export$e51408a300e8929a) - (0, $70840aecc36cf34e$export$6c421550c66a327d) : (0, $70840aecc36cf34e$export$e51408a300e8929a) - b[1]);
}



var $8c9f367c4ffdbd9b$export$2e2bcd8739ae039 = (0, $4465b2a071da6643$export$2e2bcd8739ae039)(function() {
    return true;
}, $8c9f367c4ffdbd9b$var$clipAntimeridianLine, $8c9f367c4ffdbd9b$var$clipAntimeridianInterpolate, [
    -(0, $70840aecc36cf34e$export$18c7bea995a110f),
    -(0, $70840aecc36cf34e$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $8c9f367c4ffdbd9b$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $70840aecc36cf34e$export$18c7bea995a110f) : -(0, $70840aecc36cf34e$export$18c7bea995a110f), delta = (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(delta - (0, $70840aecc36cf34e$export$18c7bea995a110f)) < (0, $70840aecc36cf34e$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $70840aecc36cf34e$export$e51408a300e8929a) : -(0, $70840aecc36cf34e$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $70840aecc36cf34e$export$18c7bea995a110f)) {
                if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $70840aecc36cf34e$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $70840aecc36cf34e$export$6c421550c66a327d); // handle degeneracies
                if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $70840aecc36cf34e$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $70840aecc36cf34e$export$6c421550c66a327d);
                phi0 = $8c9f367c4ffdbd9b$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $8c9f367c4ffdbd9b$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $70840aecc36cf34e$export$6c421550c66a327d) ? (0, $70840aecc36cf34e$export$628dc4eed22b0fbd)(((0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi1)) * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda1) - (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi0)) * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $8c9f367c4ffdbd9b$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $70840aecc36cf34e$export$e51408a300e8929a);
        stream.point(-(0, $70840aecc36cf34e$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $70840aecc36cf34e$export$18c7bea995a110f), phi);
        stream.point((0, $70840aecc36cf34e$export$18c7bea995a110f), 0);
        stream.point((0, $70840aecc36cf34e$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $70840aecc36cf34e$export$18c7bea995a110f), -phi);
        stream.point(-(0, $70840aecc36cf34e$export$18c7bea995a110f), 0);
        stream.point(-(0, $70840aecc36cf34e$export$18c7bea995a110f), phi);
    } else if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $70840aecc36cf34e$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $70840aecc36cf34e$export$18c7bea995a110f) : -(0, $70840aecc36cf34e$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}







function $70547cddeff00c3d$export$2e2bcd8739ae039(radius) {
    var cr = (0, $70840aecc36cf34e$export$50d414a77b60d802)(radius), delta = 6 * (0, $70840aecc36cf34e$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(cr) > (0, $70840aecc36cf34e$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $80a6d64eaafa7bc2$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $70840aecc36cf34e$export$50d414a77b60d802)(lambda) * (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $70840aecc36cf34e$export$18c7bea995a110f) : -(0, $70840aecc36cf34e$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                // Handle degeneracies.
                // TODO ignore if not clipping polygons.
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $e58b56fa1327dc25$export$2e2bcd8739ae039)(point0, point2) || (0, $e58b56fa1327dc25$export$2e2bcd8739ae039)(point1, point2)) {
                        point1[0] += (0, $70840aecc36cf34e$export$6c421550c66a327d);
                        point1[1] += (0, $70840aecc36cf34e$export$6c421550c66a327d);
                        v = visible(point1[0], point1[1]);
                    }
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1]);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                        }
                    }
                }
                if (v && (!point0 || !(0, $e58b56fa1327dc25$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $49177a3f7b861183$export$6e6697ef026a96)(a), pb = (0, $49177a3f7b861183$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $49177a3f7b861183$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $49177a3f7b861183$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $49177a3f7b861183$export$4763f5351b14293f)(n1, n2), A = (0, $49177a3f7b861183$export$52d0ee3fc868d452)(n1, c1), B = (0, $49177a3f7b861183$export$52d0ee3fc868d452)(n2, c2);
        (0, $49177a3f7b861183$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $49177a3f7b861183$export$2ef80f51436a9de9)(A, u), uu = (0, $49177a3f7b861183$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $49177a3f7b861183$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(t2), q = (0, $49177a3f7b861183$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $49177a3f7b861183$export$e62eba72fc898eae)(q, A);
        q = (0, $49177a3f7b861183$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(delta - (0, $70840aecc36cf34e$export$18c7bea995a110f)) < (0, $70840aecc36cf34e$export$6c421550c66a327d), meridian = polar || delta < (0, $70840aecc36cf34e$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $70840aecc36cf34e$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $70840aecc36cf34e$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $49177a3f7b861183$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $49177a3f7b861183$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $49177a3f7b861183$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $70840aecc36cf34e$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $4465b2a071da6643$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $70840aecc36cf34e$export$18c7bea995a110f),
        radius - (0, $70840aecc36cf34e$export$18c7bea995a110f)
    ]);
}




function $d4e381f4cf24b07e$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $be9ac0958bbb6aac$var$clipMax = 1e9, $be9ac0958bbb6aac$var$clipMin = -$be9ac0958bbb6aac$var$clipMax;
function $be9ac0958bbb6aac$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(p[0] - x0) < (0, $70840aecc36cf34e$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(p[0] - x1) < (0, $70840aecc36cf34e$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(p[1] - y0) < (0, $70840aecc36cf34e$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $be746d937a6b2ed1$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $809b374c1c35a6b2$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $3425b0251ab64a1f$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($be9ac0958bbb6aac$var$clipMin, Math.min($be9ac0958bbb6aac$var$clipMax, x_)),
                    y_ = Math.max($be9ac0958bbb6aac$var$clipMin, Math.min($be9ac0958bbb6aac$var$clipMax, y_))
                ], b = [
                    x = Math.max($be9ac0958bbb6aac$var$clipMin, Math.min($be9ac0958bbb6aac$var$clipMax, x)),
                    y = Math.max($be9ac0958bbb6aac$var$clipMin, Math.min($be9ac0958bbb6aac$var$clipMax, y))
                ];
                if ((0, $d4e381f4cf24b07e$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}


function $fdc85ec611b845dc$export$2e2bcd8739ae039() {
    var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
    return clip = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = (0, $be9ac0958bbb6aac$export$2e2bcd8739ae039)(x0, y0, x1, y1)(cacheStream = stream);
        },
        extent: function(_) {
            return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        }
    };
}








var $740d377ef2573903$var$lengthSum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)(), $740d377ef2573903$var$lambda0, $740d377ef2573903$var$sinPhi0, $740d377ef2573903$var$cosPhi0;
var $740d377ef2573903$var$lengthStream = {
    sphere: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    point: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineStart: $740d377ef2573903$var$lengthLineStart,
    lineEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    polygonStart: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    polygonEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039)
};
function $740d377ef2573903$var$lengthLineStart() {
    $740d377ef2573903$var$lengthStream.point = $740d377ef2573903$var$lengthPointFirst;
    $740d377ef2573903$var$lengthStream.lineEnd = $740d377ef2573903$var$lengthLineEnd;
}
function $740d377ef2573903$var$lengthLineEnd() {
    $740d377ef2573903$var$lengthStream.point = $740d377ef2573903$var$lengthStream.lineEnd = (0, $6015f26a2955b66b$export$2e2bcd8739ae039);
}
function $740d377ef2573903$var$lengthPointFirst(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    $740d377ef2573903$var$lambda0 = lambda, $740d377ef2573903$var$sinPhi0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), $740d377ef2573903$var$cosPhi0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi);
    $740d377ef2573903$var$lengthStream.point = $740d377ef2573903$var$lengthPoint;
}
function $740d377ef2573903$var$lengthPoint(lambda, phi) {
    lambda *= (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi *= (0, $70840aecc36cf34e$export$8449e153fbd325fc);
    var sinPhi = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi), cosPhi = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi), delta = (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(lambda - $740d377ef2573903$var$lambda0), cosDelta = (0, $70840aecc36cf34e$export$50d414a77b60d802)(delta), sinDelta = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(delta), x = cosPhi * sinDelta, y = $740d377ef2573903$var$cosPhi0 * sinPhi - $740d377ef2573903$var$sinPhi0 * cosPhi * cosDelta, z = $740d377ef2573903$var$sinPhi0 * sinPhi + $740d377ef2573903$var$cosPhi0 * cosPhi * cosDelta;
    $740d377ef2573903$var$lengthSum.add((0, $70840aecc36cf34e$export$b8b770ee6a0d9760)((0, $70840aecc36cf34e$export$eba8049fb5020b81)(x * x + y * y), z));
    $740d377ef2573903$var$lambda0 = lambda, $740d377ef2573903$var$sinPhi0 = sinPhi, $740d377ef2573903$var$cosPhi0 = cosPhi;
}
function $740d377ef2573903$export$2e2bcd8739ae039(object) {
    $740d377ef2573903$var$lengthSum.reset();
    (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, $740d377ef2573903$var$lengthStream);
    return +$740d377ef2573903$var$lengthSum;
}


var $4206984cfe4bfe2e$var$coordinates = [
    null,
    null
], $4206984cfe4bfe2e$var$object = {
    type: "LineString",
    coordinates: $4206984cfe4bfe2e$var$coordinates
};
function $4206984cfe4bfe2e$export$2e2bcd8739ae039(a, b) {
    $4206984cfe4bfe2e$var$coordinates[0] = a;
    $4206984cfe4bfe2e$var$coordinates[1] = b;
    return (0, $740d377ef2573903$export$2e2bcd8739ae039)($4206984cfe4bfe2e$var$object);
}



var $d6546f466656230a$var$containsObjectType = {
    Feature: function(object, point) {
        return $d6546f466656230a$var$containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if ($d6546f466656230a$var$containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var $d6546f466656230a$var$containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return $d6546f466656230a$var$containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($d6546f466656230a$var$containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return $d6546f466656230a$var$containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($d6546f466656230a$var$containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return $d6546f466656230a$var$containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if ($d6546f466656230a$var$containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if ($d6546f466656230a$var$containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function $d6546f466656230a$var$containsGeometry(geometry, point) {
    return geometry && $d6546f466656230a$var$containsGeometryType.hasOwnProperty(geometry.type) ? $d6546f466656230a$var$containsGeometryType[geometry.type](geometry, point) : false;
}
function $d6546f466656230a$var$containsPoint(coordinates, point) {
    return (0, $4206984cfe4bfe2e$export$2e2bcd8739ae039)(coordinates, point) === 0;
}
function $d6546f466656230a$var$containsLine(coordinates, point) {
    var ab = (0, $4206984cfe4bfe2e$export$2e2bcd8739ae039)(coordinates[0], coordinates[1]), ao = (0, $4206984cfe4bfe2e$export$2e2bcd8739ae039)(coordinates[0], point), ob = (0, $4206984cfe4bfe2e$export$2e2bcd8739ae039)(point, coordinates[1]);
    return ao + ob <= ab + (0, $70840aecc36cf34e$export$6c421550c66a327d);
}
function $d6546f466656230a$var$containsPolygon(coordinates, point) {
    return !!(0, $feafe4a2afae0067$export$2e2bcd8739ae039)(coordinates.map($d6546f466656230a$var$ringRadians), $d6546f466656230a$var$pointRadians(point));
}
function $d6546f466656230a$var$ringRadians(ring) {
    return ring = ring.map($d6546f466656230a$var$pointRadians), ring.pop(), ring;
}
function $d6546f466656230a$var$pointRadians(point) {
    return [
        point[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc),
        point[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc)
    ];
}
function $d6546f466656230a$export$2e2bcd8739ae039(object, point) {
    return (object && $d6546f466656230a$var$containsObjectType.hasOwnProperty(object.type) ? $d6546f466656230a$var$containsObjectType[object.type] : $d6546f466656230a$var$containsGeometry)(object, point);
}





function $35811cc82840f736$var$graticuleX(y0, y1, dy) {
    var y = (0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)(y0, y1 - (0, $70840aecc36cf34e$export$6c421550c66a327d), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function $35811cc82840f736$var$graticuleY(x0, x1, dx) {
    var x = (0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)(x0, x1 - (0, $70840aecc36cf34e$export$6c421550c66a327d), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function $35811cc82840f736$export$2e2bcd8739ae039() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)((0, $70840aecc36cf34e$export$803ce6b71a0a94b2)(X0 / DX) * DX, X1, DX).map(X).concat((0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)((0, $70840aecc36cf34e$export$803ce6b71a0a94b2)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)((0, $70840aecc36cf34e$export$803ce6b71a0a94b2)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(x % DX) > (0, $70840aecc36cf34e$export$6c421550c66a327d);
        }).map(x)).concat((0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)((0, $70840aecc36cf34e$export$803ce6b71a0a94b2)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(y % DY) > (0, $70840aecc36cf34e$export$6c421550c66a327d);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = $35811cc82840f736$var$graticuleX(y0, y1, 90);
        y = $35811cc82840f736$var$graticuleY(x0, x1, precision);
        X = $35811cc82840f736$var$graticuleX(Y0, Y1, 90);
        Y = $35811cc82840f736$var$graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, $70840aecc36cf34e$export$6c421550c66a327d)
        ],
        [
            180,
            90 - (0, $70840aecc36cf34e$export$6c421550c66a327d)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, $70840aecc36cf34e$export$6c421550c66a327d)
        ],
        [
            180,
            80 + (0, $70840aecc36cf34e$export$6c421550c66a327d)
        ]
    ]);
}
function $35811cc82840f736$export$b8db4e9403a5b6f1() {
    return $35811cc82840f736$export$2e2bcd8739ae039()();
}



function $03bad6ee5cf5da38$export$2e2bcd8739ae039(a, b) {
    var x0 = a[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), y0 = a[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), x1 = b[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), y1 = b[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), cy0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y0), sy0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y0), cy1 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y1), sy1 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y1), kx0 = cy0 * (0, $70840aecc36cf34e$export$50d414a77b60d802)(x0), ky0 = cy0 * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x0), kx1 = cy1 * (0, $70840aecc36cf34e$export$50d414a77b60d802)(x1), ky1 = cy1 * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x1), d = 2 * (0, $70840aecc36cf34e$export$41726bdb1fc63f)((0, $70840aecc36cf34e$export$eba8049fb5020b81)((0, $70840aecc36cf34e$export$e808712c2966e662)(y1 - y0) + cy0 * cy1 * (0, $70840aecc36cf34e$export$e808712c2966e662)(x1 - x0))), k = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(d);
    var interpolate = d ? function(t) {
        var B = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(t *= d) / k, A = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(y, x) * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(z, (0, $70840aecc36cf34e$export$eba8049fb5020b81)(x * x + y * y)) * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
        ];
    } : function() {
        return [
            x0 * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            y0 * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
        ];
    };
    interpolate.distance = d;
    return interpolate;
}



function $ec823651b6f73054$export$2e2bcd8739ae039(x) {
    return x;
}






var $14517ebbeffe9007$var$areaSum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)(), $14517ebbeffe9007$var$areaRingSum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)(), $14517ebbeffe9007$var$x00, $14517ebbeffe9007$var$y00, $14517ebbeffe9007$var$x0, $14517ebbeffe9007$var$y0;
var $14517ebbeffe9007$var$areaStream = {
    point: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineStart: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    polygonStart: function() {
        $14517ebbeffe9007$var$areaStream.lineStart = $14517ebbeffe9007$var$areaRingStart;
        $14517ebbeffe9007$var$areaStream.lineEnd = $14517ebbeffe9007$var$areaRingEnd;
    },
    polygonEnd: function() {
        $14517ebbeffe9007$var$areaStream.lineStart = $14517ebbeffe9007$var$areaStream.lineEnd = $14517ebbeffe9007$var$areaStream.point = (0, $6015f26a2955b66b$export$2e2bcd8739ae039);
        $14517ebbeffe9007$var$areaSum.add((0, $70840aecc36cf34e$export$2335f513bbd82c6d)($14517ebbeffe9007$var$areaRingSum));
        $14517ebbeffe9007$var$areaRingSum.reset();
    },
    result: function() {
        var area = $14517ebbeffe9007$var$areaSum / 2;
        $14517ebbeffe9007$var$areaSum.reset();
        return area;
    }
};
function $14517ebbeffe9007$var$areaRingStart() {
    $14517ebbeffe9007$var$areaStream.point = $14517ebbeffe9007$var$areaPointFirst;
}
function $14517ebbeffe9007$var$areaPointFirst(x, y) {
    $14517ebbeffe9007$var$areaStream.point = $14517ebbeffe9007$var$areaPoint;
    $14517ebbeffe9007$var$x00 = $14517ebbeffe9007$var$x0 = x, $14517ebbeffe9007$var$y00 = $14517ebbeffe9007$var$y0 = y;
}
function $14517ebbeffe9007$var$areaPoint(x, y) {
    $14517ebbeffe9007$var$areaRingSum.add($14517ebbeffe9007$var$y0 * x - $14517ebbeffe9007$var$x0 * y);
    $14517ebbeffe9007$var$x0 = x, $14517ebbeffe9007$var$y0 = y;
}
function $14517ebbeffe9007$var$areaRingEnd() {
    $14517ebbeffe9007$var$areaPoint($14517ebbeffe9007$var$x00, $14517ebbeffe9007$var$y00);
}
var $14517ebbeffe9007$export$2e2bcd8739ae039 = $14517ebbeffe9007$var$areaStream;



var $673a53bd108bc95d$var$x0 = Infinity, $673a53bd108bc95d$var$y0 = $673a53bd108bc95d$var$x0, $673a53bd108bc95d$var$x1 = -$673a53bd108bc95d$var$x0, $673a53bd108bc95d$var$y1 = $673a53bd108bc95d$var$x1;
var $673a53bd108bc95d$var$boundsStream = {
    point: $673a53bd108bc95d$var$boundsPoint,
    lineStart: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    polygonStart: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    polygonEnd: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $673a53bd108bc95d$var$x0,
                $673a53bd108bc95d$var$y0
            ],
            [
                $673a53bd108bc95d$var$x1,
                $673a53bd108bc95d$var$y1
            ]
        ];
        $673a53bd108bc95d$var$x1 = $673a53bd108bc95d$var$y1 = -($673a53bd108bc95d$var$y0 = $673a53bd108bc95d$var$x0 = Infinity);
        return bounds;
    }
};
function $673a53bd108bc95d$var$boundsPoint(x, y) {
    if (x < $673a53bd108bc95d$var$x0) $673a53bd108bc95d$var$x0 = x;
    if (x > $673a53bd108bc95d$var$x1) $673a53bd108bc95d$var$x1 = x;
    if (y < $673a53bd108bc95d$var$y0) $673a53bd108bc95d$var$y0 = y;
    if (y > $673a53bd108bc95d$var$y1) $673a53bd108bc95d$var$y1 = y;
}
var $673a53bd108bc95d$export$2e2bcd8739ae039 = $673a53bd108bc95d$var$boundsStream;



// TODO Enforce positive area for exterior, negative area for interior?
var $2d86a31e077a0a8c$var$X0 = 0, $2d86a31e077a0a8c$var$Y0 = 0, $2d86a31e077a0a8c$var$Z0 = 0, $2d86a31e077a0a8c$var$X1 = 0, $2d86a31e077a0a8c$var$Y1 = 0, $2d86a31e077a0a8c$var$Z1 = 0, $2d86a31e077a0a8c$var$X2 = 0, $2d86a31e077a0a8c$var$Y2 = 0, $2d86a31e077a0a8c$var$Z2 = 0, $2d86a31e077a0a8c$var$x00, $2d86a31e077a0a8c$var$y00, $2d86a31e077a0a8c$var$x0, $2d86a31e077a0a8c$var$y0;
var $2d86a31e077a0a8c$var$centroidStream = {
    point: $2d86a31e077a0a8c$var$centroidPoint,
    lineStart: $2d86a31e077a0a8c$var$centroidLineStart,
    lineEnd: $2d86a31e077a0a8c$var$centroidLineEnd,
    polygonStart: function() {
        $2d86a31e077a0a8c$var$centroidStream.lineStart = $2d86a31e077a0a8c$var$centroidRingStart;
        $2d86a31e077a0a8c$var$centroidStream.lineEnd = $2d86a31e077a0a8c$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $2d86a31e077a0a8c$var$centroidStream.point = $2d86a31e077a0a8c$var$centroidPoint;
        $2d86a31e077a0a8c$var$centroidStream.lineStart = $2d86a31e077a0a8c$var$centroidLineStart;
        $2d86a31e077a0a8c$var$centroidStream.lineEnd = $2d86a31e077a0a8c$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $2d86a31e077a0a8c$var$Z2 ? [
            $2d86a31e077a0a8c$var$X2 / $2d86a31e077a0a8c$var$Z2,
            $2d86a31e077a0a8c$var$Y2 / $2d86a31e077a0a8c$var$Z2
        ] : $2d86a31e077a0a8c$var$Z1 ? [
            $2d86a31e077a0a8c$var$X1 / $2d86a31e077a0a8c$var$Z1,
            $2d86a31e077a0a8c$var$Y1 / $2d86a31e077a0a8c$var$Z1
        ] : $2d86a31e077a0a8c$var$Z0 ? [
            $2d86a31e077a0a8c$var$X0 / $2d86a31e077a0a8c$var$Z0,
            $2d86a31e077a0a8c$var$Y0 / $2d86a31e077a0a8c$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $2d86a31e077a0a8c$var$X0 = $2d86a31e077a0a8c$var$Y0 = $2d86a31e077a0a8c$var$Z0 = $2d86a31e077a0a8c$var$X1 = $2d86a31e077a0a8c$var$Y1 = $2d86a31e077a0a8c$var$Z1 = $2d86a31e077a0a8c$var$X2 = $2d86a31e077a0a8c$var$Y2 = $2d86a31e077a0a8c$var$Z2 = 0;
        return centroid;
    }
};
function $2d86a31e077a0a8c$var$centroidPoint(x, y) {
    $2d86a31e077a0a8c$var$X0 += x;
    $2d86a31e077a0a8c$var$Y0 += y;
    ++$2d86a31e077a0a8c$var$Z0;
}
function $2d86a31e077a0a8c$var$centroidLineStart() {
    $2d86a31e077a0a8c$var$centroidStream.point = $2d86a31e077a0a8c$var$centroidPointFirstLine;
}
function $2d86a31e077a0a8c$var$centroidPointFirstLine(x, y) {
    $2d86a31e077a0a8c$var$centroidStream.point = $2d86a31e077a0a8c$var$centroidPointLine;
    $2d86a31e077a0a8c$var$centroidPoint($2d86a31e077a0a8c$var$x0 = x, $2d86a31e077a0a8c$var$y0 = y);
}
function $2d86a31e077a0a8c$var$centroidPointLine(x, y) {
    var dx = x - $2d86a31e077a0a8c$var$x0, dy = y - $2d86a31e077a0a8c$var$y0, z = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $2d86a31e077a0a8c$var$X1 += z * ($2d86a31e077a0a8c$var$x0 + x) / 2;
    $2d86a31e077a0a8c$var$Y1 += z * ($2d86a31e077a0a8c$var$y0 + y) / 2;
    $2d86a31e077a0a8c$var$Z1 += z;
    $2d86a31e077a0a8c$var$centroidPoint($2d86a31e077a0a8c$var$x0 = x, $2d86a31e077a0a8c$var$y0 = y);
}
function $2d86a31e077a0a8c$var$centroidLineEnd() {
    $2d86a31e077a0a8c$var$centroidStream.point = $2d86a31e077a0a8c$var$centroidPoint;
}
function $2d86a31e077a0a8c$var$centroidRingStart() {
    $2d86a31e077a0a8c$var$centroidStream.point = $2d86a31e077a0a8c$var$centroidPointFirstRing;
}
function $2d86a31e077a0a8c$var$centroidRingEnd() {
    $2d86a31e077a0a8c$var$centroidPointRing($2d86a31e077a0a8c$var$x00, $2d86a31e077a0a8c$var$y00);
}
function $2d86a31e077a0a8c$var$centroidPointFirstRing(x, y) {
    $2d86a31e077a0a8c$var$centroidStream.point = $2d86a31e077a0a8c$var$centroidPointRing;
    $2d86a31e077a0a8c$var$centroidPoint($2d86a31e077a0a8c$var$x00 = $2d86a31e077a0a8c$var$x0 = x, $2d86a31e077a0a8c$var$y00 = $2d86a31e077a0a8c$var$y0 = y);
}
function $2d86a31e077a0a8c$var$centroidPointRing(x, y) {
    var dx = x - $2d86a31e077a0a8c$var$x0, dy = y - $2d86a31e077a0a8c$var$y0, z = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $2d86a31e077a0a8c$var$X1 += z * ($2d86a31e077a0a8c$var$x0 + x) / 2;
    $2d86a31e077a0a8c$var$Y1 += z * ($2d86a31e077a0a8c$var$y0 + y) / 2;
    $2d86a31e077a0a8c$var$Z1 += z;
    z = $2d86a31e077a0a8c$var$y0 * x - $2d86a31e077a0a8c$var$x0 * y;
    $2d86a31e077a0a8c$var$X2 += z * ($2d86a31e077a0a8c$var$x0 + x);
    $2d86a31e077a0a8c$var$Y2 += z * ($2d86a31e077a0a8c$var$y0 + y);
    $2d86a31e077a0a8c$var$Z2 += z * 3;
    $2d86a31e077a0a8c$var$centroidPoint($2d86a31e077a0a8c$var$x0 = x, $2d86a31e077a0a8c$var$y0 = y);
}
var $2d86a31e077a0a8c$export$2e2bcd8739ae039 = $2d86a31e077a0a8c$var$centroidStream;




function $e92a907d27cd8bab$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$e92a907d27cd8bab$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $6015f26a2955b66b$export$2e2bcd8739ae039)
};





var $34e197eb6b39e81d$var$lengthSum = (0, $3fdaf69483da55a8$export$2e2bcd8739ae039)(), $34e197eb6b39e81d$var$lengthRing, $34e197eb6b39e81d$var$x00, $34e197eb6b39e81d$var$y00, $34e197eb6b39e81d$var$x0, $34e197eb6b39e81d$var$y0;
var $34e197eb6b39e81d$var$lengthStream = {
    point: (0, $6015f26a2955b66b$export$2e2bcd8739ae039),
    lineStart: function() {
        $34e197eb6b39e81d$var$lengthStream.point = $34e197eb6b39e81d$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($34e197eb6b39e81d$var$lengthRing) $34e197eb6b39e81d$var$lengthPoint($34e197eb6b39e81d$var$x00, $34e197eb6b39e81d$var$y00);
        $34e197eb6b39e81d$var$lengthStream.point = (0, $6015f26a2955b66b$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $34e197eb6b39e81d$var$lengthRing = true;
    },
    polygonEnd: function() {
        $34e197eb6b39e81d$var$lengthRing = null;
    },
    result: function() {
        var length = +$34e197eb6b39e81d$var$lengthSum;
        $34e197eb6b39e81d$var$lengthSum.reset();
        return length;
    }
};
function $34e197eb6b39e81d$var$lengthPointFirst(x, y) {
    $34e197eb6b39e81d$var$lengthStream.point = $34e197eb6b39e81d$var$lengthPoint;
    $34e197eb6b39e81d$var$x00 = $34e197eb6b39e81d$var$x0 = x, $34e197eb6b39e81d$var$y00 = $34e197eb6b39e81d$var$y0 = y;
}
function $34e197eb6b39e81d$var$lengthPoint(x, y) {
    $34e197eb6b39e81d$var$x0 -= x, $34e197eb6b39e81d$var$y0 -= y;
    $34e197eb6b39e81d$var$lengthSum.add((0, $70840aecc36cf34e$export$eba8049fb5020b81)($34e197eb6b39e81d$var$x0 * $34e197eb6b39e81d$var$x0 + $34e197eb6b39e81d$var$y0 * $34e197eb6b39e81d$var$y0));
    $34e197eb6b39e81d$var$x0 = x, $34e197eb6b39e81d$var$y0 = y;
}
var $34e197eb6b39e81d$export$2e2bcd8739ae039 = $34e197eb6b39e81d$var$lengthStream;


function $6e4d9f485f4fc392$export$2e2bcd8739ae039() {
    this._string = [];
}
$6e4d9f485f4fc392$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    _circle: $6e4d9f485f4fc392$var$circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = $6e4d9f485f4fc392$var$circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function $6e4d9f485f4fc392$var$circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}


function $256f850fc8469d00$export$2e2bcd8739ae039(projection, context) {
    var pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, projectionStream((0, $14517ebbeffe9007$export$2e2bcd8739ae039)));
        return (0, $14517ebbeffe9007$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, projectionStream((0, $34e197eb6b39e81d$export$2e2bcd8739ae039)));
        return (0, $34e197eb6b39e81d$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, projectionStream((0, $673a53bd108bc95d$export$2e2bcd8739ae039)));
        return (0, $673a53bd108bc95d$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, projectionStream((0, $2d86a31e077a0a8c$export$2e2bcd8739ae039)));
        return (0, $2d86a31e077a0a8c$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        return arguments.length ? (projectionStream = _ == null ? (projection = null, $ec823651b6f73054$export$2e2bcd8739ae039) : (projection = _).stream, path) : projection;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $6e4d9f485f4fc392$export$2e2bcd8739ae039)) : new (0, $e92a907d27cd8bab$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    return path.projection(projection).context(context);
}











function $2fa48444807b5e82$export$2e2bcd8739ae039(methods) {
    return {
        stream: $2fa48444807b5e82$export$6b468dcfb64c653c(methods)
    };
}
function $2fa48444807b5e82$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $2fa48444807b5e82$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $2fa48444807b5e82$var$TransformStream() {}
$2fa48444807b5e82$var$TransformStream.prototype = {
    constructor: $2fa48444807b5e82$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};




function $9fb213d4348f2f60$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $632b0d86f5bfaeaf$export$2e2bcd8739ae039)(object, projection.stream((0, $673a53bd108bc95d$export$2e2bcd8739ae039)));
    fitBounds((0, $673a53bd108bc95d$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $9fb213d4348f2f60$export$e450184041869e7f(projection, extent, object) {
    return $9fb213d4348f2f60$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $9fb213d4348f2f60$export$33a367fa1728c3ba(projection, size, object) {
    return $9fb213d4348f2f60$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $9fb213d4348f2f60$export$7d8f2192ef31c5a7(projection, width, object) {
    return $9fb213d4348f2f60$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $9fb213d4348f2f60$export$7069bab0d2ced675(projection, height, object) {
    return $9fb213d4348f2f60$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $9eeb37574a92d59f$var$maxDepth = 16, $9eeb37574a92d59f$var$cosMinDistance = (0, $70840aecc36cf34e$export$50d414a77b60d802)(30 * (0, $70840aecc36cf34e$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $9eeb37574a92d59f$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $9eeb37574a92d59f$var$resample(project, delta2) : $9eeb37574a92d59f$var$resampleNone(project);
}
function $9eeb37574a92d59f$var$resampleNone(project) {
    return (0, $2fa48444807b5e82$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $9eeb37574a92d59f$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $70840aecc36cf34e$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $70840aecc36cf34e$export$2335f513bbd82c6d)((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(c) - 1) < (0, $70840aecc36cf34e$export$6c421550c66a327d) || (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $70840aecc36cf34e$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $70840aecc36cf34e$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $9eeb37574a92d59f$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $49177a3f7b861183$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $9eeb37574a92d59f$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $9eeb37574a92d59f$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $ce76dac127892bea$var$transformRadians = (0, $2fa48444807b5e82$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $70840aecc36cf34e$export$8449e153fbd325fc), y * (0, $70840aecc36cf34e$export$8449e153fbd325fc));
    }
});
function $ce76dac127892bea$var$transformRotate(rotate) {
    return (0, $2fa48444807b5e82$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $ce76dac127892bea$export$2e2bcd8739ae039(project) {
    return $ce76dac127892bea$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $ce76dac127892bea$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, dx, dy, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, theta = null, preclip = (0, $8c9f367c4ffdbd9b$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $ec823651b6f73054$export$2e2bcd8739ae039), delta2 = 0.5, projectResample = (0, $9eeb37574a92d59f$export$2e2bcd8739ae039)(projectTransform, delta2), cache, cacheStream;
    function projection(point) {
        point = projectRotate(point[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), point[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc));
        return [
            point[0] * k + dx,
            dy - point[1] * k
        ];
    }
    function invert(point) {
        point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
        return point && [
            point[0] * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            point[1] * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
        ];
    }
    function projectTransform(x, y) {
        return x = project(x, y), [
            x[0] * k + dx,
            dy - x[1] * k
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $ce76dac127892bea$var$transformRadians($ce76dac127892bea$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $70547cddeff00c3d$export$2e2bcd8739ae039)(theta = _ * (0, $70840aecc36cf34e$export$8449e153fbd325fc)) : (theta = null, $8c9f367c4ffdbd9b$export$2e2bcd8739ae039), reset()) : theta * (0, $70840aecc36cf34e$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $ec823651b6f73054$export$2e2bcd8739ae039) : (0, $be9ac0958bbb6aac$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $70840aecc36cf34e$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            phi * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $70840aecc36cf34e$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $70840aecc36cf34e$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $70840aecc36cf34e$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            deltaPhi * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            deltaGamma * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
        ];
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $9eeb37574a92d59f$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $70840aecc36cf34e$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $9fb213d4348f2f60$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $9fb213d4348f2f60$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $9fb213d4348f2f60$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $9fb213d4348f2f60$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        projectRotate = (0, $46633a69482867a7$export$2e2bcd8739ae039)(rotate = (0, $78f32e27e549aaef$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma), project);
        var center = project(lambda, phi);
        dx = x - center[0] * k;
        dy = y + center[1] * k;
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}


function $ed04ed4b1cad6f98$export$228272587c4d24d8(projectAt) {
    var phi0 = 0, phi1 = (0, $70840aecc36cf34e$export$18c7bea995a110f) / 3, m = (0, $ce76dac127892bea$export$155d5a6fa6fddeba)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, $70840aecc36cf34e$export$8449e153fbd325fc), phi1 = _[1] * (0, $70840aecc36cf34e$export$8449e153fbd325fc)) : [
            phi0 * (0, $70840aecc36cf34e$export$41fc368e1a942b97),
            phi1 * (0, $70840aecc36cf34e$export$41fc368e1a942b97)
        ];
    };
    return p;
}



function $32d101444cd17b0b$export$ae68c6db8b65046a(phi0) {
    var cosPhi0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, $70840aecc36cf34e$export$41726bdb1fc63f)(y * cosPhi0)
        ];
    };
    return forward;
}


function $b39b51ffcc57ee96$export$75409dad1c406288(y0, y1) {
    var sy0 = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y0), n = (sy0 + (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(n) < (0, $70840aecc36cf34e$export$6c421550c66a327d)) return (0, $32d101444cd17b0b$export$ae68c6db8b65046a)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(c) / n;
    function project(x, y) {
        var r = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(c - 2 * n * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y)) / n;
        return [
            r * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x *= n),
            r0 - r * (0, $70840aecc36cf34e$export$50d414a77b60d802)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y;
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(x, (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(r0y)) / n * (0, $70840aecc36cf34e$export$c5552dfdbc7cec71)(r0y),
            (0, $70840aecc36cf34e$export$41726bdb1fc63f)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}
function $b39b51ffcc57ee96$export$2e2bcd8739ae039() {
    return (0, $ed04ed4b1cad6f98$export$228272587c4d24d8)($b39b51ffcc57ee96$export$75409dad1c406288).scale(155.424).center([
        0,
        33.6442
    ]);
}


function $6c975b29ac7d6819$export$2e2bcd8739ae039() {
    return (0, $b39b51ffcc57ee96$export$2e2bcd8739ae039)().parallels([
        29.5,
        45.5
    ]).scale(1070).translate([
        480,
        250
    ]).rotate([
        96,
        0
    ]).center([
        -0.6,
        38.7
    ]);
}






// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function $c879c11142842814$var$multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}
function $c879c11142842814$export$2e2bcd8739ae039() {
    var cache, cacheStream, lower48 = (0, $6c975b29ac7d6819$export$2e2bcd8739ae039)(), lower48Point, alaska = (0, $b39b51ffcc57ee96$export$2e2bcd8739ae039)().rotate([
        154,
        0
    ]).center([
        -2,
        58.5
    ]).parallels([
        55,
        65
    ]), alaskaPoint, hawaii = (0, $b39b51ffcc57ee96$export$2e2bcd8739ae039)().rotate([
        157,
        0
    ]).center([
        -3,
        19.9
    ]).parallels([
        8,
        18
    ]), hawaiiPoint, point, pointStream = {
        point: function(x, y) {
            point = [
                x,
                y
            ];
        }
    };
    function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
    }
    albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $c879c11142842814$var$multiplex([
            lower48.stream(cacheStream = stream),
            alaska.stream(stream),
            hawaii.stream(stream)
        ]);
    };
    albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_), alaska.precision(_), hawaii.precision(_);
        return reset();
    };
    albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([
            [
                x - 0.455 * k,
                y - 0.238 * k
            ],
            [
                x + 0.455 * k,
                y + 0.238 * k
            ]
        ]).stream(pointStream);
        alaskaPoint = alaska.translate([
            x - 0.307 * k,
            y + 0.201 * k
        ]).clipExtent([
            [
                x - 0.425 * k + (0, $70840aecc36cf34e$export$6c421550c66a327d),
                y + 0.120 * k + (0, $70840aecc36cf34e$export$6c421550c66a327d)
            ],
            [
                x - 0.214 * k - (0, $70840aecc36cf34e$export$6c421550c66a327d),
                y + 0.234 * k - (0, $70840aecc36cf34e$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        hawaiiPoint = hawaii.translate([
            x - 0.205 * k,
            y + 0.212 * k
        ]).clipExtent([
            [
                x - 0.214 * k + (0, $70840aecc36cf34e$export$6c421550c66a327d),
                y + 0.166 * k + (0, $70840aecc36cf34e$export$6c421550c66a327d)
            ],
            [
                x - 0.115 * k - (0, $70840aecc36cf34e$export$6c421550c66a327d),
                y + 0.234 * k - (0, $70840aecc36cf34e$export$6c421550c66a327d)
            ]
        ]).stream(pointStream);
        return reset();
    };
    albersUsa.fitExtent = function(extent, object) {
        return (0, $9fb213d4348f2f60$export$e450184041869e7f)(albersUsa, extent, object);
    };
    albersUsa.fitSize = function(size, object) {
        return (0, $9fb213d4348f2f60$export$33a367fa1728c3ba)(albersUsa, size, object);
    };
    albersUsa.fitWidth = function(width, object) {
        return (0, $9fb213d4348f2f60$export$7d8f2192ef31c5a7)(albersUsa, width, object);
    };
    albersUsa.fitHeight = function(height, object) {
        return (0, $9fb213d4348f2f60$export$7069bab0d2ced675)(albersUsa, height, object);
    };
    function reset() {
        cache = cacheStream = null;
        return albersUsa;
    }
    return albersUsa.scale(1070);
}




function $f54636025958480a$export$f1211ac1bdb0796(scale) {
    return function(x, y) {
        var cx = (0, $70840aecc36cf34e$export$50d414a77b60d802)(x), cy = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y), k = scale(cx * cy);
        return [
            k * cy * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x),
            k * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y)
        ];
    };
}
function $f54636025958480a$export$3cee429f13e44eac(angle) {
    return function(x, y) {
        var z = (0, $70840aecc36cf34e$export$eba8049fb5020b81)(x * x + y * y), c = angle(z), sc = (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(c), cc = (0, $70840aecc36cf34e$export$50d414a77b60d802)(c);
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(x * sc, z * cc),
            (0, $70840aecc36cf34e$export$41726bdb1fc63f)(z && y * sc / z)
        ];
    };
}



var $c87cb56158f17f07$export$5e11f94fc4a8d2c6 = (0, $f54636025958480a$export$f1211ac1bdb0796)(function(cxcy) {
    return (0, $70840aecc36cf34e$export$eba8049fb5020b81)(2 / (1 + cxcy));
});
$c87cb56158f17f07$export$5e11f94fc4a8d2c6.invert = (0, $f54636025958480a$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $70840aecc36cf34e$export$41726bdb1fc63f)(z / 2);
});
function $c87cb56158f17f07$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($c87cb56158f17f07$export$5e11f94fc4a8d2c6).scale(124.75).clipAngle(179.999);
}





var $2462b0002fe26661$export$b94a4d6aa3dd25c = (0, $f54636025958480a$export$f1211ac1bdb0796)(function(c) {
    return (c = (0, $70840aecc36cf34e$export$fd6306be3fde5b04)(c)) && c / (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(c);
});
$2462b0002fe26661$export$b94a4d6aa3dd25c.invert = (0, $f54636025958480a$export$3cee429f13e44eac)(function(z) {
    return z;
});
function $2462b0002fe26661$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($2462b0002fe26661$export$b94a4d6aa3dd25c).scale(79.4188).clipAngle(179.999);
}







function $1270d30edeb98db6$export$94ff8a57e9b91cc3(lambda, phi) {
    return [
        lambda,
        (0, $70840aecc36cf34e$export$bef1f36f5486a6a3)((0, $70840aecc36cf34e$export$fcdd3b0b3246a325)(((0, $70840aecc36cf34e$export$e51408a300e8929a) + phi) / 2))
    ];
}
$1270d30edeb98db6$export$94ff8a57e9b91cc3.invert = function(x, y) {
    return [
        x,
        2 * (0, $70840aecc36cf34e$export$628dc4eed22b0fbd)((0, $70840aecc36cf34e$export$b310ec824aaee37f)(y)) - (0, $70840aecc36cf34e$export$e51408a300e8929a)
    ];
};
function $1270d30edeb98db6$export$2e2bcd8739ae039() {
    return $1270d30edeb98db6$export$44b9b66a01f2127b($1270d30edeb98db6$export$94ff8a57e9b91cc3).scale(961 / (0, $70840aecc36cf34e$export$a4b4b4d4d776fe92));
}
function $1270d30edeb98db6$export$44b9b66a01f2127b(project) {
    var m = (0, $ce76dac127892bea$export$2e2bcd8739ae039)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, $70840aecc36cf34e$export$18c7bea995a110f) * scale(), t = m((0, $78f32e27e549aaef$export$2e2bcd8739ae039)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === $1270d30edeb98db6$export$94ff8a57e9b91cc3 ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}


function $560b29f27b5b7df9$var$tany(y) {
    return (0, $70840aecc36cf34e$export$fcdd3b0b3246a325)(((0, $70840aecc36cf34e$export$e51408a300e8929a) + y) / 2);
}
function $560b29f27b5b7df9$export$2b1bc913962ed170(y0, y1) {
    var cy0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y0) : (0, $70840aecc36cf34e$export$bef1f36f5486a6a3)(cy0 / (0, $70840aecc36cf34e$export$50d414a77b60d802)(y1)) / (0, $70840aecc36cf34e$export$bef1f36f5486a6a3)($560b29f27b5b7df9$var$tany(y1) / $560b29f27b5b7df9$var$tany(y0)), f = cy0 * (0, $70840aecc36cf34e$export$9c297f60e22e3389)($560b29f27b5b7df9$var$tany(y0), n) / n;
    if (!n) return 0, $1270d30edeb98db6$export$94ff8a57e9b91cc3;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, $70840aecc36cf34e$export$e51408a300e8929a) + (0, $70840aecc36cf34e$export$6c421550c66a327d)) y = -(0, $70840aecc36cf34e$export$e51408a300e8929a) + (0, $70840aecc36cf34e$export$6c421550c66a327d);
        } else if (y > (0, $70840aecc36cf34e$export$e51408a300e8929a) - (0, $70840aecc36cf34e$export$6c421550c66a327d)) y = (0, $70840aecc36cf34e$export$e51408a300e8929a) - (0, $70840aecc36cf34e$export$6c421550c66a327d);
        var r = f / (0, $70840aecc36cf34e$export$9c297f60e22e3389)($560b29f27b5b7df9$var$tany(y), n);
        return [
            r * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(n * x),
            f - r * (0, $70840aecc36cf34e$export$50d414a77b60d802)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, $70840aecc36cf34e$export$c5552dfdbc7cec71)(n) * (0, $70840aecc36cf34e$export$eba8049fb5020b81)(x * x + fy * fy);
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(x, (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(fy)) / n * (0, $70840aecc36cf34e$export$c5552dfdbc7cec71)(fy),
            2 * (0, $70840aecc36cf34e$export$628dc4eed22b0fbd)((0, $70840aecc36cf34e$export$9c297f60e22e3389)(f / r, 1 / n)) - (0, $70840aecc36cf34e$export$e51408a300e8929a)
        ];
    };
    return project;
}
function $560b29f27b5b7df9$export$2e2bcd8739ae039() {
    return (0, $ed04ed4b1cad6f98$export$228272587c4d24d8)($560b29f27b5b7df9$export$2b1bc913962ed170).scale(109.5).parallels([
        30,
        30
    ]);
}






function $6688296a7be1f1df$export$f5fee52180f2f058(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
$6688296a7be1f1df$export$f5fee52180f2f058.invert = $6688296a7be1f1df$export$f5fee52180f2f058;
function $6688296a7be1f1df$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($6688296a7be1f1df$export$f5fee52180f2f058).scale(152.63);
}


function $1bd35c8a5c932f4d$export$24f604fe80e5f192(y0, y1) {
    var cy0 = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y0), n = y0 === y1 ? (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y0) : (cy0 - (0, $70840aecc36cf34e$export$50d414a77b60d802)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(n) < (0, $70840aecc36cf34e$export$6c421550c66a327d)) return 0, $6688296a7be1f1df$export$f5fee52180f2f058;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(nx),
            g - gy * (0, $70840aecc36cf34e$export$50d414a77b60d802)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y;
        return [
            (0, $70840aecc36cf34e$export$b8b770ee6a0d9760)(x, (0, $70840aecc36cf34e$export$2335f513bbd82c6d)(gy)) / n * (0, $70840aecc36cf34e$export$c5552dfdbc7cec71)(gy),
            g - (0, $70840aecc36cf34e$export$c5552dfdbc7cec71)(n) * (0, $70840aecc36cf34e$export$eba8049fb5020b81)(x * x + gy * gy)
        ];
    };
    return project;
}
function $1bd35c8a5c932f4d$export$2e2bcd8739ae039() {
    return (0, $ed04ed4b1cad6f98$export$228272587c4d24d8)($1bd35c8a5c932f4d$export$24f604fe80e5f192).scale(131.154).center([
        0,
        13.9389
    ]);
}






function $bc35db74a26df323$export$dc8c6ddfc8b22c85(x, y) {
    var cy = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y), k = (0, $70840aecc36cf34e$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x) / k,
        (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y) / k
    ];
}
$bc35db74a26df323$export$dc8c6ddfc8b22c85.invert = (0, $f54636025958480a$export$3cee429f13e44eac)((0, $70840aecc36cf34e$export$628dc4eed22b0fbd));
function $bc35db74a26df323$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($bc35db74a26df323$export$dc8c6ddfc8b22c85).scale(144.049).clipAngle(60);
}






function $cca128837ce07916$var$scaleTranslate(kx, ky, tx, ty) {
    return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? (0, $ec823651b6f73054$export$2e2bcd8739ae039) : (0, $2fa48444807b5e82$export$6b468dcfb64c653c)({
        point: function(x, y) {
            this.stream.point(x * kx + tx, y * ky + ty);
        }
    });
}
function $cca128837ce07916$export$2e2bcd8739ae039() {
    var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform = (0, $ec823651b6f73054$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $ec823651b6f73054$export$2e2bcd8739ae039), cache, cacheStream, projection;
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return projection = {
        stream: function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        },
        postclip: function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        },
        clipExtent: function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $ec823651b6f73054$export$2e2bcd8739ae039) : (0, $be9ac0958bbb6aac$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        },
        scale: function(_) {
            return arguments.length ? (transform = $cca128837ce07916$var$scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
        },
        translate: function(_) {
            return arguments.length ? (transform = $cca128837ce07916$var$scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [
                tx,
                ty
            ];
        },
        reflectX: function(_) {
            return arguments.length ? (transform = $cca128837ce07916$var$scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
        },
        reflectY: function(_) {
            return arguments.length ? (transform = $cca128837ce07916$var$scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
        },
        fitExtent: function(extent, object) {
            return (0, $9fb213d4348f2f60$export$e450184041869e7f)(projection, extent, object);
        },
        fitSize: function(size, object) {
            return (0, $9fb213d4348f2f60$export$33a367fa1728c3ba)(projection, size, object);
        },
        fitWidth: function(width, object) {
            return (0, $9fb213d4348f2f60$export$7d8f2192ef31c5a7)(projection, width, object);
        },
        fitHeight: function(height, object) {
            return (0, $9fb213d4348f2f60$export$7069bab0d2ced675)(projection, height, object);
        }
    };
}






function $7a49782c6a1bb046$export$acb6def22fe878e6(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
$7a49782c6a1bb046$export$acb6def22fe878e6.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, $70840aecc36cf34e$export$2335f513bbd82c6d)(delta) > (0, $70840aecc36cf34e$export$6c421550c66a327d) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};
function $7a49782c6a1bb046$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($7a49782c6a1bb046$export$acb6def22fe878e6).scale(175.295);
}





function $cf670e832b91a189$export$1cd9c2eb846182a(x, y) {
    return [
        (0, $70840aecc36cf34e$export$50d414a77b60d802)(y) * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x),
        (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y)
    ];
}
$cf670e832b91a189$export$1cd9c2eb846182a.invert = (0, $f54636025958480a$export$3cee429f13e44eac)((0, $70840aecc36cf34e$export$41726bdb1fc63f));
function $cf670e832b91a189$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($cf670e832b91a189$export$1cd9c2eb846182a).scale(249.5).clipAngle(90 + (0, $70840aecc36cf34e$export$6c421550c66a327d));
}





function $cd34d98d9783ba00$export$f9ccbb0dcb3dcd2b(x, y) {
    var cy = (0, $70840aecc36cf34e$export$50d414a77b60d802)(y), k = 1 + (0, $70840aecc36cf34e$export$50d414a77b60d802)(x) * cy;
    return [
        cy * (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(x) / k,
        (0, $70840aecc36cf34e$export$5de3937cb4b592ed)(y) / k
    ];
}
$cd34d98d9783ba00$export$f9ccbb0dcb3dcd2b.invert = (0, $f54636025958480a$export$3cee429f13e44eac)(function(z) {
    return 2 * (0, $70840aecc36cf34e$export$628dc4eed22b0fbd)(z);
});
function $cd34d98d9783ba00$export$2e2bcd8739ae039() {
    return (0, $ce76dac127892bea$export$2e2bcd8739ae039)($cd34d98d9783ba00$export$f9ccbb0dcb3dcd2b).scale(250).clipAngle(142);
}




function $3289c09726274ecc$export$e84942adec6de533(lambda, phi) {
    return [
        (0, $70840aecc36cf34e$export$bef1f36f5486a6a3)((0, $70840aecc36cf34e$export$fcdd3b0b3246a325)(((0, $70840aecc36cf34e$export$e51408a300e8929a) + phi) / 2)),
        -lambda
    ];
}
$3289c09726274ecc$export$e84942adec6de533.invert = function(x, y) {
    return [
        -y,
        2 * (0, $70840aecc36cf34e$export$628dc4eed22b0fbd)((0, $70840aecc36cf34e$export$b310ec824aaee37f)(x)) - (0, $70840aecc36cf34e$export$e51408a300e8929a)
    ];
};
function $3289c09726274ecc$export$2e2bcd8739ae039() {
    var m = (0, $1270d30edeb98db6$export$44b9b66a01f2127b)($3289c09726274ecc$export$e84942adec6de533), center = m.center, rotate = m.rotate;
    m.center = function(_) {
        return arguments.length ? center([
            -_[1],
            _[0]
        ]) : (_ = center(), [
            _[1],
            -_[0]
        ]);
    };
    m.rotate = function(_) {
        return arguments.length ? rotate([
            _[0],
            _[1],
            _.length > 2 ? _[2] + 90 : 90
        ]) : (_ = rotate(), [
            _[0],
            _[1],
            _[2] - 90
        ]);
    };
    return rotate([
        0,
        0,
        90
    ]).scale(159.155);
}







function $50edd53146b0363f$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function $50edd53146b0363f$var$meanX(children) {
    return children.reduce($50edd53146b0363f$var$meanXReduce, 0) / children.length;
}
function $50edd53146b0363f$var$meanXReduce(x, c) {
    return x + c.x;
}
function $50edd53146b0363f$var$maxY(children) {
    return 1 + children.reduce($50edd53146b0363f$var$maxYReduce, 0);
}
function $50edd53146b0363f$var$maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function $50edd53146b0363f$var$leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function $50edd53146b0363f$var$leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}
function $50edd53146b0363f$export$2e2bcd8739ae039() {
    var separation = $50edd53146b0363f$var$defaultSeparation, dx = 1, dy = 1, nodeSize = false;
    function cluster(root) {
        var previousNode, x = 0;
        // First walk, computing the initial x & y values.
        root.eachAfter(function(node) {
            var children = node.children;
            if (children) {
                node.x = $50edd53146b0363f$var$meanX(children);
                node.y = $50edd53146b0363f$var$maxY(children);
            } else {
                node.x = previousNode ? x += separation(node, previousNode) : 0;
                node.y = 0;
                previousNode = node;
            }
        });
        var left = $50edd53146b0363f$var$leafLeft(root), right = $50edd53146b0363f$var$leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        // Second walk, normalizing x & y to the desired size.
        return root.eachAfter(nodeSize ? function(node) {
            node.x = (node.x - root.x) * dx;
            node.y = (root.y - node.y) * dy;
        } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * dx;
            node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
        });
    }
    cluster.separation = function(x) {
        return arguments.length ? (separation = x, cluster) : separation;
    };
    cluster.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    cluster.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return cluster;
}


function $61f865536001f6f4$var$count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}
function $61f865536001f6f4$export$2e2bcd8739ae039() {
    return this.eachAfter($61f865536001f6f4$var$count);
}


function $39f146c49159c358$export$2e2bcd8739ae039(callback) {
    var node = this, current, next = [
        node
    ], children, i, n;
    do {
        current = next.reverse(), next = [];
        while(node = current.pop()){
            callback(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
        }
    }while (next.length);
    return this;
}


function $e72f7e8e2692c1cc$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], children, i;
    while(node = nodes.pop()){
        callback(node), children = node.children;
        if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
    }
    return this;
}


function $3584a5a890075729$export$2e2bcd8739ae039(callback) {
    var node = this, nodes = [
        node
    ], next = [], children, i, n;
    while(node = nodes.pop()){
        next.push(node), children = node.children;
        if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
    }
    while(node = next.pop())callback(node);
    return this;
}


function $66d8935a757faaef$export$2e2bcd8739ae039(value) {
    return this.eachAfter(function(node) {
        var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
        while(--i >= 0)sum += children[i].value;
        node.value = sum;
    });
}


function $42f527a5cb47c9af$export$2e2bcd8739ae039(compare) {
    return this.eachBefore(function(node) {
        if (node.children) node.children.sort(compare);
    });
}


function $9eb73209ea3a0207$export$2e2bcd8739ae039(end) {
    var start = this, ancestor = $9eb73209ea3a0207$var$leastCommonAncestor(start, end), nodes = [
        start
    ];
    while(start !== ancestor){
        start = start.parent;
        nodes.push(start);
    }
    var k = nodes.length;
    while(end !== ancestor){
        nodes.splice(k, 0, end);
        end = end.parent;
    }
    return nodes;
}
function $9eb73209ea3a0207$var$leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}


function $bf3d03c2c13b1bfa$export$2e2bcd8739ae039() {
    var node = this, nodes = [
        node
    ];
    while(node = node.parent)nodes.push(node);
    return nodes;
}


function $9e177aadf742c07b$export$2e2bcd8739ae039() {
    var nodes = [];
    this.each(function(node) {
        nodes.push(node);
    });
    return nodes;
}


function $04ca850004a60797$export$2e2bcd8739ae039() {
    var leaves = [];
    this.eachBefore(function(node) {
        if (!node.children) leaves.push(node);
    });
    return leaves;
}


function $d9df181253a4f57a$export$2e2bcd8739ae039() {
    var root = this, links = [];
    root.each(function(node) {
        if (node !== root) links.push({
            source: node.parent,
            target: node
        });
    });
    return links;
}


function $40cd35521f83aa81$export$2e2bcd8739ae039(data, children) {
    var root = new $40cd35521f83aa81$export$85c928794f8d04d4(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = $40cd35521f83aa81$var$defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new $40cd35521f83aa81$export$85c928794f8d04d4(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore($40cd35521f83aa81$export$5af32d52ab5dfd57);
}
function $40cd35521f83aa81$var$node_copy() {
    return $40cd35521f83aa81$export$2e2bcd8739ae039(this).eachBefore($40cd35521f83aa81$var$copyData);
}
function $40cd35521f83aa81$var$defaultChildren(d) {
    return d.children;
}
function $40cd35521f83aa81$var$copyData(node) {
    node.data = node.data.data;
}
function $40cd35521f83aa81$export$5af32d52ab5dfd57(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function $40cd35521f83aa81$export$85c928794f8d04d4(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
$40cd35521f83aa81$export$85c928794f8d04d4.prototype = $40cd35521f83aa81$export$2e2bcd8739ae039.prototype = {
    constructor: $40cd35521f83aa81$export$85c928794f8d04d4,
    count: (0, $61f865536001f6f4$export$2e2bcd8739ae039),
    each: (0, $39f146c49159c358$export$2e2bcd8739ae039),
    eachAfter: (0, $3584a5a890075729$export$2e2bcd8739ae039),
    eachBefore: (0, $e72f7e8e2692c1cc$export$2e2bcd8739ae039),
    sum: (0, $66d8935a757faaef$export$2e2bcd8739ae039),
    sort: (0, $42f527a5cb47c9af$export$2e2bcd8739ae039),
    path: (0, $9eb73209ea3a0207$export$2e2bcd8739ae039),
    ancestors: (0, $bf3d03c2c13b1bfa$export$2e2bcd8739ae039),
    descendants: (0, $9e177aadf742c07b$export$2e2bcd8739ae039),
    leaves: (0, $04ca850004a60797$export$2e2bcd8739ae039),
    links: (0, $d9df181253a4f57a$export$2e2bcd8739ae039),
    copy: $40cd35521f83aa81$var$node_copy
};


var $ed85658c62501a80$export$58adb3bec8346d0f = Array.prototype.slice;
function $ed85658c62501a80$export$448332262467e042(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}


function $44add844dbeca915$export$2e2bcd8739ae039(circles) {
    var i = 0, n = (circles = (0, $ed85658c62501a80$export$448332262467e042)((0, $ed85658c62501a80$export$58adb3bec8346d0f).call(circles))).length, B = [], p, e;
    while(i < n){
        p = circles[i];
        if (e && $44add844dbeca915$var$enclosesWeak(e, p)) ++i;
        else e = $44add844dbeca915$var$encloseBasis(B = $44add844dbeca915$var$extendBasis(B, p)), i = 0;
    }
    return e;
}
function $44add844dbeca915$var$extendBasis(B, p) {
    var i, j;
    if ($44add844dbeca915$var$enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if ($44add844dbeca915$var$enclosesNot(p, B[i]) && $44add844dbeca915$var$enclosesWeakAll($44add844dbeca915$var$encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if ($44add844dbeca915$var$enclosesNot($44add844dbeca915$var$encloseBasis2(B[i], B[j]), p) && $44add844dbeca915$var$enclosesNot($44add844dbeca915$var$encloseBasis2(B[i], p), B[j]) && $44add844dbeca915$var$enclosesNot($44add844dbeca915$var$encloseBasis2(B[j], p), B[i]) && $44add844dbeca915$var$enclosesWeakAll($44add844dbeca915$var$encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function $44add844dbeca915$var$enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function $44add844dbeca915$var$enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function $44add844dbeca915$var$enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!$44add844dbeca915$var$enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function $44add844dbeca915$var$encloseBasis(B) {
    switch(B.length){
        case 1:
            return $44add844dbeca915$var$encloseBasis1(B[0]);
        case 2:
            return $44add844dbeca915$var$encloseBasis2(B[0], B[1]);
        case 3:
            return $44add844dbeca915$var$encloseBasis3(B[0], B[1], B[2]);
    }
}
function $44add844dbeca915$var$encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function $44add844dbeca915$var$encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function $44add844dbeca915$var$encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}


function $4665657c7a896eb0$var$place(a, b, c) {
    var ax = a.x, ay = a.y, da = b.r + c.r, db = a.r + c.r, dx = b.x - ax, dy = b.y - ay, dc = dx * dx + dy * dy;
    if (dc) {
        var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
        c.x = ax + x * dx + y * dy;
        c.y = ay + x * dy - y * dx;
    } else {
        c.x = ax + db;
        c.y = ay;
    }
}
function $4665657c7a896eb0$var$intersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return dr * dr - 1e-6 > dx * dx + dy * dy;
}
function $4665657c7a896eb0$var$score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function $4665657c7a896eb0$var$Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function $4665657c7a896eb0$export$b86b5dcbc4bfc7a7(circles) {
    if (!(n = circles.length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    $4665657c7a896eb0$var$place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new $4665657c7a896eb0$var$Node(a), b = new $4665657c7a896eb0$var$Node(b), c = new $4665657c7a896eb0$var$Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        $4665657c7a896eb0$var$place(a._, b._, c = circles[i]), c = new $4665657c7a896eb0$var$Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if ($4665657c7a896eb0$var$intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if ($4665657c7a896eb0$var$intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = $4665657c7a896eb0$var$score(a);
        while((c = c.next) !== b)if ((ca = $4665657c7a896eb0$var$score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, $44add844dbeca915$export$2e2bcd8739ae039)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}
function $4665657c7a896eb0$export$2e2bcd8739ae039(circles) {
    $4665657c7a896eb0$export$b86b5dcbc4bfc7a7(circles);
    return circles;
}


function $989a7042741a36d0$export$516e28dec6a4b6d4(f) {
    return f == null ? null : $989a7042741a36d0$export$a7a0278c004aac3f(f);
}
function $989a7042741a36d0$export$a7a0278c004aac3f(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}


function $678ca636718f2e03$export$99e2e371aa6a9db() {
    return 0;
}
function $678ca636718f2e03$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $b0dbca902942ffc4$var$defaultRadius(d) {
    return Math.sqrt(d.value);
}
function $b0dbca902942ffc4$export$2e2bcd8739ae039() {
    var radius = null, dx = 1, dy = 1, padding = (0, $678ca636718f2e03$export$99e2e371aa6a9db);
    function pack(root) {
        root.x = dx / 2, root.y = dy / 2;
        if (radius) root.eachBefore($b0dbca902942ffc4$var$radiusLeaf(radius)).eachAfter($b0dbca902942ffc4$var$packChildren(padding, 0.5)).eachBefore($b0dbca902942ffc4$var$translateChild(1));
        else root.eachBefore($b0dbca902942ffc4$var$radiusLeaf($b0dbca902942ffc4$var$defaultRadius)).eachAfter($b0dbca902942ffc4$var$packChildren((0, $678ca636718f2e03$export$99e2e371aa6a9db), 1)).eachAfter($b0dbca902942ffc4$var$packChildren(padding, root.r / Math.min(dx, dy))).eachBefore($b0dbca902942ffc4$var$translateChild(Math.min(dx, dy) / (2 * root.r)));
        return root;
    }
    pack.radius = function(x) {
        return arguments.length ? (radius = (0, $989a7042741a36d0$export$516e28dec6a4b6d4)(x), pack) : radius;
    };
    pack.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
            dx,
            dy
        ];
    };
    pack.padding = function(x) {
        return arguments.length ? (padding = typeof x === "function" ? x : (0, $678ca636718f2e03$export$2e2bcd8739ae039)(+x), pack) : padding;
    };
    return pack;
}
function $b0dbca902942ffc4$var$radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function $b0dbca902942ffc4$var$packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, $4665657c7a896eb0$export$b86b5dcbc4bfc7a7)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function $b0dbca902942ffc4$var$translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}




function $babaee74fbdc90bd$export$2e2bcd8739ae039(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
}


function $6ca2436bd52fcacd$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
    while(++i < n){
        node = nodes[i], node.y0 = y0, node.y1 = y1;
        node.x0 = x0, node.x1 = x0 += node.value * k;
    }
}


function $8147f187eb7b26db$export$2e2bcd8739ae039() {
    var dx = 1, dy = 1, padding = 0, round = false;
    function partition(root) {
        var n = root.height + 1;
        root.x0 = root.y0 = padding;
        root.x1 = dx;
        root.y1 = dy / n;
        root.eachBefore(positionNode(dy, n));
        if (round) root.eachBefore((0, $babaee74fbdc90bd$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(dy, n) {
        return function(node) {
            if (node.children) (0, $6ca2436bd52fcacd$export$2e2bcd8739ae039)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
            var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
        };
    }
    partition.round = function(x) {
        return arguments.length ? (round = !!x, partition) : round;
    };
    partition.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
            dx,
            dy
        ];
    };
    partition.padding = function(x) {
        return arguments.length ? (padding = +x, partition) : padding;
    };
    return partition;
}




var $32461f45d86cf9c0$var$keyPrefix = "$", $32461f45d86cf9c0$var$preroot = {
    depth: -1
}, $32461f45d86cf9c0$var$ambiguous = {};
function $32461f45d86cf9c0$var$defaultId(d) {
    return d.id;
}
function $32461f45d86cf9c0$var$defaultParentId(d) {
    return d.parentId;
}
function $32461f45d86cf9c0$export$2e2bcd8739ae039() {
    var id = $32461f45d86cf9c0$var$defaultId, parentId = $32461f45d86cf9c0$var$defaultParentId;
    function stratify(data) {
        var d, i, n = data.length, root, parent, node, nodes = new Array(n), nodeId, nodeKey, nodeByKey = {};
        for(i = 0; i < n; ++i){
            d = data[i], node = nodes[i] = new (0, $40cd35521f83aa81$export$85c928794f8d04d4)(d);
            if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                nodeKey = $32461f45d86cf9c0$var$keyPrefix + (node.id = nodeId);
                nodeByKey[nodeKey] = nodeKey in nodeByKey ? $32461f45d86cf9c0$var$ambiguous : node;
            }
        }
        for(i = 0; i < n; ++i){
            node = nodes[i], nodeId = parentId(data[i], i, data);
            if (nodeId == null || !(nodeId += "")) {
                if (root) throw new Error("multiple roots");
                root = node;
            } else {
                parent = nodeByKey[$32461f45d86cf9c0$var$keyPrefix + nodeId];
                if (!parent) throw new Error("missing: " + nodeId);
                if (parent === $32461f45d86cf9c0$var$ambiguous) throw new Error("ambiguous: " + nodeId);
                if (parent.children) parent.children.push(node);
                else parent.children = [
                    node
                ];
                node.parent = parent;
            }
        }
        if (!root) throw new Error("no root");
        root.parent = $32461f45d86cf9c0$var$preroot;
        root.eachBefore(function(node) {
            node.depth = node.parent.depth + 1;
            --n;
        }).eachBefore((0, $40cd35521f83aa81$export$5af32d52ab5dfd57));
        root.parent = null;
        if (n > 0) throw new Error("cycle");
        return root;
    }
    stratify.id = function(x) {
        return arguments.length ? (id = (0, $989a7042741a36d0$export$a7a0278c004aac3f)(x), stratify) : id;
    };
    stratify.parentId = function(x) {
        return arguments.length ? (parentId = (0, $989a7042741a36d0$export$a7a0278c004aac3f)(x), stratify) : parentId;
    };
    return stratify;
}



function $867020e2910be443$var$defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function $867020e2910be443$var$nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function $867020e2910be443$var$nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function $867020e2910be443$var$moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function $867020e2910be443$var$executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function $867020e2910be443$var$nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function $867020e2910be443$var$TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
$867020e2910be443$var$TreeNode.prototype = Object.create((0, $40cd35521f83aa81$export$85c928794f8d04d4).prototype);
function $867020e2910be443$var$treeRoot(root) {
    var tree = new $867020e2910be443$var$TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new $867020e2910be443$var$TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new $867020e2910be443$var$TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}
function $867020e2910be443$export$2e2bcd8739ae039() {
    var separation = $867020e2910be443$var$defaultSeparation, dx = 1, dy = 1, nodeSize = null;
    function tree(root) {
        var t = $867020e2910be443$var$treeRoot(root);
        // Compute the layout using Buchheim et al.’s algorithm.
        t.eachAfter(firstWalk), t.parent.m = -t.z;
        t.eachBefore(secondWalk);
        // If a fixed node size is specified, scale x and y.
        if (nodeSize) root.eachBefore(sizeNode);
        else {
            var left = root, right = root, bottom = root;
            root.eachBefore(function(node) {
                if (node.x < left.x) left = node;
                if (node.x > right.x) right = node;
                if (node.depth > bottom.depth) bottom = node;
            });
            var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
            root.eachBefore(function(node) {
                node.x = (node.x + tx) * kx;
                node.y = node.depth * ky;
            });
        }
        return root;
    }
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children) {
            $867020e2910be443$var$executeShifts(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
                v.z = w.z + separation(v._, w._);
                v.m = v.z - midpoint;
            } else v.z = midpoint;
        } else if (w) v.z = w.z + separation(v._, w._);
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
    }
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
        if (w) {
            var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
            while(vim = $867020e2910be443$var$nextRight(vim), vip = $867020e2910be443$var$nextLeft(vip), vim && vip){
                vom = $867020e2910be443$var$nextLeft(vom);
                vop = $867020e2910be443$var$nextRight(vop);
                vop.a = v;
                shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                if (shift > 0) {
                    $867020e2910be443$var$moveSubtree($867020e2910be443$var$nextAncestor(vim, v, ancestor), v, shift);
                    sip += shift;
                    sop += shift;
                }
                sim += vim.m;
                sip += vip.m;
                som += vom.m;
                sop += vop.m;
            }
            if (vim && !$867020e2910be443$var$nextRight(vop)) {
                vop.t = vim;
                vop.m += sim - sop;
            }
            if (vip && !$867020e2910be443$var$nextLeft(vom)) {
                vom.t = vip;
                vom.m += sip - som;
                ancestor = v;
            }
        }
        return ancestor;
    }
    function sizeNode(node) {
        node.x *= dx;
        node.y = node.depth * dy;
    }
    tree.separation = function(x) {
        return arguments.length ? (separation = x, tree) : separation;
    };
    tree.size = function(x) {
        return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
            dx,
            dy
        ];
    };
    tree.nodeSize = function(x) {
        return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
            dx,
            dy
        ] : null;
    };
    return tree;
}




function $2716be2e51146df2$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
    while(++i < n){
        node = nodes[i], node.x0 = x0, node.x1 = x1;
        node.y0 = y0, node.y1 = y0 += node.value * k;
    }
}


var $34b5fc8fd0cc90fb$export$324943737027944a = (1 + Math.sqrt(5)) / 2;
function $34b5fc8fd0cc90fb$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, $6ca2436bd52fcacd$export$2e2bcd8739ae039)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, $2716be2e51146df2$export$2e2bcd8739ae039)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
var $34b5fc8fd0cc90fb$export$2e2bcd8739ae039 = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        $34b5fc8fd0cc90fb$export$9ff1217655212093(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}($34b5fc8fd0cc90fb$export$324943737027944a);




function $77351d7b26ee0636$export$2e2bcd8739ae039() {
    var tile = (0, $34b5fc8fd0cc90fb$export$2e2bcd8739ae039), round = false, dx = 1, dy = 1, paddingStack = [
        0
    ], paddingInner = (0, $678ca636718f2e03$export$99e2e371aa6a9db), paddingTop = (0, $678ca636718f2e03$export$99e2e371aa6a9db), paddingRight = (0, $678ca636718f2e03$export$99e2e371aa6a9db), paddingBottom = (0, $678ca636718f2e03$export$99e2e371aa6a9db), paddingLeft = (0, $678ca636718f2e03$export$99e2e371aa6a9db);
    function treemap(root) {
        root.x0 = root.y0 = 0;
        root.x1 = dx;
        root.y1 = dy;
        root.eachBefore(positionNode);
        paddingStack = [
            0
        ];
        if (round) root.eachBefore((0, $babaee74fbdc90bd$export$2e2bcd8739ae039));
        return root;
    }
    function positionNode(node) {
        var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
        if (node.children) {
            p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
            x0 += paddingLeft(node) - p;
            y0 += paddingTop(node) - p;
            x1 -= paddingRight(node) - p;
            y1 -= paddingBottom(node) - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            tile(node, x0, y0, x1, y1);
        }
    }
    treemap.round = function(x) {
        return arguments.length ? (round = !!x, treemap) : round;
    };
    treemap.size = function(x) {
        return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
            dx,
            dy
        ];
    };
    treemap.tile = function(x) {
        return arguments.length ? (tile = (0, $989a7042741a36d0$export$a7a0278c004aac3f)(x), treemap) : tile;
    };
    treemap.padding = function(x) {
        return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
    treemap.paddingInner = function(x) {
        return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, $678ca636718f2e03$export$2e2bcd8739ae039)(+x), treemap) : paddingInner;
    };
    treemap.paddingOuter = function(x) {
        return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
    treemap.paddingTop = function(x) {
        return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, $678ca636718f2e03$export$2e2bcd8739ae039)(+x), treemap) : paddingTop;
    };
    treemap.paddingRight = function(x) {
        return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, $678ca636718f2e03$export$2e2bcd8739ae039)(+x), treemap) : paddingRight;
    };
    treemap.paddingBottom = function(x) {
        return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, $678ca636718f2e03$export$2e2bcd8739ae039)(+x), treemap) : paddingBottom;
    };
    treemap.paddingLeft = function(x) {
        return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, $678ca636718f2e03$export$2e2bcd8739ae039)(+x), treemap) : paddingLeft;
    };
    return treemap;
}


function $9e4e812645eb6cd4$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
    for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
    partition(0, n, parent.value, x0, y0, x1, y1);
    function partition(i, j, value, x0, y0, x1, y1) {
        if (i >= j - 1) {
            var node = nodes[i];
            node.x0 = x0, node.y0 = y0;
            node.x1 = x1, node.y1 = y1;
            return;
        }
        var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
        while(k < hi){
            var mid = k + hi >>> 1;
            if (sums[mid] < valueTarget) k = mid + 1;
            else hi = mid;
        }
        if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
        var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
        if (x1 - x0 > y1 - y0) {
            var xk = (x0 * valueRight + x1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, xk, y1);
            partition(k, j, valueRight, xk, y0, x1, y1);
        } else {
            var yk = (y0 * valueRight + y1 * valueLeft) / value;
            partition(i, k, valueLeft, x0, y0, x1, yk);
            partition(k, j, valueRight, x0, yk, x1, y1);
        }
    }
}






function $981d0bf3d8484fc2$export$2e2bcd8739ae039(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? (0, $2716be2e51146df2$export$2e2bcd8739ae039) : (0, $6ca2436bd52fcacd$export$2e2bcd8739ae039))(parent, x0, y0, x1, y1);
}






var $eb8a69a83ffd4d0b$export$2e2bcd8739ae039 = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, $6ca2436bd52fcacd$export$2e2bcd8739ae039)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, $2716be2e51146df2$export$2e2bcd8739ae039)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, $34b5fc8fd0cc90fb$export$9ff1217655212093)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, $34b5fc8fd0cc90fb$export$324943737027944a));





var $76qHb = parcelRequire("76qHb");

var $76qHb = parcelRequire("76qHb");
function $12e07ad9e340c862$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $12e07ad9e340c862$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $12e07ad9e340c862$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $d7cf2d1f65cb0dac$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $12e07ad9e340c862$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


function $57a84e82521bb092$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $e34d2cd23619844f$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $e34d2cd23619844f$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $e34d2cd23619844f$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $e34d2cd23619844f$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $57a84e82521bb092$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $e34d2cd23619844f$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $e34d2cd23619844f$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $e34d2cd23619844f$var$exponential(a, b, y) : (0, $57a84e82521bb092$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $e34d2cd23619844f$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $e34d2cd23619844f$var$linear(a, d) : (0, $57a84e82521bb092$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $522e7398468c88d7$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $e34d2cd23619844f$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $76qHb.rgb)(start)).r, (end = (0, $76qHb.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $522e7398468c88d7$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $76qHb.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $522e7398468c88d7$export$2c0e28f2e2852d3f = $522e7398468c88d7$var$rgbSpline((0, $12e07ad9e340c862$export$2e2bcd8739ae039));
var $522e7398468c88d7$export$53d5214f625ccd4c = $522e7398468c88d7$var$rgbSpline((0, $d7cf2d1f65cb0dac$export$2e2bcd8739ae039));



function $d208fd2d51c458ce$export$2e2bcd8739ae039(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $17e121b191159354$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $56c424352efffe33$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b -= a, function(t) {
        return d.setTime(a + b * t), d;
    };
}


function $ca506f97725a7d28$export$2e2bcd8739ae039(a, b) {
    return a = +a, b -= a, function(t) {
        return a + b * t;
    };
}



function $97caf2ec93787fbc$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $17e121b191159354$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $45aa90663e3269ce$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $45aa90663e3269ce$var$reB = new RegExp($45aa90663e3269ce$var$reA.source, "g");
function $45aa90663e3269ce$var$zero(b) {
    return function() {
        return b;
    };
}
function $45aa90663e3269ce$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $45aa90663e3269ce$export$2e2bcd8739ae039(a, b) {
    var bi = $45aa90663e3269ce$var$reA.lastIndex = $45aa90663e3269ce$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $45aa90663e3269ce$var$reA.exec(a)) && (bm = $45aa90663e3269ce$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $45aa90663e3269ce$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $45aa90663e3269ce$var$one(q[0].x) : $45aa90663e3269ce$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}



function $17e121b191159354$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $57a84e82521bb092$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $ca506f97725a7d28$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $76qHb.default)(b)) ? (b = c, $522e7398468c88d7$export$2e2bcd8739ae039) : (0, $45aa90663e3269ce$export$2e2bcd8739ae039) : b instanceof (0, $76qHb.default) ? (0, $522e7398468c88d7$export$2e2bcd8739ae039) : b instanceof Date ? (0, $56c424352efffe33$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $d208fd2d51c458ce$export$2e2bcd8739ae039) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $97caf2ec93787fbc$export$2e2bcd8739ae039) : (0, $ca506f97725a7d28$export$2e2bcd8739ae039))(a, b);
}








function $2043eebe2d48b03c$export$2e2bcd8739ae039(a, b) {
    return a = +a, b -= a, function(t) {
        return Math.round(a + b * t);
    };
}




var $86e1b0facfd46e7e$var$degrees = 180 / Math.PI;
var $86e1b0facfd46e7e$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $86e1b0facfd46e7e$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $86e1b0facfd46e7e$var$degrees,
        skewX: Math.atan(skewX) * $86e1b0facfd46e7e$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $6fb7548cba4316e5$var$cssNode, $6fb7548cba4316e5$var$cssRoot, $6fb7548cba4316e5$var$cssView, $6fb7548cba4316e5$var$svgNode;
function $6fb7548cba4316e5$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $86e1b0facfd46e7e$export$f0954fd7d5368655;
    if (!$6fb7548cba4316e5$var$cssNode) $6fb7548cba4316e5$var$cssNode = document.createElement("DIV"), $6fb7548cba4316e5$var$cssRoot = document.documentElement, $6fb7548cba4316e5$var$cssView = document.defaultView;
    $6fb7548cba4316e5$var$cssNode.style.transform = value;
    value = $6fb7548cba4316e5$var$cssView.getComputedStyle($6fb7548cba4316e5$var$cssRoot.appendChild($6fb7548cba4316e5$var$cssNode), null).getPropertyValue("transform");
    $6fb7548cba4316e5$var$cssRoot.removeChild($6fb7548cba4316e5$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $86e1b0facfd46e7e$export$2e2bcd8739ae039)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $6fb7548cba4316e5$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $86e1b0facfd46e7e$export$f0954fd7d5368655;
    if (!$6fb7548cba4316e5$var$svgNode) $6fb7548cba4316e5$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $6fb7548cba4316e5$var$svgNode.setAttribute("transform", value);
    if (!(value = $6fb7548cba4316e5$var$svgNode.transform.baseVal.consolidate())) return 0, $86e1b0facfd46e7e$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $86e1b0facfd46e7e$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $999ad6549e0af96d$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $ca506f97725a7d28$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $999ad6549e0af96d$export$56bec7123bb3589a = $999ad6549e0af96d$var$interpolateTransform((0, $6fb7548cba4316e5$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $999ad6549e0af96d$export$da8cba906d64c082 = $999ad6549e0af96d$var$interpolateTransform((0, $6fb7548cba4316e5$export$f9ef43f9a1d89a18), ", ", ")", ")");


var $b43f356c91d4108e$var$rho = Math.SQRT2, $b43f356c91d4108e$var$rho2 = 2, $b43f356c91d4108e$var$rho4 = 4, $b43f356c91d4108e$var$epsilon2 = 1e-12;
function $b43f356c91d4108e$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $b43f356c91d4108e$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $b43f356c91d4108e$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $b43f356c91d4108e$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $b43f356c91d4108e$var$epsilon2) {
        S = Math.log(w1 / w0) / $b43f356c91d4108e$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($b43f356c91d4108e$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $b43f356c91d4108e$var$rho4 * d2) / (2 * w0 * $b43f356c91d4108e$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $b43f356c91d4108e$var$rho4 * d2) / (2 * w1 * $b43f356c91d4108e$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $b43f356c91d4108e$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $b43f356c91d4108e$var$cosh(r0), u = w0 / ($b43f356c91d4108e$var$rho2 * d1) * (coshr0 * $b43f356c91d4108e$var$tanh($b43f356c91d4108e$var$rho * s + r0) - $b43f356c91d4108e$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $b43f356c91d4108e$var$cosh($b43f356c91d4108e$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}




var $76qHb = parcelRequire("76qHb");

function $41ef284fb8ab1c44$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $76qHb.hsl)(start)).h, (end = (0, $76qHb.hsl)(end)).h), s = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $41ef284fb8ab1c44$export$2e2bcd8739ae039 = $41ef284fb8ab1c44$var$hsl((0, $e34d2cd23619844f$export$97d7b0c7ddb78dcf));
var $41ef284fb8ab1c44$export$a2c535e270a59256 = $41ef284fb8ab1c44$var$hsl((0, $e34d2cd23619844f$export$2e2bcd8739ae039));



var $l64PU = parcelRequire("l64PU");

var $76qHb = parcelRequire("76qHb");
var $f092802d05d05161$export$b1b275608b2b1b8 = Math.PI / 180;
var $f092802d05d05161$export$b2ba2578f2c43d74 = 180 / Math.PI;


// https://observablehq.com/@mbostock/lab-and-rgb
var $4dde1608fe046dc6$var$K = 18, $4dde1608fe046dc6$var$Xn = 0.96422, $4dde1608fe046dc6$var$Yn = 1, $4dde1608fe046dc6$var$Zn = 0.82521, $4dde1608fe046dc6$var$t0 = 4 / 29, $4dde1608fe046dc6$var$t1 = 6 / 29, $4dde1608fe046dc6$var$t2 = 3 * $4dde1608fe046dc6$var$t1 * $4dde1608fe046dc6$var$t1, $4dde1608fe046dc6$var$t3 = $4dde1608fe046dc6$var$t1 * $4dde1608fe046dc6$var$t1 * $4dde1608fe046dc6$var$t1;
function $4dde1608fe046dc6$var$labConvert(o) {
    if (o instanceof $4dde1608fe046dc6$export$f2722c70a60257f7) return new $4dde1608fe046dc6$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $4dde1608fe046dc6$export$d9397e094a5fbb9a) return $4dde1608fe046dc6$var$hcl2lab(o);
    if (!(o instanceof (0, $76qHb.Rgb))) o = (0, $76qHb.rgbConvert)(o);
    var r = $4dde1608fe046dc6$var$rgb2lrgb(o.r), g = $4dde1608fe046dc6$var$rgb2lrgb(o.g), b = $4dde1608fe046dc6$var$rgb2lrgb(o.b), y = $4dde1608fe046dc6$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $4dde1608fe046dc6$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $4dde1608fe046dc6$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $4dde1608fe046dc6$var$Xn);
        z = $4dde1608fe046dc6$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $4dde1608fe046dc6$var$Zn);
    }
    return new $4dde1608fe046dc6$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $4dde1608fe046dc6$export$3e2c219d3ab79d01(l, opacity) {
    return new $4dde1608fe046dc6$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $4dde1608fe046dc6$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $4dde1608fe046dc6$var$labConvert(l) : new $4dde1608fe046dc6$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $4dde1608fe046dc6$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $l64PU.default)($4dde1608fe046dc6$export$f2722c70a60257f7, $4dde1608fe046dc6$export$2e2bcd8739ae039, (0, $l64PU.extend)((0, $76qHb.Color), {
    brighter: function(k) {
        return new $4dde1608fe046dc6$export$f2722c70a60257f7(this.l + $4dde1608fe046dc6$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new $4dde1608fe046dc6$export$f2722c70a60257f7(this.l - $4dde1608fe046dc6$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $4dde1608fe046dc6$var$Xn * $4dde1608fe046dc6$var$lab2xyz(x);
        y = $4dde1608fe046dc6$var$Yn * $4dde1608fe046dc6$var$lab2xyz(y);
        z = $4dde1608fe046dc6$var$Zn * $4dde1608fe046dc6$var$lab2xyz(z);
        return new (0, $76qHb.Rgb)($4dde1608fe046dc6$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $4dde1608fe046dc6$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $4dde1608fe046dc6$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $4dde1608fe046dc6$var$xyz2lab(t) {
    return t > $4dde1608fe046dc6$var$t3 ? Math.pow(t, 1 / 3) : t / $4dde1608fe046dc6$var$t2 + $4dde1608fe046dc6$var$t0;
}
function $4dde1608fe046dc6$var$lab2xyz(t) {
    return t > $4dde1608fe046dc6$var$t1 ? t * t * t : $4dde1608fe046dc6$var$t2 * (t - $4dde1608fe046dc6$var$t0);
}
function $4dde1608fe046dc6$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $4dde1608fe046dc6$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $4dde1608fe046dc6$var$hclConvert(o) {
    if (o instanceof $4dde1608fe046dc6$export$d9397e094a5fbb9a) return new $4dde1608fe046dc6$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $4dde1608fe046dc6$export$f2722c70a60257f7)) o = $4dde1608fe046dc6$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $4dde1608fe046dc6$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $f092802d05d05161$export$b2ba2578f2c43d74);
    return new $4dde1608fe046dc6$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $4dde1608fe046dc6$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $4dde1608fe046dc6$var$hclConvert(l) : new $4dde1608fe046dc6$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $4dde1608fe046dc6$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $4dde1608fe046dc6$var$hclConvert(h) : new $4dde1608fe046dc6$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $4dde1608fe046dc6$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $4dde1608fe046dc6$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $4dde1608fe046dc6$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $f092802d05d05161$export$b1b275608b2b1b8);
    return new $4dde1608fe046dc6$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $l64PU.default)($4dde1608fe046dc6$export$d9397e094a5fbb9a, $4dde1608fe046dc6$export$d0e870ba50062ff1, (0, $l64PU.extend)((0, $76qHb.Color), {
    brighter: function(k) {
        return new $4dde1608fe046dc6$export$d9397e094a5fbb9a(this.h, this.c, this.l + $4dde1608fe046dc6$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new $4dde1608fe046dc6$export$d9397e094a5fbb9a(this.h, this.c, this.l - $4dde1608fe046dc6$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return $4dde1608fe046dc6$var$hcl2lab(this).rgb();
    }
}));



function $ce3e19ca63f90584$export$2e2bcd8739ae039(start, end) {
    var l = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)((start = (0, $4dde1608fe046dc6$export$2e2bcd8739ae039)(start)).l, (end = (0, $4dde1608fe046dc6$export$2e2bcd8739ae039)(end)).l), a = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.a, end.a), b = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.b, end.b), opacity = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}




function $54628e967e2eb9ae$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $4dde1608fe046dc6$export$d0e870ba50062ff1)(start)).h, (end = (0, $4dde1608fe046dc6$export$d0e870ba50062ff1)(end)).h), c = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $54628e967e2eb9ae$export$2e2bcd8739ae039 = $54628e967e2eb9ae$var$hcl((0, $e34d2cd23619844f$export$97d7b0c7ddb78dcf));
var $54628e967e2eb9ae$export$5aaa50f7615f9b70 = $54628e967e2eb9ae$var$hcl((0, $e34d2cd23619844f$export$2e2bcd8739ae039));



var $l64PU = parcelRequire("l64PU");

var $76qHb = parcelRequire("76qHb");

var $4ae9c83a023654bf$var$A = -0.14861, $4ae9c83a023654bf$var$B = 1.78277, $4ae9c83a023654bf$var$C = -0.29227, $4ae9c83a023654bf$var$D = -0.90649, $4ae9c83a023654bf$var$E = 1.97294, $4ae9c83a023654bf$var$ED = $4ae9c83a023654bf$var$E * $4ae9c83a023654bf$var$D, $4ae9c83a023654bf$var$EB = $4ae9c83a023654bf$var$E * $4ae9c83a023654bf$var$B, $4ae9c83a023654bf$var$BC_DA = $4ae9c83a023654bf$var$B * $4ae9c83a023654bf$var$C - $4ae9c83a023654bf$var$D * $4ae9c83a023654bf$var$A;
function $4ae9c83a023654bf$var$cubehelixConvert(o) {
    if (o instanceof $4ae9c83a023654bf$export$57ed4bde61a1e2f2) return new $4ae9c83a023654bf$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $76qHb.Rgb))) o = (0, $76qHb.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($4ae9c83a023654bf$var$BC_DA * b + $4ae9c83a023654bf$var$ED * r - $4ae9c83a023654bf$var$EB * g) / ($4ae9c83a023654bf$var$BC_DA + $4ae9c83a023654bf$var$ED - $4ae9c83a023654bf$var$EB), bl = b - l, k = ($4ae9c83a023654bf$var$E * (g - l) - $4ae9c83a023654bf$var$C * bl) / $4ae9c83a023654bf$var$D, s = Math.sqrt(k * k + bl * bl) / ($4ae9c83a023654bf$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $f092802d05d05161$export$b2ba2578f2c43d74) - 120 : NaN;
    return new $4ae9c83a023654bf$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $4ae9c83a023654bf$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $4ae9c83a023654bf$var$cubehelixConvert(h) : new $4ae9c83a023654bf$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $4ae9c83a023654bf$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $l64PU.default)($4ae9c83a023654bf$export$57ed4bde61a1e2f2, $4ae9c83a023654bf$export$2e2bcd8739ae039, (0, $l64PU.extend)((0, $76qHb.Color), {
    brighter: function(k) {
        k = k == null ? (0, $76qHb.brighter) : Math.pow((0, $76qHb.brighter), k);
        return new $4ae9c83a023654bf$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $76qHb.darker) : Math.pow((0, $76qHb.darker), k);
        return new $4ae9c83a023654bf$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $f092802d05d05161$export$b1b275608b2b1b8), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $76qHb.Rgb)(255 * (l + a * ($4ae9c83a023654bf$var$A * cosh + $4ae9c83a023654bf$var$B * sinh)), 255 * (l + a * ($4ae9c83a023654bf$var$C * cosh + $4ae9c83a023654bf$var$D * sinh)), 255 * (l + a * ($4ae9c83a023654bf$var$E * cosh)), this.opacity);
    }
}));



function $525e8d2cdd473e01$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $4ae9c83a023654bf$export$2e2bcd8739ae039)(start)).h, (end = (0, $4ae9c83a023654bf$export$2e2bcd8739ae039)(end)).h), s = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $e34d2cd23619844f$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $525e8d2cdd473e01$export$2e2bcd8739ae039 = $525e8d2cdd473e01$var$cubehelix((0, $e34d2cd23619844f$export$97d7b0c7ddb78dcf));
var $525e8d2cdd473e01$export$934fa09ad474a1b4 = $525e8d2cdd473e01$var$cubehelix((0, $e34d2cd23619844f$export$2e2bcd8739ae039));


function $59137705bbed522d$export$2e2bcd8739ae039(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}




var $892f6828dee9f8dd$var$pi = Math.PI, $892f6828dee9f8dd$var$tau = 2 * $892f6828dee9f8dd$var$pi, $892f6828dee9f8dd$var$epsilon = 1e-6, $892f6828dee9f8dd$var$tauEpsilon = $892f6828dee9f8dd$var$tau - $892f6828dee9f8dd$var$epsilon;
function $892f6828dee9f8dd$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $892f6828dee9f8dd$var$path() {
    return new $892f6828dee9f8dd$var$Path;
}
$892f6828dee9f8dd$var$Path.prototype = $892f6828dee9f8dd$var$path.prototype = {
    constructor: $892f6828dee9f8dd$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $892f6828dee9f8dd$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $892f6828dee9f8dd$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($892f6828dee9f8dd$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $892f6828dee9f8dd$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $892f6828dee9f8dd$var$epsilon || Math.abs(this._y1 - y0) > $892f6828dee9f8dd$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $892f6828dee9f8dd$var$tau + $892f6828dee9f8dd$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $892f6828dee9f8dd$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $892f6828dee9f8dd$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $892f6828dee9f8dd$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $892f6828dee9f8dd$export$2e2bcd8739ae039 = $892f6828dee9f8dd$var$path;




function $546ec1b899d7d54d$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        area += a[1] * b[0] - a[0] * b[1];
    }
    return area / 2;
}


function $95bd1d66a9f56996$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
    while(++i < n){
        a = b;
        b = polygon[i];
        k += c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
    }
    return k *= 3, [
        x / k,
        y / k
    ];
}


// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
function $39a151431ecc52e5$export$2e2bcd8739ae039(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
}


function $29fd16dc90912c8c$var$lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function $29fd16dc90912c8c$var$computeUpperHullIndexes(points) {
    var n = points.length, indexes = [
        0,
        1
    ], size = 2;
    for(var i = 2; i < n; ++i){
        while(size > 1 && (0, $39a151431ecc52e5$export$2e2bcd8739ae039)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}
function $29fd16dc90912c8c$export$2e2bcd8739ae039(points) {
    if ((n = points.length) < 3) return null;
    var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
    for(i = 0; i < n; ++i)sortedPoints[i] = [
        +points[i][0],
        +points[i][1],
        i
    ];
    sortedPoints.sort($29fd16dc90912c8c$var$lexicographicOrder);
    for(i = 0; i < n; ++i)flippedPoints[i] = [
        sortedPoints[i][0],
        -sortedPoints[i][1]
    ];
    var upperIndexes = $29fd16dc90912c8c$var$computeUpperHullIndexes(sortedPoints), lowerIndexes = $29fd16dc90912c8c$var$computeUpperHullIndexes(flippedPoints);
    // Construct the hull polygon, removing possible duplicate endpoints.
    var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
    // Add upper hull in right-to-l order.
    // Then add lower hull in left-to-right order.
    for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
    for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
    return hull;
}


function $e231a8cfce499cec$export$2e2bcd8739ae039(polygon, point) {
    var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
    for(var i = 0; i < n; ++i){
        p = polygon[i], x1 = p[0], y1 = p[1];
        if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
        x0 = x1, y0 = y1;
    }
    return inside;
}


function $e228d6675e399019$export$2e2bcd8739ae039(polygon) {
    var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
    while(++i < n){
        xa = xb;
        ya = yb;
        b = polygon[i];
        xb = b[0];
        yb = b[1];
        xa -= xb;
        ya -= yb;
        perimeter += Math.sqrt(xa * xa + ya * ya);
    }
    return perimeter;
}




function $34a1040a7fbba119$export$2e2bcd8739ae039(d) {
    var x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $34a1040a7fbba119$var$add(this.cover(x, y), x, y, d);
}
function $34a1040a7fbba119$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $34a1040a7fbba119$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, inherit the existing extent.
    if (x1 < x0) x0 = this._x0, x1 = this._x1;
    if (y1 < y0) y0 = this._y0, y1 = this._y1;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$34a1040a7fbba119$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $3a4ec995c4dc6c19$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else if (x0 > x || x > x1 || y0 > y || y > y1) {
        var z = x1 - x0, node = this._root, parent, i;
        switch(i = (y < (y0 + y1) / 2) << 1 | x < (x0 + x1) / 2){
            case 0:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
                break;
            case 1:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
                break;
            case 2:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
                break;
            case 3:
                do parent = new Array(4), parent[i] = node, node = parent;
                while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
                break;
        }
        if (this._root && this._root.length) this._root = node;
    } else return this;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $37b3bb5bf363b75f$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $f80391ccac674fca$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $523f3b3c334d0b10$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $78174a52c9fb8294$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $e45e3a5e79f78848$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $e45e3a5e79f78848$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $8fed5ec9fdbd1aed$export$2e2bcd8739ae039() {
    return this._root;
}


function $38483b441f5b48d2$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $cb564e77dbb795c2$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $f538976764123e4c$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $523f3b3c334d0b10$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $da60751e8184666c$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $da60751e8184666c$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $e163eec3d1d86b57$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $e163eec3d1d86b57$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $0c6327604770b58f$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $0c6327604770b58f$var$Quadtree(x == null ? (0, $da60751e8184666c$export$e6fafc98131d2a44) : x, y == null ? (0, $e163eec3d1d86b57$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $0c6327604770b58f$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $0c6327604770b58f$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $0c6327604770b58f$var$treeProto = $0c6327604770b58f$export$2e2bcd8739ae039.prototype = $0c6327604770b58f$var$Quadtree.prototype;
$0c6327604770b58f$var$treeProto.copy = function() {
    var copy = new $0c6327604770b58f$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $0c6327604770b58f$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $0c6327604770b58f$var$leaf_copy(child);
        }
    }
    return copy;
};
$0c6327604770b58f$var$treeProto.add = (0, $34a1040a7fbba119$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.addAll = (0, $34a1040a7fbba119$export$32ed0561867ec8a1);
$0c6327604770b58f$var$treeProto.cover = (0, $3a4ec995c4dc6c19$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.data = (0, $37b3bb5bf363b75f$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.extent = (0, $f80391ccac674fca$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.find = (0, $78174a52c9fb8294$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.remove = (0, $e45e3a5e79f78848$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.removeAll = (0, $e45e3a5e79f78848$export$1cfc7aad5cb1833b);
$0c6327604770b58f$var$treeProto.root = (0, $8fed5ec9fdbd1aed$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.size = (0, $38483b441f5b48d2$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.visit = (0, $cb564e77dbb795c2$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.visitAfter = (0, $f538976764123e4c$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.x = (0, $da60751e8184666c$export$2e2bcd8739ae039);
$0c6327604770b58f$var$treeProto.y = (0, $e163eec3d1d86b57$export$2e2bcd8739ae039);




var $42901e3df65900db$export$58adb3bec8346d0f = [].slice;


var $7450bd763a7d99b1$var$noabort = {};
function $7450bd763a7d99b1$var$Queue(size) {
    this._size = size;
    this._call = this._error = null;
    this._tasks = [];
    this._data = [];
    this._waiting = this._active = this._ended = this._start = 0; // inside a synchronous task callback?
}
$7450bd763a7d99b1$var$Queue.prototype = $7450bd763a7d99b1$export$2e2bcd8739ae039.prototype = {
    constructor: $7450bd763a7d99b1$var$Queue,
    defer: function(callback) {
        if (typeof callback !== "function") throw new Error("invalid callback");
        if (this._call) throw new Error("defer after await");
        if (this._error != null) return this;
        var t = (0, $42901e3df65900db$export$58adb3bec8346d0f).call(arguments, 1);
        t.push(callback);
        ++this._waiting, this._tasks.push(t);
        $7450bd763a7d99b1$var$poke(this);
        return this;
    },
    abort: function() {
        if (this._error == null) $7450bd763a7d99b1$var$abort(this, new Error("abort"));
        return this;
    },
    await: function(callback) {
        if (typeof callback !== "function") throw new Error("invalid callback");
        if (this._call) throw new Error("multiple await");
        this._call = function(error, results) {
            callback.apply(null, [
                error
            ].concat(results));
        };
        $7450bd763a7d99b1$var$maybeNotify(this);
        return this;
    },
    awaitAll: function(callback) {
        if (typeof callback !== "function") throw new Error("invalid callback");
        if (this._call) throw new Error("multiple await");
        this._call = callback;
        $7450bd763a7d99b1$var$maybeNotify(this);
        return this;
    }
};
function $7450bd763a7d99b1$var$poke(q) {
    if (!q._start) try {
        $7450bd763a7d99b1$var$start(q);
    } catch (e) {
        if (q._tasks[q._ended + q._active - 1]) $7450bd763a7d99b1$var$abort(q, e); // task errored synchronously
        else if (!q._data) throw e; // await callback errored synchronously
    }
}
function $7450bd763a7d99b1$var$start(q) {
    while(q._start = q._waiting && q._active < q._size){
        var i = q._ended + q._active, t = q._tasks[i], j = t.length - 1, c = t[j];
        t[j] = $7450bd763a7d99b1$var$end(q, i);
        --q._waiting, ++q._active;
        t = c.apply(null, t);
        if (!q._tasks[i]) continue; // task finished synchronously
        q._tasks[i] = t || $7450bd763a7d99b1$var$noabort;
    }
}
function $7450bd763a7d99b1$var$end(q, i) {
    return function(e, r) {
        if (!q._tasks[i]) return; // ignore multiple callbacks
        --q._active, ++q._ended;
        q._tasks[i] = null;
        if (q._error != null) return; // ignore secondary errors
        if (e != null) $7450bd763a7d99b1$var$abort(q, e);
        else {
            q._data[i] = r;
            if (q._waiting) $7450bd763a7d99b1$var$poke(q);
            else $7450bd763a7d99b1$var$maybeNotify(q);
        }
    };
}
function $7450bd763a7d99b1$var$abort(q, e) {
    var i = q._tasks.length, t;
    q._error = e; // ignore active callbacks
    q._data = undefined; // allow gc
    q._waiting = NaN; // prevent starting
    while(--i >= 0)if (t = q._tasks[i]) {
        q._tasks[i] = null;
        if (t.abort) try {
            t.abort();
        } catch (e) {}
    }
    q._active = NaN; // allow notification
    $7450bd763a7d99b1$var$maybeNotify(q);
}
function $7450bd763a7d99b1$var$maybeNotify(q) {
    if (!q._active && q._call) {
        var d = q._data;
        q._data = undefined; // allow gc
        q._call(q._error, d);
    }
}
function $7450bd763a7d99b1$export$2e2bcd8739ae039(concurrency) {
    if (concurrency == null) concurrency = Infinity;
    else if (!((concurrency = +concurrency) >= 1)) throw new Error("invalid concurrency");
    return new $7450bd763a7d99b1$var$Queue(concurrency);
}




function $abe9722e15f20f09$export$2e2bcd8739ae039() {
    return Math.random();
}


var $8082f669eba67eb4$export$2e2bcd8739ae039 = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, $abe9722e15f20f09$export$2e2bcd8739ae039));



var $3ca8da5d5af5d13f$export$2e2bcd8739ae039 = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, $abe9722e15f20f09$export$2e2bcd8739ae039));




var $2f6ccbec4465de43$export$2e2bcd8739ae039 = function sourceRandomLogNormal(source) {
    function randomLogNormal() {
        var randomNormal = (0, $3ca8da5d5af5d13f$export$2e2bcd8739ae039).source(source).apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, $abe9722e15f20f09$export$2e2bcd8739ae039));




var $883762d2233ad44d$export$2e2bcd8739ae039 = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        return function() {
            for(var sum = 0, i = 0; i < n; ++i)sum += source();
            return sum;
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, $abe9722e15f20f09$export$2e2bcd8739ae039));


var $9c92aeb95875117e$export$2e2bcd8739ae039 = function sourceRandomBates(source) {
    function randomBates(n) {
        var randomIrwinHall = (0, $883762d2233ad44d$export$2e2bcd8739ae039).source(source)(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, $abe9722e15f20f09$export$2e2bcd8739ae039));




var $f601f63fa8a9e0b7$export$2e2bcd8739ae039 = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log(1 - source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, $abe9722e15f20f09$export$2e2bcd8739ae039));






function $8b3d64b95cf20bbe$export$2e2bcd8739ae039(url, callback) {
    var request, event = (0, $f1a1df54262d4945$export$2e2bcd8739ae039)("beforesend", "progress", "load", "error"), mimeType, headers = (0, $26d518efaa36ea37$export$2e2bcd8739ae039)(), xhr = new XMLHttpRequest, user = null, password = null, response, responseType, timeout = 0;
    // If IE does not support CORS, use XDomainRequest.
    if (typeof XDomainRequest !== "undefined" && !("withCredentials" in xhr) && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
    "onload" in xhr ? xhr.onload = xhr.onerror = xhr.ontimeout = respond : xhr.onreadystatechange = function(o) {
        xhr.readyState > 3 && respond(o);
    };
    function respond(o) {
        var status = xhr.status, result;
        if (!status && $8b3d64b95cf20bbe$var$hasResponse(xhr) || status >= 200 && status < 300 || status === 304) {
            if (response) try {
                result = response.call(request, xhr);
            } catch (e) {
                event.call("error", request, e);
                return;
            }
            else result = xhr;
            event.call("load", request, result);
        } else event.call("error", request, o);
    }
    xhr.onprogress = function(e) {
        event.call("progress", request, e);
    };
    request = {
        header: function(name, value) {
            name = (name + "").toLowerCase();
            if (arguments.length < 2) return headers.get(name);
            if (value == null) headers.remove(name);
            else headers.set(name, value + "");
            return request;
        },
        // If mimeType is non-null and no Accept header is set, a default is used.
        mimeType: function(value) {
            if (!arguments.length) return mimeType;
            mimeType = value == null ? null : value + "";
            return request;
        },
        // Specifies what type the response value should take;
        // for instance, arraybuffer, blob, document, or text.
        responseType: function(value) {
            if (!arguments.length) return responseType;
            responseType = value;
            return request;
        },
        timeout: function(value) {
            if (!arguments.length) return timeout;
            timeout = +value;
            return request;
        },
        user: function(value) {
            return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
        },
        password: function(value) {
            return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
        },
        // Specify how to convert the response content to a specific type;
        // changes the callback value on "load" events.
        response: function(value) {
            response = value;
            return request;
        },
        // Alias for send("GET", …).
        get: function(data, callback) {
            return request.send("GET", data, callback);
        },
        // Alias for send("POST", …).
        post: function(data, callback) {
            return request.send("POST", data, callback);
        },
        // If callback is non-null, it will be used for error and load events.
        send: function(method, data, callback) {
            xhr.open(method, url, true, user, password);
            if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
            if (xhr.setRequestHeader) headers.each(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
            if (responseType != null) xhr.responseType = responseType;
            if (timeout > 0) xhr.timeout = timeout;
            if (callback == null && typeof data === "function") callback = data, data = null;
            if (callback != null && callback.length === 1) callback = $8b3d64b95cf20bbe$var$fixCallback(callback);
            if (callback != null) request.on("error", callback).on("load", function(xhr) {
                callback(null, xhr);
            });
            event.call("beforesend", request, xhr);
            xhr.send(data == null ? null : data);
            return request;
        },
        abort: function() {
            xhr.abort();
            return request;
        },
        on: function() {
            var value = event.on.apply(event, arguments);
            return value === event ? request : value;
        }
    };
    if (callback != null) {
        if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
        return request.get(callback);
    }
    return request;
}
function $8b3d64b95cf20bbe$var$fixCallback(callback) {
    return function(error, xhr) {
        callback(error == null ? xhr : null);
    };
}
function $8b3d64b95cf20bbe$var$hasResponse(xhr) {
    var type = xhr.responseType;
    return type && type !== "text" ? xhr.response // null on error
     : xhr.responseText; // "" on error
}



function $aceed916830c2f04$export$2e2bcd8739ae039(defaultMimeType, response) {
    return function(url, callback) {
        var r = (0, $8b3d64b95cf20bbe$export$2e2bcd8739ae039)(url).mimeType(defaultMimeType).response(response);
        if (callback != null) {
            if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
            return r.get(callback);
        }
        return r;
    };
}


var $22fbcff544d74193$export$2e2bcd8739ae039 = (0, $aceed916830c2f04$export$2e2bcd8739ae039)("text/html", function(xhr) {
    return document.createRange().createContextualFragment(xhr.responseText);
});



var $efe3dd9a1fe2a300$export$2e2bcd8739ae039 = (0, $aceed916830c2f04$export$2e2bcd8739ae039)("application/json", function(xhr) {
    return JSON.parse(xhr.responseText);
});



var $3ef2a3e452e857cd$export$2e2bcd8739ae039 = (0, $aceed916830c2f04$export$2e2bcd8739ae039)("text/plain", function(xhr) {
    return xhr.responseText;
});



var $199c98abc3d67424$export$2e2bcd8739ae039 = (0, $aceed916830c2f04$export$2e2bcd8739ae039)("application/xml", function(xhr) {
    var xml = xhr.responseXML;
    if (!xml) throw new Error("parse error");
    return xml;
});


var $420512ea7358e568$var$EOL = {}, $420512ea7358e568$var$EOF = {}, $420512ea7358e568$var$QUOTE = 34, $420512ea7358e568$var$NEWLINE = 10, $420512ea7358e568$var$RETURN = 13;
function $420512ea7358e568$var$objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function $420512ea7358e568$var$customConverter(columns, f) {
    var object = $420512ea7358e568$var$objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function $420512ea7358e568$var$inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function $420512ea7358e568$var$pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function $420512ea7358e568$var$formatYear(year) {
    return year < 0 ? "-" + $420512ea7358e568$var$pad(-year, 6) : year > 9999 ? "+" + $420512ea7358e568$var$pad(year, 6) : $420512ea7358e568$var$pad(year, 4);
}
function $420512ea7358e568$var$formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : $420512ea7358e568$var$formatYear(date.getUTCFullYear(), 4) + "-" + $420512ea7358e568$var$pad(date.getUTCMonth() + 1, 2) + "-" + $420512ea7358e568$var$pad(date.getUTCDate(), 2) + (milliseconds ? "T" + $420512ea7358e568$var$pad(hours, 2) + ":" + $420512ea7358e568$var$pad(minutes, 2) + ":" + $420512ea7358e568$var$pad(seconds, 2) + "." + $420512ea7358e568$var$pad(milliseconds, 3) + "Z" : seconds ? "T" + $420512ea7358e568$var$pad(hours, 2) + ":" + $420512ea7358e568$var$pad(minutes, 2) + ":" + $420512ea7358e568$var$pad(seconds, 2) + "Z" : minutes || hours ? "T" + $420512ea7358e568$var$pad(hours, 2) + ":" + $420512ea7358e568$var$pad(minutes, 2) + "Z" : "");
}
function $420512ea7358e568$export$2e2bcd8739ae039(delimiter) {
    var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
    function parse(text, f) {
        var convert, columns, rows = parseRows(text, function(row, i) {
            if (convert) return convert(row, i - 1);
            columns = row, convert = f ? $420512ea7358e568$var$customConverter(row, f) : $420512ea7358e568$var$objectConverter(row);
        });
        rows.columns = columns || [];
        return rows;
    }
    function parseRows(text, f) {
        var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
        // Strip the trailing newline.
        if (text.charCodeAt(N - 1) === $420512ea7358e568$var$NEWLINE) --N;
        if (text.charCodeAt(N - 1) === $420512ea7358e568$var$RETURN) --N;
        function token() {
            if (eof) return $420512ea7358e568$var$EOF;
            if (eol) return eol = false, $420512ea7358e568$var$EOL;
            // Unescape quotes.
            var i, j = I, c;
            if (text.charCodeAt(j) === $420512ea7358e568$var$QUOTE) {
                while(I++ < N && text.charCodeAt(I) !== $420512ea7358e568$var$QUOTE || text.charCodeAt(++I) === $420512ea7358e568$var$QUOTE);
                if ((i = I) >= N) eof = true;
                else if ((c = text.charCodeAt(I++)) === $420512ea7358e568$var$NEWLINE) eol = true;
                else if (c === $420512ea7358e568$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $420512ea7358e568$var$NEWLINE) ++I;
                }
                return text.slice(j + 1, i - 1).replace(/""/g, "\"");
            }
            // Find next delimiter or newline.
            while(I < N){
                if ((c = text.charCodeAt(i = I++)) === $420512ea7358e568$var$NEWLINE) eol = true;
                else if (c === $420512ea7358e568$var$RETURN) {
                    eol = true;
                    if (text.charCodeAt(I) === $420512ea7358e568$var$NEWLINE) ++I;
                } else if (c !== DELIMITER) continue;
                return text.slice(j, i);
            }
            // Return last token before EOF.
            return eof = true, text.slice(j, N);
        }
        while((t = token()) !== $420512ea7358e568$var$EOF){
            var row = [];
            while(t !== $420512ea7358e568$var$EOL && t !== $420512ea7358e568$var$EOF)row.push(t), t = token();
            if (f && (row = f(row, n++)) == null) continue;
            rows.push(row);
        }
        return rows;
    }
    function preformatBody(rows, columns) {
        return rows.map(function(row) {
            return columns.map(function(column) {
                return formatValue(row[column]);
            }).join(delimiter);
        });
    }
    function format(rows, columns) {
        if (columns == null) columns = $420512ea7358e568$var$inferColumns(rows);
        return [
            columns.map(formatValue).join(delimiter)
        ].concat(preformatBody(rows, columns)).join("\n");
    }
    function formatBody(rows, columns) {
        if (columns == null) columns = $420512ea7358e568$var$inferColumns(rows);
        return preformatBody(rows, columns).join("\n");
    }
    function formatRows(rows) {
        return rows.map(formatRow).join("\n");
    }
    function formatRow(row) {
        return row.map(formatValue).join(delimiter);
    }
    function formatValue(value) {
        return value == null ? "" : value instanceof Date ? $420512ea7358e568$var$formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
    }
    return {
        parse: parse,
        parseRows: parseRows,
        format: format,
        formatBody: formatBody,
        formatRows: formatRows,
        formatRow: formatRow,
        formatValue: formatValue
    };
}


var $cca912aa8ba9a577$var$csv = (0, $420512ea7358e568$export$2e2bcd8739ae039)(",");
var $cca912aa8ba9a577$export$289d25497b0f4c16 = $cca912aa8ba9a577$var$csv.parse;
var $cca912aa8ba9a577$export$c82550ca942d869 = $cca912aa8ba9a577$var$csv.parseRows;
var $cca912aa8ba9a577$export$afe767551074aa08 = $cca912aa8ba9a577$var$csv.format;
var $cca912aa8ba9a577$export$b46fa59a5e3bc8a2 = $cca912aa8ba9a577$var$csv.formatBody;
var $cca912aa8ba9a577$export$3f42a65843fbd1d9 = $cca912aa8ba9a577$var$csv.formatRows;
var $cca912aa8ba9a577$export$c30212b87b2d080f = $cca912aa8ba9a577$var$csv.formatRow;
var $cca912aa8ba9a577$export$2771de09a60fc648 = $cca912aa8ba9a577$var$csv.formatValue;



function $d3a7a428db5721e7$export$2e2bcd8739ae039(defaultMimeType, parse) {
    return function(url, row, callback) {
        if (arguments.length < 3) callback = row, row = null;
        var r = (0, $8b3d64b95cf20bbe$export$2e2bcd8739ae039)(url).mimeType(defaultMimeType);
        r.row = function(_) {
            return arguments.length ? r.response($d3a7a428db5721e7$var$responseOf(parse, row = _)) : row;
        };
        r.row(row);
        return callback ? r.get(callback) : r;
    };
}
function $d3a7a428db5721e7$var$responseOf(parse, row) {
    return function(request) {
        return parse(request.responseText, row);
    };
}


var $2e5bdf60dbcc1334$export$2e2bcd8739ae039 = (0, $d3a7a428db5721e7$export$2e2bcd8739ae039)("text/csv", (0, $cca912aa8ba9a577$export$289d25497b0f4c16));



var $0bfb10c81ea12fb6$var$tsv = (0, $420512ea7358e568$export$2e2bcd8739ae039)("\t");
var $0bfb10c81ea12fb6$export$f913251db2f734ee = $0bfb10c81ea12fb6$var$tsv.parse;
var $0bfb10c81ea12fb6$export$8de3b5abc40a067f = $0bfb10c81ea12fb6$var$tsv.parseRows;
var $0bfb10c81ea12fb6$export$77e754c4f8504293 = $0bfb10c81ea12fb6$var$tsv.format;
var $0bfb10c81ea12fb6$export$9d44987d460c9cb3 = $0bfb10c81ea12fb6$var$tsv.formatBody;
var $0bfb10c81ea12fb6$export$ae461973f6adc981 = $0bfb10c81ea12fb6$var$tsv.formatRows;
var $0bfb10c81ea12fb6$export$5d61cf35a4a738d2 = $0bfb10c81ea12fb6$var$tsv.formatRow;
var $0bfb10c81ea12fb6$export$4280e6a416cd92a3 = $0bfb10c81ea12fb6$var$tsv.formatValue;



var $86586d42dc748b8a$export$2e2bcd8739ae039 = (0, $d3a7a428db5721e7$export$2e2bcd8739ae039)("text/tab-separated-values", (0, $0bfb10c81ea12fb6$export$f913251db2f734ee));






var $737becf007b3944b$var$array = Array.prototype;
var $737becf007b3944b$export$871de8747c9eaa88 = $737becf007b3944b$var$array.map;
var $737becf007b3944b$export$58adb3bec8346d0f = $737becf007b3944b$var$array.slice;


var $208581d375ac7212$export$e4f898ab14d9d460 = {
    name: "implicit"
};
function $208581d375ac7212$export$2e2bcd8739ae039(range) {
    var index = (0, $26d518efaa36ea37$export$2e2bcd8739ae039)(), domain = [], unknown = $208581d375ac7212$export$e4f898ab14d9d460;
    range = range == null ? [] : (0, $737becf007b3944b$export$58adb3bec8346d0f).call(range);
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== $208581d375ac7212$export$e4f898ab14d9d460) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, $26d518efaa36ea37$export$2e2bcd8739ae039)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $208581d375ac7212$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return scale;
}


function $41576b8b9d908013$export$2e2bcd8739ae039() {
    var scale = (0, $208581d375ac7212$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $6bd36ecffc9a8fb7$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $41576b8b9d908013$export$2e2bcd8739ae039().domain(domain()).range(range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return rescale();
}
function $41576b8b9d908013$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $41576b8b9d908013$var$pointish(copy());
    };
    return scale;
}
function $41576b8b9d908013$export$105684a3041cb6f3() {
    return $41576b8b9d908013$var$pointish($41576b8b9d908013$export$2e2bcd8739ae039().paddingInner(1));
}






function $63d1caeb12ec74ad$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}



function $b2c05400b60d88d5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $feb67a02949d7022$export$2e2bcd8739ae039(x) {
    return +x;
}


var $a77642f0e685e2bc$var$unit = [
    0,
    1
];
function $a77642f0e685e2bc$export$774010690f7452c2(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $b2c05400b60d88d5$export$2e2bcd8739ae039)(b);
}
function $a77642f0e685e2bc$var$deinterpolateClamp(deinterpolate) {
    return function(a, b) {
        var d = deinterpolate(a = +a, b = +b);
        return function(x) {
            return x <= a ? 0 : x >= b ? 1 : d(x);
        };
    };
}
function $a77642f0e685e2bc$var$reinterpolateClamp(reinterpolate) {
    return function(a, b) {
        var r = reinterpolate(a = +a, b = +b);
        return function(t) {
            return t <= 0 ? a : t >= 1 ? b : r(t);
        };
    };
}
function $a77642f0e685e2bc$var$bimap(domain, range, deinterpolate, reinterpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $a77642f0e685e2bc$var$polymap(domain, range, deinterpolate, reinterpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = deinterpolate(domain[i], domain[i + 1]);
        r[i] = reinterpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $ebc8358e83b40f6b$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $a77642f0e685e2bc$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp());
}
function $a77642f0e685e2bc$export$2e2bcd8739ae039(deinterpolate, reinterpolate) {
    var domain = $a77642f0e685e2bc$var$unit, range = $a77642f0e685e2bc$var$unit, interpolate = (0, $c1f23c99e29b9b5a$export$2e2bcd8739ae039), clamp = false, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? $a77642f0e685e2bc$var$polymap : $a77642f0e685e2bc$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return (output || (output = piecewise(domain, range, clamp ? $a77642f0e685e2bc$var$deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
    }
    scale.invert = function(y) {
        return (input || (input = piecewise(range, domain, $a77642f0e685e2bc$export$774010690f7452c2, clamp ? $a77642f0e685e2bc$var$reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $737becf007b3944b$export$871de8747c9eaa88).call(_, (0, $feb67a02949d7022$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_), interpolate = (0, $63d1caeb12ec74ad$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, rescale()) : clamp;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    return rescale();
}



function $feba4c621b60de93$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $feba4c621b60de93$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $63992eba8ad3b353$export$2e2bcd8739ae039(x) {
    return x = (0, $feba4c621b60de93$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $69edd7201e43ba3f$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $ed9ef6fc5d1e6f67$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $30bc82d58263c55d$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $30bc82d58263c55d$export$2e2bcd8739ae039(specifier) {
    if (!(match = $30bc82d58263c55d$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $30bc82d58263c55d$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$30bc82d58263c55d$export$2e2bcd8739ae039.prototype = $30bc82d58263c55d$export$963aac351db36ed4.prototype; // instanceof
function $30bc82d58263c55d$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$30bc82d58263c55d$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $43bf5202d5d620cf$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $a30ae61a2d3c53e1$export$6863724d9a42263;
function $a30ae61a2d3c53e1$export$2e2bcd8739ae039(x, p) {
    var d = (0, $feba4c621b60de93$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($a30ae61a2d3c53e1$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $feba4c621b60de93$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $d84aa05f1b666354$export$2e2bcd8739ae039(x, p) {
    var d = (0, $feba4c621b60de93$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $6d6dd160c4e4c635$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $feba4c621b60de93$export$2e2bcd8739ae039),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $d84aa05f1b666354$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $d84aa05f1b666354$export$2e2bcd8739ae039),
    "s": (0, $a30ae61a2d3c53e1$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};



function $ebacd39947b2313b$export$2e2bcd8739ae039(x) {
    return x;
}


var $e435256cb60e0daa$var$map = Array.prototype.map, $e435256cb60e0daa$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e435256cb60e0daa$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $ebacd39947b2313b$export$2e2bcd8739ae039) : (0, $69edd7201e43ba3f$export$2e2bcd8739ae039)($e435256cb60e0daa$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $ebacd39947b2313b$export$2e2bcd8739ae039) : (0, $ed9ef6fc5d1e6f67$export$2e2bcd8739ae039)($e435256cb60e0daa$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $30bc82d58263c55d$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $6d6dd160c4e4c635$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $6d6dd160c4e4c635$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $43bf5202d5d620cf$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e435256cb60e0daa$var$prefixes[8 + (0, $a30ae61a2d3c53e1$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $30bc82d58263c55d$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $63992eba8ad3b353$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e435256cb60e0daa$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $31b654d063ca2fad$var$locale;
var $31b654d063ca2fad$export$d9468344d3651243;
var $31b654d063ca2fad$export$8d85692a469dde6f;
$31b654d063ca2fad$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $31b654d063ca2fad$export$2e2bcd8739ae039(definition) {
    $31b654d063ca2fad$var$locale = (0, $e435256cb60e0daa$export$2e2bcd8739ae039)(definition);
    $31b654d063ca2fad$export$d9468344d3651243 = $31b654d063ca2fad$var$locale.format;
    $31b654d063ca2fad$export$8d85692a469dde6f = $31b654d063ca2fad$var$locale.formatPrefix;
    return $31b654d063ca2fad$var$locale;
}


function $5786578c33cfbcb2$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $63992eba8ad3b353$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $0df3b34cc2a654c6$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $63992eba8ad3b353$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $63992eba8ad3b353$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $0454c527e92f68df$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $63992eba8ad3b353$export$2e2bcd8739ae039)(max) - (0, $63992eba8ad3b353$export$2e2bcd8739ae039)(step)) + 1;
}


function $41cc0d2b3859f2fa$export$2e2bcd8739ae039(domain, count, specifier) {
    var start = domain[0], stop = domain[domain.length - 1], step = (0, $fd752f66568b8bf9$export$81087d9b915d4ede)(start, stop, count == null ? 10 : count), precision;
    specifier = (0, $30bc82d58263c55d$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $0df3b34cc2a654c6$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $31b654d063ca2fad$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $0454c527e92f68df$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $5786578c33cfbcb2$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $31b654d063ca2fad$export$d9468344d3651243)(specifier);
}


function $a0b9e5e3cd5bd1c9$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $fd752f66568b8bf9$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        return (0, $41cc0d2b3859f2fa$export$2e2bcd8739ae039)(domain(), count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, $fd752f66568b8bf9$export$bc64d00cc98e7e95)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, $fd752f66568b8bf9$export$bc64d00cc98e7e95)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, $fd752f66568b8bf9$export$bc64d00cc98e7e95)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function $a0b9e5e3cd5bd1c9$export$2e2bcd8739ae039() {
    var scale = (0, $a77642f0e685e2bc$export$2e2bcd8739ae039)((0, $a77642f0e685e2bc$export$774010690f7452c2), (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039));
    scale.copy = function() {
        return (0, $a77642f0e685e2bc$export$784d13d8ee351f07)(scale, $a0b9e5e3cd5bd1c9$export$2e2bcd8739ae039());
    };
    return $a0b9e5e3cd5bd1c9$export$16a5d4b4a61a274d(scale);
}



function $3af5424acf27e038$export$2e2bcd8739ae039() {
    var domain = [
        0,
        1
    ];
    function scale(x) {
        return +x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, $737becf007b3944b$export$871de8747c9eaa88).call(_, (0, $feb67a02949d7022$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.copy = function() {
        return $3af5424acf27e038$export$2e2bcd8739ae039().domain(domain);
    };
    return (0, $a0b9e5e3cd5bd1c9$export$16a5d4b4a61a274d)(scale);
}






function $2a424c37c03e960c$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}



function $bf409c1a7e5c0851$var$deinterpolate(a, b) {
    return (b = Math.log(b / a)) ? function(x) {
        return Math.log(x / a) / b;
    } : (0, $b2c05400b60d88d5$export$2e2bcd8739ae039)(b);
}
function $bf409c1a7e5c0851$var$reinterpolate(a, b) {
    return a < 0 ? function(t) {
        return -Math.pow(-b, t) * Math.pow(-a, 1 - t);
    } : function(t) {
        return Math.pow(b, t) * Math.pow(a, 1 - t);
    };
}
function $bf409c1a7e5c0851$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $bf409c1a7e5c0851$var$powp(base) {
    return base === 10 ? $bf409c1a7e5c0851$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $bf409c1a7e5c0851$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $bf409c1a7e5c0851$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $bf409c1a7e5c0851$export$2e2bcd8739ae039() {
    var scale = (0, $a77642f0e685e2bc$export$2e2bcd8739ae039)($bf409c1a7e5c0851$var$deinterpolate, $bf409c1a7e5c0851$var$reinterpolate).domain([
        1,
        10
    ]), domain = scale.domain, base = 10, logs = $bf409c1a7e5c0851$var$logp(10), pows = $bf409c1a7e5c0851$var$powp(10);
    function rescale() {
        logs = $bf409c1a7e5c0851$var$logp(base), pows = $bf409c1a7e5c0851$var$powp(base);
        if (domain()[0] < 0) logs = $bf409c1a7e5c0851$var$reflect(logs), pows = $bf409c1a7e5c0851$var$reflect(pows);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, $fd752f66568b8bf9$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $31b654d063ca2fad$export$d9468344d3651243)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $2a424c37c03e960c$export$2e2bcd8739ae039)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    scale.copy = function() {
        return (0, $a77642f0e685e2bc$export$784d13d8ee351f07)(scale, $bf409c1a7e5c0851$export$2e2bcd8739ae039().base(base));
    };
    return scale;
}






function $c93072fed626869c$var$raise(x, exponent) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}
function $c93072fed626869c$export$2e2bcd8739ae039() {
    var exponent = 1, scale = (0, $a77642f0e685e2bc$export$2e2bcd8739ae039)(deinterpolate, reinterpolate), domain = scale.domain;
    function deinterpolate(a, b) {
        return (b = $c93072fed626869c$var$raise(b, exponent) - (a = $c93072fed626869c$var$raise(a, exponent))) ? function(x) {
            return ($c93072fed626869c$var$raise(x, exponent) - a) / b;
        } : (0, $b2c05400b60d88d5$export$2e2bcd8739ae039)(b);
    }
    function reinterpolate(a, b) {
        b = $c93072fed626869c$var$raise(b, exponent) - (a = $c93072fed626869c$var$raise(a, exponent));
        return function(t) {
            return $c93072fed626869c$var$raise(a + b * t, 1 / exponent);
        };
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, domain(domain())) : exponent;
    };
    scale.copy = function() {
        return (0, $a77642f0e685e2bc$export$784d13d8ee351f07)(scale, $c93072fed626869c$export$2e2bcd8739ae039().exponent(exponent));
    };
    return (0, $a0b9e5e3cd5bd1c9$export$16a5d4b4a61a274d)(scale);
}
function $c93072fed626869c$export$eba8049fb5020b81() {
    return $c93072fed626869c$export$2e2bcd8739ae039().exponent(0.5);
}




function $ca48b186ee33abf7$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [];
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $f418b2432d94f799$export$2e2bcd8739ae039)(domain, i / n);
        return scale;
    }
    function scale(x) {
        if (!isNaN(x = +x)) return range[(0, $ebc8358e83b40f6b$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $ac07eaf4741610f5$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_), rescale()) : range.slice();
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $ca48b186ee33abf7$export$2e2bcd8739ae039().domain(domain).range(range);
    };
    return scale;
}





function $e7d15f9bc7deb6bd$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ];
    function scale(x) {
        if (x <= x) return range[(0, $ebc8358e83b40f6b$export$2e2bcd8739ae039)(domain, x, 0, n)];
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return $e7d15f9bc7deb6bd$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range);
    };
    return (0, $a0b9e5e3cd5bd1c9$export$16a5d4b4a61a274d)(scale);
}




function $1c9c95db11d2ff8f$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], n = 1;
    function scale(x) {
        if (x <= x) return range[(0, $ebc8358e83b40f6b$export$2e2bcd8739ae039)(domain, x, 0, n)];
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, $737becf007b3944b$export$58adb3bec8346d0f).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.copy = function() {
        return $1c9c95db11d2ff8f$export$2e2bcd8739ae039().domain(domain).range(range);
    };
    return scale;
}




var $7d3cdef2d64f9d24$var$t0 = new Date, $7d3cdef2d64f9d24$var$t1 = new Date;
function $7d3cdef2d64f9d24$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $7d3cdef2d64f9d24$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $7d3cdef2d64f9d24$var$t0.setTime(+start), $7d3cdef2d64f9d24$var$t1.setTime(+end);
            floori($7d3cdef2d64f9d24$var$t0), floori($7d3cdef2d64f9d24$var$t1);
            return Math.floor(count($7d3cdef2d64f9d24$var$t0, $7d3cdef2d64f9d24$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


var $1ac2b7c223d9f119$export$79ef0e34099623dc = 1e3;
var $1ac2b7c223d9f119$export$683905d551c33fa9 = 6e4;
var $1ac2b7c223d9f119$export$4157bf0c8e241659 = 36e5;
var $1ac2b7c223d9f119$export$353686095f4fbf45 = 864e5;
var $1ac2b7c223d9f119$export$c241eb88520d5016 = 6048e5;


var $602aff1c99220c6b$var$day = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $1ac2b7c223d9f119$export$683905d551c33fa9)) / (0, $1ac2b7c223d9f119$export$353686095f4fbf45);
}, function(date) {
    return date.getDate() - 1;
});
var $602aff1c99220c6b$export$2e2bcd8739ae039 = $602aff1c99220c6b$var$day;
var $602aff1c99220c6b$export$3cf5dda4201cc0f2 = $602aff1c99220c6b$var$day.range;



var $fb9a8315f21b976d$var$hour = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $1ac2b7c223d9f119$export$79ef0e34099623dc) - date.getMinutes() * (0, $1ac2b7c223d9f119$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $1ac2b7c223d9f119$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $1ac2b7c223d9f119$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $fb9a8315f21b976d$export$2e2bcd8739ae039 = $fb9a8315f21b976d$var$hour;
var $fb9a8315f21b976d$export$8d468796d69cdad1 = $fb9a8315f21b976d$var$hour.range;


var $ee2eb9ba018c49e9$var$millisecond = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$ee2eb9ba018c49e9$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $ee2eb9ba018c49e9$var$millisecond;
    return (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $ee2eb9ba018c49e9$export$2e2bcd8739ae039 = $ee2eb9ba018c49e9$var$millisecond;
var $ee2eb9ba018c49e9$export$9a27fac83d67afd3 = $ee2eb9ba018c49e9$var$millisecond.range;



var $109f46f27355bc65$var$minute = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $1ac2b7c223d9f119$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $1ac2b7c223d9f119$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $1ac2b7c223d9f119$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $109f46f27355bc65$export$2e2bcd8739ae039 = $109f46f27355bc65$var$minute;
var $109f46f27355bc65$export$666252b437cce0c7 = $109f46f27355bc65$var$minute.range;


var $4f9a001daae5050d$var$month = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $4f9a001daae5050d$export$2e2bcd8739ae039 = $4f9a001daae5050d$var$month;
var $4f9a001daae5050d$export$16352d1b10c5eb38 = $4f9a001daae5050d$var$month.range;



var $487ed9b7591747b7$var$second = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $1ac2b7c223d9f119$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $1ac2b7c223d9f119$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $487ed9b7591747b7$export$2e2bcd8739ae039 = $487ed9b7591747b7$var$second;
var $487ed9b7591747b7$export$4792e48abc550fa1 = $487ed9b7591747b7$var$second.range;



function $fe13d34793e7e3a0$var$weekday(i) {
    return (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $1ac2b7c223d9f119$export$683905d551c33fa9)) / (0, $1ac2b7c223d9f119$export$c241eb88520d5016);
    });
}
var $fe13d34793e7e3a0$export$fb3ee18ed410cc21 = $fe13d34793e7e3a0$var$weekday(0);
var $fe13d34793e7e3a0$export$6416afaab03bc9b8 = $fe13d34793e7e3a0$var$weekday(1);
var $fe13d34793e7e3a0$export$cb8f040f5d17ac7b = $fe13d34793e7e3a0$var$weekday(2);
var $fe13d34793e7e3a0$export$347581849975dfc8 = $fe13d34793e7e3a0$var$weekday(3);
var $fe13d34793e7e3a0$export$2f2b56683a3e5629 = $fe13d34793e7e3a0$var$weekday(4);
var $fe13d34793e7e3a0$export$59b8c2ccd931d806 = $fe13d34793e7e3a0$var$weekday(5);
var $fe13d34793e7e3a0$export$478ceadebff4d377 = $fe13d34793e7e3a0$var$weekday(6);
var $fe13d34793e7e3a0$export$e8daabaa40641211 = $fe13d34793e7e3a0$export$fb3ee18ed410cc21.range;
var $fe13d34793e7e3a0$export$74e5b559c235c00e = $fe13d34793e7e3a0$export$6416afaab03bc9b8.range;
var $fe13d34793e7e3a0$export$e7d6aa4fb107bc56 = $fe13d34793e7e3a0$export$cb8f040f5d17ac7b.range;
var $fe13d34793e7e3a0$export$fcd5880b20bb06a8 = $fe13d34793e7e3a0$export$347581849975dfc8.range;
var $fe13d34793e7e3a0$export$682716b7bbe33641 = $fe13d34793e7e3a0$export$2f2b56683a3e5629.range;
var $fe13d34793e7e3a0$export$482924968ca86084 = $fe13d34793e7e3a0$export$59b8c2ccd931d806.range;
var $fe13d34793e7e3a0$export$7d755172c9cda9d2 = $fe13d34793e7e3a0$export$478ceadebff4d377.range;


var $1680cba015ceb6d5$var$year = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$1680cba015ceb6d5$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $1680cba015ceb6d5$export$2e2bcd8739ae039 = $1680cba015ceb6d5$var$year;
var $1680cba015ceb6d5$export$6fda41c7fb23acf9 = $1680cba015ceb6d5$var$year.range;




var $c8ae11bf9d321b24$var$utcDay = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $1ac2b7c223d9f119$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $c8ae11bf9d321b24$export$2e2bcd8739ae039 = $c8ae11bf9d321b24$var$utcDay;
var $c8ae11bf9d321b24$export$d277e198508549a1 = $c8ae11bf9d321b24$var$utcDay.range;



function $b78e53b93ee93fd9$var$utcWeekday(i) {
    return (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $1ac2b7c223d9f119$export$c241eb88520d5016);
    });
}
var $b78e53b93ee93fd9$export$4898b06303a92011 = $b78e53b93ee93fd9$var$utcWeekday(0);
var $b78e53b93ee93fd9$export$9cfc53b9cfafd080 = $b78e53b93ee93fd9$var$utcWeekday(1);
var $b78e53b93ee93fd9$export$2a6d545f77eceb15 = $b78e53b93ee93fd9$var$utcWeekday(2);
var $b78e53b93ee93fd9$export$a5c25d8ed64433c4 = $b78e53b93ee93fd9$var$utcWeekday(3);
var $b78e53b93ee93fd9$export$1db08111baec2f53 = $b78e53b93ee93fd9$var$utcWeekday(4);
var $b78e53b93ee93fd9$export$29265e34dd5921f7 = $b78e53b93ee93fd9$var$utcWeekday(5);
var $b78e53b93ee93fd9$export$85b74dad05049604 = $b78e53b93ee93fd9$var$utcWeekday(6);
var $b78e53b93ee93fd9$export$6f3e1c2b0f7d7880 = $b78e53b93ee93fd9$export$4898b06303a92011.range;
var $b78e53b93ee93fd9$export$1d2d8b858bb366f9 = $b78e53b93ee93fd9$export$9cfc53b9cfafd080.range;
var $b78e53b93ee93fd9$export$1d5f6785fc7f30f8 = $b78e53b93ee93fd9$export$2a6d545f77eceb15.range;
var $b78e53b93ee93fd9$export$7a75faf0e37ef4af = $b78e53b93ee93fd9$export$a5c25d8ed64433c4.range;
var $b78e53b93ee93fd9$export$417eb959611b2f2f = $b78e53b93ee93fd9$export$1db08111baec2f53.range;
var $b78e53b93ee93fd9$export$59d308db7af08c64 = $b78e53b93ee93fd9$export$29265e34dd5921f7.range;
var $b78e53b93ee93fd9$export$a124108a0a7f34c8 = $b78e53b93ee93fd9$export$85b74dad05049604.range;


var $91196dc42dd1ff6a$var$utcYear = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$91196dc42dd1ff6a$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $91196dc42dd1ff6a$export$2e2bcd8739ae039 = $91196dc42dd1ff6a$var$utcYear;
var $91196dc42dd1ff6a$export$3e24d311e17f5802 = $91196dc42dd1ff6a$var$utcYear.range;


function $2b77072f60d19f26$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $2b77072f60d19f26$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $2b77072f60d19f26$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $2b77072f60d19f26$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $2b77072f60d19f26$var$formatRe(locale_periods), periodLookup = $2b77072f60d19f26$var$formatLookup(locale_periods), weekdayRe = $2b77072f60d19f26$var$formatRe(locale_weekdays), weekdayLookup = $2b77072f60d19f26$var$formatLookup(locale_weekdays), shortWeekdayRe = $2b77072f60d19f26$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $2b77072f60d19f26$var$formatLookup(locale_shortWeekdays), monthRe = $2b77072f60d19f26$var$formatRe(locale_months), monthLookup = $2b77072f60d19f26$var$formatLookup(locale_months), shortMonthRe = $2b77072f60d19f26$var$formatRe(locale_shortMonths), shortMonthLookup = $2b77072f60d19f26$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $2b77072f60d19f26$var$formatDayOfMonth,
        "e": $2b77072f60d19f26$var$formatDayOfMonth,
        "f": $2b77072f60d19f26$var$formatMicroseconds,
        "g": $2b77072f60d19f26$var$formatYearISO,
        "G": $2b77072f60d19f26$var$formatFullYearISO,
        "H": $2b77072f60d19f26$var$formatHour24,
        "I": $2b77072f60d19f26$var$formatHour12,
        "j": $2b77072f60d19f26$var$formatDayOfYear,
        "L": $2b77072f60d19f26$var$formatMilliseconds,
        "m": $2b77072f60d19f26$var$formatMonthNumber,
        "M": $2b77072f60d19f26$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $2b77072f60d19f26$var$formatUnixTimestamp,
        "s": $2b77072f60d19f26$var$formatUnixTimestampSeconds,
        "S": $2b77072f60d19f26$var$formatSeconds,
        "u": $2b77072f60d19f26$var$formatWeekdayNumberMonday,
        "U": $2b77072f60d19f26$var$formatWeekNumberSunday,
        "V": $2b77072f60d19f26$var$formatWeekNumberISO,
        "w": $2b77072f60d19f26$var$formatWeekdayNumberSunday,
        "W": $2b77072f60d19f26$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $2b77072f60d19f26$var$formatYear,
        "Y": $2b77072f60d19f26$var$formatFullYear,
        "Z": $2b77072f60d19f26$var$formatZone,
        "%": $2b77072f60d19f26$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $2b77072f60d19f26$var$formatUTCDayOfMonth,
        "e": $2b77072f60d19f26$var$formatUTCDayOfMonth,
        "f": $2b77072f60d19f26$var$formatUTCMicroseconds,
        "g": $2b77072f60d19f26$var$formatUTCYearISO,
        "G": $2b77072f60d19f26$var$formatUTCFullYearISO,
        "H": $2b77072f60d19f26$var$formatUTCHour24,
        "I": $2b77072f60d19f26$var$formatUTCHour12,
        "j": $2b77072f60d19f26$var$formatUTCDayOfYear,
        "L": $2b77072f60d19f26$var$formatUTCMilliseconds,
        "m": $2b77072f60d19f26$var$formatUTCMonthNumber,
        "M": $2b77072f60d19f26$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $2b77072f60d19f26$var$formatUnixTimestamp,
        "s": $2b77072f60d19f26$var$formatUnixTimestampSeconds,
        "S": $2b77072f60d19f26$var$formatUTCSeconds,
        "u": $2b77072f60d19f26$var$formatUTCWeekdayNumberMonday,
        "U": $2b77072f60d19f26$var$formatUTCWeekNumberSunday,
        "V": $2b77072f60d19f26$var$formatUTCWeekNumberISO,
        "w": $2b77072f60d19f26$var$formatUTCWeekdayNumberSunday,
        "W": $2b77072f60d19f26$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $2b77072f60d19f26$var$formatUTCYear,
        "Y": $2b77072f60d19f26$var$formatUTCFullYear,
        "Z": $2b77072f60d19f26$var$formatUTCZone,
        "%": $2b77072f60d19f26$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $2b77072f60d19f26$var$parseDayOfMonth,
        "e": $2b77072f60d19f26$var$parseDayOfMonth,
        "f": $2b77072f60d19f26$var$parseMicroseconds,
        "g": $2b77072f60d19f26$var$parseYear,
        "G": $2b77072f60d19f26$var$parseFullYear,
        "H": $2b77072f60d19f26$var$parseHour24,
        "I": $2b77072f60d19f26$var$parseHour24,
        "j": $2b77072f60d19f26$var$parseDayOfYear,
        "L": $2b77072f60d19f26$var$parseMilliseconds,
        "m": $2b77072f60d19f26$var$parseMonthNumber,
        "M": $2b77072f60d19f26$var$parseMinutes,
        "p": parsePeriod,
        "q": $2b77072f60d19f26$var$parseQuarter,
        "Q": $2b77072f60d19f26$var$parseUnixTimestamp,
        "s": $2b77072f60d19f26$var$parseUnixTimestampSeconds,
        "S": $2b77072f60d19f26$var$parseSeconds,
        "u": $2b77072f60d19f26$var$parseWeekdayNumberMonday,
        "U": $2b77072f60d19f26$var$parseWeekNumberSunday,
        "V": $2b77072f60d19f26$var$parseWeekNumberISO,
        "w": $2b77072f60d19f26$var$parseWeekdayNumberSunday,
        "W": $2b77072f60d19f26$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $2b77072f60d19f26$var$parseYear,
        "Y": $2b77072f60d19f26$var$parseFullYear,
        "Z": $2b77072f60d19f26$var$parseZone,
        "%": $2b77072f60d19f26$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $2b77072f60d19f26$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $2b77072f60d19f26$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $2b77072f60d19f26$var$utcDate($2b77072f60d19f26$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $b78e53b93ee93fd9$export$9cfc53b9cfafd080).ceil(week) : (0, $b78e53b93ee93fd9$export$9cfc53b9cfafd080)(week);
                    week = (0, $c8ae11bf9d321b24$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $2b77072f60d19f26$var$localDate($2b77072f60d19f26$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $fe13d34793e7e3a0$export$6416afaab03bc9b8).ceil(week) : (0, $fe13d34793e7e3a0$export$6416afaab03bc9b8)(week);
                    week = (0, $602aff1c99220c6b$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $2b77072f60d19f26$var$utcDate($2b77072f60d19f26$var$newDate(d.y, 0, 1)).getUTCDay() : $2b77072f60d19f26$var$localDate($2b77072f60d19f26$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $2b77072f60d19f26$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $2b77072f60d19f26$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $2b77072f60d19f26$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $2b77072f60d19f26$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $2b77072f60d19f26$var$numberRe = /^\s*\d+/, $2b77072f60d19f26$var$percentRe = /^%/, $2b77072f60d19f26$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $2b77072f60d19f26$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $2b77072f60d19f26$var$requote(s) {
    return s.replace($2b77072f60d19f26$var$requoteRe, "\\$&");
}
function $2b77072f60d19f26$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($2b77072f60d19f26$var$requote).join("|") + ")", "i");
}
function $2b77072f60d19f26$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $2b77072f60d19f26$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseWeekNumberSunday(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseWeekNumberISO(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseWeekNumberMonday(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseFullYear(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseYear(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseQuarter(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseMonthNumber(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseDayOfMonth(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseDayOfYear(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseHour24(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseMinutes(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseSeconds(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseMilliseconds(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseMicroseconds(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseLiteralPercent(d, string, i) {
    var n = $2b77072f60d19f26$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $2b77072f60d19f26$var$parseUnixTimestamp(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $2b77072f60d19f26$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $2b77072f60d19f26$var$formatDayOfMonth(d, p) {
    return $2b77072f60d19f26$var$pad(d.getDate(), p, 2);
}
function $2b77072f60d19f26$var$formatHour24(d, p) {
    return $2b77072f60d19f26$var$pad(d.getHours(), p, 2);
}
function $2b77072f60d19f26$var$formatHour12(d, p) {
    return $2b77072f60d19f26$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $2b77072f60d19f26$var$formatDayOfYear(d, p) {
    return $2b77072f60d19f26$var$pad(1 + (0, $602aff1c99220c6b$export$2e2bcd8739ae039).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $2b77072f60d19f26$var$formatMilliseconds(d, p) {
    return $2b77072f60d19f26$var$pad(d.getMilliseconds(), p, 3);
}
function $2b77072f60d19f26$var$formatMicroseconds(d, p) {
    return $2b77072f60d19f26$var$formatMilliseconds(d, p) + "000";
}
function $2b77072f60d19f26$var$formatMonthNumber(d, p) {
    return $2b77072f60d19f26$var$pad(d.getMonth() + 1, p, 2);
}
function $2b77072f60d19f26$var$formatMinutes(d, p) {
    return $2b77072f60d19f26$var$pad(d.getMinutes(), p, 2);
}
function $2b77072f60d19f26$var$formatSeconds(d, p) {
    return $2b77072f60d19f26$var$pad(d.getSeconds(), p, 2);
}
function $2b77072f60d19f26$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $2b77072f60d19f26$var$formatWeekNumberSunday(d, p) {
    return $2b77072f60d19f26$var$pad((0, $fe13d34793e7e3a0$export$fb3ee18ed410cc21).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $2b77072f60d19f26$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $fe13d34793e7e3a0$export$2f2b56683a3e5629)(d) : (0, $fe13d34793e7e3a0$export$2f2b56683a3e5629).ceil(d);
}
function $2b77072f60d19f26$var$formatWeekNumberISO(d, p) {
    d = $2b77072f60d19f26$var$dISO(d);
    return $2b77072f60d19f26$var$pad((0, $fe13d34793e7e3a0$export$2f2b56683a3e5629).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d), d) + ((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $2b77072f60d19f26$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $2b77072f60d19f26$var$formatWeekNumberMonday(d, p) {
    return $2b77072f60d19f26$var$pad((0, $fe13d34793e7e3a0$export$6416afaab03bc9b8).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $2b77072f60d19f26$var$formatYear(d, p) {
    return $2b77072f60d19f26$var$pad(d.getFullYear() % 100, p, 2);
}
function $2b77072f60d19f26$var$formatYearISO(d, p) {
    d = $2b77072f60d19f26$var$dISO(d);
    return $2b77072f60d19f26$var$pad(d.getFullYear() % 100, p, 2);
}
function $2b77072f60d19f26$var$formatFullYear(d, p) {
    return $2b77072f60d19f26$var$pad(d.getFullYear() % 10000, p, 4);
}
function $2b77072f60d19f26$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $fe13d34793e7e3a0$export$2f2b56683a3e5629)(d) : (0, $fe13d34793e7e3a0$export$2f2b56683a3e5629).ceil(d);
    return $2b77072f60d19f26$var$pad(d.getFullYear() % 10000, p, 4);
}
function $2b77072f60d19f26$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $2b77072f60d19f26$var$pad(z / 60 | 0, "0", 2) + $2b77072f60d19f26$var$pad(z % 60, "0", 2);
}
function $2b77072f60d19f26$var$formatUTCDayOfMonth(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCDate(), p, 2);
}
function $2b77072f60d19f26$var$formatUTCHour24(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCHours(), p, 2);
}
function $2b77072f60d19f26$var$formatUTCHour12(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $2b77072f60d19f26$var$formatUTCDayOfYear(d, p) {
    return $2b77072f60d19f26$var$pad(1 + (0, $c8ae11bf9d321b24$export$2e2bcd8739ae039).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $2b77072f60d19f26$var$formatUTCMilliseconds(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $2b77072f60d19f26$var$formatUTCMicroseconds(d, p) {
    return $2b77072f60d19f26$var$formatUTCMilliseconds(d, p) + "000";
}
function $2b77072f60d19f26$var$formatUTCMonthNumber(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $2b77072f60d19f26$var$formatUTCMinutes(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCMinutes(), p, 2);
}
function $2b77072f60d19f26$var$formatUTCSeconds(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCSeconds(), p, 2);
}
function $2b77072f60d19f26$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $2b77072f60d19f26$var$formatUTCWeekNumberSunday(d, p) {
    return $2b77072f60d19f26$var$pad((0, $b78e53b93ee93fd9$export$4898b06303a92011).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $2b77072f60d19f26$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $b78e53b93ee93fd9$export$1db08111baec2f53)(d) : (0, $b78e53b93ee93fd9$export$1db08111baec2f53).ceil(d);
}
function $2b77072f60d19f26$var$formatUTCWeekNumberISO(d, p) {
    d = $2b77072f60d19f26$var$UTCdISO(d);
    return $2b77072f60d19f26$var$pad((0, $b78e53b93ee93fd9$export$1db08111baec2f53).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d), d) + ((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $2b77072f60d19f26$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $2b77072f60d19f26$var$formatUTCWeekNumberMonday(d, p) {
    return $2b77072f60d19f26$var$pad((0, $b78e53b93ee93fd9$export$9cfc53b9cfafd080).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $2b77072f60d19f26$var$formatUTCYear(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $2b77072f60d19f26$var$formatUTCYearISO(d, p) {
    d = $2b77072f60d19f26$var$UTCdISO(d);
    return $2b77072f60d19f26$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $2b77072f60d19f26$var$formatUTCFullYear(d, p) {
    return $2b77072f60d19f26$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $2b77072f60d19f26$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $b78e53b93ee93fd9$export$1db08111baec2f53)(d) : (0, $b78e53b93ee93fd9$export$1db08111baec2f53).ceil(d);
    return $2b77072f60d19f26$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $2b77072f60d19f26$var$formatUTCZone() {
    return "+0000";
}
function $2b77072f60d19f26$var$formatLiteralPercent() {
    return "%";
}
function $2b77072f60d19f26$var$formatUnixTimestamp(d) {
    return +d;
}
function $2b77072f60d19f26$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $f79df9e45b336d91$var$locale;
var $f79df9e45b336d91$export$94f4d87fad5dcf9a;
var $f79df9e45b336d91$export$32b9cd16e1b8c8d2;
var $f79df9e45b336d91$export$1a08fe38f63ebbbb;
var $f79df9e45b336d91$export$3edae9cf8e233729;
$f79df9e45b336d91$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $f79df9e45b336d91$export$2e2bcd8739ae039(definition) {
    $f79df9e45b336d91$var$locale = (0, $2b77072f60d19f26$export$2e2bcd8739ae039)(definition);
    $f79df9e45b336d91$export$94f4d87fad5dcf9a = $f79df9e45b336d91$var$locale.format;
    $f79df9e45b336d91$export$32b9cd16e1b8c8d2 = $f79df9e45b336d91$var$locale.parse;
    $f79df9e45b336d91$export$1a08fe38f63ebbbb = $f79df9e45b336d91$var$locale.utcFormat;
    $f79df9e45b336d91$export$3edae9cf8e233729 = $f79df9e45b336d91$var$locale.utcParse;
    return $f79df9e45b336d91$var$locale;
}





var $6058decc9090509d$var$durationSecond = 1000, $6058decc9090509d$var$durationMinute = $6058decc9090509d$var$durationSecond * 60, $6058decc9090509d$var$durationHour = $6058decc9090509d$var$durationMinute * 60, $6058decc9090509d$var$durationDay = $6058decc9090509d$var$durationHour * 24, $6058decc9090509d$var$durationWeek = $6058decc9090509d$var$durationDay * 7, $6058decc9090509d$var$durationMonth = $6058decc9090509d$var$durationDay * 30, $6058decc9090509d$var$durationYear = $6058decc9090509d$var$durationDay * 365;
function $6058decc9090509d$var$date(t) {
    return new Date(t);
}
function $6058decc9090509d$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $6058decc9090509d$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, $a77642f0e685e2bc$export$2e2bcd8739ae039)((0, $a77642f0e685e2bc$export$774010690f7452c2), (0, $4bd58df1c6298bf3$export$2e2bcd8739ae039)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            $6058decc9090509d$var$durationSecond
        ],
        [
            second,
            5,
            5 * $6058decc9090509d$var$durationSecond
        ],
        [
            second,
            15,
            15 * $6058decc9090509d$var$durationSecond
        ],
        [
            second,
            30,
            30 * $6058decc9090509d$var$durationSecond
        ],
        [
            minute,
            1,
            $6058decc9090509d$var$durationMinute
        ],
        [
            minute,
            5,
            5 * $6058decc9090509d$var$durationMinute
        ],
        [
            minute,
            15,
            15 * $6058decc9090509d$var$durationMinute
        ],
        [
            minute,
            30,
            30 * $6058decc9090509d$var$durationMinute
        ],
        [
            hour,
            1,
            $6058decc9090509d$var$durationHour
        ],
        [
            hour,
            3,
            3 * $6058decc9090509d$var$durationHour
        ],
        [
            hour,
            6,
            6 * $6058decc9090509d$var$durationHour
        ],
        [
            hour,
            12,
            12 * $6058decc9090509d$var$durationHour
        ],
        [
            day,
            1,
            $6058decc9090509d$var$durationDay
        ],
        [
            day,
            2,
            2 * $6058decc9090509d$var$durationDay
        ],
        [
            week,
            1,
            $6058decc9090509d$var$durationWeek
        ],
        [
            month,
            1,
            $6058decc9090509d$var$durationMonth
        ],
        [
            month,
            3,
            3 * $6058decc9090509d$var$durationMonth
        ],
        [
            year,
            1,
            $6058decc9090509d$var$durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, $48ef30fb98306994$export$2e2bcd8739ae039)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, $fd752f66568b8bf9$export$81087d9b915d4ede)(start / $6058decc9090509d$var$durationYear, stop / $6058decc9090509d$var$durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, $fd752f66568b8bf9$export$81087d9b915d4ede)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, $737becf007b3944b$export$871de8747c9eaa88).call(_, $6058decc9090509d$var$number)) : domain().map($6058decc9090509d$var$date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, $2a424c37c03e960c$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $a77642f0e685e2bc$export$784d13d8ee351f07)(scale, $6058decc9090509d$export$56bbcdb8aca31149(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}
function $6058decc9090509d$export$2e2bcd8739ae039() {
    return $6058decc9090509d$export$56bbcdb8aca31149((0, $1680cba015ceb6d5$export$2e2bcd8739ae039), (0, $4f9a001daae5050d$export$2e2bcd8739ae039), (0, $fe13d34793e7e3a0$export$fb3ee18ed410cc21), (0, $602aff1c99220c6b$export$2e2bcd8739ae039), (0, $fb9a8315f21b976d$export$2e2bcd8739ae039), (0, $109f46f27355bc65$export$2e2bcd8739ae039), (0, $487ed9b7591747b7$export$2e2bcd8739ae039), (0, $ee2eb9ba018c49e9$export$2e2bcd8739ae039), (0, $f79df9e45b336d91$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]);
}






var $90f180d65417fdae$var$utcHour = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $1ac2b7c223d9f119$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $1ac2b7c223d9f119$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $90f180d65417fdae$export$2e2bcd8739ae039 = $90f180d65417fdae$var$utcHour;
var $90f180d65417fdae$export$6e7a76cd5f50b719 = $90f180d65417fdae$var$utcHour.range;



var $1dd3d96749ba1800$var$utcMinute = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $1ac2b7c223d9f119$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $1ac2b7c223d9f119$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $1dd3d96749ba1800$export$2e2bcd8739ae039 = $1dd3d96749ba1800$var$utcMinute;
var $1dd3d96749ba1800$export$cedd563624e8ee50 = $1dd3d96749ba1800$var$utcMinute.range;


var $10fb9bb728599ced$var$utcMonth = (0, $7d3cdef2d64f9d24$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $10fb9bb728599ced$export$2e2bcd8739ae039 = $10fb9bb728599ced$var$utcMonth;
var $10fb9bb728599ced$export$49159f585997498 = $10fb9bb728599ced$var$utcMonth.range;


function $108566a5c7af9794$export$2e2bcd8739ae039() {
    return (0, $6058decc9090509d$export$56bbcdb8aca31149)((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039), (0, $10fb9bb728599ced$export$2e2bcd8739ae039), (0, $b78e53b93ee93fd9$export$4898b06303a92011), (0, $c8ae11bf9d321b24$export$2e2bcd8739ae039), (0, $90f180d65417fdae$export$2e2bcd8739ae039), (0, $1dd3d96749ba1800$export$2e2bcd8739ae039), (0, $487ed9b7591747b7$export$2e2bcd8739ae039), (0, $ee2eb9ba018c49e9$export$2e2bcd8739ae039), (0, $f79df9e45b336d91$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]);
}


function $fd6a44a2afb0e111$export$2e2bcd8739ae039(s) {
    return s.match(/.{6}/g).map(function(x) {
        return "#" + x;
    });
}


var $77c67e50346ab974$export$2e2bcd8739ae039 = (0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");



var $3a92a1fdd80817c9$export$2e2bcd8739ae039 = (0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");



var $bdaa5effe00b5708$export$2e2bcd8739ae039 = (0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");



var $976774e01a7b2130$export$2e2bcd8739ae039 = (0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");



var $kDNpt = parcelRequire("kDNpt");

var $39bR5 = parcelRequire("39bR5");
var $602d5a9fa8a236c4$export$b1b275608b2b1b8 = Math.PI / 180;
var $602d5a9fa8a236c4$export$b2ba2578f2c43d74 = 180 / Math.PI;


var $e7d21e2390941dd5$var$A = -0.14861, $e7d21e2390941dd5$var$B = 1.78277, $e7d21e2390941dd5$var$C = -0.29227, $e7d21e2390941dd5$var$D = -0.90649, $e7d21e2390941dd5$var$E = 1.97294, $e7d21e2390941dd5$var$ED = $e7d21e2390941dd5$var$E * $e7d21e2390941dd5$var$D, $e7d21e2390941dd5$var$EB = $e7d21e2390941dd5$var$E * $e7d21e2390941dd5$var$B, $e7d21e2390941dd5$var$BC_DA = $e7d21e2390941dd5$var$B * $e7d21e2390941dd5$var$C - $e7d21e2390941dd5$var$D * $e7d21e2390941dd5$var$A;
function $e7d21e2390941dd5$var$cubehelixConvert(o) {
    if (o instanceof $e7d21e2390941dd5$export$57ed4bde61a1e2f2) return new $e7d21e2390941dd5$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $39bR5.Rgb))) o = (0, $39bR5.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($e7d21e2390941dd5$var$BC_DA * b + $e7d21e2390941dd5$var$ED * r - $e7d21e2390941dd5$var$EB * g) / ($e7d21e2390941dd5$var$BC_DA + $e7d21e2390941dd5$var$ED - $e7d21e2390941dd5$var$EB), bl = b - l, k = ($e7d21e2390941dd5$var$E * (g - l) - $e7d21e2390941dd5$var$C * bl) / $e7d21e2390941dd5$var$D, s = Math.sqrt(k * k + bl * bl) / ($e7d21e2390941dd5$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $602d5a9fa8a236c4$export$b2ba2578f2c43d74) - 120 : NaN;
    return new $e7d21e2390941dd5$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $e7d21e2390941dd5$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $e7d21e2390941dd5$var$cubehelixConvert(h) : new $e7d21e2390941dd5$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $e7d21e2390941dd5$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $kDNpt.default)($e7d21e2390941dd5$export$57ed4bde61a1e2f2, $e7d21e2390941dd5$export$2e2bcd8739ae039, (0, $kDNpt.extend)((0, $39bR5.Color), {
    brighter: function(k) {
        k = k == null ? (0, $39bR5.brighter) : Math.pow((0, $39bR5.brighter), k);
        return new $e7d21e2390941dd5$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $39bR5.darker) : Math.pow((0, $39bR5.darker), k);
        return new $e7d21e2390941dd5$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $602d5a9fa8a236c4$export$b1b275608b2b1b8), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $39bR5.Rgb)(255 * (l + a * ($e7d21e2390941dd5$var$A * cosh + $e7d21e2390941dd5$var$B * sinh)), 255 * (l + a * ($e7d21e2390941dd5$var$C * cosh + $e7d21e2390941dd5$var$D * sinh)), 255 * (l + a * ($e7d21e2390941dd5$var$E * cosh)), this.opacity);
    }
}));




function $eeab3f1e93496764$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(start)).h, (end = (0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(end)).h), s = (0, $8ccd72a948bd24c2$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $8ccd72a948bd24c2$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $8ccd72a948bd24c2$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $eeab3f1e93496764$export$2e2bcd8739ae039 = $eeab3f1e93496764$var$cubehelix((0, $8ccd72a948bd24c2$export$97d7b0c7ddb78dcf));
var $eeab3f1e93496764$export$934fa09ad474a1b4 = $eeab3f1e93496764$var$cubehelix((0, $8ccd72a948bd24c2$export$2e2bcd8739ae039));


var $366c913aadfb5bcc$export$2e2bcd8739ae039 = (0, $eeab3f1e93496764$export$934fa09ad474a1b4)((0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(-240, 0.5, 1.0));




var $a24aa4552af3daca$export$fc70efcec537be98 = (0, $eeab3f1e93496764$export$934fa09ad474a1b4)((0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $a24aa4552af3daca$export$c5cedbc1ab3be2c3 = (0, $eeab3f1e93496764$export$934fa09ad474a1b4)((0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $e7d21e2390941dd5$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $a24aa4552af3daca$var$rainbow = (0, $e7d21e2390941dd5$export$2e2bcd8739ae039)();
function $a24aa4552af3daca$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $a24aa4552af3daca$var$rainbow.h = 360 * t - 100;
    $a24aa4552af3daca$var$rainbow.s = 1.5 - 1.5 * ts;
    $a24aa4552af3daca$var$rainbow.l = 0.8 - 0.9 * ts;
    return $a24aa4552af3daca$var$rainbow + "";
}



function $d87608e9823ad421$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $d87608e9823ad421$export$2e2bcd8739ae039 = $d87608e9823ad421$var$ramp((0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $d87608e9823ad421$export$c41e69203f572e8d = $d87608e9823ad421$var$ramp((0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $d87608e9823ad421$export$ad0c8285c8ea6dbd = $d87608e9823ad421$var$ramp((0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $d87608e9823ad421$export$6664860a633d9daf = $d87608e9823ad421$var$ramp((0, $fd6a44a2afb0e111$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



function $02f7d8723f53f17c$export$2e2bcd8739ae039(interpolator) {
    var x0 = 0, x1 = 1, clamp = false;
    function scale(x) {
        var t = (x - x0) / (x1 - x0);
        return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return $02f7d8723f53f17c$export$2e2bcd8739ae039(interpolator).domain([
            x0,
            x1
        ]).clamp(clamp);
    };
    return (0, $a0b9e5e3cd5bd1c9$export$16a5d4b4a61a274d)(scale);
}




var $6521e73031711d05$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $6521e73031711d05$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $6521e73031711d05$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $8390e495ad027a42$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $6521e73031711d05$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $6521e73031711d05$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name;
}



function $a6d656bdfd1d966b$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $6521e73031711d05$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $6521e73031711d05$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $a6d656bdfd1d966b$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $a6d656bdfd1d966b$export$2e2bcd8739ae039(name) {
    var fullname = (0, $8390e495ad027a42$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $a6d656bdfd1d966b$var$creatorFixed : $a6d656bdfd1d966b$var$creatorInherit)(fullname);
}



function $1cb32fe27b0654cb$var$none() {}
function $1cb32fe27b0654cb$export$2e2bcd8739ae039(selector) {
    return selector == null ? $1cb32fe27b0654cb$var$none : function() {
        return this.querySelector(selector);
    };
}


function $081d4b50d806f2b2$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $1cb32fe27b0654cb$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(subgroups, this._parents);
}



function $6d1415ed76595ded$var$empty() {
    return [];
}
function $6d1415ed76595ded$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6d1415ed76595ded$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $94ba6f3c5d3234a0$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6d1415ed76595ded$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(subgroups, parents);
}



var $16e89fc8e90dbc2d$var$matcher = function(selector) {
    return function() {
        return this.matches(selector);
    };
};
if (typeof document !== "undefined") {
    var $16e89fc8e90dbc2d$var$element = document.documentElement;
    if (!$16e89fc8e90dbc2d$var$element.matches) {
        var $16e89fc8e90dbc2d$var$vendorMatches = $16e89fc8e90dbc2d$var$element.webkitMatchesSelector || $16e89fc8e90dbc2d$var$element.msMatchesSelector || $16e89fc8e90dbc2d$var$element.mozMatchesSelector || $16e89fc8e90dbc2d$var$element.oMatchesSelector;
        $16e89fc8e90dbc2d$var$matcher = function(selector) {
            return function() {
                return $16e89fc8e90dbc2d$var$vendorMatches.call(this, selector);
            };
        };
    }
}
var $16e89fc8e90dbc2d$export$2e2bcd8739ae039 = $16e89fc8e90dbc2d$var$matcher;


function $ef53f196a6a2c00c$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $16e89fc8e90dbc2d$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(subgroups, this._parents);
}



function $ac0bfede53cc7b30$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $486fe9dd5b03c282$export$2e2bcd8739ae039() {
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(this._enter || this._groups.map((0, $ac0bfede53cc7b30$export$2e2bcd8739ae039)), this._parents);
}
function $486fe9dd5b03c282$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$486fe9dd5b03c282$export$67b01759a14cf6a4.prototype = {
    constructor: $486fe9dd5b03c282$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $bcfda4ab970b047b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


var $7d6af2687d9725aa$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $7d6af2687d9725aa$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $486fe9dd5b03c282$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $7d6af2687d9725aa$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $7d6af2687d9725aa$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $7d6af2687d9725aa$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $486fe9dd5b03c282$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $7d6af2687d9725aa$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $7d6af2687d9725aa$var$bindKey : $7d6af2687d9725aa$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $bcfda4ab970b047b$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $8d5983e94e005693$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $2147809461104cda$export$2e2bcd8739ae039() {
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(this._exit || this._groups.map((0, $ac0bfede53cc7b30$export$2e2bcd8739ae039)), this._parents);
}



function $0360773b32469468$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(merges, this._parents);
}


function $bfc26845fa79b9e7$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $39793dbd7986aca0$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $39793dbd7986aca0$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $8d5983e94e005693$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $39793dbd7986aca0$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $64f7da0a4be30009$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $b9a13f1934daf438$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}


function $b17aea09d901428f$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $d80c7d9e0d35a32d$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}


function $53f4af6525ae392c$export$2e2bcd8739ae039() {
    return !this.node();
}


function $81c241593d889887$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}



function $386de8bde821da6a$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $386de8bde821da6a$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $386de8bde821da6a$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $386de8bde821da6a$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $386de8bde821da6a$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $386de8bde821da6a$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $386de8bde821da6a$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $8390e495ad027a42$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $386de8bde821da6a$var$attrRemoveNS : $386de8bde821da6a$var$attrRemove : typeof value === "function" ? fullname.local ? $386de8bde821da6a$var$attrFunctionNS : $386de8bde821da6a$var$attrFunction : fullname.local ? $386de8bde821da6a$var$attrConstantNS : $386de8bde821da6a$var$attrConstant)(fullname, value));
}


function $3b935bd0c6f9c20a$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6fc9ee4e8034e230$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6fc9ee4e8034e230$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6fc9ee4e8034e230$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6fc9ee4e8034e230$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6fc9ee4e8034e230$var$styleRemove : typeof value === "function" ? $6fc9ee4e8034e230$var$styleFunction : $6fc9ee4e8034e230$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6fc9ee4e8034e230$export$5e3cec964f0b5efd(this.node(), name);
}
function $6fc9ee4e8034e230$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $3b935bd0c6f9c20a$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $3a469e226a2bf226$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $3a469e226a2bf226$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $3a469e226a2bf226$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $3a469e226a2bf226$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $3a469e226a2bf226$var$propertyRemove : typeof value === "function" ? $3a469e226a2bf226$var$propertyFunction : $3a469e226a2bf226$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6a4d6db5c0e8ba68$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6a4d6db5c0e8ba68$var$classList(node) {
    return node.classList || new $6a4d6db5c0e8ba68$var$ClassList(node);
}
function $6a4d6db5c0e8ba68$var$ClassList(node) {
    this._node = node;
    this._names = $6a4d6db5c0e8ba68$var$classArray(node.getAttribute("class") || "");
}
$6a4d6db5c0e8ba68$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6a4d6db5c0e8ba68$var$classedAdd(node, names) {
    var list = $6a4d6db5c0e8ba68$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6a4d6db5c0e8ba68$var$classedRemove(node, names) {
    var list = $6a4d6db5c0e8ba68$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6a4d6db5c0e8ba68$var$classedTrue(names) {
    return function() {
        $6a4d6db5c0e8ba68$var$classedAdd(this, names);
    };
}
function $6a4d6db5c0e8ba68$var$classedFalse(names) {
    return function() {
        $6a4d6db5c0e8ba68$var$classedRemove(this, names);
    };
}
function $6a4d6db5c0e8ba68$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6a4d6db5c0e8ba68$var$classedAdd : $6a4d6db5c0e8ba68$var$classedRemove)(this, names);
    };
}
function $6a4d6db5c0e8ba68$export$2e2bcd8739ae039(name, value) {
    var names = $6a4d6db5c0e8ba68$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6a4d6db5c0e8ba68$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6a4d6db5c0e8ba68$var$classedFunction : value ? $6a4d6db5c0e8ba68$var$classedTrue : $6a4d6db5c0e8ba68$var$classedFalse)(names, value));
}


function $14d72774414c2c78$var$textRemove() {
    this.textContent = "";
}
function $14d72774414c2c78$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $14d72774414c2c78$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $14d72774414c2c78$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $14d72774414c2c78$var$textRemove : (typeof value === "function" ? $14d72774414c2c78$var$textFunction : $14d72774414c2c78$var$textConstant)(value)) : this.node().textContent;
}


function $0f1ac48e7a5232ac$var$htmlRemove() {
    this.innerHTML = "";
}
function $0f1ac48e7a5232ac$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $0f1ac48e7a5232ac$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $0f1ac48e7a5232ac$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $0f1ac48e7a5232ac$var$htmlRemove : (typeof value === "function" ? $0f1ac48e7a5232ac$var$htmlFunction : $0f1ac48e7a5232ac$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $7286d2874ec8c448$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $7286d2874ec8c448$export$2e2bcd8739ae039() {
    return this.each($7286d2874ec8c448$var$raise);
}


function $5a1727bb988b4e91$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $5a1727bb988b4e91$export$2e2bcd8739ae039() {
    return this.each($5a1727bb988b4e91$var$lower);
}



function $7b7f8fbbf7c0bf96$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $a6d656bdfd1d966b$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $1b767affa670c025$var$constantNull() {
    return null;
}
function $1b767affa670c025$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $a6d656bdfd1d966b$export$2e2bcd8739ae039)(name), select = before == null ? $1b767affa670c025$var$constantNull : typeof before === "function" ? before : (0, $1cb32fe27b0654cb$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $a47e143526763f10$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $a47e143526763f10$export$2e2bcd8739ae039() {
    return this.each($a47e143526763f10$var$remove);
}


function $02becf6037a7f2c8$var$selection_cloneShallow() {
    return this.parentNode.insertBefore(this.cloneNode(false), this.nextSibling);
}
function $02becf6037a7f2c8$var$selection_cloneDeep() {
    return this.parentNode.insertBefore(this.cloneNode(true), this.nextSibling);
}
function $02becf6037a7f2c8$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $02becf6037a7f2c8$var$selection_cloneDeep : $02becf6037a7f2c8$var$selection_cloneShallow);
}


function $40128d4ca0456686$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


var $7b8252b4dbece68a$var$filterEvents = {};
var $7b8252b4dbece68a$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $7b8252b4dbece68a$var$element = document.documentElement;
    if (!("onmouseenter" in $7b8252b4dbece68a$var$element)) $7b8252b4dbece68a$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $7b8252b4dbece68a$var$filterContextListener(listener, index, group) {
    listener = $7b8252b4dbece68a$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $7b8252b4dbece68a$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $7b8252b4dbece68a$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $7b8252b4dbece68a$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $7b8252b4dbece68a$export$6cd530ed55e06764 = event0;
        }
    };
}
function $7b8252b4dbece68a$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $7b8252b4dbece68a$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $7b8252b4dbece68a$var$onAdd(typename, value, capture) {
    var wrap = $7b8252b4dbece68a$var$filterEvents.hasOwnProperty(typename.type) ? $7b8252b4dbece68a$var$filterContextListener : $7b8252b4dbece68a$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $7b8252b4dbece68a$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $7b8252b4dbece68a$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $7b8252b4dbece68a$var$onAdd : $7b8252b4dbece68a$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $7b8252b4dbece68a$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $7b8252b4dbece68a$export$6cd530ed55e06764;
    event1.sourceEvent = $7b8252b4dbece68a$export$6cd530ed55e06764;
    $7b8252b4dbece68a$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $7b8252b4dbece68a$export$6cd530ed55e06764 = event0;
    }
}



function $39a35c6a263019d9$var$dispatchEvent(node, type, params) {
    var window = (0, $3b935bd0c6f9c20a$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $39a35c6a263019d9$var$dispatchConstant(type, params) {
    return function() {
        return $39a35c6a263019d9$var$dispatchEvent(this, type, params);
    };
}
function $39a35c6a263019d9$var$dispatchFunction(type, params) {
    return function() {
        return $39a35c6a263019d9$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $39a35c6a263019d9$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $39a35c6a263019d9$var$dispatchFunction : $39a35c6a263019d9$var$dispatchConstant)(type, params));
}


var $8d5983e94e005693$export$e8e78c978b129247 = [
    null
];
function $8d5983e94e005693$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $8d5983e94e005693$var$selection() {
    return new $8d5983e94e005693$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $8d5983e94e005693$export$e8e78c978b129247);
}
$8d5983e94e005693$export$52baac22726c72bf.prototype = $8d5983e94e005693$var$selection.prototype = {
    constructor: $8d5983e94e005693$export$52baac22726c72bf,
    select: (0, $081d4b50d806f2b2$export$2e2bcd8739ae039),
    selectAll: (0, $94ba6f3c5d3234a0$export$2e2bcd8739ae039),
    filter: (0, $ef53f196a6a2c00c$export$2e2bcd8739ae039),
    data: (0, $7d6af2687d9725aa$export$2e2bcd8739ae039),
    enter: (0, $486fe9dd5b03c282$export$2e2bcd8739ae039),
    exit: (0, $2147809461104cda$export$2e2bcd8739ae039),
    merge: (0, $0360773b32469468$export$2e2bcd8739ae039),
    order: (0, $bfc26845fa79b9e7$export$2e2bcd8739ae039),
    sort: (0, $39793dbd7986aca0$export$2e2bcd8739ae039),
    call: (0, $64f7da0a4be30009$export$2e2bcd8739ae039),
    nodes: (0, $b9a13f1934daf438$export$2e2bcd8739ae039),
    node: (0, $b17aea09d901428f$export$2e2bcd8739ae039),
    size: (0, $d80c7d9e0d35a32d$export$2e2bcd8739ae039),
    empty: (0, $53f4af6525ae392c$export$2e2bcd8739ae039),
    each: (0, $81c241593d889887$export$2e2bcd8739ae039),
    attr: (0, $386de8bde821da6a$export$2e2bcd8739ae039),
    style: (0, $6fc9ee4e8034e230$export$2e2bcd8739ae039),
    property: (0, $3a469e226a2bf226$export$2e2bcd8739ae039),
    classed: (0, $6a4d6db5c0e8ba68$export$2e2bcd8739ae039),
    text: (0, $14d72774414c2c78$export$2e2bcd8739ae039),
    html: (0, $0f1ac48e7a5232ac$export$2e2bcd8739ae039),
    raise: (0, $7286d2874ec8c448$export$2e2bcd8739ae039),
    lower: (0, $5a1727bb988b4e91$export$2e2bcd8739ae039),
    append: (0, $7b7f8fbbf7c0bf96$export$2e2bcd8739ae039),
    insert: (0, $1b767affa670c025$export$2e2bcd8739ae039),
    remove: (0, $a47e143526763f10$export$2e2bcd8739ae039),
    clone: (0, $02becf6037a7f2c8$export$2e2bcd8739ae039),
    datum: (0, $40128d4ca0456686$export$2e2bcd8739ae039),
    on: (0, $7b8252b4dbece68a$export$2e2bcd8739ae039),
    dispatch: (0, $39a35c6a263019d9$export$2e2bcd8739ae039)
};
var $8d5983e94e005693$export$2e2bcd8739ae039 = $8d5983e94e005693$var$selection;


function $9dc0bf83babef520$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $8d5983e94e005693$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $8d5983e94e005693$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $8d5983e94e005693$export$e8e78c978b129247));
}


function $4a343c4e02352046$export$2e2bcd8739ae039(name) {
    return (0, $9dc0bf83babef520$export$2e2bcd8739ae039)((0, $a6d656bdfd1d966b$export$2e2bcd8739ae039)(name).call(document.documentElement));
}



var $e0dca0293f26c093$var$nextId = 0;
function $e0dca0293f26c093$export$2e2bcd8739ae039() {
    return new $e0dca0293f26c093$var$Local;
}
function $e0dca0293f26c093$var$Local() {
    this._ = "@" + (++$e0dca0293f26c093$var$nextId).toString(36);
}
$e0dca0293f26c093$var$Local.prototype = $e0dca0293f26c093$export$2e2bcd8739ae039.prototype = {
    constructor: $e0dca0293f26c093$var$Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};




function $003b79026fec09cc$export$2e2bcd8739ae039() {
    var current = (0, $7b8252b4dbece68a$export$6cd530ed55e06764), source;
    while(source = current.sourceEvent)current = source;
    return current;
}


function $cfd0bdd2b70c9aeb$export$2e2bcd8739ae039(node, event) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = event.clientX, point.y = event.clientY;
        point = point.matrixTransform(node.getScreenCTM().inverse());
        return [
            point.x,
            point.y
        ];
    }
    var rect = node.getBoundingClientRect();
    return [
        event.clientX - rect.left - node.clientLeft,
        event.clientY - rect.top - node.clientTop
    ];
}


function $75fe57f10a85f91f$export$2e2bcd8739ae039(node) {
    var event = (0, $003b79026fec09cc$export$2e2bcd8739ae039)();
    if (event.changedTouches) event = event.changedTouches[0];
    return (0, $cfd0bdd2b70c9aeb$export$2e2bcd8739ae039)(node, event);
}







function $291b040c42b1eb9a$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $8d5983e94e005693$export$52baac22726c72bf)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $8d5983e94e005693$export$52baac22726c72bf)([
        selector == null ? [] : selector
    ], (0, $8d5983e94e005693$export$e8e78c978b129247));
}








function $8b8f8c65a8748748$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $003b79026fec09cc$export$2e2bcd8739ae039)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $cfd0bdd2b70c9aeb$export$2e2bcd8739ae039)(node, touch);
    }
    return null;
}




function $34bf3fb128c3a793$export$2e2bcd8739ae039(node, touches) {
    if (touches == null) touches = (0, $003b79026fec09cc$export$2e2bcd8739ae039)().touches;
    for(var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i)points[i] = (0, $cfd0bdd2b70c9aeb$export$2e2bcd8739ae039)(node, touches[i]);
    return points;
}







function $bab02431b5ece3c1$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}



var $1Iwhd = parcelRequire("1Iwhd");
function $6c9cc02c644d9182$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $6c9cc02c644d9182$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $6c9cc02c644d9182$var$arcStartAngle(d) {
    return d.startAngle;
}
function $6c9cc02c644d9182$var$arcEndAngle(d) {
    return d.endAngle;
}
function $6c9cc02c644d9182$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $6c9cc02c644d9182$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $6c9cc02c644d9182$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $1Iwhd.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $1Iwhd.sqrt)((0, $1Iwhd.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $6c9cc02c644d9182$export$2e2bcd8739ae039() {
    var innerRadius = $6c9cc02c644d9182$var$arcInnerRadius, outerRadius = $6c9cc02c644d9182$var$arcOuterRadius, cornerRadius = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $6c9cc02c644d9182$var$arcStartAngle, endAngle = $6c9cc02c644d9182$var$arcEndAngle, padAngle = $6c9cc02c644d9182$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $1Iwhd.halfPi), a1 = endAngle.apply(this, arguments) - (0, $1Iwhd.halfPi), da = (0, $1Iwhd.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $d29cec310fd417a9$export$2e2bcd8739ae039)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $1Iwhd.epsilon))) context.moveTo(0, 0);
        else if (da > (0, $1Iwhd.tau) - (0, $1Iwhd.epsilon)) {
            context.moveTo(r1 * (0, $1Iwhd.cos)(a0), r1 * (0, $1Iwhd.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $1Iwhd.epsilon)) {
                context.moveTo(r0 * (0, $1Iwhd.cos)(a1), r0 * (0, $1Iwhd.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $1Iwhd.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, $1Iwhd.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $1Iwhd.min)((0, $1Iwhd.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $1Iwhd.epsilon)) {
                var p0 = (0, $1Iwhd.asin)(rp / r0 * (0, $1Iwhd.sin)(ap)), p1 = (0, $1Iwhd.asin)(rp / r1 * (0, $1Iwhd.sin)(ap));
                if ((da0 -= p0 * 2) > (0, $1Iwhd.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $1Iwhd.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $1Iwhd.cos)(a01), y01 = r1 * (0, $1Iwhd.sin)(a01), x10 = r0 * (0, $1Iwhd.cos)(a10), y10 = r0 * (0, $1Iwhd.sin)(a10);
            // Apply rounded corners?
            if (rc > (0, $1Iwhd.epsilon)) {
                var x11 = r1 * (0, $1Iwhd.cos)(a11), y11 = r1 * (0, $1Iwhd.sin)(a11), x00 = r0 * (0, $1Iwhd.cos)(a00), y00 = r0 * (0, $1Iwhd.sin)(a00);
                // Restrict the corner radius according to the sector angle.
                if (da < (0, $1Iwhd.pi)) {
                    var oc = da0 > (0, $1Iwhd.epsilon) ? $6c9cc02c644d9182$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [
                        x10,
                        y10
                    ], ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $1Iwhd.sin)((0, $1Iwhd.acos)((ax * bx + ay * by) / ((0, $1Iwhd.sqrt)(ax * ax + ay * ay) * (0, $1Iwhd.sqrt)(bx * bx + by * by))) / 2), lc = (0, $1Iwhd.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $1Iwhd.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $1Iwhd.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $1Iwhd.epsilon))) context.moveTo(x01, y01);
            else if (rc1 > (0, $1Iwhd.epsilon)) {
                t0 = $6c9cc02c644d9182$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $6c9cc02c644d9182$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $1Iwhd.atan2)(t0.y01, t0.x01), (0, $1Iwhd.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $1Iwhd.atan2)(t0.y01, t0.x01), (0, $1Iwhd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $1Iwhd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $1Iwhd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $1Iwhd.atan2)(t1.y11, t1.x11), (0, $1Iwhd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $1Iwhd.epsilon)) || !(da0 > (0, $1Iwhd.epsilon))) context.lineTo(x10, y10);
            else if (rc0 > (0, $1Iwhd.epsilon)) {
                t0 = $6c9cc02c644d9182$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $6c9cc02c644d9182$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $1Iwhd.atan2)(t0.y01, t0.x01), (0, $1Iwhd.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $1Iwhd.atan2)(t0.y01, t0.x01), (0, $1Iwhd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $1Iwhd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $1Iwhd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $1Iwhd.atan2)(t1.y11, t1.x11), (0, $1Iwhd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $1Iwhd.pi) / 2;
        return [
            (0, $1Iwhd.cos)(a) * r,
            (0, $1Iwhd.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}




function $2d5fe82efb73e4f3$var$Linear(context) {
    this._context = context;
}
$2d5fe82efb73e4f3$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $2d5fe82efb73e4f3$export$2e2bcd8739ae039(context) {
    return new $2d5fe82efb73e4f3$var$Linear(context);
}





function $99b95bb71909a82f$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $99b95bb71909a82f$export$4a5767248b18ef41(p) {
    return p[1];
}


function $4c34d52fc46c1f87$export$2e2bcd8739ae039() {
    var x = (0, $99b95bb71909a82f$export$d141bba7fdc215a3), y = (0, $99b95bb71909a82f$export$4a5767248b18ef41), defined = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(true), context = null, curve = (0, $2d5fe82efb73e4f3$export$2e2bcd8739ae039), output = null;
    function line(data) {
        var i, n = data.length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $d29cec310fd417a9$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}



function $fd48b00f0ac80772$export$2e2bcd8739ae039() {
    var x0 = (0, $99b95bb71909a82f$export$d141bba7fdc215a3), x1 = null, y0 = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(0), y1 = (0, $99b95bb71909a82f$export$4a5767248b18ef41), defined = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(true), context = null, curve = (0, $2d5fe82efb73e4f3$export$2e2bcd8739ae039), output = null;
    function area(data) {
        var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $d29cec310fd417a9$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $4c34d52fc46c1f87$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}




function $8cf6c73d45fdaf25$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $683301935e9188b3$export$2e2bcd8739ae039(d) {
    return d;
}



var $1Iwhd = parcelRequire("1Iwhd");
function $d7ffe41a484e323b$export$2e2bcd8739ae039() {
    var value = (0, $683301935e9188b3$export$2e2bcd8739ae039), sortValues = (0, $8cf6c73d45fdaf25$export$2e2bcd8739ae039), sort = null, startAngle = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(0), endAngle = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)((0, $1Iwhd.tau)), padAngle = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $1Iwhd.tau), Math.max(-(0, $1Iwhd.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}



var $e8044e84d4937293$export$22d25ffb9fb15b6f = $e8044e84d4937293$export$2e2bcd8739ae039((0, $2d5fe82efb73e4f3$export$2e2bcd8739ae039));
function $e8044e84d4937293$var$Radial(curve) {
    this._curve = curve;
}
$e8044e84d4937293$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $e8044e84d4937293$export$2e2bcd8739ae039(curve) {
    function radial(context) {
        return new $e8044e84d4937293$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}





function $9e329955b60ed22c$export$4d8815a75dc8cd4d(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $e8044e84d4937293$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return l;
}
function $9e329955b60ed22c$export$2e2bcd8739ae039() {
    return $9e329955b60ed22c$export$4d8815a75dc8cd4d((0, $4c34d52fc46c1f87$export$2e2bcd8739ae039)().curve((0, $e8044e84d4937293$export$22d25ffb9fb15b6f)));
}


function $87523e3648e96507$export$2e2bcd8739ae039() {
    var a = (0, $fd48b00f0ac80772$export$2e2bcd8739ae039)().curve((0, $e8044e84d4937293$export$22d25ffb9fb15b6f)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $9e329955b60ed22c$export$4d8815a75dc8cd4d)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $9e329955b60ed22c$export$4d8815a75dc8cd4d)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $9e329955b60ed22c$export$4d8815a75dc8cd4d)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $9e329955b60ed22c$export$4d8815a75dc8cd4d)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $e8044e84d4937293$export$2e2bcd8739ae039)(_)) : c()._curve;
    };
    return a;
}



function $30d9c8b6ab6dd6c6$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}



var $d15053515cae7853$export$58adb3bec8346d0f = Array.prototype.slice;





function $28e0f082af402434$var$linkSource(d) {
    return d.source;
}
function $28e0f082af402434$var$linkTarget(d) {
    return d.target;
}
function $28e0f082af402434$var$link(curve) {
    var source = $28e0f082af402434$var$linkSource, target = $28e0f082af402434$var$linkTarget, x = (0, $99b95bb71909a82f$export$d141bba7fdc215a3), y = (0, $99b95bb71909a82f$export$4a5767248b18ef41), context = null;
    function link() {
        var buffer, argv = (0, $d15053515cae7853$export$58adb3bec8346d0f).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, $d29cec310fd417a9$export$2e2bcd8739ae039)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function $28e0f082af402434$var$curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function $28e0f082af402434$var$curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function $28e0f082af402434$var$curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, $30d9c8b6ab6dd6c6$export$2e2bcd8739ae039)(x0, y0), p1 = (0, $30d9c8b6ab6dd6c6$export$2e2bcd8739ae039)(x0, y0 = (y0 + y1) / 2), p2 = (0, $30d9c8b6ab6dd6c6$export$2e2bcd8739ae039)(x1, y0), p3 = (0, $30d9c8b6ab6dd6c6$export$2e2bcd8739ae039)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function $28e0f082af402434$export$e7c381889b2cd14d() {
    return $28e0f082af402434$var$link($28e0f082af402434$var$curveHorizontal);
}
function $28e0f082af402434$export$75de4c8c66884e04() {
    return $28e0f082af402434$var$link($28e0f082af402434$var$curveVertical);
}
function $28e0f082af402434$export$7739cfe68d4e0799() {
    var l = $28e0f082af402434$var$link($28e0f082af402434$var$curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}




var $1Iwhd = parcelRequire("1Iwhd");
var $f2eb04612d9eee52$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, $1Iwhd.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $1Iwhd.tau));
    }
};


var $e0818fbcc8c4da59$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};


var $325e7ccb251f7d24$var$tan30 = Math.sqrt(1 / 3), $325e7ccb251f7d24$var$tan30_2 = $325e7ccb251f7d24$var$tan30 * 2;
var $325e7ccb251f7d24$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = Math.sqrt(size / $325e7ccb251f7d24$var$tan30_2), x = y * $325e7ccb251f7d24$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $1Iwhd = parcelRequire("1Iwhd");
var $9cdfa9105343d5ce$var$ka = 0.89081309152928522810, $9cdfa9105343d5ce$var$kr = Math.sin((0, $1Iwhd.pi) / 10) / Math.sin(7 * (0, $1Iwhd.pi) / 10), $9cdfa9105343d5ce$var$kx = Math.sin((0, $1Iwhd.tau) / 10) * $9cdfa9105343d5ce$var$kr, $9cdfa9105343d5ce$var$ky = -Math.cos((0, $1Iwhd.tau) / 10) * $9cdfa9105343d5ce$var$kr;
var $9cdfa9105343d5ce$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size * $9cdfa9105343d5ce$var$ka), x = $9cdfa9105343d5ce$var$kx * r, y = $9cdfa9105343d5ce$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, $1Iwhd.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};


var $85470f2a6152e9a2$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};


var $bc035271c06cfcfe$var$sqrt3 = Math.sqrt(3);
var $bc035271c06cfcfe$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / ($bc035271c06cfcfe$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$bc035271c06cfcfe$var$sqrt3 * y, -y);
        context.lineTo($bc035271c06cfcfe$var$sqrt3 * y, -y);
        context.closePath();
    }
};


var $955fdf1dc0f8e255$var$c = -0.5, $955fdf1dc0f8e255$var$s = Math.sqrt(3) / 2, $955fdf1dc0f8e255$var$k = 1 / Math.sqrt(12), $955fdf1dc0f8e255$var$a = ($955fdf1dc0f8e255$var$k / 2 + 1) * 3;
var $955fdf1dc0f8e255$export$2e2bcd8739ae039 = {
    draw: function(context, size) {
        var r = Math.sqrt(size / $955fdf1dc0f8e255$var$a), x0 = r / 2, y0 = r * $955fdf1dc0f8e255$var$k, x1 = x0, y1 = r * $955fdf1dc0f8e255$var$k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($955fdf1dc0f8e255$var$c * x0 - $955fdf1dc0f8e255$var$s * y0, $955fdf1dc0f8e255$var$s * x0 + $955fdf1dc0f8e255$var$c * y0);
        context.lineTo($955fdf1dc0f8e255$var$c * x1 - $955fdf1dc0f8e255$var$s * y1, $955fdf1dc0f8e255$var$s * x1 + $955fdf1dc0f8e255$var$c * y1);
        context.lineTo($955fdf1dc0f8e255$var$c * x2 - $955fdf1dc0f8e255$var$s * y2, $955fdf1dc0f8e255$var$s * x2 + $955fdf1dc0f8e255$var$c * y2);
        context.lineTo($955fdf1dc0f8e255$var$c * x0 + $955fdf1dc0f8e255$var$s * y0, $955fdf1dc0f8e255$var$c * y0 - $955fdf1dc0f8e255$var$s * x0);
        context.lineTo($955fdf1dc0f8e255$var$c * x1 + $955fdf1dc0f8e255$var$s * y1, $955fdf1dc0f8e255$var$c * y1 - $955fdf1dc0f8e255$var$s * x1);
        context.lineTo($955fdf1dc0f8e255$var$c * x2 + $955fdf1dc0f8e255$var$s * y2, $955fdf1dc0f8e255$var$c * y2 - $955fdf1dc0f8e255$var$s * x2);
        context.closePath();
    }
};



var $e77bcb1bd810005d$export$47616e9f7f5fe113 = [
    (0, $f2eb04612d9eee52$export$2e2bcd8739ae039),
    (0, $e0818fbcc8c4da59$export$2e2bcd8739ae039),
    (0, $325e7ccb251f7d24$export$2e2bcd8739ae039),
    (0, $85470f2a6152e9a2$export$2e2bcd8739ae039),
    (0, $9cdfa9105343d5ce$export$2e2bcd8739ae039),
    (0, $bc035271c06cfcfe$export$2e2bcd8739ae039),
    (0, $955fdf1dc0f8e255$export$2e2bcd8739ae039)
];
function $e77bcb1bd810005d$export$2e2bcd8739ae039() {
    var type = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)((0, $f2eb04612d9eee52$export$2e2bcd8739ae039)), size = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(64), context = null;
    function symbol() {
        var buffer;
        if (!context) context = buffer = (0, $d29cec310fd417a9$export$2e2bcd8739ae039)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}









function $b57b8314eb5d9d1a$export$2e2bcd8739ae039() {}


function $bfca2baebaf0677e$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $bfca2baebaf0677e$export$957f7263e89bedd2(context) {
    this._context = context;
}
$bfca2baebaf0677e$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $bfca2baebaf0677e$export$105684a3041cb6f3(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                $bfca2baebaf0677e$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $bfca2baebaf0677e$export$2e2bcd8739ae039(context) {
    return new $bfca2baebaf0677e$export$957f7263e89bedd2(context);
}


function $ea99d4d44a1b1e73$var$BasisClosed(context) {
    this._context = context;
}
$ea99d4d44a1b1e73$var$BasisClosed.prototype = {
    areaStart: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    areaEnd: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $bfca2baebaf0677e$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $ea99d4d44a1b1e73$export$2e2bcd8739ae039(context) {
    return new $ea99d4d44a1b1e73$var$BasisClosed(context);
}



function $3655163cb5da08a3$var$BasisOpen(context) {
    this._context = context;
}
$3655163cb5da08a3$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $bfca2baebaf0677e$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $3655163cb5da08a3$export$2e2bcd8739ae039(context) {
    return new $3655163cb5da08a3$var$BasisOpen(context);
}




function $08ba8eb51bf9e0fd$var$Bundle(context, beta) {
    this._basis = new (0, $bfca2baebaf0677e$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$08ba8eb51bf9e0fd$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $08ba8eb51bf9e0fd$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $bfca2baebaf0677e$export$957f7263e89bedd2)(context) : new $08ba8eb51bf9e0fd$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);




var $gGVAG = parcelRequire("gGVAG");
function $d3e3ef1e7b159dbe$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d3e3ef1e7b159dbe$export$da3940d7e9162858.prototype = {
    areaStart: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    areaEnd: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $gGVAG.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d3e3ef1e7b159dbe$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $d3e3ef1e7b159dbe$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $gGVAG = parcelRequire("gGVAG");
function $fabf9642eefd6fd2$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$fabf9642eefd6fd2$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $gGVAG.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $fabf9642eefd6fd2$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $fabf9642eefd6fd2$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);



var $gGVAG = parcelRequire("gGVAG");



var $iBwc3 = parcelRequire("iBwc3");
function $f69c2b0a55fccd00$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f69c2b0a55fccd00$var$CatmullRomClosed.prototype = {
    areaStart: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    areaEnd: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $iBwc3.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f69c2b0a55fccd00$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f69c2b0a55fccd00$var$CatmullRomClosed(context, alpha) : new (0, $d3e3ef1e7b159dbe$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);




var $iBwc3 = parcelRequire("iBwc3");
function $42817e5993c9979d$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$42817e5993c9979d$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, $iBwc3.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $42817e5993c9979d$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $42817e5993c9979d$var$CatmullRomOpen(context, alpha) : new (0, $fabf9642eefd6fd2$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $iBwc3 = parcelRequire("iBwc3");

function $cd9a752fae05e04e$var$LinearClosed(context) {
    this._context = context;
}
$cd9a752fae05e04e$var$LinearClosed.prototype = {
    areaStart: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    areaEnd: (0, $b57b8314eb5d9d1a$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $cd9a752fae05e04e$export$2e2bcd8739ae039(context) {
    return new $cd9a752fae05e04e$var$LinearClosed(context);
}



function $7334f07905a6f760$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $7334f07905a6f760$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($7334f07905a6f760$var$sign(s0) + $7334f07905a6f760$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $7334f07905a6f760$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $7334f07905a6f760$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $7334f07905a6f760$var$MonotoneX(context) {
    this._context = context;
}
$7334f07905a6f760$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $7334f07905a6f760$var$point(this, this._t0, $7334f07905a6f760$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $7334f07905a6f760$var$point(this, $7334f07905a6f760$var$slope2(this, t1 = $7334f07905a6f760$var$slope3(this, x, y)), t1);
                break;
            default:
                $7334f07905a6f760$var$point(this, this._t0, t1 = $7334f07905a6f760$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $7334f07905a6f760$var$MonotoneY(context) {
    this._context = new $7334f07905a6f760$var$ReflectContext(context);
}
($7334f07905a6f760$var$MonotoneY.prototype = Object.create($7334f07905a6f760$var$MonotoneX.prototype)).point = function(x, y) {
    $7334f07905a6f760$var$MonotoneX.prototype.point.call(this, y, x);
};
function $7334f07905a6f760$var$ReflectContext(context) {
    this._context = context;
}
$7334f07905a6f760$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $7334f07905a6f760$export$99563b5420dbdc55(context) {
    return new $7334f07905a6f760$var$MonotoneX(context);
}
function $7334f07905a6f760$export$8b5360456d6bdb88(context) {
    return new $7334f07905a6f760$var$MonotoneY(context);
}


function $93acb1949af219b5$var$Natural(context) {
    this._context = context;
}
$93acb1949af219b5$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $93acb1949af219b5$var$controlPoints(x), py = $93acb1949af219b5$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $93acb1949af219b5$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $93acb1949af219b5$export$2e2bcd8739ae039(context) {
    return new $93acb1949af219b5$var$Natural(context);
}


function $8eb4a79fbb72b037$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$8eb4a79fbb72b037$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $8eb4a79fbb72b037$export$2e2bcd8739ae039(context) {
    return new $8eb4a79fbb72b037$var$Step(context, 0.5);
}
function $8eb4a79fbb72b037$export$10eafa5b7478b343(context) {
    return new $8eb4a79fbb72b037$var$Step(context, 0);
}
function $8eb4a79fbb72b037$export$793b3db073781cbb(context) {
    return new $8eb4a79fbb72b037$var$Step(context, 1);
}




function $2fdb5f999fa3c4e3$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $23a3eaed89d4f53e$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $45308a30d7f4694f$var$stackValue(d, key) {
    return d[key];
}
function $45308a30d7f4694f$export$2e2bcd8739ae039() {
    var keys = (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)([]), order = (0, $23a3eaed89d4f53e$export$2e2bcd8739ae039), offset = (0, $2fdb5f999fa3c4e3$export$2e2bcd8739ae039), value = $45308a30d7f4694f$var$stackValue;
    function stack(data) {
        var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
        for(i = 0; i < n; ++i){
            for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                si[j] = sij = [
                    0,
                    +value(data[j], ki, j, data)
                ];
                sij.data = data[j];
            }
            si.key = ki;
        }
        for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)((0, $d15053515cae7853$export$58adb3bec8346d0f).call(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $23a3eaed89d4f53e$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $bab02431b5ece3c1$export$2e2bcd8739ae039)((0, $d15053515cae7853$export$58adb3bec8346d0f).call(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $2fdb5f999fa3c4e3$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}



function $fd0a1aa5a66cdfda$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $2fdb5f999fa3c4e3$export$2e2bcd8739ae039)(series, order);
}


function $1e5bc5105dd1d784$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = yp;
    }
}




function $66238e05316f8e25$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $2fdb5f999fa3c4e3$export$2e2bcd8739ae039)(series, order);
}



function $657dba241bd55655$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $2fdb5f999fa3c4e3$export$2e2bcd8739ae039)(series, order);
}



function $45ae703d31bc0cbc$export$2e2bcd8739ae039(series) {
    var sums = series.map($45ae703d31bc0cbc$export$8a63f25cc62965f1);
    return (0, $23a3eaed89d4f53e$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $45ae703d31bc0cbc$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}



function $4746512389947435$export$2e2bcd8739ae039(series) {
    return (0, $45ae703d31bc0cbc$export$2e2bcd8739ae039)(series).reverse();
}




function $0d68e9b188fde2f7$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $45ae703d31bc0cbc$export$8a63f25cc62965f1)), order = (0, $23a3eaed89d4f53e$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[b] - sums[a];
    }), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}




function $d9fd0cfc82456287$export$2e2bcd8739ae039(series) {
    return (0, $23a3eaed89d4f53e$export$2e2bcd8739ae039)(series).reverse();
}




var $cad286b12ade0119$var$t0 = new Date, $cad286b12ade0119$var$t1 = new Date;
function $cad286b12ade0119$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = new Date(+date)), date;
    }
    interval.floor = interval;
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $cad286b12ade0119$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $cad286b12ade0119$var$t0.setTime(+start), $cad286b12ade0119$var$t1.setTime(+end);
            floori($cad286b12ade0119$var$t0), floori($cad286b12ade0119$var$t1);
            return Math.floor(count($cad286b12ade0119$var$t0, $cad286b12ade0119$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}



var $75c9cb09a80706a9$var$millisecond = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$75c9cb09a80706a9$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $75c9cb09a80706a9$var$millisecond;
    return (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $75c9cb09a80706a9$export$2e2bcd8739ae039 = $75c9cb09a80706a9$var$millisecond;
var $75c9cb09a80706a9$export$9a27fac83d67afd3 = $75c9cb09a80706a9$var$millisecond.range;



var $b7f267685b5a9116$export$79ef0e34099623dc = 1e3;
var $b7f267685b5a9116$export$683905d551c33fa9 = 6e4;
var $b7f267685b5a9116$export$4157bf0c8e241659 = 36e5;
var $b7f267685b5a9116$export$353686095f4fbf45 = 864e5;
var $b7f267685b5a9116$export$c241eb88520d5016 = 6048e5;


var $55d3c76d56a90878$var$second = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setTime(Math.floor(date / (0, $b7f267685b5a9116$export$79ef0e34099623dc)) * (0, $b7f267685b5a9116$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $b7f267685b5a9116$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $b7f267685b5a9116$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $55d3c76d56a90878$export$2e2bcd8739ae039 = $55d3c76d56a90878$var$second;
var $55d3c76d56a90878$export$4792e48abc550fa1 = $55d3c76d56a90878$var$second.range;




var $a0f8782af29673fa$var$minute = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setTime(Math.floor(date / (0, $b7f267685b5a9116$export$683905d551c33fa9)) * (0, $b7f267685b5a9116$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $b7f267685b5a9116$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $b7f267685b5a9116$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $a0f8782af29673fa$export$2e2bcd8739ae039 = $a0f8782af29673fa$var$minute;
var $a0f8782af29673fa$export$666252b437cce0c7 = $a0f8782af29673fa$var$minute.range;




var $9a26620b5caf7701$var$hour = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    var offset = date.getTimezoneOffset() * (0, $b7f267685b5a9116$export$683905d551c33fa9) % (0, $b7f267685b5a9116$export$4157bf0c8e241659);
    if (offset < 0) offset += (0, $b7f267685b5a9116$export$4157bf0c8e241659);
    date.setTime(Math.floor((+date - offset) / (0, $b7f267685b5a9116$export$4157bf0c8e241659)) * (0, $b7f267685b5a9116$export$4157bf0c8e241659) + offset);
}, function(date, step) {
    date.setTime(+date + step * (0, $b7f267685b5a9116$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $b7f267685b5a9116$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $9a26620b5caf7701$export$2e2bcd8739ae039 = $9a26620b5caf7701$var$hour;
var $9a26620b5caf7701$export$8d468796d69cdad1 = $9a26620b5caf7701$var$hour.range;




var $7ccb9bf514e79d62$var$day = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $b7f267685b5a9116$export$683905d551c33fa9)) / (0, $b7f267685b5a9116$export$353686095f4fbf45);
}, function(date) {
    return date.getDate() - 1;
});
var $7ccb9bf514e79d62$export$2e2bcd8739ae039 = $7ccb9bf514e79d62$var$day;
var $7ccb9bf514e79d62$export$3cf5dda4201cc0f2 = $7ccb9bf514e79d62$var$day.range;




function $7cf7f4784a66ee2f$var$weekday(i) {
    return (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $b7f267685b5a9116$export$683905d551c33fa9)) / (0, $b7f267685b5a9116$export$c241eb88520d5016);
    });
}
var $7cf7f4784a66ee2f$export$fb3ee18ed410cc21 = $7cf7f4784a66ee2f$var$weekday(0);
var $7cf7f4784a66ee2f$export$6416afaab03bc9b8 = $7cf7f4784a66ee2f$var$weekday(1);
var $7cf7f4784a66ee2f$export$cb8f040f5d17ac7b = $7cf7f4784a66ee2f$var$weekday(2);
var $7cf7f4784a66ee2f$export$347581849975dfc8 = $7cf7f4784a66ee2f$var$weekday(3);
var $7cf7f4784a66ee2f$export$2f2b56683a3e5629 = $7cf7f4784a66ee2f$var$weekday(4);
var $7cf7f4784a66ee2f$export$59b8c2ccd931d806 = $7cf7f4784a66ee2f$var$weekday(5);
var $7cf7f4784a66ee2f$export$478ceadebff4d377 = $7cf7f4784a66ee2f$var$weekday(6);
var $7cf7f4784a66ee2f$export$e8daabaa40641211 = $7cf7f4784a66ee2f$export$fb3ee18ed410cc21.range;
var $7cf7f4784a66ee2f$export$74e5b559c235c00e = $7cf7f4784a66ee2f$export$6416afaab03bc9b8.range;
var $7cf7f4784a66ee2f$export$e7d6aa4fb107bc56 = $7cf7f4784a66ee2f$export$cb8f040f5d17ac7b.range;
var $7cf7f4784a66ee2f$export$fcd5880b20bb06a8 = $7cf7f4784a66ee2f$export$347581849975dfc8.range;
var $7cf7f4784a66ee2f$export$682716b7bbe33641 = $7cf7f4784a66ee2f$export$2f2b56683a3e5629.range;
var $7cf7f4784a66ee2f$export$482924968ca86084 = $7cf7f4784a66ee2f$export$59b8c2ccd931d806.range;
var $7cf7f4784a66ee2f$export$7d755172c9cda9d2 = $7cf7f4784a66ee2f$export$478ceadebff4d377.range;



var $28f7e8d10f96189f$var$month = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $28f7e8d10f96189f$export$2e2bcd8739ae039 = $28f7e8d10f96189f$var$month;
var $28f7e8d10f96189f$export$16352d1b10c5eb38 = $28f7e8d10f96189f$var$month.range;



var $4aa3543ac840a4f9$var$year = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$4aa3543ac840a4f9$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $4aa3543ac840a4f9$export$2e2bcd8739ae039 = $4aa3543ac840a4f9$var$year;
var $4aa3543ac840a4f9$export$6fda41c7fb23acf9 = $4aa3543ac840a4f9$var$year.range;




var $6f9bcc9cb0ba8290$var$utcMinute = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $b7f267685b5a9116$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $b7f267685b5a9116$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $6f9bcc9cb0ba8290$export$2e2bcd8739ae039 = $6f9bcc9cb0ba8290$var$utcMinute;
var $6f9bcc9cb0ba8290$export$cedd563624e8ee50 = $6f9bcc9cb0ba8290$var$utcMinute.range;




var $f7db8a18eecec0b4$var$utcHour = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $b7f267685b5a9116$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $b7f267685b5a9116$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $f7db8a18eecec0b4$export$2e2bcd8739ae039 = $f7db8a18eecec0b4$var$utcHour;
var $f7db8a18eecec0b4$export$6e7a76cd5f50b719 = $f7db8a18eecec0b4$var$utcHour.range;




var $c289b0f7e1846fa4$var$utcDay = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $b7f267685b5a9116$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $c289b0f7e1846fa4$export$2e2bcd8739ae039 = $c289b0f7e1846fa4$var$utcDay;
var $c289b0f7e1846fa4$export$d277e198508549a1 = $c289b0f7e1846fa4$var$utcDay.range;




function $4a0b5ecf96a42d66$var$utcWeekday(i) {
    return (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $b7f267685b5a9116$export$c241eb88520d5016);
    });
}
var $4a0b5ecf96a42d66$export$4898b06303a92011 = $4a0b5ecf96a42d66$var$utcWeekday(0);
var $4a0b5ecf96a42d66$export$9cfc53b9cfafd080 = $4a0b5ecf96a42d66$var$utcWeekday(1);
var $4a0b5ecf96a42d66$export$2a6d545f77eceb15 = $4a0b5ecf96a42d66$var$utcWeekday(2);
var $4a0b5ecf96a42d66$export$a5c25d8ed64433c4 = $4a0b5ecf96a42d66$var$utcWeekday(3);
var $4a0b5ecf96a42d66$export$1db08111baec2f53 = $4a0b5ecf96a42d66$var$utcWeekday(4);
var $4a0b5ecf96a42d66$export$29265e34dd5921f7 = $4a0b5ecf96a42d66$var$utcWeekday(5);
var $4a0b5ecf96a42d66$export$85b74dad05049604 = $4a0b5ecf96a42d66$var$utcWeekday(6);
var $4a0b5ecf96a42d66$export$6f3e1c2b0f7d7880 = $4a0b5ecf96a42d66$export$4898b06303a92011.range;
var $4a0b5ecf96a42d66$export$1d2d8b858bb366f9 = $4a0b5ecf96a42d66$export$9cfc53b9cfafd080.range;
var $4a0b5ecf96a42d66$export$1d5f6785fc7f30f8 = $4a0b5ecf96a42d66$export$2a6d545f77eceb15.range;
var $4a0b5ecf96a42d66$export$7a75faf0e37ef4af = $4a0b5ecf96a42d66$export$a5c25d8ed64433c4.range;
var $4a0b5ecf96a42d66$export$417eb959611b2f2f = $4a0b5ecf96a42d66$export$1db08111baec2f53.range;
var $4a0b5ecf96a42d66$export$59d308db7af08c64 = $4a0b5ecf96a42d66$export$29265e34dd5921f7.range;
var $4a0b5ecf96a42d66$export$a124108a0a7f34c8 = $4a0b5ecf96a42d66$export$85b74dad05049604.range;



var $410fa1aeb386cf6b$var$utcMonth = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $410fa1aeb386cf6b$export$2e2bcd8739ae039 = $410fa1aeb386cf6b$var$utcMonth;
var $410fa1aeb386cf6b$export$49159f585997498 = $410fa1aeb386cf6b$var$utcMonth.range;



var $cfeaba02a70a5a3b$var$utcYear = (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$cfeaba02a70a5a3b$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cad286b12ade0119$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $cfeaba02a70a5a3b$export$2e2bcd8739ae039 = $cfeaba02a70a5a3b$var$utcYear;
var $cfeaba02a70a5a3b$export$3e24d311e17f5802 = $cfeaba02a70a5a3b$var$utcYear.range;





function $05fd4cd711ed5057$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $05fd4cd711ed5057$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $05fd4cd711ed5057$var$newYear(y) {
    return {
        y: y,
        m: 0,
        d: 1,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $05fd4cd711ed5057$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $05fd4cd711ed5057$var$formatRe(locale_periods), periodLookup = $05fd4cd711ed5057$var$formatLookup(locale_periods), weekdayRe = $05fd4cd711ed5057$var$formatRe(locale_weekdays), weekdayLookup = $05fd4cd711ed5057$var$formatLookup(locale_weekdays), shortWeekdayRe = $05fd4cd711ed5057$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $05fd4cd711ed5057$var$formatLookup(locale_shortWeekdays), monthRe = $05fd4cd711ed5057$var$formatRe(locale_months), monthLookup = $05fd4cd711ed5057$var$formatLookup(locale_months), shortMonthRe = $05fd4cd711ed5057$var$formatRe(locale_shortMonths), shortMonthLookup = $05fd4cd711ed5057$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $05fd4cd711ed5057$var$formatDayOfMonth,
        "e": $05fd4cd711ed5057$var$formatDayOfMonth,
        "f": $05fd4cd711ed5057$var$formatMicroseconds,
        "H": $05fd4cd711ed5057$var$formatHour24,
        "I": $05fd4cd711ed5057$var$formatHour12,
        "j": $05fd4cd711ed5057$var$formatDayOfYear,
        "L": $05fd4cd711ed5057$var$formatMilliseconds,
        "m": $05fd4cd711ed5057$var$formatMonthNumber,
        "M": $05fd4cd711ed5057$var$formatMinutes,
        "p": formatPeriod,
        "Q": $05fd4cd711ed5057$var$formatUnixTimestamp,
        "s": $05fd4cd711ed5057$var$formatUnixTimestampSeconds,
        "S": $05fd4cd711ed5057$var$formatSeconds,
        "u": $05fd4cd711ed5057$var$formatWeekdayNumberMonday,
        "U": $05fd4cd711ed5057$var$formatWeekNumberSunday,
        "V": $05fd4cd711ed5057$var$formatWeekNumberISO,
        "w": $05fd4cd711ed5057$var$formatWeekdayNumberSunday,
        "W": $05fd4cd711ed5057$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $05fd4cd711ed5057$var$formatYear,
        "Y": $05fd4cd711ed5057$var$formatFullYear,
        "Z": $05fd4cd711ed5057$var$formatZone,
        "%": $05fd4cd711ed5057$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $05fd4cd711ed5057$var$formatUTCDayOfMonth,
        "e": $05fd4cd711ed5057$var$formatUTCDayOfMonth,
        "f": $05fd4cd711ed5057$var$formatUTCMicroseconds,
        "H": $05fd4cd711ed5057$var$formatUTCHour24,
        "I": $05fd4cd711ed5057$var$formatUTCHour12,
        "j": $05fd4cd711ed5057$var$formatUTCDayOfYear,
        "L": $05fd4cd711ed5057$var$formatUTCMilliseconds,
        "m": $05fd4cd711ed5057$var$formatUTCMonthNumber,
        "M": $05fd4cd711ed5057$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "Q": $05fd4cd711ed5057$var$formatUnixTimestamp,
        "s": $05fd4cd711ed5057$var$formatUnixTimestampSeconds,
        "S": $05fd4cd711ed5057$var$formatUTCSeconds,
        "u": $05fd4cd711ed5057$var$formatUTCWeekdayNumberMonday,
        "U": $05fd4cd711ed5057$var$formatUTCWeekNumberSunday,
        "V": $05fd4cd711ed5057$var$formatUTCWeekNumberISO,
        "w": $05fd4cd711ed5057$var$formatUTCWeekdayNumberSunday,
        "W": $05fd4cd711ed5057$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $05fd4cd711ed5057$var$formatUTCYear,
        "Y": $05fd4cd711ed5057$var$formatUTCFullYear,
        "Z": $05fd4cd711ed5057$var$formatUTCZone,
        "%": $05fd4cd711ed5057$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $05fd4cd711ed5057$var$parseDayOfMonth,
        "e": $05fd4cd711ed5057$var$parseDayOfMonth,
        "f": $05fd4cd711ed5057$var$parseMicroseconds,
        "H": $05fd4cd711ed5057$var$parseHour24,
        "I": $05fd4cd711ed5057$var$parseHour24,
        "j": $05fd4cd711ed5057$var$parseDayOfYear,
        "L": $05fd4cd711ed5057$var$parseMilliseconds,
        "m": $05fd4cd711ed5057$var$parseMonthNumber,
        "M": $05fd4cd711ed5057$var$parseMinutes,
        "p": parsePeriod,
        "Q": $05fd4cd711ed5057$var$parseUnixTimestamp,
        "s": $05fd4cd711ed5057$var$parseUnixTimestampSeconds,
        "S": $05fd4cd711ed5057$var$parseSeconds,
        "u": $05fd4cd711ed5057$var$parseWeekdayNumberMonday,
        "U": $05fd4cd711ed5057$var$parseWeekNumberSunday,
        "V": $05fd4cd711ed5057$var$parseWeekNumberISO,
        "w": $05fd4cd711ed5057$var$parseWeekdayNumberSunday,
        "W": $05fd4cd711ed5057$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $05fd4cd711ed5057$var$parseYear,
        "Y": $05fd4cd711ed5057$var$parseFullYear,
        "Z": $05fd4cd711ed5057$var$parseZone,
        "%": $05fd4cd711ed5057$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $05fd4cd711ed5057$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, newDate) {
        return function(string) {
            var d = $05fd4cd711ed5057$var$newYear(1900), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $05fd4cd711ed5057$var$utcDate($05fd4cd711ed5057$var$newYear(d.y)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $b78e53b93ee93fd9$export$9cfc53b9cfafd080).ceil(week) : (0, $b78e53b93ee93fd9$export$9cfc53b9cfafd080)(week);
                    week = (0, $c8ae11bf9d321b24$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = newDate($05fd4cd711ed5057$var$newYear(d.y)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $fe13d34793e7e3a0$export$6416afaab03bc9b8).ceil(week) : (0, $fe13d34793e7e3a0$export$6416afaab03bc9b8)(week);
                    week = (0, $602aff1c99220c6b$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $05fd4cd711ed5057$var$utcDate($05fd4cd711ed5057$var$newYear(d.y)).getUTCDay() : newDate($05fd4cd711ed5057$var$newYear(d.y)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $05fd4cd711ed5057$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return newDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $05fd4cd711ed5057$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", $05fd4cd711ed5057$var$localDate);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier, $05fd4cd711ed5057$var$utcDate);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $05fd4cd711ed5057$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $05fd4cd711ed5057$var$numberRe = /^\s*\d+/, $05fd4cd711ed5057$var$percentRe = /^%/, $05fd4cd711ed5057$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $05fd4cd711ed5057$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $05fd4cd711ed5057$var$requote(s) {
    return s.replace($05fd4cd711ed5057$var$requoteRe, "\\$&");
}
function $05fd4cd711ed5057$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($05fd4cd711ed5057$var$requote).join("|") + ")", "i");
}
function $05fd4cd711ed5057$var$formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function $05fd4cd711ed5057$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseWeekNumberSunday(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseWeekNumberISO(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseWeekNumberMonday(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseFullYear(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseYear(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseMonthNumber(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseDayOfMonth(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseDayOfYear(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseHour24(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseMinutes(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseSeconds(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseMilliseconds(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseMicroseconds(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseLiteralPercent(d, string, i) {
    var n = $05fd4cd711ed5057$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $05fd4cd711ed5057$var$parseUnixTimestamp(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $05fd4cd711ed5057$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0] * 1000, i + n[0].length) : -1;
}
function $05fd4cd711ed5057$var$formatDayOfMonth(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getDate(), p, 2);
}
function $05fd4cd711ed5057$var$formatHour24(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getHours(), p, 2);
}
function $05fd4cd711ed5057$var$formatHour12(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $05fd4cd711ed5057$var$formatDayOfYear(d, p) {
    return $05fd4cd711ed5057$var$pad(1 + (0, $602aff1c99220c6b$export$2e2bcd8739ae039).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $05fd4cd711ed5057$var$formatMilliseconds(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getMilliseconds(), p, 3);
}
function $05fd4cd711ed5057$var$formatMicroseconds(d, p) {
    return $05fd4cd711ed5057$var$formatMilliseconds(d, p) + "000";
}
function $05fd4cd711ed5057$var$formatMonthNumber(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getMonth() + 1, p, 2);
}
function $05fd4cd711ed5057$var$formatMinutes(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getMinutes(), p, 2);
}
function $05fd4cd711ed5057$var$formatSeconds(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getSeconds(), p, 2);
}
function $05fd4cd711ed5057$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $05fd4cd711ed5057$var$formatWeekNumberSunday(d, p) {
    return $05fd4cd711ed5057$var$pad((0, $fe13d34793e7e3a0$export$fb3ee18ed410cc21).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d), d), p, 2);
}
function $05fd4cd711ed5057$var$formatWeekNumberISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $fe13d34793e7e3a0$export$2f2b56683a3e5629)(d) : (0, $fe13d34793e7e3a0$export$2f2b56683a3e5629).ceil(d);
    return $05fd4cd711ed5057$var$pad((0, $fe13d34793e7e3a0$export$2f2b56683a3e5629).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d), d) + ((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $05fd4cd711ed5057$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $05fd4cd711ed5057$var$formatWeekNumberMonday(d, p) {
    return $05fd4cd711ed5057$var$pad((0, $fe13d34793e7e3a0$export$6416afaab03bc9b8).count((0, $1680cba015ceb6d5$export$2e2bcd8739ae039)(d), d), p, 2);
}
function $05fd4cd711ed5057$var$formatYear(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getFullYear() % 100, p, 2);
}
function $05fd4cd711ed5057$var$formatFullYear(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getFullYear() % 10000, p, 4);
}
function $05fd4cd711ed5057$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $05fd4cd711ed5057$var$pad(z / 60 | 0, "0", 2) + $05fd4cd711ed5057$var$pad(z % 60, "0", 2);
}
function $05fd4cd711ed5057$var$formatUTCDayOfMonth(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCDate(), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCHour24(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCHours(), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCHour12(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $05fd4cd711ed5057$var$formatUTCDayOfYear(d, p) {
    return $05fd4cd711ed5057$var$pad(1 + (0, $c8ae11bf9d321b24$export$2e2bcd8739ae039).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $05fd4cd711ed5057$var$formatUTCMilliseconds(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $05fd4cd711ed5057$var$formatUTCMicroseconds(d, p) {
    return $05fd4cd711ed5057$var$formatUTCMilliseconds(d, p) + "000";
}
function $05fd4cd711ed5057$var$formatUTCMonthNumber(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $05fd4cd711ed5057$var$formatUTCMinutes(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCMinutes(), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCSeconds(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCSeconds(), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $05fd4cd711ed5057$var$formatUTCWeekNumberSunday(d, p) {
    return $05fd4cd711ed5057$var$pad((0, $b78e53b93ee93fd9$export$4898b06303a92011).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d), d), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCWeekNumberISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $b78e53b93ee93fd9$export$1db08111baec2f53)(d) : (0, $b78e53b93ee93fd9$export$1db08111baec2f53).ceil(d);
    return $05fd4cd711ed5057$var$pad((0, $b78e53b93ee93fd9$export$1db08111baec2f53).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d), d) + ((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $05fd4cd711ed5057$var$formatUTCWeekNumberMonday(d, p) {
    return $05fd4cd711ed5057$var$pad((0, $b78e53b93ee93fd9$export$9cfc53b9cfafd080).count((0, $91196dc42dd1ff6a$export$2e2bcd8739ae039)(d), d), p, 2);
}
function $05fd4cd711ed5057$var$formatUTCYear(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $05fd4cd711ed5057$var$formatUTCFullYear(d, p) {
    return $05fd4cd711ed5057$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $05fd4cd711ed5057$var$formatUTCZone() {
    return "+0000";
}
function $05fd4cd711ed5057$var$formatLiteralPercent() {
    return "%";
}
function $05fd4cd711ed5057$var$formatUnixTimestamp(d) {
    return +d;
}
function $05fd4cd711ed5057$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $300149578d1222dc$var$locale;
var $300149578d1222dc$export$94f4d87fad5dcf9a;
var $300149578d1222dc$export$32b9cd16e1b8c8d2;
var $300149578d1222dc$export$1a08fe38f63ebbbb;
var $300149578d1222dc$export$3edae9cf8e233729;
$300149578d1222dc$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $300149578d1222dc$export$2e2bcd8739ae039(definition) {
    $300149578d1222dc$var$locale = (0, $05fd4cd711ed5057$export$2e2bcd8739ae039)(definition);
    $300149578d1222dc$export$94f4d87fad5dcf9a = $300149578d1222dc$var$locale.format;
    $300149578d1222dc$export$32b9cd16e1b8c8d2 = $300149578d1222dc$var$locale.parse;
    $300149578d1222dc$export$1a08fe38f63ebbbb = $300149578d1222dc$var$locale.utcFormat;
    $300149578d1222dc$export$3edae9cf8e233729 = $300149578d1222dc$var$locale.utcParse;
    return $300149578d1222dc$var$locale;
}




var $918d322b2b9ea8d0$export$491f7bf2e88d83ce = "%Y-%m-%dT%H:%M:%S.%LZ";
function $918d322b2b9ea8d0$var$formatIsoNative(date) {
    return date.toISOString();
}
var $918d322b2b9ea8d0$var$formatIso = Date.prototype.toISOString ? $918d322b2b9ea8d0$var$formatIsoNative : (0, $300149578d1222dc$export$1a08fe38f63ebbbb)($918d322b2b9ea8d0$export$491f7bf2e88d83ce);
var $918d322b2b9ea8d0$export$2e2bcd8739ae039 = $918d322b2b9ea8d0$var$formatIso;




function $7b9d89a84cf8d954$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $7b9d89a84cf8d954$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $7b9d89a84cf8d954$var$parseIsoNative : (0, $300149578d1222dc$export$3edae9cf8e233729)((0, $918d322b2b9ea8d0$export$491f7bf2e88d83ce));
var $7b9d89a84cf8d954$export$2e2bcd8739ae039 = $7b9d89a84cf8d954$var$parseIso;




var $cb401f23b167b404$var$frame = 0, $cb401f23b167b404$var$timeout = 0, $cb401f23b167b404$var$interval = 0, $cb401f23b167b404$var$pokeDelay = 1000, $cb401f23b167b404$var$taskHead, $cb401f23b167b404$var$taskTail, $cb401f23b167b404$var$clockLast = 0, $cb401f23b167b404$var$clockNow = 0, $cb401f23b167b404$var$clockSkew = 0, $cb401f23b167b404$var$clock = typeof performance === "object" && performance.now ? performance : Date, $cb401f23b167b404$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $cb401f23b167b404$export$461939dd4422153() {
    return $cb401f23b167b404$var$clockNow || ($cb401f23b167b404$var$setFrame($cb401f23b167b404$var$clearNow), $cb401f23b167b404$var$clockNow = $cb401f23b167b404$var$clock.now() + $cb401f23b167b404$var$clockSkew);
}
function $cb401f23b167b404$var$clearNow() {
    $cb401f23b167b404$var$clockNow = 0;
}
function $cb401f23b167b404$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$cb401f23b167b404$export$c57e9b2d8b9e4de.prototype = $cb401f23b167b404$export$9dc4ecf953986f04.prototype = {
    constructor: $cb401f23b167b404$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $cb401f23b167b404$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $cb401f23b167b404$var$taskTail !== this) {
            if ($cb401f23b167b404$var$taskTail) $cb401f23b167b404$var$taskTail._next = this;
            else $cb401f23b167b404$var$taskHead = this;
            $cb401f23b167b404$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $cb401f23b167b404$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $cb401f23b167b404$var$sleep();
        }
    }
};
function $cb401f23b167b404$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $cb401f23b167b404$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $cb401f23b167b404$export$d60154c1d7f3990e() {
    $cb401f23b167b404$export$461939dd4422153(); // Get the current time, if not already set.
    ++$cb401f23b167b404$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $cb401f23b167b404$var$taskHead, e;
    while(t){
        if ((e = $cb401f23b167b404$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$cb401f23b167b404$var$frame;
}
function $cb401f23b167b404$var$wake() {
    $cb401f23b167b404$var$clockNow = ($cb401f23b167b404$var$clockLast = $cb401f23b167b404$var$clock.now()) + $cb401f23b167b404$var$clockSkew;
    $cb401f23b167b404$var$frame = $cb401f23b167b404$var$timeout = 0;
    try {
        $cb401f23b167b404$export$d60154c1d7f3990e();
    } finally{
        $cb401f23b167b404$var$frame = 0;
        $cb401f23b167b404$var$nap();
        $cb401f23b167b404$var$clockNow = 0;
    }
}
function $cb401f23b167b404$var$poke() {
    var now = $cb401f23b167b404$var$clock.now(), delay = now - $cb401f23b167b404$var$clockLast;
    if (delay > $cb401f23b167b404$var$pokeDelay) $cb401f23b167b404$var$clockSkew -= delay, $cb401f23b167b404$var$clockLast = now;
}
function $cb401f23b167b404$var$nap() {
    var t0, t1 = $cb401f23b167b404$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $cb401f23b167b404$var$taskHead = t2;
    }
    $cb401f23b167b404$var$taskTail = t0;
    $cb401f23b167b404$var$sleep(time);
}
function $cb401f23b167b404$var$sleep(time) {
    if ($cb401f23b167b404$var$frame) return; // Soonest alarm already set, or will be.
    if ($cb401f23b167b404$var$timeout) $cb401f23b167b404$var$timeout = clearTimeout($cb401f23b167b404$var$timeout);
    var delay = time - $cb401f23b167b404$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $cb401f23b167b404$var$timeout = setTimeout($cb401f23b167b404$var$wake, time - $cb401f23b167b404$var$clock.now() - $cb401f23b167b404$var$clockSkew);
        if ($cb401f23b167b404$var$interval) $cb401f23b167b404$var$interval = clearInterval($cb401f23b167b404$var$interval);
    } else {
        if (!$cb401f23b167b404$var$interval) $cb401f23b167b404$var$clockLast = $cb401f23b167b404$var$clock.now(), $cb401f23b167b404$var$interval = setInterval($cb401f23b167b404$var$poke, $cb401f23b167b404$var$pokeDelay);
        $cb401f23b167b404$var$frame = 1, $cb401f23b167b404$var$setFrame($cb401f23b167b404$var$wake);
    }
}



function $887be21395ce88c4$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $cb401f23b167b404$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}



function $195ff76615c1ca2e$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $cb401f23b167b404$export$c57e9b2d8b9e4de), total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    delay = +delay, time = time == null ? (0, $cb401f23b167b404$export$461939dd4422153)() : +time;
    t.restart(function tick(elapsed) {
        elapsed += total;
        t.restart(tick, total += delay, time);
        callback(elapsed);
    }, delay, time);
    return t;
}





function $a4b8b148ad40cff6$var$none() {}
function $a4b8b148ad40cff6$export$2e2bcd8739ae039(selector) {
    return selector == null ? $a4b8b148ad40cff6$var$none : function() {
        return this.querySelector(selector);
    };
}


function $e63e73549c047c56$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $a4b8b148ad40cff6$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(subgroups, this._parents);
}



function $1617ed3f33f464b8$var$empty() {
    return [];
}
function $1617ed3f33f464b8$export$2e2bcd8739ae039(selector) {
    return selector == null ? $1617ed3f33f464b8$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $bdbd06a782fc9b59$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $1617ed3f33f464b8$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(subgroups, parents);
}



function $1de11c01fba96121$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}


function $0a7481bc346d0a3a$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $1de11c01fba96121$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(subgroups, this._parents);
}



function $131117fa030763f8$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $282e51f2abb5c765$export$2e2bcd8739ae039() {
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(this._enter || this._groups.map((0, $131117fa030763f8$export$2e2bcd8739ae039)), this._parents);
}
function $282e51f2abb5c765$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$282e51f2abb5c765$export$67b01759a14cf6a4.prototype = {
    constructor: $282e51f2abb5c765$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d6a7c2136d8cbc9b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


var $36349b49096ebb81$var$keyPrefix = "$"; // Protect against keys like “__proto__”.
function $36349b49096ebb81$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $282e51f2abb5c765$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $36349b49096ebb81$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = $36349b49096ebb81$var$keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = $36349b49096ebb81$var$keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, $282e51f2abb5c765$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}
function $36349b49096ebb81$export$2e2bcd8739ae039(value, key) {
    if (!value) {
        data = new Array(this.size()), j = -1;
        this.each(function(d) {
            data[++j] = d;
        });
        return data;
    }
    var bind = key ? $36349b49096ebb81$var$bindKey : $36349b49096ebb81$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d6a7c2136d8cbc9b$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}





function $ec7ecb9b8e5abd62$export$2e2bcd8739ae039() {
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(this._exit || this._groups.map((0, $131117fa030763f8$export$2e2bcd8739ae039)), this._parents);
}


function $94afc12be22e41d8$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $71158ac35b1e0d18$export$2e2bcd8739ae039(selection) {
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(merges, this._parents);
}


function $5c16a5988fdecf02$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $5a9072d204c8403d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $5a9072d204c8403d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $ac042f6d8fade9df$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $5a9072d204c8403d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $805fde96badd95ef$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $5b99e2948b30461d$export$2e2bcd8739ae039() {
    var nodes = new Array(this.size()), i = -1;
    this.each(function() {
        nodes[++i] = this;
    });
    return nodes;
}


function $a62f261090858a1b$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $6c2feecb58beb49e$export$2e2bcd8739ae039() {
    var size = 0;
    this.each(function() {
        ++size;
    });
    return size;
}


function $d22f738fd21bbdae$export$2e2bcd8739ae039() {
    return !this.node();
}


function $0a1318434f92c87f$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $c0435a0b38f59bde$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $c0435a0b38f59bde$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $c0435a0b38f59bde$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $70fbad3460829634$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $c0435a0b38f59bde$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $c0435a0b38f59bde$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name;
}


function $f983ba0ccfb7c97c$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $f983ba0ccfb7c97c$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $f983ba0ccfb7c97c$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $f983ba0ccfb7c97c$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $f983ba0ccfb7c97c$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $f983ba0ccfb7c97c$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $f983ba0ccfb7c97c$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $70fbad3460829634$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $f983ba0ccfb7c97c$var$attrRemoveNS : $f983ba0ccfb7c97c$var$attrRemove : typeof value === "function" ? fullname.local ? $f983ba0ccfb7c97c$var$attrFunctionNS : $f983ba0ccfb7c97c$var$attrFunction : fullname.local ? $f983ba0ccfb7c97c$var$attrConstantNS : $f983ba0ccfb7c97c$var$attrConstant)(fullname, value));
}


function $a991e06b6a2e297d$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $f466d4f748796511$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $f466d4f748796511$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $f466d4f748796511$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $f466d4f748796511$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $f466d4f748796511$var$styleRemove : typeof value === "function" ? $f466d4f748796511$var$styleFunction : $f466d4f748796511$var$styleConstant)(name, value, priority == null ? "" : priority)) : $f466d4f748796511$export$5e3cec964f0b5efd(this.node(), name);
}
function $f466d4f748796511$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $a991e06b6a2e297d$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $8e3eb941cee51bef$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $8e3eb941cee51bef$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $8e3eb941cee51bef$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $8e3eb941cee51bef$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $8e3eb941cee51bef$var$propertyRemove : typeof value === "function" ? $8e3eb941cee51bef$var$propertyFunction : $8e3eb941cee51bef$var$propertyConstant)(name, value)) : this.node()[name];
}


function $1049c69631a071fc$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $1049c69631a071fc$var$classList(node) {
    return node.classList || new $1049c69631a071fc$var$ClassList(node);
}
function $1049c69631a071fc$var$ClassList(node) {
    this._node = node;
    this._names = $1049c69631a071fc$var$classArray(node.getAttribute("class") || "");
}
$1049c69631a071fc$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $1049c69631a071fc$var$classedAdd(node, names) {
    var list = $1049c69631a071fc$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $1049c69631a071fc$var$classedRemove(node, names) {
    var list = $1049c69631a071fc$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $1049c69631a071fc$var$classedTrue(names) {
    return function() {
        $1049c69631a071fc$var$classedAdd(this, names);
    };
}
function $1049c69631a071fc$var$classedFalse(names) {
    return function() {
        $1049c69631a071fc$var$classedRemove(this, names);
    };
}
function $1049c69631a071fc$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $1049c69631a071fc$var$classedAdd : $1049c69631a071fc$var$classedRemove)(this, names);
    };
}
function $1049c69631a071fc$export$2e2bcd8739ae039(name, value) {
    var names = $1049c69631a071fc$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $1049c69631a071fc$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $1049c69631a071fc$var$classedFunction : value ? $1049c69631a071fc$var$classedTrue : $1049c69631a071fc$var$classedFalse)(names, value));
}


function $45eb8421e074242f$var$textRemove() {
    this.textContent = "";
}
function $45eb8421e074242f$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $45eb8421e074242f$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $45eb8421e074242f$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $45eb8421e074242f$var$textRemove : (typeof value === "function" ? $45eb8421e074242f$var$textFunction : $45eb8421e074242f$var$textConstant)(value)) : this.node().textContent;
}


function $594cdd5ba552c854$var$htmlRemove() {
    this.innerHTML = "";
}
function $594cdd5ba552c854$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $594cdd5ba552c854$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $594cdd5ba552c854$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $594cdd5ba552c854$var$htmlRemove : (typeof value === "function" ? $594cdd5ba552c854$var$htmlFunction : $594cdd5ba552c854$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $718f1c4546b1acc2$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $718f1c4546b1acc2$export$2e2bcd8739ae039() {
    return this.each($718f1c4546b1acc2$var$raise);
}


function $4e6ad2b85fcd01aa$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4e6ad2b85fcd01aa$export$2e2bcd8739ae039() {
    return this.each($4e6ad2b85fcd01aa$var$lower);
}




function $31ac8c171710a671$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $c0435a0b38f59bde$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $c0435a0b38f59bde$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $31ac8c171710a671$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $31ac8c171710a671$export$2e2bcd8739ae039(name) {
    var fullname = (0, $70fbad3460829634$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $31ac8c171710a671$var$creatorFixed : $31ac8c171710a671$var$creatorInherit)(fullname);
}


function $2365f74379a52018$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $31ac8c171710a671$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $24550ced0704d26a$var$constantNull() {
    return null;
}
function $24550ced0704d26a$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $31ac8c171710a671$export$2e2bcd8739ae039)(name), select = before == null ? $24550ced0704d26a$var$constantNull : typeof before === "function" ? before : (0, $a4b8b148ad40cff6$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d5af824158ade6e6$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d5af824158ade6e6$export$2e2bcd8739ae039() {
    return this.each($d5af824158ade6e6$var$remove);
}


function $7ef355c8cdc57f68$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $7ef355c8cdc57f68$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $7ef355c8cdc57f68$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $7ef355c8cdc57f68$var$selection_cloneDeep : $7ef355c8cdc57f68$var$selection_cloneShallow);
}


function $3483c6112bc4c713$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


var $c3d405d44c70a482$var$filterEvents = {};
var $c3d405d44c70a482$export$6cd530ed55e06764 = null;
if (typeof document !== "undefined") {
    var $c3d405d44c70a482$var$element = document.documentElement;
    if (!("onmouseenter" in $c3d405d44c70a482$var$element)) $c3d405d44c70a482$var$filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function $c3d405d44c70a482$var$filterContextListener(listener, index, group) {
    listener = $c3d405d44c70a482$var$contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function $c3d405d44c70a482$var$contextListener(listener, index, group) {
    return function(event1) {
        var event0 = $c3d405d44c70a482$export$6cd530ed55e06764; // Events can be reentrant (e.g., focus).
        $c3d405d44c70a482$export$6cd530ed55e06764 = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            $c3d405d44c70a482$export$6cd530ed55e06764 = event0;
        }
    };
}
function $c3d405d44c70a482$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $c3d405d44c70a482$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $c3d405d44c70a482$var$onAdd(typename, value, capture) {
    var wrap = $c3d405d44c70a482$var$filterEvents.hasOwnProperty(typename.type) ? $c3d405d44c70a482$var$filterContextListener : $c3d405d44c70a482$var$contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $c3d405d44c70a482$export$2e2bcd8739ae039(typename, value, capture) {
    var typenames = $c3d405d44c70a482$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $c3d405d44c70a482$var$onAdd : $c3d405d44c70a482$var$onRemove;
    if (capture == null) capture = false;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
    return this;
}
function $c3d405d44c70a482$export$4c724631b4750aef(event1, listener, that, args) {
    var event0 = $c3d405d44c70a482$export$6cd530ed55e06764;
    event1.sourceEvent = $c3d405d44c70a482$export$6cd530ed55e06764;
    $c3d405d44c70a482$export$6cd530ed55e06764 = event1;
    try {
        return listener.apply(that, args);
    } finally{
        $c3d405d44c70a482$export$6cd530ed55e06764 = event0;
    }
}



function $1c03df71124fa48d$var$dispatchEvent(node, type, params) {
    var window = (0, $a991e06b6a2e297d$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $1c03df71124fa48d$var$dispatchConstant(type, params) {
    return function() {
        return $1c03df71124fa48d$var$dispatchEvent(this, type, params);
    };
}
function $1c03df71124fa48d$var$dispatchFunction(type, params) {
    return function() {
        return $1c03df71124fa48d$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $1c03df71124fa48d$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $1c03df71124fa48d$var$dispatchFunction : $1c03df71124fa48d$var$dispatchConstant)(type, params));
}


var $ac042f6d8fade9df$export$e8e78c978b129247 = [
    null
];
function $ac042f6d8fade9df$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $ac042f6d8fade9df$var$selection() {
    return new $ac042f6d8fade9df$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $ac042f6d8fade9df$export$e8e78c978b129247);
}
$ac042f6d8fade9df$export$52baac22726c72bf.prototype = $ac042f6d8fade9df$var$selection.prototype = {
    constructor: $ac042f6d8fade9df$export$52baac22726c72bf,
    select: (0, $e63e73549c047c56$export$2e2bcd8739ae039),
    selectAll: (0, $bdbd06a782fc9b59$export$2e2bcd8739ae039),
    filter: (0, $0a7481bc346d0a3a$export$2e2bcd8739ae039),
    data: (0, $36349b49096ebb81$export$2e2bcd8739ae039),
    enter: (0, $282e51f2abb5c765$export$2e2bcd8739ae039),
    exit: (0, $ec7ecb9b8e5abd62$export$2e2bcd8739ae039),
    join: (0, $94afc12be22e41d8$export$2e2bcd8739ae039),
    merge: (0, $71158ac35b1e0d18$export$2e2bcd8739ae039),
    order: (0, $5c16a5988fdecf02$export$2e2bcd8739ae039),
    sort: (0, $5a9072d204c8403d$export$2e2bcd8739ae039),
    call: (0, $805fde96badd95ef$export$2e2bcd8739ae039),
    nodes: (0, $5b99e2948b30461d$export$2e2bcd8739ae039),
    node: (0, $a62f261090858a1b$export$2e2bcd8739ae039),
    size: (0, $6c2feecb58beb49e$export$2e2bcd8739ae039),
    empty: (0, $d22f738fd21bbdae$export$2e2bcd8739ae039),
    each: (0, $0a1318434f92c87f$export$2e2bcd8739ae039),
    attr: (0, $f983ba0ccfb7c97c$export$2e2bcd8739ae039),
    style: (0, $f466d4f748796511$export$2e2bcd8739ae039),
    property: (0, $8e3eb941cee51bef$export$2e2bcd8739ae039),
    classed: (0, $1049c69631a071fc$export$2e2bcd8739ae039),
    text: (0, $45eb8421e074242f$export$2e2bcd8739ae039),
    html: (0, $594cdd5ba552c854$export$2e2bcd8739ae039),
    raise: (0, $718f1c4546b1acc2$export$2e2bcd8739ae039),
    lower: (0, $4e6ad2b85fcd01aa$export$2e2bcd8739ae039),
    append: (0, $2365f74379a52018$export$2e2bcd8739ae039),
    insert: (0, $24550ced0704d26a$export$2e2bcd8739ae039),
    remove: (0, $d5af824158ade6e6$export$2e2bcd8739ae039),
    clone: (0, $7ef355c8cdc57f68$export$2e2bcd8739ae039),
    datum: (0, $3483c6112bc4c713$export$2e2bcd8739ae039),
    on: (0, $c3d405d44c70a482$export$2e2bcd8739ae039),
    dispatch: (0, $1c03df71124fa48d$export$2e2bcd8739ae039)
};
var $ac042f6d8fade9df$export$2e2bcd8739ae039 = $ac042f6d8fade9df$var$selection;


var $ca0b49e66c7ba6ed$var$noop = {
    value: function() {}
};
function $ca0b49e66c7ba6ed$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $ca0b49e66c7ba6ed$var$Dispatch(_);
}
function $ca0b49e66c7ba6ed$var$Dispatch(_) {
    this._ = _;
}
function $ca0b49e66c7ba6ed$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$ca0b49e66c7ba6ed$var$Dispatch.prototype = $ca0b49e66c7ba6ed$var$dispatch.prototype = {
    constructor: $ca0b49e66c7ba6ed$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $ca0b49e66c7ba6ed$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $ca0b49e66c7ba6ed$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $ca0b49e66c7ba6ed$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $ca0b49e66c7ba6ed$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $ca0b49e66c7ba6ed$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $ca0b49e66c7ba6ed$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $ca0b49e66c7ba6ed$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $ca0b49e66c7ba6ed$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $ca0b49e66c7ba6ed$export$2e2bcd8739ae039 = $ca0b49e66c7ba6ed$var$dispatch;


var $f3386654ea4b70d8$var$frame = 0, $f3386654ea4b70d8$var$timeout = 0, $f3386654ea4b70d8$var$interval = 0, $f3386654ea4b70d8$var$pokeDelay = 1000, $f3386654ea4b70d8$var$taskHead, $f3386654ea4b70d8$var$taskTail, $f3386654ea4b70d8$var$clockLast = 0, $f3386654ea4b70d8$var$clockNow = 0, $f3386654ea4b70d8$var$clockSkew = 0, $f3386654ea4b70d8$var$clock = typeof performance === "object" && performance.now ? performance : Date, $f3386654ea4b70d8$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $f3386654ea4b70d8$export$461939dd4422153() {
    return $f3386654ea4b70d8$var$clockNow || ($f3386654ea4b70d8$var$setFrame($f3386654ea4b70d8$var$clearNow), $f3386654ea4b70d8$var$clockNow = $f3386654ea4b70d8$var$clock.now() + $f3386654ea4b70d8$var$clockSkew);
}
function $f3386654ea4b70d8$var$clearNow() {
    $f3386654ea4b70d8$var$clockNow = 0;
}
function $f3386654ea4b70d8$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$f3386654ea4b70d8$export$c57e9b2d8b9e4de.prototype = $f3386654ea4b70d8$export$9dc4ecf953986f04.prototype = {
    constructor: $f3386654ea4b70d8$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $f3386654ea4b70d8$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $f3386654ea4b70d8$var$taskTail !== this) {
            if ($f3386654ea4b70d8$var$taskTail) $f3386654ea4b70d8$var$taskTail._next = this;
            else $f3386654ea4b70d8$var$taskHead = this;
            $f3386654ea4b70d8$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $f3386654ea4b70d8$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $f3386654ea4b70d8$var$sleep();
        }
    }
};
function $f3386654ea4b70d8$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $f3386654ea4b70d8$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $f3386654ea4b70d8$export$d60154c1d7f3990e() {
    $f3386654ea4b70d8$export$461939dd4422153(); // Get the current time, if not already set.
    ++$f3386654ea4b70d8$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $f3386654ea4b70d8$var$taskHead, e;
    while(t){
        if ((e = $f3386654ea4b70d8$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$f3386654ea4b70d8$var$frame;
}
function $f3386654ea4b70d8$var$wake() {
    $f3386654ea4b70d8$var$clockNow = ($f3386654ea4b70d8$var$clockLast = $f3386654ea4b70d8$var$clock.now()) + $f3386654ea4b70d8$var$clockSkew;
    $f3386654ea4b70d8$var$frame = $f3386654ea4b70d8$var$timeout = 0;
    try {
        $f3386654ea4b70d8$export$d60154c1d7f3990e();
    } finally{
        $f3386654ea4b70d8$var$frame = 0;
        $f3386654ea4b70d8$var$nap();
        $f3386654ea4b70d8$var$clockNow = 0;
    }
}
function $f3386654ea4b70d8$var$poke() {
    var now = $f3386654ea4b70d8$var$clock.now(), delay = now - $f3386654ea4b70d8$var$clockLast;
    if (delay > $f3386654ea4b70d8$var$pokeDelay) $f3386654ea4b70d8$var$clockSkew -= delay, $f3386654ea4b70d8$var$clockLast = now;
}
function $f3386654ea4b70d8$var$nap() {
    var t0, t1 = $f3386654ea4b70d8$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $f3386654ea4b70d8$var$taskHead = t2;
    }
    $f3386654ea4b70d8$var$taskTail = t0;
    $f3386654ea4b70d8$var$sleep(time);
}
function $f3386654ea4b70d8$var$sleep(time) {
    if ($f3386654ea4b70d8$var$frame) return; // Soonest alarm already set, or will be.
    if ($f3386654ea4b70d8$var$timeout) $f3386654ea4b70d8$var$timeout = clearTimeout($f3386654ea4b70d8$var$timeout);
    var delay = time - $f3386654ea4b70d8$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $f3386654ea4b70d8$var$timeout = setTimeout($f3386654ea4b70d8$var$wake, time - $f3386654ea4b70d8$var$clock.now() - $f3386654ea4b70d8$var$clockSkew);
        if ($f3386654ea4b70d8$var$interval) $f3386654ea4b70d8$var$interval = clearInterval($f3386654ea4b70d8$var$interval);
    } else {
        if (!$f3386654ea4b70d8$var$interval) $f3386654ea4b70d8$var$clockLast = $f3386654ea4b70d8$var$clock.now(), $f3386654ea4b70d8$var$interval = setInterval($f3386654ea4b70d8$var$poke, $f3386654ea4b70d8$var$pokeDelay);
        $f3386654ea4b70d8$var$frame = 1, $f3386654ea4b70d8$var$setFrame($f3386654ea4b70d8$var$wake);
    }
}


function $c03e8e1834a5220e$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $f3386654ea4b70d8$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $d9a85b4328712ebb$var$emptyOn = (0, $ca0b49e66c7ba6ed$export$2e2bcd8739ae039)("start", "end", "interrupt");
var $d9a85b4328712ebb$var$emptyTween = [];
var $d9a85b4328712ebb$export$ff39ebd4bb12b718 = 0;
var $d9a85b4328712ebb$export$584530fe98d14a84 = 1;
var $d9a85b4328712ebb$export$a5d151aee16efd42 = 2;
var $d9a85b4328712ebb$export$fb935ab5849a0db9 = 3;
var $d9a85b4328712ebb$export$1573e22b087389af = 4;
var $d9a85b4328712ebb$export$a2e792214ded83b2 = 5;
var $d9a85b4328712ebb$export$9d38167254403955 = 6;
function $d9a85b4328712ebb$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $d9a85b4328712ebb$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $d9a85b4328712ebb$var$emptyOn,
        tween: $d9a85b4328712ebb$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $d9a85b4328712ebb$export$ff39ebd4bb12b718
    });
}
function $d9a85b4328712ebb$export$2cd8252107eb640b(node, id) {
    var schedule = $d9a85b4328712ebb$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $d9a85b4328712ebb$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $d9a85b4328712ebb$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $d9a85b4328712ebb$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $d9a85b4328712ebb$export$a5d151aee16efd42) throw new Error("too late; already started");
    return schedule;
}
function $d9a85b4328712ebb$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $d9a85b4328712ebb$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $f3386654ea4b70d8$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $d9a85b4328712ebb$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $d9a85b4328712ebb$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $d9a85b4328712ebb$export$fb935ab5849a0db9) return (0, $c03e8e1834a5220e$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            // Dispatch the interrupt event.
            if (o.state === $d9a85b4328712ebb$export$1573e22b087389af) {
                o.state = $d9a85b4328712ebb$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $d9a85b4328712ebb$export$9d38167254403955;
                o.timer.stop();
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $c03e8e1834a5220e$export$2e2bcd8739ae039)(function() {
            if (self.state === $d9a85b4328712ebb$export$fb935ab5849a0db9) {
                self.state = $d9a85b4328712ebb$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $d9a85b4328712ebb$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $d9a85b4328712ebb$export$a5d151aee16efd42) return; // interrupted
        self.state = $d9a85b4328712ebb$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $d9a85b4328712ebb$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(null, t);
        // Dispatch the end event.
        if (self.state === $d9a85b4328712ebb$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $d9a85b4328712ebb$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $055e2dd61e030f90$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $d9a85b4328712ebb$export$a5d151aee16efd42) && schedule.state < (0, $d9a85b4328712ebb$export$a2e792214ded83b2);
        schedule.state = (0, $d9a85b4328712ebb$export$9d38167254403955);
        schedule.timer.stop();
        if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $afbb32d24ac5bc4b$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $055e2dd61e030f90$export$2e2bcd8739ae039)(this, name);
    });
}



function $1d9e788570856c5d$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $9aae43e1cd2dd9f4$var$degrees = 180 / Math.PI;
var $9aae43e1cd2dd9f4$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $9aae43e1cd2dd9f4$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $9aae43e1cd2dd9f4$var$degrees,
        skewX: Math.atan(skewX) * $9aae43e1cd2dd9f4$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $0c8546b72a20168a$var$cssNode, $0c8546b72a20168a$var$cssRoot, $0c8546b72a20168a$var$cssView, $0c8546b72a20168a$var$svgNode;
function $0c8546b72a20168a$export$59ad369bf4938177(value) {
    if (value === "none") return 0, $9aae43e1cd2dd9f4$export$f0954fd7d5368655;
    if (!$0c8546b72a20168a$var$cssNode) $0c8546b72a20168a$var$cssNode = document.createElement("DIV"), $0c8546b72a20168a$var$cssRoot = document.documentElement, $0c8546b72a20168a$var$cssView = document.defaultView;
    $0c8546b72a20168a$var$cssNode.style.transform = value;
    value = $0c8546b72a20168a$var$cssView.getComputedStyle($0c8546b72a20168a$var$cssRoot.appendChild($0c8546b72a20168a$var$cssNode), null).getPropertyValue("transform");
    $0c8546b72a20168a$var$cssRoot.removeChild($0c8546b72a20168a$var$cssNode);
    value = value.slice(7, -1).split(",");
    return (0, $9aae43e1cd2dd9f4$export$2e2bcd8739ae039)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function $0c8546b72a20168a$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $9aae43e1cd2dd9f4$export$f0954fd7d5368655;
    if (!$0c8546b72a20168a$var$svgNode) $0c8546b72a20168a$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $0c8546b72a20168a$var$svgNode.setAttribute("transform", value);
    if (!(value = $0c8546b72a20168a$var$svgNode.transform.baseVal.consolidate())) return 0, $9aae43e1cd2dd9f4$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $9aae43e1cd2dd9f4$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $ce010af1b9c75424$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $ce010af1b9c75424$export$56bec7123bb3589a = $ce010af1b9c75424$var$interpolateTransform((0, $0c8546b72a20168a$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $ce010af1b9c75424$export$da8cba906d64c082 = $ce010af1b9c75424$var$interpolateTransform((0, $0c8546b72a20168a$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $62731c8cf5cc1d82$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $62731c8cf5cc1d82$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $62731c8cf5cc1d82$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $62731c8cf5cc1d82$var$tweenRemove : $62731c8cf5cc1d82$var$tweenFunction)(id, name, value));
}
function $62731c8cf5cc1d82$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $hp6is = parcelRequire("hp6is");

var $hp6is = parcelRequire("hp6is");
function $6e9ac62a2f40b7c2$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $6e9ac62a2f40b7c2$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $6e9ac62a2f40b7c2$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $719f72706372126e$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $6e9ac62a2f40b7c2$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


function $9fcf8f16944170c0$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $202d2aa7d834d724$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $202d2aa7d834d724$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $202d2aa7d834d724$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $202d2aa7d834d724$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $9fcf8f16944170c0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $202d2aa7d834d724$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $202d2aa7d834d724$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $202d2aa7d834d724$var$exponential(a, b, y) : (0, $9fcf8f16944170c0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $202d2aa7d834d724$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $202d2aa7d834d724$var$linear(a, d) : (0, $9fcf8f16944170c0$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $9db629cf58f27bbe$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $202d2aa7d834d724$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $hp6is.rgb)(start)).r, (end = (0, $hp6is.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $202d2aa7d834d724$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $9db629cf58f27bbe$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $hp6is.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9db629cf58f27bbe$export$2c0e28f2e2852d3f = $9db629cf58f27bbe$var$rgbSpline((0, $6e9ac62a2f40b7c2$export$2e2bcd8739ae039));
var $9db629cf58f27bbe$export$53d5214f625ccd4c = $9db629cf58f27bbe$var$rgbSpline((0, $719f72706372126e$export$2e2bcd8739ae039));


var $09f722cd28d64c92$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $09f722cd28d64c92$var$reB = new RegExp($09f722cd28d64c92$var$reA.source, "g");
function $09f722cd28d64c92$var$zero(b) {
    return function() {
        return b;
    };
}
function $09f722cd28d64c92$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $09f722cd28d64c92$export$2e2bcd8739ae039(a, b) {
    var bi = $09f722cd28d64c92$var$reA.lastIndex = $09f722cd28d64c92$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $09f722cd28d64c92$var$reA.exec(a)) && (bm = $09f722cd28d64c92$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $1d9e788570856c5d$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $09f722cd28d64c92$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $09f722cd28d64c92$var$one(q[0].x) : $09f722cd28d64c92$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}


function $df95a8695595cc23$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $1d9e788570856c5d$export$2e2bcd8739ae039) : b instanceof (0, $hp6is.default) ? (0, $9db629cf58f27bbe$export$2e2bcd8739ae039) : (c = (0, $hp6is.default)(b)) ? (b = c, $9db629cf58f27bbe$export$2e2bcd8739ae039) : (0, $09f722cd28d64c92$export$2e2bcd8739ae039))(a, b);
}


function $70038d959ef07234$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $70038d959ef07234$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $70038d959ef07234$var$attrConstant(name, interpolate, value1) {
    var value00, interpolate0;
    return function() {
        var value0 = this.getAttribute(name);
        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
    };
}
function $70038d959ef07234$var$attrConstantNS(fullname, interpolate, value1) {
    var value00, interpolate0;
    return function() {
        var value0 = this.getAttributeNS(fullname.space, fullname.local);
        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
    };
}
function $70038d959ef07234$var$attrFunction(name, interpolate, value) {
    var value00, value10, interpolate0;
    return function() {
        var value0, value1 = value(this);
        if (value1 == null) return void this.removeAttribute(name);
        value0 = this.getAttribute(name);
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $70038d959ef07234$var$attrFunctionNS(fullname, interpolate, value) {
    var value00, value10, interpolate0;
    return function() {
        var value0, value1 = value(this);
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        value0 = this.getAttributeNS(fullname.space, fullname.local);
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $70038d959ef07234$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $70fbad3460829634$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $ce010af1b9c75424$export$da8cba906d64c082) : (0, $df95a8695595cc23$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $70038d959ef07234$var$attrFunctionNS : $70038d959ef07234$var$attrFunction)(fullname, i, (0, $62731c8cf5cc1d82$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $70038d959ef07234$var$attrRemoveNS : $70038d959ef07234$var$attrRemove)(fullname) : (fullname.local ? $70038d959ef07234$var$attrConstantNS : $70038d959ef07234$var$attrConstant)(fullname, i, value + ""));
}



function $424e3f2ed5e682cb$var$attrTweenNS(fullname, value) {
    function tween() {
        var node = this, i = value.apply(node, arguments);
        return i && function(t) {
            node.setAttributeNS(fullname.space, fullname.local, i(t));
        };
    }
    tween._value = value;
    return tween;
}
function $424e3f2ed5e682cb$var$attrTween(name, value) {
    function tween() {
        var node = this, i = value.apply(node, arguments);
        return i && function(t) {
            node.setAttribute(name, i(t));
        };
    }
    tween._value = value;
    return tween;
}
function $424e3f2ed5e682cb$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $70fbad3460829634$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $424e3f2ed5e682cb$var$attrTweenNS : $424e3f2ed5e682cb$var$attrTween)(fullname, value));
}



function $f270d7c116c4c11a$var$delayFunction(id, value) {
    return function() {
        (0, $d9a85b4328712ebb$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $f270d7c116c4c11a$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $d9a85b4328712ebb$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $f270d7c116c4c11a$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $f270d7c116c4c11a$var$delayFunction : $f270d7c116c4c11a$var$delayConstant)(id, value)) : (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $3162cbd780b35892$var$durationFunction(id, value) {
    return function() {
        (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $3162cbd780b35892$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $3162cbd780b35892$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $3162cbd780b35892$var$durationFunction : $3162cbd780b35892$var$durationConstant)(id, value)) : (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $cc5f2625d60310a5$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $cc5f2625d60310a5$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($cc5f2625d60310a5$var$easeConstant(id, value)) : (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(this.node(), id).ease;
}




function $10ac8703eee03e5b$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $1de11c01fba96121$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $f80f26e0d12f57e7$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $e46dec6b80a2e648$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $e46dec6b80a2e648$var$onFunction(id, name, listener) {
    var on0, on1, sit = $e46dec6b80a2e648$var$start(name) ? (0, $d9a85b4328712ebb$export$2cd8252107eb640b) : (0, $d9a85b4328712ebb$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $e46dec6b80a2e648$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($e46dec6b80a2e648$var$onFunction(id, name, listener));
}


function $ebf525bfcf467307$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $ebf525bfcf467307$export$2e2bcd8739ae039() {
    return this.on("end.remove", $ebf525bfcf467307$var$removeFunction(this._id));
}





function $ef355941a7a9fb98$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $a4b8b148ad40cff6$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $d9a85b4328712ebb$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $e9cd5922f07670bb$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $1617ed3f33f464b8$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $d9a85b4328712ebb$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $1147ef0836a5c000$var$Selection = (0, $ac042f6d8fade9df$export$2e2bcd8739ae039).prototype.constructor;
function $1147ef0836a5c000$export$2e2bcd8739ae039() {
    return new $1147ef0836a5c000$var$Selection(this._groups, this._parents);
}






function $067519110e7d2bc9$var$styleRemove(name, interpolate) {
    var value00, value10, interpolate0;
    return function() {
        var value0 = (0, $f466d4f748796511$export$5e3cec964f0b5efd)(this, name), value1 = (this.style.removeProperty(name), (0, $f466d4f748796511$export$5e3cec964f0b5efd)(this, name));
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $067519110e7d2bc9$var$styleRemoveEnd(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $067519110e7d2bc9$var$styleConstant(name, interpolate, value1) {
    var value00, interpolate0;
    return function() {
        var value0 = (0, $f466d4f748796511$export$5e3cec964f0b5efd)(this, name);
        return value0 === value1 ? null : value0 === value00 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value1);
    };
}
function $067519110e7d2bc9$var$styleFunction(name, interpolate, value) {
    var value00, value10, interpolate0;
    return function() {
        var value0 = (0, $f466d4f748796511$export$5e3cec964f0b5efd)(this, name), value1 = value(this);
        if (value1 == null) value1 = (this.style.removeProperty(name), (0, $f466d4f748796511$export$5e3cec964f0b5efd)(this, name));
        return value0 === value1 ? null : value0 === value00 && value1 === value10 ? interpolate0 : interpolate0 = interpolate(value00 = value0, value10 = value1);
    };
}
function $067519110e7d2bc9$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $ce010af1b9c75424$export$56bec7123bb3589a) : (0, $df95a8695595cc23$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $067519110e7d2bc9$var$styleRemove(name, i)).on("end.style." + name, $067519110e7d2bc9$var$styleRemoveEnd(name)) : this.styleTween(name, typeof value === "function" ? $067519110e7d2bc9$var$styleFunction(name, i, (0, $62731c8cf5cc1d82$export$f78ce6ab10405d82)(this, "style." + name, value)) : $067519110e7d2bc9$var$styleConstant(name, i, value + ""), priority);
}


function $8330f7f7c6f006c7$var$styleTween(name, value, priority) {
    function tween() {
        var node = this, i = value.apply(node, arguments);
        return i && function(t) {
            node.style.setProperty(name, i(t), priority);
        };
    }
    tween._value = value;
    return tween;
}
function $8330f7f7c6f006c7$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $8330f7f7c6f006c7$var$styleTween(name, value, priority == null ? "" : priority));
}



function $f01094141dea7840$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $f01094141dea7840$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $f01094141dea7840$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $f01094141dea7840$var$textFunction((0, $62731c8cf5cc1d82$export$f78ce6ab10405d82)(this, "text", value)) : $f01094141dea7840$var$textConstant(value == null ? "" : value + ""));
}




function $e00aca56fa15e77f$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $844cf5d1c74cb3a4$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $d9a85b4328712ebb$export$3988ae62b71be9a3)(node, id0);
            (0, $d9a85b4328712ebb$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)(groups, this._parents, name, id1);
}



var $844cf5d1c74cb3a4$var$id = 0;
function $844cf5d1c74cb3a4$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $844cf5d1c74cb3a4$export$2e2bcd8739ae039(name) {
    return (0, $ac042f6d8fade9df$export$2e2bcd8739ae039)().transition(name);
}
function $844cf5d1c74cb3a4$export$9ffd10a3fbdc175b() {
    return ++$844cf5d1c74cb3a4$var$id;
}
var $844cf5d1c74cb3a4$var$selection_prototype = (0, $ac042f6d8fade9df$export$2e2bcd8739ae039).prototype;
$844cf5d1c74cb3a4$export$be58926105124dd4.prototype = $844cf5d1c74cb3a4$export$2e2bcd8739ae039.prototype = {
    constructor: $844cf5d1c74cb3a4$export$be58926105124dd4,
    select: (0, $ef355941a7a9fb98$export$2e2bcd8739ae039),
    selectAll: (0, $e9cd5922f07670bb$export$2e2bcd8739ae039),
    filter: (0, $10ac8703eee03e5b$export$2e2bcd8739ae039),
    merge: (0, $f80f26e0d12f57e7$export$2e2bcd8739ae039),
    selection: (0, $1147ef0836a5c000$export$2e2bcd8739ae039),
    transition: (0, $e00aca56fa15e77f$export$2e2bcd8739ae039),
    call: $844cf5d1c74cb3a4$var$selection_prototype.call,
    nodes: $844cf5d1c74cb3a4$var$selection_prototype.nodes,
    node: $844cf5d1c74cb3a4$var$selection_prototype.node,
    size: $844cf5d1c74cb3a4$var$selection_prototype.size,
    empty: $844cf5d1c74cb3a4$var$selection_prototype.empty,
    each: $844cf5d1c74cb3a4$var$selection_prototype.each,
    on: (0, $e46dec6b80a2e648$export$2e2bcd8739ae039),
    attr: (0, $70038d959ef07234$export$2e2bcd8739ae039),
    attrTween: (0, $424e3f2ed5e682cb$export$2e2bcd8739ae039),
    style: (0, $067519110e7d2bc9$export$2e2bcd8739ae039),
    styleTween: (0, $8330f7f7c6f006c7$export$2e2bcd8739ae039),
    text: (0, $f01094141dea7840$export$2e2bcd8739ae039),
    remove: (0, $ebf525bfcf467307$export$2e2bcd8739ae039),
    tween: (0, $62731c8cf5cc1d82$export$2e2bcd8739ae039),
    delay: (0, $f270d7c116c4c11a$export$2e2bcd8739ae039),
    duration: (0, $3162cbd780b35892$export$2e2bcd8739ae039),
    ease: (0, $cc5f2625d60310a5$export$2e2bcd8739ae039)
};



function $299f1ff80f9040e9$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $299f1ff80f9040e9$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $299f1ff80f9040e9$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $9de43058ffbdfc79$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $299f1ff80f9040e9$export$89238d3bc79d3ada)
};
function $9de43058ffbdfc79$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return $9de43058ffbdfc79$var$defaultTiming.time = (0, $f3386654ea4b70d8$export$461939dd4422153)(), $9de43058ffbdfc79$var$defaultTiming;
    }
    return timing;
}
function $9de43058ffbdfc79$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $844cf5d1c74cb3a4$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $844cf5d1c74cb3a4$export$9ffd10a3fbdc175b)(), (timing = $9de43058ffbdfc79$var$defaultTiming).time = (0, $f3386654ea4b70d8$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $d9a85b4328712ebb$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $9de43058ffbdfc79$var$inherit(node, id));
    }
    return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $ac042f6d8fade9df$export$2e2bcd8739ae039).prototype.interrupt = (0, $afbb32d24ac5bc4b$export$2e2bcd8739ae039);
(0, $ac042f6d8fade9df$export$2e2bcd8739ae039).prototype.transition = (0, $9de43058ffbdfc79$export$2e2bcd8739ae039);





var $9dccd4cabf0e95c1$var$root = [
    null
];
function $9dccd4cabf0e95c1$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $d9a85b4328712ebb$export$584530fe98d14a84) && schedule.name === name) return new (0, $844cf5d1c74cb3a4$export$be58926105124dd4)([
                [
                    node
                ]
            ], $9dccd4cabf0e95c1$var$root, name, +i);
        }
    }
    return null;
}





function $dfed81fe49974966$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $e4266aba7c31efa8$export$d141bba7fdc215a3(d) {
    return d[0];
}
function $e4266aba7c31efa8$export$4a5767248b18ef41(d) {
    return d[1];
}



var $7tI6w = parcelRequire("7tI6w");
function $ad7b7c6ae09354f2$export$2e2bcd8739ae039() {
    var x = (0, $e4266aba7c31efa8$export$d141bba7fdc215a3), y = (0, $e4266aba7c31efa8$export$4a5767248b18ef41), extent = null;
    function voronoi(data) {
        return new (0, $7tI6w.default)(data.map(function(d, i) {
            var s = [
                Math.round(x(d, i, data) / (0, $7tI6w.epsilon)) * (0, $7tI6w.epsilon),
                Math.round(y(d, i, data) / (0, $7tI6w.epsilon)) * (0, $7tI6w.epsilon)
            ];
            s.index = i;
            s.data = d;
            return s;
        }), extent);
    }
    voronoi.polygons = function(data) {
        return voronoi(data).polygons();
    };
    voronoi.links = function(data) {
        return voronoi(data).links();
    };
    voronoi.triangles = function(data) {
        return voronoi(data).triangles();
    };
    voronoi.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $dfed81fe49974966$export$2e2bcd8739ae039)(+_), voronoi) : x;
    };
    voronoi.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $dfed81fe49974966$export$2e2bcd8739ae039)(+_), voronoi) : y;
    };
    voronoi.extent = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ], voronoi) : extent && [
            [
                extent[0][0],
                extent[0][1]
            ],
            [
                extent[1][0],
                extent[1][1]
            ]
        ];
    };
    voronoi.size = function(_) {
        return arguments.length ? (extent = _ == null ? null : [
            [
                0,
                0
            ],
            [
                +_[0],
                +_[1]
            ]
        ], voronoi) : extent && [
            extent[1][0] - extent[0][0],
            extent[1][1] - extent[0][1]
        ];
    };
    return voronoi;
}






var $91aa5825c7b4665a$var$rho = Math.SQRT2, $91aa5825c7b4665a$var$rho2 = 2, $91aa5825c7b4665a$var$rho4 = 4, $91aa5825c7b4665a$var$epsilon2 = 1e-12;
function $91aa5825c7b4665a$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $91aa5825c7b4665a$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $91aa5825c7b4665a$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
function $91aa5825c7b4665a$export$2e2bcd8739ae039(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    // Special case for u0 ≅ u1.
    if (d2 < $91aa5825c7b4665a$var$epsilon2) {
        S = Math.log(w1 / w0) / $91aa5825c7b4665a$var$rho;
        i = function(t) {
            return [
                ux0 + t * dx,
                uy0 + t * dy,
                w0 * Math.exp($91aa5825c7b4665a$var$rho * t * S)
            ];
        };
    } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + $91aa5825c7b4665a$var$rho4 * d2) / (2 * w0 * $91aa5825c7b4665a$var$rho2 * d1), b1 = (w1 * w1 - w0 * w0 - $91aa5825c7b4665a$var$rho4 * d2) / (2 * w1 * $91aa5825c7b4665a$var$rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / $91aa5825c7b4665a$var$rho;
        i = function(t) {
            var s = t * S, coshr0 = $91aa5825c7b4665a$var$cosh(r0), u = w0 / ($91aa5825c7b4665a$var$rho2 * d1) * (coshr0 * $91aa5825c7b4665a$var$tanh($91aa5825c7b4665a$var$rho * s + r0) - $91aa5825c7b4665a$var$sinh(r0));
            return [
                ux0 + u * dx,
                uy0 + u * dy,
                w0 * coshr0 / $91aa5825c7b4665a$var$cosh($91aa5825c7b4665a$var$rho * s + r0)
            ];
        };
    }
    i.duration = S * 1000;
    return i;
}




function $bffce2e1abc081ee$export$2e2bcd8739ae039(node, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = (0, $8ca07fdf38c63b63$export$2e2bcd8739ae039)().changedTouches;
    for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
        if ((touch = touches[i]).identifier === identifier) return (0, $d292e63c082fa724$export$2e2bcd8739ae039)(node, touch);
    }
    return null;
}



function $58982032a199fe73$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $32cc04564c4da392$export$2e2bcd8739ae039(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}


function $58abc962c23ae047$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$58abc962c23ae047$export$563a914cafbdc389.prototype = {
    constructor: $58abc962c23ae047$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $58abc962c23ae047$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $58abc962c23ae047$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $58abc962c23ae047$export$f0954fd7d5368655 = new $58abc962c23ae047$export$563a914cafbdc389(1, 0, 0);
$58abc962c23ae047$export$2e2bcd8739ae039.prototype = $58abc962c23ae047$export$563a914cafbdc389.prototype;
function $58abc962c23ae047$export$2e2bcd8739ae039(node) {
    return node.__zoom || $58abc962c23ae047$export$f0954fd7d5368655;
}



function $377fa975183656a1$export$2e2561858db9bf47() {
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).stopImmediatePropagation();
}
function $377fa975183656a1$export$2e2bcd8739ae039() {
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).preventDefault();
    (0, $75679d3f7c3bc482$export$6cd530ed55e06764).stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
function $c5e8fa4c116d35dc$var$defaultFilter() {
    return !(0, $75679d3f7c3bc482$export$6cd530ed55e06764).button;
}
function $c5e8fa4c116d35dc$var$defaultExtent() {
    var e = this, w, h;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        w = e.width.baseVal.value;
        h = e.height.baseVal.value;
    } else {
        w = e.clientWidth;
        h = e.clientHeight;
    }
    return [
        [
            0,
            0
        ],
        [
            w,
            h
        ]
    ];
}
function $c5e8fa4c116d35dc$var$defaultTransform() {
    return this.__zoom || (0, $58abc962c23ae047$export$f0954fd7d5368655);
}
function $c5e8fa4c116d35dc$var$defaultWheelDelta() {
    return -(0, $75679d3f7c3bc482$export$6cd530ed55e06764).deltaY * ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).deltaMode ? 120 : 1) / 500;
}
function $c5e8fa4c116d35dc$var$defaultTouchable() {
    return "ontouchstart" in this;
}
function $c5e8fa4c116d35dc$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $c5e8fa4c116d35dc$export$2e2bcd8739ae039() {
    var filter = $c5e8fa4c116d35dc$var$defaultFilter, extent = $c5e8fa4c116d35dc$var$defaultExtent, constrain = $c5e8fa4c116d35dc$var$defaultConstrain, wheelDelta = $c5e8fa4c116d35dc$var$defaultWheelDelta, touchable = $c5e8fa4c116d35dc$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $91aa5825c7b4665a$export$2e2bcd8739ae039), gestures = [], listeners = (0, $f1a1df54262d4945$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
    function zoom(selection) {
        selection.property("__zoom", $c5e8fa4c116d35dc$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $c5e8fa4c116d35dc$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform);
        else selection.interrupt().each(function() {
            gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        });
    };
    zoom.scaleTo = function(selection, k) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = centroid(e), p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        });
    };
    zoom.translateBy = function(selection, x, y) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        });
    };
    zoom.translateTo = function(selection, x, y) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p = centroid(e);
            return constrain((0, $58abc962c23ae047$export$f0954fd7d5368655).translate(p[0], p[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        });
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $58abc962c23ae047$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $58abc962c23ae047$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, center) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = center || centroid(e), w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $58abc962c23ae047$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args) {
        for(var i = 0, n = gestures.length, g; i < n; ++i){
            if ((g = gestures[i]).that === that) return g;
        }
        return new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.index = -1;
        this.active = 0;
        this.extent = extent.apply(that, args);
    }
    Gesture.prototype = {
        start: function() {
            if (++this.active === 1) {
                this.index = gestures.push(this) - 1;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                gestures.splice(this.index, 1);
                this.index = -1;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            (0, $75679d3f7c3bc482$export$4c724631b4750aef)(new (0, $32cc04564c4da392$export$2e2bcd8739ae039)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function wheeled() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $a9daf6b6ba2679b5$export$2e2bcd8739ae039)(this);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $ef45489bd346b26a$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $377fa975183656a1$export$2e2bcd8739ae039)();
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned() {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), v = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)((0, $75679d3f7c3bc482$export$6cd530ed55e06764).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $a9daf6b6ba2679b5$export$2e2bcd8739ae039)(this), x0 = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).clientX, y0 = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).clientY;
        (0, $1ad953c62f5557ec$export$2e2bcd8739ae039)((0, $75679d3f7c3bc482$export$6cd530ed55e06764).view);
        (0, $377fa975183656a1$export$2e2561858db9bf47)();
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $ef45489bd346b26a$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved() {
            (0, $377fa975183656a1$export$2e2bcd8739ae039)();
            if (!g.moved) {
                var dx = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).clientX - x0, dy = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $a9daf6b6ba2679b5$export$2e2bcd8739ae039)(g.that), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped() {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $1ad953c62f5557ec$export$833237748009e1e1)((0, $75679d3f7c3bc482$export$6cd530ed55e06764).view, g.moved);
            (0, $377fa975183656a1$export$2e2bcd8739ae039)();
            g.end();
        }
    }
    function dblclicked() {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $a9daf6b6ba2679b5$export$2e2bcd8739ae039)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, $75679d3f7c3bc482$export$6cd530ed55e06764).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
        (0, $377fa975183656a1$export$2e2bcd8739ae039)();
        if (duration > 0) (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0);
        else (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(this).call(zoom.transform, t1);
    }
    function touchstarted() {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, arguments), touches = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).changedTouches, started, n = touches.length, i, t, p;
        (0, $377fa975183656a1$export$2e2561858db9bf47)();
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $bffce2e1abc081ee$export$2e2bcd8739ae039)(this, touches, t.identifier);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true;
            else if (!g.touch1) g.touch1 = p;
        }
        // If this is a dbltap, reroute to the (optional) dblclick.zoom handler.
        if (touchstarting) {
            touchstarting = clearTimeout(touchstarting);
            if (!g.touch1) {
                g.end();
                p = (0, $47d5dea6a143564e$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                if (p) p.apply(this, arguments);
                return;
            }
        }
        if (started) {
            touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $ef45489bd346b26a$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved() {
        var g = gesture(this, arguments), touches = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).changedTouches, n = touches.length, i, t, p, l;
        (0, $377fa975183656a1$export$2e2bcd8739ae039)();
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $bffce2e1abc081ee$export$2e2bcd8739ae039)(this, touches, t.identifier);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended() {
        var g = gesture(this, arguments), touches = (0, $75679d3f7c3bc482$export$6cd530ed55e06764).changedTouches, n = touches.length, i, t;
        (0, $377fa975183656a1$export$2e2561858db9bf47)();
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else g.end();
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $58982032a199fe73$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $58982032a199fe73$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $58982032a199fe73$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $58982032a199fe73$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    return zoom;
}







class $f114d6e387da3e11$export$acaa6426d77a227e {
    parent;
    element;
    dimensions;
    name = '';
    render = true;
    margins = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        xAxis: 0,
        yAxis: 0
    };
    constructor(parent, dimensions, name, margins, render = true){
        this.parent = parent;
        this.dimensions = dimensions;
        this.name = name;
        if (margins) this.margins = margins;
        if (typeof render === 'boolean') this.render = render;
        // Create SVG element and assign properties
        this.element = $9dc0bf83babef520$export$2e2bcd8739ae039(this.parent).append('svg').attr('class', this.name ? this.name + '-svg' : 'chart-svg').attr('width', this.dimensions.width + this.margins.left + this.margins.right).attr('height', this.dimensions.height + this.margins.top + this.margins.bottom).append('g');
        if (this.margins) this.element.attr('transform', 'translate(' + this.margins.left + ',' + this.margins.top + ')');
        return this.element;
    }
    get = (variable)=>this[variable];
    set = (variable, value)=>{
        if (!variable || !this[variable] || !value) return;
        this[variable] = value;
        return this[variable];
    };
    destroy = ()=>{
        if (this.element) {
            this.element.remove();
            this.element = null;
        }
    };
    addChild = (child)=>{
        if (this.element && child) return this.element.appendChild(child);
    };
    removeChild = (child)=>{
        if (this.element && child) return this.element.removeChild(child);
    };
}


var $c0d77edc7017bd35$exports = {};

$parcel$export($c0d77edc7017bd35$exports, "ColorScale", function () { return $c0d77edc7017bd35$export$cd4efb55feeae0be; });

class $c0d77edc7017bd35$export$cd4efb55feeae0be {
    colorRange;
    colors = {};
    keys;
    constructor(colorRange){
        this.colorRange = colorRange;
        this.keys = Object.keys(this.colorRange);
        this.colors = {};
        for(const color in this.keys){
            const key = this.keys[color];
            this.colors[key] = $208581d375ac7212$export$2e2bcd8739ae039($77c67e50346ab974$export$2e2bcd8739ae039).range(this.colorRange[key]);
        }
    }
}


var $ecdd72d73f07fa43$exports = {};

$parcel$export($ecdd72d73f07fa43$exports, "Dimensions", function () { return $ecdd72d73f07fa43$export$d5b8c1948b345816; });
class $ecdd72d73f07fa43$export$d5b8c1948b345816 {
    width;
    height;
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
}


var $ca26bde6f3f0bc21$exports = {};

$parcel$export($ca26bde6f3f0bc21$exports, "Domain", function () { return $ca26bde6f3f0bc21$export$f102e87ccfb079d0; });
class $ca26bde6f3f0bc21$export$f102e87ccfb079d0 {
    domain;
    constructor(domain){
        this.domain = domain;
    }
}


var $5ee2b34699c97fb7$exports = {};

$parcel$export($5ee2b34699c97fb7$exports, "Filter", function () { return $5ee2b34699c97fb7$export$ec91da630f36d5ea; });
class $5ee2b34699c97fb7$export$ec91da630f36d5ea {
    name;
    constructor(name){
        this.name = name;
    }
}


var $2f15a7f4ec78042e$exports = {};

$parcel$export($2f15a7f4ec78042e$exports, "Margins", function () { return $2f15a7f4ec78042e$export$8b41a899820e47d6; });
class $2f15a7f4ec78042e$export$8b41a899820e47d6 {
    top = 0;
    right = 0;
    bottom = 0;
    left = 0;
    xAxis = 0;
    yAxis = 0;
    constructor(margins){
        if (margins) {
            for(const margin in margins)if (margins[margin]) this[margin] = margins[margin];
        }
    }
}


var $e6ba4ea686b187e8$exports = {};

$parcel$export($e6ba4ea686b187e8$exports, "Position", function () { return $e6ba4ea686b187e8$export$13807d9ee5a34a42; });
class $e6ba4ea686b187e8$export$13807d9ee5a34a42 {
    x;
    dx;
    y;
    dy;
    transform;
    constructor(x, dx, y, dy, transform){
        this.x = x;
        this.dx = dx;
        this.y = y;
        this.dy = dy;
        this.transform = transform;
    }
}


var $8173a0d1e183aad8$exports = {};

$parcel$export($8173a0d1e183aad8$exports, "Range", function () { return $8173a0d1e183aad8$export$9a58ef0d7ad3278c; });
class $8173a0d1e183aad8$export$9a58ef0d7ad3278c {
    values;
    type;
    constructor(values, type = 'range'){
        this.values = values;
        this.type = type;
    }
}


var $b328e2f314618102$exports = {};

$parcel$export($b328e2f314618102$exports, "Scale", function () { return $b328e2f314618102$export$d60cfc58d3c358b6; });
class $b328e2f314618102$export$d60cfc58d3c358b6 {
    scale;
    range;
    domain;
    constructor(scale, range, domain){
        if (scale && (range || domain)) {
            this.scale = scale;
            this.range = range;
            this.domain = domain;
            // Create scale
            this.scale();
            if (this.range) {
                if (this.range.type) {
                    this.range.type.toLowerCase();
                    if (this.range.type === 'range') this.scale.range(this.range.values);
                    if (this.range.type === 'round') this.scale.rangeRound(this.range.values);
                    if (this.range.type === 'roundbands') this.scale.rangeRoundBands(this.range.values);
                } else this.scale.range(this.range.values);
            }
            if (this.domain) this.scale.domain(this.domain);
        }
    }
}


var $beddacb2ea01fd08$exports = {};

$parcel$export($beddacb2ea01fd08$exports, "Ticks", function () { return $beddacb2ea01fd08$export$27c7467594ef87bd; });
class $beddacb2ea01fd08$export$27c7467594ef87bd {
    number;
    format;
    constructor(number, format){
        this.number = number;
        this.format = format;
    }
}


const $8597a53da626d345$export$ab152e6ff2cc840e = ()=>(0, $50c68e19ba8e5079$export$2e59fa295abca125);
const $8597a53da626d345$export$50499dcf398ab867 = (array, sortProperty)=>{
    if (!array) return;
    array.sort(function(a, b) {
        return a[sortProperty] - b[sortProperty];
    });
    return array;
};
const $8597a53da626d345$export$3c49c185de0c2bfc = (element, id = 'totalBarChart')=>{
    if (!element || document.getElementById(id) === null) return 0;
    return document.getElementById(id)?.getBoundingClientRect().width;
};
const $8597a53da626d345$export$55382f732810ce34 = (chartWidth, divisor)=>{
    if (!chartWidth || !divisor) return 0;
    let width = Math.round(chartWidth / divisor);
    if (width % 2) width += 1;
    return width;
};
const $8597a53da626d345$export$871ad45925ecebef = (string)=>{
    if (string) {
        let newString = string.replace(/[.,-/#!$%^&*;:{}=\-_`~()]/g, '');
        newString = newString.replace(/\s{2,}/g, ' ');
        return newString;
    }
};
const $8597a53da626d345$export$86f54f62aa7a7514 = (string)=>{
    if (string === undefined) return '';
    return string.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
};
const $8597a53da626d345$export$c8d7cffe57163567 = (string)=>{
    if (string.charAt(0) === string.charAt(0).toLowerCase()) {
        const withSpaces = string.replace(/([A-Z])/g, ' $1');
        const finalString = withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
        return finalString;
    }
};
$parcel$exportWildcard($8597a53da626d345$exports, $2a584e384e0c1f6d$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $f114d6e387da3e11$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $c0d77edc7017bd35$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $ecdd72d73f07fa43$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $ca26bde6f3f0bc21$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $5ee2b34699c97fb7$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $2f15a7f4ec78042e$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $e6ba4ea686b187e8$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $8173a0d1e183aad8$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $b328e2f314618102$exports);
$parcel$exportWildcard($8597a53da626d345$exports, $beddacb2ea01fd08$exports);


$parcel$exportWildcard($2c379471d5bc2795$exports, $4bb6caff349888e9$exports);
$parcel$exportWildcard($2c379471d5bc2795$exports, $f90d087769f90e7b$exports);
$parcel$exportWildcard($2c379471d5bc2795$exports, $ca0b580bae42961b$exports);
$parcel$exportWildcard($2c379471d5bc2795$exports, $95a9e3a3afe1e6c3$exports);
$parcel$exportWildcard($2c379471d5bc2795$exports, $8597a53da626d345$exports);


class $accbdc2bb764768e$export$985c8653d1398450 {
    static _interceptor = (transactions)=>{
        // Prepare
        const totals = {
            display: {},
            feesCharged: 0,
            feeTotal: 0,
            feesPaid: 0,
            interestCharged: 0,
            interestPaid: 0,
            principalPaid: 0,
            currentPrincipal: 0,
            advanceAmount: 0,
            adjustmentAmount: 0,
            paymentAmount: 0
        };
        let transaction;
        // Sort the history by date (newest at index 0)
        transactions.sort((a, b)=>new Date(b.sequenceNumber).getTime() - new Date(a.sequenceNumber).getTime());
        // Prepare finished transactions array
        const formattedTransactions = [];
        // Loop through the transactions and perform calculations
        for(let i = 0; i < transactions.length; i++){
            transaction = transactions[i];
            if (transaction.__t !== 'adjustments') {
                // Calculate
                transaction.feeTotal = (transaction.originationFee ?? 0) + (transaction.diligenceFee ?? 0) + (transaction.lateFee ?? 0) + (transaction.facilityFee ?? 0) + (transaction.adminFee ?? 0);
                transaction.feesDue = transaction.feeBalance + transaction.feeTotal;
                transaction.feesDue = transaction.appliedToFees ? transaction.feesDue - transaction.appliedToFees : transaction.feesDue;
                transaction.interestDue = transaction.interestBalance + transaction.interestCharge;
                transaction.interestDue = transaction.appliedToInterest ? transaction.interestDue - transaction.appliedToInterest : transaction.interestDue;
                // Tally
                totals.feeTotal += transaction.feeTotal;
                totals.feesCharged += transaction.feeTotal;
                totals.feesPaid = (0, $f90d087769f90e7b$export$7e4aa119212bc614)(transaction.appliedToFees) ? totals.feesPaid + transaction.appliedToFees : totals.feesPaid;
                totals.interestCharged += transaction.interestCharge;
                totals.interestPaid = transaction.appliedToInterest ? totals.interestPaid + transaction.appliedToInterest : totals.interestPaid;
                // Parse
                transaction.effectiveDate = new Date(transaction.effectiveDate);
                // Filter
                // transaction.display = {};
                switch(transaction.__t){
                    case 'advances':
                        // Calculate
                        transaction.advanceAmount = transaction.amount;
                        transaction.newPrincipalBalance = transaction.principalBalance + transaction.amount;
                        // Tally
                        totals.advanceAmount += transaction.amount;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                        break;
                    case 'payments':
                        // Calculate
                        transaction.paymentAmount = transaction.amount;
                        transaction.newPrincipalBalance = transaction.principalBalance - transaction.appliedToPrincipal;
                        // Tally
                        totals.paymentAmount += transaction.amount;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                        totals.principalPaid += transaction.appliedToPrincipal;
                        break;
                    case 'statements':
                        // Calculate
                        transaction.newPrincipalBalance = transaction.principalBalance;
                        break;
                }
                // Store
                formattedTransactions.push(transaction);
            }
        }
        // Store updated transactions
        transactions = formattedTransactions;
        if (transactions && transactions[0]) {
            if (transactions[0].newPrincipalBalance) totals.currentPrincipal = transactions[0].newPrincipalBalance;
            if (transactions[0].assetValue) totals.currentAssets = transactions[0].assetValue;
            if (transactions[0].currentAvailableCredit) totals.currentAvailableCredit = transactions[0].currentAvailableCredit;
        }
        // Return
        return {
            transactions: transactions,
            totals: totals
        };
    };
    /**
   * Get Loan Transactions
   */ static async query(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/transactions',
            query: req
        }));
    }
}



class $1376736a8aed5dd4$export$a81c579a392aa9d2 {
    // TODO: how do we properly represent routes for `users.client.service.js` lines 5-13?
    /**
   * List Users
   * @returns User[]
   * @throws ApiError
   */ static async query(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/users',
            query: req
        });
        return res;
    }
    /**
   * Get User
   * @param id TUserId
   * @returns User
   * @throws ApiError
   */ static async get(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/users/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
    /**
   * Create User
   * @param user User
   * @returns User
   * @throws ApiError
   */ static async create(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/api/users',
            body: req
        });
        return res;
    }
    /**
   * Update User
   * @param user User
   * @returns User
   * @throws ApiError
   */ static async update(id, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/users/{id}',
            path: {
                id: id
            },
            body: req
        });
        return res;
    }
    /**
   * Delete User
   * @param id TUserId
   * @returns User
   * @throws ApiError
   */ static async remove(id) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/users/{id}',
            path: {
                id: id
            }
        });
        return res;
    }
}






class $52b9bdfcbdeba495$export$b662858863b75c61 {
    /**
   * List Accounts
   * @returns Account[]
   * @throws ApiError
   */ static async query(lenderId) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/lenders/{lenderId}/account',
            path: {
                lenderId: lenderId
            }
        });
        return res.data;
    }
    /**
   * Get Account
   * @param id TAccountId
   * @returns Account
   * @throws ApiError
   */ static async get(lenderId, transactionId) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/lenders/{lenderId}/account/{transactionId}',
            path: {
                lenderId: lenderId,
                transactionId: transactionId
            }
        });
        return res.data;
    }
    /**
   * Create Account
   * @param account Account
   * @returns Account
   * @throws ApiError
   */ static async create(lenderId, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/lenders/{lenderId}/account',
            path: {
                lenderId: lenderId
            },
            body: req
        });
        return res.data;
    }
    /**
   * Update Account
   * @param account Account
   * @returns Account
   * @throws ApiError
   */ static async update(lenderId, transactionId, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/lenders/{lenderId}/account/{transactionId}',
            path: {
                lenderId: lenderId,
                transactionId: transactionId
            },
            body: req
        });
        return res.data;
    }
    /**
   * Delete Account
   * @param id TAccountId
   * @returns Account
   * @throws ApiError
   */ static async remove(lenderId, transactionId) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'DELETE',
            url: '/lenders/{lenderId}/account/{transactionId}',
            path: {
                lenderId: lenderId,
                transactionId: transactionId
            }
        });
        return res.data;
    }
}


class $4bf368a23258265b$export$5b1ba45d47672b60 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    constructor(rootStore){
        super(rootStore);
    }
    /**** Data Processing ****/ /**
   * Tabulates line item balances for an account.
   *
   * @param account - The account to tabulate balances for
   * @returns The input account with the `balance` field set to sum of the line items
   */ calculateBalances = (account)=>{
        // Zero out balance
        let balance = 0;
        // Add up line items
        account.activity = account.activity.map((activity)=>({
                ...activity,
                balance: balance += activity.amount
            }));
        return account;
    };
    /**** Account CRUD ****/ /**
   * Fetches a list of Accounts.
   *
   * @param lenderId - ID of the Lender to fetch Accounts for
   * @returns An array of Accounts
   */ query = async (lenderId)=>{
        const response = await (0, $52b9bdfcbdeba495$export$b662858863b75c61).query(lenderId);
        return response.map((account)=>this.calculateBalances(account));
    };
    /**
   * Fetches a single Account.
   *
   * @param lenderId - ID of the Lender whose Account is being fetched
   * @param transactionId - The associated Transaction
   * @returns An Account object
   */ get = async (lenderId, transactionId)=>{
        const response = await (0, $52b9bdfcbdeba495$export$b662858863b75c61).get(lenderId, transactionId);
        return this.calculateBalances(response);
    };
    /**
   * Creates an Account item.
   *
   * @param lenderId - ID of the Lender to create an Account for
   * @param formValues - A populated CreateAccountForm object
   * @returns The new Account item (with line item balances)
   */ create = async (lenderId, formValues)=>{
        // Create new Account object
        const request = {
            _id: lenderId,
            amount: formValues.amount,
            effectiveDate: formValues.effectiveDate
        };
        const response = await (0, $52b9bdfcbdeba495$export$b662858863b75c61).create(lenderId, request);
        return this.calculateBalances(response);
    };
    /**
   * Updates a Ledger item.
   *
   * @param lenderId - ID of the Lender whose Ledger item is being updated
   * @param transactionId - The associated Transaction
   * @param formValues - A populated UpdateAccountForm object
   * @returns The updated Account (with line item balances)
   */ update = async (lenderId, transactionId, formValues)=>{
        // Create new withdrawal/deposit object
        const request = {
            _id: lenderId,
            amount: formValues.amount,
            transactionId: transactionId
        };
        const response = await (0, $52b9bdfcbdeba495$export$b662858863b75c61).update(lenderId, transactionId, request);
        return this.calculateBalances(response);
    };
    /**
   * Removes a Ledger item.
   *
   * @param lenderId - ID of the Lender whose Ledger item is being removed
   * @param transactionId - The associated Transaction
   * @returns The removed Account
   *
   */ remove = async (lenderId, transactionId)=>{
        const response = await (0, $52b9bdfcbdeba495$export$b662858863b75c61).remove(lenderId, transactionId);
        return this.calculateBalances(response);
    };
}



var $jzre3 = parcelRequire("jzre3");



class $2e5b36618c278ea8$export$2185f9289be2edc extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    adjustments;
    currentAdjustment;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            adjustments: (0, $jzre3.observable),
            currentAdjustment: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Adjustment nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Adjustments', 'adjustments', this.rootStore.userStore.isLender ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/adjustments(/create)?', false, undefined, 10);
        if (!this.rootStore.userStore.isLender) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'adjustments', 'List Adjustments', 'adjustments');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'adjustments', 'New Adjustment', 'adjustments/create', 'adjustments/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Adjustments responses.
   *
   * @param adjustments - An array of Adjustments to format
   * @returns The formatted Adjustments
   */ formatAdjustmentList = (adjustments)=>{
        return adjustments.map((adjustment)=>this.formatAdjustment(adjustment));
    };
    /**
   * Format Get Adjustment responses.
   *
   * @param adjustment - The Adjustment to format
   * @returns The formatted Adjustment
   */ formatAdjustment = (adjustment)=>{
        // Calculate
        adjustment.resultingAssetValue = (adjustment.assetValue ?? 0) + adjustment.amount;
        // Parse
        adjustment.effectiveDate = new Date(adjustment.effectiveDate);
        return adjustment;
    };
    /**** Adjustment CRUD ****/ /**
   * Fetches a list of Adjustments.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Adjustments
   */ query = async (query)=>{
        // if (query) query.px = true;
        const response = await (0, $df00e24747d28c11$export$37b37a9dc875f921).query(query);
        (0, $jzre3.runInAction)(()=>{
            this.adjustments = this.formatAdjustmentList(response);
        });
        return this.adjustments;
    };
    /**
   * Fetches a single Adjustment and sets it as the current Adjustment.
   *
   * @param adjustmentId - ID of the Adjustment to fetch
   * @returns An Adjustment object
   */ get = async (adjustmentId)=>{
        const response = await (0, $df00e24747d28c11$export$37b37a9dc875f921).get(adjustmentId);
        (0, $jzre3.runInAction)(()=>{
            this.currentAdjustment = response ? this.formatAdjustment(response) : undefined;
        });
        return this.currentAdjustment;
    };
    /**
   * Creates an Adjustment.
   *
   * @param formValues - A populated CreateAdjustmentForm object
   * @returns The new Adjustment
   */ create = async (formValues)=>{
        if (!formValues.company || !formValues.loan || !formValues.name || !formValues.asset || !formValues.effectiveDate || Number.isNaN(formValues.amount)) throw new Error('Please fix the errors first.');
        // Create new Adjustment object
        const adjustment = {
            company: formValues.company._id,
            loan: formValues.loan._id,
            effectiveDate: formValues.effectiveDate,
            name: formValues.name,
            assetId: formValues.asset._id,
            assetValue: formValues.asset.value,
            amount: formValues.amount,
            notes: formValues.notes,
            files: formValues.files,
            user: this.rootStore.userStore.user
        };
        const response = await (0, $df00e24747d28c11$export$37b37a9dc875f921).create(adjustment);
        return response;
    };
    /**
   * Updates an Adjustment.
   *
   * @param formValues - A populated UpdateAdjustmentForm object
   * @returns The updated Adjustment
   */ update = async (formValues)=>{
        const adjustment = formValues;
        const response = await (0, $df00e24747d28c11$export$37b37a9dc875f921).update(adjustment._id, adjustment);
        (0, $jzre3.runInAction)(()=>this.currentAdjustment = Object.assign(this.currentAdjustment ?? {}, response));
        return this.currentAdjustment;
    };
    /**
   * Removes an Adjustment.
   *
   * @param adjustmentId - ID of the Adjustment to delete
   * @returns The removed Adjustment
   */ remove = async (adjustmentId)=>{
        const removed = await (0, $df00e24747d28c11$export$37b37a9dc875f921).remove(adjustmentId);
        (0, $jzre3.runInAction)(()=>this.adjustments?.splice(this.adjustments?.findIndex((adjustment)=>adjustment._id === adjustmentId), 1));
        return removed;
    };
}



var $jzre3 = parcelRequire("jzre3");



class $2596541f68fe0e6f$export$59f5c3bf9b610a7a extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    advances;
    currentAdvance;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            advances: (0, $jzre3.observable),
            currentAdvance: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Advance nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Advances', 'advances', this.rootStore.userStore.isLender ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/advances(/create)?', false, undefined, 9);
        if (!this.rootStore.userStore.isLender) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'advances', 'List Advances', 'advances');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'advances', 'New Advance', 'advances/create', 'advances/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Advances responses.
   *
   * @param advances - An array of Advances to format
   * @returns The formatted Advances
   */ formatAdvanceList = (advances)=>{
        return advances.map((advance)=>this.formatAdvance(advance));
    };
    /**
   * Format Get Advance responses.
   *
   * @param advance - The Advance to format
   * @returns The formatted Advance
   */ formatAdvance = (advance)=>{
        // Get the asset object from the attached loan
        if (advance.loan?.assets && advance.loan.assets.length) {
            const asset = advance.loan.assets.find((asset)=>asset._id === advance.assetId);
            if (asset) advance.asset = asset;
        }
        // Parse
        if (advance.dateRequested) advance.dateRequested = new Date(advance.dateRequested);
        if (advance.dateFulfilled) advance.dateFulfilled = new Date(advance.dateFulfilled);
        // Return
        return advance;
    };
    /**** Advance CRUD ****/ /**
   * Fetches a list of Advances.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Advances
   */ query = async (query)=>{
        // if (query) query.px = true;
        const response = await (0, $92ab41bdff63d770$export$5d45644869e3cfc).query(query);
        const advances = this.formatAdvanceList(response);
        (0, $jzre3.runInAction)(()=>this.advances = advances);
        return this.advances;
    };
    /**
   * Fetches a single Advance and sets it as the current Advance.
   *
   * @param advanceId - ID of the Advance to fetch
   * @returns An Advance object
   */ get = async (advanceId)=>{
        const response = await (0, $92ab41bdff63d770$export$5d45644869e3cfc).get(advanceId);
        (0, $jzre3.runInAction)(()=>{
            this.currentAdvance = response ? this.formatAdvance(response) : undefined;
        });
        return this.currentAdvance;
    };
    /**
   * Creates an Advance.
   *
   * @param formValues - A populated CreateAdvanceForm object
   * @returns The new Advance
   */ create = async (formValues)=>{
        if (!formValues.loan || !formValues.company) throw new Error('Please fix the errors first.');
        // Create new Advance object
        const request = {
            name: formValues.name,
            amount: formValues.amount,
            loan: formValues.loan._id,
            company: formValues.company._id,
            dateRequested: formValues.dateRequested,
            originationFee: formValues.amount * (formValues.loan.originationFee ?? 0),
            notes: formValues.notes,
            dateFulfilled: formValues.dateFulfilled,
            effectiveDate: formValues.dateFulfilled,
            files: formValues.files
        };
        if (formValues.loan.isOwned && formValues.asset) request.assetId = formValues.asset._id;
        // Save the Advance
        const response = await (0, $92ab41bdff63d770$export$5d45644869e3cfc).create(request);
        return response;
    };
    /**
   * Updates an Advance.
   *
   * @param advance - The Advance to update
   * @returns The updated Advance
   */ update = async (advance)=>{
        // Calculate
        if (advance.dateFulfilled) advance.effectiveDate = advance.dateFulfilled;
        if (advance.amount && advance.loan?.originationFee) advance.originationFee = advance.amount * advance.loan.originationFee;
        // Update
        const response = await (0, $92ab41bdff63d770$export$5d45644869e3cfc).update(advance._id, advance);
        (0, $jzre3.runInAction)(()=>this.currentAdvance = Object.assign(this.currentAdvance ?? {}, response));
        return this.currentAdvance;
    };
    /**
   * Removes an Advance.
   *
   * @param advanceId - ID of the Advance to delete
   * @returns The removed Advance
   */ remove = async (advanceId)=>{
        return await (0, $92ab41bdff63d770$export$5d45644869e3cfc).remove(advanceId);
    };
}



var $jzre3 = parcelRequire("jzre3");


class $21393a8f7dbfe0e0$export$6efe27c077f7cc6e {
    /**
   * List Alerts
   * @returns Alert[]
   * @throws ApiError
   */ static async query(req) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/alerts',
            query: req
        });
    }
    /**
   * Get Alert
   * @param id TAlertId
   * @returns Alert
   * @throws ApiError
   */ static async get(id) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/alerts/{id}',
            path: {
                id: id
            }
        });
    }
    /**
   * Update Alert
   * @param id TAlertId
   * @param req TUpdateAlertRequest
   * @returns Alert
   * @throws ApiError
   */ static async update(id, req) {
        return await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'PUT',
            url: '/alerts/{id}',
            path: {
                id: id
            },
            body: req
        });
    }
}



class $9130148a45682035$export$49ce1c6a489d392a extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    filterStore;
    userStore;
    alerts;
    newAlertCount = 0;
    allowPoll = true;
    pollTimer = 600000;
    constructor(rootStore){
        super(rootStore);
        this.filterStore = rootStore.filterStore;
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            alerts: (0, $jzre3.observable),
            newAlertCount: (0, $jzre3.observable),
            allowPoll: (0, $jzre3.observable),
            pollTimer: (0, $jzre3.observable)
        });
    }
    /**** Data Processing ****/ /**
   * Prepares Alert responses.
   *
   * @param alert - Alert to process
   * @returns The prepared Alert
   */ _interceptor = (alert)=>{
        if (alert.asset) {
            alert.source = {
                __t: (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Asset,
                _id: alert.asset._id,
                company: alert.loan?.borrower,
                loan: alert.loan
            };
            delete alert.loan;
            delete alert.asset;
        }
        return alert;
    };
    /**** Alert CRUD ****/ /**
   * Fetch Alerts
   */ query = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const alerts = (await (0, $21393a8f7dbfe0e0$export$6efe27c077f7cc6e).query()).map(this._interceptor).filter((alert)=>!!alert.source);
            (0, $jzre3.runInAction)(()=>{
                this.alerts = alerts;
                this.newAlertCount = alerts.filter((a)=>a.status === (0, $c6a113d11e099562$export$d4654b2858949cbe).Unread).length;
            });
        } catch (err) {
            if (err.status === 401) {
                const errBody = err.body;
                if (errBody.message?.toLocaleLowerCase() === 'user is not logged in') this.rootStore.userStore.signout();
            } else console.error(err);
        }
    };
    /**
   * Get Alert
   */ get = async (id)=>{
        return this._interceptor(await (0, $21393a8f7dbfe0e0$export$6efe27c077f7cc6e).get(id));
    };
    /**
   * Update Alert
   */ update = async (alert)=>{
        return await (0, $21393a8f7dbfe0e0$export$6efe27c077f7cc6e).update(alert._id, alert);
    };
    /**
   * Looks up names in the Companies list
   */ getCompanyName = (companyId)=>{
        if (!companyId) return;
        const companies = this.filterStore.companyListGet();
        return companies?.find((company)=>company._id === companyId)?.name;
    };
    /**
   * Looks up names in the Loans list
   */ getLoanName = (loanId)=>{
        if (!loanId) return;
        const loans = this.filterStore.loanListGet();
        return loans?.find((loan)=>loan._id === loanId)?.name;
    };
    /**
   * Looks up names in the Lenders list
   */ getLenderName = (lenderId)=>{
        if (!lenderId) return;
        const lenders = this.filterStore.lenderListGet();
        return Array.isArray(lenders) ? lenders.find((lender)=>lender._id === lenderId)?.name : lenders;
    };
    /**
   * Counts the unread alerts in a given array
   */ scanNewAlerts = (alerts)=>{
        return alerts.filter((alert)=>alert.status === (0, $c6a113d11e099562$export$d4654b2858949cbe).Unread).length;
    };
    /**
   * Marks all unread Alerts as read
   */ markAsRead = async ()=>{
        if (!this.alerts) return;
        const updateRequests = this.alerts?.filter((alert)=>alert.status === (0, $c6a113d11e099562$export$d4654b2858949cbe).Unread).map((alert)=>{
            alert.status = (0, $c6a113d11e099562$export$d4654b2858949cbe).Read;
            // if (alert.source) delete alert.source;
            return (0, $21393a8f7dbfe0e0$export$6efe27c077f7cc6e).update(alert._id, alert);
        });
        await Promise.all(updateRequests);
        await this.query();
    };
    /**
   * Poll the server for new alerts
   */ tick = async ()=>{
        if (!this.allowPoll || !this.userStore.isAdmin) return;
        const alerts = await (0, $21393a8f7dbfe0e0$export$6efe27c077f7cc6e).query();
        (0, $jzre3.runInAction)(()=>{
            this.alerts = alerts;
            this.newAlertCount = this.scanNewAlerts(alerts);
        });
    };
}




var $jzre3 = parcelRequire("jzre3");



class $39ee393095dda7e7$export$dbfcb0e671e479ed extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    userStore;
    assets;
    currentAsset;
    constructor(rootStore){
        super(rootStore);
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            assets: (0, $jzre3.observable),
            currentAsset: (0, $jzre3.observable),
            setCurrentAsset: (0, $jzre3.action)
        });
    }
    /**
   * Adds Asset nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Assets', 'assets', this.rootStore.userStore.isLender ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/assets(/create)?', false, undefined, 8);
        if (!this.rootStore.userStore.isLender) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'assets', 'List Assets', 'assets');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'assets', 'New Asset', 'assets/create', 'assets/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Getters/Setters ****/ /**
   * Sets the current Asset.
   *
   * @param asset The new current Asset. May be undefined
   * @returns The Asset
   */ setCurrentAsset = (asset)=>this.currentAsset = asset;
    /**** Data Processing ****/ /**
   * Formats List Assets responses.
   *
   * @param assets - An array of Assets to format
   * @param userIsLender - Whether the logged-in User is a Lender User
   * @returns The formatted Assets
   */ formatAssetList = (assets, userIsAdmin)=>{
        return assets.map((asset)=>{
            // Process
            if (!asset.notes) {
                const notes = [
                    ...userIsAdmin ? asset.socketComments ?? [] : [],
                    ...asset.companyComments ?? []
                ];
                // Sort comments by created date
                notes.sort((a, b)=>a.created && b.created ? a.created > b.created ? 1 : b.created > a.created ? -1 : 0 : 0);
                // Save updated Notes array
                asset.notes = notes;
            }
            // Calculate
            asset.originalValue ??= 0;
            asset.currentAdjustments ??= 0;
            asset.initialPaymentAmount ??= 0;
            asset.adminFee ??= 0;
            asset.discountFee ??= 0;
            asset.lateFee ??= 0;
            asset.feeBalance ??= 0;
            asset.expectedResidualPayment = asset.originalValue + (asset.currentAdjustments || 0) - asset.initialPaymentAmount - asset.adminFee - asset.discountFee - asset.lateFee;
            // Parse
            asset.startDate = new Date(asset.startDate);
            asset.nextDate = new Date(asset.nextDate);
            asset.endDate = new Date(asset.endDate);
            asset.effectiveDate = new Date(asset.effectiveDate);
            // Return
            return asset;
        });
    };
    /**
   * Format Get Asset responses.
   *
   * @param asset - The Asset to format
   * @param userIsLender - Whether the logged-in User is a Lender User
   * @returns The formatted Asset
   */ formatAsset = (asset, userIsLender)=>{
        // Clean
        if (userIsLender) asset.files = [];
        // Total Payments
        if (asset.payments) {
            const currentPayments = asset.payments.map((payment)=>payment.amount);
            if (currentPayments.length) asset.currentPayments = currentPayments.reduce((total, amount)=>total += amount);
        }
        // Total Adjustments
        if (asset.adjustments) {
            const currentAdjustments = asset.adjustments.map((adjustment)=>adjustment.amount);
            if (currentAdjustments.length) asset.currentAdjustments = currentAdjustments.reduce((total, amount)=>total += amount);
        }
        // Total Starting Asset Value
        if (asset.adjustments) {
            const totalStartingAssetValue = asset.adjustments.filter((adjustment)=>adjustment.assetValue).map((adjustment)=>adjustment.assetValue);
            if (totalStartingAssetValue.length) asset.totalStartingAssetValue = totalStartingAssetValue.reduce((total, amount)=>total += amount);
        }
        // Total Resulting Asset Value
        if (asset.adjustments) {
            let totalResultingAssetValue = 0;
            asset.adjustments = asset.adjustments.map((adjustment)=>{
                const resultingAssetValue = (adjustment.assetValue ?? 0) + adjustment.amount;
                totalResultingAssetValue += resultingAssetValue;
                return {
                    ...adjustment,
                    resultingAssetValue: resultingAssetValue
                };
            });
            asset.totalResultingAssetValue = totalResultingAssetValue;
        }
        // Calculate
        if (asset.feeBalance === undefined || asset.feeBalance === null || isNaN(asset.feeBalance)) asset.feeBalance = 0;
        asset.expectedResidualPayment = asset.originalValue + (asset.currentAdjustments || 0) - asset.initialPaymentAmount - asset.adminFee - asset.discountFee - asset.lateFee;
        asset.totalDueSocket = asset.initialPaymentAmount + asset.adminFee + asset.discountFee + asset.lateFee;
        // Parse
        asset.startDate = new Date(asset.startDate);
        asset.nextDate = new Date(asset.nextDate);
        asset.endDate = new Date(asset.endDate);
        asset.effectiveDate = new Date(asset.effectiveDate);
        // Return
        return asset;
    };
    /**** Asset CRUD ****/ /**
   * Fetches a list of Assets.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Assets
   */ query = async (query)=>{
        const response = await (0, $995d980118c41d8f$export$29ef22b941ad5ba0).query(query);
        (0, $jzre3.runInAction)(()=>{
            this.assets = this.formatAssetList(response, !!this.userStore.isAdmin);
        });
        return this.assets;
    };
    /**
   * Fetches a single Asset and sets it as the current Asset.
   *
   * @param assetId - ID of the Asset to fetch
   * @returns An Asset object
   */ get = async (assetId)=>{
        const response = await (0, $995d980118c41d8f$export$29ef22b941ad5ba0).get(assetId);
        (0, $jzre3.runInAction)(()=>{
            this.currentAsset = response ? this.formatAsset(response, !!this.userStore.isLender) : undefined;
        });
        return this.currentAsset;
    };
    /**
   * Fetches an Asset's name.
   *
   * @param assetId - ID of the Asset
   * @returns The Asset's name
   */ getName = async (assetId)=>{
        const response = await (0, $995d980118c41d8f$export$29ef22b941ad5ba0).get(assetId);
        return response;
    };
    /**
   * Creates an Asset.
   *
   * @param formValues - A populated CreateAssetForm object
   * @returns The new Asset
   */ create = async (formValues)=>{
        if (!this.userStore.user) throw new Error('Not authorized');
        if (!formValues.loan || !formValues.effectiveDate || !formValues.nextDate) throw new Error('Please fix the errors first.');
        const loan = formValues.loan;
        const value = parseFloat(formValues.value);
        // Create new Asset object
        const asset = {
            loan: loan._id,
            company: loan.borrower._id,
            name: formValues.name,
            assetType: formValues.assetType,
            value: value,
            originalValue: value,
            program: formValues.program,
            paymentSchedule: formValues.paymentSchedule,
            nextDate: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.nextDate).toDate(),
            companyComments: formValues.companyComments,
            socketComments: formValues.socketComments,
            effectiveDate: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.effectiveDate).toDate(),
            files: formValues.files,
            status: (0, $16167722a89c0415$export$ea3addc32bc92d57).Open
        };
        if (loan.isOwned) {
            loan.adminFee ??= 0;
            loan.discountFee ??= 0;
            // Admin Fee
            asset.adminFee = value * loan.adminFee;
            // Discount Fee
            asset.discountFee = value * loan.discountFee * ((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.nextDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.effectiveDate), 'days') / 30);
            // Late Fee
            asset.lateFee = 0;
            // Initial Payment Amount
            asset.initialPaymentAmount = value * loan.advanceRate;
            // Late After Date
            asset.startDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.nextDate).add(15, 'days').toDate();
            // Buyback Date
            asset.endDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.nextDate).add(30, 'days').toDate();
        }
        const response = await (0, $995d980118c41d8f$export$29ef22b941ad5ba0).create(asset);
        return response;
    };
    /**
   * Updates an Asset.
   *
   * @param asset - The Asset to update
   * @returns The updated Asset
   */ update = async (asset)=>{
        if (!this.userStore.user) throw new Error('Not authorized');
        if (!asset.loan || !asset.assetType || !asset.effectiveDate || !asset.nextDate) throw new Error('Please fix the errors first.');
        const loan = asset.loan;
        // Re-calculate any fields depending on nextDate or effectiveDate
        if (loan.isOwned) {
            loan.adminFee ??= 0;
            loan.discountFee ??= 0;
            // Discount Fee
            asset.discountFee = asset.originalValue * loan.discountFee * ((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(asset.nextDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(asset.effectiveDate), 'days') / 30);
            // Late After Date
            asset.startDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(asset.nextDate).add(15, 'days').toDate();
            // Buyback Date
            asset.endDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(asset.nextDate).add(30, 'days').toDate();
        }
        asset.loan = asset.loan._id;
        const response = await (0, $995d980118c41d8f$export$29ef22b941ad5ba0).update(asset._id, asset);
        (0, $jzre3.runInAction)(()=>this.currentAsset = Object.assign(this.currentAsset ?? {}, response));
        return this.currentAsset;
    };
    /**
   * Closes an Asset. This is equivalent to a soft delete.
   *
   * @param assetId - ID of the Asset to close
   * @returns The closed Asset
   */ close = async (assetId)=>{
        return await (0, $995d980118c41d8f$export$29ef22b941ad5ba0).remove(assetId);
    };
}



var $jzre3 = parcelRequire("jzre3");



class $653633979076e8c9$export$252777fe0fb3a7d {
    /**
   * List Bulks
   * @returns Bulk[]
   * @throws ApiError
   */ static async import(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/import',
            body: req
        });
        return res;
    }
}



class $46e720aa374c775f$export$b68d8f720b7dd307 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    exportIsActive = false;
    xhr = new XMLHttpRequest();
    uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready;
    uploadProgress = 0;
    success = false;
    wrongFile;
    // fileObject?: any;
    // files: any[] = [];
    importProgressBar = 1;
    queue;
    returnMessage;
    error = false;
    errorMessage;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            exportIsActive: (0, $jzre3.observable),
            xhr: (0, $jzre3.observable),
            uploadStatus: (0, $jzre3.observable),
            uploadProgress: (0, $jzre3.observable),
            success: (0, $jzre3.observable),
            wrongFile: (0, $jzre3.observable),
            // fileObject: observable,
            // files: observable,
            importProgressBar: (0, $jzre3.observable),
            queue: (0, $jzre3.observable),
            returnMessage: (0, $jzre3.observable),
            error: (0, $jzre3.observable),
            errorMessage: (0, $jzre3.observable),
            updateFiles: (0, $jzre3.action),
            upload: (0, $jzre3.action)
        });
    }
    /**
   * Watch the file input and update the files array when it changes.
   *
   * @param files - List of changed files
   */ updateFiles = (files)=>{
        this.success = false;
        // Push files onto the uploads queue
        this.queue = files;
        if (this.importProgressBar === 1 && this.queue[0].name !== 'company.csv') this.wrongFile = 'company.csv';
        else if (this.importProgressBar === 2 && this.queue[0].name !== 'loan.csv') this.wrongFile = 'loan.csv';
        else if (this.importProgressBar === 3 && this.queue[0].name !== 'participation.csv') this.wrongFile = 'participation.csv';
        else if (this.importProgressBar === 4 && this.queue[0].name !== 'asset.csv') this.wrongFile = 'asset.csv';
        else if (this.importProgressBar === 5 && this.queue[0].name !== 'advance.csv') this.wrongFile = 'advance.csv';
        else if (this.importProgressBar === 6 && this.queue[0].name !== 'payment.csv') this.wrongFile = 'payment.csv';
        else {
            this.wrongFile = undefined;
            this.uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Queued;
        }
        if (this.uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Queued) this.upload();
    };
    /**
   * User-facing upload method.
   */ upload = async ()=>{
        if (!this.rootStore.userStore.user) throw new Error('Not authorized');
        if (!this.queue?.[0]) return;
        const response = await (0, $653633979076e8c9$export$252777fe0fb3a7d).import(this.queue[0]);
        //   this.uploadFiles(this.queue[0], (returnObj) => {
        this.uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Done;
        this.returnMessage = JSON.parse(response);
        if (!this.returnMessage?.errors.length) {
            // Flag a successful upload
            this.success = true;
            this.error = false;
            // Advance the progress bar one step
            this.importProgressBar += 1;
            // Resets
            this.uploadProgress = 0;
            this.uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready;
        } else if (this.returnMessage.errors.length) this.error = true;
    //   });
    };
    /**
   * Low-level file upload method.
   *
   * @remarks
   * We're doing this manually instead of using `fetch` so that we can track the upload progress in real time.
   *
   * @param file - File to upload
   * @param callback - Called after upload
   */ uploadFiles = (file, callback)=>{
        this.uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading;
        const xhr = this.xhr;
        const apiUrl = (0, $6c9b670123ce891e$export$1b98eaf73d37f034)();
        // Track upload progress
        xhr.upload.onprogress = (upload)=>this.uploadProgress = upload.loaded / upload.total * 100;
        // Open connection & set headers
        xhr.open('POST', `${apiUrl}/import`, true);
        xhr.onload = ()=>{
            // Success callback
            if (xhr.status === 200) {
                this.success = true;
                this.error = false;
                this.errorMessage = undefined;
                callback(xhr.response);
            } else if (xhr.status >= 400) {
                this.error = true;
                this.errorMessage = xhr.responseText;
                this.uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready;
                window.setTimeout(()=>{
                    this.error = false;
                    this.errorMessage = undefined;
                }, 2000);
            }
        };
        // General error callback
        xhr.onerror = ()=>{
            this.success = false;
            this.error = true;
            this.errorMessage = 'An error has occurred';
            this.uploadStatus = (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready;
        };
        // Engage
        xhr.send(file);
    };
}



var $jzre3 = parcelRequire("jzre3");



class $68401467a547d5a7$export$649406674d76fc3f extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    userStore;
    companies;
    currentCompany;
    constructor(rootStore){
        super(rootStore);
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            companies: (0, $jzre3.observable),
            currentCompany: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Company nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Companies', 'companies', !this.rootStore.userStore.isAdmin ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/companies(/create)?', false, undefined, 7);
        if (this.rootStore.userStore.isAdmin) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'companies', 'List Companies', 'companies');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'companies', 'New Company', 'companies/create', 'companies/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Companies responses.
   *
   * @param companies - An array of Companies to format
   * @returns The formatted Companies
   */ formatCompanyList = (companies)=>{
        return companies.map((company)=>{
            // Parse dates
            company.statementDate = new Date(company.statementDate);
            // Add tags
            // TODO: do we need this part, or is this only for the filters?
            company.tags = {
                companies: [
                    company._id
                ],
                loans: company.loans?.map((loan)=>loan._id) ?? [],
                lenders: []
            };
            return company;
        });
    };
    /**
   * Format Get Company responses.
   *
   * @param company - The Company to format
   * @returns The formatted Company
   */ formatCompany = (company)=>{
        // Calculate
        company.currentAvailableCredit = company.currentCredit - company.currentPrincipalBalances;
        // Return
        return company;
    };
    /**** Company CRUD ****/ /**
   * Fetches a list of Companies.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Companies
   */ query = async (query)=>{
        if (query) query.px = true;
        const response = await (0, $9ee2733bf62593c7$export$81a665b0338610f5).query(query);
        (0, $jzre3.runInAction)(()=>{
            this.companies = this.formatCompanyList(response);
        });
        return this.companies;
    };
    /**
   * Fetches a single Company and sets it as the current Company.
   *
   * @param companyId - ID of the Company to fetch
   * @returns A Company object
   */ get = async (companyId)=>{
        const response = await (0, $9ee2733bf62593c7$export$81a665b0338610f5).get(companyId);
        (0, $jzre3.runInAction)(()=>{
            this.currentCompany = response ? this.formatCompany(response) : undefined;
        });
        return this.currentCompany;
    };
    /**
   * Creates an Company.
   *
   * @param formValues - A populated CreateCompanyForm object
   * @returns The new Company
   */ create = async (formValues)=>{
        if (!this.userStore.user) throw new Error('Not authorized');
        if (Number.isNaN(parseInt(formValues.zip ?? '')) || !formValues.socketLineOfBusiness) throw new Error('Please fix the errors first.');
        // Create new Company object
        const company = {
            name: formValues.name,
            longName: formValues.longName,
            address: {
                street: formValues.street,
                city: formValues.city,
                state: formValues.state,
                zip: formValues.zip
            },
            contactPerson: formValues.contactPerson,
            phone: {
                primary: formValues.phonePrimary,
                secondary: formValues.phoneSecondary,
                fax: formValues.phoneFax
            },
            email: formValues.email,
            website: formValues.website,
            socketLineOfBusiness: formValues.socketLineOfBusiness,
            companyType: formValues.companyType,
            notes: formValues.notes,
            files: formValues.files,
            isLender: formValues.isLender,
            status: (0, $5c4a9f32b679a002$export$cec65c3c11b5d5c1).Active,
            user: this.userStore.user._id
        };
        const response = await (0, $9ee2733bf62593c7$export$81a665b0338610f5).create(company);
        return response;
    };
    /**
   * Updates an Company.
   *
   * @param company - The Company to update
   * @returns The updated Company
   */ update = async (company)=>{
        if (!this.userStore.user) throw new Error('Not authorized');
        // if () throw new Error('Please fix the errors first.');
        // TODO: this is the logic in the original code; set company.loans, then delete it
        const loanIds = company.loans.map((loan)=>loan._id);
        company.loans = loanIds;
        delete company.adjustments;
        delete company.advances;
        delete company.companies;
        delete company.payments;
        delete company.loans;
        delete company.statements;
        const response = await (0, $9ee2733bf62593c7$export$81a665b0338610f5).update(company._id, company);
        (0, $jzre3.runInAction)(()=>this.currentCompany = Object.assign(this.currentCompany ?? {}, response));
        return this.currentCompany;
    };
    /**
   * Deactivates a Company. This is equivalent to a soft delete.
   *
   * @param companyId - ID of the Company to deactivate
   * @returns The deactivated Company
   */ deactivateCompany = async (companyId)=>{
        const response = await (0, $9ee2733bf62593c7$export$81a665b0338610f5).remove(companyId);
        return response;
    };
}



var $jzre3 = parcelRequire("jzre3");


class $e8db264aa4d6d62d$export$753647e56e513114 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    rangeType = (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly;
    currentDate = new Date();
    dateRange = {};
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            rangeType: (0, $jzre3.observable),
            currentDate: (0, $jzre3.observable),
            dateRange: (0, $jzre3.observable),
            setRangeType: (0, $jzre3.action),
            calculateRange: (0, $jzre3.action),
            setCurrentDate: (0, $jzre3.action),
            modifyCurrentDate: (0, $jzre3.action)
        });
        // Calculate initial date range
        this.calculateRange(this.currentDate, this.rangeType);
    }
    /**
   * Checks to see if a range type is allowed.
   *
   * @param rangeType - Range type to check
   * @returns Boolean indicating if the type is valid
   */ isValidType = (rangeType)=>Object.values((0, $dff1c8c0bf270f18$export$d0d7df129860d081)).includes(rangeType);
    /**
   * Updates stored range type.
   *
   * @param rangeType - New date range type
   */ setRangeType = (rangeType)=>{
        if (!this.isValidType(rangeType)) return;
        // Store new range type
        this.rangeType = rangeType;
    };
    /**
   * Calculates and saves a new date range.
   *
   * @remarks
   * Runs automatically when service is first loaded.
   *
   * @param currentDate - Current date to use. Defaults to stored `currentDate` if not provided
   * @param rangeType - Updated range type. Defaults to stored `rangeType` if not provided
   * @returns The new date range (or undefined if all params were undefined)
   */ calculateRange = (currentDate, rangeType)=>{
        currentDate = currentDate ? currentDate : this.currentDate;
        rangeType = rangeType ? rangeType : this.rangeType;
        if (!currentDate || !rangeType) return;
        const newRange = {};
        if (rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly) {
            newRange.start = new Date(currentDate.getFullYear(), 0, 1);
            newRange.end = new Date(currentDate.getFullYear() + 1, 0, 0);
        } else if (rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Monthly) {
            newRange.start = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            newRange.end = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        } else if (rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Weekly) {
            const weekStart = currentDate.getDate() - currentDate.getDay();
            const weekEnd = weekStart + 6;
            newRange.start = new Date(currentDate.getFullYear(), currentDate.getMonth(), weekStart);
            newRange.end = new Date(currentDate.getFullYear(), currentDate.getMonth(), weekEnd);
        }
        // Store current date
        newRange.currentDate = currentDate;
        // Store new date range
        this.dateRange = newRange;
        // Return data
        return newRange;
    };
    /**
   * Sets the current date.
   *
   * @param currentDate - New current date
   */ setCurrentDate = (currentDate)=>{
        this.currentDate = currentDate;
    };
    /**
   * Moves the current date forward or back by a given number of weeks, months, or years.
   *
   * @remarks
   * Whether the date is moved by weeks/months/years depends on the date range type.
   *
   * @param action - Number of units to add or remove from the current date. Can be negative
   * @param currentDate - Current date to use. Defaults to stored `currentDate` if not provided
   * @param rangeType - Date range type to use. Defaults to stored `rangeType` if not provided
   * @returns The new current date
   */ modifyCurrentDate = (modifier, currentDate, rangeType)=>{
        currentDate = currentDate ? currentDate : this.currentDate;
        rangeType = rangeType ? rangeType : this.rangeType;
        if (!modifier || !currentDate || !rangeType) return;
        let newDate = currentDate;
        // Get new current date
        if (rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Weekly) {
            newDate.setDate(newDate.getDate() + modifier * 7);
            newDate = new Date(newDate);
        } else if (rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Monthly) {
            newDate.setMonth(newDate.getMonth() + modifier);
            newDate = new Date(newDate);
        } else if (rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly) {
            newDate.setFullYear(newDate.getFullYear() + modifier);
            newDate = new Date(newDate);
        }
        // Store new date
        this.currentDate = newDate;
        return newDate;
    };
}



var $jzre3 = parcelRequire("jzre3");

class $3e984327d351c841$export$d76397ee299c7ea4 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    _companyFilterId = undefined;
    _companyFilterName = undefined;
    _companyFilterTags = undefined;
    _companyList = [];
    _loanFilterId = undefined;
    _loanFilterName = undefined;
    _loanFilterTags = undefined;
    _loanList = [];
    _lenderFilterId = undefined;
    _lenderFilterName = undefined;
    _lenderFilterTags = undefined;
    _lenderList = [];
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            _companyFilterId: (0, $jzre3.observable),
            _companyFilterName: (0, $jzre3.observable),
            _companyFilterTags: (0, $jzre3.observable),
            _companyList: (0, $jzre3.observable),
            _loanFilterId: (0, $jzre3.observable),
            _loanFilterName: (0, $jzre3.observable),
            _loanFilterTags: (0, $jzre3.observable),
            _loanList: (0, $jzre3.observable),
            _lenderFilterId: (0, $jzre3.observable),
            _lenderFilterName: (0, $jzre3.observable),
            _lenderFilterTags: (0, $jzre3.observable),
            _lenderList: (0, $jzre3.observable),
            batchSet: (0, $jzre3.action),
            companySet: (0, $jzre3.action),
            companyListSet: (0, $jzre3.action),
            companyListUpdateLenders: (0, $jzre3.action),
            loanSet: (0, $jzre3.action),
            loanListSet: (0, $jzre3.action),
            lenderSet: (0, $jzre3.action),
            lenderListSet: (0, $jzre3.action)
        });
    }
    /**
   * Returns the current Company, Loan, and Lender filters.
   */ batchGet = ()=>({
            company: this._companyFilterId ? {
                _id: this._companyFilterId,
                name: this._companyFilterName,
                tags: this._companyFilterTags
            } : undefined,
            loan: this._loanFilterId ? {
                _id: this._loanFilterId,
                name: this._loanFilterName,
                tags: this._loanFilterTags
            } : undefined,
            lender: this._lenderFilterId ? {
                _id: this._lenderFilterId,
                name: this._lenderFilterName,
                tags: this._lenderFilterTags
            } : undefined
        });
    /**
   * Sets the Company, Loan, and/or Lender filters all at once.
   *
   * @param companyFilter Company to filter by
   * @param loanFilter Loan to filter by
   * @param lenderFilter Lender to filter by
   */ batchSet = (companyFilter, loanFilter, lenderFilter)=>{
        this._companyFilterId = companyFilter?._id;
        this._companyFilterName = companyFilter?.name;
        this._companyFilterTags = companyFilter?.tags;
        this._loanFilterId = loanFilter?._id;
        this._loanFilterName = loanFilter?.name;
        this._loanFilterTags = loanFilter?.tags;
        this._lenderFilterId = lenderFilter?._id;
        this._lenderFilterName = lenderFilter?.name;
        this._lenderFilterTags = lenderFilter?.tags;
    };
    /**
   * Returns the current Company filter.
   */ companyGet = ()=>{
        return this._companyFilterId ? {
            _id: this._companyFilterId,
            name: this._companyFilterName,
            tags: this._companyFilterTags
        } : undefined;
    };
    /**
   * Sets the current Company filter.
   *
   * @param filter - Company to begin filtering by
   */ companySet = (filter)=>{
        this._companyFilterId = filter?._id;
        this._companyFilterName = filter?.name;
        this._companyFilterTags = filter?.tags;
    };
    /**
   * Returns a list of Companies with the selected fields.
   *
   * @param fields - Optional array of Company data model props to include with each list item. If undefined, the entire Company object is used.
   */ companyListGet = (fields)=>{
        if (fields) return this._companyList.map((co)=>{
            const retObj = {};
            fields.forEach((f)=>{
                retObj[f] = co[f];
            });
            return retObj;
        });
        else return this._companyList;
    };
    /**
   * Sets the list of Companies.
   *
   * @param list - Array of Companies
   */ companyListSet = (list)=>{
        if (list !== undefined) {
            list.sort((a, b)=>{
                if (a.name && b.name) {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                }
                return 0;
            });
            this._companyList = list;
        }
    };
    /**
   * Update Lender tags for Company list.
   */ companyListUpdateLenders = ()=>{
        this._companyList.forEach((company)=>{
            this._lenderList.forEach((lender)=>{
                const borrowers = lender.tags?.companies;
                borrowers?.forEach(function(borrower) {
                    if (lender._id && borrower === company._id) company.tags?.lenders.push(lender._id);
                });
            });
        });
    };
    /**
   * Returns the current Loan filter.
   */ loanGet = ()=>{
        return this._loanFilterId ? {
            _id: this._loanFilterId,
            name: this._loanFilterName,
            tags: this._loanFilterTags
        } : undefined;
    };
    /**
   * Sets the current Loan filter.
   *
   * @param filter - Loan to begin filtering by
   */ loanSet = (filter)=>{
        this._loanFilterId = filter?._id;
        this._loanFilterName = filter?.name;
        this._loanFilterTags = filter?.tags;
    };
    /**
   * Returns a list of Loans with the selected fields.
   *
   * @param fields - Optional array of Loan data model props to include with each list item. If undefined, the entire Loan object is used.
   */ loanListGet = (fields)=>{
        if (fields) return this._loanList.map((co)=>{
            const retObj = {};
            fields.forEach((f)=>{
                retObj[f] = co[f];
            });
            return retObj;
        });
        else return this._loanList;
    };
    /**
   * Sets the list of Loans.
   *
   * @param list - Array of Loans
   */ loanListSet = (list)=>{
        if (list !== undefined) {
            list.sort((a, b)=>{
                if (a.name && b.name) {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                }
                return 0;
            });
            this._loanList = list;
        }
    };
    /**
   * Returns the current Lender filter.
   */ lenderGet = ()=>{
        return this._lenderFilterId ? {
            _id: this._lenderFilterId,
            name: this._lenderFilterName,
            tags: this._lenderFilterTags
        } : undefined;
    };
    /**
   * Sets the current Lender filter.
   *
   * @param filter - Lender to begin filtering by
   */ lenderSet = (filter)=>{
        this._lenderFilterId = filter?._id;
        this._lenderFilterName = filter?.name;
        this._lenderFilterTags = filter?.tags;
    };
    /**
   * Returns a list of Lenders with the selected fields.
   *
   * @param fields - Optional array of Lender data model props to include with each list item. If undefined, the entire Lender object is used.
   */ lenderListGet = (lenderSearch, fields)=>{
        if (!lenderSearch) {
            if (fields) return this._lenderList.map(function(co) {
                const retObj = {};
                fields.forEach((f)=>{
                    retObj[f] = co[f];
                });
                return retObj;
            });
            else return this._lenderList;
        } else {
            if (this._lenderList.length) for(const lender in this._lenderList){
                if (this._lenderList[lender].name === lenderSearch) return this._lenderList[lender];
                else if (this._lenderList[lender]._id === lenderSearch) return this._lenderList[lender];
            }
        }
    };
    /**
   * Sets the list of Lenders.
   *
   * @param list - Array of Lenders
   */ lenderListSet = (list)=>{
        if (list !== undefined) {
            list.sort((a, b)=>{
                if (a.name && b.name) {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                }
                return 0;
            });
            this._lenderList = list;
        }
    };
    /**
   * Resets all filters.
   */ reset = ()=>{
        this.companySet({
            _id: undefined,
            name: undefined,
            tags: undefined
        });
        this.loanSet({
            _id: undefined,
            name: undefined,
            tags: undefined
        });
        this.lenderSet({
            _id: undefined,
            name: undefined,
            tags: undefined
        });
    };
}



var $jzre3 = parcelRequire("jzre3");

class $fc0fef0ad7995cad$export$daa0810644ffe016 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    renderHeader = true;
    currentPage = '';
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            renderHeader: (0, $jzre3.observable),
            currentPage: (0, $jzre3.observable)
        });
    }
    /**
   * Fetches a list of Companies and populates the Company filters with the result.
   */ loadCompanies = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const response = await this.rootStore.companyStore.query();
            const companyList = response?.map((company)=>({
                    ...company,
                    tags: {
                        companies: [
                            company._id
                        ],
                        loans: company.loans ? company.loans.map((loan)=>loan._id) : [],
                        lenders: []
                    }
                }));
            this.rootStore.filterStore.companyListSet(companyList);
        } catch (err) {
            if (err.status === 401) {
                const errBody = err.body;
                if (errBody.message?.toLocaleLowerCase() === 'user is not logged in') this.rootStore.userStore.signout();
            } else console.error(err);
        }
    };
    /**
   * Fetches a list of Loans and populates the Loan filters with the result.
   */ loadLoans = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const response = await this.rootStore.loanStore.query();
            const loanList = response?.map((loan)=>({
                    ...loan,
                    tags: {
                        loans: [
                            loan.borrower._id
                        ],
                        loanList: [
                            loan._id
                        ],
                        lenders: loan.lenders.map((lender)=>lender._id)
                    }
                }));
            this.rootStore.filterStore.loanListSet(loanList);
        } catch (err) {
            if (err.status === 401) {
                const errBody = err.body;
                if (errBody.message?.toLocaleLowerCase() === 'user is not logged in') this.rootStore.userStore.signout();
            } else console.error(err);
        }
    };
    /**
   * Fetches a list of Lenders and populates the Lender filters with the result.
   */ loadLenders = async ()=>{
        if (!this.rootStore.userStore.user) return;
        try {
            const response = await this.rootStore.lenderStore.query();
            const lenderList = response?.map((lender)=>({
                    ...lender,
                    tags: {
                        companies: [],
                        loans: [],
                        lenders: [
                            lender._id
                        ]
                    }
                }));
            this.rootStore.filterStore.lenderListSet(lenderList);
        } catch (err) {
            if (err.status === 401) {
                const errBody = err.body;
                if (errBody.message?.toLocaleLowerCase() === 'user is not logged in') this.rootStore.userStore.signout();
            } else console.error(err);
        }
    };
}



var $jzre3 = parcelRequire("jzre3");


class $4efa80cba9115fa0$export$c174125e28244bee extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    headlines;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            headlines: (0, $jzre3.observable)
        });
    }
    /**** Headlines CRUD ****/ /**
   * Gets a list of Headlines
   *
   * @param filters - Filters to use when parsing Headline results
   * @returns Filtered headlines
   */ get = async (filters)=>{
        const headlines = await (0, $1fd8a92edc8c1db5$export$8bcf2a1e145214ea).get(filters);
        (0, $jzre3.runInAction)(()=>this.headlines = headlines);
        return headlines;
    };
}



var $jzre3 = parcelRequire("jzre3");


class $9163b0ac45868bd8$export$4911a02fd83e3bfa extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    lenderStatementHeadlines;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            lenderStatementHeadlines: (0, $jzre3.observable)
        });
    }
    /**** Data Processing ****/ /**
   * Formats Lender Statement Headlines response.
   *
   * @param response - Headlines to format
   * @returns The formatted Headlines
   */ formatLenderStatementHeadlines = (response)=>{
        const headlines = response;
        let balances = [];
        // End-of-month calcs
        if (headlines.month) {
            headlines.month.totalRevenue = headlines.month.appliedToFees + headlines.month.appliedToInterest;
            headlines.month.netRevenue = headlines.month.totalRevenue - headlines.month.managementFees;
            headlines.month.totalUnpaidRevenue = headlines.month.feeBalance + headlines.month.interestBalance;
            balances = [
                headlines.month.account.amountInvested,
                -Math.abs(headlines.month.principalBalance),
                headlines.month.appliedToFees,
                headlines.month.appliedToInterest,
                -Math.abs(headlines.month.managementFees),
                -Math.abs(headlines.month.account.amountReturned ?? 0)
            ];
            headlines.month.balances = balances.reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0)) ?? 0;
        }
        // YTD calcs
        if (headlines.ytd) {
            headlines.ytd.totalRevenue = headlines.ytd.appliedToFees + headlines.ytd.appliedToInterest;
            headlines.ytd.netRevenue = headlines.ytd.totalRevenue - headlines.ytd.managementFees;
            headlines.ytd.totalUnpaidRevenue = headlines.ytd.feeBalance + headlines.ytd.interestBalance;
            balances = [
                headlines.ytd.account.amountInvested,
                -Math.abs(headlines.ytd.principalBalance),
                headlines.ytd.appliedToFees,
                headlines.ytd.appliedToInterest,
                -Math.abs(headlines.ytd.managementFees),
                -Math.abs(headlines.ytd.account.amountReturned ?? 0)
            ];
            headlines.ytd.balances = balances.reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0)) ?? 0;
        }
        // All-time calcs
        if (headlines.alltime) {
            headlines.alltime.totalRevenue = headlines.alltime.appliedToFees + headlines.alltime.appliedToInterest;
            headlines.alltime.netRevenue = headlines.alltime.totalRevenue - headlines.alltime.managementFees;
            headlines.alltime.totalUnpaidRevenue = headlines.alltime.feeBalance + headlines.alltime.interestBalance;
            balances = [
                headlines.alltime.account.amountInvested,
                -Math.abs(headlines.alltime.principalBalance),
                headlines.alltime.appliedToFees,
                headlines.alltime.appliedToInterest,
                -Math.abs(headlines.alltime.managementFees),
                -Math.abs(headlines.alltime.account.amountReturned ?? 0)
            ];
            headlines.alltime.balances = balances.reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0)) ?? 0;
            headlines.alltime.holdingAccountBalance = headlines.alltime.account.balance - headlines.alltime.principalBalance + headlines.alltime.netRevenue || 0;
        }
        // Return the data
        return headlines;
    };
    /**** Lender Statement Headlines CRUD ****/ /**
   * Fetches and caches Lender Statement Headlines data.
   *
   * @param filters - Filters to use when fetching Headlines
   * @returns The Lender Statement Headlines
   */ get = async (filters)=>{
        const lenderStatementHeadlines = await (0, $2674880b4f6f34a4$export$ebbafa41a7dafb5c).get(filters);
        (0, $jzre3.runInAction)(()=>this.lenderStatementHeadlines = this.formatLenderStatementHeadlines(lenderStatementHeadlines));
        return this.lenderStatementHeadlines;
    };
}



var $jzre3 = parcelRequire("jzre3");


class $da31860026caba0c$export$e5e982b3f8cd34fa extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    statementHeadlines;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            statementHeadlines: (0, $jzre3.observable)
        });
    }
    /**** Statement Headlines CRUD ****/ /**
   * Fetches and caches Statement Headlines data.
   *
   * @param filters - Filters to use when fetching Headlines
   * @returns The Statement Headlines
   */ get = async (filters)=>{
        const statementHeadlines = await (0, $fe5c98af9b155e38$export$dc1f3aaa2c25ddbc).get(filters);
        (0, $jzre3.runInAction)(()=>this.statementHeadlines = statementHeadlines);
    };
}





var $jzre3 = parcelRequire("jzre3");



class $3c40d701da4cefbc$export$a7a808ac31b8e363 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    userStore;
    lenders;
    currentLender;
    constructor(rootStore){
        super(rootStore);
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            lenders: (0, $jzre3.observable),
            currentLender: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Lender nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Investors', 'investors', this.rootStore.userStore.isLender ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/investors(/create)?', false, [
            (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
            (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor
        ], 6);
        if (!this.rootStore.userStore.isLender) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'investors', 'List Investors', 'investors');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'investors', 'New Investor', 'companies/create', 'companies/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Lenders responses.
   *
   * @param companies - An array of Lenders to format
   * @returns The formatted Lenders
   */ formatLenderList = (lenders)=>{
        return lenders.map((lender)=>{
            // Calculate
            if (lender.participations) {
                lender.loansParticipatedIn = lender.participations.length;
                lender.currentBalance = 0;
                for (const participation of lender.participations)lender.currentBalance += participation.relativeBalance;
            }
            // Return
            return lender;
        });
    };
    /**
   * Format Get Lender responses.
   *
   * @param lender - The Lender to format
   * @returns The formatted Lender
   */ formatLender = (lender)=>{
        // Remap
        lender.feesCollected = lender.feesPaid;
        lender.interestCollected = lender.interestPaid;
        lender.socketFees = lender.totalSocketFees;
        lender.totalRevenue = lender.feesCollected + lender.interestCollected;
        lender.netRevenue = lender.totalRevenue - lender.socketFees;
        // Calculate Account activity balances
        let balance = 0;
        // Add up line items
        lender.account.activity = lender.account.activity.map((activity)=>({
                ...activity,
                balance: balance += activity.amount
            }));
        // Return
        return lender;
    };
    /**** Lender CRUD ****/ /**
   * Fetches a list of Lenders.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Lenders
   */ query = async (query)=>{
        const response = await (0, $ead355dc3e4dafd9$export$6f059e92a7272a52).query(query);
        (0, $jzre3.runInAction)(()=>this.lenders = this.formatLenderList(response ?? []));
        return this.lenders;
    };
    /**
   * Fetches a single Lender and sets it as the current Lender.
   *
   * @param lenderId - ID of the Lender to fetch
   * @returns A Lender object
   */ get = async (lenderId)=>{
        const response = await (0, $ead355dc3e4dafd9$export$6f059e92a7272a52).get(lenderId);
        (0, $jzre3.runInAction)(()=>{
            this.currentLender = response ? this.formatLender(response) : undefined;
        });
        return this.currentLender;
    };
    /**
   * Deactivates a Lender. This is equivalent to a soft delete.
   *
   * @param lenderId - ID of the Lender to deactivate
   * @returns The deactivated Lender
   */ deactivate = async (lenderId)=>{
        const response = await (0, $ead355dc3e4dafd9$export$6f059e92a7272a52).deactivate(lenderId);
        return response;
    };
}



var $jzre3 = parcelRequire("jzre3");



class $2814aa2805833a6c$export$c5e2446288acf619 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    userStore;
    loans;
    currentLoan;
    constructor(rootStore){
        super(rootStore);
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            loans: (0, $jzre3.observable),
            currentLoan: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Loan nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Deals', 'loans', !this.rootStore.userStore.isAdmin ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/deals(/create)?', false, undefined, 5);
        if (this.rootStore.userStore.isAdmin) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'loans', 'List Deals', 'deals');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'loans', 'New Deal', 'deals/create', 'deals/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Loans responses.
   *
   * @param loans - An array of Loans to format
   * @returns The formatted Loans
   */ formatLoanList = (loans)=>{
        return loans.map((loan)=>{
            // Define
            if (!loan.isOwned) loan.isOwned = false;
            if (!loan.adminFee) loan.adminFee = 0;
            if (!loan.discountFee) loan.discountFee = 0;
            // Parse
            loan.maturityDate = new Date(loan.maturityDate);
            loan.lastAdvanceDate = new Date(loan.lastAdvanceDate);
            loan.facilityFeeDate = new Date(loan.facilityFeeDate);
            loan.created = new Date(loan.created);
            // Combine
            if (!loan.notes) {
                const notes = [];
                if (loan.socketComments && this.userStore.isAdmin) loan.socketComments.forEach((comment)=>{
                    notes.push(comment);
                });
                if (loan.companyComments) loan.companyComments.forEach((comment)=>{
                    notes.push(comment);
                });
                notes.sort((a, b)=>a.created && b.created ? a.created > b.created ? 1 : b.created > a.created ? -1 : 0 : 0);
                loan.notes = notes;
            }
            // Return
            return loan;
        });
    };
    /**
   * Format Get Loan responses.
   *
   * @param loan - The Loan to format
   * @returns The formatted Loan
   */ formatLoan = (loan)=>{
        if (!loan) return;
        // Define
        if (!loan.isOwned) loan.isOwned = false;
        if (!loan.adminFee) loan.adminFee = 0;
        if (!loan.discountFee) loan.discountFee = 0;
        // Parse
        loan.created = new Date(loan.created);
        loan.maturityDate = new Date(loan.maturityDate);
        loan.lastAdvanceDate = new Date(loan.lastAdvanceDate);
        loan.facilityFeeDate = new Date(loan.facilityFeeDate);
        // Return
        return loan;
    };
    /**** Loan CRUD ****/ /**
   * Fetches a list of Loans.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Loans
   */ query = async (query)=>{
        // if (query) query.px = true;
        const response = await (0, $036b2e0dfab38af7$export$bc9e7cacb37e13e9).query(query);
        (0, $jzre3.runInAction)(()=>this.loans = this.formatLoanList(response));
        return this.loans;
    };
    /**
   * Fetches a single Loan and sets it as the current Loan.
   *
   * @param loanId - ID of the Loan to fetch
   * @returns A Loan object
   */ get = async (loanId)=>{
        const response = await (0, $036b2e0dfab38af7$export$bc9e7cacb37e13e9).get(loanId);
        (0, $jzre3.runInAction)(()=>this.currentLoan = this.formatLoan(response));
        return this.currentLoan;
    };
    /**
   * Creates an Loan.
   *
   * @param formValues - A populated CreateLoanForm object
   * @returns The new Loan
   */ create = async (formValues)=>{
        if (!this.userStore.user) throw new Error('Not authorized');
        // Create new Loan object
        const loan = {
            name: formValues.name,
            borrower: formValues.borrower,
            isOwned: formValues.dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned,
            amount: formValues.amount,
            interestRate: formValues.interestRate,
            advanceRate: formValues.advanceRate,
            originationFee: formValues.originationFee,
            term: formValues.term,
            maturityDate: formValues.maturityDate,
            lastAdvanceDate: formValues.lastAdvanceDate,
            minPmtMethod: formValues.minPmtMethod,
            minimumPayment: formValues.minimumPayment,
            payDownPercent: formValues.payDownPercent,
            status: (0, $2dfb8a4751b2faae$export$bbc9c51434c18c55).Active,
            socketComments: formValues.socketComments,
            companyComments: formValues.companyComments,
            files: formValues.files,
            feeBalance: 0,
            adminFee: formValues.adminFee,
            discountFee: formValues.discountFee,
            interestBalance: 0,
            principalBalance: 0,
            principalDateUpdated: formValues.principalDateUpdated,
            assetValue: 0,
            lenders: formValues.lenders
        };
        const response = await (0, $036b2e0dfab38af7$export$bc9e7cacb37e13e9).create(loan);
        return response;
    };
    /**
   * Updates an Loan.
   *
   * @param loan - The Loan to update
   * @returns The updated Loan
   */ update = async (loan)=>{
        const response = await (0, $036b2e0dfab38af7$export$bc9e7cacb37e13e9).update(loan._id, loan);
        (0, $jzre3.runInAction)(()=>this.currentLoan = Object.assign(this.currentLoan ?? {}, response));
        return this.currentLoan;
    };
    /**
   * Deactivates a Loan. This is equivalent to a soft delete.
   *
   * @param loanId - ID of the Loan to deactivate
   * @returns The deactivated Loan
   */ deactivate = async (loanId)=>{
        if (!loanId) return;
        return await (0, $036b2e0dfab38af7$export$bc9e7cacb37e13e9).remove(loanId);
    };
}



var $jzre3 = parcelRequire("jzre3");


class $f9310644f9c439e9$export$688a30d8df3e0b9e extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    menus = {};
    roles = [
        (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin
    ];
    isPublic = false;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            menus: (0, $jzre3.observable),
            roles: (0, $jzre3.observable),
            isPublic: (0, $jzre3.observable)
        });
        // Add menu
        this.addMenu('topbar');
    }
    /**
   * Validates that the given User has permissions to view this menu item.
   *
   * @param user - The User to verify
   * @returns True if the User is allowed to view the menu
   */ shouldRender = (user)=>{
        return user ? !!~this.roles.indexOf('*') || !!user.roles.find((role)=>this.roles.includes(role)) : this.isPublic;
    };
    /**
   * Checks whether a menu exists.
   *
   * @param menuId - The Menu ID to check
   * @returns Boolean indicating the result
   */ validateMenuExistence = (menuId)=>{
        if (this.menus[menuId]) return true;
        else throw new Error('TMenu does not exist');
    };
    /**
   * Fetches a Header menu by ID
   *
   * @param menuId - ID of the menu to retrieve
   * @returns The menu, or undefined if it doesn't exist
   */ getMenu = (menuId)=>{
        // Validate that the menu exists
        this.validateMenuExistence(menuId);
        // Return the menu object
        return this.menus[menuId];
    };
    /**
   * Add a new menu to the page Header.
   *
   * @param menuId - ID of the new Menu item
   * @param isPublic - Whether to display the item to non-logged-in Users
   * @param roles - User roles allowed to view this menu
   * @returns The new menu
   */ addMenu = (menuId, isPublic, roles)=>{
        // Create the new menu
        this.menus[menuId] = {
            isPublic: isPublic || false,
            roles: roles || Object.values((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8)),
            items: [],
            shouldRender: this.shouldRender
        };
        // Return the menu object
        return this.menus[menuId];
    };
    /**
   * Removes a menu from the page Header.
   *
   * @param menuId - ID of the menu to remove
   * @returns The removed menu
   */ removeMenu = (menuId)=>{
        // Validate that the menu exists
        this.validateMenuExistence(menuId);
        // Return the menu object
        delete this.menus[menuId];
    };
    /**
   * Add a menu item to the page Header.
   *
   * @param menuId - ID of the parent menu
   * @param menuItemTitle - Menu item title
   * @param menuItemURL - Navigate to this URL on menu item click
   * @param menuItemType - Menu item type
   * @param menuItemUIRoute - Navigate to this route on menu item click
   * @param isPublic - Whether to display the menu item to non-logged-in Users
   * @param roles - User roles allowed to view this menu item
   * @param position - This menu item's index in the parent menu
   * @returns
   */ addMenuItem = (menuId, menuItemTitle, menuItemURL, menuItemType, menuItemUIRoute, isPublic, roles, position)=>{
        // Validate that the menu exists
        this.validateMenuExistence(menuId);
        // Push new menu item
        this.menus[menuId].items.push({
            title: menuItemTitle,
            link: menuItemURL,
            menuItemType: menuItemType || 'item',
            menuItemClass: menuItemType,
            uiRoute: menuItemUIRoute || '/' + menuItemURL,
            isPublic: isPublic === null || typeof isPublic === 'undefined' ? this.menus[menuId].isPublic : isPublic,
            roles: roles === null || typeof roles === 'undefined' ? this.menus[menuId].roles : roles,
            position: position || 0,
            items: [],
            open: false,
            anchor: null,
            shouldRender: this.shouldRender
        });
        // Return the menu object
        return this.menus[menuId];
    };
    /**
   * Add a submenu item to the page Header.
   *
   * @param menuId - ID of the parent menu
   * @param rootMenuItemURL - URL of the parent menu item
   * @param menuItemTitle - Submenu title
   * @param menuItemURL - Navigate to this URL on submenu click
   * @param menuItemUIRoute - Navigate to this route on submenu click
   * @param isPublic - Whether to display the item to non-logged-in Users
   * @param roles - User roles allowed to view this menu
   * @param position - This submenu's index in the parent menu
   * @returns The updated menu
   */ addSubMenuItem = (menuId, rootMenuItemURL, menuItemTitle, menuItemURL, menuItemUIRoute, isPublic, roles, position)=>{
        // Validate that the menu exists
        this.validateMenuExistence(menuId);
        // Search for menu item
        for(const itemIndex in this.menus[menuId].items)if (this.menus[menuId].items[itemIndex].link === rootMenuItemURL) // Push new submenu item
        this.menus[menuId].items[itemIndex].items.push({
            title: menuItemTitle,
            link: menuItemURL,
            uiRoute: menuItemUIRoute || '/' + menuItemURL,
            isPublic: isPublic === null || typeof isPublic === 'undefined' ? this.menus[menuId].items[itemIndex].isPublic : isPublic,
            roles: roles === null || typeof roles === 'undefined' ? this.menus[menuId].items[itemIndex].roles : roles,
            position: position || 0,
            shouldRender: this.shouldRender
        });
        // Return the menu object
        return this.menus[menuId];
    };
    /**
   * Removes a menu item.
   *
   * @param menuId - Parent menu ID
   * @param menuItemURL - URL of the menu item to remove
   * @returns The removed menu item
   */ removeMenuItem = (menuId, menuItemURL)=>{
        // Validate that the menu exists
        this.validateMenuExistence(menuId);
        // Search for menu item to remove
        const itemIndex = this.menus[menuId].items.findIndex((item)=>item.link === menuItemURL);
        this.menus[menuId].items.splice(itemIndex, 1);
        // Return the menu object
        return this.menus[menuId];
    };
    /**
   * Removes a submenu item.
   *
   * @param menuId - Parent menu ID
   * @param submenuItemURL - URL of the submenu item to remove
   * @returns The removed menu item
   */ removeSubMenuItem = (menuId, submenuItemURL)=>{
        // Validate that the menu exists
        this.validateMenuExistence(menuId);
        // Search for menu item to remove
        for(const itemIndex in this.menus[menuId].items){
            for(const subitemIndex in this.menus[menuId].items[itemIndex].items)if (this.menus[menuId].items[itemIndex].items[subitemIndex].link === submenuItemURL) this.menus[menuId].items[itemIndex].items.splice(parseInt(subitemIndex), 1);
        }
        // Return the menu object
        return this.menus[menuId];
    };
}



var $jzre3 = parcelRequire("jzre3");



class $c0efa7295b56331a$export$44f7db4bc705030d extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    userStore;
    participations;
    constructor(rootStore){
        super(rootStore);
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            participations: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Participations nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Participations', 'participations', (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item, '/participations(/create)?', false, [
            (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin
        ], 4);
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Participations responses.
   *
   * @param participations - An array of Participations to format
   * @returns The formatted Participations
   */ formatParticipationList = (participations)=>{
        // Format
        if (!this.userStore.isAdmin) participations = participations.filter((participation)=>participation.lender._id === this.userStore.user?.company?._id);
        // Return
        return participations;
    };
    /**** Participation CRUD ****/ /**
   * Fetches a list of Participations.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Participations
   */ query = async (query)=>{
        // if (query) query.px = true;
        const response = await (0, $4346f0317e5d5849$export$8790c55037488520).query(query);
        (0, $jzre3.runInAction)(()=>this.participations = this.formatParticipationList(response));
        return this.participations;
    };
}



var $jzre3 = parcelRequire("jzre3");



class $94d0256d95650f34$export$e3f66ae4dba268c1 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    userStore;
    payments;
    currentPayment;
    payoffEstimate;
    isEstimating;
    constructor(rootStore){
        super(rootStore);
        this.userStore = rootStore.userStore;
        (0, $jzre3.makeObservable)(this, {
            payments: (0, $jzre3.observable),
            currentPayment: (0, $jzre3.observable),
            payoffEstimate: (0, $jzre3.observable),
            isEstimating: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Payment nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Payments', 'payments', this.rootStore.userStore.isLender ? (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item : (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, '/payments(/create)?', false, undefined, 3);
        if (!this.rootStore.userStore.isLender) {
            this.rootStore.menuStore.addSubMenuItem('topbar', 'payments', 'List Payments', 'payments');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'payments', 'New Payment', 'payments/create', 'payments/create', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
            ]);
        }
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats List Payments responses.
   *
   * @param payments - An array of Payments to format
   * @returns The formatted Payments
   */ formatPaymentList = (payments)=>payments.map((payment)=>this.formatPayment(payment));
    /**
   * Format Get Payment responses.
   *
   * @param payment - The Payment to format
   * @returns The formatted Payment
   */ formatPayment = (payment)=>{
        // Parse
        if (payment.datePaid) payment.datePaid = new Date(payment.datePaid);
        if (payment.dateDeposited) payment.dateDeposited = new Date(payment.dateDeposited);
        // Return
        return payment;
    };
    /**** Payment CRUD ****/ /**
   * Estimates a Loan's total payoff amount.
   *
   * @param loanId - ID of the Loan to get payoff amount for
   * @param asOfDate - Gets payoff estimate as of a given date
   */ estimatePayoff = async (loanId, asOfDate)=>{
        const response = await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).estimatePayoff({
            loanId: loanId,
            asOfDate: asOfDate
        });
        (0, $jzre3.runInAction)(()=>{
            this.payoffEstimate = undefined;
            this.isEstimating = true;
        });
        let attempts = 0;
        const maxAttempts = 5;
        let backoff = 1000; // in ms
        const getReport = async ()=>{
            try {
                const report = await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).getPayoffReport(response._id);
                (0, $jzre3.runInAction)(()=>{
                    this.payoffEstimate = report?.payoffEstimate;
                    this.isEstimating = false;
                });
            } catch (err) {
                // Poll using exponential backoff
                if (err.status === 400) {
                    attempts += 1;
                    if (attempts > maxAttempts) (0, $jzre3.runInAction)(()=>this.isEstimating = false);
                    else {
                        setTimeout(getReport, backoff);
                        backoff *= 2;
                    }
                }
            }
        };
        getReport();
    };
    /**
   * Fetches a list of Payments.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Payments
   */ query = async (query)=>{
        // if (query) query.px = true;
        const response = await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).query(query);
        (0, $jzre3.runInAction)(()=>this.payments = this.formatPaymentList(response));
        return this.payments;
    };
    /**
   * Fetches a single Payment and sets it as the current Payment.
   *
   * @param paymentId - ID of the Payment to fetch
   * @returns A Payment object
   */ get = async (paymentId)=>{
        const response = await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).get(paymentId);
        (0, $jzre3.runInAction)(()=>this.currentPayment = this.formatPayment(response));
        return this.currentPayment;
    };
    /**
   * Creates an Payment.
   *
   * @param formValues - A populated CreatePaymentForm object
   * @returns The new Payment
   */ create = async (formValues)=>{
        if (!this.userStore.user) throw new Error('Not authorized');
        // Create new Payment object
        const payment = {
            name: formValues.name,
            assetId: formValues.asset._id,
            loan: formValues.loan._id,
            client: formValues.asset.client,
            company: formValues.company._id,
            amount: formValues.amount,
            paymentType: formValues.paymentType,
            datePaid: formValues.datePaid,
            dateDeposited: formValues.dateDeposited,
            notes: formValues.notes,
            effectiveDate: formValues.dateDeposited,
            files: formValues.files
        };
        const response = await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).create(payment);
        return response;
    };
    /**
   * Updates an Payment.
   *
   * @param payment - The Payment to update
   * @returns The updated Payment
   */ update = async (payment)=>{
        const response = await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).update(payment._id, payment);
        (0, $jzre3.runInAction)(()=>this.currentPayment = Object.assign(this.currentPayment ?? {}, response));
        return this.currentPayment;
    };
    /**
   * Removes a Payment.
   *
   * @param paymentId - ID of the Payment to remove
   * @returns The remove Payment
   */ remove = async (paymentId)=>{
        return await (0, $1ffbcb70c7ef9c7b$export$e5ffdf14a094ba8).remove(paymentId);
    };
}




var $jzre3 = parcelRequire("jzre3");




class $519f117b053ef9dc$export$a879e4efa7765ff9 {
    static _interceptor = (transactions)=>{
        const statements = [];
        // Prepare totals (for entire transaction history)
        const totals = {
            feesCharged: 0,
            feeTotal: 0,
            feesPaid: 0,
            interestCharged: 0,
            interestPaid: 0,
            principalPaid: 0,
            currentPrincipal: 0,
            advanceAmount: 0,
            adjustmentAmount: 0,
            paymentAmount: 0
        };
        let allAdjustments = true;
        // Pre-process the data
        if (transactions.length) {
            let transaction;
            for(const txn in transactions){
                transaction = transactions[txn];
                // Push all statement transactions to the Statements array
                if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement) statements.push(transaction);
                // Skip the transaction if it's an adjustment
                if (transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment) {
                    // Set the 'list is all adjustments' flag to false
                    allAdjustments = false;
                    // Define some item-specific totals
                    if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance) {
                        transaction.advanceAmount = transaction.amount;
                        totals.advanceAmount += transaction.amount;
                    } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment) {
                        transaction.paymentAmount = transaction.amount;
                        totals.paymentAmount += transaction.amount;
                    }
                    // Total fees
                    transaction.feeTotal = transaction.fees + transaction.lateFee;
                    totals.feeTotal += transaction.feeTotal;
                    // Fees charged
                    totals.feesCharged += transaction.feeTotal;
                    // Fees due
                    transaction.feesDue = transaction.feeBalance + transaction.feeTotal;
                    // Fees paid
                    if (transaction.appliedToFees) {
                        transaction.feesDue -= transaction.appliedToFees;
                        totals.feesPaid += transaction.appliedToFees;
                    }
                    // Interest due
                    transaction.interestDue = transaction.interestBalance + transaction.interestCharge;
                    totals.interestCharged += transaction.interestCharge;
                    // Interest paid
                    if (transaction.appliedToInterest) {
                        transaction.interestDue -= transaction.appliedToInterest;
                        totals.interestPaid += transaction.appliedToInterest;
                    }
                    // Principal balance
                    if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance) {
                        transaction.newPrincipalBalance = transaction.principalBalance + transaction.amount;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                    } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment) {
                        transaction.newPrincipalBalance = transaction.principalBalance - transaction.appliedToPrincipal;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                        totals.principalPaid += transaction.appliedToPrincipal;
                    } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment) {
                        transaction.newPrincipalBalance = transaction.principalBalance;
                        totals.currentPrincipal = transaction.newPrincipalBalance;
                    }
                }
            }
            if (transactions && transactions[0]) {
                if (transactions[0].newPrincipalBalance) totals.currentPrincipal = transactions[0].newPrincipalBalance;
                if (transactions[0].assetValue) totals.currentAssets = transactions[0].assetValue;
                if (transactions[0].currentAvailableCredit) totals.currentAvailableCredit = transactions[0].currentAvailableCredit;
            }
        }
        // Return the data
        return {
            transactions: transactions,
            totals: totals,
            allAdjustments: allAdjustments
        };
    };
    /**
   * Get Loan Transactions
   */ static async query(req) {
        return this._interceptor(await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'GET',
            url: '/transactions',
            query: req
        }));
    }
}



class $73c52116742e47d4$export$f1f8dce61d1eef6c extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    transactions;
    headlines;
    loans;
    totals;
    statements;
    currentStatement;
    currentLender;
    allAdjustments;
    totalAvailableCredit;
    totalCurrentAvailableCredit;
    totalBeginPrincipalBalance;
    totalEndingPrincipalBalance;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            transactions: (0, $jzre3.observable),
            headlines: (0, $jzre3.observable),
            loans: (0, $jzre3.observable),
            totals: (0, $jzre3.observable),
            statements: (0, $jzre3.observable),
            currentStatement: (0, $jzre3.observable),
            currentLender: (0, $jzre3.observable),
            allAdjustments: (0, $jzre3.observable),
            totalAvailableCredit: (0, $jzre3.observable),
            totalCurrentAvailableCredit: (0, $jzre3.observable),
            totalBeginPrincipalBalance: (0, $jzre3.observable),
            totalEndingPrincipalBalance: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Statement nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        if (this.rootStore.userStore.isAdmin || this.rootStore.userStore.isLender) {
            this.rootStore.menuStore.addMenuItem('topbar', 'Statements', 'statements', (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Dropdown, 'statements', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor
            ], 2);
            this.rootStore.menuStore.addSubMenuItem('topbar', 'statements', 'Deal Statements', 'statements');
            this.rootStore.menuStore.addSubMenuItem('topbar', 'statements', 'Investor Statements', 'statements/investors', 'statements/investors', false, [
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
            ]);
        } else this.rootStore.menuStore.addMenuItem('topbar', 'Statements', 'statements', (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item, '/statements', false, [
            (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
            (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
        ]);
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Utility Methods ****/ /**
   * Retrieves and formats Loan Statements from a list of Transactions.
   *
   * @param transactions - An array of Transactions to parse
   * @returns The formatted Loan Statements
   */ formatLoanStatements = (transactions)=>{
        return transactions.filter((transaction)=>transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement);
    };
    /**
   * Retrieves and formats Lender Statements from a list of Transactions.
   *
   * @param transactions - An array of Transactions to parse
   * @returns The formatted Lender Statements
   */ formatLenderStatements = (transactions)=>{
        const statementTxns = transactions.filter((transaction)=>transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement).sort((a, b)=>new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime());
        // Prepare statements array
        const statements = [];
        let previousDate;
        let txnDate;
        // Loop through transactions looking for statement txn dates
        for (const statement of statementTxns){
            txnDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(statement.effectiveDate).format('YYYY-MM');
            // If this month hasn't already been added...
            if (txnDate !== previousDate) {
                previousDate = txnDate;
                statements.push(statement);
            }
        }
        return statements;
    };
    /**** Loan Statement CRUD ****/ /**
   * Fetches and stores Loan Statement data for the given Loan.
   *
   * @param loanId - ID of the Loan to fetch Statements for
   */ queryLoanStatements = async (loanId)=>{
        if (!loanId) return;
        const { transactions: transactions } = await (0, $6ab62f0bff533817$export$31e7a36e1317b801).query({
            loanId: loanId
        });
        const statements = this.formatLoanStatements(transactions);
        (0, $jzre3.runInAction)(()=>{
            this.statements = statements;
        });
    };
    /**
   * Fetches a Loan Statement and sets associated transactions, headers, and totals.
   *
   * @param loanId - ID of the Loan to fetch Statements for
   * @param month - Statement month to fetch. Value should be a string in the format 'YYYY-MM'
   */ getLoanStatement = async (loanId, month)=>{
        const m = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(month, 'YYYY-MM');
        const startDate = m.startOf('month');
        const endDate = m.endOf('month');
        await Promise.all([
            this.rootStore.statementTransactionsStore.query({
                loanId: loanId,
                start: startDate.toISOString(),
                end: endDate.toISOString()
            }),
            this.rootStore.statementHeadlinesStore.get({
                loanId: loanId,
                date: startDate.toISOString()
            })
        ]);
        (0, $jzre3.runInAction)(()=>{
            this.headlines = this.rootStore.statementHeadlinesStore.statementHeadlines;
            this.transactions = this.rootStore.statementTransactionsStore.transactions;
            this.totals = this.rootStore.statementTransactionsStore.totals;
            this.statements = this.rootStore.statementTransactionsStore.statements;
        });
    };
    /**** Lender Statement CRUD ****/ /**
   * Fetches and stores Lender Statement data for the given Lender.
   *
   * @param lenderId - ID of the Lender to fetch Statements for
   */ queryLenderStatements = async (lenderId)=>{
        if (!lenderId) return;
        const { transactions: transactions, totals: totals } = await (0, $519f117b053ef9dc$export$a879e4efa7765ff9).query({
            lenderId: lenderId
        });
        (0, $jzre3.runInAction)(()=>{
            this.transactions = transactions;
            this.totals = totals;
            this.statements = this.formatLenderStatements(transactions);
        });
    };
    /**
   * Fetches a Lender Statement and sets associated transactions, headers, and totals.
   *
   * @param lenderId - ID of the Lender to fetch Statements for
   * @param month - Statement month to fetch. Value should be a string in the format 'YYYY-MM'
   */ getLenderStatement = async (lenderId, month)=>{
        const m = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(month, 'YYYY-MM');
        const startDate = m.startOf('month');
        const endDate = m.endOf('month');
        const [lender] = await Promise.all([
            this.rootStore.lenderStore.get(lenderId),
            this.rootStore.lenderStatementTransactionsStore.query({
                lenderId: lenderId,
                start: startDate.toISOString(),
                end: endDate.toISOString()
            }),
            this.rootStore.lenderStatementHeadlinesStore.get({
                lenderId: lenderId,
                date: startDate.toISOString()
            })
        ]);
        const transactions = this.rootStore.lenderStatementTransactionsStore.transactions ?? [];
        const totals = this.rootStore.lenderStatementTransactionsStore.totals;
        let totalAvailableCredit = 0;
        let totalCurrentAvailableCredit = 0;
        let totalBeginPrincipalBalance = 0;
        let totalEndingPrincipalBalance = 0;
        // Get participated loans list
        const loans = [];
        const txnSorter = (a, b)=>new Date(a.sequenceNumber) - new Date(b.sequenceNumber);
        if (lender && lender.participations.length) for(const item in lender.participations){
            const listItem = {};
            const participation = lender.participations[item];
            // Get the loan name
            const loanTxns = [];
            let beginPrincipalBalance = 0;
            let endPrincipalBalance = 0;
            let currentAvailableCredit = 0;
            let availableCredit = 0;
            const totals = {
                advanceAmount: 0,
                feesCharged: 0,
                paymentAmount: 0,
                feesPaid: 0,
                interestPaid: 0,
                principalPaid: 0
            };
            if (transactions.length) {
                // Sort the transactions
                transactions.sort(txnSorter);
                // Go through transactions and pull the ones for that loan
                for (const transaction of transactions)if (transaction.loanName === participation.loan.name) {
                    // Calculate loan totals
                    if (transaction.advanceAmount) totals.advanceAmount += transaction.advanceAmount;
                    if (transaction.fees) totals.feesCharged += transaction.fees;
                    if (transaction.paymentAmount) totals.paymentAmount += transaction.paymentAmount;
                    if (transaction.appliedToFees) totals.feesPaid += transaction.appliedToFees;
                    if (transaction.appliedToInterest) totals.interestPaid += transaction.appliedToInterest;
                    if (transaction.appliedToPrincipal) totals.principalPaid += transaction.appliedToPrincipal;
                    loanTxns.push(transaction);
                }
            }
            if (loanTxns.length) {
                // Get the earliest transaction's principal balance
                beginPrincipalBalance = loanTxns[0].principalBalance;
                // Get the latest transaction's final principal balance
                endPrincipalBalance = loanTxns[loanTxns.length - 1].newPrincipalBalance ?? loanTxns[loanTxns.length - 1].principalBalance;
                // Get the current available credit for this loan
                availableCredit = loanTxns[loanTxns.length - 1].assetValue * participation.loan.advanceRate;
                currentAvailableCredit = availableCredit - loanTxns[loanTxns.length - 1].principalBalance;
                // Loan totals
                listItem.totals = totals;
                // Statement totals
                totalAvailableCredit += availableCredit;
                totalCurrentAvailableCredit += currentAvailableCredit;
                totalBeginPrincipalBalance += beginPrincipalBalance;
                totalEndingPrincipalBalance += endPrincipalBalance;
            }
            // Add loan name
            listItem.name = participation.loan.name;
            // Store loan txns in loans array
            listItem.loanTxns = loanTxns;
            loans.push(listItem);
        }
        (0, $jzre3.runInAction)(()=>{
            this.headlines = this.rootStore.lenderStatementHeadlinesStore.lenderStatementHeadlines;
            this.statements = this.rootStore.lenderStatementTransactionsStore.statements;
            this.allAdjustments = this.rootStore.lenderStatementTransactionsStore.allAdjustments;
            this.transactions = transactions;
            this.totals = totals;
            this.loans = loans;
            this.currentLender = lender;
            this.totalAvailableCredit = totalAvailableCredit;
            this.totalCurrentAvailableCredit = totalCurrentAvailableCredit;
            this.totalBeginPrincipalBalance = totalBeginPrincipalBalance;
            this.totalEndingPrincipalBalance = totalEndingPrincipalBalance;
        });
    };
}



var $jzre3 = parcelRequire("jzre3");



class $a185c92bb930e2b4$export$dfb9487ae5bd2023 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    transactions;
    statements;
    totals;
    allAdjustments;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            transactions: (0, $jzre3.observable),
            statements: (0, $jzre3.observable),
            totals: (0, $jzre3.observable),
            allAdjustments: (0, $jzre3.observable)
        });
    }
    /**** Data Processing ****/ /**
   * Perform calculations and get Transaction totals.
   *
   * @param transactions - List of Transactions to total
   * @returns Transaction and Statement lists, totals, and related flags
   */ calculateTotals = (transactions)=>{
        const statements = [];
        const totals = {
            feesCharged: 0,
            feeTotal: 0,
            feesPaid: 0,
            interestCharged: 0,
            interestPaid: 0,
            principalPaid: 0,
            currentPrincipal: 0,
            advanceAmount: 0,
            adjustmentAmount: 0,
            paymentAmount: 0
        };
        let allAdjustments = false;
        for (const transaction of transactions){
            // Push all statement transactions to the Statements array
            if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement) statements.push(transaction);
            // Don't show adjustments
            if (transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment) {
                // Set the 'list is all adjustments' flag to false
                allAdjustments = false;
                // Define some item-specific variables
                if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance) {
                    transaction.advanceAmount = transaction.amount;
                    totals.advanceAmount += transaction.amount;
                } else if (transaction.__t === 'payments') {
                    transaction.paymentAmount = transaction.amount;
                    totals.paymentAmount += transaction.amount;
                }
                // Fees due
                transaction.feesDue = (transaction.feeBalance ?? 0) + (transaction.originationFee ?? 0) + (transaction.diligenceFee ?? 0) + (transaction.lateFee ?? 0) + (transaction.facilityFee ?? 0) + (transaction.adminFee ?? 0);
                // Fees paid
                if (transaction.appliedToFees) {
                    transaction.feesDue -= transaction.appliedToFees;
                    totals.feesPaid += transaction.appliedToFees;
                }
                // Interest due
                transaction.interestDue = (transaction.interestBalance ?? 0) + (transaction.interestCharge ?? 0);
                // Interest paid
                if (transaction.appliedToInterest) {
                    transaction.interestDue -= transaction.appliedToInterest;
                    totals.interestPaid += transaction.appliedToInterest;
                }
                // Principal balance
                if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance) {
                    transaction.newPrincipalBalance = (transaction.principalBalance ?? 0) + transaction.amount;
                    totals.currentPrincipal = transaction.newPrincipalBalance;
                } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment) {
                    transaction.newPrincipalBalance = (transaction.principalBalance ?? 0) - transaction.appliedToPrincipal;
                    totals.currentPrincipal = transaction.newPrincipalBalance;
                    totals.principalPaid += transaction.appliedToPrincipal;
                } else if (transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment) transaction.newPrincipalBalance = transaction.principalBalance ?? 0;
                totals.currentPrincipal = transaction.newPrincipalBalance ?? 0;
            }
            if (transactions && transactions[0]) {
                if (transactions[0].newPrincipalBalance) totals.currentPrincipal = transactions[0].newPrincipalBalance;
                if (transactions[0].assetValue) totals.currentAssets = transactions[0].assetValue;
                if (transactions[0].currentAvailableCredit) totals.currentAvailableCredit = transactions[0].currentAvailableCredit;
            }
        }
        return {
            transactions: transactions,
            statements: statements,
            totals: totals,
            allAdjustments: allAdjustments
        };
    };
    /**** Statement Transactions CRUD ****/ /**
   * Fetches and caches a list of Statements and their Transactions.
   *
   * @param filters - Filters to use when fetching Transactions
   * @returns Transaction and Statement lists, totals, and related flags
   */ query = async (filters)=>{
        if (!filters.loanId) return;
        // Execute the query and get the Transactions list
        const response = await (0, $6ab62f0bff533817$export$31e7a36e1317b801).query(filters);
        const { transactions: transactions, statements: statements, totals: totals, allAdjustments: allAdjustments } = this.calculateTotals(response.transactions);
        // Sort the history by date (newest at index 0)
        transactions.sort((a, b)=>b.sequenceNumber - a.sequenceNumber);
        (0, $jzre3.runInAction)(()=>{
            this.transactions = transactions;
            this.statements = statements;
            this.totals = totals;
            this.allAdjustments = allAdjustments;
        });
    };
}



var $jzre3 = parcelRequire("jzre3");



class $1a4ad9f1387e500b$export$ec10b5b27014d36a extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    didInitMenu = false;
    transactions;
    totals;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            transactions: (0, $jzre3.observable),
            totals: (0, $jzre3.observable)
        });
    }
    /**
   * Adds Transaction nav menu items to the app header.
   */ initMenuItems = ()=>{
        if (this.didInitMenu || !this.rootStore.userStore.user) return;
        // Add menu items
        this.rootStore.menuStore.addMenuItem('topbar', 'Transactions', 'transactions', (0, $dff1c8c0bf270f18$export$c79d5012e88c1e24).Item, '/transactions', false, undefined, 1);
        (0, $jzre3.runInAction)(()=>this.didInitMenu = true);
    };
    /**** Data Processing ****/ /**
   * Formats Transactions query response.
   *
   * @param transactions - An array of Transactions to format
   * @returns The formatted Transactions
   */ formatQueryResponses = (transactions)=>{
        // Sort (newest items first)
        transactions.sort((a, b)=>new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime());
        // Return
        return transactions;
    };
    /**** Transactions Services ****/ /**
   * Fetches and saves Transactions ledger data.
   *
   * @param options - Required query options, including whether to retrieve Loan or Lender Transactions
   */ query = async (options)=>{
        if (!options.loanId) return;
        const { transactions: transactions, totals: totals } = await (0, $accbdc2bb764768e$export$985c8653d1398450).query(options);
        (0, $jzre3.runInAction)(()=>{
            this.transactions = transactions;
            this.totals = totals;
        });
    };
}





var $jzre3 = parcelRequire("jzre3");



class $c1256e4b4682f909$export$ec463281936fb630 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    transactions;
    statements;
    totals;
    allAdjustments;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            transactions: (0, $jzre3.observable),
            statements: (0, $jzre3.observable),
            totals: (0, $jzre3.observable),
            allAdjustments: (0, $jzre3.observable)
        });
    }
    /**** Lender Statement Transactions CRUD ****/ /**
   * Fetches and caches a list of Lender Statements and their Transactions.
   *
   * @param filters - Filters to use when fetching Transactions
   * @returns The Lender Statement Transactions list
   */ query = async (filters)=>{
        if (!filters.lenderId) return;
        // Execute the query and get the Transactions list
        const { transactions: transactions, totals: totals, allAdjustments: allAdjustments } = await (0, $519f117b053ef9dc$export$a879e4efa7765ff9).query(filters);
        const statements = transactions.filter((transaction)=>transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement);
        (0, $jzre3.runInAction)(()=>{
            this.transactions = transactions;
            this.statements = statements;
            this.totals = totals;
            this.allAdjustments = allAdjustments;
        });
    };
}




var $jzre3 = parcelRequire("jzre3");



class $5cfb6645572bda10$export$43517e359c54197f {
    /**
   * Forgot Password
   */ static async forgotPassword(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/auth/forgot',
            body: req
        });
        return res;
    }
    /**
   * Reset Password
   */ static async resetPassword(token, req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/auth/reset/{token}',
            path: {
                token: token
            },
            body: req
        });
        return res;
    }
    /**
   * Update Password
   */ static async updatePassword(req) {
        const res = await (0, $6c9b670123ce891e$export$b5fe3f66a567bec0)((0, $a387df8f417cb087$export$3bbbb17165d6e0ef), {
            method: 'POST',
            url: '/users/password',
            body: req
        });
        return res;
    }
}




class $e07ab0ab628414f5$export$1b645105c1ac05e1 extends (0, $9329bf06553946c4$export$f6772e87ca157ef) {
    _user;
    users;
    currentUser;
    success = null;
    error = null;
    submitted = false;
    constructor(rootStore){
        super(rootStore);
        (0, $jzre3.makeObservable)(this, {
            _user: (0, $jzre3.observable),
            users: (0, $jzre3.observable),
            currentUser: (0, $jzre3.observable),
            success: (0, $jzre3.observable),
            error: (0, $jzre3.observable),
            submitted: (0, $jzre3.observable)
        });
    }
    get user() {
        if (!this._user) this.restoreFromStorage();
        return this._user;
    }
    get isAdmin() {
        return this.user && this.hasRole((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin);
    }
    get isLender() {
        return this.user && this.hasRole((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor);
    }
    get isCompany() {
        return this.user && this.hasRole((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company);
    // NOTE: this is how it was originally:
    // return this.user && !this.isAdmin && !this.isLender;
    }
    hasRole = (role)=>!this.user ? false : this.user.roles?.includes(role);
    restoreFromStorage = ()=>{
        const user = (0, $ca0b580bae42961b$export$a79e7ef8c396bb0e)();
        if (user) (0, $jzre3.runInAction)(()=>this._user = user);
    };
    /**** User CRUD ****/ /**
   * Fetches a list of Users.
   *
   * @param query - Optional query to send with the API request
   * @returns An array of Users
   */ query = async (query)=>{
        if (query) query.px = true;
        const response = await (0, $1376736a8aed5dd4$export$a81c579a392aa9d2).query(query);
        (0, $jzre3.runInAction)(()=>this.users = response);
        return this.users;
    };
    /**
   * Fetches a single User and sets it as the current User.
   *
   * @param userId - ID of the User to fetch
   * @returns A User object
   */ get = async (userId)=>{
        const response = await (0, $1376736a8aed5dd4$export$a81c579a392aa9d2).get(userId);
        (0, $jzre3.runInAction)(()=>this.currentUser = response);
        return this.currentUser;
    };
    /**
   * Creates an User.
   *
   * @param formValues - A populated CreateUserForm object
   * @returns The new User
   */ create = async (formValues)=>{
        if (!this.user) throw new Error('Not authorized');
        // Create new User object
        const user = {
            username: formValues.username,
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            displayName: formValues.firstName + ' ' + formValues.lastName,
            email: formValues.email,
            password: formValues.password,
            roles: [
                formValues.role
            ],
            company: formValues.company,
            status: (0, $989a2d26b0fc80b4$export$a82073022ded66e8).Active
        };
        const response = await (0, $1376736a8aed5dd4$export$a81c579a392aa9d2).create(user);
        return response;
    };
    /**
   * Updates an User.
   *
   * @param user - The User to update
   * @returns The updated User
   */ update = async (user)=>{
        if (user.roles.includes((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin)) user.company = null;
        else if (user.company && typeof user.company !== 'string') user.company = user?.company?._id;
        const response = await (0, $1376736a8aed5dd4$export$a81c579a392aa9d2).update(user._id, user);
        (0, $jzre3.runInAction)(()=>this.currentUser = Object.assign(this.currentUser ?? {}, response));
        return this.currentUser;
    };
    /**
   * Removes a User.
   *
   * @param userId - ID of the User to remove
   * @returns The remove User
   */ remove = async (userId)=>{
        return await (0, $1376736a8aed5dd4$export$a81c579a392aa9d2).remove(userId);
    };
    /**** Authentication Controller ****/ /**
   * Attempts to sign in using the given credentials.
   *
   * @param username - Username to log into
   * @param password - User password
   */ signin = async (username, password)=>{
        const response = await (0, $415208479c772fab$export$a15b8b4ccae62017).signin({
            username: username,
            password: password
        });
        (0, $jzre3.runInAction)(()=>this._user = response);
        (0, $ca0b580bae42961b$export$97851c88c0bf33aa)(response);
    };
    signout = async ()=>{
        try {
            await (0, $415208479c772fab$export$a15b8b4ccae62017).signout();
            (0, $jzre3.runInAction)(()=>this._user = undefined);
            (0, $ca0b580bae42961b$export$b0ef8831976e9d68)();
        } catch (err) {
            if (err.status === 401) {
                (0, $jzre3.runInAction)(()=>this._user = undefined);
                (0, $ca0b580bae42961b$export$b0ef8831976e9d68)();
            }
        }
    };
    /**** Settings Controller ****/ /**
   * Lets non-Admin Users update their own data.
   *
   * @param user - The User to update
   * @param isValid - Whether the data has been validated
   * @returns The updated User
   */ updateUserProfile = async (user, isValid)=>{
        if (isValid) {
            (0, $jzre3.runInAction)(()=>this.success = this.error = null);
            try {
                const response = await (0, $1376736a8aed5dd4$export$a81c579a392aa9d2).update(user._id, user);
                (0, $jzre3.runInAction)(()=>this.success = true);
                return response;
            } catch (response) {
                (0, $jzre3.runInAction)(()=>this.error = response.data.message);
            }
        } else (0, $jzre3.runInAction)(()=>this.submitted = true);
    };
    /**
   * Changes a User's password. Only the User whose password is being changed may perform this action.
   *
   * @param currentPassword - User's current password
   * @param newPassword - The new password
   * @param verifyPassword - Should match `newPassword`
   * @returns The update password response
   */ changeUserPassword = async (currentPassword, newPassword, verifyPassword)=>{
        (0, $jzre3.runInAction)(()=>this.success = this.error = null);
        try {
            const response = await (0, $5cfb6645572bda10$export$43517e359c54197f).updatePassword({
                currentPassword: currentPassword,
                newPassword: newPassword,
                verifyPassword: verifyPassword
            });
            (0, $jzre3.runInAction)(()=>this.success = true);
            return response;
        } catch (response) {
            (0, $jzre3.runInAction)(()=>this.error = response.message);
        }
    };
    /**** Passwords Controller ****/ /**
   * Request a password reset token be generated and sent to the given User's email address.
   *
   * @param username - User to start password reset process for
   */ askForPasswordReset = async (username)=>{
        return await (0, $5cfb6645572bda10$export$43517e359c54197f).forgotPassword({
            username: username
        });
    };
    /**
   * Changes the password of a user who requested a password reset.
   *
   * @param token - Password reset token
   * @param newPassword - The new password
   * @param verifyPassword - Should match `newPassword`
   */ resetUserPassword = async (token, newPassword, verifyPassword)=>{
        const response = await (0, $5cfb6645572bda10$export$43517e359c54197f).resetPassword(token, {
            newPassword: newPassword,
            verifyPassword: verifyPassword
        });
        (0, $jzre3.runInAction)(()=>this._user = response);
        return response;
    };
}


class $eb31ecbbc1726c5e$export$5b19c597f1926e87 {
    userStore;
    menuStore;
    accountStore;
    advanceStore;
    assetStore;
    adjustmentStore;
    bulkStore;
    companyStore;
    dateStore;
    filterStore;
    lenderStore;
    loanStore;
    participationStore;
    paymentStore;
    headlinesStore;
    statementHeadlinesStore;
    lenderStatementHeadlinesStore;
    transactionStore;
    statementTransactionsStore;
    lenderStatementTransactionsStore;
    statementStore;
    alertStore;
    headerStore;
    constructor(){
        this.userStore = new (0, $e07ab0ab628414f5$export$1b645105c1ac05e1)(this);
        this.menuStore = new (0, $f9310644f9c439e9$export$688a30d8df3e0b9e)(this);
        this.accountStore = new (0, $4bf368a23258265b$export$5b1ba45d47672b60)(this);
        this.advanceStore = new (0, $2596541f68fe0e6f$export$59f5c3bf9b610a7a)(this);
        this.assetStore = new (0, $39ee393095dda7e7$export$dbfcb0e671e479ed)(this);
        this.adjustmentStore = new (0, $2e5b36618c278ea8$export$2185f9289be2edc)(this);
        this.bulkStore = new (0, $46e720aa374c775f$export$b68d8f720b7dd307)(this);
        this.companyStore = new (0, $68401467a547d5a7$export$649406674d76fc3f)(this);
        this.dateStore = new (0, $e8db264aa4d6d62d$export$753647e56e513114)(this);
        this.lenderStore = new (0, $3c40d701da4cefbc$export$a7a808ac31b8e363)(this);
        this.loanStore = new (0, $2814aa2805833a6c$export$c5e2446288acf619)(this);
        this.filterStore = new (0, $3e984327d351c841$export$d76397ee299c7ea4)(this);
        this.participationStore = new (0, $c0efa7295b56331a$export$44f7db4bc705030d)(this);
        this.paymentStore = new (0, $94d0256d95650f34$export$e3f66ae4dba268c1)(this);
        this.headlinesStore = new (0, $4efa80cba9115fa0$export$c174125e28244bee)(this);
        this.statementHeadlinesStore = new (0, $da31860026caba0c$export$e5e982b3f8cd34fa)(this);
        this.lenderStatementHeadlinesStore = new (0, $9163b0ac45868bd8$export$4911a02fd83e3bfa)(this);
        this.transactionStore = new (0, $1a4ad9f1387e500b$export$ec10b5b27014d36a)(this);
        this.statementTransactionsStore = new (0, $a185c92bb930e2b4$export$dfb9487ae5bd2023)(this);
        this.lenderStatementTransactionsStore = new (0, $c1256e4b4682f909$export$ec463281936fb630)(this);
        this.statementStore = new (0, $73c52116742e47d4$export$f1f8dce61d1eef6c)(this);
        this.alertStore = new (0, $9130148a45682035$export$49ce1c6a489d392a)(this);
        this.headerStore = new (0, $fc0fef0ad7995cad$export$daa0810644ffe016)(this);
        (0, $jzre3.makeObservable)(this, {
            userStore: (0, $jzre3.observable),
            menuStore: (0, $jzre3.observable),
            accountStore: (0, $jzre3.observable),
            advanceStore: (0, $jzre3.observable),
            assetStore: (0, $jzre3.observable),
            adjustmentStore: (0, $jzre3.observable),
            bulkStore: (0, $jzre3.observable),
            companyStore: (0, $jzre3.observable),
            dateStore: (0, $jzre3.observable),
            filterStore: (0, $jzre3.observable),
            lenderStore: (0, $jzre3.observable),
            loanStore: (0, $jzre3.observable),
            participationStore: (0, $jzre3.observable),
            paymentStore: (0, $jzre3.observable),
            headlinesStore: (0, $jzre3.observable),
            statementHeadlinesStore: (0, $jzre3.observable),
            lenderStatementHeadlinesStore: (0, $jzre3.observable),
            transactionStore: (0, $jzre3.observable),
            statementTransactionsStore: (0, $jzre3.observable),
            lenderStatementTransactionsStore: (0, $jzre3.observable),
            statementStore: (0, $jzre3.observable),
            alertStore: (0, $jzre3.observable),
            headerStore: (0, $jzre3.observable)
        });
    }
}


const $1da4b8b758f1a116$var$RootContext = /*#__PURE__*/ (0, $lVd4O.createContext)(undefined);
const $1da4b8b758f1a116$export$5bc58655df8395ab = ()=>{
    const context = (0, $lVd4O.useContext)($1da4b8b758f1a116$var$RootContext);
    if (context === undefined) throw new Error('useRootStore must be used within RootContextProvider');
    return context;
};
const $1da4b8b758f1a116$export$17d4feea532c39aa = ()=>{
    const { accountStore: accountStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (accountStore === undefined) throw new Error('useAccountStore must be used within RootContextProvider');
    return accountStore;
};
const $1da4b8b758f1a116$export$8808bffeb1795f83 = ()=>{
    const { adjustmentStore: adjustmentStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (adjustmentStore === undefined) throw new Error('useAdjustmentStore must be used within RootContextProvider');
    return adjustmentStore;
};
const $1da4b8b758f1a116$export$ed879bc79c1297c7 = ()=>{
    const { advanceStore: advanceStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (advanceStore === undefined) throw new Error('useAdvanceStore must be used within RootContextProvider');
    return advanceStore;
};
const $1da4b8b758f1a116$export$c345cf07ab3c1b9e = ()=>{
    const { alertStore: alertStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (alertStore === undefined) throw new Error('useAlertStore must be used within RootContextProvider');
    return alertStore;
};
const $1da4b8b758f1a116$export$ad85ecc5ecb98730 = ()=>{
    const { assetStore: assetStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (assetStore === undefined) throw new Error('useAssetStore must be used within RootContextProvider');
    return assetStore;
};
const $1da4b8b758f1a116$export$18a8f52cc7ad1ddc = ()=>{
    const { bulkStore: bulkStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (bulkStore === undefined) throw new Error('useBulkStore must be used within RootContextProvider');
    return bulkStore;
};
const $1da4b8b758f1a116$export$2242c4b86ec3e2c3 = ()=>{
    const { companyStore: companyStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (companyStore === undefined) throw new Error('useCompanyStore must be used within RootContextProvider');
    return companyStore;
};
const $1da4b8b758f1a116$export$3f917fb33f736152 = ()=>{
    const { dateStore: dateStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (dateStore === undefined) throw new Error('useDateStore must be used within RootContextProvider');
    return dateStore;
};
const $1da4b8b758f1a116$export$875b296eac126ec2 = ()=>{
    const { filterStore: filterStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (filterStore === undefined) throw new Error('useFilterStore must be used within RootContextProvider');
    return filterStore;
};
const $1da4b8b758f1a116$export$b7680113a886673e = ()=>{
    const { headerStore: headerStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (headerStore === undefined) throw new Error('useHeaderStore must be used within RootContextProvider');
    return headerStore;
};
const $1da4b8b758f1a116$export$8642d496b95aa4e9 = ()=>{
    const { headlinesStore: headlinesStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (headlinesStore === undefined) throw new Error('useHeadlinesStore must be used within RootContextProvider');
    return headlinesStore;
};
const $1da4b8b758f1a116$export$9e981f97ad523833 = ()=>{
    const { lenderStore: lenderStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (lenderStore === undefined) throw new Error('useLenderStore must be used within RootContextProvider');
    return lenderStore;
};
const $1da4b8b758f1a116$export$2069e70401eb38b3 = ()=>{
    const { loanStore: loanStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (loanStore === undefined) throw new Error('useLoanStore must be used within RootContextProvider');
    return loanStore;
};
const $1da4b8b758f1a116$export$d0c52745bc4840d7 = ()=>{
    const { menuStore: menuStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (menuStore === undefined) throw new Error('useMenuStore must be used within RootContextProvider');
    return menuStore;
};
const $1da4b8b758f1a116$export$57265aab020abcea = ()=>{
    const { participationStore: participationStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (participationStore === undefined) throw new Error('useParticipationStore must be used within RootContextProvider');
    return participationStore;
};
const $1da4b8b758f1a116$export$f38831fc90eda5d5 = ()=>{
    const { paymentStore: paymentStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (paymentStore === undefined) throw new Error('usePaymentStore must be used within RootContextProvider');
    return paymentStore;
};
const $1da4b8b758f1a116$export$5ce405a4422ef92 = ()=>{
    const { statementStore: statementStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (statementStore === undefined) throw new Error('useStatementStore must be used within RootContextProvider');
    return statementStore;
};
const $1da4b8b758f1a116$export$86ffe3fcb746aece = ()=>{
    const { statementHeadlinesStore: statementHeadlinesStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (statementHeadlinesStore === undefined) throw new Error('useStatementHeadlinesStore must be used within RootContextProvider');
    return statementHeadlinesStore;
};
const $1da4b8b758f1a116$export$31ae50f0086b267 = ()=>{
    const { lenderStatementHeadlinesStore: lenderStatementHeadlinesStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (lenderStatementHeadlinesStore === undefined) throw new Error('useLenderStatementHeadlinesStore must be used within RootContextProvider');
    return lenderStatementHeadlinesStore;
};
const $1da4b8b758f1a116$export$70066748493aeb79 = ()=>{
    const { statementTransactionsStore: statementTransactionsStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (statementTransactionsStore === undefined) throw new Error('useStatementTransactionsStore must be used within RootContextProvider');
    return statementTransactionsStore;
};
const $1da4b8b758f1a116$export$f325c401982a590a = ()=>{
    const { lenderStatementTransactionsStore: lenderStatementTransactionsStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (lenderStatementTransactionsStore === undefined) throw new Error('useLenderStatementTransactionsStore must be used within RootContextProvider');
    return lenderStatementTransactionsStore;
};
const $1da4b8b758f1a116$export$935e650b2b7e3ea8 = ()=>{
    const { transactionStore: transactionStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (transactionStore === undefined) throw new Error('useTransactionStore must be used within RootContextProvider');
    return transactionStore;
};
const $1da4b8b758f1a116$export$cc885caaa8b7ab4e = ()=>{
    const { userStore: userStore } = $1da4b8b758f1a116$export$5bc58655df8395ab();
    if (userStore === undefined) throw new Error('useUserStore must be used within RootContextProvider');
    return userStore;
};
const $1da4b8b758f1a116$export$773ef8ccef99e88a = ({ children: children })=>{
    const store = new (0, $eb31ecbbc1726c5e$export$5b19c597f1926e87)();
    return /*#__PURE__*/ (0, $iO5o7.jsx)($1da4b8b758f1a116$var$RootContext.Provider, {
        value: store,
        children: children
    });
};




const $793f41df01b030e4$export$8b686e0d2df13a76 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const adjustmentStore = (0, $1da4b8b758f1a116$export$8808bffeb1795f83)();
    /** State **/ const [adjustments, setAdjustments] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (adjustments) {
            const list = adjustments.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        adjustments,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.assetValue = 0;
        totals.amount = 0;
        totals.resultingAssetValue = 0;
        const adjustments = data.map((adjustment)=>{
            // Calculate Adjustment values
            if (adjustment.assetValue) adjustment.resultingAssetValue = adjustment.assetValue + adjustment.amount;
            // Calculate totals
            if (adjustment.assetValue) totals.assetValue += adjustment.assetValue;
            totals.amount += adjustment.amount;
            if (adjustment.resultingAssetValue) totals.resultingAssetValue += adjustment.resultingAssetValue;
            // Store
            return adjustment;
        });
        // Save data
        setAdjustments(adjustments);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) adjustmentStore.query(query).then((adjustments)=>adjustments && formatData(adjustments));
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        flex: 5,
                        propName: 'notes',
                        label: 'Notes'
                    },
                    {
                        flex: 1,
                        propName: 'name',
                        label: 'Name'
                    },
                    {
                        flex: 10,
                        propName: 'effectiveDate',
                        label: 'Effective Date'
                    },
                    {
                        flex: 1,
                        propName: 'assetValue',
                        label: 'Starting Asset Value',
                        textAlign: 'right'
                    },
                    {
                        flex: 1,
                        propName: 'amount',
                        label: 'Amount',
                        textAlign: 'right'
                    },
                    {
                        flex: 1,
                        propName: 'resultingAssetValue',
                        label: 'Resulting Asset Value',
                        textAlign: 'right'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((adjustment, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                        rowHeight: rowHeight,
                        padForScrollbar: listData.length > 8,
                        items: [
                            {
                                propName: 'notes',
                                isNotes: true,
                                flex: 5,
                                hide: !adjustment.notes.length,
                                showNotesPopup: ()=>showNotesPopup(adjustment.notes, adjustment.name)
                            },
                            {
                                flex: 1,
                                propName: 'name',
                                label: 'Name',
                                content: adjustment.name,
                                url: `/adjustments/${adjustment._id}`
                            },
                            {
                                flex: 10,
                                propName: 'effectiveDate',
                                label: 'Effective Date',
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(adjustment.effectiveDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                            },
                            {
                                flex: 1,
                                propName: 'assetValue',
                                label: 'Starting Asset Value',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(adjustment.assetValue),
                                textAlign: 'right'
                            },
                            {
                                flex: 1,
                                propName: 'amount',
                                label: 'Amount',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(adjustment.amount),
                                textAlign: 'right'
                            },
                            {
                                flex: 1,
                                propName: 'resultingAssetValue',
                                label: 'Resulting Asset Value',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(adjustment.resultingAssetValue),
                                textAlign: 'right'
                            }
                        ],
                        rowIndex: i
                    }, adjustment._id))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            flex: 5,
                            propName: 'notes',
                            label: 'Totals',
                            content: 'Totals'
                        },
                        {
                            propName: 'name',
                            label: 'Name'
                        },
                        {
                            flex: 10,
                            propName: 'effectiveDate',
                            label: 'Effective Date'
                        },
                        {
                            propName: 'assetValue',
                            label: 'Starting Asset Value',
                            textAlign: 'right',
                            content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals.assetValue)
                        },
                        {
                            propName: 'amount',
                            label: 'Amount',
                            textAlign: 'right',
                            content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals.amount)
                        },
                        {
                            propName: 'resultingAssetValue',
                            label: 'Resulting Asset Value',
                            textAlign: 'right',
                            content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals.resultingAssetValue)
                        }
                    ].map(({ propName: propName, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : totals[propName] ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals[propName]) : '',
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        children: "No Adjustments found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");







const $4c3e24505b1c6e36$export$ed37f0d324fc0eb4 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const advanceStore = (0, $1da4b8b758f1a116$export$ed879bc79c1297c7)();
    /** State **/ const [advances, setAdvances] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (advances) {
            const list = advances.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        advances,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.amount = 0;
        totals.offset = 0;
        totals.originationFee = 0;
        const advances = data.map((advance)=>{
            // Calculate totals
            totals.amount += advance.amount;
            if (advance.originationFee) totals.originationFee += advance.originationFee;
            // Store
            return advance;
        });
        // Save data
        setAdvances(advances);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * (From ListDirectiveController)
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) advanceStore.query(query).then((advances)=>advances && formatData(advances));
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        flex: 5,
                        propName: 'notes',
                        label: 'Notes'
                    },
                    {
                        propName: 'name',
                        label: 'Name'
                    },
                    {
                        propName: 'amount',
                        label: 'Amount'
                    },
                    {
                        propName: 'offset',
                        label: 'Offset'
                    },
                    {
                        propName: 'originationFee',
                        label: 'Origination Fee'
                    },
                    {
                        propName: 'loanName',
                        label: 'Deal Name'
                    },
                    {
                        propName: 'dateRequested',
                        label: 'Requested On'
                    },
                    {
                        propName: 'dateFulfilled',
                        label: 'Fulfilled On'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((advance, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                        padForScrollbar: listData.length > 8,
                        items: [
                            {
                                propName: 'notes',
                                isNotes: true,
                                flex: 5,
                                hide: !advance.notes.length,
                                showNotesPopup: ()=>showNotesPopup(advance.notes, advance.name)
                            },
                            {
                                propName: 'name',
                                content: advance.name,
                                url: `/advances/${advance._id}`
                            },
                            {
                                propName: 'amount',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(advance.amount)
                            },
                            {
                                propName: 'offset',
                                content: advance.offset ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(advance.offset) : ''
                            },
                            {
                                propName: 'originationFee',
                                content: advance.originationFee ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(advance.originationFee) : ''
                            },
                            {
                                propName: 'loanName',
                                content: advance.loan.name,
                                url: `/deals/${advance.loan._id}`
                            },
                            {
                                propName: 'dateRequested',
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(advance.dateRequested).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                            },
                            {
                                propName: 'dateFulfilled',
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(advance.dateFulfilled).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                            }
                        ],
                        rowIndex: i
                    }, advance._id))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            flex: 5,
                            propName: 'notes',
                            label: 'Notes'
                        },
                        {
                            propName: 'name',
                            label: 'Name'
                        },
                        {
                            propName: 'amount',
                            label: 'Amount'
                        },
                        {
                            propName: 'offset',
                            label: 'Offset'
                        },
                        {
                            propName: 'originationFee',
                            label: 'Origination Fee'
                        },
                        {
                            propName: 'loanName',
                            label: 'Deal Name'
                        },
                        {
                            propName: 'dateRequested',
                            label: 'Requested On'
                        },
                        {
                            propName: 'dateFulfilled',
                            label: 'Fulfilled On'
                        }
                    ].map(({ propName: propName, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : totals[propName] ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals[propName]) : '',
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "span",
                        children: "No Advances found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $4HqRp = parcelRequire("4HqRp");

const $c76f4f389ec00274$export$e9e6a82d894af283 = ({ asset: asset, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Asset Details",
        open: open,
        toggleOpen: toggleOpen,
        resolved: !!asset,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Effective Date",
                value: asset?.effectiveDate,
                date: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Asset Type",
                value: asset?.assetType
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Program",
                value: asset?.program
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            asset?.loan.isOwned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Administrative Fee",
                        value: asset?.adminFee ?? 0,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Discount Fee",
                        value: asset?.discountFee ?? 0,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Late Fee",
                        value: asset?.lateFee ?? 0,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Fee Balance",
                        value: asset?.feeBalance ?? 0,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Initial Payment Amount",
                        value: asset?.initialPaymentAmount ?? 0,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Expected Residual Payment",
                        value: asset?.expectedResidualPayment ?? 0,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Deal",
                value: asset?.loan?.name,
                url: `/deals/${asset?.loan._id}`
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Status",
                value: (0, $4HqRp.default)(asset?.status ?? '')
            })
        ]
    });



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");


const $41af608264f61f27$export$1288c65e1f92c76b = ({ value: value, setValue: setValue, assets: assets, boxProps: boxProps, ...selectProps })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                component: "span",
                children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                value: value,
                updateValue: (value)=>setValue(value),
                placeholder: "Select Asset",
                ariaLabel: "Select Asset",
                options: assets.map((asset)=>({
                        label: asset.name,
                        value: asset._id
                    })),
                ...selectProps
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $4HqRp = parcelRequire("4HqRp");




const $60f6c7d7a387095a$export$2a9db9e784596663 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query, viewOptions: viewOptions })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    /** State **/ const [assets, setAssets] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (assets) {
            const list = assets.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        assets,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.value = 0;
        totals.originalValue = 0;
        totals.currentValue = 0;
        totals.totalPayments = 0;
        totals.totalAdjustments = 0;
        const assets = data.map((asset)=>{
            // Combine
            asset.notes = [
                ...asset.socketComments,
                ...asset.companyComments
            ].sort((a, b)=>a.created > b.created ? 1 : -1);
            // Calculate values
            asset.currentValue = asset.originalValue + (asset.totalAdjustments ?? 0) - (asset.totalPayments || 0);
            // Calculate totals
            totals.value += asset.value;
            totals.originalValue += asset.originalValue;
            totals.currentValue += asset.currentValue;
            if (asset.totalPayments) totals.totalPayments += asset.totalPayments;
            if (asset.totalAdjustments) totals.totalAdjustments += asset.totalAdjustments;
            // Store
            return asset;
        });
        // Save data
        setAssets(assets);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) assetStore.query(query).then((assets)=>assets && formatData(assets));
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        flex: 5,
                        propName: 'notes',
                        label: 'Notes'
                    },
                    {
                        propName: 'name',
                        label: 'Name'
                    },
                    {
                        propName: 'value',
                        label: 'Value'
                    },
                    {
                        propName: 'originalValue',
                        label: 'Original Value'
                    },
                    {
                        propName: 'currentValue',
                        label: 'Current Value',
                        textAlign: 'right'
                    },
                    {
                        propName: 'program',
                        label: 'Program',
                        textAlign: 'right'
                    },
                    {
                        propName: 'status',
                        label: 'Status',
                        textAlign: 'right'
                    },
                    {
                        propName: 'totalPayments',
                        label: 'Total Payments',
                        textAlign: 'right'
                    },
                    {
                        propName: 'totalAdjustments',
                        label: 'Total Adjustments',
                        textAlign: 'right'
                    },
                    {
                        propName: 'loan',
                        label: 'Deal',
                        textAlign: 'right'
                    }
                ],
                viewOptions: viewOptions,
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((asset, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                        viewOptions: viewOptions,
                        items: [
                            {
                                propName: 'notes',
                                isNotes: true,
                                flex: 5,
                                hide: !asset.companyComments.length && !asset.socketComments.length,
                                showNotesPopup: ()=>showNotesPopup(asset.notes, asset.name)
                            },
                            {
                                propName: 'name',
                                label: 'Name',
                                content: asset.name,
                                url: `/assets/${asset._id}`
                            },
                            {
                                propName: 'value',
                                label: 'Value',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.value)
                            },
                            {
                                propName: 'originalValue',
                                label: 'Original Value',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.originalValue)
                            },
                            {
                                propName: 'currentValue',
                                label: 'Current Value',
                                textAlign: 'right',
                                content: asset.currentValue ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.currentValue) : ''
                            },
                            {
                                propName: 'program',
                                label: 'Program',
                                textAlign: 'right',
                                content: asset.program
                            },
                            {
                                propName: 'status',
                                label: 'Status',
                                textAlign: 'right',
                                content: (0, $4HqRp.default)(asset.status)
                            },
                            {
                                propName: 'totalPayments',
                                label: 'Total Payments',
                                textAlign: 'right',
                                content: asset.totalPayments ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.totalPayments) : ''
                            },
                            {
                                propName: 'totalAdjustments',
                                label: 'Total Adjustments',
                                textAlign: 'right',
                                content: asset.totalAdjustments ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.totalAdjustments) : ''
                            },
                            {
                                propName: 'loan',
                                label: 'Deal',
                                textAlign: 'right',
                                content: asset.loan.name,
                                url: `/deals/${asset.loan._id}`
                            }
                        ],
                        rowIndex: i
                    }, asset._id))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            flex: 5,
                            propName: 'notes'
                        },
                        {
                            propName: 'name'
                        },
                        {
                            propName: 'value'
                        },
                        {
                            propName: 'originalValue'
                        },
                        {
                            propName: 'currentValue',
                            textAlign: 'right'
                        },
                        {
                            propName: 'program',
                            textAlign: 'right'
                        },
                        {
                            propName: 'status',
                            textAlign: 'right'
                        },
                        {
                            propName: 'totalPayments',
                            textAlign: 'right'
                        },
                        {
                            propName: 'totalAdjustments',
                            textAlign: 'right'
                        },
                        {
                            propName: 'loan',
                            textAlign: 'right'
                        }
                    ].filter((item)=>viewOptions[item.propName]).map(({ propName: propName, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : totals[propName] ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals[propName]) : '',
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "span",
                        children: "No Assets found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");


const $c93b6043f087dfd6$export$17c0f4fa5885d11 = ({ asset: asset, open: open, toggleOpen: toggleOpen })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Asset Value",
        open: open,
        toggleOpen: toggleOpen,
        resolved: !!asset,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Face Value",
                value: asset?.originalValue ?? 0,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Payments",
                value: asset?.currentPayments ?? 0,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Adjustments",
                value: asset?.currentAdjustments ?? 0,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Current Value",
                value: asset?.value ?? 0,
                bold: true,
                currency: true
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $31385b62cee78c1a$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), 'AddCircle');




const $34c48d72be66f2c1$export$449c1beb1b38d1d2 = ({ asset: asset, open: open, toggleOpen: toggleOpen })=>{
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Payment Schedule",
        open: open,
        toggleOpen: toggleOpen,
        buttonProps: {
            label: 'Record Payment',
            icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $31385b62cee78c1a$export$2e2bcd8739ae039), {
                style: {
                    color: 'white'
                },
                className: "material-icons md-icon"
            }),
            onClick: ()=>navigate('/payments/create')
        },
        resolved: !!asset,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Payment Schedule",
                value: asset?.paymentSchedule,
                date: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Next Payment",
                value: asset?.nextDate,
                date: true
            }),
            asset?.loan?.isOwned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Late After",
                        value: asset?.startDate,
                        date: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Buyback Date",
                        value: asset?.endDate,
                        date: true
                    })
                ]
            })
        ]
    });
};





var $iO5o7 = parcelRequire("iO5o7");

const $8f073dbc7525ab1f$export$e71c4d32a2263218 = ({ children: children, flex: flex, layout: layout = 'row', component: component = 'div', ...boxProps })=>{
    const { 'layout-align': layoutAlign, 'layout-padding': layoutPadding, ...props } = boxProps;
    const align = layoutAlign?.split(' ');
    const justifyContent = align?.[layout === 'row' ? 0 : 1];
    const alignItems = align?.[layout === 'row' ? 1 : 0];
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        component: component,
        display: !!flex || layoutAlign ? 'flex' : undefined,
        flex: typeof flex === 'string' ? flex : undefined,
        justifyContent: justifyContent,
        alignItems: alignItems,
        padding: layoutPadding ? '16px' : undefined,
        ...props,
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $d22848c8528cbdab$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $f9e94eabcee6b832$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $cbgVL = parcelRequire("cbgVL");

var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");

var $lVd4O = parcelRequire("lVd4O");
'use client';
let $a1ab550e14ceaf6f$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $a1ab550e14ceaf6f$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $lVd4O.useState(idOverride);
    const id = idOverride || defaultId;
    $lVd4O.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a1ab550e14ceaf6f$var$globalId += 1;
            setDefaultId(`mui-${$a1ab550e14ceaf6f$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $a1ab550e14ceaf6f$var$safeReact = {
    ...$lVd4O
};
const $a1ab550e14ceaf6f$var$maybeReactUseId = $a1ab550e14ceaf6f$var$safeReact.useId;
function $a1ab550e14ceaf6f$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($a1ab550e14ceaf6f$var$maybeReactUseId !== undefined) {
        const reactId = $a1ab550e14ceaf6f$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a1ab550e14ceaf6f$var$useGlobalId(idOverride);
}


'use client';
var $8c851458a2177131$export$2e2bcd8739ae039 = (0, $a1ab550e14ceaf6f$export$2e2bcd8739ae039);



var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");



var $jkA0j = parcelRequire("jkA0j");
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $f4c7fd7821681f04$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}



var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");


var $lVd4O = parcelRequire("lVd4O");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $08e2321bb932106c$var$useEventCallback(fn) {
    const ref = $lVd4O.useRef(fn);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $lVd4O.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $08e2321bb932106c$export$2e2bcd8739ae039 = $08e2321bb932106c$var$useEventCallback;


'use client';
var $6b1200dc53bcda97$export$2e2bcd8739ae039 = (0, $08e2321bb932106c$export$2e2bcd8739ae039);



var $lVd4O = parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");
'use client';
const $7b1ec9dd33c24219$var$UNINITIALIZED = {};
function $7b1ec9dd33c24219$export$2e2bcd8739ae039(init, initArg) {
    const ref = $lVd4O.useRef($7b1ec9dd33c24219$var$UNINITIALIZED);
    if (ref.current === $7b1ec9dd33c24219$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
class $52a685d7e49a129f$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $52a685d7e49a129f$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $7b1ec9dd33c24219$export$2e2bcd8739ae039)($52a685d7e49a129f$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $lVd4O.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $lVd4O.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $52a685d7e49a129f$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $52a685d7e49a129f$export$2e2bcd8739ae039() {
    return $52a685d7e49a129f$export$f5de0641c7db4154.use();
}
function $52a685d7e49a129f$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $lVd4O = parcelRequire("lVd4O");

function $12479526586cdfe1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $42AQp = parcelRequire("42AQp");
function $b125815882a9c5ae$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $78383401d14535b4$export$2e2bcd8739ae039(t, e) {
    return $78383401d14535b4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $78383401d14535b4$export$2e2bcd8739ae039(t, e);
}


function $8542fbc377858247$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $78383401d14535b4$export$2e2bcd8739ae039)(t, o);
}




var $lVd4O = parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");
var $466b8b47f84e3458$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createContext(null);



var $lVd4O = parcelRequire("lVd4O");
function $4d0f1ccf246c0c37$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $lVd4O.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $lVd4O.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $4d0f1ccf246c0c37$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $4d0f1ccf246c0c37$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $4d0f1ccf246c0c37$export$fa71e2345c31d7a2(props, onExited) {
    return $4d0f1ccf246c0c37$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $lVd4O.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $4d0f1ccf246c0c37$var$getProp(child, 'appear', props),
            enter: $4d0f1ccf246c0c37$var$getProp(child, 'enter', props),
            exit: $4d0f1ccf246c0c37$var$getProp(child, 'exit', props)
        });
    });
}
function $4d0f1ccf246c0c37$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $4d0f1ccf246c0c37$export$bbc8a025727ea824(nextProps.children);
    var children = $4d0f1ccf246c0c37$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $lVd4O.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $lVd4O.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $lVd4O.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $4d0f1ccf246c0c37$var$getProp(child, 'exit', nextProps),
            enter: $4d0f1ccf246c0c37$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $lVd4O.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $lVd4O.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $lVd4O.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $4d0f1ccf246c0c37$var$getProp(child, 'exit', nextProps),
            enter: $4d0f1ccf246c0c37$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $b6b692a05d127d26$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $b6b692a05d127d26$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $b6b692a05d127d26$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $8542fbc377858247$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $b125815882a9c5ae$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $4d0f1ccf246c0c37$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $4d0f1ccf246c0c37$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $4d0f1ccf246c0c37$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $42AQp.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $12479526586cdfe1$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $b6b692a05d127d26$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement((0, $466b8b47f84e3458$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement((0, $466b8b47f84e3458$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).Component);
$b6b692a05d127d26$var$TransitionGroup.propTypes = {};
$b6b692a05d127d26$var$TransitionGroup.defaultProps = $b6b692a05d127d26$var$defaultProps;
var $b6b692a05d127d26$export$2e2bcd8739ae039 = $b6b692a05d127d26$var$TransitionGroup;



var $anaDR = parcelRequire("anaDR");


var $lVd4O = parcelRequire("lVd4O");
'use client';
const $64a5fab389837204$var$EMPTY = [];
function $64a5fab389837204$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $lVd4O.useEffect(fn, $64a5fab389837204$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $650032dc7599a0a1$export$786b4da70f00938b {
    static create() {
        return new $650032dc7599a0a1$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $650032dc7599a0a1$export$2e2bcd8739ae039() {
    const timeout = (0, $7b1ec9dd33c24219$export$2e2bcd8739ae039)($650032dc7599a0a1$export$786b4da70f00938b.create).current;
    (0, $64a5fab389837204$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}



var $cfEcJ = parcelRequire("cfEcJ");
var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $255d8951249c0142$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $lVd4O.useState(false);
    const rippleClassName = (0, $anaDR.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $anaDR.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $lVd4O.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
            className: childClassName
        })
    });
}
var $255d8951249c0142$export$2e2bcd8739ae039 = $255d8951249c0142$var$Ripple;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $066be17aa7305dfc$export$b464606f735ab902(slot) {
    return (0, $bYZd6.default)('MuiTouchRipple', slot);
}
const $066be17aa7305dfc$var$touchRippleClasses = (0, $eaNcJ.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $066be17aa7305dfc$export$2e2bcd8739ae039 = $066be17aa7305dfc$var$touchRippleClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $6fa0a95e6d173e07$var$DURATION = 550;
const $6fa0a95e6d173e07$export$95d0c9356b2231a3 = 80;
const $6fa0a95e6d173e07$var$enterKeyframe = (0, $cfEcJ.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $6fa0a95e6d173e07$var$exitKeyframe = (0, $cfEcJ.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $6fa0a95e6d173e07$var$pulsateKeyframe = (0, $cfEcJ.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $6fa0a95e6d173e07$export$f6b7418508c72c25 = (0, $gvIKB.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $6fa0a95e6d173e07$export$676cfe7b12693c4b = (0, $gvIKB.default)((0, $255d8951249c0142$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $066be17aa7305dfc$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$6fa0a95e6d173e07$var$enterKeyframe};
    animation-duration: ${$6fa0a95e6d173e07$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $066be17aa7305dfc$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $066be17aa7305dfc$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $066be17aa7305dfc$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$6fa0a95e6d173e07$var$exitKeyframe};
    animation-duration: ${$6fa0a95e6d173e07$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $066be17aa7305dfc$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$6fa0a95e6d173e07$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $6fa0a95e6d173e07$var$TouchRipple = /*#__PURE__*/ $lVd4O.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $lVd4O.useState([]);
    const nextKey = $lVd4O.useRef(0);
    const rippleCallback = $lVd4O.useRef(null);
    $lVd4O.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $lVd4O.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $lVd4O.useRef(null);
    const container = $lVd4O.useRef(null);
    const startCommit = $lVd4O.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $iO5o7.jsx)($6fa0a95e6d173e07$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $anaDR.default)(classes.ripple, (0, $066be17aa7305dfc$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $anaDR.default)(classes.rippleVisible, (0, $066be17aa7305dfc$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $anaDR.default)(classes.ripplePulsate, (0, $066be17aa7305dfc$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $anaDR.default)(classes.child, (0, $066be17aa7305dfc$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $anaDR.default)(classes.childLeaving, (0, $066be17aa7305dfc$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $anaDR.default)(classes.childPulsate, (0, $066be17aa7305dfc$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $6fa0a95e6d173e07$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $lVd4O.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($6fa0a95e6d173e07$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $lVd4O.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $lVd4O.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $lVd4O.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($6fa0a95e6d173e07$export$f6b7418508c72c25, {
        className: (0, $anaDR.default)((0, $066be17aa7305dfc$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b6b692a05d127d26$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $6fa0a95e6d173e07$export$2e2bcd8739ae039 = $6fa0a95e6d173e07$var$TouchRipple;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $c4b3b58e870ef5a8$export$fccb0498dcd99783(slot) {
    return (0, $bYZd6.default)('MuiButtonBase', slot);
}
const $c4b3b58e870ef5a8$var$buttonBaseClasses = (0, $eaNcJ.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $c4b3b58e870ef5a8$export$2e2bcd8739ae039 = $c4b3b58e870ef5a8$var$buttonBaseClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $fb7cce4edf16a834$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $c4b3b58e870ef5a8$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $fb7cce4edf16a834$export$7ec0dcc5e3cdcd36 = (0, $gvIKB.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $c4b3b58e870ef5a8$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $fb7cce4edf16a834$var$ButtonBase = /*#__PURE__*/ $lVd4O.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $lVd4O.useRef(null);
    const ripple = (0, $52a685d7e49a129f$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $lVd4O.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $lVd4O.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $lVd4O.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $fb7cce4edf16a834$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $f4c7fd7821681f04$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $f4c7fd7821681f04$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $fb7cce4edf16a834$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($fb7cce4edf16a834$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa0a95e6d173e07$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $fb7cce4edf16a834$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $fb7cce4edf16a834$export$2e2bcd8739ae039 = $fb7cce4edf16a834$var$ButtonBase;




var $4HqRp = parcelRequire("4HqRp");


var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $eed2f2b6e4808c0b$export$5a6f9035944c8119(slot) {
    return (0, $bYZd6.default)('MuiButton', slot);
}
const $eed2f2b6e4808c0b$var$buttonClasses = (0, $eaNcJ.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $eed2f2b6e4808c0b$export$2e2bcd8739ae039 = $eed2f2b6e4808c0b$var$buttonClasses;



var $lVd4O = parcelRequire("lVd4O");
'use client';
/**
 * @ignore - internal component.
 */ const $af631900ebb5382a$var$ButtonGroupContext = /*#__PURE__*/ $lVd4O.createContext({});
var $af631900ebb5382a$export$2e2bcd8739ae039 = $af631900ebb5382a$var$ButtonGroupContext;



var $lVd4O = parcelRequire("lVd4O");
'use client';
/**
 * @ignore - internal component.
 */ const $ef93bee37fa00f3f$var$ButtonGroupButtonContext = /*#__PURE__*/ $lVd4O.createContext(undefined);
var $ef93bee37fa00f3f$export$2e2bcd8739ae039 = $ef93bee37fa00f3f$var$ButtonGroupButtonContext;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $cd1a77cab329a8c8$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $4HqRp.default)(color)}`,
            `size${(0, $4HqRp.default)(size)}`,
            `${variant}Size${(0, $4HqRp.default)(size)}`,
            `color${(0, $4HqRp.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $4HqRp.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $4HqRp.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $4HqRp.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $eed2f2b6e4808c0b$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $cd1a77cab329a8c8$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $cd1a77cab329a8c8$var$ButtonRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $4HqRp.default)(ownerState.color)}`],
            styles[`size${(0, $4HqRp.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $4HqRp.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $dRIMW.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $eed2f2b6e4808c0b$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $cd1a77cab329a8c8$var$ButtonStartIcon = (0, $gvIKB.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $4HqRp.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$cd1a77cab329a8c8$var$commonIconStyles
        ]
    }));
const $cd1a77cab329a8c8$var$ButtonEndIcon = (0, $gvIKB.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $4HqRp.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$cd1a77cab329a8c8$var$commonIconStyles
        ]
    }));
const $cd1a77cab329a8c8$var$ButtonLoadingIndicator = (0, $gvIKB.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $cd1a77cab329a8c8$var$ButtonLoadingIconPlaceholder = (0, $gvIKB.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $cd1a77cab329a8c8$var$Button = /*#__PURE__*/ $lVd4O.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $lVd4O.useContext((0, $af631900ebb5382a$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $lVd4O.useContext((0, $ef93bee37fa00f3f$export$2e2bcd8739ae039));
    const resolvedProps = (0, $cbgVL.default)(contextProps, inProps);
    const props = (0, $6r1xF.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $8c851458a2177131$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $cd1a77cab329a8c8$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $iO5o7.jsx)($cd1a77cab329a8c8$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $iO5o7.jsx)($cd1a77cab329a8c8$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $iO5o7.jsx)($cd1a77cab329a8c8$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $iO5o7.jsx)($cd1a77cab329a8c8$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $iO5o7.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $iO5o7.jsx)($cd1a77cab329a8c8$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($cd1a77cab329a8c8$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $anaDR.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $anaDR.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $cd1a77cab329a8c8$export$2e2bcd8739ae039 = $cd1a77cab329a8c8$var$Button;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");


var $dRIMW = parcelRequire("dRIMW");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");



var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $6f44bd9057011895$export$5e8702d71474f093(slot) {
    return (0, $bYZd6.default)('MuiIconButton', slot);
}
const $6f44bd9057011895$var$iconButtonClasses = (0, $eaNcJ.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $6f44bd9057011895$export$2e2bcd8739ae039 = $6f44bd9057011895$var$iconButtonClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $ffffa63de1eb66cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $4HqRp.default)(color)}`,
            edge && `edge${(0, $4HqRp.default)(edge)}`,
            `size${(0, $4HqRp.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $6f44bd9057011895$export$5e8702d71474f093), classes);
};
const $ffffa63de1eb66cb$var$IconButtonRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $4HqRp.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $4HqRp.default)(ownerState.edge)}`],
            styles[`size${(0, $4HqRp.default)(ownerState.size)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $7KgDD.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $6f44bd9057011895$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $6f44bd9057011895$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $ffffa63de1eb66cb$var$IconButtonLoadingIndicator = (0, $gvIKB.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $ffffa63de1eb66cb$var$IconButton = /*#__PURE__*/ $lVd4O.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $8c851458a2177131$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $ffffa63de1eb66cb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($ffffa63de1eb66cb$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $anaDR.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $iO5o7.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)($ffffa63de1eb66cb$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $ffffa63de1eb66cb$export$2e2bcd8739ae039 = $ffffa63de1eb66cb$var$IconButton;








const $0b0ef54190654a4b$export$5109c6dd95d8fb00 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ defaultRangeType: defaultRangeType = (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly })=>{
    /** Context **/ const dateStore = (0, $1da4b8b758f1a116$export$3f917fb33f736152)();
    /** Computed **/ const rangeType = dateStore.rangeType;
    const dateRange = dateStore.dateRange;
    const currentDate = dateStore.currentDate;
    /** Methods **/ /**
   * Sets the date range type
   */ const setRangeType = (rangeType)=>{
        dateStore.setRangeType(rangeType);
        dateStore.calculateRange();
    };
    /**
   * Changes the current Transactions window
   */ const changeDate = (modifier)=>{
        dateStore.modifyCurrentDate(modifier);
        dateStore.calculateRange();
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        setRangeType(defaultRangeType);
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
        className: "fadeDown",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                "layout-align": "center center",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        display: "flex"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        display: "flex",
                        "layout-align": "center center",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                className: "md-icon-button",
                                onClick: ()=>changeDate(-1),
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d22848c8528cbdab$export$2e2bcd8739ae039), {
                                    className: "md-icons material-icons"
                                })
                            }),
                            rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Weekly && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                component: "span",
                                className: "thin textZoomIn center",
                                flex: "25",
                                children: `${(0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(dateRange?.start).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))}-${(0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(dateRange?.end).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))}`
                            }),
                            rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Monthly && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                component: "span",
                                className: "thin textZoomIn center",
                                flex: "25",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(currentDate).format('MMMM YYYY')
                            }),
                            rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                component: "span",
                                className: "thin textZoomIn center",
                                flex: "25",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(currentDate).format('YYYY')
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                className: "md-icon-button",
                                onClick: ()=>changeDate(1),
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f9e94eabcee6b832$export$2e2bcd8739ae039), {
                                    className: "md-icons material-icons"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        display: "flex"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                className: `${rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Weekly && 'md-raised'}`,
                                onClick: ()=>setRangeType((0, $dff1c8c0bf270f18$export$d0d7df129860d081).Weekly),
                                children: "Weekly"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                className: `${rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Monthly && 'md-raised'}`,
                                onClick: ()=>setRangeType((0, $dff1c8c0bf270f18$export$d0d7df129860d081).Monthly),
                                children: "Monthly"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                className: `${rangeType === (0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly && 'md-raised'}`,
                                onClick: ()=>setRangeType((0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly),
                                children: "Yearly"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        display: "flex"
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $b3f197c3a21accaf$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $68af6d93e40eee40$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $ccdf51d07380559d$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");



var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");

var $gvIKB = parcelRequire("gvIKB");parcelRequire("lVd4O");


var $4ZbsN = parcelRequire("4ZbsN");

var $lRoul = parcelRequire("lRoul");
'use client';
function $713aff601b146490$export$2e2bcd8739ae039() {
    const theme = (0, $6a00530d38c0e8b0$export$2e2bcd8739ae039)((0, $4ZbsN.default));
    return theme[0, $lRoul.default] || theme;
}



var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $18Oap = parcelRequire("18Oap");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $1e7f27cb37b215c8$export$29cdb466b9b6f20b(slot) {
    return (0, $bYZd6.default)('MuiPaper', slot);
}
const $1e7f27cb37b215c8$var$paperClasses = (0, $eaNcJ.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $1e7f27cb37b215c8$export$2e2bcd8739ae039 = $1e7f27cb37b215c8$var$paperClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $094c486a546066a9$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $1e7f27cb37b215c8$export$29cdb466b9b6f20b), classes);
};
const $094c486a546066a9$var$PaperRoot = (0, $gvIKB.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $094c486a546066a9$var$Paper = /*#__PURE__*/ $lVd4O.forwardRef(function Paper(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $094c486a546066a9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($094c486a546066a9$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $dRIMW.alpha)('#fff', (0, $18Oap.default)(elevation))}, ${(0, $dRIMW.alpha)('#fff', (0, $18Oap.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $094c486a546066a9$export$2e2bcd8739ae039 = $094c486a546066a9$var$Paper;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $bfd7360657d8b152$export$f3b76d2cce458caa(slot) {
    return (0, $bYZd6.default)('MuiCard', slot);
}
const $bfd7360657d8b152$var$cardClasses = (0, $eaNcJ.default)('MuiCard', [
    'root'
]);
var $bfd7360657d8b152$export$2e2bcd8739ae039 = $bfd7360657d8b152$var$cardClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $5f1d95e6bd2f8d5c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $bfd7360657d8b152$export$f3b76d2cce458caa), classes);
};
const $5f1d95e6bd2f8d5c$var$CardRoot = (0, $gvIKB.default)((0, $094c486a546066a9$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $5f1d95e6bd2f8d5c$var$Card = /*#__PURE__*/ $lVd4O.forwardRef(function Card(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $5f1d95e6bd2f8d5c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($5f1d95e6bd2f8d5c$var$CardRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039 = $5f1d95e6bd2f8d5c$var$Card;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");


var $cfEcJ = parcelRequire("cfEcJ");
var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");

var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $1118af4646585f27$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $bYZd6.default)('MuiLinearProgress', slot);
}
const $1118af4646585f27$var$linearProgressClasses = (0, $eaNcJ.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $1118af4646585f27$export$2e2bcd8739ae039 = $1118af4646585f27$var$linearProgressClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $570333f629f71c57$var$TRANSITION_DURATION = 4; // seconds
const $570333f629f71c57$var$indeterminate1Keyframe = (0, $cfEcJ.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $570333f629f71c57$var$indeterminate1Animation = typeof $570333f629f71c57$var$indeterminate1Keyframe !== 'string' ? (0, $cfEcJ.css)`
        animation: ${$570333f629f71c57$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $570333f629f71c57$var$indeterminate2Keyframe = (0, $cfEcJ.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $570333f629f71c57$var$indeterminate2Animation = typeof $570333f629f71c57$var$indeterminate2Keyframe !== 'string' ? (0, $cfEcJ.css)`
        animation: ${$570333f629f71c57$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $570333f629f71c57$var$bufferKeyframe = (0, $cfEcJ.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $570333f629f71c57$var$bufferAnimation = typeof $570333f629f71c57$var$bufferKeyframe !== 'string' ? (0, $cfEcJ.css)`
        animation: ${$570333f629f71c57$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $570333f629f71c57$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4HqRp.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $4HqRp.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $4HqRp.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $4HqRp.default)(color)}`,
            variant === 'buffer' && `color${(0, $4HqRp.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $1118af4646585f27$export$bc8a6ea1eb17d7c6), classes);
};
const $570333f629f71c57$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $dRIMW.lighten)(theme.palette[color].main, 0.62) : (0, $dRIMW.darken)(theme.palette[color].main, 0.5);
};
const $570333f629f71c57$var$LinearProgressRoot = (0, $gvIKB.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $4HqRp.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $570333f629f71c57$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $570333f629f71c57$var$LinearProgressDashed = (0, $gvIKB.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $4HqRp.default)(ownerState.color)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>{
                const backgroundColor = $570333f629f71c57$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $570333f629f71c57$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$570333f629f71c57$var$bufferKeyframe} 3s infinite linear`
});
const $570333f629f71c57$var$LinearProgressBar1 = (0, $gvIKB.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $4HqRp.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$570333f629f71c57$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$570333f629f71c57$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $570333f629f71c57$var$indeterminate1Animation || {
                    animation: `${$570333f629f71c57$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $570333f629f71c57$var$LinearProgressBar2 = (0, $gvIKB.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $4HqRp.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $570333f629f71c57$var$getColorShade(theme, color),
                        transition: `transform .${$570333f629f71c57$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $570333f629f71c57$var$indeterminate2Animation || {
                    animation: `${$570333f629f71c57$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $570333f629f71c57$var$LinearProgress = /*#__PURE__*/ $lVd4O.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $570333f629f71c57$var$useUtilityClasses(ownerState);
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($570333f629f71c57$var$LinearProgressRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $iO5o7.jsx)($570333f629f71c57$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $iO5o7.jsx)($570333f629f71c57$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $iO5o7.jsx)($570333f629f71c57$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $570333f629f71c57$export$2e2bcd8739ae039 = $570333f629f71c57$var$LinearProgress;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");



var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");



var $lVd4O = parcelRequire("lVd4O");
function $354496b1137733e9$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($lVd4O.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}



var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $4HqRp = parcelRequire("4HqRp");

var $lVd4O = parcelRequire("lVd4O");








var $lVd4O = parcelRequire("lVd4O");

var $3d51f97f618ada29$export$2e2bcd8739ae039 = {
    disabled: false
};




var $3b85dd13aab8416b$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $d4ddf0f0262c03ba$export$bb38bb9a1161268 = 'unmounted';
var $d4ddf0f0262c03ba$export$84cbff306f539230 = 'exited';
var $d4ddf0f0262c03ba$export$df38205c966be359 = 'entering';
var $d4ddf0f0262c03ba$export$78e9e6e3e014d60a = 'entered';
var $d4ddf0f0262c03ba$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $d4ddf0f0262c03ba$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $8542fbc377858247$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $d4ddf0f0262c03ba$export$84cbff306f539230;
                _this.appearStatus = $d4ddf0f0262c03ba$export$df38205c966be359;
            } else initialStatus = $d4ddf0f0262c03ba$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $d4ddf0f0262c03ba$export$bb38bb9a1161268;
        else initialStatus = $d4ddf0f0262c03ba$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $d4ddf0f0262c03ba$export$bb38bb9a1161268) return {
            status: $d4ddf0f0262c03ba$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $d4ddf0f0262c03ba$export$df38205c966be359 && status !== $d4ddf0f0262c03ba$export$78e9e6e3e014d60a) nextStatus = $d4ddf0f0262c03ba$export$df38205c966be359;
            } else if (status === $d4ddf0f0262c03ba$export$df38205c966be359 || status === $d4ddf0f0262c03ba$export$78e9e6e3e014d60a) nextStatus = $d4ddf0f0262c03ba$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $d4ddf0f0262c03ba$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($096c782a4047fe48$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $3b85dd13aab8416b$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $d4ddf0f0262c03ba$export$84cbff306f539230) this.setState({
            status: $d4ddf0f0262c03ba$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($096c782a4047fe48$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3d51f97f618ada29$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $d4ddf0f0262c03ba$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $d4ddf0f0262c03ba$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $d4ddf0f0262c03ba$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($096c782a4047fe48$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3d51f97f618ada29$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $d4ddf0f0262c03ba$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $d4ddf0f0262c03ba$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $d4ddf0f0262c03ba$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($096c782a4047fe48$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $d4ddf0f0262c03ba$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $12479526586cdfe1$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement((0, $466b8b47f84e3458$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).Component);
$d4ddf0f0262c03ba$var$Transition.contextType = (0, $466b8b47f84e3458$export$2e2bcd8739ae039);
$d4ddf0f0262c03ba$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $d4ddf0f0262c03ba$var$noop() {}
$d4ddf0f0262c03ba$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $d4ddf0f0262c03ba$var$noop,
    onEntering: $d4ddf0f0262c03ba$var$noop,
    onEntered: $d4ddf0f0262c03ba$var$noop,
    onExit: $d4ddf0f0262c03ba$var$noop,
    onExiting: $d4ddf0f0262c03ba$var$noop,
    onExited: $d4ddf0f0262c03ba$var$noop
};
$d4ddf0f0262c03ba$var$Transition.UNMOUNTED = $d4ddf0f0262c03ba$export$bb38bb9a1161268;
$d4ddf0f0262c03ba$var$Transition.EXITED = $d4ddf0f0262c03ba$export$84cbff306f539230;
$d4ddf0f0262c03ba$var$Transition.ENTERING = $d4ddf0f0262c03ba$export$df38205c966be359;
$d4ddf0f0262c03ba$var$Transition.ENTERED = $d4ddf0f0262c03ba$export$78e9e6e3e014d60a;
$d4ddf0f0262c03ba$var$Transition.EXITING = $d4ddf0f0262c03ba$export$4aacc83d4d59139f;
var $d4ddf0f0262c03ba$export$2e2bcd8739ae039 = $d4ddf0f0262c03ba$var$Transition;



const $d3fbac79a43fb6d0$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $d3fbac79a43fb6d0$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $58cfe74858b5a2b7$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $58cfe74858b5a2b7$var$styles = {
    entering: {
        opacity: 1,
        transform: $58cfe74858b5a2b7$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $58cfe74858b5a2b7$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $58cfe74858b5a2b7$var$Grow = /*#__PURE__*/ $lVd4O.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $d4ddf0f0262c03ba$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    const autoTimeout = $lVd4O.useRef();
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const nodeRef = $lVd4O.useRef(null);
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(nodeRef, (0, $354496b1137733e9$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $d3fbac79a43fb6d0$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $d3fbac79a43fb6d0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $58cfe74858b5a2b7$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $d3fbac79a43fb6d0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $58cfe74858b5a2b7$var$isWebKit154 ? duration : duration * 0.666,
                delay: $58cfe74858b5a2b7$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $58cfe74858b5a2b7$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $lVd4O.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $58cfe74858b5a2b7$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$58cfe74858b5a2b7$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($58cfe74858b5a2b7$var$Grow) $58cfe74858b5a2b7$var$Grow.muiSupportAuto = true;
var $58cfe74858b5a2b7$export$2e2bcd8739ae039 = $58cfe74858b5a2b7$var$Grow;







var $lVd4O = parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");
function $6a56ba80654449ac$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $25bd5cbacd978ada$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $826a62d09c2c223e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $826a62d09c2c223e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $826a62d09c2c223e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $447991b54db0c957$export$8960430cfd85939f = Math.max;
var $447991b54db0c957$export$96ec731ed4dcb222 = Math.min;
var $447991b54db0c957$export$2077e0241d6afd3c = Math.round;



function $58ff6852588920d0$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $d4ba2437eea97349$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $58ff6852588920d0$export$2e2bcd8739ae039)());
}


function $f2586059e851170a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $447991b54db0c957$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $447991b54db0c957$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(element) ? (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $d4ba2437eea97349$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $f378072ffeb8ab73$export$2e2bcd8739ae039(node) {
    var win = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $34f553cf6e61088a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $340d410a65a8635d$export$2e2bcd8739ae039(node) {
    if (node === (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(node) || !(0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(node)) return (0, $f378072ffeb8ab73$export$2e2bcd8739ae039)(node);
    else return (0, $34f553cf6e61088a$export$2e2bcd8739ae039)(node);
}


function $deb67fee0cd15fd5$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $d56fa76f9f0ca9d6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $9fe401831550978f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f2586059e851170a$export$2e2bcd8739ae039)((0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(element)).left + (0, $f378072ffeb8ab73$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $ec36446e928af744$export$2e2bcd8739ae039(element) {
    return (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $2d211a962303b125$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $ec36446e928af744$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $7dede13c05b2578f$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $447991b54db0c957$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $447991b54db0c957$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $7dede13c05b2578f$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(offsetParent) && $7dede13c05b2578f$var$isElementScaled(offsetParent);
    var documentElement = (0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f2586059e851170a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $2d211a962303b125$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $340d410a65a8635d$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f2586059e851170a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $9fe401831550978f$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $33eebcf0c498501c$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f2586059e851170a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $edb1f31be340f3a2$export$2e2bcd8739ae039(element) {
    if ((0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $826a62d09c2c223e$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $7a3026532ed614b0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(node) && (0, $2d211a962303b125$export$2e2bcd8739ae039)(node)) return node;
    return $7a3026532ed614b0$export$2e2bcd8739ae039((0, $edb1f31be340f3a2$export$2e2bcd8739ae039)(node));
}





function $219368d2dd6c8e5f$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $7a3026532ed614b0$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $2d211a962303b125$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($219368d2dd6c8e5f$export$2e2bcd8739ae039((0, $edb1f31be340f3a2$export$2e2bcd8739ae039)(target)));
}







function $b934a7419a3a1924$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(element)) >= 0;
}




function $63eb3a3f40719f45$var$getTrueOffsetParent(element) {
    if (!(0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $ec36446e928af744$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $63eb3a3f40719f45$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $58ff6852588920d0$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $58ff6852588920d0$export$2e2bcd8739ae039)());
    if (isIE && (0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $ec36446e928af744$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $edb1f31be340f3a2$export$2e2bcd8739ae039)(element);
    if ((0, $826a62d09c2c223e$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $ec36446e928af744$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $63eb3a3f40719f45$export$2e2bcd8739ae039(element) {
    var window = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(element);
    var offsetParent = $63eb3a3f40719f45$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $b934a7419a3a1924$export$2e2bcd8739ae039)(offsetParent) && (0, $ec36446e928af744$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $63eb3a3f40719f45$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $ec36446e928af744$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $63eb3a3f40719f45$var$getContainingBlock(element) || window;
}


var $fa5141c7e214c2bf$export$1e95b668f3b82d = 'top';
var $fa5141c7e214c2bf$export$40e543e69a8b3fbb = 'bottom';
var $fa5141c7e214c2bf$export$79ffe56a765070d2 = 'right';
var $fa5141c7e214c2bf$export$eabcd2c8791e7bf4 = 'left';
var $fa5141c7e214c2bf$export$dfb5619354ba860 = 'auto';
var $fa5141c7e214c2bf$export$aec2ce47c367b8c3 = [
    $fa5141c7e214c2bf$export$1e95b668f3b82d,
    $fa5141c7e214c2bf$export$40e543e69a8b3fbb,
    $fa5141c7e214c2bf$export$79ffe56a765070d2,
    $fa5141c7e214c2bf$export$eabcd2c8791e7bf4
];
var $fa5141c7e214c2bf$export$b3571188c770cc5a = 'start';
var $fa5141c7e214c2bf$export$bd5df0f255a350f8 = 'end';
var $fa5141c7e214c2bf$export$390fd549c5303b4d = 'clippingParents';
var $fa5141c7e214c2bf$export$d7b7311ec04a3e8f = 'viewport';
var $fa5141c7e214c2bf$export$ae5ab1c730825774 = 'popper';
var $fa5141c7e214c2bf$export$ca50aac9f3ba507f = 'reference';
var $fa5141c7e214c2bf$export$368f9a87e87fa4e1 = /*#__PURE__*/ $fa5141c7e214c2bf$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $fa5141c7e214c2bf$export$b3571188c770cc5a,
        placement + "-" + $fa5141c7e214c2bf$export$bd5df0f255a350f8
    ]);
}, []);
var $fa5141c7e214c2bf$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($fa5141c7e214c2bf$export$aec2ce47c367b8c3, [
    $fa5141c7e214c2bf$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $fa5141c7e214c2bf$export$b3571188c770cc5a,
        placement + "-" + $fa5141c7e214c2bf$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $fa5141c7e214c2bf$export$421679a7c3d56e = 'beforeRead';
var $fa5141c7e214c2bf$export$aafa59e2e03f2942 = 'read';
var $fa5141c7e214c2bf$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $fa5141c7e214c2bf$export$c65e99957a05207c = 'beforeMain';
var $fa5141c7e214c2bf$export$f22da7240b7add18 = 'main';
var $fa5141c7e214c2bf$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $fa5141c7e214c2bf$export$8d4d2d70e7d46032 = 'beforeWrite';
var $fa5141c7e214c2bf$export$68d8715fc104d294 = 'write';
var $fa5141c7e214c2bf$export$70a6e5159acce2e6 = 'afterWrite';
var $fa5141c7e214c2bf$export$d087d3878fdf71d5 = [
    $fa5141c7e214c2bf$export$421679a7c3d56e,
    $fa5141c7e214c2bf$export$aafa59e2e03f2942,
    $fa5141c7e214c2bf$export$6964f6c886723980,
    $fa5141c7e214c2bf$export$c65e99957a05207c,
    $fa5141c7e214c2bf$export$f22da7240b7add18,
    $fa5141c7e214c2bf$export$bab79516f2d662fe,
    $fa5141c7e214c2bf$export$8d4d2d70e7d46032,
    $fa5141c7e214c2bf$export$68d8715fc104d294,
    $fa5141c7e214c2bf$export$70a6e5159acce2e6
];


function $851e89e902dc1fbf$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $851e89e902dc1fbf$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $851e89e902dc1fbf$var$order(modifiers); // order based on phase
    return (0, $fa5141c7e214c2bf$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $697f775291b59509$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $a60077bd5425b255$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $ca0eaf70de99c2fa$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $ca0eaf70de99c2fa$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $ca0eaf70de99c2fa$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $ca0eaf70de99c2fa$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $ca0eaf70de99c2fa$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(reference) ? (0, $219368d2dd6c8e5f$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $219368d2dd6c8e5f$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $219368d2dd6c8e5f$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $851e89e902dc1fbf$export$2e2bcd8739ae039)((0, $a60077bd5425b255$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$ca0eaf70de99c2fa$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7dede13c05b2578f$export$2e2bcd8739ae039)(reference, (0, $63eb3a3f40719f45$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $33eebcf0c498501c$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $697f775291b59509$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$ca0eaf70de99c2fa$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $ca0eaf70de99c2fa$export$8f7491d57c8f97a9 = /*#__PURE__*/ $ca0eaf70de99c2fa$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $d21a06e598711706$var$passive = {
    passive: true
};
function $d21a06e598711706$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $d21a06e598711706$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $d21a06e598711706$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $d21a06e598711706$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $d21a06e598711706$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $d21a06e598711706$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $d21a06e598711706$var$effect,
    data: {}
};



function $f277a406099b12c8$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d3d37888c5596111$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $4270454d97f39758$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9e2234fb2cdf9293$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f277a406099b12c8$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $d3d37888c5596111$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $fa5141c7e214c2bf$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $fa5141c7e214c2bf$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4270454d97f39758$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $fa5141c7e214c2bf$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $fa5141c7e214c2bf$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $d869ad29da798b30$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9e2234fb2cdf9293$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d869ad29da798b30$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $d869ad29da798b30$var$popperOffsets,
    data: {}
};










var $bf3acb5b42a76180$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bf3acb5b42a76180$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $447991b54db0c957$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $447991b54db0c957$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bf3acb5b42a76180$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4);
    var sideY = (0, $fa5141c7e214c2bf$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $63eb3a3f40719f45$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(popper);
            if ((0, $ec36446e928af744$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $fa5141c7e214c2bf$export$1e95b668f3b82d) || (placement === (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4) || placement === (0, $fa5141c7e214c2bf$export$79ffe56a765070d2)) && variation === (0, $fa5141c7e214c2bf$export$bd5df0f255a350f8)) {
            sideY = (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4) || (placement === (0, $fa5141c7e214c2bf$export$1e95b668f3b82d) || placement === (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb)) && variation === (0, $fa5141c7e214c2bf$export$bd5df0f255a350f8)) {
            sideX = (0, $fa5141c7e214c2bf$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bf3acb5b42a76180$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bf3acb5b42a76180$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bf3acb5b42a76180$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f277a406099b12c8$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $d3d37888c5596111$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bf3acb5b42a76180$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bf3acb5b42a76180$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bf3acb5b42a76180$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bf3acb5b42a76180$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $5b8c2b199896b37c$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(element) || !(0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $5b8c2b199896b37c$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(element) || !(0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $5b8c2b199896b37c$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $5b8c2b199896b37c$var$applyStyles,
    effect: $5b8c2b199896b37c$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $50c068a971a19204$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f277a406099b12c8$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4),
        (0, $fa5141c7e214c2bf$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4),
        (0, $fa5141c7e214c2bf$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $50c068a971a19204$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $fa5141c7e214c2bf$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $50c068a971a19204$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $50c068a971a19204$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $50c068a971a19204$var$offset
};


var $1c8262d44e9dfc1d$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $1c8262d44e9dfc1d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $1c8262d44e9dfc1d$var$hash[matched];
    });
}



var $9f925d9e2766bf23$var$hash = {
    start: 'end',
    end: 'start'
};
function $9f925d9e2766bf23$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $9f925d9e2766bf23$var$hash[matched];
    });
}







function $98ae22c94f7e30a1$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $25bd5cbacd978ada$export$2e2bcd8739ae039)(element);
    var html = (0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $d4ba2437eea97349$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $9fe401831550978f$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $e49df54f14cd77da$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $f378072ffeb8ab73$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $447991b54db0c957$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $447991b54db0c957$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $9fe401831550978f$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $ec36446e928af744$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $447991b54db0c957$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $7ee70d83cfebf0f9$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $826a62d09c2c223e$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $32bcdca20232c97c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $684c2e0d2fcef346$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f2586059e851170a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $684c2e0d2fcef346$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $fa5141c7e214c2bf$export$d7b7311ec04a3e8f) ? (0, $32bcdca20232c97c$export$2e2bcd8739ae039)((0, $98ae22c94f7e30a1$export$2e2bcd8739ae039)(element, strategy)) : (0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(clippingParent) ? $684c2e0d2fcef346$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $32bcdca20232c97c$export$2e2bcd8739ae039)((0, $e49df54f14cd77da$export$2e2bcd8739ae039)((0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $684c2e0d2fcef346$var$getClippingParents(element) {
    var clippingParents = (0, $219368d2dd6c8e5f$export$2e2bcd8739ae039)((0, $edb1f31be340f3a2$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $ec36446e928af744$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $826a62d09c2c223e$export$1b3bfaa9684536aa)(element) ? (0, $63eb3a3f40719f45$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(clippingParent) && (0, $7ee70d83cfebf0f9$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $deb67fee0cd15fd5$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $684c2e0d2fcef346$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $684c2e0d2fcef346$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $684c2e0d2fcef346$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $447991b54db0c957$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $447991b54db0c957$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $447991b54db0c957$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $447991b54db0c957$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $684c2e0d2fcef346$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $c87f1cc64c9a174b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $018f9163a01cd256$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $c87f1cc64c9a174b$export$2e2bcd8739ae039)(), paddingObject);
}


function $2125d8252c646ce4$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $926e2dd10b16bed0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $fa5141c7e214c2bf$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $fa5141c7e214c2bf$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $fa5141c7e214c2bf$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $018f9163a01cd256$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $2125d8252c646ce4$export$2e2bcd8739ae039)(padding, (0, $fa5141c7e214c2bf$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $fa5141c7e214c2bf$export$ae5ab1c730825774) ? (0, $fa5141c7e214c2bf$export$ca50aac9f3ba507f) : (0, $fa5141c7e214c2bf$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $684c2e0d2fcef346$export$2e2bcd8739ae039)((0, $826a62d09c2c223e$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $d56fa76f9f0ca9d6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f2586059e851170a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9e2234fb2cdf9293$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $32bcdca20232c97c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $fa5141c7e214c2bf$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $fa5141c7e214c2bf$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $fa5141c7e214c2bf$export$79ffe56a765070d2),
                (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $fa5141c7e214c2bf$export$1e95b668f3b82d),
                (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $b24eef33863d61e9$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $fa5141c7e214c2bf$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $d3d37888c5596111$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $fa5141c7e214c2bf$export$368f9a87e87fa4e1) : (0, $fa5141c7e214c2bf$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $d3d37888c5596111$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $fa5141c7e214c2bf$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $926e2dd10b16bed0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f277a406099b12c8$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $f52de5c4b2e089c0$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f277a406099b12c8$export$2e2bcd8739ae039)(placement) === (0, $fa5141c7e214c2bf$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $1c8262d44e9dfc1d$export$2e2bcd8739ae039)(placement);
    return [
        (0, $9f925d9e2766bf23$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $9f925d9e2766bf23$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $f52de5c4b2e089c0$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f277a406099b12c8$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1c8262d44e9dfc1d$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $f52de5c4b2e089c0$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f277a406099b12c8$export$2e2bcd8739ae039)(placement) === (0, $fa5141c7e214c2bf$export$dfb5619354ba860) ? (0, $b24eef33863d61e9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f277a406099b12c8$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $d3d37888c5596111$export$2e2bcd8739ae039)(placement) === (0, $fa5141c7e214c2bf$export$b3571188c770cc5a);
        var isVertical = [
            (0, $fa5141c7e214c2bf$export$1e95b668f3b82d),
            (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $926e2dd10b16bed0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $fa5141c7e214c2bf$export$79ffe56a765070d2) : (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb) : (0, $fa5141c7e214c2bf$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1c8262d44e9dfc1d$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $1c8262d44e9dfc1d$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $f52de5c4b2e089c0$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $f52de5c4b2e089c0$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $ae146733ba36fe0c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $53b10b6ef7ef0c04$export$f28d906d67a997f3(min, value, max) {
    return (0, $447991b54db0c957$export$8960430cfd85939f)(min, (0, $447991b54db0c957$export$96ec731ed4dcb222)(value, max));
}
function $53b10b6ef7ef0c04$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $53b10b6ef7ef0c04$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3623ad5a09fc9680$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $926e2dd10b16bed0$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f277a406099b12c8$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $d3d37888c5596111$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4270454d97f39758$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $ae146733ba36fe0c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $fa5141c7e214c2bf$export$1e95b668f3b82d) : (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb) : (0, $fa5141c7e214c2bf$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $fa5141c7e214c2bf$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $fa5141c7e214c2bf$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $33eebcf0c498501c$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $c87f1cc64c9a174b$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $53b10b6ef7ef0c04$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $63eb3a3f40719f45$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $53b10b6ef7ef0c04$export$f28d906d67a997f3)(tether ? (0, $447991b54db0c957$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $447991b54db0c957$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $fa5141c7e214c2bf$export$1e95b668f3b82d) : (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb) : (0, $fa5141c7e214c2bf$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $fa5141c7e214c2bf$export$1e95b668f3b82d),
            (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $53b10b6ef7ef0c04$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $53b10b6ef7ef0c04$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3623ad5a09fc9680$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3623ad5a09fc9680$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $b6780285105127c9$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $018f9163a01cd256$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $2125d8252c646ce4$export$2e2bcd8739ae039)(padding, (0, $fa5141c7e214c2bf$export$aec2ce47c367b8c3)));
};
function $b6780285105127c9$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f277a406099b12c8$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $4270454d97f39758$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4),
        (0, $fa5141c7e214c2bf$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $b6780285105127c9$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $33eebcf0c498501c$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $fa5141c7e214c2bf$export$1e95b668f3b82d) : (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb) : (0, $fa5141c7e214c2bf$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $63eb3a3f40719f45$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $53b10b6ef7ef0c04$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $b6780285105127c9$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $7ee70d83cfebf0f9$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $b6780285105127c9$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $b6780285105127c9$var$arrow,
    effect: $b6780285105127c9$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $d568cc230d265dab$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d568cc230d265dab$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $fa5141c7e214c2bf$export$1e95b668f3b82d),
        (0, $fa5141c7e214c2bf$export$79ffe56a765070d2),
        (0, $fa5141c7e214c2bf$export$40e543e69a8b3fbb),
        (0, $fa5141c7e214c2bf$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d568cc230d265dab$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $926e2dd10b16bed0$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $926e2dd10b16bed0$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d568cc230d265dab$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d568cc230d265dab$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d568cc230d265dab$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d568cc230d265dab$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d568cc230d265dab$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d568cc230d265dab$var$hide
};




var $4284e9599bc76096$export$d34966752335dd47 = [
    (0, $d21a06e598711706$export$2e2bcd8739ae039),
    (0, $d869ad29da798b30$export$2e2bcd8739ae039),
    (0, $bf3acb5b42a76180$export$2e2bcd8739ae039),
    (0, $5b8c2b199896b37c$export$2e2bcd8739ae039),
    (0, $50c068a971a19204$export$2e2bcd8739ae039),
    (0, $f52de5c4b2e089c0$export$2e2bcd8739ae039),
    (0, $3623ad5a09fc9680$export$2e2bcd8739ae039),
    (0, $b6780285105127c9$export$2e2bcd8739ae039),
    (0, $d568cc230d265dab$export$2e2bcd8739ae039)
];
var $4284e9599bc76096$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $ca0eaf70de99c2fa$export$ed5e13716264f202)({
    defaultModifiers: $4284e9599bc76096$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $jkA0j = parcelRequire("jkA0j");

/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $5e6726fe938426ac$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $5e6726fe938426ac$export$2e2bcd8739ae039 = $5e6726fe938426ac$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $256adfc9db5fd1aa$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $5e6726fe938426ac$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $256adfc9db5fd1aa$export$2e2bcd8739ae039 = $256adfc9db5fd1aa$var$appendOwnerState;



var $anaDR = parcelRequire("anaDR");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $5b439fbf43b53f58$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $5b439fbf43b53f58$export$2e2bcd8739ae039 = $5b439fbf43b53f58$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $67686abccb1ade03$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $67686abccb1ade03$export$2e2bcd8739ae039 = $67686abccb1ade03$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $5bcc280cbb274619$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $anaDR.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $5b439fbf43b53f58$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $67686abccb1ade03$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $67686abccb1ade03$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $anaDR.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $5bcc280cbb274619$export$2e2bcd8739ae039 = $5bcc280cbb274619$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $6eee36282fe607c2$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $6eee36282fe607c2$export$2e2bcd8739ae039 = $6eee36282fe607c2$var$resolveComponentProps;


'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $3e009f3d502773cc$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $6eee36282fe607c2$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $5bcc280cbb274619$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $56d901343d819caa$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $256adfc9db5fd1aa$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $3e009f3d502773cc$export$2e2bcd8739ae039 = $3e009f3d502773cc$var$useSlotProps;



var $lVd4O = parcelRequire("lVd4O");


/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $133dd504f3e1c336$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $e371495800f0b06d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $e371495800f0b06d$var$Portal = /*#__PURE__*/ $lVd4O.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $lVd4O.useState(null);
    const handleRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)(/*#__PURE__*/ $lVd4O.isValidElement(children) ? (0, $354496b1137733e9$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($e371495800f0b06d$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $133dd504f3e1c336$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $133dd504f3e1c336$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $lVd4O.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $lVd4O.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $096c782a4047fe48$exports.createPortal(children, mountNode) : mountNode;
});
var $e371495800f0b06d$export$2e2bcd8739ae039 = $e371495800f0b06d$var$Portal;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $51a13aa64ade770a$export$1b69b6cd0fa638a1(slot) {
    return (0, $bYZd6.default)('MuiPopper', slot);
}
const $51a13aa64ade770a$var$popperClasses = (0, $eaNcJ.default)('MuiPopper', [
    'root'
]);
var $51a13aa64ade770a$export$2e2bcd8739ae039 = $51a13aa64ade770a$var$popperClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $b99e247ea44deb86$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $b99e247ea44deb86$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $b99e247ea44deb86$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $b99e247ea44deb86$var$isVirtualElement(element) {
    return !$b99e247ea44deb86$var$isHTMLElement(element);
}
const $b99e247ea44deb86$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $51a13aa64ade770a$export$1b69b6cd0fa638a1), classes);
};
const $b99e247ea44deb86$var$defaultPopperOptions = {};
const $b99e247ea44deb86$var$PopperTooltip = /*#__PURE__*/ $lVd4O.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $lVd4O.useRef(null);
    const ownRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $lVd4O.useRef(null);
    const handlePopperRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $lVd4O.useRef(handlePopperRef);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $lVd4O.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $b99e247ea44deb86$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $lVd4O.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $lVd4O.useState($b99e247ea44deb86$var$resolveAnchorEl(anchorEl));
    $lVd4O.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $lVd4O.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($b99e247ea44deb86$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $4284e9599bc76096$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $b99e247ea44deb86$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $b99e247ea44deb86$var$Popper = /*#__PURE__*/ $lVd4O.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $b99e247ea44deb86$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $lVd4O.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $b99e247ea44deb86$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $b99e247ea44deb86$var$isHTMLElement(resolvedAnchorEl) ? (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e371495800f0b06d$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)($b99e247ea44deb86$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $b99e247ea44deb86$export$2e2bcd8739ae039 = $b99e247ea44deb86$var$Popper;



var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $640d046b3ea99234$var$PopperRoot = (0, $gvIKB.default)((0, $b99e247ea44deb86$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://v6.mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 * - [Popper](https://v6.mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://v6.mui.com/material-ui/api/popper/)
 */ const $640d046b3ea99234$var$Popper = /*#__PURE__*/ $lVd4O.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $iO5o7.jsx)($640d046b3ea99234$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $640d046b3ea99234$export$2e2bcd8739ae039 = $640d046b3ea99234$var$Popper;






var $lVd4O = parcelRequire("lVd4O");
'use client';
function $da7ec4d15deb2b86$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $lVd4O.useRef(controlled !== undefined);
    const [valueState, setValue] = $lVd4O.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $lVd4O.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $d420a656705086cf$export$2e2bcd8739ae039 = (0, $da7ec4d15deb2b86$export$2e2bcd8739ae039);






'use client';
function $e0c2f7af30c96190$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $6eee36282fe607c2$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $5bcc280cbb274619$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $56d901343d819caa$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $256adfc9db5fd1aa$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $459909cb1ada2676$export$837848f5f6cee923(slot) {
    return (0, $bYZd6.default)('MuiTooltip', slot);
}
const $459909cb1ada2676$var$tooltipClasses = (0, $eaNcJ.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $459909cb1ada2676$export$2e2bcd8739ae039 = $459909cb1ada2676$var$tooltipClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $597ca07016a19218$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $597ca07016a19218$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $4HqRp.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $459909cb1ada2676$export$837848f5f6cee923), classes);
};
const $597ca07016a19218$var$TooltipPopper = (0, $gvIKB.default)((0, $640d046b3ea99234$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $459909cb1ada2676$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $597ca07016a19218$var$TooltipTooltip = (0, $gvIKB.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $4HqRp.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $dRIMW.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$597ca07016a19218$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $459909cb1ada2676$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $597ca07016a19218$var$TooltipArrow = (0, $gvIKB.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $7KgDD.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $dRIMW.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $597ca07016a19218$var$hystersisOpen = false;
const $597ca07016a19218$var$hystersisTimer = new (0, $650032dc7599a0a1$export$786b4da70f00938b)();
let $597ca07016a19218$var$cursorPosition = {
    x: 0,
    y: 0
};
function $597ca07016a19218$export$b9ee5a7ace0541f8() {
    $597ca07016a19218$var$hystersisOpen = false;
    $597ca07016a19218$var$hystersisTimer.clear();
}
function $597ca07016a19218$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $597ca07016a19218$var$Tooltip = /*#__PURE__*/ $lVd4O.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $lVd4O.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $lVd4O.useState();
    const [arrowRef, setArrowRef] = $lVd4O.useState(null);
    const ignoreNonTouchEvents = $lVd4O.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    const enterTimer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    const touchTimer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $d420a656705086cf$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $8c851458a2177131$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $lVd4O.useRef();
    const stopTouchInteraction = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $lVd4O.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $597ca07016a19218$var$hystersisTimer.clear();
        $597ca07016a19218$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $597ca07016a19218$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $597ca07016a19218$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $597ca07016a19218$var$hystersisOpen && enterNextDelay) enterTimer.start($597ca07016a19218$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $lVd4O.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $f4c7fd7821681f04$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $f4c7fd7821681f04$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $lVd4O.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)((0, $354496b1137733e9$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $lVd4O.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $597ca07016a19218$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $anaDR.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $597ca07016a19218$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $597ca07016a19218$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $597ca07016a19218$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $597ca07016a19218$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $lVd4O.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $597ca07016a19218$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('popper', {
        elementType: $597ca07016a19218$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $58cfe74858b5a2b7$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('tooltip', {
        elementType: $597ca07016a19218$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('arrow', {
        elementType: $597ca07016a19218$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            /*#__PURE__*/ $lVd4O.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $iO5o7.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $640d046b3ea99234$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $597ca07016a19218$var$cursorPosition.y,
                            left: $597ca07016a19218$var$cursorPosition.x,
                            right: $597ca07016a19218$var$cursorPosition.x,
                            bottom: $597ca07016a19218$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $iO5o7.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $iO5o7.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $iO5o7.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $597ca07016a19218$export$2e2bcd8739ae039 = $597ca07016a19218$var$Tooltip;





const $f59363be96761416$export$40fb018dd4c59f8 = {
    listAdjustments: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the adjustments list.'
    },
    viewAdjustment: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the adjustment.'
    },
    createAdjustment: {
        success: 'Adjustment Created',
        error: 'There was a problem creating the adjustment.'
    },
    updateAdjustment: {
        success: 'Adjustment Updated',
        error: 'There was a problem updating the adjustment.'
    },
    deleteAdjustment: {
        success: 'Adjustment Deleted',
        error: 'There was a problem deleting the adjustment.'
    },
    listNotes: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the notes list.'
    },
    viewNote: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the note.'
    },
    createNote: {
        success: 'Note Added',
        error: 'There was a problem adding the note.'
    },
    updateNote: {
        success: 'Note Updated',
        error: 'There was a problem updating the note.'
    },
    deleteNote: {
        success: 'Note Deleted',
        error: 'There was a problem deleting the note.'
    },
    listAdvances: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the advances list.'
    },
    viewAdvance: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the advance.'
    },
    createAdvance: {
        success: 'Advance Created',
        error: 'There was a problem creating the advance.'
    },
    updateAdvance: {
        success: 'Advance Updated',
        error: 'There was a problem updating the advance.'
    },
    deleteAdvance: {
        success: 'Advance Deleted',
        error: 'There was a problem deleting the advance.'
    },
    listAssets: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the assets list.'
    },
    viewAsset: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the asset.'
    },
    createAsset: {
        success: 'Asset Created',
        error: 'There was a problem creating the asset.'
    },
    updateAsset: {
        success: 'Asset Updated',
        error: 'There was a problem updating the asset.'
    },
    deleteAsset: {
        success: 'Asset Closed',
        error: 'There was a problem closing the asset.'
    },
    listCompanies: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the companies list.'
    },
    viewCompany: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the company.'
    },
    createCompany: {
        success: 'Company Created',
        error: 'There was a problem creating the company.'
    },
    updateCompany: {
        success: 'Company Updated',
        error: 'There was a problem updating the company.'
    },
    deleteCompany: {
        success: 'Company Deleted',
        error: 'There was a problem deleting the company.'
    },
    listDocuments: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the documents list.'
    },
    viewDocument: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the document.'
    },
    createDocument: {
        success: 'Document Created',
        error: 'There was a problem creating the document.'
    },
    uploadDocument: {
        success: 'Document Uploaded',
        error: 'There was a problem uploading the document.'
    },
    updateDocument: {
        success: 'Document Updated',
        error: 'There was a problem updating the document.'
    },
    deleteDocument: {
        success: 'Document Deleted',
        error: 'There was a problem deleting the document.'
    },
    listLenders: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the investors list.'
    },
    viewLender: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the investor.'
    },
    createLender: {
        success: 'Lender Created',
        error: 'There was a problem creating the investor.'
    },
    updateLender: {
        success: 'Lender Updated',
        error: 'There was a problem updating the investor.'
    },
    deleteLender: {
        success: 'Lender Deactivated',
        error: 'There was a problem deactivating the investor.'
    },
    listLoans: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the deals list.'
    },
    viewLoan: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the deal.'
    },
    createLoan: {
        success: 'Deal Created',
        error: 'There was a problem creating the deal.'
    },
    updateLoan: {
        success: 'Loan Updated',
        error: 'There was a problem updating the deal.'
    },
    deleteLoan: {
        success: 'Deal Deactivated',
        error: 'There was a problem deleting the deal.'
    },
    listParticipations: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the participations list.'
    },
    listPayments: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the payments list.'
    },
    viewPayment: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the payment.'
    },
    createPayment: {
        success: 'Payment Created',
        error: 'There was a problem creating the payment.'
    },
    updatePayment: {
        success: 'Payment Updated',
        error: 'There was a problem updating the payment.'
    },
    deletePayment: {
        success: 'Payment Deleted',
        error: 'There was a problem deleting the payment.'
    },
    listReports: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the reports list.'
    },
    viewReport: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the report.'
    },
    createReport: {
        success: 'Report Created',
        error: 'There was a problem creating the report.'
    },
    updateReport: {
        success: 'Report Updated',
        error: 'There was a problem updating the report.'
    },
    deleteReport: {
        success: 'Report Deleted',
        error: 'There was a problem deleting the report.'
    },
    listStatements: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the statements list.'
    },
    viewStatement: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the statement.'
    },
    createStatement: {
        success: 'Statement Created',
        error: 'There was a problem creating the statement.'
    },
    updateStatement: {
        success: 'Statement Updated',
        error: 'There was a problem updating the statement.'
    },
    deleteStatement: {
        success: 'Statement Deleted',
        error: 'There was a problem deleting the statement.'
    },
    listTransactions: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the transactions list.'
    },
    viewTransaction: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the transaction.'
    },
    createTransaction: {
        success: 'Transaction successfully recorded.',
        error: 'There was a problem recording the transaction.'
    },
    updateTransaction: {
        success: 'Transaction successfully updated.',
        error: 'There was a problem updating the transaction.'
    },
    deleteTransaction: {
        success: 'Transaction successfully removed.',
        error: 'There was a problem removing the transaction.'
    },
    listUsers: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the users list.'
    },
    viewUser: {
        success: 'Fetch successful!',
        error: 'There was a problem fetching the user.'
    },
    createUser: {
        success: 'User Created',
        error: 'There was a problem creating the user.'
    },
    updateUser: {
        success: 'User Updated',
        error: 'There was a problem updating the user.'
    },
    deactivateUser: {
        success: 'User Deactivated',
        error: 'There was a problem deactivating the user.'
    },
    activateUser: {
        success: 'User Activated',
        error: 'There was a problem activating the user.'
    },
    changePassword: {
        success: 'Password Changed',
        error: 'Error Changing Password'
    }
};






const $e03ba8c5e5838a24$export$22c59631e6c46e5a = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ mode: mode, documents: documents, updateDocuments: updateDocuments, sidebarIndex: sidebarIndex, sidebarItems: sidebarItems, setSidebarItems: setSidebarItems, title: title = 'Documents', tooltip: tooltip = 'Add Document' })=>{
    /** Refs **/ const xhr = (0, $lVd4O.useRef)(new XMLHttpRequest());
    /** State **/ const [indexToDelete, setIndexToDelete] = (0, $lVd4O.useState)();
    const [uploadStatus, setUploadStatus] = (0, $lVd4O.useState)((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
    const [uploadProgress, setUploadProgress] = (0, $lVd4O.useState)(0);
    const [files, setFiles] = (0, $lVd4O.useState)([]);
    const [queue, setQueue] = (0, $lVd4O.useState)({});
    const [showControls, setShowControls] = (0, $lVd4O.useState)([]);
    const [, setError] = (0, $lVd4O.useState)(false);
    const fileInput = document.getElementById('fileInput');
    /** Methods **/ /*** Returns the filename from a given URL ***/ const getFileName = (url, keepExtension)=>{
        let fileName = url.slice(url.lastIndexOf('/') + 1);
        // If no value was passed, default to true
        if (!keepExtension) keepExtension = true;
        // Remove extension
        if (!keepExtension) fileName = fileName.slice(0, fileName.indexOf('.'));
        return fileName;
    };
    /*** Opens File Upload dialog ***/ const openFileDialog = ()=>{
        if (uploadStatus !== (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading) fileInput?.click();
    };
    /*** Opens a file in another window ***/ const openFile = (fileUrl)=>{
        window.open(fileUrl, '_blank');
    };
    /*** High-level upload  ***/ const upload = ()=>{
        if (!updateDocuments) return;
        // Gets signed request
        getSignedRequest((response)=>{
            // Uploads the file to S3
            uploadFiles(queue[0], response.signed_request, response.url, (newFileUrl)=>{
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Done);
                // Updates the proper database entry with the file's URL
                updateDocuments([
                    ...files,
                    newFileUrl
                ]);
                // Show alert
                (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).uploadDocument.success);
                // Resets
                setUploadProgress(0);
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
                // Open documents list item (if applicable)
                if (sidebarItems) setSidebarItems(sidebarItems.with(sidebarIndex, true));
            });
        });
    };
    /*** Get Signed Request ***/ const getSignedRequest = (callback)=>{
        if (queue.length > 0) {
            const apiUrl = (0, $6c9b670123ce891e$export$1b98eaf73d37f034)();
            const file = queue[0];
            xhr.current.open('GET', `${apiUrl}/s3request?file_name=${file.name}&file_type=${file.type}`);
            xhr.current.onreadystatechange = ()=>{
                if (xhr.current.readyState === 4) {
                    if (xhr.current.status === 200) {
                        const response = (0, $4bb6caff349888e9$export$54fd2c36b5cc6731)(xhr.current.response);
                        if (response) callback(response);
                    }
                }
            };
            xhr.current.send();
        }
    };
    /*** Upload Files to S3 ***/ const uploadFiles = (file, signedRequest, url, callback)=>{
        setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading);
        // Track upload progress
        xhr.current.upload.onprogress = (upload)=>{
            setUploadProgress(upload.loaded / upload.total * 100);
        };
        // Open connection & set headers
        xhr.current.open('PUT', signedRequest);
        xhr.current.setRequestHeader('x-amz-acl', 'public-read');
        xhr.current.onload = ()=>{
            // Success callback
            if (xhr.current.status === 200) {
                setFiles([
                    ...files,
                    url
                ]);
                callback(url);
            } else if (xhr.current.status === 403) {
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
                setError(true);
                window.setTimeout(()=>{
                    setError(false);
                }, 2000);
            }
        };
        // General error callback
        xhr.current.onerror = ()=>{
            setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
            setError(true);
        };
        // Engage
        xhr.current.send(file);
    };
    /*** Remove file ***/ const removeFile = async ()=>{
        if (!updateDocuments) return;
        const fileIndex = indexToDelete;
        if (typeof fileIndex !== 'number' || !files[fileIndex]) return;
        try {
            const updatedFiles = files;
            updatedFiles.splice(fileIndex, 1);
            if (mode === (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit) {
                // Push updates to the database
                await updateDocuments(updatedFiles);
                setFiles(updatedFiles);
                setIndexToDelete(undefined);
                if (updatedFiles.length < 1) setSidebarItems(sidebarItems.with(sidebarIndex, false));
                // Show alert
                (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteDocument.success);
            }
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteDocument.error);
        }
    };
    const handleFileSelect = (files)=>{
        if (files) {
            setQueue(files);
            setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Queued);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (documents) setFiles(documents);
    }, [
        documents
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (queue.length && uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Queued) upload();
    }, [
        queue,
        uploadStatus
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                component: "md-card",
                className: "no-margin-bottom md-default-theme text-center",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        className: "toolbar-div pad-left",
                        children: [
                            mode !== (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Read && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                title: tooltip,
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                    className: "md-icon-button float-left",
                                    onClick: ()=>openFileDialog(),
                                    disabled: uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading,
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $31385b62cee78c1a$export$2e2bcd8739ae039), {
                                        style: {
                                            color: 'white'
                                        },
                                        className: "md-icon material-icons"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                sx: {
                                    flex: 1
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                sx: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    component: "span",
                                    className: "float-right",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                        className: "md-icon-button",
                                        onClick: ()=>setSidebarItems(sidebarItems.with(sidebarIndex, !sidebarItems[sidebarIndex])),
                                        disabled: !files.length,
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                            title: sidebarItems[sidebarIndex] ? 'Show Less' : 'Show More',
                                            children: sidebarItems[sidebarIndex] ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $68af6d93e40eee40$export$2e2bcd8739ae039), {
                                                style: {
                                                    color: !files.length ? undefined : 'white'
                                                },
                                                className: "md-icon material-icons"
                                            }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ccdf51d07380559d$export$2e2bcd8739ae039), {
                                                style: {
                                                    color: !files.length ? undefined : 'white'
                                                },
                                                className: "md-icon material-icons"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)("input", {
                                type: "file",
                                id: "fileInput",
                                onChange: (e)=>handleFileSelect(e.target.files),
                                style: {
                                    display: 'none'
                                }
                            })
                        ]
                    }),
                    sidebarItems[sidebarIndex] && !!files.length && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        children: [
                            files.map((file, fileIndex)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    bgcolor: "white",
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                            sx: {
                                                paddingLeft: '16px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            },
                                            onMouseOver: ()=>{
                                                const controls = showControls;
                                                controls[fileIndex] = true;
                                                setShowControls(controls);
                                            },
                                            onMouseOut: ()=>{
                                                const controls = showControls;
                                                controls[fileIndex] = false;
                                                setShowControls(controls);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    onClick: ()=>openFile(file),
                                                    sx: {
                                                        flex: 1
                                                    },
                                                    className: "pointer",
                                                    children: getFileName(file)
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        flex: 1
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                                    className: "md-icon-button md-warn",
                                                    onClick: ()=>setIndexToDelete(fileIndex),
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                        title: "Delete File",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                fontSize: '18px'
                                                            }
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                                    ]
                                }, fileIndex)),
                            uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $570333f629f71c57$export$2e2bcd8739ae039), {
                                    className: "md-primary",
                                    value: uploadProgress
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
                content: "Are you sure you want to delete this Document?",
                label: "Confirm Deletion",
                open: typeof indexToDelete === 'number',
                setOpen: ()=>setIndexToDelete(undefined),
                okLabel: "Delete",
                onOk: ()=>removeFile(),
                cancelLabel: "Cancel"
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");
/**
 * react-number-format - 5.4.4
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2025 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */ 
var $lVd4O = parcelRequire("lVd4O");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $4b1d9a4dcf1b21ac$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $4b1d9a4dcf1b21ac$var$SourceType;
(function(SourceType) {
    SourceType["event"] = "event";
    SourceType["props"] = "prop";
})($4b1d9a4dcf1b21ac$var$SourceType || ($4b1d9a4dcf1b21ac$var$SourceType = {}));
// basic noop function
function $4b1d9a4dcf1b21ac$var$noop() {}
function $4b1d9a4dcf1b21ac$var$memoizeOnce(cb) {
    var lastArgs;
    var lastValue = undefined;
    return function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        if (lastArgs && args.length === lastArgs.length && args.every(function(value, index) {
            return value === lastArgs[index];
        })) return lastValue;
        lastArgs = args;
        lastValue = cb.apply(void 0, args);
        return lastValue;
    };
}
function $4b1d9a4dcf1b21ac$var$charIsNumber(char) {
    return !!(char || '').match(/\d/);
}
function $4b1d9a4dcf1b21ac$var$isNil(val) {
    return val === null || val === undefined;
}
function $4b1d9a4dcf1b21ac$var$isNanValue(val) {
    return typeof val === 'number' && isNaN(val);
}
function $4b1d9a4dcf1b21ac$var$isNotValidValue(val) {
    return $4b1d9a4dcf1b21ac$var$isNil(val) || $4b1d9a4dcf1b21ac$var$isNanValue(val) || typeof val === 'number' && !isFinite(val);
}
function $4b1d9a4dcf1b21ac$var$escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}
function $4b1d9a4dcf1b21ac$var$getThousandsGroupRegex(thousandsGroupStyle) {
    switch(thousandsGroupStyle){
        case 'lakh':
            return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
        case 'wan':
            return /(\d)(?=(\d{4})+(?!\d))/g;
        case 'thousand':
        default:
            return /(\d)(?=(\d{3})+(?!\d))/g;
    }
}
function $4b1d9a4dcf1b21ac$var$applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = $4b1d9a4dcf1b21ac$var$getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    index = index === -1 ? str.length : index;
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator);
}
function $4b1d9a4dcf1b21ac$var$usePersistentCallback(cb) {
    var callbackRef = (0, $lVd4O.useRef)(cb);
    // keep the callback ref upto date
    callbackRef.current = cb;
    /**
     * initialize a persistent callback which never changes
     * through out the component lifecycle
     */ var persistentCbRef = (0, $lVd4O.useRef)(function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return callbackRef.current.apply(callbackRef, args);
    });
    return persistentCbRef.current;
}
//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function $4b1d9a4dcf1b21ac$var$splitDecimal(numStr, allowNegative) {
    if (allowNegative === void 0) allowNegative = true;
    var hasNegation = numStr[0] === '-';
    var addNegation = hasNegation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
        beforeDecimal: beforeDecimal,
        afterDecimal: afterDecimal,
        hasNegation: hasNegation,
        addNegation: addNegation
    };
}
function $4b1d9a4dcf1b21ac$var$fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === '-';
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return "" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? "." + afterDecimal : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */ function $4b1d9a4dcf1b21ac$var$limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';
    for(var i = 0; i <= scale - 1; i++)str += numStr[i] || filler;
    return str;
}
function $4b1d9a4dcf1b21ac$var$repeat(str, count) {
    return Array(count + 1).join(str);
}
function $4b1d9a4dcf1b21ac$var$toNumericString(num) {
    var _num = num + ''; // typecast number to string
    // store the sign and remove it from the number.
    var sign = _num[0] === '-' ? '-' : '';
    if (sign) _num = _num.substring(1);
    // split the number into cofficient and exponent
    var ref = _num.split(/[eE]/g);
    var coefficient = ref[0];
    var exponent = ref[1];
    // covert exponent to number;
    exponent = Number(exponent);
    // if there is no exponent part or its 0, return the coffiecient with sign
    if (!exponent) return sign + coefficient;
    coefficient = coefficient.replace('.', '');
    /**
     * for scientific notation the current decimal index will be after first number (index 0)
     * So effective decimal index will always be 1 + exponent value
     */ var decimalIndex = 1 + exponent;
    var coffiecientLn = coefficient.length;
    if (decimalIndex < 0) // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + $4b1d9a4dcf1b21ac$var$repeat('0', Math.abs(decimalIndex)) + coefficient;
    else if (decimalIndex >= coffiecientLn) // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + $4b1d9a4dcf1b21ac$var$repeat('0', decimalIndex - coffiecientLn);
    else // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
    return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */ function $4b1d9a4dcf1b21ac$var$roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if ([
        '',
        '-'
    ].indexOf(numStr) !== -1) return numStr;
    var shouldHaveDecimalSeparator = (numStr.indexOf('.') !== -1 || fixedDecimalScale) && scale;
    var ref = $4b1d9a4dcf1b21ac$var$splitDecimal(numStr);
    var beforeDecimal = ref.beforeDecimal;
    var afterDecimal = ref.afterDecimal;
    var hasNegation = ref.hasNegation;
    var floatValue = parseFloat("0." + (afterDecimal || '0'));
    var floatValueStr = afterDecimal.length <= scale ? "0." + afterDecimal : floatValue.toFixed(scale);
    var roundedDecimalParts = floatValueStr.split('.');
    var intPart = beforeDecimal;
    // if we have cary over from rounding decimal part, add that on before decimal
    if (beforeDecimal && Number(roundedDecimalParts[0])) intPart = beforeDecimal.split('').reverse().reduce(function(roundedStr, current, idx) {
        if (roundedStr.length > idx) return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
        return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = $4b1d9a4dcf1b21ac$var$limitToScale(roundedDecimalParts[1] || '', scale, fixedDecimalScale);
    var negation = hasNegation ? '-' : '';
    var decimalSeparator = shouldHaveDecimalSeparator ? '.' : '';
    return "" + negation + intPart + decimalSeparator + decimalPart;
}
/** set the caret positon in an input field **/ function $4b1d9a4dcf1b21ac$var$setCaretPosition(el, caretPos) {
    el.value = el.value;
    // ^ this is used to not only get 'focus', but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)
    if (el !== null) {
        /* @ts-ignore */ if (el.createTextRange) {
            /* @ts-ignore */ var range = el.createTextRange();
            range.move('character', caretPos);
            range.select();
            return true;
        }
        // (el.selectionStart === 0 added for Firefox bug)
        if (el.selectionStart || el.selectionStart === 0) {
            el.focus();
            el.setSelectionRange(caretPos, caretPos);
            return true;
        }
        // fail city, fortunately this never happens (as far as I've tested) :)
        el.focus();
        return false;
    }
}
/**
 * TODO: remove dependency of findChangeRange, findChangedRangeFromCaretPositions is better way to find what is changed
 * currently this is mostly required by test and isCharacterSame util
 * Given previous value and newValue it returns the index
 * start - end to which values have changed.
 * This function makes assumption about only consecutive
 * characters are changed which is correct assumption for caret input.
 */ var $4b1d9a4dcf1b21ac$var$findChangeRange = $4b1d9a4dcf1b21ac$var$memoizeOnce(function(prevValue, newValue) {
    var i = 0, j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;
    while(prevValue[i] === newValue[i] && i < prevLength)i++;
    //check what has been changed from last
    while(prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i)j++;
    return {
        from: {
            start: i,
            end: prevLength - j
        },
        to: {
            start: i,
            end: newLength - j
        }
    };
});
var $4b1d9a4dcf1b21ac$var$findChangedRangeFromCaretPositions = function(lastCaretPositions, currentCaretPosition) {
    var startPosition = Math.min(lastCaretPositions.selectionStart, currentCaretPosition);
    return {
        from: {
            start: startPosition,
            end: lastCaretPositions.selectionEnd
        },
        to: {
            start: startPosition,
            end: currentCaretPosition
        }
    };
};
/*
  Returns a number whose value is limited to the given range
*/ function $4b1d9a4dcf1b21ac$var$clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
function $4b1d9a4dcf1b21ac$var$geInputCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/ return Math.max(el.selectionStart, el.selectionEnd);
}
function $4b1d9a4dcf1b21ac$var$addInputMode() {
    return typeof navigator !== 'undefined' && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $4b1d9a4dcf1b21ac$var$getDefaultChangeMeta(value) {
    return {
        from: {
            start: 0,
            end: 0
        },
        to: {
            start: 0,
            end: value.length
        },
        lastValue: ''
    };
}
function $4b1d9a4dcf1b21ac$var$getMaskAtIndex(mask, index) {
    if (mask === void 0) mask = ' ';
    if (typeof mask === 'string') return mask;
    return mask[index] || ' ';
}
function $4b1d9a4dcf1b21ac$var$defaultIsCharacterSame(ref) {
    var currentValue = ref.currentValue;
    var formattedValue = ref.formattedValue;
    var currentValueIndex = ref.currentValueIndex;
    var formattedValueIndex = ref.formattedValueIndex;
    return currentValue[currentValueIndex] === formattedValue[formattedValueIndex];
}
function $4b1d9a4dcf1b21ac$var$getCaretPosition(newFormattedValue, lastFormattedValue, curValue, curCaretPos, boundary, isValidInputCharacter, /**
 * format function can change the character, the caret engine relies on mapping old value and new value
 * In such case if character is changed, parent can tell which chars are equivalent
 * Some example, all allowedDecimalCharacters are updated to decimalCharacters, 2nd case if user is coverting
 * number to different numeric system.
 */ isCharacterSame) {
    if (isCharacterSame === void 0) isCharacterSame = $4b1d9a4dcf1b21ac$var$defaultIsCharacterSame;
    /**
     * if something got inserted on empty value, add the formatted character before the current value,
     * This is to avoid the case where typed character is present on format characters
     */ var firstAllowedPosition = boundary.findIndex(function(b) {
        return b;
    });
    var prefixFormat = newFormattedValue.slice(0, firstAllowedPosition);
    if (!lastFormattedValue && !curValue.startsWith(prefixFormat)) {
        lastFormattedValue = prefixFormat;
        curValue = prefixFormat + curValue;
        curCaretPos = curCaretPos + prefixFormat.length;
    }
    var curValLn = curValue.length;
    var formattedValueLn = newFormattedValue.length;
    // create index map
    var addedIndexMap = {};
    var indexMap = new Array(curValLn);
    for(var i = 0; i < curValLn; i++){
        indexMap[i] = -1;
        for(var j = 0, jLn = formattedValueLn; j < jLn; j++){
            var isCharSame = isCharacterSame({
                currentValue: curValue,
                lastValue: lastFormattedValue,
                formattedValue: newFormattedValue,
                currentValueIndex: i,
                formattedValueIndex: j
            });
            if (isCharSame && addedIndexMap[j] !== true) {
                indexMap[i] = j;
                addedIndexMap[j] = true;
                break;
            }
        }
    }
    /**
     * For current caret position find closest characters (left and right side)
     * which are properly mapped to formatted value.
     * The idea is that the new caret position will exist always in the boundary of
     * that mapped index
     */ var pos = curCaretPos;
    while(pos < curValLn && (indexMap[pos] === -1 || !isValidInputCharacter(curValue[pos])))pos++;
    // if the caret position is on last keep the endIndex as last for formatted value
    var endIndex = pos === curValLn || indexMap[pos] === -1 ? formattedValueLn : indexMap[pos];
    pos = curCaretPos - 1;
    while(pos > 0 && indexMap[pos] === -1)pos--;
    var startIndex = pos === -1 || indexMap[pos] === -1 ? 0 : indexMap[pos] + 1;
    /**
     * case where a char is added on suffix and removed from middle, example 2sq345 becoming $2,345 sq
     * there is still a mapping but the order of start index and end index is changed
     */ if (startIndex > endIndex) return endIndex;
    /**
     * given the current caret position if it closer to startIndex
     * keep the new caret position on start index or keep it closer to endIndex
     */ return curCaretPos - startIndex < endIndex - curCaretPos ? startIndex : endIndex;
}
/* This keeps the caret within typing area so people can't type in between prefix or suffix or format characters */ function $4b1d9a4dcf1b21ac$var$getCaretPosInBoundary(value, caretPos, boundary, direction) {
    var valLn = value.length;
    // clamp caret position to [0, value.length]
    caretPos = $4b1d9a4dcf1b21ac$var$clamp(caretPos, 0, valLn);
    if (direction === 'left') {
        while(caretPos >= 0 && !boundary[caretPos])caretPos--;
        // if we don't find any suitable caret position on left, set it on first allowed position
        if (caretPos === -1) caretPos = boundary.indexOf(true);
    } else {
        while(caretPos <= valLn && !boundary[caretPos])caretPos++;
        // if we don't find any suitable caret position on right, set it on last allowed position
        if (caretPos > valLn) caretPos = boundary.lastIndexOf(true);
    }
    // if we still don't find caret position, set it at the end of value
    if (caretPos === -1) caretPos = valLn;
    return caretPos;
}
function $4b1d9a4dcf1b21ac$var$caretUnknownFormatBoundary(formattedValue) {
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    boundaryAry[i] = Boolean($4b1d9a4dcf1b21ac$var$charIsNumber(formattedValue[i]) || $4b1d9a4dcf1b21ac$var$charIsNumber(formattedValue[i - 1]));
    return boundaryAry;
}
function $4b1d9a4dcf1b21ac$var$useInternalValues(value, defaultValue, valueIsNumericString, format, removeFormatting, onValueChange) {
    if (onValueChange === void 0) onValueChange = $4b1d9a4dcf1b21ac$var$noop;
    var getValues = $4b1d9a4dcf1b21ac$var$usePersistentCallback(function(value, valueIsNumericString) {
        var formattedValue, numAsString;
        if ($4b1d9a4dcf1b21ac$var$isNotValidValue(value)) {
            numAsString = '';
            formattedValue = '';
        } else if (typeof value === 'number' || valueIsNumericString) {
            numAsString = typeof value === 'number' ? $4b1d9a4dcf1b21ac$var$toNumericString(value) : value;
            formattedValue = format(numAsString);
        } else {
            numAsString = removeFormatting(value, undefined);
            formattedValue = format(numAsString);
        }
        return {
            formattedValue: formattedValue,
            numAsString: numAsString
        };
    });
    var ref = (0, $lVd4O.useState)(function() {
        return getValues($4b1d9a4dcf1b21ac$var$isNil(value) ? defaultValue : value, valueIsNumericString);
    });
    var values = ref[0];
    var setValues = ref[1];
    var _onValueChange = function(newValues, sourceInfo) {
        if (newValues.formattedValue !== values.formattedValue) setValues({
            formattedValue: newValues.formattedValue,
            numAsString: newValues.value
        });
        // call parent on value change if only if formatted value is changed
        onValueChange(newValues, sourceInfo);
    };
    // if value is switch from controlled to uncontrolled, use the internal state's value to format with new props
    var _value = value;
    var _valueIsNumericString = valueIsNumericString;
    if ($4b1d9a4dcf1b21ac$var$isNil(value)) {
        _value = values.numAsString;
        _valueIsNumericString = true;
    }
    var newValues = getValues(_value, _valueIsNumericString);
    (0, $lVd4O.useMemo)(function() {
        setValues(newValues);
    }, [
        newValues.formattedValue
    ]);
    return [
        values,
        _onValueChange
    ];
}
function $4b1d9a4dcf1b21ac$var$defaultRemoveFormatting(value) {
    return value.replace(/[^0-9]/g, '');
}
function $4b1d9a4dcf1b21ac$var$defaultFormat(value) {
    return value;
}
function $4b1d9a4dcf1b21ac$export$dd1caf9b8ccbc158(props) {
    var type = props.type;
    if (type === void 0) type = 'text';
    var displayType = props.displayType;
    if (displayType === void 0) displayType = 'input';
    var customInput = props.customInput;
    var renderText = props.renderText;
    var getInputRef = props.getInputRef;
    var format = props.format;
    if (format === void 0) format = $4b1d9a4dcf1b21ac$var$defaultFormat;
    var removeFormatting = props.removeFormatting;
    if (removeFormatting === void 0) removeFormatting = $4b1d9a4dcf1b21ac$var$defaultRemoveFormatting;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var isAllowed = props.isAllowed;
    var onChange = props.onChange;
    if (onChange === void 0) onChange = $4b1d9a4dcf1b21ac$var$noop;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $4b1d9a4dcf1b21ac$var$noop;
    var onMouseUp = props.onMouseUp;
    if (onMouseUp === void 0) onMouseUp = $4b1d9a4dcf1b21ac$var$noop;
    var onFocus = props.onFocus;
    if (onFocus === void 0) onFocus = $4b1d9a4dcf1b21ac$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $4b1d9a4dcf1b21ac$var$noop;
    var propValue = props.value;
    var getCaretBoundary = props.getCaretBoundary;
    if (getCaretBoundary === void 0) getCaretBoundary = $4b1d9a4dcf1b21ac$var$caretUnknownFormatBoundary;
    var isValidInputCharacter = props.isValidInputCharacter;
    if (isValidInputCharacter === void 0) isValidInputCharacter = $4b1d9a4dcf1b21ac$var$charIsNumber;
    var isCharacterSame = props.isCharacterSame;
    var otherProps = $4b1d9a4dcf1b21ac$var$__rest(props, [
        "type",
        "displayType",
        "customInput",
        "renderText",
        "getInputRef",
        "format",
        "removeFormatting",
        "defaultValue",
        "valueIsNumericString",
        "onValueChange",
        "isAllowed",
        "onChange",
        "onKeyDown",
        "onMouseUp",
        "onFocus",
        "onBlur",
        "value",
        "getCaretBoundary",
        "isValidInputCharacter",
        "isCharacterSame"
    ]);
    var ref = $4b1d9a4dcf1b21ac$var$useInternalValues(propValue, defaultValue, Boolean(valueIsNumericString), format, removeFormatting, onValueChange);
    var ref_0 = ref[0];
    var formattedValue = ref_0.formattedValue;
    var numAsString = ref_0.numAsString;
    var onFormattedValueChange = ref[1];
    var caretPositionBeforeChange = (0, $lVd4O.useRef)();
    var lastUpdatedValue = (0, $lVd4O.useRef)({
        formattedValue: formattedValue,
        numAsString: numAsString
    });
    var _onValueChange = function(values, source) {
        lastUpdatedValue.current = {
            formattedValue: values.formattedValue,
            numAsString: values.value
        };
        onFormattedValueChange(values, source);
    };
    var ref$1 = (0, $lVd4O.useState)(false);
    var mounted = ref$1[0];
    var setMounted = ref$1[1];
    var focusedElm = (0, $lVd4O.useRef)(null);
    var timeout = (0, $lVd4O.useRef)({
        setCaretTimeout: null,
        focusTimeout: null
    });
    (0, $lVd4O.useEffect)(function() {
        setMounted(true);
        return function() {
            clearTimeout(timeout.current.setCaretTimeout);
            clearTimeout(timeout.current.focusTimeout);
        };
    }, []);
    var _format = format;
    var getValueObject = function(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
            formattedValue: formattedValue,
            value: numAsString,
            floatValue: isNaN(floatValue) ? undefined : floatValue
        };
    };
    var setPatchedCaretPosition = function(el, caretPos, currentValue) {
        // don't reset the caret position when the whole input content is selected
        if (el.selectionStart === 0 && el.selectionEnd === el.value.length) return;
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */ $4b1d9a4dcf1b21ac$var$setCaretPosition(el, caretPos);
        timeout.current.setCaretTimeout = setTimeout(function() {
            if (el.value === currentValue && el.selectionStart !== caretPos) $4b1d9a4dcf1b21ac$var$setCaretPosition(el, caretPos);
        }, 0);
    };
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */ var correctCaretPosition = function(value, caretPos, direction) {
        return $4b1d9a4dcf1b21ac$var$getCaretPosInBoundary(value, caretPos, getCaretBoundary(value), direction);
    };
    var getNewCaretPosition = function(inputValue, newFormattedValue, caretPos) {
        var caretBoundary = getCaretBoundary(newFormattedValue);
        var updatedCaretPos = $4b1d9a4dcf1b21ac$var$getCaretPosition(newFormattedValue, formattedValue, inputValue, caretPos, caretBoundary, isValidInputCharacter, isCharacterSame);
        //correct caret position if its outside of editable area
        updatedCaretPos = $4b1d9a4dcf1b21ac$var$getCaretPosInBoundary(newFormattedValue, updatedCaretPos, caretBoundary);
        return updatedCaretPos;
    };
    var updateValueAndCaretPosition = function(params) {
        var newFormattedValue = params.formattedValue;
        if (newFormattedValue === void 0) newFormattedValue = '';
        var input = params.input;
        var source = params.source;
        var event = params.event;
        var numAsString = params.numAsString;
        var caretPos;
        if (input) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = $4b1d9a4dcf1b21ac$var$geInputCaretPosition(input);
            /**
             * set the value imperatively, this is required for IE fix
             * This is also required as if new caret position is beyond the previous value.
             * Caret position will not be set correctly
             */ input.value = newFormattedValue;
            //get the caret position
            caretPos = getNewCaretPosition(inputValue, newFormattedValue, currentCaretPosition);
            //set caret position imperatively
            if (caretPos !== undefined) setPatchedCaretPosition(input, caretPos, newFormattedValue);
        }
        if (newFormattedValue !== formattedValue) // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
        _onValueChange(getValueObject(newFormattedValue, numAsString), {
            event: event,
            source: source
        });
    };
    /**
     * if the formatted value is not synced to parent, or if the formatted value is different from last synced value sync it
     * if the formatting props is removed, in which case last formatted value will be different from the numeric string value
     * in such case we need to inform the parent.
     */ (0, $lVd4O.useEffect)(function() {
        var ref = lastUpdatedValue.current;
        var lastFormattedValue = ref.formattedValue;
        var lastNumAsString = ref.numAsString;
        if (formattedValue !== lastFormattedValue || numAsString !== lastNumAsString) _onValueChange(getValueObject(formattedValue, numAsString), {
            event: undefined,
            source: $4b1d9a4dcf1b21ac$var$SourceType.props
        });
    }, [
        formattedValue,
        numAsString
    ]);
    // also if formatted value is changed from the props, we need to update the caret position
    // keep the last caret position if element is focused
    var currentCaretPosition = focusedElm.current ? $4b1d9a4dcf1b21ac$var$geInputCaretPosition(focusedElm.current) : undefined;
    // needed to prevent warning with useLayoutEffect on server
    var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $lVd4O.useLayoutEffect) : (0, $lVd4O.useEffect);
    useIsomorphicLayoutEffect(function() {
        var input = focusedElm.current;
        if (formattedValue !== lastUpdatedValue.current.formattedValue && input) {
            var caretPos = getNewCaretPosition(lastUpdatedValue.current.formattedValue, formattedValue, currentCaretPosition);
            /**
             * set the value imperatively, as we set the caret position as well imperatively.
             * This is to keep value and caret position in sync
             */ input.value = formattedValue;
            setPatchedCaretPosition(input, caretPos, formattedValue);
        }
    }, [
        formattedValue
    ]);
    var formatInputValue = function(inputValue, event, source) {
        var input = event.target;
        var changeRange = caretPositionBeforeChange.current ? $4b1d9a4dcf1b21ac$var$findChangedRangeFromCaretPositions(caretPositionBeforeChange.current, input.selectionEnd) : $4b1d9a4dcf1b21ac$var$findChangeRange(formattedValue, inputValue);
        var changeMeta = Object.assign(Object.assign({}, changeRange), {
            lastValue: formattedValue
        });
        var _numAsString = removeFormatting(inputValue, changeMeta);
        var _formattedValue = _format(_numAsString);
        // formatting can remove some of the number chars, so we need to fine number string again
        _numAsString = removeFormatting(_formattedValue, undefined);
        if (isAllowed && !isAllowed(getValueObject(_formattedValue, _numAsString))) {
            //reset the caret position
            var input$1 = event.target;
            var currentCaretPosition = $4b1d9a4dcf1b21ac$var$geInputCaretPosition(input$1);
            var caretPos = getNewCaretPosition(inputValue, formattedValue, currentCaretPosition);
            input$1.value = formattedValue;
            setPatchedCaretPosition(input$1, caretPos, formattedValue);
            return false;
        }
        updateValueAndCaretPosition({
            formattedValue: _formattedValue,
            numAsString: _numAsString,
            inputValue: inputValue,
            event: event,
            source: source,
            input: event.target
        });
        return true;
    };
    var setCaretPositionInfoBeforeChange = function(el, endOffset) {
        if (endOffset === void 0) endOffset = 0;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        caretPositionBeforeChange.current = {
            selectionStart: selectionStart,
            selectionEnd: selectionEnd + endOffset
        };
    };
    var _onChange = function(e) {
        var el = e.target;
        var inputValue = el.value;
        var changed = formatInputValue(inputValue, e, $4b1d9a4dcf1b21ac$var$SourceType.event);
        if (changed) onChange(e);
        // reset the position, as we have already handled the caret position
        caretPositionBeforeChange.current = undefined;
    };
    var _onKeyDown = function(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = '';
        var expectedCaretPosition;
        //Handle backspace and delete against non numerical/decimal characters or arrow keys
        if (key === 'ArrowLeft' || key === 'Backspace') expectedCaretPosition = Math.max(selectionStart - 1, 0);
        else if (key === 'ArrowRight') expectedCaretPosition = Math.min(selectionStart + 1, value.length);
        else if (key === 'Delete') expectedCaretPosition = selectionStart;
        // if key is delete and text is not selected keep the end offset to 1, as it deletes one character
        // this is required as selection is not changed on delete case, which changes the change range calculation
        var endOffset = 0;
        if (key === 'Delete' && selectionStart === selectionEnd) endOffset = 1;
        var isArrowKey = key === 'ArrowLeft' || key === 'ArrowRight';
        //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        // also if multiple characters are selected don't handle
        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd && !isArrowKey) {
            onKeyDown(e);
            // keep information of what was the caret position before keyDown
            // set it after onKeyDown, in case parent updates the position manually
            setCaretPositionInfoBeforeChange(el, endOffset);
            return;
        }
        var newCaretPosition = expectedCaretPosition;
        if (isArrowKey) {
            var direction = key === 'ArrowLeft' ? 'left' : 'right';
            newCaretPosition = correctCaretPosition(value, expectedCaretPosition, direction);
            // arrow left or right only moves the caret, so no need to handle the event, if we are handling it manually
            if (newCaretPosition !== expectedCaretPosition) e.preventDefault();
        } else if (key === 'Delete' && !isValidInputCharacter(value[expectedCaretPosition])) // in case of delete go to closest caret boundary on the right side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'right');
        else if (key === 'Backspace' && !isValidInputCharacter(value[expectedCaretPosition])) // in case of backspace go to closest caret boundary on the left side
        newCaretPosition = correctCaretPosition(value, expectedCaretPosition, 'left');
        if (newCaretPosition !== expectedCaretPosition) setPatchedCaretPosition(el, newCaretPosition, value);
        onKeyDown(e);
        setCaretPositionInfoBeforeChange(el, endOffset);
    };
    /** required to handle the caret position when click anywhere within the input **/ var _onMouseUp = function(e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
         */ var correctCaretPositionIfRequired = function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = '';
            if (selectionStart === selectionEnd) {
                var caretPosition = correctCaretPosition(value, selectionStart);
                if (caretPosition !== selectionStart) setPatchedCaretPosition(el, caretPosition, value);
            }
        };
        correctCaretPositionIfRequired();
        // try to correct after selection has updated by browser
        // this case is required when user clicks on some position while a text is selected on input
        requestAnimationFrame(function() {
            correctCaretPositionIfRequired();
        });
        onMouseUp(e);
        setCaretPositionInfoBeforeChange(el);
    };
    var _onFocus = function(e) {
        // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)
        if (e.persist) e.persist();
        var el = e.target;
        var currentTarget = e.currentTarget;
        focusedElm.current = el;
        timeout.current.focusTimeout = setTimeout(function() {
            var selectionStart = el.selectionStart;
            var selectionEnd = el.selectionEnd;
            var value = el.value;
            if (value === void 0) value = '';
            var caretPosition = correctCaretPosition(value, selectionStart);
            //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
            if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) setPatchedCaretPosition(el, caretPosition, value);
            onFocus(Object.assign(Object.assign({}, e), {
                currentTarget: currentTarget
            }));
        }, 0);
    };
    var _onBlur = function(e) {
        focusedElm.current = null;
        clearTimeout(timeout.current.focusTimeout);
        clearTimeout(timeout.current.setCaretTimeout);
        onBlur(e);
    };
    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && $4b1d9a4dcf1b21ac$var$addInputMode() ? 'numeric' : undefined;
    var inputProps = Object.assign({
        inputMode: inputMode
    }, otherProps, {
        type: type,
        value: formattedValue,
        onChange: _onChange,
        onKeyDown: _onKeyDown,
        onMouseUp: _onMouseUp,
        onFocus: _onFocus,
        onBlur: _onBlur
    });
    if (displayType === 'text') return renderText ? (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).Fragment, null, renderText(formattedValue, otherProps) || null) : (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("span", Object.assign({}, otherProps, {
        ref: getInputRef
    }), formattedValue);
    else if (customInput) {
        var CustomInput = customInput;
        /* @ts-ignore */ return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement(CustomInput, Object.assign({}, inputProps, {
            ref: getInputRef
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement("input", Object.assign({}, inputProps, {
        ref: getInputRef
    }));
}
function $4b1d9a4dcf1b21ac$export$8afdc6404de1eded(numStr, props) {
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var allowNegative = props.allowNegative;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    if (thousandsGroupStyle === void 0) thousandsGroupStyle = 'thousand';
    // don't apply formatting on empty string or '-'
    if (numStr === '' || numStr === '-') return numStr;
    var ref = $4b1d9a4dcf1b21ac$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    /**
     * Keep the decimal separator
     * when decimalScale is not defined or non zero and the numStr has decimal in it
     * Or if decimalScale is > 0 and fixeDecimalScale is true (even if numStr has no decimal)
     */ var hasDecimalSeparator = decimalScale !== 0 && numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
    var ref$1 = $4b1d9a4dcf1b21ac$var$splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$1.beforeDecimal;
    var afterDecimal = ref$1.afterDecimal;
    var addNegation = ref$1.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined
    if (decimalScale !== undefined) afterDecimal = $4b1d9a4dcf1b21ac$var$limitToScale(afterDecimal, decimalScale, !!fixedDecimalScale);
    if (thousandSeparator) beforeDecimal = $4b1d9a4dcf1b21ac$var$applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    //add prefix and suffix when there is a number present
    if (prefix) beforeDecimal = prefix + beforeDecimal;
    if (suffix) afterDecimal = afterDecimal + suffix;
    //restore negation sign
    if (addNegation) beforeDecimal = '-' + beforeDecimal;
    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
    return numStr;
}
function $4b1d9a4dcf1b21ac$var$getSeparators(props) {
    var decimalSeparator = props.decimalSeparator;
    if (decimalSeparator === void 0) decimalSeparator = '.';
    var thousandSeparator = props.thousandSeparator;
    var allowedDecimalSeparators = props.allowedDecimalSeparators;
    if (thousandSeparator === true) thousandSeparator = ',';
    if (!allowedDecimalSeparators) allowedDecimalSeparators = [
        decimalSeparator,
        '.'
    ];
    return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator,
        allowedDecimalSeparators: allowedDecimalSeparators
    };
}
function $4b1d9a4dcf1b21ac$var$handleNegation(value, allowNegative) {
    if (value === void 0) value = '';
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');
    // Check number has '-' value
    var hasNegation = negationRegex.test(value);
    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);
    //remove negation
    value = value.replace(/-/g, '');
    if (hasNegation && !removeNegation && allowNegative) value = '-' + value;
    return value;
}
function $4b1d9a4dcf1b21ac$var$getNumberRegex(decimalSeparator, global) {
    return new RegExp("(^-)|[0-9]|" + $4b1d9a4dcf1b21ac$var$escapeRegExp(decimalSeparator), global ? 'g' : undefined);
}
function $4b1d9a4dcf1b21ac$var$isNumericString(val, prefix, suffix) {
    // for empty value we can always treat it as numeric string
    if (val === '') return true;
    return !(prefix === null || prefix === void 0 ? void 0 : prefix.match(/\d/)) && !(suffix === null || suffix === void 0 ? void 0 : suffix.match(/\d/)) && typeof val === 'string' && !isNaN(Number(val));
}
function $4b1d9a4dcf1b21ac$export$bd06c53c8882f574(value, changeMeta, props) {
    var assign;
    if (changeMeta === void 0) changeMeta = $4b1d9a4dcf1b21ac$var$getDefaultChangeMeta(value);
    var allowNegative = props.allowNegative;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var decimalScale = props.decimalScale;
    var from = changeMeta.from;
    var to = changeMeta.to;
    var start = to.start;
    var end = to.end;
    var ref = $4b1d9a4dcf1b21ac$var$getSeparators(props);
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var decimalSeparator = ref.decimalSeparator;
    var isBeforeDecimalSeparator = value[end] === decimalSeparator;
    /**
     * If only a number is added on empty input which matches with the prefix or suffix,
     * then don't remove it, just return the same
     */ if ($4b1d9a4dcf1b21ac$var$charIsNumber(value) && (value === prefix || value === suffix) && changeMeta.lastValue === '') return value;
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */ if (end - start === 1 && allowedDecimalSeparators.indexOf(value[start]) !== -1) {
        var separator = decimalScale === 0 ? '' : decimalSeparator;
        value = value.substring(0, start) + separator + value.substring(start + 1, value.length);
    }
    var stripNegation = function(value, start, end) {
        /**
         * if prefix starts with - we don't allow negative number to avoid confusion
         * if suffix starts with - and the value length is same as suffix length, then the - sign is from the suffix
         * In other cases, if the value starts with - then it is a negation
         */ var hasNegation = false;
        var hasDoubleNegation = false;
        if (prefix.startsWith('-')) hasNegation = false;
        else if (value.startsWith('--')) {
            hasNegation = false;
            hasDoubleNegation = true;
        } else if (suffix.startsWith('-') && value.length === suffix.length) hasNegation = false;
        else if (value[0] === '-') hasNegation = true;
        var charsToRemove = hasNegation ? 1 : 0;
        if (hasDoubleNegation) charsToRemove = 2;
        // remove negation/double negation from start to simplify prefix logic as negation comes before prefix
        if (charsToRemove) {
            value = value.substring(charsToRemove);
            // account for the removal of the negation for start and end index
            start -= charsToRemove;
            end -= charsToRemove;
        }
        return {
            value: value,
            start: start,
            end: end,
            hasNegation: hasNegation
        };
    };
    var toMetadata = stripNegation(value, start, end);
    var hasNegation = toMetadata.hasNegation;
    assign = toMetadata, value = assign.value, start = assign.start, end = assign.end;
    var ref$1 = stripNegation(changeMeta.lastValue, from.start, from.end);
    var fromStart = ref$1.start;
    var fromEnd = ref$1.end;
    var lastValue = ref$1.value;
    // if only prefix and suffix part is updated reset the value to last value
    // if the changed range is from suffix in the updated value, and the the suffix starts with the same characters, allow the change
    var updatedSuffixPart = value.substring(start, end);
    if (value.length && lastValue.length && (fromStart > lastValue.length - suffix.length || fromEnd < prefix.length) && !(updatedSuffixPart && suffix.startsWith(updatedSuffixPart))) value = lastValue;
    /**
     * remove prefix
     * Remove whole prefix part if its present on the value
     * If the prefix is partially deleted (in which case change start index will be less the prefix length)
     * Remove only partial part of prefix.
     */ var startIndex = 0;
    if (value.startsWith(prefix)) startIndex += prefix.length;
    else if (start < prefix.length) startIndex = start;
    value = value.substring(startIndex);
    // account for deleted prefix for end
    end -= startIndex;
    /**
     * Remove suffix
     * Remove whole suffix part if its present on the value
     * If the suffix is partially deleted (in which case change end index will be greater than the suffixStartIndex)
     * remove the partial part of suffix
     */ var endIndex = value.length;
    var suffixStartIndex = value.length - suffix.length;
    if (value.endsWith(suffix)) endIndex = suffixStartIndex;
    else if (end > suffixStartIndex) endIndex = end;
    else if (end > value.length - suffix.length) endIndex = end;
    value = value.substring(0, endIndex);
    // add the negation back and handle for double negation
    value = $4b1d9a4dcf1b21ac$var$handleNegation(hasNegation ? "-" + value : value, allowNegative);
    // remove non numeric characters
    value = (value.match($4b1d9a4dcf1b21ac$var$getNumberRegex(decimalSeparator, true)) || []).join('');
    // replace the decimalSeparator with ., and only keep the first separator, ignore following ones
    var firstIndex = value.indexOf(decimalSeparator);
    value = value.replace(new RegExp($4b1d9a4dcf1b21ac$var$escapeRegExp(decimalSeparator), 'g'), function(match, index) {
        return index === firstIndex ? '.' : '';
    });
    //check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    var ref$2 = $4b1d9a4dcf1b21ac$var$splitDecimal(value, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //clear only if something got deleted before decimal (cursor is before decimal)
    if (to.end - to.start < from.end - from.start && beforeDecimal === '' && isBeforeDecimalSeparator && !parseFloat(afterDecimal)) value = addNegation ? '-' : '';
    return value;
}
function $4b1d9a4dcf1b21ac$export$ce26457d42b8fa52(formattedValue, props) {
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var suffix = props.suffix;
    if (suffix === void 0) suffix = '';
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hasNegation = formattedValue[0] === '-';
    // fill for prefix and negation
    boundaryAry.fill(false, 0, prefix.length + (hasNegation ? 1 : 0));
    // fill for suffix
    var valLn = formattedValue.length;
    boundaryAry.fill(false, valLn - suffix.length + 1, valLn + 1);
    return boundaryAry;
}
function $4b1d9a4dcf1b21ac$var$validateAndUpdateProps(props) {
    var ref = $4b1d9a4dcf1b21ac$var$getSeparators(props);
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    // eslint-disable-next-line prefer-const
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var allowNegative = props.allowNegative;
    if (allowNegative === void 0) allowNegative = true;
    if (thousandSeparator === decimalSeparator) throw new Error("\n        Decimal separator can't be same as thousand separator.\n        thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n        decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n     ");
    if (prefix.startsWith('-') && allowNegative) {
        // TODO: throw error in next major version
        console.error("\n      Prefix can't start with '-' when allowNegative is true.\n      prefix: " + prefix + "\n      allowNegative: " + allowNegative + "\n    ");
        allowNegative = false;
    }
    return Object.assign(Object.assign({}, props), {
        allowNegative: allowNegative
    });
}
function $4b1d9a4dcf1b21ac$export$2fb051e8b03d5d2d(props) {
    // validate props
    props = $4b1d9a4dcf1b21ac$var$validateAndUpdateProps(props);
    var _decimalSeparator = props.decimalSeparator;
    var _allowedDecimalSeparators = props.allowedDecimalSeparators;
    var thousandsGroupStyle = props.thousandsGroupStyle;
    var suffix = props.suffix;
    var allowNegative = props.allowNegative;
    var allowLeadingZeros = props.allowLeadingZeros;
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $4b1d9a4dcf1b21ac$var$noop;
    var onBlur = props.onBlur;
    if (onBlur === void 0) onBlur = $4b1d9a4dcf1b21ac$var$noop;
    var thousandSeparator = props.thousandSeparator;
    var decimalScale = props.decimalScale;
    var fixedDecimalScale = props.fixedDecimalScale;
    var prefix = props.prefix;
    if (prefix === void 0) prefix = '';
    var defaultValue = props.defaultValue;
    var value = props.value;
    var valueIsNumericString = props.valueIsNumericString;
    var onValueChange = props.onValueChange;
    var restProps = $4b1d9a4dcf1b21ac$var$__rest(props, [
        "decimalSeparator",
        "allowedDecimalSeparators",
        "thousandsGroupStyle",
        "suffix",
        "allowNegative",
        "allowLeadingZeros",
        "onKeyDown",
        "onBlur",
        "thousandSeparator",
        "decimalScale",
        "fixedDecimalScale",
        "prefix",
        "defaultValue",
        "value",
        "valueIsNumericString",
        "onValueChange"
    ]);
    // get derived decimalSeparator and allowedDecimalSeparators
    var ref = $4b1d9a4dcf1b21ac$var$getSeparators(props);
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var _format = function(numStr) {
        return $4b1d9a4dcf1b21ac$export$8afdc6404de1eded(numStr, props);
    };
    var _removeFormatting = function(inputValue, changeMeta) {
        return $4b1d9a4dcf1b21ac$export$bd06c53c8882f574(inputValue, changeMeta, props);
    };
    var _value = $4b1d9a4dcf1b21ac$var$isNil(value) ? defaultValue : value;
    // try to figure out isValueNumericString based on format prop and value
    var _valueIsNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $4b1d9a4dcf1b21ac$var$isNumericString(_value, prefix, suffix);
    if (!$4b1d9a4dcf1b21ac$var$isNil(value)) _valueIsNumericString = _valueIsNumericString || typeof value === 'number';
    else if (!$4b1d9a4dcf1b21ac$var$isNil(defaultValue)) _valueIsNumericString = _valueIsNumericString || typeof defaultValue === 'number';
    var roundIncomingValueToPrecision = function(value) {
        if ($4b1d9a4dcf1b21ac$var$isNotValidValue(value)) return value;
        if (typeof value === 'number') value = $4b1d9a4dcf1b21ac$var$toNumericString(value);
        /**
         * only round numeric or float string values coming through props,
         * we don't need to do it for onChange events, as we want to prevent typing there
         */ if (_valueIsNumericString && typeof decimalScale === 'number') return $4b1d9a4dcf1b21ac$var$roundToPrecision(value, decimalScale, Boolean(fixedDecimalScale));
        return value;
    };
    var ref$1 = $4b1d9a4dcf1b21ac$var$useInternalValues(roundIncomingValueToPrecision(value), roundIncomingValueToPrecision(defaultValue), Boolean(_valueIsNumericString), _format, _removeFormatting, onValueChange);
    var ref$1_0 = ref$1[0];
    var numAsString = ref$1_0.numAsString;
    var formattedValue = ref$1_0.formattedValue;
    var _onValueChange = ref$1[1];
    var _onKeyDown = function(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        if (value === void 0) value = '';
        // if user tries to delete partial prefix then ignore it
        if ((key === 'Backspace' || key === 'Delete') && selectionEnd < prefix.length) {
            e.preventDefault();
            return;
        }
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // if user hits backspace, while the cursor is before prefix, and the input has negation, remove the negation
        if (key === 'Backspace' && value[0] === '-' && selectionStart === prefix.length + 1 && allowNegative) // bring the cursor to after negation
        $4b1d9a4dcf1b21ac$var$setCaretPosition(el, 1);
        // don't allow user to delete decimal separator when decimalScale and fixedDecimalScale is set
        if (decimalScale && fixedDecimalScale) {
            if (key === 'Backspace' && value[selectionStart - 1] === decimalSeparator) {
                $4b1d9a4dcf1b21ac$var$setCaretPosition(el, selectionStart - 1);
                e.preventDefault();
            } else if (key === 'Delete' && value[selectionStart] === decimalSeparator) e.preventDefault();
        }
        // if user presses the allowed decimal separator before the separator, move the cursor after the separator
        if ((allowedDecimalSeparators === null || allowedDecimalSeparators === void 0 ? void 0 : allowedDecimalSeparators.includes(key)) && value[selectionStart] === decimalSeparator) $4b1d9a4dcf1b21ac$var$setCaretPosition(el, selectionStart + 1);
        var _thousandSeparator = thousandSeparator === true ? ',' : thousandSeparator;
        // move cursor when delete or backspace is pressed before/after thousand separator
        if (key === 'Backspace' && value[selectionStart - 1] === _thousandSeparator) $4b1d9a4dcf1b21ac$var$setCaretPosition(el, selectionStart - 1);
        if (key === 'Delete' && value[selectionStart] === _thousandSeparator) $4b1d9a4dcf1b21ac$var$setCaretPosition(el, selectionStart + 1);
        onKeyDown(e);
    };
    var _onBlur = function(e) {
        var _value = numAsString;
        // if there no no numeric value, clear the input
        if (!_value.match(/\d/g)) _value = '';
        // clear leading 0s
        if (!allowLeadingZeros) _value = $4b1d9a4dcf1b21ac$var$fixLeadingZero(_value);
        // apply fixedDecimalScale on blur event
        if (fixedDecimalScale && decimalScale) _value = $4b1d9a4dcf1b21ac$var$roundToPrecision(_value, decimalScale, fixedDecimalScale);
        if (_value !== numAsString) {
            var formattedValue = $4b1d9a4dcf1b21ac$export$8afdc6404de1eded(_value, props);
            _onValueChange({
                formattedValue: formattedValue,
                value: _value,
                floatValue: parseFloat(_value)
            }, {
                event: e,
                source: $4b1d9a4dcf1b21ac$var$SourceType.event
            });
        }
        onBlur(e);
    };
    var isValidInputCharacter = function(inputChar) {
        if (inputChar === decimalSeparator) return true;
        return $4b1d9a4dcf1b21ac$var$charIsNumber(inputChar);
    };
    var isCharacterSame = function(ref) {
        var currentValue = ref.currentValue;
        var lastValue = ref.lastValue;
        var formattedValue = ref.formattedValue;
        var currentValueIndex = ref.currentValueIndex;
        var formattedValueIndex = ref.formattedValueIndex;
        var curChar = currentValue[currentValueIndex];
        var newChar = formattedValue[formattedValueIndex];
        /**
         * NOTE: as thousand separator and allowedDecimalSeparators can be same, we need to check on
         * typed range if we have typed any character from allowedDecimalSeparators, in that case we
         * consider different characters like , and . same within the range of updated value.
         */ var typedRange = $4b1d9a4dcf1b21ac$var$findChangeRange(lastValue, currentValue);
        var to = typedRange.to;
        // handle corner case where if we user types a decimal separator with fixedDecimalScale
        // and pass back float value the cursor jumps. #851
        var getDecimalSeparatorIndex = function(value) {
            return _removeFormatting(value).indexOf('.') + prefix.length;
        };
        if (value === 0 && fixedDecimalScale && decimalScale && currentValue[to.start] === decimalSeparator && getDecimalSeparatorIndex(currentValue) < currentValueIndex && getDecimalSeparatorIndex(formattedValue) > formattedValueIndex) return false;
        if (currentValueIndex >= to.start && currentValueIndex < to.end && allowedDecimalSeparators && allowedDecimalSeparators.includes(curChar) && newChar === decimalSeparator) return true;
        return curChar === newChar;
    };
    return Object.assign(Object.assign({}, restProps), {
        value: formattedValue,
        valueIsNumericString: false,
        isValidInputCharacter: isValidInputCharacter,
        isCharacterSame: isCharacterSame,
        onValueChange: _onValueChange,
        format: _format,
        removeFormatting: _removeFormatting,
        getCaretBoundary: function(formattedValue) {
            return $4b1d9a4dcf1b21ac$export$ce26457d42b8fa52(formattedValue, props);
        },
        onKeyDown: _onKeyDown,
        onBlur: _onBlur
    });
}
function $4b1d9a4dcf1b21ac$export$3437cf0602f97db7(props) {
    var numericFormatProps = $4b1d9a4dcf1b21ac$export$2fb051e8b03d5d2d(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($4b1d9a4dcf1b21ac$export$dd1caf9b8ccbc158, Object.assign({}, numericFormatProps));
}
function $4b1d9a4dcf1b21ac$export$4b8d05d749baae10(numStr, props) {
    var format = props.format;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    if (numStr === '' && !allowEmptyFormatting) return '';
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for(var i = 0, ln = format.length; i < ln; i++)if (format[i] === patternChar) {
        formattedNumberAry[i] = numStr[hashCount] || $4b1d9a4dcf1b21ac$var$getMaskAtIndex(mask, hashCount);
        hashCount += 1;
    }
    return formattedNumberAry.join('');
}
function $4b1d9a4dcf1b21ac$export$63600a84c223a8ea(value, changeMeta, props) {
    if (changeMeta === void 0) changeMeta = $4b1d9a4dcf1b21ac$var$getDefaultChangeMeta(value);
    var format = props.format;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var from = changeMeta.from;
    var to = changeMeta.to;
    var lastValue = changeMeta.lastValue;
    if (lastValue === void 0) lastValue = '';
    var isNumericSlot = function(caretPos) {
        return format[caretPos] === patternChar;
    };
    var removeFormatChar = function(string, startIndex) {
        var str = '';
        for(var i = 0; i < string.length; i++)if (isNumericSlot(startIndex + i) && $4b1d9a4dcf1b21ac$var$charIsNumber(string[i])) str += string[i];
        return str;
    };
    var extractNumbers = function(str) {
        return str.replace(/[^0-9]/g, '');
    };
    // if format doesn't have any number, remove all the non numeric characters
    if (!format.match(/\d/)) return extractNumbers(value);
    /**
     * if user paste the whole formatted text in an empty input or doing select all and paste, check if matches to the pattern
     * and remove the format characters, if there is a mismatch on the pattern, do plane number extract
     */ if ((lastValue === '' || from.end - from.start === lastValue.length) && value.length === format.length) {
        var str = '';
        for(var i = 0; i < value.length; i++){
            if (isNumericSlot(i)) {
                if ($4b1d9a4dcf1b21ac$var$charIsNumber(value[i])) str += value[i];
            } else if (value[i] !== format[i]) // if there is a mismatch on the pattern, do plane number extract
            return extractNumbers(value);
        }
        return str;
    }
    /**
     * For partial change,
     * where ever there is a change on the input, we can break the number in three parts
     * 1st: left part which is unchanged
     * 2nd: middle part which is changed
     * 3rd: right part which is unchanged
     *
     * The first and third section will be same as last value, only the middle part will change
     * We can consider on the change part all the new characters are non format characters.
     * And on the first and last section it can have partial format characters.
     *
     * We pick first and last section from the lastValue (as that has 1-1 mapping with format)
     * and middle one from the update value.
     */ var firstSection = lastValue.substring(0, from.start);
    var middleSection = value.substring(to.start, to.end);
    var lastSection = lastValue.substring(from.end);
    return "" + removeFormatChar(firstSection, 0) + extractNumbers(middleSection) + removeFormatChar(lastSection, from.end);
}
function $4b1d9a4dcf1b21ac$export$cbab503a3360c264(formattedValue, props) {
    var format = props.format;
    var mask = props.mask;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var boundaryAry = Array.from({
        length: formattedValue.length + 1
    }).map(function() {
        return true;
    });
    var hashCount = 0;
    var firstEmptySlot = -1;
    var maskAndIndexMap = {};
    format.split('').forEach(function(char, index) {
        var maskAtIndex = undefined;
        if (char === patternChar) {
            hashCount++;
            maskAtIndex = $4b1d9a4dcf1b21ac$var$getMaskAtIndex(mask, hashCount - 1);
            if (firstEmptySlot === -1 && formattedValue[index] === maskAtIndex) firstEmptySlot = index;
        }
        maskAndIndexMap[index] = maskAtIndex;
    });
    var isPosAllowed = function(pos) {
        // the position is allowed if the position is not masked and valid number area
        return format[pos] === patternChar && formattedValue[pos] !== maskAndIndexMap[pos];
    };
    for(var i = 0, ln = boundaryAry.length; i < ln; i++)// consider caret to be in boundary if it is before or after numeric value
    // Note: on pattern based format its denoted by patternCharacter
    // we should also allow user to put cursor on first empty slot
    boundaryAry[i] = i === firstEmptySlot || isPosAllowed(i) || isPosAllowed(i - 1);
    // the first patternChar position is always allowed
    boundaryAry[format.indexOf(patternChar)] = true;
    return boundaryAry;
}
function $4b1d9a4dcf1b21ac$var$validateProps(props) {
    var mask = props.mask;
    if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) throw new Error("Mask " + mask + " should not contain numeric character;");
    }
}
function $4b1d9a4dcf1b21ac$var$isNumericString$1(val, format) {
    //we can treat empty string as numeric string
    if (val === '') return true;
    return !(format === null || format === void 0 ? void 0 : format.match(/\d/)) && typeof val === 'string' && (!!val.match(/^\d+$/) || val === '');
}
function $4b1d9a4dcf1b21ac$export$1290cfe2185b28c0(props) {
    var mask = props.mask;
    var allowEmptyFormatting = props.allowEmptyFormatting;
    var formatProp = props.format;
    var inputMode = props.inputMode;
    if (inputMode === void 0) inputMode = 'numeric';
    var onKeyDown = props.onKeyDown;
    if (onKeyDown === void 0) onKeyDown = $4b1d9a4dcf1b21ac$var$noop;
    var patternChar = props.patternChar;
    if (patternChar === void 0) patternChar = '#';
    var value = props.value;
    var defaultValue = props.defaultValue;
    var valueIsNumericString = props.valueIsNumericString;
    var restProps = $4b1d9a4dcf1b21ac$var$__rest(props, [
        "mask",
        "allowEmptyFormatting",
        "format",
        "inputMode",
        "onKeyDown",
        "patternChar",
        "value",
        "defaultValue",
        "valueIsNumericString"
    ]);
    // validate props
    $4b1d9a4dcf1b21ac$var$validateProps(props);
    var _getCaretBoundary = function(formattedValue) {
        return $4b1d9a4dcf1b21ac$export$cbab503a3360c264(formattedValue, props);
    };
    var _onKeyDown = function(e) {
        var key = e.key;
        var el = e.target;
        var selectionStart = el.selectionStart;
        var selectionEnd = el.selectionEnd;
        var value = el.value;
        // if multiple characters are selected and user hits backspace, no need to handle anything manually
        if (selectionStart !== selectionEnd) {
            onKeyDown(e);
            return;
        }
        // bring the cursor to closest numeric section
        var caretPos = selectionStart;
        // if backspace is pressed after the format characters, bring it to numeric section
        // if delete is pressed before the format characters, bring it to numeric section
        if (key === 'Backspace' || key === 'Delete') {
            var direction = 'right';
            if (key === 'Backspace') {
                while(caretPos > 0 && formatProp[caretPos - 1] !== patternChar)caretPos--;
                direction = 'left';
            } else {
                var formatLn = formatProp.length;
                while(caretPos < formatLn && formatProp[caretPos] !== patternChar)caretPos++;
                direction = 'right';
            }
            caretPos = $4b1d9a4dcf1b21ac$var$getCaretPosInBoundary(value, caretPos, _getCaretBoundary(value), direction);
        } else if (formatProp[caretPos] !== patternChar && key !== 'ArrowLeft' && key !== 'ArrowRight') // if user is typing on format character position, bring user to next allowed caret position
        caretPos = $4b1d9a4dcf1b21ac$var$getCaretPosInBoundary(value, caretPos + 1, _getCaretBoundary(value), 'right');
        // if we changing caret position, set the caret position
        if (caretPos !== selectionStart) $4b1d9a4dcf1b21ac$var$setCaretPosition(el, caretPos);
        onKeyDown(e);
    };
    // try to figure out isValueNumericString based on format prop and value
    var _value = $4b1d9a4dcf1b21ac$var$isNil(value) ? defaultValue : value;
    var isValueNumericString = valueIsNumericString !== null && valueIsNumericString !== void 0 ? valueIsNumericString : $4b1d9a4dcf1b21ac$var$isNumericString$1(_value, formatProp);
    var _props = Object.assign(Object.assign({}, props), {
        valueIsNumericString: isValueNumericString
    });
    return Object.assign(Object.assign({}, restProps), {
        value: value,
        defaultValue: defaultValue,
        valueIsNumericString: isValueNumericString,
        inputMode: inputMode,
        format: function(numStr) {
            return $4b1d9a4dcf1b21ac$export$4b8d05d749baae10(numStr, _props);
        },
        removeFormatting: function(inputValue, changeMeta) {
            return $4b1d9a4dcf1b21ac$export$63600a84c223a8ea(inputValue, changeMeta, _props);
        },
        getCaretBoundary: _getCaretBoundary,
        onKeyDown: _onKeyDown
    });
}
function $4b1d9a4dcf1b21ac$export$9e8c774149e1782b(props) {
    var patternFormatProps = $4b1d9a4dcf1b21ac$export$1290cfe2185b28c0(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).createElement($4b1d9a4dcf1b21ac$export$dd1caf9b8ccbc158, Object.assign({}, patternFormatProps));
}



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $8c433c002dc8ee28$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $8c433c002dc8ee28$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($8c433c002dc8ee28$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $8c433c002dc8ee28$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $8c433c002dc8ee28$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $4HqRp = parcelRequire("4HqRp");


var $lVd4O = parcelRequire("lVd4O");
'use client';
/**
 * @ignore - internal component.
 */ const $bb1bac96645f7181$var$FormControlContext = /*#__PURE__*/ $lVd4O.createContext(undefined);
var $bb1bac96645f7181$export$2e2bcd8739ae039 = $bb1bac96645f7181$var$FormControlContext;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $035fa9cbb119482e$export$149c8b8bab2289d1(slot) {
    return (0, $bYZd6.default)('MuiFormControl', slot);
}
const $035fa9cbb119482e$var$formControlClasses = (0, $eaNcJ.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $035fa9cbb119482e$export$2e2bcd8739ae039 = $035fa9cbb119482e$var$formControlClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $8e95540a876aab9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $4HqRp.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $035fa9cbb119482e$export$149c8b8bab2289d1), classes);
};
const $8e95540a876aab9d$var$FormControlRoot = (0, $gvIKB.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $4HqRp.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $8e95540a876aab9d$var$FormControl = /*#__PURE__*/ $lVd4O.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $8e95540a876aab9d$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $lVd4O.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $lVd4O.Children.forEach(children, (child)=>{
            if (!(0, $0ae62b7a43146e9e$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $0ae62b7a43146e9e$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $8c433c002dc8ee28$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $lVd4O.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $lVd4O.Children.forEach(children, (child)=>{
            if (!(0, $0ae62b7a43146e9e$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $8c433c002dc8ee28$export$d652b828d7fdeff8)(child.props, true) || (0, $8c433c002dc8ee28$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $lVd4O.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $lVd4O.useRef(false);
    const onFilled = $lVd4O.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $lVd4O.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $lVd4O.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $bb1bac96645f7181$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)($8e95540a876aab9d$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $anaDR.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $8e95540a876aab9d$export$2e2bcd8739ae039 = $8e95540a876aab9d$var$FormControl;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");
function $01837c4c011538a4$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $lVd4O = parcelRequire("lVd4O");

'use client';
function $671916c86bb46a18$export$2e2bcd8739ae039() {
    return $lVd4O.useContext((0, $bb1bac96645f7181$export$2e2bcd8739ae039));
}



var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $a174e73b3cbecdf7$export$a394fa61b1d583a9(slot) {
    return (0, $bYZd6.default)('MuiFormHelperText', slot);
}
const $a174e73b3cbecdf7$var$formHelperTextClasses = (0, $eaNcJ.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a174e73b3cbecdf7$export$2e2bcd8739ae039 = $a174e73b3cbecdf7$var$formHelperTextClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $f56666fc53e7fc38$var$_span;
const $f56666fc53e7fc38$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $4HqRp.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $a174e73b3cbecdf7$export$a394fa61b1d583a9), classes);
};
const $f56666fc53e7fc38$var$FormHelperTextRoot = (0, $gvIKB.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $4HqRp.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $a174e73b3cbecdf7$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $a174e73b3cbecdf7$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $f56666fc53e7fc38$var$FormHelperText = /*#__PURE__*/ $lVd4O.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $f56666fc53e7fc38$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($f56666fc53e7fc38$var$FormHelperTextRoot, {
        as: component,
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $f56666fc53e7fc38$var$_span || ($f56666fc53e7fc38$var$_span = /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $f56666fc53e7fc38$export$2e2bcd8739ae039 = $f56666fc53e7fc38$var$FormHelperText;


var $lVd4O = parcelRequire("lVd4O");


var $jkA0j = parcelRequire("jkA0j");

var $7qwc9 = parcelRequire("7qwc9");


var $biW9R = parcelRequire("biW9R");

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");



var $jkA0j = parcelRequire("jkA0j");

var $lVd4O = parcelRequire("lVd4O");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $12553ccf2dfa9dee$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


function $d4d595d6203b8301$export$2e2bcd8739ae039(node) {
    const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}



var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $329481b97cef9b48$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $329481b97cef9b48$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $329481b97cef9b48$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $329481b97cef9b48$var$isEmpty(obj) {
    return $329481b97cef9b48$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v6.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v6.mui.com/material-ui/api/textarea-autosize/)
 */ const $329481b97cef9b48$var$TextareaAutosize = /*#__PURE__*/ $lVd4O.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $lVd4O.useRef(value != null);
    const textareaRef = $lVd4O.useRef(null);
    const handleRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $lVd4O.useRef(null);
    const hiddenTextareaRef = $lVd4O.useRef(null);
    const calculateTextareaStyles = $lVd4O.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $d4d595d6203b8301$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $329481b97cef9b48$var$getStyleValue(computedStyle.paddingBottom) + $329481b97cef9b48$var$getStyleValue(computedStyle.paddingTop);
        const border = $329481b97cef9b48$var$getStyleValue(computedStyle.borderBottomWidth) + $329481b97cef9b48$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $08e2321bb932106c$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $329481b97cef9b48$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $lVd4O.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $329481b97cef9b48$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $lVd4O.useRef(-1);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $12553ccf2dfa9dee$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $d4d595d6203b8301$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$329481b97cef9b48$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $329481b97cef9b48$export$2e2bcd8739ae039 = $329481b97cef9b48$var$TextareaAutosize;






parcelRequire("lVd4O");


parcelRequire("lVd4O");

parcelRequire("lVd4O");


var $hVfFZ = parcelRequire("hVfFZ");


var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $1f7f1e5ad3c2602b$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $6a00530d38c0e8b0$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $hVfFZ.default), {
        styles: globalStyles
    });
}
var $1f7f1e5ad3c2602b$export$2e2bcd8739ae039 = $1f7f1e5ad3c2602b$var$GlobalStyles;



var $4ZbsN = parcelRequire("4ZbsN");

var $lRoul = parcelRequire("lRoul");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $78b2698748a7cddc$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1f7f1e5ad3c2602b$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $4ZbsN.default),
        themeId: (0, $lRoul.default)
    });
}
var $78b2698748a7cddc$export$2e2bcd8739ae039 = $78b2698748a7cddc$var$GlobalStyles;



var $iO5o7 = parcelRequire("iO5o7");

var $cfEcJ = parcelRequire("cfEcJ");

var $gvIKB = parcelRequire("gvIKB");
function $70d5a6dd34f3cbc3$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $iO5o7.jsx)((0, $78b2698748a7cddc$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $70d5a6dd34f3cbc3$export$7e7f5719ff4debb1() {
    return 0, $75e909056141c6de$export$2e2bcd8739ae039;
}


var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $4HqRp = parcelRequire("4HqRp");


'use client';
var $4719068e6ea2a726$export$2e2bcd8739ae039 = (0, $936b0567590735ec$export$2e2bcd8739ae039);




var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $ef3e12df16667060$export$ef57d5c8ca2278f6(slot) {
    return (0, $bYZd6.default)('MuiInputBase', slot);
}
const $ef3e12df16667060$var$inputBaseClasses = (0, $eaNcJ.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $ef3e12df16667060$export$2e2bcd8739ae039 = $ef3e12df16667060$var$inputBaseClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $8af59d4a6cc8aa2f$var$_InputGlobalStyles;
const $8af59d4a6cc8aa2f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $4HqRp.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $8af59d4a6cc8aa2f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $8af59d4a6cc8aa2f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4HqRp.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $4HqRp.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $ef3e12df16667060$export$ef57d5c8ca2278f6), classes);
};
const $8af59d4a6cc8aa2f$export$298a043133d72a38 = (0, $gvIKB.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $8af59d4a6cc8aa2f$export$965edad20a84fa75
})((0, $7KgDD.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $ef3e12df16667060$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $8af59d4a6cc8aa2f$export$ee10465db6ff6017 = (0, $gvIKB.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $8af59d4a6cc8aa2f$export$cf507b112810e72d
})((0, $7KgDD.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $ef3e12df16667060$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $ef3e12df16667060$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $8af59d4a6cc8aa2f$var$InputGlobalStyles = (0, $70d5a6dd34f3cbc3$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $8af59d4a6cc8aa2f$var$InputBase = /*#__PURE__*/ $lVd4O.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $lVd4O.useRef(value != null);
    const inputRef = $lVd4O.useRef();
    const handleInputRefWarning = $lVd4O.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $lVd4O.useState(false);
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $lVd4O.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $lVd4O.useCallback((obj)=>{
        if ((0, $8c433c002dc8ee28$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $4719068e6ea2a726$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $biW9R.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $lVd4O.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $329481b97cef9b48$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $lVd4O.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $8af59d4a6cc8aa2f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $8af59d4a6cc8aa2f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $8af59d4a6cc8aa2f$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $8af59d4a6cc8aa2f$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($8af59d4a6cc8aa2f$var$_InputGlobalStyles || ($8af59d4a6cc8aa2f$var$_InputGlobalStyles = /*#__PURE__*/ (0, $iO5o7.jsx)($8af59d4a6cc8aa2f$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $iO5o7.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $anaDR.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $bb1bac96645f7181$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $anaDR.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $8af59d4a6cc8aa2f$export$2e2bcd8739ae039 = $8af59d4a6cc8aa2f$var$InputBase;



var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");

function $721af9de35ad4d52$export$cdb270390122322b(slot) {
    return (0, $bYZd6.default)('MuiInput', slot);
}
const $721af9de35ad4d52$var$inputClasses = {
    ...(0, $ef3e12df16667060$export$2e2bcd8739ae039),
    ...(0, $eaNcJ.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $721af9de35ad4d52$export$2e2bcd8739ae039 = $721af9de35ad4d52$var$inputClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $311ae76fb1b3b08e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $721af9de35ad4d52$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $311ae76fb1b3b08e$var$InputRoot = (0, $gvIKB.default)((0, $8af59d4a6cc8aa2f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8af59d4a6cc8aa2f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $721af9de35ad4d52$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $721af9de35ad4d52$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $721af9de35ad4d52$export$2e2bcd8739ae039).disabled}, .${(0, $721af9de35ad4d52$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $721af9de35ad4d52$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $311ae76fb1b3b08e$var$InputInput = (0, $gvIKB.default)((0, $8af59d4a6cc8aa2f$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $8af59d4a6cc8aa2f$export$cf507b112810e72d)
})({});
const $311ae76fb1b3b08e$var$Input = /*#__PURE__*/ $lVd4O.forwardRef(function Input(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $311ae76fb1b3b08e$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $7qwc9.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $311ae76fb1b3b08e$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $311ae76fb1b3b08e$var$InputInput;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8af59d4a6cc8aa2f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$311ae76fb1b3b08e$var$Input.muiName = 'Input';
var $311ae76fb1b3b08e$export$2e2bcd8739ae039 = $311ae76fb1b3b08e$var$Input;


var $lVd4O = parcelRequire("lVd4O");


var $jkA0j = parcelRequire("jkA0j");

var $anaDR = parcelRequire("anaDR");



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");



var $4HqRp = parcelRequire("4HqRp");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $ac8c675efbc4e5f5$export$f7d501e40371cd17(slot) {
    return (0, $bYZd6.default)('MuiFormLabel', slot);
}
const $ac8c675efbc4e5f5$var$formLabelClasses = (0, $eaNcJ.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $ac8c675efbc4e5f5$export$2e2bcd8739ae039 = $ac8c675efbc4e5f5$var$formLabelClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $54af1e1b0778e09c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4HqRp.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $ac8c675efbc4e5f5$export$f7d501e40371cd17), classes);
};
const $54af1e1b0778e09c$export$aa5bc7f8a4705b27 = (0, $gvIKB.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $ac8c675efbc4e5f5$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $ac8c675efbc4e5f5$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $ac8c675efbc4e5f5$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $54af1e1b0778e09c$var$AsteriskComponent = (0, $gvIKB.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $7KgDD.default)(({ theme: theme })=>({
        [`&.${(0, $ac8c675efbc4e5f5$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $54af1e1b0778e09c$var$FormLabel = /*#__PURE__*/ $lVd4O.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $54af1e1b0778e09c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($54af1e1b0778e09c$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $iO5o7.jsxs)($54af1e1b0778e09c$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $54af1e1b0778e09c$export$2e2bcd8739ae039 = $54af1e1b0778e09c$var$FormLabel;



var $4HqRp = parcelRequire("4HqRp");

var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $1932b396b98d8f35$export$c1c4b4545ad2ea5f(slot) {
    return (0, $bYZd6.default)('MuiInputLabel', slot);
}
const $1932b396b98d8f35$var$inputLabelClasses = (0, $eaNcJ.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $1932b396b98d8f35$export$2e2bcd8739ae039 = $1932b396b98d8f35$var$inputLabelClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $d36f7c81336aa280$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $4HqRp.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $1932b396b98d8f35$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $d36f7c81336aa280$var$InputLabelRoot = (0, $gvIKB.default)((0, $54af1e1b0778e09c$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ac8c675efbc4e5f5$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $d36f7c81336aa280$var$InputLabel = /*#__PURE__*/ $lVd4O.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $d36f7c81336aa280$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($d36f7c81336aa280$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $anaDR.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $d36f7c81336aa280$export$2e2bcd8739ae039 = $d36f7c81336aa280$var$InputLabel;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");



var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");


var $lVd4O = parcelRequire("lVd4O");

var $7qwc9 = parcelRequire("7qwc9");



var $jkA0j = parcelRequire("jkA0j");


var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");

function $c9401e08fda8f17d$export$3331e419f1a48437(slot) {
    return (0, $bYZd6.default)('MuiFilledInput', slot);
}
const $c9401e08fda8f17d$var$filledInputClasses = {
    ...(0, $ef3e12df16667060$export$2e2bcd8739ae039),
    ...(0, $eaNcJ.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $c9401e08fda8f17d$export$2e2bcd8739ae039 = $c9401e08fda8f17d$var$filledInputClasses;




var $4HqRp = parcelRequire("4HqRp");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $c012e0ac5dd7c799$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $4HqRp.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $c9401e08fda8f17d$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $c012e0ac5dd7c799$var$FilledInputRoot = (0, $gvIKB.default)((0, $8af59d4a6cc8aa2f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8af59d4a6cc8aa2f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).disabled}, .${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $c9401e08fda8f17d$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $c012e0ac5dd7c799$var$FilledInputInput = (0, $gvIKB.default)((0, $8af59d4a6cc8aa2f$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $8af59d4a6cc8aa2f$export$cf507b112810e72d)
})((0, $7KgDD.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $c012e0ac5dd7c799$var$FilledInput = /*#__PURE__*/ $lVd4O.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $c012e0ac5dd7c799$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $7qwc9.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $c012e0ac5dd7c799$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $c012e0ac5dd7c799$var$FilledInputInput;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8af59d4a6cc8aa2f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$c012e0ac5dd7c799$var$FilledInput.muiName = 'Input';
var $c012e0ac5dd7c799$export$2e2bcd8739ae039 = $c012e0ac5dd7c799$var$FilledInput;



var $lVd4O = parcelRequire("lVd4O");



var $jkA0j = parcelRequire("jkA0j");
parcelRequire("lVd4O");


var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $46e7b5ba5f6d00d1$var$_span;
const $46e7b5ba5f6d00d1$var$NotchedOutlineRoot = (0, $gvIKB.default)('fieldset', {
    shouldForwardProp: (0, $8Yw6Z.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $46e7b5ba5f6d00d1$var$NotchedOutlineLegend = (0, $gvIKB.default)('legend', {
    shouldForwardProp: (0, $8Yw6Z.default)
})((0, $7KgDD.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $46e7b5ba5f6d00d1$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $iO5o7.jsx)($46e7b5ba5f6d00d1$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)($46e7b5ba5f6d00d1$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                children: label
            }) : $46e7b5ba5f6d00d1$var$_span || ($46e7b5ba5f6d00d1$var$_span = /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}





var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");

function $10179e8053296258$export$89922944c7227687(slot) {
    return (0, $bYZd6.default)('MuiOutlinedInput', slot);
}
const $10179e8053296258$var$outlinedInputClasses = {
    ...(0, $ef3e12df16667060$export$2e2bcd8739ae039),
    ...(0, $eaNcJ.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $10179e8053296258$export$2e2bcd8739ae039 = $10179e8053296258$var$outlinedInputClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $5788750077f568c7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $10179e8053296258$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $5788750077f568c7$var$OutlinedInputRoot = (0, $gvIKB.default)((0, $8af59d4a6cc8aa2f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $8af59d4a6cc8aa2f$export$965edad20a84fa75)
})((0, $7KgDD.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $10179e8053296258$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $10179e8053296258$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $10179e8053296258$export$2e2bcd8739ae039).focused} .${(0, $10179e8053296258$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $10179e8053296258$export$2e2bcd8739ae039).focused} .${(0, $10179e8053296258$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $10179e8053296258$export$2e2bcd8739ae039).error} .${(0, $10179e8053296258$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $10179e8053296258$export$2e2bcd8739ae039).disabled} .${(0, $10179e8053296258$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $5788750077f568c7$var$NotchedOutlineRoot = (0, $gvIKB.default)((0, $46e7b5ba5f6d00d1$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $7KgDD.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $5788750077f568c7$var$OutlinedInputInput = (0, $gvIKB.default)((0, $8af59d4a6cc8aa2f$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $8af59d4a6cc8aa2f$export$cf507b112810e72d)
})((0, $7KgDD.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $5788750077f568c7$var$OutlinedInput = /*#__PURE__*/ $lVd4O.forwardRef(function OutlinedInput(inProps, ref) {
    var _React$Fragment;
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $5788750077f568c7$var$useUtilityClasses(props);
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $5788750077f568c7$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $5788750077f568c7$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8af59d4a6cc8aa2f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $iO5o7.jsx)($5788750077f568c7$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$5788750077f568c7$var$OutlinedInput.muiName = 'Input';
var $5788750077f568c7$export$2e2bcd8739ae039 = $5788750077f568c7$var$OutlinedInput;






var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $7qwc9 = parcelRequire("7qwc9");

var $jkA0j = parcelRequire("jkA0j");


var $biW9R = parcelRequire("biW9R");

var $lVd4O = parcelRequire("lVd4O");



var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");



var $a0360aeb44b98c04$export$2e2bcd8739ae039 = (0, $6a56ba80654449ac$export$2e2bcd8739ae039);



var $4HqRp = parcelRequire("4HqRp");

var $lVd4O = parcelRequire("lVd4O");



var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");




var $lVd4O = parcelRequire("lVd4O");




var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");


var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $c6941c49a6a9c109$export$c6bd6795ed6e3203(slot) {
    return (0, $bYZd6.default)('MuiList', slot);
}
const $c6941c49a6a9c109$var$listClasses = (0, $eaNcJ.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $c6941c49a6a9c109$export$2e2bcd8739ae039 = $c6941c49a6a9c109$var$listClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a5f98fb65ea8145d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $c6941c49a6a9c109$export$c6bd6795ed6e3203), classes);
};
const $a5f98fb65ea8145d$var$ListRoot = (0, $gvIKB.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $a5f98fb65ea8145d$var$List = /*#__PURE__*/ $lVd4O.forwardRef(function List(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $lVd4O.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $a5f98fb65ea8145d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $71f802e7b868aa8f$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)($a5f98fb65ea8145d$var$ListRoot, {
            as: component,
            className: (0, $anaDR.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $a5f98fb65ea8145d$export$2e2bcd8739ae039 = $a5f98fb65ea8145d$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $ea4404ab2586ffb6$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


var $19e61c406db01774$export$2e2bcd8739ae039 = (0, $ea4404ab2586ffb6$export$2e2bcd8739ae039);





var $f09fc1a8c621e01b$export$2e2bcd8739ae039 = (0, $d4d595d6203b8301$export$2e2bcd8739ae039);



var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $c587742d7fb2ce63$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $c587742d7fb2ce63$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $c587742d7fb2ce63$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $c587742d7fb2ce63$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$c587742d7fb2ce63$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $c587742d7fb2ce63$var$MenuList = /*#__PURE__*/ $lVd4O.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $lVd4O.useRef(null);
    const textCriteriaRef = $lVd4O.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $4719068e6ea2a726$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $lVd4O.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $19e61c406db01774$export$2e2bcd8739ae039)((0, $f09fc1a8c621e01b$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $a0360aeb44b98c04$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $c587742d7fb2ce63$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c587742d7fb2ce63$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $c587742d7fb2ce63$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c587742d7fb2ce63$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $c587742d7fb2ce63$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c587742d7fb2ce63$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $c587742d7fb2ce63$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c587742d7fb2ce63$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $c587742d7fb2ce63$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $c587742d7fb2ce63$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $c587742d7fb2ce63$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $lVd4O.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $lVd4O.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $lVd4O.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $lVd4O.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a5f98fb65ea8145d$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $c587742d7fb2ce63$export$2e2bcd8739ae039 = $c587742d7fb2ce63$var$MenuList;



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");







var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $188bd33bc7d9d82e$export$2e2bcd8739ae039 = (0, $12553ccf2dfa9dee$export$2e2bcd8739ae039);






var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");



var $jkA0j = parcelRequire("jkA0j");

var $lVd4O = parcelRequire("lVd4O");



var $iO5o7 = parcelRequire("iO5o7");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $c9663e0e3d3e74bf$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $c9663e0e3d3e74bf$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $c9663e0e3d3e74bf$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $c9663e0e3d3e74bf$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $c9663e0e3d3e74bf$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $c9663e0e3d3e74bf$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($c9663e0e3d3e74bf$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $c9663e0e3d3e74bf$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$c9663e0e3d3e74bf$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $c9663e0e3d3e74bf$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $c9663e0e3d3e74bf$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $c9663e0e3d3e74bf$var$defaultGetTabbable, isEnabled: isEnabled = $c9663e0e3d3e74bf$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $lVd4O.useRef(false);
    const sentinelStart = $lVd4O.useRef(null);
    const sentinelEnd = $lVd4O.useRef(null);
    const nodeToRestore = $lVd4O.useRef(null);
    const reactFocusEventTarget = $lVd4O.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $lVd4O.useRef(false);
    const rootRef = $lVd4O.useRef(null);
    const handleRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)((0, $354496b1137733e9$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $lVd4O.useRef(null);
    $lVd4O.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $lVd4O.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $lVd4O.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $lVd4O.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $c9663e0e3d3e74bf$export$2e2bcd8739ae039 = $c9663e0e3d3e74bf$var$FocusTrap;




var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");


var $lVd4O = parcelRequire("lVd4O");








var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $ce18eb56bb45d984$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $ce18eb56bb45d984$var$Fade = /*#__PURE__*/ $lVd4O.forwardRef(function Fade(props, ref) {
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $d4ddf0f0262c03ba$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $lVd4O.useRef(null);
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(nodeRef, (0, $354496b1137733e9$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $d3fbac79a43fb6d0$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $d3fbac79a43fb6d0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $d3fbac79a43fb6d0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $lVd4O.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$ce18eb56bb45d984$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $ce18eb56bb45d984$export$2e2bcd8739ae039 = $ce18eb56bb45d984$var$Fade;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $b7aea02f652c937f$export$9927a91fd93152bd(slot) {
    return (0, $bYZd6.default)('MuiBackdrop', slot);
}
const $b7aea02f652c937f$var$backdropClasses = (0, $eaNcJ.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $b7aea02f652c937f$export$2e2bcd8739ae039 = $b7aea02f652c937f$var$backdropClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $4406b948e3c3881f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $b7aea02f652c937f$export$9927a91fd93152bd), classes);
};
const $4406b948e3c3881f$var$BackdropRoot = (0, $gvIKB.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $4406b948e3c3881f$var$Backdrop = /*#__PURE__*/ $lVd4O.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $4406b948e3c3881f$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        elementType: $4406b948e3c3881f$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $ce18eb56bb45d984$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $4406b948e3c3881f$export$2e2bcd8739ae039 = $4406b948e3c3881f$var$Backdrop;



var $lVd4O = parcelRequire("lVd4O");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $9dd070f40506bf6d$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $a47b5de2ac3f61e8$var$isOverflowing(container) {
    const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $d4d595d6203b8301$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $a47b5de2ac3f61e8$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $a47b5de2ac3f61e8$var$getPaddingRight(element) {
    return parseInt((0, $d4d595d6203b8301$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $a47b5de2ac3f61e8$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $a47b5de2ac3f61e8$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$a47b5de2ac3f61e8$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $a47b5de2ac3f61e8$export$e1bd0c6150f13d96(element, hide);
    });
}
function $a47b5de2ac3f61e8$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $a47b5de2ac3f61e8$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($a47b5de2ac3f61e8$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $ea4404ab2586ffb6$export$2e2bcd8739ae039)((0, $d4d595d6203b8301$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$a47b5de2ac3f61e8$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$a47b5de2ac3f61e8$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $d4d595d6203b8301$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $a47b5de2ac3f61e8$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $a47b5de2ac3f61e8$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $a47b5de2ac3f61e8$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $a47b5de2ac3f61e8$var$getHiddenSiblings(container);
        $a47b5de2ac3f61e8$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $a47b5de2ac3f61e8$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $a47b5de2ac3f61e8$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $a47b5de2ac3f61e8$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $a47b5de2ac3f61e8$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $a47b5de2ac3f61e8$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $a47b5de2ac3f61e8$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $a47b5de2ac3f61e8$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $2dc69dba10ccac0b$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $2dc69dba10ccac0b$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $2dc69dba10ccac0b$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $2dc69dba10ccac0b$var$manager = new (0, $a47b5de2ac3f61e8$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $2dc69dba10ccac0b$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $lVd4O.useRef({});
    const mountNodeRef = $lVd4O.useRef(null);
    const modalRef = $lVd4O.useRef(null);
    const handleRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $lVd4O.useState(!open);
    const hasTransition = $2dc69dba10ccac0b$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6a56ba80654449ac$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $2dc69dba10ccac0b$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $08e2321bb932106c$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $2dc69dba10ccac0b$var$getContainer(container) || getDoc().body;
        $2dc69dba10ccac0b$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$2dc69dba10ccac0b$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $08e2321bb932106c$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $a47b5de2ac3f61e8$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $lVd4O.useCallback(()=>{
        $2dc69dba10ccac0b$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $lVd4O.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $lVd4O.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $5b439fbf43b53f58$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $9dd070f40506bf6d$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $2dc69dba10ccac0b$var$noop),
            onExited: (0, $9dd070f40506bf6d$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $2dc69dba10ccac0b$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $2dc69dba10ccac0b$export$2e2bcd8739ae039 = $2dc69dba10ccac0b$var$useModal;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $98e34b82471398a7$export$67960e22b12a638d(slot) {
    return (0, $bYZd6.default)('MuiModal', slot);
}
const $98e34b82471398a7$var$modalClasses = (0, $eaNcJ.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $98e34b82471398a7$export$2e2bcd8739ae039 = $98e34b82471398a7$var$modalClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $4edd77deffff3ad1$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $98e34b82471398a7$export$67960e22b12a638d), classes);
};
const $4edd77deffff3ad1$var$ModalRoot = (0, $gvIKB.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $4edd77deffff3ad1$var$ModalBackdrop = (0, $gvIKB.default)((0, $4406b948e3c3881f$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4edd77deffff3ad1$var$Modal = /*#__PURE__*/ $lVd4O.forwardRef(function Modal(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4edd77deffff3ad1$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $2dc69dba10ccac0b$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $4edd77deffff3ad1$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $4edd77deffff3ad1$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $anaDR.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $anaDR.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e371495800f0b06d$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $iO5o7.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c9663e0e3d3e74bf$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $lVd4O.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $4edd77deffff3ad1$export$2e2bcd8739ae039 = $4edd77deffff3ad1$var$Modal;




var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $a719ce5dc677ff0e$export$88f455dd56c95edb(slot) {
    return (0, $bYZd6.default)('MuiPopover', slot);
}
const $a719ce5dc677ff0e$var$popoverClasses = (0, $eaNcJ.default)('MuiPopover', [
    'root',
    'paper'
]);
var $a719ce5dc677ff0e$export$2e2bcd8739ae039 = $a719ce5dc677ff0e$var$popoverClasses;




var $anaDR = parcelRequire("anaDR");
function $e604885c935ab4f8$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $anaDR.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $anaDR.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $d5f3ec1faa929937$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $d5f3ec1faa929937$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $d5f3ec1faa929937$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $d5f3ec1faa929937$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $d5f3ec1faa929937$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $a719ce5dc677ff0e$export$88f455dd56c95edb), classes);
};
const $d5f3ec1faa929937$export$bcce13685275fc99 = (0, $gvIKB.default)((0, $4edd77deffff3ad1$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $d5f3ec1faa929937$export$821346c38a2d9390 = (0, $gvIKB.default)((0, $094c486a546066a9$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $d5f3ec1faa929937$var$Popover = /*#__PURE__*/ $lVd4O.forwardRef(function Popover(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $lVd4O.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $d5f3ec1faa929937$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $lVd4O.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $d5f3ec1faa929937$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $a0360aeb44b98c04$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $d5f3ec1faa929937$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $d5f3ec1faa929937$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $lVd4O.useCallback((elemRect)=>{
        return {
            vertical: $d5f3ec1faa929937$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $d5f3ec1faa929937$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $lVd4O.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $d5f3ec1faa929937$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $f09fc1a8c621e01b$export$2e2bcd8739ae039)($d5f3ec1faa929937$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $d5f3ec1faa929937$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $lVd4O.useState(open);
    const setPositioningStyles = $lVd4O.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $lVd4O.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $lVd4O.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $lVd4O.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $lVd4O.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $188bd33bc7d9d82e$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $f09fc1a8c621e01b$export$2e2bcd8739ae039)($d5f3ec1faa929937$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $58cfe74858b5a2b7$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $a0360aeb44b98c04$export$2e2bcd8739ae039)($d5f3ec1faa929937$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $d5f3ec1faa929937$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $e604885c935ab4f8$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $d5f3ec1faa929937$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $iO5o7.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $d5f3ec1faa929937$export$2e2bcd8739ae039 = $d5f3ec1faa929937$var$Popover;



var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $70fa20bc8c6f3693$export$2cf86a63a84fe23d(slot) {
    return (0, $bYZd6.default)('MuiMenu', slot);
}
const $70fa20bc8c6f3693$var$menuClasses = (0, $eaNcJ.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $70fa20bc8c6f3693$export$2e2bcd8739ae039 = $70fa20bc8c6f3693$var$menuClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $92c0bcdb3f8e13cc$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $92c0bcdb3f8e13cc$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $92c0bcdb3f8e13cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $70fa20bc8c6f3693$export$2cf86a63a84fe23d), classes);
};
const $92c0bcdb3f8e13cc$var$MenuRoot = (0, $gvIKB.default)((0, $d5f3ec1faa929937$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $92c0bcdb3f8e13cc$export$4f7c51a5920c9f33 = (0, $gvIKB.default)((0, $d5f3ec1faa929937$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $92c0bcdb3f8e13cc$var$MenuMenuList = (0, $gvIKB.default)((0, $c587742d7fb2ce63$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $92c0bcdb3f8e13cc$var$Menu = /*#__PURE__*/ $lVd4O.forwardRef(function Menu(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $92c0bcdb3f8e13cc$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $lVd4O.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $lVd4O.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $lVd4O.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $92c0bcdb3f8e13cc$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('list', {
        className: (0, $anaDR.default)(classes.list, MenuListProps.className),
        elementType: $92c0bcdb3f8e13cc$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $iO5o7.jsx)($92c0bcdb3f8e13cc$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $92c0bcdb3f8e13cc$var$RTL_ORIGIN : $92c0bcdb3f8e13cc$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $92c0bcdb3f8e13cc$export$2e2bcd8739ae039 = $92c0bcdb3f8e13cc$var$Menu;



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");

var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $f6a6573898608abc$export$1ee13051fd9e2ab5(slot) {
    return (0, $bYZd6.default)('MuiNativeSelect', slot);
}
const $f6a6573898608abc$var$nativeSelectClasses = (0, $eaNcJ.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $f6a6573898608abc$export$2e2bcd8739ae039 = $f6a6573898608abc$var$nativeSelectClasses;



var $gvIKB = parcelRequire("gvIKB");

var $8Yw6Z = parcelRequire("8Yw6Z");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $e7c48c1dfab22251$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $4HqRp.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $f6a6573898608abc$export$1ee13051fd9e2ab5), classes);
};
const $e7c48c1dfab22251$export$50b3545a8ccd87af = (0, $gvIKB.default)('select')(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $f6a6573898608abc$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $e7c48c1dfab22251$var$NativeSelectSelect = (0, $gvIKB.default)($e7c48c1dfab22251$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Yw6Z.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $f6a6573898608abc$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $e7c48c1dfab22251$export$7dd4d92f143902e3 = (0, $gvIKB.default)('svg')(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $f6a6573898608abc$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $e7c48c1dfab22251$var$NativeSelectIcon = (0, $gvIKB.default)($e7c48c1dfab22251$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4HqRp.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $e7c48c1dfab22251$var$NativeSelectInput = /*#__PURE__*/ $lVd4O.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $e7c48c1dfab22251$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)($e7c48c1dfab22251$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $anaDR.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $iO5o7.jsx)($e7c48c1dfab22251$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $e7c48c1dfab22251$export$2e2bcd8739ae039 = $e7c48c1dfab22251$var$NativeSelectInput;




var $gvIKB = parcelRequire("gvIKB");

var $9o0F5 = parcelRequire("9o0F5");



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $d54eda4b8aa51261$export$2c0c1ee5a3392e(slot) {
    return (0, $bYZd6.default)('MuiSelect', slot);
}
const $d54eda4b8aa51261$var$selectClasses = (0, $eaNcJ.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $d54eda4b8aa51261$export$2e2bcd8739ae039 = $d54eda4b8aa51261$var$selectClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $3e0e9c919860c4d2$var$_span;
const $3e0e9c919860c4d2$var$SelectSelect = (0, $gvIKB.default)((0, $e7c48c1dfab22251$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $d54eda4b8aa51261$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $d54eda4b8aa51261$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $d54eda4b8aa51261$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $d54eda4b8aa51261$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $d54eda4b8aa51261$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $3e0e9c919860c4d2$var$SelectIcon = (0, $gvIKB.default)((0, $e7c48c1dfab22251$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4HqRp.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $3e0e9c919860c4d2$var$SelectNativeInput = (0, $gvIKB.default)('input', {
    shouldForwardProp: (prop)=>(0, $9o0F5.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $3e0e9c919860c4d2$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $3e0e9c919860c4d2$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $3e0e9c919860c4d2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $4HqRp.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $d54eda4b8aa51261$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $3e0e9c919860c4d2$var$SelectInput = /*#__PURE__*/ $lVd4O.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $d420a656705086cf$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $d420a656705086cf$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $lVd4O.useRef(null);
    const displayRef = $lVd4O.useRef(null);
    const [displayNode, setDisplayNode] = $lVd4O.useState(null);
    const { current: isOpenControlled } = $lVd4O.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $lVd4O.useState();
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $lVd4O.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $lVd4O.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $lVd4O.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $lVd4O.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $lVd4O.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $a0360aeb44b98c04$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $lVd4O.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $8c433c002dc8ee28$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $lVd4O.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $biW9R.default)(2));
            selected = value.some((v)=>$3e0e9c919860c4d2$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $3e0e9c919860c4d2$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $lVd4O.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $3e0e9c919860c4d2$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $a1ab550e14ceaf6f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)($3e0e9c919860c4d2$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $anaDR.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $3e0e9c919860c4d2$var$isEmpty(display) ? $3e0e9c919860c4d2$var$_span || ($3e0e9c919860c4d2$var$_span = /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)($3e0e9c919860c4d2$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)($3e0e9c919860c4d2$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92c0bcdb3f8e13cc$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $3e0e9c919860c4d2$export$2e2bcd8739ae039 = $3e0e9c919860c4d2$var$SelectInput;




parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $14e074380e787918$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $6r1xF = parcelRequire("6r1xF");


var $gvIKB = parcelRequire("gvIKB");

var $8Yw6Z = parcelRequire("8Yw6Z");


var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $03c9c602bb0ef925$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $d54eda4b8aa51261$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $03c9c602bb0ef925$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $03c9c602bb0ef925$var$StyledInput = (0, $gvIKB.default)((0, $311ae76fb1b3b08e$export$2e2bcd8739ae039), $03c9c602bb0ef925$var$styledRootConfig)('');
const $03c9c602bb0ef925$var$StyledOutlinedInput = (0, $gvIKB.default)((0, $5788750077f568c7$export$2e2bcd8739ae039), $03c9c602bb0ef925$var$styledRootConfig)('');
const $03c9c602bb0ef925$var$StyledFilledInput = (0, $gvIKB.default)((0, $c012e0ac5dd7c799$export$2e2bcd8739ae039), $03c9c602bb0ef925$var$styledRootConfig)('');
const $03c9c602bb0ef925$var$Select = /*#__PURE__*/ $lVd4O.forwardRef(function Select(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $14e074380e787918$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $e7c48c1dfab22251$export$2e2bcd8739ae039) : (0, $3e0e9c919860c4d2$export$2e2bcd8739ae039);
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $03c9c602bb0ef925$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $iO5o7.jsx)($03c9c602bb0ef925$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $iO5o7.jsx)($03c9c602bb0ef925$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $iO5o7.jsx)($03c9c602bb0ef925$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(ref, (0, $354496b1137733e9$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $iO5o7.jsx)($lVd4O.Fragment, {
        children: /*#__PURE__*/ $lVd4O.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $7qwc9.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $anaDR.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$03c9c602bb0ef925$var$Select.muiName = 'Select';
var $03c9c602bb0ef925$export$2e2bcd8739ae039 = $03c9c602bb0ef925$var$Select;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $0e3a806cc24e4cb3$export$c1bdcbaf0596aeda(slot) {
    return (0, $bYZd6.default)('MuiTextField', slot);
}
const $0e3a806cc24e4cb3$var$textFieldClasses = (0, $eaNcJ.default)('MuiTextField', [
    'root'
]);
var $0e3a806cc24e4cb3$export$2e2bcd8739ae039 = $0e3a806cc24e4cb3$var$textFieldClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $916424a6441a2548$var$variantComponent = {
    standard: (0, $311ae76fb1b3b08e$export$2e2bcd8739ae039),
    filled: (0, $c012e0ac5dd7c799$export$2e2bcd8739ae039),
    outlined: (0, $5788750077f568c7$export$2e2bcd8739ae039)
};
const $916424a6441a2548$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $0e3a806cc24e4cb3$export$c1bdcbaf0596aeda), classes);
};
const $916424a6441a2548$var$TextFieldRoot = (0, $gvIKB.default)((0, $8e95540a876aab9d$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $916424a6441a2548$var$TextField = /*#__PURE__*/ $lVd4O.forwardRef(function TextField(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $916424a6441a2548$var$useUtilityClasses(ownerState);
    const id = (0, $a1ab550e14ceaf6f$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $916424a6441a2548$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        elementType: $916424a6441a2548$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $d36f7c81336aa280$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $f56666fc53e7fc38$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('select', {
        elementType: (0, $03c9c602bb0ef925$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $iO5o7.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $iO5o7.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $iO5o7.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $iO5o7.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $916424a6441a2548$export$2e2bcd8739ae039 = $916424a6441a2548$var$TextField;





const $4436aac128298086$export$e06108bfe6141a40 = ({ label: label, updateValue: updateValue, value: _value, type: type, id: id, field: field, formValues: formValues, required: required, disabled: disabled, tooltip: tooltip, focused: focused, percentageMask: percentageMask, isDecimalPercent: isDecimalPercent = true, moneyMask: moneyMask, negativeNumber: negativeNumber, error: error, minLength: minLength, maxLength: maxLength, placeholder: placeholder, disableMargin: disableMargin, onPressEnter: onPressEnter, ...inputProps })=>{
    const value = _value ?? formValues?.[field ?? ''] ?? '';
    const isDate = type === 'date';
    const formLabel = /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d36f7c81336aa280$export$2e2bcd8739ae039), {
        id: id ? `${id}-label` : `${label.toLocaleLowerCase()}-input-label`,
        children: label
    });
    const renderCurrencyInput = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $4b1d9a4dcf1b21ac$export$3437cf0602f97db7), {
            fullWidth: true,
            customInput: (0, $311ae76fb1b3b08e$export$2e2bcd8739ae039),
            thousandSeparator: (0, $50c68e19ba8e5079$export$398db890a5d5c686),
            decimalSeparator: (0, $50c68e19ba8e5079$export$93cc62f3860b8d09),
            prefix: (0, $50c68e19ba8e5079$export$8eebe5cdb07c3b08),
            allowNegative: negativeNumber,
            decimalScale: 2,
            fixedDecimalScale: true,
            id: id,
            value: value,
            onValueChange: (values)=>{
                const newVal = values.value.trim();
                if ((0, $f90d087769f90e7b$export$7e4aa119212bc614)(newVal)) updateValue(parseFloat(newVal));
            },
            required: required,
            disabled: disabled,
            inputProps: {
                minLength: minLength,
                maxLength: maxLength,
                ...inputProps
            },
            placeholder: placeholder,
            onKeyDown: (e)=>{
                if (onPressEnter && e.key === 'Enter') onPressEnter();
            }
        });
    const renderPercentageInput = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $4b1d9a4dcf1b21ac$export$3437cf0602f97db7), {
            fullWidth: true,
            customInput: (0, $311ae76fb1b3b08e$export$2e2bcd8739ae039),
            suffix: "%",
            decimalScale: 2,
            fixedDecimalScale: true,
            allowNegative: negativeNumber,
            id: id,
            value: isDecimalPercent && (0, $f90d087769f90e7b$export$7e4aa119212bc614)(value) ? value * 100 : value,
            onValueChange: (values)=>updateValue(isDecimalPercent && (0, $f90d087769f90e7b$export$7e4aa119212bc614)(values.value) ? parseFloat(values.value) / 100 : values.value),
            required: required,
            disabled: disabled,
            inputProps: {
                minLength: minLength,
                maxLength: maxLength,
                ...inputProps
            },
            placeholder: placeholder,
            onKeyDown: (e)=>{
                if (onPressEnter && e.key === 'Enter') onPressEnter();
            }
        });
    const renderTextInput = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $311ae76fb1b3b08e$export$2e2bcd8739ae039), {
            fullWidth: true,
            id: id,
            type: type,
            value: value,
            onChange: (e)=>updateValue(e.target.value),
            required: required,
            disabled: disabled,
            inputProps: {
                minLength: minLength,
                maxLength: maxLength,
                ...inputProps
            },
            placeholder: placeholder,
            onKeyDown: (e)=>{
                if (onPressEnter && e.key === 'Enter') onPressEnter();
            }
        });
    const renderDateInput = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $916424a6441a2548$export$2e2bcd8739ae039), {
            fullWidth: true,
            id: id,
            type: "date",
            label: tooltip ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                title: tooltip,
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    children: label
                })
            }) : label,
            value: value ? (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(value).format((0, $50c68e19ba8e5079$export$bfc92d8962c59fa1)) : ' ',
            onChange: (e)=>updateValue((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(e.target.value).toDate()),
            required: required,
            disabled: disabled,
            variant: "standard",
            slotProps: {
                inputLabel: {
                    shrink: true
                }
            },
            // inputProps={{
            //   ...inputProps,
            // }}
            placeholder: placeholder,
            onKeyDown: (e)=>{
                if (onPressEnter && e.key === 'Enter') onPressEnter();
            }
        });
    const renderInput = ()=>{
        if (percentageMask) return renderPercentageInput();
        else if (moneyMask) return renderCurrencyInput();
        else if (isDate) return renderDateInput();
        else return renderTextInput();
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8e95540a876aab9d$export$2e2bcd8739ae039), {
        fullWidth: true,
        variant: "standard",
        error: !!error,
        focused: focused,
        sx: !disableMargin ? {
            margin: '20px 0 26px 0'
        } : {},
        children: [
            !isDate && (tooltip ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                title: tooltip,
                children: formLabel
            }) : formLabel),
            renderInput(),
            error && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f56666fc53e7fc38$export$2e2bcd8739ae039), {
                error: true,
                children: error
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $656e97243cc8fc4f$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");

var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");






var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $527f3e59cd7c6e0a$export$81478e24460c57f2(slot) {
    return (0, $bYZd6.default)('MuiListItemIcon', slot);
}
const $527f3e59cd7c6e0a$var$listItemIconClasses = (0, $eaNcJ.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $527f3e59cd7c6e0a$export$2e2bcd8739ae039 = $527f3e59cd7c6e0a$var$listItemIconClasses;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $811f56bc3a7c43d7$export$1061006a0db3aeb5(slot) {
    return (0, $bYZd6.default)('MuiListItemText', slot);
}
const $811f56bc3a7c43d7$var$listItemTextClasses = (0, $eaNcJ.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $811f56bc3a7c43d7$export$2e2bcd8739ae039 = $811f56bc3a7c43d7$var$listItemTextClasses;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $dfa7fc3017fb91a2$export$515f8c67b5305377(slot) {
    return (0, $bYZd6.default)('MuiMenuItem', slot);
}
const $dfa7fc3017fb91a2$var$menuItemClasses = (0, $eaNcJ.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $dfa7fc3017fb91a2$export$2e2bcd8739ae039 = $dfa7fc3017fb91a2$var$menuItemClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $6f9a4b79561b13db$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $6f9a4b79561b13db$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $dfa7fc3017fb91a2$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $6f9a4b79561b13db$var$MenuItemRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $6f9a4b79561b13db$export$4334bb34c76fef24
})((0, $7KgDD.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $dfa7fc3017fb91a2$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $dRIMW.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $dfa7fc3017fb91a2$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $dRIMW.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $dfa7fc3017fb91a2$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $dRIMW.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $dRIMW.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $dfa7fc3017fb91a2$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dfa7fc3017fb91a2$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $7adef3073a7f326d$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $7adef3073a7f326d$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $811f56bc3a7c43d7$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $811f56bc3a7c43d7$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $527f3e59cd7c6e0a$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $527f3e59cd7c6e0a$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $6f9a4b79561b13db$var$MenuItem = /*#__PURE__*/ $lVd4O.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $lVd4O.useContext((0, $71f802e7b868aa8f$export$2e2bcd8739ae039));
    const childContext = $lVd4O.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $lVd4O.useRef(null);
    (0, $4719068e6ea2a726$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $6f9a4b79561b13db$var$useUtilityClasses(props);
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $71f802e7b868aa8f$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)($6f9a4b79561b13db$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $anaDR.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $anaDR.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $6f9a4b79561b13db$export$2e2bcd8739ae039 = $6f9a4b79561b13db$var$MenuItem;



const $5aa67484160e5d9c$export$c7c3831628327b0f = ({ label: label, options: options, updateValue: updateValue, value: _value, field: field, formValues: formValues, placeholder: placeholder, required: required, tooltip: tooltip, id: id, disabled: disabled, className: className, color: color, error: error, ariaLabel: ariaLabel, showLabel: showLabel = false, showPlaceholderOption: showPlaceholderOption = true, enablePlaceholderOption: enablePlaceholderOption = false, disableUnderline: disableUnderline = false, disableMargin: disableMargin = false, fullWidth: fullWidth = true })=>{
    const value = _value ?? formValues?.[field ?? ''] ?? '';
    const placeholderText = placeholder;
    const ariaText = ariaLabel || placeholderText;
    const labelId = id || `${label?.toLocaleLowerCase()}-select-label`;
    const labelEl = label ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d36f7c81336aa280$export$2e2bcd8739ae039), {
        htmlFor: id,
        shrink: !!placeholderText,
        id: labelId,
        children: label
    }) : undefined;
    const ArrowDropDownIcon = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $656e97243cc8fc4f$export$2e2bcd8739ae039), {
            sx: {
                color: color
            }
        });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8e95540a876aab9d$export$2e2bcd8739ae039), {
        fullWidth: true,
        variant: "standard",
        error: !!error,
        sx: !disableMargin ? {
            margin: '20px 0 26px 0'
        } : undefined,
        children: [
            showLabel && labelEl ? tooltip ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                title: tooltip,
                children: labelEl
            }) : labelEl : labelEl,
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $03c9c602bb0ef925$export$2e2bcd8739ae039), {
                fullWidth: fullWidth,
                id: id,
                labelId: labelId,
                value: value,
                "aria-placeholder": ariaText,
                "aria-label": ariaText,
                onChange: (e)=>updateValue(e.target.value),
                required: required,
                disabled: disabled,
                className: className,
                disableUnderline: disableUnderline,
                displayEmpty: true,
                // color="rgb(255,255,255)"
                // sx={{ color: color }}
                sx: {
                    color: color || showPlaceholderOption && !value ? color || (0, $5b108f16e2d84dda$export$4aa0a1b480cdb1b6).placeholderText : color
                },
                IconComponent: ArrowDropDownIcon,
                children: [
                    showPlaceholderOption && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6f9a4b79561b13db$export$2e2bcd8739ae039), {
                        disabled: !enablePlaceholderOption,
                        value: "",
                        children: placeholderText
                    }),
                    options.map((option)=>{
                        const optionValue = typeof option === 'string' ? option : option.value;
                        const optionLabel = typeof option === 'string' ? option : option.label;
                        return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6f9a4b79561b13db$export$2e2bcd8739ae039), {
                            value: optionValue,
                            selected: value === optionValue,
                            children: optionLabel
                        }, optionValue);
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f56666fc53e7fc38$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");



var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");


var $h9hwn = parcelRequire("h9hwn");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $lVd4O = parcelRequire("lVd4O");








var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $af8b775a07f02da9$var$styles = {
    entering: {
        transform: 'none'
    },
    entered: {
        transform: 'none'
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $af8b775a07f02da9$var$Zoom = /*#__PURE__*/ $lVd4O.forwardRef(function Zoom(props, ref) {
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $d4ddf0f0262c03ba$export$2e2bcd8739ae039), ...other } = props;
    const nodeRef = $lVd4O.useRef(null);
    const handleRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(nodeRef, (0, $354496b1137733e9$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $d3fbac79a43fb6d0$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $d3fbac79a43fb6d0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $d3fbac79a43fb6d0$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $lVd4O.cloneElement(children, {
                style: {
                    transform: 'scale(0)',
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$af8b775a07f02da9$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $af8b775a07f02da9$export$2e2bcd8739ae039 = $af8b775a07f02da9$var$Zoom;



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");


var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $6c40ec09fe4ecbad$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $bYZd6.default)('MuiFab', slot);
}
const $6c40ec09fe4ecbad$var$fabClasses = (0, $eaNcJ.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $6c40ec09fe4ecbad$export$2e2bcd8739ae039 = $6c40ec09fe4ecbad$var$fabClasses;



var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a84b7c0350b0505a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $4HqRp.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $6c40ec09fe4ecbad$export$e2cfa0ca4bce1fc2), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $a84b7c0350b0505a$var$FabRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $4HqRp.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $4HqRp.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $6c40ec09fe4ecbad$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $7KgDD.default)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $7KgDD.default)(({ theme: theme })=>({
        [`&.${(0, $6c40ec09fe4ecbad$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $a84b7c0350b0505a$var$Fab = /*#__PURE__*/ $lVd4O.forwardRef(function Fab(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $a84b7c0350b0505a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($a84b7c0350b0505a$var$FabRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $anaDR.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: classes,
        children: children
    });
});
var $a84b7c0350b0505a$export$2e2bcd8739ae039 = $a84b7c0350b0505a$var$Fab;



var $4HqRp = parcelRequire("4HqRp");




var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $afb097670710683c$export$b96222ae71926780(slot) {
    return (0, $bYZd6.default)('MuiSpeedDial', slot);
}
const $afb097670710683c$var$speedDialClasses = (0, $eaNcJ.default)('MuiSpeedDial', [
    'root',
    'fab',
    'directionUp',
    'directionDown',
    'directionLeft',
    'directionRight',
    'actions',
    'actionsClosed'
]);
var $afb097670710683c$export$2e2bcd8739ae039 = $afb097670710683c$var$speedDialClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $5269b56e023c27c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open, direction: direction } = ownerState;
    const slots = {
        root: [
            'root',
            `direction${(0, $4HqRp.default)(direction)}`
        ],
        fab: [
            'fab'
        ],
        actions: [
            'actions',
            !open && 'actionsClosed'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $afb097670710683c$export$b96222ae71926780), classes);
};
function $5269b56e023c27c3$var$getOrientation(direction) {
    if (direction === 'up' || direction === 'down') return 'vertical';
    if (direction === 'right' || direction === 'left') return 'horizontal';
    return undefined;
}
const $5269b56e023c27c3$var$dialRadius = 32;
const $5269b56e023c27c3$var$spacingActions = 16;
const $5269b56e023c27c3$var$SpeedDialRoot = (0, $gvIKB.default)('div', {
    name: 'MuiSpeedDial',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`direction${(0, $4HqRp.default)(ownerState.direction)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.speedDial,
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    direction: 'up'
                },
                style: {
                    flexDirection: 'column-reverse',
                    [`& .${(0, $afb097670710683c$export$2e2bcd8739ae039).actions}`]: {
                        flexDirection: 'column-reverse',
                        marginBottom: -$5269b56e023c27c3$var$dialRadius,
                        paddingBottom: $5269b56e023c27c3$var$spacingActions + $5269b56e023c27c3$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'down'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $afb097670710683c$export$2e2bcd8739ae039).actions}`]: {
                        flexDirection: 'column',
                        marginTop: -$5269b56e023c27c3$var$dialRadius,
                        paddingTop: $5269b56e023c27c3$var$spacingActions + $5269b56e023c27c3$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'left'
                },
                style: {
                    flexDirection: 'row-reverse',
                    [`& .${(0, $afb097670710683c$export$2e2bcd8739ae039).actions}`]: {
                        flexDirection: 'row-reverse',
                        marginRight: -$5269b56e023c27c3$var$dialRadius,
                        paddingRight: $5269b56e023c27c3$var$spacingActions + $5269b56e023c27c3$var$dialRadius
                    }
                }
            },
            {
                props: {
                    direction: 'right'
                },
                style: {
                    flexDirection: 'row',
                    [`& .${(0, $afb097670710683c$export$2e2bcd8739ae039).actions}`]: {
                        flexDirection: 'row',
                        marginLeft: -$5269b56e023c27c3$var$dialRadius,
                        paddingLeft: $5269b56e023c27c3$var$spacingActions + $5269b56e023c27c3$var$dialRadius
                    }
                }
            }
        ]
    })));
const $5269b56e023c27c3$var$SpeedDialFab = (0, $gvIKB.default)((0, $a84b7c0350b0505a$export$2e2bcd8739ae039), {
    name: 'MuiSpeedDial',
    slot: 'Fab',
    overridesResolver: (props, styles)=>styles.fab
})({
    pointerEvents: 'auto'
});
const $5269b56e023c27c3$var$SpeedDialActions = (0, $gvIKB.default)('div', {
    name: 'MuiSpeedDial',
    slot: 'Actions',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.actions,
            !ownerState.open && styles.actionsClosed
        ];
    }
})({
    display: 'flex',
    pointerEvents: 'auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.open,
            style: {
                transition: 'top 0s linear 0.2s',
                pointerEvents: 'none'
            }
        }
    ]
});
const $5269b56e023c27c3$var$SpeedDial = /*#__PURE__*/ $lVd4O.forwardRef(function SpeedDial(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDial'
    });
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { ariaLabel: ariaLabel, FabProps: { ref: origDialButtonRef, ...FabProps } = {}, children: childrenProp, className: className, direction: direction = 'up', hidden: hidden = false, icon: icon, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onOpen: onOpen, open: openProp, openIcon: openIcon, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, transitionDuration: transitionDuration = defaultTransitionDuration, ...other } = props;
    const [open, setOpenState] = (0, $d420a656705086cf$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'SpeedDial',
        state: 'open'
    });
    const ownerState = {
        ...props,
        open: open,
        direction: direction
    };
    const classes = $5269b56e023c27c3$var$useUtilityClasses(ownerState);
    const eventTimer = (0, $650032dc7599a0a1$export$2e2bcd8739ae039)();
    /**
   * an index in actions.current
   */ const focusedAction = $lVd4O.useRef(0);
    /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */ const nextItemArrowKey = $lVd4O.useRef();
    /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */ const actions = $lVd4O.useRef([]);
    actions.current = [
        actions.current[0]
    ];
    const handleOwnFabRef = $lVd4O.useCallback((fabFef)=>{
        actions.current[0] = fabFef;
    }, []);
    const handleFabRef = (0, $378090240d6c80ab$export$2e2bcd8739ae039)(origDialButtonRef, handleOwnFabRef);
    /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   */ const createHandleSpeedDialActionButtonRef = (dialActionIndex, origButtonRef)=>{
        return (buttonRef)=>{
            actions.current[dialActionIndex + 1] = buttonRef;
            if (origButtonRef) origButtonRef(buttonRef);
        };
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        const key = event.key.replace('Arrow', '').toLowerCase();
        const { current: nextItemArrowKeyCurrent = key } = nextItemArrowKey;
        if (event.key === 'Escape') {
            setOpenState(false);
            actions.current[0].focus();
            if (onClose) onClose(event, 'escapeKeyDown');
            return;
        }
        if ($5269b56e023c27c3$var$getOrientation(key) === $5269b56e023c27c3$var$getOrientation(nextItemArrowKeyCurrent) && $5269b56e023c27c3$var$getOrientation(key) !== undefined) {
            event.preventDefault();
            const actionStep = key === nextItemArrowKeyCurrent ? 1 : -1;
            // stay within array indices
            const nextAction = (0, $h9hwn.default)(focusedAction.current + actionStep, 0, actions.current.length - 1);
            actions.current[nextAction].focus();
            focusedAction.current = nextAction;
            nextItemArrowKey.current = nextItemArrowKeyCurrent;
        }
    };
    $lVd4O.useEffect(()=>{
        // actions were closed while navigation state was not reset
        if (!open) {
            focusedAction.current = 0;
            nextItemArrowKey.current = undefined;
        }
    }, [
        open
    ]);
    const handleClose = (event)=>{
        if (event.type === 'mouseleave' && onMouseLeave) onMouseLeave(event);
        if (event.type === 'blur' && onBlur) onBlur(event);
        eventTimer.clear();
        if (event.type === 'blur') eventTimer.start(0, ()=>{
            setOpenState(false);
            if (onClose) onClose(event, 'blur');
        });
        else {
            setOpenState(false);
            if (onClose) onClose(event, 'mouseLeave');
        }
    };
    const handleClick = (event)=>{
        if (FabProps.onClick) FabProps.onClick(event);
        eventTimer.clear();
        if (open) {
            setOpenState(false);
            if (onClose) onClose(event, 'toggle');
        } else {
            setOpenState(true);
            if (onOpen) onOpen(event, 'toggle');
        }
    };
    const handleOpen = (event)=>{
        if (event.type === 'mouseenter' && onMouseEnter) onMouseEnter(event);
        if (event.type === 'focus' && onFocus) onFocus(event);
        // When moving the focus between two items,
        // a chain if blur and focus event is triggered.
        // We only handle the last event.
        eventTimer.clear();
        if (!open) // Wait for a future focus or click event
        eventTimer.start(0, ()=>{
            setOpenState(true);
            if (onOpen) {
                const eventMap = {
                    focus: 'focus',
                    mouseenter: 'mouseEnter'
                };
                onOpen(event, eventMap[event.type]);
            }
        });
    };
    // Filter the label for valid id characters.
    const id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
    const allItems = $lVd4O.Children.toArray(childrenProp).filter((child)=>{
        return /*#__PURE__*/ $lVd4O.isValidElement(child);
    });
    const children = allItems.map((child, index)=>{
        const { FabProps: { ref: origButtonRef, ...ChildFabProps } = {}, tooltipPlacement: tooltipPlacementProp } = child.props;
        const tooltipPlacement = tooltipPlacementProp || ($5269b56e023c27c3$var$getOrientation(direction) === 'vertical' ? 'left' : 'top');
        return /*#__PURE__*/ $lVd4O.cloneElement(child, {
            FabProps: {
                ...ChildFabProps,
                ref: createHandleSpeedDialActionButtonRef(index, origButtonRef)
            },
            delay: 30 * (open ? index : allItems.length - index),
            open: open,
            tooltipPlacement: tooltipPlacement,
            id: `${id}-action-${index}`
        });
    });
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        elementType: $5269b56e023c27c3$var$SpeedDialRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref,
        className: (0, $anaDR.default)(classes.root, className),
        additionalProps: {
            role: 'presentation'
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleClose(event);
                },
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleOpen(event);
                },
                onMouseEnter: (event)=>{
                    handlers.onMouseEnter?.(event);
                    handleOpen(event);
                },
                onMouseLeave: (event)=>{
                    handlers.onMouseLeave?.(event);
                    handleClose(event);
                }
            })
    });
    const [TransitionSlot, transitionProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $af8b775a07f02da9$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionSlot, {
                in: !hidden,
                timeout: transitionDuration,
                unmountOnExit: true,
                ...transitionProps,
                children: /*#__PURE__*/ (0, $iO5o7.jsx)($5269b56e023c27c3$var$SpeedDialFab, {
                    color: "primary",
                    "aria-label": ariaLabel,
                    "aria-haspopup": "true",
                    "aria-expanded": open,
                    "aria-controls": `${id}-actions`,
                    ...FabProps,
                    onClick: handleClick,
                    className: (0, $anaDR.default)(classes.fab, FabProps.className),
                    ref: handleFabRef,
                    ownerState: ownerState,
                    children: /*#__PURE__*/ $lVd4O.isValidElement(icon) && (0, $0ae62b7a43146e9e$export$2e2bcd8739ae039)(icon, [
                        'SpeedDialIcon'
                    ]) ? /*#__PURE__*/ $lVd4O.cloneElement(icon, {
                        open: open
                    }) : icon
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)($5269b56e023c27c3$var$SpeedDialActions, {
                id: `${id}-actions`,
                role: "menu",
                "aria-orientation": $5269b56e023c27c3$var$getOrientation(direction),
                className: (0, $anaDR.default)(classes.actions, !open && classes.actionsClosed),
                ownerState: ownerState,
                children: children
            })
        ]
    });
});
var $5269b56e023c27c3$export$2e2bcd8739ae039 = $5269b56e023c27c3$var$SpeedDial;


const $6e0c13309ae81fe4$export$16bc57642f47033 = ({ children: children, ariaLabel: ariaLabel = '', direction: direction = 'right', icon: icon })=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $5269b56e023c27c3$export$2e2bcd8739ae039), {
        component: "md-fab-speed-dial",
        direction: direction,
        className: "md-fling md-noop",
        ariaLabel: ariaLabel,
        FabProps: {
            'aria-label': 'menu',
            className: 'md-fab md-mini md-accent md-button md-default-theme'
        },
        icon: icon,
        children: children
    });



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");


var $4HqRp = parcelRequire("4HqRp");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");


var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $68a6e6fbb5ecfb70$export$72aef224d6115253(slot) {
    return (0, $bYZd6.default)('MuiTab', slot);
}
const $68a6e6fbb5ecfb70$var$tabClasses = (0, $eaNcJ.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $68a6e6fbb5ecfb70$export$2e2bcd8739ae039 = $68a6e6fbb5ecfb70$var$tabClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $ab9ddec285737a1f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $4HqRp.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $68a6e6fbb5ecfb70$export$72aef224d6115253), classes);
};
const $ab9ddec285737a1f$var$TabRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $4HqRp.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).icon}`]: styles.icon
            }
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $68a6e6fbb5ecfb70$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $ab9ddec285737a1f$var$Tab = /*#__PURE__*/ $lVd4O.forwardRef(function Tab(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $ab9ddec285737a1f$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $lVd4O.isValidElement(iconProp) ? /*#__PURE__*/ $lVd4O.cloneElement(iconProp, {
        className: (0, $anaDR.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($ab9ddec285737a1f$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $ab9ddec285737a1f$export$2e2bcd8739ae039 = $ab9ddec285737a1f$var$Tab;


var $lVd4O = parcelRequire("lVd4O");



var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");



var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

function $9086e283f1b41988$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $9086e283f1b41988$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $9086e283f1b41988$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $lVd4O = parcelRequire("lVd4O");




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $7ae39b7239133c8e$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $7ae39b7239133c8e$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $lVd4O.useRef();
    const nodeRef = $lVd4O.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $4719068e6ea2a726$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $188bd33bc7d9d82e$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $f09fc1a8c621e01b$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $lVd4O.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsx)("div", {
        style: $7ae39b7239133c8e$var$styles,
        ...other,
        ref: nodeRef
    });
}



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");


parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $3bcf51ad9645c0b1$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $cf1c73f6d6e4c108$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');




var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $1297e06991a26e75$export$34861783d3c2eef8(slot) {
    return (0, $bYZd6.default)('MuiTabScrollButton', slot);
}
const $1297e06991a26e75$var$tabScrollButtonClasses = (0, $eaNcJ.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $1297e06991a26e75$export$2e2bcd8739ae039 = $1297e06991a26e75$var$tabScrollButtonClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $936938578a4806b8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $1297e06991a26e75$export$34861783d3c2eef8), classes);
};
const $936938578a4806b8$var$TabScrollButtonRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $1297e06991a26e75$export$2e2bcd8739ae039).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $936938578a4806b8$var$TabScrollButton = /*#__PURE__*/ $lVd4O.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $936938578a4806b8$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $3bcf51ad9645c0b1$export$2e2bcd8739ae039);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $cf1c73f6d6e4c108$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)($936938578a4806b8$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $iO5o7.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $936938578a4806b8$export$2e2bcd8739ae039 = $936938578a4806b8$var$TabScrollButton;




var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $4d92e22ef3f94ae2$export$cdd93bd054dec359(slot) {
    return (0, $bYZd6.default)('MuiTabs', slot);
}
const $4d92e22ef3f94ae2$var$tabsClasses = (0, $eaNcJ.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $4d92e22ef3f94ae2$export$2e2bcd8739ae039 = $4d92e22ef3f94ae2$var$tabsClasses;






var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $2cedac9d70aeb012$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $2cedac9d70aeb012$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $2cedac9d70aeb012$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $2cedac9d70aeb012$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $4d92e22ef3f94ae2$export$cdd93bd054dec359), classes);
};
const $2cedac9d70aeb012$var$TabsRoot = (0, $gvIKB.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $4d92e22ef3f94ae2$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $4d92e22ef3f94ae2$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $4d92e22ef3f94ae2$export$2e2bcd8739ae039).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $2cedac9d70aeb012$var$TabsScroller = (0, $gvIKB.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $2cedac9d70aeb012$var$List = (0, $gvIKB.default)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $2cedac9d70aeb012$var$TabsIndicator = (0, $gvIKB.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $2cedac9d70aeb012$var$TabsScrollbarSize = (0, $gvIKB.default)((0, $7ae39b7239133c8e$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $2cedac9d70aeb012$var$defaultIndicatorStyle = {};
let $2cedac9d70aeb012$var$warnedOnceTabPresent = false;
const $2cedac9d70aeb012$var$Tabs = /*#__PURE__*/ $lVd4O.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $2cedac9d70aeb012$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $lVd4O.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $lVd4O.useState($2cedac9d70aeb012$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $lVd4O.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $lVd4O.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $lVd4O.useState(false);
    const [scrollerStyle, setScrollerStyle] = $lVd4O.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $lVd4O.useRef(null);
    const tabListRef = $lVd4O.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $9086e283f1b41988$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('scrollbar', {
        className: (0, $anaDR.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $2cedac9d70aeb012$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $lVd4O.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('scrollButtons', {
        className: (0, $anaDR.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $936938578a4806b8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $iO5o7.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $iO5o7.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $iO5o7.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $6b1200dc53bcda97$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $lVd4O.useEffect(()=>{
        const handleResize = (0, $188bd33bc7d9d82e$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $f09fc1a8c621e01b$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $lVd4O.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $lVd4O.useEffect(()=>{
        setMounted(true);
    }, []);
    $lVd4O.useEffect(()=>{
        updateIndicatorState();
    });
    $lVd4O.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($2cedac9d70aeb012$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $lVd4O.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('indicator', {
        className: (0, $anaDR.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $2cedac9d70aeb012$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $iO5o7.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $lVd4O.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $lVd4O.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $lVd4O.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $a0360aeb44b98c04$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $2cedac9d70aeb012$var$moveFocus(list, currentFocus, $2cedac9d70aeb012$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $2cedac9d70aeb012$var$moveFocus(list, currentFocus, $2cedac9d70aeb012$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $2cedac9d70aeb012$var$moveFocus(list, null, $2cedac9d70aeb012$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $2cedac9d70aeb012$var$moveFocus(list, null, $2cedac9d70aeb012$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: (0, $anaDR.default)(classes.root, className),
        elementType: $2cedac9d70aeb012$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $2cedac9d70aeb012$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('list', {
        ref: tabListRef,
        className: (0, $anaDR.default)(classes.list, classes.flexContainer),
        elementType: $2cedac9d70aeb012$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $iO5o7.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $2cedac9d70aeb012$export$2e2bcd8739ae039 = $2cedac9d70aeb012$var$Tabs;


const $ae4f60d495c7af90$export$a19ed25791c85468 = ({ defaultTab: defaultTab = 0, children: children, boxProps: boxProps })=>{
    /** State **/ const [activeTab, setActiveTab] = (0, $lVd4O.useState)(defaultTab);
    /** Methods **/ const handleChange = (_, newValue)=>{
        setActiveTab(newValue);
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        bgcolor: "white",
        flexDirection: "column",
        height: "100%",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2cedac9d70aeb012$export$2e2bcd8739ae039), {
                className: "md-default-theme",
                value: activeTab,
                indicatorColor: "secondary",
                variant: "fullWidth",
                scrollButtons: "auto",
                onChange: handleChange,
                children: children.map((tab)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $ab9ddec285737a1f$export$2e2bcd8739ae039), {
                        sx: {
                            flex: 1
                        },
                        label: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            component: "span",
                            className: "text-center",
                            children: tab.label
                        })
                    }, tab.index))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                sx: {
                    overflowY: 'auto'
                },
                children: children[activeTab].content
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");


var $4HqRp = parcelRequire("4HqRp");



const $78de29a962de2a35$export$84736f919622d25b = ({ title: title, value: value, titleFlex: titleFlex, titleIcon: titleIcon, url: url, currency: currency = false, percent: percent = false, date: date = false, bold: bold = false, dateFormat: dateFormat = (0, $50c68e19ba8e5079$export$237cfe6dcad1a246), show: show = true, divider: divider = false, smallFont: smallFont = false, capitalize: capitalize = false, rowHeight: rowHeight = 48 })=>{
    const displayValue = ()=>{
        let val = '';
        if (typeof value === 'object') {
            if (date) val = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(value).format(dateFormat);
            else val = value;
        } else if (typeof value === 'number') {
            const numValue = isNaN(value) ? 0 : value;
            if (percent) val = $4bb6caff349888e9$export$626336c2cd4b14de.format(numValue);
            else if (currency) val = $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(numValue);
        } else if (typeof value === 'string') val = capitalize ? (0, $4HqRp.default)(value) : value;
        if (url) val = /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
            to: url,
            children: val
        });
        return val;
    };
    return divider ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}) : show && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
        className: "pad-top-bottom-xs",
        sx: {
            height: rowHeight
        },
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                sx: {
                    flex: titleFlex
                },
                className: bold ? 'medium' : undefined,
                children: /*#__PURE__*/ (0, $iO5o7.jsx)("small", {
                    children: titleIcon ?? title
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                sx: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    component: "span",
                    className: `${bold ? 'medium' : 'thin'} ${!smallFont ? 'md-title md-title-mobile' : ''} float-right`,
                    children: displayValue()
                })
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");

const $7719e8ad46b49834$export$54c2e3dc7acea9f5 = ({ children: children, flex: flex, layout: layout = 'row', ...boxProps })=>{
    const { 'layout-align': layoutAlign, 'layout-padding': layoutPadding, sx: sx, ...props } = boxProps;
    const align = layoutAlign?.split(' ');
    const justifyContent = align?.[layout === 'row' ? 0 : 1];
    const alignItems = align?.[layout === 'row' ? 1 : 0];
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a5f98fb65ea8145d$export$2e2bcd8739ae039), {
        sx: {
            display: !!flex || layoutAlign ? 'flex' : undefined,
            flex: typeof flex === 'string' ? flex : undefined,
            justifyContent: justifyContent,
            alignItems: alignItems,
            padding: layoutPadding ? '16px' : undefined,
            ...sx
        },
        ...props,
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $2c5c5bfa123d756e$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4zM18 14H6v-2h12zm0-3H6V9h12zm0-3H6V6h12z"
}), 'Comment');



const $82ed55be55b0d2d3$export$70fd4c70dabf3732 = ({ flex: flex = 1, textAlign: textAlign, content: content, url: url, linkTarget: linkTarget, icon: icon, isNotes: isNotes, isButton: isButton, tooltip: tooltip, hide: hide, hideOverflow: hideOverflow, showNotesPopup: showNotesPopup, placeholder: placeholder = '', className: className = '', onClick: onClick })=>{
    /** Computed **/ const value = content ?? placeholder;
    /** Render **/ const renderNotes = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
            onClick: ()=>showNotesPopup?.(),
            className: "pointer",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                title: "Click to see Notes",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2c5c5bfa123d756e$export$2e2bcd8739ae039), {
                    className: "md-icon material-icons"
                })
            })
        });
    const renderIconButton = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
            title: tooltip ?? '',
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                onClick: onClick,
                children: icon
            })
        });
    const renderLink = ()=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
            to: url ?? '',
            target: linkTarget,
            children: value
        });
    const renderIcon = ()=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            gap: "6px",
            children: [
                icon,
                " ",
                content
            ]
        });
    const renderContent = ()=>{
        if (isNotes) return renderNotes();
        else if (isButton && icon) return renderIconButton();
        else if (url) return renderLink();
        else if (icon) return renderIcon();
        else return value;
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        display: "flex",
        flex: flex,
        justifyContent: textAlign === 'left' ? 'start' : textAlign === 'right' ? 'end' : textAlign,
        alignItems: "center",
        className: `${textAlign ? `text-${textAlign}` : ''} ${className}`,
        maxWidth: flex && flex > 1 ? flex + '%' : undefined,
        overflow: hideOverflow ? 'hidden' : undefined,
        textOverflow: hideOverflow ? 'ellipsis' : undefined,
        width: "100%",
        children: [
            !hide && renderContent(),
            ' '
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");


const $3ce0df94cc20588a$export$aba88a2ee03882aa = ({ value: value, url: url, flex: flex = 1, textAlign: textAlign, blankPlaceholder: blankPlaceholder = '' })=>{
    /** Computed **/ const className = textAlign ? `text-${textAlign}` : '';
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        component: "span",
        display: flex ? 'flex' : undefined,
        flex: flex,
        className: className,
        maxWidth: flex && flex > 1 ? flex + '%' : undefined,
        children: value ? url ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
            to: url,
            children: value
        }) : value : blankPlaceholder
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $1f199a5096acf580$exports = {};
var $6d2ea7c0df11bbce$exports = {};
var $159e6dab409c1d39$exports = {};
var $ff45ec7578cd0e39$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $ff45ec7578cd0e39$var$isArray = Array.isArray;
$ff45ec7578cd0e39$exports = $ff45ec7578cd0e39$var$isArray;


var $e966749ca980889a$exports = {};

var $fe61db9eac120da3$exports = {};
var $ba3d0b6d3f1c5726$exports = {};
var $eef0f75ee6f85301$exports = {};
var $338e15ebee6a321d$exports = {};
var $9f9f0b502ba68d42$exports = {};
/** Detect free variable `global` from Node.js. */ var $9f9f0b502ba68d42$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$9f9f0b502ba68d42$exports = $9f9f0b502ba68d42$var$freeGlobal;


/** Detect free variable `self`. */ var $338e15ebee6a321d$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $338e15ebee6a321d$var$root = $9f9f0b502ba68d42$exports || $338e15ebee6a321d$var$freeSelf || Function('return this')();
$338e15ebee6a321d$exports = $338e15ebee6a321d$var$root;


/** Built-in value references. */ var $eef0f75ee6f85301$var$Symbol = $338e15ebee6a321d$exports.Symbol;
$eef0f75ee6f85301$exports = $eef0f75ee6f85301$var$Symbol;


var $0d043e9c95b34584$exports = {};

/** Used for built-in method references. */ var $0d043e9c95b34584$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d043e9c95b34584$var$hasOwnProperty = $0d043e9c95b34584$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0d043e9c95b34584$var$nativeObjectToString = $0d043e9c95b34584$var$objectProto.toString;
/** Built-in value references. */ var $0d043e9c95b34584$var$symToStringTag = $eef0f75ee6f85301$exports ? $eef0f75ee6f85301$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0d043e9c95b34584$var$getRawTag(value) {
    var isOwn = $0d043e9c95b34584$var$hasOwnProperty.call(value, $0d043e9c95b34584$var$symToStringTag), tag = value[$0d043e9c95b34584$var$symToStringTag];
    try {
        value[$0d043e9c95b34584$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $0d043e9c95b34584$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0d043e9c95b34584$var$symToStringTag] = tag;
        else delete value[$0d043e9c95b34584$var$symToStringTag];
    }
    return result;
}
$0d043e9c95b34584$exports = $0d043e9c95b34584$var$getRawTag;


var $ba77da8c7466b839$exports = {};
/** Used for built-in method references. */ var $ba77da8c7466b839$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ba77da8c7466b839$var$nativeObjectToString = $ba77da8c7466b839$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ba77da8c7466b839$var$objectToString(value) {
    return $ba77da8c7466b839$var$nativeObjectToString.call(value);
}
$ba77da8c7466b839$exports = $ba77da8c7466b839$var$objectToString;


/** `Object#toString` result references. */ var $ba3d0b6d3f1c5726$var$nullTag = '[object Null]', $ba3d0b6d3f1c5726$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $ba3d0b6d3f1c5726$var$symToStringTag = $eef0f75ee6f85301$exports ? $eef0f75ee6f85301$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ba3d0b6d3f1c5726$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ba3d0b6d3f1c5726$var$undefinedTag : $ba3d0b6d3f1c5726$var$nullTag;
    return $ba3d0b6d3f1c5726$var$symToStringTag && $ba3d0b6d3f1c5726$var$symToStringTag in Object(value) ? $0d043e9c95b34584$exports(value) : $ba77da8c7466b839$exports(value);
}
$ba3d0b6d3f1c5726$exports = $ba3d0b6d3f1c5726$var$baseGetTag;


var $0c747d9bddb62323$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0c747d9bddb62323$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$0c747d9bddb62323$exports = $0c747d9bddb62323$var$isObjectLike;


/** `Object#toString` result references. */ var $fe61db9eac120da3$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $fe61db9eac120da3$var$isSymbol(value) {
    return typeof value == 'symbol' || $0c747d9bddb62323$exports(value) && $ba3d0b6d3f1c5726$exports(value) == $fe61db9eac120da3$var$symbolTag;
}
$fe61db9eac120da3$exports = $fe61db9eac120da3$var$isSymbol;


/** Used to match property names within property paths. */ var $e966749ca980889a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $e966749ca980889a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $e966749ca980889a$var$isKey(value, object) {
    if ($ff45ec7578cd0e39$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $fe61db9eac120da3$exports(value)) return true;
    return $e966749ca980889a$var$reIsPlainProp.test(value) || !$e966749ca980889a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$e966749ca980889a$exports = $e966749ca980889a$var$isKey;


var $7af65c6e65e87325$exports = {};
var $c3a9a5361df3916c$exports = {};
var $38da4d5724862e86$exports = {};
var $966ee44c582d8bcc$exports = {};
var $1f8b65229d9f53c5$exports = {};
var $0782c258123c2c4f$exports = {};
var $2209a6ccabc8efc0$exports = {};
var $d59cb16621498bf2$exports = {};
var $f44cd9dcb53cd615$exports = {};
var $4085d2984bbfc929$exports = {};
var $636e9491e6e21f73$exports = {};

var $5f1b213061b59f84$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5f1b213061b59f84$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$5f1b213061b59f84$exports = $5f1b213061b59f84$var$isObject;


/** `Object#toString` result references. */ var $636e9491e6e21f73$var$asyncTag = '[object AsyncFunction]', $636e9491e6e21f73$var$funcTag = '[object Function]', $636e9491e6e21f73$var$genTag = '[object GeneratorFunction]', $636e9491e6e21f73$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $636e9491e6e21f73$var$isFunction(value) {
    if (!$5f1b213061b59f84$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $ba3d0b6d3f1c5726$exports(value);
    return tag == $636e9491e6e21f73$var$funcTag || tag == $636e9491e6e21f73$var$genTag || tag == $636e9491e6e21f73$var$asyncTag || tag == $636e9491e6e21f73$var$proxyTag;
}
$636e9491e6e21f73$exports = $636e9491e6e21f73$var$isFunction;


var $2f36f1b23268dad4$exports = {};
var $a9637ef003b9669f$exports = {};

/** Used to detect overreaching core-js shims. */ var $a9637ef003b9669f$var$coreJsData = $338e15ebee6a321d$exports["__core-js_shared__"];
$a9637ef003b9669f$exports = $a9637ef003b9669f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $2f36f1b23268dad4$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($a9637ef003b9669f$exports && $a9637ef003b9669f$exports.keys && $a9637ef003b9669f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2f36f1b23268dad4$var$isMasked(func) {
    return !!$2f36f1b23268dad4$var$maskSrcKey && $2f36f1b23268dad4$var$maskSrcKey in func;
}
$2f36f1b23268dad4$exports = $2f36f1b23268dad4$var$isMasked;



var $da6099eb0e84f762$exports = {};
/** Used for built-in method references. */ var $da6099eb0e84f762$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $da6099eb0e84f762$var$funcToString = $da6099eb0e84f762$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $da6099eb0e84f762$var$toSource(func) {
    if (func != null) {
        try {
            return $da6099eb0e84f762$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$da6099eb0e84f762$exports = $da6099eb0e84f762$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4085d2984bbfc929$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4085d2984bbfc929$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $4085d2984bbfc929$var$funcProto = Function.prototype, $4085d2984bbfc929$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4085d2984bbfc929$var$funcToString = $4085d2984bbfc929$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4085d2984bbfc929$var$hasOwnProperty = $4085d2984bbfc929$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $4085d2984bbfc929$var$reIsNative = RegExp('^' + $4085d2984bbfc929$var$funcToString.call($4085d2984bbfc929$var$hasOwnProperty).replace($4085d2984bbfc929$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4085d2984bbfc929$var$baseIsNative(value) {
    if (!$5f1b213061b59f84$exports(value) || $2f36f1b23268dad4$exports(value)) return false;
    var pattern = $636e9491e6e21f73$exports(value) ? $4085d2984bbfc929$var$reIsNative : $4085d2984bbfc929$var$reIsHostCtor;
    return pattern.test($da6099eb0e84f762$exports(value));
}
$4085d2984bbfc929$exports = $4085d2984bbfc929$var$baseIsNative;


var $223594ce0a35fa44$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $223594ce0a35fa44$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$223594ce0a35fa44$exports = $223594ce0a35fa44$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f44cd9dcb53cd615$var$getNative(object, key) {
    var value = $223594ce0a35fa44$exports(object, key);
    return $4085d2984bbfc929$exports(value) ? value : undefined;
}
$f44cd9dcb53cd615$exports = $f44cd9dcb53cd615$var$getNative;


/* Built-in method references that are verified to be native. */ var $d59cb16621498bf2$var$nativeCreate = $f44cd9dcb53cd615$exports(Object, 'create');
$d59cb16621498bf2$exports = $d59cb16621498bf2$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $2209a6ccabc8efc0$var$hashClear() {
    this.__data__ = $d59cb16621498bf2$exports ? $d59cb16621498bf2$exports(null) : {};
    this.size = 0;
}
$2209a6ccabc8efc0$exports = $2209a6ccabc8efc0$var$hashClear;


var $d0fbdc423e54fde8$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d0fbdc423e54fde8$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$d0fbdc423e54fde8$exports = $d0fbdc423e54fde8$var$hashDelete;


var $3b968bb1c8c97a36$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $3b968bb1c8c97a36$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $3b968bb1c8c97a36$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3b968bb1c8c97a36$var$hasOwnProperty = $3b968bb1c8c97a36$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3b968bb1c8c97a36$var$hashGet(key) {
    var data = this.__data__;
    if ($d59cb16621498bf2$exports) {
        var result = data[key];
        return result === $3b968bb1c8c97a36$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3b968bb1c8c97a36$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$3b968bb1c8c97a36$exports = $3b968bb1c8c97a36$var$hashGet;


var $1ada1e806c445ebc$exports = {};

/** Used for built-in method references. */ var $1ada1e806c445ebc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ada1e806c445ebc$var$hasOwnProperty = $1ada1e806c445ebc$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1ada1e806c445ebc$var$hashHas(key) {
    var data = this.__data__;
    return $d59cb16621498bf2$exports ? data[key] !== undefined : $1ada1e806c445ebc$var$hasOwnProperty.call(data, key);
}
$1ada1e806c445ebc$exports = $1ada1e806c445ebc$var$hashHas;


var $782a72bfc78e4ce2$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $782a72bfc78e4ce2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $782a72bfc78e4ce2$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $d59cb16621498bf2$exports && value === undefined ? $782a72bfc78e4ce2$var$HASH_UNDEFINED : value;
    return this;
}
$782a72bfc78e4ce2$exports = $782a72bfc78e4ce2$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0782c258123c2c4f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$0782c258123c2c4f$var$Hash.prototype.clear = $2209a6ccabc8efc0$exports;
$0782c258123c2c4f$var$Hash.prototype['delete'] = $d0fbdc423e54fde8$exports;
$0782c258123c2c4f$var$Hash.prototype.get = $3b968bb1c8c97a36$exports;
$0782c258123c2c4f$var$Hash.prototype.has = $1ada1e806c445ebc$exports;
$0782c258123c2c4f$var$Hash.prototype.set = $782a72bfc78e4ce2$exports;
$0782c258123c2c4f$exports = $0782c258123c2c4f$var$Hash;


var $ee2d531a94c083ff$exports = {};
var $b85defd213346b0a$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b85defd213346b0a$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$b85defd213346b0a$exports = $b85defd213346b0a$var$listCacheClear;


var $133cdf04e6e517f5$exports = {};
var $cf13ba41f4c8410d$exports = {};
var $f52c060a24b73359$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $f52c060a24b73359$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$f52c060a24b73359$exports = $f52c060a24b73359$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cf13ba41f4c8410d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($f52c060a24b73359$exports(array[length][0], key)) return length;
    }
    return -1;
}
$cf13ba41f4c8410d$exports = $cf13ba41f4c8410d$var$assocIndexOf;


/** Used for built-in method references. */ var $133cdf04e6e517f5$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $133cdf04e6e517f5$var$splice = $133cdf04e6e517f5$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $133cdf04e6e517f5$var$listCacheDelete(key) {
    var data = this.__data__, index = $cf13ba41f4c8410d$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $133cdf04e6e517f5$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$133cdf04e6e517f5$exports = $133cdf04e6e517f5$var$listCacheDelete;


var $7ca7651ef0f82889$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7ca7651ef0f82889$var$listCacheGet(key) {
    var data = this.__data__, index = $cf13ba41f4c8410d$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$7ca7651ef0f82889$exports = $7ca7651ef0f82889$var$listCacheGet;


var $fb0606fb0d3e597c$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fb0606fb0d3e597c$var$listCacheHas(key) {
    return $cf13ba41f4c8410d$exports(this.__data__, key) > -1;
}
$fb0606fb0d3e597c$exports = $fb0606fb0d3e597c$var$listCacheHas;


var $0b37faab87000b1a$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0b37faab87000b1a$var$listCacheSet(key, value) {
    var data = this.__data__, index = $cf13ba41f4c8410d$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$0b37faab87000b1a$exports = $0b37faab87000b1a$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ee2d531a94c083ff$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$ee2d531a94c083ff$var$ListCache.prototype.clear = $b85defd213346b0a$exports;
$ee2d531a94c083ff$var$ListCache.prototype['delete'] = $133cdf04e6e517f5$exports;
$ee2d531a94c083ff$var$ListCache.prototype.get = $7ca7651ef0f82889$exports;
$ee2d531a94c083ff$var$ListCache.prototype.has = $fb0606fb0d3e597c$exports;
$ee2d531a94c083ff$var$ListCache.prototype.set = $0b37faab87000b1a$exports;
$ee2d531a94c083ff$exports = $ee2d531a94c083ff$var$ListCache;


var $49f96bf0455bd360$exports = {};


/* Built-in method references that are verified to be native. */ var $49f96bf0455bd360$var$Map = $f44cd9dcb53cd615$exports($338e15ebee6a321d$exports, 'Map');
$49f96bf0455bd360$exports = $49f96bf0455bd360$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $1f8b65229d9f53c5$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $0782c258123c2c4f$exports,
        'map': new ($49f96bf0455bd360$exports || $ee2d531a94c083ff$exports),
        'string': new $0782c258123c2c4f$exports
    };
}
$1f8b65229d9f53c5$exports = $1f8b65229d9f53c5$var$mapCacheClear;


var $d7abf8fe5599503e$exports = {};
var $c91b4c15546a480b$exports = {};
var $0b7c3671a75cc92e$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $0b7c3671a75cc92e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$0b7c3671a75cc92e$exports = $0b7c3671a75cc92e$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c91b4c15546a480b$var$getMapData(map, key) {
    var data = map.__data__;
    return $0b7c3671a75cc92e$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c91b4c15546a480b$exports = $c91b4c15546a480b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d7abf8fe5599503e$var$mapCacheDelete(key) {
    var result = $c91b4c15546a480b$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$d7abf8fe5599503e$exports = $d7abf8fe5599503e$var$mapCacheDelete;


var $abebc4eba5bd8626$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $abebc4eba5bd8626$var$mapCacheGet(key) {
    return $c91b4c15546a480b$exports(this, key).get(key);
}
$abebc4eba5bd8626$exports = $abebc4eba5bd8626$var$mapCacheGet;


var $76381686e7e2d753$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $76381686e7e2d753$var$mapCacheHas(key) {
    return $c91b4c15546a480b$exports(this, key).has(key);
}
$76381686e7e2d753$exports = $76381686e7e2d753$var$mapCacheHas;


var $6b03a6b037e58bf3$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $6b03a6b037e58bf3$var$mapCacheSet(key, value) {
    var data = $c91b4c15546a480b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$6b03a6b037e58bf3$exports = $6b03a6b037e58bf3$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $966ee44c582d8bcc$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$966ee44c582d8bcc$var$MapCache.prototype.clear = $1f8b65229d9f53c5$exports;
$966ee44c582d8bcc$var$MapCache.prototype['delete'] = $d7abf8fe5599503e$exports;
$966ee44c582d8bcc$var$MapCache.prototype.get = $abebc4eba5bd8626$exports;
$966ee44c582d8bcc$var$MapCache.prototype.has = $76381686e7e2d753$exports;
$966ee44c582d8bcc$var$MapCache.prototype.set = $6b03a6b037e58bf3$exports;
$966ee44c582d8bcc$exports = $966ee44c582d8bcc$var$MapCache;


/** Error message constants. */ var $38da4d5724862e86$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $38da4d5724862e86$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($38da4d5724862e86$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($38da4d5724862e86$var$memoize.Cache || $966ee44c582d8bcc$exports);
    return memoized;
}
// Expose `MapCache`.
$38da4d5724862e86$var$memoize.Cache = $966ee44c582d8bcc$exports;
$38da4d5724862e86$exports = $38da4d5724862e86$var$memoize;


/** Used as the maximum memoize cache size. */ var $c3a9a5361df3916c$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $c3a9a5361df3916c$var$memoizeCapped(func) {
    var result = $38da4d5724862e86$exports(func, function(key) {
        if (cache.size === $c3a9a5361df3916c$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$c3a9a5361df3916c$exports = $c3a9a5361df3916c$var$memoizeCapped;


/** Used to match property names within property paths. */ var $7af65c6e65e87325$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $7af65c6e65e87325$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7af65c6e65e87325$var$stringToPath = $c3a9a5361df3916c$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($7af65c6e65e87325$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($7af65c6e65e87325$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$7af65c6e65e87325$exports = $7af65c6e65e87325$var$stringToPath;


var $65552f459c32f7da$exports = {};
var $d893fa760f730ca4$exports = {};

var $178014b5128e4648$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $178014b5128e4648$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$178014b5128e4648$exports = $178014b5128e4648$var$arrayMap;




/** Used as references for various `Number` constants. */ var $d893fa760f730ca4$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $d893fa760f730ca4$var$symbolProto = $eef0f75ee6f85301$exports ? $eef0f75ee6f85301$exports.prototype : undefined, $d893fa760f730ca4$var$symbolToString = $d893fa760f730ca4$var$symbolProto ? $d893fa760f730ca4$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $d893fa760f730ca4$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($ff45ec7578cd0e39$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $178014b5128e4648$exports(value, $d893fa760f730ca4$var$baseToString) + '';
    if ($fe61db9eac120da3$exports(value)) return $d893fa760f730ca4$var$symbolToString ? $d893fa760f730ca4$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$d893fa760f730ca4$var$INFINITY ? '-0' : result;
}
$d893fa760f730ca4$exports = $d893fa760f730ca4$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $65552f459c32f7da$var$toString(value) {
    return value == null ? '' : $d893fa760f730ca4$exports(value);
}
$65552f459c32f7da$exports = $65552f459c32f7da$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $159e6dab409c1d39$var$castPath(value, object) {
    if ($ff45ec7578cd0e39$exports(value)) return value;
    return $e966749ca980889a$exports(value, object) ? [
        value
    ] : $7af65c6e65e87325$exports($65552f459c32f7da$exports(value));
}
$159e6dab409c1d39$exports = $159e6dab409c1d39$var$castPath;


var $ba97b743440ee490$exports = {};

/** Used as references for various `Number` constants. */ var $ba97b743440ee490$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $ba97b743440ee490$var$toKey(value) {
    if (typeof value == 'string' || $fe61db9eac120da3$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$ba97b743440ee490$var$INFINITY ? '-0' : result;
}
$ba97b743440ee490$exports = $ba97b743440ee490$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $6d2ea7c0df11bbce$var$baseGet(object, path) {
    path = $159e6dab409c1d39$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$ba97b743440ee490$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$6d2ea7c0df11bbce$exports = $6d2ea7c0df11bbce$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $1f199a5096acf580$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $6d2ea7c0df11bbce$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$1f199a5096acf580$exports = $1f199a5096acf580$var$get;


const $8443e75340b01d61$export$3d6ed0715468a113 = ({ items: items, sortType: sortType, sortReverse: sortReverse, sortList: sortList, rowHeight: rowHeight = 48, viewOptions: viewOptions, padForScrollbar: padForScrollbar, hideSortIcon: hideSortIcon })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        paddingX: "16px",
        display: "flex",
        alignItems: "center",
        className: `medium md-caption sortable-list ${padForScrollbar ? 'padForScrollbar' : ''}`,
        sx: {
            height: rowHeight
        },
        children: items.filter((item)=>!item.hide && (viewOptions ? typeof (0, (/*@__PURE__*/$parcel$interopDefault($1f199a5096acf580$exports)))(viewOptions, item.propName) === 'boolean' : true)).map(({ flex: flex = 1, propName: propName, label: label, textAlign: textAlign }, i)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                sx: {
                    cursor: 'pointer'
                },
                display: "flex",
                flex: flex,
                justifyContent: textAlign === 'left' ? 'start' : textAlign === 'right' ? 'end' : textAlign,
                alignItems: "center",
                gap: "3px",
                maxWidth: flex && flex > 1 ? flex + '%' : undefined,
                width: "100%",
                onClick: ()=>sortList(propName),
                children: [
                    label,
                    !hideSortIcon && sortType === propName && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        className: sortReverse ? 'arrow-down' : 'arrow-up'
                    })
                ]
            }, `${propName}-${i}`))
    });
};



var $iO5o7 = parcelRequire("iO5o7");

const $620a1c4ac4d86c09$export$a7b06bfba60a8a78 = ({ children: children, flex: flex, layout: layout = 'row', ...boxProps })=>{
    const { 'layout-align': layoutAlign, 'layout-padding': layoutPadding, sx: sx, ...props } = boxProps;
    const align = layoutAlign?.split(' ');
    const justifyContent = align?.[layout === 'row' ? 0 : 1];
    const alignItems = align?.[layout === 'row' ? 1 : 0];
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
        sx: {
            display: !!flex || layoutAlign ? 'flex' : undefined,
            flex: typeof flex === 'string' ? flex : undefined,
            justifyContent: justifyContent,
            alignItems: alignItems,
            padding: layoutPadding ? '16px' : undefined,
            ...sx
        },
        disableGutters: true,
        disablePadding: true,
        ...props,
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");


const $984f98682cffcd4b$export$c36f87108246a02a = ({ items: items, rowIndex: rowIndex, rowHeight: rowHeight = 48, padForScrollbar: padForScrollbar, bold: bold, viewOptions: viewOptions })=>{
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        paddingX: "16px",
        display: "flex",
        alignItems: "center",
        className: `text-center ${bold ? 'medium' : ''} md-subhead-sm ${rowIndex % 2 ? '' : 'highlighted'}  ${padForScrollbar ? 'padForScrollbar' : ''}`,
        sx: {
            height: rowHeight + 'px'
        },
        children: items.filter((item)=>(!item.hide || item.isNotes) && (viewOptions ? viewOptions[item.propName] : true)).map(({ propName: propName, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                className: bold ? 'medium' : '',
                ...itemProps
            }, `${propName}-${i}`))
    });
};



var $iO5o7 = parcelRequire("iO5o7");

const $3cac63400060a6b9$export$2ce376c2cc3355c8 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6f9a4b79561b13db$export$2e2bcd8739ae039), {
        className: "md-menu-item",
        disableGutters: true,
        ...props,
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $586b74a6bc7bc051$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');










const $6e43da1956a4b90a$export$aa31b211d2f4c3af = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ mode: mode, notes: notes, updateNotes: updateNotes, sidebarIndex: sidebarIndex, sidebarItems: sidebarItems, setSidebarItems: setSidebarItems, title: title = 'Notes', tooltip: tooltip = 'Add Note' })=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [selectedNoteId, setSelectedNoteId] = (0, $lVd4O.useState)();
    const [showDeleteModal, setShowDeleteModal] = (0, $lVd4O.useState)(false);
    const [showCreateModal, setShowCreateModal] = (0, $lVd4O.useState)(false);
    const [showEditModal, setShowEditModal] = (0, $lVd4O.useState)(false);
    /** Computed **/ const selectedNote = notes.find((note)=>note._id === selectedNoteId);
    /** Methods **/ /**
     * Return a Request object with `user` and `roles` pre-populated
     */ const getNoteUser = ()=>{
        const noteData = {
            user: {
                id: userStore.user?._id,
                displayName: userStore.user?.displayName
            },
            roles: [
                userStore.isAdmin ? (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin : (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
            ]
        };
        return noteData;
    };
    /**
     * Show a Create Note dialog
     * @param noteId TNoteId
     */ const confirmCreate = ()=>{
        setShowDeleteModal(false);
        setShowEditModal(false);
        setShowCreateModal(true);
    };
    /**
     * Show an Edit Note dialog
     * @param noteId TNoteId
     */ const confirmEdit = (noteId)=>{
        setSelectedNoteId(noteId);
        setShowDeleteModal(false);
        setShowCreateModal(false);
        setShowEditModal(true);
    };
    /**
     * Show a delete confirmation dialog
     * @param noteId TNoteId
     */ const confirmDelete = (noteId)=>{
        setSelectedNoteId(noteId);
        setShowEditModal(false);
        setShowCreateModal(false);
        setShowDeleteModal(true);
    };
    /**
     * Create a new Note
     */ const createNote = async (content = '')=>{
        if (!updateNotes) return;
        try {
            const newNote = {
                ...getNoteUser(),
                content: content,
                created: new Date(),
                updated: new Date()
            };
            await updateNotes([
                ...notes,
                newNote
            ]);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createNote.success);
            // Open notes list item (if applicable)
            const items = sidebarItems;
            items[sidebarIndex] = true;
            setSidebarItems(items);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createNote.error);
        }
    };
    /**
     * Update an existing Note
     */ const editNote = async (noteId, content = '')=>{
        if (!updateNotes) return;
        try {
            // Get Note index
            const noteIndex = notes.findIndex((note)=>note._id === noteId);
            if (noteIndex === -1) throw new Error(`No Note with ID "${noteId}" found in Notes list`);
            const note = {
                ...notes[noteIndex],
                ...getNoteUser(),
                content: content,
                updated: new Date()
            };
            const updatedNotes = notes;
            updatedNotes[noteIndex] = note;
            // Push updates to the database
            await updateNotes(updatedNotes);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateNote.success);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateNote.error);
        }
    };
    /**
     * Remove a Note
     */ const removeNote = async (noteId)=>{
        if (!updateNotes) return;
        try {
            // Get Note index
            const noteIndex = notes.findIndex((note)=>note._id === noteId);
            if (noteIndex === -1) throw new Error(`No Note with ID "${noteId}" found in Notes list`);
            const updatedNotes = notes;
            updatedNotes.splice(noteIndex, 1);
            // Push updates to the database
            await updateNotes(updatedNotes);
            if (selectedNoteId === noteId) setSelectedNoteId(undefined);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteNote.success);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteNote.error);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                component: "md-card",
                className: "no-margin-bottom md-default-theme text-center",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        className: "toolbar-div pad-left",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                title: tooltip,
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                    className: "md-icon-button float-left",
                                    onClick: ()=>confirmCreate(),
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $31385b62cee78c1a$export$2e2bcd8739ae039), {
                                        style: {
                                            color: 'white'
                                        },
                                        className: "md-icon material-icons"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                sx: {
                                    flex: 1
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "end",
                                flex: 1,
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    component: "span",
                                    className: "float-right",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                        className: "md-icon-button",
                                        onClick: ()=>setSidebarItems(sidebarItems.with(sidebarIndex, !sidebarItems[sidebarIndex])),
                                        disabled: !notes.length,
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                            title: sidebarItems[sidebarIndex] ? 'Show Less' : 'Show More',
                                            children: sidebarItems[sidebarIndex] ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $68af6d93e40eee40$export$2e2bcd8739ae039), {
                                                style: {
                                                    color: !notes.length ? undefined : 'white'
                                                },
                                                className: "md-icon material-icons"
                                            }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ccdf51d07380559d$export$2e2bcd8739ae039), {
                                                style: {
                                                    color: !notes.length ? undefined : 'white'
                                                },
                                                className: "md-icon material-icons"
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    sidebarItems[sidebarIndex] && !!notes.length && notes.map((note)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            bgcolor: "white",
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                    className: "md-2-line",
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            style: {
                                                textAlign: 'left',
                                                padding: 'none',
                                                flex: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    className: "md-caption",
                                                    children: [
                                                        "Added ",
                                                        (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(note.created).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                                                        " by ",
                                                        note.user.displayName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)("p", {
                                                    className: "md-body-2",
                                                    children: note.content
                                                })
                                            ]
                                        }),
                                        mode !== 'read' && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                            className: "md-icon-button",
                                            onClick: ()=>confirmEdit(note._id),
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $586b74a6bc7bc051$export$2e2bcd8739ae039), {
                                                sx: {
                                                    height: '18px',
                                                    width: '18px'
                                                }
                                            })
                                        }),
                                        mode !== 'read' && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                            className: "md-icon-button md-warn",
                                            onClick: ()=>confirmDelete(note._id),
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                                                className: "md-icon material-icons",
                                                sx: {
                                                    height: '18px',
                                                    width: '18px'
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                            ]
                        }, note._id))
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8baa694235e4631d$export$e692ee57a11ebf99), {
                mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Create,
                content: "",
                open: showCreateModal,
                setOpen: setShowCreateModal,
                onConfirm: (content)=>createNote(content)
            }),
            selectedNoteId && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8baa694235e4631d$export$e692ee57a11ebf99), {
                mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
                content: selectedNote?.content,
                open: showEditModal,
                setOpen: setShowEditModal,
                onConfirm: (content)=>selectedNoteId && editNote(selectedNoteId, content),
                onCancel: ()=>setSelectedNoteId(undefined)
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
                content: "Are you sure you want to delete this Note?",
                label: "Confirm Deletion",
                open: !!selectedNoteId && showDeleteModal,
                setOpen: setShowDeleteModal,
                okLabel: "Delete",
                cancelLabel: "Cancel",
                onOk: ()=>selectedNoteId && removeNote(selectedNoteId),
                onCancel: ()=>setSelectedNoteId(undefined)
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");


const $660b0670d077a6fb$export$b09fc4897b18f7d8 = ({ children: children, title: title, open: open, toggleOpen: toggleOpen, buttonProps: buttonProps, toggleTooltip: toggleTooltip, resolved: resolved = true })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
            component: "md-card",
            className: "no-margin-bottom md-default-theme",
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                    className: "toolbar-div pad-left",
                    children: [
                        buttonProps && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                            title: buttonProps.tooltip || buttonProps.label,
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                className: "float-left md-icon-button",
                                "aria-label": buttonProps.label,
                                onClick: buttonProps.onClick,
                                children: buttonProps.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "end",
                            flex: 1,
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                className: "float-right",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                    "aria-label": toggleTooltip || `Toggle ${title} sidebar item`,
                                    className: "md-icon-button",
                                    onClick: ()=>toggleOpen(),
                                    children: open ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $68af6d93e40eee40$export$2e2bcd8739ae039), {
                                        style: {
                                            color: 'white'
                                        },
                                        className: "md-icon material-icons"
                                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ccdf51d07380559d$export$2e2bcd8739ae039), {
                                        style: {
                                            color: 'white'
                                        },
                                        className: "md-icon material-icons"
                                    })
                                })
                            })
                        })
                    ]
                }),
                open && (resolved ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    bgcolor: "white",
                    children: children
                }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    bgcolor: "white",
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                }))
            ]
        })
    });
};



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");

const $1a2a1d044715c64b$export$141c9d2033716579 = ({ children: children, className: className, ...props })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        className: `toolbar-div pad-sides ${className}`,
        height: "64px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...props,
        children: children
    });
};





var $iO5o7 = parcelRequire("iO5o7");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $a266151bde2626a0$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 7V3H2v18h20V7zM6 19H4v-2h2zm0-4H4v-2h2zm0-4H4V9h2zm0-4H4V5h2zm4 12H8v-2h2zm0-4H8v-2h2zm0-4H8V9h2zm0-4H8V5h2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8zm-2-8h-2v2h2zm0 4h-2v2h2z"
}), 'Business');




const $bcbae850b9688487$export$19990a4daa2def24 = ({ company: company, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Company Information",
        open: open,
        toggleOpen: toggleOpen,
        resolved: !!company,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                className: "pad-top-bottom-xs",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        padding: "16px",
                        display: "flex",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a266151bde2626a0$export$2e2bcd8739ae039), {
                            className: "md-icon material-icons",
                            sx: {
                                width: '24px',
                                height: '24px'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        paddingX: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "start",
                        flex: 82,
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                className: "medium",
                                children: company?.name
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                children: company?.address.street
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: company?.address.city
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: company?.address.state
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: company?.address.zip
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            company?.longName && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Long Name",
                        value: company?.longName,
                        smallFont: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Contact Person",
                value: company?.contactPerson,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Primary Phone",
                value: company?.phone.primary,
                smallFont: true
            }),
            company?.phone.secondary && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Secondary Phone",
                value: company?.phone.secondary,
                smallFont: true
            }),
            company?.phone.fax && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Fax",
                value: company?.phone.fax,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Email",
                value: company?.email,
                url: `mailto:${company?.email}`,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Website",
                value: company?.website,
                url: company?.website,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Line of Business",
                value: company?.socketLineOfBusiness ?? '',
                capitalize: true,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Company Type",
                value: company?.companyType,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Status",
                value: company?.status ?? '',
                capitalize: true,
                smallFont: true
            })
        ]
    });



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");



const $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e = ({ value: value, setValue: setValue, companies: companies, boxProps: boxProps, placeholder: placeholder = 'Select Company', ariaLabel: ariaLabel = 'Select Company', ...selectProps })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "span",
                children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Company]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                value: value,
                updateValue: (value)=>setValue(value),
                placeholder: placeholder,
                ariaLabel: ariaLabel,
                options: companies.map((company)=>({
                        label: company.name,
                        value: company._id
                    })),
                ...selectProps
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");


const $244d8ef3bbb462ad$export$97c282f41855dcd5 = ({ company: company, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Financial Overview",
        open: open,
        toggleOpen: toggleOpen,
        resolved: !!company,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Original Assets",
                value: company?.originalAssets,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Deposited Payments",
                value: company?.currentPayments,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Adjustments",
                value: company?.currentAdjustments,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Current Value",
                bold: true,
                value: company?.currentValue,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Total Credit",
                value: company?.currentCredit,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Principal Balances",
                value: company?.currentPrincipalBalances,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Current Available Credit",
                bold: true,
                value: company?.currentAvailableCredit,
                currency: true
            })
        ]
    });





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");
'use client';
const $2449090e3a0b2376$export$b16d9fb1a22de840 = (0, $lVd4O.createContext)(null);
const $2449090e3a0b2376$var$initialState = {
    didCatch: false,
    error: null
};
class $2449090e3a0b2376$export$e926676385687eaf extends (0, $lVd4O.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $2449090e3a0b2376$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($2449090e3a0b2376$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $2449090e3a0b2376$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($2449090e3a0b2376$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $lVd4O.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $lVd4O.createElement)($2449090e3a0b2376$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $2449090e3a0b2376$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $2449090e3a0b2376$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $2449090e3a0b2376$export$c052f6604b7d51fe() {
    const context = (0, $lVd4O.useContext)($2449090e3a0b2376$export$b16d9fb1a22de840);
    $2449090e3a0b2376$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $lVd4O.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $lVd4O.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $2449090e3a0b2376$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $lVd4O.forwardRef)((props, ref)=>(0, $lVd4O.createElement)($2449090e3a0b2376$export$e926676385687eaf, errorBoundaryProps, (0, $lVd4O.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}




const $5dd0e15e9dff1511$export$b735bbab4dd866a3 = ({ children: children })=>{
    const handleError = (error, stack)=>{
        if ((0, $05ae455d2b766b2e$export$e506a1d27d1eaa20).nodeEnv === 'development') console.error('Caught error at root error boundary: %O\nStack trace: %O', error, stack);
    };
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2449090e3a0b2376$export$e926676385687eaf), {
        fallbackRender: ({ error: error, resetErrorBoundary: resetErrorBoundary })=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $eed4e655e91670d9$export$605ff0acdbe5bc43), {
                error: error,
                resetErrorBoundary: resetErrorBoundary
            }),
        onError: (error, { componentStack: componentStack })=>handleError(error, componentStack),
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $e888c73ad51d88e9$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"
}), 'Help');




var $iO5o7 = parcelRequire("iO5o7");

const $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $935296674430be13$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
                className: "content",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
                    className: "container",
                    children: children
                })
            })
        ]
    });
};




const $eed4e655e91670d9$export$605ff0acdbe5bc43 = ({})=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                component: "md-card",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        className: "toolbar-div",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "6px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e888c73ad51d88e9$export$2e2bcd8739ae039), {
                                className: "material-icons md-icon"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                className: "thin md-display-1",
                                children: "Server Error"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: 'white'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("pre", {
                            children: "An error has occurred. Please reload the page and try again."
                        })
                    })
                ]
            })
        })
    });
};





var $iO5o7 = parcelRequire("iO5o7");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $313c12310dd1cdcd$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"
}), 'AccountBalance');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $aeb975bb40c6c85a$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m2 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z"
}), 'Assignment');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $ed625357c1345036$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4"
}), 'Build');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $1f5657abe71585de$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z"
}), 'CreditCard');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $7e78168726444854$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $a7cb0a3ec807d22d$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4V6h16z"
}), 'LocalAtm');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $fd58f2af23e692bd$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M18 17H6v-2h12zm0-4H6v-2h12zm0-4H6V7h12zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2z"
}), 'Receipt');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $7fc671a29a603c45$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5M9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3m7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75M9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13"
}), 'SupervisorAccount');




var $iO5o7 = parcelRequire("iO5o7");
var $2bac58974d155131$exports = {};
$2bac58974d155131$exports = $parcel$resolve("3aVcS");


const $2a4be403ac0774af$export$47ee686680143797 = (props)=>/*#__PURE__*/ (0, $iO5o7.jsx)("img", {
        alt: "Fuse Icon",
        src: new URL($2bac58974d155131$exports).toString(),
        ...props
    });



var $iO5o7 = parcelRequire("iO5o7");
var $efe7f5d66cf32916$exports = {};
$efe7f5d66cf32916$exports = $parcel$resolve("cD1uO");


var $4eb06184f62eb3b5$exports = {};
$4eb06184f62eb3b5$exports = $parcel$resolve("7Ktu7");


const $ea32fe438ad38a6e$export$ee41d60f553c1759 = ({ white: white, ...props })=>white ? /*#__PURE__*/ (0, $iO5o7.jsx)("img", {
        alt: "Fuse Logo",
        src: new URL($efe7f5d66cf32916$exports).toString(),
        ...props
    }) : /*#__PURE__*/ (0, $iO5o7.jsx)("img", {
        alt: "Fuse Logo",
        src: new URL($4eb06184f62eb3b5$exports).toString(),
        ...props
    });



var $iO5o7 = parcelRequire("iO5o7");

var $da34492d702296d5$exports = {};
$da34492d702296d5$exports = $parcel$resolve("c9OGt");


var $208a6623898430e0$exports = {};
$208a6623898430e0$exports = $parcel$resolve("cXfVm");


const $730c4aee7584ffdf$export$7279ea9ed80dc4f5 = ({ white: white, ...props })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        className: "md-icon material-icons",
        display: "inline-block",
        bgcolor: "red",
        ...props,
        children: white ? /*#__PURE__*/ (0, $iO5o7.jsx)("img", {
            alt: "Loan Icon",
            src: new URL($da34492d702296d5$exports).toString()
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)("img", {
            alt: "Loan Icon",
            src: new URL($208a6623898430e0$exports).toString()
        })
    });
};


const $b20f24d98bb11dde$export$69325452aaefb623 = {
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Account]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ed625357c1345036$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1f5657abe71585de$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Alert]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7e78168726444854$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fd58f2af23e692bd$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Company]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a266151bde2626a0$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Lender]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $313c12310dd1cdcd$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Loan]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $313c12310dd1cdcd$export$2e2bcd8739ae039), {}),
    // [DataModelType.Loan]: <LoanIcon white width="24px" height="24px" />,
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Note]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Participation]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $313c12310dd1cdcd$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a7cb0a3ec807d22d$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Report]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Statement]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $aeb975bb40c6c85a$export$2e2bcd8739ae039), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Transaction]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {}),
    [(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User]: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7fc671a29a603c45$export$2e2bcd8739ae039), {})
};



var $iO5o7 = parcelRequire("iO5o7");


const $2d75ea95443f056a$export$9cda59e02e95cdf7 = ({ children: children, modelType: modelType, onCreate: onCreate, id: id, createVerb: createVerb = 'Add', createIcon: createIcon, ...props })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2284353ab9ad854a$export$7234abc5d81adb58), {
        modelType: modelType,
        mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Create,
        verb: createVerb,
        icon: createIcon,
        onSubmit: onCreate,
        id: id,
        ...props,
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");


const $c09930914b717387$export$1fea75498367c4ac = ({ children: children, onEdit: onEdit, editVerb: editVerb = 'Edit', editIcon: editIcon, ...props })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2284353ab9ad854a$export$7234abc5d81adb58), {
        mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
        onSubmit: onEdit,
        verb: editVerb,
        icon: editIcon,
        ...props,
        children: children
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $c31f5fc9848a62be$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $4HqRp = parcelRequire("4HqRp");


var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $c76e709e74f1aba9$export$24c1f8f60cbac79e(slot) {
    return (0, $bYZd6.default)('MuiTypography', slot);
}
const $c76e709e74f1aba9$var$typographyClasses = (0, $eaNcJ.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $c76e709e74f1aba9$export$2e2bcd8739ae039 = $c76e709e74f1aba9$var$typographyClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $cfe213ca21d1ee96$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $cfe213ca21d1ee96$var$extendSxProp = (0, $70d5a6dd34f3cbc3$export$7e7f5719ff4debb1)();
const $cfe213ca21d1ee96$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $4HqRp.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $c76e709e74f1aba9$export$24c1f8f60cbac79e), classes);
};
const $cfe213ca21d1ee96$export$140e2f5526d3cad8 = (0, $gvIKB.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $4HqRp.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $4HqRp.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $cfe213ca21d1ee96$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $cfe213ca21d1ee96$var$Typography = /*#__PURE__*/ $lVd4O.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$cfe213ca21d1ee96$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $cfe213ca21d1ee96$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $cfe213ca21d1ee96$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $cfe213ca21d1ee96$var$defaultVariantMapping[variant]) || 'span';
    const classes = $cfe213ca21d1ee96$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($cfe213ca21d1ee96$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $anaDR.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $cfe213ca21d1ee96$export$2e2bcd8739ae039 = $cfe213ca21d1ee96$var$Typography;





const $2284353ab9ad854a$export$7234abc5d81adb58 = ({ children: children, modelType: modelType, modelName: modelName, mode: mode, onSubmit: onSubmit, verb: verb, id: id, submitLabel: submitLabel, icon: icon, title: title, sidebar: sidebar, sidebarItems: sidebarItems, sidebarFlex: sidebarFlex, contentFlex: contentFlex, setSidebarItems: setSidebarItems, noteOptions: noteOptions, documentOptions: documentOptions, notesDocsFlex: notesDocsFlex, width: width })=>{
    /** Computed **/ const pageId = id || `${modelType.toLowerCase()}Form`;
    const modelIcon = icon || (0, $b20f24d98bb11dde$export$69325452aaefb623)[modelType];
    const pageTitle = title || modelName || `${verb} ${modelType}`;
    const showSidebar = sidebar || sidebarItems && setSidebarItems && (noteOptions || documentOptions);
    /** Render **/ const renderNotes = (index = 0)=>sidebarItems && setSidebarItems && noteOptions && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
            mode: mode,
            notes: noteOptions.notes ?? [],
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateNotes: noteOptions.onChange,
            title: noteOptions.title,
            tooltip: noteOptions.tooltip
        });
    const renderDocuments = (index = 1)=>sidebarItems && setSidebarItems && documentOptions && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
            mode: mode,
            documents: documentOptions.files ?? [],
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateDocuments: documentOptions.onChange,
            title: documentOptions.title,
            tooltip: documentOptions.tooltip
        });
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)("form", {
            noValidate: true,
            name: pageId,
            id: pageId,
            onSubmit: onSubmit,
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                className: "md-default-theme",
                overflow: "hidden",
                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    "layout-gt-sm": "row",
                    children: [
                        showSidebar ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            flex: sidebarFlex,
                            children: [
                                sidebar,
                                sidebarItems && setSidebarItems && (noteOptions || documentOptions) && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    flex: notesDocsFlex,
                                    children: [
                                        noteOptions && renderNotes(),
                                        documentOptions && renderDocuments()
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: 1
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            sx: !width && contentFlex ? {
                                flex: contentFlex
                            } : {
                                width: width || '100%'
                            },
                            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                component: "md-card",
                                style: {
                                    background: 'white'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $1a2a1d044715c64b$export$141c9d2033716579), {
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                justifyContent: "start",
                                                alignItems: "center",
                                                display: "flex",
                                                flex: 1
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                display: "flex",
                                                gap: "6px",
                                                children: [
                                                    modelIcon && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                        title: pageTitle,
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
                                                            children: modelIcon
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cfe213ca21d1ee96$export$2e2bcd8739ae039), {
                                                        fontSize: "34px",
                                                        lineHeight: "40px",
                                                        fontWeight: 100,
                                                        children: pageTitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                justifyContent: "end",
                                                alignItems: "center",
                                                display: "flex",
                                                flex: 1,
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                    title: submitLabel || pageTitle,
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            background: (0, $5b108f16e2d84dda$export$4aa0a1b480cdb1b6).accent
                                                        },
                                                        "aria-label": submitLabel || pageTitle,
                                                        onClick: onSubmit,
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c31f5fc9848a62be$export$2e2bcd8739ae039), {})
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        flexDirection: "column",
                                        padding: "0 16px 0 16px",
                                        display: "flex",
                                        children: children
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: 1
                        })
                    ]
                })
            })
        })
    });
};


/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");





const $935296674430be13$export$8b251419efc915eb = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const menuStore = (0, $1da4b8b758f1a116$export$d0c52745bc4840d7)();
    const headerStore = (0, $1da4b8b758f1a116$export$b7680113a886673e)();
    const rootStore = (0, $1da4b8b758f1a116$export$5bc58655df8395ab)();
    const location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** Computed **/ const currentPage = location.pathname.slice(1);
    const shouldRender = userStore.user?.roles && menuStore.shouldRender(userStore.user);
    const menu = menuStore.getMenu('topbar');
    const isViewStatement = (0, $a648eab72417989b$export$6c330e8992e8a295)('/statements/:loanId/:month');
    const isViewLenderStatement = (0, $a648eab72417989b$export$6c330e8992e8a295)('/statements/investors/:lenderId/:month');
    const renderHeader = !isViewStatement && !isViewLenderStatement;
    /** Methods **/ const handleClick = (event, item)=>{
        item.anchor = event.currentTarget;
        item.open = true;
    };
    const handleClose = (item)=>{
        item.anchor = null;
        item.open = false;
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        // Init menu items
        rootStore.adjustmentStore.initMenuItems();
        rootStore.advanceStore.initMenuItems();
        rootStore.assetStore.initMenuItems();
        rootStore.companyStore.initMenuItems();
        rootStore.lenderStore.initMenuItems();
        rootStore.loanStore.initMenuItems();
        rootStore.participationStore.initMenuItems();
        rootStore.paymentStore.initMenuItems();
        rootStore.statementStore.initMenuItems();
        rootStore.transactionStore.initMenuItems();
        // Get data
        Promise.all([
            rootStore.alertStore.query(),
            headerStore.loadCompanies(),
            headerStore.loadLoans(),
            headerStore.loadLenders()
        ]);
        // Begin polling for alerts
        const alertPoll = setInterval(()=>{
            rootStore.alertStore.tick();
        }, rootStore.alertStore.pollTimer);
        return ()=>clearInterval(alertPoll);
    }, []);
    (0, $lVd4O.useEffect)(()=>{
        if (!userStore.user && !location.pathname.includes('signin') && !location.pathname.includes('password')) navigate('/signin');
    }, [
        userStore.user,
        location.pathname
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
        children: renderHeader && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                component: "nav",
                "layout-align": "start center",
                display: "flex",
                children: [
                    !userStore.user && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        style: {
                            padding: '0 15px'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2a4be403ac0774af$export$47ee686680143797), {
                            height: "36px",
                            width: "36px"
                        })
                    }),
                    shouldRender && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $7719e8ad46b49834$export$54c2e3dc7acea9f5), {
                        component: "ul",
                        sx: {
                            display: 'flex',
                            lineHeight: '70px'
                        },
                        "layout-align": "start center",
                        className: "left",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                className: "left",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                    title: "Dashboard",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2a4be403ac0774af$export$47ee686680143797), {
                                            height: "36px",
                                            width: "36px"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                className: "left",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $249095e73b622ebe$export$eb40a627c5a27f38), {})
                            }),
                            userStore.user && menu.items.filter((item)=>item.shouldRender(userStore.user)).toSorted((a, b)=>a.position - b.position).map((item, itemIndex)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                    className: `ng-scope ${currentPage === item.link ? 'nav-selected' : ''}`,
                                    sx: {
                                        height: '70px',
                                        lineHeight: '70px'
                                    },
                                    children: [
                                        item.items.length === 0 && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                            className: "ng-scope",
                                            to: `/${item.link}`,
                                            "aria-label": item.title,
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                className: "ng-binding",
                                                children: item.title
                                            })
                                        }),
                                        !!item.items.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                            className: "md-menu ng-scope",
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)("a", {
                                                id: `${item.title}-${itemIndex}`,
                                                "aria-controls": item.open ? 'basic-menu' : undefined,
                                                "aria-haspopup": "true",
                                                "aria-expanded": item.open ? 'true' : undefined,
                                                onClick: (e)=>handleClick(e, item),
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                    component: "span",
                                                    className: "ng-binding",
                                                    children: item.title
                                                })
                                            })
                                        }),
                                        !!item.items.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92c0bcdb3f8e13cc$export$2e2bcd8739ae039), {
                                            className: "md-menu",
                                            anchorEl: item.anchor,
                                            open: item.open,
                                            onClose: ()=>handleClose(item),
                                            slotProps: {
                                                list: {
                                                    'aria-labelledby': `${item.title}-${itemIndex}`
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                className: 'md-menu-content[width="4"] md-default-theme',
                                                minWidth: "256px",
                                                children: item.items.toSorted((a, b)=>b.position - a.position).filter((subItem)=>subItem.shouldRender(userStore.user)).map((subItem, subItemIndex)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $3cac63400060a6b9$export$2ce376c2cc3355c8), {
                                                        className: "md-menu-item",
                                                        onClick: ()=>handleClose(item),
                                                        selected: location.pathname === subItem.link,
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                                            className: "md-button md-default-theme",
                                                            onClick: ()=>navigate(`/${subItem.link}`),
                                                            "aria-label": subItem.title,
                                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                                component: "span",
                                                                children: subItem.title
                                                            })
                                                        })
                                                    }, `${subItem.title}-${subItemIndex}`))
                                            })
                                        })
                                    ]
                                }, `${item.title}-${itemIndex}`))
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        sx: {
                            flex: 1
                        }
                    }),
                    userStore.user && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1611cc39e0827699$export$b04dd99d751ebb47), {}),
                    !userStore.user && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7719e8ad46b49834$export$54c2e3dc7acea9f5), {
                        component: "ul",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                to: "/signin",
                                "aria-label": "Sign In",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                    children: "Sign In"
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
// TODO: re-implement mobile menu:
//   {/* <md-sidenav className="md-sidenav-left md-whiteframe-z2" md-component-id="left" md-is-locked-open="scope.isOpen"> */}
// <Box className="md-sidenav-left md-whiteframe-z2" md-component-id="left" md-is-locked-open="scope.isOpen">
//   <Toolbar className="">
//     <h1 className="md-toolbar-tools">
//       <Tooltip title="Close">
//         <IconButton className="md-icon-button" onClick={() => toggleMenu()}>
//           <ChevronLeft />
//         </IconButton>
//       </Tooltip>
//     </h1>
//   </Toolbar>
//   <Box sx={{ paddingBottom: '20px' }}>
//     {menu.items
//       .toSorted((a, b) => (a.position > b.position ? 1 : -1))
//       .map((item) => (
//         <ListItem
//           className="hoverable black-text"
//           onClick={() => openPage(`/${item.link}`)}
//           aria-label={item.title}
//         >
//           <Box ng-bind="item.title" />
//         </ListItem>
//       ))}
//     {isMobile && (
//       <>
//         {userStore.isAdmin && (
//           <>
//             <ListItem
//               className="hoverable black-text highlighted"
//               onClick={() => openPage('/bulk')}
//               aria-label="Import/Export Data"
//             >
//               Import/Export
//             </ListItem>
//             <ListItem
//               className="hoverable black-text highlighted"
//               onClick={() => openPage('/users')}
//               aria-label="User Administration"
//             >
//               User Administration
//             </ListItem>
//           </>
//         )}
//         <ListItem
//           className="hoverable black-text highlighted"
//           onClick={() => openPage('/settings/profile')}
//           aria-label="Edit User Profile"
//         >
//           Edit User Profile
//         </ListItem>
//         <ListItem
//           className="hoverable black-text highlighted"
//           onClick={() => openPage('/settings/password')}
//           aria-label="Change User Password"
//         >
//           Change User Password
//         </ListItem>
//         <ListItem
//           className="hoverable black-text"
//           onClick={() => openPage('/auth/signout')}
//           aria-label="Sign Out"
//         >
//           <strong>Sign Out</strong>
//         </ListItem>
//       </>
//     )}
//     {/*</md-content> */}
//   </Box>
//   {/*</md-sidenav>   */}
//    </Box>
//  </Box>
});



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $0f7ec11a5e78fdaf$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');



var $4HqRp = parcelRequire("4HqRp");





const $7ae08a74a92b1771$export$9b7824917a0c851e = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ children: children, data: data, modelType: // items,
modelType, headerItems: headerItems, createVerb: createVerb = 'Add', createUrl: createUrl, id: id, toolbarItems: toolbarItems, sortType: // defaultSortType,
// defaultSortReverse,
sortType, sortReverse: sortReverse, sortList: sortList, notes: notes, notesName: notesName, setNotes: setNotes, setNotesName: setNotesName, showCreateLink: showCreateLink = false, noDataMessage: noDataMessage, isFiltered: isFiltered, noFilteredDataMessage: noFilteredDataMessage, hideCreateButton: hideCreateButton, message: message })=>{
    const rowHeight = 48;
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ // const [sortType, setSortType] = useState((defaultSortType || '') as string);
    // const [sortReverse, setSortReverse] = useState(defaultSortReverse || false);
    /** Computed **/ const pageId = id || `list${modelType}`;
    const pageTitle = `${createVerb} ${modelType}`;
    const dataModelsName = (0, $4HqRp.default)((0, $dff1c8c0bf270f18$export$5f1ddd061a43f32d)[modelType]);
    /** Methods **/ /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            id: pageId,
            component: "md-content",
            className: "md-default-theme",
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                    component: "md-card",
                    className: "md-default-theme",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $1a2a1d044715c64b$export$141c9d2033716579), {
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    justifyContent: "start",
                                    alignItems: "center",
                                    display: "flex",
                                    flex: 33,
                                    children: toolbarItems
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    flex: 33,
                                    children: [
                                        (0, $b20f24d98bb11dde$export$69325452aaefb623)[modelType],
                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            component: "span",
                                            className: "md-title pad-left-xs",
                                            children: dataModelsName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    justifyContent: "end",
                                    alignItems: "center",
                                    display: "flex",
                                    flex: 33,
                                    children: userStore.isAdmin && !hideCreateButton && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                        className: "md-button md-fab md-mini",
                                        "aria-label": pageTitle,
                                        onClick: ()=>navigate(createUrl || `/${dataModelsName.toLowerCase()}/create`),
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                            title: pageTitle,
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $0f7ec11a5e78fdaf$export$2e2bcd8739ae039), {
                                                className: "md-icon material-icons"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        !data && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            bgcolor: "white",
                            display: "flex",
                            flex: "100",
                            justifyContent: "center",
                            alignItems: "center",
                            className: "pad-top-bottom",
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                                className: "md-primary",
                                "md-mode": "indeterminate"
                            })
                        }),
                        data && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            bgcolor: "white",
                            children: [
                                !!data.length && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    bgcolor: "white",
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                                            items: headerItems,
                                            sortType: sortType,
                                            sortReverse: sortReverse,
                                            sortList: sortList,
                                            padForScrollbar: data.length > 11
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            // component="md-content"
                                            className: data.length > 11 ? 'fixed-list-lg' : '',
                                            sx: {
                                                maxHeight: `${(11 * rowHeight).toString()}px`
                                            },
                                            children: children
                                        })
                                    ]
                                }),
                                message && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        flex: "100",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        className: "pad-top-bottom",
                                        children: message
                                    })
                                }),
                                !message && data && !data.length && isFiltered && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        flex: "100",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        className: "pad-top-bottom md-title thin",
                                        children: noFilteredDataMessage || `No ${dataModelsName} found.`
                                    })
                                }),
                                !message && data && !data.length && !isFiltered && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        flex: "100",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        className: "pad-top-bottom md-title thin",
                                        children: showCreateLink && !userStore.isLender ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            children: [
                                                "No ",
                                                dataModelsName,
                                                " yet, why don't you ",
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    paddingRight: "4px"
                                                }),
                                                ' ',
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                                    to: `/${dataModelsName.toLowerCase()}/create`,
                                                    children: "create one"
                                                }),
                                                "?"
                                            ]
                                        }) : noDataMessage || `No ${dataModelsName} found.`
                                    })
                                }),
                                !message && !data && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        flex: "100",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        className: "pad-top-bottom",
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                                            className: "md-primary",
                                            "md-mode": "indeterminate"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                notes && notesName && setNotes && setNotesName && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                    notes: notes,
                    name: notesName,
                    open: !!notes,
                    setOpen: (open)=>!open && setNotes(undefined) && setNotesName(undefined)
                })
            ]
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $91537c146b0bb33c$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');







const $e6f74e0a78043d70$export$767e3006bdbb424a = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ children: children, modelType: modelType, modelName: modelName, icon: icon, speedDialActions: speedDialActions, id: id, sidebar: sidebar, sidebarItems: sidebarItems, sidebarFlex: sidebarFlex = '25', contentFlex: contentFlex = '75', width: width, setSidebarItems: setSidebarItems, textClassName: textClassName, modals: modals, noteOptions: noteOptions, documentOptions: documentOptions, notesDocsFlex: notesDocsFlex })=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** Computed **/ const pageId = id || `${modelType.toLowerCase()}Form`;
    const modelIcon = icon ?? (0, $b20f24d98bb11dde$export$69325452aaefb623)[modelType];
    const title = modelName;
    const showSidebar = sidebar || sidebarItems && setSidebarItems && (noteOptions || documentOptions);
    /** Render **/ const renderNotes = (index = 0)=>sidebarItems && setSidebarItems && noteOptions && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
            mode: noteOptions.mode,
            notes: noteOptions.notes ?? [],
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateNotes: noteOptions.onChange,
            title: noteOptions.title,
            tooltip: noteOptions.tooltip
        });
    const renderDocuments = (index = 1)=>sidebarItems && setSidebarItems && documentOptions && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
            mode: documentOptions.mode,
            documents: documentOptions.files ?? [],
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateDocuments: documentOptions.onChange,
            title: documentOptions.title,
            tooltip: documentOptions.tooltip
        });
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            id: pageId,
            className: "detail-page-content md-default-theme",
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    "layout-gt-sm": "row",
                    children: [
                        showSidebar ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            sx: {
                                flex: sidebarFlex
                            },
                            children: [
                                sidebar,
                                sidebarItems && setSidebarItems && (noteOptions || documentOptions) && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    sx: {
                                        flex: notesDocsFlex
                                    },
                                    children: [
                                        noteOptions && renderNotes(),
                                        documentOptions && renderDocuments()
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: 1
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            sx: !width ? {
                                flex: contentFlex
                            } : undefined,
                            width: width,
                            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                component: "md-card",
                                style: {
                                    background: 'white'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $1a2a1d044715c64b$export$141c9d2033716579), {
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                display: "flex",
                                                flex: 15,
                                                children: userStore.isAdmin && speedDialActions && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e0c13309ae81fe4$export$16bc57642f47033), {
                                                    ariaLabel: "Adjustment Options",
                                                    direction: "right",
                                                    icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $91537c146b0bb33c$export$2e2bcd8739ae039), {
                                                        style: {
                                                            color: 'black'
                                                        },
                                                        className: "md-icon material-icons"
                                                    }),
                                                    children: Array.isArray(speedDialActions) ? speedDialActions.map((action)=>action) : speedDialActions
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                className: textClassName ?? 'thin md-display-1',
                                                display: "flex",
                                                gap: "6px",
                                                children: [
                                                    modelIcon,
                                                    title
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                display: "flex",
                                                flex: 15
                                            })
                                        ]
                                    }),
                                    children
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: 1
                        })
                    ]
                }),
                modals
            ]
        })
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $PKVGF = parcelRequire("PKVGF");





const $80243c13f35b435b$export$27b0f39d8596faa0 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ lender: lender, open: open, toggleOpen: toggleOpen, setShowLedgerPopup: setShowLedgerPopup })=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)('sequenceNumber');
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(true);
    /** Computed **/ const transactions = lender?.account.activity;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (transactions) {
            const list = transactions.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        transactions,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Account Ledger",
        open: open,
        toggleOpen: toggleOpen,
        toggleTooltip: "Toggles the Account Ledger sidebar item",
        resolved: !!lender,
        children: [
            userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 1
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                    "aria-label": "Post Transaction",
                                    className: "md-mini thin",
                                    onClick: ()=>setShowLedgerPopup(true),
                                    children: "Post Transaction"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                ]
            }),
            !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    className: "md-subhead-sm",
                    justifyContent: "center",
                    children: "You haven't posted any transactions yet!"
                })
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        propName: 'effectiveDate',
                        label: 'Date'
                    },
                    {
                        propName: 'amount',
                        label: 'Credit/Debit',
                        textAlign: 'right'
                    },
                    {
                        propName: 'balance',
                        label: 'Balance',
                        textAlign: 'right'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && listData?.map((txn, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                    items: [
                        {
                            propName: 'effectiveDate',
                            content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(txn.effectiveDate).format((0, $50c68e19ba8e5079$export$26e685d98fdeb12f)),
                            textAlign: 'right'
                        },
                        {
                            propName: 'amount',
                            content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(txn.amount),
                            textAlign: 'right'
                        },
                        {
                            propName: 'balance',
                            content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(txn.balance),
                            textAlign: 'right'
                        }
                    ],
                    rowIndex: i
                }, txn._id))
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");



const $6beec9822bb5e1cc$export$218382a9390eb464 = ({ lender: lender, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Investor Information (YTD)",
        open: open,
        toggleOpen: toggleOpen,
        toggleTooltip: "Toggles the Investor Information sidebar item",
        resolved: !!lender,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                className: "pad-top-bottom-xs",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        padding: "16px",
                        display: "flex",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $313c12310dd1cdcd$export$2e2bcd8739ae039), {
                            className: "md-icon material-icons",
                            sx: {
                                width: '24px',
                                height: '24px'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        paddingX: "16px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "start",
                        flex: 82,
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                className: "medium",
                                children: lender?.name
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                children: lender?.address.street
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: lender?.address.city
                                    }),
                                    ", ",
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: lender?.address.state
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        children: lender?.address.zip
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            lender?.longName && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Long Name",
                        value: lender?.longName,
                        smallFont: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Contact Person",
                value: lender?.contactPerson,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Primary Phone",
                value: lender?.phone.primary,
                smallFont: true
            }),
            lender?.phone.secondary && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Secondary Phone",
                value: lender?.phone.secondary,
                smallFont: true
            }),
            lender?.phone.fax && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Fax",
                value: lender?.phone.fax,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Email",
                value: lender?.email,
                url: `mailto:${lender?.email}`,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Website",
                value: lender?.website,
                url: lender?.website,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Line of Business",
                value: lender?.socketLineOfBusiness ?? '',
                capitalize: true,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Company Type",
                value: lender?.companyType,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Status",
                value: lender?.status ?? '',
                capitalize: true,
                smallFont: true
            })
        ]
    });



var $iO5o7 = parcelRequire("iO5o7");


const $4f233e3b681f6d7f$export$7d8fd244d7da7f91 = ({ lender: lender, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Investor Overview (YTD)",
        open: open,
        toggleOpen: toggleOpen,
        toggleTooltip: "Toggles the Investor Overview sidebar item",
        resolved: !!lender,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Current Principal Balances (YTD)",
                value: lender?.ytd.principalBalance,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Fees Collected (YTD)",
                value: lender?.ytd.appliedToFees,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Interest Collected (YTD)",
                value: lender?.ytd.appliedToInterest,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Total Revenue (YTD)",
                value: lender?.ytd.totalRevenue,
                bold: true,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Socket Fees (YTD)",
                value: lender?.ytd.managementFees,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Net Revenue Collected (YTD)",
                value: lender?.ytd.netRevenue,
                bold: true,
                currency: true
            })
        ]
    });



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");


const $08905dc44ac0415b$export$1e52b2b24171e046 = ({ value: value, setValue: setValue, lenders: lenders, boxProps: boxProps, placeholder: placeholder = 'Select Investor', ariaLabel: ariaLabel = 'Select Investor', ...selectProps })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                component: "span",
                children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Lender]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                value: value,
                updateValue: (value)=>setValue(value),
                placeholder: placeholder,
                ariaLabel: ariaLabel,
                options: lenders.map((company)=>({
                        label: company.name,
                        value: company._id
                    })),
                ...selectProps
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");






const $4a47b27bbb9242ba$export$b0aae760ecfd650c = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const lenderStore = (0, $1da4b8b758f1a116$export$9e981f97ad523833)();
    /** State **/ const [lenders, setLenders] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (lenders) {
            const list = lenders.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        lenders,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.participationPercentage = 0;
        totals.currentBalance = 0;
        totals.feesDue = 0;
        totals.interestDue = 0;
        const lenders = data.map((lender)=>{
            lender;
            // Calculate totals
            totals.participationPercentage += lender.participationPercentage;
            totals.currentBalance += lender.principalBalance;
            totals.feesDue += lender.feesDue;
            totals.interestDue += lender.interestDue;
            // Store
            return lender;
        });
        // Save data
        setLenders(lenders);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) {
            const fetchLenders = async ()=>{
                const response = await (0, $ead355dc3e4dafd9$export$6f059e92a7272a52).query(query);
                const lenders = lenderStore.formatLenderList(response);
                formatData(lenders);
            };
            fetchLenders();
        }
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        propName: 'lenderName',
                        label: 'Investor Name'
                    },
                    {
                        propName: 'participationPercentage',
                        label: 'Participation Percentage'
                    },
                    {
                        propName: 'principalBalance',
                        label: 'Current Balance'
                    },
                    {
                        propName: 'feesDue',
                        label: 'Fees Due'
                    },
                    {
                        propName: 'interestDue',
                        label: 'Interest Due'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((lender, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                        padForScrollbar: listData.length > 8,
                        items: [
                            {
                                propName: 'lenderName',
                                content: lender.company.name,
                                url: `/investors/${lender.company._id}`
                            },
                            {
                                propName: 'participationPercentage',
                                content: $2c379471d5bc2795$exports.percent.format(lender.participationPercentage ?? 0)
                            },
                            {
                                propName: 'principalBalance',
                                content: $2c379471d5bc2795$exports.currency.format(lender.principalBalance)
                            },
                            {
                                propName: 'feesDue',
                                content: $2c379471d5bc2795$exports.currency.format(lender.feesDue ?? 0)
                            },
                            {
                                propName: 'interestDue',
                                content: $2c379471d5bc2795$exports.currency.format(lender.interestDue ?? 0)
                            }
                        ],
                        rowIndex: i
                    }, lender._id))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            propName: 'lenderName',
                            label: 'Investor Name'
                        },
                        {
                            propName: 'participationPercentage',
                            label: 'Participation Percentage',
                            type: 'percent'
                        },
                        {
                            propName: 'currentBalance',
                            label: 'Current Balance'
                        },
                        {
                            propName: 'feesDue',
                            label: 'Fees Due'
                        },
                        {
                            propName: 'interestDue',
                            label: 'Interest Due'
                        }
                    ].map(({ propName: propName, type: type, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : $2c379471d5bc2795$exports[type === 'percent' ? 'percent' : 'currency'].format(totals[propName] ?? 0),
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "span",
                        children: "No Lenders found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");


const $37791693c4460ea0$export$6dd91515a4716fcd = ({ lender: lender, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Portfolio Summary (All-Time)",
        open: open,
        toggleOpen: toggleOpen,
        toggleTooltip: "Toggles the Portfolio Summary sidebar item",
        resolved: !!lender,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Amount Invested",
                value: lender?.alltime.account.amountInvested,
                bold: true,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Current Principal Balances",
                value: lender?.alltime.principalBalance,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Fees Collected",
                value: lender?.alltime.appliedToFees,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Interest Collected",
                value: lender?.alltime.appliedToInterest,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Total Revenue",
                value: lender?.alltime.totalRevenue,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Socket Fees",
                value: lender?.alltime.managementFees,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Net Revenue Collected",
                value: lender?.alltime.netRevenue,
                bold: true,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Returned to Investor",
                value: lender?.alltime.account.amountReturned,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Holding Account Balance",
                value: lender?.alltime.holdingAccountBalance,
                bold: true,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Accrued Unpaid Deal Fees",
                value: lender?.alltime.feeBalance,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Accrued Unpaid Deal Interest",
                value: lender?.alltime.interestBalance,
                currency: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Total Accrued Unpaid Revenue",
                value: lender?.alltime.totalUnpaidRevenue,
                bold: true,
                currency: true
            })
        ]
    });





var $iO5o7 = parcelRequire("iO5o7");

var $4HqRp = parcelRequire("4HqRp");


const $4808c6d3c8fe8287$export$f96bed44a6dab4bf = ({ loan: loan, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Deal Details",
        open: open,
        toggleOpen: toggleOpen,
        resolved: !!loan,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Company",
                value: loan?.borrower.name,
                url: `/companies/${loan?.borrower._id}`,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Created On",
                value: loan?.created,
                date: true,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Type",
                value: loan?.isOwned ? (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned : (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Status",
                value: (0, $4HqRp.default)(loan?.status ?? ''),
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Amount",
                bold: true,
                value: loan?.amount,
                currency: true,
                smallFont: true
            }),
            !loan?.isOwned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Term",
                        value: `${loan?.term} Months`,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Maturity Date",
                        value: loan?.maturityDate,
                        date: true,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Last Advance Date",
                        value: loan?.lastAdvanceDate,
                        date: true,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Minimum Payment Method",
                        value: loan?.minPmtMethod,
                        smallFont: true
                    }),
                    !!loan?.minimumPayment && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Minimum Payment",
                        value: loan.minimumPayment,
                        currency: true,
                        smallFont: true
                    }),
                    !!loan?.payDownPercent && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Pay Down Percent",
                        value: loan.payDownPercent,
                        percent: true,
                        smallFont: true
                    })
                ]
            })
        ]
    });



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");


const $4a273722595f97f8$export$a370fbe028fde36c = ({ value: value, setValue: setValue, loans: loans, boxProps: boxProps, placeholder: placeholder = 'Select Deal', ariaLabel: ariaLabel = 'Select Deal', ...selectProps })=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        ...boxProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                component: "span",
                children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Loan]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                value: value,
                updateValue: (value)=>setValue(value),
                placeholder: placeholder,
                ariaLabel: ariaLabel,
                options: loans.map((loan)=>({
                        label: loan.name,
                        value: loan._id
                    })),
                ...selectProps
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");






const $9ac5e4c872c7a2ed$export$d0c4febac53db166 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const loanStore = (0, $1da4b8b758f1a116$export$2069e70401eb38b3)();
    /** State **/ const [loans, setLoans] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (loans) {
            const list = loans.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        loans,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.principalBalance = 0;
        totals.feeBalance = 0;
        totals.interestBalance = 0;
        totals.assetValue = 0;
        const loans = data.map((loan)=>{
            // Combine
            loan.notes = [
                ...loan.socketComments,
                ...loan.companyComments
            ].sort((a, b)=>a.created > b.created ? 1 : -1);
            // Calculate totals
            totals.principalBalance += loan.principalBalance;
            totals.feeBalance += loan.feeBalance;
            totals.interestBalance += loan.interestBalance;
            totals.assetValue += loan.assetValue;
            // Store
            return loan;
        });
        // Save data
        setLoans(loans);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) loanStore.query(query).then((loans)=>loans && formatData(loans));
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        flex: 5,
                        propName: 'notes',
                        label: 'Notes'
                    },
                    {
                        propName: 'name',
                        label: 'Name'
                    },
                    {
                        propName: 'principalBalance',
                        label: 'Principal Balance'
                    },
                    {
                        propName: 'feeBalance',
                        label: 'Fee Balance'
                    },
                    {
                        propName: 'interestBalance',
                        label: 'Interest Balance'
                    },
                    {
                        propName: 'assetValue',
                        label: 'Current Asset Value'
                    },
                    {
                        propName: 'interestRate',
                        label: 'Interest Rate'
                    },
                    {
                        propName: 'status',
                        label: 'Status'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((loan, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        className: `capitalize ${i % 2 ? '' : 'highlighted'}`,
                        sx: {
                            height: rowHeight + 'px',
                            maxHeight: rowHeight + 'px'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: "100",
                            justifyContent: "space-around",
                            alignItems: "center",
                            className: "text-center md-subhead-sm",
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    component: "span",
                                    display: "flex",
                                    flex: 5,
                                    maxWidth: "5%",
                                    children: (!!loan.companyComments?.length || !!loan.socketComments?.length) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                        onClick: ()=>showNotesPopup(loan.notes, loan.name),
                                        className: "pointer",
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                            title: "Click to see Notes",
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2c5c5bfa123d756e$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Deal Name",
                                    value: loan.name,
                                    url: `/deals/${loan._id}`
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Principal Balance",
                                    value: $2c379471d5bc2795$exports.currency.format(loan.principalBalance),
                                    textAlign: "right"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Fee Balance",
                                    value: $2c379471d5bc2795$exports.currency.format(loan.feeBalance),
                                    textAlign: "right"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Interest Balance",
                                    value: $2c379471d5bc2795$exports.currency.format(loan.interestBalance),
                                    textAlign: "right"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Current Asset Value",
                                    value: $2c379471d5bc2795$exports.currency.format(loan.assetValue),
                                    textAlign: "right"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Interest Rate",
                                    value: $2c379471d5bc2795$exports.percent.format(loan.interestRate),
                                    textAlign: "right"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                    label: "Status",
                                    value: loan.status,
                                    textAlign: "right"
                                })
                            ]
                        })
                    }, loan._id))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            flex: 5,
                            propName: 'notes',
                            label: 'Notes'
                        },
                        {
                            propName: 'name',
                            label: 'Name'
                        },
                        {
                            propName: 'principalBalance',
                            label: 'Principal Balance'
                        },
                        {
                            propName: 'feeBalance',
                            label: 'Fee Balance'
                        },
                        {
                            propName: 'interestBalance',
                            label: 'Interest Balance'
                        },
                        {
                            propName: 'assetValue',
                            label: 'Current Asset Value'
                        },
                        {
                            propName: 'interestRate',
                            label: 'Interest Rate',
                            type: 'percent'
                        },
                        {
                            propName: 'status',
                            label: 'Status'
                        }
                    ].map(({ propName: propName, type: type, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : $2c379471d5bc2795$exports.isNumber(totals[propName]) ? $2c379471d5bc2795$exports[type === 'percent' ? 'percent' : 'currency'].format(totals[propName]) : '',
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "span",
                        children: "No Deals found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");


const $22ac995406cc2454$export$2628809462f3b8e = ({ loan: loan, open: open, toggleOpen: toggleOpen })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Rates & Fees",
        open: open,
        toggleOpen: toggleOpen,
        resolved: !!loan,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                title: "Advance Rate",
                value: loan?.advanceRate,
                percent: true,
                smallFont: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !loan?.isOwned ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Interest Rate",
                        value: loan?.interestRate,
                        percent: true,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Origination Fee",
                        value: loan?.originationFee,
                        percent: true,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    !!loan?.adminFee && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Administrative Fee",
                        value: loan.adminFee,
                        percent: true,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    !!loan?.discountFee && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Discount Fee",
                        value: loan.discountFee,
                        percent: true,
                        smallFont: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Administrative Fee",
                        value: loan?.adminFee,
                        percent: true,
                        smallFont: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Discount Fee",
                        value: loan?.discountFee,
                        percent: true,
                        smallFont: true
                    })
                ]
            })
        ]
    });





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $9d4e318c09305a91$exports = {};
"use strict";
"use client";
var $acdf9d64e3104bc2$exports = {};
function $acdf9d64e3104bc2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$acdf9d64e3104bc2$exports = $acdf9d64e3104bc2$var$_interopRequireDefault, $acdf9d64e3104bc2$exports.__esModule = true, $acdf9d64e3104bc2$exports["default"] = $acdf9d64e3104bc2$exports;


var $9d4e318c09305a91$require$_interopRequireDefault = $acdf9d64e3104bc2$exports.default;
Object.defineProperty($9d4e318c09305a91$exports, "__esModule", {
    value: true
});
$9d4e318c09305a91$exports.default = void 0;

var $9d4e318c09305a91$var$_createSvgIcon = $9d4e318c09305a91$require$_interopRequireDefault((parcelRequire("japms")));

var $iO5o7 = parcelRequire("iO5o7");
var $9d4e318c09305a91$var$_default = $9d4e318c09305a91$exports.default = (0, $9d4e318c09305a91$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");


var $4HqRp = parcelRequire("4HqRp");




var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $2782fffafe0eddef$export$2177af0aa15c34c2(slot) {
    return (0, $bYZd6.default)('MuiDialog', slot);
}
const $2782fffafe0eddef$var$dialogClasses = (0, $eaNcJ.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $2782fffafe0eddef$export$2e2bcd8739ae039 = $2782fffafe0eddef$var$dialogClasses;



var $lVd4O = parcelRequire("lVd4O");
'use client';
const $1d4aafd614c364dc$var$DialogContext = /*#__PURE__*/ $lVd4O.createContext({});
var $1d4aafd614c364dc$export$2e2bcd8739ae039 = $1d4aafd614c364dc$var$DialogContext;




var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");


var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a5bc9e5473bdb35e$var$DialogBackdrop = (0, $gvIKB.default)((0, $4406b948e3c3881f$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $a5bc9e5473bdb35e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $4HqRp.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $4HqRp.default)(scroll)}`,
            `paperWidth${(0, $4HqRp.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $2782fffafe0eddef$export$2177af0aa15c34c2), classes);
};
const $a5bc9e5473bdb35e$var$DialogRoot = (0, $gvIKB.default)((0, $4edd77deffff3ad1$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $a5bc9e5473bdb35e$var$DialogContainer = (0, $gvIKB.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $4HqRp.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $a5bc9e5473bdb35e$var$DialogPaper = (0, $gvIKB.default)((0, $094c486a546066a9$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $4HqRp.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $4HqRp.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $2782fffafe0eddef$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $2782fffafe0eddef$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $2782fffafe0eddef$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $a5bc9e5473bdb35e$var$Dialog = /*#__PURE__*/ $lVd4O.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $713aff601b146490$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $094c486a546066a9$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $ce18eb56bb45d984$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $a5bc9e5473bdb35e$var$useUtilityClasses(ownerState);
    const backdropClick = $lVd4O.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $a1ab550e14ceaf6f$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $lVd4O.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        elementType: $a5bc9e5473bdb35e$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('backdrop', {
        elementType: $a5bc9e5473bdb35e$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('paper', {
        elementType: $a5bc9e5473bdb35e$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('container', {
        elementType: $a5bc9e5473bdb35e$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $anaDR.default)(classes.container)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $ce18eb56bb45d984$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $iO5o7.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $iO5o7.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1d4aafd614c364dc$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $a5bc9e5473bdb35e$export$2e2bcd8739ae039 = $a5bc9e5473bdb35e$var$Dialog;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $bd95a5e3c6dde229$export$5e57a444791c63be(slot) {
    return (0, $bYZd6.default)('MuiDialogActions', slot);
}
const $bd95a5e3c6dde229$var$dialogActionsClasses = (0, $eaNcJ.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $bd95a5e3c6dde229$export$2e2bcd8739ae039 = $bd95a5e3c6dde229$var$dialogActionsClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a71d598f193c5937$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $bd95a5e3c6dde229$export$5e57a444791c63be), classes);
};
const $a71d598f193c5937$var$DialogActionsRoot = (0, $gvIKB.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $a71d598f193c5937$var$DialogActions = /*#__PURE__*/ $lVd4O.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $a71d598f193c5937$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($a71d598f193c5937$var$DialogActionsRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $a71d598f193c5937$export$2e2bcd8739ae039 = $a71d598f193c5937$var$DialogActions;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $4ddede4a3bdd0eb3$export$61b0ee1f05fb344e(slot) {
    return (0, $bYZd6.default)('MuiDialogContent', slot);
}
const $4ddede4a3bdd0eb3$var$dialogContentClasses = (0, $eaNcJ.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $4ddede4a3bdd0eb3$export$2e2bcd8739ae039 = $4ddede4a3bdd0eb3$var$dialogContentClasses;



var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $1ccde807a2cfcb4f$export$f5d2ec7e4c47e088(slot) {
    return (0, $bYZd6.default)('MuiDialogTitle', slot);
}
const $1ccde807a2cfcb4f$var$dialogTitleClasses = (0, $eaNcJ.default)('MuiDialogTitle', [
    'root'
]);
var $1ccde807a2cfcb4f$export$2e2bcd8739ae039 = $1ccde807a2cfcb4f$var$dialogTitleClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $a63e675744415152$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $4ddede4a3bdd0eb3$export$61b0ee1f05fb344e), classes);
};
const $a63e675744415152$var$DialogContentRoot = (0, $gvIKB.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $1ccde807a2cfcb4f$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $a63e675744415152$var$DialogContent = /*#__PURE__*/ $lVd4O.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $a63e675744415152$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($a63e675744415152$var$DialogContentRoot, {
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $a63e675744415152$export$2e2bcd8739ae039 = $a63e675744415152$var$DialogContent;







const $8a627ea3c55963d3$export$c1af37dd38d7de63 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ lender: lender, setLender: setLender, item: item, open: open, setOpen: setOpen })=>{
    /** Context **/ const accountStore = (0, $1da4b8b758f1a116$export$17d4feea532c39aa)();
    /** State **/ const [amount, setAmount] = (0, $lVd4O.useState)(item?.amount);
    const [oldAmount] = (0, $lVd4O.useState)(item?.amount);
    const [effectiveDate, setEffectiveDate] = (0, $lVd4O.useState)(item ? (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(item.effectiveDate).toDate() : (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))().toDate());
    const [maxError, setMaxError] = (0, $lVd4O.useState)(false);
    /**
     * Remove a Ledger item
     */ const removeLedgerItem = async ()=>{
        if (!item) return;
        try {
            // Create new withdrawal/deposit object
            const ledgerItem = {
                _id: lender._id,
                transactionId: item._id
            };
            // Remove it
            const account = await accountStore.remove(lender._id, ledgerItem.transactionId);
            // Store updated account items list
            setLender({
                ...lender,
                account: account
            });
            // Confirmation alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteTransaction.success);
            // Close dialog
            setOpen(false);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteTransaction.error);
        }
    };
    /**
     * Updates a Ledger item
     */ const updateLedgerItem = async ()=>{
        if (!item) return;
        if (!amount) throw new Error('An amount is required');
        if (amount === oldAmount) {
            setOpen(false);
            return;
        }
        // Check to see if form is valid
        // $lenderLedgerForm.$setDirty();
        // if (!$lenderLedgerForm.$valid) {
        //   Alerts.show('Please fix the errors first.');
        //   return false;
        // }
        try {
            const account = await accountStore.update(lender._id, item._id, {
                amount: amount
            });
            // Store updated account items list
            setLender({
                ...lender,
                account: account
            });
            // Confirmation alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateTransaction.success);
            // Close dialog
            setOpen(false);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateTransaction.error);
        }
    };
    /**
     * Creates a Ledger item
     */ const createLedgerItem = async ()=>{
        if (!amount) throw new Error('An amount is required');
        if (!effectiveDate) throw new Error('Effective date is required');
        // // Check to see if form is valid
        // $scope.lenderLedgerForm.$setDirty();
        // if(!$scope.lenderLedgerForm.$valid){
        //     Alerts.show('Please fix the errors first.');
        //     scope.maxError = true;
        //     return;
        // }
        setMaxError(false);
        try {
            // Update it
            const account = await accountStore.create(lender._id, {
                amount: amount,
                effectiveDate: effectiveDate
            });
            // Store updated account items list
            setLender({
                ...lender,
                account: account
            });
            // Confirmation alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createTransaction.success);
            // Close dialog
            setOpen(false);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createTransaction.error);
        }
    };
    // const handleAmountChange = (value?: string) => {
    //   isNumber(value) && setAmount(parseFloat(value ?? '0'));
    // };
    const handleDateChange = (value)=>{
        if (!value) {
            setMaxError(false);
            setEffectiveDate(new Date());
            return;
        }
        const selectedDate = new Date(value);
        const today = new Date();
        if (selectedDate > today) setMaxError(true);
        else {
            setMaxError(false);
            setEffectiveDate(selectedDate);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a5bc9e5473bdb35e$export$2e2bcd8739ae039), {
        open: open,
        onClose: ()=>setOpen(false),
        // maxWidth="xs"
        // fullWidth
        "aria-label": `${item ? 'Edit' : 'Post'} Transaction`,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                className: "toolbar-div md-toolbar-tools",
                width: "500px",
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $cfe213ca21d1ee96$export$2e2bcd8739ae039), {
                        variant: "h2",
                        className: "md-subhead capitalize",
                        children: [
                            item ? 'Edit' : 'Post',
                            " Transaction"
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                        className: "md-icon-button",
                        onClick: ()=>setOpen(false),
                        "aria-label": "close",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9d4e318c09305a91$exports))), {
                            className: "md-icon material-icons",
                            sx: {
                                color: 'white'
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a63e675744415152$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: `Amount ${item ? '(Enter $0 To Delete)' : ''}`,
                        value: amount,
                        updateValue: (value)=>setAmount(value),
                        type: "number",
                        required: true
                    }),
                    !item && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Effective Date",
                        type: "date",
                        value: effectiveDate,
                        updateValue: handleDateChange,
                        required: true
                    }),
                    maxError && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cfe213ca21d1ee96$export$2e2bcd8739ae039), {
                        color: "error",
                        align: "center",
                        children: "Please select a date that's not in the future."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a71d598f193c5937$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: ()=>setOpen(false),
                        color: "primary",
                        children: "Cancel"
                    }),
                    item && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: ()=>amount === 0 ? removeLedgerItem() : updateLedgerItem(),
                        color: amount === 0 ? 'error' : 'primary',
                        children: amount === 0 ? 'Delete' : 'Update'
                    }),
                    !item && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: ()=>createLedgerItem(),
                        color: "primary",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");

const $6c09b31ac8ce3c48$export$8eec1a3a911975a4 = ({ content: content, open: open, setOpen: setOpen, onOk: onOk, onCancel: onCancel, label: label, okLabel: okLabel = 'OK', cancelLabel: cancelLabel = 'Cancel' })=>{
    const handleConfirm = ()=>{
        setOpen(false);
        onOk?.();
    };
    const handleClose = ()=>{
        setOpen(false);
        onCancel?.();
    };
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a5bc9e5473bdb35e$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        "aria-label": label,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a63e675744415152$export$2e2bcd8739ae039), {
                children: content
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a71d598f193c5937$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        color: "secondary",
                        children: cancelLabel
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: handleConfirm,
                        color: "primary",
                        children: okLabel
                    })
                ]
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $4HqRp = parcelRequire("4HqRp");


const $8baa694235e4631d$export$e692ee57a11ebf99 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ mode: mode, open: open, content: content, setOpen: setOpen, onConfirm: onConfirm, onCancel: onCancel })=>{
    const [noteContent, setNoteContent] = (0, $lVd4O.useState)('');
    const action = (0, $4HqRp.default)(mode);
    const handleConfirm = ()=>{
        setOpen(false);
        onConfirm(noteContent);
        setNoteContent('');
    };
    const handleCancel = ()=>{
        setOpen(false);
        setNoteContent('');
        onCancel?.();
    };
    (0, $lVd4O.useEffect)(()=>{
        if (content && content !== noteContent) setNoteContent(content);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a5bc9e5473bdb35e$export$2e2bcd8739ae039), {
        open: open,
        "aria-label": `${action} Note`,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                className: "toolbar-div",
                width: "500px",
                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "none",
                    className: "md-title",
                    gap: "6px",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2c5c5bfa123d756e$export$2e2bcd8739ae039), {}),
                        " ",
                        action,
                        " Note"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8e95540a876aab9d$export$2e2bcd8739ae039), {
                    variant: "standard",
                    fullWidth: true,
                    margin: "dense",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $329481b97cef9b48$export$2e2bcd8739ae039), {
                        value: noteContent,
                        onChange: (event)=>setNoteContent(event.target.value),
                        minRows: 10,
                        maxRows: 10,
                        style: {
                            width: '100%',
                            border: 'none',
                            resize: 'none',
                            padding: '0 8px',
                            outline: 'none'
                        },
                        id: "noteContent",
                        "aria-label": "Enter the Note's text",
                        required: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a71d598f193c5937$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: ()=>handleCancel(),
                        className: "md-primary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                        onClick: ()=>handleConfirm(),
                        className: "md-primary",
                        children: [
                            mode == (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Create && 'Add',
                            mode == (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit && 'Save',
                            mode == (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Remove && 'Delete'
                        ]
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");
parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $41248fcbdc9a27cf$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');






const $ca8c088d223abec1$export$7e933156548d708b = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ name: name = 'Notes', notes: notes, open: open, setOpen: setOpen })=>{
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a5bc9e5473bdb35e$export$2e2bcd8739ae039), {
        open: open,
        "aria-label": "View Notes",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                className: "toolbar-div md-toolbar-tools",
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)("h2", {
                        className: "md-subhead capitalize",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                        className: "md-icon-button",
                        onClick: ()=>setOpen(false),
                        "aria-label": "Close",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41248fcbdc9a27cf$export$2e2bcd8739ae039), {
                            className: "md-icon material-icons",
                            sx: {
                                color: 'white'
                            }
                        })
                    })
                ]
            }),
            notes.map((note)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                            sx: {
                                padding: '16px 16px 8px 16px'
                            },
                            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-caption",
                                        children: [
                                            "Added ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(note.created).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                                            note.user.displayName && ` by ${note.user.displayName}`
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)("p", {
                                        className: "md-body-2",
                                        children: note.content
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                    ]
                }, note._id))
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $d24e65f9bc8c5447$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'AddCircleOutline');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $0d529cca628def1a$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'RemoveCircleOutline');







const $cc4ed34d900a0882$export$3640f67146a55712 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ open: open, toggleOpen: toggleOpen, participations: participations, setParticipations: setParticipations, flex: flex })=>{
    const rowHeight = 48;
    /** Context **/ const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    /** State **/ const [indexToDelete, setIndexToDelete] = (0, $lVd4O.useState)();
    const [formValues, setFormValues] = (0, $lVd4O.useState)({
        company: '',
        managementFee: 0,
        participationPercentage: 0
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const totalParticipation = (0, $lVd4O.useMemo)(()=>{
        // Add up participation percentages
        let totalParticipation = 0;
        for (const participation of participations)totalParticipation += participation.participationPercentage;
        // Add any extra values if given
        totalParticipation += formValues.participationPercentage;
        // Return
        return totalParticipation;
    }, [
        participations,
        formValues.participationPercentage
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>filterStore.lenderListGet(), [
        filterStore._lenderList
    ]);
    const lenderOptions = lenders?.map((lender)=>({
            label: lender.name,
            value: lender._id
        }));
    /** Methods **/ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
     * Adds a participation interest
     */ const addParticipation = ()=>{
        if (!formValues.company) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please select a Lender');
            return false;
        } else if (!formValues.participationPercentage) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please enter a Participation Percentage');
            return false;
        }
        const lenderParticipation = {
            ...formValues
        };
        // Push to lenders array
        const updatedParticipations = [
            ...participations,
            lenderParticipation
        ];
        setParticipations(updatedParticipations);
        setFormValues({
            company: '',
            managementFee: 0,
            participationPercentage: 0
        });
    };
    /**
     * Removes a participation interest
     */ const removeParticipation = ()=>{
        if (typeof indexToDelete !== 'number') return;
        participations.splice(indexToDelete, 1);
        setParticipations(participations);
    };
    var managementFee, participationPercentage, participation, i, company, managementFee1, participationPercentage1;
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $660b0670d077a6fb$export$b09fc4897b18f7d8), {
        title: "Investor Participations",
        open: open,
        toggleOpen: toggleOpen,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                className: "pad-sides",
                gap: "6px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "48px",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                            className: "md-icon-button",
                            onClick: ()=>addParticipation(),
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                title: "Add Participation",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d24e65f9bc8c5447$export$2e2bcd8739ae039), {
                                    className: "md-icon material-icons"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                        flex: 50,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            value: formValues.company,
                            placeholder: "Select Investor",
                            ariaLabel: "Select an Investor for this Participation",
                            updateValue: updateFormValue('company'),
                            required: true,
                            options: lenderOptions
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 40,
                        gap: "6px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                label: "Management Fee",
                                value: formValues.managementFee,
                                updateValue: (managementFee)=>updateFormValue('managementFee')((0, $f90d087769f90e7b$export$7e4aa119212bc614)(managementFee) ? parseFloat(managementFee) : 0),
                                type: "number",
                                min: "0",
                                percentageMask: true,
                                boxProps: {
                                    className: 'thin float-right'
                                },
                                required: true
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                label: "Participation %",
                                value: formValues.participationPercentage,
                                updateValue: (participationPercentage)=>updateFormValue('participationPercentage')((0, $f90d087769f90e7b$export$7e4aa119212bc614)(participationPercentage) ? parseFloat(participationPercentage) : 0),
                                type: "number",
                                min: "0",
                                percentageMask: true,
                                boxProps: {
                                    className: 'thin float-right'
                                },
                                required: true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            participations.map((participation, i)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    className: "pad-sides",
                    gap: "6px",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "48px",
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                className: "md-icon-button",
                                onClick: ()=>{
                                    setIndexToDelete(i);
                                },
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                    title: "Remove Participation",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $0d529cca628def1a$export$2e2bcd8739ae039), {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            flex: 50,
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                id: "participation.company",
                                value: typeof participation.company === 'string' ? participation.company : participation.company._id,
                                placeholder: "Select Investor",
                                ariaLabel: "Select an Investor for this Participation",
                                updateValue: (company)=>setParticipations(participations.with(i, {
                                        ...participations[i],
                                        company: company
                                    })),
                                options: lenderOptions
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: 40,
                            gap: "6px",
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                        label: "Management Fee",
                                        value: participation.managementFee,
                                        updateValue: (managementFee)=>setParticipations(participations.with(i, {
                                                ...participations[i],
                                                managementFee: (0, $f90d087769f90e7b$export$7e4aa119212bc614)(managementFee) ? parseFloat(managementFee) : 0
                                            })),
                                        type: "number",
                                        min: "0",
                                        percentageMask: true,
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    flex: 1,
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                        label: "Participation %",
                                        value: participation.participationPercentage,
                                        updateValue: (participationPercentage)=>{
                                            setParticipations(participations.with(i, {
                                                ...participations[i],
                                                participationPercentage: (0, $f90d087769f90e7b$export$7e4aa119212bc614)(participationPercentage) ? parseFloat(participationPercentage) : 0
                                            }));
                                        },
                                        type: "number",
                                        min: "0",
                                        percentageMask: true,
                                        required: true
                                    })
                                })
                            ]
                        })
                    ]
                }, participation.company)),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                className: "md-title pad-sides",
                height: rowHeight,
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)("small", {
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                            children: "Total"
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        color: totalParticipation === 1 ? 'green' : totalParticipation > 1 ? 'red' : '#000',
                        children: [
                            totalParticipation * 100,
                            "%"
                        ]
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");





const $5b8ecd84f957630c$export$7281d451a4749566 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const participationStore = (0, $1da4b8b758f1a116$export$57265aab020abcea)();
    /** State **/ const [participations, setParticipations] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (participations) {
            const list = participations.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        participations,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.currentBalance = 0;
        totals.feesDue = 0;
        totals.interestDue = 0;
        const participations = data.map((participation)=>{
            // Calculate totals
            totals.currentBalance += participation.relativeBalance;
            totals.feesDue += participation.loan.feeBalance * participation.participationPercentage;
            totals.interestDue += participation.loan.interestBalance * participation.participationPercentage;
            // Store
            return participation;
        });
        // Save data
        setParticipations(participations);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) participationStore.query(query).then((participations)=>participations && formatData(participations));
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        propName: 'loan.name',
                        label: 'Deal Name'
                    },
                    {
                        propName: 'participationPercentage',
                        label: 'Participation Percentage',
                        textAlign: 'right'
                    },
                    {
                        propName: 'currentBalance',
                        label: 'Current Balance',
                        textAlign: 'right'
                    },
                    {
                        propName: 'feesDue',
                        label: 'Fees Due',
                        textAlign: 'right'
                    },
                    {
                        propName: 'interestDue',
                        label: 'Interest Due',
                        textAlign: 'right'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((participation, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                        padForScrollbar: listData.length > 8,
                        items: [
                            {
                                propName: 'loan.name',
                                content: participation.loan.name,
                                url: `/deals/${participation.loan._id}`
                            },
                            {
                                propName: 'participationPercentage',
                                content: $4bb6caff349888e9$export$626336c2cd4b14de.format(participation.participationPercentage),
                                textAlign: 'right'
                            },
                            {
                                propName: 'currentBalance',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(participation.relativeBalance),
                                textAlign: 'right'
                            },
                            {
                                propName: 'feesDue',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(participation.loan.feeBalance * participation.participationPercentage),
                                textAlign: 'right'
                            },
                            {
                                propName: 'interestDue',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(participation.loan.interestBalance * participation.participationPercentage),
                                textAlign: 'right'
                            }
                        ],
                        rowIndex: i
                    }, `participation-${i}`))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            propName: 'loanName',
                            label: 'Deal Name'
                        },
                        {
                            propName: 'participationPercentage',
                            label: 'Participation Percentage',
                            textAlign: 'right'
                        },
                        {
                            propName: 'currentBalance',
                            label: 'Current Balance',
                            textAlign: 'right'
                        },
                        {
                            propName: 'feesDue',
                            label: 'Fees Due',
                            textAlign: 'right'
                        },
                        {
                            propName: 'interestDue',
                            label: 'Interest Due',
                            textAlign: 'right'
                        }
                    ].map(({ propName: propName, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : typeof totals[propName] === 'number' ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals[propName]) : '',
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "span",
                        children: "No Participations found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");







const $a4de7992bc8a1a37$export$a3eeb7b4564e9c7d = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, query: query })=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const paymentStore = (0, $1da4b8b758f1a116$export$f38831fc90eda5d5)();
    /** State **/ const [payments, setPayments] = (0, $lVd4O.useState)([]);
    const [totals, setTotals] = (0, $lVd4O.useState)({});
    const [resolved, setResolved] = (0, $lVd4O.useState)(false);
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    // View Notes popup shows if `notes` is defined
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const listData = (0, $lVd4O.useMemo)(()=>{
        if (payments) {
            const list = payments.toSorted((a, b)=>a[sortType] > b[sortType] ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        payments,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const formatData = (data)=>{
        // Prepare totals
        const totals = {};
        totals.amount = 0;
        const payments = data.map((payment)=>{
            // Calculate totals
            totals.amount += payment.amount;
            // Store
            return payment;
        });
        // Save data
        setPayments(payments);
        setTotals(totals);
        // Set as resolved
        setResolved(true);
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /**
   * Sets sortType and sortReverse based on given sortType
   * @param type string sortType to use
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (data) formatData(data);
        else if (query && Object.values(query).length) paymentStore.query(query).then((payments)=>formatData(payments ?? []));
    }, [
        data,
        query
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        children: [
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                items: [
                    {
                        flex: 5,
                        propName: 'notes',
                        label: 'Notes'
                    },
                    {
                        propName: 'name',
                        label: 'Name'
                    },
                    {
                        propName: 'amount',
                        label: 'Amount',
                        textAlign: 'right'
                    },
                    {
                        propName: 'datePaid',
                        label: 'Date Paid',
                        textAlign: 'right'
                    },
                    {
                        propName: 'dateDeposited',
                        label: 'Date Deposited',
                        textAlign: 'right'
                    }
                ],
                sortType: sortType,
                sortReverse: sortReverse,
                sortList: sortList
            }),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            resolved && !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "md-content",
                height: listData.length * rowHeight + 'px',
                maxHeight: 9 * rowHeight + 'px',
                children: listData.map((payment, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                        items: [
                            {
                                propName: 'notes',
                                isNotes: true,
                                flex: 5,
                                hide: !payment.notes?.length,
                                showNotesPopup: ()=>showNotesPopup(payment.notes, payment.name)
                            },
                            {
                                propName: 'name',
                                content: payment.name,
                                url: `/payments/${payment._id}`
                            },
                            {
                                propName: 'amount',
                                content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(payment.amount),
                                textAlign: 'right'
                            },
                            {
                                propName: 'datePaid',
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(payment.datePaid).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                                textAlign: 'right'
                            },
                            {
                                propName: 'dateDeposited',
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(payment.dateDeposited).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                                textAlign: 'right'
                            }
                        ],
                        rowIndex: i
                    }, payment._id))
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                sx: {
                    height: rowHeight
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "space-between",
                    alignItems: "center",
                    className: `medium md-subhead-sm text-center ${listData.length > 8 && 'padForScrollbar'}`,
                    children: [
                        {
                            flex: 5,
                            propName: 'notes',
                            label: 'Notes'
                        },
                        {
                            propName: 'name',
                            label: 'Name'
                        },
                        {
                            propName: 'amount',
                            label: 'Amount',
                            textAlign: 'right'
                        },
                        {
                            propName: 'datePaid',
                            label: 'Date Paid',
                            textAlign: 'right'
                        },
                        {
                            propName: 'dateDeposited',
                            label: 'Date Deposited',
                            textAlign: 'right'
                        }
                    ].map(({ propName: propName, ...itemProps }, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $82ed55be55b0d2d3$export$70fd4c70dabf3732), {
                            content: i === 0 ? 'Totals' : totals[propName] ? $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(totals[propName]) : '',
                            ...itemProps
                        }, `${propName}-${i}`))
                })
            }),
            resolved && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "span",
                        children: "No Payments found."
                    })
                })
            }),
            !resolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: "100",
                    justifyContent: "center",
                    alignItems: "center",
                    className: "pad-top-bottom",
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                        className: "md-primary",
                        "md-mode": "indeterminate"
                    })
                })
            }),
            notes && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ca8c088d223abec1$export$7e933156548d708b), {
                notes: notes,
                name: notesName,
                open: !!notes,
                setOpen: (open)=>!open && setNotes(undefined)
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $4HqRp = parcelRequire("4HqRp");







const $d3330c51d9739b57$export$294daaca83af1301 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ loan: loan, showDatePicker: showDatePicker = true, showHeader: showHeader = true, hideErrors: hideErrors = false, numItemsBeforeScroll: numItemsBeforeScroll = 8 })=>{
    const headerHeight = 89;
    const rowHeight = 48;
    const listHeight = headerHeight + rowHeight * numItemsBeforeScroll + 'px';
    /** Context **/ const transactionStore = (0, $1da4b8b758f1a116$export$935e650b2b7e3ea8)();
    const dateStore = (0, $1da4b8b758f1a116$export$3f917fb33f736152)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)('sequenceNumber');
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(false);
    /** Computed **/ const transactions = transactionStore.transactions;
    const totals = transactionStore.totals;
    const dateRange = dateStore.dateRange;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (transactions) {
            const list = transactions.filter((transaction)=>transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment).toSorted((a, b)=>{
                const _a = a[sortType] ?? 0;
                const _b = b[sortType] ?? 0;
                return _a - _b;
            });
            if (sortReverse) list.reverse();
            return list;
        }
    }, [
        transactions,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (loan?._id && dateRange?.start && dateRange?.end) transactionStore.query({
            loanId: loan?._id,
            start: dateRange.start.toISOString(),
            end: dateRange.end.toISOString()
        });
    }, [
        loan?._id,
        dateRange
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
        sx: {
            overflowY: 'auto'
        },
        height: listHeight,
        children: [
            loan && listData && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    showDatePicker && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $0b0ef54190654a4b$export$5109c6dd95d8fb00), {}),
                    showHeader && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                        items: [
                            {
                                flex: 1,
                                propName: '__t',
                                label: 'Type'
                            },
                            {
                                flex: 1,
                                propName: 'effectiveDate',
                                label: 'Effective Date'
                            },
                            {
                                flex: 1,
                                propName: 'advanceAmount',
                                label: 'Advance Amount'
                            },
                            {
                                flex: 1,
                                propName: 'feeTotal',
                                label: 'Fees Charged'
                            },
                            {
                                flex: 1,
                                propName: 'paymentAmount',
                                label: 'Payment Amount'
                            },
                            {
                                flex: 1,
                                propName: 'appliedToFees',
                                label: 'Fees Paid'
                            },
                            {
                                flex: 1,
                                propName: 'appliedToInterest',
                                label: 'Interest Paid'
                            },
                            {
                                flex: 1,
                                propName: 'appliedToPrincipal',
                                label: 'Principal Paid'
                            },
                            {
                                flex: 1,
                                propName: 'newPrincipalBalance',
                                label: 'Principal Balance'
                            }
                        ],
                        sortType: sortType,
                        sortReverse: sortReverse,
                        sortList: sortList
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        children: listData.map((transaction, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                                rowHeight: rowHeight,
                                items: [
                                    {
                                        propName: '__t',
                                        content: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                                            children: [
                                                transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                    component: "span",
                                                    display: "flex",
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                        title: (0, $4HqRp.default)(transaction.__t),
                                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance]
                                                    })
                                                }),
                                                transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                    component: "span",
                                                    display: "flex",
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                        title: (0, $4HqRp.default)(transaction.__t),
                                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment]
                                                    })
                                                }),
                                                transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                    component: "span",
                                                    display: "flex",
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                        title: (0, $4HqRp.default)(transaction.__t),
                                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Statement]
                                                    })
                                                })
                                            ]
                                        })
                                    },
                                    {
                                        propName: 'effectiveDate',
                                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(transaction.effectiveDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                                    },
                                    {
                                        propName: 'advanceAmount',
                                        content: transaction.advanceAmount ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.advanceAmount) : '',
                                        url: `/${transaction.__t}/${transaction._id}`
                                    },
                                    {
                                        propName: 'feeTotal',
                                        content: transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.feeTotal ?? 0) : '',
                                        url: `/${transaction.__t}/${transaction._id}`
                                    },
                                    {
                                        propName: 'paymentAmount',
                                        content: transaction.paymentAmount ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.paymentAmount) : '',
                                        url: `/${transaction.__t}/${transaction._id}`
                                    },
                                    {
                                        propName: 'appliedToFees',
                                        content: transaction?.appliedToFees ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction?.appliedToFees) : ''
                                    },
                                    {
                                        propName: 'appliedToInterest',
                                        content: transaction?.appliedToInterest ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction?.appliedToInterest) : ''
                                    },
                                    {
                                        propName: 'appliedToPrincipal',
                                        content: transaction?.appliedToPrincipal ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction?.appliedToPrincipal) : ''
                                    },
                                    {
                                        propName: 'newPrincipalBalance',
                                        content: transaction?.newPrincipalBalance ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction?.newPrincipalBalance) : ''
                                    }
                                ],
                                rowIndex: i
                            }, transaction._id + '-' + i))
                    })
                ]
            }),
            loan && !!transactions?.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                sx: {
                    fontWeight: 'bold'
                },
                rowHeight: rowHeight,
                items: [
                    {
                        flex: 1,
                        propName: '',
                        content: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                            component: "span",
                            display: "flex",
                            children: "Totals"
                        })
                    },
                    {
                        flex: 1,
                        propName: '',
                        content: ''
                    },
                    {
                        flex: 1,
                        propName: 'totals.advanceAmount',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.advanceAmount ?? 0)
                    },
                    {
                        flex: 1,
                        propName: 'totals.feesCharged',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.feesCharged ?? 0)
                    },
                    {
                        flex: 1,
                        propName: 'totals.paymentAmount',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.paymentAmount ?? 0)
                    },
                    {
                        flex: 1,
                        propName: 'totals.feesPaid',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.feesPaid ?? 0)
                    },
                    {
                        flex: 1,
                        propName: 'totals.interestPaid',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.interestPaid ?? 0)
                    },
                    {
                        flex: 1,
                        propName: 'totals.principalPaid',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.principalPaid ?? 0)
                    },
                    {
                        flex: 1,
                        propName: '',
                        content: ''
                    }
                ],
                rowIndex: transactions.length
            }),
            !loan && !hideErrors && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                "layout-align": "center center",
                className: "md-headline thin pad-top-bottom",
                children: "Please Select a Deal Above."
            }),
            loan && transactions && !transactions.length && !hideErrors && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                "layout-align": "center center",
                className: "md-title thin pad-top-bottom",
                children: "No Transactions Found."
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");





// alias to stop TS errors
const { d3: $593a401d86c3ee39$var$d3 } = window;
const $593a401d86c3ee39$export$94aefc399ef206a9 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ data: data, dateRange: dateRange, categoryNames: categoryNames = [
    'advances',
    'principalPayments',
    'revenue'
], colorRange: colorRange, duration: duration = 500, showTooltip: showTooltip = true, sortReverse: sortReverse, sortValue: sortValue })=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** Refs **/ let element = null;
    const barChart = (0, $lVd4O.useRef)(null);
    const tip = (0, $lVd4O.useRef)(null);
    /** State **/ const [windowWidth, setWindowWidth] = (0, $lVd4O.useState)(window.innerWidth);
    const [categoryFilter, setCategoryFilter] = (0, $lVd4O.useState)('');
    /** Computed **/ const t = (0, $lVd4O.useMemo)(()=>$593a401d86c3ee39$var$d3.transition().duration(duration), [
        duration
    ]);
    const colors = (0, $lVd4O.useMemo)(()=>new (0, $c0d77edc7017bd35$export$cd4efb55feeae0be)(colorRange).colors, [
        colorRange
    ]);
    // Set up data array for the grouped bars
    const chartData = (0, $lVd4O.useMemo)(()=>{
        let y0 = 0;
        // let y1 = 0;
        let arrayData = [];
        // Loop through each month
        data?.forEach(function(d) {
            arrayData = [];
            for(const category in d.items){
                y0 = 0;
                if (d.items[category] && d.items[category].length) {
                    d.items[category] = (0, $8597a53da626d345$export$50499dcf398ab867)(d.items[category], sortValue);
                    if (sortReverse) d.items[category].reverse();
                    for(const item in d.items[category]){
                        d.items[category][item].y0 = y0;
                        d.items[category][item].y1 = y0 += +d.items[category][item].value;
                    }
                }
                arrayData.push(d.items[category]);
            }
            d.arrayData = arrayData;
        });
        return data;
    }, [
        data
    ]);
    /** Methods **/ /***** FILTERS *****/ const filterStacks = (category)=>{
        const chart = barChart.current;
        if (!chart) return;
        // Set up variables
        const newFilter = category || categoryFilter ? `.${category || categoryFilter}` : '';
        // If there are any filters checked...
        if (newFilter) {
            let first = true;
            // Select the old bars
            if (first) {
                chart.oldBars = chart.month.selectAll(`:not(${newFilter})`);
                first = false;
            } else chart.oldBars.selectAll(`:not(${newFilter})`);
            // Select the new bars
            chart.newBars = chart.month.selectAll(newFilter);
        } else {
            chart.oldBars = chart.newBars;
            chart.newBars = chart.month.selectAll('rect');
        }
        // Get max value of stacked bars
        const max = getMaxHeight(categoryFilter);
        // Update Y axis
        chart.y.domain([
            0,
            max
        ]);
        chart.yAxis.scale(chart.y);
        chart.svg.select('.y.axis').remove();
        chart.svg.append('g').attr('class', 'y axis').call(chart.yAxis).append('text').attr('transform', 'rotate(-90)').attr('y', 6).attr('dy', '.71em').attr('class', 'md-caption').style('text-anchor', 'end').text('Amount');
        // Animate old bars out
        if (chart.oldBars?._groups?.length) chart.oldBars.transition(t).attr('height', '0').attr('y', (d)=>chart.y(d.y0));
        // Animate the new bars in
        if (chart.newBars?._groups?.length) chart.newBars.transition(t).attr('height', (d)=>chart.y(d.y0) - chart.y(d.y1)).attr('y', (d)=>chart.y(d.y1));
    };
    const drawLegend = ()=>{
        const chart = barChart.current;
        chart.legend = chart.svg.selectAll('.legend').data(categoryNames.slice()).enter().append('g').attr('class', 'legend').attr('transform', (_, i)=>'translate(0,' + i * 25 + ')');
        let yLegend = -10;
        chart.legend.append('rect').attr('class', (d)=>d).attr('x', chart.width - 25).attr('y', ()=>{
            yLegend += 10;
            return yLegend;
        }).attr('width', 30).attr('height', 30).style('fill', (d)=>colorRange[d][0]).on('mouseover', (d)=>$593a401d86c3ee39$var$d3.selectAll('.' + d).style('opacity', '0.9')).on('mouseleave', (d)=>$593a401d86c3ee39$var$d3.selectAll('.' + d).style('opacity', '1')).on('click', (d)=>{
            // setFilters({ ...filters, category: categoryFilter === d ? '' : d });
            setCategoryFilter(categoryFilter === d ? '' : d);
            filterStacks(categoryFilter === d ? '' : d);
            drawLegend();
        });
        yLegend = 5;
        chart.legend.append('text').attr('x', chart.width - 31).attr('y', ()=>{
            yLegend += 10;
            return yLegend;
        }).attr('dy', '.35em').attr('class', (d)=>categoryFilter === d ? 'legend-title medium' : 'legend-title thin').style('text-anchor', 'end').text((d)=>d === 'revenue' ? userStore.isAdmin || userStore.isLender ? 'Revenue' : 'Costs' : (0, $8597a53da626d345$export$c8d7cffe57163567)(d)).on('click', (d)=>{
            // setFilters({ ...filters, category: categoryFilter === d ? '' : d });
            setCategoryFilter(categoryFilter === d ? '' : d);
            filterStacks(categoryFilter === d ? '' : d);
            drawLegend();
        });
        barChart.current = chart;
    };
    const drawBars = ()=>{
        const chart = barChart.current;
        chart.month = chart.svg.append('g').selectAll('g').data(data).enter().append('g').attr('class', (d)=>{
            const groupMonth = new Date(d.month).getMonth();
            return 'g month ' + (0, $50c68e19ba8e5079$export$2e59fa295abca125)[groupMonth].toLowerCase();
        }).attr('transform', (d)=>{
            const items = Object.values(d.items);
            let offset = chart.xGroupBand;
            const count = items.length;
            const barWidth = count * chart.xGroupBand;
            if (count > 1) offset = barWidth / 2;
            return 'translate(' + (chart.margins.xAxis + chart.xScale(d.month) - offset) + ', 0)';
        });
        chart.stack = chart.month.selectAll('g')// Begin sorting by categories
        .data((d)=>d.arrayData).enter().append('g').attr('class', (d)=>{
            // console.log('[drawBars] sorting datum: %O', d);
            if (d.length) return 'g category ' + d[0].category;
        }).selectAll('rect')// Then sort by company
        .data((d)=>d).enter().append('rect').attr('class', (d)=>`${d.category} ${(0, $8597a53da626d345$export$86f54f62aa7a7514)(d.company)} ${(0, $8597a53da626d345$export$86f54f62aa7a7514)(d.loan)} ${d.lenders.map((lender)=>(0, $8597a53da626d345$export$86f54f62aa7a7514)(lender)).join(' ')}`.trimEnd()).attr('width', chart.xGroupBand).attr('x', (d)=>chart.x1(d.category)).attr('height', (d)=>{
            const barHeight = chart.y(d.y0) - chart.y(d.y1);
            return barHeight < 0 ? 0 : barHeight;
        }).attr('y', (d)=>chart.y(d.y1)).style('fill', (d)=>colors[d.category](d.company)).style('cursor', 'pointer').on('mouseover', (d)=>{
            if (showTooltip) tip.current.style('opacity', 1).html(`<md-card class="d3-tooltip" layout="column" layout-padding layout-align="center center" style="background: #FFF;">
                  <span flex class="medium" style="border-bottom: 1px solid #000;">${d.company}</span>
                  <span flex>${(0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(d.value)}</span>
                </md-card>`).style('left', $593a401d86c3ee39$var$d3.event.pageX + 'px').style('top', $593a401d86c3ee39$var$d3.event.pageY + 'px');
        }).on('mouseleave', ()=>{
            tip.current.style('opacity', 0);
        });
        barChart.current = chart;
    };
    /***** DRAW CHART *****/ const drawChart = (element, data)=>{
        if (!element || !data) return;
        $593a401d86c3ee39$var$d3.select(element).selectAll('*').remove();
        // Create chart object
        // const chart: Record<string, any> = {};
        const chart = {};
        // Define SVG dimensions
        chart.margins = {
            top: 20,
            right: 70,
            bottom: 50,
            left: 50,
            xAxis: 75
        };
        chart.width = (0, $8597a53da626d345$export$3c49c185de0c2bfc)(element);
        if (chart.width) chart.width = chart.width - chart.margins.left - chart.margins.right;
        chart.height = 472.5 - chart.margins.top - chart.margins.bottom;
        // Create SVG
        chart.svg = $593a401d86c3ee39$var$d3.select(element).append('svg').attr('class', 'totalBarChart-svg').attr('width', chart.width + chart.margins.left + chart.margins.right).attr('height', chart.height + chart.margins.top + chart.margins.bottom).append('g').attr('transform', 'translate(' + chart.margins.left + ',' + chart.margins.top + ')');
        // chart.svg.call(tip.current).call(totalTip.current);
        // Month Axis (x)
        chart.xScale = $593a401d86c3ee39$var$d3.scaleTime().range([
            0,
            chart.width
        ]).domain([
            dateRange.start,
            dateRange.end
        ]);
        chart.xAxis = $593a401d86c3ee39$var$d3.axisBottom(chart.xScale).ticks(12).tickFormat($593a401d86c3ee39$var$d3.timeFormat('%b'));
        chart.svg.append('g').attr('class', 'x axis').attr('transform', 'translate(' + chart.margins.xAxis + ',' + (chart.height + 6) + ')').call(chart.xAxis);
        // Groups Axis (x)
        chart.xGroupBand = (0, $8597a53da626d345$export$55382f732810ce34)(chart.width, 40);
        chart.x1 = $593a401d86c3ee39$var$d3.scaleBand().domain(categoryNames).range([
            0,
            chart.xGroupBand * 3
        ]);
        // Amount Axis (y)
        chart.y = $593a401d86c3ee39$var$d3.scaleLinear().rangeRound([
            chart.height,
            0
        ]);
        chart.y.domain([
            0,
            $593a401d86c3ee39$var$d3.max(data, function(d) {
                return d.total;
            })
        ]);
        // y1 = d3.scaleLinear().rangeRound([chart.height, 0]);
        chart.y.domain([
            0,
            getMaxHeight()
        ]);
        chart.yAxis = $593a401d86c3ee39$var$d3.axisLeft(chart.y).tickFormat($593a401d86c3ee39$var$d3.format('.2s'));
        chart.svg.append('g').attr('class', 'y axis').call(chart.yAxis).append('text').attr('transform', 'rotate(-90)').attr('y', 6).attr('dy', '.71em').attr('class', 'md-caption').style('text-anchor', 'end').text('Amount');
        barChart.current = chart;
        /***** LEGEND *****/ drawLegend();
        /***** DRAW BARS *****/ drawBars();
        /***** FILTER STACKS *****/ filterStacks();
    };
    /**
     * Calculate max bar height
     */ const getMaxHeight = function(filter) {
        const response = [];
        data.forEach(function(d) {
            for(const category in d)if (d[category]) {
                for(const name in categoryNames)if (category === categoryNames[name]) {
                    if (filter) {
                        if (category === filter) response.push(d[category]);
                    } else response.push(d[category]);
                }
            }
        });
        return $593a401d86c3ee39$var$d3.max(response);
    };
    const createTip = ()=>{
        // tip.current = d3Tip()
        tip.current = $593a401d86c3ee39$var$d3.select('body').append('div').attr('class', 'd3-tooltip').style('opacity', 0).style('position', 'absolute').style('pointer-events', 'none');
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        window.onresize = ()=>setWindowWidth(window.innerWidth);
        createTip();
        return ()=>{
            window.onresize = null;
            $593a401d86c3ee39$var$d3.select(element).selectAll('*').remove();
        };
    }, []);
    (0, $lVd4O.useEffect)(()=>{
        if (element && chartData) drawChart(element, chartData);
    }, [
        element,
        chartData,
        windowWidth
    ]);
    // need one just for category filters, because we're not going to redraw the whole chart
    (0, $lVd4O.useEffect)(()=>{
        if (element && chartData) drawChart(element, chartData);
    }, [
        categoryFilter
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        justifyContent: "center",
        alignItems: "center",
        className: "pad-top-bottom",
        display: "flex",
        flex: 1,
        children: /*#__PURE__*/ (0, $iO5o7.jsx)("div", {
            ref: (node)=>{
                if (!element) element = node;
            },
            id: "total-bar-chart-container",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary"
            })
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");





const $6de737cc2e500997$export$45b7a635e7285757 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    /** State **/ const [isResolved, setIsResolved] = (0, $lVd4O.useState)(false);
    const [balances, setBalances] = (0, $lVd4O.useState)();
    const [costs, setCosts] = (0, $lVd4O.useState)();
    const [assets, setAssets] = (0, $lVd4O.useState)();
    const [advances, setAdvances] = (0, $lVd4O.useState)();
    /** Computed **/ const hasData = !!balances?.length || !!costs?.length || !!assets?.length || !!advances?.length;
    /** Methods **/ /**
   * Gets loan balances info
   */ const getBalances = async (query)=>{
        setBalances(await (0, $78334dc192bf113d$export$4ae0a19c5571ff34).get(query));
    };
    /**
   * Gets revenue/costs info
   */ const getCosts = async (query)=>{
        setCosts(await (0, $95921c948e1c414c$export$6afbdc6ae408984b).get(query));
    };
    /**
   * Gets assets infoe}
   */ const getAssets = async (query)=>{
        setAssets(await (0, $78de0e464a7e5887$export$732ba14786ab16c9).get(query));
    };
    /**
   * Gets advances/cash flow info
   */ const getAdvances = async (query)=>{
        setAdvances(await (0, $64b06aa07d3fa40d$export$953265e3a561b3f2).get(query));
    };
    /**
   * @name activateController()
   * @desc Performs any necessary init tasks
   */ // const activateController = () => {};
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        const query = {};
        if (filterStore.lenderGet()) query.lenderId = filterStore.lenderGet()?._id;
        const fetchData = async ()=>{
            setIsResolved(false);
            await Promise.all([
                getBalances(query),
                getCosts(query),
                getAssets(query),
                getAdvances(query)
            ]);
            setIsResolved(true);
        };
        fetchData();
    }, [
        filterStore._lenderFilterId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
        component: "md-card",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                className: "toolbar-div",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                    className: "thin md-title",
                    children: "Company Totals"
                })
            }),
            hasData && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                bgcolor: "white",
                className: "pad-top-bottom-xs",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92ddc2267dfcd1d4$export$b99d3348f709c998), {
                        chartType: "donut",
                        chartTitle: "balances",
                        chartData: balances,
                        hoverText: "company",
                        hoverValue: "amount",
                        showText: true,
                        sortBy: "amount"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92ddc2267dfcd1d4$export$b99d3348f709c998), {
                        chartType: "donut",
                        chartTitle: "revenue",
                        chartData: costs,
                        hoverText: "company",
                        hoverValue: "amount",
                        showText: true,
                        sortBy: "amount"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92ddc2267dfcd1d4$export$b99d3348f709c998), {
                        chartType: "donut",
                        chartTitle: "assets",
                        chartData: assets,
                        hoverText: "company",
                        hoverValue: "amount",
                        showText: true,
                        sortBy: "amount"
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92ddc2267dfcd1d4$export$b99d3348f709c998), {
                        chartType: "donut",
                        chartTitle: "advances",
                        chartData: advances,
                        hoverText: "company",
                        hoverValue: "amount",
                        showText: true,
                        sortBy: "amount"
                    })
                ]
            }),
            isResolved && !hasData && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "row",
                justifyContent: "center",
                alignItems: "center",
                className: "md-headline thin pad-top-bottom",
                children: "No Companies Found."
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");





const $4d95fff15b40455d$export$79e57034ed04ee78 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ company: company, loan: loan, lender: lender })=>{
    /** Computed **/ const headlinesStore = (0, $1da4b8b758f1a116$export$8642d496b95aa4e9)();
    /** Computed **/ const headlines = headlinesStore.headlines;
    /** Methods **/ /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        const query = {};
        if (loan) {
            query.companyId = loan.borrower?._id;
            query.loanId = loan._id;
        } else if (company) query.companyId = company._id;
        else if (lender) query.lenderId = lender._id;
        headlinesStore.get(query);
    }, [
        company,
        loan,
        lender
    ]);
    /** Render **/ const HeadlineItem = ({ label: label, value: value })=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
            sx: {
                display: 'flex',
                flexDirection: 'column'
            },
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                    sx: {
                        flex: 1
                    },
                    component: "span",
                    className: "medium text-left-sm",
                    children: label
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                    sx: {
                        flex: 1
                    },
                    component: "span",
                    className: "thin md-headline text-right-sm",
                    children: value
                })
            ]
        });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a5f98fb65ea8145d$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            flex: 1
        },
        className: "md-subhead text-center",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)(HeadlineItem, {
                label: "Asset Value",
                value: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.assetValue || 0)
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)(HeadlineItem, {
                label: "Principal Balance",
                value: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.principalBalance || 0)
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)(HeadlineItem, {
                label: "Fees Due",
                value: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.feesDue || 0)
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)(HeadlineItem, {
                label: "Interest Due",
                value: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.interestDue || 0)
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)(HeadlineItem, {
                label: "Available Credit",
                value: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.availableCredit || 0)
            })
        ]
    });
});


/* eslint-disable react/no-unknown-property */ 
var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");








const $90b55d3d3a306eb6$export$12829f7d8872d6be = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ companyFilter: companyFilter, loanFilter: loanFilter, lenderFilter: lenderFilter })=>{
    /** Context **/ const dateStore = (0, $1da4b8b758f1a116$export$3f917fb33f736152)();
    /** Refs **/ const chartColors = {
        advances: [
            '#316399',
            '#5C6BC0',
            '#7986CB',
            '#9FA8DA',
            '#C5CAE9'
        ],
        revenue: [
            '#EAAD47',
            '#FFCA28',
            '#FFD54F',
            '#FFE082',
            '#FFECB3'
        ],
        principalPayments: [
            '#4CAF50',
            '#66BB6A',
            '#81C784',
            '#A5D6A7',
            '#C8E6C9'
        ]
    };
    /** State **/ const [monthlyActivity, setMonthlyActivity] = (0, $lVd4O.useState)([]);
    const [isResolved, setIsResolved] = (0, $lVd4O.useState)(false);
    /** Computed **/ const lastYear = true;
    const nextYear = true;
    const filters = {
        companyId: companyFilter?._id,
        loanId: loanFilter?._id,
        lenderId: lenderFilter?._id,
        category: undefined
    };
    const dateRange = (0, $lVd4O.useMemo)(()=>({
            start: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(dateStore.dateRange?.start).startOf('year').toDate(),
            end: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(dateStore.dateRange?.end).endOf('year').toDate()
        }), [
        dateStore.dateRange
    ]);
    const currentDate = dateStore.currentDate;
    /** Methods **/ // Goes forward/back a block of time
    const changeDate = (modifier)=>{
        if (!modifier) return;
        dateStore.setRangeType((0, $dff1c8c0bf270f18$export$d0d7df129860d081).Yearly);
        dateStore.modifyCurrentDate(modifier);
        dateStore.calculateRange();
    };
    // Main data getting function
    const fetchData = async ()=>{
        try {
            const query = {
                ...filters,
                start: dateRange.start.toISOString(),
                end: dateRange.end.toISOString()
            };
            const data = await (0, $a06e9f24104da8b2$export$b892c6de60948fe9).get(query);
            setMonthlyActivity(data);
            setIsResolved(true);
        } catch (err) {
            console.error(err);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        fetchData();
    }, [
        dateRange,
        companyFilter,
        loanFilter,
        lenderFilter
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)("section", {
        "ng-controller": "MonthlyActivityController",
        id: "totalBarChart",
        "ng-init": "monthlyActivityInit()",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                "layout-gt-sm": "row",
                "layout-sm": "column",
                "layout-align": "center center",
                "ng-if": "isResolved",
                marginTop: "6px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        sx: {
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        "layout-sm": "row",
                        "layout-align-sm": "center center",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                className: "md-icon-button",
                                onClick: ()=>changeDate(-1),
                                disabled: !lastYear,
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d22848c8528cbdab$export$2e2bcd8739ae039), {
                                    className: "md-icons material-icons"
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                component: "span",
                                className: "thin textZoomIn center",
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(dateRange?.start ? dateRange.start : currentDate).format('YYYY')
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                className: "md-icon-button",
                                onClick: ()=>changeDate(1),
                                disabled: !nextYear,
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f9e94eabcee6b832$export$2e2bcd8739ae039), {
                                    className: "md-icons material-icons"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        component: "span",
                        sx: {
                            flex: 1
                        }
                    })
                ]
            }),
            isResolved && !!monthlyActivity.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $593a401d86c3ee39$export$94aefc399ef206a9), {
                    data: monthlyActivity,
                    dateRange: dateRange,
                    colorRange: chartColors,
                    sortReverse: true,
                    sortValue: "value"
                })
            }),
            isResolved && !monthlyActivity.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                "ng-if": "isResolved && !monthlyActivity.length",
                layout: "row",
                "layout-align": "center center",
                className: "md-headline thin pad-top-bottom",
                children: "No Activity Found."
            }),
            !isResolved && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                layout: "column",
                "layout-align": "center center",
                className: "pad-top-bottom",
                sx: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                    className: "md-primary"
                })
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");






const $92ddc2267dfcd1d4$export$b99d3348f709c998 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ chartType: chartType = 'donut', chartTitle: chartTitle = '', chartData: rawData, hoverText: hoverText = '', hoverValue: hoverValue = '', showText: showText = true, showHover: showHover = true, sortBy: sortBy })=>{
    /** Context **/ const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    /** Refs **/ // let element: Nullable<HTMLDivElement> = null;
    const element = (0, $lVd4O.useRef)(null);
    /** State **/ const [isReady, setIsReady] = (0, $lVd4O.useState)(false);
    const [, setNoData] = (0, $lVd4O.useState)();
    /** Computed **/ const chartData = (0, $lVd4O.useMemo)(()=>{
        let total = 0;
        const preparedData = [];
        // Calculate totals
        for (const item of rawData ?? [])if (item[hoverValue] === 0) setNoData(true);
        else {
            // Add to total
            total += item[hoverValue];
            // Format for display
            item.display = {};
            item.display[hoverValue] = (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(item[hoverValue]);
            // Assign the given chart title
            item.chartTitle = chartTitle;
            // Finished preparing
            preparedData.push(item);
        }
        // Sort data
        if (sortBy) preparedData.sort((a, b)=>a[sortBy] - b[sortBy]);
        // Make chart draw clockwise
        preparedData.reverse();
        return {
            preparedData: preparedData,
            total: total
        };
    }, [
        rawData,
        hoverValue,
        chartTitle
    ]);
    const colorLibrary = (0, $lVd4O.useMemo)(()=>{
        const parser = $208581d375ac7212$export$2e2bcd8739ae039().range((0, $5b108f16e2d84dda$export$569885e57444f84a));
        const colorLibrary = [];
        for (const item of filterStore.companyListGet())colorLibrary.push({
            name: item.name,
            color: parser(item.name)
        });
        return colorLibrary;
    }, [
        (0, $5b108f16e2d84dda$export$569885e57444f84a),
        filterStore._companyList
    ]);
    /** Methods **/ /**
     * Gets an element's width
     */ const getWidth = (element)=>{
        if (!element) return;
        if (isNaN(parseInt($9dc0bf83babef520$export$2e2bcd8739ae039(element).style('width'), 10))) return element.offsetWidth;
        else return parseInt($9dc0bf83babef520$export$2e2bcd8739ae039(element).style('width'), 10);
    };
    /**
     * Creates the pie chart SVG
     */ const drawChart = (element, data)=>{
        if (!element || !data) return;
        setIsReady(false);
        const drawLabel = (label = chartTitle, value = (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(data.total))=>{
            // if (!chart) return;
            // Remove any existing text or dividers
            chart.g.selectAll('text').remove();
            chart.g.selectAll('line').remove();
            // Draw text
            chart.g.append('text').attr('transform', 'translate(0, -20)').attr('dy', '0.35em').style('text-anchor', 'middle').attr('class', 'thin md-title capitalize').text(label);
            // Draw divider
            chart.g.append('line').attr('x1', '-60').attr('x2', '60').attr('y1', '0').attr('y2', '0').attr('stroke', 'black').attr('stroke-width', '1');
            // Draw value
            chart.g.append('text').attr('transform', 'translate(0, 20)').attr('dy', '0.35em').style('text-anchor', 'middle').attr('class', 'md-title').text(value);
        };
        // Create chart object
        const chart = {};
        // Define SVG dimensions
        chart.margins = {
            top: 30,
            right: 10,
            bottom: 30,
            left: 10
        };
        chart.width = getWidth(element);
        chart.height = chart.width;
        chart.radius = Math.min(chart.width, chart.height) / 2;
        // Clear existing SVG
        $9dc0bf83babef520$export$2e2bcd8739ae039(element).selectAll('svg').remove();
        // Create SVG
        chart.svg = $9dc0bf83babef520$export$2e2bcd8739ae039(element).append('svg').attr('width', '100%').attr('height', '100%').attr('viewBox', '0 0 ' + Math.min(chart.width, chart.height) + ' ' + Math.min(chart.width, chart.height)).attr('preserveAspectRatio', 'xMinYMin')// .attr('ng-if', isReady)
        .append('g').attr('transform', 'translate(' + chart.width / 2 + ',' + chart.height / 2 + ')');
        // Create circle scale
        chart.arc = $6c9cc02c644d9182$export$2e2bcd8739ae039().outerRadius(chart.radius - 10);
        if (chartType === 'donut') chart.arc.innerRadius(chart.radius - 50);
        else chart.arc.innerRadius(0);
        // Create the pie slice scale
        chart.pie = $d7ffe41a484e323b$export$2e2bcd8739ae039().sort(null).value((d)=>d[hoverValue]);
        // Draw a circle where the pie chart will be
        chart.g = chart.svg.selectAll('.arc').data(()=>chart.pie(data.preparedData)).enter().append('g').attr('class', 'arc');
        // Fill in the slices
        chart.g.append('path').attr('d', (d)=>{
            if (!d.endAngle) d.endAngle = 0;
            return chart.arc(d);
        }).style('fill', (d)=>{
            for (const paletteItem of colorLibrary){
                if (paletteItem.name === d.data[hoverText]) return paletteItem.color;
            }
        }).on('mouseover', (d)=>showHover && drawLabel(d.data[hoverText], d.data.display[hoverValue])).on('mouseleave', ()=>showText && drawLabel());
        drawLabel();
        setIsReady(true);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        return ()=>$9dc0bf83babef520$export$2e2bcd8739ae039(element.current).selectAll('*').remove();
    }, []);
    (0, $lVd4O.useEffect)(()=>{
        if (element.current && chartData) drawChart(element.current, chartData);
    }, [
        element.current,
        chartData,
        hoverText,
        hoverValue
    ]);
    /**** Render ****/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        children: [
            !isReady && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary"
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)("div", {
                ref: (node)=>{
                    element.current = node;
                },
                id: "chart-container",
                style: !isReady ? {
                    display: 'none'
                } : undefined
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $5c38b2bc113b1f46$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');








const $249095e73b622ebe$export$eb40a627c5a27f38 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const alertStore = (0, $1da4b8b758f1a116$export$c345cf07ab3c1b9e)();
    /** State **/ const [anchorEl, setAnchorEl] = (0, $lVd4O.useState)(null);
    /** Computed **/ const open = !!anchorEl;
    const alerts = (0, $lVd4O.useMemo)(()=>alertStore.alerts?.toSorted((a, b)=>(0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(b.created).isAfter(a.created) ? 1 : -1).slice(0, 10), [
        alertStore.alerts
    ]);
    const alertCount = (0, $lVd4O.useMemo)(()=>alertStore.newAlertCount, [
        alertStore.newAlertCount
    ]);
    /** Methods **/ const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
        alertStore.markAsRead();
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a5f98fb65ea8145d$export$2e2bcd8739ae039), {
        component: "ul",
        className: "float-right",
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                    component: "a",
                    id: "alerts-button",
                    "aria-label": "Alerts",
                    "aria-controls": open ? 'basic-menu' : undefined,
                    "aria-haspopup": "true",
                    "aria-expanded": open ? 'true' : undefined,
                    onClick: handleClick,
                    "layout-align": "center center",
                    lineHeight: "64px",
                    height: "64px",
                    className: "pad-sides",
                    children: [
                        !!alertCount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7e78168726444854$export$2e2bcd8739ae039), {
                            className: "md-icon material-icons pad-right-xs"
                        }),
                        !alertCount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5c38b2bc113b1f46$export$2e2bcd8739ae039), {
                            className: "md-icon material-icons"
                        }),
                        !!alertCount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                            className: "alert-badge new",
                            "layout-align": "center center",
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                component: "span",
                                className: "medium",
                                children: alertCount
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $92c0bcdb3f8e13cc$export$2e2bcd8739ae039), {
                    className: "md-menu",
                    anchorEl: anchorEl,
                    open: open,
                    onClose: handleClose,
                    slotProps: {
                        list: {
                            'aria-labelledby': 'alerts-button'
                        }
                    },
                    "md-position-mode": "target-left target",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                            className: 'md-menu-content[width="4"]',
                            children: alerts?.map((alert)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $6f9a4b79561b13db$export$2e2bcd8739ae039), {
                                    className: "alerts-menu-item",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                        className: "md-button md-default-theme",
                                        to: `/${alert.source?.__t}/${alert.source?._id}`,
                                        "aria-label": alert.name,
                                        children: [
                                            (alert.source?.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment.toLocaleLowerCase() || alert.source?.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance.toLocaleLowerCase()) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                "layout-align": "start center"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                children: alert.message
                                            })
                                        ]
                                    })
                                }, alert._id))
                        }),
                        !!alerts?.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6f9a4b79561b13db$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                sx: {
                                    flex: 1
                                },
                                "layout-align": "center center",
                                children: [
                                    !!alerts?.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                        to: "/alerts",
                                        className: "pad-top-bottom",
                                        children: "View All Alerts..."
                                    }),
                                    !alerts?.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        children: "No Alerts Found."
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
});


/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 
var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $1cd17324922a34d3$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');






const $1611cc39e0827699$export$b04dd99d751ebb47 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).useState(null);
    const open = Boolean(anchorEl);
    /** Methods **/ const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const signout = async ()=>{
        await userStore.signout();
        navigate('/signin');
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7719e8ad46b49834$export$54c2e3dc7acea9f5), {
        component: "ul",
        className: "float-right",
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsxs)("a", {
                    id: "profile-button",
                    "aria-label": "Options Menu",
                    "aria-controls": open ? 'basic-menu' : undefined,
                    "aria-haspopup": "true",
                    "aria-expanded": open ? 'true' : undefined,
                    onClick: handleClick,
                    style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                            component: "span",
                            className: "pad-right-xs",
                            children: userStore.user?.displayName
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1cd17324922a34d3$export$2e2bcd8739ae039), {
                            className: "material-icons"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $92c0bcdb3f8e13cc$export$2e2bcd8739ae039), {
                    className: "md-menu",
                    anchorEl: anchorEl,
                    open: open,
                    onClose: handleClose,
                    slotProps: {
                        list: {
                            'aria-labelledby': 'profile-button'
                        }
                    },
                    "md-position-mode": "target-right target",
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                        className: 'md-menu-content[width="4"] md-default-theme',
                        children: [
                            userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3cac63400060a6b9$export$2ce376c2cc3355c8), {
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                            className: "md-button md-default-theme",
                                            onClick: ()=>navigate('/bulk'),
                                            "aria-label": "Import/Export Data",
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                children: "Import/Export"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3cac63400060a6b9$export$2ce376c2cc3355c8), {
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                            className: "md-button md-default-theme",
                                            onClick: ()=>navigate('/users'),
                                            "aria-label": "User Administration",
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                children: "User Administration"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3cac63400060a6b9$export$2ce376c2cc3355c8), {
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                    className: "md-button md-default-theme",
                                    onClick: ()=>navigate('/settings/profile'),
                                    "aria-label": "Edit Profile",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        component: "span",
                                        children: "Edit Profile"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3cac63400060a6b9$export$2ce376c2cc3355c8), {
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                    className: "md-button md-default-theme",
                                    onClick: ()=>navigate('/settings/password'),
                                    "aria-label": "Change Password",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        component: "span",
                                        children: "Change Password"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3cac63400060a6b9$export$2ce376c2cc3355c8), {
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                    className: "md-button md-default-theme",
                                    onClick: ()=>signout(),
                                    "aria-label": "Sign Out",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        component: "span",
                                        children: "Sign Out"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



const $4f6acc6ac54387d2$export$8ef2ed426dede42d = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(({ children: children, redirectUrl: redirectUrl = '/signin' })=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!userStore.user) navigate(redirectUrl);
    }, [
        userStore.user
    ]);
    return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
        children: children
    });
});






var $iO5o7 = parcelRequire("iO5o7");



var $iO5o7 = parcelRequire("iO5o7");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $7981c36822c6d83d$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');




const $94f7e3de1e13b616$export$a65c2c055de52e1d = ()=>{
    /** Context **/ const location = (0, $a648eab72417989b$export$45d76561a5302f2b)();
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                component: "md-card",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        className: "toolbar-div",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "6px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7981c36822c6d83d$export$2e2bcd8739ae039), {
                                className: "material-icons md-icon"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                className: "thin md-display-1",
                                children: "Page Not Found"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: 'white'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsxs)("pre", {
                            children: [
                                location.pathname,
                                " is not a valid path."
                            ]
                        })
                    })
                ]
            })
        })
    });
};



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $37b1b22a08b845d1$export$c1270cb4dd5ae4e3 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const adjustmentStore = (0, $1da4b8b758f1a116$export$8808bffeb1795f83)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)({
        effectiveDate: '',
        name: '',
        amount: '',
        notes: [],
        files: []
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const projectedAssetValue = formValues.asset && formValues.amount ? formValues.asset.value + parseFloat(formValues.amount ?? '0') : formValues.asset?.value ?? 0;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet(), [
        filterStore._loanList
    ]);
    const filteredLoans = (0, $lVd4O.useMemo)(()=>{
        return formValues.company?._id ? loans.filter((loan)=>loan.assets.length && loan.borrower._id === formValues.company?._id) : [];
    }, [
        loans,
        formValues.company
    ]);
    const filteredAssets = formValues.loan ? formValues.loan.assets.toSorted((a, b)=>a.name.localeCompare(b.name)) : [];
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            setFormValues((prev)=>{
                const updates = {
                    [key]: value
                };
                // Clear dependent fields
                if (key === 'company') {
                    updates.loan = undefined;
                    updates.asset = undefined;
                    updates.amount = undefined;
                } else if (key === 'loan') {
                    updates.asset = undefined;
                    updates.amount = undefined;
                } else if (key === 'asset') // Reset amount when asset changes to avoid invalid calculations
                updates.amount = undefined;
                return {
                    ...prev,
                    ...updates
                };
            });
            // Clear error when field is updated
            if (formErrors[key]) setFormErrors((prev)=>({
                    ...prev,
                    [key]: ''
                }));
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues.company) errors.company = 'Company is required';
        if (!formValues.loan) errors.loan = 'Loan is required';
        if (!formValues.asset) errors.asset = 'Asset is required';
        if (!formValues.name) errors.name = 'Name is required';
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues.amount)) errors.amount = 'Valid amount is required';
        if (!formValues.effectiveDate) errors.effectiveDate = 'Date is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Creates an Adjustment.
   *
   * @remarks
   * Redirects to the new Adjustment's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first.');
            return;
        }
        try {
            const response = await adjustmentStore.create(formValues);
            if (!response) throw new Error(`Could not create Adjustment with data: ${JSON.stringify(formValues)}`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createAdjustment.success);
            navigate(`/adjustments/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createAdjustment.error);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment,
        onCreate: create,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                value: formValues.company?._id ?? '',
                setValue: (companyId)=>updateFormValue('company')(companies.find((company)=>company._id === companyId)),
                companies: companies.filter((company)=>company.loans?.length),
                error: formErrors.company
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                value: formValues.loan?._id ?? '',
                setValue: (loanId)=>updateFormValue('loan')(filteredLoans.find((loan)=>loan._id === loanId)),
                loans: filteredLoans,
                error: formErrors.loan
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41af608264f61f27$export$1288c65e1f92c76b), {
                value: formValues.asset?._id ?? '',
                setValue: (assetId)=>updateFormValue('asset')(filteredAssets.find((asset)=>asset._id === assetId)),
                assets: filteredAssets,
                error: formErrors.asset
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "amount",
                label: "Adjustment Amount",
                value: formValues.amount,
                updateValue: updateFormValue('amount'),
                type: "number",
                moneyMask: true,
                negativeNumber: true,
                required: true,
                error: formErrors.amount
            }),
            formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        flex: 50,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        fontSize: "1.2em",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                paddingBottom: "6px",
                                marginBottom: "6px",
                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                className: "thin",
                                children: "Current Asset Value"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                id: "value",
                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues.asset.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        flex: 50,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        fontSize: "1.2em",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                paddingBottom: "6px",
                                marginBottom: "6px",
                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                className: "thin",
                                children: "Asset Value After Adjustment"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                id: "projectedValue",
                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(projectedAssetValue)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Adjustment Name",
                value: formValues.name,
                updateValue: updateFormValue('name'),
                required: true,
                error: formErrors.name
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Adjustment Date",
                value: formValues.effectiveDate,
                updateValue: updateFormValue('effectiveDate'),
                type: "date",
                required: true,
                error: formErrors.effectiveDate
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $e9f557d4087bbf14$export$4f8128a63ac4e86e = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const adjustmentStore = (0, $1da4b8b758f1a116$export$8808bffeb1795f83)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Computed **/ const assets = (0, $lVd4O.useMemo)(()=>assetStore.assets?.filter((asset)=>asset.company?._id === formValues?.company).sort((a, b)=>a.name.localeCompare(b.name)) ?? [], [
        assetStore.assets,
        formValues?.company
    ]);
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet().filter((company)=>!!company.loans?.length), [
        filterStore._companyList
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet().filter((loan)=>loan.assets.length && loan.borrower._id === formValues?.company), [
        filterStore._loanList,
        formValues?.company
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues?.company) errors.company = 'Company is required';
        if (!formValues?.loan) errors.loan = 'Loan is required';
        if (!formValues?.asset) errors.asset = 'Asset is required';
        if (!formValues?.name) errors.name = 'Name is required';
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.amount)) errors.amount = 'Valid amount is required';
        if (!formValues?.effectiveDate) errors.effectiveDate = 'Date is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the Adjustment.
   *
   * @remarks
   * Redirects to the Adjustment's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await adjustmentStore.update(formValues);
            if (!response) throw new Error(`Could not update Adjustment with ID "${formValues._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateAdjustment.success);
            navigate(`/adjustments/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateAdjustment.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!formValues) return;
        await adjustmentStore.update({
            ...formValues,
            notes: notes
        });
        updateFormValue('notes')(notes);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!formValues) return;
        await adjustmentStore.update({
            ...formValues,
            files: files
        });
        updateFormValue('files')(files);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.adjustmentId) return;
        Promise.all([
            adjustmentStore.get(params.adjustmentId),
            assetStore.query()
        ]);
    }, [
        params.adjustmentId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (adjustmentStore.currentAdjustment) setFormValues(adjustmentStore.currentAdjustment);
    }, [
        adjustmentStore.currentAdjustment
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: adjustmentStore.currentAdjustment?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment,
        editVerb: "Edit",
        onEdit: update,
        sidebarFlex: "35",
        contentFlex: "65",
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        noteOptions: {
            notes: formValues?.notes ?? [],
            onChange: updateNotes
        },
        documentOptions: {
            files: formValues?.files ?? [],
            onChange: updateFiles
        },
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                value: formValues?.company ?? '',
                setValue: (companyId)=>updateFormValue('company')(companies.find((company)=>company._id === companyId)),
                companies: companies,
                disabled: true,
                error: formErrors.company
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                value: formValues?.loan?._id ?? '',
                setValue: (loanId)=>updateFormValue('loan')(loans.find((loan)=>loan._id === loanId)),
                loans: loans,
                disabled: true,
                error: formErrors.loan
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41af608264f61f27$export$1288c65e1f92c76b), {
                value: formValues?.asset?._id ?? '',
                setValue: (assetId)=>updateFormValue('asset')(assets.find((asset)=>asset._id === assetId)),
                assets: assets,
                disabled: true,
                error: formErrors.asset
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "amount",
                label: "Amount",
                value: formValues?.amount,
                updateValue: updateFormValue('amount'),
                type: "number",
                moneyMask: true,
                required: true,
                error: formErrors.amount
            }),
            formValues?.asset && typeof formValues.assetValue === 'number' && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        flex: 50,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        fontSize: "1.2em",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                paddingBottom: "6px",
                                marginBottom: "6px",
                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                className: "thin",
                                children: "Current Asset Value"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                id: "value",
                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues?.assetValue)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        flex: 50,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        fontSize: "1.2em",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                paddingBottom: "6px",
                                marginBottom: "6px",
                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                className: "thin",
                                children: "Asset Value After Adjustment"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                id: "projectedValue",
                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues?.amount ? formValues?.assetValue + formValues?.amount : formValues?.assetValue)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "name",
                label: "Adjustment Name",
                value: formValues?.name,
                updateValue: updateFormValue('name'),
                required: true,
                error: formErrors.name
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "effectiveDate",
                label: "Adjustment Date",
                value: formValues?.effectiveDate,
                updateValue: updateFormValue('effectiveDate'),
                type: "date",
                required: true,
                error: formErrors.effectiveDate
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $6456bd903e13ed6a$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');




var $bNwqO = parcelRequire("bNwqO");


var $PKVGF = parcelRequire("PKVGF");






const $054bb2d5b6d228c6$export$2b6da3a761ba24fe = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const adjustmentStore = (0, $1da4b8b758f1a116$export$8808bffeb1795f83)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [search, setSearch] = (0, $lVd4O.useState)({});
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const adjustments = adjustmentStore.adjustments;
    const isFiltered = !!Object.values(search).length;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet([
            'name',
            '_id',
            'isLender'
        ]), [
        filterStore._companyList
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (adjustments) {
            let list = adjustments.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            if (search.companyId) list = list.filter((adjustment)=>adjustment.company._id === search.companyId);
            return list;
        }
    }, [
        adjustments,
        search,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        adjustmentStore.query();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment,
        headerItems: [
            {
                flex: 5,
                propName: 'notes',
                label: 'Notes'
            },
            {
                propName: 'name',
                label: 'Name'
            },
            {
                flex: 15,
                propName: 'company.name',
                label: 'Company'
            },
            {
                propName: 'asset.name',
                label: 'Asset'
            },
            {
                flex: 10,
                propName: 'effectiveDate',
                label: 'Effective Date'
            },
            {
                propName: 'assetValue',
                label: 'Starting Asset Value',
                textAlign: 'right'
            },
            {
                propName: 'amount',
                label: 'Adjustment Amount',
                textAlign: 'right'
            },
            {
                propName: 'resultingAssetValue',
                label: 'Resulting Asset Value',
                textAlign: 'right'
            }
        ],
        noFilteredDataMessage: "No Adjustments found for that Company.",
        toolbarItems: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
            children: userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                flex: 1,
                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "3px",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            value: search.companyId,
                            updateValue: (id)=>setSearch({
                                    ...search,
                                    companyId: id
                                }),
                            options: companies.map((company)=>({
                                    label: company.name,
                                    value: company._id
                                })),
                            placeholder: "All Companies",
                            enablePlaceholderOption: true,
                            disableUnderline: true,
                            disableMargin: true,
                            color: (0, $bNwqO.default).white
                        })
                    ]
                })
            })
        }),
        isFiltered: isFiltered,
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        notes: notes,
        notesName: notesName,
        setNotes: setNotes,
        setNotesName: setNotesName,
        children: listData?.map((adjustment, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                rowHeight: rowHeight,
                padForScrollbar: listData.length > 8,
                items: [
                    {
                        propName: 'notes',
                        isNotes: true,
                        flex: 5,
                        hide: !adjustment.notes.length,
                        showNotesPopup: ()=>showNotesPopup(adjustment.notes, adjustment.name)
                    },
                    {
                        propName: 'name',
                        content: adjustment.name,
                        url: `/adjustments/${adjustment._id}`
                    },
                    {
                        propName: 'company.name',
                        content: adjustment.company.name,
                        url: `/companies/${adjustment.company._id}`,
                        flex: 15
                    },
                    {
                        propName: 'asset.name',
                        content: adjustment.asset?.name,
                        url: `/assets/${adjustment.asset?._id}`
                    },
                    {
                        propName: 'effectiveDate',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(adjustment.effectiveDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                        flex: 10
                    },
                    {
                        propName: 'assetValue',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(adjustment.assetValue ?? ''),
                        textAlign: 'right'
                    },
                    {
                        propName: 'amount',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(adjustment.amount),
                        textAlign: 'right'
                    },
                    {
                        propName: 'resultingAssetValue',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(adjustment.resultingAssetValue ?? ''),
                        textAlign: 'right'
                    }
                ],
                rowIndex: i
            }, adjustment._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $baee3d6dffc2be18$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'ModeEdit');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");

var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");



var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $5bb23b252e131893$export$245f94b54fb85595(slot) {
    return (0, $bYZd6.default)('MuiSpeedDialAction', slot);
}
const $5bb23b252e131893$var$speedDialActionClasses = (0, $eaNcJ.default)('MuiSpeedDialAction', [
    'fab',
    'fabClosed',
    'staticTooltip',
    'staticTooltipClosed',
    'staticTooltipLabel',
    'tooltipPlacementLeft',
    'tooltipPlacementRight'
]);
var $5bb23b252e131893$export$2e2bcd8739ae039 = $5bb23b252e131893$var$speedDialActionClasses;





var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $b55097dc6b994c42$var$useUtilityClasses = (ownerState)=>{
    const { open: open, tooltipPlacement: tooltipPlacement, classes: classes } = ownerState;
    const slots = {
        fab: [
            'fab',
            !open && 'fabClosed'
        ],
        staticTooltip: [
            'staticTooltip',
            `tooltipPlacement${(0, $4HqRp.default)(tooltipPlacement)}`,
            !open && 'staticTooltipClosed'
        ],
        staticTooltipLabel: [
            'staticTooltipLabel'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $5bb23b252e131893$export$245f94b54fb85595), classes);
};
const $b55097dc6b994c42$var$SpeedDialActionFab = (0, $gvIKB.default)((0, $a84b7c0350b0505a$export$2e2bcd8739ae039), {
    name: 'MuiSpeedDialAction',
    slot: 'Fab',
    skipVariantsResolver: false,
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.fab,
            !ownerState.open && styles.fabClosed
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        margin: 8,
        color: (theme.vars || theme).palette.text.secondary,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.SpeedDialAction.fabHoverBg : (0, $dRIMW.emphasize)(theme.palette.background.paper, 0.15)
        },
        transition: `${theme.transitions.create('transform', {
            duration: theme.transitions.duration.shorter
        })}, opacity 0.8s`,
        opacity: 1,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open,
                style: {
                    opacity: 0,
                    transform: 'scale(0)'
                }
            }
        ]
    })));
const $b55097dc6b994c42$var$SpeedDialActionStaticTooltip = (0, $gvIKB.default)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.staticTooltip,
            !ownerState.open && styles.staticTooltipClosed,
            styles[`tooltipPlacement${(0, $4HqRp.default)(ownerState.tooltipPlacement)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        [`& .${(0, $5bb23b252e131893$export$2e2bcd8739ae039).staticTooltipLabel}`]: {
            transition: theme.transitions.create([
                'transform',
                'opacity'
            ], {
                duration: theme.transitions.duration.shorter
            }),
            opacity: 1
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open,
                style: {
                    [`& .${(0, $5bb23b252e131893$export$2e2bcd8739ae039).staticTooltipLabel}`]: {
                        opacity: 0,
                        transform: 'scale(0.5)'
                    }
                }
            },
            {
                props: {
                    tooltipPlacement: 'left'
                },
                style: {
                    [`& .${(0, $5bb23b252e131893$export$2e2bcd8739ae039).staticTooltipLabel}`]: {
                        transformOrigin: '100% 50%',
                        right: '100%',
                        marginRight: 8
                    }
                }
            },
            {
                props: {
                    tooltipPlacement: 'right'
                },
                style: {
                    [`& .${(0, $5bb23b252e131893$export$2e2bcd8739ae039).staticTooltipLabel}`]: {
                        transformOrigin: '0% 50%',
                        left: '100%',
                        marginLeft: 8
                    }
                }
            }
        ]
    })));
const $b55097dc6b994c42$var$SpeedDialActionStaticTooltipLabel = (0, $gvIKB.default)('span', {
    name: 'MuiSpeedDialAction',
    slot: 'StaticTooltipLabel',
    overridesResolver: (props, styles)=>styles.staticTooltipLabel
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'absolute',
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        boxShadow: (theme.vars || theme).shadows[1],
        color: (theme.vars || theme).palette.text.secondary,
        padding: '4px 16px',
        wordBreak: 'keep-all'
    })));
const $b55097dc6b994c42$var$SpeedDialAction = /*#__PURE__*/ $lVd4O.forwardRef(function SpeedDialAction(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiSpeedDialAction'
    });
    const { className: className, delay: delay = 0, FabProps: FabProps = {}, icon: icon, id: id, open: open, TooltipClasses: TooltipClasses, tooltipOpen: tooltipOpenProp = false, tooltipPlacement: tooltipPlacement = 'left', tooltipTitle: tooltipTitle, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        tooltipPlacement: tooltipPlacement
    };
    const classes = $b55097dc6b994c42$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            fab: FabProps,
            ...slotProps,
            tooltip: (0, $e604885c935ab4f8$export$2e2bcd8739ae039)(typeof slotProps.tooltip === 'function' ? slotProps.tooltip(ownerState) : slotProps.tooltip, {
                title: tooltipTitle,
                open: tooltipOpenProp,
                placement: tooltipPlacement,
                classes: TooltipClasses
            })
        }
    };
    const [tooltipOpen, setTooltipOpen] = $lVd4O.useState(externalForwardedProps.slotProps.tooltip?.open);
    const handleTooltipClose = ()=>{
        setTooltipOpen(false);
    };
    const handleTooltipOpen = ()=>{
        setTooltipOpen(true);
    };
    const transitionStyle = {
        transitionDelay: `${delay}ms`
    };
    const [FabSlot, fabSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('fab', {
        elementType: $b55097dc6b994c42$var$SpeedDialActionFab,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        shouldForwardComponentProp: true,
        className: (0, $anaDR.default)(classes.fab, className),
        additionalProps: {
            style: transitionStyle,
            tabIndex: -1,
            role: 'menuitem',
            size: 'small'
        }
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('tooltip', {
        elementType: (0, $597ca07016a19218$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ref: ref,
        additionalProps: {
            id: id
        },
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onClose: (event)=>{
                    handlers.onClose?.(event);
                    handleTooltipClose();
                },
                onOpen: (event)=>{
                    handlers.onOpen?.(event);
                    handleTooltipOpen();
                }
            })
    });
    const [StaticTooltipSlot, staticTooltipSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('staticTooltip', {
        elementType: $b55097dc6b994c42$var$SpeedDialActionStaticTooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: ref,
        className: classes.staticTooltip,
        additionalProps: {
            id: id
        }
    });
    const [StaticTooltipLabelSlot, staticTooltipLabelSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('staticTooltipLabel', {
        elementType: $b55097dc6b994c42$var$SpeedDialActionStaticTooltipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.staticTooltipLabel,
        additionalProps: {
            style: transitionStyle,
            id: `${id}-label`
        }
    });
    const fab = /*#__PURE__*/ (0, $iO5o7.jsx)(FabSlot, {
        ...fabSlotProps,
        children: icon
    });
    if (tooltipSlotProps.open) return /*#__PURE__*/ (0, $iO5o7.jsxs)(StaticTooltipSlot, {
        ...staticTooltipSlotProps,
        ...other,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)(StaticTooltipLabelSlot, {
                ...staticTooltipLabelSlotProps,
                children: tooltipSlotProps.title
            }),
            /*#__PURE__*/ $lVd4O.cloneElement(fab, {
                'aria-labelledby': `${id}-label`
            })
        ]
    });
    if (!open && tooltipOpen) setTooltipOpen(false);
    return /*#__PURE__*/ (0, $iO5o7.jsx)(TooltipSlot, {
        ...tooltipSlotProps,
        title: tooltipSlotProps.title,
        open: open && tooltipOpen,
        placement: tooltipSlotProps.placement,
        classes: tooltipSlotProps.classes,
        ...other,
        children: fab
    });
});
var $b55097dc6b994c42$export$2e2bcd8739ae039 = $b55097dc6b994c42$var$SpeedDialAction;








const $143dacb32fb82bf7$export$48941c19c8b3b6b = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const adjustmentStore = (0, $1da4b8b758f1a116$export$8808bffeb1795f83)();
    const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmDelete, setShowConfirmDelete] = (0, $lVd4O.useState)(false);
    const [files] = (0, $lVd4O.useState)([]);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Computed **/ const adjustment = adjustmentStore.currentAdjustment;
    /** Methods **/ /**
   * Removes the Adjustment.
   *
   * @remarks
   * Redirects to the Adjustments List afterwards.
   */ const remove = async ()=>{
        if (!adjustment) return;
        try {
            await adjustmentStore.remove(adjustment._id);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteAdjustment.success);
            // Redirect to adjustments
            navigate('/adjustments');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteAdjustment.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!adjustment) return;
        const response = await adjustmentStore.update({
            ...adjustment,
            notes: notes
        });
        if (!response) throw new Error(`Error updating notes for Adjustment ID ${adjustment._id}`);
        adjustmentStore.currentAdjustment = response;
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!adjustment) return;
        const response = await adjustmentStore.update({
            ...adjustment,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Adjustment ID ${adjustment._id}`);
        adjustmentStore.currentAdjustment = response;
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.adjustmentId) return;
        Promise.all([
            adjustmentStore.get(params.adjustmentId),
            assetStore.query()
        ]);
    }, [
        params.adjustmentId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: adjustment?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment,
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        sidebarFlex: "35",
        contentFlex: "65",
        noteOptions: {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
            notes: adjustment?.notes ?? [],
            onChange: updateNotes
        },
        documentOptions: {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
            files: files ?? [],
            onChange: updateFiles
        },
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit, 'Edit Adjustment'),
                onClick: ()=>navigate(`/adjustments/${adjustment?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Remove, 'Delete Adjustment'),
                onClick: ()=>setShowConfirmDelete(true)
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: "Are you sure you want to delete this Adjustment?",
            open: showConfirmDelete,
            setOpen: setShowConfirmDelete,
            onOk: ()=>remove(),
            label: "Confirm Adjustment Deletion",
            okLabel: "Delete",
            cancelLabel: "Cancel"
        }),
        children: adjustment ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Effective Date",
                    value: adjustment?.effectiveDate,
                    date: true
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Asset",
                    value: adjustment?.asset?.name,
                    url: `/assets/${adjustment?.asset?._id}`
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Original Asset Value",
                    value: adjustment?.assetValue,
                    currency: true
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Adjustment Amount",
                    value: adjustment?.amount,
                    currency: true
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Resulting Asset Value",
                    bold: true,
                    value: adjustment?.resultingAssetValue,
                    currency: true
                })
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $905c5702d1df1a82$export$b5d742573aa3b192 = [
    // Create
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/adjustments/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $37b1b22a08b845d1$export$c1270cb4dd5ae4e3), {})
        })
    }),
    // Edit
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/adjustments/:adjustmentId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e9f557d4087bbf14$export$4f8128a63ac4e86e), {})
        })
    }),
    // List
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/adjustments",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $054bb2d5b6d228c6$export$2b6da3a761ba24fe), {})
        })
    }),
    // View
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/adjustments/:adjustmentId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $143dacb32fb82bf7$export$48941c19c8b3b6b), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $5e81028af4703de0$export$5db7f0c4ef25fbda = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const advanceStore = (0, $1da4b8b758f1a116$export$ed879bc79c1297c7)();
    const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [isLoaded, setIsLoaded] = (0, $lVd4O.useState)(false);
    const [formValues, setFormValues] = (0, $lVd4O.useState)({
        name: '',
        amount: '',
        dateRequested: new Date(),
        originationFee: 0,
        effectiveDate: '',
        notes: [],
        files: []
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet(), [
        filterStore._loanList
    ]);
    const filteredLoans = loans;
    const filteredAssets = formValues.loan ? formValues.loan.assets.toSorted((a, b)=>a.name.localeCompare(b.name)) : [];
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (field)=>(value)=>{
            setFormValues((prev)=>{
                const updates = {
                    [field]: value
                };
                // Clear dependent fields
                if (field === 'loan') {
                    updates.asset = undefined;
                    updates.amount = undefined;
                } else if (field === 'asset') // Reset amount when asset changes to avoid invalid calculations
                updates.amount = undefined;
                return {
                    ...prev,
                    ...updates
                };
            });
            // Clear error when field is updated
            if (formErrors[field]) setFormErrors((prev)=>({
                    ...prev,
                    [field]: ''
                }));
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues.loan) errors.loan = 'Loan is required';
        if (formValues.loan?.isOwned && !formValues?.asset) errors.asset = 'Asset is required';
        if (!formValues.name) errors.name = 'Name is required';
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues.amount)) errors.amount = 'Valid amount is required';
        if (!formValues.dateFulfilled) errors.dateFulfilled = 'Date is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Creates an Advance.
   *
   * @remarks
   * Redirects to the new Advance's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first.');
            return;
        }
        try {
            const response = await advanceStore.create({
                ...formValues,
                originationFee: parseFloat(formValues.amount || '0') * (formValues.loan?.originationFee ?? 0)
            });
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createAdvance.success);
            navigate(`/advances/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createAdvance.error);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (formValues.loan) updateFormValue('company')(formValues.loan.borrower);
    }, [
        formValues.loan
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (assetStore.currentAsset) {
            const asset = assetStore.currentAsset;
            updateFormValue('asset')({
                ...formValues.asset ?? asset,
                expectedResidualPayment: asset.expectedResidualPayment
            });
            setIsLoaded(true);
        }
    }, [
        assetStore.currentAsset
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance,
        onCreate: create,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                value: formValues.loan?._id ?? '',
                setValue: (loanId)=>updateFormValue('loan')(filteredLoans.find((loan)=>loan._id === loanId)),
                loans: filteredLoans,
                error: formErrors.loan
            }),
            formValues.loan && formValues.loan.isOwned && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41af608264f61f27$export$1288c65e1f92c76b), {
                value: formValues.asset?._id ?? '',
                setValue: (assetId)=>assetStore.get(assetId),
                assets: filteredAssets,
                error: formErrors.asset
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "name",
                                label: "Advance Name",
                                value: formValues.name,
                                updateValue: updateFormValue('name'),
                                required: true,
                                error: formErrors.name
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "amount",
                                label: "Amount",
                                value: formValues.amount,
                                updateValue: updateFormValue('amount'),
                                type: "number",
                                moneyMask: true,
                                negativeNumber: true,
                                required: true,
                                error: formErrors.amount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        children: [
                            !formValues.loan && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                className: "md-title thin",
                                height: "100%",
                                children: "Please Select a Deal."
                            }),
                            formValues.loan && !formValues.loan.isOwned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                className: "md-title",
                                height: "100%",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        paddingBottom: "6px",
                                        marginBottom: "6px",
                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                        className: "thin",
                                        children: "Available Credit"
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        id: "currentValue",
                                        children: formValues.loan.assetValue ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues.loan.assetValue * formValues.loan.advanceRate - formValues.loan.principalBalance) : '-'
                                    })
                                ]
                            }),
                            formValues.loan && formValues.loan.isOwned && !formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                className: "md-title thin",
                                height: "100%",
                                children: "Please Select an Asset."
                            }),
                            formValues.loan?.isOwned && formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                className: "md-title thin",
                                height: "100%",
                                flexDirection: "column",
                                gap: "16px",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Asset Value"
                                                    }),
                                                    formValues.asset?.originalValue && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "originalValue",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues.asset?.originalValue)
                                                    }),
                                                    !formValues.asset?.originalValue && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        className: "md-caption center thin",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                            children: "No Asset value found."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Initial Payment Amount"
                                                    }),
                                                    formValues.asset?.initialPaymentAmount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "initialPaymentAmount",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues.asset?.initialPaymentAmount)
                                                    }),
                                                    !formValues.asset?.initialPaymentAmount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        className: "md-caption center thin",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                            children: "No initial payment amount found."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Socket Fees"
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "socketFees",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format((formValues.asset.adminFee || 0) + (formValues.asset.discountFee || 0) + (formValues.asset.lateFee || 0))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Expected Residual Payment"
                                                    }),
                                                    typeof formValues.asset.expectedResidualPayment === 'number' && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "expectedResidualPayment",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues.asset.expectedResidualPayment)
                                                    }),
                                                    !isLoaded && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        className: "md-caption center thin",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                            children: "Calculating..."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Requested",
                        value: formValues.dateRequested,
                        updateValue: updateFormValue('dateRequested'),
                        type: "date",
                        required: true,
                        error: formErrors.dateRequested
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Fulfilled",
                        value: formValues.dateFulfilled,
                        updateValue: updateFormValue('dateFulfilled'),
                        type: "date",
                        required: true,
                        error: formErrors.dateFulfilled
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $ee611056d43895ad$export$45c3a847b1ebe7ef = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const advanceStore = (0, $1da4b8b758f1a116$export$ed879bc79c1297c7)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Computed **/ const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet(), [
        filterStore._loanList
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues?.loan) errors.loan = 'Loan is required';
        if (formValues?.loan.isOwned && !formValues?.asset) errors.asset = 'Asset is required';
        if (!formValues?.name) errors.name = 'Name is required';
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.amount)) errors.amount = 'Valid amount is required';
        if (!formValues?.dateFulfilled) errors.dateFulfilled = 'Date is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the Advance.
   *
   * @remarks
   * Redirects to the Advance's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await advanceStore.update(formValues);
            if (!response) throw new Error(`Could not update Advance with ID "${formValues?._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateAdvance.success);
            navigate(`/advances/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateAdvance.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!formValues) return;
        await advanceStore.update({
            ...formValues,
            notes: notes
        });
        updateFormValue('notes')(notes);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!formValues) return;
        await advanceStore.update({
            ...formValues,
            files: files
        });
        updateFormValue('files')(files);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (params.advanceId) advanceStore.get(params.advanceId);
    }, [
        params.advanceId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (advanceStore.currentAdvance) setFormValues(advanceStore.currentAdvance);
    }, [
        advanceStore.currentAdvance
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance,
        editVerb: "Edit",
        onEdit: update,
        sidebarFlex: "35",
        contentFlex: "65",
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        noteOptions: {
            notes: formValues?.notes ?? [],
            onChange: updateNotes
        },
        documentOptions: {
            files: formValues?.files ?? [],
            onChange: updateFiles
        },
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                value: formValues?.loan?._id ?? '',
                setValue: (loanId)=>updateFormValue('loan')(loans.find((loan)=>loan._id === loanId)),
                loans: loans,
                error: formErrors.loan,
                disabled: true
            }),
            formValues?.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41af608264f61f27$export$1288c65e1f92c76b), {
                value: formValues?.asset?._id ?? '',
                setValue: ()=>{},
                assets: [
                    formValues?.asset
                ],
                error: formErrors.asset,
                disabled: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "name",
                                label: "Advance Name",
                                value: formValues?.name,
                                updateValue: updateFormValue('name'),
                                required: true,
                                error: formErrors.name
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "amount",
                                label: "Amount",
                                value: formValues?.amount,
                                updateValue: updateFormValue('amount'),
                                type: "number",
                                moneyMask: true,
                                negativeNumber: true,
                                required: true,
                                error: formErrors.amount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        children: [
                            formValues?.loan && !formValues?.loan.isOwned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                className: "md-title",
                                height: "100%",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        paddingBottom: "6px",
                                        marginBottom: "6px",
                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                        className: "thin",
                                        children: "Available Credit"
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        id: "currentValue",
                                        children: formValues?.loan.assetValue ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues?.loan.assetValue * formValues?.loan.advanceRate - formValues?.loan.principalBalance) : '-'
                                    })
                                ]
                            }),
                            formValues?.loan && formValues?.loan.isOwned && !formValues?.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                className: "md-title thin",
                                height: "100%",
                                children: "Please Select an Asset."
                            }),
                            formValues?.loan?.isOwned && formValues?.asset && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                className: "md-title thin",
                                height: "100%",
                                flexDirection: "column",
                                gap: "16px",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Asset Value"
                                                    }),
                                                    formValues?.asset?.originalValue && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "originalValue",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues?.asset?.originalValue)
                                                    }),
                                                    !formValues?.asset?.originalValue && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        className: "md-caption center thin",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                            children: "No Asset value found."
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Initial Payment Amount"
                                                    }),
                                                    formValues?.asset?.initialPaymentAmount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "initialPaymentAmount",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues?.asset?.initialPaymentAmount)
                                                    }),
                                                    !formValues?.asset?.initialPaymentAmount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        className: "md-caption center thin",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                            children: "No initial payment amount found."
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Socket Fees"
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "socketFees",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format((formValues?.asset.adminFee || 0) + (formValues?.asset.discountFee || 0) + (formValues?.asset.lateFee || 0))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                flex: 50,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                className: "md-title",
                                                height: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        paddingBottom: "6px",
                                                        marginBottom: "6px",
                                                        borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                        className: "thin",
                                                        children: "Expected Residual Payment"
                                                    }),
                                                    typeof formValues?.asset.expectedResidualPayment === 'number' && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        id: "expectedResidualPayment",
                                                        children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(formValues?.asset.expectedResidualPayment)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Requested",
                        value: formValues?.dateRequested,
                        updateValue: updateFormValue('dateRequested'),
                        type: "date",
                        required: true,
                        error: formErrors.dateRequested
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Fulfilled",
                        value: formValues?.dateFulfilled,
                        updateValue: updateFormValue('dateFulfilled'),
                        type: "date",
                        required: true,
                        error: formErrors.dateFulfilled
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $bNwqO = parcelRequire("bNwqO");


var $PKVGF = parcelRequire("PKVGF");






const $e70a0a265c356159$export$e83f411aec024198 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    /** Context **/ const advanceStore = (0, $1da4b8b758f1a116$export$ed879bc79c1297c7)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [search, setSearch] = (0, $lVd4O.useState)({});
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const advances = advanceStore.advances;
    const isFiltered = !!Object.values(search).length;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (advances) {
            let list = advances.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            if (search.companyId) list = list.filter((advance)=>advance.company._id === search.companyId);
            return list;
        }
    }, [
        advances,
        search,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        advanceStore.query();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance,
        headerItems: [
            {
                flex: 5,
                propName: 'notes',
                label: 'Notes'
            },
            {
                propName: 'name',
                label: 'Advance Name'
            },
            {
                flex: 15,
                propName: 'company.name',
                label: 'Company'
            },
            {
                flex: 10,
                propName: 'loan.name',
                label: 'Deal'
            },
            {
                propName: 'amount',
                label: 'Amount',
                textAlign: 'right'
            },
            {
                propName: 'dateRequested',
                label: 'Date Requested',
                textAlign: 'right'
            },
            {
                propName: 'dateFulfilled',
                label: 'Date Fulfilled',
                textAlign: 'right'
            },
            {
                propName: 'originationFee',
                label: 'Origination Fee',
                textAlign: 'right'
            }
        ],
        noFilteredDataMessage: "No Advances found for that Company.",
        toolbarItems: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
            children: userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                flex: 1,
                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "3px",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            value: search.companyId,
                            updateValue: (id)=>setSearch({
                                    ...search,
                                    companyId: id
                                }),
                            options: companies.filter((company)=>!company.isLender).map((company)=>({
                                    label: company.name,
                                    value: company._id
                                })),
                            placeholder: "All Companies",
                            enablePlaceholderOption: true,
                            disableUnderline: true,
                            disableMargin: true,
                            color: (0, $bNwqO.default).white
                        })
                    ]
                })
            })
        }),
        isFiltered: isFiltered,
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        notes: notes,
        notesName: notesName,
        setNotes: setNotes,
        setNotesName: setNotesName,
        children: listData?.map((advance, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        propName: 'notes',
                        isNotes: true,
                        flex: 5,
                        hide: !advance.notes.length,
                        showNotesPopup: ()=>showNotesPopup(advance.notes, advance.name)
                    },
                    {
                        propName: 'name',
                        content: advance.name,
                        url: `/advances/${advance._id}`
                    },
                    {
                        propName: 'company.name',
                        content: advance.company.name,
                        url: `/companies/${advance.company._id}`,
                        flex: 15
                    },
                    {
                        propName: 'loan.name',
                        content: advance.loan.name,
                        url: `/deals/${advance.loan._id}`,
                        flex: 10
                    },
                    {
                        propName: 'amount',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(advance.amount),
                        textAlign: 'right'
                    },
                    {
                        propName: 'dateRequested',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(advance.dateRequested).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                        textAlign: 'right'
                    },
                    {
                        propName: 'dateFulfilled',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(advance.dateFulfilled).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                        textAlign: 'right'
                    },
                    {
                        propName: 'originationFee',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(advance.originationFee ?? 0),
                        textAlign: 'right'
                    }
                ],
                rowIndex: i
            }, advance._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $93270db252cb57d4$export$12b89fe341d15ac = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const advanceStore = (0, $1da4b8b758f1a116$export$ed879bc79c1297c7)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmDelete, setShowConfirmDelete] = (0, $lVd4O.useState)(false);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Computed **/ const advance = advanceStore.currentAdvance;
    /** Methods **/ /**
   * Removes the Advance.
   *
   * @remarks
   * Redirects to the Advances List afterwards.
   */ const remove = async ()=>{
        if (!advance) return;
        try {
            await advanceStore.remove(advance._id);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteAdvance.success);
            // Redirect to advances
            navigate('/advances');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteAdvance.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!advance) return;
        const response = await advanceStore.update({
            ...advance,
            notes: notes
        });
        if (!response) throw new Error(`Error updating notes for Advance ID ${advance._id}`);
        advanceStore.currentAdvance = response;
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!advance) return;
        const response = await advanceStore.update({
            ...advance,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Advance ID ${advance._id}`);
        advanceStore.currentAdvance = response;
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.advanceId) return;
        Promise.all([
            advanceStore.get(params.advanceId)
        ]);
    }, [
        params.advanceId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: advance?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance,
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        sidebarFlex: "35",
        contentFlex: "65",
        noteOptions: {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
            notes: advance?.notes ?? [],
            onChange: updateNotes
        },
        documentOptions: {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
            files: advance?.files ?? [],
            onChange: updateFiles
        },
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit, 'Edit Advance'),
                onClick: ()=>navigate(`/advances/${advance?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Remove, 'Delete Advance'),
                onClick: ()=>setShowConfirmDelete(true)
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: "Are you sure you want to delete this Advance?",
            open: showConfirmDelete,
            setOpen: setShowConfirmDelete,
            onOk: ()=>remove(),
            label: "Confirm Advance Deletion",
            okLabel: "Delete",
            cancelLabel: "Cancel"
        }),
        children: advance ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Deal",
                    value: advance?.loan.name,
                    url: `/deals/${advance?.loan._id}`
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Amount",
                    value: advance?.amount,
                    bold: true,
                    currency: true
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Origination Fee",
                    value: advance?.originationFee,
                    currency: true
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Date Requested",
                    value: advance?.dateRequested,
                    date: true
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Date Fulfilled",
                    value: advance?.dateFulfilled,
                    date: true
                })
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $c0f5ace9137e9735$export$ae8050ec2c89360d = [
    // Create
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/advances/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5e81028af4703de0$export$5db7f0c4ef25fbda), {})
        })
    }),
    // Edit
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/advances/:advanceId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ee611056d43895ad$export$45c3a847b1ebe7ef), {})
        })
    }),
    // List
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/advances",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e70a0a265c356159$export$e83f411aec024198), {})
        })
    }),
    // View
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/advances/:advanceId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $93270db252cb57d4$export$12b89fe341d15ac), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $PKVGF = parcelRequire("PKVGF");





const $f47a744970474d7b$export$1238436888b9776d = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'effectiveDate';
    const defaultSortReverse = true;
    /** Context **/ const alertStore = (0, $1da4b8b758f1a116$export$c345cf07ab3c1b9e)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    /** Computed **/ const alerts = alertStore.alerts;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (alerts) {
            const list = alerts.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        alerts,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        alertStore.query();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Alert,
        headerItems: [
            {
                flex: 10,
                propName: 'source',
                label: 'Type'
            },
            {
                flex: 10,
                propName: 'created',
                label: 'Date'
            },
            {
                flex: 15,
                propName: 'company',
                label: 'Company'
            },
            {
                flex: 15,
                propName: 'loan',
                label: 'Deal'
            },
            {
                flex: 35,
                propName: 'message',
                label: 'Message'
            },
            {
                flex: 15,
                propName: 'sender',
                label: 'Originating User'
            }
        ],
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        hideCreateButton: true,
        children: listData?.map((alert, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        flex: 10,
                        propName: 'source',
                        content: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
                            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                alignItems: "center",
                                display: "flex",
                                children: [
                                    (alert.source?.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment || alert.message.includes(`${(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment}:`)) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                        title: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment,
                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment]
                                    }),
                                    (alert.source?.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance || alert.message.includes(`${(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance}:`)) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                        title: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance,
                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Advance]
                                    }),
                                    (alert.source?.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Asset || alert.message.includes(`${(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset}:`)) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                        title: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset,
                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset]
                                    }),
                                    (alert.source?.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment || alert.message.includes(`${(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment}:`)) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                        title: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment,
                                        children: (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Adjustment]
                                    })
                                ]
                            })
                        })
                    },
                    {
                        flex: 10,
                        propName: 'created',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(alert.created).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                    },
                    {
                        flex: 15,
                        propName: 'company',
                        content: alert.source ? alertStore.getCompanyName(alert.source.company) : '',
                        url: `/companies/${alert.source?.company}`
                    },
                    {
                        flex: 15,
                        propName: 'loan',
                        content: alert.source ? alertStore.getLoanName(alert.source.loan) : '',
                        url: `/deals/${alert.source?.loan}`
                    },
                    {
                        flex: 35,
                        propName: 'message',
                        content: alert.message,
                        url: alert.source ? `/${alert.source?.__t}/${alert.source?._id}` : undefined
                    },
                    {
                        flex: 15,
                        propName: 'sender',
                        content: alert.sender?.displayName,
                        url: `/users/${alert.sender?._id}`
                    }
                ],
                rowIndex: i
            }, alert._id))
    });
});



const $e28fa16046440cc5$export$660a8d7d3aa4942 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/alerts",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f47a744970474d7b$export$1238436888b9776d), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $dcc89a56249ef4e6$export$200a7c354c2f6940 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)({
        name: '',
        effectiveDate: new Date(),
        value: '',
        paymentSchedule: '',
        files: [],
        companyComments: [],
        socketComments: [],
        adminFee: '0',
        discountFee: '0',
        lateFee: '0'
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet(), [
        filterStore._loanList
    ]);
    const projectedValue = (0, $lVd4O.useMemo)(()=>{
        const value = parseFloat(formValues.value || '0');
        const currentAdjustments = parseFloat(formValues.currentAdjustments || '0');
        const advanceRate = formValues.loan?.advanceRate || 0;
        const adminFee = formValues.loan?.adminFee || 0;
        const discountFee = formValues.loan?.discountFee || 0;
        const lateFee = parseFloat(formValues.lateFee || '0');
        const dateDiff = formValues.nextDate && formValues.effectiveDate ? (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.nextDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues.effectiveDate), 'days') / 30 : 0;
        const res = value + currentAdjustments - value * advanceRate - value * adminFee - value * discountFee * dateDiff - lateFee;
        return !Number.isNaN(res) ? res : 0;
    }, [
        formValues.value,
        formValues.currentAdjustments,
        formValues.loan,
        formValues.lateFee,
        formValues.nextDate,
        formValues.effectiveDate
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            setFormValues((prev)=>({
                    ...prev,
                    [key]: value
                }));
            // Clear error when field is updated
            if (formErrors[key]) setFormErrors((prev)=>({
                    ...prev,
                    [key]: ''
                }));
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues.loan) errors.loan = 'Loan is required';
        if (!formValues.assetType) errors.assetType = 'Type is required';
        if (!formValues.name) errors.name = 'Name is required';
        if (!$f90d087769f90e7b$export$7e4aa119212bc614(formValues.value)) errors.value = 'Valid amount is required';
        if (!formValues.program) errors.program = 'Program is required';
        if (!formValues.paymentSchedule) errors.paymentSchedule = 'Schedule is required';
        if (!formValues.nextDate) errors.nextDate = 'Date is required';
        if (!formValues.effectiveDate) errors.effectiveDate = 'Date is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Creates an Asset.
   *
   * @remarks
   * Redirects to the new Asset's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first.');
            return;
        }
        try {
            const response = await assetStore.create(formValues);
            if (!response) throw new Error(`Could not create Asset with data: ${JSON.stringify(formValues)}`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createAsset.success);
            navigate(`/deals/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createAsset.error);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset,
        onCreate: create,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                id: "loan",
                value: formValues.loan?._id ?? '',
                setValue: (loanId)=>updateFormValue('loan')(loans.find((loan)=>loan._id === loanId)),
                loans: loans,
                required: true,
                error: formErrors.loan
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 33,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            label: "Asset Type",
                            options: Object.entries((0, $16167722a89c0415$export$e57062a38354425e)).map(([label, value])=>({
                                    label: label,
                                    value: value
                                })),
                            value: formValues?.assetType,
                            updateValue: updateFormValue('assetType'),
                            placeholder: "Asset Type",
                            flex: "33",
                            required: true,
                            error: formErrors.assetType
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 66,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "Asset Name",
                            field: "name",
                            formValues: formValues,
                            updateValue: updateFormValue('name'),
                            required: true,
                            error: formErrors.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Value",
                        field: formValues.value,
                        formValues: formValues,
                        updateValue: updateFormValue('value'),
                        type: "number",
                        moneyMask: true,
                        negativeNumber: true,
                        required: true,
                        error: formErrors.value
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Program",
                        field: "program",
                        formValues: formValues,
                        updateValue: updateFormValue('program'),
                        required: true,
                        error: formErrors.program
                    }),
                    formValues.loan?.isOwned && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        className: "no-pad-sides textZoomIn",
                        sx: {
                            display: 'flex'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            sx: {
                                flex: 1
                            },
                            "layout-align": "center center",
                            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                fontWeight: "100",
                                children: [
                                    "Expected Residual Payment:",
                                    ' ',
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        id: "expectedResidualPayment",
                                        className: "strong",
                                        children: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(projectedValue)
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Payment Schedule",
                        field: "paymentSchedule",
                        formValues: formValues,
                        updateValue: updateFormValue('paymentSchedule'),
                        required: true,
                        error: formErrors.paymentSchedule
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Next Payment",
                        value: formValues.nextDate,
                        updateValue: updateFormValue('nextDate'),
                        type: "date",
                        required: true,
                        error: formErrors.nextDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Asset Effective Date",
                value: formValues.effectiveDate,
                updateValue: updateFormValue('effectiveDate'),
                type: "date",
                required: true,
                error: formErrors.effectiveDate,
                boxProps: {
                    className: 'pad-bottom-xs'
                }
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");











const $481f34c9d6bb330b$export$f2702cc94d90999a = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false,
        false
    ]);
    /** Computed **/ const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet(), [
        filterStore._loanList
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        const errorMessages = {
            effectiveDate: 'Effective date is required',
            name: 'Asset name is required',
            program: 'Program is required',
            paymentSchedule: 'Payment schedule is required',
            nextDate: 'Next payment date is required',
            lateFee: 'Late fee is required for owned loans'
        };
        if (!formValues?.effectiveDate) errors.effectiveDate = errorMessages['effectiveDate'];
        if (!formValues?.name) errors.name = errorMessages['name'];
        if (!formValues?.program) errors.program = errorMessages['program'];
        if (!formValues?.paymentSchedule) errors.paymentSchedule = errorMessages['paymentSchedule'];
        if (!formValues?.nextDate) errors.nextDate = errorMessages['nextDate'];
        if (formValues?.loan?.isOwned && !(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.lateFee)) errors.lateFee = errorMessages['lateFee'];
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the Asset.
   *
   * @remarks
   * Redirects to the Asset's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        // Validate form before submitting
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await assetStore.update(formValues);
            if (!response) throw new Error(`Could not update Asset with ID "${formValues._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateAsset.success);
            navigate(`/assets/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateAsset.error);
        }
    };
    /**
   * Updates the Company Comments list.
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateCompanyComments = async (companyComments)=>{
        if (!formValues) return;
        const response = await assetStore.update({
            ...formValues,
            companyComments: companyComments
        });
        if (!response) throw new Error(`Error updating company comments for Asset ID ${formValues._id}`);
        assetStore.currentAsset = await assetStore.get(formValues._id);
    };
    /**
   * Update Socket Comments
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateSocketComments = async (socketComments)=>{
        if (!formValues) return;
        const response = await assetStore.update({
            ...formValues,
            socketComments: socketComments
        });
        if (!response) throw new Error(`Error updating socket comments for Asset ID ${formValues._id}`);
        assetStore.currentAsset = await assetStore.get(formValues._id);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!formValues) return;
        await assetStore.update({
            ...formValues,
            files: files
        });
        updateFormValue('files')(files);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.assetId) return;
        Promise.all([
            assetStore.get(params.assetId)
        ]);
    }, [
        params.assetId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (assetStore.currentAsset) setFormValues(assetStore.currentAsset);
    }, [
        assetStore.currentAsset
    ]);
    /** Render **/ const renderCompanyComments = (index = 0)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
            notes: formValues?.companyComments ?? [],
            title: "Company Comments",
            tooltip: "Add Company Comment",
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateNotes: updateCompanyComments
        });
    const renderSocketComments = (index = 1)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
            notes: formValues?.socketComments ?? [],
            title: "Socket Comments",
            tooltip: "Add Socket Comment",
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateNotes: updateSocketComments
        });
    const renderDocuments = (index = 2)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
            documents: formValues?.files ?? [],
            sidebarIndex: index,
            sidebarItems: sidebarItems,
            setSidebarItems: setSidebarItems,
            updateDocuments: updateFiles
        });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: assetStore.currentAsset?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset,
        editVerb: "Edit",
        onEdit: update,
        sidebarFlex: "30",
        contentFlex: "70",
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                renderCompanyComments(),
                userStore.isAdmin && renderSocketComments(),
                renderDocuments()
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                id: "loan",
                value: formValues?.loan?._id ?? '',
                setValue: updateFormValue('loan'),
                loans: loans,
                disabled: true,
                error: formErrors.loan
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "name",
                label: "Asset Name",
                value: formValues?.name,
                updateValue: updateFormValue('name'),
                required: true,
                error: formErrors.name
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                        id: "assetType",
                        label: "Asset Type",
                        options: Object.entries((0, $16167722a89c0415$export$e57062a38354425e)).map(([label, value])=>({
                                label: label,
                                value: value
                            })),
                        value: formValues?.assetType,
                        updateValue: updateFormValue('assetType'),
                        placeholder: "Asset Type",
                        flex: "33",
                        required: true,
                        error: formErrors.assetType
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                        id: "status",
                        label: "Status",
                        options: Object.entries((0, $16167722a89c0415$export$ea3addc32bc92d57)).map(([label, value])=>({
                                label: label,
                                value: value
                            })),
                        value: formValues?.status,
                        updateValue: updateFormValue('status'),
                        placeholder: "Asset Status",
                        ariaLabel: "Select an Asset Status",
                        required: true,
                        error: formErrors.assetType
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexDirection: "column",
                        flex: 50,
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                className: "text-label",
                                children: [
                                    "Value -",
                                    ' ',
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)("strong", {
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                                to: "/adjustments/create",
                                                children: "Add an Adjustment"
                                            }),
                                            " to change asset value."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "value",
                                label: "",
                                "aria-label": "Asset Value",
                                value: formValues?.value,
                                updateValue: updateFormValue('value'),
                                type: "number",
                                moneyMask: true,
                                required: true,
                                disabled: true,
                                disableMargin: true,
                                tooltip: "Add an Adjustment to change value"
                            }),
                            formErrors?.value && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f56666fc53e7fc38$export$2e2bcd8739ae039), {
                                children: formErrors?.value
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 50,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            id: "program",
                            label: "Program",
                            value: formValues?.program,
                            updateValue: updateFormValue('program'),
                            required: true,
                            error: formErrors.program
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        id: "paymentSchedule",
                        label: "Payment Schedule",
                        value: formValues?.paymentSchedule,
                        updateValue: updateFormValue('paymentSchedule'),
                        required: true,
                        error: formErrors.paymentSchedule
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        id: "nextDate",
                        label: "Next Payment",
                        value: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(formValues?.nextDate).format((0, $50c68e19ba8e5079$export$bfc92d8962c59fa1)),
                        updateValue: updateFormValue('nextDate'),
                        type: "date",
                        required: true,
                        error: formErrors.nextDate
                    })
                ]
            }),
            formValues?.loan.isOwned && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    id: "lateFee",
                    label: "Late Fee",
                    value: formValues?.lateFee,
                    updateValue: updateFormValue('lateFee'),
                    type: "number",
                    moneyMask: true,
                    required: formValues.loan.isOwned,
                    error: formErrors.lateFee
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "effectiveDate",
                label: "Asset Effective Date",
                value: formValues?.effectiveDate,
                updateValue: updateFormValue('effectiveDate'),
                type: "date",
                required: true,
                error: formErrors.effectiveDate,
                boxProps: {
                    paddingBottom: '6px'
                }
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $4HqRp = parcelRequire("4HqRp");

var $bNwqO = parcelRequire("bNwqO");


var $PKVGF = parcelRequire("PKVGF");






const $f0aa60e078b28c23$export$1cdc65811e830219 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'effectiveDate';
    const defaultSortReverse = true;
    /** Context **/ const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [search, setSearch] = (0, $lVd4O.useState)({
        status: (0, $16167722a89c0415$export$ea3addc32bc92d57).Open
    });
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const assets = assetStore.assets;
    const isFiltered = !!Object.values(search).length;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (assets) {
            let list = assets.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            if (search.companyId) list = list.filter((asset)=>asset.company?._id === search.companyId);
            if (search.status) list = list.filter((asset)=>asset.status === search.status);
            return list;
        }
    }, [
        assets,
        search,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        assetStore.query();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset,
        headerItems: [
            {
                flex: 5,
                propName: 'notes',
                label: 'Notes'
            },
            {
                propName: 'name',
                label: 'Asset Name'
            },
            {
                propName: 'loan.name',
                label: 'Deal'
            },
            {
                propName: 'program',
                label: 'Program'
            },
            {
                propName: 'value',
                label: 'Value',
                textAlign: 'right'
            },
            {
                propName: 'status',
                label: 'Status',
                textAlign: 'right'
            },
            {
                propName: 'totalAdjustments',
                label: 'Total Adjustments',
                textAlign: 'right'
            },
            {
                propName: 'totalPayments',
                label: 'Total Payments',
                textAlign: 'right'
            },
            {
                propName: 'effectiveDate',
                label: 'Asset Effective Date',
                textAlign: 'right'
            },
            {
                propName: 'nextDate',
                label: 'Next Payment',
                textAlign: 'right'
            }
        ],
        toolbarItems: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "3px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                value: search.companyId,
                                updateValue: (id)=>setSearch({
                                        ...search,
                                        companyId: id
                                    }),
                                options: companies.filter((company)=>!company.isLender).map((company)=>({
                                        label: company.name,
                                        value: company._id
                                    })),
                                placeholder: "All Companies",
                                enablePlaceholderOption: true,
                                boxProps: {
                                    className: 'no-margin-top-bottom'
                                },
                                tooltip: "Filter by Company",
                                disableUnderline: true,
                                disableMargin: true,
                                color: (0, $bNwqO.default).white
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "3px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                value: search.status,
                                updateValue: (status)=>setSearch({
                                        ...search,
                                        status: status
                                    }),
                                options: Object.entries((0, $16167722a89c0415$export$ea3addc32bc92d57)).map(([label, value])=>({
                                        label: label,
                                        value: value
                                    })),
                                placeholder: "Select Status",
                                tooltip: "Filter by Status",
                                disableUnderline: true,
                                disableMargin: true,
                                color: (0, $bNwqO.default).white
                            })
                        ]
                    })
                })
            ]
        }),
        isFiltered: isFiltered,
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        notes: notes,
        notesName: notesName,
        setNotes: setNotes,
        setNotesName: setNotesName,
        children: listData?.map((asset, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        propName: 'notes',
                        isNotes: true,
                        flex: 5,
                        hide: !asset.notes?.length,
                        showNotesPopup: ()=>showNotesPopup(asset.notes, asset.name)
                    },
                    {
                        propName: 'name',
                        content: asset.name,
                        url: `/assets/${asset._id}`
                    },
                    {
                        propName: 'loan.name',
                        content: asset.loan.name,
                        url: `/deals/${asset.loan._id}`
                    },
                    {
                        propName: 'program',
                        content: asset.program
                    },
                    {
                        propName: 'value',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.value),
                        textAlign: 'right'
                    },
                    {
                        propName: 'status',
                        content: (0, $4HqRp.default)(asset.status),
                        textAlign: 'right'
                    },
                    {
                        propName: 'totalAdjustments',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.totalAdjustments ?? 0),
                        textAlign: 'right'
                    },
                    {
                        propName: 'totalPayments',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(asset.totalPayments ?? 0),
                        textAlign: 'right'
                    },
                    {
                        propName: 'effectiveDate',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(asset.effectiveDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                        textAlign: 'right'
                    },
                    {
                        propName: 'nextDate',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(asset.nextDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                        textAlign: 'right'
                    }
                ],
                rowIndex: i
            }, asset._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $65203bb9d3ed6696$export$511353d4f5b5538a = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmClose, setShowConfirmClose] = (0, $lVd4O.useState)(false);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        true,
        false,
        false,
        false,
        false,
        false
    ]);
    /** Computed **/ const assetId = params.assetId;
    const asset = assetStore.currentAsset;
    /** Methods **/ /**
   * Closes the Asset.
   *
   * @remarks
   * We don't ever remove Assets from the system, just mark them as "closed".
   *
   * @remarks
   * Redirects to the Assets List afterwards.
   */ const close = async ()=>{
        if (!asset) return;
        try {
            await assetStore.close(asset?._id);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteAsset.success);
            navigate('/assets');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteAsset.error);
        }
    };
    /**
   * Updates the Company Comments list.
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateCompanyComments = async (companyComments)=>{
        if (!asset) return;
        const response = await assetStore.update({
            ...asset,
            companyComments: companyComments
        });
        if (!response) throw new Error(`Error updating company comments for Asset ID ${asset._id}`);
        assetStore.setCurrentAsset(await assetStore.get(asset._id));
    };
    /**
   * Update Socket Comments
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateSocketComments = async (socketComments)=>{
        if (!asset) return;
        const response = await assetStore.update({
            ...asset,
            socketComments: socketComments
        });
        if (!response) throw new Error(`Error updating socket comments for Asset ID ${asset._id}`);
        assetStore.setCurrentAsset(await assetStore.get(asset._id));
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!asset) return;
        const response = await assetStore.update({
            ...asset,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Asset ID ${asset._id}`);
        assetStore.setCurrentAsset(await assetStore.get(asset._id));
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        assetId && assetStore.get(assetId);
    }, [
        assetId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: asset?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Asset,
        sidebarFlex: "25",
        contentFlex: "75",
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            flexDirection: "column",
            sx: {
                flex: 1
            },
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c93b6043f087dfd6$export$17c0f4fa5885d11), {
                    asset: asset,
                    open: sidebarItems[0],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(0, !sidebarItems[0]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c76f4f389ec00274$export$e9e6a82d894af283), {
                    asset: asset,
                    open: sidebarItems[1],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(1, !sidebarItems[1]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $34c48d72be66f2c1$export$449c1beb1b38d1d2), {
                    asset: asset,
                    open: sidebarItems[2],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(2, !sidebarItems[2]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: asset?.companyComments ?? [],
                    title: "Notes",
                    tooltip: "Add Note",
                    sidebarIndex: 3,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateCompanyComments
                }),
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: asset?.socketComments ?? [],
                    title: "Internal Notes",
                    tooltip: "Add Internal Note",
                    sidebarIndex: 4,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateSocketComments
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
                    documents: asset?.files ?? [],
                    sidebarIndex: 5,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateDocuments: updateFiles
                })
            ]
        }),
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit, 'Edit Asset'),
                onClick: ()=>navigate(`/assets/${asset?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41248fcbdc9a27cf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Remove, 'Close Asset', 'Mark Asset as Closed'),
                onClick: ()=>setShowConfirmClose(true)
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: "Are you sure you want to mark this Asset as Closed?",
            open: showConfirmClose,
            setOpen: setShowConfirmClose,
            onOk: ()=>close(),
            label: "Confirm Asset Closing",
            okLabel: "Close",
            cancelLabel: "Cancel"
        }),
        children: asset ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ae4f60d495c7af90$export$a19ed25791c85468), {
            defaultTab: 0,
            children: [
                {
                    index: 0,
                    label: 'Payments',
                    content: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a4de7992bc8a1a37$export$a3eeb7b4564e9c7d), {
                        query: {
                            assetId: asset._id
                        }
                    })
                },
                {
                    index: 1,
                    label: 'Adjustments',
                    content: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $793f41df01b030e4$export$8b686e0d2df13a76), {
                        query: {
                            assetId: asset._id
                        }
                    })
                }
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $897f2e27f29a0ef5$export$f04e3339f964e4c2 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/assets/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $dcc89a56249ef4e6$export$200a7c354c2f6940), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/assets/:assetId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $481f34c9d6bb330b$export$f2702cc94d90999a), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/assets",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $f0aa60e078b28c23$export$1cdc65811e830219), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/assets/:assetId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $65203bb9d3ed6696$export$511353d4f5b5538a), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $ebd18fb00829058f$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), 'FileDownload');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $081e84eb5a3da242$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
}), 'FileUpload');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $5c72bf6c7f83e463$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), 'SwapVert');



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $gvIKB = parcelRequire("gvIKB");

var $6r1xF = parcelRequire("6r1xF");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $9b251a926dadfc3f$export$964336739a8c7119(slot) {
    return (0, $bYZd6.default)('MuiCardContent', slot);
}
const $9b251a926dadfc3f$var$cardContentClasses = (0, $eaNcJ.default)('MuiCardContent', [
    'root'
]);
var $9b251a926dadfc3f$export$2e2bcd8739ae039 = $9b251a926dadfc3f$var$cardContentClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $defc33c31483df0b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $9b251a926dadfc3f$export$964336739a8c7119), classes);
};
const $defc33c31483df0b$var$CardContentRoot = (0, $gvIKB.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $defc33c31483df0b$var$CardContent = /*#__PURE__*/ $lVd4O.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $defc33c31483df0b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $iO5o7.jsx)($defc33c31483df0b$var$CardContentRoot, {
        as: component,
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $defc33c31483df0b$export$2e2bcd8739ae039 = $defc33c31483df0b$var$CardContent;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");



var $lVd4O = parcelRequire("lVd4O");

var $h9hwn = parcelRequire("h9hwn");const $76e40be0b491be0d$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $76e40be0b491be0d$export$2e2bcd8739ae039 = $76e40be0b491be0d$var$visuallyHidden;



function $cd2ca1f322bb7be5$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $cd2ca1f322bb7be5$export$2e2bcd8739ae039 = $cd2ca1f322bb7be5$var$areArraysEqual;


'use client';
const $444aecda5f05a137$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $444aecda5f05a137$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $444aecda5f05a137$var$asc(a, b) {
    return a - b;
}
function $444aecda5f05a137$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $444aecda5f05a137$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $444aecda5f05a137$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $444aecda5f05a137$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $444aecda5f05a137$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $444aecda5f05a137$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($444aecda5f05a137$var$getDecimalPrecision(step)));
}
function $444aecda5f05a137$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($444aecda5f05a137$var$asc);
}
function $444aecda5f05a137$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $444aecda5f05a137$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $cd2ca1f322bb7be5$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $444aecda5f05a137$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $444aecda5f05a137$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $444aecda5f05a137$var$cachedSupportsTouchActionNone;
function $444aecda5f05a137$var$doesSupportTouchActionNone() {
    if ($444aecda5f05a137$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $444aecda5f05a137$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $444aecda5f05a137$var$cachedSupportsTouchActionNone = true;
    }
    return $444aecda5f05a137$var$cachedSupportsTouchActionNone;
}
function $444aecda5f05a137$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $444aecda5f05a137$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $lVd4O.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $lVd4O.useState(-1);
    const [open, setOpen] = $lVd4O.useState(-1);
    const [dragging, setDragging] = $lVd4O.useState(false);
    const moveCount = $lVd4O.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $lVd4O.useRef(null);
    const [valueDerived, setValueState] = (0, $da7ec4d15deb2b86$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($444aecda5f05a137$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $h9hwn.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $lVd4O.useState(-1);
    const sliderRef = $lVd4O.useRef(null);
    const handleRef = (0, $56d901343d819caa$export$2e2bcd8739ae039)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $f4c7fd7821681f04$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $f4c7fd7821681f04$export$2e2bcd8739ae039)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $h9hwn.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $h9hwn.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $444aecda5f05a137$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $444aecda5f05a137$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$444aecda5f05a137$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $444aecda5f05a137$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $444aecda5f05a137$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $444aecda5f05a137$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $444aecda5f05a137$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $444aecda5f05a137$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $444aecda5f05a137$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $936b0567590735ec$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $lVd4O.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $444aecda5f05a137$var$percentToValue(percent, min, max);
        if (step) newValue = $444aecda5f05a137$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $444aecda5f05a137$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $h9hwn.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $444aecda5f05a137$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $h9hwn.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $444aecda5f05a137$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $08e2321bb932106c$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $444aecda5f05a137$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $444aecda5f05a137$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $444aecda5f05a137$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$444aecda5f05a137$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $08e2321bb932106c$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $444aecda5f05a137$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $08e2321bb932106c$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$444aecda5f05a137$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $444aecda5f05a137$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $444aecda5f05a137$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$444aecda5f05a137$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $lVd4O.useCallback(()=>{
        const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $lVd4O.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $444aecda5f05a137$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $lVd4O.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $444aecda5f05a137$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $444aecda5f05a137$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$444aecda5f05a137$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $6a56ba80654449ac$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $444aecda5f05a137$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $444aecda5f05a137$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $5b439fbf43b53f58$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $5b439fbf43b53f58$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $5b439fbf43b53f58$export$2e2bcd8739ae039)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $76e40be0b491be0d$export$2e2bcd8739ae039),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $444aecda5f05a137$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}




var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");

var $9o0F5 = parcelRequire("9o0F5");

const $53f157b5c4542f90$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(Slot);
};
var $53f157b5c4542f90$export$2e2bcd8739ae039 = $53f157b5c4542f90$var$shouldSpreadAdditionalProps;



var $4HqRp = parcelRequire("4HqRp");


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $85abbde04dfb2b51$export$9f59f2622d5cbc2a(slot) {
    return (0, $bYZd6.default)('MuiSlider', slot);
}
const $85abbde04dfb2b51$var$sliderClasses = (0, $eaNcJ.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $85abbde04dfb2b51$export$2e2bcd8739ae039 = $85abbde04dfb2b51$var$sliderClasses;



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $5dc426838350fc34$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $anaDR.default)(open && (0, $85abbde04dfb2b51$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $85abbde04dfb2b51$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $85abbde04dfb2b51$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $5dc426838350fc34$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $5dc426838350fc34$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $lVd4O.cloneElement(children, {
        className: (0, $anaDR.default)(children.props.className)
    }, /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                className: (0, $anaDR.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $iO5o7 = parcelRequire("iO5o7");
'use client';
function $15b7f464124bdea2$var$Identity(x) {
    return x;
}
const $15b7f464124bdea2$export$c1a21b3b4da66aa1 = (0, $gvIKB.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $4HqRp.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $4HqRp.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).thumb}, & .${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $15b7f464124bdea2$export$b02fde61a3559c2 = (0, $gvIKB.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $15b7f464124bdea2$export$105594979f116971 = (0, $gvIKB.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $7KgDD.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: (0, $dRIMW.lighten)(theme.palette[color].main, 0.62),
                            borderColor: (0, $dRIMW.lighten)(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: (0, $dRIMW.darken)(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: (0, $dRIMW.darken)(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $15b7f464124bdea2$export$2c1b491743890dec = (0, $gvIKB.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $4HqRp.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $4HqRp.default)(ownerState.size)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).focusVisible}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 8px ${(0, $dRIMW.alpha)(theme.palette[color].main, 0.16)}`
                            },
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).active}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 14px ${(0, $dRIMW.alpha)(theme.palette[color].main, 0.16)}`
                            }
                        }
                    }
                }))
        ]
    })));
const $15b7f464124bdea2$export$6453176f504d54f0 = (0, $gvIKB.default)((0, $5dc426838350fc34$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})((0, $7KgDD.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $85abbde04dfb2b51$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $15b7f464124bdea2$export$6f85f6a3c5da6f62 = (0, $gvIKB.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $9o0F5.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $15b7f464124bdea2$export$e6cd369965e5aa95 = (0, $gvIKB.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $9o0F5.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})((0, $7KgDD.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $15b7f464124bdea2$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $4HqRp.default)(color)}`,
            size && `size${(0, $4HqRp.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $4HqRp.default)(size)}`,
            color && `thumbColor${(0, $4HqRp.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $85abbde04dfb2b51$export$9f59f2622d5cbc2a), classes);
};
const $15b7f464124bdea2$var$Forward = ({ children: children })=>children;
const $15b7f464124bdea2$var$Slider = /*#__PURE__*/ $lVd4O.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $b74605da85fbbf8b$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $15b7f464124bdea2$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $15b7f464124bdea2$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $444aecda5f05a137$export$56b2c08e277f365)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $15b7f464124bdea2$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $15b7f464124bdea2$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $15b7f464124bdea2$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $15b7f464124bdea2$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $15b7f464124bdea2$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $15b7f464124bdea2$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $15b7f464124bdea2$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $15b7f464124bdea2$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $53f157b5c4542f90$export$2e2bcd8739ae039)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $3e009f3d502773cc$export$2e2bcd8739ae039)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $444aecda5f05a137$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $iO5o7.jsxs)($lVd4O.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $anaDR.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $iO5o7.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $anaDR.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $444aecda5f05a137$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $15b7f464124bdea2$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $iO5o7.jsx)(ValueLabelComponent, {
                    ...!(0, $314e9ef39ea63309$export$2e2bcd8739ae039)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $anaDR.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $15b7f464124bdea2$export$2e2bcd8739ae039 = $15b7f464124bdea2$var$Slider;








const $592c7591da758d1c$export$caea88324e87486f = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const bulkStore = (0, $1da4b8b758f1a116$export$18a8f52cc7ad1ddc)();
    /** Ref **/ /** State **/ const [success, setSuccess] = (0, $lVd4O.useState)(false);
    const [wrongFile, setWrongFile] = (0, $lVd4O.useState)();
    const [importProgressBar, setImportProgressBar] = (0, $lVd4O.useState)(1);
    const [queue, setQueue] = (0, $lVd4O.useState)({});
    const [uploadStatus, setUploadStatus] = (0, $lVd4O.useState)((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
    /** Computed **/ /**
   * Data must be imported in this order.
   */ const steps = {
        1: {
            title: 'Step 1: Import Companies',
            fileName: 'company.csv'
        },
        2: {
            title: 'Step 2: Import Deals',
            fileName: 'loan.csv'
        },
        3: {
            title: 'Step 3: Import Participations',
            fileName: 'participation.csv'
        },
        4: {
            title: 'Step 4: Import Assets',
            fileName: 'asset.csv'
        },
        5: {
            title: 'Step 5: Import Advances',
            fileName: 'advance.csv'
        },
        6: {
            title: 'Step 6: Import Payments',
            fileName: 'payment.csv'
        },
        7: {
            title: 'Database Import Complete!'
        }
    };
    const fileForm = document.getElementById('fileForm');
    const fileInput = document.getElementById('fileInput');
    /** Methods **/ const openFileDialog = ()=>{
        if (uploadStatus !== (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading) fileInput?.click();
    };
    /**
   * Validates and queues files for upload.
   *
   * @param files List of files to upload. Can be null.
   */ const handleFileSelect = (files)=>{
        if (files) {
            if (steps[importProgressBar] && files?.[0].name !== steps[importProgressBar].fileName) {
                setWrongFile(steps[importProgressBar].fileName);
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
            } else {
                setQueue(files);
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Queued);
            }
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (queue.length && uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Queued) {
            const upload = async ()=>{
                if (!fileForm) return;
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading);
                const request = new FormData(fileForm);
                await (0, $653633979076e8c9$export$252777fe0fb3a7d).import(request);
                setSuccess(true);
                setImportProgressBar(importProgressBar + 1);
                setUploadStatus((0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Ready);
            };
            upload();
        }
    }, [
        queue,
        uploadStatus,
        fileForm,
        importProgressBar
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
            className: "md-content",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                "layout-align": "center top",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                    width: "50%",
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                className: "toolbar-div pad-top-bottom-xs",
                                "layout-align": "center center",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        component: "span",
                                        display: "flex"
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        display: "flex",
                                        "layout-align": "center center",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5c72bf6c7f83e463$export$2e2bcd8739ae039), {
                                                className: "md-icons material-icons"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                className: "md-title pad-left-xs",
                                                children: "Data Import/Export"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        component: "span",
                                        display: "flex"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        "layout-align": "space-between center",
                                        className: "margin-bottom-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                display: "flex",
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                        component: "span",
                                                        className: "textZoomIn",
                                                        children: "Import Data"
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                        component: "span",
                                                        className: "text-size-md",
                                                        children: "Files must be in CSV format."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                                className: "md-fab md-mini md-primary",
                                                onClick: ()=>openFileDialog(),
                                                disabled: uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading,
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                    title: "Import Data",
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $081e84eb5a3da242$export$2e2bcd8739ae039), {
                                                        className: "md-icons material-icons"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $15b7f464124bdea2$export$2e2bcd8739ae039), {
                                            className: "md-primary",
                                            onChange: (_, step)=>{
                                                if (typeof step === 'number') setImportProgressBar(step);
                                            },
                                            value: importProgressBar,
                                            disabled: true,
                                            step: null,
                                            marks: new Array(7).map((_, i)=>({
                                                    value: i + 1
                                                })),
                                            min: 1,
                                            max: 7,
                                            sx: {
                                                display: 'flex'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                            component: "span",
                                            className: "md-title text-sm-mobile",
                                            children: steps[importProgressBar].title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)("form", {
                                        name: "fileForm",
                                        id: "fileForm",
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)("input", {
                                            type: "file",
                                            id: "fileInput",
                                            name: "fileInput",
                                            onChange: (e)=>handleFileSelect(e.target.files),
                                            style: {
                                                display: 'none'
                                            }
                                        })
                                    })
                                ]
                            }),
                            (bulkStore.returnMessage?.saved.length || bulkStore.returnMessage?.errors.length || bulkStore.error || wrongFile) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                            (bulkStore.returnMessage?.saved.length || bulkStore.returnMessage?.errors.length || bulkStore.error || uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading || wrongFile) && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                },
                                children: [
                                    uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $570333f629f71c57$export$2e2bcd8739ae039), {
                                            className: "md-primary",
                                            "md-mode": "determinate"
                                        })
                                    }),
                                    bulkStore.error && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7981c36822c6d83d$export$2e2bcd8739ae039), {
                                                className: "md-icon material-icons pad-right-xs"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                className: "thin",
                                                children: "There was an error importing the data."
                                            })
                                        ]
                                    }),
                                    wrongFile && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7981c36822c6d83d$export$2e2bcd8739ae039), {
                                                className: "md-icon material-icons pad-right-xs"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                className: "thin",
                                                children: [
                                                    "Please select a file named ",
                                                    wrongFile,
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    bulkStore.returnMessage?.saved.length && uploadStatus !== (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading && !bulkStore.error && success && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        },
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c31f5fc9848a62be$export$2e2bcd8739ae039), {
                                                className: "md-icon material-icons pad-right-xs"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                className: "thin",
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                        component: "span",
                                                        className: "medium",
                                                        children: bulkStore.returnMessage?.saved.length
                                                    }),
                                                    ' ',
                                                    "Items imported successfully."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $570333f629f71c57$export$2e2bcd8739ae039), {
                                        className: "md-primary",
                                        "md-mode": "determinate"
                                    })
                                ]
                            }),
                            bulkStore.exportIsActive && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                        sx: {
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                className: "textZoomIn",
                                                children: "Export Transactions"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                                component: "span",
                                                display: "flex"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                                className: "md-fab md-mini md-primary",
                                                onClick: ()=>openFileDialog(),
                                                disabled: uploadStatus === (0, $50e9e5a88f291ca6$export$f7cdc72f22de79df).Uploading,
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                    title: "Export Transactions",
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ebd18fb00829058f$export$2e2bcd8739ae039), {
                                                        className: "md-icons material-icons"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");








const $e0481b1dea7de11a$export$507d6a62bb693662 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const companyStore = (0, $1da4b8b758f1a116$export$2242c4b86ec3e2c3)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)({
        name: '',
        longName: '',
        street: '',
        city: '',
        zip: '',
        contactPerson: '',
        phonePrimary: '',
        email: '',
        website: 'https://',
        companyType: '',
        isLender: false,
        notes: [],
        files: []
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        const errorMessages = {
            name: 'Company Name is required',
            socketLineOfBusiness: 'Line of Business is required',
            companyType: 'Company Type is required',
            'address.street': 'Street is required',
            'address.city': 'City is required',
            'address.state': 'State is required',
            'address.zip': 'Zip code is required',
            'phone.primary': 'Primary phone number is required',
            contactPerson: 'Contact person is required'
        };
        if (!formValues?.['name']) errors['name'] = errorMessages['name'];
        if (!formValues?.['socketLineOfBusiness']) errors['socketLineOfBusiness'] = errorMessages['socketLineOfBusiness'];
        if (!formValues?.['companyType']) errors['companyType'] = errorMessages['companyType'];
        if (!formValues?.street) errors['address.street'] = errorMessages['address.street'];
        if (!formValues?.city) errors['address.city'] = errorMessages['address.city'];
        if (!formValues?.state) errors['address.state'] = errorMessages['address.state'];
        if (!formValues?.zip) errors['address.zip'] = errorMessages['address.zip'];
        if (!formValues?.phonePrimary) errors['phone.primary'] = errorMessages['phone.primary'];
        if (!formValues?.['contactPerson']) errors['contactPerson'] = errorMessages['contactPerson'];
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Creates a Company.
   *
   * @remarks
   * Redirects to the new Company's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await companyStore.create(formValues);
            if (!response) throw new Error(`Could not create Company with data: ${JSON.stringify(formValues)}`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8)[response.isLender ? 'createLender' : 'createCompany'].success);
            navigate(`/${response.isLender ? 'investors' : 'companies'}/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8)[formValues.isLender ? 'createLender' : 'createCompany'].error);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Company,
        onCreate: create,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Company Short Name",
                        value: formValues?.name,
                        updateValue: updateFormValue('name'),
                        maxLength: 40,
                        required: true,
                        error: formErrors.name
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Company Long Name",
                        value: formValues?.longName,
                        updateValue: updateFormValue('longName'),
                        maxLength: 40,
                        error: formErrors.longName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                        label: "Line of Business",
                        options: Object.values((0, $5c4a9f32b679a002$export$65e03f16ca8e7cd5)),
                        value: formValues?.socketLineOfBusiness,
                        updateValue: updateFormValue('socketLineOfBusiness'),
                        placeholder: "Line of Business",
                        // placeholder="Select a Line of Business for this Company"
                        required: true,
                        error: formErrors.socketLineOfBusiness
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Company Type",
                        value: formValues?.companyType,
                        updateValue: updateFormValue('companyType'),
                        maxLength: 40,
                        required: true,
                        error: formErrors.companyType
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Street",
                    value: formValues?.street,
                    updateValue: updateFormValue('street'),
                    maxLength: 40,
                    required: true,
                    error: formErrors['address.street']
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 60,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "City",
                            value: formValues?.city,
                            updateValue: updateFormValue('city'),
                            maxLength: 40,
                            required: true,
                            error: formErrors['address.city']
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 15,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            label: "State",
                            value: formValues?.state,
                            options: Object.values((0, $dff1c8c0bf270f18$export$b1f97c3099fc6872)),
                            updateValue: updateFormValue('state'),
                            placeholder: "State",
                            required: true,
                            error: formErrors['address.state']
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 25,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "Zip",
                            value: formValues?.zip,
                            updateValue: updateFormValue('zip'),
                            maxLength: 5,
                            type: "number",
                            required: true,
                            error: formErrors['address.zip']
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Primary Phone",
                        value: formValues?.phonePrimary,
                        updateValue: updateFormValue('phonePrimary'),
                        type: "phone",
                        required: true,
                        error: formErrors['phone.primary']
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Secondary Phone",
                        value: formValues?.phoneSecondary,
                        updateValue: updateFormValue('phoneSecondary'),
                        type: "phone",
                        error: formErrors['phone.secondary']
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Fax",
                        value: formValues?.phoneFax,
                        updateValue: updateFormValue('phoneFax'),
                        type: "phone",
                        error: formErrors['phone.fax']
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Contact Person",
                value: formValues?.contactPerson,
                updateValue: updateFormValue('contactPerson'),
                maxLength: 40,
                required: true,
                error: formErrors.contactPerson
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Email",
                        value: formValues?.email,
                        updateValue: updateFormValue('email'),
                        type: "email",
                        maxLength: 40,
                        boxProps: {
                            className: 'pad-bottom-xs'
                        },
                        error: formErrors.email
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Website",
                        value: formValues?.website,
                        updateValue: updateFormValue('website'),
                        type: "url",
                        maxLength: 40,
                        error: formErrors.website
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");








const $68afe5a82e723da9$export$45aef75b844b0725 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const companyStore = (0, $1da4b8b758f1a116$export$2242c4b86ec3e2c3)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        const errorMessages = {
            name: 'Company Name is required',
            socketLineOfBusiness: 'Line of Business is required',
            companyType: 'Company Type is required',
            'address.street': 'Street is required',
            'address.city': 'City is required',
            'address.zip': 'Zip code is required',
            'phone.primary': 'Primary phone number is required',
            contactPerson: 'Contact person is required'
        };
        if (!formValues?.['name']) errors['name'] = errorMessages['name'];
        if (!formValues?.['socketLineOfBusiness']) errors['socketLineOfBusiness'] = errorMessages['socketLineOfBusiness'];
        if (!formValues?.['companyType']) errors['companyType'] = errorMessages['companyType'];
        if (!formValues?.['address']?.street) errors['address.street'] = errorMessages['address.street'];
        if (!formValues?.['address']?.city) errors['address.city'] = errorMessages['address.city'];
        if (!formValues?.['address']?.zip) errors['address.zip'] = errorMessages['address.zip'];
        if (!formValues?.['phone']?.primary) errors['phone.primary'] = errorMessages['phone.primary'];
        if (!formValues?.['contactPerson']) errors['contactPerson'] = errorMessages['contactPerson'];
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the Company.
   *
   * @remarks
   * Redirects to the Company's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        // Validate form before submitting
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await companyStore.update(formValues);
            if (!response) throw new Error(`Could not update Company with ID "${formValues._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8)[response.isLender ? 'updateLender' : 'updateCompany'].success);
            navigate(`/${response.isLender ? 'lenders' : 'companies'}/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8)[formValues.isLender ? 'updateLender' : 'updateCompany'].error);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.companyId) return;
        Promise.all([
            companyStore.get(params.companyId)
        ]);
    }, [
        params.companyId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (companyStore.currentCompany) setFormValues(companyStore.currentCompany);
    }, [
        companyStore.currentCompany
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: companyStore.currentCompany?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Company,
        onEdit: update,
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        sidebarFlex: "30",
        contentFlex: "70",
        noteOptions: {
            notes: formValues?.notes ?? [],
            onChange: updateFormValue('notes')
        },
        documentOptions: {
            files: formValues?.files ?? [],
            onChange: updateFormValue('files')
        },
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Company Short Name",
                        value: formValues?.name,
                        updateValue: updateFormValue('name'),
                        maxLength: 40,
                        required: true,
                        error: formErrors.name
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Company Long Name",
                        value: formValues?.longName,
                        updateValue: updateFormValue('longName'),
                        maxLength: 40,
                        error: formErrors.longName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                        label: "Line of Business",
                        options: Object.values((0, $5c4a9f32b679a002$export$65e03f16ca8e7cd5)),
                        value: formValues?.socketLineOfBusiness,
                        updateValue: updateFormValue('socketLineOfBusiness'),
                        placeholder: "Select a Line of Business for this Company",
                        required: true,
                        error: formErrors.socketLineOfBusiness
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Company Type",
                        value: formValues?.companyType,
                        updateValue: updateFormValue('companyType'),
                        maxLength: 40,
                        required: true,
                        error: formErrors.companyType
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Street",
                    value: formValues?.address.street,
                    updateValue: (street)=>updateFormValue('address')({
                            ...formValues?.address,
                            street: street
                        }),
                    maxLength: 40,
                    required: true,
                    error: formErrors['address.street']
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 60,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "City",
                            value: formValues?.address.city,
                            updateValue: (city)=>updateFormValue('address')({
                                    ...formValues?.address,
                                    city: city
                                }),
                            maxLength: 40,
                            required: true,
                            error: formErrors['address.city']
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 15,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            label: "State",
                            options: Object.values((0, $dff1c8c0bf270f18$export$b1f97c3099fc6872)),
                            value: formValues?.address.state,
                            updateValue: (state)=>updateFormValue('address')({
                                    ...formValues?.address,
                                    state: state
                                }),
                            placeholder: "State",
                            flex: "15",
                            required: true,
                            error: formErrors['address.state']
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 25,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "Zip",
                            value: formValues?.address.zip,
                            updateValue: (zip)=>updateFormValue('address')({
                                    ...formValues?.address,
                                    zip: zip
                                }),
                            maxLength: 5,
                            type: "number",
                            required: true,
                            error: formErrors['address.zip']
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Primary Phone",
                        value: formValues?.phone?.primary,
                        updateValue: (primary)=>updateFormValue('phone')({
                                ...formValues?.phone,
                                primary: primary
                            }),
                        required: true,
                        error: formErrors['phone.primary']
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Secondary Phone",
                        value: formValues?.phone?.secondary,
                        updateValue: (secondary)=>updateFormValue('phone')({
                                ...formValues?.phone,
                                secondary: secondary
                            }),
                        error: formErrors['phone.secondary']
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Fax",
                        value: formValues?.phone?.fax,
                        updateValue: (fax)=>updateFormValue('phone')({
                                ...formValues?.phone,
                                fax: fax
                            }),
                        error: formErrors['phone.fax']
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Contact Person",
                value: formValues?.contactPerson,
                updateValue: updateFormValue('contactPerson'),
                maxLength: 40,
                required: true,
                error: formErrors.contactPerson
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Email",
                        value: formValues?.email,
                        updateValue: updateFormValue('email'),
                        type: "email",
                        maxLength: 40,
                        error: formErrors.email
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Website",
                        value: formValues?.website,
                        updateValue: updateFormValue('website'),
                        type: "url",
                        maxLength: 40,
                        error: formErrors.website
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $4HqRp = parcelRequire("4HqRp");

var $PKVGF = parcelRequire("PKVGF");





const $6861b1bad07a25e0$export$daba86e045164d80 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'name';
    const defaultSortReverse = false;
    /** Context **/ const companyStore = (0, $1da4b8b758f1a116$export$2242c4b86ec3e2c3)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const companies = companyStore.companies;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (companies) {
            const list = companies.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        }
    }, [
        companies,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        companyStore.query();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Company,
        headerItems: [
            {
                flex: 5,
                propName: 'notes',
                label: 'Notes'
            },
            {
                flex: 1,
                propName: 'name',
                label: 'Name'
            },
            {
                flex: 1,
                propName: 'currentCredit',
                label: 'Current Available Credit'
            },
            {
                flex: 1,
                propName: 'principalBalance',
                label: 'Current Balance'
            },
            {
                flex: 1,
                propName: 'currentAssetValue',
                label: 'Current Asset Values'
            },
            {
                flex: 1,
                propName: 'revenue',
                label: userStore.isAdmin ? 'Revenue (YTD)' : userStore.isLender ? 'Revenue (YTD)' : 'Costs (YTD)'
            },
            {
                flex: 1,
                propName: 'socketLineOfBusiness',
                label: 'Line of Business'
            },
            {
                flex: 1,
                propName: 'status',
                label: 'Status'
            }
        ],
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        notes: notes,
        notesName: notesName,
        setNotes: setNotes,
        setNotesName: setNotesName,
        children: listData?.map((company, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        propName: 'notes',
                        isNotes: true,
                        flex: 5,
                        hide: !company.notes?.length,
                        showNotesPopup: ()=>showNotesPopup(company.notes, company.name)
                    },
                    {
                        propName: 'name',
                        content: company.name,
                        url: `/companies/${company._id}`,
                        hideOverflow: true
                    },
                    {
                        propName: 'currentCredit',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(company.currentCredit)
                    },
                    {
                        propName: 'principalBalance',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(company.principalBalance)
                    },
                    {
                        propName: 'currentAssetValue',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(company.currentAssetValue)
                    },
                    {
                        propName: 'revenue',
                        content: (0, $f90d087769f90e7b$export$7e4aa119212bc614)(company.revenue) ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(company.revenue) : ''
                    },
                    {
                        propName: 'socketLineOfBusiness',
                        content: company.socketLineOfBusiness
                    },
                    {
                        propName: 'status',
                        content: (0, $4HqRp.default)(company.status)
                    }
                ],
                rowIndex: i
            }, company._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $02df4353d3e8ec9b$export$e9b98c562f1590b1 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const companyStore = (0, $1da4b8b758f1a116$export$2242c4b86ec3e2c3)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmDeactivate, setShowConfirmDeactivate] = (0, $lVd4O.useState)(false);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        true,
        false,
        false,
        false
    ]);
    /** Computed **/ const company = companyStore.currentCompany;
    const assetListOptions = {
        value: true,
        originalValue: true,
        currentValue: true,
        program: true,
        status: true,
        totalPayments: true,
        totalAdjustments: true,
        loan: true
    };
    /** Methods **/ /**
   * Deactivates the Company.
   *
   * @remarks
   * We don't ever remove Companies from the system, just mark them as "inactive".
   *
   * @remarks
   * Redirects to the Companies List afterwards.
   */ const deactivate = async ()=>{
        if (!company) return;
        try {
            await companyStore.deactivateCompany(company?._id);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteCompany.success);
            // Redirect to assets
            navigate('/companies');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteCompany.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!company) return;
        const response = await companyStore.update({
            ...company,
            notes: notes
        });
        if (!response) throw new Error(`Error updating notes for Company ID ${company._id}`);
        companyStore.currentCompany = await companyStore.get(company._id);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!company) return;
        const response = await companyStore.update({
            ...company,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Company ID ${company._id}`);
        companyStore.currentCompany = await companyStore.get(company._id);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        params.companyId && companyStore.get(params.companyId);
    }, [
        params.companyId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: company?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Company,
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $244d8ef3bbb462ad$export$97c282f41855dcd5), {
                    company: company,
                    open: sidebarItems[0],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(0, !sidebarItems[0]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $bcbae850b9688487$export$19990a4daa2def24), {
                    company: company,
                    open: sidebarItems[1],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(1, !sidebarItems[1]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: company?.notes ?? [],
                    title: "Notes",
                    tooltip: "Add Note",
                    sidebarIndex: 2,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateNotes
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
                    documents: company?.files ?? [],
                    sidebarIndex: 3,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateDocuments: updateFiles
                })
            ]
        }),
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Edit Company',
                        className: 'md-fab md-mini md-accent md-button md-default-theme'
                    },
                    tooltip: {
                        title: 'Edit Company'
                    }
                },
                onClick: ()=>navigate(`/companies/${company?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Deactivate Company',
                        className: 'md-fab md-mini md-warn md-button md-default-theme',
                        style: {
                            background: (0, $5b108f16e2d84dda$export$bca14c5b3b88a9c9).palette.warning.main,
                            color: 'white'
                        }
                    },
                    tooltip: {
                        title: 'Deactivate Company'
                    }
                },
                onClick: ()=>setShowConfirmDeactivate(true)
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: "Are you sure you want to deactivate this Company? Doing so will deactivate its associated loans and assets as well.",
            open: showConfirmDeactivate,
            setOpen: setShowConfirmDeactivate,
            onOk: ()=>deactivate(),
            label: "Confirm Company Deactivation",
            okLabel: "Deactivate",
            cancelLabel: "Cancel"
        }),
        children: company ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ae4f60d495c7af90$export$a19ed25791c85468), {
            defaultTab: 0,
            children: [
                {
                    index: 0,
                    label: 'Advances',
                    content: company ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4c3e24505b1c6e36$export$ed37f0d324fc0eb4), {
                        query: {
                            companyId: company._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 1,
                    label: 'Payments',
                    content: company ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a4de7992bc8a1a37$export$a3eeb7b4564e9c7d), {
                        query: {
                            companyId: company._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 2,
                    label: 'Assets',
                    content: company ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $60f6c7d7a387095a$export$2a9db9e784596663), {
                        query: {
                            companyId: company._id
                        },
                        viewOptions: assetListOptions
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 3,
                    label: 'Adjustments',
                    content: company ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $793f41df01b030e4$export$8b686e0d2df13a76), {
                        query: {
                            companyId: company._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 4,
                    label: 'Deals',
                    content: company ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $9ac5e4c872c7a2ed$export$d0c4febac53db166), {
                        query: {
                            companyId: company._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                }
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $f8d5db5b06018063$export$9577a4d0122f1bbe = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/companies/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e0481b1dea7de11a$export$507d6a62bb693662), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/companies/:companyId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $68afe5a82e723da9$export$45aef75b844b0725), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/companies",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6861b1bad07a25e0$export$daba86e045164d80), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/companies/:companyId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $02df4353d3e8ec9b$export$e9b98c562f1590b1), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $8e41ecf4f9bc5a0d$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20m6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9"
}), 'NotInterested');







const $1e8a98bb9396e49e$export$fedd53519a0e2bce = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    const dateStore = (0, $1da4b8b758f1a116$export$3f917fb33f736152)();
    /** State **/ const [companyFilter, setCompanyFilter] = (0, $lVd4O.useState)(filterStore.companyGet());
    const [loanFilter, setLoanFilter] = (0, $lVd4O.useState)(filterStore.loanGet());
    const [lenderFilter, setLenderFilter] = (0, $lVd4O.useState)(filterStore.lenderGet());
    /** Computed **/ const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet([
            'name',
            '_id',
            'tags'
        ]).filter((company)=>!company.isLender), [
        filterStore._companyList
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet([
            'name',
            '_id',
            'tags',
            'borrower',
            'lenders'
        ]).filter((l)=>{
            if (companyFilter?._id || lenderFilter?._id) {
                if (companyFilter?._id) return l.borrower._id === companyFilter._id;
                if (lenderFilter?._id) return !!l.lenders?.find((participation)=>participation.company === lenderFilter._id);
            } else return true;
        }), [
        filterStore._loanList,
        companyFilter?._id,
        lenderFilter?._id
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>{
        const l = filterStore.lenderListGet(null, [
            'name',
            '_id',
            'tags'
        ]);
        return Array.isArray(l) ? l.filter((lender)=>{
            return loanFilter?._id ? loanFilter.lenders?.find((participation)=>participation.company === lender._id) : true;
        }) : l && l._id ? [
            l
        ] : [];
    }, [
        filterStore._lenderList,
        loanFilter
    ]);
    /** Methods **/ /**
   * Resets the filter dropdowns.
   */ const resetFilters = ()=>{
        setCompanyFilter(undefined);
        setLoanFilter(undefined);
        setLenderFilter(undefined);
        // Reset date range
        dateStore.setCurrentDate(new Date());
        dateStore.calculateRange();
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!userStore.user) navigate('/signin');
        // If user belongs to a company, add that company as a filter
        if (userStore && userStore.user && !userStore.isLender) setCompanyFilter({
            _id: userStore.user.company
        });
    }, []);
    (0, $lVd4O.useEffect)(()=>{
        if (lenders) filterStore.companyListUpdateLenders();
    }, [
        filterStore._companyList,
        lenders
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (companies) filterStore.companyListUpdateLenders();
    }, [
        filterStore._lenderList,
        companies
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                    component: "md-card",
                    className: "margin-top-10",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "top",
                            alignItems: "center",
                            bgcolor: "white",
                            className: "pad-sides",
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    flex: 1,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    className: "pad-right",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                                        value: companyFilter?._id ?? '',
                                        setValue: (companyId)=>{
                                            setLenderFilter(undefined);
                                            setLoanFilter(undefined);
                                            setCompanyFilter(companies.find((company)=>company._id === companyId));
                                        },
                                        companies: companies,
                                        ariaLabel: "Select a Company",
                                        placeholder: "All Companies",
                                        enablePlaceholderOption: true,
                                        boxProps: {
                                            width: '100%'
                                        },
                                        className: "md-primary no-margin-top-bottom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    flex: 1,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    className: "pad-right",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                                        value: loanFilter?._id ?? '',
                                        setValue: (loanId)=>setLoanFilter(loans.find((loan)=>loan._id === loanId)),
                                        loans: loans,
                                        ariaLabel: "Select a Deal",
                                        placeholder: "All Deals",
                                        enablePlaceholderOption: true,
                                        boxProps: {
                                            width: '100%'
                                        },
                                        className: "md-primary no-margin-top-bottom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    flex: 1,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    className: "pad-right",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $08905dc44ac0415b$export$1e52b2b24171e046), {
                                        value: lenderFilter?._id ?? '',
                                        setValue: (lenderId)=>setLenderFilter(lenders.find((lender)=>lender._id === lenderId)),
                                        lenders: lenders,
                                        ariaLabel: "Select an Investor",
                                        placeholder: "All Investors",
                                        enablePlaceholderOption: true,
                                        boxProps: {
                                            width: '100%'
                                        },
                                        className: "md-primary no-margin-top-bottom"
                                    })
                                }),
                                (companyFilter?._id || loanFilter?._id || lenderFilter?._id) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                    component: "span",
                                    className: "right",
                                    "layout-align": "center center",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        sx: {
                                            cursor: 'pointer'
                                        },
                                        onClick: ()=>resetFilters(),
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                            title: "Clear Filters",
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8e41ecf4f9bc5a0d$export$2e2bcd8739ae039), {
                                                className: "pad-left-xs"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "top",
                            alignItems: "center",
                            bgcolor: "white",
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4d95fff15b40455d$export$79e57034ed04ee78), {
                                company: companyFilter,
                                loan: loanFilter,
                                lender: lenderFilter
                            })
                        }),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ae4f60d495c7af90$export$a19ed25791c85468), {
                            defaultTab: 0,
                            children: [
                                {
                                    index: 0,
                                    label: 'Monthly Activity',
                                    content: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $90b55d3d3a306eb6$export$12829f7d8872d6be), {
                                        companyFilter: companyFilter,
                                        loanFilter: loanFilter,
                                        lenderFilter: lenderFilter
                                    })
                                },
                                {
                                    index: 1,
                                    label: 'Transactions',
                                    content: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d3330c51d9739b57$export$294daaca83af1301), {
                                        loan: loanFilter
                                    })
                                }
                            ]
                        })
                    ]
                }),
                (userStore.isAdmin || userStore.isLender) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6de737cc2e500997$export$45b7a635e7285757), {})
            ]
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $4HqRp = parcelRequire("4HqRp");

var $PKVGF = parcelRequire("PKVGF");





const $680cbf817e5240e0$export$b6981798910bc408 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'name';
    const defaultSortReverse = false;
    /** Context **/ const lenderStore = (0, $1da4b8b758f1a116$export$9e981f97ad523833)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    /** Computed **/ const lenders = lenderStore.lenders;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (lenders) {
            const list = lenders.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        }
    }, [
        lenders,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Lender,
        createUrl: '/companies/create',
        headerItems: [
            {
                flex: 1,
                propName: 'name',
                label: 'Name'
            },
            {
                flex: 1,
                propName: 'loansParticipatedIn',
                label: 'Deals Participated In',
                type: 'number'
            },
            {
                flex: 1,
                propName: 'currentBalance',
                label: 'Current Total Balance'
            },
            {
                flex: 1,
                propName: 'status',
                label: 'Investor Status'
            }
        ],
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        children: listData?.map((lender, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        propName: 'name',
                        content: lender.name,
                        url: `/investors/${lender._id}`
                    },
                    {
                        propName: 'loansParticipatedIn',
                        content: lender.loansParticipatedIn
                    },
                    {
                        propName: 'currentBalance',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(lender.currentBalance)
                    },
                    {
                        propName: 'status',
                        content: (0, $4HqRp.default)(lender.status)
                    }
                ],
                rowIndex: i
            }, lender._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $2122aaca5dd65c94$export$49268d315e497a02 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const companyStore = (0, $1da4b8b758f1a116$export$2242c4b86ec3e2c3)();
    const lenderStore = (0, $1da4b8b758f1a116$export$9e981f97ad523833)();
    const statementHeadlinesStore = (0, $1da4b8b758f1a116$export$31ae50f0086b267)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showLedgerPopup, setShowLedgerPopup] = (0, $lVd4O.useState)(false);
    const [showConfirmDeactivate, setShowConfirmDeactivate] = (0, $lVd4O.useState)(false);
    const [lender, setLender] = (0, $lVd4O.useState)();
    const [notes] = (0, $lVd4O.useState)([]);
    const [files] = (0, $lVd4O.useState)([]);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        true,
        false,
        false,
        false,
        false,
        false
    ]);
    /** Methods **/ /**
   * Deactivates the Lender.
   *
   * @remarks
   * We don't ever remove Lenders from the system, just mark them as "inactive".
   *
   * @remarks
   * Redirects to the Lenders List afterwards.
   */ const deactivate = async ()=>{
        if (!lender) return;
        try {
            await lenderStore.deactivate(lender?._id);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteLender.success);
            // Redirect to lenders
            navigate('/lenders');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteLender.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!lender) return;
        const response = await companyStore.update({
            ...lender,
            notes: notes
        });
        if (!response) throw new Error(`Error updating notes for Lender ID ${lender._id}`);
        lenderStore.currentLender = await lenderStore.get(lender._id);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!lender) return;
        const response = await companyStore.update({
            ...lender,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Lender ID ${lender._id}`);
        lenderStore.currentLender = await lenderStore.get(lender._id);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.lenderId) return;
        Promise.all([
            lenderStore.get(params.lenderId),
            statementHeadlinesStore.get({
                lenderId: params.lenderId
            })
        ]);
    }, [
        params.lenderId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (lenderStore.currentLender && statementHeadlinesStore.lenderStatementHeadlines) {
            const headlines = statementHeadlinesStore.lenderStatementHeadlines;
            setLender({
                ...lenderStore.currentLender,
                alltime: headlines.alltime,
                ytd: headlines.ytd
            });
        }
    }, [
        lenderStore.currentLender,
        statementHeadlinesStore.lenderStatementHeadlines
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: lender?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Lender,
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f233e3b681f6d7f$export$7d8fd244d7da7f91), {
                    lender: lender,
                    open: sidebarItems[0],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(0, !sidebarItems[0]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $37791693c4460ea0$export$6dd91515a4716fcd), {
                    lender: lender,
                    open: sidebarItems[1],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(1, !sidebarItems[1]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $80243c13f35b435b$export$27b0f39d8596faa0), {
                    lender: lender,
                    open: sidebarItems[2],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(2, !sidebarItems[2])),
                    setShowLedgerPopup: setShowLedgerPopup
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6beec9822bb5e1cc$export$218382a9390eb464), {
                    lender: lender,
                    open: sidebarItems[3],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(3, !sidebarItems[3]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: notes ?? [],
                    title: "Notes",
                    tooltip: "Add Note",
                    sidebarIndex: 4,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateNotes
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
                    documents: files ?? [],
                    sidebarIndex: 5,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateDocuments: updateFiles
                })
            ]
        }),
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Edit Investor',
                        className: 'md-fab md-mini md-accent md-button md-default-theme'
                    },
                    tooltip: {
                        title: 'Edit Investor'
                    }
                },
                onClick: ()=>navigate(`/companies/${lender?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item md-warn",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Deactivate Investor',
                        className: 'md-fab md-mini md-warn md-button md-default-theme',
                        style: {
                            background: (0, $5b108f16e2d84dda$export$bca14c5b3b88a9c9).palette.warning.main,
                            color: 'white'
                        }
                    },
                    tooltip: {
                        title: 'Deactivate Investor'
                    }
                },
                onClick: ()=>setShowConfirmDeactivate(true)
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
                    content: "Are you sure you want to deactivate this Investor? Doing so will deactivate its associated loans and assets as well.",
                    open: showConfirmDeactivate,
                    setOpen: setShowConfirmDeactivate,
                    onOk: ()=>deactivate(),
                    label: "Confirm Lender Deactivation",
                    okLabel: "Deactivate",
                    cancelLabel: "Cancel"
                }),
                lender && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8a627ea3c55963d3$export$c1af37dd38d7de63), {
                    lender: lender,
                    setLender: setLender,
                    open: showLedgerPopup,
                    setOpen: setShowLedgerPopup
                })
            ]
        }),
        children: lender ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ae4f60d495c7af90$export$a19ed25791c85468), {
            defaultTab: 0,
            children: [
                {
                    index: 0,
                    label: 'Participations',
                    content: lender ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5b8ecd84f957630c$export$7281d451a4749566), {
                        data: lender.participations ?? []
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 1,
                    label: 'Advances',
                    content: lender ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4c3e24505b1c6e36$export$ed37f0d324fc0eb4), {
                        query: {
                            lenderId: lender._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 2,
                    label: 'Payments',
                    content: lender ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a4de7992bc8a1a37$export$a3eeb7b4564e9c7d), {
                        query: {
                            lenderId: lender._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                }
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $e8c39a09e4f9ecd4$export$340be184fa44c4bb = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/investors",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $680cbf817e5240e0$export$b6981798910bc408), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/investors/:lenderId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2122aaca5dd65c94$export$49268d315e497a02), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $c709b92aa8b5b483$export$f517e1b983436238 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const loanStore = (0, $1da4b8b758f1a116$export$2069e70401eb38b3)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        true
    ]);
    const [formValues, setFormValues] = (0, $lVd4O.useState)({
        name: '',
        isOwned: false,
        amount: 0,
        interestRate: 0,
        advanceRate: 0,
        originationFee: 0,
        term: 0,
        minimumPayment: 0,
        status: (0, $2dfb8a4751b2faae$export$bbc9c51434c18c55).Active,
        socketComments: [],
        companyComments: [],
        files: [],
        principalDateUpdated: new Date(),
        lenders: [],
        adminFee: 0,
        discountFee: 0,
        payDownPercent: 0
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const dealType = (0, $lVd4O.useMemo)(()=>formValues?.isOwned ? (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned : (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan, [
        formValues?.isOwned
    ]);
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            setFormValues((prev)=>({
                    ...prev,
                    [key]: value
                }));
            if (formErrors[key]) setFormErrors((prev)=>({
                    ...prev,
                    [key]: ''
                }));
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        const errorMessages = {
            name: 'Deal Name is required',
            dealType: 'Deal Type is required',
            borrower: 'Borrower is required',
            amount: 'Valid amount is required',
            advanceRate: 'Advance Rate is required',
            term: 'Term is required',
            maturityDate: 'Maturity Date is required',
            lastAdvanceDate: 'Last Advance Date is required',
            interestRate: 'Interest Rate is required',
            originationFee: 'Origination Fee is required',
            minimumPayment: 'Minimum Payment is required',
            payDownPercent: 'Pay Down Percent is required',
            minPmtMethod: 'Minimum Payment Method is required',
            adminFee: 'Admin Fee is required',
            discountFee: 'Discount Fee is required'
        };
        if (!formValues?.['name']) errors['name'] = errorMessages['name'];
        if (typeof formValues?.['isOwned'] !== 'boolean') errors['dealType'] = errorMessages['dealType'];
        if (!formValues?.['borrower']) errors['borrower'] = errorMessages['borrower'];
        if (!formValues?.['amount'] || !(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['amount'])) errors['amount'] = errorMessages['amount'];
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['advanceRate'])) errors['advanceRate'] = errorMessages['advanceRate'];
        if (dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan) {
            if (!formValues?.['maturityDate']) errors['maturityDate'] = errorMessages['maturityDate'];
            if (!formValues?.['lastAdvanceDate']) errors['lastAdvanceDate'] = errorMessages['lastAdvanceDate'];
            if (!formValues?.['term']) errors['term'] = errorMessages['term'];
            if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['interestRate'])) errors['interestRate'] = errorMessages['interestRate'];
            if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['originationFee'])) errors['originationFee'] = errorMessages['originationFee'];
            if (formValues?.['minPmtMethod'] === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).SetAmount && !formValues?.['minimumPayment']) errors['minimumPayment'] = errorMessages['minimumPayment'];
            if (formValues?.['minPmtMethod'] === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).PayDown && dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && !(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['payDownPercent'])) errors['payDownPercent'] = errorMessages['payDownPercent'];
            if (!formValues?.['minPmtMethod']) errors['minPmtMethod'] = errorMessages['minPmtMethod'];
        } else if (dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned) {
            if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['adminFee'])) errors['adminFee'] = errorMessages['adminFee'];
            if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['discountFee'])) errors['discountFee'] = errorMessages['discountFee'];
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Creates a Loan.
   *
   * @remarks
   * Redirects to the new Loan's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await loanStore.create(formValues);
            if (!response) throw new Error(`Could not create Loan with data: ${JSON.stringify(formValues)}`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createLoan.success);
            navigate(`/deals/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createLoan.error);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Loan,
        onCreate: create,
        sidebarFlex: "40",
        contentFlex: "60",
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cc4ed34d900a0882$export$3640f67146a55712), {
            open: sidebarItems[0],
            toggleOpen: ()=>setSidebarItems(sidebarItems.with(0, !sidebarItems[0])),
            participations: formValues.lenders,
            setParticipations: updateFormValue('lenders')
        }),
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                id: "company",
                value: formValues?.borrower ?? '',
                setValue: updateFormValue('borrower'),
                companies: companies,
                required: true,
                error: formErrors.borrower
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 70,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "Deal Name",
                            value: formValues?.name,
                            updateValue: updateFormValue('name'),
                            required: true,
                            error: formErrors.name
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 30,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            label: "Deal Type",
                            options: Object.values((0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09)),
                            value: dealType,
                            updateValue: (dealType)=>updateFormValue('isOwned')(dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned),
                            placeholder: "Deal Type",
                            required: true,
                            tooltip: "Deal type cannot be changed after the Deal is created",
                            error: formErrors.dealType
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Amount",
                        value: formValues?.amount,
                        tooltip: 'Total indebtedness including principal and outstanding interest charges ("Commitment Amount")',
                        updateValue: updateFormValue('amount'),
                        min: "0",
                        moneyMask: true,
                        required: true,
                        error: formErrors.amount
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Advance Rate",
                        tooltip: "Percent of the value of eligible assets that can be made available for advances",
                        value: formValues?.advanceRate,
                        updateValue: updateFormValue('advanceRate'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.advanceRate
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                        label: "Min. Monthly Pmt. Method",
                        options: Object.values((0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39)),
                        value: formValues?.minPmtMethod,
                        updateValue: updateFormValue('minPmtMethod'),
                        placeholder: "Select Method...",
                        error: formErrors.minPmtMethod
                    }),
                    formValues.minPmtMethod === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).SetAmount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Minimum Payment",
                        value: formValues?.minimumPayment,
                        updateValue: updateFormValue('minimumPayment'),
                        min: "0",
                        moneyMask: true,
                        error: formErrors.minimumPayment
                    }),
                    formValues.minPmtMethod === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).PayDown && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Pay Down Percent",
                        value: formValues?.payDownPercent,
                        updateValue: updateFormValue('payDownPercent'),
                        min: "0",
                        percentageMask: true,
                        error: formErrors.payDownPercent
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Term (Months)",
                        value: formValues?.term,
                        updateValue: updateFormValue('term'),
                        type: "number",
                        min: "0",
                        required: dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan,
                        error: formErrors.term
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Maturity Date",
                        value: formValues?.maturityDate,
                        updateValue: updateFormValue('maturityDate'),
                        type: "date",
                        required: true,
                        error: formErrors.maturityDate
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Last Advance Date",
                        value: formValues?.lastAdvanceDate,
                        updateValue: updateFormValue('lastAdvanceDate'),
                        type: "date",
                        required: true,
                        error: formErrors.lastAdvanceDate
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Origination Fee",
                        tooltip: "Percentage fee charged for each advance",
                        value: formValues?.originationFee,
                        updateValue: updateFormValue('originationFee'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.originationFee
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Monthly Interest Rate",
                        tooltip: "Applied daily to the outstanding principal balance",
                        value: formValues?.interestRate,
                        updateValue: updateFormValue('interestRate'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.interestRate
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Administrative Fee",
                        value: formValues?.adminFee,
                        updateValue: updateFormValue('adminFee'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.adminFee
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Discount Fee",
                        value: formValues?.discountFee,
                        updateValue: updateFormValue('discountFee'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.discountFee
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $c876e2c12fc1f0be$export$fcd20780b2e02e01 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const loanStore = (0, $1da4b8b758f1a116$export$2069e70401eb38b3)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        true,
        false,
        false,
        false
    ]);
    /** Computed **/ const dealType = (0, $lVd4O.useMemo)(()=>formValues?.isOwned ? (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned : (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan, [
        formValues?.isOwned
    ]);
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        const errorMessages = {
            name: 'Deal Name is required',
            dealType: 'Deal Type is required',
            borrower: 'Borrower is required',
            amount: 'Amount is required',
            advanceRate: 'Advance Rate is required',
            term: 'Term is required',
            maturityDate: 'Maturity Date is required',
            lastAdvanceDate: 'Last Advance Date is required',
            interestRate: 'Interest Rate is required',
            originationFee: 'Origination Fee is required',
            minimumPayment: 'Minimum Payment is required',
            payDownPercent: 'Pay Down Percent is required',
            minPmtMethod: 'Minimum Payment Method is required'
        };
        if (!formValues?.['name']) errors['name'] = errorMessages['name'];
        if (typeof formValues?.['isOwned'] !== 'boolean') errors['dealType'] = errorMessages['dealType'];
        if (!formValues?.['borrower']) errors['borrower'] = errorMessages['borrower'];
        if (!formValues?.['amount'] || !(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['amount'])) errors['amount'] = errorMessages['amount'];
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['advanceRate'])) errors['advanceRate'] = errorMessages['advanceRate'];
        if (dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan) {
            if (!formValues?.['maturityDate']) errors['maturityDate'] = errorMessages['maturityDate'];
            if (!formValues?.['lastAdvanceDate']) errors['lastAdvanceDate'] = errorMessages['lastAdvanceDate'];
            if (!formValues?.['term']) errors['term'] = errorMessages['term'];
            if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['interestRate'])) errors['interestRate'] = errorMessages['interestRate'];
            if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['originationFee'])) errors['originationFee'] = errorMessages['originationFee'];
            if (formValues?.['minPmtMethod'] === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).SetAmount && !formValues?.['minimumPayment']) errors['minimumPayment'] = errorMessages['minimumPayment'];
            if (formValues?.['minPmtMethod'] === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).PayDown && dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && !(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.['payDownPercent'])) errors['payDownPercent'] = errorMessages['payDownPercent'];
            if (!formValues?.['minPmtMethod']) errors['minPmtMethod'] = errorMessages['minPmtMethod'];
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the Loan.
   *
   * @remarks
   * Redirects to the Loan's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await loanStore.update(formValues);
            if (!response) throw new Error(`Could not update Loan with ID "${formValues._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateLoan.success);
            navigate(`/deals/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateLoan.error);
        }
    };
    /**
   * Updates the Company Comments list.
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateCompanyComments = async (companyComments)=>{
        if (!formValues) return;
        const response = await loanStore.update({
            ...formValues,
            companyComments: companyComments
        });
        if (!response) throw new Error(`Error updating company comments for Loan ID ${formValues._id}`);
        loanStore.currentLoan = await loanStore.get(formValues._id);
    };
    /**
   * Update Socket Comments
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateSocketComments = async (socketComments)=>{
        if (!formValues) return;
        const response = await loanStore.update({
            ...formValues,
            socketComments: socketComments
        });
        if (!response) throw new Error(`Error updating socket comments for Loan ID ${formValues._id}`);
        loanStore.currentLoan = await loanStore.get(formValues._id);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!formValues) return;
        await loanStore.update({
            ...formValues,
            files: files
        });
        updateFormValue('files')(files);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.loanId) return;
        Promise.all([
            loanStore.get(params.loanId)
        ]);
    }, [
        params.loanId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (loanStore.currentLoan) setFormValues(loanStore.currentLoan);
    }, [
        loanStore.currentLoan
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (formValues?.minPmtMethod) {
            updateFormValue('minimumPayment')(0);
            updateFormValue('payDownPercent')(0);
        }
    }, [
        formValues?.minPmtMethod
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: loanStore.currentLoan?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Loan,
        editVerb: "Edit",
        onEdit: update,
        sidebarFlex: "40",
        contentFlex: "60",
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cc4ed34d900a0882$export$3640f67146a55712), {
                    open: sidebarItems[0],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(0, !sidebarItems[0])),
                    participations: formValues?.lenders ?? [],
                    setParticipations: updateFormValue('lenders')
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: formValues?.companyComments ?? [],
                    title: "Notes",
                    tooltip: "Notes",
                    sidebarIndex: 1,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateCompanyComments
                }),
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: formValues?.socketComments ?? [],
                    title: "Internal Notes",
                    tooltip: "Internal Notes",
                    sidebarIndex: 2,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateSocketComments
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
                    documents: formValues?.files ?? [],
                    sidebarIndex: 3,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateDocuments: updateFiles
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                id: "company",
                value: formValues?.borrower?._id ?? '',
                setValue: updateFormValue('borrower'),
                companies: companies,
                disabled: true,
                error: formErrors.borrower
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 70,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                            label: "Deal Name",
                            value: formValues?.name,
                            updateValue: updateFormValue('name'),
                            required: true,
                            error: formErrors.name
                        })
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 30,
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                            title: "Deal type cannot be changed after the Deal is created",
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                    label: "Deal Type",
                                    options: Object.values((0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09)),
                                    value: formValues?.isOwned ? (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned : (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan,
                                    updateValue: (loanType)=>updateFormValue('isOwned')(loanType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned),
                                    placeholder: "Deal Type",
                                    required: true,
                                    disabled: true,
                                    flex: "30",
                                    error: formErrors.dealType
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Amount",
                        value: formValues?.amount,
                        tooltip: 'Total indebtedness including principal and outstanding interest charges ("Commitment Amount")',
                        updateValue: updateFormValue('amount'),
                        min: "0",
                        moneyMask: true,
                        required: true,
                        error: formErrors.amount
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Advance Rate",
                        value: formValues?.advanceRate,
                        tooltip: "Percent of the value of eligible assets that can be made available for advances",
                        updateValue: updateFormValue('advanceRate'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.advanceRate
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                        label: "Min. Monthly Pmt. Method",
                        value: formValues?.minPmtMethod,
                        options: Object.values((0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39)),
                        updateValue: updateFormValue('minPmtMethod'),
                        placeholder: "Select a Method for Calculating Minimum Monthly Payments",
                        flex: "30",
                        error: formErrors.minPmtMethod
                    }),
                    formValues?.minPmtMethod === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).SetAmount && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Minimum Payment",
                        value: formValues?.minimumPayment,
                        updateValue: updateFormValue('minimumPayment'),
                        min: "0",
                        moneyMask: true,
                        error: formErrors.minimumPayment
                    }),
                    formValues?.minPmtMethod === (0, $2dfb8a4751b2faae$export$34b52ce9cfcb0a39).PayDown && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Pay Down Percent",
                        value: formValues?.payDownPercent,
                        updateValue: updateFormValue('payDownPercent'),
                        min: "0",
                        percentageMask: true,
                        error: formErrors.payDownPercent
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Term (Months)",
                        value: formValues?.term,
                        updateValue: updateFormValue('term'),
                        type: "number",
                        min: "0",
                        required: dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan,
                        error: formErrors.term
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Maturity Date",
                        value: formValues?.maturityDate,
                        updateValue: updateFormValue('maturityDate'),
                        type: "date",
                        required: true,
                        error: formErrors.maturityDate
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Last Advance Date",
                        value: formValues?.lastAdvanceDate,
                        updateValue: updateFormValue('lastAdvanceDate'),
                        type: "date",
                        required: true,
                        error: formErrors.lastAdvanceDate
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Origination Fee",
                        value: formValues?.originationFee,
                        tooltip: "Percentage fee charged for each advance",
                        updateValue: updateFormValue('originationFee'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.originationFee
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Monthly Interest Rate",
                        value: formValues?.interestRate,
                        tooltip: "Applied daily to the outstanding principal balance",
                        updateValue: updateFormValue('interestRate'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.interestRate
                    })
                ]
            }),
            dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Administrative Fee",
                        value: formValues?.adminFee,
                        updateValue: updateFormValue('adminFee'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.adminFee
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Discount Fee",
                        value: formValues?.discountFee,
                        updateValue: updateFormValue('discountFee'),
                        min: "0",
                        percentageMask: true,
                        required: true,
                        error: formErrors.discountFee
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $4HqRp = parcelRequire("4HqRp");

var $bNwqO = parcelRequire("bNwqO");


var $PKVGF = parcelRequire("PKVGF");






const $7885d3bbecc54fcd$export$12709e127812864a = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'name';
    const defaultSortReverse = false;
    /** Context **/ const loanStore = (0, $1da4b8b758f1a116$export$2069e70401eb38b3)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [search, setSearch] = (0, $lVd4O.useState)({});
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const loans = loanStore.loans;
    const isFiltered = !!Object.values(search).length;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (loans) {
            let list = loans.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            if (search.companyId) list = list.filter((loan)=>loan.borrower?._id === search.companyId);
            if (search.dealType) list = list.filter((loan)=>search.dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Owned && loan.isOwned || search.dealType === (0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09).Loan && !loan.isOwned);
            else list = [];
            return list;
        }
    }, [
        loans,
        search,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        loanStore.query(search);
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Loan,
        headerItems: [
            {
                flex: 5,
                propName: 'notes',
                label: 'Notes'
            },
            {
                flex: 1,
                propName: 'name',
                label: 'Deal Name'
            },
            {
                flex: 1,
                propName: 'borrower.name',
                label: 'Company'
            },
            {
                flex: 1,
                propName: 'principalBalance',
                label: 'Current Balance',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'assetValue',
                label: 'Current Asset Value',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'originationFee',
                label: 'Origination Fee',
                hide: search.isOwned,
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'adminFee',
                label: 'Administrative Fee',
                hide: !search.isOwned,
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'interestRate',
                label: 'Interest Rate',
                hide: search.isOwned,
                textAlign: 'right'
            },
            // TODO: this is "discountRate" in the header, but "discountFee" in the body (on the List Loans angular view)
            {
                flex: 1,
                propName: 'discountFee',
                label: 'Discount Rate',
                hide: !search.isOwned,
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'created',
                label: 'Date Created',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'type',
                label: 'Type',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'status',
                label: 'Status',
                textAlign: 'right'
            }
        ],
        toolbarItems: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "3px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                value: search.companyId,
                                updateValue: (id)=>setSearch({
                                        ...search,
                                        companyId: id
                                    }),
                                options: companies.map((company)=>({
                                        label: company.name,
                                        value: company._id
                                    })),
                                placeholder: "All Companies",
                                enablePlaceholderOption: true,
                                boxProps: {
                                    className: 'no-margin-top-bottom'
                                },
                                tooltip: "Filter by Company",
                                disableUnderline: true,
                                disableMargin: true,
                                color: (0, $bNwqO.default).white
                            })
                        ]
                    })
                }),
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "3px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                value: search.dealType,
                                updateValue: (dealType)=>setSearch({
                                        ...search,
                                        dealType: dealType
                                    }),
                                placeholder: "Choose a Deal Type...",
                                enablePlaceholderOption: true,
                                options: Object.entries((0, $2dfb8a4751b2faae$export$bb78da1c05bb8d09)).map(([label, value])=>({
                                        label: `${label} Deals`,
                                        value: value
                                    })),
                                disableUnderline: true,
                                disableMargin: true,
                                color: (0, $bNwqO.default).white
                            })
                        ]
                    })
                })
            ]
        }),
        isFiltered: isFiltered,
        noFilteredDataMessage: "No Deals found for that Company.",
        message: !search.dealType ? 'Please choose a Deal Type from the dropdown.' : undefined,
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        notes: notes,
        notesName: notesName,
        setNotes: setNotes,
        setNotesName: setNotesName,
        children: listData?.map((loan, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        propName: 'notes',
                        isNotes: true,
                        flex: 5,
                        hide: !loan.notes?.length,
                        showNotesPopup: ()=>showNotesPopup(loan.notes, loan.name)
                    },
                    {
                        propName: 'name',
                        content: loan.name,
                        url: `/deals/${loan._id}`
                    },
                    {
                        propName: 'borrower.name',
                        content: loan.borrower.name,
                        url: `/companies/${loan.borrower._id}`
                    },
                    {
                        propName: 'principalBalance',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(loan.principalBalance),
                        textAlign: 'right'
                    },
                    {
                        propName: 'assetValue',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(loan.assetValue),
                        textAlign: 'right'
                    },
                    {
                        propName: 'originationFee',
                        content: (0, $4bb6caff349888e9$export$626336c2cd4b14de).format(loan.originationFee),
                        hide: search.isOwned,
                        textAlign: 'right'
                    },
                    {
                        propName: 'adminFee',
                        content: loan.adminFee ? (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(loan.adminFee) : '',
                        hide: !search.isOwned,
                        textAlign: 'right'
                    },
                    {
                        propName: 'interestRate',
                        content: (0, $4bb6caff349888e9$export$626336c2cd4b14de).format(loan.interestRate),
                        hide: search.isOwned,
                        textAlign: 'right'
                    },
                    {
                        propName: 'discountFee',
                        content: loan.discountFee ? (0, $4bb6caff349888e9$export$626336c2cd4b14de).format(loan.discountFee) : undefined,
                        hide: !search.isOwned,
                        textAlign: 'right'
                    },
                    {
                        propName: 'created',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(loan.created).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246)),
                        textAlign: 'right'
                    },
                    {
                        propName: 'type',
                        content: loan.isOwned ? 'Owned' : 'Loan',
                        textAlign: 'right'
                    },
                    {
                        propName: 'status',
                        content: (0, $4HqRp.default)(loan.status),
                        textAlign: 'right'
                    }
                ],
                rowIndex: i
            }, loan._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $fc302e82eaf50271$export$f660e297d593b64d = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const loanStore = (0, $1da4b8b758f1a116$export$2069e70401eb38b3)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmDeactivate, setShowConfirmDeactivate] = (0, $lVd4O.useState)(false);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        true,
        false,
        false,
        false,
        false
    ]);
    /** Computed **/ const loan = loanStore.currentLoan;
    const assetListOptions = {
        notes: true,
        name: true,
        originalValue: true,
        currentValue: true,
        status: true
    };
    /** Methods **/ const deactivate = async ()=>{
        if (!loan) return;
        try {
            await loanStore.deactivate(loan?._id);
            // Show alert
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deleteLoan.success);
            // Redirect to assets
            navigate('/deals');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deleteLoan.error);
        }
    };
    /**
   * Updates the Company Comments list.
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateCompanyComments = async (companyComments)=>{
        if (!loan) return;
        const response = await loanStore.update({
            ...loan,
            companyComments: companyComments
        });
        if (!response) throw new Error(`Error updating company comments for Asset ID ${loan._id}`);
        loanStore.currentLoan = await loanStore.get(loan._id);
    };
    /**
   * Update Socket Comments
   *
   * @remarks
   * This works the same as any other Notes field. We just needed two of them.
   */ const updateSocketComments = async (socketComments)=>{
        if (!loan) return;
        const response = await loanStore.update({
            ...loan,
            socketComments: socketComments
        });
        if (!response) throw new Error(`Error updating socket comments for Asset ID ${loan._id}`);
        loanStore.currentLoan = await loanStore.get(loan._id);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!loan) return;
        const response = await loanStore.update({
            ...loan,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Asset ID ${loan._id}`);
        loanStore.currentLoan = await loanStore.get(loan._id);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.loanId) return;
        Promise.all([
            loanStore.get(params.loanId)
        ]);
    }, [
        params.loanId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: loan?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Loan,
        sidebarFlex: "25",
        contentFlex: "75",
        sidebar: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4808c6d3c8fe8287$export$f96bed44a6dab4bf), {
                    loan: loan,
                    open: sidebarItems[0],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(0, !sidebarItems[0]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $22ac995406cc2454$export$2628809462f3b8e), {
                    loan: loan,
                    open: sidebarItems[1],
                    toggleOpen: ()=>setSidebarItems(sidebarItems.with(1, !sidebarItems[1]))
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: loan?.companyComments ?? [],
                    title: "Notes",
                    tooltip: "Notes",
                    sidebarIndex: 2,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateCompanyComments
                }),
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e43da1956a4b90a$export$aa31b211d2f4c3af), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
                    notes: loan?.socketComments ?? [],
                    title: "Internal Notes",
                    tooltip: "Internal Notes",
                    sidebarIndex: 3,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateNotes: updateSocketComments
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e03ba8c5e5838a24$export$22c59631e6c46e5a), {
                    mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
                    documents: loan?.files ?? [],
                    sidebarIndex: 4,
                    sidebarItems: sidebarItems,
                    setSidebarItems: setSidebarItems,
                    updateDocuments: updateFiles
                })
            ]
        }),
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Edit Deal',
                        className: 'md-fab md-mini md-accent md-button md-default-theme'
                    },
                    tooltip: {
                        title: 'Edit Deal'
                    }
                },
                onClick: ()=>navigate(`/deals/${loan?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                hidden: loan?.status !== (0, $2dfb8a4751b2faae$export$bbc9c51434c18c55).Active,
                className: "md-fab-action-item md-warn",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Deactivate Deal',
                        className: 'md-fab md-mini md-warn md-button md-default-theme',
                        style: {
                            background: (0, $5b108f16e2d84dda$export$bca14c5b3b88a9c9).palette.warning.main,
                            color: 'white'
                        }
                    },
                    tooltip: {
                        title: 'Deactivate Deal'
                    }
                },
                onClick: ()=>loan?.status === (0, $2dfb8a4751b2faae$export$bbc9c51434c18c55).Active ? setShowConfirmDeactivate(true) : {}
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: "Are you sure you want to deactivate this Deal? Doing so will deactivate its associated loans and assets as well.",
            open: showConfirmDeactivate,
            setOpen: setShowConfirmDeactivate,
            onOk: ()=>deactivate(),
            label: "Confirm Deal Deactivation",
            okLabel: "Deactivate",
            cancelLabel: "Cancel"
        }),
        children: loan ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ae4f60d495c7af90$export$a19ed25791c85468), {
            defaultTab: 0,
            children: [
                {
                    index: 0,
                    label: 'Advances',
                    content: loan ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4c3e24505b1c6e36$export$ed37f0d324fc0eb4), {
                        query: {
                            loanId: loan._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 1,
                    label: 'Payments',
                    content: loan ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a4de7992bc8a1a37$export$a3eeb7b4564e9c7d), {
                        query: {
                            loanId: loan._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 2,
                    label: 'Assets',
                    content: loan ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $60f6c7d7a387095a$export$2a9db9e784596663), {
                        query: {
                            loanId: loan._id
                        },
                        viewOptions: assetListOptions
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 3,
                    label: 'Adjustments',
                    content: loan ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $793f41df01b030e4$export$8b686e0d2df13a76), {
                        query: {
                            loanId: loan._id
                        }
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                },
                {
                    index: 4,
                    label: 'Investors',
                    content: loan ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a47b27bbb9242ba$export$b0aae760ecfd650c), {
                        data: loan.lenders
                    }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {})
                }
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $3e5ff6589207682b$export$e5293f74b74b5ba4 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/deals/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c709b92aa8b5b483$export$f517e1b983436238), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/deals/:loanId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $c876e2c12fc1f0be$export$fcd20780b2e02e01), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/deals",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7885d3bbecc54fcd$export$12709e127812864a), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/deals/:loanId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fc302e82eaf50271$export$f660e297d593b64d), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $4HqRp = parcelRequire("4HqRp");

var $bNwqO = parcelRequire("bNwqO");

var $PKVGF = parcelRequire("PKVGF");





const $abccb13ba3abc82e$export$c0421cb03dc4fb40 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'name';
    const defaultSortReverse = false;
    /** Context **/ const participationStore = (0, $1da4b8b758f1a116$export$57265aab020abcea)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [search, setSearch] = (0, $lVd4O.useState)({});
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    /** Computed **/ const participations = participationStore.participations;
    const isFiltered = !!Object.values(search).length;
    const lenders = (0, $lVd4O.useMemo)(()=>filterStore.lenderListGet(), [
        filterStore._lenderList
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet(), [
        filterStore._loanList
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (participations) {
            let list = participations.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            if (search.loanId || search.lenderId) list = list.filter((participation)=>{
                const loanMatch = search.loanId ? participation.loan._id === search.loanId : true;
                const lenderMatch = search.lenderId ? participation.lender?._id === search.lenderId : true;
                return loanMatch && lenderMatch;
            });
            return list;
        }
    }, [
        participations,
        search,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        participationStore.query();
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Participation,
        headerItems: [
            {
                flex: 5,
                propName: '',
                label: ''
            },
            {
                flex: 1,
                propName: 'lender.name',
                label: 'Investor'
            },
            {
                flex: 1,
                propName: 'loan.name',
                label: 'Deal Name'
            },
            {
                flex: 1,
                propName: 'participationPercentage',
                label: 'Participation Percentage',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'relativeBalance',
                label: 'Current Balance',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'feeBalance',
                label: 'Fees Due',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'interestBalance',
                label: 'Interest Due',
                textAlign: 'right'
            },
            {
                flex: 1,
                propName: 'loan.status',
                label: 'Deal Status',
                textAlign: 'right'
            }
        ],
        toolbarItems: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "3px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                placeholder: "All Investors",
                                ariaLabel: "View Deals By Investor",
                                value: search.lenderId,
                                updateValue: (lenderId)=>setSearch({
                                        ...search,
                                        lenderId: lenderId
                                    }),
                                options: (Array.isArray(lenders) ? lenders : [])?.map((lender)=>({
                                        label: lender.name,
                                        value: lender._id
                                    })),
                                enablePlaceholderOption: true,
                                disableUnderline: true,
                                disableMargin: true,
                                color: (0, $bNwqO.default).white
                            })
                        ]
                    })
                }),
                (userStore.isAdmin || userStore.isLender) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    flex: 1,
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        gap: "3px",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                                placeholder: "All Deals",
                                ariaLabel: "View Deals By Investor",
                                value: search.loanId,
                                updateValue: (loanId)=>setSearch({
                                        ...search,
                                        loanId: loanId
                                    }),
                                options: (Array.isArray(loans) ? loans : [])?.map((loan)=>({
                                        label: loan.name,
                                        value: loan._id
                                    })),
                                enablePlaceholderOption: true,
                                disableUnderline: true,
                                disableMargin: true,
                                color: (0, $bNwqO.default).white
                            })
                        ]
                    })
                })
            ]
        }),
        isFiltered: isFiltered,
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        noDataMessage: "You're not participating in any Deals yet.",
        hideCreateButton: true,
        children: listData?.map((participation, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        flex: 5,
                        propName: '',
                        icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $586b74a6bc7bc051$export$2e2bcd8739ae039), {}),
                        isButton: true,
                        tooltip: 'Edit Deal',
                        onClick: ()=>navigate(`/deals/${participation.loan._id}/edit`)
                    },
                    {
                        flex: 1,
                        propName: 'lender.name',
                        content: participation.lender?.name,
                        url: `/investors/${participation.lender?._id}`
                    },
                    {
                        flex: 1,
                        propName: 'loan.name',
                        content: participation.loan.name,
                        url: `/deals/${participation.loan._id}`
                    },
                    {
                        flex: 1,
                        propName: 'participationPercentage',
                        content: (0, $4bb6caff349888e9$export$626336c2cd4b14de).format(participation.participationPercentage),
                        textAlign: 'right'
                    },
                    {
                        flex: 1,
                        propName: 'relativeBalance',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(participation.relativeBalance),
                        textAlign: 'right'
                    },
                    {
                        flex: 1,
                        propName: 'feeBalance',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(participation.loan.feeBalance * participation.participationPercentage),
                        textAlign: 'right'
                    },
                    {
                        flex: 1,
                        propName: 'interestBalance',
                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(participation.loan.interestBalance * participation.participationPercentage),
                        textAlign: 'right'
                    },
                    {
                        flex: 1,
                        propName: 'loan.status',
                        content: (0, $4HqRp.default)(participation.loan.status),
                        textAlign: 'right'
                    }
                ],
                rowIndex: i
            }, i))
    });
});



const $ffb0c2a144bba7e2$export$20bae686c949514 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/participations",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $abccb13ba3abc82e$export$c0421cb03dc4fb40), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");

var $jkA0j = parcelRequire("jkA0j");

var $dRIMW = parcelRequire("dRIMW");

var $lVd4O = parcelRequire("lVd4O");



var $jkA0j = parcelRequire("jkA0j");

var $4HqRp = parcelRequire("4HqRp");

var $8Yw6Z = parcelRequire("8Yw6Z");

var $gvIKB = parcelRequire("gvIKB");




var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $9a9de665e590814b$export$baa0faa0c7ad8085(slot) {
    return (0, $bYZd6.default)('PrivateSwitchBase', slot);
}
const $9a9de665e590814b$var$switchBaseClasses = (0, $eaNcJ.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $9a9de665e590814b$export$2e2bcd8739ae039 = $9a9de665e590814b$var$switchBaseClasses;




var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $02abd04959ec7b64$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $4HqRp.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $9a9de665e590814b$export$baa0faa0c7ad8085), classes);
};
const $02abd04959ec7b64$var$SwitchBaseRoot = (0, $gvIKB.default)((0, $fb7cce4edf16a834$export$2e2bcd8739ae039))({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $02abd04959ec7b64$var$SwitchBaseInput = (0, $gvIKB.default)('input', {
    shouldForwardProp: (0, $8Yw6Z.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $02abd04959ec7b64$var$SwitchBase = /*#__PURE__*/ $lVd4O.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $d420a656705086cf$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $02abd04959ec7b64$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $02abd04959ec7b64$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $02abd04959ec7b64$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $02abd04959ec7b64$export$2e2bcd8739ae039 = $02abd04959ec7b64$var$SwitchBase;


parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $d93e8f693b7b614e$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $84092cd011f2005b$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
'use client';
var $9f52234eb9a18c87$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $4HqRp = parcelRequire("4HqRp");

var $8Yw6Z = parcelRequire("8Yw6Z");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $bc3fa91b59528bc3$export$6c57c6e16b4063b(slot) {
    return (0, $bYZd6.default)('MuiCheckbox', slot);
}
const $bc3fa91b59528bc3$var$checkboxClasses = (0, $eaNcJ.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $bc3fa91b59528bc3$export$2e2bcd8739ae039 = $bc3fa91b59528bc3$var$checkboxClasses;



var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");


var $6r1xF = parcelRequire("6r1xF");



var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $298adc5bce7eca02$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $4HqRp.default)(color)}`,
            `size${(0, $4HqRp.default)(size)}`
        ]
    };
    const composedClasses = (0, $jkA0j.default)(slots, (0, $bc3fa91b59528bc3$export$6c57c6e16b4063b), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $298adc5bce7eca02$var$CheckboxRoot = (0, $gvIKB.default)((0, $02abd04959ec7b64$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $8Yw6Z.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $4HqRp.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $4HqRp.default)(ownerState.color)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $dRIMW.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $92f3facad9078ce8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $bc3fa91b59528bc3$export$2e2bcd8739ae039).checked}, &.${(0, $bc3fa91b59528bc3$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $bc3fa91b59528bc3$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $298adc5bce7eca02$var$defaultCheckedIcon = /*#__PURE__*/ (0, $iO5o7.jsx)((0, $84092cd011f2005b$export$2e2bcd8739ae039), {});
const $298adc5bce7eca02$var$defaultIcon = /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d93e8f693b7b614e$export$2e2bcd8739ae039), {});
const $298adc5bce7eca02$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $iO5o7.jsx)((0, $9f52234eb9a18c87$export$2e2bcd8739ae039), {});
const $298adc5bce7eca02$var$Checkbox = /*#__PURE__*/ $lVd4O.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $298adc5bce7eca02$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $298adc5bce7eca02$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $298adc5bce7eca02$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $298adc5bce7eca02$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $298adc5bce7eca02$var$CheckboxRoot,
        className: (0, $anaDR.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $lVd4O.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $lVd4O.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $e604885c935ab4f8$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $iO5o7.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $298adc5bce7eca02$export$2e2bcd8739ae039 = $298adc5bce7eca02$var$Checkbox;


var $lVd4O = parcelRequire("lVd4O");


var $anaDR = parcelRequire("anaDR");


var $jkA0j = parcelRequire("jkA0j");


var $gvIKB = parcelRequire("gvIKB");

var $7KgDD = parcelRequire("7KgDD");

var $6r1xF = parcelRequire("6r1xF");


var $4HqRp = parcelRequire("4HqRp");

var $eaNcJ = parcelRequire("eaNcJ");

var $bYZd6 = parcelRequire("bYZd6");
function $34c4b70bca999d81$export$717666c39ec07e12(slot) {
    return (0, $bYZd6.default)('MuiFormControlLabel', slot);
}
const $34c4b70bca999d81$var$formControlLabelClasses = (0, $eaNcJ.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $34c4b70bca999d81$export$2e2bcd8739ae039 = $34c4b70bca999d81$var$formControlLabelClasses;





var $iO5o7 = parcelRequire("iO5o7");
'use client';
const $89aa114143d7c720$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $4HqRp.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $jkA0j.default)(slots, (0, $34c4b70bca999d81$export$717666c39ec07e12), classes);
};
const $89aa114143d7c720$export$1b479270917a5676 = (0, $gvIKB.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $34c4b70bca999d81$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $4HqRp.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $7KgDD.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $34c4b70bca999d81$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $34c4b70bca999d81$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $34c4b70bca999d81$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $89aa114143d7c720$var$AsteriskComponent = (0, $gvIKB.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $7KgDD.default)(({ theme: theme })=>({
        [`&.${(0, $34c4b70bca999d81$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $89aa114143d7c720$var$FormControlLabel = /*#__PURE__*/ $lVd4O.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $6r1xF.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $671916c86bb46a18$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $01837c4c011538a4$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $89aa114143d7c720$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $e0c2f7af30c96190$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $cfe213ca21d1ee96$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $cfe213ca21d1ee96$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $iO5o7.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $anaDR.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $iO5o7.jsxs)($89aa114143d7c720$export$1b479270917a5676, {
        className: (0, $anaDR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $lVd4O.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $iO5o7.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $iO5o7.jsxs)($89aa114143d7c720$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $89aa114143d7c720$export$2e2bcd8739ae039 = $89aa114143d7c720$var$FormControlLabel;








const $eb240a9de544b6f3$export$215071c5e2ff0000 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const assetStore = (0, $1da4b8b758f1a116$export$ad85ecc5ecb98730)();
    const paymentStore = (0, $1da4b8b758f1a116$export$f38831fc90eda5d5)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [payoff, setPayoff] = (0, $lVd4O.useState)(false);
    const [formValues, setFormValues] = (0, $lVd4O.useState)({
        name: '',
        company: undefined,
        loan: undefined,
        asset: undefined,
        amount: 0,
        paymentType: '',
        datePaid: '',
        dateDeposited: '',
        effectiveDate: '',
        notes: [],
        files: []
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const isEstimating = paymentStore.isEstimating;
    const payoffEstimate = paymentStore.payoffEstimate;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet().filter((company)=>company.loans?.length), [
        filterStore._companyList
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet().filter((loan)=>loan.assets.length && loan.borrower._id === formValues.company?._id), [
        filterStore._loanList,
        formValues.company
    ]);
    const assets = (0, $lVd4O.useMemo)(()=>formValues.loan?.assets?.filter((asset)=>asset.status === (0, $16167722a89c0415$export$ea3addc32bc92d57).Open).sort((a, b)=>a.name > b.name ? -1 : 1) ?? [], [
        formValues.loan,
        formValues.company
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            setFormValues((prev)=>({
                    ...prev,
                    [key]: value
                }));
            if (formErrors[key]) setFormErrors((prev)=>({
                    ...prev,
                    [key]: ''
                }));
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        const errorMessages = {
            company: 'Company is required',
            loan: 'Loan is required',
            asset: 'Asset is required',
            name: 'Payment Name is required',
            amount: 'Amount is required',
            paymentType: 'Payment Type is required',
            datePaid: 'Date Paid is required',
            dateDeposited: 'Date Deposited is required'
        };
        if (!formValues.company) errors.company = errorMessages.company;
        if (!formValues.loan) errors.loan = errorMessages.loan;
        if (!formValues.asset) errors.asset = errorMessages.asset;
        if (!formValues.name) errors.name = errorMessages.name;
        if (!$f90d087769f90e7b$export$7e4aa119212bc614(formValues.amount) || !formValues.amount) errors.amount = errorMessages.amount;
        if (!formValues.paymentType) errors.paymentType = errorMessages.paymentType;
        if (!formValues.datePaid) errors.datePaid = errorMessages.datePaid;
        if (!formValues.dateDeposited) errors.dateDeposited = errorMessages.dateDeposited;
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const clearSavedEstimate = ()=>{
        paymentStore.payoffEstimate = undefined;
        updateFormValue('dateDeposited')(undefined);
    };
    const clearAsset = ()=>{
        updateFormValue('asset')(undefined);
    };
    const changeCompany = (companyId)=>{
        clearSavedEstimate();
        clearAsset();
        updateFormValue('company')(companies.find((company)=>company._id === companyId));
    };
    const changeLoan = (loanId)=>{
        clearSavedEstimate();
        clearAsset();
        updateFormValue('loan')(loans.find((loan)=>loan._id === loanId));
    };
    const changeAsset = async (assetId)=>{
        const response = await assetStore.get(assetId);
        if (response) updateFormValue('asset')({
            ...assets.find((asset)=>asset._id === assetId),
            expectedResidualPayment: response.expectedResidualPayment,
            currentPayments: response.currentPayments,
            totalDueSocket: response.totalDueSocket
        });
    };
    /**
   * Creates a Payment.
   *
   * @remarks
   * Redirects to the new Payment's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            const response = await paymentStore.create(formValues);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).createPayment.success);
            navigate(`/payments/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createPayment.error);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (payoff && formValues.dateDeposited && formValues.loan && formValues.asset) paymentStore.estimatePayoff(formValues.loan._id, new Date(formValues.dateDeposited));
    }, [
        payoff,
        formValues.dateDeposited,
        formValues.loan,
        formValues.asset
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment,
        onCreate: create,
        createVerb: "Record",
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                value: formValues.company?._id ?? '',
                setValue: changeCompany,
                companies: companies,
                error: formErrors.company
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                value: formValues.loan?._id ?? '',
                setValue: changeLoan,
                loans: loans,
                error: formErrors.loan
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41af608264f61f27$export$1288c65e1f92c76b), {
                value: formValues.asset?._id ?? '',
                setValue: changeAsset,
                assets: assets,
                error: formErrors.asset
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Payment Name",
                field: "name",
                formValues: formValues,
                updateValue: updateFormValue('name'),
                required: true,
                error: formErrors.name
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flexDirection: "column",
                        flex: 50,
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            display: "flex",
                                            alignItems: "center",
                                            className: "padding-25 textZoomIn",
                                            height: "100%",
                                            flex: 1,
                                            gap: "16px",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $89aa114143d7c720$export$2e2bcd8739ae039), {
                                                        label: "Payoff Deal",
                                                        sx: {
                                                            color: 'rgba(0, 0, 0, 0.87)'
                                                        },
                                                        control: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $298adc5bce7eca02$export$2e2bcd8739ae039), {
                                                            checked: payoff,
                                                            onChange: (e)=>setPayoff(e.target.checked),
                                                            name: "payoff"
                                                        })
                                                    })
                                                }),
                                                payoff && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    flex: 80,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    className: "md-title",
                                                    height: "100%",
                                                    children: [
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            paddingBottom: "6px",
                                                            marginBottom: "6px",
                                                            borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                            className: "thin",
                                                            children: "Payoff Estimate"
                                                        }),
                                                        !isEstimating && payoffEstimate && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            id: "payoffEstimate",
                                                            children: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(payoffEstimate)
                                                        }),
                                                        !isEstimating && payoff && !formValues.dateDeposited && !formValues.asset && !formValues.loan && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            className: "md-caption center",
                                                            fontWeight: "100",
                                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                                children: "Please choose a Loan."
                                                            })
                                                        }),
                                                        !isEstimating && payoff && !formValues.dateDeposited && !formValues.asset && formValues.loan && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            className: "md-caption center",
                                                            fontWeight: "100",
                                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                                children: "Please choose an Asset."
                                                            })
                                                        }),
                                                        !isEstimating && payoff && !formValues.dateDeposited && formValues.asset && formValues.loan && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            className: "md-caption center",
                                                            fontWeight: "100",
                                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                                children: "No date deposited set."
                                                            })
                                                        }),
                                                        isEstimating && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            className: "md-caption center",
                                                            fontWeight: "100",
                                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                                children: "Estimating..."
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        display: "flex",
                                        flex: 25,
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                            label: "Amount",
                                            field: "amount",
                                            formValues: formValues,
                                            updateValue: updateFormValue('amount'),
                                            min: "0",
                                            moneyMask: true,
                                            required: true,
                                            error: formErrors.amount
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                label: "Payment Type",
                                field: "paymentType",
                                formValues: formValues,
                                updateValue: updateFormValue('paymentType'),
                                required: true,
                                error: formErrors.paymentType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        className: "md-title thin",
                        height: "100%",
                        flexDirection: "column",
                        gap: "32px",
                        flex: 50,
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        flex: 50,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        className: "md-title",
                                        height: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                paddingBottom: "6px",
                                                marginBottom: "6px",
                                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                className: "thin",
                                                children: "Payments To Date"
                                            }),
                                            formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                id: "currentPayments",
                                                children: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(formValues.asset?.currentPayments ?? 0)
                                            }),
                                            !formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                className: "md-caption center",
                                                fontWeight: "100",
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: "Please select an Asset."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        flex: 50,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        className: "md-title",
                                        height: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                paddingBottom: "6px",
                                                marginBottom: "6px",
                                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                className: "thin",
                                                children: "Total Due Socket"
                                            }),
                                            formValues.asset && formValues.loan?.isOwned && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                id: "totalDueSocket",
                                                children: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(formValues.asset.totalDueSocket || 0)
                                            }),
                                            (!formValues.asset || !formValues.loan?.isOwned) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                className: "md-caption center",
                                                fontWeight: "100",
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: 'Please select an "Owned" Asset.'
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        flex: 50,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        className: "md-title",
                                        height: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                paddingBottom: "6px",
                                                marginBottom: "6px",
                                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                className: "thin",
                                                children: "Initial Payment Amount"
                                            }),
                                            formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                id: "initialPaymentAmount",
                                                children: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(formValues.asset.initialPaymentAmount || 0)
                                            }),
                                            !formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                className: "md-caption center",
                                                fontWeight: "100",
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: "Please select an Asset."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        flex: 50,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        className: "md-title",
                                        height: "100%",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                paddingBottom: "6px",
                                                marginBottom: "6px",
                                                borderBottom: "solid 1px rgba(0,0,0,0.12)",
                                                className: "thin",
                                                children: "Expected Residual Payment"
                                            }),
                                            formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                id: "expectedResidualPayment",
                                                children: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(formValues.asset.expectedResidualPayment || 0)
                                            }),
                                            !formValues.asset && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                className: "md-caption center",
                                                fontWeight: "100",
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: "Please select an Asset."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Paid",
                        field: "datePaid",
                        formValues: formValues,
                        updateValue: updateFormValue('datePaid'),
                        type: "date",
                        required: true,
                        boxProps: {
                            className: 'pad-bottom-xs'
                        },
                        error: formErrors.datePaid
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Deposited",
                        field: "dateDeposited",
                        formValues: formValues,
                        updateValue: updateFormValue('dateDeposited'),
                        type: "date",
                        required: true,
                        boxProps: {
                            className: 'pad-bottom-xs'
                        },
                        error: formErrors.dateDeposited
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $61229fc2cf421871$export$8b8472140d5ea822 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const paymentStore = (0, $1da4b8b758f1a116$export$f38831fc90eda5d5)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Computed **/ const payment = paymentStore.currentPayment;
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues?.name) errors.name = 'Please enter a name';
        if (!(0, $f90d087769f90e7b$export$7e4aa119212bc614)(formValues?.amount) || !formValues?.amount) errors.amount = 'Please enter an amount';
        if (!formValues?.paymentType) errors.paymentType = 'Please select a payment type';
        if (!formValues?.datePaid) errors.datePaid = 'Please select a date paid';
        if (!formValues?.dateDeposited) errors.dateDeposited = 'Please select a date deposited';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the Payment.
   *
   * @remarks
   * Redirects to the Payment's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors before submitting');
            return;
        }
        try {
            const response = await paymentStore.update(formValues);
            if (!response) throw new Error(`Could not update Payment with ID "${formValues._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success('Payment Updated');
            navigate(`/payments/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updatePayment.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!formValues) return;
        await paymentStore.update({
            ...formValues,
            notes: notes
        });
        updateFormValue('notes')(notes);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!formValues) return;
        await paymentStore.update({
            ...formValues,
            files: files
        });
        updateFormValue('files')(files);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        params.paymentId && paymentStore.get(params.paymentId);
    }, [
        params.paymentId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (paymentStore.currentPayment) setFormValues(paymentStore.currentPayment);
    }, [
        paymentStore.currentPayment
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: paymentStore.currentPayment?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment,
        onEdit: update,
        sidebarFlex: "35",
        contentFlex: "65",
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        noteOptions: {
            notes: formValues?.notes ?? [],
            onChange: updateNotes
        },
        documentOptions: {
            files: formValues?.files ?? [],
            onChange: updateFiles
        },
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $41af608264f61f27$export$1288c65e1f92c76b), {
                value: payment?.asset._id ?? '',
                setValue: ()=>{},
                assets: payment?.asset ? [
                    payment.asset
                ] : [],
                disabled: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                label: "Payment Name",
                field: "name",
                formValues: formValues,
                updateValue: updateFormValue('name'),
                required: true,
                error: formErrors.name
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Amount",
                        field: "amount",
                        formValues: formValues,
                        updateValue: updateFormValue('amount'),
                        min: "0",
                        moneyMask: true,
                        required: true,
                        error: formErrors.amount
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Payment Type",
                        field: "paymentType",
                        formValues: formValues,
                        updateValue: updateFormValue('paymentType'),
                        required: true,
                        error: formErrors.paymentType
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Paid",
                        value: formValues?.datePaid,
                        updateValue: updateFormValue('datePaid'),
                        type: "date",
                        required: true,
                        error: formErrors.datePaid,
                        boxProps: {
                            className: 'pad-bottom-xs'
                        }
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Date Deposited",
                        value: formValues?.dateDeposited,
                        updateValue: updateFormValue('dateDeposited'),
                        type: "date",
                        required: true,
                        error: formErrors.dateDeposited,
                        boxProps: {
                            className: 'pad-bottom-xs'
                        }
                    })
                ]
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $bNwqO = parcelRequire("bNwqO");


var $PKVGF = parcelRequire("PKVGF");






const $58a3d839586219e6$export$593150fb73b6601a = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'datePaid';
    const defaultSortReverse = true;
    /** Context **/ const paymentStore = (0, $1da4b8b758f1a116$export$f38831fc90eda5d5)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [search, setSearch] = (0, $lVd4O.useState)({});
    const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [notes, setNotes] = (0, $lVd4O.useState)();
    const [notesName, setNotesName] = (0, $lVd4O.useState)();
    /** Computed **/ const payments = paymentStore.payments;
    const isFiltered = !!Object.values(search).length;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet([
            'name',
            '_id',
            'isLender'
        ]), [
        filterStore._companyList
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (payments) {
            let list = payments.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            if (search.company) list = list.filter((payment)=>payment.company?._id === search.company);
            return list;
        }
    }, [
        payments,
        search,
        sortType,
        sortReverse
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    const showNotesPopup = (notes, name)=>{
        setNotes(notes ?? []);
        setNotesName(name);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        paymentStore.query(search);
    }, []);
    (0, $lVd4O.useEffect)(()=>{
        if (userStore.user && !userStore.isAdmin) setSearch({
            ...search,
            company: userStore.user.company
        });
    }, [
        userStore.user,
        userStore.isAdmin
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment,
        headerItems: [
            {
                flex: 5,
                propName: 'notes',
                label: 'Notes'
            },
            {
                flex: 1,
                propName: 'name',
                label: 'Payment'
            },
            {
                flex: 1,
                propName: 'company.name',
                label: 'Company'
            },
            {
                flex: 1,
                propName: 'asset.name',
                label: 'Asset'
            },
            {
                flex: 1,
                propName: 'program',
                label: 'Program'
            },
            {
                flex: 1,
                propName: 'amount',
                label: 'Amount'
            },
            {
                flex: 1,
                propName: 'paymentType',
                label: 'Payment Type'
            },
            {
                flex: 1,
                propName: 'datePaid',
                label: 'Date Paid'
            },
            {
                flex: 1,
                propName: 'dateDeposited',
                label: 'Date Deposited'
            }
        ],
        toolbarItems: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $iO5o7.Fragment), {
            children: userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                flex: 1,
                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "3px",
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6456bd903e13ed6a$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                            value: search.company,
                            updateValue: (id)=>setSearch({
                                    ...search,
                                    company: id
                                }),
                            options: companies.filter((company)=>!company.isLender).map((company)=>({
                                    label: company.name,
                                    value: company._id
                                })),
                            placeholder: "All Companies",
                            enablePlaceholderOption: true,
                            disableUnderline: true,
                            disableMargin: true,
                            color: (0, $bNwqO.default).white
                        })
                    ]
                })
            })
        }),
        isFiltered: isFiltered,
        noFilteredDataMessage: "No Payments found for that Company.",
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        notes: notes,
        notesName: notesName,
        setNotes: setNotes,
        setNotesName: setNotesName,
        children: listData?.map((payment, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                items: [
                    {
                        propName: 'notes',
                        isNotes: true,
                        flex: 5,
                        hide: !payment.notes?.length,
                        showNotesPopup: ()=>showNotesPopup(payment.notes, payment.name)
                    },
                    {
                        propName: 'name',
                        content: payment.name,
                        url: `/payments/${payment._id}`
                    },
                    {
                        propName: 'company.name',
                        content: payment.company.name,
                        url: `/companies/${payment.company._id}`
                    },
                    {
                        propName: 'asset.name',
                        content: payment.asset?.name,
                        url: `/assets/${payment.asset?._id}`
                    },
                    {
                        propName: 'program',
                        content: payment.program
                    },
                    {
                        propName: 'amount',
                        content: $4bb6caff349888e9$export$f4f21ed02b0ddb8f.format(payment.amount),
                        className: 'text-right'
                    },
                    {
                        propName: 'paymentType',
                        content: payment.paymentType
                    },
                    {
                        propName: 'datePaid',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(payment.datePaid).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                    },
                    {
                        propName: 'dateDeposited',
                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(payment.dateDeposited).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                    }
                ],
                rowIndex: i
            }, payment._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $d80af21033f1d72d$export$91b69bc8e71695eb = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const paymentStore = (0, $1da4b8b758f1a116$export$f38831fc90eda5d5)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmDelete, setShowConfirmDelete] = (0, $lVd4O.useState)(false);
    /**
   * Array of booleans indicating which sidebar items are open.
   *
   * @remarks
   * Each item's index in the array corresponds to its position in the sidebar.
   */ const [sidebarItems, setSidebarItems] = (0, $lVd4O.useState)([
        false,
        false
    ]);
    /** Computed **/ const payment = paymentStore.currentPayment;
    /** Methods **/ /**
   * Removes the Payment.
   *
   * @remarks
   * Redirects to the Payments List afterwards.
   */ const remove = async ()=>{
        if (!payment) return;
        try {
            await paymentStore.remove(payment._id);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deletePayment.success);
            navigate('/payments');
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deletePayment.error);
        }
    };
    /**
   * Updates the Notes list.
   */ const updateNotes = async (notes)=>{
        if (!payment) return;
        const response = await paymentStore.update({
            ...payment,
            notes: notes
        });
        if (!response) throw new Error(`Error updating notes for Payment ID ${payment._id}`);
        paymentStore.currentPayment = await paymentStore.get(payment._id);
    };
    /**
   * Updates the Documents list.
   *
   * @param files List of Document URLs.
   */ const updateFiles = async (files)=>{
        if (!payment) return;
        const response = await paymentStore.update({
            ...payment,
            files: files
        });
        if (!response) throw new Error(`Error updating files for Payment ID ${payment._id}`);
        paymentStore.currentPayment = await paymentStore.get(payment._id);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        params.paymentId && paymentStore.get(params.paymentId);
    }, [
        params.paymentId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: payment?.name ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Payment,
        sidebarItems: sidebarItems,
        setSidebarItems: setSidebarItems,
        sidebarFlex: "35",
        contentFlex: "65",
        noteOptions: {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).View,
            notes: payment?.notes ?? [],
            onChange: updateNotes
        },
        documentOptions: {
            mode: (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit,
            files: payment?.files ?? [],
            onChange: updateFiles
        },
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Edit Payment',
                        className: 'md-fab md-mini md-accent md-button md-default-theme'
                    },
                    tooltip: {
                        title: 'Edit Payment'
                    }
                },
                onClick: ()=>navigate(`/payments/${payment?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                className: "md-fab-action-item md-warn",
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: {
                    fab: {
                        'aria-label': 'Delete Payment',
                        className: 'md-fab md-mini md-warn md-button md-default-theme',
                        style: {
                            background: (0, $5b108f16e2d84dda$export$bca14c5b3b88a9c9).palette.warning.main,
                            color: 'white'
                        }
                    },
                    tooltip: {
                        title: 'Delete Payment'
                    }
                },
                onClick: ()=>setShowConfirmDelete(true)
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: "Are you sure you want to delete this Payment?",
            open: showConfirmDelete,
            setOpen: setShowConfirmDelete,
            onOk: ()=>remove(),
            label: "Confirm Payment Deletion",
            okLabel: "Delete",
            cancelLabel: "Cancel"
        }),
        children: [
            payment && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Asset",
                        value: payment?.asset.name,
                        url: `/assets/${payment?.asset._id}`
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Program",
                        value: payment?.program
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Amount",
                        bold: true,
                        value: payment?.amount,
                        currency: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Payment Type",
                        value: payment?.paymentType
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Date Paid",
                        value: payment?.datePaid,
                        date: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                        title: "Date Deposited",
                        value: payment?.dateDeposited,
                        date: true
                    })
                ]
            }),
            !payment && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                flex: "100",
                justifyContent: "center",
                alignItems: "center",
                className: "pad-top-bottom",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                    className: "md-primary",
                    "md-mode": "indeterminate"
                })
            })
        ]
    });
});



const $5bd07723e1c5073f$export$b4aef71b1c563a49 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/payments/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $eb240a9de544b6f3$export$215071c5e2ff0000), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/payments/:paymentId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $61229fc2cf421871$export$8b8472140d5ea822), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/payments",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $58a3d839586219e6$export$593150fb73b6601a), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/payments/:paymentId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d80af21033f1d72d$export$91b69bc8e71695eb), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $59396668d748ca18$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');




var $bNwqO = parcelRequire("bNwqO");




const $ba4b80aeeee08b01$export$54b483389384521c = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [username, setUsername] = (0, $lVd4O.useState)('');
    const [password, setPassword] = (0, $lVd4O.useState)('');
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    const [, setSigninError] = (0, $lVd4O.useState)('');
    /** Methods **/ /**
   * Validate credentials and log the given User in if valid.
   *
   * @remarks
   * Redirects to the Dashboard after login.
   */ const signin = async ()=>{
        const errors = {};
        if (!username) errors.username = 'Username is required.';
        if (!password) errors.password = 'Password is required.';
        if (Object.keys(errors).length) {
            setFormErrors(errors);
            return;
        }
        try {
            await userStore.signin(username, password);
            navigate('/');
        } catch (err) {
            setSigninError(err.message);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (userStore.user) navigate('/');
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)("form", {
                noValidate: true,
                name: "userForm",
                id: "userForm",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    className: "detail-page-content margin-top",
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flex: "35"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flex: "30",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        sx: {
                                            background: (0, $bNwqO.default).white
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                                                style: {
                                                    padding: '16px'
                                                },
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ea32fe438ad38a6e$export$ee41d60f553c1759), {
                                                    style: {
                                                        maxWidth: '100%'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                                            id: "username",
                                                            label: "Username",
                                                            value: username,
                                                            updateValue: (value)=>setUsername(value),
                                                            error: formErrors.username,
                                                            onPressEnter: ()=>signin()
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                                            id: "password",
                                                            label: "Password",
                                                            value: password,
                                                            updateValue: (value)=>setPassword(value),
                                                            type: "password",
                                                            error: formErrors.password,
                                                            onPressEnter: ()=>signin()
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                                                                to: "/password/forgot",
                                                                className: "md-caption",
                                                                children: "Forgot your password?"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ffffa63de1eb66cb$export$2e2bcd8739ae039), {
                                                                className: "md-fab md-mini",
                                                                "aria-label": "Sign In",
                                                                onClick: ()=>signin(),
                                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                    title: "Sign In",
                                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $59396668d748ca18$export$2e2bcd8739ae039), {
                                                                        className: "material-icons"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flex: "35"
                            })
                        ]
                    })
                })
            })
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $PKVGF = parcelRequire("PKVGF");





const $a43f0afce420d8f3$export$6314483256bf4643 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'effectiveDate';
    const defaultSortReverse = false;
    const rowHeight = 48;
    /** Context **/ const statementStore = (0, $1da4b8b758f1a116$export$5ce405a4422ef92)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [lender, setLender] = (0, $lVd4O.useState)();
    /** Computed **/ const statements = statementStore.statements;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (statements) {
            const list = statements?.toSorted((a, b)=>((0, $PKVGF.get)(a, sortType) ?? 0) - ((0, $PKVGF.get)(b, sortType) ?? 0));
            if (list && sortReverse) list.reverse();
            return list;
        }
    }, [
        statements,
        sortType,
        sortReverse
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>{
        const l = filterStore.lenderListGet();
        return Array.isArray(l) ? l : l && l._id ? [
            l
        ] : [];
    }, [
        filterStore._lenderList
    ]);
    /** Methods **/ /**
   * Sets sortType and sortReverse based on given sortType.
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (lender?._id) statementStore.queryLenderStatements(lender._id);
        return ()=>statementStore.statements = undefined;
    }, [
        lender
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            id: "listLenderStatements",
            component: "md-content",
            className: "md-default-theme",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                component: "md-card",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $1a2a1d044715c64b$export$141c9d2033716579), {
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                children: [
                                    (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Statement],
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-title pad-left-xs",
                                        children: `${userStore.isAdmin ? 'Investor ' : ''} Statements`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        bgcolor: "white",
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "32px",
                            paddingX: "16px",
                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $08905dc44ac0415b$export$1e52b2b24171e046), {
                                value: lender?._id ?? '',
                                setValue: (lenderId)=>{
                                    const lender = lenders.find((lender)=>lender._id === lenderId);
                                    setLender(lender);
                                    if (!lender) statementStore.statements = undefined;
                                },
                                lenders: lenders,
                                ariaLabel: "Select an Investor to view their Statements.",
                                boxProps: {
                                    width: '100%'
                                },
                                className: "md-primary no-margin-top-bottom"
                            })
                        })
                    }),
                    (lender?._id || !!listData?.length) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    lender?._id && !!lender.participations.length && !!listData?.length && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        bgcolor: "white",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                                items: [
                                    {
                                        propName: 'effectiveDate',
                                        label: 'Statement Date'
                                    }
                                ],
                                sortType: sortType,
                                sortReverse: sortReverse,
                                sortList: sortList
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                //  className={listData.length > 11 ? 'fixed-list-lg' : ''}
                                sx: {
                                    maxHeight: `${(11 * rowHeight).toString()}px`
                                },
                                children: listData?.map((statement, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                                        items: [
                                            {
                                                propName: 'effectiveDate',
                                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(statement.effectiveDate).format('MMMM YYYY'),
                                                url: `/statements/investors/${lender?._id}/${(0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(statement.effectiveDate).format('YYYY-M')}`,
                                                linkTarget: '_blank'
                                            }
                                        ],
                                        rowIndex: i
                                    }, statement._id))
                            })
                        ]
                    }),
                    lender && statements && !statements?.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: 'white'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: "100",
                            justifyContent: "center",
                            alignItems: "center",
                            className: "pad-top-bottom md-title thin",
                            children: "No Statements Found."
                        })
                    })
                ]
            })
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $PKVGF = parcelRequire("PKVGF");





const $e10a6eb38d002f45$export$e5c7de443da6c3b9 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = true;
    const rowHeight = 48;
    /** Context **/ const statementStore = (0, $1da4b8b758f1a116$export$5ce405a4422ef92)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [company, setCompany] = (0, $lVd4O.useState)();
    const [loan, setLoan] = (0, $lVd4O.useState)();
    /** Computed **/ const statements = statementStore.statements;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet().filter((company)=>!company.isLender), [
        filterStore._companyList
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet().filter((loan)=>company ? loan.borrower._id === company._id : true), [
        filterStore._loanList,
        company
    ]);
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (statements) {
            const list = statements.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (list && sortReverse) list.reverse();
            return list;
        }
    }, [
        statements,
        sortType,
        sortReverse
    ]);
    /** Methods **/ /**
   * Sets sortType and sortReverse based on given sortType.
   */ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (loan?._id) statementStore.queryLoanStatements(loan._id);
        return ()=>statementStore.statements = undefined;
    }, [
        loan
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            id: "listStatements",
            component: "md-content",
            className: "md-default-theme",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                component: "md-card",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $1a2a1d044715c64b$export$141c9d2033716579), {
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                children: [
                                    (0, $b20f24d98bb11dde$export$69325452aaefb623)[(0, $dff1c8c0bf270f18$export$4c61f29f9791c495).Statement],
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-title pad-left-xs",
                                        children: `${userStore.isAdmin ? 'Deal ' : ''} Statements`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        bgcolor: "white",
                        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "32px",
                            paddingX: "16px",
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                                    value: company?._id ?? '',
                                    setValue: (companyId)=>{
                                        const company = companies.find((company)=>company._id === companyId);
                                        setCompany(company);
                                        setLoan(undefined);
                                    },
                                    companies: companies,
                                    ariaLabel: "Select a Company to view its Statements.",
                                    placeholder: "Select Company",
                                    boxProps: {
                                        width: '100%'
                                    },
                                    className: "md-primary no-margin-top-bottom"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                                    value: loan?._id ?? '',
                                    setValue: (loanId)=>{
                                        const loan = loans.find((loan)=>loan._id === loanId);
                                        setLoan(loan);
                                        if (!loan) statementStore.statements = undefined;
                                    },
                                    loans: loans,
                                    ariaLabel: "Select a Deal",
                                    placeholder: "All Deals",
                                    enablePlaceholderOption: true,
                                    boxProps: {
                                        width: '100%'
                                    },
                                    className: "md-primary no-margin-top-bottom"
                                })
                            ]
                        })
                    }),
                    (loan || !!listData?.length) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                    loan && !!listData?.length && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        bgcolor: "white",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                                items: [
                                    {
                                        propName: 'effectiveDate',
                                        label: 'Statement Date'
                                    }
                                ],
                                sortType: sortType,
                                sortReverse: sortReverse,
                                sortList: sortList
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                // className={listData.length > 11 ? 'fixed-list-lg' : ''}
                                sx: {
                                    maxHeight: `${(11 * rowHeight).toString()}px`
                                },
                                children: listData?.map((statement, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                                        items: [
                                            {
                                                propName: 'effectiveDate',
                                                content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(statement.effectiveDate).format('MMMM YYYY'),
                                                url: `/statements/${loan?._id}/${(0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(statement.effectiveDate).format('YYYY-M')}`,
                                                linkTarget: '_blank'
                                            }
                                        ],
                                        rowIndex: i
                                    }, statement._id))
                            })
                        ]
                    }),
                    loan && listData && !listData.length && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: 'white'
                        },
                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                            display: "flex",
                            flex: "100",
                            justifyContent: "center",
                            alignItems: "center",
                            className: "pad-top-bottom md-title thin",
                            children: "No Statements Found."
                        })
                    })
                ]
            })
        })
    });
});


/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/no-unknown-property */ 
var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");










const $9e6d0302673038bc$export$b47cd23effc71404 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const rowHeight = 48;
    /** Context **/ const statementStore = (0, $1da4b8b758f1a116$export$5ce405a4422ef92)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** Computed **/ const lenderId = params.lenderId;
    const month = params.month;
    const statementDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(month, 'YYYY-MM');
    const startDate = statementDate.startOf('month');
    const endDate = statementDate.endOf('month');
    const headlines = statementStore.headlines;
    const totals = statementStore.totals;
    const loans = statementStore.loans;
    const lender = statementStore.currentLender;
    /** Methods **/ /**
   * Query for LenderStatementTransactions and prepare the data
   */ const getTxns = async (lenderId, month)=>{
        // Make sure the requested statement date is in the past
        if ((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(month, 'YYYY-MM').isBefore((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))())) await statementStore.getLenderStatement(lenderId, month);
        else navigate('/statements');
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (lenderId && month) getTxns(lenderId, month);
    }, [
        lenderId,
        month
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
        className: "content",
        children: /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
            className: "container",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                className: "margin-sides-lg pad-bottom md-default-theme",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "top",
                        className: "margin-top-md pad-sides-xs",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "top",
                                className: "pad-top-sm",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2a4be403ac0774af$export$47ee686680143797), {
                                            className: "margin-right-xs margin-bottom-xs logo-size"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        className: "thin text-size-md",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                className: "medium",
                                                children: "FuSE Financial"
                                            }),
                                            ' ',
                                            "| 801 K Street, Suite 2700 | Sacramento, CA 95814",
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                display: "flex",
                                flex: 1
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flexDirection: "column",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "end",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-headline thin",
                                        children: "Investor Activity Statement"
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-title-print",
                                        children: startDate?.format('MMMM YYYY')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "top",
                        alignItems: "top",
                        className: "margin-top-lg print-margin-top",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flexDirection: "column",
                                display: "flex",
                                justifyContent: "top",
                                alignItems: "top",
                                flex: 33,
                                className: "thin pad-left-sm",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-headline",
                                        children: lender?.longName
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "text-sm",
                                        children: lender?.address?.street
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "text-sm",
                                        children: [
                                            lender?.address?.city,
                                            ", ",
                                            lender?.address?.state,
                                            ", ",
                                            lender?.address?.zip
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flexDirection: "column",
                                display: "flex",
                                flex: 66,
                                justifyContent: "center",
                                alignItems: "top",
                                className: "pad-sides-xs loan-summary-text",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small text-size-md",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: "Month"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: "YTD"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                className: "text-right",
                                                component: "span",
                                                children: "All-Time"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small medium",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Amount Invested"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.account?.amountInvested ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.account?.amountInvested ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.account?.amountInvested ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Current Principal Balances"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.principalBalance ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Fees Collected"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.appliedToFees ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.appliedToFees ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.appliedToFees ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Interest Collected"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.appliedToInterest ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.appliedToInterest ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.appliedToInterest ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Total Revenue"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.totalRevenue ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.totalRevenue ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.totalRevenue ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Socket Fees"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.managementFees ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.managementFees ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.managementFees ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small medium",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Net Revenue Collected"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.netRevenue ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.netRevenue ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.netRevenue ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Returned to Investor"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.account?.amountReturned ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.ytd.account?.amountReturned ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.account?.amountReturned ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small medium",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Holding Account Balance"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.alltime.balances ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Accrued Unpaid Deal Fees"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.feeBalance ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Accrued Unpaid Deal Interest"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.interestBalance ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small medium",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Total Accrued Unpaid Revenue"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.totalUnpaidRevenue ?? 0)
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        className: "margin-top-lg print-margin-top",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33,
                                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    style: {
                                        background: 'white',
                                        display: 'flex',
                                        flex: 100
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "toolbar-div-print text-size-sm",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: "Monthly Deal Balance Activity"
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "statement-list-text",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Begin Principal Balances",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(statementStore.totalBeginPrincipalBalance ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Advances",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.advanceAmount ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Principal Payments",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.principalPaid ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Ending Principal Balances",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(statementStore.totalEndingPrincipalBalance ?? 0)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33,
                                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    style: {
                                        background: 'white',
                                        display: 'flex',
                                        flex: 100
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "toolbar-div-print text-size-sm",
                                            display: "flex",
                                            flex: 1,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex",
                                                    flex: 1
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: "Monthly Payment Activity"
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex",
                                                    flex: 1
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "statement-list-text",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Total Payments",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.paymentAmount ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Fees Paid",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.feesPaid ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Interest Paid",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.interestPaid ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Principal Paid",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.principalPaid ?? 0)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33,
                                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    style: {
                                        background: 'white',
                                        display: 'flex',
                                        flex: 100
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "toolbar-div-print text-size-sm",
                                            display: "flex",
                                            flex: 1,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex",
                                                    flex: 1
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                                    children: "Month-End Asset Summary"
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex",
                                                    flex: 1
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "statement-list-text",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Asset Value",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.assetValue)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Total Available Credit",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.totalAvailableCredit)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Principal Balance",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.principalBalance)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Current Available Credit",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.month?.currentAvailableCredit)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    false
                ]
            })
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $2b09d25fcdda2025$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z"
}), 'Payment');





var $PKVGF = parcelRequire("PKVGF");






const $247d6391fc78310d$export$9fc297a662fe0e6d = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = true;
    const rowHeight = 48;
    /** Context **/ const statementStore = (0, $1da4b8b758f1a116$export$5ce405a4422ef92)();
    const loanStore = (0, $1da4b8b758f1a116$export$2069e70401eb38b3)();
    const companyStore = (0, $1da4b8b758f1a116$export$2242c4b86ec3e2c3)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    const [loan, setLoan] = (0, $lVd4O.useState)();
    /** Computed **/ const loanId = params.loanId;
    const month = params.month;
    const statementDate = (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(month, 'YYYY-MM');
    const startDate = statementDate.startOf('month');
    const endDate = statementDate.endOf('month');
    const headlines = statementStore.headlines?.[0];
    const transactionHistory = statementStore.transactions;
    const totals = statementStore.totals;
    const beginPrincipalBalance = transactionHistory?.[transactionHistory.length - 1].principalBalance;
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (transactionHistory) {
            const list = transactionHistory.toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        transactionHistory,
        sortType,
        sortReverse
    ]);
    /** Methods **/ // Changes list sorting
    const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /**
   * Gets a list of Loan Transactions for the given month.
   *
   * @param loanId ID of the Loan to get transactions for
   * @param month Month string in the format `YYYY-MM`
   */ const getTxns = async (loanId, month)=>{
        if (loanId && month) {
            // Make sure the requested statement date is in the past
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(month, 'YYYY-MM').isBefore((0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))())) {
                const loan = await loanStore.get(loanId);
                if (!loan) return;
                const [borrower] = await Promise.all([
                    companyStore.get(loan?.borrower._id),
                    statementStore.getLoanStatement(loanId, month)
                ]);
                if (!borrower) return;
                setLoan({
                    ...loan,
                    borrower: {
                        ...loan.borrower,
                        longName: borrower?.longName,
                        address: borrower?.address
                    }
                });
            } else navigate('/statements');
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (loanId && month) getTxns(loanId, month);
    }, [
        loanId,
        month
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
        className: "content",
        children: /*#__PURE__*/ (0, $iO5o7.jsx)("section", {
            className: "container",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                className: "margin-sides-lg pad-bottom",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "top",
                        className: "margin-top-md card-margins",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "top",
                                className: "pad-top-sm",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2a4be403ac0774af$export$47ee686680143797), {
                                            className: "margin-right-xs margin-bottom-xs logo-size"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        className: "thin text-size-md",
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                className: "medium",
                                                children: "FuSE Financial"
                                            }),
                                            ' ',
                                            "| 801 K Street, Suite 2700 | Sacramento, CA 95814",
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                display: "flex",
                                flex: 1
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                flexDirection: "column",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "end",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-headline thin",
                                        children: "Deal Activity Statement"
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-title-print",
                                        children: startDate?.format('MMMM YYYY')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "top",
                        alignItems: "top",
                        className: "margin-top-lg print-margin-top card-margins",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "top",
                                alignItems: "top",
                                flex: 70,
                                className: "thin ",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "md-headline",
                                        children: loan?.borrower?.longName
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "text-sm",
                                        children: loan?.borrower?.address?.street
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        className: "text-sm",
                                        children: [
                                            loan?.borrower?.address?.city,
                                            ", ",
                                            loan?.borrower?.address?.state,
                                            ", ",
                                            loan?.borrower?.address?.zip
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "span",
                                display: "flex"
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 30,
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "top",
                                className: "no-margin-right-sm loan-summary-text",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Deal Name"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: loan?.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small medium",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Principal Balance"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.principalBalance)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Fees Due"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transactionHistory?.[0].feesDue ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Interest Due"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transactionHistory?.[0].interestDue ?? 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        className: "height-small",
                                        sx: {
                                            height: '35px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-size-md",
                                                children: "Minimum Payment"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                width: "100%",
                                                component: "span",
                                                className: "text-right",
                                                children: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transactionHistory?.[0].minimumPayment ?? 0)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        className: "margin-top-lg print-margin-top",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33,
                                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    style: {
                                        background: 'white',
                                        display: 'flex',
                                        flex: 100
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "toolbar-div-print text-size-sm",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                }),
                                                "Deal Balances",
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "statement-list-text",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Begin Principal Balance",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(beginPrincipalBalance ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Advances",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.advanceAmount ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Principal Payments",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.principalPaid ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Ending Principal Balance",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.principalBalance ?? 0)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33,
                                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    style: {
                                        background: 'white',
                                        display: 'flex',
                                        flex: 100
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "toolbar-div-print text-size-sm",
                                            display: "flex",
                                            "layout-align": "center center",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                }),
                                                "Payment Summary",
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "statement-list-text",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Total Payments",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.paymentAmount ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Fees Paid",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.feesPaid ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Interest Paid",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.interestPaid ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Principal Paid",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(totals?.principalPaid ?? 0)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                display: "flex",
                                flex: 33,
                                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                                    component: "md-card",
                                    style: {
                                        background: 'white',
                                        display: 'flex',
                                        flex: 100
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "toolbar-div-print text-size-sm",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                }),
                                                "Account Summary",
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                    component: "span",
                                                    display: "flex"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                            className: "statement-list-text",
                                            children: [
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Asset Value",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.assetValue ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Total Credit",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.totalAvailableCredit ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Principal Balance",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.principalBalance ?? 0)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    sx: {
                                                        height: rowHeight,
                                                        padding: '0 16px 0 16px'
                                                    },
                                                    children: [
                                                        "Available Credit",
                                                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                            component: "span",
                                                            display: "flex",
                                                            flex: 1
                                                        }),
                                                        (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(headlines?.currentAvailableCredit ?? 0)
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                        component: "md-card",
                        // className="margin-top-md"
                        style: {
                            background: 'white',
                            display: 'flex',
                            flex: 100,
                            marginTop: '25px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                className: "toolbar-div-print text-size-sm",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        display: "flex"
                                    }),
                                    "Transaction Activity (",
                                    (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(startDate).format((0, $50c68e19ba8e5079$export$26e685d98fdeb12f)),
                                    " - ",
                                    (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(endDate).format((0, $50c68e19ba8e5079$export$26e685d98fdeb12f)),
                                    ")",
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "span",
                                        display: "flex"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                            !!listData.length && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                bgcolor: "white",
                                className: "fadeDown",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                                        items: [
                                            {
                                                propName: '__t',
                                                label: 'Type'
                                            },
                                            {
                                                propName: 'sequenceNumber',
                                                label: 'Effective Date'
                                            },
                                            {
                                                propName: 'advanceAmount',
                                                label: 'Advance Amount',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'feesCharged',
                                                label: 'Fees Charged',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'paymentAmount',
                                                label: 'Payment Amount',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'appliedToFees',
                                                label: 'Fees Paid',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'appliedToInterest',
                                                label: 'Interest Paid',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'appliedToPrincipal',
                                                label: 'Principal Paid',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'newPrincipalBalance',
                                                label: 'Principal Balance',
                                                textAlign: 'right'
                                            }
                                        ],
                                        sortType: sortType,
                                        sortReverse: sortReverse,
                                        sortList: sortList,
                                        hideSortIcon: true,
                                        padForScrollbar: listData.length > 11
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        // component="md-content"
                                        // className={data.length > 11 ? 'fixed-list-lg' : ''}
                                        sx: {
                                            maxHeight: `${(11 * rowHeight).toString()}px`
                                        },
                                        children: listData.map((transaction, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                                                padForScrollbar: listData.length > 11,
                                                items: [
                                                    {
                                                        propName: '__t',
                                                        label: 'Type',
                                                        icon: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
                                                            children: [
                                                                transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                    title: "Advance",
                                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2b09d25fcdda2025$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            fontSize: '1.9em'
                                                                        }
                                                                    })
                                                                }),
                                                                transaction.__t === 'payments' && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                    title: "Payment",
                                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a7cb0a3ec807d22d$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            fontSize: '1.9em'
                                                                        }
                                                                    })
                                                                }),
                                                                transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                    title: "Statement",
                                                                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $aeb975bb40c6c85a$export$2e2bcd8739ae039), {
                                                                        sx: {
                                                                            fontSize: '1.9em'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    },
                                                    {
                                                        propName: 'sequenceNumber',
                                                        label: 'Effective Date',
                                                        content: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(transaction.effectiveDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                                                    },
                                                    {
                                                        propName: 'advanceAmount',
                                                        label: 'Advance Amount',
                                                        content: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.advanceAmount ?? 0),
                                                        url: `/${transaction.__t}/${transaction._id}`,
                                                        textAlign: 'right'
                                                    },
                                                    {
                                                        propName: 'feesCharged',
                                                        label: 'Fees Charged',
                                                        content: transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.originationFee ?? 0),
                                                        url: `/${transaction.__t}/${transaction._id}`,
                                                        textAlign: 'right'
                                                    },
                                                    {
                                                        propName: 'paymentAmount',
                                                        label: 'Payment Amount',
                                                        content: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.paymentAmount ?? 0),
                                                        url: `/${transaction.__t}/${transaction._id}`,
                                                        textAlign: 'right'
                                                    },
                                                    {
                                                        propName: 'appliedToFees',
                                                        label: 'Fees Paid',
                                                        content: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.appliedToFees ?? 0),
                                                        textAlign: 'right'
                                                    },
                                                    {
                                                        propName: 'appliedToInterest',
                                                        label: 'Interest Paid',
                                                        content: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.appliedToInterest ?? 0),
                                                        textAlign: 'right'
                                                    },
                                                    {
                                                        propName: 'appliedToPrincipal',
                                                        label: 'Principal Paid',
                                                        content: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.appliedToPrincipal ?? 0),
                                                        textAlign: 'right'
                                                    },
                                                    {
                                                        propName: 'newPrincipalBalance',
                                                        label: 'Principal Balance',
                                                        content: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format((transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement ? transaction.principalBalance : transaction.newPrincipalBalance) ?? 0),
                                                        textAlign: 'right'
                                                    }
                                                ],
                                                rowIndex: i
                                            }, transaction._id))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                hidden: true,
                                className: "fadeDown",
                                children: [
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8443e75340b01d61$export$3d6ed0715468a113), {
                                        items: [
                                            {
                                                propName: '__t',
                                                label: 'Type'
                                            },
                                            {
                                                propName: 'sequenceNumber',
                                                label: 'Effective Date'
                                            },
                                            {
                                                propName: 'advanceAmount',
                                                label: 'Advance Amount',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'feesCharged',
                                                label: 'Fees Charged',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'paymentAmount',
                                                label: 'Payment Amount',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'appliedToFees',
                                                label: 'Fees Paid',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'appliedToInterest',
                                                label: 'Interest Paid',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'appliedToPrincipal',
                                                label: 'Principal Paid',
                                                textAlign: 'right'
                                            },
                                            {
                                                propName: 'newPrincipalBalance',
                                                label: 'Principal Balance',
                                                textAlign: 'right'
                                            }
                                        ],
                                        sortType: sortType,
                                        sortReverse: sortReverse,
                                        sortList: sortList,
                                        hideSortIcon: true
                                    }),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                        component: "md-content",
                                        children: listData.filter((transaction)=>transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Adjustment).map((transaction, i)=>/*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                                className: `capitalize row-height-${rowHeight} ${i % 2 ? '' : 'highlighted'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                        display: "flex",
                                                        flex: "100",
                                                        justifyContent: "space-around",
                                                        alignItems: "center",
                                                        className: "text-center md-subhead-sm-print",
                                                        children: [
                                                            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                                component: "span",
                                                                width: "100%",
                                                                children: [
                                                                    transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                        title: "Advance",
                                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $2b09d25fcdda2025$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                fontSize: '1.9em'
                                                                            }
                                                                        })
                                                                    }),
                                                                    transaction.__t === 'payments' && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                        title: "Payment",
                                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a7cb0a3ec807d22d$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                fontSize: '1.9em'
                                                                            }
                                                                        })
                                                                    }),
                                                                    transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                                                        title: "Statement",
                                                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $aeb975bb40c6c85a$export$2e2bcd8739ae039), {
                                                                            sx: {
                                                                                fontSize: '1.9em'
                                                                            }
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Effective Date",
                                                                value: (0, (/*@__PURE__*/$parcel$interopDefault($dd0f682fb0da8fa4$exports)))(transaction.effectiveDate).format((0, $50c68e19ba8e5079$export$237cfe6dcad1a246))
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Advance Amount",
                                                                value: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Advance && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.advanceAmount ?? 0),
                                                                url: `/${transaction.__t}/${transaction._id}`,
                                                                textAlign: "right"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Fees Charged",
                                                                value: transaction.__t !== (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.originationFee ?? 0),
                                                                url: `/${transaction.__t}/${transaction._id}`,
                                                                textAlign: "right"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Payment Amount",
                                                                value: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.paymentAmount ?? 0),
                                                                url: `/${transaction.__t}/${transaction._id}`,
                                                                textAlign: "right"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Fees Paid",
                                                                value: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.appliedToFees ?? 0),
                                                                textAlign: "right"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Interest Paid",
                                                                value: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.appliedToInterest ?? 0),
                                                                textAlign: "right"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Interest Due",
                                                                value: transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Payment && (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format(transaction.appliedToPrincipal ?? 0),
                                                                textAlign: "right"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                                component: "span",
                                                                className: "divider-bar"
                                                            }),
                                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3ce0df94cc20588a$export$aba88a2ee03882aa), {
                                                                label: "Principal Balance",
                                                                value: (0, $4bb6caff349888e9$export$f4f21ed02b0ddb8f).format((transaction.__t === (0, $dff1c8c0bf270f18$export$b99e2dfdc8527d3c).Statement ? transaction.principalBalance : transaction.newPrincipalBalance) ?? 0),
                                                                textAlign: "right"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {})
                                                ]
                                            }, transaction._id))
                                    }),
                                    transactionHistory && transactionHistory?.length === 0 && /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a2032c97e5ab093a$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                display: "flex"
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                className: "md-warn",
                                                children: "No transactions found for this period."
                                            }),
                                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                                component: "span",
                                                display: "flex"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});



const $530632050afc9df5$export$3622253e6351bfc7 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/statements/investors",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a43f0afce420d8f3$export$6314483256bf4643), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/statements/investors/:lenderId/:month",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $9e6d0302673038bc$export$b47cd23effc71404), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/statements",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e10a6eb38d002f45$export$e5c7de443da6c3b9), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/statements/:loanId/:month",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $247d6391fc78310d$export$9fc297a662fe0e6d), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");






const $3b6e96d7169325d6$export$2f0eb1bfa125508e = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const dateStore = (0, $1da4b8b758f1a116$export$3f917fb33f736152)();
    /** State **/ const [company, setCompany] = (0, $lVd4O.useState)();
    const [loan, setLoan] = (0, $lVd4O.useState)();
    /** Computed **/ const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet().filter((c)=>company ? c._id === company._id : true), [
        filterStore._companyList,
        company
    ]);
    const loans = (0, $lVd4O.useMemo)(()=>filterStore.loanListGet().filter((l)=>company ? l.borrower._id === company._id : true), [
        filterStore._loanList,
        company
    ]);
    /** Methods **/ const resetFilters = ()=>{
        setCompany(undefined);
        setLoan(undefined);
        dateStore.setCurrentDate(new Date());
        dateStore.calculateRange();
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        filterStore.lenderSet(undefined);
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
            id: "list-transactions",
            children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5f1d95e6bd2f8d5c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $defc33c31483df0b$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                            sx: {
                                flex: 1
                            },
                            "layout-align": "center center",
                            children: [
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6fa7ef33df7fcd44$export$30c48cf6ba1dae4e), {
                                    value: company?._id ?? '',
                                    setValue: (companyId)=>{
                                        const company = companies.find((company)=>company._id === companyId);
                                        setCompany(company);
                                        setLoan(undefined);
                                    },
                                    companies: companies,
                                    ariaLabel: "Select a Company",
                                    placeholder: "All Companies",
                                    enablePlaceholderOption: true,
                                    boxProps: {
                                        width: '100%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                    component: "span",
                                    flex: "5"
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4a273722595f97f8$export$a370fbe028fde36c), {
                                    value: loan?._id ?? '',
                                    setValue: (loanId)=>{
                                        if (!loanId) resetFilters();
                                        else {
                                            const loan = loans.find((loan)=>loan._id === loanId);
                                            setLoan(loan);
                                            setCompany(loan?.borrower);
                                        }
                                    },
                                    loans: loans,
                                    ariaLabel: "Select a Deal",
                                    placeholder: "All Deals",
                                    enablePlaceholderOption: true,
                                    boxProps: {
                                        width: '100%'
                                    }
                                }),
                                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $620a1c4ac4d86c09$export$a7b06bfba60a8a78), {
                                    sx: {
                                        flex: 1
                                    },
                                    className: "no-pad-sides pad-top-bottom-sm-mobile",
                                    "layout-align": "center center",
                                    children: (company || loan) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                                        display: "flex",
                                        className: "right",
                                        "layout-align": "center center",
                                        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $597ca07016a19218$export$2e2bcd8739ae039), {
                                            title: "Clear Filters",
                                            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $cd1a77cab329a8c8$export$2e2bcd8739ae039), {
                                                sx: {
                                                    paddingLeft: '6px'
                                                },
                                                onClick: ()=>resetFilters(),
                                                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8e41ecf4f9bc5a0d$export$2e2bcd8739ae039), {
                                                    className: "md-icon material-icons pad-left-xs"
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    loan && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4d95fff15b40455d$export$79e57034ed04ee78), {
                        loan: loan
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $d3330c51d9739b57$export$294daaca83af1301), {
                        loan: loan
                    })
                ]
            })
        })
    });
});



const $cf769dea9915d8a3$export$d69a7b48575d117d = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/transactions",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3b6e96d7169325d6$export$2f0eb1bfa125508e), {})
        })
    })
];



var $iO5o7 = parcelRequire("iO5o7");


var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $11641b74e2c721fc$export$b5faf749c56418c7 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)({
        username: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company,
        company: undefined
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet() ?? [], [
        filterStore._companyList
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>{
        const l = filterStore.lenderListGet();
        if (Array.isArray(l)) return l;
        else if (l && l._id) return [
            l
        ];
        return [];
    }, [
        filterStore._lenderList
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            setFormValues((prevFormValues)=>({
                    ...prevFormValues,
                    [key]: value
                }));
            // Clear error when field is updated
            if (formErrors[key]) setFormErrors((prevFormErrors)=>({
                    ...prevFormErrors,
                    [key]: ''
                }));
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues.username) errors.username = 'Username is required';
        if (!formValues.firstName) errors.firstName = 'First Name is required';
        if (!formValues.lastName) errors.lastName = 'Last Name is required';
        if (!formValues.password) errors.password = 'Password is required';
        if (!formValues.email) errors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formValues.email)) errors.email = 'Email is invalid';
        if (!formValues.role) errors.role = 'User Type is required';
        if ((formValues.role === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company || formValues.role === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor) && !formValues.company) errors.company = 'Company is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Creates the User.
   *
   * @remarks
   * Redirects to the User's Detail page afterwards.
   */ const create = async ()=>{
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors first');
            return;
        }
        try {
            // Save the User
            const user = await userStore.create(formValues);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success('User created successfully');
            navigate(`/users/${user._id}`);
            // Reset the form
            setFormValues({
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                role: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company,
                company: undefined
            });
            setFormErrors({});
        } catch (error) {
            console.error(error);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).createUser.error);
        }
    };
    const changeUserType = (role)=>{
        updateFormValue('role')(role);
        updateFormValue('company')(undefined);
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $2d75ea95443f056a$export$9cda59e02e95cdf7), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User,
        onCreate: create,
        width: "50%",
        createVerb: "Create",
        createIcon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1cd17324922a34d3$export$2e2bcd8739ae039), {
            className: "md-icon material-icons"
        }),
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Username",
                    value: formValues.username,
                    updateValue: updateFormValue('username'),
                    error: formErrors.username,
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "First Name",
                        value: formValues.firstName,
                        updateValue: updateFormValue('firstName'),
                        error: formErrors.firstName,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Last Name",
                        value: formValues.lastName,
                        updateValue: updateFormValue('lastName'),
                        error: formErrors.lastName,
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Password",
                    type: "password",
                    value: formValues.password,
                    updateValue: updateFormValue('password'),
                    error: formErrors.password,
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Email",
                    type: "email",
                    value: formValues.email,
                    updateValue: updateFormValue('email'),
                    error: formErrors.email,
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                    label: "User Type",
                    placeholder: "Select User Type",
                    value: formValues.role,
                    updateValue: changeUserType,
                    error: formErrors.role,
                    options: [
                        {
                            value: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                            label: 'Admin'
                        },
                        {
                            value: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company,
                            label: 'Company'
                        },
                        {
                            value: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor,
                            label: 'Investor'
                        }
                    ],
                    required: true,
                    boxProps: {
                        'aria-label': 'Select a type for this User.'
                    }
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                    label: "User Company",
                    placeholder: "Select User Company",
                    value: formValues.company,
                    updateValue: updateFormValue('company'),
                    error: formErrors.company,
                    options: (userStore.isLender ? lenders : companies).map((company)=>({
                            value: company._id,
                            label: company.name
                        })),
                    required: true,
                    disabled: formValues.role === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin,
                    boxProps: {
                        'aria-label': 'Select a Company to associate this user with.'
                    }
                })
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");









const $ee7fa3b6c48cdb6b$export$109a4ce65eb6ec38 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const user = userStore.currentUser;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet() ?? [], [
        filterStore._companyList
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>{
        const l = filterStore.lenderListGet();
        if (Array.isArray(l)) return l;
        else if (l && l._id) return [
            l
        ];
        return [];
    }, [
        filterStore._lenderList
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues?.username) errors.username = 'Username is required';
        if (!formValues?.firstName) errors.firstName = 'First Name is required';
        if (!formValues?.lastName) errors.lastName = 'Last Name is required';
        if (!formValues?.email) errors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formValues?.email)) errors.email = 'Email is invalid';
        if (!formValues?.roles[0]) errors.role = 'User Type is required';
        if ((formValues?.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company || formValues?.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor) && !formValues?.company) errors.company = 'Company is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the User.
   *
   * @remarks
   * Redirects to the User's Detail page afterwards.
   */ const update = async ()=>{
        if (!formValues) return;
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors before submitting');
            return;
        }
        try {
            const response = await userStore.update(formValues);
            if (!response) throw new Error(`Could not update User with ID "${formValues?._id}"`);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateUser.success);
            navigate(`/users/${response._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateUser.error);
        }
    };
    const changeUserType = (role)=>{
        updateFormValue('roles')([
            role
        ]);
        updateFormValue('company')(undefined);
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (!params.userId) return;
        Promise.all([
            userStore.get(params.userId)
        ]);
    }, [
        params.userId
    ]);
    (0, $lVd4O.useEffect)(()=>{
        if (user) setFormValues(user);
    }, [
        user
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User,
        onEdit: update,
        width: "50%",
        editIcon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1cd17324922a34d3$export$2e2bcd8739ae039), {
            className: "md-icon material-icons"
        }),
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Username",
                    value: formValues?.username,
                    updateValue: updateFormValue('username'),
                    error: formErrors.username,
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "First Name",
                        value: formValues?.firstName,
                        updateValue: updateFormValue('firstName'),
                        error: formErrors.firstName,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Last Name",
                        value: formValues?.lastName,
                        updateValue: updateFormValue('lastName'),
                        error: formErrors.lastName,
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Email",
                    type: "email",
                    value: formValues?.email,
                    updateValue: updateFormValue('email'),
                    error: formErrors.email,
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                    label: "User Type",
                    placeholder: "Select User Type",
                    value: formValues?.roles[0],
                    updateValue: changeUserType,
                    error: formErrors.role,
                    options: Object.entries((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8)).map(([label, value])=>({
                            label: label,
                            value: value
                        })),
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                    label: "User Company",
                    placeholder: "Select User Company",
                    value: formValues?.company,
                    updateValue: updateFormValue('company'),
                    error: formErrors.company,
                    options: (userStore.isLender ? lenders : companies).map((company)=>({
                            label: company.name,
                            value: company._id
                        })),
                    required: true,
                    disabled: user?.roles.includes((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin),
                    boxProps: {
                        'aria-label': 'Select a Company to associate this user with.'
                    }
                })
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");

var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $e7742865d765b467$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'Person');


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $32ea2dea697cc5a9$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4"
}), 'PersonOutline');



var $4HqRp = parcelRequire("4HqRp");

var $PKVGF = parcelRequire("PKVGF");




const $67e06227b1ca0204$export$e396b9722e5a1ef5 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    const defaultSortType = 'sequenceNumber';
    const defaultSortReverse = false;
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    /** State **/ const [sortType, setSortType] = (0, $lVd4O.useState)(defaultSortType);
    const [sortReverse, setSortReverse] = (0, $lVd4O.useState)(defaultSortReverse);
    /** Computed **/ const users = userStore.users;
    const companies = filterStore.companyListGet();
    const lenders = filterStore.lenderListGet();
    const listData = (0, $lVd4O.useMemo)(()=>{
        if (users) {
            const list = users.map((user)=>{
                if (user.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company) user.companyDisplay = companies?.find((company)=>typeof user.company === 'string' && company._id === user.company)?.name || '';
                else if (user.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor) {
                    if (Array.isArray(lenders)) user.companyDisplay = lenders?.find((lender)=>typeof user.company === 'string' && lender._id === user.company)?.name || '';
                }
                return user;
            }).toSorted((a, b)=>(0, $PKVGF.get)(a, sortType) > (0, $PKVGF.get)(b, sortType) ? 1 : -1);
            if (sortReverse) list.reverse();
            return list;
        } else return [];
    }, [
        users,
        sortType,
        sortReverse,
        companies,
        lenders
    ]);
    /** Methods **/ const sortList = (type)=>{
        if (type) {
            if (sortType === type) setSortReverse(!sortReverse);
            else setSortType(type);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        userStore.query();
        return ()=>userStore.users = undefined;
    }, []);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7ae08a74a92b1771$export$9b7824917a0c851e), {
        data: listData,
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User,
        createVerb: "Create",
        headerItems: [
            {
                flex: 1,
                propName: 'status',
                label: 'Status'
            },
            {
                flex: 1,
                propName: 'username',
                label: 'Username'
            },
            {
                flex: 1,
                propName: 'displayName',
                label: 'Display Name'
            },
            {
                flex: 1,
                propName: 'email',
                label: 'Email'
            },
            {
                flex: 1,
                propName: 'role',
                label: 'User Role'
            },
            {
                flex: 1,
                propName: 'company',
                label: 'Company'
            }
        ],
        sortType: sortType,
        sortReverse: sortReverse,
        sortList: sortList,
        children: listData?.map((user, i)=>/*#__PURE__*/ (0, $iO5o7.jsx)((0, $984f98682cffcd4b$export$c36f87108246a02a), {
                padForScrollbar: listData.length > 11,
                items: [
                    {
                        propName: 'status',
                        content: (0, $4HqRp.default)(user.status),
                        justifyContent: 'start',
                        icon: user.status === (0, $989a2d26b0fc80b4$export$a82073022ded66e8).Active ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e7742865d765b467$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $32ea2dea697cc5a9$export$2e2bcd8739ae039), {})
                    },
                    {
                        propName: 'username',
                        content: user.username,
                        url: `/users/${user._id}`
                    },
                    {
                        propName: 'displayName',
                        content: user.displayName
                    },
                    {
                        propName: 'email',
                        content: user.email
                    },
                    {
                        propName: 'role',
                        content: (0, $4HqRp.default)(user.roles[0])
                    },
                    {
                        propName: 'company',
                        content: user.companyDisplay
                    }
                ],
                rowIndex: i
            }, user._id))
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");


var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $8f0f0dac4cb1463c$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), 'VpnKey');







const $3a9db277b3fc6f5b$export$8ec0fb1e4323236d = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)({
        currentPassword: '',
        newPassword: '',
        verifyPassword: ''
    });
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues?.currentPassword) errors.currentPassword = 'Current password is required';
        if (!formValues?.newPassword) errors.newPassword = 'New password is required';
        if (!formValues?.verifyPassword) errors.verifyPassword = 'Verify password is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Change the User's password.
   */ const changeUserPassword = async ()=>{
        if (!formValues || !userStore?.user) return;
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors before submitting');
            return;
        }
        try {
            await userStore.changeUserPassword(formValues.currentPassword, formValues.newPassword, formValues.verifyPassword);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).changePassword.success);
            setFormValues({
                currentPassword: '',
                newPassword: '',
                verifyPassword: ''
            });
        } catch (err) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).changePassword.error);
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: "Change Password",
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User,
        editIcon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f0f0dac4cb1463c$export$2e2bcd8739ae039), {}),
        onEdit: changeUserPassword,
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "currentPassword",
                label: "Current Password",
                value: formValues.currentPassword,
                updateValue: updateFormValue('currentPassword'),
                error: formErrors.currentPassword,
                type: "password",
                required: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "newPassword",
                label: "New Password",
                value: formValues.newPassword,
                updateValue: updateFormValue('newPassword'),
                error: formErrors.newPassword,
                type: "password",
                required: true
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                id: "verifyPassword",
                label: "Verify Password",
                value: formValues.verifyPassword,
                updateValue: updateFormValue('verifyPassword'),
                error: formErrors.verifyPassword,
                type: "password",
                required: true
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $4HqRp = parcelRequire("4HqRp");





const $1bb9cdf4f28a48cf$export$cd4e4ce058d8cb51 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [formValues, setFormValues] = (0, $lVd4O.useState)();
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet() ?? [], [
        filterStore._companyList
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>{
        const l = filterStore.lenderListGet();
        if (Array.isArray(l)) return l;
        else if (l && l._id) return [
            l
        ];
        return [];
    }, [
        filterStore._lenderList
    ]);
    const userTypeOptions = (0, $lVd4O.useMemo)(()=>{
        const options = [];
        if (userStore.isAdmin) options.push({
            label: (0, $4HqRp.default)((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin),
            value: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin
        });
        if (userStore.isAdmin || userStore.isCompany) options.push({
            label: 'Company',
            value: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company
        });
        if (userStore.isAdmin || userStore.isLender) options.push({
            label: (0, $4HqRp.default)((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor),
            value: (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor
        });
        return options;
    }, [
        userStore.isAdmin,
        userStore.isCompany,
        userStore.isLender
    ]);
    /** Methods **/ /**
   * Updates a form value. Designed so that, in a form field's `onChange` method,
   * you pass this function with the name of the prop you want to update, and it
   * returns a function that will automatically handle saving the returned value.
   *
   * @param key Name of the form prop to update.
   */ const updateFormValue = (key)=>(value)=>{
            if (formValues) {
                setFormValues({
                    ...formValues,
                    [key]: value
                });
                // Clear error when field is updated
                if (formErrors[key]) setFormErrors({
                    ...formErrors,
                    [key]: ''
                });
            }
        };
    /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!formValues?.username) errors.username = 'Username is required';
        if (!formValues?.firstName) errors.firstName = 'First Name is required';
        if (!formValues?.lastName) errors.lastName = 'Last Name is required';
        if (!formValues?.email) errors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formValues?.email)) errors.email = 'Email is invalid';
        if (!formValues?.roles[0]) errors.role = 'User Type is required';
        if ((formValues?.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company || formValues?.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Investor) && !formValues?.company) errors.company = 'Company is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Updates the User's profile.
   *
   * @remarks
   * Redirects to the User's Detail page afterwards.
   */ const updateUserProfile = async ()=>{
        if (!formValues) return;
        // Validate form before submitting
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors before submitting');
            return;
        }
        try {
            const response = await userStore.updateUserProfile(formValues, true);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).updateUser.success);
            navigate(`/users/${response?._id}`);
        } catch (err) {
            console.error(err);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).updateUser.error);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        if (userStore.user) setFormValues(userStore.user);
    }, [
        userStore.user
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $c09930914b717387$export$1fea75498367c4ac), {
        modelName: "Edit User",
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User,
        onEdit: updateUserProfile,
        submitLabel: "Save Profile",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Username",
                    value: formValues?.username,
                    updateValue: updateFormValue('username'),
                    error: formErrors.username,
                    required: true
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "First Name",
                        value: formValues?.firstName,
                        updateValue: updateFormValue('firstName'),
                        error: formErrors.firstName,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                        label: "Last Name",
                        value: formValues?.lastName,
                        updateValue: updateFormValue('lastName'),
                        error: formErrors.lastName,
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                    label: "Email",
                    type: "email",
                    value: formValues?.email,
                    updateValue: updateFormValue('email'),
                    error: formErrors.email,
                    required: true
                })
            }),
            userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                    label: "User Type",
                    placeholder: "Select User Type",
                    value: formValues?.roles[0],
                    updateValue: ()=>{},
                    error: formErrors.role,
                    options: userTypeOptions,
                    disabled: true,
                    required: true
                })
            }),
            formValues?.roles[0] === (0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Company && userStore.isAdmin && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $8f073dbc7525ab1f$export$e71c4d32a2263218), {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $5aa67484160e5d9c$export$c7c3831628327b0f), {
                    label: "User Company",
                    placeholder: "Select User Company",
                    value: formValues?.company,
                    updateValue: updateFormValue('company'),
                    error: formErrors.company,
                    options: (userStore.isLender ? lenders : companies).map((company)=>({
                            label: company.name,
                            value: company._id
                        })),
                    required: true,
                    disabled: true,
                    boxProps: {
                        'aria-label': 'Select a Company to associate this user with.'
                    }
                })
            })
        ]
    });
});





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");



var $3qrVB = parcelRequire("3qrVB");

var $iO5o7 = parcelRequire("iO5o7");
"use client";
var $089478a8a48b35d0$export$2e2bcd8739ae039 = (0, $3qrVB.default)(/*#__PURE__*/ (0, $iO5o7.jsx)("path", {
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m-9-2V7H4v3H1v2h3v3h2v-3h3v-2zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'PersonAdd');









const $ad4ab98827b3b2a9$export$195ee4b8d78cf8d3 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const filterStore = (0, $1da4b8b758f1a116$export$875b296eac126ec2)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    /** State **/ const [showConfirmModal, setShowConfirmModal] = (0, $lVd4O.useState)(false);
    /** Computed **/ const user = userStore.currentUser;
    const isActive = user?.status === (0, $989a2d26b0fc80b4$export$a82073022ded66e8).Active;
    const companies = (0, $lVd4O.useMemo)(()=>filterStore.companyListGet(), [
        filterStore._companyList
    ]);
    const lenders = (0, $lVd4O.useMemo)(()=>{
        const l = filterStore.lenderListGet();
        if (Array.isArray(l)) return l;
        else if (l && l._id) return [
            l
        ];
        return [];
    }, [
        filterStore._lenderList
    ]);
    const userCompany = (userStore.isLender ? lenders : companies).find((company)=>company._id === user?.company);
    /** Methods **/ /**
   * Deactivates this User.
   *
   * @remarks
   * We don't ever remove Users from the system, just mark them as "inactive".
   *
   * @remarks
   * Redirects to the Users List afterwards.
   */ const deactivate = async (targetUser)=>{
        try {
            if (targetUser) {
                if (targetUser?.company) {
                    if (typeof targetUser.company !== 'string') targetUser.company = targetUser.company._id;
                }
                targetUser.status = (0, $989a2d26b0fc80b4$export$a82073022ded66e8).Inactive;
                userStore.update(targetUser);
            } else if (user) {
                if (user?.company) {
                    if (typeof user.company !== 'string') user.company = user.company._id;
                }
                user.status = (0, $989a2d26b0fc80b4$export$a82073022ded66e8).Inactive;
                await userStore.update(user);
                (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).deactivateUser.success);
                navigate('/users');
            }
        } catch (err) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).deactivateUser.error);
        }
    };
    /**
   * Activates this User.
   *
   * @remarks
   * Redirects to the Users List afterwards.
   */ const activate = async ()=>{
        try {
            if (!user) return;
            if (user?.company) {
                if (typeof user.company !== 'string') user.company = user.company._id;
            }
            user.status = (0, $989a2d26b0fc80b4$export$a82073022ded66e8).Active;
            await userStore.update(user);
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).success((0, $f59363be96761416$export$40fb018dd4c59f8).activateUser.success);
            navigate('/users');
        } catch (err) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error((0, $f59363be96761416$export$40fb018dd4c59f8).activateUser.error);
        }
    };
    /** Effects **/ (0, $lVd4O.useEffect)(()=>{
        params.userId && userStore.get(params.userId);
    }, [
        params.userId
    ]);
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $e6f74e0a78043d70$export$767e3006bdbb424a), {
        modelName: user?.displayName ?? '',
        modelType: (0, $dff1c8c0bf270f18$export$4c61f29f9791c495).User,
        icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1cd17324922a34d3$export$2e2bcd8739ae039), {
            className: "md-icon material-icons"
        }),
        width: "50%",
        textClassName: "md-title",
        speedDialActions: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $baee3d6dffc2be18$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)((0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit, 'Edit User'),
                onClick: ()=>navigate(`/users/${user?._id}/edit`)
            }, "edit-button"),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b55097dc6b994c42$export$2e2bcd8739ae039), {
                icon: user && isActive ? /*#__PURE__*/ (0, $iO5o7.jsx)((0, $b3f197c3a21accaf$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $089478a8a48b35d0$export$2e2bcd8739ae039), {
                    className: "material-icons"
                }),
                slotProps: (0, $4bb6caff349888e9$export$5ddecab480f41f9a)(user && isActive ? (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Remove : (0, $dff1c8c0bf270f18$export$e4d8b68a62928ba3).Edit, `${user && isActive ? 'Deactivate' : 'Activate'} User`),
                onClick: ()=>setShowConfirmModal(true),
                className: "md-warn"
            }, "delete-button")
        ],
        modals: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6c09b31ac8ce3c48$export$8eec1a3a911975a4), {
            content: `Are you sure you want to ${user && isActive ? 'deactivate' : 'activate'} this User?`,
            open: showConfirmModal,
            setOpen: setShowConfirmModal,
            onOk: ()=>(user && isActive ? deactivate : activate)(),
            label: `Confirm User ${user && isActive ? 'Deactivation' : 'Activation'}`,
            okLabel: user && isActive ? 'Deactivate' : 'Activate',
            cancelLabel: "Cancel"
        }),
        children: user ? /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $iO5o7.Fragment), {
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Username",
                    value: user?.username
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Display Name",
                    value: user?.displayName
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "Email",
                    value: user?.email,
                    url: `mailto:${user?.email}`
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $7640c64fed7cb5ef$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "User Role",
                    value: user?.roles[0],
                    capitalize: true
                }),
                !user.roles.includes((0, $989a2d26b0fc80b4$export$eb3485a690c2f0b8).Admin) && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $78de29a962de2a35$export$84736f919622d25b), {
                    title: "User Company",
                    value: userCompany?.name,
                    url: `/companies/${userCompany?._id}`,
                    capitalize: true
                })
            ]
        }) : /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            display: "flex",
            flex: "100",
            justifyContent: "center",
            alignItems: "center",
            className: "pad-top-bottom",
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a137f263533bb854$export$2e2bcd8739ae039), {
                className: "md-primary",
                "md-mode": "indeterminate"
            })
        })
    });
});



const $c9483128e9c05e5b$export$66c6e37b55101793 = [
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/users/create",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $11641b74e2c721fc$export$b5faf749c56418c7), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/users/:userId/edit",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ee7fa3b6c48cdb6b$export$109a4ce65eb6ec38), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/users",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $67e06227b1ca0204$export$e396b9722e5a1ef5), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/users/:userId",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ad4ab98827b3b2a9$export$195ee4b8d78cf8d3), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/settings/profile",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1bb9cdf4f28a48cf$export$cd4e4ce058d8cb51), {})
        })
    }),
    /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
        path: "/settings/password",
        element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3a9db277b3fc6f5b$export$8ec0fb1e4323236d), {})
        })
    })
];





var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");





const $ee7c2653a4a2e319$export$c7a55480dba6f1f1 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Computed **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    /** State **/ const [username, setUsername] = (0, $lVd4O.useState)();
    const [error, setError] = (0, $lVd4O.useState)();
    const [success, setSuccess] = (0, $lVd4O.useState)();
    /** Methods **/ /**
   * Requests that a password reset token be sent to the User's email address.
   */ const askForPasswordReset = async ()=>{
        if (!username) return;
        setSuccess(undefined);
        setError(undefined);
        try {
            const response = await userStore.askForPasswordReset(username);
            setSuccess(response.message);
        } catch (err) {
            setError(err.message);
        } finally{
            setUsername('');
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsx)((0, $39bd3c1fb2ecd5f4$export$c1faa9c8f42906a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
            className: "row",
            children: [
                /*#__PURE__*/ (0, $iO5o7.jsx)("h3", {
                    className: "col-md-12 text-center",
                    children: "Restore your password"
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)("p", {
                    className: "small text-center",
                    children: "Enter your account username."
                }),
                /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                    component: "div",
                    className: "col-xs-offset-2 col-xs-8 col-md-offset-5 col-md-2",
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                        component: "fieldset",
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                label: "Username",
                                type: "text",
                                id: "username",
                                value: username,
                                updateValue: (value)=>setUsername(value)
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "div",
                                className: "text-center form-group",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    onClick: ()=>askForPasswordReset(),
                                    disabled: !username,
                                    children: "Submit"
                                })
                            }),
                            error && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "div",
                                className: "text-center text-danger",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                    children: error
                                })
                            }),
                            success && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "div",
                                className: "text-center text-success",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                    children: success
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
});



var $iO5o7 = parcelRequire("iO5o7");

var $lVd4O = parcelRequire("lVd4O");






const $17acdfc7fe1ff663$export$da4433e8d8a5678 = (0, $0f7629d23d6d6537$export$b6ae1bc530f4c149)(()=>{
    /** Context **/ const userStore = (0, $1da4b8b758f1a116$export$cc885caaa8b7ab4e)();
    const navigate = (0, $a648eab72417989b$export$9770f232ac06a008)();
    const params = (0, $a648eab72417989b$export$99eaa27ddbbb95ef)();
    /** State **/ const [newPassword, setNewPassword] = (0, $lVd4O.useState)('');
    const [verifyPassword, setVerifyPassword] = (0, $lVd4O.useState)('');
    const [error, setError] = (0, $lVd4O.useState)('');
    const [formErrors, setFormErrors] = (0, $lVd4O.useState)({});
    /** Computed **/ const token = params.token;
    /** Methods **/ /**
   * Validates the form data. If errors are detected, it saves them to `formErrors` and returns false.
   *
   * @returns Boolean indicating whether the data is valid
   */ const validateForm = ()=>{
        const errors = {};
        if (!newPassword) errors.newPassword = 'New password is required';
        if (!verifyPassword) errors.verifyPassword = 'Verify password is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    /**
   * Resets the User's password.
   *
   * @remarks
   * Redirects to either the `success` or `invalid` password reset pages.
   */ const resetUserPassword = async ()=>{
        if (!token) {
            navigate('/password/reset/invalid');
            return;
        }
        if (!validateForm()) {
            (0, $ad74cb9159ed3c41$export$b410431fab84fa58).error('Please fix the errors before submitting');
            return;
        }
        try {
            await userStore.resetUserPassword(token, newPassword, verifyPassword);
            navigate('/password/reset/success');
        } catch (err) {
            setError(err.message);
            navigate('/password/reset/invalid');
        }
    };
    /** Render **/ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        className: "row",
        "data-ng-controller": "PasswordController",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)("h3", {
                className: "col-md-12 text-center",
                children: "Reset your password"
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                component: "div",
                className: "col-xs-offset-2 col-xs-8 col-md-offset-5 col-md-2",
                children: /*#__PURE__*/ (0, $iO5o7.jsx)("form", {
                    className: "signin form-horizontal",
                    autoComplete: "off",
                    children: /*#__PURE__*/ (0, $iO5o7.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "newPassword",
                                label: "New Password",
                                type: "password",
                                value: newPassword,
                                updateValue: (value)=>setNewPassword(value),
                                required: true,
                                error: formErrors.newPassword
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4436aac128298086$export$e06108bfe6141a40), {
                                id: "verifyPassword",
                                label: "Verify Password",
                                type: "password",
                                value: verifyPassword,
                                updateValue: (value)=>setVerifyPassword(value),
                                required: true,
                                error: formErrors.verifyPassword
                            }),
                            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "div",
                                className: "text-center form-group",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("button", {
                                    className: "btn btn-large btn-primary",
                                    onClick: ()=>resetUserPassword(),
                                    children: "Update Password"
                                })
                            }),
                            error && /*#__PURE__*/ (0, $iO5o7.jsx)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
                                component: "div",
                                className: "text-center text-danger",
                                children: /*#__PURE__*/ (0, $iO5o7.jsx)("strong", {
                                    children: error
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
});



var $iO5o7 = parcelRequire("iO5o7");


const $6e9856d0081423d0$export$9ffd0b2dcdf16d76 = ()=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        className: "row text-center",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)("h3", {
                className: "col-md-12",
                children: "Password reset is invalid"
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                to: "/password/forgot",
                className: "col-md-12",
                children: "Ask for a new password reset"
            })
        ]
    });
};



var $iO5o7 = parcelRequire("iO5o7");


const $a9fb0380827cbbd6$export$14f4d8123c637bec = ()=>{
    return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $fbb05a6af45ba6c1$export$2e2bcd8739ae039), {
        className: "row text-center",
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)("h3", {
                className: "col-md-12",
                children: "Password successfully reset"
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "col-md-12",
                children: "Continue to home page"
            })
        ]
    });
};




const $dcdebe7a2bb9016e$export$37d3279522fbf5e2 = ()=>{
    /** Render */ return /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $a648eab72417989b$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $94f7e3de1e13b616$export$a65c2c055de52e1d), {})
            }),
            ...(0, $905c5702d1df1a82$export$b5d742573aa3b192),
            ...(0, $c0f5ace9137e9735$export$ae8050ec2c89360d),
            ...(0, $897f2e27f29a0ef5$export$f04e3339f964e4c2),
            ...(0, $f8d5db5b06018063$export$9577a4d0122f1bbe),
            ...(0, $e8c39a09e4f9ecd4$export$340be184fa44c4bb),
            ...(0, $3e5ff6589207682b$export$e5293f74b74b5ba4),
            ...(0, $ffb0c2a144bba7e2$export$20bae686c949514),
            ...(0, $5bd07723e1c5073f$export$b4aef71b1c563a49),
            ...(0, $530632050afc9df5$export$3622253e6351bfc7),
            ...(0, $cf769dea9915d8a3$export$d69a7b48575d117d),
            ...(0, $c9483128e9c05e5b$export$66c6e37b55101793),
            ...(0, $e28fa16046440cc5$export$660a8d7d3aa4942),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/signin",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ba4b80aeeee08b01$export$54b483389384521c), {})
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/password/forgot",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ee7c2653a4a2e319$export$c7a55480dba6f1f1), {})
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/password/reset/:token",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $17acdfc7fe1ff663$export$da4433e8d8a5678), {})
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/password/reset/invalid",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $6e9856d0081423d0$export$9ffd0b2dcdf16d76), {})
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/password/reset/success",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a9fb0380827cbbd6$export$14f4d8123c637bec), {})
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/bulk",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $592c7591da758d1c$export$caea88324e87486f), {})
                })
            }),
            /*#__PURE__*/ (0, $iO5o7.jsx)((0, $a648eab72417989b$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $4f6acc6ac54387d2$export$8ef2ed426dede42d), {
                    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1e8a98bb9396e49e$export$fedd53519a0e2bce), {})
                })
            })
        ]
    });
};



const $6de0f47b5929765c$var$rootElement = document.getElementById('app');
$6de0f47b5929765c$var$rootElement && (0, (/*@__PURE__*/$parcel$interopDefault($37cfaa3aa237e105$exports))).createRoot($6de0f47b5929765c$var$rootElement).render(/*#__PURE__*/ (0, $iO5o7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lVd4O))).StrictMode, {
    children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $1da4b8b758f1a116$export$773ef8ccef99e88a), {
        children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $3114e5f14228fb75$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ea93627b116aa5a9$export$2e2bcd8739ae039), {
                theme: (0, $5b108f16e2d84dda$export$bca14c5b3b88a9c9),
                children: /*#__PURE__*/ (0, $iO5o7.jsxs)((0, $5dd0e15e9dff1511$export$b735bbab4dd866a3), {
                    children: [
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $dcdebe7a2bb9016e$export$37d3279522fbf5e2), {}),
                        /*#__PURE__*/ (0, $iO5o7.jsx)((0, $ad74cb9159ed3c41$export$f2815235e76a62b9), {
                            position: "top-right",
                            autoClose: 1750,
                            hideProgressBar: false,
                            newestOnTop: false,
                            pauseOnFocusLoss: false,
                            draggable: false,
                            closeOnClick: true,
                            pauseOnHover: true
                        })
                    ]
                })
            })
        })
    })
}));


//# sourceMappingURL=public.f79e3399.js.map
